{
  "schemaVersion": 1,
  "id": "vilnius-wide-judu-public-transport-network",
  "description": "Canonical weekday bus and trolleybus route patterns, ordered stops and service departures compiled from official JUDU static GTFS.",
  "source": {
    "name": "Vilnius public transport static GTFS",
    "publisher": "SĮ Susisiekimo paslaugos (JUDU)",
    "catalogUrl": "https://judu.lt/atviri-duomenys/",
    "url": "https://www.stops.lt/vilnius/vilnius/gtfs.zip",
    "termsUrl": "https://judu.lt/wp-content/uploads/2022/03/Duomenu-naudojimo-salygos-lt.pdf",
    "fetchedAt": "2026-08-11",
    "serviceDate": "20260811",
    "archiveFileName": "vilnius-gtfs.zip",
    "archiveSha256": "6707aff0990da48d6e670b7f79ca6666b9a52a9e14a205292134bc91ed5063cb",
    "notes": "For each route and direction, the most frequently scheduled active stop-sequence and shape pair is retained. Routes must provide both directions and remain wholly inside data/regions/vilnius-wide.json. Shapes are projected to EPSG:3346 and simplified to a 1.25 m tolerance; stop positions remain exact GTFS coordinates."
  },
  "localOriginLks94": {
    "crs": "EPSG:3346",
    "easting": 582400,
    "northing": 6062080,
    "elevationM": 80
  },
  "boundsLks94": {
    "minEasting": 556032,
    "minNorthing": 6051072,
    "maxEasting": 594176,
    "maxNorthing": 6077184
  },
  "routeCount": 101,
  "patternCount": 202,
  "departureCount": 8661,
  "rejectedPatternCount": {
    "outsideGeneratedWorld": 10,
    "stopShapeFit": 0
  },
  "routes": [
    {
      "id": "judu:route:vilnius_bus_1",
      "sourceRouteId": "vilnius_bus_1",
      "mode": "bus",
      "shortName": "1",
      "longName": "Stotis–Vikingų g.–Oro uostas–Rodūnios sodai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_1:0",
          "sourceRouteId": "vilnius_bus_1",
          "sourceShapeId": "vilnius_bus_1_a-b",
          "directionId": 0,
          "headsign": "Rodūnios sodai",
          "directionName": "Stotis–Vikingų g.–Oro uostas–Rodūnios sodai",
          "mode": "bus",
          "routeShortName": "1",
          "routeLongName": "Stotis–Vikingų g.–Oro uostas–Rodūnios sodai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              365.148,
              1967.953,
              0
            ],
            [
              359.628,
              1983.639,
              16.629
            ],
            [
              363.117,
              1998.047,
              31.454
            ],
            [
              375.555,
              2007.839,
              47.284
            ],
            [
              384.565,
              2006.561,
              56.383
            ],
            [
              450.348,
              1969.735,
              131.773
            ],
            [
              464.314,
              1957.234,
              150.516
            ],
            [
              465.359,
              1943.856,
              163.935
            ],
            [
              460.037,
              1935.047,
              174.227
            ],
            [
              448.99,
              1930.796,
              186.063
            ],
            [
              427.686,
              1930.073,
              207.38
            ],
            [
              403.862,
              1932.735,
              231.352
            ],
            [
              390.012,
              1916.29,
              252.852
            ],
            [
              339.428,
              1831.495,
              351.589
            ],
            [
              318.606,
              1821.856,
              374.533
            ],
            [
              29.934,
              1735.835,
              675.75
            ],
            [
              -11.424,
              1732.135,
              717.273
            ],
            [
              -46.755,
              1740.57,
              753.597
            ],
            [
              -320.217,
              1781.157,
              1030.054
            ],
            [
              -515.259,
              1841.463,
              1234.207
            ],
            [
              -520.923,
              1849.358,
              1243.923
            ],
            [
              -526.486,
              1862.817,
              1258.487
            ],
            [
              -511.654,
              1933.795,
              1330.998
            ],
            [
              -496.901,
              1964.699,
              1365.243
            ],
            [
              -462.075,
              2106.562,
              1511.318
            ],
            [
              -436.719,
              2188.482,
              1597.072
            ],
            [
              -427.991,
              2207.248,
              1617.769
            ],
            [
              -344.32,
              2338.207,
              1773.176
            ],
            [
              -326.137,
              2380.181,
              1818.918
            ],
            [
              -285.296,
              2533.066,
              1977.164
            ],
            [
              -290.153,
              2585.475,
              2029.798
            ],
            [
              -278.622,
              2616.436,
              2062.837
            ],
            [
              -251.706,
              2819.669,
              2267.844
            ],
            [
              -239.003,
              2950.799,
              2399.588
            ],
            [
              -239.164,
              2977.519,
              2426.309
            ],
            [
              -244.788,
              3023.264,
              2472.398
            ],
            [
              -255.513,
              3072.44,
              2522.73
            ],
            [
              -253.033,
              3102.452,
              2552.845
            ],
            [
              -344.245,
              3589.471,
              3048.331
            ],
            [
              -366.041,
              3597.658,
              3071.614
            ],
            [
              -487.765,
              3576.482,
              3195.166
            ],
            [
              -509.299,
              3563.512,
              3220.304
            ],
            [
              -516.093,
              3544.71,
              3240.296
            ],
            [
              -513.753,
              3531.31,
              3253.899
            ],
            [
              -508.087,
              3523.415,
              3263.617
            ],
            [
              -481.25,
              3508.458,
              3294.341
            ],
            [
              -441.711,
              3517.762,
              3334.96
            ],
            [
              -307.871,
              3566.547,
              3477.414
            ],
            [
              -94.218,
              3673.994,
              3716.563
            ],
            [
              9.183,
              3716.644,
              3828.415
            ],
            [
              123.958,
              3745.726,
              3946.817
            ],
            [
              243.774,
              3768.034,
              4068.692
            ],
            [
              305.255,
              3776.931,
              4130.814
            ],
            [
              329.292,
              3785.398,
              4156.298
            ],
            [
              358.069,
              3806.024,
              4191.704
            ],
            [
              364.161,
              3821.498,
              4208.333
            ],
            [
              354.918,
              3916.291,
              4303.576
            ],
            [
              348.689,
              3928.65,
              4317.416
            ],
            [
              334.031,
              3938.937,
              4335.324
            ],
            [
              293.984,
              3937.441,
              4375.399
            ],
            [
              249.963,
              3930.452,
              4419.971
            ],
            [
              216.024,
              3909.919,
              4459.638
            ],
            [
              197.189,
              3903.583,
              4479.51
            ],
            [
              187.287,
              3891.518,
              4495.118
            ],
            [
              173.696,
              3889.539,
              4508.852
            ],
            [
              160.288,
              3897.576,
              4524.485
            ],
            [
              157.848,
              3905.413,
              4532.693
            ],
            [
              158.696,
              3916.53,
              4543.842
            ],
            [
              171.18,
              3928.548,
              4561.17
            ],
            [
              184.71,
              3927.189,
              4574.769
            ],
            [
              199.993,
              3915.778,
              4593.842
            ],
            [
              209.048,
              3916.726,
              4602.945
            ],
            [
              218.183,
              3922.126,
              4613.557
            ],
            [
              228.044,
              3931.965,
              4627.488
            ],
            [
              267.146,
              3952.403,
              4671.609
            ],
            [
              353.089,
              3957.514,
              4757.704
            ],
            [
              339.014,
              4105.83,
              4906.686
            ],
            [
              333.674,
              4131.532,
              4932.937
            ],
            [
              328.708,
              4248.511,
              5050.022
            ],
            [
              4.962,
              4265.541,
              5374.215
            ],
            [
              -16.313,
              4267.041,
              5395.543
            ],
            [
              -27.868,
              4270.591,
              5407.631
            ],
            [
              -30.045,
              4292.895,
              5430.041
            ],
            [
              -28.186,
              4359.654,
              5496.827
            ],
            [
              -33.24,
              4507.805,
              5645.064
            ],
            [
              -26.822,
              4612.332,
              5749.787
            ],
            [
              -9.27,
              4725.561,
              5864.369
            ],
            [
              19.778,
              4831.903,
              5974.607
            ],
            [
              33.779,
              4891.762,
              6036.082
            ],
            [
              49.008,
              4912.637,
              6061.921
            ],
            [
              65.892,
              4953.519,
              6106.152
            ],
            [
              77.939,
              5047.924,
              6201.323
            ],
            [
              190.244,
              5045.879,
              6313.646
            ],
            [
              184.689,
              4953.583,
              6406.109
            ],
            [
              190.96,
              4943.45,
              6418.026
            ],
            [
              176.292,
              4882.489,
              6480.726
            ],
            [
              169.757,
              4878.156,
              6488.568
            ],
            [
              101.688,
              4898.32,
              6559.56
            ],
            [
              64.014,
              4921.27,
              6603.674
            ],
            [
              58.972,
              4928.041,
              6612.116
            ],
            [
              69.22,
              4959.024,
              6644.751
            ],
            [
              77.939,
              5047.924,
              6734.077
            ],
            [
              78.797,
              5201.533,
              6887.689
            ],
            [
              75.045,
              5208.281,
              6895.409
            ],
            [
              77.789,
              5217.137,
              6904.68
            ],
            [
              76.802,
              5233.853,
              6921.425
            ],
            [
              20.879,
              5425.231,
              7120.807
            ],
            [
              16.99,
              5495.435,
              7191.118
            ],
            [
              27.321,
              5566.493,
              7262.924
            ],
            [
              35.069,
              5601.975,
              7299.242
            ],
            [
              35.963,
              5722.187,
              7419.457
            ],
            [
              38.892,
              5812.305,
              7509.622
            ],
            [
              36.029,
              5832.395,
              7529.916
            ],
            [
              28.384,
              5838.1,
              7539.455
            ],
            [
              20.032,
              5840.478,
              7548.138
            ],
            [
              14.949,
              5845.023,
              7554.958
            ],
            [
              11.237,
              5853.997,
              7564.668
            ],
            [
              20.216,
              5886.117,
              7598.02
            ],
            [
              30.732,
              6002.814,
              7715.19
            ],
            [
              131.614,
              6188.001,
              7926.072
            ],
            [
              138.313,
              6201.238,
              7940.907
            ],
            [
              140.412,
              6210.105,
              7950.02
            ],
            [
              136.7,
              6219.078,
              7959.73
            ],
            [
              132.242,
              6222.499,
              7965.35
            ],
            [
              126.451,
              6223.718,
              7971.267
            ],
            [
              113.378,
              6215.05,
              7986.953
            ],
            [
              110.048,
              6209.544,
              7993.387
            ],
            [
              100.284,
              6205.269,
              8004.047
            ],
            [
              77.042,
              6205.692,
              8027.292
            ],
            [
              73.25,
              6210.214,
              8033.194
            ],
            [
              73.331,
              6214.665,
              8037.646
            ],
            [
              75.974,
              6217.957,
              8041.867
            ],
            [
              97.359,
              6222.021,
              8063.636
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8262",
              "position": {
                "x": 365.148,
                "z": 1967.953
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 717.273,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 1330.998,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 2029.798,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 2522.73,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:10359",
              "position": {
                "x": 228.044,
                "z": 3931.965
              },
              "distanceAlongShapeM": 4627.488,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9738",
              "position": {
                "x": 333.674,
                "z": 4131.532
              },
              "distanceAlongShapeM": 4932.937,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 6418.026,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7817",
              "position": {
                "x": 75.045,
                "z": 5208.281
              },
              "distanceAlongShapeM": 6895.409,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:4290",
              "position": {
                "x": 11.237,
                "z": 5853.997
              },
              "distanceAlongShapeM": 7564.668,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9226",
              "position": {
                "x": 97.359,
                "z": 6222.021
              },
              "distanceAlongShapeM": 8063.636,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            }
          ],
          "departuresSeconds": [
            20340,
            22140,
            24060,
            25920,
            27840,
            29940,
            31800,
            33780,
            38160,
            40080,
            42120,
            44160,
            46260,
            48420,
            50520,
            52620,
            54780,
            56940,
            59100,
            61380,
            63600,
            65820,
            67860,
            69960,
            74160,
            76020,
            77880,
            79680,
            81540,
            83340
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_1:1",
          "sourceRouteId": "vilnius_bus_1",
          "sourceShapeId": "vilnius_bus_1_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Rodūnios sodai–Oro uostas–Vikingų g.–Stotis",
          "mode": "bus",
          "routeShortName": "1",
          "routeLongName": "Stotis–Vikingų g.–Oro uostas–Rodūnios sodai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              97.359,
              6222.021,
              0
            ],
            [
              127.138,
              6225.932,
              30.034
            ],
            [
              133.573,
              6224.701,
              36.586
            ],
            [
              142.45,
              6215.634,
              49.275
            ],
            [
              140.371,
              6207.879,
              57.304
            ],
            [
              52.642,
              6035.813,
              250.444
            ],
            [
              32.79,
              6009.456,
              283.441
            ],
            [
              28.35,
              5978.367,
              314.846
            ],
            [
              21.991,
              5877.179,
              416.233
            ],
            [
              42.585,
              5837.842,
              460.636
            ],
            [
              33.94,
              5610.902,
              687.74
            ],
            [
              17.01,
              5496.547,
              803.341
            ],
            [
              20.94,
              5428.569,
              871.433
            ],
            [
              46.935,
              5331.246,
              972.167
            ],
            [
              78.012,
              5229.378,
              1078.671
            ],
            [
              80.91,
              5140.267,
              1167.829
            ],
            [
              77.939,
              5047.924,
              1260.22
            ],
            [
              190.223,
              5044.767,
              1372.548
            ],
            [
              184.668,
              4952.47,
              1465.012
            ],
            [
              190.96,
              4943.45,
              1476.01
            ],
            [
              173.065,
              4882.548,
              1539.486
            ],
            [
              169.736,
              4877.043,
              1545.92
            ],
            [
              106.811,
              4896,
              1611.639
            ],
            [
              65.284,
              4920.133,
              1659.668
            ],
            [
              56.935,
              4922.512,
              1668.35
            ],
            [
              38.922,
              4890.556,
              1705.033
            ],
            [
              8.764,
              4794.253,
              1805.947
            ],
            [
              -10.098,
              4715.557,
              1886.872
            ],
            [
              -20.79,
              4660.091,
              1943.36
            ],
            [
              -26.278,
              4606.755,
              1996.977
            ],
            [
              -28.3,
              4495.47,
              2108.281
            ],
            [
              -27.162,
              4273.918,
              2329.836
            ],
            [
              -18.208,
              4269.302,
              2339.909
            ],
            [
              130.759,
              4261.026,
              2489.106
            ],
            [
              341.111,
              4256.078,
              2699.517
            ],
            [
              343.708,
              4221.52,
              2734.171
            ],
            [
              366.01,
              4064.148,
              2893.116
            ],
            [
              372.087,
              3972.752,
              2984.713
            ],
            [
              375.049,
              3958.226,
              2999.538
            ],
            [
              372.971,
              3950.472,
              3007.567
            ],
            [
              369.038,
              3947.204,
              3012.68
            ],
            [
              354.116,
              3943.023,
              3028.177
            ],
            [
              330.159,
              3939.008,
              3052.467
            ],
            [
              288.801,
              3936.423,
              3093.906
            ],
            [
              255.146,
              3931.471,
              3127.924
            ],
            [
              244.74,
              3927.207,
              3139.169
            ],
            [
              217.274,
              3907.67,
              3172.875
            ],
            [
              195.233,
              3902.506,
              3195.513
            ],
            [
              191.24,
              3895.899,
              3203.232
            ],
            [
              180.169,
              3890.535,
              3215.535
            ],
            [
              173.716,
              3890.652,
              3221.988
            ],
            [
              166.034,
              3894.132,
              3230.422
            ],
            [
              157.848,
              3905.413,
              3244.36
            ],
            [
              157.95,
              3910.978,
              3249.925
            ],
            [
              162.024,
              3922.036,
              3261.71
            ],
            [
              167.288,
              3927.506,
              3269.301
            ],
            [
              180.213,
              3928.384,
              3282.257
            ],
            [
              192.997,
              3921.471,
              3296.79
            ],
            [
              194.227,
              3918.109,
              3300.37
            ],
            [
              201.929,
              3915.742,
              3308.428
            ],
            [
              218.162,
              3921.013,
              3325.495
            ],
            [
              228.044,
              3931.965,
              3340.246
            ],
            [
              250.207,
              3943.806,
              3365.374
            ],
            [
              371.802,
              3957.172,
              3487.702
            ],
            [
              383.803,
              3836.724,
              3608.746
            ],
            [
              380.002,
              3770,
              3675.578
            ],
            [
              336.329,
              3640.55,
              3812.197
            ],
            [
              326.991,
              3624.022,
              3831.18
            ],
            [
              309.951,
              3609.861,
              3853.336
            ],
            [
              293.699,
              3603.478,
              3870.797
            ],
            [
              276.903,
              3602.672,
              3887.613
            ],
            [
              258.273,
              3607.464,
              3906.849
            ],
            [
              244.24,
              3616.626,
              3923.608
            ],
            [
              221.077,
              3656.012,
              3969.3
            ],
            [
              215.797,
              3685.052,
              3998.816
            ],
            [
              212.108,
              3695.138,
              4009.556
            ],
            [
              203.903,
              3705.307,
              4022.622
            ],
            [
              187.934,
              3714.503,
              4041.05
            ],
            [
              162.871,
              3720.526,
              4066.826
            ],
            [
              93.084,
              3716.231,
              4136.745
            ],
            [
              41.303,
              3708.267,
              4189.135
            ],
            [
              -51.008,
              3672.096,
              4288.28
            ],
            [
              -107.145,
              3637.493,
              4354.225
            ],
            [
              -149.771,
              3600.417,
              4410.719
            ],
            [
              -182.033,
              3565.379,
              4458.348
            ],
            [
              -225.808,
              3500.493,
              4536.62
            ],
            [
              -239.68,
              3482.933,
              4558.998
            ],
            [
              -275.691,
              3454.642,
              4604.793
            ],
            [
              -305.209,
              3428.459,
              4644.25
            ],
            [
              -308.011,
              3416.265,
              4656.762
            ],
            [
              -288.192,
              3299.017,
              4775.673
            ],
            [
              -248.134,
              3087.891,
              4990.565
            ],
            [
              -233.72,
              2993.006,
              5086.539
            ],
            [
              -225.435,
              2951.666,
              5128.701
            ],
            [
              -266.588,
              2603.973,
              5478.821
            ],
            [
              -287.151,
              2501.929,
              5582.917
            ],
            [
              -327.226,
              2355.709,
              5734.529
            ],
            [
              -350.367,
              2324.958,
              5773.014
            ],
            [
              -412.128,
              2228.113,
              5887.877
            ],
            [
              -425.492,
              2202.75,
              5916.545
            ],
            [
              -439.803,
              2160.707,
              5960.957
            ],
            [
              -445.668,
              2121.85,
              6000.254
            ],
            [
              -471.768,
              2034.377,
              6091.538
            ],
            [
              -499.661,
              1919.106,
              6210.135
            ],
            [
              -508.548,
              1855.813,
              6274.049
            ],
            [
              -490.609,
              1848.809,
              6293.307
            ],
            [
              -470.051,
              1843.985,
              6314.424
            ],
            [
              -432.32,
              1825.49,
              6356.444
            ],
            [
              -327.19,
              1787.963,
              6468.07
            ],
            [
              -259.046,
              1774.482,
              6537.535
            ],
            [
              -147.106,
              1756.865,
              6650.853
            ],
            [
              -84.021,
              1749.04,
              6714.421
            ],
            [
              9.981,
              1738.424,
              6809.021
            ],
            [
              41.02,
              1742.312,
              6840.302
            ],
            [
              63.816,
              1754.143,
              6865.985
            ],
            [
              97.435,
              1757.984,
              6899.823
            ],
            [
              310.866,
              1821.998,
              7122.648
            ],
            [
              325.178,
              1828.416,
              7138.332
            ],
            [
              355.259,
              1885.754,
              7203.082
            ],
            [
              380.962,
              1915.342,
              7242.275
            ],
            [
              392.354,
              1938.511,
              7268.094
            ],
            [
              391.831,
              1945.2,
              7274.803
            ],
            [
              387.438,
              1951.96,
              7282.865
            ],
            [
              365.148,
              1967.953,
              7310.298
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9226",
              "position": {
                "x": 97.359,
                "z": 6222.021
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9276",
              "position": {
                "x": 42.585,
                "z": 5837.842
              },
              "distanceAlongShapeM": 460.636,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7820",
              "position": {
                "x": 80.91,
                "z": 5140.267
              },
              "distanceAlongShapeM": 1167.829,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 1476.01,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9750",
              "position": {
                "x": 366.01,
                "z": 4064.148
              },
              "distanceAlongShapeM": 2893.116,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:10359",
              "position": {
                "x": 228.044,
                "z": 3931.965
              },
              "distanceAlongShapeM": 3340.246,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 5128.701,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 5478.821,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 6314.424,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 6865.985,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7573",
              "position": {
                "x": 355.259,
                "z": 1885.754
              },
              "distanceAlongShapeM": 7203.082,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            }
          ],
          "departuresSeconds": [
            18720,
            20520,
            22320,
            24120,
            25920,
            27960,
            30000,
            32100,
            36300,
            38160,
            40320,
            42420,
            44520,
            46620,
            48720,
            50820,
            52920,
            55020,
            57120,
            59280,
            61500,
            63720,
            65940,
            68160,
            72420,
            74340,
            76200,
            77940,
            79800,
            81660
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_1G",
      "sourceRouteId": "vilnius_expressbus_1G",
      "mode": "bus",
      "shortName": "1G",
      "longName": "Stotis–Kalvarijų g.–Santariškės",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_1G:0",
          "sourceRouteId": "vilnius_expressbus_1G",
          "sourceShapeId": "vilnius_expressbus_1G_a-b",
          "directionId": 0,
          "headsign": "Santariškės",
          "directionName": "Stotis–Kalvarijų g.–Santariškės",
          "mode": "bus",
          "routeShortName": "1G",
          "routeLongName": "Stotis–Kalvarijų g.–Santariškės",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              355.259,
              1885.754,
              0
            ],
            [
              392.313,
              1936.286,
              62.662
            ],
            [
              391.729,
              1939.636,
              66.062
            ],
            [
              372.202,
              1965.597,
              98.547
            ],
            [
              357.795,
              1989.238,
              126.233
            ],
            [
              356.647,
              1997.052,
              134.13
            ],
            [
              359.39,
              2005.908,
              143.401
            ],
            [
              369.268,
              2016.86,
              158.15
            ],
            [
              380.898,
              2017.76,
              169.815
            ],
            [
              389.202,
              2013.156,
              179.31
            ],
            [
              477.214,
              1956.998,
              283.712
            ],
            [
              484.77,
              1946.84,
              296.372
            ],
            [
              483.983,
              1939.062,
              304.19
            ],
            [
              476.08,
              1930.301,
              315.988
            ],
            [
              460.458,
              1922.794,
              333.321
            ],
            [
              416.68,
              1928.048,
              377.412
            ],
            [
              398.6,
              1927.265,
              395.509
            ],
            [
              339.428,
              1831.495,
              508.084
            ],
            [
              330.657,
              1810.504,
              530.834
            ],
            [
              391.321,
              1670.242,
              683.653
            ],
            [
              473.433,
              1574.115,
              810.076
            ],
            [
              482.238,
              1561.708,
              825.29
            ],
            [
              479.414,
              1548.401,
              838.893
            ],
            [
              472.7,
              1534.052,
              854.736
            ],
            [
              453.691,
              1517.701,
              879.809
            ],
            [
              360.424,
              1427.008,
              1009.901
            ],
            [
              315.899,
              1391.085,
              1067.111
            ],
            [
              256.42,
              1348.755,
              1140.114
            ],
            [
              223.566,
              1315.958,
              1186.537
            ],
            [
              196.476,
              1280.829,
              1230.899
            ],
            [
              149.248,
              1202.651,
              1322.235
            ],
            [
              55.081,
              1061.873,
              1491.604
            ],
            [
              52.802,
              1042.989,
              1510.624
            ],
            [
              38.996,
              1028.769,
              1530.444
            ],
            [
              -5.066,
              911.568,
              1655.653
            ],
            [
              -20.812,
              826.136,
              1742.524
            ],
            [
              -26.358,
              769.462,
              1799.469
            ],
            [
              -32.708,
              739.521,
              1830.077
            ],
            [
              -31.911,
              641.542,
              1928.059
            ],
            [
              -49.15,
              509.381,
              2061.339
            ],
            [
              -49.278,
              431.457,
              2139.263
            ],
            [
              18.234,
              348.963,
              2245.861
            ],
            [
              38.092,
              270.675,
              2326.628
            ],
            [
              60.241,
              141.136,
              2458.047
            ],
            [
              63.906,
              129.937,
              2469.83
            ],
            [
              96.95,
              138.241,
              2503.901
            ],
            [
              107.728,
              128.025,
              2518.751
            ],
            [
              116.145,
              94.475,
              2553.341
            ],
            [
              124.691,
              -38.156,
              2686.247
            ],
            [
              129.098,
              -79.426,
              2727.751
            ],
            [
              129.88,
              -107.271,
              2755.607
            ],
            [
              116.846,
              -256.206,
              2905.112
            ],
            [
              117.887,
              -305.208,
              2954.125
            ],
            [
              127.989,
              -387.771,
              3037.304
            ],
            [
              138.319,
              -422.47,
              3073.508
            ],
            [
              150.182,
              -443.837,
              3097.947
            ],
            [
              177.186,
              -518.917,
              3177.735
            ],
            [
              237.149,
              -695.903,
              3364.603
            ],
            [
              238.113,
              -713.732,
              3382.458
            ],
            [
              217.158,
              -872.542,
              3542.645
            ],
            [
              276.82,
              -1242.113,
              3917
            ],
            [
              297.35,
              -1318.188,
              3995.797
            ],
            [
              320.249,
              -1546.82,
              4225.573
            ],
            [
              342.249,
              -1718.661,
              4398.817
            ],
            [
              356.237,
              -1764.56,
              4446.8
            ],
            [
              354.758,
              -1810.175,
              4492.439
            ],
            [
              356.121,
              -1841.371,
              4523.665
            ],
            [
              372.957,
              -1942.984,
              4626.663
            ],
            [
              426.379,
              -2158.817,
              4849.009
            ],
            [
              441.836,
              -2194.724,
              4888.101
            ],
            [
              440.947,
              -2208.066,
              4901.474
            ],
            [
              462.343,
              -2342.047,
              5037.152
            ],
            [
              478.13,
              -2430.282,
              5126.788
            ],
            [
              504.821,
              -2556.567,
              5255.863
            ],
            [
              510.676,
              -2659.093,
              5358.556
            ],
            [
              511.756,
              -2776.003,
              5475.471
            ],
            [
              513.301,
              -2797.183,
              5496.707
            ],
            [
              524.563,
              -2850.825,
              5551.519
            ],
            [
              524.913,
              -2902.04,
              5602.736
            ],
            [
              518.333,
              -3049.981,
              5750.822
            ],
            [
              517.855,
              -3111.2,
              5812.044
            ],
            [
              509.89,
              -3158.924,
              5860.427
            ],
            [
              509.054,
              -3204.551,
              5906.062
            ],
            [
              505.742,
              -3244.567,
              5946.215
            ],
            [
              511.316,
              -3256.915,
              5959.762
            ],
            [
              504.142,
              -3366.994,
              6070.075
            ],
            [
              489.873,
              -3512.567,
              6216.346
            ],
            [
              474.056,
              -3566.826,
              6272.863
            ],
            [
              441.104,
              -3641.923,
              6354.871
            ],
            [
              383.151,
              -3709.882,
              6444.185
            ],
            [
              303.678,
              -3791.921,
              6558.405
            ],
            [
              278.895,
              -3808.166,
              6588.039
            ],
            [
              228.358,
              -3858.451,
              6659.331
            ],
            [
              158.106,
              -3965.152,
              6787.082
            ],
            [
              127.093,
              -4040.286,
              6868.365
            ],
            [
              102.95,
              -4092.167,
              6925.589
            ],
            [
              79.561,
              -4208.631,
              7044.378
            ],
            [
              75.006,
              -4246.398,
              7082.419
            ],
            [
              72.804,
              -4296.453,
              7132.523
            ],
            [
              57.959,
              -4368.543,
              7206.125
            ],
            [
              54.707,
              -4440.844,
              7278.5
            ],
            [
              47.88,
              -4461.871,
              7300.607
            ],
            [
              42.119,
              -4495.164,
              7334.394
            ],
            [
              46.027,
              -4598.766,
              7438.07
            ],
            [
              43.323,
              -4641.02,
              7480.411
            ],
            [
              -32.111,
              -5068.242,
              7914.241
            ],
            [
              -36.204,
              -5116.037,
              7962.211
            ],
            [
              -42.927,
              -5131.5,
              7979.072
            ],
            [
              -75.729,
              -5270.057,
              8121.46
            ],
            [
              -95.037,
              -5339.84,
              8193.864
            ],
            [
              -105.993,
              -5410.888,
              8265.752
            ],
            [
              -116.661,
              -5430.732,
              8288.281
            ],
            [
              -144.967,
              -5534.861,
              8396.189
            ],
            [
              -183.275,
              -5657.733,
              8524.895
            ],
            [
              -188.212,
              -5716.645,
              8584.013
            ],
            [
              -185.377,
              -5737.848,
              8605.405
            ],
            [
              -196.91,
              -5769.923,
              8639.49
            ],
            [
              -201.665,
              -5818.819,
              8688.617
            ],
            [
              -201.086,
              -5857.793,
              8727.595
            ],
            [
              -195.599,
              -5910.215,
              8780.303
            ],
            [
              -136.015,
              -6175.138,
              9051.844
            ],
            [
              -122.378,
              -6204.331,
              9084.065
            ],
            [
              -123.468,
              -6228.802,
              9108.561
            ],
            [
              -113.557,
              -6285.758,
              9166.373
            ],
            [
              -58.166,
              -6532.794,
              9419.543
            ],
            [
              -46.468,
              -6597.576,
              9485.372
            ],
            [
              -39.377,
              -6667.839,
              9555.992
            ],
            [
              -35.045,
              -6748.072,
              9636.342
            ],
            [
              -27.041,
              -6768.256,
              9658.055
            ],
            [
              -16.965,
              -6780.686,
              9674.056
            ],
            [
              0.233,
              -6791.019,
              9694.12
            ],
            [
              10.168,
              -6811.238,
              9716.648
            ],
            [
              11.151,
              -6827.955,
              9733.393
            ],
            [
              7.024,
              -6842.352,
              9748.37
            ],
            [
              -10.864,
              -6869.857,
              9781.18
            ],
            [
              -21.671,
              -6897.49,
              9810.852
            ],
            [
              -10.612,
              -6926.637,
              9842.026
            ],
            [
              -9.853,
              -6955.595,
              9870.994
            ],
            [
              6.027,
              -7144.023,
              10060.09
            ],
            [
              16.38,
              -7176.496,
              10094.174
            ],
            [
              9.978,
              -7209.777,
              10128.065
            ],
            [
              38.024,
              -7507.525,
              10427.131
            ],
            [
              44.494,
              -7541.041,
              10461.265
            ],
            [
              46.371,
              -7614.549,
              10534.798
            ],
            [
              74.723,
              -7859.981,
              10781.862
            ],
            [
              84.573,
              -7884.653,
              10808.427
            ],
            [
              81.064,
              -7935.798,
              10859.693
            ],
            [
              118.182,
              -8264.884,
              11190.866
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5156",
              "position": {
                "x": 389.202,
                "z": 2013.156
              },
              "distanceAlongShapeM": 179.31,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 854.736,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1510.624,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 2553.341,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 3097.947,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 3995.797,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 4446.8,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 5959.762,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 6558.405,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6487",
              "position": {
                "x": 54.707,
                "z": -4440.844
              },
              "distanceAlongShapeM": 7278.5,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 8605.405,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 9084.065,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 10094.174,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:8716",
              "position": {
                "x": 44.494,
                "z": -7541.041
              },
              "distanceAlongShapeM": 10461.265,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:16649",
              "position": {
                "x": 118.182,
                "z": -8264.884
              },
              "distanceAlongShapeM": 11190.866,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            18240,
            18840,
            19260,
            19740,
            20160,
            20520,
            20880,
            21240,
            21660,
            22080,
            22440,
            22800,
            23160,
            23520,
            23820,
            24120,
            24420,
            24720,
            25020,
            25320,
            25620,
            25920,
            26220,
            26520,
            26820,
            27120,
            27420,
            27720,
            28020,
            28320,
            28680,
            28980,
            29280,
            29580,
            29880,
            30180,
            30480,
            30780,
            31140,
            31560,
            31980,
            32580,
            33180,
            33660,
            34080,
            34560,
            34980,
            35460,
            35940,
            36360,
            36840,
            37320,
            37800,
            38220,
            38640,
            39060,
            39540,
            40020,
            40560,
            41040,
            41580,
            42060,
            42540,
            43020,
            43500,
            44040,
            44580,
            45120,
            45600,
            46080,
            46620,
            47100,
            47580,
            48060,
            48540,
            48960,
            49380,
            49800,
            50280,
            50820,
            51360,
            51900,
            52440,
            52920,
            53460,
            54000,
            54540,
            55020,
            55500,
            55980,
            56460,
            56940,
            57300,
            57660,
            58020,
            58320,
            58620,
            58920,
            59280,
            59580,
            59880,
            60180,
            60480,
            60780,
            61140,
            61500,
            61860,
            62220,
            62520,
            62820,
            63120,
            63420,
            63720,
            64020,
            64320,
            64680,
            65040,
            65400,
            65820,
            66240,
            66720,
            67140,
            67560,
            67920,
            68340,
            68700,
            69060,
            69480,
            69900,
            70320,
            70800,
            71220,
            71700,
            72180,
            72660,
            73140,
            73560,
            74040,
            74580,
            75060,
            75540,
            76020,
            76500,
            77040,
            77520,
            78000,
            78540,
            79020,
            79500,
            79980,
            80460,
            80940,
            81420,
            81960,
            82500,
            83100,
            83700,
            84360,
            85080,
            86400
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_1G:1",
          "sourceRouteId": "vilnius_expressbus_1G",
          "sourceShapeId": "vilnius_expressbus_1G_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Santariškės–Kalvarijų g.–Stotis",
          "mode": "bus",
          "routeShortName": "1G",
          "routeLongName": "Stotis–Kalvarijų g.–Santariškės",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              118.182,
              -8264.884,
              0
            ],
            [
              113.324,
              -8319.345,
              54.677
            ],
            [
              119.934,
              -8345.07,
              81.238
            ],
            [
              130.007,
              -8357.5,
              97.237
            ],
            [
              136.801,
              -8373.21,
              114.352
            ],
            [
              136.732,
              -8412.172,
              153.315
            ],
            [
              134.097,
              -8415.464,
              157.531
            ],
            [
              123.699,
              -8420.84,
              169.237
            ],
            [
              117.305,
              -8418.496,
              176.047
            ],
            [
              114.209,
              -8411.76,
              183.46
            ],
            [
              113.324,
              -8319.345,
              275.88
            ],
            [
              103.551,
              -8220.087,
              375.618
            ],
            [
              64.771,
              -7840.874,
              756.808
            ],
            [
              60.212,
              -7808.507,
              789.495
            ],
            [
              51.629,
              -7784.972,
              814.547
            ],
            [
              54.874,
              -7748.294,
              851.368
            ],
            [
              46.371,
              -7614.549,
              985.383
            ],
            [
              38.797,
              -7570.994,
              1029.591
            ],
            [
              25.801,
              -7471.678,
              1129.754
            ],
            [
              8.189,
              -7201.951,
              1400.055
            ],
            [
              -2.477,
              -7116.037,
              1486.629
            ],
            [
              -15.345,
              -7080.178,
              1524.727
            ],
            [
              -10.894,
              -7047.975,
              1557.236
            ],
            [
              -21.671,
              -6897.49,
              1708.106
            ],
            [
              -33.557,
              -6878.349,
              1730.638
            ],
            [
              -59.463,
              -6851.158,
              1768.194
            ],
            [
              -67.548,
              -6835.425,
              1785.882
            ],
            [
              -70.502,
              -6820.899,
              1800.706
            ],
            [
              -64.262,
              -6796.522,
              1825.869
            ],
            [
              -53.78,
              -6786.694,
              1840.238
            ],
            [
              -43.196,
              -6771.301,
              1858.918
            ],
            [
              -41.984,
              -6740.153,
              1890.091
            ],
            [
              -44.194,
              -6720.074,
              1910.291
            ],
            [
              -50.829,
              -6695.462,
              1935.782
            ],
            [
              -50.159,
              -6658.737,
              1972.513
            ],
            [
              -53.169,
              -6611.926,
              2019.42
            ],
            [
              -67.701,
              -6525.941,
              2106.624
            ],
            [
              -119.736,
              -6306.797,
              2331.862
            ],
            [
              -170.109,
              -6102.156,
              2542.611
            ],
            [
              -182.398,
              -6069.649,
              2577.364
            ],
            [
              -186.217,
              -6031.729,
              2615.475
            ],
            [
              -210.448,
              -5912.171,
              2737.464
            ],
            [
              -214.769,
              -5866.45,
              2783.389
            ],
            [
              -215.425,
              -5796.303,
              2853.538
            ],
            [
              -201.911,
              -5690.791,
              2959.912
            ],
            [
              -179.043,
              -5602.148,
              3051.458
            ],
            [
              -176.685,
              -5578.813,
              3074.912
            ],
            [
              -161.79,
              -5539.008,
              3117.413
            ],
            [
              -100.123,
              -5300.784,
              3363.489
            ],
            [
              -97,
              -5270.783,
              3393.652
            ],
            [
              -86.291,
              -5248.713,
              3418.182
            ],
            [
              -41.786,
              -5033.555,
              3637.895
            ],
            [
              -41.097,
              -4995.718,
              3675.739
            ],
            [
              -29.601,
              -4965.87,
              3707.724
            ],
            [
              29.378,
              -4628.52,
              4050.191
            ],
            [
              28.501,
              -4570.615,
              4108.102
            ],
            [
              22.071,
              -4499.251,
              4179.755
            ],
            [
              25.378,
              -4459.234,
              4219.908
            ],
            [
              39.057,
              -4380.444,
              4299.877
            ],
            [
              49.82,
              -4284.902,
              4396.024
            ],
            [
              59.203,
              -4265.034,
              4417.995
            ],
            [
              91.736,
              -4106.435,
              4579.897
            ],
            [
              104.143,
              -4062.131,
              4625.905
            ],
            [
              126.577,
              -3997.973,
              4693.873
            ],
            [
              148.043,
              -3951.609,
              4744.965
            ],
            [
              246.3,
              -3828.721,
              4902.305
            ],
            [
              290.877,
              -3787.233,
              4963.201
            ],
            [
              363.161,
              -3710.629,
              5068.525
            ],
            [
              434.283,
              -3627.326,
              5178.06
            ],
            [
              450.253,
              -3599.787,
              5209.894
            ],
            [
              463.769,
              -3565.524,
              5246.726
            ],
            [
              474.065,
              -3531.203,
              5282.559
            ],
            [
              484.063,
              -3477.95,
              5336.742
            ],
            [
              489.712,
              -3345.578,
              5469.234
            ],
            [
              488.249,
              -3319.947,
              5494.907
            ],
            [
              479.687,
              -3259.675,
              5555.785
            ],
            [
              477.905,
              -3216.226,
              5599.27
            ],
            [
              481.339,
              -3169.533,
              5646.089
            ],
            [
              500.602,
              -3103.091,
              5715.267
            ],
            [
              500.428,
              -3077.483,
              5740.875
            ],
            [
              504.445,
              -3034.141,
              5784.404
            ],
            [
              503.491,
              -2980.688,
              5837.865
            ],
            [
              505.751,
              -2962.917,
              5855.779
            ],
            [
              502.159,
              -2912.756,
              5906.069
            ],
            [
              509.899,
              -2877.274,
              5942.385
            ],
            [
              511.861,
              -2840.573,
              5979.139
            ],
            [
              496.04,
              -2648.805,
              6171.557
            ],
            [
              482.722,
              -2601.805,
              6220.408
            ],
            [
              485.911,
              -2568.466,
              6253.899
            ],
            [
              474.223,
              -2432.437,
              6390.43
            ],
            [
              449.166,
              -2287.257,
              6537.757
            ],
            [
              413.918,
              -2135.211,
              6693.835
            ],
            [
              407.176,
              -2116.162,
              6714.041
            ],
            [
              406.254,
              -2096.107,
              6734.118
            ],
            [
              369.715,
              -1944.038,
              6890.515
            ],
            [
              352.071,
              -1851.316,
              6984.9
            ],
            [
              343.07,
              -1744.281,
              7092.314
            ],
            [
              332.874,
              -1667.281,
              7169.986
            ],
            [
              324.984,
              -1640.419,
              7197.982
            ],
            [
              326.097,
              -1614.835,
              7223.591
            ],
            [
              277.22,
              -1255.479,
              7586.255
            ],
            [
              271.867,
              -1230.89,
              7611.42
            ],
            [
              265.625,
              -1219.643,
              7624.283
            ],
            [
              267.28,
              -1199.635,
              7644.359
            ],
            [
              254.802,
              -1141.519,
              7703.8
            ],
            [
              216.915,
              -885.896,
              7962.215
            ],
            [
              226.048,
              -703.492,
              8144.848
            ],
            [
              223.795,
              -685.64,
              8162.842
            ],
            [
              209.218,
              -636.391,
              8214.203
            ],
            [
              192.022,
              -589.321,
              8264.315
            ],
            [
              159.237,
              -513.023,
              8347.359
            ],
            [
              151.725,
              -500.641,
              8361.842
            ],
            [
              143.086,
              -479.332,
              8384.836
            ],
            [
              121.213,
              -441.083,
              8428.897
            ],
            [
              106.146,
              -277.163,
              8593.508
            ],
            [
              46.11,
              -280.522,
              8653.637
            ],
            [
              26.146,
              -279.045,
              8673.656
            ],
            [
              15.43,
              -265.491,
              8690.935
            ],
            [
              14.363,
              -253.226,
              8703.246
            ],
            [
              16.439,
              -245.471,
              8711.274
            ],
            [
              45.916,
              -220.403,
              8749.968
            ],
            [
              103.215,
              -190.277,
              8814.705
            ],
            [
              127.382,
              -102.772,
              8905.486
            ],
            [
              121.848,
              -52.576,
              8955.986
            ],
            [
              115.041,
              -36.866,
              8973.107
            ],
            [
              117.583,
              -3.516,
              9006.555
            ],
            [
              102.671,
              133.684,
              9144.562
            ],
            [
              63.181,
              125.497,
              9184.892
            ],
            [
              59.312,
              125.568,
              9188.761
            ],
            [
              57.419,
              127.829,
              9191.71
            ],
            [
              31.786,
              278.582,
              9344.627
            ],
            [
              4.856,
              358.112,
              9428.593
            ],
            [
              -8.924,
              380.627,
              9454.99
            ],
            [
              -39.768,
              422.378,
              9506.899
            ],
            [
              -46.8,
              425.846,
              9514.739
            ],
            [
              -51.212,
              431.492,
              9521.905
            ],
            [
              -51.307,
              497.175,
              9587.587
            ],
            [
              -56,
              522.864,
              9613.702
            ],
            [
              -44.593,
              547.148,
              9640.531
            ],
            [
              -34.25,
              619.32,
              9713.441
            ],
            [
              -34.886,
              726.201,
              9820.324
            ],
            [
              -29.964,
              784,
              9878.332
            ],
            [
              -31.514,
              805.179,
              9899.568
            ],
            [
              -24.076,
              823.969,
              9919.776
            ],
            [
              -6.94,
              914.942,
              10012.349
            ],
            [
              5.94,
              949.218,
              10048.965
            ],
            [
              14.89,
              980.225,
              10081.238
            ],
            [
              17.976,
              1008,
              10109.184
            ],
            [
              104.844,
              1137.779,
              10265.353
            ],
            [
              206.575,
              1304.022,
              10460.253
            ],
            [
              265.611,
              1357.493,
              10539.904
            ],
            [
              360.424,
              1427.008,
              10657.47
            ],
            [
              406.382,
              1470.698,
              10720.881
            ],
            [
              390.605,
              1489.911,
              10745.742
            ],
            [
              398.092,
              1546.549,
              10802.872
            ],
            [
              392.049,
              1568.924,
              10826.049
            ],
            [
              397.453,
              1582.184,
              10840.368
            ],
            [
              391.321,
              1670.242,
              10928.639
            ],
            [
              327.595,
              1819.466,
              11090.9
            ],
            [
              328.524,
              1835.034,
              11106.496
            ],
            [
              355.259,
              1885.754,
              11163.831
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7830",
              "position": {
                "x": 112.767,
                "z": -8385.016
              },
              "distanceAlongShapeM": 210.217,
              "shapeOffsetM": 1.186,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 1129.754,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 1524.727,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 2577.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6494",
              "position": {
                "x": -176.685,
                "z": -5578.813
              },
              "distanceAlongShapeM": 3074.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 4396.024,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 5100.125,
              "shapeOffsetM": 0.131,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 5906.069,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 7197.982,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 7624.283,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 8428.897,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 8973.107,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 9613.702,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 10109.184,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7573",
              "position": {
                "x": 355.259,
                "z": 1885.754
              },
              "distanceAlongShapeM": 11163.831,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            18660,
            19140,
            19800,
            20520,
            20940,
            21420,
            21840,
            22260,
            22560,
            22860,
            23160,
            23460,
            23760,
            24120,
            24480,
            24780,
            25080,
            25380,
            25740,
            26100,
            26400,
            26700,
            27000,
            27300,
            27600,
            27900,
            28200,
            28500,
            28800,
            29100,
            29400,
            29820,
            30240,
            30660,
            31020,
            31440,
            31920,
            32280,
            32640,
            32940,
            33360,
            33780,
            34260,
            34740,
            35160,
            35580,
            36000,
            36480,
            36960,
            37500,
            38040,
            38580,
            39060,
            39540,
            40020,
            40500,
            40980,
            41460,
            41940,
            42420,
            42900,
            43380,
            43860,
            44340,
            44820,
            45300,
            45780,
            46260,
            46680,
            47100,
            47580,
            48060,
            48480,
            48960,
            49500,
            49980,
            50520,
            51060,
            51600,
            52140,
            52680,
            53220,
            53760,
            54300,
            54720,
            55140,
            55560,
            55980,
            56460,
            56940,
            57420,
            57840,
            58260,
            58680,
            59100,
            59520,
            59940,
            60240,
            60540,
            60840,
            61140,
            61440,
            61740,
            62100,
            62460,
            62820,
            63180,
            63480,
            63840,
            64260,
            64680,
            65100,
            65520,
            65940,
            66360,
            66720,
            67140,
            67500,
            67860,
            68160,
            68460,
            68820,
            69180,
            69660,
            70140,
            70620,
            71160,
            71700,
            72240,
            72720,
            73200,
            73680,
            74160,
            74640,
            75120,
            75600,
            76080,
            76500,
            76860,
            77220,
            77640,
            78120,
            78600,
            79080,
            79560,
            80100,
            80640,
            81180,
            81720,
            82320,
            82920,
            83520,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_2",
      "sourceRouteId": "vilnius_bus_2",
      "mode": "bus",
      "shortName": "2",
      "longName": "Stotis–Liepkalnio–Vikingų g.–Oro uostas",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_2:0",
          "sourceRouteId": "vilnius_bus_2",
          "sourceShapeId": "vilnius_bus_2_a-b",
          "directionId": 0,
          "headsign": "Oro uostas",
          "directionName": "Stotis–Liepkalnio–Vikingų g.–Oro uostas",
          "mode": "bus",
          "routeShortName": "2",
          "routeLongName": "Stotis–Liepkalnio–Vikingų g.–Oro uostas",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              493.148,
              1911.064,
              0
            ],
            [
              468.32,
              1929.33,
              30.824
            ],
            [
              440.606,
              1930.95,
              58.585
            ],
            [
              420.672,
              1934.654,
              78.86
            ],
            [
              395.721,
              1946.243,
              106.371
            ],
            [
              365.148,
              1967.953,
              143.868
            ],
            [
              366.037,
              1981.295,
              157.24
            ],
            [
              377.952,
              1997.776,
              177.577
            ],
            [
              392.142,
              1997.517,
              191.769
            ],
            [
              473.887,
              1951.492,
              285.579
            ],
            [
              478.68,
              1931.366,
              306.268
            ],
            [
              623.161,
              1858.587,
              468.045
            ],
            [
              825.163,
              1791.425,
              680.919
            ],
            [
              862.14,
              1837.501,
              739.998
            ],
            [
              869.06,
              1862.978,
              766.398
            ],
            [
              873.401,
              1888.503,
              792.289
            ],
            [
              889.31,
              1911.588,
              820.326
            ],
            [
              908.823,
              1920.135,
              841.629
            ],
            [
              941.154,
              1923.993,
              874.189
            ],
            [
              953.593,
              1933.783,
              890.019
            ],
            [
              1083.618,
              2057.184,
              1069.279
            ],
            [
              1196.071,
              2172,
              1229.991
            ],
            [
              1233.034,
              2216.96,
              1288.195
            ],
            [
              1262.402,
              2269.853,
              1348.694
            ],
            [
              1272.571,
              2296.383,
              1377.106
            ],
            [
              1295.641,
              2322.675,
              1412.084
            ],
            [
              1353.693,
              2426.246,
              1530.815
            ],
            [
              1363.843,
              2451.663,
              1558.183
            ],
            [
              1395.21,
              2612.502,
              1722.053
            ],
            [
              1412.03,
              2684.551,
              1796.039
            ],
            [
              1428.563,
              2741.021,
              1854.879
            ],
            [
              1438.754,
              2768.663,
              1884.34
            ],
            [
              1466.069,
              2814.913,
              1938.054
            ],
            [
              1480.947,
              2816.864,
              1953.06
            ],
            [
              1584.045,
              2912.919,
              2093.971
            ],
            [
              1624.327,
              2962.268,
              2157.672
            ],
            [
              1644.883,
              2991.944,
              2193.773
            ],
            [
              1682.229,
              3056.932,
              2268.727
            ],
            [
              1693.837,
              3091.227,
              2304.933
            ],
            [
              1697.848,
              3133.456,
              2347.352
            ],
            [
              1698.943,
              3192.437,
              2406.344
            ],
            [
              1697.261,
              3310.472,
              2524.39
            ],
            [
              1700.204,
              3399.476,
              2613.443
            ],
            [
              1674.097,
              3592.551,
              2808.275
            ],
            [
              1669.889,
              3748.482,
              2964.263
            ],
            [
              1617.274,
              3730.533,
              3019.856
            ],
            [
              1602.913,
              3721.893,
              3036.615
            ],
            [
              1497.952,
              3700.459,
              3143.742
            ],
            [
              1228.761,
              3628.622,
              3422.354
            ],
            [
              1081.72,
              3600.162,
              3572.123
            ],
            [
              1000.053,
              3581.628,
              3655.867
            ],
            [
              917.844,
              3568.668,
              3739.091
            ],
            [
              819.044,
              3566.031,
              3837.927
            ],
            [
              779.706,
              3567.866,
              3877.307
            ],
            [
              724.965,
              3574.437,
              3932.442
            ],
            [
              647.824,
              3591.436,
              4011.433
            ],
            [
              549.01,
              3623.303,
              4115.259
            ],
            [
              339.987,
              3699.484,
              4337.732
            ],
            [
              289.862,
              3711.532,
              4389.284
            ],
            [
              262.015,
              3706.473,
              4417.587
            ],
            [
              248.282,
              3696.705,
              4434.439
            ],
            [
              235.8,
              3684.687,
              4451.767
            ],
            [
              231.06,
              3672.528,
              4464.817
            ],
            [
              230.715,
              3653.609,
              4483.739
            ],
            [
              236.096,
              3630.133,
              4507.824
            ],
            [
              244.26,
              3617.739,
              4522.666
            ],
            [
              255.046,
              3607.523,
              4537.522
            ],
            [
              271.096,
              3602.778,
              4554.258
            ],
            [
              285.291,
              3602.519,
              4568.455
            ],
            [
              311.928,
              3612.052,
              4596.747
            ],
            [
              323.12,
              3624.093,
              4613.186
            ],
            [
              341.857,
              3660.487,
              4654.121
            ],
            [
              361.224,
              3731.38,
              4727.611
            ],
            [
              371.817,
              3781.282,
              4778.625
            ],
            [
              370.232,
              3835.859,
              4833.225
            ],
            [
              359.252,
              3906.193,
              4904.411
            ],
            [
              346.733,
              3927.573,
              4929.187
            ],
            [
              325.018,
              3940.215,
              4954.314
            ],
            [
              260.994,
              3933.59,
              5018.68
            ],
            [
              244.74,
              3927.207,
              5036.142
            ],
            [
              208.199,
              3905.609,
              5078.588
            ],
            [
              199.125,
              3903.548,
              5087.894
            ],
            [
              193.902,
              3900.304,
              5094.042
            ],
            [
              189.264,
              3893.709,
              5102.105
            ],
            [
              180.814,
              3890.523,
              5111.135
            ],
            [
              167.304,
              3892.996,
              5124.869
            ],
            [
              160.288,
              3897.576,
              5133.249
            ],
            [
              155.933,
              3906.561,
              5143.234
            ],
            [
              156.7,
              3913.227,
              5149.943
            ],
            [
              169.203,
              3926.358,
              5168.075
            ],
            [
              178.923,
              3928.407,
              5178.008
            ],
            [
              191.081,
              3922.619,
              5191.474
            ],
            [
              196.787,
              3916.949,
              5199.518
            ],
            [
              205.821,
              3916.785,
              5208.553
            ],
            [
              228.044,
              3931.965,
              5235.466
            ],
            [
              267.146,
              3952.403,
              5279.587
            ],
            [
              353.089,
              3957.514,
              5365.682
            ],
            [
              339.014,
              4105.83,
              5514.665
            ],
            [
              333.674,
              4131.532,
              5540.916
            ],
            [
              328.708,
              4248.511,
              5658
            ],
            [
              -16.313,
              4267.041,
              6003.518
            ],
            [
              -27.868,
              4270.591,
              6015.606
            ],
            [
              -30.045,
              4292.895,
              6038.016
            ],
            [
              -28.186,
              4359.654,
              6104.802
            ],
            [
              -33.24,
              4507.805,
              6253.039
            ],
            [
              -26.822,
              4612.332,
              6357.762
            ],
            [
              -9.27,
              4725.561,
              6472.344
            ],
            [
              19.778,
              4831.903,
              6582.582
            ],
            [
              33.779,
              4891.762,
              6644.057
            ],
            [
              49.008,
              4912.637,
              6669.896
            ],
            [
              65.892,
              4953.519,
              6714.127
            ],
            [
              77.939,
              5047.924,
              6809.298
            ],
            [
              190.244,
              5045.879,
              6921.621
            ],
            [
              184.689,
              4953.583,
              7014.085
            ],
            [
              190.96,
              4943.45,
              7026.002
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8262",
              "position": {
                "x": 365.148,
                "z": 1967.953
              },
              "distanceAlongShapeM": 143.868,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 820.326,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 1377.106,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 1938.054,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:16978",
              "position": {
                "x": 1602.913,
                "z": 3721.893
              },
              "distanceAlongShapeM": 3036.615,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:10359",
              "position": {
                "x": 228.044,
                "z": 3931.965
              },
              "distanceAlongShapeM": 5235.466,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:9738",
              "position": {
                "x": 333.674,
                "z": 4131.532
              },
              "distanceAlongShapeM": 5540.916,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 7026.002,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            }
          ],
          "departuresSeconds": [
            19860,
            23280,
            26880,
            30480,
            32640,
            36720,
            40020,
            43740,
            47520,
            51240,
            54720,
            57120,
            58620,
            60480,
            62160,
            63840,
            65340,
            71520,
            74460,
            77400,
            80340
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_2:1",
          "sourceRouteId": "vilnius_bus_2",
          "sourceShapeId": "vilnius_bus_2_b1-a1",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Oro uostas–Vikingų–Liepynės kapinės–Stotis",
          "mode": "bus",
          "routeShortName": "2",
          "routeLongName": "Stotis–Liepkalnio–Vikingų g.–Oro uostas",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              190.96,
              4943.45,
              0
            ],
            [
              173.065,
              4882.548,
              63.476
            ],
            [
              169.736,
              4877.043,
              69.91
            ],
            [
              106.811,
              4896,
              135.629
            ],
            [
              65.284,
              4920.133,
              183.658
            ],
            [
              56.935,
              4922.512,
              192.34
            ],
            [
              38.922,
              4890.556,
              229.023
            ],
            [
              8.764,
              4794.253,
              329.937
            ],
            [
              -10.098,
              4715.557,
              410.862
            ],
            [
              -20.79,
              4660.091,
              467.35
            ],
            [
              -26.278,
              4606.755,
              520.967
            ],
            [
              -28.3,
              4495.47,
              632.271
            ],
            [
              -27.162,
              4273.918,
              853.826
            ],
            [
              -18.208,
              4269.302,
              863.899
            ],
            [
              130.759,
              4261.026,
              1013.096
            ],
            [
              341.111,
              4256.078,
              1223.507
            ],
            [
              343.708,
              4221.52,
              1258.161
            ],
            [
              366.01,
              4064.148,
              1417.106
            ],
            [
              372.087,
              3972.752,
              1508.704
            ],
            [
              375.049,
              3958.226,
              1523.529
            ],
            [
              372.971,
              3950.472,
              1531.557
            ],
            [
              369.038,
              3947.204,
              1536.67
            ],
            [
              354.116,
              3943.023,
              1552.167
            ],
            [
              330.159,
              3939.008,
              1576.457
            ],
            [
              288.801,
              3936.423,
              1617.896
            ],
            [
              255.146,
              3931.471,
              1651.914
            ],
            [
              244.74,
              3927.207,
              1663.159
            ],
            [
              217.274,
              3907.67,
              1696.865
            ],
            [
              195.233,
              3902.506,
              1719.503
            ],
            [
              191.24,
              3895.899,
              1727.223
            ],
            [
              180.169,
              3890.535,
              1739.525
            ],
            [
              173.716,
              3890.652,
              1745.978
            ],
            [
              166.034,
              3894.132,
              1754.412
            ],
            [
              159.078,
              3902.051,
              1764.952
            ],
            [
              157.95,
              3910.978,
              1773.95
            ],
            [
              162.024,
              3922.036,
              1785.735
            ],
            [
              167.288,
              3927.506,
              1793.326
            ],
            [
              180.213,
              3928.384,
              1806.281
            ],
            [
              192.997,
              3921.471,
              1820.814
            ],
            [
              194.227,
              3918.109,
              1824.394
            ],
            [
              201.929,
              3915.742,
              1832.452
            ],
            [
              218.162,
              3921.013,
              1849.519
            ],
            [
              228.044,
              3931.965,
              1864.271
            ],
            [
              360.751,
              3952.921,
              1998.622
            ],
            [
              378.117,
              3843.508,
              2109.405
            ],
            [
              398.272,
              3780.799,
              2175.273
            ],
            [
              423.248,
              3734.7,
              2227.703
            ],
            [
              449.718,
              3699.706,
              2271.581
            ],
            [
              489.112,
              3665.589,
              2323.695
            ],
            [
              524.294,
              3648.247,
              2362.919
            ],
            [
              632.02,
              3609.538,
              2477.388
            ],
            [
              682.727,
              3594.136,
              2530.383
            ],
            [
              736.158,
              3586.477,
              2584.36
            ],
            [
              825.762,
              3580.379,
              2674.171
            ],
            [
              940.191,
              3590.522,
              2789.049
            ],
            [
              904.801,
              3807.14,
              3008.538
            ],
            [
              901.093,
              3816.114,
              3018.248
            ],
            [
              862.991,
              3850.211,
              3069.379
            ],
            [
              859.324,
              3861.41,
              3081.164
            ],
            [
              876.93,
              3871.106,
              3101.263
            ],
            [
              898.296,
              3839.543,
              3139.378
            ],
            [
              901.257,
              3825.016,
              3154.203
            ],
            [
              916.272,
              3799.136,
              3184.124
            ],
            [
              941.686,
              3601.627,
              3383.261
            ],
            [
              1319.455,
              3681.496,
              3769.381
            ],
            [
              1545.858,
              3742.988,
              4003.986
            ],
            [
              1664.639,
              3778.637,
              4128.002
            ],
            [
              1674.798,
              3769.542,
              4141.637
            ],
            [
              1679.129,
              3759.443,
              4152.626
            ],
            [
              1677.281,
              3729.42,
              4182.706
            ],
            [
              1684.234,
              3721.498,
              4193.246
            ],
            [
              1678.221,
              3710.477,
              4205.801
            ],
            [
              1677.947,
              3591.366,
              4324.912
            ],
            [
              1696.885,
              3464.105,
              4453.574
            ],
            [
              1701.035,
              3409.48,
              4508.357
            ],
            [
              1703.196,
              3282.531,
              4635.325
            ],
            [
              1703.03,
              3134.473,
              4783.382
            ],
            [
              1699.891,
              3104.474,
              4813.545
            ],
            [
              1687.994,
              3054.599,
              4864.82
            ],
            [
              1659.262,
              3001.697,
              4925.021
            ],
            [
              1605.061,
              2932.568,
              5012.865
            ],
            [
              1556.997,
              2881.137,
              5083.259
            ],
            [
              1484.111,
              2813.466,
              5182.716
            ],
            [
              1478.744,
              2802.433,
              5194.985
            ],
            [
              1453.839,
              2781.743,
              5227.363
            ],
            [
              1433.991,
              2755.392,
              5260.352
            ],
            [
              1428.563,
              2741.021,
              5275.715
            ],
            [
              1382.281,
              2541.494,
              5480.539
            ],
            [
              1365.86,
              2456.079,
              5567.519
            ],
            [
              1336.284,
              2392.058,
              5638.041
            ],
            [
              1224.883,
              2194.846,
              5864.542
            ],
            [
              958.108,
              1933.7,
              6237.859
            ],
            [
              922.174,
              1874.247,
              6307.329
            ],
            [
              898.105,
              1863.557,
              6333.664
            ],
            [
              862.14,
              1837.501,
              6378.076
            ],
            [
              825.163,
              1791.425,
              6437.155
            ],
            [
              623.161,
              1858.587,
              6650.029
            ],
            [
              493.148,
              1911.064,
              6790.233
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9750",
              "position": {
                "x": 366.01,
                "z": 4064.148
              },
              "distanceAlongShapeM": 1417.106,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:10359",
              "position": {
                "x": 228.044,
                "z": 3931.965
              },
              "distanceAlongShapeM": 1864.271,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:17003",
              "position": {
                "x": 916.272,
                "z": 3799.136
              },
              "distanceAlongShapeM": 3184.124,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6024",
              "position": {
                "x": 1319.455,
                "z": 3681.496
              },
              "distanceAlongShapeM": 3769.381,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 4193.246,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 5194.985,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 5864.542,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 6307.329,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 6790.233,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            }
          ],
          "departuresSeconds": [
            21180,
            31980,
            34140,
            38220,
            41520,
            45240,
            49020,
            52800,
            56340,
            58680,
            60180,
            63720,
            78660
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_2G",
      "sourceRouteId": "vilnius_expressbus_2G",
      "mode": "bus",
      "shortName": "2G",
      "longName": "Santariškės–Laisvės pr.–Stotis",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_2G:0",
          "sourceRouteId": "vilnius_expressbus_2G",
          "sourceShapeId": "vilnius_expressbus_2G_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Santariškės–Laisvės pr.–Stotis",
          "mode": "bus",
          "routeShortName": "2G",
          "routeLongName": "Santariškės–Laisvės pr.–Stotis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              73.695,
              -7563.839,
              0
            ],
            [
              69.345,
              -7590.477,
              26.991
            ],
            [
              45.368,
              -7598.945,
              52.419
            ],
            [
              37.787,
              -7591.014,
              63.391
            ],
            [
              25.801,
              -7471.678,
              183.328
            ],
            [
              8.189,
              -7201.951,
              453.629
            ],
            [
              -2.477,
              -7116.037,
              540.203
            ],
            [
              -15.345,
              -7080.178,
              578.301
            ],
            [
              -10.894,
              -7047.975,
              610.81
            ],
            [
              -21.671,
              -6897.49,
              761.68
            ],
            [
              -33.557,
              -6878.349,
              784.212
            ],
            [
              -59.463,
              -6851.158,
              821.767
            ],
            [
              -67.548,
              -6835.425,
              839.456
            ],
            [
              -70.502,
              -6820.899,
              854.279
            ],
            [
              -64.262,
              -6796.522,
              879.443
            ],
            [
              -53.78,
              -6786.694,
              893.812
            ],
            [
              -43.196,
              -6771.301,
              912.492
            ],
            [
              -41.984,
              -6740.153,
              943.664
            ],
            [
              -44.194,
              -6720.074,
              963.864
            ],
            [
              -50.829,
              -6695.462,
              989.355
            ],
            [
              -50.159,
              -6658.737,
              1026.086
            ],
            [
              -53.169,
              -6611.926,
              1072.994
            ],
            [
              -67.701,
              -6525.941,
              1160.198
            ],
            [
              -119.736,
              -6306.797,
              1385.435
            ],
            [
              -170.109,
              -6102.156,
              1596.184
            ],
            [
              -182.398,
              -6069.649,
              1630.937
            ],
            [
              -186.217,
              -6031.729,
              1669.049
            ],
            [
              -210.448,
              -5912.171,
              1791.038
            ],
            [
              -214.688,
              -5861.998,
              1841.389
            ],
            [
              -215.425,
              -5796.303,
              1907.088
            ],
            [
              -210.007,
              -5746.306,
              1957.378
            ],
            [
              -195.772,
              -5671.978,
              2033.057
            ],
            [
              -200.158,
              -5665.219,
              2041.115
            ],
            [
              -245.834,
              -5662.161,
              2086.893
            ],
            [
              -275.515,
              -5664.961,
              2116.705
            ],
            [
              -314.611,
              -5654.232,
              2157.247
            ],
            [
              -365.398,
              -5648.856,
              2208.318
            ],
            [
              -408.358,
              -5638.057,
              2252.614
            ],
            [
              -454.376,
              -5618.297,
              2302.695
            ],
            [
              -663.705,
              -5510.974,
              2537.934
            ],
            [
              -740.836,
              -5466.163,
              2627.136
            ],
            [
              -765.768,
              -5455.693,
              2654.178
            ],
            [
              -887.614,
              -5390.039,
              2792.587
            ],
            [
              -927.257,
              -5373.739,
              2835.45
            ],
            [
              -1090.384,
              -5275.062,
              3026.1
            ],
            [
              -1302.999,
              -5205.56,
              3249.787
            ],
            [
              -1387.604,
              -5181.778,
              3337.67
            ],
            [
              -1687.713,
              -4997.177,
              3690.01
            ],
            [
              -1731.791,
              -4976.352,
              3738.76
            ],
            [
              -1760.592,
              -4965.819,
              3769.426
            ],
            [
              -1786.639,
              -4945.316,
              3802.574
            ],
            [
              -1870.695,
              -4890.382,
              3902.989
            ],
            [
              -2020.603,
              -4770.824,
              4094.735
            ],
            [
              -2056.897,
              -4746.801,
              4138.26
            ],
            [
              -2116.546,
              -4695.646,
              4216.84
            ],
            [
              -2169.487,
              -4665.762,
              4277.634
            ],
            [
              -2190.603,
              -4657.594,
              4300.273
            ],
            [
              -2217.593,
              -4653.776,
              4327.533
            ],
            [
              -2245.99,
              -4656.611,
              4356.071
            ],
            [
              -2248.369,
              -4645.437,
              4367.496
            ],
            [
              -2421.69,
              -4610.083,
              4544.386
            ],
            [
              -2609.045,
              -4566.695,
              4736.699
            ],
            [
              -2630.259,
              -4564.094,
              4758.072
            ],
            [
              -2748.743,
              -4524.155,
              4883.106
            ],
            [
              -2772.397,
              -4513.719,
              4908.96
            ],
            [
              -2809.985,
              -4489.679,
              4953.578
            ],
            [
              -2814.297,
              -4478.471,
              4965.587
            ],
            [
              -2835.666,
              -4448.038,
              5002.773
            ],
            [
              -2880.475,
              -4394.928,
              5072.261
            ],
            [
              -2902.49,
              -4364.484,
              5109.831
            ],
            [
              -2923.723,
              -4326.261,
              5153.555
            ],
            [
              -2938.397,
              -4244.738,
              5236.388
            ],
            [
              -2943.47,
              -4203.459,
              5277.977
            ],
            [
              -2943.332,
              -4158.933,
              5322.504
            ],
            [
              -2947.565,
              -4106.537,
              5375.071
            ],
            [
              -2936.886,
              -4048.837,
              5433.75
            ],
            [
              -2933.232,
              -3950.938,
              5531.717
            ],
            [
              -2933.288,
              -3880.804,
              5601.851
            ],
            [
              -2935.53,
              -3825.104,
              5657.597
            ],
            [
              -2942.439,
              -3778.227,
              5704.98
            ],
            [
              -2941.11,
              -3739.288,
              5743.942
            ],
            [
              -2942.553,
              -3711.432,
              5771.835
            ],
            [
              -2962.772,
              -3578.604,
              5906.194
            ],
            [
              -2994.393,
              -3434.443,
              6053.782
            ],
            [
              -3009.522,
              -3378.516,
              6111.718
            ],
            [
              -3026.974,
              -3344.813,
              6149.672
            ],
            [
              -3029.648,
              -3313.596,
              6181.003
            ],
            [
              -3083.217,
              -3134.541,
              6367.9
            ],
            [
              -3102.428,
              -3054.053,
              6450.649
            ],
            [
              -3137.083,
              -2972.18,
              6539.554
            ],
            [
              -3158.619,
              -2877.179,
              6636.965
            ],
            [
              -3186.209,
              -2796.544,
              6722.19
            ],
            [
              -3248.067,
              -2685.253,
              6849.517
            ],
            [
              -3332.852,
              -2557.976,
              7002.447
            ],
            [
              -3349.352,
              -2543.216,
              7024.586
            ],
            [
              -3361.538,
              -2502.927,
              7066.678
            ],
            [
              -3386.79,
              -2435.693,
              7138.497
            ],
            [
              -3393.431,
              -2409.973,
              7165.061
            ],
            [
              -3395.464,
              -2378.768,
              7196.332
            ],
            [
              -3389.87,
              -2243.053,
              7332.162
            ],
            [
              -3384.424,
              -2226.45,
              7349.636
            ],
            [
              -3365.672,
              -2038.645,
              7538.375
            ],
            [
              -3375.166,
              -1991.724,
              7586.247
            ],
            [
              -3374.974,
              -1943.859,
              7634.112
            ],
            [
              -3391.774,
              -1872.32,
              7707.597
            ],
            [
              -3430.979,
              -1754.748,
              7831.533
            ],
            [
              -3480.186,
              -1619.191,
              7975.745
            ],
            [
              -3508.003,
              -1550.799,
              8049.577
            ],
            [
              -3525.544,
              -1521.55,
              8083.683
            ],
            [
              -3534.455,
              -1477.979,
              8128.156
            ],
            [
              -3620.717,
              -1211.532,
              8408.219
            ],
            [
              -3662.686,
              -1103.933,
              8523.713
            ],
            [
              -3680.758,
              -1067.996,
              8563.938
            ],
            [
              -3720.589,
              -911.454,
              8725.468
            ],
            [
              -3751.541,
              -837.444,
              8805.69
            ],
            [
              -3761.526,
              -818.346,
              8827.241
            ],
            [
              -3766.218,
              -791.548,
              8854.447
            ],
            [
              -3793.988,
              -719.82,
              8931.363
            ],
            [
              -3843.779,
              -616.54,
              9046.018
            ],
            [
              -3881.258,
              -546.871,
              9125.129
            ],
            [
              -3968.98,
              -399.519,
              9296.615
            ],
            [
              -3986.683,
              -379.175,
              9323.583
            ],
            [
              -3999.719,
              -350.005,
              9355.533
            ],
            [
              -4048.201,
              -282.373,
              9438.747
            ],
            [
              -4133.499,
              -180.709,
              9571.455
            ],
            [
              -4196.245,
              -117.285,
              9660.672
            ],
            [
              -4221.08,
              -99.045,
              9691.486
            ],
            [
              -4243.751,
              -67.483,
              9730.346
            ],
            [
              -4402.336,
              85.535,
              9950.717
            ],
            [
              -4449.086,
              142,
              10024.025
            ],
            [
              -4479.797,
              193.736,
              10084.189
            ],
            [
              -4502.905,
              237.549,
              10133.722
            ],
            [
              -4519.036,
              274.562,
              10174.098
            ],
            [
              -4536.228,
              324.952,
              10227.34
            ],
            [
              -4547.048,
              370.78,
              10274.427
            ],
            [
              -4566.578,
              510.266,
              10415.274
            ],
            [
              -4574.501,
              537.119,
              10443.272
            ],
            [
              -4575.517,
              590.57,
              10496.732
            ],
            [
              -4579.623,
              651.866,
              10558.166
            ],
            [
              -4586.366,
              709.869,
              10616.559
            ],
            [
              -4584.541,
              741.007,
              10647.751
            ],
            [
              -4573.306,
              794.248,
              10702.164
            ],
            [
              -4555.909,
              830.684,
              10742.541
            ],
            [
              -4538.646,
              859.331,
              10775.987
            ],
            [
              -4503.175,
              896.569,
              10827.416
            ],
            [
              -4462.091,
              922.579,
              10876.041
            ],
            [
              -4445.644,
              941.22,
              10900.9
            ],
            [
              -4396.195,
              965.972,
              10956.198
            ],
            [
              -4188.107,
              1100.42,
              11203.941
            ],
            [
              -4154.055,
              1129.888,
              11248.973
            ],
            [
              -4048.114,
              1175.924,
              11364.484
            ],
            [
              -3997.487,
              1193.972,
              11418.233
            ],
            [
              -3829.673,
              1236.704,
              11591.402
            ],
            [
              -3789.4,
              1252.704,
              11634.736
            ],
            [
              -3749.695,
              1273.165,
              11679.403
            ],
            [
              -3705.908,
              1305.8,
              11734.015
            ],
            [
              -3669.839,
              1339.683,
              11783.502
            ],
            [
              -3634.26,
              1382.479,
              11839.156
            ],
            [
              -3619.001,
              1406.704,
              11867.787
            ],
            [
              -3601.633,
              1440.911,
              11906.15
            ],
            [
              -3596.615,
              1469.767,
              11935.439
            ],
            [
              -3579.402,
              1495.072,
              11966.043
            ],
            [
              -3566.606,
              1526.019,
              11999.531
            ],
            [
              -3560.672,
              1570.444,
              12044.351
            ],
            [
              -3561.909,
              1610.54,
              12084.467
            ],
            [
              -3553.124,
              1670.501,
              12145.067
            ],
            [
              -3546.511,
              1753.876,
              12228.704
            ],
            [
              -3528.72,
              1849.302,
              12325.775
            ],
            [
              -3507.519,
              1881.216,
              12364.089
            ],
            [
              -3466.677,
              1929.485,
              12427.318
            ],
            [
              -3411.117,
              1970.818,
              12496.567
            ],
            [
              -3377.989,
              1983.599,
              12532.075
            ],
            [
              -3293.772,
              2003.28,
              12618.561
            ],
            [
              -3253.06,
              2007.021,
              12659.445
            ],
            [
              -3234.374,
              2005.581,
              12678.186
            ],
            [
              -3211.057,
              2010.74,
              12702.066
            ],
            [
              -2960.432,
              2100.974,
              12968.441
            ],
            [
              -2902.519,
              2128.901,
              13032.736
            ],
            [
              -2763.528,
              2181.007,
              13181.173
            ],
            [
              -2705.632,
              2207.819,
              13244.976
            ],
            [
              -2695.312,
              2207.637,
              13255.297
            ],
            [
              -2620.644,
              2234.153,
              13334.533
            ],
            [
              -2602.113,
              2260.544,
              13366.78
            ],
            [
              -2588.136,
              2284.788,
              13394.765
            ],
            [
              -2571.13,
              2297.847,
              13416.207
            ],
            [
              -2532.153,
              2312.745,
              13457.933
            ],
            [
              -2506.977,
              2313.414,
              13483.118
            ],
            [
              -2483.854,
              2307.44,
              13507.001
            ],
            [
              -2455.846,
              2285.795,
              13542.398
            ],
            [
              -2438.355,
              2253.203,
              13579.387
            ],
            [
              -2433.47,
              2237.532,
              13595.802
            ],
            [
              -2436.603,
              2169.681,
              13663.725
            ],
            [
              -2432.988,
              2155.146,
              13678.703
            ],
            [
              -2421.673,
              2138.248,
              13699.04
            ],
            [
              -2405.237,
              2119.033,
              13724.325
            ],
            [
              -2339.12,
              2063.317,
              13810.787
            ],
            [
              -2328.352,
              2051.995,
              13826.413
            ],
            [
              -2313.635,
              2045.055,
              13842.684
            ],
            [
              -2298.509,
              2024.75,
              13868.004
            ],
            [
              -1925.909,
              1679.727,
              14375.814
            ],
            [
              -1868.675,
              1633.068,
              14449.657
            ],
            [
              -1860.469,
              1622.903,
              14462.721
            ],
            [
              -1769.084,
              1537.785,
              14587.606
            ],
            [
              -1703.649,
              1480.959,
              14674.272
            ],
            [
              -1699.799,
              1479.777,
              14678.299
            ],
            [
              -1682.168,
              1491.708,
              14699.588
            ],
            [
              -1671.651,
              1502.653,
              14714.767
            ],
            [
              -1654.972,
              1533.526,
              14749.856
            ],
            [
              -1603.973,
              1571.579,
              14813.488
            ],
            [
              -1299.013,
              1921.245,
              15277.456
            ],
            [
              -1270.801,
              1947.457,
              15315.966
            ],
            [
              -1190.297,
              2047.317,
              15444.236
            ],
            [
              -1173.912,
              2061.495,
              15465.903
            ],
            [
              -1158.937,
              2069.019,
              15482.661
            ],
            [
              -1145.392,
              2068.776,
              15496.209
            ],
            [
              -1135.112,
              2066.366,
              15506.768
            ],
            [
              -987.662,
              2013.623,
              15663.367
            ],
            [
              -958.677,
              2010.875,
              15692.482
            ],
            [
              -943.398,
              1999.468,
              15711.55
            ],
            [
              -544.505,
              1865.369,
              16132.38
            ],
            [
              -470.051,
              1843.985,
              16209.844
            ],
            [
              -420.186,
              1818.591,
              16265.802
            ],
            [
              -302.823,
              1779.729,
              16389.433
            ],
            [
              -124.613,
              1752.004,
              16569.786
            ],
            [
              29.934,
              1735.835,
              16725.176
            ],
            [
              63.816,
              1754.143,
              16763.689
            ],
            [
              97.435,
              1757.984,
              16797.526
            ],
            [
              156.41,
              1772.494,
              16858.26
            ],
            [
              318.606,
              1821.856,
              17027.801
            ],
            [
              358.443,
              1883.47,
              17101.171
            ],
            [
              373.827,
              1913.246,
              17134.687
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 183.328,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 578.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 1630.937,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 2537.934,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 3337.67,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5812",
              "position": {
                "x": -1760.592,
                "z": -4965.819
              },
              "distanceAlongShapeM": 3769.426,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 4356.071,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 5375.071,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 5704.98,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6477",
              "position": {
                "x": -3137.083,
                "z": -2972.18
              },
              "distanceAlongShapeM": 6539.554,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5620",
              "position": {
                "x": -3375.166,
                "z": -1991.724
              },
              "distanceAlongShapeM": 7586.247,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1410,
              "departureOffsetSeconds": 1410
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 8083.683,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 8563.938,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 9323.583,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 10443.272,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6461",
              "position": {
                "x": -4154.055,
                "z": 1129.888
              },
              "distanceAlongShapeM": 11248.973,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6333",
              "position": {
                "x": -3596.615,
                "z": 1469.767
              },
              "distanceAlongShapeM": 11935.439,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 13842.684,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 14449.657,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6366",
              "position": {
                "x": -1299.013,
                "z": 1921.245
              },
              "distanceAlongShapeM": 15277.456,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6363",
              "position": {
                "x": -958.677,
                "z": 2010.875
              },
              "distanceAlongShapeM": 15692.482,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 16209.844,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 17134.687,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            }
          ],
          "departuresSeconds": [
            19320,
            19980,
            20700,
            21060,
            21660,
            22080,
            22500,
            22860,
            23220,
            23580,
            23940,
            24300,
            24660,
            25080,
            25500,
            25920,
            26340,
            26760,
            27180,
            27600,
            28020,
            28500,
            28980,
            29400,
            29880,
            30300,
            30780,
            31320,
            31860,
            32460,
            33060,
            33660,
            34260,
            34920,
            35520,
            36060,
            36600,
            37080,
            37560,
            37980,
            38460,
            38820,
            39240,
            39840,
            40440,
            40920,
            41400,
            42000,
            42660,
            43140,
            43740,
            44280,
            44760,
            45240,
            45720,
            46200,
            46680,
            47280,
            47820,
            48300,
            48780,
            49320,
            49860,
            50340,
            50880,
            51420,
            51960,
            52440,
            52980,
            53520,
            54180,
            54600,
            55020,
            55620,
            56220,
            56760,
            57360,
            57840,
            58380,
            58920,
            59460,
            59940,
            60480,
            60960,
            61380,
            61800,
            62220,
            62640,
            63060,
            63480,
            63900,
            64380,
            64920,
            65460,
            66300,
            67320,
            67740,
            68280,
            68820,
            69420,
            69960,
            70500,
            71160,
            71820,
            72420,
            72900,
            73500,
            74100,
            74760,
            75300,
            75900,
            76500,
            77040,
            77580,
            78120,
            78600,
            79080,
            79680,
            80280,
            80940,
            81480,
            82620
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_2G:1",
          "sourceRouteId": "vilnius_expressbus_2G",
          "sourceShapeId": "vilnius_expressbus_2G_b-a",
          "directionId": 1,
          "headsign": "Santariškės",
          "directionName": "Stotis–Laisvės pr.–Santariškės",
          "mode": "bus",
          "routeShortName": "2G",
          "routeLongName": "Santariškės–Laisvės pr.–Stotis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              373.827,
              1913.246,
              0
            ],
            [
              381.688,
              1919.781,
              10.224
            ],
            [
              390.297,
              1931.87,
              25.064
            ],
            [
              381.613,
              1950.953,
              46.03
            ],
            [
              374.681,
              1959.986,
              57.417
            ],
            [
              359.73,
              1989.203,
              90.237
            ],
            [
              357.312,
              1998.153,
              99.508
            ],
            [
              360.055,
              2007.009,
              108.778
            ],
            [
              365.317,
              2012.479,
              116.368
            ],
            [
              381.462,
              2013.297,
              132.534
            ],
            [
              469.575,
              1962.704,
              234.14
            ],
            [
              481.002,
              1952.475,
              249.475
            ],
            [
              482.211,
              1948,
              254.111
            ],
            [
              476.141,
              1933.639,
              269.702
            ],
            [
              470.194,
              1925.956,
              279.418
            ],
            [
              463.683,
              1922.735,
              286.682
            ],
            [
              447.558,
              1923.03,
              302.809
            ],
            [
              415.411,
              1929.184,
              335.541
            ],
            [
              398.6,
              1927.265,
              352.46
            ],
            [
              334.106,
              1822.687,
              475.327
            ],
            [
              318.606,
              1821.856,
              490.849
            ],
            [
              29.934,
              1735.835,
              792.065
            ],
            [
              -11.424,
              1732.135,
              833.588
            ],
            [
              -46.755,
              1740.57,
              869.912
            ],
            [
              -320.217,
              1781.157,
              1146.369
            ],
            [
              -550.531,
              1853.232,
              1387.698
            ],
            [
              -582.7,
              1858.267,
              1420.258
            ],
            [
              -596.688,
              1869.651,
              1438.294
            ],
            [
              -1032.712,
              2019.998,
              1899.511
            ],
            [
              -1048.212,
              2019.164,
              1915.033
            ],
            [
              -1075.687,
              2034.129,
              1946.319
            ],
            [
              -1134.042,
              2054.101,
              2007.998
            ],
            [
              -1154.642,
              2056.697,
              2028.761
            ],
            [
              -1164.417,
              2051.306,
              2039.924
            ],
            [
              -1208.37,
              2010.905,
              2099.624
            ],
            [
              -1267.715,
              1939.609,
              2192.387
            ],
            [
              -1394.1,
              1799.379,
              2381.166
            ],
            [
              -1411.426,
              1768.519,
              2416.557
            ],
            [
              -1434.923,
              1753.354,
              2444.523
            ],
            [
              -1515.962,
              1659.065,
              2568.852
            ],
            [
              -1594.12,
              1581.422,
              2679.021
            ],
            [
              -1692.298,
              1466.285,
              2830.333
            ],
            [
              -1701.366,
              1464.22,
              2839.634
            ],
            [
              -1708.441,
              1465.459,
              2846.816
            ],
            [
              -1712.191,
              1472.205,
              2854.534
            ],
            [
              -1970.62,
              1705.012,
              3202.363
            ],
            [
              -1985.783,
              1723.093,
              3225.96
            ],
            [
              -2263.842,
              1978.495,
              3603.513
            ],
            [
              -2290.557,
              2000.118,
              3637.883
            ],
            [
              -2318.992,
              2034.018,
              3682.129
            ],
            [
              -2425.036,
              2130.514,
              3825.506
            ],
            [
              -2441.629,
              2140.826,
              3845.043
            ],
            [
              -2453.884,
              2141.043,
              3857.3
            ],
            [
              -2464.869,
              2140.123,
              3868.323
            ],
            [
              -2491.57,
              2126.123,
              3898.472
            ],
            [
              -2514.888,
              2120.968,
              3922.353
            ],
            [
              -2528.453,
              2120.094,
              3935.946
            ],
            [
              -2551.595,
              2124.955,
              3959.593
            ],
            [
              -2561.836,
              2129.588,
              3970.834
            ],
            [
              -2579.681,
              2142.148,
              3992.655
            ],
            [
              -2607.297,
              2186.05,
              4044.52
            ],
            [
              -2618.809,
              2191.819,
              4057.397
            ],
            [
              -2640.075,
              2193.306,
              4078.715
            ],
            [
              -2665.388,
              2184.846,
              4105.404
            ],
            [
              -2681.67,
              2176.227,
              4123.827
            ],
            [
              -2690.837,
              2168.596,
              4135.755
            ],
            [
              -2738.119,
              2158.296,
              4184.145
            ],
            [
              -2899.782,
              2101.023,
              4355.654
            ],
            [
              -2971.67,
              2085.586,
              4429.181
            ],
            [
              -3158.032,
              2017.605,
              4627.554
            ],
            [
              -3215.258,
              1991.889,
              4690.293
            ],
            [
              -3240.098,
              1973.399,
              4721.26
            ],
            [
              -3275.786,
              1961.777,
              4758.793
            ],
            [
              -3353.278,
              1920.828,
              4846.438
            ],
            [
              -3402.898,
              1887.184,
              4906.388
            ],
            [
              -3447.61,
              1838.983,
              4972.134
            ],
            [
              -3464.825,
              1813.679,
              5002.739
            ],
            [
              -3479.576,
              1781.653,
              5037.999
            ],
            [
              -3552.495,
              1521.32,
              5308.351
            ],
            [
              -3555.031,
              1486.855,
              5342.91
            ],
            [
              -3569.097,
              1457.043,
              5375.873
            ],
            [
              -3608.386,
              1386.482,
              5456.636
            ],
            [
              -3647.326,
              1335.952,
              5520.429
            ],
            [
              -3697.872,
              1285.623,
              5591.759
            ],
            [
              -3750.727,
              1250.919,
              5654.988
            ],
            [
              -3785.215,
              1233.706,
              5693.533
            ],
            [
              -3881.236,
              1201.976,
              5794.661
            ],
            [
              -3947.947,
              1186.435,
              5863.159
            ],
            [
              -4028.355,
              1162.223,
              5947.132
            ],
            [
              -4081.657,
              1138.655,
              6005.413
            ],
            [
              -4117.491,
              1118.124,
              6046.711
            ],
            [
              -4156.018,
              1090.96,
              6093.852
            ],
            [
              -4168.309,
              1088.946,
              6106.307
            ],
            [
              -4405.115,
              934.956,
              6388.778
            ],
            [
              -4421.523,
              918.541,
              6411.987
            ],
            [
              -4433.169,
              916.515,
              6423.808
            ],
            [
              -4463.138,
              899.22,
              6458.409
            ],
            [
              -4519.455,
              850.095,
              6533.141
            ],
            [
              -4559.388,
              778.424,
              6615.186
            ],
            [
              -4567.189,
              737.369,
              6656.975
            ],
            [
              -4562.176,
              653.793,
              6740.702
            ],
            [
              -4542.083,
              471.996,
              6923.606
            ],
            [
              -4530.426,
              437.286,
              6960.221
            ],
            [
              -4533.311,
              419.524,
              6978.216
            ],
            [
              -4527.744,
              368.221,
              7029.82
            ],
            [
              -4516.259,
              323.495,
              7075.996
            ],
            [
              -4491.638,
              255.166,
              7148.626
            ],
            [
              -4427.619,
              152.763,
              7269.394
            ],
            [
              -4367.011,
              77.134,
              7366.312
            ],
            [
              -4077.229,
              -208.399,
              7773.132
            ],
            [
              -3954.469,
              -380.846,
              7984.811
            ],
            [
              -3921.604,
              -419.265,
              8035.369
            ],
            [
              -3917.323,
              -432.698,
              8049.468
            ],
            [
              -3857.936,
              -540.596,
              8172.63
            ],
            [
              -3823.641,
              -607.984,
              8248.242
            ],
            [
              -3766.483,
              -732.543,
              8385.29
            ],
            [
              -3707.64,
              -908.34,
              8570.673
            ],
            [
              -3695.741,
              -928.584,
              8594.156
            ],
            [
              -3679.35,
              -950.021,
              8621.14
            ],
            [
              -3673.878,
              -969.04,
              8640.931
            ],
            [
              -3654.555,
              -1007.226,
              8683.728
            ],
            [
              -3618.236,
              -1069.084,
              8755.46
            ],
            [
              -3599.031,
              -1113.947,
              8804.261
            ],
            [
              -3569.469,
              -1193.5,
              8889.129
            ],
            [
              -3554.873,
              -1243.849,
              8941.551
            ],
            [
              -3543.073,
              -1269.659,
              8969.93
            ],
            [
              -3520.478,
              -1415.883,
              9117.89
            ],
            [
              -3500.646,
              -1498.607,
              9202.958
            ],
            [
              -3461.302,
              -1608.388,
              9319.576
            ],
            [
              -3438.975,
              -1658.872,
              9374.777
            ],
            [
              -3418.974,
              -1694.844,
              9415.936
            ],
            [
              -3409.362,
              -1735.088,
              9457.311
            ],
            [
              -3353.575,
              -1899.704,
              9631.124
            ],
            [
              -3340.35,
              -1954.483,
              9687.476
            ],
            [
              -3339.232,
              -2037.994,
              9770.994
            ],
            [
              -3345.53,
              -2177.035,
              9910.179
            ],
            [
              -3368.406,
              -2305.768,
              10040.928
            ],
            [
              -3372.034,
              -2365.819,
              10101.088
            ],
            [
              -3365.898,
              -2420.473,
              10156.086
            ],
            [
              -3338.206,
              -2495.543,
              10236.1
            ],
            [
              -3294.464,
              -2574.233,
              10326.131
            ],
            [
              -3256.485,
              -2613.86,
              10381.019
            ],
            [
              -3240.415,
              -2653.104,
              10423.426
            ],
            [
              -3181.544,
              -2750.984,
              10537.646
            ],
            [
              -3157.274,
              -2800.391,
              10592.692
            ],
            [
              -3108.891,
              -2944.844,
              10745.033
            ],
            [
              -3088.313,
              -3020.904,
              10823.827
            ],
            [
              -3080.894,
              -3038.845,
              10843.242
            ],
            [
              -3066.407,
              -3094.76,
              10901.003
            ],
            [
              -3053.229,
              -3115.03,
              10925.179
            ],
            [
              -3044.503,
              -3168.617,
              10979.473
            ],
            [
              -2983.753,
              -3378.969,
              11198.421
            ],
            [
              -2968.741,
              -3404.837,
              11228.329
            ],
            [
              -2964.33,
              -3447.216,
              11270.938
            ],
            [
              -2935.834,
              -3585.756,
              11412.379
            ],
            [
              -2926.739,
              -3654.936,
              11482.153
            ],
            [
              -2914.467,
              -3799.87,
              11627.606
            ],
            [
              -2906.719,
              -3835.629,
              11664.195
            ],
            [
              -2909.141,
              -3863.417,
              11692.089
            ],
            [
              -2921.12,
              -4178.248,
              12007.147
            ],
            [
              -2914.524,
              -4206.195,
              12035.861
            ],
            [
              -2913.823,
              -4239.604,
              12069.278
            ],
            [
              -2906.681,
              -4273.126,
              12103.552
            ],
            [
              -2893.275,
              -4316.777,
              12149.216
            ],
            [
              -2874.618,
              -4354.955,
              12191.709
            ],
            [
              -2823.799,
              -4432.662,
              12284.557
            ],
            [
              -2759.103,
              -4490.576,
              12371.388
            ],
            [
              -2701.004,
              -4520.544,
              12436.761
            ],
            [
              -2600.594,
              -4562.391,
              12545.543
            ],
            [
              -2523.056,
              -4586.026,
              12626.602
            ],
            [
              -2471.67,
              -4594.727,
              12678.72
            ],
            [
              -2274.597,
              -4634.953,
              12879.856
            ],
            [
              -2190.603,
              -4657.594,
              12966.849
            ],
            [
              -2134.709,
              -4666.379,
              13023.428
            ],
            [
              -2111.82,
              -4683.484,
              13052.002
            ],
            [
              -2099.157,
              -4695.955,
              13069.775
            ],
            [
              -2067.351,
              -4718.784,
              13108.927
            ],
            [
              -2007.683,
              -4768.827,
              13186.802
            ],
            [
              -1998.706,
              -4771.214,
              13196.091
            ],
            [
              -1979.306,
              -4767.106,
              13215.921
            ],
            [
              -1961.313,
              -4769.653,
              13234.093
            ],
            [
              -1950.602,
              -4783.202,
              13251.365
            ],
            [
              -1941.516,
              -4815.647,
              13285.058
            ],
            [
              -1918.262,
              -4848.345,
              13325.182
            ],
            [
              -1854.05,
              -4896.245,
              13405.292
            ],
            [
              -1743.848,
              -4966.117,
              13535.778
            ],
            [
              -1676.24,
              -5004.061,
              13613.306
            ],
            [
              -1625.643,
              -5020.551,
              13666.522
            ],
            [
              -1586.957,
              -5054.639,
              13718.084
            ],
            [
              -1465.895,
              -5129.166,
              13860.247
            ],
            [
              -1407.208,
              -5161.388,
              13927.198
            ],
            [
              -1338.038,
              -5183.78,
              13999.902
            ],
            [
              -1271.325,
              -5199.449,
              14068.43
            ],
            [
              -1246.49,
              -5215.481,
              14097.99
            ],
            [
              -1208.756,
              -5230.63,
              14138.651
            ],
            [
              -1099.904,
              -5267.098,
              14253.45
            ],
            [
              -1057.683,
              -5283.443,
              14298.724
            ],
            [
              -933.839,
              -5345.789,
              14437.376
            ],
            [
              -826.661,
              -5403.385,
              14559.05
            ],
            [
              -674.33,
              -5492.97,
              14735.77
            ],
            [
              -589.373,
              -5532.358,
              14829.414
            ],
            [
              -509.147,
              -5583.907,
              14924.774
            ],
            [
              -408.358,
              -5638.057,
              15039.188
            ],
            [
              -376.948,
              -5646.42,
              15071.692
            ],
            [
              -183.275,
              -5657.733,
              15265.696
            ],
            [
              -188.212,
              -5716.645,
              15324.814
            ],
            [
              -185.377,
              -5737.848,
              15346.206
            ],
            [
              -196.91,
              -5769.923,
              15380.291
            ],
            [
              -201.665,
              -5818.819,
              15429.418
            ],
            [
              -201.086,
              -5857.793,
              15468.396
            ],
            [
              -195.599,
              -5910.215,
              15521.104
            ],
            [
              -136.015,
              -6175.138,
              15792.645
            ],
            [
              -122.378,
              -6204.331,
              15824.866
            ],
            [
              -123.468,
              -6228.802,
              15849.362
            ],
            [
              -113.557,
              -6285.758,
              15907.174
            ],
            [
              -58.166,
              -6532.794,
              16160.344
            ],
            [
              -46.468,
              -6597.576,
              16226.173
            ],
            [
              -39.377,
              -6667.839,
              16296.793
            ],
            [
              -35.045,
              -6748.072,
              16377.143
            ],
            [
              -27.041,
              -6768.256,
              16398.856
            ],
            [
              -16.965,
              -6780.686,
              16414.857
            ],
            [
              0.233,
              -6791.019,
              16434.921
            ],
            [
              10.168,
              -6811.238,
              16457.449
            ],
            [
              11.151,
              -6827.955,
              16474.194
            ],
            [
              7.024,
              -6842.352,
              16489.171
            ],
            [
              -10.864,
              -6869.857,
              16521.981
            ],
            [
              -21.671,
              -6897.49,
              16551.653
            ],
            [
              -10.612,
              -6926.637,
              16582.827
            ],
            [
              -9.853,
              -6955.595,
              16611.795
            ],
            [
              6.027,
              -7144.023,
              16800.891
            ],
            [
              16.38,
              -7176.496,
              16834.975
            ],
            [
              10.845,
              -7197.547,
              16856.741
            ],
            [
              32.291,
              -7398.322,
              17058.659
            ],
            [
              48.234,
              -7442.03,
              17105.183
            ],
            [
              37.062,
              -7489.696,
              17154.141
            ],
            [
              41.201,
              -7509.81,
              17174.676
            ],
            [
              62.699,
              -7531.354,
              17205.111
            ],
            [
              73.695,
              -7563.839,
              17239.407
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -120,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5167",
              "position": {
                "x": -582.7,
                "z": 1858.267
              },
              "distanceAlongShapeM": 1420.258,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6362",
              "position": {
                "x": -1048.212,
                "z": 2019.164
              },
              "distanceAlongShapeM": 1915.033,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6365",
              "position": {
                "x": -1411.426,
                "z": 1768.519
              },
              "distanceAlongShapeM": 2416.557,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 3202.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 3637.883,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:790",
              "position": {
                "x": -3555.031,
                "z": 1486.855
              },
              "distanceAlongShapeM": 5342.91,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6648",
              "position": {
                "x": -4156.018,
                "z": 1090.96
              },
              "distanceAlongShapeM": 6093.852,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 6960.221,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 8035.369,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 8621.14,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 8969.93,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6472",
              "position": {
                "x": -3345.53,
                "z": -2177.035
              },
              "distanceAlongShapeM": 9910.179,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 10925.179,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 11664.195,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 12035.861,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5804",
              "position": {
                "x": -2134.709,
                "z": -4666.379
              },
              "distanceAlongShapeM": 13023.428,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 13666.522,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 14068.43,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 14829.414,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 15824.866,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 16834.975,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:10244",
              "position": {
                "x": 48.234,
                "z": -7442.03
              },
              "distanceAlongShapeM": 17105.183,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            }
          ],
          "departuresSeconds": [
            18420,
            19440,
            20460,
            21120,
            21720,
            22260,
            22620,
            22920,
            23280,
            23640,
            24000,
            24360,
            24720,
            25140,
            25560,
            25920,
            26220,
            26520,
            26820,
            27180,
            27540,
            27960,
            28440,
            28860,
            29340,
            29820,
            30240,
            30660,
            31080,
            31500,
            31980,
            32460,
            32940,
            33360,
            33840,
            34320,
            34860,
            35340,
            35880,
            36360,
            36960,
            37560,
            38220,
            38820,
            39300,
            39840,
            40320,
            40800,
            41220,
            41700,
            42120,
            42540,
            43140,
            43740,
            44220,
            44700,
            45300,
            45840,
            46380,
            46980,
            47520,
            48000,
            48480,
            48960,
            49440,
            49920,
            50520,
            51060,
            51540,
            52020,
            52560,
            53160,
            53640,
            54180,
            54720,
            55320,
            55800,
            56340,
            56880,
            57180,
            57480,
            57900,
            58380,
            58680,
            58980,
            59280,
            59580,
            59880,
            60180,
            60480,
            60840,
            61260,
            61860,
            62340,
            62880,
            63360,
            63960,
            64500,
            64920,
            65340,
            65760,
            66240,
            66660,
            67080,
            67440,
            67860,
            68400,
            68940,
            69660,
            70680,
            71100,
            71580,
            72120,
            72720,
            73200,
            73740,
            74340,
            75000,
            75540,
            76080,
            76620,
            77220,
            77880,
            78420,
            79080,
            79680,
            80160,
            80700,
            81240,
            81720,
            82200,
            82740,
            83340,
            85080,
            86280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_3",
      "sourceRouteId": "vilnius_bus_3",
      "mode": "bus",
      "shortName": "3",
      "longName": "Stotis–Eišiškių pl.–Dilgynė–Salininkai–Vaidotai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_3:0",
          "sourceRouteId": "vilnius_bus_3",
          "sourceShapeId": "vilnius_bus_3_a-b",
          "directionId": 0,
          "headsign": "Vaidotai",
          "directionName": "Stotis–Eišiškių pl.–Dilgynė–Salininkai–Vaidotai",
          "mode": "bus",
          "routeShortName": "3",
          "routeLongName": "Stotis–Eišiškių pl.–Dilgynė–Salininkai–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              365.148,
              1967.953,
              0
            ],
            [
              359.628,
              1983.639,
              16.629
            ],
            [
              363.117,
              1998.047,
              31.454
            ],
            [
              375.555,
              2007.839,
              47.284
            ],
            [
              384.565,
              2006.561,
              56.383
            ],
            [
              450.348,
              1969.735,
              131.773
            ],
            [
              464.314,
              1957.234,
              150.516
            ],
            [
              465.359,
              1943.856,
              163.935
            ],
            [
              460.037,
              1935.047,
              174.227
            ],
            [
              448.99,
              1930.796,
              186.063
            ],
            [
              427.686,
              1930.073,
              207.38
            ],
            [
              403.862,
              1932.735,
              231.352
            ],
            [
              390.012,
              1916.29,
              252.852
            ],
            [
              339.428,
              1831.495,
              351.589
            ],
            [
              318.606,
              1821.856,
              374.533
            ],
            [
              29.934,
              1735.835,
              675.75
            ],
            [
              -11.424,
              1732.135,
              717.273
            ],
            [
              -46.755,
              1740.57,
              753.597
            ],
            [
              -320.217,
              1781.157,
              1030.054
            ],
            [
              -515.259,
              1841.463,
              1234.207
            ],
            [
              -520.923,
              1849.358,
              1243.923
            ],
            [
              -526.486,
              1862.817,
              1258.487
            ],
            [
              -511.654,
              1933.795,
              1330.998
            ],
            [
              -496.901,
              1964.699,
              1365.243
            ],
            [
              -462.075,
              2106.562,
              1511.318
            ],
            [
              -436.719,
              2188.482,
              1597.072
            ],
            [
              -427.991,
              2207.248,
              1617.769
            ],
            [
              -344.32,
              2338.207,
              1773.176
            ],
            [
              -326.137,
              2380.181,
              1818.918
            ],
            [
              -285.296,
              2533.066,
              1977.164
            ],
            [
              -290.153,
              2585.475,
              2029.798
            ],
            [
              -278.622,
              2616.436,
              2062.837
            ],
            [
              -251.706,
              2819.669,
              2267.844
            ],
            [
              -239.003,
              2950.799,
              2399.588
            ],
            [
              -239.164,
              2977.519,
              2426.309
            ],
            [
              -244.788,
              3023.264,
              2472.398
            ],
            [
              -255.513,
              3072.44,
              2522.73
            ],
            [
              -253.335,
              3121.382,
              2571.721
            ],
            [
              -336.623,
              3547.03,
              3005.441
            ],
            [
              -379.958,
              3791.61,
              3253.831
            ],
            [
              -382.016,
              3856.215,
              3318.468
            ],
            [
              -345.945,
              4030.338,
              3496.288
            ],
            [
              -408.418,
              4109.394,
              3597.049
            ],
            [
              -481.301,
              4219.808,
              3729.348
            ],
            [
              -539.627,
              4314.372,
              3840.453
            ],
            [
              -578.027,
              4368.5,
              3906.819
            ],
            [
              -621.677,
              4489.515,
              4035.466
            ],
            [
              -657.683,
              4569.203,
              4122.911
            ],
            [
              -715.86,
              4708.291,
              4273.676
            ],
            [
              -710.664,
              4781.67,
              4347.238
            ],
            [
              -693.915,
              4887.124,
              4454.014
            ],
            [
              -643.028,
              5310.343,
              4880.281
            ],
            [
              -621.345,
              5545.954,
              5116.888
            ],
            [
              -612.702,
              5667.139,
              5238.381
            ],
            [
              -665.323,
              5971.996,
              5547.746
            ],
            [
              -708.429,
              6267.775,
              5846.65
            ],
            [
              -741.072,
              6427.553,
              6009.728
            ],
            [
              -745.195,
              6485.515,
              6067.836
            ],
            [
              -1066.466,
              6433.4,
              6393.306
            ],
            [
              -1082.746,
              6425.899,
              6411.231
            ],
            [
              -1122.835,
              6423.278,
              6451.405
            ],
            [
              -1321.777,
              6385.649,
              6653.875
            ],
            [
              -1269.126,
              6079.688,
              6964.333
            ],
            [
              -1220.288,
              5741.51,
              7306.019
            ],
            [
              -1252.943,
              5720.943,
              7344.611
            ],
            [
              -1341.654,
              5851.663,
              7502.589
            ],
            [
              -1434.869,
              5983.574,
              7664.112
            ],
            [
              -1434.909,
              5981.348,
              7666.338
            ],
            [
              -1471.061,
              6054.352,
              7747.803
            ],
            [
              -1667.918,
              6422.993,
              8165.714
            ],
            [
              -1679.373,
              6468.839,
              8212.969
            ],
            [
              -1707.91,
              6788.838,
              8534.237
            ],
            [
              -1715.73,
              6821.26,
              8567.589
            ],
            [
              -1712.83,
              6839.019,
              8585.584
            ],
            [
              -1721.42,
              6937.135,
              8684.075
            ],
            [
              -1729.279,
              6967.331,
              8715.277
            ],
            [
              -1746.568,
              7012.167,
              8763.33
            ],
            [
              -1767.164,
              7052.608,
              8808.715
            ],
            [
              -1986.586,
              7354.842,
              9182.2
            ],
            [
              -2025.991,
              7391.163,
              9235.791
            ],
            [
              -2098.584,
              7450.335,
              9329.445
            ],
            [
              -2040.584,
              7588.459,
              9479.252
            ],
            [
              -2023.848,
              7621.558,
              9516.342
            ],
            [
              -2003.942,
              7651.262,
              9552.099
            ],
            [
              -1949.699,
              7759.395,
              9673.074
            ],
            [
              -1905.866,
              7863.259,
              9785.809
            ],
            [
              -1804.677,
              8031.784,
              9982.379
            ],
            [
              -1769.656,
              8075.69,
              10038.541
            ],
            [
              -1704.351,
              8151.341,
              10138.48
            ],
            [
              -1667.469,
              8190.76,
              10192.463
            ],
            [
              -1631.959,
              8225.751,
              10242.316
            ],
            [
              -1597.192,
              8255.189,
              10287.872
            ],
            [
              -1555.301,
              8285.612,
              10339.645
            ],
            [
              -1542.006,
              8306.527,
              10364.427
            ],
            [
              -1526.833,
              8324.068,
              10387.62
            ],
            [
              -1510.907,
              8383.897,
              10449.533
            ],
            [
              -1505.414,
              8438.346,
              10504.258
            ],
            [
              -1503.229,
              8488.402,
              10554.361
            ],
            [
              -1511.708,
              8556.458,
              10622.944
            ],
            [
              -1543.904,
              8744.051,
              10813.279
            ],
            [
              -1556.03,
              8788.795,
              10859.638
            ],
            [
              -1618.698,
              9225.174,
              11300.493
            ],
            [
              -1909.16,
              9171.333,
              11595.904
            ],
            [
              -1929.991,
              9162.797,
              11618.416
            ],
            [
              -1953.562,
              9145.403,
              11647.71
            ],
            [
              -1966.778,
              9128.939,
              11668.822
            ],
            [
              -1992.214,
              9079.296,
              11724.603
            ],
            [
              -2047.392,
              8955.594,
              11860.053
            ],
            [
              -2093.736,
              8856.226,
              11969.697
            ],
            [
              -2111.787,
              8822.036,
              12008.36
            ],
            [
              -2119.031,
              8814.371,
              12018.905
            ],
            [
              -2130.111,
              8809.001,
              12031.218
            ],
            [
              -2137.374,
              8800.224,
              12042.61
            ],
            [
              -2151.096,
              8791.561,
              12058.838
            ],
            [
              -2169.966,
              8784.102,
              12079.129
            ],
            [
              -2741.81,
              8673.948,
              12661.486
            ],
            [
              -3334.939,
              8564.092,
              13264.703
            ],
            [
              -3591.691,
              8512.898,
              13526.509
            ],
            [
              -3607.723,
              8519.855,
              13543.986
            ],
            [
              -3659.232,
              8567.503,
              13614.153
            ],
            [
              -3746.2,
              8656.953,
              13738.912
            ],
            [
              -3800.064,
              8717.999,
              13820.324
            ],
            [
              -3843.276,
              8759.935,
              13880.539
            ],
            [
              -4138.195,
              8968.743,
              14241.894
            ],
            [
              -4247.36,
              9008.472,
              14358.064
            ],
            [
              -4355.996,
              9041.51,
              14471.613
            ],
            [
              -4417.136,
              9055.919,
              14534.428
            ],
            [
              -4590.126,
              9104.527,
              14714.117
            ],
            [
              -4643.248,
              9134.38,
              14775.053
            ],
            [
              -4774.327,
              9253.508,
              14952.178
            ],
            [
              -5075.825,
              9611.532,
              15420.24
            ],
            [
              -5091.863,
              9618.484,
              15437.72
            ],
            [
              -5109.915,
              9621.018,
              15455.949
            ],
            [
              -5126.181,
              9614.615,
              15473.429
            ],
            [
              -5233.744,
              9521.824,
              15615.486
            ],
            [
              -5251.014,
              9494.288,
              15647.99
            ],
            [
              -5257.075,
              9479.92,
              15663.584
            ],
            [
              -5249.054,
              9457.52,
              15687.376
            ],
            [
              -5236.931,
              9448.408,
              15702.542
            ],
            [
              -5215.706,
              9442.482,
              15724.579
            ],
            [
              -5202.12,
              9443.364,
              15738.193
            ],
            [
              -5027.711,
              9590.675,
              15966.489
            ],
            [
              -5022.258,
              9607.28,
              15983.966
            ],
            [
              -5022.753,
              9616.194,
              15992.894
            ],
            [
              -5094.927,
              9704.251,
              16106.75
            ],
            [
              -5302.797,
              9527.45,
              16379.639
            ],
            [
              -5328.941,
              9510.083,
              16411.027
            ],
            [
              -5340.778,
              9498.039,
              16427.913
            ],
            [
              -5368.936,
              9476.253,
              16463.515
            ],
            [
              -5370.969,
              9470.722,
              16469.408
            ],
            [
              -5367.871,
              9462.877,
              16477.843
            ],
            [
              -5371.233,
              9455.142,
              16486.277
            ],
            [
              -5379.783,
              9446.381,
              16498.518
            ],
            [
              -5388.219,
              9444.298,
              16507.208
            ],
            [
              -5395.953,
              9445.542,
              16515.041
            ],
            [
              -5402.319,
              9451.216,
              16523.569
            ],
            [
              -5404.087,
              9461.265,
              16533.772
            ],
            [
              -5443.232,
              9477.513,
              16576.155
            ],
            [
              -5441.218,
              9481.932,
              16581.011
            ],
            [
              -5481.844,
              9487.073,
              16621.961
            ],
            [
              -5545.139,
              9489.258,
              16685.293
            ],
            [
              -5626.849,
              9510.677,
              16769.763
            ],
            [
              -5666.49,
              9535.837,
              16816.715
            ],
            [
              -5758.358,
              9606.406,
              16932.559
            ],
            [
              -5990.756,
              9775.073,
              17219.712
            ],
            [
              -6020.289,
              9786.701,
              17251.452
            ],
            [
              -6057.033,
              9830.733,
              17308.801
            ],
            [
              -6278.159,
              9979.158,
              17575.122
            ],
            [
              -6380.272,
              10056.564,
              17703.258
            ],
            [
              -6412.094,
              10086.039,
              17746.633
            ],
            [
              -6420.233,
              10101.76,
              17764.336
            ],
            [
              -6442.123,
              10416.041,
              18079.378
            ],
            [
              -6442.03,
              10421.605,
              18084.943
            ],
            [
              -6438.743,
              10424.89,
              18089.59
            ],
            [
              -6427.795,
              10422.48,
              18100.8
            ],
            [
              -6425.912,
              10419.109,
              18104.661
            ],
            [
              -6430.087,
              10401.368,
              18122.886
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8262",
              "position": {
                "x": 365.148,
                "z": 1967.953
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 717.273,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 1330.998,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 2029.798,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 2522.73,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5304",
              "position": {
                "x": -578.027,
                "z": 4368.5
              },
              "distanceAlongShapeM": 3906.819,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5310",
              "position": {
                "x": -710.664,
                "z": 4781.67
              },
              "distanceAlongShapeM": 4347.238,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5313",
              "position": {
                "x": -621.345,
                "z": 5545.954
              },
              "distanceAlongShapeM": 5116.888,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5315",
              "position": {
                "x": -665.323,
                "z": 5971.996
              },
              "distanceAlongShapeM": 5547.746,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5317",
              "position": {
                "x": -741.072,
                "z": 6427.553
              },
              "distanceAlongShapeM": 6009.728,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5316",
              "position": {
                "x": -1082.746,
                "z": 6425.899
              },
              "distanceAlongShapeM": 6411.231,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5319",
              "position": {
                "x": -1269.126,
                "z": 6079.688
              },
              "distanceAlongShapeM": 6964.333,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:8347",
              "position": {
                "x": -1434.909,
                "z": 5981.348
              },
              "distanceAlongShapeM": 7666.338,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6963",
              "position": {
                "x": -1715.73,
                "z": 6821.26
              },
              "distanceAlongShapeM": 8567.589,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6967",
              "position": {
                "x": -2023.848,
                "z": 7621.558
              },
              "distanceAlongShapeM": 9516.342,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6264",
              "position": {
                "x": -1542.006,
                "z": 8306.527
              },
              "distanceAlongShapeM": 10364.427,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6261",
              "position": {
                "x": -1556.03,
                "z": 8788.795
              },
              "distanceAlongShapeM": 10859.638,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:9003",
              "position": {
                "x": -1669.285,
                "z": 9214.942
              },
              "distanceAlongShapeM": 11352.099,
              "shapeOffsetM": 0.841,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6973",
              "position": {
                "x": -2047.392,
                "z": 8955.594
              },
              "distanceAlongShapeM": 11860.053,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:4705",
              "position": {
                "x": -2935.628,
                "z": 8638.383
              },
              "distanceAlongShapeM": 12858.54,
              "shapeOffsetM": 0.327,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6974",
              "position": {
                "x": -3746.2,
                "z": 8656.953
              },
              "distanceAlongShapeM": 13738.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:9200",
              "position": {
                "x": -5302.797,
                "z": 9527.45
              },
              "distanceAlongShapeM": 16379.639,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:9773",
              "position": {
                "x": -5443.232,
                "z": 9477.513
              },
              "distanceAlongShapeM": 16576.155,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5756",
              "position": {
                "x": -6020.289,
                "z": 9786.701
              },
              "distanceAlongShapeM": 17251.452,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2670,
              "departureOffsetSeconds": 2670
            },
            {
              "stopId": "judu:stop:9732",
              "position": {
                "x": -6430.087,
                "z": 10401.368
              },
              "distanceAlongShapeM": 18122.886,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2790,
              "departureOffsetSeconds": 2790
            }
          ],
          "departuresSeconds": [
            18660,
            19920,
            21480,
            23100,
            24660,
            26700,
            28320,
            31080,
            34140,
            36180,
            40200,
            42300,
            46080,
            48360,
            52320,
            54600,
            55860,
            57060,
            59040,
            61080,
            62700,
            64320,
            68640,
            70560,
            74400,
            79920
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_3:1",
          "sourceRouteId": "vilnius_bus_3",
          "sourceShapeId": "vilnius_bus_3_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Vaidotai–Salininkai–Dilgynė–Eišiškių pl.–Stotis",
          "mode": "bus",
          "routeShortName": "3",
          "routeLongName": "Stotis–Eišiškių pl.–Dilgynė–Salininkai–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6430.087,
              10401.368,
              0
            ],
            [
              -6438.692,
              10389.267,
              14.849
            ],
            [
              -6428.175,
              10206.531,
              197.887
            ],
            [
              -6421.93,
              10116.26,
              288.375
            ],
            [
              -6420.731,
              10110.674,
              294.088
            ],
            [
              -6411.225,
              10099.383,
              308.847
            ],
            [
              -6400.408,
              10089.183,
              323.714
            ],
            [
              -6388.113,
              10090.091,
              336.043
            ],
            [
              -6365.187,
              10069.67,
              366.745
            ],
            [
              -6356.936,
              10060.626,
              378.987
            ],
            [
              -6353.227,
              10050.546,
              389.728
            ],
            [
              -6339.385,
              10028.05,
              416.141
            ],
            [
              -5956.85,
              9754.465,
              886.441
            ],
            [
              -5658.167,
              9531.244,
              1259.321
            ],
            [
              -5627.495,
              9510.688,
              1296.244
            ],
            [
              -5583.845,
              9493.252,
              1343.247
            ],
            [
              -5567.086,
              9490.742,
              1360.193
            ],
            [
              -5516.085,
              9487.653,
              1411.287
            ],
            [
              -5468.239,
              9489.069,
              1459.154
            ],
            [
              -5399.965,
              9475.666,
              1528.731
            ],
            [
              -5385.05,
              9478.753,
              1543.963
            ],
            [
              -5379.273,
              9476.428,
              1550.19
            ],
            [
              -5153.129,
              9664.054,
              1844.034
            ],
            [
              -5089.701,
              9707.502,
              1920.915
            ],
            [
              -5041.071,
              9640.996,
              2003.304
            ],
            [
              -5030.221,
              9633.019,
              2016.771
            ],
            [
              -5019.257,
              9631.719,
              2027.813
            ],
            [
              -5006.24,
              9637.063,
              2041.883
            ],
            [
              -4953.187,
              9678.459,
              2109.176
            ],
            [
              -4945.89,
              9689.466,
              2122.382
            ],
            [
              -4944.94,
              9707.261,
              2140.202
            ],
            [
              -4948,
              9717.332,
              2150.728
            ],
            [
              -4956.304,
              9723.04,
              2160.804
            ],
            [
              -4958.813,
              9727.535,
              2165.952
            ],
            [
              -4997.692,
              9721.519,
              2205.294
            ],
            [
              -5079.038,
              9650.548,
              2313.248
            ],
            [
              -5081.85,
              9637.238,
              2326.852
            ],
            [
              -5080.082,
              9627.189,
              2337.055
            ],
            [
              -4806.589,
              9294.134,
              2768.012
            ],
            [
              -4729.202,
              9209.322,
              2882.825
            ],
            [
              -4643.248,
              9134.38,
              2996.861
            ],
            [
              -4545.116,
              9091.511,
              3103.949
            ],
            [
              -4197.811,
              8996.486,
              3464.019
            ],
            [
              -4150.353,
              8975.631,
              3515.857
            ],
            [
              -4059.622,
              8916.181,
              3624.33
            ],
            [
              -3843.276,
              8759.935,
              3891.198
            ],
            [
              -3713.566,
              8638.576,
              4068.828
            ],
            [
              -3697.804,
              8616.039,
              4096.33
            ],
            [
              -3661.015,
              8576.44,
              4150.382
            ],
            [
              -3619.725,
              8535.648,
              4208.423
            ],
            [
              -3591.691,
              8512.898,
              4244.527
            ],
            [
              -2877.847,
              8654.069,
              4972.196
            ],
            [
              -2205.592,
              8779.166,
              5655.991
            ],
            [
              -2160.179,
              8789.495,
              5702.565
            ],
            [
              -2145.869,
              8794.808,
              5717.829
            ],
            [
              -2111.689,
              8827.6,
              5765.195
            ],
            [
              -1976.705,
              9115.757,
              6083.401
            ],
            [
              -1958.124,
              9143.258,
              6116.591
            ],
            [
              -1928.659,
              9164.999,
              6153.209
            ],
            [
              -1890.993,
              9175.464,
              6192.301
            ],
            [
              -1618.698,
              9225.174,
              6469.097
            ],
            [
              -1611.777,
              9178.296,
              6516.483
            ],
            [
              -1592.202,
              9079.986,
              6616.724
            ],
            [
              -1553.05,
              8811.006,
              6888.538
            ],
            [
              -1548.081,
              8799.785,
              6900.81
            ],
            [
              -1540.488,
              8790.744,
              6912.616
            ],
            [
              -1537.516,
              8776.22,
              6927.442
            ],
            [
              -1545.584,
              8758.552,
              6946.864
            ],
            [
              -1504.025,
              8516.246,
              7192.709
            ],
            [
              -1501.391,
              8482.803,
              7226.256
            ],
            [
              -1502.671,
              8447.203,
              7261.878
            ],
            [
              -1506.496,
              8413.875,
              7295.425
            ],
            [
              -1524.816,
              8328.484,
              7382.759
            ],
            [
              -1523.196,
              8310.644,
              7400.673
            ],
            [
              -1526.037,
              8296.223,
              7415.371
            ],
            [
              -1532.635,
              8288.548,
              7425.492
            ],
            [
              -1550.213,
              8281.069,
              7444.595
            ],
            [
              -1597.232,
              8252.963,
              7499.374
            ],
            [
              -1633.27,
              8224.661,
              7545.197
            ],
            [
              -1763.019,
              8085.591,
              7735.395
            ],
            [
              -1804.677,
              8031.784,
              7803.443
            ],
            [
              -1903.889,
              7865.451,
              7997.118
            ],
            [
              -1952.381,
              7753.877,
              8118.774
            ],
            [
              -2057.537,
              7543.118,
              8354.31
            ],
            [
              -2098.584,
              7450.335,
              8455.766
            ],
            [
              -2070.914,
              7444.279,
              8484.091
            ],
            [
              -2050.683,
              7419.43,
              8516.134
            ],
            [
              -1961.855,
              7328.8,
              8643.037
            ],
            [
              -1773.99,
              7068.315,
              8964.2
            ],
            [
              -1717.974,
              6949.319,
              9095.721
            ],
            [
              -1717.474,
              6904.781,
              9140.261
            ],
            [
              -1680.546,
              6475.539,
              9571.089
            ],
            [
              -1667.918,
              6422.993,
              9625.131
            ],
            [
              -1471.061,
              6054.352,
              10043.042
            ],
            [
              -1459.639,
              6043.016,
              10059.134
            ],
            [
              -1442.825,
              6008.206,
              10097.792
            ],
            [
              -1415.255,
              5960.959,
              10152.495
            ],
            [
              -1252.943,
              5720.943,
              10442.241
            ],
            [
              -1220.288,
              5741.51,
              10480.832
            ],
            [
              -1286.059,
              6107.821,
              10853.001
            ],
            [
              -1300.387,
              6209.379,
              10955.565
            ],
            [
              -1321.777,
              6385.649,
              11133.128
            ],
            [
              -1086.38,
              6439.323,
              11374.566
            ],
            [
              -745.195,
              6485.515,
              11718.864
            ],
            [
              -727.534,
              6426.196,
              11780.756
            ],
            [
              -708.429,
              6267.775,
              11940.324
            ],
            [
              -654.389,
              5969.573,
              12243.384
            ],
            [
              -612.702,
              5667.139,
              12548.677
            ],
            [
              -622.125,
              5466.93,
              12749.108
            ],
            [
              -626.941,
              5414.695,
              12801.564
            ],
            [
              -643.028,
              5310.343,
              12907.149
            ],
            [
              -682.124,
              4968.176,
              13251.542
            ],
            [
              -715.86,
              4708.291,
              13513.608
            ],
            [
              -708.316,
              4697.023,
              13527.168
            ],
            [
              -707.871,
              4685.883,
              13538.317
            ],
            [
              -676.746,
              4621.868,
              13609.498
            ],
            [
              -601.144,
              4446.842,
              13800.154
            ],
            [
              -555.117,
              4350.275,
              13907.129
            ],
            [
              -482.27,
              4237.637,
              14041.271
            ],
            [
              -475.614,
              4213.025,
              14066.766
            ],
            [
              -396.44,
              4093.592,
              14210.06
            ],
            [
              -345.945,
              4030.338,
              14290.997
            ],
            [
              -378.367,
              3879.526,
              14445.254
            ],
            [
              -382.056,
              3853.989,
              14471.057
            ],
            [
              -382.136,
              3813.914,
              14511.131
            ],
            [
              -379.958,
              3791.61,
              14533.541
            ],
            [
              -326.239,
              3550.182,
              14780.874
            ],
            [
              -300.672,
              3393.867,
              14939.266
            ],
            [
              -259.604,
              3167.138,
              15169.684
            ],
            [
              -234.366,
              2993.018,
              15345.624
            ],
            [
              -225.435,
              2951.666,
              15387.929
            ],
            [
              -266.588,
              2603.973,
              15738.049
            ],
            [
              -287.151,
              2501.929,
              15842.145
            ],
            [
              -327.226,
              2355.709,
              15993.757
            ],
            [
              -350.367,
              2324.958,
              16032.242
            ],
            [
              -412.128,
              2228.113,
              16147.105
            ],
            [
              -425.492,
              2202.75,
              16175.773
            ],
            [
              -439.803,
              2160.707,
              16220.185
            ],
            [
              -445.668,
              2121.85,
              16259.482
            ],
            [
              -471.768,
              2034.377,
              16350.766
            ],
            [
              -499.661,
              1919.106,
              16469.363
            ],
            [
              -508.548,
              1855.813,
              16533.277
            ],
            [
              -490.609,
              1848.809,
              16552.535
            ],
            [
              -470.051,
              1843.985,
              16573.652
            ],
            [
              -432.32,
              1825.49,
              16615.672
            ],
            [
              -327.19,
              1787.963,
              16727.298
            ],
            [
              -259.046,
              1774.482,
              16796.763
            ],
            [
              -147.106,
              1756.865,
              16910.081
            ],
            [
              9.981,
              1738.424,
              17068.246
            ],
            [
              41.02,
              1742.312,
              17099.528
            ],
            [
              63.816,
              1754.143,
              17125.211
            ],
            [
              135.751,
              1771.757,
              17199.272
            ],
            [
              319.251,
              1821.845,
              17389.484
            ],
            [
              341.2,
              1822.557,
              17411.445
            ],
            [
              378.73,
              1828.551,
              17449.451
            ],
            [
              526.755,
              1843.654,
              17598.244
            ],
            [
              583.03,
              1851.529,
              17655.068
            ],
            [
              594.24,
              1864.683,
              17672.349
            ],
            [
              593.052,
              1870.271,
              17678.062
            ],
            [
              545.045,
              1891.188,
              17730.428
            ],
            [
              472.814,
              1928.134,
              17811.559
            ],
            [
              457.253,
              1923.966,
              17827.669
            ],
            [
              443.063,
              1924.225,
              17841.861
            ],
            [
              417.95,
              1926.911,
              17867.118
            ],
            [
              405.756,
              1930.474,
              17879.821
            ],
            [
              392.999,
              1938.5,
              17894.893
            ],
            [
              365.148,
              1967.953,
              17935.429
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9732",
              "position": {
                "x": -6430.087,
                "z": 10401.368
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:3575",
              "position": {
                "x": -6388.113,
                "z": 10090.091
              },
              "distanceAlongShapeM": 336.043,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5757",
              "position": {
                "x": -5956.85,
                "z": 9754.465
              },
              "distanceAlongShapeM": 886.441,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9201",
              "position": {
                "x": -5153.129,
                "z": 9664.054
              },
              "distanceAlongShapeM": 1844.034,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6975",
              "position": {
                "x": -3713.566,
                "z": 8638.576
              },
              "distanceAlongShapeM": 4068.828,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:4706",
              "position": {
                "x": -2877.847,
                "z": 8654.069
              },
              "distanceAlongShapeM": 4972.196,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6972",
              "position": {
                "x": -2032.412,
                "z": 8998.744
              },
              "distanceAlongShapeM": 5953.807,
              "shapeOffsetM": 0.809,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9740",
              "position": {
                "x": -1611.777,
                "z": 9178.296
              },
              "distanceAlongShapeM": 6516.483,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6260",
              "position": {
                "x": -1540.488,
                "z": 8790.744
              },
              "distanceAlongShapeM": 6912.616,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6263",
              "position": {
                "x": -1532.635,
                "z": 8288.548
              },
              "distanceAlongShapeM": 7425.492,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6966",
              "position": {
                "x": -2070.914,
                "z": 7444.279
              },
              "distanceAlongShapeM": 8484.091,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6964",
              "position": {
                "x": -1717.974,
                "z": 6949.319
              },
              "distanceAlongShapeM": 9095.721,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6961",
              "position": {
                "x": -1459.639,
                "z": 6043.016
              },
              "distanceAlongShapeM": 10059.134,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9728",
              "position": {
                "x": -1286.059,
                "z": 6107.821
              },
              "distanceAlongShapeM": 10853.001,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9729",
              "position": {
                "x": -1086.38,
                "z": 6439.323
              },
              "distanceAlongShapeM": 11374.566,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:9731",
              "position": {
                "x": -727.534,
                "z": 6426.196
              },
              "distanceAlongShapeM": 11780.756,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:9730",
              "position": {
                "x": -654.389,
                "z": 5969.573
              },
              "distanceAlongShapeM": 12243.384,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:491",
              "position": {
                "x": -626.941,
                "z": 5414.695
              },
              "distanceAlongShapeM": 12801.564,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5307",
              "position": {
                "x": -708.316,
                "z": 4697.023
              },
              "distanceAlongShapeM": 13527.168,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5305",
              "position": {
                "x": -482.27,
                "z": 4237.637
              },
              "distanceAlongShapeM": 14041.271,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 15387.929,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 15738.049,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 16573.652,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 17125.211,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2430,
              "departureOffsetSeconds": 2430
            },
            {
              "stopId": "judu:stop:16581",
              "position": {
                "x": 378.73,
                "z": 1828.551
              },
              "distanceAlongShapeM": 17449.451,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            21720,
            23400,
            24780,
            26880,
            28200,
            30180,
            32040,
            34980,
            37320,
            39240,
            43200,
            45360,
            49140,
            51480,
            55440,
            57780,
            59400,
            60900,
            62700,
            64680,
            66540,
            68340,
            71640,
            79080
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_3G",
      "sourceRouteId": "vilnius_expressbus_3G",
      "mode": "bus",
      "shortName": "3G",
      "longName": "Perkūnkiemis–Šeškinė–Centras–Oro uostas",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_3G:0",
          "sourceRouteId": "vilnius_expressbus_3G",
          "sourceShapeId": "vilnius_expressbus_3G_a-b",
          "directionId": 0,
          "headsign": "Oro uostas",
          "directionName": "Perkūnkiemis–Šeškinė–Centras–Oro uostas",
          "mode": "bus",
          "routeShortName": "3G",
          "routeLongName": "Perkūnkiemis–Šeškinė–Centras–Oro uostas",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3844.602,
              -5152.866,
              0
            ],
            [
              -3862.028,
              -5154.789,
              17.532
            ],
            [
              -3896.745,
              -5150.846,
              52.471
            ],
            [
              -3904.981,
              -5142.911,
              63.908
            ],
            [
              -3906.076,
              -5131.759,
              75.113
            ],
            [
              -3903.757,
              -5109.535,
              97.458
            ],
            [
              -3899.68,
              -5097.361,
              110.297
            ],
            [
              -3891.837,
              -5090.818,
              120.511
            ],
            [
              -3867.269,
              -5085.679,
              145.611
            ],
            [
              -3846.822,
              -5058.204,
              179.859
            ],
            [
              -3847.955,
              -5049.278,
              188.856
            ],
            [
              -3872.993,
              -5044.39,
              214.367
            ],
            [
              -4005.77,
              -5048.764,
              347.216
            ],
            [
              -4036.095,
              -5051.578,
              377.671
            ],
            [
              -4045.246,
              -5059.211,
              389.588
            ],
            [
              -4054.001,
              -5192.645,
              523.309
            ],
            [
              -3974.864,
              -5346.529,
              696.349
            ],
            [
              -3828.987,
              -5588.405,
              978.81
            ],
            [
              -3738.174,
              -5773.666,
              1185.132
            ],
            [
              -3673.968,
              -5896.125,
              1323.402
            ],
            [
              -3663.88,
              -5908.547,
              1339.404
            ],
            [
              -3644.191,
              -5924.475,
              1364.729
            ],
            [
              -3618.634,
              -5899.316,
              1400.591
            ],
            [
              -3485.286,
              -5750.246,
              1600.6
            ],
            [
              -3386.562,
              -5629.518,
              1756.555
            ],
            [
              -3375.968,
              -5613.005,
              1776.174
            ],
            [
              -3323.404,
              -5553.81,
              1855.338
            ],
            [
              -3282.741,
              -5512.22,
              1913.504
            ],
            [
              -3111.162,
              -5314.848,
              2175.028
            ],
            [
              -3040.755,
              -5230.366,
              2285.003
            ],
            [
              -2985.976,
              -5155.629,
              2377.665
            ],
            [
              -2932.971,
              -5071.956,
              2476.714
            ],
            [
              -2914.996,
              -5038.876,
              2514.363
            ],
            [
              -2884.805,
              -5007.124,
              2558.177
            ],
            [
              -2783.196,
              -4834.137,
              2758.798
            ],
            [
              -2685.035,
              -4674.45,
              2946.243
            ],
            [
              -2617.123,
              -4549.854,
              3088.145
            ],
            [
              -2601.622,
              -4511.165,
              3129.824
            ],
            [
              -2570.953,
              -4452.706,
              3195.839
            ],
            [
              -2472.865,
              -4225.115,
              3443.667
            ],
            [
              -2375.99,
              -3957.429,
              3728.343
            ],
            [
              -2366.341,
              -3921.977,
              3765.085
            ],
            [
              -2313.476,
              -3774.854,
              3921.418
            ],
            [
              -2292.987,
              -3709.537,
              3989.873
            ],
            [
              -2289.819,
              -3676.197,
              4023.364
            ],
            [
              -2072.945,
              -3075.564,
              4661.951
            ],
            [
              -2044.086,
              -2974.773,
              4766.792
            ],
            [
              -2024.769,
              -2939.494,
              4807.014
            ],
            [
              -2004.312,
              -2876.403,
              4873.338
            ],
            [
              -1942.85,
              -2718.306,
              5042.962
            ],
            [
              -1897.194,
              -2615.588,
              5155.369
            ],
            [
              -1889.264,
              -2604.597,
              5168.923
            ],
            [
              -1854.797,
              -2587.399,
              5207.442
            ],
            [
              -1805.935,
              -2485.853,
              5320.132
            ],
            [
              -1803.13,
              -2436.921,
              5369.144
            ],
            [
              -1757.32,
              -2362.039,
              5456.928
            ],
            [
              -1747.763,
              -2332.152,
              5488.306
            ],
            [
              -1727.311,
              -2305.799,
              5521.663
            ],
            [
              -1547.472,
              -2017.345,
              5861.586
            ],
            [
              -1343.434,
              -1674.784,
              6260.309
            ],
            [
              -1305.861,
              -1628.702,
              6319.767
            ],
            [
              -1268.647,
              -1602.651,
              6365.193
            ],
            [
              -1054.592,
              -1494.059,
              6605.217
            ],
            [
              -1027.103,
              -1471.176,
              6640.985
            ],
            [
              -1009.966,
              -1450.333,
              6667.968
            ],
            [
              -1001.511,
              -1410.409,
              6708.778
            ],
            [
              -987.78,
              -1363.9,
              6757.271
            ],
            [
              -988.723,
              -1201.352,
              6919.822
            ],
            [
              -990.397,
              -1186.85,
              6934.42
            ],
            [
              -1017.615,
              -1122.906,
              7003.916
            ],
            [
              -1020.518,
              -1105.042,
              7022.014
            ],
            [
              -1018.304,
              -1089.497,
              7037.716
            ],
            [
              -1013.532,
              -1075.111,
              7052.873
            ],
            [
              -1005.537,
              -1060.783,
              7069.281
            ],
            [
              -969.041,
              -1039.175,
              7111.694
            ],
            [
              -947.066,
              -1036.231,
              7133.865
            ],
            [
              -930.307,
              -1036.533,
              7150.627
            ],
            [
              -906.579,
              -1043.639,
              7175.396
            ],
            [
              -895.802,
              -1053.852,
              7190.244
            ],
            [
              -890.221,
              -1066.198,
              7203.793
            ],
            [
              -882.043,
              -1077.478,
              7217.726
            ],
            [
              -868.708,
              -1088.851,
              7235.252
            ],
            [
              -845.624,
              -1095.946,
              7259.401
            ],
            [
              -837.245,
              -1096.097,
              7267.782
            ],
            [
              -813.336,
              -1093.188,
              7291.866
            ],
            [
              -786.145,
              -1086.999,
              7319.754
            ],
            [
              -775.751,
              -1082.734,
              7330.988
            ],
            [
              -717.641,
              -1078.217,
              7389.274
            ],
            [
              -647.083,
              -1062.792,
              7461.498
            ],
            [
              -599.769,
              -1049.176,
              7510.732
            ],
            [
              -535.555,
              -1028.072,
              7578.325
            ],
            [
              -464.693,
              -995.958,
              7656.124
            ],
            [
              -361.843,
              -942.16,
              7772.195
            ],
            [
              -333.702,
              -919.293,
              7808.456
            ],
            [
              -286.889,
              -897.877,
              7859.935
            ],
            [
              -196.966,
              -846.075,
              7963.711
            ],
            [
              -115.583,
              -803.025,
              8055.779
            ],
            [
              -96.647,
              -790.01,
              8078.757
            ],
            [
              -42.035,
              -765.399,
              8138.658
            ],
            [
              224.176,
              -700.119,
              8412.756
            ],
            [
              211.01,
              -644.216,
              8470.187
            ],
            [
              143.71,
              -480.456,
              8647.237
            ],
            [
              121.213,
              -441.083,
              8692.584
            ],
            [
              119.827,
              -411,
              8722.699
            ],
            [
              106.146,
              -277.163,
              8857.234
            ],
            [
              35.151,
              -280.322,
              8928.299
            ],
            [
              -101.904,
              -298.979,
              9066.617
            ],
            [
              -140.08,
              -306.078,
              9105.449
            ],
            [
              -153.095,
              -312.52,
              9119.971
            ],
            [
              -191.836,
              -315.156,
              9158.801
            ],
            [
              -244.276,
              -326.45,
              9212.443
            ],
            [
              -305.298,
              -348.72,
              9277.402
            ],
            [
              -413.017,
              -421.354,
              9407.322
            ],
            [
              -450.326,
              -380.602,
              9462.573
            ],
            [
              -465.596,
              -369.193,
              9481.634
            ],
            [
              -470.512,
              -355.745,
              9495.952
            ],
            [
              -508.466,
              -314.982,
              9551.65
            ],
            [
              -611.52,
              -58.189,
              9828.349
            ],
            [
              -615.308,
              -53.668,
              9834.247
            ],
            [
              -625.745,
              -24.535,
              9865.193
            ],
            [
              -646.921,
              17.037,
              9911.848
            ],
            [
              -652.524,
              63.893,
              9959.038
            ],
            [
              -679.973,
              222.467,
              10119.971
            ],
            [
              -691.721,
              250.51,
              10150.375
            ],
            [
              -832.714,
              443.415,
              10389.313
            ],
            [
              -840.816,
              459.146,
              10407.007
            ],
            [
              -843.214,
              469.208,
              10417.351
            ],
            [
              -833.842,
              667.193,
              10615.559
            ],
            [
              -824.942,
              731.6,
              10680.577
            ],
            [
              -800.789,
              819.11,
              10771.359
            ],
            [
              -793.638,
              857.944,
              10810.846
            ],
            [
              -767.948,
              887.538,
              10850.035
            ],
            [
              -708.773,
              1021.171,
              10996.184
            ],
            [
              -697.048,
              1063.262,
              11039.877
            ],
            [
              -655.787,
              1240.633,
              11221.985
            ],
            [
              -656.233,
              1287.397,
              11268.75
            ],
            [
              -631.67,
              1361.539,
              11346.856
            ],
            [
              -535.917,
              1805.1,
              11800.634
            ],
            [
              -511.654,
              1933.795,
              11931.596
            ],
            [
              -496.901,
              1964.699,
              11965.841
            ],
            [
              -457.217,
              2125.399,
              12131.368
            ],
            [
              -447.865,
              2143.041,
              12151.336
            ],
            [
              -441.536,
              2171.87,
              12180.852
            ],
            [
              -427.991,
              2207.248,
              12218.734
            ],
            [
              -406.646,
              2245.825,
              12262.823
            ],
            [
              -367.501,
              2305.23,
              12333.966
            ],
            [
              -344.32,
              2338.207,
              12374.275
            ],
            [
              -327.226,
              2355.709,
              12398.739
            ],
            [
              -287.151,
              2501.929,
              12550.351
            ],
            [
              -286.021,
              2528.626,
              12577.072
            ],
            [
              -290.153,
              2585.475,
              12634.072
            ],
            [
              -278.622,
              2616.436,
              12667.111
            ],
            [
              -255.517,
              2787.454,
              12839.682
            ],
            [
              -234.366,
              2993.018,
              13046.331
            ],
            [
              -244.365,
              3011.01,
              13066.915
            ],
            [
              -250.393,
              3034.497,
              13091.164
            ],
            [
              -255.513,
              3072.44,
              13129.45
            ],
            [
              -253.335,
              3121.382,
              13178.441
            ],
            [
              -378.969,
              3774.894,
              13843.919
            ],
            [
              -384.152,
              3809.498,
              13878.909
            ],
            [
              -385.02,
              3832.891,
              13902.319
            ],
            [
              -382.299,
              3876.258,
              13945.77
            ],
            [
              -328.221,
              4117.961,
              14193.45
            ],
            [
              -328.523,
              4136.892,
              14212.382
            ],
            [
              -271.052,
              4387.439,
              14469.437
            ],
            [
              -225.312,
              4631.519,
              14717.766
            ],
            [
              -199.899,
              4822.533,
              14910.462
            ],
            [
              -199.233,
              4859.257,
              14947.193
            ],
            [
              -191.024,
              4884.712,
              14973.939
            ],
            [
              -172.749,
              5038.005,
              15128.317
            ],
            [
              -160.849,
              5053.375,
              15147.755
            ],
            [
              181.228,
              5047.157,
              15489.889
            ],
            [
              185.04,
              5043.748,
              15495.003
            ],
            [
              184.043,
              4953.595,
              15585.161
            ],
            [
              190.96,
              4943.45,
              15597.44
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 166.686,
              "shapeOffsetM": 0.733,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15634",
              "position": {
                "x": -3828.987,
                "z": -5588.405
              },
              "distanceAlongShapeM": 978.81,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7077",
              "position": {
                "x": -3618.634,
                "z": -5899.316
              },
              "distanceAlongShapeM": 1400.591,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9153",
              "position": {
                "x": -3375.968,
                "z": -5613.005
              },
              "distanceAlongShapeM": 1776.174,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5443",
              "position": {
                "x": -2914.996,
                "z": -5038.876
              },
              "distanceAlongShapeM": 2514.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7896",
              "position": {
                "x": -2601.622,
                "z": -4511.165
              },
              "distanceAlongShapeM": 3129.824,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5451",
              "position": {
                "x": -2289.819,
                "z": -3676.197
              },
              "distanceAlongShapeM": 4023.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5452",
              "position": {
                "x": -2044.086,
                "z": -2974.773
              },
              "distanceAlongShapeM": 4766.792,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 5488.306,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 7330.988,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 8138.658,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 8692.584,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 9911.848,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5266",
              "position": {
                "x": -793.638,
                "z": 857.944
              },
              "distanceAlongShapeM": 10810.846,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5272",
              "position": {
                "x": -656.233,
                "z": 1287.397
              },
              "distanceAlongShapeM": 11268.75,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 11931.596,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 13129.45,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:5180",
              "position": {
                "x": -328.523,
                "z": 4136.892
              },
              "distanceAlongShapeM": 14212.382,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:5182",
              "position": {
                "x": -232.492,
                "z": 4591.573
              },
              "distanceAlongShapeM": 14677.181,
              "shapeOffsetM": 0.301,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 15597.44,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            }
          ],
          "departuresSeconds": [
            18540,
            19320,
            20100,
            20820,
            21360,
            21840,
            22260,
            22680,
            23040,
            23400,
            23760,
            24060,
            24360,
            24660,
            24960,
            25260,
            25560,
            25920,
            26220,
            26520,
            26820,
            27180,
            27540,
            27900,
            28260,
            28740,
            29280,
            29940,
            30660,
            31320,
            32040,
            32760,
            33120,
            33540,
            33960,
            34380,
            34800,
            35220,
            35640,
            36060,
            36540,
            37140,
            37860,
            38580,
            39300,
            39900,
            40440,
            41040,
            41640,
            42240,
            42840,
            43440,
            44040,
            44580,
            45180,
            45840,
            46500,
            46980,
            47460,
            48180,
            48960,
            49620,
            50280,
            50940,
            51600,
            52200,
            52740,
            53280,
            53820,
            54240,
            54720,
            55080,
            55500,
            55860,
            56220,
            56580,
            57000,
            57300,
            57660,
            58020,
            58380,
            58860,
            59220,
            59760,
            60300,
            60840,
            61380,
            61920,
            62280,
            62640,
            63060,
            63420,
            63900,
            64320,
            64680,
            65160,
            65700,
            66180,
            66600,
            67200,
            67800,
            68340,
            68940,
            69600,
            70260,
            70980,
            71640,
            72300,
            72960,
            73560,
            74160,
            74760,
            75360,
            75900,
            76500,
            77100,
            77700,
            78300,
            78900,
            79740,
            80580,
            81420,
            82620
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_3G:1",
          "sourceRouteId": "vilnius_expressbus_3G",
          "sourceShapeId": "vilnius_expressbus_3G_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Oro uostas–Centras–Šeškinė–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "3G",
          "routeLongName": "Perkūnkiemis–Šeškinė–Centras–Oro uostas",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              190.96,
              4943.45,
              0
            ],
            [
              180.147,
              4916.929,
              28.64
            ],
            [
              171.149,
              4883.696,
              63.07
            ],
            [
              160.096,
              4879.445,
              74.912
            ],
            [
              101.063,
              4899.444,
              137.241
            ],
            [
              60.141,
              4921.34,
              183.652
            ],
            [
              56.975,
              4924.737,
              188.296
            ],
            [
              65.084,
              4944.628,
              209.776
            ],
            [
              70.713,
              4970.13,
              235.892
            ],
            [
              75.861,
              5040.169,
              306.12
            ],
            [
              -161.696,
              5042.258,
              543.687
            ],
            [
              -168.272,
              5035.698,
              552.975
            ],
            [
              -168.292,
              4998.962,
              589.711
            ],
            [
              -175.836,
              4974.608,
              615.206
            ],
            [
              -229.992,
              4551.452,
              1041.814
            ],
            [
              -236.808,
              4531.537,
              1062.862
            ],
            [
              -291.097,
              4278.706,
              1321.456
            ],
            [
              -315.819,
              4161.153,
              1441.582
            ],
            [
              -323.098,
              4115.642,
              1487.67
            ],
            [
              -345.945,
              4030.338,
              1575.981
            ],
            [
              -367.116,
              3930.531,
              1678.009
            ],
            [
              -376.774,
              3896.196,
              1713.676
            ],
            [
              -379.958,
              3791.61,
              1818.31
            ],
            [
              -316.278,
              3458.717,
              2157.24
            ],
            [
              -225.435,
              2951.666,
              2672.364
            ],
            [
              -236.969,
              2849.459,
              2775.22
            ],
            [
              -279.066,
              2556.33,
              3071.356
            ],
            [
              -287.151,
              2501.929,
              3126.355
            ],
            [
              -313.901,
              2414.469,
              3217.814
            ],
            [
              -330.149,
              2372.461,
              3262.855
            ],
            [
              -366.936,
              2300.767,
              3343.436
            ],
            [
              -419.989,
              2221.576,
              3438.756
            ],
            [
              -434.119,
              2189.548,
              3473.762
            ],
            [
              -525.296,
              1821.606,
              3852.833
            ],
            [
              -529.526,
              1766.021,
              3908.578
            ],
            [
              -536.862,
              1752.795,
              3923.702
            ],
            [
              -542.324,
              1736.195,
              3941.177
            ],
            [
              -601.244,
              1474.539,
              4209.386
            ],
            [
              -678.532,
              1124.155,
              4568.193
            ],
            [
              -679.739,
              1093.006,
              4599.365
            ],
            [
              -691.829,
              1066.507,
              4628.491
            ],
            [
              -722.413,
              980.227,
              4720.032
            ],
            [
              -789.726,
              824.476,
              4889.706
            ],
            [
              -808.22,
              764.696,
              4952.282
            ],
            [
              -810.251,
              723.543,
              4993.485
            ],
            [
              -824.878,
              699.315,
              5021.785
            ],
            [
              -838.2,
              496.948,
              5224.59
            ],
            [
              -838.156,
              463.551,
              5257.988
            ],
            [
              -823.183,
              435.45,
              5289.829
            ],
            [
              -689.041,
              256.028,
              5513.852
            ],
            [
              -671.067,
              215.627,
              5558.071
            ],
            [
              -634.631,
              19.041,
              5758.005
            ],
            [
              -585.127,
              -96.516,
              5883.719
            ],
            [
              -570.097,
              -121.279,
              5912.687
            ],
            [
              -567.275,
              -143.594,
              5935.18
            ],
            [
              -513.161,
              -289.293,
              6090.603
            ],
            [
              -501.093,
              -299.53,
              6106.428
            ],
            [
              -461.426,
              -352.57,
              6172.66
            ],
            [
              -449.339,
              -361.695,
              6187.805
            ],
            [
              -413.017,
              -421.354,
              6257.651
            ],
            [
              -305.298,
              -348.72,
              6387.571
            ],
            [
              -203.339,
              -309.381,
              6496.856
            ],
            [
              -102.285,
              -284.5,
              6600.927
            ],
            [
              -50.388,
              -267.632,
              6655.497
            ],
            [
              -22.626,
              -265.911,
              6683.312
            ],
            [
              -0.545,
              -257.407,
              6706.974
            ],
            [
              46.601,
              -218.189,
              6768.299
            ],
            [
              70.758,
              -201.931,
              6797.418
            ],
            [
              82.464,
              -196.578,
              6810.289
            ],
            [
              94.753,
              -194.576,
              6822.741
            ],
            [
              103.738,
              -196.966,
              6832.038
            ],
            [
              115.784,
              -208.318,
              6848.591
            ],
            [
              119.866,
              -267.394,
              6907.807
            ],
            [
              118.552,
              -304.106,
              6944.544
            ],
            [
              124.949,
              -377.696,
              7018.411
            ],
            [
              130.203,
              -407.85,
              7049.019
            ],
            [
              150.182,
              -443.837,
              7090.18
            ],
            [
              177.186,
              -518.917,
              7169.968
            ],
            [
              187.997,
              -562.53,
              7214.902
            ],
            [
              214.213,
              -645.388,
              7301.808
            ],
            [
              224.323,
              -656.705,
              7316.984
            ],
            [
              237.149,
              -695.903,
              7358.226
            ],
            [
              236.925,
              -708.144,
              7370.47
            ],
            [
              229.693,
              -715.805,
              7381.005
            ],
            [
              23.734,
              -765.484,
              7592.87
            ],
            [
              -53.078,
              -805.275,
              7679.377
            ],
            [
              -306.711,
              -924.235,
              7959.522
            ],
            [
              -475.993,
              -1014.678,
              8151.451
            ],
            [
              -535.776,
              -1040.314,
              8216.498
            ],
            [
              -673.187,
              -1080.133,
              8359.562
            ],
            [
              -763.423,
              -1114.127,
              8455.988
            ],
            [
              -822.801,
              -1117.509,
              8515.463
            ],
            [
              -837.686,
              -1120.58,
              8530.662
            ],
            [
              -857.223,
              -1131.36,
              8552.976
            ],
            [
              -899.68,
              -1161.766,
              8605.197
            ],
            [
              -917.464,
              -1182.597,
              8632.587
            ],
            [
              -926.283,
              -1206.929,
              8658.468
            ],
            [
              -917.431,
              -1323.977,
              8775.851
            ],
            [
              -911.942,
              -1448.758,
              8900.752
            ],
            [
              -922.391,
              -1491.986,
              8945.224
            ],
            [
              -939.829,
              -1529.521,
              8986.613
            ],
            [
              -961.618,
              -1558.073,
              9022.529
            ],
            [
              -995.732,
              -1590.856,
              9069.842
            ],
            [
              -1026.383,
              -1610.342,
              9106.163
            ],
            [
              -1072.441,
              -1626.213,
              9154.878
            ],
            [
              -1262.636,
              -1662.874,
              9348.574
            ],
            [
              -1320.472,
              -1688.554,
              9411.855
            ],
            [
              -1370.209,
              -1729.965,
              9476.575
            ],
            [
              -1651.924,
              -2199.162,
              10023.849
            ],
            [
              -1682.619,
              -2257.615,
              10089.871
            ],
            [
              -1702.963,
              -2314.026,
              10149.839
            ],
            [
              -1711.936,
              -2347.263,
              10184.266
            ],
            [
              -1753.781,
              -2416.65,
              10265.294
            ],
            [
              -1791.442,
              -2468.3,
              10329.216
            ],
            [
              -1838.817,
              -2558.74,
              10431.313
            ],
            [
              -1870.389,
              -2630.537,
              10509.746
            ],
            [
              -1871.271,
              -2643.88,
              10523.118
            ],
            [
              -1912.507,
              -2715.506,
              10605.766
            ],
            [
              -1995.657,
              -2933.332,
              10838.922
            ],
            [
              -2020.861,
              -3009.696,
              10919.338
            ],
            [
              -2025.964,
              -3043.002,
              10953.033
            ],
            [
              -2242.142,
              -3640.305,
              11588.253
            ],
            [
              -2468.164,
              -4250.803,
              12239.246
            ],
            [
              -2556.572,
              -4477.451,
              12482.527
            ],
            [
              -2704.304,
              -4744.243,
              12787.491
            ],
            [
              -2811.577,
              -4909.336,
              12984.374
            ],
            [
              -2905.084,
              -5061.315,
              13162.815
            ],
            [
              -2916.619,
              -5094.508,
              13197.956
            ],
            [
              -2950.713,
              -5128.419,
              13246.042
            ],
            [
              -3045.536,
              -5245.867,
              13396.991
            ],
            [
              -3100.371,
              -5323.943,
              13492.399
            ],
            [
              -3306.232,
              -5566.356,
              13810.429
            ],
            [
              -3328.612,
              -5593.795,
              13845.837
            ],
            [
              -3341.197,
              -5613.613,
              13869.313
            ],
            [
              -3386.425,
              -5658.464,
              13933.009
            ],
            [
              -3630.767,
              -5930.275,
              14298.501
            ],
            [
              -3641.05,
              -5928.983,
              14308.865
            ],
            [
              -3660.796,
              -5916.393,
              14332.283
            ],
            [
              -3701.111,
              -5864.482,
              14398.01
            ],
            [
              -3758.86,
              -5741.023,
              14534.308
            ],
            [
              -3885.643,
              -5512.834,
              14795.352
            ],
            [
              -3934.889,
              -5418.469,
              14901.795
            ],
            [
              -3998.014,
              -5307.164,
              15029.753
            ],
            [
              -4047.188,
              -5208.349,
              15140.128
            ],
            [
              -4050.157,
              -5193.825,
              15154.952
            ],
            [
              -4048.98,
              -5125.94,
              15222.848
            ],
            [
              -4041.71,
              -5078.197,
              15271.14
            ],
            [
              -4035.058,
              -5066.067,
              15284.975
            ],
            [
              -4020.053,
              -5055.195,
              15303.504
            ],
            [
              -3998.725,
              -5051.113,
              15325.22
            ],
            [
              -3824.791,
              -5050.794,
              15499.154
            ],
            [
              -3827.361,
              -5087.486,
              15535.935
            ],
            [
              -3833.268,
              -5130.798,
              15579.649
            ],
            [
              -3844.602,
              -5152.866,
              15604.457
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:410",
              "position": {
                "x": -229.992,
                "z": 4551.452
              },
              "distanceAlongShapeM": 1041.814,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5181",
              "position": {
                "x": -323.098,
                "z": 4115.642
              },
              "distanceAlongShapeM": 1487.67,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 2672.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5168",
              "position": {
                "x": -529.526,
                "z": 1766.021
              },
              "distanceAlongShapeM": 3908.578,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 4599.365,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 4993.485,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 5912.687,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 7090.18,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 7679.377,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 8455.988,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 10184.266,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:986",
              "position": {
                "x": -2025.964,
                "z": -3043.002
              },
              "distanceAlongShapeM": 10953.033,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:4388",
              "position": {
                "x": -2242.142,
                "z": -3640.305
              },
              "distanceAlongShapeM": 11588.253,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:7897",
              "position": {
                "x": -2556.572,
                "z": -4477.451
              },
              "distanceAlongShapeM": 12482.527,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:481",
              "position": {
                "x": -2916.619,
                "z": -5094.508
              },
              "distanceAlongShapeM": 13197.956,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:9152",
              "position": {
                "x": -3341.197,
                "z": -5613.613
              },
              "distanceAlongShapeM": 13869.313,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:15639",
              "position": {
                "x": -3701.111,
                "z": -5864.482
              },
              "distanceAlongShapeM": 14398.01,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:15636",
              "position": {
                "x": -3885.643,
                "z": -5512.834
              },
              "distanceAlongShapeM": 14795.352,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 15535.935,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            }
          ],
          "departuresSeconds": [
            18900,
            19560,
            20220,
            20880,
            21420,
            21960,
            22440,
            22920,
            23400,
            23880,
            24360,
            24840,
            25320,
            25740,
            26160,
            26580,
            26940,
            27300,
            27660,
            28020,
            28380,
            28800,
            29160,
            29700,
            30240,
            30780,
            31320,
            31800,
            32280,
            33000,
            33480,
            34080,
            34680,
            35160,
            35700,
            36480,
            37020,
            37560,
            38160,
            38700,
            39240,
            39780,
            40320,
            40800,
            41460,
            42120,
            42780,
            43260,
            43800,
            44400,
            44940,
            45660,
            46320,
            46920,
            47460,
            48060,
            48660,
            49320,
            49980,
            50880,
            51360,
            51960,
            52680,
            53280,
            53940,
            54540,
            55140,
            55800,
            56460,
            57000,
            57480,
            57900,
            58320,
            58740,
            59160,
            59700,
            60180,
            60660,
            61200,
            61620,
            62100,
            62520,
            63060,
            63600,
            64080,
            64860,
            65580,
            66360,
            66780,
            67260,
            67740,
            68040,
            68520,
            69000,
            69600,
            70320,
            70920,
            71700,
            72300,
            72840,
            73380,
            73920,
            74520,
            75060,
            75660,
            76260,
            77040,
            77640,
            78180,
            78780,
            79380,
            79980,
            80580,
            81240,
            81840,
            82440,
            83040,
            83640
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_3G-A",
      "sourceRouteId": "vilnius_expressbus_3G-A",
      "mode": "bus",
      "shortName": "3G-A",
      "longName": "Fabijoniškės–Žaliasis tiltas (Apylanka P. Žadeikos g.)",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_3G-A:0",
          "sourceRouteId": "vilnius_expressbus_3G-A",
          "sourceShapeId": "vilnius_expressbus_3G-A_a-b",
          "directionId": 0,
          "headsign": "Žaliasis tiltas (Apylanka P. Žadeikos g.)",
          "directionName": "Fabijoniškės–Žaliasis tiltas (Apylanka P. Žadeikos g.)",
          "mode": "bus",
          "routeShortName": "3G-A",
          "routeLongName": "Fabijoniškės–Žaliasis tiltas (Apylanka P. Žadeikos g.)",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2464.27,
              -5705.856,
              27.473
            ],
            [
              -2454.941,
              -5688.21,
              47.434
            ],
            [
              -2458.022,
              -5680.363,
              55.864
            ],
            [
              -2467.523,
              -5671.289,
              69.002
            ],
            [
              -2484.515,
              -5648.724,
              97.249
            ],
            [
              -2456.526,
              -5595.784,
              157.132
            ],
            [
              -2438.766,
              -5574.947,
              184.511
            ],
            [
              -2323.024,
              -5404.447,
              390.585
            ],
            [
              -2243.521,
              -5280.062,
              538.207
            ],
            [
              -2221.212,
              -5257.08,
              570.237
            ],
            [
              -2172.788,
              -5214.524,
              634.703
            ],
            [
              -2110.315,
              -5178.897,
              706.62
            ],
            [
              -2139.87,
              -5138.296,
              756.839
            ],
            [
              -2215.749,
              -4985.55,
              927.394
            ],
            [
              -2263.134,
              -4896.764,
              1028.033
            ],
            [
              -2303.85,
              -4831.475,
              1104.978
            ],
            [
              -2250.757,
              -4780.095,
              1178.861
            ],
            [
              -2249.272,
              -4768.989,
              1190.066
            ],
            [
              -2217.023,
              -4730.598,
              1240.204
            ],
            [
              -2199.094,
              -4664.123,
              1309.055
            ],
            [
              -2245.99,
              -4656.611,
              1356.55
            ],
            [
              -2248.369,
              -4645.437,
              1367.974
            ],
            [
              -2421.69,
              -4610.083,
              1544.864
            ],
            [
              -2609.045,
              -4566.695,
              1737.178
            ],
            [
              -2744.388,
              -4496.401,
              1889.687
            ],
            [
              -2770.134,
              -4531.57,
              1933.273
            ],
            [
              -2804.177,
              -4598.877,
              2008.699
            ],
            [
              -2799.786,
              -4605.634,
              2016.757
            ],
            [
              -2737.686,
              -4627.879,
              2082.721
            ],
            [
              -2739.677,
              -4631.184,
              2086.579
            ],
            [
              -2716.063,
              -4643.846,
              2113.373
            ],
            [
              -2663.507,
              -4659.245,
              2168.139
            ],
            [
              -2601.622,
              -4511.165,
              2328.63
            ],
            [
              -2575.776,
              -4470.432,
              2376.871
            ],
            [
              -2510.179,
              -4331.325,
              2530.669
            ],
            [
              -2380.854,
              -3977.381,
              2907.499
            ],
            [
              -2366.341,
              -3921.977,
              2964.773
            ],
            [
              -2313.476,
              -3774.854,
              3121.105
            ],
            [
              -2292.987,
              -3709.537,
              3189.56
            ],
            [
              -2289.819,
              -3676.197,
              3223.051
            ],
            [
              -2072.945,
              -3075.564,
              3861.638
            ],
            [
              -2044.086,
              -2974.773,
              3966.479
            ],
            [
              -2024.769,
              -2939.494,
              4006.701
            ],
            [
              -2004.312,
              -2876.403,
              4073.025
            ],
            [
              -1942.85,
              -2718.306,
              4242.65
            ],
            [
              -1897.194,
              -2615.588,
              4355.057
            ],
            [
              -1889.264,
              -2604.597,
              4368.61
            ],
            [
              -1854.797,
              -2587.399,
              4407.129
            ],
            [
              -1805.935,
              -2485.853,
              4519.819
            ],
            [
              -1803.13,
              -2436.921,
              4568.832
            ],
            [
              -1757.32,
              -2362.039,
              4656.615
            ],
            [
              -1747.763,
              -2332.152,
              4687.993
            ],
            [
              -1727.311,
              -2305.799,
              4721.351
            ],
            [
              -1547.472,
              -2017.345,
              5061.273
            ],
            [
              -1343.434,
              -1674.784,
              5459.997
            ],
            [
              -1305.861,
              -1628.702,
              5519.455
            ],
            [
              -1268.647,
              -1602.651,
              5564.88
            ],
            [
              -1054.592,
              -1494.059,
              5804.905
            ],
            [
              -1027.103,
              -1471.176,
              5840.672
            ],
            [
              -1009.966,
              -1450.333,
              5867.656
            ],
            [
              -1001.511,
              -1410.409,
              5908.465
            ],
            [
              -987.78,
              -1363.9,
              5956.958
            ],
            [
              -988.723,
              -1201.352,
              6119.509
            ],
            [
              -990.397,
              -1186.85,
              6134.108
            ],
            [
              -1017.615,
              -1122.906,
              6203.603
            ],
            [
              -1020.518,
              -1105.042,
              6221.701
            ],
            [
              -1018.304,
              -1089.497,
              6237.404
            ],
            [
              -1013.532,
              -1075.111,
              6252.561
            ],
            [
              -1005.537,
              -1060.783,
              6268.968
            ],
            [
              -969.041,
              -1039.175,
              6311.381
            ],
            [
              -947.066,
              -1036.231,
              6333.553
            ],
            [
              -930.307,
              -1036.533,
              6350.314
            ],
            [
              -906.579,
              -1043.639,
              6375.084
            ],
            [
              -895.802,
              -1053.852,
              6389.931
            ],
            [
              -890.221,
              -1066.198,
              6403.48
            ],
            [
              -882.043,
              -1077.478,
              6417.413
            ],
            [
              -868.708,
              -1088.851,
              6434.939
            ],
            [
              -845.624,
              -1095.946,
              6459.088
            ],
            [
              -837.245,
              -1096.097,
              6467.469
            ],
            [
              -813.336,
              -1093.188,
              6491.554
            ],
            [
              -786.145,
              -1086.999,
              6519.441
            ],
            [
              -775.751,
              -1082.734,
              6530.675
            ],
            [
              -717.641,
              -1078.217,
              6588.961
            ],
            [
              -647.083,
              -1062.792,
              6661.185
            ],
            [
              -599.769,
              -1049.176,
              6710.42
            ],
            [
              -535.555,
              -1028.072,
              6778.012
            ],
            [
              -464.693,
              -995.958,
              6855.812
            ],
            [
              -361.843,
              -942.16,
              6971.882
            ],
            [
              -333.702,
              -919.293,
              7008.143
            ],
            [
              -286.889,
              -897.877,
              7059.622
            ],
            [
              -196.966,
              -846.075,
              7163.399
            ],
            [
              -115.583,
              -803.025,
              7255.467
            ],
            [
              -96.647,
              -790.01,
              7278.444
            ],
            [
              -42.035,
              -765.399,
              7338.345
            ],
            [
              224.176,
              -700.119,
              7612.443
            ],
            [
              211.01,
              -644.216,
              7669.874
            ],
            [
              143.71,
              -480.456,
              7846.924
            ],
            [
              121.213,
              -441.083,
              7892.272
            ],
            [
              119.827,
              -411,
              7922.386
            ],
            [
              105.562,
              -273.812,
              8060.314
            ],
            [
              80.298,
              -280.031,
              8086.332
            ],
            [
              41.557,
              -282.665,
              8125.162
            ],
            [
              35.151,
              -280.322,
              8131.983
            ],
            [
              24.998,
              -271.231,
              8145.611
            ],
            [
              19.399,
              -259.997,
              8158.164
            ],
            [
              19.541,
              -252.207,
              8165.955
            ],
            [
              25.627,
              -236.732,
              8182.583
            ],
            [
              52.464,
              -214.957,
              8217.143
            ],
            [
              95.418,
              -193.475,
              8265.17
            ],
            [
              112.865,
              -191.566,
              8282.721
            ],
            [
              118.546,
              -198.349,
              8291.568
            ],
            [
              119.866,
              -267.394,
              8360.626
            ],
            [
              118.552,
              -304.106,
              8397.362
            ],
            [
              124.949,
              -377.696,
              8471.229
            ],
            [
              130.203,
              -407.85,
              8501.837
            ],
            [
              150.182,
              -443.837,
              8542.999
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 157.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 756.839,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 1356.55,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7896",
              "position": {
                "x": -2601.622,
                "z": -4511.165
              },
              "distanceAlongShapeM": 2328.63,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5450",
              "position": {
                "x": -2366.341,
                "z": -3921.977
              },
              "distanceAlongShapeM": 2964.773,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5451",
              "position": {
                "x": -2289.819,
                "z": -3676.197
              },
              "distanceAlongShapeM": 3223.051,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5452",
              "position": {
                "x": -2044.086,
                "z": -2974.773
              },
              "distanceAlongShapeM": 3966.479,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 4687.993,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 5908.465,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 6530.675,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 7338.345,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 7892.272,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 8542.999,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            18240,
            19680,
            20640,
            21720,
            22560,
            23580,
            24480,
            25500,
            26340,
            27360,
            28260,
            29400,
            30240,
            31260,
            32220,
            34020,
            35940,
            37740,
            39540,
            40860,
            42120,
            43440,
            44760,
            46080,
            47400,
            48720,
            50040,
            51360,
            52560,
            53820,
            55140,
            56340,
            57420,
            58440,
            59640,
            60840,
            61980,
            63000,
            64080,
            65160,
            66180,
            67080,
            69120,
            71220,
            73560,
            74820,
            75960,
            77160,
            78360,
            79560,
            80760,
            81960,
            83160
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_3G-A:1",
          "sourceRouteId": "vilnius_expressbus_3G-A",
          "sourceShapeId": "vilnius_expressbus_3G-A_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės (Apylanka P. Žadeikos g.)",
          "directionName": "Žaliasis tiltas–Fabijoniškės (Apylanka P. Žadeikos g.)",
          "mode": "bus",
          "routeShortName": "3G-A",
          "routeLongName": "Fabijoniškės–Žaliasis tiltas (Apylanka P. Žadeikos g.)",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              150.182,
              -443.837,
              0
            ],
            [
              177.186,
              -518.917,
              79.788
            ],
            [
              187.997,
              -562.53,
              124.721
            ],
            [
              214.213,
              -645.388,
              211.628
            ],
            [
              224.323,
              -656.705,
              226.803
            ],
            [
              237.149,
              -695.903,
              268.046
            ],
            [
              236.925,
              -708.144,
              280.289
            ],
            [
              229.693,
              -715.805,
              290.825
            ],
            [
              23.734,
              -765.484,
              502.69
            ],
            [
              -53.078,
              -805.275,
              589.197
            ],
            [
              -306.711,
              -924.235,
              869.342
            ],
            [
              -475.993,
              -1014.678,
              1061.27
            ],
            [
              -535.776,
              -1040.314,
              1126.318
            ],
            [
              -673.187,
              -1080.133,
              1269.382
            ],
            [
              -763.423,
              -1114.127,
              1365.808
            ],
            [
              -822.801,
              -1117.509,
              1425.283
            ],
            [
              -837.686,
              -1120.58,
              1440.482
            ],
            [
              -857.223,
              -1131.36,
              1462.795
            ],
            [
              -899.68,
              -1161.766,
              1515.017
            ],
            [
              -917.464,
              -1182.597,
              1542.406
            ],
            [
              -926.283,
              -1206.929,
              1568.288
            ],
            [
              -917.431,
              -1323.977,
              1685.67
            ],
            [
              -911.942,
              -1448.758,
              1810.571
            ],
            [
              -922.391,
              -1491.986,
              1855.044
            ],
            [
              -939.829,
              -1529.521,
              1896.433
            ],
            [
              -961.618,
              -1558.073,
              1932.349
            ],
            [
              -995.732,
              -1590.856,
              1979.661
            ],
            [
              -1026.383,
              -1610.342,
              2015.982
            ],
            [
              -1072.441,
              -1626.213,
              2064.698
            ],
            [
              -1262.636,
              -1662.874,
              2258.394
            ],
            [
              -1320.472,
              -1688.554,
              2321.675
            ],
            [
              -1370.209,
              -1729.965,
              2386.395
            ],
            [
              -1651.924,
              -2199.162,
              2933.669
            ],
            [
              -1682.619,
              -2257.615,
              2999.691
            ],
            [
              -1702.963,
              -2314.026,
              3059.659
            ],
            [
              -1711.936,
              -2347.263,
              3094.085
            ],
            [
              -1753.781,
              -2416.65,
              3175.114
            ],
            [
              -1791.442,
              -2468.3,
              3239.036
            ],
            [
              -1838.817,
              -2558.74,
              3341.133
            ],
            [
              -1870.389,
              -2630.537,
              3419.566
            ],
            [
              -1871.271,
              -2643.88,
              3432.938
            ],
            [
              -1912.507,
              -2715.506,
              3515.585
            ],
            [
              -1995.657,
              -2933.332,
              3748.742
            ],
            [
              -2020.861,
              -3009.696,
              3829.158
            ],
            [
              -2025.964,
              -3043.002,
              3862.853
            ],
            [
              -2242.142,
              -3640.305,
              4498.072
            ],
            [
              -2268.114,
              -3687.714,
              4552.128
            ],
            [
              -2346.255,
              -3915.653,
              4793.09
            ],
            [
              -2360.668,
              -3965.493,
              4844.972
            ],
            [
              -2466.817,
              -4247.487,
              5146.283
            ],
            [
              -2538.941,
              -4427.667,
              5340.362
            ],
            [
              -2556.572,
              -4477.451,
              5393.176
            ],
            [
              -2571.739,
              -4497.221,
              5418.093
            ],
            [
              -2635.224,
              -4626.347,
              5561.982
            ],
            [
              -2636.28,
              -4649.706,
              5585.365
            ],
            [
              -2631.949,
              -4659.802,
              5596.35
            ],
            [
              -2592.254,
              -4673.861,
              5638.461
            ],
            [
              -2567.235,
              -4679.869,
              5664.192
            ],
            [
              -2548.031,
              -4686.888,
              5684.637
            ],
            [
              -2515.304,
              -4694.145,
              5718.16
            ],
            [
              -2465.325,
              -4709.501,
              5770.445
            ],
            [
              -2409.103,
              -4736.1,
              5832.642
            ],
            [
              -2349.957,
              -4779.45,
              5905.973
            ],
            [
              -2306.893,
              -4821.402,
              5966.093
            ],
            [
              -2284.806,
              -4847.398,
              6000.205
            ],
            [
              -2241.672,
              -4921.636,
              6086.064
            ],
            [
              -2236.559,
              -4923.953,
              6091.678
            ],
            [
              -2217.405,
              -4969.935,
              6141.49
            ],
            [
              -2110.315,
              -5178.897,
              6376.294
            ],
            [
              -2127.276,
              -5190.841,
              6397.039
            ],
            [
              -2143.028,
              -5207.26,
              6419.791
            ],
            [
              -2175.503,
              -5222.268,
              6455.567
            ],
            [
              -2204.955,
              -5248.463,
              6494.982
            ],
            [
              -2230.543,
              -5274.726,
              6531.65
            ],
            [
              -2512.326,
              -5691.648,
              7034.865
            ],
            [
              -2513.285,
              -5709.442,
              7052.685
            ],
            [
              -2528.468,
              -5730.325,
              7078.505
            ],
            [
              -2529.407,
              -5747.007,
              7095.213
            ],
            [
              -2525.623,
              -5751.527,
              7101.108
            ],
            [
              -2510.288,
              -5758.477,
              7117.945
            ],
            [
              -2498.658,
              -5756.456,
              7129.748
            ],
            [
              -2480.761,
              -5727.829,
              7163.509
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 589.197,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 1365.808,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 3094.085,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:986",
              "position": {
                "x": -2025.964,
                "z": -3043.002
              },
              "distanceAlongShapeM": 3862.853,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:4388",
              "position": {
                "x": -2242.142,
                "z": -3640.305
              },
              "distanceAlongShapeM": 4498.072,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:823",
              "position": {
                "x": -2360.668,
                "z": -3965.493
              },
              "distanceAlongShapeM": 4844.972,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7897",
              "position": {
                "x": -2556.572,
                "z": -4477.451
              },
              "distanceAlongShapeM": 5393.176,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 6091.678,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 6419.791,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 7052.685,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            }
          ],
          "departuresSeconds": [
            19800,
            21240,
            22260,
            23340,
            24180,
            25140,
            26040,
            27060,
            27960,
            29040,
            29940,
            31140,
            32040,
            33060,
            34020,
            35700,
            37620,
            39480,
            41220,
            42540,
            43800,
            45120,
            46440,
            47760,
            49080,
            50340,
            51660,
            53100,
            54300,
            55560,
            56880,
            58140,
            59220,
            60300,
            61500,
            62700,
            63840,
            64860,
            65880,
            66960,
            67980,
            68880,
            70920,
            72900,
            75180,
            76440,
            77580,
            78780,
            79920,
            81120,
            82260,
            83460,
            84660
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_4",
      "sourceRouteId": "vilnius_bus_4",
      "mode": "bus",
      "shortName": "4",
      "longName": "Stotis–Rodūnios kelias–Kirtimai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_4:0",
          "sourceRouteId": "vilnius_bus_4",
          "sourceShapeId": "vilnius_bus_4_a-b",
          "directionId": 0,
          "headsign": "Kirtimai",
          "directionName": "Stotis–Rodūnios kelias–Kirtimai",
          "mode": "bus",
          "routeShortName": "4",
          "routeLongName": "Stotis–Rodūnios kelias–Kirtimai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              365.148,
              1967.953,
              0
            ],
            [
              359.628,
              1983.639,
              16.629
            ],
            [
              363.117,
              1998.047,
              31.454
            ],
            [
              375.555,
              2007.839,
              47.284
            ],
            [
              384.565,
              2006.561,
              56.383
            ],
            [
              450.348,
              1969.735,
              131.773
            ],
            [
              464.314,
              1957.234,
              150.516
            ],
            [
              465.359,
              1943.856,
              163.935
            ],
            [
              460.037,
              1935.047,
              174.227
            ],
            [
              448.99,
              1930.796,
              186.063
            ],
            [
              427.686,
              1930.073,
              207.38
            ],
            [
              403.862,
              1932.735,
              231.352
            ],
            [
              390.012,
              1916.29,
              252.852
            ],
            [
              339.428,
              1831.495,
              351.589
            ],
            [
              318.606,
              1821.856,
              374.533
            ],
            [
              29.934,
              1735.835,
              675.75
            ],
            [
              -11.424,
              1732.135,
              717.273
            ],
            [
              -46.755,
              1740.57,
              753.597
            ],
            [
              -320.217,
              1781.157,
              1030.054
            ],
            [
              -515.259,
              1841.463,
              1234.207
            ],
            [
              -520.923,
              1849.358,
              1243.923
            ],
            [
              -526.486,
              1862.817,
              1258.487
            ],
            [
              -511.654,
              1933.795,
              1330.998
            ],
            [
              -496.901,
              1964.699,
              1365.243
            ],
            [
              -462.075,
              2106.562,
              1511.318
            ],
            [
              -436.719,
              2188.482,
              1597.072
            ],
            [
              -427.991,
              2207.248,
              1617.769
            ],
            [
              -344.32,
              2338.207,
              1773.176
            ],
            [
              -326.137,
              2380.181,
              1818.918
            ],
            [
              -285.296,
              2533.066,
              1977.164
            ],
            [
              -290.153,
              2585.475,
              2029.798
            ],
            [
              -278.622,
              2616.436,
              2062.837
            ],
            [
              -251.706,
              2819.669,
              2267.844
            ],
            [
              -239.003,
              2950.799,
              2399.588
            ],
            [
              -239.164,
              2977.519,
              2426.309
            ],
            [
              -244.788,
              3023.264,
              2472.398
            ],
            [
              -255.513,
              3072.44,
              2522.73
            ],
            [
              -253.335,
              3121.382,
              2571.721
            ],
            [
              -378.969,
              3774.894,
              3237.2
            ],
            [
              -384.152,
              3809.498,
              3272.189
            ],
            [
              -385.02,
              3832.891,
              3295.599
            ],
            [
              -382.299,
              3876.258,
              3339.051
            ],
            [
              -328.221,
              4117.961,
              3586.73
            ],
            [
              -328.523,
              4136.892,
              3605.663
            ],
            [
              -271.052,
              4387.439,
              3862.717
            ],
            [
              -232.492,
              4591.573,
              4070.461
            ],
            [
              -199.233,
              4859.257,
              4340.203
            ],
            [
              -145.658,
              5250.139,
              4734.74
            ],
            [
              -103.917,
              5593.368,
              5080.497
            ],
            [
              -105.288,
              5624.563,
              5111.722
            ],
            [
              -114.143,
              5670.365,
              5158.373
            ],
            [
              -126.648,
              5764.103,
              5252.941
            ],
            [
              -188.014,
              6119.22,
              5613.321
            ],
            [
              -197.879,
              6145.003,
              5640.927
            ],
            [
              -199.413,
              6202.918,
              5698.862
            ],
            [
              -253.467,
              6534.523,
              6034.845
            ],
            [
              -260.307,
              6549.119,
              6050.964
            ],
            [
              -273.2,
              6550.466,
              6063.926
            ],
            [
              -282.178,
              6553.968,
              6073.564
            ],
            [
              -285.286,
              6560.704,
              6080.982
            ],
            [
              -283.248,
              6566.233,
              6086.874
            ],
            [
              -276.691,
              6571.68,
              6095.399
            ],
            [
              -272.151,
              6572.711,
              6100.054
            ],
            [
              -259.339,
              6566.913,
              6114.117
            ],
            [
              -256.918,
              6557.964,
              6123.389
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8262",
              "position": {
                "x": 365.148,
                "z": 1967.953
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 717.273,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 1330.998,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 2029.798,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 2522.73,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5180",
              "position": {
                "x": -328.523,
                "z": 4136.892
              },
              "distanceAlongShapeM": 3605.663,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5182",
              "position": {
                "x": -232.492,
                "z": 4591.573
              },
              "distanceAlongShapeM": 4070.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:8240",
              "position": {
                "x": -199.233,
                "z": 4859.257
              },
              "distanceAlongShapeM": 4340.203,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5193",
              "position": {
                "x": -114.143,
                "z": 5670.365
              },
              "distanceAlongShapeM": 5158.373,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5194",
              "position": {
                "x": -197.879,
                "z": 6145.003
              },
              "distanceAlongShapeM": 5640.927,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:690",
              "position": {
                "x": -256.918,
                "z": 6557.964
              },
              "distanceAlongShapeM": 6123.389,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            }
          ],
          "departuresSeconds": [
            19800,
            21300,
            22680,
            24480,
            26100,
            27900,
            29640,
            36000,
            39180,
            42060,
            45420,
            48900,
            52560,
            56100,
            59820,
            64020,
            70380,
            73200,
            75960,
            78720,
            81480
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_4:1",
          "sourceRouteId": "vilnius_bus_4",
          "sourceShapeId": "vilnius_bus_4_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Kirtimai–Rodūnios kelias–Stotis",
          "mode": "bus",
          "routeShortName": "4",
          "routeLongName": "Stotis–Rodūnios kelias–Kirtimai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -256.918,
              6557.964,
              0
            ],
            [
              -213.092,
              6303.356,
              258.352
            ],
            [
              -202.621,
              6275.335,
              288.265
            ],
            [
              -203.65,
              6254.203,
              309.423
            ],
            [
              -199.413,
              6202.918,
              360.882
            ],
            [
              -142.241,
              5865.689,
              702.923
            ],
            [
              -125.115,
              5777.434,
              792.825
            ],
            [
              -116.078,
              5741.647,
              829.735
            ],
            [
              -114.707,
              5710.452,
              860.96
            ],
            [
              -99.68,
              5613.329,
              959.239
            ],
            [
              -109.103,
              5521.102,
              1051.945
            ],
            [
              -145.658,
              5250.139,
              1325.363
            ],
            [
              -167.989,
              5051.278,
              1525.474
            ],
            [
              -168.292,
              4998.962,
              1577.791
            ],
            [
              -175.836,
              4974.608,
              1603.287
            ],
            [
              -229.992,
              4551.452,
              2029.894
            ],
            [
              -236.808,
              4531.537,
              2050.943
            ],
            [
              -291.097,
              4278.706,
              2309.537
            ],
            [
              -315.819,
              4161.153,
              2429.662
            ],
            [
              -323.098,
              4115.642,
              2475.751
            ],
            [
              -345.945,
              4030.338,
              2564.062
            ],
            [
              -367.116,
              3930.531,
              2666.089
            ],
            [
              -376.774,
              3896.196,
              2701.757
            ],
            [
              -379.958,
              3791.61,
              2806.391
            ],
            [
              -316.278,
              3458.717,
              3145.32
            ],
            [
              -225.435,
              2951.666,
              3660.444
            ],
            [
              -266.588,
              2603.973,
              4010.565
            ],
            [
              -287.151,
              2501.929,
              4114.66
            ],
            [
              -327.226,
              2355.709,
              4266.272
            ],
            [
              -350.367,
              2324.958,
              4304.757
            ],
            [
              -412.128,
              2228.113,
              4419.62
            ],
            [
              -425.492,
              2202.75,
              4448.288
            ],
            [
              -439.803,
              2160.707,
              4492.7
            ],
            [
              -445.668,
              2121.85,
              4531.997
            ],
            [
              -471.768,
              2034.377,
              4623.281
            ],
            [
              -499.661,
              1919.106,
              4741.879
            ],
            [
              -508.548,
              1855.813,
              4805.793
            ],
            [
              -490.609,
              1848.809,
              4825.05
            ],
            [
              -470.051,
              1843.985,
              4846.167
            ],
            [
              -432.32,
              1825.49,
              4888.187
            ],
            [
              -327.19,
              1787.963,
              4999.813
            ],
            [
              -259.046,
              1774.482,
              5069.278
            ],
            [
              -147.106,
              1756.865,
              5182.596
            ],
            [
              9.981,
              1738.424,
              5340.761
            ],
            [
              41.02,
              1742.312,
              5372.043
            ],
            [
              63.816,
              1754.143,
              5397.726
            ],
            [
              135.751,
              1771.757,
              5471.787
            ],
            [
              319.251,
              1821.845,
              5662
            ],
            [
              341.2,
              1822.557,
              5683.96
            ],
            [
              378.73,
              1828.551,
              5721.966
            ],
            [
              526.755,
              1843.654,
              5870.759
            ],
            [
              583.03,
              1851.529,
              5927.583
            ],
            [
              594.24,
              1864.683,
              5944.865
            ],
            [
              593.052,
              1870.271,
              5950.577
            ],
            [
              545.045,
              1891.188,
              6002.943
            ],
            [
              472.814,
              1928.134,
              6084.075
            ],
            [
              457.253,
              1923.966,
              6100.184
            ],
            [
              443.063,
              1924.225,
              6114.376
            ],
            [
              417.95,
              1926.911,
              6139.633
            ],
            [
              405.756,
              1930.474,
              6152.337
            ],
            [
              392.999,
              1938.5,
              6167.408
            ],
            [
              365.148,
              1967.953,
              6207.944
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:690",
              "position": {
                "x": -256.918,
                "z": 6557.964
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:493",
              "position": {
                "x": -202.621,
                "z": 6275.335
              },
              "distanceAlongShapeM": 288.265,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:588",
              "position": {
                "x": -116.078,
                "z": 5741.647
              },
              "distanceAlongShapeM": 829.735,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5184",
              "position": {
                "x": -168.292,
                "z": 4998.962
              },
              "distanceAlongShapeM": 1577.791,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:410",
              "position": {
                "x": -229.992,
                "z": 4551.452
              },
              "distanceAlongShapeM": 2029.894,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5181",
              "position": {
                "x": -323.098,
                "z": 4115.642
              },
              "distanceAlongShapeM": 2475.751,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 3660.444,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 4010.565,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 4846.167,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 5397.726,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:16581",
              "position": {
                "x": 378.73,
                "z": 1828.551
              },
              "distanceAlongShapeM": 5721.966,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            }
          ],
          "departuresSeconds": [
            21180,
            22680,
            24420,
            26220,
            27900,
            29700,
            31500,
            37500,
            40680,
            43980,
            47400,
            50700,
            54540,
            57900,
            61680,
            65700,
            71820,
            74580,
            77340,
            80040,
            82860
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_4G",
      "sourceRouteId": "vilnius_expressbus_4G",
      "mode": "bus",
      "shortName": "4G",
      "longName": "Pilaitė–Konstitucijos pr.–Saulėtekis",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_4G:0",
          "sourceRouteId": "vilnius_expressbus_4G",
          "sourceShapeId": "vilnius_expressbus_4G_a-b",
          "directionId": 0,
          "headsign": "Saulėtekis",
          "directionName": "Pilaitė–Konstitucijos pr.–Saulėtekis",
          "mode": "bus",
          "routeShortName": "4G",
          "routeLongName": "Pilaitė–Konstitucijos pr.–Saulėtekis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6804.479,
              -1529.023,
              0
            ],
            [
              -6810.019,
              -1513.345,
              16.627
            ],
            [
              -6803.426,
              -1504.55,
              27.62
            ],
            [
              -6797.569,
              -1501.308,
              34.313
            ],
            [
              -6795.561,
              -1496.889,
              39.167
            ],
            [
              -6804.801,
              -1471.131,
              66.532
            ],
            [
              -6817.871,
              -1443.083,
              97.476
            ],
            [
              -6849.755,
              -1383.551,
              165.008
            ],
            [
              -6863.711,
              -1369.96,
              184.489
            ],
            [
              -6868.44,
              -1344.278,
              210.603
            ],
            [
              -6866.432,
              -1339.858,
              215.457
            ],
            [
              -6856.69,
              -1335.568,
              226.102
            ],
            [
              -6848.367,
              -1339.047,
              235.122
            ],
            [
              -6837.763,
              -1360.375,
              258.94
            ],
            [
              -6823.318,
              -1421.841,
              322.082
            ],
            [
              -6723.821,
              -1601.615,
              527.553
            ],
            [
              -6711.23,
              -1619.637,
              549.537
            ],
            [
              -6684.251,
              -1702.465,
              636.648
            ],
            [
              -6676.395,
              -1733.766,
              668.92
            ],
            [
              -6677.514,
              -1993.121,
              928.277
            ],
            [
              -6624.485,
              -1982.877,
              982.286
            ],
            [
              -6584.624,
              -1989.111,
              1022.631
            ],
            [
              -6371.248,
              -1988.24,
              1236.01
            ],
            [
              -6349.244,
              -1983.044,
              1258.619
            ],
            [
              -6316.453,
              -1988.048,
              1291.789
            ],
            [
              -6227.58,
              -1992.883,
              1380.794
            ],
            [
              -5930.998,
              -1988.982,
              1677.402
            ],
            [
              -5852.356,
              -2027.048,
              1764.772
            ],
            [
              -5732.243,
              -2090.308,
              1900.525
            ],
            [
              -5670.572,
              -2064.637,
              1967.326
            ],
            [
              -5318.875,
              -1890.278,
              2359.871
            ],
            [
              -5264.212,
              -1860.04,
              2422.341
            ],
            [
              -5225.223,
              -1841.781,
              2465.393
            ],
            [
              -5160.018,
              -1798.366,
              2543.729
            ],
            [
              -5102.28,
              -1739.239,
              2626.371
            ],
            [
              -5012.864,
              -1637.24,
              2762.014
            ],
            [
              -4831.761,
              -1414.361,
              3049.195
            ],
            [
              -4761.883,
              -1362.126,
              3136.439
            ],
            [
              -4704.97,
              -1314.122,
              3210.894
            ],
            [
              -4653.804,
              -1300.53,
              3263.834
            ],
            [
              -4405.208,
              -1203.507,
              3530.692
            ],
            [
              -4296.995,
              -1171.977,
              3643.405
            ],
            [
              -4247.02,
              -1152.802,
              3696.933
            ],
            [
              -4191.003,
              -1157.11,
              3753.115
            ],
            [
              -3912.099,
              -1135.223,
              4032.877
            ],
            [
              -3759.013,
              -1118.956,
              4186.824
            ],
            [
              -3705.284,
              -1106.532,
              4241.971
            ],
            [
              -3657.704,
              -1114.039,
              4290.14
            ],
            [
              -3599.031,
              -1113.947,
              4348.813
            ],
            [
              -3412.497,
              -1176.2,
              4545.46
            ],
            [
              -3355.367,
              -1190.556,
              4604.367
            ],
            [
              -3108.49,
              -1230.499,
              4854.454
            ],
            [
              -3070.013,
              -1242.306,
              4894.702
            ],
            [
              -2879.155,
              -1277.94,
              5088.857
            ],
            [
              -2839.273,
              -1283.094,
              5129.071
            ],
            [
              -2787.087,
              -1285.125,
              5181.297
            ],
            [
              -2748.376,
              -1283.58,
              5220.039
            ],
            [
              -2714.118,
              -1278.617,
              5254.654
            ],
            [
              -2670.7,
              -1266.023,
              5299.862
            ],
            [
              -2624.585,
              -1246.798,
              5349.823
            ],
            [
              -2500.301,
              -1182.198,
              5489.894
            ],
            [
              -2469.831,
              -1172.717,
              5521.805
            ],
            [
              -2418.716,
              -1162.489,
              5573.933
            ],
            [
              -2392.231,
              -1159.617,
              5600.574
            ],
            [
              -2151.528,
              -1183.918,
              5842.5
            ],
            [
              -2126.509,
              -1191.041,
              5868.513
            ],
            [
              -2118.854,
              -1195.63,
              5877.438
            ],
            [
              -1988.935,
              -1213.522,
              6008.584
            ],
            [
              -1948.388,
              -1217.583,
              6049.333
            ],
            [
              -1866.572,
              -1221.265,
              6131.232
            ],
            [
              -1794.345,
              -1220.324,
              6203.465
            ],
            [
              -1681.879,
              -1204.518,
              6317.037
            ],
            [
              -1544.075,
              -1178.035,
              6457.362
            ],
            [
              -1436.465,
              -1145.449,
              6569.798
            ],
            [
              -1393.22,
              -1142.883,
              6613.118
            ],
            [
              -1155.149,
              -1098.17,
              6855.352
            ],
            [
              -1103.929,
              -1082.392,
              6908.947
            ],
            [
              -1083.324,
              -1083.875,
              6929.606
            ],
            [
              -1022.536,
              -1073.836,
              6991.218
            ],
            [
              -998.991,
              -1055.334,
              7021.162
            ],
            [
              -969.041,
              -1039.175,
              7055.193
            ],
            [
              -947.066,
              -1036.231,
              7077.364
            ],
            [
              -930.307,
              -1036.533,
              7094.126
            ],
            [
              -906.579,
              -1043.639,
              7118.896
            ],
            [
              -895.802,
              -1053.852,
              7133.743
            ],
            [
              -890.221,
              -1066.198,
              7147.292
            ],
            [
              -876.342,
              -1083.147,
              7169.198
            ],
            [
              -864.236,
              -1091.158,
              7183.715
            ],
            [
              -845.624,
              -1095.946,
              7202.933
            ],
            [
              -813.336,
              -1093.188,
              7235.338
            ],
            [
              -786.145,
              -1086.999,
              7263.225
            ],
            [
              -775.751,
              -1082.734,
              7274.46
            ],
            [
              -717.641,
              -1078.217,
              7332.745
            ],
            [
              -647.083,
              -1062.792,
              7404.969
            ],
            [
              -599.769,
              -1049.176,
              7454.204
            ],
            [
              -511.525,
              -1018.488,
              7547.632
            ],
            [
              -361.843,
              -942.16,
              7715.652
            ],
            [
              -333.702,
              -919.293,
              7751.912
            ],
            [
              -286.889,
              -897.877,
              7803.391
            ],
            [
              -196.966,
              -846.075,
              7907.168
            ],
            [
              -115.583,
              -803.025,
              7999.236
            ],
            [
              -96.647,
              -790.01,
              8022.213
            ],
            [
              -42.035,
              -765.399,
              8082.114
            ],
            [
              224.8,
              -701.243,
              8356.554
            ],
            [
              237.149,
              -695.903,
              8370.008
            ],
            [
              292.85,
              -682.448,
              8427.311
            ],
            [
              331.506,
              -684.268,
              8466.01
            ],
            [
              436.802,
              -673.948,
              8571.81
            ],
            [
              647.48,
              -719,
              8787.251
            ],
            [
              692.52,
              -724.28,
              8832.6
            ],
            [
              729.304,
              -722.729,
              8869.416
            ],
            [
              752.305,
              -734.284,
              8895.157
            ],
            [
              1031.058,
              -793.963,
              9180.227
            ],
            [
              1157.03,
              -816.326,
              9308.168
            ],
            [
              1200.176,
              -819.349,
              9351.42
            ],
            [
              1220.015,
              -827.509,
              9372.871
            ],
            [
              1248.96,
              -831.383,
              9402.074
            ],
            [
              1325.104,
              -828.339,
              9478.279
            ],
            [
              1339.141,
              -836.391,
              9494.462
            ],
            [
              1354.364,
              -850.032,
              9514.902
            ],
            [
              1360.583,
              -862.393,
              9528.74
            ],
            [
              1367.85,
              -922.642,
              9589.426
            ],
            [
              1384.491,
              -964.14,
              9634.136
            ],
            [
              1464.439,
              -1103.664,
              9794.942
            ],
            [
              1480.223,
              -1121.768,
              9818.96
            ],
            [
              1488.813,
              -1145.306,
              9844.016
            ],
            [
              1537.374,
              -1238.606,
              9949.198
            ],
            [
              1587.871,
              -1366.453,
              10086.656
            ],
            [
              1626.598,
              -1502.988,
              10228.577
            ],
            [
              1647.564,
              -1589.097,
              10317.202
            ],
            [
              1670.179,
              -1759.844,
              10489.44
            ],
            [
              1676.751,
              -1787.797,
              10518.156
            ],
            [
              1672.408,
              -1813.321,
              10544.046
            ],
            [
              1676.994,
              -1948.109,
              10678.912
            ],
            [
              1724.765,
              -1944.545,
              10726.816
            ],
            [
              1955.555,
              -1909.879,
              10960.194
            ],
            [
              1982.08,
              -1904.808,
              10987.201
            ],
            [
              2058.602,
              -1880.631,
              11067.451
            ],
            [
              2066.336,
              -1880.775,
              11075.186
            ],
            [
              2070.784,
              -1884.198,
              11080.799
            ],
            [
              2087.852,
              -1936.84,
              11136.138
            ],
            [
              2087.374,
              -1962.435,
              11161.738
            ],
            [
              2110.719,
              -2024.1,
              11227.674
            ],
            [
              2234.812,
              -2316.979,
              11545.758
            ],
            [
              2284.924,
              -2429.242,
              11668.698
            ],
            [
              2299.015,
              -2468.47,
              11710.379
            ],
            [
              2319.691,
              -2569.05,
              11813.063
            ],
            [
              2327.089,
              -2587.001,
              11832.478
            ],
            [
              2323.492,
              -2606.972,
              11852.771
            ],
            [
              2328.687,
              -2639.354,
              11885.566
            ],
            [
              2411.872,
              -3118.499,
              12371.879
            ],
            [
              2419.872,
              -3138.687,
              12393.595
            ],
            [
              2418.768,
              -3163.158,
              12418.09
            ],
            [
              2474.472,
              -3526.012,
              12785.194
            ],
            [
              2513.109,
              -3664.781,
              12929.242
            ],
            [
              2522.438,
              -3682.768,
              12949.504
            ],
            [
              2522.312,
              -3689.445,
              12956.183
            ],
            [
              2535.711,
              -3730.887,
              12999.737
            ],
            [
              2556.818,
              -3773.588,
              13047.369
            ],
            [
              2598.204,
              -3834.482,
              13120.996
            ],
            [
              2619.624,
              -3860.489,
              13154.689
            ],
            [
              2636.723,
              -3876.397,
              13178.043
            ],
            [
              2642.893,
              -3890.985,
              13193.883
            ],
            [
              2709.56,
              -3977.961,
              13303.469
            ],
            [
              3021.059,
              -4338.966,
              13780.289
            ],
            [
              3086.352,
              -4293.444,
              13859.885
            ],
            [
              3111.27,
              -4270.537,
              13893.732
            ],
            [
              3142.482,
              -4255.542,
              13928.359
            ],
            [
              3336.938,
              -4126.748,
              14161.599
            ],
            [
              3389.682,
              -4097.691,
              14221.818
            ],
            [
              3402.776,
              -4086.807,
              14238.845
            ],
            [
              3446.229,
              -4072.046,
              14284.736
            ],
            [
              3528.69,
              -4039.102,
              14373.534
            ],
            [
              3592.048,
              -4028.061,
              14437.847
            ],
            [
              3640.634,
              -4014.513,
              14488.287
            ],
            [
              3666.294,
              -4020.567,
              14514.651
            ],
            [
              3848.026,
              -4019.578,
              14696.387
            ],
            [
              3878.881,
              -4023.507,
              14727.491
            ],
            [
              3901.964,
              -4029.514,
              14751.342
            ],
            [
              3958.181,
              -4055.079,
              14813.099
            ],
            [
              3967.843,
              -4055.264,
              14822.763
            ],
            [
              4018.762,
              -4121.92,
              14906.643
            ],
            [
              4037.773,
              -4172.381,
              14960.566
            ],
            [
              4032.364,
              -4185.636,
              14974.882
            ],
            [
              4021.265,
              -4193.217,
              14988.323
            ],
            [
              4012.248,
              -4193.045,
              14997.342
            ],
            [
              3999.472,
              -4187.234,
              15011.378
            ],
            [
              3957.337,
              -4132.992,
              15080.062
            ],
            [
              3954.003,
              -4105.097,
              15108.156
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 258.94,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 549.537,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6611",
              "position": {
                "x": -6624.485,
                "z": -1982.877
              },
              "distanceAlongShapeM": 982.286,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6615",
              "position": {
                "x": -6349.244,
                "z": -1983.044
              },
              "distanceAlongShapeM": 1258.619,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9561",
              "position": {
                "x": -5852.356,
                "z": -2027.048
              },
              "distanceAlongShapeM": 1764.772,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 3210.894,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 3696.933,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7342",
              "position": {
                "x": -3705.284,
                "z": -1106.532
              },
              "distanceAlongShapeM": 4241.971,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 4854.454,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 6908.947,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 7274.46,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 8082.114,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 8427.311,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 9818.96,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 10518.156,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 11136.138,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 11832.478,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 13178.043,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 13893.732,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 14238.845,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 14488.287,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 14822.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            17940,
            18600,
            19200,
            19800,
            20400,
            21000,
            21480,
            21900,
            22320,
            22740,
            23100,
            23520,
            23940,
            24300,
            24660,
            25020,
            25380,
            25740,
            26100,
            26520,
            27000,
            27480,
            27900,
            28380,
            28860,
            29340,
            29760,
            30180,
            30660,
            31140,
            31620,
            32100,
            32580,
            33180,
            33780,
            34320,
            34860,
            35400,
            35880,
            36360,
            36840,
            37320,
            37980,
            38580,
            39120,
            39660,
            40260,
            40920,
            41640,
            42360,
            43140,
            43920,
            44700,
            45480,
            46200,
            46920,
            47640,
            48360,
            49080,
            49680,
            50340,
            51000,
            51720,
            52200,
            52680,
            53100,
            53520,
            53880,
            54240,
            54600,
            55080,
            55440,
            55800,
            56160,
            56520,
            56880,
            57240,
            57600,
            58080,
            58560,
            59040,
            59520,
            59880,
            60240,
            60600,
            60960,
            61380,
            61800,
            62280,
            62820,
            63300,
            63720,
            64140,
            64560,
            65040,
            65460,
            65880,
            66360,
            66840,
            67380,
            67920,
            68520,
            69300,
            70680,
            71700,
            72780,
            73680,
            74580,
            75360,
            76020,
            76680,
            77340,
            77880,
            78360,
            78960,
            79500,
            80100,
            80700,
            81360,
            82020,
            82740,
            83460,
            84180,
            84840,
            85620,
            86340
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_4G:1",
          "sourceRouteId": "vilnius_expressbus_4G",
          "sourceShapeId": "vilnius_expressbus_4G_b-a",
          "directionId": 1,
          "headsign": "Pilaitė",
          "directionName": "Saulėtekis–Konstitucijos pr.–Pilaitė",
          "mode": "bus",
          "routeShortName": "4G",
          "routeLongName": "Pilaitė–Konstitucijos pr.–Saulėtekis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3954.003,
              -4105.097,
              0
            ],
            [
              3949.042,
              -4094.982,
              11.266
            ],
            [
              3942.445,
              -4069.251,
              37.829
            ],
            [
              3936.216,
              -4058,
              50.69
            ],
            [
              3917.749,
              -4046.514,
              72.437
            ],
            [
              3898.552,
              -4039.468,
              92.886
            ],
            [
              3898.616,
              -4036.13,
              96.225
            ],
            [
              3858.828,
              -4027.577,
              136.922
            ],
            [
              3592.048,
              -4028.061,
              403.703
            ],
            [
              3581.678,
              -4031.203,
              414.538
            ],
            [
              3565.986,
              -4043.151,
              434.261
            ],
            [
              3520.083,
              -4051.184,
              480.861
            ],
            [
              3445.458,
              -4078.711,
              560.402
            ],
            [
              3358.965,
              -4120.486,
              656.455
            ],
            [
              3360.169,
              -4124.962,
              661.09
            ],
            [
              3310.064,
              -4150.73,
              717.432
            ],
            [
              3021.059,
              -4338.966,
              1062.334
            ],
            [
              2959.695,
              -4278.804,
              1148.269
            ],
            [
              2937.404,
              -4265.024,
              1174.476
            ],
            [
              2920.517,
              -4237.987,
              1206.353
            ],
            [
              2810.169,
              -4110.107,
              1375.262
            ],
            [
              2739.116,
              -4050.879,
              1467.763
            ],
            [
              2661.391,
              -4003.772,
              1558.649
            ],
            [
              2636.416,
              -3995.509,
              1584.956
            ],
            [
              2619.338,
              -3978.489,
              1609.067
            ],
            [
              2604.004,
              -3971.521,
              1625.909
            ],
            [
              2505.227,
              -3912.889,
              1740.777
            ],
            [
              2493.26,
              -3898.192,
              1759.73
            ],
            [
              2485.802,
              -3883.579,
              1776.136
            ],
            [
              2479.071,
              -3864.528,
              1796.342
            ],
            [
              2475.189,
              -3831.057,
              1830.037
            ],
            [
              2503.004,
              -3722.48,
              1942.12
            ],
            [
              2508.663,
              -3661.358,
              2003.504
            ],
            [
              2463.001,
              -3519.117,
              2152.894
            ],
            [
              2462.068,
              -3500.174,
              2171.86
            ],
            [
              2434.072,
              -3309.282,
              2364.794
            ],
            [
              2425.512,
              -3284.63,
              2390.89
            ],
            [
              2426.678,
              -3256.82,
              2418.724
            ],
            [
              2373.189,
              -2912.935,
              2766.744
            ],
            [
              2328.687,
              -2639.354,
              3043.921
            ],
            [
              2308.053,
              -2536.548,
              3148.777
            ],
            [
              2296.913,
              -2511.848,
              3175.873
            ],
            [
              2295.002,
              -2476.188,
              3211.584
            ],
            [
              2274.24,
              -2414.57,
              3276.606
            ],
            [
              2234.812,
              -2316.979,
              3381.861
            ],
            [
              2177.257,
              -2188.992,
              3522.194
            ],
            [
              2082.177,
              -1964.565,
              3765.931
            ],
            [
              2062.178,
              -1896.283,
              3837.081
            ],
            [
              2031.037,
              -1906.834,
              3869.961
            ],
            [
              1998.15,
              -1907.334,
              3902.852
            ],
            [
              1855.148,
              -1935.839,
              4048.667
            ],
            [
              1712.252,
              -1958.784,
              4193.393
            ],
            [
              1669.637,
              -1962.445,
              4236.166
            ],
            [
              1663.92,
              -1957.886,
              4243.478
            ],
            [
              1665.702,
              -1896.69,
              4304.699
            ],
            [
              1663.09,
              -1759.712,
              4441.702
            ],
            [
              1653.419,
              -1725.022,
              4477.715
            ],
            [
              1660.464,
              -1692.869,
              4510.631
            ],
            [
              1642.718,
              -1572.308,
              4632.49
            ],
            [
              1626.598,
              -1502.988,
              4703.661
            ],
            [
              1590.763,
              -1384.318,
              4827.623
            ],
            [
              1541.473,
              -1260.946,
              4960.476
            ],
            [
              1439.941,
              -1068.699,
              5177.888
            ],
            [
              1418.417,
              -1047.149,
              5208.346
            ],
            [
              1413.029,
              -1024.784,
              5231.351
            ],
            [
              1381.79,
              -970.77,
              5293.748
            ],
            [
              1372.327,
              -959.462,
              5308.493
            ],
            [
              1333.941,
              -943.166,
              5350.194
            ],
            [
              1307.513,
              -942.677,
              5376.627
            ],
            [
              1293.291,
              -944.641,
              5390.983
            ],
            [
              1278.507,
              -942.141,
              5405.977
            ],
            [
              1268.297,
              -936.386,
              5417.698
            ],
            [
              1257.545,
              -925.054,
              5433.318
            ],
            [
              1253.197,
              -916.068,
              5443.301
            ],
            [
              1249.597,
              -901.529,
              5458.279
            ],
            [
              1250.468,
              -889.3,
              5470.54
            ],
            [
              1243.124,
              -868.013,
              5493.058
            ],
            [
              1234.408,
              -851.153,
              5512.037
            ],
            [
              1218.52,
              -838.613,
              5532.278
            ],
            [
              1192.86,
              -831.46,
              5558.917
            ],
            [
              1154.205,
              -829.633,
              5597.615
            ],
            [
              1120.288,
              -815.648,
              5634.302
            ],
            [
              1031.058,
              -793.963,
              5726.128
            ],
            [
              773.373,
              -745.803,
              5988.276
            ],
            [
              729.54,
              -744.998,
              6032.116
            ],
            [
              702.691,
              -732.259,
              6061.834
            ],
            [
              508.13,
              -687.5,
              6261.477
            ],
            [
              443.852,
              -676.304,
              6326.722
            ],
            [
              405.738,
              -680.059,
              6365.021
            ],
            [
              364.219,
              -693.772,
              6408.746
            ],
            [
              341.718,
              -690.021,
              6431.557
            ],
            [
              238.113,
              -713.732,
              6537.841
            ],
            [
              219.901,
              -722.305,
              6557.97
            ],
            [
              73.653,
              -750.808,
              6706.97
            ],
            [
              -18.428,
              -779.188,
              6803.325
            ],
            [
              -53.078,
              -805.275,
              6846.697
            ],
            [
              -306.711,
              -924.235,
              7126.842
            ],
            [
              -475.993,
              -1014.678,
              7318.771
            ],
            [
              -535.776,
              -1040.314,
              7383.818
            ],
            [
              -673.187,
              -1080.133,
              7526.882
            ],
            [
              -763.423,
              -1114.127,
              7623.308
            ],
            [
              -829.227,
              -1116.28,
              7689.148
            ],
            [
              -865.018,
              -1134.559,
              7729.337
            ],
            [
              -891.825,
              -1155.228,
              7763.187
            ],
            [
              -898.431,
              -1164.015,
              7774.18
            ],
            [
              -907.595,
              -1171.642,
              7786.103
            ],
            [
              -917.363,
              -1177.032,
              7797.259
            ],
            [
              -929.65,
              -1179.038,
              7809.708
            ],
            [
              -961.877,
              -1178.457,
              7841.941
            ],
            [
              -977.306,
              -1175.953,
              7857.571
            ],
            [
              -995.797,
              -1164.488,
              7879.329
            ],
            [
              -1006.474,
              -1148.711,
              7898.379
            ],
            [
              -1029.882,
              -1123.799,
              7932.563
            ],
            [
              -1062.634,
              -1116.531,
              7966.112
            ],
            [
              -1096.995,
              -1127.045,
              8002.045
            ],
            [
              -1143.947,
              -1120.636,
              8049.433
            ],
            [
              -1339.338,
              -1158.32,
              8248.425
            ],
            [
              -1374.402,
              -1172.164,
              8286.123
            ],
            [
              -1791.301,
              -1230.398,
              8707.069
            ],
            [
              -1855.793,
              -1231.475,
              8771.571
            ],
            [
              -1940.187,
              -1227.747,
              8856.047
            ],
            [
              -2027.705,
              -1218.399,
              8944.063
            ],
            [
              -2166.609,
              -1198.122,
              9084.439
            ],
            [
              -2255.397,
              -1187.643,
              9173.843
            ],
            [
              -2267.097,
              -1193.002,
              9186.712
            ],
            [
              -2295.924,
              -1182.472,
              9217.402
            ],
            [
              -2392.506,
              -1175.197,
              9314.258
            ],
            [
              -2431.277,
              -1180.078,
              9353.334
            ],
            [
              -2478.584,
              -1193.714,
              9402.567
            ],
            [
              -2533.196,
              -1219.467,
              9462.947
            ],
            [
              -2617.204,
              -1266.966,
              9559.454
            ],
            [
              -2663.944,
              -1285.067,
              9609.576
            ],
            [
              -2710.565,
              -1296.491,
              9657.576
            ],
            [
              -2762.303,
              -1305.599,
              9710.11
            ],
            [
              -2808.767,
              -1308.121,
              9756.642
            ],
            [
              -2858.317,
              -1302.797,
              9806.477
            ],
            [
              -3071.028,
              -1263.439,
              10022.799
            ],
            [
              -3140.52,
              -1255.542,
              10092.738
            ],
            [
              -3159.719,
              -1247.413,
              10113.588
            ],
            [
              -3359.526,
              -1207.182,
              10317.404
            ],
            [
              -3495.953,
              -1192.555,
              10454.613
            ],
            [
              -3569.469,
              -1193.5,
              10528.135
            ],
            [
              -3626.266,
              -1196.964,
              10585.037
            ],
            [
              -3688.025,
              -1189.21,
              10647.281
            ],
            [
              -3714.785,
              -1170.933,
              10679.688
            ],
            [
              -3768.733,
              -1158.863,
              10734.969
            ],
            [
              -3858.305,
              -1156.194,
              10824.581
            ],
            [
              -4063.615,
              -1172.672,
              11030.551
            ],
            [
              -4237.967,
              -1188.581,
              11205.627
            ],
            [
              -4268.356,
              -1193.623,
              11236.432
            ],
            [
              -4294.993,
              -1205.408,
              11265.56
            ],
            [
              -4333.704,
              -1206.966,
              11304.301
            ],
            [
              -4364.15,
              -1215.347,
              11335.88
            ],
            [
              -4597.068,
              -1300.392,
              11583.838
            ],
            [
              -4637.998,
              -1318.612,
              11628.641
            ],
            [
              -4714.189,
              -1362.945,
              11716.791
            ],
            [
              -4755.992,
              -1394.51,
              11769.173
            ],
            [
              -4809.036,
              -1442.581,
              11840.759
            ],
            [
              -4834.84,
              -1481.101,
              11887.122
            ],
            [
              -5089.015,
              -1792.899,
              12289.395
            ],
            [
              -5145.804,
              -1834.231,
              12359.633
            ],
            [
              -5350.813,
              -1948.734,
              12594.45
            ],
            [
              -5768.874,
              -2159.819,
              13062.779
            ],
            [
              -5758.969,
              -2298.023,
              13201.338
            ],
            [
              -5764.309,
              -2346.913,
              13250.519
            ],
            [
              -5743.082,
              -2349.5,
              13271.902
            ],
            [
              -5699.018,
              -2373.624,
              13322.139
            ],
            [
              -5700.051,
              -1978.421,
              13717.343
            ],
            [
              -5728.848,
              -1889.99,
              13810.345
            ],
            [
              -5825.26,
              -1949.582,
              13923.688
            ],
            [
              -5930.998,
              -1988.982,
              14036.527
            ],
            [
              -6228.224,
              -1992.872,
              14333.78
            ],
            [
              -6278.639,
              -2000.929,
              14384.834
            ],
            [
              -6312.718,
              -1995.903,
              14419.281
            ],
            [
              -6605.358,
              -1995.443,
              14711.922
            ],
            [
              -6631.209,
              -1999.462,
              14738.084
            ],
            [
              -6677.514,
              -1993.121,
              14784.821
            ],
            [
              -6680.925,
              -1734.803,
              15043.161
            ],
            [
              -6684.251,
              -1702.465,
              15075.67
            ],
            [
              -6705.09,
              -1676.513,
              15108.953
            ],
            [
              -6747.127,
              -1568.943,
              15224.445
            ],
            [
              -6771.666,
              -1532.911,
              15268.039
            ],
            [
              -6834.733,
              -1410.519,
              15405.724
            ],
            [
              -6863.711,
              -1369.96,
              15455.572
            ],
            [
              -6868.44,
              -1344.278,
              15481.686
            ],
            [
              -6866.432,
              -1339.858,
              15486.54
            ],
            [
              -6856.69,
              -1335.568,
              15497.184
            ],
            [
              -6848.367,
              -1339.047,
              15506.205
            ],
            [
              -6837.763,
              -1360.375,
              15530.023
            ],
            [
              -6825.084,
              -1411.793,
              15582.982
            ],
            [
              -6801.411,
              -1461.169,
              15637.739
            ],
            [
              -6771.957,
              -1511.755,
              15696.275
            ],
            [
              -6765.128,
              -1527.454,
              15713.395
            ],
            [
              -6769.807,
              -1537.394,
              15724.382
            ],
            [
              -6777.653,
              -1543.942,
              15734.601
            ],
            [
              -6839.38,
              -1572.967,
              15802.812
            ],
            [
              -6855.566,
              -1577.15,
              15819.529
            ],
            [
              -6863.189,
              -1570.343,
              15829.748
            ],
            [
              -6866.907,
              -1561.375,
              15839.456
            ],
            [
              -6864.843,
              -1553.618,
              15847.484
            ],
            [
              -6804.479,
              -1529.023,
              15912.666
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 92.886,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 434.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 661.09,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 1174.476,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 2152.894,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 3175.873,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5091",
              "position": {
                "x": 2031.037,
                "z": -1906.834
              },
              "distanceAlongShapeM": 3869.961,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 4477.715,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 5208.346,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 6408.746,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 6846.697,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 7623.308,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 8002.045,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 10092.738,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 10647.281,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 11265.56,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:8060",
              "position": {
                "x": -4834.84,
                "z": -1481.101
              },
              "distanceAlongShapeM": 11887.122,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:17769",
              "position": {
                "x": -5758.969,
                "z": -2298.023
              },
              "distanceAlongShapeM": 13201.338,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6619",
              "position": {
                "x": -5825.26,
                "z": -1949.582
              },
              "distanceAlongShapeM": 13923.688,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6614",
              "position": {
                "x": -6278.639,
                "z": -2000.929
              },
              "distanceAlongShapeM": 14384.834,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:6612",
              "position": {
                "x": -6631.209,
                "z": -1999.462
              },
              "distanceAlongShapeM": 14738.084,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 15108.953,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 15455.572,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            }
          ],
          "departuresSeconds": [
            19080,
            19680,
            20340,
            21000,
            21660,
            22260,
            22860,
            23460,
            23940,
            24420,
            24900,
            25380,
            25860,
            26280,
            26700,
            27180,
            27660,
            28080,
            28500,
            28920,
            29340,
            29820,
            30240,
            30720,
            31200,
            31680,
            32160,
            32640,
            33120,
            33600,
            34020,
            34440,
            34920,
            35400,
            35880,
            36300,
            36780,
            37260,
            37680,
            38160,
            38700,
            39240,
            39780,
            40320,
            40860,
            41400,
            41940,
            42540,
            43140,
            43800,
            44520,
            45180,
            45780,
            46440,
            47160,
            47940,
            48720,
            49500,
            50220,
            51000,
            51780,
            52500,
            53160,
            53820,
            54480,
            55080,
            55680,
            56160,
            56640,
            57060,
            57480,
            57840,
            58260,
            58680,
            59040,
            59460,
            59880,
            60360,
            60780,
            61200,
            61620,
            62100,
            62580,
            63000,
            63420,
            63780,
            64200,
            64560,
            64920,
            65280,
            65640,
            66000,
            66420,
            66900,
            67320,
            67740,
            68220,
            68700,
            69120,
            69540,
            69960,
            70560,
            71160,
            71820,
            72660,
            73620,
            74640,
            75660,
            76560,
            77460,
            78180,
            78900,
            79680,
            80400,
            81060,
            81660,
            82320,
            82920,
            83460,
            84060,
            84720,
            85320,
            86040
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_5",
      "sourceRouteId": "vilnius_bus_5",
      "mode": "bus",
      "shortName": "5",
      "longName": "Fabijoniškės–Žalgirio g.–Tuskulėnų g.–Šiaurės miestelis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_5:0",
          "sourceRouteId": "vilnius_bus_5",
          "sourceShapeId": "vilnius_bus_5_a-b",
          "directionId": 0,
          "headsign": "Šiaurės miestelis",
          "directionName": "Fabijoniškės–Žalgirio g.–Tuskulėnų g.–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "5",
          "routeLongName": "Fabijoniškės–Žalgirio g.–Tuskulėnų g.–Šiaurės miestelis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2464.27,
              -5705.856,
              27.473
            ],
            [
              -2454.941,
              -5688.21,
              47.434
            ],
            [
              -2458.022,
              -5680.363,
              55.864
            ],
            [
              -2467.523,
              -5671.289,
              69.002
            ],
            [
              -2484.515,
              -5648.724,
              97.249
            ],
            [
              -2456.526,
              -5595.784,
              157.132
            ],
            [
              -2438.766,
              -5574.947,
              184.511
            ],
            [
              -2323.024,
              -5404.447,
              390.585
            ],
            [
              -2243.521,
              -5280.062,
              538.207
            ],
            [
              -2221.212,
              -5257.08,
              570.237
            ],
            [
              -2172.788,
              -5214.524,
              634.703
            ],
            [
              -2110.315,
              -5178.897,
              706.62
            ],
            [
              -2139.87,
              -5138.296,
              756.839
            ],
            [
              -2215.749,
              -4985.55,
              927.394
            ],
            [
              -2263.134,
              -4896.764,
              1028.033
            ],
            [
              -2303.85,
              -4831.475,
              1104.978
            ],
            [
              -2250.757,
              -4780.095,
              1178.861
            ],
            [
              -2249.272,
              -4768.989,
              1190.066
            ],
            [
              -2217.023,
              -4730.598,
              1240.204
            ],
            [
              -2199.094,
              -4664.123,
              1309.055
            ],
            [
              -2245.99,
              -4656.611,
              1356.55
            ],
            [
              -2248.369,
              -4645.437,
              1367.974
            ],
            [
              -2421.69,
              -4610.083,
              1544.864
            ],
            [
              -2609.045,
              -4566.695,
              1737.178
            ],
            [
              -2744.388,
              -4496.401,
              1889.687
            ],
            [
              -2770.134,
              -4531.57,
              1933.273
            ],
            [
              -2804.177,
              -4598.877,
              2008.699
            ],
            [
              -2799.786,
              -4605.634,
              2016.757
            ],
            [
              -2737.686,
              -4627.879,
              2082.721
            ],
            [
              -2739.677,
              -4631.184,
              2086.579
            ],
            [
              -2716.063,
              -4643.846,
              2113.373
            ],
            [
              -2663.507,
              -4659.245,
              2168.139
            ],
            [
              -2601.622,
              -4511.165,
              2328.63
            ],
            [
              -2575.776,
              -4470.432,
              2376.871
            ],
            [
              -2510.179,
              -4331.325,
              2530.669
            ],
            [
              -2380.854,
              -3977.381,
              2907.499
            ],
            [
              -2366.341,
              -3921.977,
              2964.773
            ],
            [
              -2313.476,
              -3774.854,
              3121.105
            ],
            [
              -2292.987,
              -3709.537,
              3189.56
            ],
            [
              -2289.819,
              -3676.197,
              3223.051
            ],
            [
              -2072.945,
              -3075.564,
              3861.638
            ],
            [
              -2044.086,
              -2974.773,
              3966.479
            ],
            [
              -2024.769,
              -2939.494,
              4006.701
            ],
            [
              -2004.312,
              -2876.403,
              4073.025
            ],
            [
              -1942.85,
              -2718.306,
              4242.65
            ],
            [
              -1911.924,
              -2646.496,
              4320.835
            ],
            [
              -1897.194,
              -2615.588,
              4355.074
            ],
            [
              -1889.264,
              -2604.597,
              4368.627
            ],
            [
              -1854.797,
              -2587.399,
              4407.146
            ],
            [
              -1805.935,
              -2485.853,
              4519.837
            ],
            [
              -1803.13,
              -2436.921,
              4568.849
            ],
            [
              -1757.32,
              -2362.039,
              4656.633
            ],
            [
              -1747.763,
              -2332.152,
              4688.01
            ],
            [
              -1727.311,
              -2305.799,
              4721.368
            ],
            [
              -1547.472,
              -2017.345,
              5061.291
            ],
            [
              -1343.434,
              -1674.784,
              5460.014
            ],
            [
              -1305.861,
              -1628.702,
              5519.472
            ],
            [
              -1268.647,
              -1602.651,
              5564.898
            ],
            [
              -1054.592,
              -1494.059,
              5804.922
            ],
            [
              -1027.103,
              -1471.176,
              5840.689
            ],
            [
              -1009.966,
              -1450.333,
              5867.673
            ],
            [
              -1001.511,
              -1410.409,
              5908.482
            ],
            [
              -987.78,
              -1363.9,
              5956.976
            ],
            [
              -988.723,
              -1201.352,
              6119.527
            ],
            [
              -990.397,
              -1186.85,
              6134.125
            ],
            [
              -1017.615,
              -1122.906,
              6203.621
            ],
            [
              -1020.518,
              -1105.042,
              6221.719
            ],
            [
              -1018.304,
              -1089.497,
              6237.421
            ],
            [
              -1013.532,
              -1075.111,
              6252.578
            ],
            [
              -1005.537,
              -1060.783,
              6268.986
            ],
            [
              -969.041,
              -1039.175,
              6311.398
            ],
            [
              -947.066,
              -1036.231,
              6333.57
            ],
            [
              -930.307,
              -1036.533,
              6350.331
            ],
            [
              -906.579,
              -1043.639,
              6375.101
            ],
            [
              -895.802,
              -1053.852,
              6389.949
            ],
            [
              -890.221,
              -1066.198,
              6403.497
            ],
            [
              -867.459,
              -1091.1,
              6437.235
            ],
            [
              -847.054,
              -1103.713,
              6461.224
            ],
            [
              -821.251,
              -1103.065,
              6487.034
            ],
            [
              -688.757,
              -1085.417,
              6620.698
            ],
            [
              -659.265,
              -1201.726,
              6740.688
            ],
            [
              -651.167,
              -1217.458,
              6758.381
            ],
            [
              -631.025,
              -1244.539,
              6792.132
            ],
            [
              -620.269,
              -1255.866,
              6807.752
            ],
            [
              -610.057,
              -1261.617,
              6819.472
            ],
            [
              -593.158,
              -1289.753,
              6852.293
            ],
            [
              -557.225,
              -1334.932,
              6910.019
            ],
            [
              -548.544,
              -1354.014,
              6930.983
            ],
            [
              -546.208,
              -1367.415,
              6944.586
            ],
            [
              -541.958,
              -1488.834,
              7066.08
            ],
            [
              -536.137,
              -1559.073,
              7136.559
            ],
            [
              -520.589,
              -1697.395,
              7275.753
            ],
            [
              -504.478,
              -1804.557,
              7384.119
            ],
            [
              -451.512,
              -1798.837,
              7437.393
            ],
            [
              -397.821,
              -1788.678,
              7492.037
            ],
            [
              -386.905,
              -1791.102,
              7503.218
            ],
            [
              -162.795,
              -1768.453,
              7728.47
            ],
            [
              -103.866,
              -1753.939,
              7789.16
            ],
            [
              91.167,
              -1735.227,
              7985.089
            ],
            [
              238.49,
              -1716.765,
              8133.564
            ],
            [
              252.628,
              -1719.249,
              8147.919
            ],
            [
              342.249,
              -1718.661,
              8237.542
            ],
            [
              510.658,
              -1710.612,
              8406.143
            ],
            [
              549.551,
              -1699.08,
              8446.71
            ],
            [
              585.119,
              -1693.053,
              8482.785
            ],
            [
              616.278,
              -1681.379,
              8516.059
            ],
            [
              646.312,
              -1660.778,
              8552.479
            ],
            [
              673.267,
              -1632.329,
              8591.67
            ],
            [
              699.977,
              -1617.234,
              8622.35
            ],
            [
              891.199,
              -1385.857,
              8922.518
            ],
            [
              926.904,
              -1337.532,
              8982.603
            ],
            [
              934.987,
              -1318.756,
              9003.045
            ],
            [
              959.848,
              -1299.175,
              9034.691
            ],
            [
              1019.189,
              -1227.908,
              9127.429
            ],
            [
              1188.158,
              -1016.171,
              9398.322
            ],
            [
              1209.421,
              -982.054,
              9438.524
            ],
            [
              1229.046,
              -966.831,
              9463.361
            ],
            [
              1246.923,
              -941.557,
              9494.318
            ],
            [
              1250.475,
              -923.811,
              9512.416
            ],
            [
              1249.57,
              -868.132,
              9568.103
            ],
            [
              1251.689,
              -858.152,
              9578.305
            ],
            [
              1256.345,
              -850.445,
              9587.309
            ],
            [
              1271.438,
              -836.252,
              9608.027
            ],
            [
              1287.032,
              -829.861,
              9624.88
            ],
            [
              1325.104,
              -828.339,
              9662.982
            ],
            [
              1339.141,
              -836.391,
              9679.165
            ],
            [
              1354.364,
              -850.032,
              9699.605
            ],
            [
              1360.583,
              -862.393,
              9713.442
            ],
            [
              1367.85,
              -922.642,
              9774.129
            ],
            [
              1384.491,
              -964.14,
              9818.839
            ],
            [
              1464.439,
              -1103.664,
              9979.645
            ],
            [
              1480.223,
              -1121.768,
              10003.663
            ],
            [
              1488.813,
              -1145.306,
              10028.719
            ],
            [
              1537.374,
              -1238.606,
              10133.901
            ],
            [
              1587.871,
              -1366.453,
              10271.359
            ],
            [
              1626.598,
              -1502.988,
              10413.28
            ],
            [
              1647.564,
              -1589.097,
              10501.905
            ],
            [
              1670.179,
              -1759.844,
              10674.143
            ],
            [
              1676.751,
              -1787.797,
              10702.859
            ],
            [
              1672.408,
              -1813.321,
              10728.749
            ],
            [
              1677.37,
              -1962.589,
              10878.099
            ],
            [
              1675.815,
              -2011.543,
              10927.078
            ],
            [
              1684.596,
              -2579.462,
              11495.065
            ],
            [
              1621.888,
              -2589.429,
              11558.56
            ],
            [
              1614.3,
              -2581.496,
              11569.538
            ],
            [
              1426.817,
              -2576.903,
              11757.078
            ],
            [
              1419.812,
              -2572.32,
              11765.449
            ],
            [
              1413.343,
              -2538.803,
              11799.585
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 157.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 756.839,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5803",
              "position": {
                "x": -2249.272,
                "z": -4768.989
              },
              "distanceAlongShapeM": 1190.066,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 1356.55,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:364",
              "position": {
                "x": -2737.686,
                "z": -4627.879
              },
              "distanceAlongShapeM": 2082.721,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7896",
              "position": {
                "x": -2601.622,
                "z": -4511.165
              },
              "distanceAlongShapeM": 2328.63,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5450",
              "position": {
                "x": -2366.341,
                "z": -3921.977
              },
              "distanceAlongShapeM": 2964.773,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5451",
              "position": {
                "x": -2289.819,
                "z": -3676.197
              },
              "distanceAlongShapeM": 3223.051,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5452",
              "position": {
                "x": -2044.086,
                "z": -2974.773
              },
              "distanceAlongShapeM": 3966.479,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 4688.01,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 5908.482,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7769",
              "position": {
                "x": -610.057,
                "z": -1261.617
              },
              "distanceAlongShapeM": 6819.472,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5462",
              "position": {
                "x": -397.821,
                "z": -1788.678
              },
              "distanceAlongShapeM": 7492.037,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:17318",
              "position": {
                "x": -103.866,
                "z": -1753.939
              },
              "distanceAlongShapeM": 7789.16,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7691",
              "position": {
                "x": 238.49,
                "z": -1716.765
              },
              "distanceAlongShapeM": 8133.564,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 8591.67,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6544",
              "position": {
                "x": 934.987,
                "z": -1318.756
              },
              "distanceAlongShapeM": 9003.045,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6546",
              "position": {
                "x": 1209.421,
                "z": -982.054
              },
              "distanceAlongShapeM": 9438.524,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 10003.663,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 10702.859,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5013",
              "position": {
                "x": 1621.888,
                "z": -2589.429
              },
              "distanceAlongShapeM": 11558.56,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 11799.585,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            }
          ],
          "departuresSeconds": [
            19140,
            21420,
            23580,
            24840,
            26100,
            27300,
            28500,
            29700,
            30900,
            32400,
            34380,
            35880,
            37440,
            39000,
            42000,
            43740,
            45480,
            47220,
            49380,
            51180,
            53040,
            55200,
            56520,
            57480,
            58440,
            59760,
            61080,
            62400,
            63780,
            65280,
            66960,
            68640,
            69960,
            74580,
            75720,
            76920,
            79380,
            80820,
            82320,
            84000,
            85380
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_5:1",
          "sourceRouteId": "vilnius_bus_5",
          "sourceShapeId": "vilnius_bus_5_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės",
          "directionName": "Šiaurės miestelis–Tuskulėnų g.–Žalgirio g.–Fabijoniškės",
          "mode": "bus",
          "routeShortName": "5",
          "routeLongName": "Fabijoniškės–Žalgirio g.–Tuskulėnų g.–Šiaurės miestelis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1412.698,
              -2538.791,
              0
            ],
            [
              1427.807,
              -2523.486,
              21.507
            ],
            [
              1492.99,
              -2519.128,
              86.835
            ],
            [
              1524.687,
              -2513.037,
              119.112
            ],
            [
              1549.069,
              -2519.056,
              144.226
            ],
            [
              1557.925,
              -2528.126,
              156.902
            ],
            [
              1557.243,
              -2564.85,
              193.633
            ],
            [
              1565.454,
              -2573.909,
              205.859
            ],
            [
              1658.884,
              -2575.644,
              299.305
            ],
            [
              1668.591,
              -2573.598,
              309.225
            ],
            [
              1675.2,
              -2564.815,
              320.217
            ],
            [
              1674.783,
              -2552.562,
              332.478
            ],
            [
              1670.083,
              -2527.983,
              357.502
            ],
            [
              1679.06,
              -2495.866,
              390.85
            ],
            [
              1670.601,
              -2049.296,
              837.5
            ],
            [
              1665.105,
              -1963.474,
              923.498
            ],
            [
              1664.613,
              -1816.516,
              1070.456
            ],
            [
              1663.09,
              -1759.712,
              1127.281
            ],
            [
              1653.419,
              -1725.022,
              1163.294
            ],
            [
              1660.464,
              -1692.869,
              1196.209
            ],
            [
              1642.718,
              -1572.308,
              1318.069
            ],
            [
              1626.598,
              -1502.988,
              1389.239
            ],
            [
              1590.763,
              -1384.318,
              1513.201
            ],
            [
              1541.473,
              -1260.946,
              1646.055
            ],
            [
              1439.941,
              -1068.699,
              1863.467
            ],
            [
              1418.417,
              -1047.149,
              1893.924
            ],
            [
              1413.029,
              -1024.784,
              1916.929
            ],
            [
              1381.79,
              -970.77,
              1979.326
            ],
            [
              1372.327,
              -959.462,
              1994.071
            ],
            [
              1333.941,
              -943.166,
              2035.773
            ],
            [
              1285.577,
              -943.385,
              2084.137
            ],
            [
              1262.269,
              -948.52,
              2108.004
            ],
            [
              1247.842,
              -961.612,
              2127.486
            ],
            [
              1192.361,
              -1032.948,
              2217.857
            ],
            [
              1184.819,
              -1057.3,
              2243.35
            ],
            [
              1157.377,
              -1076.831,
              2277.032
            ],
            [
              1022.871,
              -1237.996,
              2486.951
            ],
            [
              942.352,
              -1338.93,
              2616.068
            ],
            [
              920.55,
              -1367.472,
              2651.984
            ],
            [
              905.214,
              -1395.021,
              2683.514
            ],
            [
              882.932,
              -1414.649,
              2713.208
            ],
            [
              768.148,
              -1556.146,
              2895.408
            ],
            [
              700.938,
              -1635.064,
              2999.067
            ],
            [
              640.022,
              -1687.381,
              3079.366
            ],
            [
              593.917,
              -1705.46,
              3128.888
            ],
            [
              578.225,
              -1717.417,
              3148.617
            ],
            [
              475.715,
              -1717.765,
              3251.128
            ],
            [
              322.189,
              -1722.747,
              3404.734
            ],
            [
              290.448,
              -1731.073,
              3437.549
            ],
            [
              249.243,
              -1728.093,
              3478.862
            ],
            [
              91.167,
              -1735.227,
              3637.099
            ],
            [
              -460.696,
              -1807.576,
              4193.684
            ],
            [
              -504.679,
              -1815.686,
              4238.409
            ],
            [
              -529.853,
              -1817.457,
              4263.645
            ],
            [
              -564.13,
              -1823.516,
              4298.453
            ],
            [
              -591.68,
              -1814.111,
              4327.564
            ],
            [
              -669.981,
              -1794.884,
              4408.191
            ],
            [
              -739.986,
              -1780.261,
              4479.707
            ],
            [
              -775.874,
              -1768.481,
              4517.479
            ],
            [
              -800.123,
              -1754.685,
              4545.377
            ],
            [
              -815.269,
              -1736.6,
              4568.967
            ],
            [
              -917.833,
              -1561.088,
              4772.25
            ],
            [
              -998.805,
              -1475.025,
              4890.417
            ],
            [
              -1007.808,
              -1473.75,
              4899.51
            ],
            [
              -1034.713,
              -1499.983,
              4937.087
            ],
            [
              -1061.478,
              -1518.427,
              4969.591
            ],
            [
              -1070.7,
              -1529.393,
              4983.92
            ],
            [
              -1114.746,
              -1540.847,
              5029.43
            ],
            [
              -1223.074,
              -1577.865,
              5143.909
            ],
            [
              -1268.647,
              -1602.651,
              5195.786
            ],
            [
              -1297.383,
              -1623.287,
              5231.164
            ],
            [
              -1333.607,
              -1666.054,
              5287.21
            ],
            [
              -1382.029,
              -1741.999,
              5377.279
            ],
            [
              -1597.414,
              -2106.624,
              5800.767
            ],
            [
              -1645.063,
              -2175.906,
              5884.853
            ],
            [
              -1682.619,
              -2257.615,
              5974.779
            ],
            [
              -1702.963,
              -2314.026,
              6034.747
            ],
            [
              -1711.936,
              -2347.263,
              6069.173
            ],
            [
              -1753.781,
              -2416.65,
              6150.202
            ],
            [
              -1791.442,
              -2468.3,
              6214.124
            ],
            [
              -1838.817,
              -2558.74,
              6316.221
            ],
            [
              -1870.389,
              -2630.537,
              6394.654
            ],
            [
              -1871.271,
              -2643.88,
              6408.026
            ],
            [
              -1912.507,
              -2715.506,
              6490.673
            ],
            [
              -1995.657,
              -2933.332,
              6723.83
            ],
            [
              -2020.861,
              -3009.696,
              6804.246
            ],
            [
              -2025.964,
              -3043.002,
              6837.941
            ],
            [
              -2242.142,
              -3640.305,
              7473.161
            ],
            [
              -2268.114,
              -3687.714,
              7527.217
            ],
            [
              -2346.255,
              -3915.653,
              7768.178
            ],
            [
              -2360.668,
              -3965.493,
              7820.06
            ],
            [
              -2466.817,
              -4247.487,
              8121.371
            ],
            [
              -2538.941,
              -4427.667,
              8315.45
            ],
            [
              -2556.572,
              -4477.451,
              8368.264
            ],
            [
              -2571.739,
              -4497.221,
              8393.182
            ],
            [
              -2635.224,
              -4626.347,
              8537.07
            ],
            [
              -2636.28,
              -4649.706,
              8560.453
            ],
            [
              -2631.949,
              -4659.802,
              8571.438
            ],
            [
              -2592.254,
              -4673.861,
              8613.549
            ],
            [
              -2567.235,
              -4679.869,
              8639.28
            ],
            [
              -2548.031,
              -4686.888,
              8659.726
            ],
            [
              -2515.304,
              -4694.145,
              8693.248
            ],
            [
              -2465.325,
              -4709.501,
              8745.533
            ],
            [
              -2409.103,
              -4736.1,
              8807.73
            ],
            [
              -2349.957,
              -4779.45,
              8881.061
            ],
            [
              -2306.893,
              -4821.402,
              8941.182
            ],
            [
              -2284.806,
              -4847.398,
              8975.293
            ],
            [
              -2241.672,
              -4921.636,
              9061.153
            ],
            [
              -2236.559,
              -4923.953,
              9066.766
            ],
            [
              -2217.405,
              -4969.935,
              9116.578
            ],
            [
              -2110.315,
              -5178.897,
              9351.382
            ],
            [
              -2127.276,
              -5190.841,
              9372.127
            ],
            [
              -2143.028,
              -5207.26,
              9394.879
            ],
            [
              -2175.503,
              -5222.268,
              9430.655
            ],
            [
              -2204.955,
              -5248.463,
              9470.07
            ],
            [
              -2230.543,
              -5274.726,
              9506.738
            ],
            [
              -2512.326,
              -5691.648,
              10009.953
            ],
            [
              -2513.285,
              -5709.442,
              10027.774
            ],
            [
              -2528.468,
              -5730.325,
              10053.593
            ],
            [
              -2529.407,
              -5747.007,
              10070.301
            ],
            [
              -2525.623,
              -5751.527,
              10076.196
            ],
            [
              -2510.288,
              -5758.477,
              10093.033
            ],
            [
              -2498.658,
              -5756.456,
              10104.836
            ],
            [
              -2480.761,
              -5727.829,
              10138.597
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 119.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 357.502,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 1163.294,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 1893.924,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6547",
              "position": {
                "x": 1184.819,
                "z": -1057.3
              },
              "distanceAlongShapeM": 2243.35,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:1032",
              "position": {
                "x": 905.214,
                "z": -1395.021
              },
              "distanceAlongShapeM": 2683.514,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:18847",
              "position": {
                "x": 578.225,
                "z": -1717.417
              },
              "distanceAlongShapeM": 3148.617,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5498",
              "position": {
                "x": 290.448,
                "z": -1731.073
              },
              "distanceAlongShapeM": 3437.549,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5499",
              "position": {
                "x": -564.13,
                "z": -1823.516
              },
              "distanceAlongShapeM": 4298.453,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5289",
              "position": {
                "x": -1070.7,
                "z": -1529.393
              },
              "distanceAlongShapeM": 4983.92,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 6069.173,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:1039",
              "position": {
                "x": -1871.271,
                "z": -2643.88
              },
              "distanceAlongShapeM": 6408.026,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:986",
              "position": {
                "x": -2025.964,
                "z": -3043.002
              },
              "distanceAlongShapeM": 6837.941,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:4388",
              "position": {
                "x": -2242.142,
                "z": -3640.305
              },
              "distanceAlongShapeM": 7473.161,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:823",
              "position": {
                "x": -2360.668,
                "z": -3965.493
              },
              "distanceAlongShapeM": 7820.06,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7897",
              "position": {
                "x": -2556.572,
                "z": -4477.451
              },
              "distanceAlongShapeM": 8368.264,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 9066.766,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 9394.879,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 10027.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            19320,
            21480,
            22380,
            23640,
            24600,
            25560,
            26460,
            27840,
            29220,
            30600,
            31860,
            33660,
            34920,
            36480,
            38400,
            39600,
            41160,
            42720,
            44760,
            46620,
            48480,
            50340,
            52380,
            53820,
            56160,
            58500,
            59640,
            60780,
            61920,
            63180,
            64500,
            66120,
            67740,
            69240,
            72180,
            73200,
            74280,
            77160,
            78420,
            79800,
            81900,
            83280,
            84780
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_5G",
      "sourceRouteId": "vilnius_expressbus_5G",
      "mode": "bus",
      "shortName": "5G",
      "longName": "Perkūnkiemis–Ozo g.–Saulėtekis",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_5G:0",
          "sourceRouteId": "vilnius_expressbus_5G",
          "sourceShapeId": "vilnius_expressbus_5G_a-b",
          "directionId": 0,
          "headsign": "Saulėtekis",
          "directionName": "Perkūnkiemis–Ozo g.–Saulėtekis",
          "mode": "bus",
          "routeShortName": "5G",
          "routeLongName": "Perkūnkiemis–Ozo g.–Saulėtekis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3844.602,
              -5152.866,
              0
            ],
            [
              -3862.028,
              -5154.789,
              17.532
            ],
            [
              -3896.745,
              -5150.846,
              52.471
            ],
            [
              -3904.981,
              -5142.911,
              63.908
            ],
            [
              -3906.076,
              -5131.759,
              75.113
            ],
            [
              -3903.757,
              -5109.535,
              97.458
            ],
            [
              -3899.68,
              -5097.361,
              110.297
            ],
            [
              -3891.837,
              -5090.818,
              120.511
            ],
            [
              -3867.269,
              -5085.679,
              145.611
            ],
            [
              -3845.592,
              -5061.565,
              178.036
            ],
            [
              -3842.178,
              -5050.492,
              189.623
            ],
            [
              -3838.726,
              -5037.193,
              203.362
            ],
            [
              -3828.914,
              -4880.4,
              360.462
            ],
            [
              -3839.647,
              -4756.647,
              484.68
            ],
            [
              -3856.989,
              -4679.534,
              563.719
            ],
            [
              -3893.073,
              -4568.698,
              680.28
            ],
            [
              -3919.183,
              -4476.961,
              775.661
            ],
            [
              -3925.083,
              -4445.689,
              807.485
            ],
            [
              -3938.125,
              -4417.632,
              838.425
            ],
            [
              -3934.344,
              -4385.414,
              870.864
            ],
            [
              -3933.945,
              -4325.308,
              930.972
            ],
            [
              -3923.556,
              -4246.45,
              1010.511
            ],
            [
              -3863.253,
              -4076.062,
              1191.255
            ],
            [
              -3846.667,
              -4048.52,
              1223.406
            ],
            [
              -3724.705,
              -3815.753,
              1486.189
            ],
            [
              -3681.09,
              -3716.323,
              1594.765
            ],
            [
              -3652.775,
              -3644.457,
              1672.007
            ],
            [
              -3636.19,
              -3580.18,
              1738.39
            ],
            [
              -3633.854,
              -3520.107,
              1798.508
            ],
            [
              -3624.82,
              -3482.415,
              1837.268
            ],
            [
              -3626.214,
              -3414.484,
              1905.213
            ],
            [
              -3629.537,
              -3383.256,
              1936.617
            ],
            [
              -3641.883,
              -3315.135,
              2005.848
            ],
            [
              -3659.519,
              -3254.715,
              2068.79
            ],
            [
              -3681.569,
              -3188.651,
              2138.436
            ],
            [
              -3706.235,
              -3124.768,
              2206.915
            ],
            [
              -3706.685,
              -3113.628,
              2218.064
            ],
            [
              -3698.78,
              -3103.747,
              2230.718
            ],
            [
              -3687.144,
              -3101.723,
              2242.529
            ],
            [
              -3665.065,
              -3092.089,
              2266.618
            ],
            [
              -3645.64,
              -3086.861,
              2286.734
            ],
            [
              -3581.078,
              -3080.193,
              2351.64
            ],
            [
              -3537.19,
              -3076.506,
              2395.682
            ],
            [
              -3288.387,
              -3074.173,
              2644.497
            ],
            [
              -3226.908,
              -3059.664,
              2707.664
            ],
            [
              -3088.313,
              -3020.904,
              2851.578
            ],
            [
              -3076.618,
              -3015.543,
              2864.442
            ],
            [
              -3065.626,
              -3013.509,
              2875.621
            ],
            [
              -3013.674,
              -2991.043,
              2932.222
            ],
            [
              -2972.908,
              -2981.74,
              2974.036
            ],
            [
              -2923.591,
              -2962.569,
              3026.949
            ],
            [
              -2796.251,
              -2867.959,
              3185.588
            ],
            [
              -2713.249,
              -2802.628,
              3291.217
            ],
            [
              -2678.551,
              -2772.069,
              3337.453
            ],
            [
              -2644.38,
              -2734.822,
              3388
            ],
            [
              -2636.314,
              -2716.04,
              3408.441
            ],
            [
              -2600.033,
              -2668.811,
              3467.997
            ],
            [
              -2574.02,
              -2619.176,
              3524.036
            ],
            [
              -2545.641,
              -2545.091,
              3603.37
            ],
            [
              -2520.523,
              -2473.175,
              3679.546
            ],
            [
              -2499.973,
              -2404.518,
              3751.212
            ],
            [
              -2490.126,
              -2357.937,
              3798.823
            ],
            [
              -2467.791,
              -2224.746,
              3933.875
            ],
            [
              -2431.725,
              -2226.496,
              3969.983
            ],
            [
              -2415.576,
              -2224.555,
              3986.248
            ],
            [
              -2373.4,
              -2245.339,
              4033.267
            ],
            [
              -2196.773,
              -2317.488,
              4224.061
            ],
            [
              -2137.182,
              -2337.47,
              4286.913
            ],
            [
              -2015.246,
              -2367.466,
              4412.485
            ],
            [
              -1889.653,
              -2373.04,
              4538.201
            ],
            [
              -1756.388,
              -2382.093,
              4671.774
            ],
            [
              -1647.51,
              -2385.149,
              4780.695
            ],
            [
              -1597.953,
              -2389.374,
              4830.431
            ],
            [
              -1522.821,
              -2405.189,
              4907.21
            ],
            [
              -1485.023,
              -2418.11,
              4947.156
            ],
            [
              -1375.913,
              -2480.178,
              5072.684
            ],
            [
              -1324.1,
              -2502.258,
              5129.006
            ],
            [
              -1292.401,
              -2531.77,
              5172.316
            ],
            [
              -1235.733,
              -2570.637,
              5241.031
            ],
            [
              -1150.916,
              -2621.142,
              5339.747
            ],
            [
              -1079.915,
              -2651.362,
              5416.912
            ],
            [
              -1012.681,
              -2675.949,
              5488.501
            ],
            [
              -916.353,
              -2695.496,
              5586.792
            ],
            [
              -830.758,
              -2702.605,
              5672.681
            ],
            [
              -592.882,
              -2700.223,
              5910.569
            ],
            [
              -320.273,
              -2701.823,
              6183.183
            ],
            [
              -192.234,
              -2714.168,
              6311.815
            ],
            [
              12.173,
              -2744.606,
              6518.477
            ],
            [
              66.615,
              -2763.41,
              6576.075
            ],
            [
              144.816,
              -2787.102,
              6657.785
            ],
            [
              177.432,
              -2801.056,
              6693.261
            ],
            [
              248.7,
              -2851.341,
              6780.483
            ],
            [
              331.278,
              -2917.419,
              6886.244
            ],
            [
              357.389,
              -2934.595,
              6917.498
            ],
            [
              386.802,
              -2947.379,
              6949.569
            ],
            [
              425.296,
              -2956.99,
              6989.245
            ],
            [
              460.671,
              -2960.978,
              7024.844
            ],
            [
              521.837,
              -2964.325,
              7086.102
            ],
            [
              532.044,
              -2970.079,
              7097.818
            ],
            [
              602.169,
              -2976.932,
              7168.278
            ],
            [
              619.319,
              -2990.605,
              7190.212
            ],
            [
              906.98,
              -3153.977,
              7521.027
            ],
            [
              1051.83,
              -3232.348,
              7685.72
            ],
            [
              1074.9,
              -3239.454,
              7709.859
            ],
            [
              1095.125,
              -3260.979,
              7739.395
            ],
            [
              1260.9,
              -3357.556,
              7931.25
            ],
            [
              1339.233,
              -3407.989,
              8024.415
            ],
            [
              1373.568,
              -3433.117,
              8066.962
            ],
            [
              1493.843,
              -3550.011,
              8234.683
            ],
            [
              1520.486,
              -3572.771,
              8269.724
            ],
            [
              1584,
              -3657.444,
              8375.571
            ],
            [
              1660.25,
              -3750.148,
              8495.605
            ],
            [
              1866.498,
              -3989.997,
              8811.936
            ],
            [
              1889.999,
              -4008.247,
              8841.692
            ],
            [
              1892.95,
              -4022.775,
              8856.516
            ],
            [
              1975.005,
              -4114.479,
              8979.572
            ],
            [
              2057.826,
              -4199.52,
              9098.278
            ],
            [
              2170.271,
              -4319.627,
              9262.807
            ],
            [
              2237.981,
              -4385.463,
              9357.247
            ],
            [
              2278.639,
              -4416.283,
              9408.266
            ],
            [
              2288.882,
              -4419.815,
              9419.101
            ],
            [
              2297.234,
              -4421.084,
              9427.549
            ],
            [
              2310.823,
              -4417.999,
              9441.483
            ],
            [
              2320.672,
              -4408.165,
              9455.402
            ],
            [
              2330.583,
              -4394.991,
              9471.887
            ],
            [
              2336.672,
              -4379.52,
              9488.514
            ],
            [
              2336.174,
              -4371.718,
              9496.332
            ],
            [
              2352.029,
              -4350.863,
              9522.529
            ],
            [
              2362.441,
              -4310.981,
              9563.748
            ],
            [
              2385.909,
              -4193.416,
              9683.632
            ],
            [
              2408.961,
              -4098.109,
              9781.688
            ],
            [
              2465.77,
              -3886.543,
              10000.748
            ],
            [
              2502.69,
              -3739.173,
              10152.672
            ],
            [
              2513.829,
              -3729.363,
              10167.515
            ],
            [
              2523.534,
              -3727.319,
              10177.433
            ],
            [
              2532.532,
              -3728.601,
              10186.521
            ],
            [
              2540.76,
              -3736.549,
              10197.961
            ],
            [
              2566.251,
              -3786.011,
              10253.605
            ],
            [
              2598.162,
              -3836.707,
              10313.509
            ],
            [
              2614.638,
              -3851.49,
              10335.644
            ],
            [
              2636.723,
              -3876.397,
              10368.933
            ],
            [
              2642.893,
              -3890.985,
              10384.772
            ],
            [
              2709.56,
              -3977.961,
              10494.359
            ],
            [
              3021.059,
              -4338.966,
              10971.178
            ],
            [
              3086.352,
              -4293.444,
              11050.774
            ],
            [
              3111.27,
              -4270.537,
              11084.622
            ],
            [
              3142.482,
              -4255.542,
              11119.249
            ],
            [
              3336.938,
              -4126.748,
              11352.489
            ],
            [
              3389.682,
              -4097.691,
              11412.707
            ],
            [
              3402.776,
              -4086.807,
              11429.734
            ],
            [
              3446.229,
              -4072.046,
              11475.626
            ],
            [
              3528.69,
              -4039.102,
              11564.424
            ],
            [
              3592.048,
              -4028.061,
              11628.737
            ],
            [
              3640.634,
              -4014.513,
              11679.176
            ],
            [
              3666.294,
              -4020.567,
              11705.541
            ],
            [
              3848.026,
              -4019.578,
              11887.276
            ],
            [
              3878.881,
              -4023.507,
              11918.38
            ],
            [
              3901.964,
              -4029.514,
              11942.232
            ],
            [
              3958.181,
              -4055.079,
              12003.989
            ],
            [
              3967.843,
              -4055.264,
              12013.652
            ],
            [
              4018.762,
              -4121.92,
              12097.532
            ],
            [
              4037.773,
              -4172.381,
              12151.455
            ],
            [
              4032.364,
              -4185.636,
              12165.772
            ],
            [
              4021.265,
              -4193.217,
              12179.212
            ],
            [
              4012.248,
              -4193.045,
              12188.232
            ],
            [
              3999.472,
              -4187.234,
              12202.267
            ],
            [
              3957.337,
              -4132.992,
              12270.952
            ],
            [
              3954.003,
              -4105.097,
              12299.045
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 166.663,
              "shapeOffsetM": 1.216,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:687",
              "position": {
                "x": -3938.125,
                "z": -4417.632
              },
              "distanceAlongShapeM": 838.425,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5060",
              "position": {
                "x": -3633.854,
                "z": -3520.107
              },
              "distanceAlongShapeM": 1798.508,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7001",
              "position": {
                "x": -3665.065,
                "z": -3092.089
              },
              "distanceAlongShapeM": 2266.618,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 2932.222,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 3408.441,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:1069",
              "position": {
                "x": -2415.576,
                "z": -2224.555
              },
              "distanceAlongShapeM": 3986.248,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7017",
              "position": {
                "x": -1324.1,
                "z": -2502.258
              },
              "distanceAlongShapeM": 5129.006,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5080",
              "position": {
                "x": 12.173,
                "z": -2744.606
              },
              "distanceAlongShapeM": 6518.477,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6846",
              "position": {
                "x": 602.169,
                "z": -2976.932
              },
              "distanceAlongShapeM": 7168.278,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6873",
              "position": {
                "x": 1553.844,
                "z": -3615.694
              },
              "distanceAlongShapeM": 8324.077,
              "shapeOffsetM": 0.929,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5476",
              "position": {
                "x": 2336.174,
                "z": -4371.718
              },
              "distanceAlongShapeM": 9496.332,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 10368.933,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 11084.622,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 11429.734,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 11679.176,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 12013.652,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            19080,
            19920,
            20640,
            21360,
            21960,
            22680,
            23280,
            23760,
            24180,
            24660,
            25140,
            25620,
            26100,
            26460,
            26940,
            27420,
            27900,
            28380,
            28860,
            29400,
            29940,
            30600,
            31200,
            31740,
            32280,
            32760,
            33300,
            33960,
            34680,
            35400,
            35940,
            36420,
            36960,
            37440,
            37920,
            38520,
            39180,
            39720,
            40260,
            40860,
            41460,
            42060,
            42660,
            43320,
            44100,
            44880,
            45600,
            46320,
            47040,
            47760,
            48480,
            49080,
            49800,
            50400,
            51180,
            51960,
            52620,
            53460,
            54120,
            54840,
            55500,
            56040,
            56880,
            57720,
            58440,
            59220,
            59820,
            60420,
            60900,
            61380,
            61980,
            62520,
            63000,
            63540,
            64020,
            64500,
            65040,
            65640,
            66180,
            66720,
            67200,
            67680,
            68220,
            69000,
            69780,
            70500,
            71280,
            72060,
            72840,
            73620,
            74280,
            74940,
            75600,
            76260,
            76920,
            77580,
            78240,
            78900,
            79620,
            80340,
            81060,
            81780,
            82500,
            83220,
            83880,
            84540
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_5G:1",
          "sourceRouteId": "vilnius_expressbus_5G",
          "sourceShapeId": "vilnius_expressbus_5G_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Saulėtekis–Ozo g.–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "5G",
          "routeLongName": "Perkūnkiemis–Ozo g.–Saulėtekis",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3954.003,
              -4105.097,
              0
            ],
            [
              3949.042,
              -4094.982,
              11.266
            ],
            [
              3942.445,
              -4069.251,
              37.829
            ],
            [
              3936.216,
              -4058,
              50.69
            ],
            [
              3917.749,
              -4046.514,
              72.437
            ],
            [
              3898.552,
              -4039.468,
              92.886
            ],
            [
              3898.616,
              -4036.13,
              96.225
            ],
            [
              3858.828,
              -4027.577,
              136.922
            ],
            [
              3592.048,
              -4028.061,
              403.703
            ],
            [
              3581.678,
              -4031.203,
              414.538
            ],
            [
              3565.986,
              -4043.151,
              434.261
            ],
            [
              3520.083,
              -4051.184,
              480.861
            ],
            [
              3445.458,
              -4078.711,
              560.402
            ],
            [
              3358.965,
              -4120.486,
              656.455
            ],
            [
              3360.169,
              -4124.962,
              661.09
            ],
            [
              3310.064,
              -4150.73,
              717.432
            ],
            [
              3021.059,
              -4338.966,
              1062.334
            ],
            [
              2959.695,
              -4278.804,
              1148.269
            ],
            [
              2937.404,
              -4265.024,
              1174.476
            ],
            [
              2920.517,
              -4237.987,
              1206.353
            ],
            [
              2810.169,
              -4110.107,
              1375.262
            ],
            [
              2739.116,
              -4050.879,
              1467.763
            ],
            [
              2661.391,
              -4003.772,
              1558.649
            ],
            [
              2636.416,
              -3995.509,
              1584.956
            ],
            [
              2624.428,
              -3981.925,
              1603.073
            ],
            [
              2519.252,
              -3920.945,
              1724.648
            ],
            [
              2497.02,
              -3903.829,
              1752.706
            ],
            [
              2481.543,
              -3870.14,
              1789.779
            ],
            [
              2477.598,
              -3840.008,
              1820.168
            ],
            [
              2486.808,
              -3795.651,
              1865.472
            ],
            [
              2503.376,
              -3736.96,
              1926.457
            ],
            [
              2508.032,
              -3729.254,
              1935.459
            ],
            [
              2515.825,
              -3726.061,
              1943.881
            ],
            [
              2523.534,
              -3727.319,
              1951.692
            ],
            [
              2538.183,
              -3736.5,
              1968.981
            ],
            [
              2569.676,
              -3809.454,
              2048.442
            ],
            [
              2576.842,
              -3839.646,
              2079.473
            ],
            [
              2577.544,
              -3870.831,
              2110.665
            ],
            [
              2568.689,
              -3896.269,
              2137.601
            ],
            [
              2541.856,
              -3952.541,
              2199.943
            ],
            [
              2519.328,
              -3985.515,
              2239.878
            ],
            [
              2483.001,
              -4032.703,
              2299.429
            ],
            [
              2454.012,
              -4066.67,
              2344.085
            ],
            [
              2436.763,
              -4093.064,
              2375.615
            ],
            [
              2406.107,
              -4181.549,
              2469.261
            ],
            [
              2398.976,
              -4218.153,
              2506.552
            ],
            [
              2394.879,
              -4264.833,
              2553.412
            ],
            [
              2388.205,
              -4311.465,
              2600.519
            ],
            [
              2381.138,
              -4344.73,
              2634.526
            ],
            [
              2383.36,
              -4363.697,
              2653.623
            ],
            [
              2363.369,
              -4398.946,
              2694.146
            ],
            [
              2340.823,
              -4433.034,
              2735.015
            ],
            [
              2328.252,
              -4450.61,
              2756.625
            ],
            [
              2298.04,
              -4481.215,
              2799.63
            ],
            [
              2296.004,
              -4486.743,
              2805.521
            ],
            [
              2297.644,
              -4502.36,
              2821.223
            ],
            [
              2324.901,
              -4526.249,
              2857.467
            ],
            [
              2369.547,
              -4550.465,
              2908.258
            ],
            [
              2386.895,
              -4553.017,
              2925.792
            ],
            [
              2397.928,
              -4548.771,
              2937.614
            ],
            [
              2404.556,
              -4538.876,
              2949.524
            ],
            [
              2405.535,
              -4521.082,
              2967.345
            ],
            [
              2396.166,
              -4505.32,
              2985.68
            ],
            [
              2310.611,
              -4463.639,
              3080.848
            ],
            [
              2261.601,
              -4431.549,
              3139.429
            ],
            [
              2254.143,
              -4416.937,
              3155.834
            ],
            [
              2239.684,
              -4397.741,
              3179.867
            ],
            [
              2101.811,
              -4259.344,
              3375.219
            ],
            [
              2005.819,
              -4155.131,
              3516.905
            ],
            [
              1848.669,
              -3978.532,
              3753.302
            ],
            [
              1832.856,
              -3962.652,
              3775.712
            ],
            [
              1811.224,
              -3947.777,
              3801.965
            ],
            [
              1800.044,
              -3925.303,
              3827.066
            ],
            [
              1667.691,
              -3765.872,
              4034.276
            ],
            [
              1499.686,
              -3582.404,
              4283.044
            ],
            [
              1482.767,
              -3556.485,
              4313.996
            ],
            [
              1455.5,
              -3532.601,
              4350.245
            ],
            [
              1443.07,
              -3507.879,
              4377.916
            ],
            [
              1391.152,
              -3457.934,
              4449.957
            ],
            [
              1338.486,
              -3413.541,
              4518.837
            ],
            [
              1317.474,
              -3399.793,
              4543.947
            ],
            [
              978.337,
              -3198.709,
              4938.218
            ],
            [
              945.685,
              -3186.974,
              4972.914
            ],
            [
              931.778,
              -3172.246,
              4993.171
            ],
            [
              710.47,
              -3045.716,
              5248.096
            ],
            [
              679.709,
              -3036.244,
              5280.283
            ],
            [
              665.217,
              -3018.166,
              5303.452
            ],
            [
              641.604,
              -3005.487,
              5330.254
            ],
            [
              624.331,
              -2998.49,
              5348.891
            ],
            [
              521.572,
              -2978.793,
              5453.52
            ],
            [
              442.304,
              -2978.453,
              5532.788
            ],
            [
              342.529,
              -2936.549,
              5641.006
            ],
            [
              249.744,
              -2864.719,
              5758.346
            ],
            [
              215.338,
              -2842.938,
              5799.067
            ],
            [
              172.556,
              -2821.005,
              5847.143
            ],
            [
              116.826,
              -2802.176,
              5905.968
            ],
            [
              -65.348,
              -2754.326,
              6094.321
            ],
            [
              -121.383,
              -2752.193,
              6150.397
            ],
            [
              -224.17,
              -2733.625,
              6254.848
            ],
            [
              -312.321,
              -2725.345,
              6343.387
            ],
            [
              -534.611,
              -2721.315,
              6565.714
            ],
            [
              -763.526,
              -2727.196,
              6794.704
            ],
            [
              -847.912,
              -2724.56,
              6879.131
            ],
            [
              -963.025,
              -2710.24,
              6995.131
            ],
            [
              -1021.438,
              -2696.943,
              7055.038
            ],
            [
              -1084.241,
              -2676.889,
              7120.966
            ],
            [
              -1158.443,
              -2645.498,
              7201.535
            ],
            [
              -1386.622,
              -2502.251,
              7470.951
            ],
            [
              -1450.559,
              -2473.275,
              7541.147
            ],
            [
              -1488.158,
              -2449.225,
              7585.78
            ],
            [
              -1548.409,
              -2430.336,
              7648.923
            ],
            [
              -1640.314,
              -2415.335,
              7742.044
            ],
            [
              -1771.001,
              -2406.324,
              7873.041
            ],
            [
              -1888.235,
              -2402.009,
              7990.355
            ],
            [
              -1933.866,
              -2394.517,
              8036.597
            ],
            [
              -2056.217,
              -2387.889,
              8159.127
            ],
            [
              -2112.099,
              -2376.878,
              8216.084
            ],
            [
              -2168.467,
              -2356.953,
              8275.87
            ],
            [
              -2219.78,
              -2342.684,
              8329.13
            ],
            [
              -2405.236,
              -2295.984,
              8520.376
            ],
            [
              -2472.07,
              -2248.048,
              8602.623
            ],
            [
              -2470.476,
              -2303.737,
              8658.335
            ],
            [
              -2477.313,
              -2325.88,
              8681.51
            ],
            [
              -2484.017,
              -2376.97,
              8733.038
            ],
            [
              -2514.005,
              -2505.574,
              8865.092
            ],
            [
              -2552.25,
              -2627.352,
              8992.735
            ],
            [
              -2587.598,
              -2694.635,
              9068.737
            ],
            [
              -2667.366,
              -2795.644,
              9197.446
            ],
            [
              -2878.335,
              -2954.459,
              9461.51
            ],
            [
              -2942.823,
              -2993.401,
              9536.844
            ],
            [
              -2993.467,
              -3014.776,
              9591.814
            ],
            [
              -3056.314,
              -3033.711,
              9657.451
            ],
            [
              -3148.249,
              -3057.702,
              9752.465
            ],
            [
              -3175.503,
              -3068.357,
              9781.728
            ],
            [
              -3258.301,
              -3085.832,
              9866.35
            ],
            [
              -3322.825,
              -3090.269,
              9931.026
            ],
            [
              -3543.885,
              -3090.861,
              10152.087
            ],
            [
              -3642.787,
              -3108.062,
              10252.474
            ],
            [
              -3690.695,
              -3120.586,
              10301.992
            ],
            [
              -3680.304,
              -3153.05,
              10336.078
            ],
            [
              -3662.711,
              -3178.96,
              10367.397
            ],
            [
              -3658.589,
              -3201.296,
              10390.11
            ],
            [
              -3639.586,
              -3257.288,
              10449.238
            ],
            [
              -3617.301,
              -3346.734,
              10541.418
            ],
            [
              -3610.443,
              -3396.948,
              10592.099
            ],
            [
              -3607.737,
              -3500.524,
              10695.71
            ],
            [
              -3620.065,
              -3579.347,
              10775.492
            ],
            [
              -3625.467,
              -3630.461,
              10826.89
            ],
            [
              -3640.182,
              -3661.375,
              10861.127
            ],
            [
              -3673.181,
              -3743.178,
              10949.335
            ],
            [
              -3862.172,
              -4125.062,
              11375.426
            ],
            [
              -3875.164,
              -4168.252,
              11420.528
            ],
            [
              -3892.491,
              -4201.348,
              11457.885
            ],
            [
              -3906.204,
              -4248.978,
              11507.449
            ],
            [
              -3915.447,
              -4298.912,
              11558.232
            ],
            [
              -3918.758,
              -4341.156,
              11600.606
            ],
            [
              -3914.159,
              -4410.256,
              11669.858
            ],
            [
              -3903.629,
              -4471.665,
              11732.164
            ],
            [
              -3893.942,
              -4507.456,
              11769.243
            ],
            [
              -3883.947,
              -4525.441,
              11789.819
            ],
            [
              -3876.856,
              -4562.301,
              11827.354
            ],
            [
              -3837.687,
              -4680.982,
              11952.332
            ],
            [
              -3830.05,
              -4723.417,
              11995.449
            ],
            [
              -3816.509,
              -4833.861,
              12106.719
            ],
            [
              -3815.714,
              -4936.291,
              12209.152
            ],
            [
              -3827.361,
              -5087.486,
              12360.795
            ],
            [
              -3833.268,
              -5130.798,
              12404.509
            ],
            [
              -3844.602,
              -5152.866,
              12429.317
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 92.886,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 434.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 661.09,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 1174.476,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5485",
              "position": {
                "x": 2577.544,
                "z": -3870.831
              },
              "distanceAlongShapeM": 2110.665,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5490",
              "position": {
                "x": 2383.36,
                "z": -4363.697
              },
              "distanceAlongShapeM": 2653.623,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5125",
              "position": {
                "x": 1455.5,
                "z": -3532.601
              },
              "distanceAlongShapeM": 4350.245,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5131",
              "position": {
                "x": 442.304,
                "z": -2978.453
              },
              "distanceAlongShapeM": 5532.788,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8463",
              "position": {
                "x": -121.383,
                "z": -2752.193
              },
              "distanceAlongShapeM": 6150.397,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6937",
              "position": {
                "x": -1450.559,
                "z": -2473.275
              },
              "distanceAlongShapeM": 7541.147,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5074",
              "position": {
                "x": -2470.476,
                "z": -2303.737
              },
              "distanceAlongShapeM": 8658.335,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 9197.446,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5137",
              "position": {
                "x": -3175.503,
                "z": -3068.357
              },
              "distanceAlongShapeM": 9781.728,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5063",
              "position": {
                "x": -3662.711,
                "z": -3178.96
              },
              "distanceAlongShapeM": 10367.397,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5140",
              "position": {
                "x": -3625.467,
                "z": -3630.461
              },
              "distanceAlongShapeM": 10826.89,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6925",
              "position": {
                "x": -3883.947,
                "z": -4525.441
              },
              "distanceAlongShapeM": 11789.819,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 12360.795,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            19380,
            20220,
            21060,
            21900,
            22680,
            23400,
            24060,
            24600,
            25380,
            25980,
            26580,
            27060,
            27600,
            28140,
            28680,
            29160,
            29640,
            30120,
            30960,
            31800,
            32640,
            33180,
            33720,
            34260,
            34740,
            35340,
            35940,
            36540,
            37020,
            37680,
            38220,
            38760,
            39240,
            39840,
            40560,
            41340,
            42300,
            43020,
            43680,
            44340,
            45060,
            45720,
            46380,
            47100,
            47700,
            48300,
            49080,
            49860,
            50640,
            51300,
            51960,
            52680,
            53280,
            53940,
            54720,
            55500,
            56280,
            56880,
            57420,
            57840,
            58380,
            58920,
            59460,
            59940,
            60360,
            60840,
            61320,
            61860,
            62400,
            62940,
            63480,
            64020,
            64560,
            65160,
            65820,
            66720,
            67620,
            68460,
            69360,
            70260,
            70920,
            71580,
            72240,
            72900,
            73560,
            74220,
            74880,
            75540,
            76260,
            76980,
            77640,
            78300,
            78960,
            79680,
            80400,
            81120,
            81840,
            82560,
            83280,
            84000,
            84780
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_expressbus_6G",
      "sourceRouteId": "vilnius_expressbus_6G",
      "mode": "bus",
      "shortName": "6G",
      "longName": "Parko–Olandų g.–Žaliasis tiltas",
      "color": "008000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_expressbus_6G:0",
          "sourceRouteId": "vilnius_expressbus_6G",
          "sourceShapeId": "vilnius_expressbus_6G_a-b",
          "directionId": 0,
          "headsign": "Žaliasis tiltas",
          "directionName": "Parko–Olandų g.–Žaliasis tiltas",
          "mode": "bus",
          "routeShortName": "6G",
          "routeLongName": "Parko–Olandų g.–Žaliasis tiltas",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9870.147,
              132.145,
              0
            ],
            [
              9862.137,
              118.949,
              15.437
            ],
            [
              9810.14,
              131.141,
              68.844
            ],
            [
              9748.867,
              131.276,
              130.117
            ],
            [
              9682.346,
              127.063,
              196.772
            ],
            [
              9621.808,
              131.634,
              257.482
            ],
            [
              9517.36,
              133.756,
              361.952
            ],
            [
              9448.882,
              128.466,
              430.634
            ],
            [
              9389.611,
              131.895,
              490.004
            ],
            [
              9156.08,
              129.945,
              723.543
            ],
            [
              9090.691,
              117.908,
              790.031
            ],
            [
              9073.545,
              99.328,
              815.313
            ],
            [
              9049.578,
              94.246,
              839.813
            ],
            [
              8990.008,
              50.917,
              913.474
            ],
            [
              8869.532,
              -70.228,
              1084.327
            ],
            [
              8853.145,
              -83.257,
              1105.262
            ],
            [
              8819.883,
              -101.512,
              1143.204
            ],
            [
              8767.948,
              -118.279,
              1197.778
            ],
            [
              8695.316,
              -137.969,
              1273.032
            ],
            [
              8673.105,
              -151.995,
              1299.301
            ],
            [
              8624.063,
              -153.235,
              1348.359
            ],
            [
              8595.54,
              -160.454,
              1377.782
            ],
            [
              8590.933,
              -197.1,
              1414.716
            ],
            [
              8584.694,
              -314.984,
              1532.765
            ],
            [
              8567.281,
              -539.519,
              1757.974
            ],
            [
              8554.112,
              -617.185,
              1836.749
            ],
            [
              8531.721,
              -672.4,
              1896.331
            ],
            [
              8486.109,
              -663.69,
              1942.767
            ],
            [
              8367.171,
              -581.146,
              2087.542
            ],
            [
              8314.693,
              -528.882,
              2161.606
            ],
            [
              8254.878,
              -456.433,
              2255.556
            ],
            [
              8204.93,
              -406.448,
              2326.219
            ],
            [
              8163.673,
              -373.337,
              2379.12
            ],
            [
              8140.11,
              -358.393,
              2407.023
            ],
            [
              8089.693,
              -331.779,
              2464.033
            ],
            [
              8068.574,
              -323.563,
              2486.693
            ],
            [
              7987.101,
              -301.896,
              2570.999
            ],
            [
              7941.44,
              -295.418,
              2617.117
            ],
            [
              7927.813,
              -299.599,
              2631.371
            ],
            [
              7910.517,
              -293.688,
              2649.649
            ],
            [
              7877.639,
              -293.032,
              2682.534
            ],
            [
              7803.39,
              -297.118,
              2756.895
            ],
            [
              7662.12,
              -331.043,
              2902.182
            ],
            [
              7525.898,
              -370.639,
              3044.042
            ],
            [
              7481.619,
              -392.025,
              3093.215
            ],
            [
              7422.914,
              -425.371,
              3160.729
            ],
            [
              7391.551,
              -445.901,
              3198.214
            ],
            [
              7274.84,
              -542.67,
              3349.824
            ],
            [
              7223.786,
              -580.623,
              3413.44
            ],
            [
              7148.018,
              -629.221,
              3503.455
            ],
            [
              7093.297,
              -657.084,
              3564.861
            ],
            [
              6995.189,
              -694.109,
              3669.723
            ],
            [
              6921.973,
              -711.59,
              3744.996
            ],
            [
              6856.67,
              -720.321,
              3810.881
            ],
            [
              6795.988,
              -723.577,
              3871.65
            ],
            [
              6712.188,
              -721.926,
              3955.466
            ],
            [
              6649.147,
              -714.005,
              4019.003
            ],
            [
              6571.433,
              -698.004,
              4098.347
            ],
            [
              6523.349,
              -683.7,
              4148.514
            ],
            [
              6449.764,
              -654.422,
              4227.709
            ],
            [
              6436.249,
              -653.044,
              4241.295
            ],
            [
              6365.394,
              -616.028,
              4321.236
            ],
            [
              6247.14,
              -562.5,
              4451.04
            ],
            [
              6102.584,
              -501.78,
              4607.831
            ],
            [
              6033.375,
              -479.275,
              4680.607
            ],
            [
              5958.9,
              -462.234,
              4757.007
            ],
            [
              5902.989,
              -452.237,
              4813.805
            ],
            [
              5819.293,
              -445.038,
              4897.81
            ],
            [
              5710.368,
              -441.803,
              5006.783
            ],
            [
              5691.565,
              -447.003,
              5026.292
            ],
            [
              5642.614,
              -443.824,
              5075.345
            ],
            [
              5383.59,
              -465.511,
              5335.276
            ],
            [
              5245.719,
              -491.784,
              5475.628
            ],
            [
              5168.103,
              -503.64,
              5554.144
            ],
            [
              5099.964,
              -525.701,
              5625.766
            ],
            [
              5024.562,
              -556.529,
              5707.226
            ],
            [
              4957.541,
              -587.519,
              5781.065
            ],
            [
              4906.057,
              -615.47,
              5839.647
            ],
            [
              4828.015,
              -649.59,
              5924.821
            ],
            [
              4765.144,
              -666.191,
              5989.847
            ],
            [
              4704.378,
              -673.927,
              6051.104
            ],
            [
              4650.166,
              -676.224,
              6105.364
            ],
            [
              4614.755,
              -673.316,
              6140.895
            ],
            [
              4552.441,
              -660.985,
              6204.417
            ],
            [
              4508.24,
              -645.664,
              6251.199
            ],
            [
              4426.454,
              -606.243,
              6341.989
            ],
            [
              4266.373,
              -479.602,
              6546.106
            ],
            [
              4205.92,
              -437.254,
              6619.916
            ],
            [
              4102.373,
              -355.119,
              6752.084
            ],
            [
              4073.746,
              -334.533,
              6787.344
            ],
            [
              4021.499,
              -301.251,
              6849.291
            ],
            [
              3924.337,
              -255.979,
              6956.482
            ],
            [
              3871.834,
              -236.053,
              7012.639
            ],
            [
              3794.896,
              -212.322,
              7093.154
            ],
            [
              3748.025,
              -201.41,
              7141.278
            ],
            [
              3692.751,
              -191.452,
              7197.442
            ],
            [
              3533.915,
              -167.282,
              7358.107
            ],
            [
              3462.629,
              -151.456,
              7431.128
            ],
            [
              3392.114,
              -128.967,
              7505.143
            ],
            [
              3376.313,
              -111.969,
              7528.351
            ],
            [
              3343.728,
              -95.766,
              7564.742
            ],
            [
              3282.595,
              -54.531,
              7638.481
            ],
            [
              2977.671,
              191.693,
              8030.407
            ],
            [
              2941.964,
              213.518,
              8072.256
            ],
            [
              2918.591,
              239.564,
              8107.251
            ],
            [
              2850.195,
              306.534,
              8202.975
            ],
            [
              2697.486,
              451.904,
              8413.811
            ],
            [
              2677.062,
              463.42,
              8437.258
            ],
            [
              2649.901,
              493.988,
              8478.15
            ],
            [
              2582.473,
              544.237,
              8562.242
            ],
            [
              2413.667,
              623.104,
              8748.564
            ],
            [
              2393.054,
              624.603,
              8769.231
            ],
            [
              2378.182,
              622.655,
              8784.23
            ],
            [
              2363.247,
              617.369,
              8800.073
            ],
            [
              2305.672,
              573.917,
              8872.205
            ],
            [
              2269.605,
              542.307,
              8920.163
            ],
            [
              2256.376,
              524.743,
              8942.152
            ],
            [
              2223.804,
              507.54,
              8978.988
            ],
            [
              1990.962,
              334.88,
              9268.861
            ],
            [
              1973.014,
              306.27,
              9302.635
            ],
            [
              1935.827,
              283.585,
              9346.195
            ],
            [
              1864.599,
              199.192,
              9456.629
            ],
            [
              1763.619,
              40.763,
              9644.503
            ],
            [
              1759.816,
              9.663,
              9675.834
            ],
            [
              1734.841,
              -15.477,
              9711.271
            ],
            [
              1714.048,
              -58.507,
              9759.062
            ],
            [
              1702.489,
              -90.576,
              9793.151
            ],
            [
              1692.553,
              -139.375,
              9842.95
            ],
            [
              1696.284,
              -216.258,
              9919.924
            ],
            [
              1701.445,
              -250.864,
              9954.913
            ],
            [
              1720.689,
              -325.809,
              10032.289
            ],
            [
              1735.144,
              -346.116,
              10057.215
            ],
            [
              1742.617,
              -429.749,
              10141.181
            ],
            [
              1739.19,
              -475.328,
              10186.889
            ],
            [
              1717.531,
              -565.098,
              10279.235
            ],
            [
              1721.402,
              -599.681,
              10314.034
            ],
            [
              1716.683,
              -610.725,
              10326.044
            ],
            [
              1700.984,
              -622.679,
              10345.776
            ],
            [
              1670.687,
              -622.116,
              10376.079
            ],
            [
              1655.278,
              -618.49,
              10391.908
            ],
            [
              1647.146,
              -604.98,
              10407.677
            ],
            [
              1647.435,
              -589.4,
              10423.26
            ],
            [
              1641.361,
              -569.249,
              10444.307
            ],
            [
              1626.241,
              -550.043,
              10468.75
            ],
            [
              1608.96,
              -543.043,
              10487.395
            ],
            [
              1585.646,
              -513.666,
              10524.899
            ],
            [
              1220.098,
              -229.7,
              10987.783
            ],
            [
              1131.659,
              -164.612,
              11097.592
            ],
            [
              1087.044,
              -135.958,
              11150.616
            ],
            [
              1060.09,
              -128.781,
              11178.509
            ],
            [
              1042.305,
              -113.981,
              11201.646
            ],
            [
              992.552,
              -84.12,
              11259.673
            ],
            [
              920.398,
              -44.941,
              11341.778
            ],
            [
              797.689,
              -19.306,
              11467.136
            ],
            [
              670.384,
              1.958,
              11596.204
            ],
            [
              652.936,
              0.051,
              11613.756
            ],
            [
              630.873,
              -7.336,
              11637.023
            ],
            [
              604.636,
              -31.346,
              11672.588
            ],
            [
              564.962,
              -49.544,
              11716.237
            ],
            [
              476.44,
              -129.188,
              11835.314
            ],
            [
              402.286,
              -199.078,
              11937.212
            ],
            [
              346.776,
              -237.026,
              12004.454
            ],
            [
              281.176,
              -262.545,
              12074.843
            ],
            [
              119.684,
              -277.409,
              12237.018
            ],
            [
              130.203,
              -407.85,
              12367.882
            ],
            [
              150.182,
              -443.837,
              12409.044
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 196.772,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 430.634,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 815.313,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 1299.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5400",
              "position": {
                "x": 8486.109,
                "z": -663.69
              },
              "distanceAlongShapeM": 1942.767,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6729",
              "position": {
                "x": 7927.813,
                "z": -299.599
              },
              "distanceAlongShapeM": 2631.371,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5424",
              "position": {
                "x": 2941.964,
                "z": 213.518
              },
              "distanceAlongShapeM": 8072.256,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 8942.152,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 9302.635,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 10487.395,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 11672.588,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 12409.044,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            18840,
            19200,
            19620,
            20040,
            20460,
            20940,
            21420,
            21960,
            22440,
            22860,
            23280,
            23700,
            24120,
            24540,
            25020,
            25500,
            26040,
            26520,
            27000,
            27480,
            27960,
            28440,
            28800,
            29220,
            29580,
            29940,
            30660,
            31500,
            32340,
            33180,
            34020,
            34680,
            35340,
            36240,
            37080,
            37620,
            38160,
            38700,
            39240,
            39780,
            40320,
            40800,
            41340,
            41880,
            42420,
            42960,
            43500,
            44040,
            44580,
            45060,
            45600,
            46080,
            46620,
            47160,
            47640,
            48180,
            48720,
            49200,
            49740,
            50280,
            50820,
            51300,
            51780,
            52260,
            52680,
            53100,
            53520,
            53940,
            54420,
            54900,
            55380,
            55860,
            56340,
            56820,
            57300,
            57780,
            58260,
            58740,
            59220,
            59700,
            60180,
            60720,
            61260,
            61800,
            62340,
            62880,
            63420,
            63960,
            64620,
            65280,
            66120,
            66900,
            67680,
            68460,
            69360,
            70260,
            70920,
            71520,
            72060,
            72600,
            73140,
            73680,
            74160,
            74700,
            75180,
            75660,
            76140,
            76620,
            77160,
            77700,
            78240,
            78780,
            79320,
            79860,
            80400,
            80940,
            81480,
            82020,
            82560,
            83100
          ]
        },
        {
          "id": "judu:pattern:vilnius_expressbus_6G:1",
          "sourceRouteId": "vilnius_expressbus_6G",
          "sourceShapeId": "vilnius_expressbus_6G_b-a",
          "directionId": 1,
          "headsign": "Parko g.",
          "directionName": "Žaliasis tiltas–Olandų–Parko g.",
          "mode": "bus",
          "routeShortName": "6G",
          "routeLongName": "Parko–Olandų g.–Žaliasis tiltas",
          "routeColor": "008000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              150.182,
              -443.837,
              0
            ],
            [
              177.186,
              -518.917,
              79.788
            ],
            [
              186.708,
              -562.507,
              124.406
            ],
            [
              214.213,
              -645.388,
              211.732
            ],
            [
              224.323,
              -656.705,
              226.908
            ],
            [
              237.149,
              -695.903,
              268.15
            ],
            [
              292.85,
              -682.448,
              325.453
            ],
            [
              331.506,
              -684.268,
              364.152
            ],
            [
              436.802,
              -673.948,
              469.952
            ],
            [
              647.48,
              -719,
              685.393
            ],
            [
              692.52,
              -724.28,
              730.742
            ],
            [
              729.304,
              -722.729,
              767.558
            ],
            [
              752.305,
              -734.284,
              793.299
            ],
            [
              1031.058,
              -793.963,
              1078.369
            ],
            [
              1157.03,
              -816.326,
              1206.31
            ],
            [
              1200.176,
              -819.349,
              1249.562
            ],
            [
              1220.015,
              -827.509,
              1271.013
            ],
            [
              1248.96,
              -831.383,
              1300.216
            ],
            [
              1306.39,
              -829.106,
              1357.692
            ],
            [
              1381.451,
              -814.909,
              1434.084
            ],
            [
              1608.787,
              -656.591,
              1711.115
            ],
            [
              1644.195,
              -624.964,
              1758.591
            ],
            [
              1650.286,
              -609.492,
              1775.219
            ],
            [
              1647.435,
              -589.4,
              1795.512
            ],
            [
              1649.076,
              -570.506,
              1814.478
            ],
            [
              1661.593,
              -556.266,
              1833.436
            ],
            [
              1707.61,
              -543.762,
              1881.122
            ],
            [
              1715.531,
              -533.89,
              1893.779
            ],
            [
              1739.19,
              -475.328,
              1956.94
            ],
            [
              1739.832,
              -440.829,
              1991.445
            ],
            [
              1737.688,
              -417.411,
              2014.961
            ],
            [
              1728.721,
              -379.394,
              2054.021
            ],
            [
              1714.349,
              -354.636,
              2082.648
            ],
            [
              1709.957,
              -313.364,
              2124.153
            ],
            [
              1701.073,
              -270.896,
              2167.541
            ],
            [
              1691.292,
              -207.259,
              2231.925
            ],
            [
              1692.553,
              -139.375,
              2299.821
            ],
            [
              1699.889,
              -91.641,
              2348.114
            ],
            [
              1722.281,
              -31.942,
              2411.875
            ],
            [
              1763.619,
              40.763,
              2495.51
            ],
            [
              1781.292,
              89.417,
              2547.275
            ],
            [
              1803.689,
              114.605,
              2580.98
            ],
            [
              1864.141,
              209.22,
              2693.258
            ],
            [
              1913.636,
              269.526,
              2771.275
            ],
            [
              1990.962,
              334.88,
              2872.519
            ],
            [
              2015.503,
              371.16,
              2916.319
            ],
            [
              2052.586,
              388.28,
              2957.164
            ],
            [
              2087.216,
              412.125,
              2999.21
            ],
            [
              2136.967,
              451.273,
              3062.516
            ],
            [
              2182.309,
              496.069,
              3126.254
            ],
            [
              2210.658,
              528.937,
              3169.659
            ],
            [
              2229.877,
              556.409,
              3203.187
            ],
            [
              2244.749,
              592.868,
              3242.562
            ],
            [
              2266.569,
              621.404,
              3278.484
            ],
            [
              2281.67,
              670.105,
              3329.473
            ],
            [
              2292.591,
              736.695,
              3396.953
            ],
            [
              2303.283,
              756.534,
              3419.489
            ],
            [
              2315.701,
              765.207,
              3434.636
            ],
            [
              2333.819,
              768.208,
              3453
            ],
            [
              2353.101,
              764.507,
              3472.635
            ],
            [
              2377.645,
              731.764,
              3513.556
            ],
            [
              2411.777,
              694.387,
              3564.172
            ],
            [
              2432.805,
              680.634,
              3589.298
            ],
            [
              2453.583,
              653.527,
              3623.453
            ],
            [
              2501.276,
              617.009,
              3683.521
            ],
            [
              2634.367,
              525.451,
              3845.064
            ],
            [
              2716.164,
              450.439,
              3956.048
            ],
            [
              2739.748,
              435.524,
              3983.953
            ],
            [
              2755.449,
              412.963,
              4011.439
            ],
            [
              2864.4,
              307.38,
              4163.156
            ],
            [
              2936.644,
              239.224,
              4262.476
            ],
            [
              2983.62,
              199.374,
              4324.078
            ],
            [
              3035.88,
              166.104,
              4386.03
            ],
            [
              3060.52,
              138.92,
              4422.719
            ],
            [
              3266.423,
              -23.054,
              4684.695
            ],
            [
              3339.574,
              -76.762,
              4775.445
            ],
            [
              3415.597,
              -114.94,
              4860.516
            ],
            [
              3440.614,
              -122.094,
              4886.536
            ],
            [
              3506.161,
              -134.47,
              4953.242
            ],
            [
              3501.543,
              -139.949,
              4960.407
            ],
            [
              3709.123,
              -178.405,
              5171.519
            ],
            [
              3787.457,
              -196.594,
              5251.937
            ],
            [
              3851.65,
              -212.29,
              5318.021
            ],
            [
              3930.415,
              -241.623,
              5402.071
            ],
            [
              4021.131,
              -286.771,
              5503.401
            ],
            [
              4084.273,
              -323.602,
              5576.5
            ],
            [
              4201.401,
              -403.77,
              5718.436
            ],
            [
              4231.381,
              -421.043,
              5753.035
            ],
            [
              4243.975,
              -436.869,
              5773.262
            ],
            [
              4278.232,
              -466.47,
              5818.536
            ],
            [
              4369.718,
              -538.359,
              5934.887
            ],
            [
              4422.518,
              -576.109,
              5999.794
            ],
            [
              4472.265,
              -604.896,
              6057.27
            ],
            [
              4515.715,
              -625.769,
              6105.474
            ],
            [
              4558.025,
              -638.827,
              6149.753
            ],
            [
              4617.783,
              -649.996,
              6210.545
            ],
            [
              4673.822,
              -653.3,
              6266.682
            ],
            [
              4729.99,
              -649.928,
              6322.951
            ],
            [
              4754.55,
              -647.061,
              6347.678
            ],
            [
              4785.642,
              -639.867,
              6379.591
            ],
            [
              4844.087,
              -618.728,
              6441.742
            ],
            [
              5036.703,
              -528.931,
              6654.261
            ],
            [
              5111.461,
              -498.092,
              6735.13
            ],
            [
              5156.243,
              -483.372,
              6782.269
            ],
            [
              5224.275,
              -466.876,
              6852.273
            ],
            [
              5273.441,
              -458.923,
              6902.078
            ],
            [
              5284.486,
              -454.683,
              6913.909
            ],
            [
              5327.098,
              -452.169,
              6956.594
            ],
            [
              5348.35,
              -453.695,
              6977.901
            ],
            [
              5548.153,
              -426.402,
              7179.559
            ],
            [
              5629.574,
              -417.965,
              7261.417
            ],
            [
              5749.654,
              -411.396,
              7381.676
            ],
            [
              5806.942,
              -416.966,
              7439.234
            ],
            [
              5963.202,
              -440.053,
              7597.191
            ],
            [
              5998.528,
              -447.422,
              7633.277
            ],
            [
              6073.561,
              -468.928,
              7711.331
            ],
            [
              6189.436,
              -512.386,
              7835.088
            ],
            [
              6360.739,
              -590.332,
              8023.29
            ],
            [
              6402.87,
              -612.311,
              8070.809
            ],
            [
              6557.754,
              -672.13,
              8236.844
            ],
            [
              6602.659,
              -684.146,
              8283.329
            ],
            [
              6682.351,
              -697.96,
              8364.209
            ],
            [
              6780.934,
              -702.128,
              8462.88
            ],
            [
              6864.177,
              -699.316,
              8546.171
            ],
            [
              6937.971,
              -685.187,
              8621.306
            ],
            [
              7035.236,
              -658.162,
              8722.255
            ],
            [
              7126.343,
              -616.546,
              8822.416
            ],
            [
              7192.221,
              -578.885,
              8898.3
            ],
            [
              7263.567,
              -525.747,
              8987.26
            ],
            [
              7363.253,
              -442,
              9117.455
            ],
            [
              7412.953,
              -407.361,
              9178.035
            ],
            [
              7461.255,
              -378.261,
              9234.425
            ],
            [
              7507.446,
              -358.026,
              9284.855
            ],
            [
              7566.531,
              -338.048,
              9347.226
            ],
            [
              7666.431,
              -308.863,
              9451.301
            ],
            [
              7747.458,
              -288.21,
              9534.92
            ],
            [
              7874.837,
              -271.823,
              9663.348
            ],
            [
              7914.141,
              -273.721,
              9702.697
            ],
            [
              7971.362,
              -282.656,
              9760.612
            ],
            [
              8031.717,
              -296.108,
              9822.448
            ],
            [
              8097.029,
              -319.679,
              9891.883
            ],
            [
              8139.799,
              -341.687,
              9939.984
            ],
            [
              8190.705,
              -376.104,
              10001.432
            ],
            [
              8213.534,
              -395.487,
              10031.38
            ],
            [
              8367.171,
              -581.146,
              10272.365
            ],
            [
              8434.632,
              -625.918,
              10353.33
            ],
            [
              8481.22,
              -650.233,
              10405.882
            ],
            [
              8531.721,
              -672.4,
              10461.034
            ],
            [
              8539.64,
              -631.367,
              10502.824
            ],
            [
              8559.188,
              -557.169,
              10579.553
            ],
            [
              8576.654,
              -426.152,
              10711.73
            ],
            [
              8584.228,
              -306.068,
              10832.052
            ],
            [
              8588.332,
              -198.161,
              10940.037
            ],
            [
              8595.54,
              -160.454,
              10978.427
            ],
            [
              8696.05,
              -133.53,
              11082.481
            ],
            [
              8718.239,
              -120.617,
              11108.154
            ],
            [
              8744.049,
              -120.024,
              11133.971
            ],
            [
              8789.403,
              -109.804,
              11180.462
            ],
            [
              8826.443,
              -96.078,
              11219.963
            ],
            [
              8853.145,
              -83.257,
              11249.584
            ],
            [
              8900.484,
              -38.566,
              11314.686
            ],
            [
              8997.947,
              60.777,
              11453.855
            ],
            [
              9045.087,
              95.45,
              11512.373
            ],
            [
              9064.009,
              106.201,
              11534.136
            ],
            [
              9090.691,
              117.908,
              11563.273
            ],
            [
              9116.151,
              132.979,
              11592.859
            ],
            [
              9141.918,
              131.345,
              11618.678
            ],
            [
              9732.975,
              142.732,
              12209.845
            ],
            [
              9774.103,
              135.215,
              12251.654
            ],
            [
              9799.87,
              133.577,
              12277.473
            ],
            [
              9819.925,
              136.508,
              12297.741
            ],
            [
              9849.832,
              148.145,
              12329.833
            ],
            [
              9862.037,
              145.67,
              12342.286
            ],
            [
              9870.147,
              132.145,
              12358.056
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 325.453,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6660",
              "position": {
                "x": 1200.176,
                "z": -819.349
              },
              "distanceAlongShapeM": 1249.562,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 2082.648,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 2916.319,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 3242.562,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5372",
              "position": {
                "x": 3035.88,
                "z": 166.104
              },
              "distanceAlongShapeM": 4386.03,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 750,
              "departureOffsetSeconds": 750
            },
            {
              "stopId": "judu:stop:6727",
              "position": {
                "x": 7874.837,
                "z": -271.823
              },
              "distanceAlongShapeM": 9663.348,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6225",
              "position": {
                "x": 8539.64,
                "z": -631.367
              },
              "distanceAlongShapeM": 10502.824,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 11108.154,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 11592.859,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 12029.758,
              "shapeOffsetM": 0.663,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7444",
              "position": {
                "x": 9732.975,
                "z": 142.732
              },
              "distanceAlongShapeM": 12209.845,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            20340,
            20700,
            21120,
            21540,
            21960,
            22500,
            22980,
            23520,
            24000,
            24420,
            24900,
            25320,
            25800,
            26280,
            26760,
            27240,
            27780,
            28260,
            28740,
            29220,
            29760,
            30240,
            30600,
            31020,
            31380,
            31740,
            32460,
            33180,
            34020,
            34860,
            35700,
            36360,
            36960,
            37860,
            38700,
            39240,
            39780,
            40320,
            40860,
            41400,
            41940,
            42420,
            42960,
            43500,
            44040,
            44580,
            45120,
            45660,
            46200,
            46680,
            47220,
            47700,
            48240,
            48780,
            49260,
            49800,
            50340,
            50880,
            51420,
            51960,
            52500,
            52980,
            53460,
            53940,
            54360,
            54780,
            55200,
            55620,
            56100,
            56580,
            57060,
            57540,
            58020,
            58560,
            59040,
            59520,
            60000,
            60480,
            60960,
            61440,
            61920,
            62460,
            63000,
            63540,
            64080,
            64620,
            65160,
            65640,
            66300,
            66960,
            67800,
            68580,
            69300,
            70080,
            70980,
            71880,
            72540,
            73080,
            73620,
            74160,
            74700,
            75240,
            75720,
            76260,
            76740,
            77220,
            77700,
            78180,
            78720,
            79200,
            79740,
            80280,
            80820,
            81360,
            81900,
            82440,
            82980,
            83520,
            84000,
            84540
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_7",
      "sourceRouteId": "vilnius_bus_7",
      "mode": "bus",
      "shortName": "7",
      "longName": "Šiaurės miestelis–Verkių g.–Viršuliškės–Lazdynai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_7:0",
          "sourceRouteId": "vilnius_bus_7",
          "sourceShapeId": "vilnius_bus_7_a-b",
          "directionId": 0,
          "headsign": "Lazdynai",
          "directionName": "Šiaurės miestelis–Verkių g.–Viršuliškės–Lazdynai",
          "mode": "bus",
          "routeShortName": "7",
          "routeLongName": "Šiaurės miestelis–Verkių g.–Viršuliškės–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1412.698,
              -2538.791,
              0
            ],
            [
              1427.807,
              -2523.486,
              21.507
            ],
            [
              1492.99,
              -2519.128,
              86.835
            ],
            [
              1524.687,
              -2513.037,
              119.112
            ],
            [
              1547.822,
              -2516.806,
              142.552
            ],
            [
              1556.615,
              -2529.215,
              157.761
            ],
            [
              1556.64,
              -2562.613,
              191.158
            ],
            [
              1562.253,
              -2572.736,
              202.734
            ],
            [
              1574.454,
              -2575.189,
              215.179
            ],
            [
              1684.596,
              -2579.462,
              325.404
            ],
            [
              1689.647,
              -2585.122,
              332.99
            ],
            [
              1696.386,
              -2638.684,
              386.973
            ],
            [
              1690.652,
              -2669.748,
              418.563
            ],
            [
              1690.731,
              -2873.474,
              622.289
            ],
            [
              1700.851,
              -3126.37,
              875.387
            ],
            [
              1709.563,
              -3177.741,
              927.492
            ],
            [
              1701.896,
              -3208.77,
              959.453
            ],
            [
              1697.306,
              -3247.648,
              998.602
            ],
            [
              1679.831,
              -3286.287,
              1041.008
            ],
            [
              1593.247,
              -3437.193,
              1214.989
            ],
            [
              1582.257,
              -3473.726,
              1253.139
            ],
            [
              1566.424,
              -3493.47,
              1278.448
            ],
            [
              1509.807,
              -3592.611,
              1392.617
            ],
            [
              1412.221,
              -3746.656,
              1574.97
            ],
            [
              1401.002,
              -3760.92,
              1593.118
            ],
            [
              1342.825,
              -3805.485,
              1666.402
            ],
            [
              1325.974,
              -3810.739,
              1684.054
            ],
            [
              1219.986,
              -3862.213,
              1801.879
            ],
            [
              1096.287,
              -3756.395,
              1964.665
            ],
            [
              1090.736,
              -3742.933,
              1979.226
            ],
            [
              1084.896,
              -3640.407,
              2081.919
            ],
            [
              1091.873,
              -3611.591,
              2111.567
            ],
            [
              1094.401,
              -3579.354,
              2143.903
            ],
            [
              1093.805,
              -3506.982,
              2216.278
            ],
            [
              1085.19,
              -3450.047,
              2273.86
            ],
            [
              1055.574,
              -3343.742,
              2384.214
            ],
            [
              1027.41,
              -3228.558,
              2502.791
            ],
            [
              978.337,
              -3198.709,
              2560.23
            ],
            [
              945.685,
              -3186.974,
              2594.926
            ],
            [
              931.778,
              -3172.246,
              2615.183
            ],
            [
              710.47,
              -3045.716,
              2870.108
            ],
            [
              679.709,
              -3036.244,
              2902.295
            ],
            [
              665.217,
              -3018.166,
              2925.464
            ],
            [
              624.331,
              -2998.49,
              2970.839
            ],
            [
              521.572,
              -2978.793,
              3075.468
            ],
            [
              442.304,
              -2978.453,
              3154.737
            ],
            [
              342.529,
              -2936.549,
              3262.954
            ],
            [
              249.744,
              -2864.719,
              3380.294
            ],
            [
              215.338,
              -2842.938,
              3421.015
            ],
            [
              172.556,
              -2821.005,
              3469.092
            ],
            [
              116.826,
              -2802.176,
              3527.916
            ],
            [
              -65.348,
              -2754.326,
              3716.269
            ],
            [
              -121.383,
              -2752.193,
              3772.345
            ],
            [
              -224.17,
              -2733.625,
              3876.796
            ],
            [
              -312.321,
              -2725.345,
              3965.335
            ],
            [
              -534.611,
              -2721.315,
              4187.662
            ],
            [
              -763.526,
              -2727.196,
              4416.652
            ],
            [
              -847.912,
              -2724.56,
              4501.079
            ],
            [
              -963.025,
              -2710.24,
              4617.079
            ],
            [
              -1021.438,
              -2696.943,
              4676.986
            ],
            [
              -1084.241,
              -2676.889,
              4742.914
            ],
            [
              -1158.443,
              -2645.498,
              4823.483
            ],
            [
              -1386.622,
              -2502.251,
              5092.899
            ],
            [
              -1450.559,
              -2473.275,
              5163.095
            ],
            [
              -1488.158,
              -2449.225,
              5207.728
            ],
            [
              -1548.409,
              -2430.336,
              5270.871
            ],
            [
              -1640.314,
              -2415.335,
              5363.993
            ],
            [
              -1771.001,
              -2406.324,
              5494.99
            ],
            [
              -1888.235,
              -2402.009,
              5612.304
            ],
            [
              -1933.866,
              -2394.517,
              5658.545
            ],
            [
              -2056.217,
              -2387.889,
              5781.075
            ],
            [
              -2112.099,
              -2376.878,
              5838.032
            ],
            [
              -2168.467,
              -2356.953,
              5897.818
            ],
            [
              -2220.425,
              -2342.673,
              5951.702
            ],
            [
              -2472.07,
              -2248.048,
              6220.551
            ],
            [
              -2531.314,
              -2244.774,
              6279.885
            ],
            [
              -2551.192,
              -2238.857,
              6300.625
            ],
            [
              -2575.188,
              -2210.603,
              6337.693
            ],
            [
              -2621.185,
              -2114.055,
              6444.639
            ],
            [
              -2635.944,
              -2073.719,
              6487.59
            ],
            [
              -2636.896,
              -2018.041,
              6543.276
            ],
            [
              -2630.036,
              -1958.048,
              6603.66
            ],
            [
              -2627.177,
              -1869.041,
              6692.713
            ],
            [
              -2627.347,
              -1805.585,
              6756.169
            ],
            [
              -2628.381,
              -1791.095,
              6770.696
            ],
            [
              -2639.18,
              -1781.999,
              6784.816
            ],
            [
              -2733.191,
              -1775.889,
              6879.025
            ],
            [
              -2793.887,
              -1781.5,
              6939.98
            ],
            [
              -2841.812,
              -1794.015,
              6989.512
            ],
            [
              -2867.844,
              -1808.029,
              7019.077
            ],
            [
              -2934.027,
              -1832.47,
              7089.629
            ],
            [
              -3144.971,
              -1987.959,
              7351.686
            ],
            [
              -3184.69,
              -2010.641,
              7397.425
            ],
            [
              -3221.031,
              -2024.476,
              7436.311
            ],
            [
              -3255.341,
              -2032.781,
              7471.611
            ],
            [
              -3305.078,
              -2038.591,
              7521.686
            ],
            [
              -3365.672,
              -2038.645,
              7582.281
            ],
            [
              -3375.166,
              -1991.724,
              7630.152
            ],
            [
              -3374.974,
              -1943.859,
              7678.018
            ],
            [
              -3391.774,
              -1872.32,
              7751.503
            ],
            [
              -3430.979,
              -1754.748,
              7875.439
            ],
            [
              -3480.186,
              -1619.191,
              8019.651
            ],
            [
              -3508.003,
              -1550.799,
              8093.483
            ],
            [
              -3525.544,
              -1521.55,
              8127.589
            ],
            [
              -3534.455,
              -1477.979,
              8172.061
            ],
            [
              -3620.717,
              -1211.532,
              8452.124
            ],
            [
              -3662.686,
              -1103.933,
              8567.618
            ],
            [
              -3680.758,
              -1067.996,
              8607.844
            ],
            [
              -3686.114,
              -1042.299,
              8634.093
            ],
            [
              -3720.918,
              -930.373,
              8751.306
            ],
            [
              -3751.541,
              -837.444,
              8849.15
            ],
            [
              -3761.526,
              -818.346,
              8870.701
            ],
            [
              -3766.218,
              -791.548,
              8897.907
            ],
            [
              -3793.988,
              -719.82,
              8974.823
            ],
            [
              -3843.779,
              -616.54,
              9089.478
            ],
            [
              -3881.258,
              -546.871,
              9168.589
            ],
            [
              -3968.98,
              -399.519,
              9340.075
            ],
            [
              -3986.683,
              -379.175,
              9367.044
            ],
            [
              -3999.719,
              -350.005,
              9398.993
            ],
            [
              -4048.201,
              -282.373,
              9482.208
            ],
            [
              -4133.499,
              -180.709,
              9614.915
            ],
            [
              -4196.245,
              -117.285,
              9704.133
            ],
            [
              -4221.08,
              -99.045,
              9734.947
            ],
            [
              -4243.751,
              -67.483,
              9773.806
            ],
            [
              -4402.336,
              85.535,
              9994.178
            ],
            [
              -4449.086,
              142,
              10067.485
            ],
            [
              -4479.797,
              193.736,
              10127.65
            ],
            [
              -4502.905,
              237.549,
              10177.183
            ],
            [
              -4519.036,
              274.562,
              10217.558
            ],
            [
              -4536.228,
              324.952,
              10270.8
            ],
            [
              -4547.048,
              370.78,
              10317.888
            ],
            [
              -4566.578,
              510.266,
              10458.734
            ],
            [
              -4574.501,
              537.119,
              10486.732
            ],
            [
              -4575.517,
              590.57,
              10540.193
            ],
            [
              -4579.623,
              651.866,
              10601.627
            ],
            [
              -4586.366,
              709.869,
              10660.02
            ],
            [
              -4584.541,
              741.007,
              10691.211
            ],
            [
              -4573.306,
              794.248,
              10745.625
            ],
            [
              -4555.909,
              830.684,
              10786.001
            ],
            [
              -4554.824,
              856.269,
              10811.609
            ],
            [
              -4566.917,
              903.232,
              10860.103
            ],
            [
              -4569.191,
              921.082,
              10878.098
            ],
            [
              -4557.807,
              945.377,
              10904.927
            ],
            [
              -4520.63,
              969.228,
              10949.097
            ],
            [
              -4517.841,
              981.425,
              10961.609
            ],
            [
              -4524.608,
              1000.466,
              10981.817
            ],
            [
              -4563.16,
              1046.77,
              11042.069
            ],
            [
              -4607.63,
              1086.496,
              11101.7
            ],
            [
              -4747.102,
              1153.456,
              11256.412
            ],
            [
              -4804.625,
              1184.498,
              11321.777
            ],
            [
              -4849.214,
              1217.545,
              11377.277
            ],
            [
              -4874.57,
              1243.583,
              11413.621
            ],
            [
              -4893.764,
              1252.817,
              11434.921
            ],
            [
              -4923.976,
              1296.749,
              11488.238
            ],
            [
              -4964.695,
              1367.577,
              11569.937
            ],
            [
              -4983.262,
              1413.535,
              11619.504
            ],
            [
              -4991.189,
              1440.387,
              11647.502
            ],
            [
              -5000.423,
              1503.997,
              11711.779
            ],
            [
              -5002.868,
              1549.68,
              11757.527
            ],
            [
              -5001.995,
              1563.024,
              11770.899
            ],
            [
              -4994.33,
              1596.289,
              11805.036
            ],
            [
              -4987.652,
              1609.533,
              11819.868
            ],
            [
              -4906.917,
              1690.529,
              11934.23
            ],
            [
              -4842.797,
              1742.865,
              12016.996
            ],
            [
              -4801.101,
              1766.641,
              12064.995
            ],
            [
              -4774.467,
              1777.316,
              12093.689
            ],
            [
              -4728.427,
              1790.998,
              12141.719
            ],
            [
              -4687.68,
              1796.979,
              12182.902
            ],
            [
              -4579.155,
              1805.134,
              12291.734
            ],
            [
              -4547.361,
              1815.72,
              12325.244
            ],
            [
              -4518.395,
              1811.882,
              12354.463
            ],
            [
              -4369.14,
              1824.898,
              12504.284
            ],
            [
              -4282.619,
              1828.972,
              12590.901
            ],
            [
              -4232.446,
              1820.314,
              12641.815
            ],
            [
              -4165.014,
              1802.452,
              12711.573
            ],
            [
              -4141.304,
              1793.136,
              12737.047
            ],
            [
              -4122.773,
              1782.797,
              12758.267
            ],
            [
              -4066.123,
              1738.403,
              12830.241
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 119.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 386.973,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 927.492,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 1253.139,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 1666.402,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5022",
              "position": {
                "x": 1084.896,
                "z": -3640.407
              },
              "distanceAlongShapeM": 2081.919,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5127",
              "position": {
                "x": 945.685,
                "z": -3186.974
              },
              "distanceAlongShapeM": 2594.926,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5131",
              "position": {
                "x": 442.304,
                "z": -2978.453
              },
              "distanceAlongShapeM": 3154.737,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:8463",
              "position": {
                "x": -121.383,
                "z": -2752.193
              },
              "distanceAlongShapeM": 3772.345,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6937",
              "position": {
                "x": -1450.559,
                "z": -2473.275
              },
              "distanceAlongShapeM": 5163.095,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:19157",
              "position": {
                "x": -2402.929,
                "z": -2274.874
              },
              "distanceAlongShapeM": 6146.392,
              "shapeOffsetM": 0.775,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:16691",
              "position": {
                "x": -2636.896,
                "z": -2018.041
              },
              "distanceAlongShapeM": 6543.276,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5613",
              "position": {
                "x": -2867.844,
                "z": -1808.029
              },
              "distanceAlongShapeM": 7019.077,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5620",
              "position": {
                "x": -3375.166,
                "z": -1991.724
              },
              "distanceAlongShapeM": 7630.152,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 8127.589,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 8607.844,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 8870.701,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 9367.044,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 9734.947,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 10486.732,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:16703",
              "position": {
                "x": -4563.16,
                "z": 1046.77
              },
              "distanceAlongShapeM": 11042.069,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5672",
              "position": {
                "x": -4893.764,
                "z": 1252.817
              },
              "distanceAlongShapeM": 11434.921,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 12325.244,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 12830.241,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            }
          ],
          "departuresSeconds": [
            18540,
            19500,
            20400,
            21300,
            22020,
            22740,
            23460,
            24180,
            24720,
            25320,
            25860,
            26400,
            26940,
            27480,
            28200,
            28920,
            29640,
            30540,
            31440,
            32340,
            33300,
            34260,
            35220,
            36180,
            37080,
            38040,
            39000,
            39960,
            40740,
            41580,
            42360,
            43260,
            44160,
            45120,
            46020,
            46920,
            47760,
            48540,
            49320,
            50220,
            51060,
            51840,
            52620,
            53400,
            54180,
            54900,
            55620,
            56340,
            57060,
            57660,
            58200,
            58800,
            59400,
            60120,
            60840,
            61560,
            62280,
            63060,
            63900,
            64740,
            65700,
            66720,
            67860,
            69000,
            69960,
            70860,
            71760,
            72660,
            73500,
            74340,
            75180,
            76020,
            76860,
            77700,
            78540,
            79380,
            80160,
            81000,
            81840,
            82680,
            83580
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_7:1",
          "sourceRouteId": "vilnius_bus_7",
          "sourceShapeId": "vilnius_bus_7_b-a",
          "directionId": 1,
          "headsign": "Šiaurės miestelis",
          "directionName": "Lazdynai–Viršuliškės–Verkių g.–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "7",
          "routeLongName": "Šiaurės miestelis–Verkių g.–Viršuliškės–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4066.123,
              1738.403,
              0
            ],
            [
              -4047.525,
              1694.666,
              47.526
            ],
            [
              -4037.081,
              1664.429,
              79.517
            ],
            [
              -4020.121,
              1600.683,
              145.48
            ],
            [
              -3992.198,
              1462.162,
              286.787
            ],
            [
              -3984.902,
              1436.432,
              313.532
            ],
            [
              -3986.154,
              1438.68,
              316.104
            ],
            [
              -3968.906,
              1391.627,
              366.219
            ],
            [
              -3971.11,
              1376.08,
              381.921
            ],
            [
              -3953.873,
              1291.178,
              468.556
            ],
            [
              -3953.633,
              1267.797,
              491.938
            ],
            [
              -3919.363,
              1123.6,
              640.152
            ],
            [
              -3889.289,
              1035.135,
              733.589
            ],
            [
              -3876.172,
              1010.417,
              761.571
            ],
            [
              -3879.245,
              944.791,
              827.269
            ],
            [
              -3886.86,
              914.867,
              858.147
            ],
            [
              -3897.582,
              891.676,
              883.697
            ],
            [
              -3911.432,
              874.104,
              906.071
            ],
            [
              -3948.102,
              842.457,
              954.509
            ],
            [
              -4089.107,
              782.559,
              1107.708
            ],
            [
              -4161.662,
              727.04,
              1199.068
            ],
            [
              -4175.491,
              710.581,
              1220.566
            ],
            [
              -4216.46,
              691.251,
              1265.866
            ],
            [
              -4255.417,
              676.338,
              1307.58
            ],
            [
              -4279.313,
              674.524,
              1331.544
            ],
            [
              -4304.422,
              677.184,
              1356.794
            ],
            [
              -4330.724,
              685.43,
              1384.358
            ],
            [
              -4370.887,
              712.839,
              1432.982
            ],
            [
              -4391.801,
              734.351,
              1462.984
            ],
            [
              -4418.25,
              771.542,
              1508.622
            ],
            [
              -4423.862,
              782.771,
              1521.175
            ],
            [
              -4434.785,
              785.185,
              1532.362
            ],
            [
              -4479.393,
              779.274,
              1577.359
            ],
            [
              -4503.366,
              773.007,
              1602.137
            ],
            [
              -4524.836,
              762.245,
              1626.154
            ],
            [
              -4546.478,
              741.466,
              1656.157
            ],
            [
              -4558.582,
              712.731,
              1687.337
            ],
            [
              -4562.872,
              688.314,
              1712.128
            ],
            [
              -4562.176,
              653.793,
              1746.656
            ],
            [
              -4542.083,
              471.996,
              1929.56
            ],
            [
              -4530.426,
              437.286,
              1966.175
            ],
            [
              -4533.311,
              419.524,
              1984.17
            ],
            [
              -4527.744,
              368.221,
              2035.774
            ],
            [
              -4516.259,
              323.495,
              2081.951
            ],
            [
              -4491.638,
              255.166,
              2154.58
            ],
            [
              -4427.619,
              152.763,
              2275.349
            ],
            [
              -4367.011,
              77.134,
              2372.267
            ],
            [
              -4077.229,
              -208.399,
              2779.086
            ],
            [
              -3954.469,
              -380.846,
              2990.765
            ],
            [
              -3921.604,
              -419.265,
              3041.324
            ],
            [
              -3917.323,
              -432.698,
              3055.422
            ],
            [
              -3857.936,
              -540.596,
              3178.584
            ],
            [
              -3823.641,
              -607.984,
              3254.196
            ],
            [
              -3766.483,
              -732.543,
              3391.244
            ],
            [
              -3707.64,
              -908.34,
              3576.627
            ],
            [
              -3695.741,
              -928.584,
              3600.11
            ],
            [
              -3679.35,
              -950.021,
              3627.094
            ],
            [
              -3673.878,
              -969.04,
              3646.886
            ],
            [
              -3654.555,
              -1007.226,
              3689.682
            ],
            [
              -3618.236,
              -1069.084,
              3761.414
            ],
            [
              -3599.031,
              -1113.947,
              3810.215
            ],
            [
              -3569.469,
              -1193.5,
              3895.083
            ],
            [
              -3554.873,
              -1243.849,
              3947.505
            ],
            [
              -3543.073,
              -1269.659,
              3975.884
            ],
            [
              -3520.478,
              -1415.883,
              4123.844
            ],
            [
              -3500.646,
              -1498.607,
              4208.912
            ],
            [
              -3461.302,
              -1608.388,
              4325.53
            ],
            [
              -3438.975,
              -1658.872,
              4380.731
            ],
            [
              -3418.974,
              -1694.844,
              4421.89
            ],
            [
              -3409.362,
              -1735.088,
              4463.265
            ],
            [
              -3353.575,
              -1899.704,
              4637.078
            ],
            [
              -3340.35,
              -1954.483,
              4693.43
            ],
            [
              -3339.232,
              -2037.994,
              4776.948
            ],
            [
              -3303.125,
              -2037.512,
              4813.058
            ],
            [
              -3264.382,
              -2033.736,
              4851.985
            ],
            [
              -3221.031,
              -2024.476,
              4896.314
            ],
            [
              -3174.263,
              -2004.144,
              4947.31
            ],
            [
              -3125.366,
              -1972.718,
              5005.436
            ],
            [
              -2913.151,
              -1818.365,
              5267.847
            ],
            [
              -2889.736,
              -1806.531,
              5294.083
            ],
            [
              -2844.956,
              -1789.507,
              5341.99
            ],
            [
              -2788.614,
              -1774.913,
              5400.191
            ],
            [
              -2751.802,
              -1771.108,
              5437.199
            ],
            [
              -2703.468,
              -1771.96,
              5485.54
            ],
            [
              -2639.18,
              -1781.999,
              5550.608
            ],
            [
              -2627.658,
              -1786.655,
              5563.035
            ],
            [
              -2624.007,
              -1798.964,
              5575.874
            ],
            [
              -2631.168,
              -1949.123,
              5726.203
            ],
            [
              -2631.119,
              -2055.992,
              5833.073
            ],
            [
              -2621.319,
              -2085.109,
              5863.795
            ],
            [
              -2617.298,
              -2113.01,
              5891.984
            ],
            [
              -2575.188,
              -2210.603,
              5998.275
            ],
            [
              -2562.457,
              -2219.734,
              6013.941
            ],
            [
              -2509.617,
              -2220.667,
              6066.79
            ],
            [
              -2431.725,
              -2226.496,
              6144.9
            ],
            [
              -2415.576,
              -2224.555,
              6161.165
            ],
            [
              -2373.4,
              -2245.339,
              6208.183
            ],
            [
              -2196.773,
              -2317.488,
              6398.978
            ],
            [
              -2137.182,
              -2337.47,
              6461.83
            ],
            [
              -2015.246,
              -2367.466,
              6587.402
            ],
            [
              -1889.653,
              -2373.04,
              6713.118
            ],
            [
              -1756.388,
              -2382.093,
              6846.69
            ],
            [
              -1647.51,
              -2385.149,
              6955.611
            ],
            [
              -1597.953,
              -2389.374,
              7005.348
            ],
            [
              -1522.821,
              -2405.189,
              7082.126
            ],
            [
              -1485.023,
              -2418.11,
              7122.072
            ],
            [
              -1375.913,
              -2480.178,
              7247.6
            ],
            [
              -1324.1,
              -2502.258,
              7303.922
            ],
            [
              -1292.401,
              -2531.77,
              7347.232
            ],
            [
              -1235.733,
              -2570.637,
              7415.948
            ],
            [
              -1150.916,
              -2621.142,
              7514.664
            ],
            [
              -1079.915,
              -2651.362,
              7591.828
            ],
            [
              -1012.681,
              -2675.949,
              7663.417
            ],
            [
              -916.353,
              -2695.496,
              7761.708
            ],
            [
              -830.758,
              -2702.605,
              7847.598
            ],
            [
              -592.882,
              -2700.223,
              8085.486
            ],
            [
              -320.273,
              -2701.823,
              8358.1
            ],
            [
              -192.234,
              -2714.168,
              8486.732
            ],
            [
              12.173,
              -2744.606,
              8693.393
            ],
            [
              66.615,
              -2763.41,
              8750.992
            ],
            [
              144.816,
              -2787.102,
              8832.702
            ],
            [
              177.432,
              -2801.056,
              8868.178
            ],
            [
              222.629,
              -2831.939,
              8922.918
            ],
            [
              331.278,
              -2917.419,
              9061.162
            ],
            [
              357.389,
              -2934.595,
              9092.416
            ],
            [
              386.802,
              -2947.379,
              9124.487
            ],
            [
              425.296,
              -2956.99,
              9164.163
            ],
            [
              460.671,
              -2960.978,
              9199.762
            ],
            [
              521.837,
              -2964.325,
              9261.02
            ],
            [
              532.044,
              -2970.079,
              9272.736
            ],
            [
              602.169,
              -2976.932,
              9343.195
            ],
            [
              619.319,
              -2990.605,
              9365.13
            ],
            [
              631.438,
              -2997.507,
              9379.076
            ],
            [
              906.98,
              -3153.977,
              9695.945
            ],
            [
              1026.951,
              -3218.53,
              9832.181
            ],
            [
              1027.41,
              -3228.558,
              9842.219
            ],
            [
              1043.901,
              -3277.845,
              9894.192
            ],
            [
              1066.821,
              -3362.875,
              9982.256
            ],
            [
              1066.595,
              -3375.116,
              9994.5
            ],
            [
              1098.437,
              -3500.388,
              10123.755
            ],
            [
              1100.082,
              -3516.004,
              10139.457
            ],
            [
              1090.736,
              -3742.933,
              10366.579
            ],
            [
              1117.962,
              -3769.041,
              10404.301
            ],
            [
              1133.882,
              -3779.354,
              10423.269
            ],
            [
              1147.08,
              -3797.41,
              10445.634
            ],
            [
              1219.986,
              -3862.213,
              10543.178
            ],
            [
              1375.611,
              -3774.922,
              10721.612
            ],
            [
              1393.375,
              -3755.212,
              10748.146
            ],
            [
              1412.221,
              -3746.656,
              10768.843
            ],
            [
              1509.056,
              -3563.653,
              10975.887
            ],
            [
              1556.885,
              -3486.613,
              11066.566
            ],
            [
              1607.644,
              -3390.704,
              11175.08
            ],
            [
              1620.009,
              -3384.254,
              11189.025
            ],
            [
              1689.847,
              -3267.548,
              11325.031
            ],
            [
              1697.306,
              -3247.648,
              11346.283
            ],
            [
              1696.944,
              -3128.524,
              11465.408
            ],
            [
              1687.839,
              -3098.296,
              11496.977
            ],
            [
              1691.619,
              -3068.309,
              11527.201
            ],
            [
              1688.435,
              -2754.314,
              11841.213
            ],
            [
              1682.19,
              -2639.533,
              11956.163
            ],
            [
              1679.485,
              -2611.651,
              11984.176
            ],
            [
              1675.868,
              -2598.225,
              11998.081
            ],
            [
              1670.837,
              -2591.452,
              12006.518
            ],
            [
              1656.786,
              -2584.511,
              12022.19
            ],
            [
              1621.888,
              -2589.429,
              12057.433
            ],
            [
              1614.3,
              -2581.496,
              12068.41
            ],
            [
              1426.817,
              -2576.903,
              12255.95
            ],
            [
              1419.812,
              -2572.32,
              12264.321
            ],
            [
              1413.343,
              -2538.803,
              12298.457
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 366.219,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 761.571,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 1220.566,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 1966.175,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 2779.086,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 3041.324,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 3627.094,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 3975.884,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5722",
              "position": {
                "x": -3418.974,
                "z": -1694.844
              },
              "distanceAlongShapeM": 4421.89,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5619",
              "position": {
                "x": -3340.35,
                "z": -1954.483
              },
              "distanceAlongShapeM": 4693.43,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5614",
              "position": {
                "x": -2788.614,
                "z": -1774.913
              },
              "distanceAlongShapeM": 5400.191,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:16692",
              "position": {
                "x": -2621.319,
                "z": -2085.109
              },
              "distanceAlongShapeM": 5863.795,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:1069",
              "position": {
                "x": -2415.576,
                "z": -2224.555
              },
              "distanceAlongShapeM": 6161.165,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:7017",
              "position": {
                "x": -1324.1,
                "z": -2502.258
              },
              "distanceAlongShapeM": 7303.922,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5080",
              "position": {
                "x": 12.173,
                "z": -2744.606
              },
              "distanceAlongShapeM": 8693.393,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6846",
              "position": {
                "x": 602.169,
                "z": -2976.932
              },
              "distanceAlongShapeM": 9343.195,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6847",
              "position": {
                "x": 1066.821,
                "z": -3362.875
              },
              "distanceAlongShapeM": 9982.256,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5147",
              "position": {
                "x": 1133.882,
                "z": -3779.354
              },
              "distanceAlongShapeM": 10423.269,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 10748.146,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 11175.08,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 11496.977,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5013",
              "position": {
                "x": 1621.888,
                "z": -2589.429
              },
              "distanceAlongShapeM": 12057.433,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 12298.457,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            }
          ],
          "departuresSeconds": [
            19140,
            19860,
            20580,
            21120,
            21600,
            22080,
            22560,
            23040,
            23580,
            24120,
            24720,
            25440,
            26160,
            26880,
            27540,
            28200,
            28800,
            29400,
            30000,
            30600,
            31320,
            32040,
            32820,
            33720,
            34560,
            35400,
            36300,
            37200,
            38160,
            39000,
            39960,
            40920,
            41940,
            42840,
            43680,
            44520,
            45300,
            46140,
            47100,
            48120,
            49080,
            50100,
            51060,
            51780,
            52560,
            53460,
            54360,
            55020,
            55740,
            56460,
            57240,
            57960,
            58740,
            59460,
            60180,
            60780,
            61380,
            61980,
            62700,
            63420,
            64200,
            64980,
            65760,
            66540,
            67320,
            68160,
            69000,
            69960,
            70980,
            72000,
            72960,
            73800,
            74640,
            75480,
            76320,
            77160,
            78000,
            78900,
            79860,
            80940,
            82020,
            82920,
            83760
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_8",
      "sourceRouteId": "vilnius_bus_8",
      "mode": "bus",
      "shortName": "8",
      "longName": "Žemieji Paneriai–Aukštieji Paneriai–Vaidotai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_8:0",
          "sourceRouteId": "vilnius_bus_8",
          "sourceShapeId": "vilnius_bus_8_a-b",
          "directionId": 0,
          "headsign": "Vaidotai",
          "directionName": "Žemieji Paneriai–Aukštieji Paneriai–Vaidotai",
          "mode": "bus",
          "routeShortName": "8",
          "routeLongName": "Žemieji Paneriai–Aukštieji Paneriai–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4333.961,
              4766.474,
              0
            ],
            [
              -4344.779,
              4775.566,
              14.131
            ],
            [
              -4352.977,
              4786.839,
              28.07
            ],
            [
              -4357.093,
              4810.287,
              51.877
            ],
            [
              -4404.75,
              4854.522,
              116.899
            ],
            [
              -4468.845,
              4919.076,
              207.868
            ],
            [
              -4488.111,
              4924.973,
              228.017
            ],
            [
              -4510.925,
              4949.856,
              261.775
            ],
            [
              -4579.258,
              4993.33,
              342.766
            ],
            [
              -4600.366,
              5004.825,
              366.8
            ],
            [
              -4835.366,
              5155.793,
              646.114
            ],
            [
              -5032.11,
              5279.379,
              878.453
            ],
            [
              -5271.713,
              5427.062,
              1159.914
            ],
            [
              -5460.164,
              5546.035,
              1382.779
            ],
            [
              -5507.478,
              5573.554,
              1437.513
            ],
            [
              -5539.526,
              5587.456,
              1472.447
            ],
            [
              -5570.341,
              5597.997,
              1505.014
            ],
            [
              -5599.939,
              5604.064,
              1535.228
            ],
            [
              -5632.195,
              5605.723,
              1567.527
            ],
            [
              -5666.482,
              5601.851,
              1602.032
            ],
            [
              -5724.289,
              5581.678,
              1663.258
            ],
            [
              -5767.933,
              5559.039,
              1712.423
            ],
            [
              -5844.413,
              5503.558,
              1806.908
            ],
            [
              -5862.75,
              5488.283,
              1830.774
            ],
            [
              -5911.642,
              5422.317,
              1912.883
            ],
            [
              -5931.13,
              5377.005,
              1962.208
            ],
            [
              -5950.367,
              5308.312,
              2033.544
            ],
            [
              -5960.48,
              5282.88,
              2060.914
            ],
            [
              -5972.455,
              5261.931,
              2085.043
            ],
            [
              -5985.57,
              5249.907,
              2102.836
            ],
            [
              -6003.755,
              5243.534,
              2122.105
            ],
            [
              -6024.466,
              5240.544,
              2143.031
            ],
            [
              -6045.12,
              5240.892,
              2163.688
            ],
            [
              -6069.366,
              5257.998,
              2193.361
            ],
            [
              -6086.896,
              5290.575,
              2230.355
            ],
            [
              -6284.365,
              5565.511,
              2568.857
            ],
            [
              -6384.618,
              5670.718,
              2714.182
            ],
            [
              -6403.151,
              5682.161,
              2735.963
            ],
            [
              -6425.222,
              5713.7,
              2774.458
            ],
            [
              -6633.66,
              5914.22,
              3063.689
            ],
            [
              -6722.128,
              5991.393,
              3181.087
            ],
            [
              -6610.439,
              6453.723,
              3656.717
            ],
            [
              -6615.859,
              6477.191,
              3680.802
            ],
            [
              -6611.247,
              6482.68,
              3687.971
            ],
            [
              -6601.507,
              6485.856,
              3698.216
            ],
            [
              -6595.808,
              6479.082,
              3707.069
            ],
            [
              -6595.901,
              6473.518,
              3712.634
            ],
            [
              -6598.614,
              6465.771,
              3720.842
            ],
            [
              -6609.831,
              6451.487,
              3739.004
            ],
            [
              -6653.627,
              6265.205,
              3930.366
            ],
            [
              -6722.128,
              5991.393,
              4212.616
            ],
            [
              -6754.294,
              5998.609,
              4245.581
            ],
            [
              -6809.827,
              6037.383,
              4313.311
            ],
            [
              -6882.79,
              6076.446,
              4396.074
            ],
            [
              -6955.867,
              6108.831,
              4476.005
            ],
            [
              -7039.365,
              6135.823,
              4563.758
            ],
            [
              -7206.108,
              6166.42,
              4733.284
            ],
            [
              -7774.707,
              6263.751,
              5310.154
            ],
            [
              -7867.343,
              6285.312,
              5405.265
            ],
            [
              -8047.971,
              6336.143,
              5592.909
            ],
            [
              -8100.928,
              6335.897,
              5645.867
            ],
            [
              -8216.781,
              6399.018,
              5777.799
            ],
            [
              -8626.991,
              6549.307,
              6214.673
            ],
            [
              -8794.097,
              6598.774,
              6388.947
            ],
            [
              -8875.212,
              6614.561,
              6471.585
            ],
            [
              -8982.209,
              6627.426,
              6579.352
            ],
            [
              -8997.202,
              6618.763,
              6596.668
            ],
            [
              -9015.208,
              6623.507,
              6615.288
            ],
            [
              -9020.857,
              6633.617,
              6626.869
            ],
            [
              -9019.959,
              6649.186,
              6642.465
            ],
            [
              -9003.584,
              6663.393,
              6664.143
            ],
            [
              -9000.086,
              6680.034,
              6681.148
            ],
            [
              -8987.422,
              6704.318,
              6708.536
            ],
            [
              -8845.474,
              7014.818,
              7049.944
            ],
            [
              -8802.47,
              7117.645,
              7161.401
            ],
            [
              -8792.189,
              7154.212,
              7199.387
            ],
            [
              -8783.058,
              7159.63,
              7210.003
            ],
            [
              -8763.181,
              7190.476,
              7246.699
            ],
            [
              -8468.88,
              7057.676,
              7569.575
            ],
            [
              -8277.251,
              6966.609,
              7781.742
            ],
            [
              -8239.065,
              6971.551,
              7820.247
            ],
            [
              -8139.3,
              6989.956,
              7921.695
            ],
            [
              -8139.173,
              6997.746,
              7929.486
            ],
            [
              -8131.797,
              7014.323,
              7947.63
            ],
            [
              -8118.146,
              7019.665,
              7962.289
            ],
            [
              -8103.295,
              7019.422,
              7977.142
            ],
            [
              -7968.079,
              7190.86,
              8195.487
            ],
            [
              -7896.751,
              7286.535,
              8314.824
            ],
            [
              -7860.12,
              7353.836,
              8391.449
            ],
            [
              -7737.233,
              7559.979,
              8631.44
            ],
            [
              -7651.984,
              7676.571,
              8775.874
            ],
            [
              -7540.147,
              7838.363,
              8972.557
            ],
            [
              -7369.238,
              8055.949,
              9249.24
            ],
            [
              -7283.86,
              8179.212,
              9399.183
            ],
            [
              -7287.938,
              8167.034,
              9412.025
            ],
            [
              -7272.881,
              8179.03,
              9431.277
            ],
            [
              -6946.23,
              8397.359,
              9824.174
            ],
            [
              -6484.668,
              8683.541,
              10367.257
            ],
            [
              -6074.473,
              8947.164,
              10854.861
            ],
            [
              -5945.212,
              8987.29,
              10990.207
            ],
            [
              -5871.728,
              9014.994,
              11068.74
            ],
            [
              -5617.109,
              9207.728,
              11388.079
            ],
            [
              -5372.483,
              9419.541,
              11711.663
            ],
            [
              -5387.04,
              9437.599,
              11734.857
            ],
            [
              -5443.232,
              9477.513,
              11803.782
            ],
            [
              -5441.218,
              9481.932,
              11808.638
            ],
            [
              -5481.844,
              9487.073,
              11849.588
            ],
            [
              -5545.139,
              9489.258,
              11912.92
            ],
            [
              -5626.849,
              9510.677,
              11997.391
            ],
            [
              -5666.49,
              9535.837,
              12044.343
            ],
            [
              -5758.358,
              9606.406,
              12160.186
            ],
            [
              -5990.756,
              9775.073,
              12447.34
            ],
            [
              -6020.289,
              9786.701,
              12479.08
            ],
            [
              -6052.07,
              9818.405,
              12523.97
            ],
            [
              -6394.984,
              10065.716,
              12946.761
            ],
            [
              -6415.306,
              10087.206,
              12976.339
            ],
            [
              -6419.587,
              10101.749,
              12991.499
            ],
            [
              -6409.212,
              10103.802,
              13002.076
            ],
            [
              -6400.868,
              10100.323,
              13011.116
            ],
            [
              -6388.113,
              10090.091,
              13027.468
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 228.017,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5728",
              "position": {
                "x": -6069.366,
                "z": 5257.998
              },
              "distanceAlongShapeM": 2193.361,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5732",
              "position": {
                "x": -6403.151,
                "z": 5682.161
              },
              "distanceAlongShapeM": 2735.963,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 3271.123,
              "shapeOffsetM": 0.317,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:8784",
              "position": {
                "x": -6615.878,
                "z": 6476.078
              },
              "distanceAlongShapeM": 3679.722,
              "shapeOffsetM": 0.269,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5738",
              "position": {
                "x": -6754.294,
                "z": 5998.609
              },
              "distanceAlongShapeM": 4245.581,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5742",
              "position": {
                "x": -8100.928,
                "z": 6335.897
              },
              "distanceAlongShapeM": 5645.867,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6450",
              "position": {
                "x": -8792.189,
                "z": 7154.212
              },
              "distanceAlongShapeM": 7199.387,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5747",
              "position": {
                "x": -8076.884,
                "z": 7054.61
              },
              "distanceAlongShapeM": 8021.127,
              "shapeOffsetM": 1.054,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5750",
              "position": {
                "x": -7651.984,
                "z": 7676.571
              },
              "distanceAlongShapeM": 8775.874,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9727",
              "position": {
                "x": -7283.86,
                "z": 8179.212
              },
              "distanceAlongShapeM": 9399.183,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9773",
              "position": {
                "x": -5443.232,
                "z": 9477.513
              },
              "distanceAlongShapeM": 11803.782,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5756",
              "position": {
                "x": -6020.289,
                "z": 9786.701
              },
              "distanceAlongShapeM": 12479.08,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:3575",
              "position": {
                "x": -6388.113,
                "z": 10090.091
              },
              "distanceAlongShapeM": 13027.468,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            }
          ],
          "departuresSeconds": [
            24840,
            28020,
            30240,
            34560,
            36840,
            38460,
            40680,
            42540,
            44820,
            46500,
            48540,
            50580,
            52800,
            55320,
            57900,
            60300,
            63000,
            66780,
            69360,
            71460,
            73560,
            75660,
            77760,
            79680,
            81660
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_8:1",
          "sourceRouteId": "vilnius_bus_8",
          "sourceShapeId": "vilnius_bus_8_b-a",
          "directionId": 1,
          "headsign": "Žemieji Paneriai",
          "directionName": "Vaidotai–Aukštieji Paneriai–Žemieji Paneriai",
          "mode": "bus",
          "routeShortName": "8",
          "routeLongName": "Žemieji Paneriai–Aukštieji Paneriai–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6388.113,
              10090.091,
              0
            ],
            [
              -6356.936,
              10060.626,
              42.897
            ],
            [
              -6353.227,
              10050.546,
              53.638
            ],
            [
              -6339.385,
              10028.05,
              80.051
            ],
            [
              -5956.85,
              9754.465,
              550.351
            ],
            [
              -5658.167,
              9531.244,
              923.231
            ],
            [
              -5627.495,
              9510.688,
              960.154
            ],
            [
              -5583.845,
              9493.252,
              1007.157
            ],
            [
              -5516.085,
              9487.653,
              1075.148
            ],
            [
              -5468.239,
              9489.069,
              1123.014
            ],
            [
              -5399.965,
              9475.666,
              1192.592
            ],
            [
              -5385.05,
              9478.753,
              1207.823
            ],
            [
              -5379.273,
              9476.428,
              1214.05
            ],
            [
              -5153.129,
              9664.054,
              1507.894
            ],
            [
              -5089.701,
              9707.502,
              1584.776
            ],
            [
              -5041.071,
              9640.996,
              1667.165
            ],
            [
              -5030.221,
              9633.019,
              1680.632
            ],
            [
              -5019.257,
              9631.719,
              1691.673
            ],
            [
              -5006.24,
              9637.063,
              1705.744
            ],
            [
              -4953.187,
              9678.459,
              1773.037
            ],
            [
              -4945.89,
              9689.466,
              1786.243
            ],
            [
              -4944.94,
              9707.261,
              1804.063
            ],
            [
              -4948,
              9717.332,
              1814.588
            ],
            [
              -4956.304,
              9723.04,
              1824.665
            ],
            [
              -4958.813,
              9727.535,
              1829.813
            ],
            [
              -4971.107,
              9726.632,
              1842.14
            ],
            [
              -5097.983,
              9638.625,
              1996.551
            ],
            [
              -5372.483,
              9419.541,
              2347.76
            ],
            [
              -5517.025,
              9279.504,
              2549.013
            ],
            [
              -5790.95,
              9053.706,
              2904.006
            ],
            [
              -5877.861,
              8996.174,
              3008.234
            ],
            [
              -6281.878,
              8793.689,
              3460.152
            ],
            [
              -6395.982,
              8732.149,
              3589.793
            ],
            [
              -6495.171,
              8673.698,
              3704.923
            ],
            [
              -6572.283,
              8621.554,
              3798.011
            ],
            [
              -6659.083,
              8569.571,
              3899.186
            ],
            [
              -6721.945,
              8519.413,
              3979.607
            ],
            [
              -6878.686,
              8418.499,
              4166.024
            ],
            [
              -6970.074,
              8362.134,
              4273.396
            ],
            [
              -7007.722,
              8312.666,
              4335.56
            ],
            [
              -7055.112,
              8260.021,
              4406.394
            ],
            [
              -7154.706,
              8136.998,
              4564.677
            ],
            [
              -7194.121,
              8097.577,
              4620.423
            ],
            [
              -7222.723,
              8086.919,
              4650.946
            ],
            [
              -7245.9,
              8091.756,
              4674.622
            ],
            [
              -7295.779,
              8122.637,
              4733.287
            ],
            [
              -7314.897,
              8138.538,
              4758.153
            ],
            [
              -7321.189,
              8109.7,
              4787.67
            ],
            [
              -7420.735,
              7988.896,
              4944.204
            ],
            [
              -7538.929,
              7833.891,
              5139.131
            ],
            [
              -7697.089,
              7604.958,
              5417.384
            ],
            [
              -7749.186,
              7540.138,
              5500.545
            ],
            [
              -7771.966,
              7490.42,
              5555.233
            ],
            [
              -7815.057,
              7423.225,
              5635.057
            ],
            [
              -7839.736,
              7375.765,
              5688.551
            ],
            [
              -7882.861,
              7306.344,
              5770.277
            ],
            [
              -7954.117,
              7215.12,
              5886.031
            ],
            [
              -8018.23,
              7126.005,
              5995.813
            ],
            [
              -8078.212,
              7052.406,
              6090.758
            ],
            [
              -8100.749,
              7017.154,
              6132.599
            ],
            [
              -8095.82,
              7002.602,
              6147.963
            ],
            [
              -8095.966,
              6993.699,
              6156.867
            ],
            [
              -8105.243,
              6979.38,
              6173.929
            ],
            [
              -8113.064,
              6975.055,
              6182.866
            ],
            [
              -8125.314,
              6976.369,
              6195.186
            ],
            [
              -8131.752,
              6977.587,
              6201.739
            ],
            [
              -8138.118,
              6983.257,
              6210.264
            ],
            [
              -8145.812,
              6986.723,
              6218.702
            ],
            [
              -8276.606,
              6966.598,
              6351.035
            ],
            [
              -8333.045,
              6990.897,
              6412.482
            ],
            [
              -8763.181,
              7190.476,
              6886.665
            ],
            [
              -8807.889,
              7102.148,
              6985.663
            ],
            [
              -8830.889,
              7037.958,
              7053.849
            ],
            [
              -8870.194,
              6964.013,
              7137.591
            ],
            [
              -8903.095,
              6886.625,
              7221.683
            ],
            [
              -8943.259,
              6799.335,
              7317.77
            ],
            [
              -8945.037,
              6769.309,
              7347.849
            ],
            [
              -8929.31,
              6743.451,
              7378.113
            ],
            [
              -8872.532,
              6700.231,
              7449.47
            ],
            [
              -8798.467,
              6647.824,
              7540.201
            ],
            [
              -8639.487,
              6575.113,
              7715.019
            ],
            [
              -8605.576,
              6555.637,
              7754.125
            ],
            [
              -8387.496,
              6464.144,
              7990.62
            ],
            [
              -8216.781,
              6399.018,
              8173.336
            ],
            [
              -8090.106,
              6365.775,
              8304.3
            ],
            [
              -8047.971,
              6336.143,
              8355.812
            ],
            [
              -7869.852,
              6289.806,
              8539.859
            ],
            [
              -7783.654,
              6269.464,
              8628.425
            ],
            [
              -7104.955,
              6152.496,
              9317.129
            ],
            [
              -7039.365,
              6135.823,
              9384.805
            ],
            [
              -6990.505,
              6122.766,
              9435.38
            ],
            [
              -6923.128,
              6097.155,
              9507.461
            ],
            [
              -6819.933,
              6050.909,
              9620.544
            ],
            [
              -6722.128,
              5991.393,
              9735.034
            ],
            [
              -6610.439,
              6453.723,
              10210.664
            ],
            [
              -6615.859,
              6477.191,
              10234.749
            ],
            [
              -6611.247,
              6482.68,
              10241.919
            ],
            [
              -6601.507,
              6485.856,
              10252.164
            ],
            [
              -6595.808,
              6479.082,
              10261.017
            ],
            [
              -6595.901,
              6473.518,
              10266.582
            ],
            [
              -6598.614,
              6465.771,
              10274.79
            ],
            [
              -6609.831,
              6451.487,
              10292.952
            ],
            [
              -6653.627,
              6265.205,
              10484.313
            ],
            [
              -6722.128,
              5991.393,
              10766.563
            ],
            [
              -6663.331,
              5954.79,
              10835.822
            ],
            [
              -6413.106,
              5704.591,
              11189.675
            ],
            [
              -6357.16,
              5652.447,
              11266.154
            ],
            [
              -6334.791,
              5638.714,
              11292.402
            ],
            [
              -6315.93,
              5608.341,
              11328.155
            ],
            [
              -6284.365,
              5565.511,
              11381.36
            ],
            [
              -6235.578,
              5510.146,
              11455.154
            ],
            [
              -6210.778,
              5487.465,
              11488.761
            ],
            [
              -6170.561,
              5460.073,
              11537.42
            ],
            [
              -6118.615,
              5439.162,
              11593.417
            ],
            [
              -6089.662,
              5433.109,
              11622.996
            ],
            [
              -6052.281,
              5429.14,
              11660.587
            ],
            [
              -6005.048,
              5435.024,
              11708.185
            ],
            [
              -5948.573,
              5452.996,
              11767.451
            ],
            [
              -5873.554,
              5498.484,
              11855.183
            ],
            [
              -5789.253,
              5558.286,
              11958.542
            ],
            [
              -5728.563,
              5596.222,
              12030.112
            ],
            [
              -5697.335,
              5610.165,
              12064.312
            ],
            [
              -5669.446,
              5617.486,
              12093.145
            ],
            [
              -5631.932,
              5621.303,
              12130.854
            ],
            [
              -5582.93,
              5617.134,
              12180.032
            ],
            [
              -5526.428,
              5598.366,
              12239.57
            ],
            [
              -5379.437,
              5509.043,
              12411.572
            ],
            [
              -4710.592,
              5090.204,
              13200.736
            ],
            [
              -4580.889,
              5011.17,
              13352.623
            ],
            [
              -4517.509,
              4980.025,
              13423.242
            ],
            [
              -4380.813,
              4857.45,
              13606.845
            ],
            [
              -4298.311,
              4774.766,
              13723.649
            ],
            [
              -4237.94,
              4719.179,
              13805.714
            ],
            [
              -4229.781,
              4705.68,
              13821.487
            ],
            [
              -4240.925,
              4695.853,
              13836.345
            ],
            [
              -4266.982,
              4719.679,
              13871.654
            ],
            [
              -4289.168,
              4743.439,
              13904.161
            ],
            [
              -4311.679,
              4748.279,
              13927.187
            ],
            [
              -4321.909,
              4754.022,
              13938.918
            ],
            [
              -4333.961,
              4766.474,
              13956.248
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3575",
              "position": {
                "x": -6388.113,
                "z": 10090.091
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5757",
              "position": {
                "x": -5956.85,
                "z": 9754.465
              },
              "distanceAlongShapeM": 550.351,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:9201",
              "position": {
                "x": -5153.129,
                "z": 9664.054
              },
              "distanceAlongShapeM": 1507.894,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:9726",
              "position": {
                "x": -7321.189,
                "z": 8109.7
              },
              "distanceAlongShapeM": 4787.67,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5751",
              "position": {
                "x": -7697.089,
                "z": 7604.958
              },
              "distanceAlongShapeM": 5417.384,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7910",
              "position": {
                "x": -8333.045,
                "z": 6990.897
              },
              "distanceAlongShapeM": 6412.482,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:9115",
              "position": {
                "x": -8830.889,
                "z": 7037.958
              },
              "distanceAlongShapeM": 7053.849,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9776",
              "position": {
                "x": -8090.106,
                "z": 6365.775
              },
              "distanceAlongShapeM": 8304.3,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 9825.071,
              "shapeOffsetM": 0.317,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:357",
              "position": {
                "x": -6598.614,
                "z": 6465.771
              },
              "distanceAlongShapeM": 10274.79,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:4410",
              "position": {
                "x": -6663.331,
                "z": 5954.79
              },
              "distanceAlongShapeM": 10835.822,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5731",
              "position": {
                "x": -6334.791,
                "z": 5638.714
              },
              "distanceAlongShapeM": 11292.402,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 13423.242,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            }
          ],
          "departuresSeconds": [
            19860,
            22560,
            25260,
            27300,
            30180,
            32340,
            36420,
            38580,
            40740,
            42480,
            44400,
            46560,
            48420,
            50400,
            52860,
            55260,
            57240,
            60180,
            62460,
            65100,
            68820,
            71400,
            73500,
            75600,
            77760,
            79620,
            81420,
            83400
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_9",
      "sourceRouteId": "vilnius_bus_9",
      "mode": "bus",
      "shortName": "9",
      "longName": "Zuikių–Agrastų g.–Baltoji Vokė–Vaidotai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_9:0",
          "sourceRouteId": "vilnius_bus_9",
          "sourceShapeId": "vilnius_bus_9_a1-b1",
          "directionId": 0,
          "headsign": "Salininkai",
          "directionName": "Zuikių–Agrastų g.–Salininkai",
          "mode": "bus",
          "routeShortName": "9",
          "routeLongName": "Zuikių–Agrastų g.–Baltoji Vokė–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5024.685,
              6320.084,
              0
            ],
            [
              -5027.002,
              6335.708,
              15.795
            ],
            [
              -5043.902,
              6367.166,
              51.505
            ],
            [
              -5082.545,
              6449.087,
              142.083
            ],
            [
              -5103.319,
              6480.611,
              179.836
            ],
            [
              -5141.697,
              6502.415,
              223.975
            ],
            [
              -5204.627,
              6523.524,
              290.352
            ],
            [
              -5224.909,
              6546.133,
              320.724
            ],
            [
              -5243.027,
              6582.063,
              360.964
            ],
            [
              -5257.592,
              6599.008,
              383.309
            ],
            [
              -5341.188,
              6658.315,
              485.806
            ],
            [
              -5352.716,
              6664.077,
              498.693
            ],
            [
              -5375.219,
              6670.025,
              521.969
            ],
            [
              -5432.244,
              6658.748,
              580.099
            ],
            [
              -5502.771,
              6651.038,
              651.046
            ],
            [
              -5525.92,
              6656.997,
              674.949
            ],
            [
              -5545.784,
              6666.239,
              696.858
            ],
            [
              -5575.696,
              6692.349,
              736.563
            ],
            [
              -5581.281,
              6705.801,
              751.129
            ],
            [
              -5584.283,
              6719.21,
              764.87
            ],
            [
              -5575.343,
              6751.341,
              798.221
            ],
            [
              -5544.855,
              6835.427,
              887.663
            ],
            [
              -5515.503,
              6890.589,
              950.149
            ],
            [
              -5474.546,
              6944.441,
              1017.806
            ],
            [
              -5402.386,
              7010.007,
              1115.305
            ],
            [
              -5344.115,
              7170.43,
              1285.982
            ],
            [
              -5320.497,
              7267.989,
              1386.36
            ],
            [
              -5330.016,
              7316.018,
              1435.322
            ],
            [
              -5369.262,
              7401.286,
              1529.189
            ],
            [
              -5385.085,
              7420.479,
              1554.063
            ],
            [
              -5412.475,
              7443.207,
              1589.655
            ],
            [
              -5545.775,
              7353.073,
              1750.569
            ],
            [
              -6208.433,
              6895.6,
              2555.8
            ],
            [
              -6301.091,
              6839.27,
              2664.237
            ],
            [
              -6382.77,
              6782.754,
              2763.562
            ],
            [
              -6405.021,
              6765.316,
              2791.832
            ],
            [
              -6427.141,
              6755.668,
              2815.965
            ],
            [
              -6453.912,
              6738.306,
              2847.873
            ],
            [
              -6457.935,
              6729.468,
              2857.583
            ],
            [
              -6458.102,
              6719.452,
              2867.601
            ],
            [
              -6452.515,
              6706,
              2882.166
            ],
            [
              -6391.973,
              6696.081,
              2943.516
            ],
            [
              -6385.591,
              6691.521,
              2951.36
            ],
            [
              -6388.397,
              6678.21,
              2964.963
            ],
            [
              -6401.347,
              6676.2,
              2978.069
            ],
            [
              -6416.104,
              6682.014,
              2993.929
            ],
            [
              -6448.126,
              6698.134,
              3029.78
            ],
            [
              -6457.053,
              6704.963,
              3041.019
            ],
            [
              -6459.487,
              6713.909,
              3050.291
            ],
            [
              -6426.19,
              6928.195,
              3267.148
            ],
            [
              -6396.062,
              7145.873,
              3486.901
            ],
            [
              -6388.531,
              7171.35,
              3513.468
            ],
            [
              -6375.131,
              7200.068,
              3545.159
            ],
            [
              -6358.597,
              7223.168,
              3573.566
            ],
            [
              -6247.739,
              7285.873,
              3700.929
            ],
            [
              -6217.053,
              7305.395,
              3737.299
            ],
            [
              -6199.338,
              7321.795,
              3761.44
            ],
            [
              -6186.142,
              7338.272,
              3782.549
            ],
            [
              -6174.014,
              7368.124,
              3814.77
            ],
            [
              -6163.748,
              7402.46,
              3850.608
            ],
            [
              -6149.889,
              7496.847,
              3946.008
            ],
            [
              -6148.739,
              7526.884,
              3976.066
            ],
            [
              -6151.529,
              7591.495,
              4040.738
            ],
            [
              -6154.824,
              7626.059,
              4075.458
            ],
            [
              -6179.16,
              7715.522,
              4168.172
            ],
            [
              -6182.858,
              7764.564,
              4217.354
            ],
            [
              -6170.673,
              7797.755,
              4252.71
            ],
            [
              -6135.491,
              7853.936,
              4318.998
            ],
            [
              -6112.139,
              7898.07,
              4368.93
            ],
            [
              -6097.978,
              7933.454,
              4407.042
            ],
            [
              -6084.013,
              7995.557,
              4470.696
            ],
            [
              -6073.839,
              8177.947,
              4653.37
            ],
            [
              -6068.279,
              8201.231,
              4677.308
            ],
            [
              -6058.273,
              8219.986,
              4698.566
            ],
            [
              -6040.423,
              8244.176,
              4728.629
            ],
            [
              -5980.215,
              8289.916,
              4804.24
            ],
            [
              -5946.236,
              8312.721,
              4845.163
            ],
            [
              -5919.379,
              8334.532,
              4879.76
            ],
            [
              -5887.851,
              8365.169,
              4923.722
            ],
            [
              -5837.16,
              8421.087,
              4999.197
            ],
            [
              -5801.091,
              8452.76,
              5047.199
            ],
            [
              -5757.214,
              8487.642,
              5103.251
            ],
            [
              -5746.673,
              8499.709,
              5119.274
            ],
            [
              -5728.174,
              8523.886,
              5149.717
            ],
            [
              -5722.041,
              8542.707,
              5169.511
            ],
            [
              -5682.214,
              8605.485,
              5243.857
            ],
            [
              -5635.725,
              8718.243,
              5365.823
            ],
            [
              -5627.146,
              8767.078,
              5415.406
            ],
            [
              -5612.677,
              8820.266,
              5470.527
            ],
            [
              -5575.029,
              8868.609,
              5531.8
            ],
            [
              -5449.08,
              8980.02,
              5699.954
            ],
            [
              -5321.224,
              9089.169,
              5868.063
            ],
            [
              -5164.209,
              9088.727,
              6025.078
            ],
            [
              -5027.714,
              9097.535,
              6161.857
            ],
            [
              -4919.737,
              9101.259,
              6269.898
            ],
            [
              -4855.784,
              9100.167,
              6333.861
            ],
            [
              -4643.157,
              9064.248,
              6549.5
            ],
            [
              -4621.744,
              9069.447,
              6571.536
            ],
            [
              -4615.15,
              9077.127,
              6581.657
            ],
            [
              -4608.955,
              9099.284,
              6604.665
            ],
            [
              -4601.07,
              9106.941,
              6615.656
            ],
            [
              -4518.84,
              9078.815,
              6702.563
            ],
            [
              -4236.225,
              9017.185,
              6991.82
            ],
            [
              -4087.776,
              8932.251,
              7162.848
            ],
            [
              -3843.276,
              8759.935,
              7461.969
            ],
            [
              -3713.566,
              8638.576,
              7639.6
            ],
            [
              -3697.804,
              8616.039,
              7667.102
            ],
            [
              -3661.015,
              8576.44,
              7721.153
            ],
            [
              -3619.725,
              8535.648,
              7779.194
            ],
            [
              -3591.691,
              8512.898,
              7815.298
            ],
            [
              -2877.847,
              8654.069,
              8542.967
            ],
            [
              -2205.592,
              8779.166,
              9226.763
            ],
            [
              -2160.179,
              8789.495,
              9273.336
            ],
            [
              -2145.869,
              8794.808,
              9288.6
            ],
            [
              -2111.689,
              8827.6,
              9335.967
            ],
            [
              -2032.412,
              8998.744,
              9524.58
            ],
            [
              -1968.13,
              9125.624,
              9666.815
            ],
            [
              -1958.203,
              9138.806,
              9683.317
            ],
            [
              -1929.991,
              9162.797,
              9720.35
            ],
            [
              -1618.698,
              9225.174,
              10037.832
            ],
            [
              -1566.739,
              9239.834,
              10091.819
            ],
            [
              -1337.858,
              9282.508,
              10324.644
            ],
            [
              -974.57,
              9288.252,
              10687.977
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9303",
              "position": {
                "x": -5024.685,
                "z": 6320.084
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -450,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9308",
              "position": {
                "x": -5545.775,
                "z": 7353.073
              },
              "distanceAlongShapeM": 1750.569,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:9311",
              "position": {
                "x": -6208.433,
                "z": 6895.6
              },
              "distanceAlongShapeM": 2555.8,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7189",
              "position": {
                "x": -6401.347,
                "z": 6676.2
              },
              "distanceAlongShapeM": 2978.069,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:7188",
              "position": {
                "x": -5722.041,
                "z": 8542.707
              },
              "distanceAlongShapeM": 5169.511,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6975",
              "position": {
                "x": -3713.566,
                "z": 8638.576
              },
              "distanceAlongShapeM": 7639.6,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:4706",
              "position": {
                "x": -2877.847,
                "z": 8654.069
              },
              "distanceAlongShapeM": 8542.967,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6972",
              "position": {
                "x": -2032.412,
                "z": 8998.744
              },
              "distanceAlongShapeM": 9524.58,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6257",
              "position": {
                "x": -1566.739,
                "z": 9239.834
              },
              "distanceAlongShapeM": 10091.819,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6253",
              "position": {
                "x": -974.57,
                "z": 9288.252
              },
              "distanceAlongShapeM": 10687.977,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            }
          ],
          "departuresSeconds": [
            23280,
            26820,
            30720,
            33960,
            39660,
            42960,
            46260,
            49500,
            53460,
            56400,
            60960,
            65340,
            71280,
            74700,
            78060,
            81420
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_9:1",
          "sourceRouteId": "vilnius_bus_9",
          "sourceShapeId": "vilnius_bus_9_b1-a1",
          "directionId": 1,
          "headsign": "Zuikių g.",
          "directionName": "Salininkai–Agrastų–Zuikių g.",
          "mode": "bus",
          "routeShortName": "9",
          "routeLongName": "Zuikių–Agrastų g.–Baltoji Vokė–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -974.57,
              9288.252,
              0
            ],
            [
              -970.754,
              9284.844,
              5.117
            ],
            [
              -956.601,
              9281.251,
              19.718
            ],
            [
              -947.577,
              9279.976,
              28.832
            ],
            [
              -933.324,
              9281.946,
              43.221
            ],
            [
              -922.828,
              9290.664,
              56.865
            ],
            [
              -911.566,
              9306.047,
              75.93
            ],
            [
              -905.066,
              9308.156,
              82.764
            ],
            [
              -888.329,
              9304.516,
              99.892
            ],
            [
              -880.696,
              9297.7,
              110.125
            ],
            [
              -878.878,
              9290.988,
              117.079
            ],
            [
              -878.978,
              9285.424,
              122.644
            ],
            [
              -881.622,
              9282.132,
              126.866
            ],
            [
              -888.748,
              9281.146,
              134.061
            ],
            [
              -908.755,
              9282.619,
              154.122
            ],
            [
              -979.918,
              9278.329,
              225.414
            ],
            [
              -1100.805,
              9276.043,
              346.322
            ],
            [
              -1238.936,
              9285.193,
              484.756
            ],
            [
              -1306.849,
              9281.954,
              552.746
            ],
            [
              -1341.168,
              9278.114,
              587.279
            ],
            [
              -1472.788,
              9253.745,
              721.136
            ],
            [
              -1538.979,
              9238.226,
              789.122
            ],
            [
              -1618.698,
              9225.174,
              869.902
            ],
            [
              -1909.16,
              9171.333,
              1165.313
            ],
            [
              -1929.991,
              9162.797,
              1187.824
            ],
            [
              -1953.562,
              9145.403,
              1217.119
            ],
            [
              -1966.778,
              9128.939,
              1238.231
            ],
            [
              -1992.214,
              9079.296,
              1294.011
            ],
            [
              -2047.392,
              8955.594,
              1429.461
            ],
            [
              -2093.736,
              8856.226,
              1539.105
            ],
            [
              -2111.787,
              8822.036,
              1577.768
            ],
            [
              -2119.031,
              8814.371,
              1588.314
            ],
            [
              -2130.111,
              8809.001,
              1600.626
            ],
            [
              -2137.374,
              8800.224,
              1612.019
            ],
            [
              -2151.096,
              8791.561,
              1628.247
            ],
            [
              -2169.966,
              8784.102,
              1648.538
            ],
            [
              -2741.81,
              8673.948,
              2230.894
            ],
            [
              -3334.939,
              8564.092,
              2834.111
            ],
            [
              -3591.691,
              8512.898,
              3095.918
            ],
            [
              -3607.723,
              8519.855,
              3113.394
            ],
            [
              -3659.232,
              8567.503,
              3183.561
            ],
            [
              -3843.276,
              8759.935,
              3449.836
            ],
            [
              -4085.116,
              8936.658,
              3749.365
            ],
            [
              -4170.263,
              8982.654,
              3846.142
            ],
            [
              -4253.174,
              9008.572,
              3933.009
            ],
            [
              -4417.136,
              9055.919,
              4103.67
            ],
            [
              -4502.747,
              9075.199,
              4191.426
            ],
            [
              -4565.123,
              9092.967,
              4256.282
            ],
            [
              -4587.067,
              9094.456,
              4278.277
            ],
            [
              -4594.877,
              9091.251,
              4286.719
            ],
            [
              -4611.236,
              9079.286,
              4306.987
            ],
            [
              -4617.83,
              9071.607,
              4317.109
            ],
            [
              -4625.677,
              9066.175,
              4326.652
            ],
            [
              -4639.946,
              9063.08,
              4341.253
            ],
            [
              -4853.865,
              9099.021,
              4558.17
            ],
            [
              -5239.088,
              9093.34,
              4943.435
            ],
            [
              -5294.073,
              9089.822,
              4998.533
            ],
            [
              -5308.78,
              9098.977,
              5015.857
            ],
            [
              -5479.172,
              8958.267,
              5236.838
            ],
            [
              -5557.857,
              8890.582,
              5340.629
            ],
            [
              -5597.769,
              8861.202,
              5390.189
            ],
            [
              -5612.677,
              8820.266,
              5433.755
            ],
            [
              -5625.07,
              8736.987,
              5517.95
            ],
            [
              -5653.856,
              8639.514,
              5619.585
            ],
            [
              -5685.042,
              8591.061,
              5677.207
            ],
            [
              -5734.269,
              8507.291,
              5774.37
            ],
            [
              -5790.167,
              8449.237,
              5854.961
            ],
            [
              -5927.945,
              8324.658,
              6040.71
            ],
            [
              -5965.912,
              8295.241,
              6088.74
            ],
            [
              -6010.319,
              8267.046,
              6141.342
            ],
            [
              -6040.423,
              8244.176,
              6179.147
            ],
            [
              -6061.119,
              8204.45,
              6223.941
            ],
            [
              -6068.766,
              8172.296,
              6256.992
            ],
            [
              -6076.086,
              8121.213,
              6308.597
            ],
            [
              -6083.741,
              7973.289,
              6456.719
            ],
            [
              -6092.774,
              7935.593,
              6495.482
            ],
            [
              -6124.325,
              7864.88,
              6572.914
            ],
            [
              -6170.251,
              7784.389,
              6665.585
            ],
            [
              -6177.897,
              7752.236,
              6698.636
            ],
            [
              -6178.036,
              7705.485,
              6745.387
            ],
            [
              -6164.137,
              7648.479,
              6804.063
            ],
            [
              -6145.791,
              7586.946,
              6868.272
            ],
            [
              -6142.796,
              7534.576,
              6920.728
            ],
            [
              -6164.488,
              7396.906,
              7060.096
            ],
            [
              -6182.287,
              7337.094,
              7122.501
            ],
            [
              -6226.28,
              7294.418,
              7183.792
            ],
            [
              -6284.199,
              7268.674,
              7247.175
            ],
            [
              -6325.937,
              7244.884,
              7295.216
            ],
            [
              -6355.368,
              7223.114,
              7331.824
            ],
            [
              -6373.747,
              7205.611,
              7357.204
            ],
            [
              -6392.908,
              7141.368,
              7424.244
            ],
            [
              -6407.034,
              7069.248,
              7497.734
            ],
            [
              -6456.96,
              6710.527,
              7859.913
            ],
            [
              -6442.867,
              6703.612,
              7875.61
            ],
            [
              -6395.791,
              6699.484,
              7922.868
            ],
            [
              -6384.889,
              6694.849,
              7934.714
            ],
            [
              -6379.798,
              6690.311,
              7941.534
            ],
            [
              -6379.929,
              6682.521,
              7949.325
            ],
            [
              -6383.269,
              6675.898,
              7956.743
            ],
            [
              -6401.347,
              6676.2,
              7974.823
            ],
            [
              -6421.157,
              6688.777,
              7998.289
            ],
            [
              -6455.781,
              6703.828,
              8036.042
            ],
            [
              -6459.561,
              6709.458,
              8042.823
            ],
            [
              -6461.349,
              6718.393,
              8051.935
            ],
            [
              -6456.569,
              6733.897,
              8068.16
            ],
            [
              -6406.958,
              6765.349,
              8126.9
            ],
            [
              -5616.326,
              7306.401,
              9084.938
            ],
            [
              -5412.475,
              7443.207,
              9330.44
            ],
            [
              -5378.76,
              7412.579,
              9375.99
            ],
            [
              -5351.616,
              7375.383,
              9422.037
            ],
            [
              -5317.725,
              7279.074,
              9524.136
            ],
            [
              -5363.141,
              7115.094,
              9694.289
            ],
            [
              -5381.482,
              7061.972,
              9750.487
            ],
            [
              -5407.571,
              7008.982,
              9809.552
            ],
            [
              -5430.091,
              6975.969,
              9849.515
            ],
            [
              -5483.831,
              6930.127,
              9920.151
            ],
            [
              -5540.241,
              6840.915,
              10025.701
            ],
            [
              -5565.262,
              6774.547,
              10096.628
            ],
            [
              -5584.001,
              6735.903,
              10139.576
            ],
            [
              -5581.889,
              6708.038,
              10167.521
            ],
            [
              -5577.577,
              6695.72,
              10180.572
            ],
            [
              -5555.945,
              6676.429,
              10209.556
            ],
            [
              -5521.419,
              6655.807,
              10249.772
            ],
            [
              -5495.669,
              6650.918,
              10275.982
            ],
            [
              -5483.971,
              6655.172,
              10288.429
            ],
            [
              -5397.284,
              6663.72,
              10375.537
            ],
            [
              -5364.888,
              6669.849,
              10408.507
            ],
            [
              -5301.574,
              6633.152,
              10481.688
            ],
            [
              -5260.783,
              6601.289,
              10533.449
            ],
            [
              -5235.411,
              6574.141,
              10570.607
            ],
            [
              -5226.2,
              6546.155,
              10600.07
            ],
            [
              -5217.407,
              6531.534,
              10617.131
            ],
            [
              -5207.229,
              6522.455,
              10630.77
            ],
            [
              -5183.511,
              6512.033,
              10656.677
            ],
            [
              -5134.082,
              6494.493,
              10709.126
            ],
            [
              -5107.193,
              6480.677,
              10739.357
            ],
            [
              -5080.608,
              6449.054,
              10780.67
            ],
            [
              -5057.403,
              6408.584,
              10827.321
            ],
            [
              -5039.572,
              6355.96,
              10882.883
            ],
            [
              -5028.293,
              6335.73,
              10906.045
            ],
            [
              -5012.875,
              6331.014,
              10922.169
            ],
            [
              -5001.235,
              6331.929,
              10933.844
            ],
            [
              -4992.234,
              6329.549,
              10943.154
            ],
            [
              -4986.576,
              6320.547,
              10953.787
            ],
            [
              -4987.981,
              6313.892,
              10960.589
            ],
            [
              -4995.139,
              6310.674,
              10968.437
            ],
            [
              -5004.804,
              6311.953,
              10978.186
            ],
            [
              -5024.685,
              6320.084,
              10999.666
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6254",
              "position": {
                "x": -1100.805,
                "z": 9276.043
              },
              "distanceAlongShapeM": 346.322,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9003",
              "position": {
                "x": -1669.285,
                "z": 9214.942
              },
              "distanceAlongShapeM": 921.507,
              "shapeOffsetM": 0.841,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6973",
              "position": {
                "x": -2047.392,
                "z": 8955.594
              },
              "distanceAlongShapeM": 1429.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:4705",
              "position": {
                "x": -2935.628,
                "z": 8638.383
              },
              "distanceAlongShapeM": 2427.948,
              "shapeOffsetM": 0.327,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6974",
              "position": {
                "x": -3746.2,
                "z": 8656.953
              },
              "distanceAlongShapeM": 3308.316,
              "shapeOffsetM": 1.024,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7187",
              "position": {
                "x": -5734.269,
                "z": 8507.291
              },
              "distanceAlongShapeM": 5774.37,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7189",
              "position": {
                "x": -6401.347,
                "z": 6676.2
              },
              "distanceAlongShapeM": 7974.823,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9312",
              "position": {
                "x": -6105.124,
                "z": 6970.674
              },
              "distanceAlongShapeM": 8491.95,
              "shapeOffsetM": 1.014,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9310",
              "position": {
                "x": -5616.326,
                "z": 7306.401
              },
              "distanceAlongShapeM": 9084.938,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:9303",
              "position": {
                "x": -5024.685,
                "z": 6320.084
              },
              "distanceAlongShapeM": 10999.666,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            }
          ],
          "departuresSeconds": [
            21780,
            24960,
            28800,
            32340,
            37980,
            41340,
            44640,
            47880,
            51780,
            55500,
            58260,
            62940,
            69420,
            72960,
            76320,
            79680
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_10",
      "sourceRouteId": "vilnius_bus_10",
      "mode": "bus",
      "shortName": "10",
      "longName": "Fabijoniškės–Baltupiai–Markučiai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_10:0",
          "sourceRouteId": "vilnius_bus_10",
          "sourceShapeId": "vilnius_bus_10_a1-b1",
          "directionId": 0,
          "headsign": "Markučiai",
          "directionName": "Fabijoniškės–Baltupiai–Markučiai",
          "mode": "bus",
          "routeShortName": "10",
          "routeLongName": "Fabijoniškės–Baltupiai–Markučiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2259.201,
              -4747.662,
              0
            ],
            [
              -2276.242,
              -4764.058,
              23.648
            ],
            [
              -2286.862,
              -4781.681,
              44.224
            ],
            [
              -2288.269,
              -4788.336,
              51.025
            ],
            [
              -2279.43,
              -4798.511,
              64.504
            ],
            [
              -2271.682,
              -4797.536,
              72.313
            ],
            [
              -2262.567,
              -4792.131,
              82.91
            ],
            [
              -2251.322,
              -4775.632,
              102.876
            ],
            [
              -2249.272,
              -4768.989,
              109.828
            ],
            [
              -2233.519,
              -4752.57,
              132.582
            ],
            [
              -2214.894,
              -4719.504,
              170.533
            ],
            [
              -2197.201,
              -4666.383,
              226.523
            ],
            [
              -2190.603,
              -4657.594,
              237.513
            ],
            [
              -2134.709,
              -4666.379,
              294.092
            ],
            [
              -2111.82,
              -4683.484,
              322.667
            ],
            [
              -2099.157,
              -4695.955,
              340.439
            ],
            [
              -2067.351,
              -4718.784,
              379.591
            ],
            [
              -2007.683,
              -4768.827,
              457.466
            ],
            [
              -1998.706,
              -4771.214,
              466.755
            ],
            [
              -1979.306,
              -4767.106,
              486.585
            ],
            [
              -1961.313,
              -4769.653,
              504.757
            ],
            [
              -1950.602,
              -4783.202,
              522.029
            ],
            [
              -1941.516,
              -4815.647,
              555.722
            ],
            [
              -1918.262,
              -4848.345,
              595.846
            ],
            [
              -1854.05,
              -4896.245,
              675.956
            ],
            [
              -1743.848,
              -4966.117,
              806.442
            ],
            [
              -1676.24,
              -5004.061,
              883.97
            ],
            [
              -1625.643,
              -5020.551,
              937.186
            ],
            [
              -1586.957,
              -5054.639,
              988.748
            ],
            [
              -1465.895,
              -5129.166,
              1130.911
            ],
            [
              -1407.208,
              -5161.388,
              1197.862
            ],
            [
              -1338.038,
              -5183.78,
              1270.566
            ],
            [
              -1271.325,
              -5199.449,
              1339.094
            ],
            [
              -1246.49,
              -5215.481,
              1368.654
            ],
            [
              -1183.862,
              -5243.323,
              1437.192
            ],
            [
              -1057.683,
              -5283.443,
              1569.596
            ],
            [
              -1011.035,
              -5304.321,
              1620.703
            ],
            [
              -893.028,
              -5368.79,
              1755.172
            ],
            [
              -884.677,
              -5370.054,
              1763.618
            ],
            [
              -880.613,
              -5358.995,
              1775.4
            ],
            [
              -871.52,
              -5283.459,
              1851.481
            ],
            [
              -867.295,
              -5263.497,
              1871.886
            ],
            [
              -873.84,
              -5126.451,
              2009.088
            ],
            [
              -873.198,
              -5090.839,
              2044.706
            ],
            [
              -867.363,
              -5053.094,
              2082.899
            ],
            [
              -847.141,
              -4967.74,
              2170.616
            ],
            [
              -716.635,
              -4519.236,
              2637.721
            ],
            [
              -646.915,
              -4511.591,
              2707.859
            ],
            [
              -568.48,
              -4520.803,
              2786.833
            ],
            [
              -439.606,
              -4519.799,
              2915.71
            ],
            [
              -373.187,
              -4516.551,
              2982.209
            ],
            [
              -303.365,
              -4503.347,
              3053.268
            ],
            [
              -273.394,
              -4484.966,
              3088.427
            ],
            [
              -264.839,
              -4475.102,
              3101.483
            ],
            [
              -248.495,
              -4462.041,
              3122.406
            ],
            [
              -208.316,
              -4413.789,
              3185.196
            ],
            [
              -185.328,
              -4389.716,
              3218.482
            ],
            [
              -166.99,
              -4373.351,
              3243.061
            ],
            [
              -153.302,
              -4364.694,
              3259.256
            ],
            [
              -100.827,
              -4348.95,
              3314.042
            ],
            [
              -72.426,
              -4346.128,
              3342.583
            ],
            [
              -23.455,
              -4345.907,
              3391.554
            ],
            [
              35.096,
              -4350.314,
              3450.271
            ],
            [
              46.147,
              -4344.95,
              3462.555
            ],
            [
              45.488,
              -4310.427,
              3497.084
            ],
            [
              49.82,
              -4284.902,
              3522.975
            ],
            [
              60.111,
              -4250.579,
              3558.807
            ],
            [
              104.143,
              -4062.131,
              3752.33
            ],
            [
              126.577,
              -3997.973,
              3820.298
            ],
            [
              148.043,
              -3951.609,
              3871.39
            ],
            [
              179.07,
              -3910.986,
              3922.507
            ],
            [
              264.038,
              -3810.121,
              4054.39
            ],
            [
              345.157,
              -3743.697,
              4159.235
            ],
            [
              383.579,
              -3686.512,
              4228.129
            ],
            [
              434.283,
              -3627.326,
              4306.064
            ],
            [
              450.253,
              -3599.787,
              4337.898
            ],
            [
              463.769,
              -3565.524,
              4374.731
            ],
            [
              474.065,
              -3531.203,
              4410.563
            ],
            [
              484.063,
              -3477.95,
              4464.746
            ],
            [
              489.712,
              -3345.578,
              4597.239
            ],
            [
              488.249,
              -3319.947,
              4622.912
            ],
            [
              479.687,
              -3259.675,
              4683.789
            ],
            [
              477.905,
              -3216.226,
              4727.275
            ],
            [
              481.339,
              -3169.533,
              4774.094
            ],
            [
              500.602,
              -3103.091,
              4843.271
            ],
            [
              500.428,
              -3077.483,
              4868.88
            ],
            [
              504.445,
              -3034.141,
              4912.408
            ],
            [
              503.491,
              -2980.688,
              4965.87
            ],
            [
              505.751,
              -2962.917,
              4983.783
            ],
            [
              502.159,
              -2912.756,
              5034.074
            ],
            [
              509.397,
              -2869.472,
              5077.958
            ],
            [
              513.301,
              -2797.183,
              5150.353
            ],
            [
              494.515,
              -2626.513,
              5322.054
            ],
            [
              482.722,
              -2601.805,
              5349.432
            ],
            [
              485.911,
              -2568.466,
              5382.922
            ],
            [
              462.343,
              -2342.047,
              5610.565
            ],
            [
              451.425,
              -2269.486,
              5683.943
            ],
            [
              407.176,
              -2116.162,
              5843.524
            ],
            [
              406.254,
              -2096.107,
              5863.601
            ],
            [
              361.405,
              -1904.922,
              6059.975
            ],
            [
              342.249,
              -1718.661,
              6247.219
            ],
            [
              324.984,
              -1640.419,
              6327.343
            ],
            [
              326.097,
              -1614.835,
              6352.952
            ],
            [
              277.22,
              -1255.479,
              6715.616
            ],
            [
              271.867,
              -1230.89,
              6740.781
            ],
            [
              265.625,
              -1219.643,
              6753.644
            ],
            [
              267.28,
              -1199.635,
              6773.72
            ],
            [
              254.802,
              -1141.519,
              6833.161
            ],
            [
              216.915,
              -885.896,
              7091.576
            ],
            [
              226.048,
              -703.492,
              7274.208
            ],
            [
              223.795,
              -685.64,
              7292.203
            ],
            [
              209.218,
              -636.391,
              7343.563
            ],
            [
              192.022,
              -589.321,
              7393.676
            ],
            [
              159.237,
              -513.023,
              7476.72
            ],
            [
              151.725,
              -500.641,
              7491.203
            ],
            [
              143.086,
              -479.332,
              7514.197
            ],
            [
              121.213,
              -441.083,
              7558.258
            ],
            [
              106.146,
              -277.163,
              7722.869
            ],
            [
              46.11,
              -280.522,
              7782.998
            ],
            [
              26.146,
              -279.045,
              7803.017
            ],
            [
              15.43,
              -265.491,
              7820.296
            ],
            [
              14.363,
              -253.226,
              7832.607
            ],
            [
              16.439,
              -245.471,
              7840.635
            ],
            [
              45.916,
              -220.403,
              7879.329
            ],
            [
              103.215,
              -190.277,
              7944.066
            ],
            [
              127.382,
              -102.772,
              8034.847
            ],
            [
              121.848,
              -52.576,
              8085.347
            ],
            [
              115.041,
              -36.866,
              8102.468
            ],
            [
              117.583,
              -3.516,
              8135.915
            ],
            [
              102.671,
              133.684,
              8273.923
            ],
            [
              63.181,
              125.497,
              8314.253
            ],
            [
              59.312,
              125.568,
              8318.122
            ],
            [
              57.419,
              127.829,
              8321.071
            ],
            [
              31.786,
              278.582,
              8473.988
            ],
            [
              4.856,
              358.112,
              8557.954
            ],
            [
              -8.924,
              380.627,
              8584.351
            ],
            [
              -39.768,
              422.378,
              8636.26
            ],
            [
              -46.8,
              425.846,
              8644.1
            ],
            [
              -51.212,
              431.492,
              8651.266
            ],
            [
              -51.307,
              497.175,
              8716.948
            ],
            [
              -56,
              522.864,
              8743.063
            ],
            [
              -44.593,
              547.148,
              8769.892
            ],
            [
              -34.25,
              619.32,
              8842.802
            ],
            [
              -34.886,
              726.201,
              8949.685
            ],
            [
              -29.964,
              784,
              9007.693
            ],
            [
              -31.514,
              805.179,
              9028.929
            ],
            [
              -24.076,
              823.969,
              9049.137
            ],
            [
              -6.94,
              914.942,
              9141.71
            ],
            [
              5.94,
              949.218,
              9178.326
            ],
            [
              14.89,
              980.225,
              9210.599
            ],
            [
              17.976,
              1008,
              9238.545
            ],
            [
              98.858,
              1127.869,
              9383.149
            ],
            [
              206.575,
              1304.022,
              9589.627
            ],
            [
              266.256,
              1357.482,
              9669.75
            ],
            [
              337.506,
              1408.502,
              9757.384
            ],
            [
              360.424,
              1427.008,
              9786.84
            ],
            [
              406.382,
              1470.698,
              9850.251
            ],
            [
              500.704,
              1583.635,
              9997.395
            ],
            [
              509.834,
              1589.034,
              10008.003
            ],
            [
              522.692,
              1586.572,
              10021.094
            ],
            [
              534.824,
              1579.67,
              10035.051
            ],
            [
              580.051,
              1583.295,
              10080.423
            ],
            [
              658.651,
              1577.401,
              10159.244
            ],
            [
              692.229,
              1579.012,
              10192.861
            ],
            [
              741.428,
              1588.128,
              10242.897
            ],
            [
              775.609,
              1587.5,
              10277.084
            ],
            [
              809.668,
              1580.195,
              10311.918
            ],
            [
              847.494,
              1567.254,
              10351.896
            ],
            [
              881.41,
              1552.158,
              10389.02
            ],
            [
              944.603,
              1515.372,
              10462.14
            ],
            [
              979.224,
              1503.603,
              10498.707
            ],
            [
              987.526,
              1498.997,
              10508.201
            ],
            [
              1015.114,
              1490.696,
              10537.011
            ],
            [
              1169.279,
              1454.457,
              10695.378
            ],
            [
              1174.911,
              1305.179,
              10844.762
            ],
            [
              1219.91,
              1296.555,
              10890.58
            ],
            [
              1270.109,
              1290.062,
              10941.197
            ],
            [
              1288.043,
              1283.051,
              10960.452
            ],
            [
              1461.257,
              1230.864,
              11141.358
            ],
            [
              1535.192,
              1217.248,
              11216.536
            ],
            [
              1586.927,
              1224.082,
              11268.72
            ],
            [
              1634.086,
              1227.66,
              11316.015
            ],
            [
              1673.61,
              1236.945,
              11356.615
            ],
            [
              1721.874,
              1230.483,
              11405.309
            ],
            [
              1775.523,
              1236.165,
              11459.259
            ],
            [
              1885.048,
              1263.072,
              11572.04
            ],
            [
              1894.159,
              1267.356,
              11582.108
            ],
            [
              1963.37,
              1277.199,
              11652.015
            ],
            [
              2112.443,
              1314.496,
              11805.684
            ],
            [
              2127.921,
              1314.207,
              11821.164
            ],
            [
              2155.776,
              1320.367,
              11849.692
            ],
            [
              2174.041,
              1331.158,
              11870.907
            ],
            [
              2182.009,
              1343.255,
              11885.392
            ],
            [
              2194.157,
              1371.972,
              11916.573
            ],
            [
              2203.248,
              1409.653,
              11955.335
            ],
            [
              2215.938,
              1432.794,
              11981.727
            ],
            [
              2225.175,
              1443.754,
              11996.06
            ],
            [
              2240.882,
              1455.706,
              12015.797
            ],
            [
              2252.719,
              1467.73,
              12032.671
            ],
            [
              2267.719,
              1476.356,
              12049.973
            ],
            [
              2303.897,
              1479.019,
              12086.249
            ],
            [
              2359.631,
              1492.448,
              12143.579
            ],
            [
              2355.491,
              1478.053,
              12158.557
            ],
            [
              2367.682,
              1474.486,
              12171.259
            ],
            [
              2429.655,
              1442.154,
              12241.16
            ],
            [
              2462.275,
              1427.071,
              12277.098
            ],
            [
              2496.871,
              1414.177,
              12314.019
            ],
            [
              2523.312,
              1413.681,
              12340.465
            ],
            [
              2540.143,
              1416.705,
              12357.565
            ],
            [
              2579.775,
              1431.547,
              12399.885
            ],
            [
              2615.559,
              1447.574,
              12439.094
            ],
            [
              2701.336,
              1480.473,
              12530.964
            ],
            [
              2766.788,
              1495.942,
              12598.218
            ],
            [
              2803.779,
              1507.492,
              12636.971
            ],
            [
              2823.834,
              1510.454,
              12657.244
            ],
            [
              2867.296,
              1522.995,
              12702.479
            ],
            [
              2890.618,
              1528.122,
              12726.358
            ],
            [
              2899.626,
              1526.839,
              12735.457
            ],
            [
              2908.446,
              1515.54,
              12749.79
            ],
            [
              2909.484,
              1502.162,
              12763.209
            ],
            [
              2907.465,
              1497.747,
              12768.063
            ],
            [
              2897.77,
              1496.816,
              12777.803
            ],
            [
              2870.248,
              1508.467,
              12807.689
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5803",
              "position": {
                "x": -2249.272,
                "z": -4768.989
              },
              "distanceAlongShapeM": 109.828,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5804",
              "position": {
                "x": -2134.709,
                "z": -4666.379
              },
              "distanceAlongShapeM": 294.092,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5808",
              "position": {
                "x": -1961.313,
                "z": -4769.653
              },
              "distanceAlongShapeM": 504.757,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 937.186,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 1339.094,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:348",
              "position": {
                "x": -871.52,
                "z": -5283.459
              },
              "distanceAlongShapeM": 1851.481,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5833",
              "position": {
                "x": -646.915,
                "z": -4511.591
              },
              "distanceAlongShapeM": 2707.859,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 3522.975,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 3871.39,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 4228.129,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 5034.074,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 5349.432,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 5843.524,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 6327.343,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 6753.644,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 7558.258,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 8102.468,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 8743.063,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 9238.545,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 9589.627,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 10080.423,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 10498.707,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5360",
              "position": {
                "x": 1270.109,
                "z": 1290.062
              },
              "distanceAlongShapeM": 10941.197,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5362",
              "position": {
                "x": 1673.61,
                "z": 1236.945
              },
              "distanceAlongShapeM": 11356.615,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5854",
              "position": {
                "x": 2112.443,
                "z": 1314.496
              },
              "distanceAlongShapeM": 11805.684,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5857",
              "position": {
                "x": 2701.336,
                "z": 1480.473
              },
              "distanceAlongShapeM": 12530.964,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:8336",
              "position": {
                "x": 2870.248,
                "z": 1508.467
              },
              "distanceAlongShapeM": 12807.689,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            }
          ],
          "departuresSeconds": [
            19800,
            21660,
            22500,
            23400,
            24300,
            25260,
            26280,
            27300,
            28320,
            29340,
            30540,
            31740,
            33240,
            34260,
            35340,
            36420,
            37500,
            38580,
            39660,
            40560,
            41460,
            42420,
            43380,
            44340,
            45300,
            46260,
            47220,
            48180,
            49200,
            50220,
            51180,
            52140,
            53100,
            54060,
            55080,
            55920,
            56820,
            57660,
            58500,
            59520,
            60660,
            61800,
            63060,
            64380,
            65820,
            67260,
            68100,
            69060,
            70380,
            71520,
            72360,
            73200,
            74100,
            75000,
            75960,
            76860,
            77760,
            78840,
            79920,
            80880,
            83520
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_10:1",
          "sourceRouteId": "vilnius_bus_10",
          "sourceShapeId": "vilnius_bus_10_b1-a1",
          "directionId": 1,
          "headsign": "Fabijoniškės",
          "directionName": "Markučiai–Baltupiai–Fabijoniškės",
          "mode": "bus",
          "routeShortName": "10",
          "routeLongName": "Fabijoniškės–Baltupiai–Markučiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2870.248,
              1508.467,
              0
            ],
            [
              2863.321,
              1517.503,
              11.386
            ],
            [
              2825.769,
              1510.417,
              49.601
            ],
            [
              2756.406,
              1492.797,
              121.167
            ],
            [
              2671.356,
              1464.338,
              210.852
            ],
            [
              2656.314,
              1453.488,
              229.399
            ],
            [
              2635.614,
              1450.537,
              250.308
            ],
            [
              2538.187,
              1415.628,
              353.8
            ],
            [
              2526.454,
              1409.169,
              367.194
            ],
            [
              2514.2,
              1409.399,
              379.45
            ],
            [
              2451.312,
              1427.276,
              444.83
            ],
            [
              2376.565,
              1466.527,
              529.256
            ],
            [
              2338.099,
              1479.492,
              569.848
            ],
            [
              2266.408,
              1475.267,
              641.663
            ],
            [
              2244.855,
              1461.198,
              667.402
            ],
            [
              2214.607,
              1430.592,
              710.433
            ],
            [
              2183.881,
              1339.88,
              806.207
            ],
            [
              2175.872,
              1325.557,
              822.617
            ],
            [
              2161.497,
              1315.807,
              839.987
            ],
            [
              2119.309,
              1302.122,
              884.339
            ],
            [
              2063.598,
              1289.803,
              941.395
            ],
            [
              2047.248,
              1277.862,
              961.642
            ],
            [
              2007.868,
              1276.37,
              1001.05
            ],
            [
              1907.433,
              1252.636,
              1104.251
            ],
            [
              1817.42,
              1234.273,
              1196.118
            ],
            [
              1745.61,
              1223.362,
              1268.752
            ],
            [
              1634.607,
              1220.971,
              1379.781
            ],
            [
              1600.284,
              1213.815,
              1414.842
            ],
            [
              1535.192,
              1217.248,
              1480.025
            ],
            [
              1461.257,
              1230.864,
              1555.203
            ],
            [
              1250.055,
              1287.093,
              1773.761
            ],
            [
              1216.542,
              1288.825,
              1807.32
            ],
            [
              1174.911,
              1305.179,
              1852.047
            ],
            [
              1169.279,
              1454.457,
              2001.431
            ],
            [
              967.492,
              1497.139,
              2207.683
            ],
            [
              940.672,
              1512.105,
              2238.397
            ],
            [
              883.949,
              1549.885,
              2306.55
            ],
            [
              863.515,
              1561.393,
              2330.001
            ],
            [
              775.609,
              1587.5,
              2421.702
            ],
            [
              747.11,
              1581.344,
              2450.859
            ],
            [
              677.252,
              1571.494,
              2521.407
            ],
            [
              534.824,
              1579.67,
              2664.07
            ],
            [
              500.201,
              1591.437,
              2700.637
            ],
            [
              472.7,
              1534.052,
              2764.272
            ],
            [
              453.691,
              1517.701,
              2789.345
            ],
            [
              360.424,
              1427.008,
              2919.437
            ],
            [
              315.899,
              1391.085,
              2976.647
            ],
            [
              256.42,
              1348.755,
              3049.651
            ],
            [
              223.566,
              1315.958,
              3096.073
            ],
            [
              196.476,
              1280.829,
              3140.435
            ],
            [
              149.248,
              1202.651,
              3231.771
            ],
            [
              55.081,
              1061.873,
              3401.14
            ],
            [
              52.802,
              1042.989,
              3420.16
            ],
            [
              42.322,
              1034.274,
              3433.79
            ],
            [
              29.685,
              1013.353,
              3458.232
            ],
            [
              17.226,
              966.824,
              3506.4
            ],
            [
              -2.949,
              921.549,
              3555.967
            ],
            [
              -20.167,
              826.124,
              3652.933
            ],
            [
              -26.358,
              769.462,
              3709.932
            ],
            [
              -34.886,
              726.201,
              3754.025
            ],
            [
              -34.25,
              619.32,
              3860.909
            ],
            [
              -49.15,
              509.381,
              3971.853
            ],
            [
              -51.111,
              437.057,
              4044.204
            ],
            [
              -46.759,
              428.072,
              4054.187
            ],
            [
              -39.768,
              422.378,
              4063.203
            ],
            [
              18.234,
              348.963,
              4156.766
            ],
            [
              36.62,
              260.682,
              4246.941
            ],
            [
              56.855,
              132.292,
              4376.916
            ],
            [
              59.373,
              128.907,
              4381.135
            ],
            [
              70.978,
              128.695,
              4392.742
            ],
            [
              102.671,
              133.684,
              4424.825
            ],
            [
              116.145,
              94.475,
              4466.285
            ],
            [
              129.88,
              -107.271,
              4668.497
            ],
            [
              116.846,
              -256.206,
              4818.002
            ],
            [
              117.887,
              -305.208,
              4867.015
            ],
            [
              127.989,
              -387.771,
              4950.194
            ],
            [
              138.319,
              -422.47,
              4986.397
            ],
            [
              150.182,
              -443.837,
              5010.837
            ],
            [
              177.186,
              -518.917,
              5090.625
            ],
            [
              237.149,
              -695.903,
              5277.493
            ],
            [
              238.113,
              -713.732,
              5295.348
            ],
            [
              217.158,
              -872.542,
              5455.535
            ],
            [
              276.82,
              -1242.113,
              5829.89
            ],
            [
              297.35,
              -1318.188,
              5908.687
            ],
            [
              320.249,
              -1546.82,
              6138.463
            ],
            [
              342.249,
              -1718.661,
              6311.707
            ],
            [
              356.237,
              -1764.56,
              6359.69
            ],
            [
              354.758,
              -1810.175,
              6405.329
            ],
            [
              356.121,
              -1841.371,
              6436.555
            ],
            [
              372.957,
              -1942.984,
              6539.553
            ],
            [
              426.379,
              -2158.817,
              6761.899
            ],
            [
              441.836,
              -2194.724,
              6800.991
            ],
            [
              440.947,
              -2208.066,
              6814.364
            ],
            [
              462.343,
              -2342.047,
              6950.042
            ],
            [
              505.139,
              -2574.385,
              7186.289
            ],
            [
              511.756,
              -2776.003,
              7388.015
            ],
            [
              513.301,
              -2797.183,
              7409.251
            ],
            [
              524.563,
              -2850.825,
              7464.063
            ],
            [
              524.913,
              -2902.04,
              7515.28
            ],
            [
              518.333,
              -3049.981,
              7663.366
            ],
            [
              517.855,
              -3111.2,
              7724.588
            ],
            [
              506.223,
              -3253.482,
              7867.344
            ],
            [
              511.316,
              -3256.915,
              7873.486
            ],
            [
              504.142,
              -3366.994,
              7983.799
            ],
            [
              489.873,
              -3512.567,
              8130.069
            ],
            [
              474.056,
              -3566.826,
              8186.586
            ],
            [
              441.104,
              -3641.923,
              8268.595
            ],
            [
              383.151,
              -3709.882,
              8357.908
            ],
            [
              303.678,
              -3791.921,
              8472.129
            ],
            [
              278.895,
              -3808.166,
              8501.762
            ],
            [
              228.358,
              -3858.451,
              8573.054
            ],
            [
              158.106,
              -3965.152,
              8700.805
            ],
            [
              127.093,
              -4040.286,
              8782.088
            ],
            [
              102.95,
              -4092.167,
              8839.312
            ],
            [
              79.561,
              -4208.631,
              8958.101
            ],
            [
              75.006,
              -4246.398,
              8996.142
            ],
            [
              72.804,
              -4296.453,
              9046.246
            ],
            [
              62.209,
              -4347.469,
              9098.35
            ],
            [
              53.653,
              -4357.332,
              9111.407
            ],
            [
              38.073,
              -4363.727,
              9128.249
            ],
            [
              -1.759,
              -4357.435,
              9168.574
            ],
            [
              -43.706,
              -4361.123,
              9210.683
            ],
            [
              -86.799,
              -4356.998,
              9253.973
            ],
            [
              -112.623,
              -4359.868,
              9279.956
            ],
            [
              -137.864,
              -4366.088,
              9305.952
            ],
            [
              -171.117,
              -4387.748,
              9345.638
            ],
            [
              -197.387,
              -4415.101,
              9383.562
            ],
            [
              -229.695,
              -4455.703,
              9435.451
            ],
            [
              -260.472,
              -4482.974,
              9476.572
            ],
            [
              -335.167,
              -4516.128,
              9558.294
            ],
            [
              -368.095,
              -4519.983,
              9591.447
            ],
            [
              -469.274,
              -4521.487,
              9692.636
            ],
            [
              -484.832,
              -4526.772,
              9709.068
            ],
            [
              -495.157,
              -4527.698,
              9719.434
            ],
            [
              -531.808,
              -4523.694,
              9756.303
            ],
            [
              -716.635,
              -4519.236,
              9941.183
            ],
            [
              -810.335,
              -4855.967,
              10290.708
            ],
            [
              -844.605,
              -4970.012,
              10409.791
            ],
            [
              -859.998,
              -5037.642,
              10479.15
            ],
            [
              -867.261,
              -5083.153,
              10525.237
            ],
            [
              -868.447,
              -5113.189,
              10555.297
            ],
            [
              -863.974,
              -5257.991,
              10700.167
            ],
            [
              -873.83,
              -5375.816,
              10818.404
            ],
            [
              -880.43,
              -5384.602,
              10829.393
            ],
            [
              -887.614,
              -5390.039,
              10838.402
            ],
            [
              -927.257,
              -5373.739,
              10881.266
            ],
            [
              -1090.384,
              -5275.062,
              11071.916
            ],
            [
              -1302.999,
              -5205.56,
              11295.603
            ],
            [
              -1387.604,
              -5181.778,
              11383.486
            ],
            [
              -1687.713,
              -4997.177,
              11735.825
            ],
            [
              -1731.791,
              -4976.352,
              11784.575
            ],
            [
              -1760.592,
              -4965.819,
              11815.242
            ],
            [
              -1786.639,
              -4945.316,
              11848.39
            ],
            [
              -1870.695,
              -4890.382,
              11948.805
            ],
            [
              -2020.603,
              -4770.824,
              12140.551
            ],
            [
              -2056.897,
              -4746.801,
              12184.075
            ],
            [
              -2116.546,
              -4695.646,
              12262.656
            ],
            [
              -2169.487,
              -4665.762,
              12323.449
            ],
            [
              -2190.603,
              -4657.594,
              12346.089
            ],
            [
              -2199.666,
              -4696.396,
              12385.936
            ],
            [
              -2209.584,
              -4710.692,
              12403.335
            ],
            [
              -2216.727,
              -4713.905,
              12411.167
            ],
            [
              -2261.533,
              -4697.525,
              12458.874
            ],
            [
              -2270.649,
              -4702.93,
              12469.471
            ],
            [
              -2259.201,
              -4747.662,
              12515.644
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8336",
              "position": {
                "x": 2870.248,
                "z": 1508.467
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5858",
              "position": {
                "x": 2656.314,
                "z": 1453.488
              },
              "distanceAlongShapeM": 229.399,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5855",
              "position": {
                "x": 2047.248,
                "z": 1277.862
              },
              "distanceAlongShapeM": 961.642,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:946",
              "position": {
                "x": 1600.284,
                "z": 1213.815
              },
              "distanceAlongShapeM": 1414.842,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5428",
              "position": {
                "x": 1216.542,
                "z": 1288.825
              },
              "distanceAlongShapeM": 1807.32,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:15581",
              "position": {
                "x": 677.252,
                "z": 1571.494
              },
              "distanceAlongShapeM": 2521.407,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 2764.272,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 3420.16,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 3709.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 4156.766,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 4466.285,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 5010.837,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 5908.687,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 6359.69,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 6800.991,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 7186.289,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 7873.486,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 8472.129,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 8782.088,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5835",
              "position": {
                "x": -43.706,
                "z": -4361.123
              },
              "distanceAlongShapeM": 9210.683,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5834",
              "position": {
                "x": -495.157,
                "z": -4527.698
              },
              "distanceAlongShapeM": 9719.434,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5822",
              "position": {
                "x": -927.257,
                "z": -5373.739
              },
              "distanceAlongShapeM": 10881.266,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2490,
              "departureOffsetSeconds": 2490
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 11383.486,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5812",
              "position": {
                "x": -1760.592,
                "z": -4965.819
              },
              "distanceAlongShapeM": 11815.242,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2670,
              "departureOffsetSeconds": 2670
            },
            {
              "stopId": "judu:stop:5807",
              "position": {
                "x": -2056.897,
                "z": -4746.801
              },
              "distanceAlongShapeM": 12184.075,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2730,
              "departureOffsetSeconds": 2730
            },
            {
              "stopId": "judu:stop:8258",
              "position": {
                "x": -2259.201,
                "z": -4747.662
              },
              "distanceAlongShapeM": 12515.644,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            }
          ],
          "departuresSeconds": [
            19560,
            20760,
            21600,
            22740,
            23940,
            24660,
            25320,
            26040,
            26760,
            27660,
            28560,
            29640,
            30720,
            31800,
            32880,
            34020,
            35220,
            36360,
            37560,
            38700,
            39840,
            40860,
            41820,
            42780,
            43800,
            44820,
            45780,
            46800,
            47820,
            48720,
            49620,
            50520,
            51540,
            52560,
            53580,
            54600,
            55620,
            56640,
            57660,
            58680,
            59640,
            60600,
            61380,
            62220,
            63060,
            64320,
            65580,
            66780,
            67980,
            69180,
            70380,
            71460,
            72540,
            73620,
            74700,
            75540,
            76380,
            77280,
            78180,
            79080,
            79860,
            80640,
            81900,
            83100
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_11",
      "sourceRouteId": "vilnius_bus_11",
      "mode": "bus",
      "shortName": "11",
      "longName": "Žvėrynas–Senamiestis–Užupis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_11:0",
          "sourceRouteId": "vilnius_bus_11",
          "sourceShapeId": "vilnius_bus_11_a1-b1",
          "directionId": 0,
          "headsign": "Užupis",
          "directionName": "Žvėrynas–Senamiestis–Užupis",
          "mode": "bus",
          "routeShortName": "11",
          "routeLongName": "Žvėrynas–Senamiestis–Užupis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2123.206,
              -1077.551,
              0
            ],
            [
              -2103.81,
              -1074.556,
              19.626
            ],
            [
              -2090.919,
              -1074.785,
              32.519
            ],
            [
              -2044.243,
              -1096.764,
              84.112
            ],
            [
              -2000.939,
              -1090.854,
              127.817
            ],
            [
              -1847.467,
              -1053.508,
              285.767
            ],
            [
              -1747.184,
              -1034.143,
              387.903
            ],
            [
              -1694.072,
              -1020.619,
              442.71
            ],
            [
              -1436.344,
              -850.447,
              751.55
            ],
            [
              -1444.532,
              -803.545,
              799.161
            ],
            [
              -1437.755,
              -749.118,
              854.008
            ],
            [
              -1410.822,
              -361.085,
              1242.975
            ],
            [
              -1412.477,
              -345.47,
              1258.677
            ],
            [
              -1406.663,
              -308.838,
              1295.768
            ],
            [
              -1394.376,
              -198.849,
              1406.442
            ],
            [
              -1393.853,
              -97.555,
              1507.737
            ],
            [
              -1388.929,
              -38.642,
              1566.855
            ],
            [
              -1362.417,
              -34.664,
              1593.664
            ],
            [
              -1329.577,
              -37.478,
              1626.625
            ],
            [
              -1190.447,
              -11.028,
              1768.246
            ],
            [
              -1025.306,
              27.195,
              1937.753
            ],
            [
              -994.12,
              39.993,
              1971.463
            ],
            [
              -949.475,
              48.095,
              2016.838
            ],
            [
              -919.958,
              39.772,
              2047.505
            ],
            [
              -857.805,
              53.124,
              2111.077
            ],
            [
              -724.996,
              86.353,
              2247.98
            ],
            [
              -591.62,
              115.115,
              2384.421
            ],
            [
              -557.893,
              125.637,
              2419.751
            ],
            [
              -539.176,
              126.412,
              2438.485
            ],
            [
              -408.498,
              148.538,
              2571.023
            ],
            [
              -385.731,
              159.258,
              2596.187
            ],
            [
              -216.06,
              268.617,
              2798.048
            ],
            [
              -50.385,
              441.496,
              3037.496
            ],
            [
              -51.307,
              497.175,
              3093.182
            ],
            [
              -56,
              522.864,
              3119.297
            ],
            [
              -44.593,
              547.148,
              3146.126
            ],
            [
              -34.25,
              619.32,
              3219.035
            ],
            [
              -34.886,
              726.201,
              3325.919
            ],
            [
              -29.964,
              784,
              3383.926
            ],
            [
              -31.514,
              805.179,
              3405.162
            ],
            [
              -24.076,
              823.969,
              3425.37
            ],
            [
              -6.94,
              914.942,
              3517.943
            ],
            [
              5.94,
              949.218,
              3554.559
            ],
            [
              14.89,
              980.225,
              3586.833
            ],
            [
              17.976,
              1008,
              3614.778
            ],
            [
              98.858,
              1127.869,
              3759.383
            ],
            [
              206.575,
              1304.022,
              3965.86
            ],
            [
              266.256,
              1357.482,
              4045.983
            ],
            [
              337.506,
              1408.502,
              4133.617
            ],
            [
              360.424,
              1427.008,
              4163.074
            ],
            [
              406.382,
              1470.698,
              4226.484
            ],
            [
              500.704,
              1583.635,
              4373.628
            ],
            [
              509.834,
              1589.034,
              4384.236
            ],
            [
              522.692,
              1586.572,
              4397.328
            ],
            [
              534.824,
              1579.67,
              4411.285
            ],
            [
              580.051,
              1583.295,
              4456.657
            ],
            [
              658.651,
              1577.401,
              4535.478
            ],
            [
              692.229,
              1579.012,
              4569.094
            ],
            [
              741.428,
              1588.128,
              4619.13
            ],
            [
              775.609,
              1587.5,
              4653.318
            ],
            [
              809.668,
              1580.195,
              4688.151
            ],
            [
              847.494,
              1567.254,
              4728.13
            ],
            [
              881.41,
              1552.158,
              4765.253
            ],
            [
              944.603,
              1515.372,
              4838.373
            ],
            [
              979.224,
              1503.603,
              4874.94
            ],
            [
              987.526,
              1498.997,
              4884.434
            ],
            [
              1015.114,
              1490.696,
              4913.244
            ],
            [
              1169.279,
              1454.457,
              5071.612
            ],
            [
              1174.911,
              1305.179,
              5220.995
            ],
            [
              1219.91,
              1296.555,
              5266.813
            ],
            [
              1270.109,
              1290.062,
              5317.43
            ],
            [
              1288.043,
              1283.051,
              5336.686
            ],
            [
              1461.257,
              1230.864,
              5517.591
            ],
            [
              1464.213,
              1216.337,
              5532.416
            ],
            [
              1462.114,
              1207.47,
              5541.528
            ],
            [
              1454.169,
              1196.485,
              5555.085
            ],
            [
              1434.198,
              1197.968,
              5575.111
            ],
            [
              1382.814,
              1210.051,
              5627.897
            ],
            [
              1330.619,
              1213.243,
              5680.189
            ],
            [
              1297.566,
              1204.948,
              5714.267
            ],
            [
              1268.299,
              1192.13,
              5746.218
            ],
            [
              1139.738,
              1112.124,
              5897.64
            ],
            [
              1020.917,
              1035.275,
              6039.148
            ],
            [
              994.589,
              1006.816,
              6077.917
            ],
            [
              976.042,
              980.44,
              6110.162
            ],
            [
              965.109,
              947.244,
              6145.112
            ],
            [
              960.871,
              927.284,
              6165.517
            ],
            [
              942.928,
              898.67,
              6199.291
            ],
            [
              924.197,
              862.278,
              6240.221
            ],
            [
              1006.501,
              883.027,
              6325.1
            ],
            [
              1024.034,
              889.384,
              6343.75
            ],
            [
              1047.228,
              887.843,
              6366.995
            ],
            [
              1102.396,
              871.241,
              6424.608
            ],
            [
              1172.005,
              833.219,
              6503.924
            ],
            [
              1193.244,
              830.601,
              6525.323
            ],
            [
              1219.078,
              832.35,
              6551.216
            ],
            [
              1253.858,
              829.481,
              6586.114
            ],
            [
              1296.753,
              811.99,
              6632.438
            ],
            [
              1366.147,
              797.348,
              6703.36
            ],
            [
              1398.223,
              787.848,
              6736.814
            ],
            [
              1417.424,
              779.7,
              6757.672
            ],
            [
              1452.786,
              773.479,
              6793.577
            ],
            [
              1481.823,
              774.054,
              6822.62
            ],
            [
              1480.513,
              772.965,
              6824.324
            ],
            [
              1534.513,
              763.059,
              6879.225
            ],
            [
              1595.023,
              756.37,
              6940.103
            ],
            [
              1777.924,
              740.728,
              7123.672
            ],
            [
              1802.116,
              723.579,
              7153.326
            ],
            [
              1938.363,
              662.041,
              7302.825
            ],
            [
              1951.821,
              657.337,
              7317.082
            ],
            [
              1982.023,
              651.208,
              7347.899
            ],
            [
              2056.134,
              647.6,
              7422.098
            ],
            [
              2120.074,
              651.973,
              7486.187
            ],
            [
              2202.359,
              671.588,
              7570.778
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4898",
              "position": {
                "x": -2071.721,
                "z": -1082.918
              },
              "distanceAlongShapeM": 53.353,
              "shapeOffsetM": 0.821,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5872",
              "position": {
                "x": -1444.532,
                "z": -803.545
              },
              "distanceAlongShapeM": 799.161,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5875",
              "position": {
                "x": -1412.477,
                "z": -345.47
              },
              "distanceAlongShapeM": 1258.677,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5880",
              "position": {
                "x": -1362.417,
                "z": -34.664
              },
              "distanceAlongShapeM": 1593.664,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5881",
              "position": {
                "x": -949.475,
                "z": 48.095
              },
              "distanceAlongShapeM": 2016.838,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 2419.751,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 3119.297,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 3614.778,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 3965.86,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 4456.657,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 4874.94,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5360",
              "position": {
                "x": 1270.109,
                "z": 1290.062
              },
              "distanceAlongShapeM": 5317.43,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7124",
              "position": {
                "x": 960.871,
                "z": 927.284
              },
              "distanceAlongShapeM": 6165.517,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5900",
              "position": {
                "x": 1024.034,
                "z": 889.384
              },
              "distanceAlongShapeM": 6343.75,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5901",
              "position": {
                "x": 1480.513,
                "z": 772.965
              },
              "distanceAlongShapeM": 6824.324,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5902",
              "position": {
                "x": 1777.924,
                "z": 740.728
              },
              "distanceAlongShapeM": 7123.672,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5904",
              "position": {
                "x": 2202.359,
                "z": 671.588
              },
              "distanceAlongShapeM": 7570.778,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            19320,
            21180,
            23040,
            24900,
            27000,
            29100,
            32340,
            34680,
            36960,
            39240,
            41400,
            43500,
            45540,
            47520,
            49620,
            51660,
            53700,
            55740,
            57780,
            59880,
            62040,
            64200,
            66780,
            69540,
            72060,
            73920,
            75900,
            77880,
            79860,
            81720,
            83580
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_11:1",
          "sourceRouteId": "vilnius_bus_11",
          "sourceShapeId": "vilnius_bus_11_b-a",
          "directionId": 1,
          "headsign": "Žvėrynas",
          "directionName": "Užupis–Senamiestis–Žvėrynas",
          "mode": "bus",
          "routeShortName": "11",
          "routeLongName": "Žvėrynas–Senamiestis–Užupis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2202.359,
              671.588,
              0
            ],
            [
              2281.67,
              670.105,
              79.325
            ],
            [
              2285.519,
              703.43,
              112.872
            ],
            [
              2286.06,
              732.364,
              141.811
            ],
            [
              2274.704,
              814.957,
              225.181
            ],
            [
              2261.392,
              861.962,
              274.035
            ],
            [
              2144.257,
              1048.95,
              494.682
            ],
            [
              2116.361,
              1075.075,
              532.901
            ],
            [
              2107.082,
              1096.4,
              556.157
            ],
            [
              2088.256,
              1124.583,
              590.05
            ],
            [
              2063.5,
              1146.196,
              622.913
            ],
            [
              2049.437,
              1153.138,
              638.595
            ],
            [
              2015.466,
              1164.904,
              674.546
            ],
            [
              1965.977,
              1174.732,
              725.002
            ],
            [
              1928.988,
              1197.686,
              768.534
            ],
            [
              1911.304,
              1218.054,
              795.507
            ],
            [
              1889.313,
              1249.634,
              833.99
            ],
            [
              1817.42,
              1234.273,
              907.506
            ],
            [
              1745.61,
              1223.362,
              980.14
            ],
            [
              1634.607,
              1220.971,
              1091.169
            ],
            [
              1600.284,
              1213.815,
              1126.23
            ],
            [
              1535.192,
              1217.248,
              1191.413
            ],
            [
              1461.257,
              1230.864,
              1266.591
            ],
            [
              1250.055,
              1287.093,
              1485.149
            ],
            [
              1216.542,
              1288.825,
              1518.708
            ],
            [
              1174.911,
              1305.179,
              1563.435
            ],
            [
              1169.279,
              1454.457,
              1712.819
            ],
            [
              967.492,
              1497.139,
              1919.071
            ],
            [
              940.672,
              1512.105,
              1949.785
            ],
            [
              883.949,
              1549.885,
              2017.938
            ],
            [
              863.515,
              1561.393,
              2041.389
            ],
            [
              775.609,
              1587.5,
              2133.09
            ],
            [
              747.11,
              1581.344,
              2162.247
            ],
            [
              677.252,
              1571.494,
              2232.795
            ],
            [
              534.824,
              1579.67,
              2375.458
            ],
            [
              518.198,
              1587.767,
              2393.951
            ],
            [
              513.684,
              1587.85,
              2398.466
            ],
            [
              494.797,
              1578.177,
              2419.686
            ],
            [
              482.238,
              1561.708,
              2440.397
            ],
            [
              482.659,
              1549.455,
              2452.657
            ],
            [
              472.7,
              1534.052,
              2470.999
            ],
            [
              453.691,
              1517.701,
              2496.072
            ],
            [
              360.424,
              1427.008,
              2626.165
            ],
            [
              315.899,
              1391.085,
              2683.374
            ],
            [
              256.42,
              1348.755,
              2756.378
            ],
            [
              223.566,
              1315.958,
              2802.801
            ],
            [
              196.476,
              1280.829,
              2847.162
            ],
            [
              149.248,
              1202.651,
              2938.499
            ],
            [
              55.081,
              1061.873,
              3107.868
            ],
            [
              52.802,
              1042.989,
              3126.888
            ],
            [
              42.322,
              1034.274,
              3140.518
            ],
            [
              29.685,
              1013.353,
              3164.96
            ],
            [
              17.226,
              966.824,
              3213.128
            ],
            [
              -2.949,
              921.549,
              3262.695
            ],
            [
              -20.167,
              826.124,
              3359.66
            ],
            [
              -26.358,
              769.462,
              3416.66
            ],
            [
              -34.886,
              726.201,
              3460.753
            ],
            [
              -34.25,
              619.32,
              3567.637
            ],
            [
              -49.15,
              509.381,
              3678.58
            ],
            [
              -50.587,
              430.368,
              3757.607
            ],
            [
              -86.677,
              396.514,
              3807.09
            ],
            [
              -97.297,
              380.009,
              3826.716
            ],
            [
              -191.175,
              289.316,
              3957.247
            ],
            [
              -216.06,
              268.617,
              3989.615
            ],
            [
              -386.375,
              159.27,
              4192.011
            ],
            [
              -408.498,
              148.538,
              4216.599
            ],
            [
              -583.944,
              111.636,
              4395.884
            ],
            [
              -658.953,
              100.746,
              4471.679
            ],
            [
              -724.996,
              86.353,
              4539.272
            ],
            [
              -736.157,
              75.422,
              4554.895
            ],
            [
              -743.833,
              78.9,
              4563.322
            ],
            [
              -798.875,
              66.534,
              4619.736
            ],
            [
              -863.023,
              49.879,
              4686.011
            ],
            [
              -870.86,
              44.454,
              4695.542
            ],
            [
              -881.155,
              45.752,
              4705.919
            ],
            [
              -934.202,
              36.688,
              4759.735
            ],
            [
              -998.108,
              33.385,
              4823.727
            ],
            [
              -1169.756,
              -8.06,
              5000.307
            ],
            [
              -1264.262,
              -27.516,
              5096.795
            ],
            [
              -1378.268,
              -55.531,
              5214.193
            ],
            [
              -1391.122,
              -53.075,
              5227.28
            ],
            [
              -1389.273,
              -129.92,
              5304.147
            ],
            [
              -1397.824,
              -283.392,
              5457.857
            ],
            [
              -1404.948,
              -321.114,
              5496.246
            ],
            [
              -1437.755,
              -749.118,
              5925.506
            ],
            [
              -1435.814,
              -784.776,
              5961.216
            ],
            [
              -1429.022,
              -801.596,
              5979.356
            ],
            [
              -1436.344,
              -850.447,
              6028.752
            ],
            [
              -1681.042,
              -1013.058,
              6322.554
            ],
            [
              -1696.006,
              -1020.584,
              6339.304
            ],
            [
              -1761.404,
              -1036.116,
              6406.521
            ],
            [
              -1847.467,
              -1053.508,
              6494.324
            ],
            [
              -1896.086,
              -1068.228,
              6545.123
            ],
            [
              -1911.753,
              -1079.081,
              6564.182
            ],
            [
              -1931.09,
              -1078.737,
              6583.522
            ],
            [
              -2127.883,
              -1123.11,
              6785.255
            ],
            [
              -2142.708,
              -1122.847,
              6800.082
            ],
            [
              -2146.884,
              -1103.849,
              6819.535
            ],
            [
              -2147.213,
              -1086.031,
              6837.355
            ],
            [
              -2123.206,
              -1077.551,
              6862.815
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5904",
              "position": {
                "x": 2202.359,
                "z": 671.588
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5925",
              "position": {
                "x": 2116.361,
                "z": 1075.075
              },
              "distanceAlongShapeM": 532.901,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:946",
              "position": {
                "x": 1600.284,
                "z": 1213.815
              },
              "distanceAlongShapeM": 1126.23,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5428",
              "position": {
                "x": 1216.542,
                "z": 1288.825
              },
              "distanceAlongShapeM": 1518.708,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:15581",
              "position": {
                "x": 677.252,
                "z": 1571.494
              },
              "distanceAlongShapeM": 2232.795,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 2470.999,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 3126.888,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 3416.66,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 3826.716,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5936",
              "position": {
                "x": -736.157,
                "z": 75.422
              },
              "distanceAlongShapeM": 4554.895,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:19193",
              "position": {
                "x": -870.86,
                "z": 44.454
              },
              "distanceAlongShapeM": 4695.542,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:1116",
              "position": {
                "x": -1397.824,
                "z": -283.392
              },
              "distanceAlongShapeM": 5457.857,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:632",
              "position": {
                "x": -1429.022,
                "z": -801.596
              },
              "distanceAlongShapeM": 5979.356,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6432",
              "position": {
                "x": -1911.753,
                "z": -1079.081
              },
              "distanceAlongShapeM": 6564.182,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:18481",
              "position": {
                "x": -2146.884,
                "z": -1103.849
              },
              "distanceAlongShapeM": 6819.535,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            }
          ],
          "departuresSeconds": [
            19200,
            20820,
            22680,
            24600,
            26460,
            28620,
            30720,
            34020,
            36360,
            38580,
            40860,
            43020,
            45120,
            47160,
            49140,
            51180,
            53280,
            55320,
            57360,
            59400,
            61560,
            63840,
            66000,
            68460,
            71160,
            73680,
            75480,
            77460,
            79440,
            81420,
            83280,
            85140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_12",
      "sourceRouteId": "vilnius_bus_12",
      "mode": "bus",
      "shortName": "12",
      "longName": "Stotis–Rudamina–Skaidiškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_12:0",
          "sourceRouteId": "vilnius_bus_12",
          "sourceShapeId": "vilnius_bus_12_a-b",
          "directionId": 0,
          "headsign": "Skaidiškės",
          "directionName": "Stotis–Rudamina–Skaidiškės",
          "mode": "bus",
          "routeShortName": "12",
          "routeLongName": "Stotis–Rudamina–Skaidiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              448.101,
              1917.454,
              0
            ],
            [
              414.243,
              1935.885,
              38.55
            ],
            [
              388.144,
              1955.287,
              71.07
            ],
            [
              374.884,
              1971.114,
              91.718
            ],
            [
              370.552,
              1981.213,
              102.707
            ],
            [
              369.405,
              1989.026,
              110.604
            ],
            [
              372.127,
              1996.769,
              118.811
            ],
            [
              376.723,
              2001.138,
              125.153
            ],
            [
              383.214,
              2003.246,
              131.977
            ],
            [
              391.578,
              2001.98,
              140.437
            ],
            [
              462.481,
              1962.833,
              221.428
            ],
            [
              478.32,
              1946.958,
              243.854
            ],
            [
              475.394,
              1928.087,
              262.951
            ],
            [
              494.54,
              1916.604,
              285.276
            ],
            [
              623.161,
              1858.587,
              426.377
            ],
            [
              825.163,
              1791.425,
              639.251
            ],
            [
              862.14,
              1837.501,
              698.33
            ],
            [
              869.06,
              1862.978,
              724.73
            ],
            [
              873.401,
              1888.503,
              750.621
            ],
            [
              889.31,
              1911.588,
              778.658
            ],
            [
              908.823,
              1920.135,
              799.961
            ],
            [
              941.154,
              1923.993,
              832.521
            ],
            [
              953.593,
              1933.783,
              848.351
            ],
            [
              1083.618,
              2057.184,
              1027.611
            ],
            [
              1196.071,
              2172,
              1188.323
            ],
            [
              1233.034,
              2216.96,
              1246.527
            ],
            [
              1262.402,
              2269.853,
              1307.026
            ],
            [
              1272.571,
              2296.383,
              1335.438
            ],
            [
              1295.641,
              2322.675,
              1370.416
            ],
            [
              1353.693,
              2426.246,
              1489.147
            ],
            [
              1363.843,
              2451.663,
              1516.515
            ],
            [
              1395.21,
              2612.502,
              1680.385
            ],
            [
              1412.03,
              2684.551,
              1754.371
            ],
            [
              1428.563,
              2741.021,
              1813.211
            ],
            [
              1438.754,
              2768.663,
              1842.672
            ],
            [
              1466.069,
              2814.913,
              1896.386
            ],
            [
              1478.408,
              2819.138,
              1909.429
            ],
            [
              1513.094,
              2845.213,
              1952.823
            ],
            [
              1567.546,
              2893.187,
              2025.393
            ],
            [
              1617.065,
              2953.497,
              2103.428
            ],
            [
              1672.764,
              3033.73,
              2201.099
            ],
            [
              1688.949,
              3071.28,
              2241.989
            ],
            [
              1698.328,
              3124.541,
              2296.07
            ],
            [
              1700.436,
              3377.207,
              2548.745
            ],
            [
              1694.118,
              3454.138,
              2625.934
            ],
            [
              1678.159,
              3567.984,
              2740.894
            ],
            [
              1670.163,
              3728.439,
              2901.547
            ],
            [
              1664.831,
              3754.142,
              2927.798
            ],
            [
              1667.788,
              3878.77,
              3052.461
            ],
            [
              1663.704,
              3902.223,
              3076.267
            ],
            [
              1666.884,
              3934.448,
              3108.649
            ],
            [
              1673.134,
              4166.999,
              3341.283
            ],
            [
              1673.634,
              4298.351,
              3472.637
            ],
            [
              1669.173,
              4336.284,
              3510.831
            ],
            [
              1674.124,
              4359.57,
              3534.637
            ],
            [
              1676.865,
              4402.935,
              3578.089
            ],
            [
              1687.031,
              4881.438,
              4056.7
            ],
            [
              1684.403,
              4913.771,
              4089.139
            ],
            [
              1688.75,
              4939.294,
              4115.03
            ],
            [
              1707.244,
              5553.457,
              4729.471
            ],
            [
              1715.118,
              5664.634,
              4840.927
            ],
            [
              1721.355,
              5722.407,
              4899.035
            ],
            [
              1837.248,
              6538.482,
              5723.299
            ],
            [
              1900.043,
              6998.194,
              6187.28
            ],
            [
              1909.827,
              7038.089,
              6228.356
            ],
            [
              1906.805,
              7049.277,
              6239.946
            ],
            [
              1901.784,
              7057.163,
              6249.295
            ],
            [
              1899.491,
              7072.791,
              6265.09
            ],
            [
              1918.465,
              7085.797,
              6288.094
            ],
            [
              1930.58,
              7146.8,
              6350.288
            ],
            [
              1976.571,
              7327.402,
              6536.653
            ],
            [
              2080.762,
              7788.568,
              7009.443
            ],
            [
              2095.419,
              7881.806,
              7103.826
            ],
            [
              2148.255,
              8082.317,
              7311.182
            ],
            [
              2205.009,
              8319.492,
              7555.052
            ],
            [
              2258.98,
              8511.074,
              7754.092
            ],
            [
              2286.351,
              8627.453,
              7873.646
            ],
            [
              2406.853,
              9024.854,
              8288.915
            ],
            [
              2420.685,
              9142.598,
              8407.469
            ],
            [
              2426.207,
              9161.42,
              8427.084
            ],
            [
              2423.309,
              9179.286,
              8445.183
            ],
            [
              2426.143,
              9192.592,
              8458.787
            ],
            [
              2431.142,
              9252.613,
              8519.016
            ],
            [
              2428.993,
              9310.541,
              8576.984
            ],
            [
              2455.974,
              9474.795,
              8743.44
            ],
            [
              2471.058,
              9624.8,
              8894.201
            ],
            [
              2508.098,
              10119.495,
              9390.281
            ],
            [
              2505.971,
              10144.026,
              9414.904
            ],
            [
              2498.947,
              10148.61,
              9423.292
            ],
            [
              2499.134,
              10158.626,
              9433.309
            ],
            [
              2501.781,
              10161.916,
              9437.532
            ],
            [
              2512.182,
              10165.061,
              9448.398
            ],
            [
              2519.832,
              10159.352,
              9457.944
            ],
            [
              2521.02,
              10153.764,
              9463.657
            ],
            [
              2518.29,
              10146.022,
              9471.866
            ],
            [
              2516.313,
              10040.302,
              9577.604
            ],
            [
              2529.215,
              10038.948,
              9590.577
            ],
            [
              2654.817,
              10084.466,
              9724.173
            ],
            [
              3516.709,
              10372.156,
              10632.811
            ],
            [
              3745.54,
              10440.182,
              10871.54
            ],
            [
              4165.181,
              10581.378,
              11314.298
            ],
            [
              4247.093,
              10605.421,
              11399.665
            ],
            [
              4345.978,
              10638.044,
              11503.793
            ],
            [
              4412.859,
              10653.465,
              11572.428
            ],
            [
              4648.102,
              10683.473,
              11809.578
            ],
            [
              4677.204,
              10684.029,
              11838.685
            ],
            [
              4696.286,
              10701.475,
              11864.54
            ],
            [
              4704.126,
              10705.778,
              11873.483
            ],
            [
              4711.86,
              10704.516,
              11881.319
            ],
            [
              4718.904,
              10701.041,
              11889.174
            ],
            [
              4723.321,
              10695.39,
              11896.347
            ],
            [
              4724.08,
              10667.545,
              11924.203
            ],
            [
              4738.709,
              10655.018,
              11943.461
            ],
            [
              5228.952,
              10465.241,
              12469.155
            ],
            [
              5336.008,
              10418.644,
              12585.913
            ],
            [
              5387.188,
              10390.937,
              12644.111
            ],
            [
              5481.705,
              10331.22,
              12755.913
            ],
            [
              5595.153,
              10247.756,
              12896.755
            ],
            [
              5632.243,
              10226.999,
              12939.258
            ],
            [
              5922.795,
              10110.032,
              13252.47
            ],
            [
              6351.864,
              9540.585,
              13965.471
            ],
            [
              6415.66,
              9464.749,
              14064.572
            ],
            [
              6461.908,
              9417.087,
              14130.984
            ],
            [
              6520.539,
              9374.749,
              14203.303
            ],
            [
              6587.139,
              9343.386,
              14276.919
            ],
            [
              6748.008,
              9274.548,
              14451.898
            ],
            [
              6806.744,
              9237.769,
              14521.198
            ],
            [
              6844.74,
              9198.059,
              14576.159
            ],
            [
              6891.967,
              9134.787,
              14655.112
            ],
            [
              6984.236,
              8996.04,
              14821.739
            ],
            [
              7017.981,
              8937.486,
              14889.32
            ],
            [
              7130.725,
              8756.028,
              15102.952
            ],
            [
              7143.03,
              8724.614,
              15136.69
            ],
            [
              7159.285,
              8664.176,
              15199.275
            ],
            [
              7162.744,
              8642.956,
              15220.775
            ],
            [
              7152.409,
              8643.16,
              15231.112
            ],
            [
              7144.701,
              8645.539,
              15239.178
            ],
            [
              7137.016,
              8649.03,
              15247.62
            ],
            [
              7133.918,
              8655.771,
              15255.038
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:939",
              "position": {
                "x": 448.101,
                "z": 1917.454
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -720,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 778.658,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 1335.438,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 1896.386,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5953",
              "position": {
                "x": 1663.704,
                "z": 3902.223
              },
              "distanceAlongShapeM": 3076.267,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5955",
              "position": {
                "x": 1669.173,
                "z": 4336.284
              },
              "distanceAlongShapeM": 3510.831,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5956",
              "position": {
                "x": 1684.403,
                "z": 4913.771
              },
              "distanceAlongShapeM": 4089.139,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5958",
              "position": {
                "x": 1721.355,
                "z": 5722.407
              },
              "distanceAlongShapeM": 4899.035,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17944",
              "position": {
                "x": 1837.248,
                "z": 6538.482
              },
              "distanceAlongShapeM": 5723.299,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5960",
              "position": {
                "x": 1900.043,
                "z": 6998.194
              },
              "distanceAlongShapeM": 6187.28,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5964",
              "position": {
                "x": 2095.419,
                "z": 7881.806
              },
              "distanceAlongShapeM": 7103.826,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5967",
              "position": {
                "x": 2286.351,
                "z": 8627.453
              },
              "distanceAlongShapeM": 7873.646,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:17222",
              "position": {
                "x": 2420.685,
                "z": 9142.598
              },
              "distanceAlongShapeM": 8407.469,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5971",
              "position": {
                "x": 2654.817,
                "z": 10084.466
              },
              "distanceAlongShapeM": 9724.173,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5973",
              "position": {
                "x": 3516.709,
                "z": 10372.156
              },
              "distanceAlongShapeM": 10632.811,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5975",
              "position": {
                "x": 4165.181,
                "z": 10581.378
              },
              "distanceAlongShapeM": 11314.298,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:17594",
              "position": {
                "x": 4648.102,
                "z": 10683.473
              },
              "distanceAlongShapeM": 11809.578,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5981",
              "position": {
                "x": 5750.274,
                "z": 10180.179
              },
              "distanceAlongShapeM": 13066.235,
              "shapeOffsetM": 0.646,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5986",
              "position": {
                "x": 6984.236,
                "z": 8996.04
              },
              "distanceAlongShapeM": 14821.739,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5988",
              "position": {
                "x": 7133.918,
                "z": 8655.771
              },
              "distanceAlongShapeM": 15255.038,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            }
          ],
          "departuresSeconds": [
            18540,
            21780,
            22680,
            23820,
            27120,
            28980,
            32760,
            35880,
            38760,
            41940,
            44820,
            47940,
            50580,
            52620,
            53820,
            56340,
            57720,
            60420,
            63300,
            65220,
            68880,
            71640,
            74400,
            77340,
            80640
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_12:1",
          "sourceRouteId": "vilnius_bus_12",
          "sourceShapeId": "vilnius_bus_12_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Skaidiškės–Rudamina–Stotis",
          "mode": "bus",
          "routeShortName": "12",
          "routeLongName": "Stotis–Rudamina–Skaidiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              7133.918,
              8655.771,
              0
            ],
            [
              7129.725,
              8672.552,
              17.297
            ],
            [
              7136.426,
              8684.666,
              31.141
            ],
            [
              7148.963,
              8697.778,
              49.282
            ],
            [
              7139.954,
              8732.467,
              85.122
            ],
            [
              7093.732,
              8813.534,
              178.44
            ],
            [
              6945.301,
              9053.583,
              460.672
            ],
            [
              6919.899,
              9076.348,
              494.783
            ],
            [
              6913.209,
              9097.632,
              517.093
            ],
            [
              6869.903,
              9163.053,
              595.549
            ],
            [
              6826.399,
              9218.458,
              665.993
            ],
            [
              6802.977,
              9243.41,
              700.215
            ],
            [
              6757.031,
              9273.257,
              755.005
            ],
            [
              6502.065,
              9388.47,
              1034.794
            ],
            [
              6465.588,
              9406.996,
              1075.706
            ],
            [
              6447.825,
              9424.042,
              1100.325
            ],
            [
              6308.307,
              9593.759,
              1320.027
            ],
            [
              5941.66,
              10082.947,
              1931.366
            ],
            [
              5920.748,
              10104.506,
              1961.4
            ],
            [
              5906.059,
              10113.697,
              1978.728
            ],
            [
              5710.988,
              10187.621,
              2187.337
            ],
            [
              5664.184,
              10207.454,
              2238.169
            ],
            [
              5602.067,
              10237.603,
              2307.216
            ],
            [
              5533.917,
              10290.132,
              2393.261
            ],
            [
              5343.031,
              10414.055,
              2620.845
            ],
            [
              5266.11,
              10447.825,
              2704.852
            ],
            [
              5035.729,
              10535.759,
              2951.444
            ],
            [
              4861.887,
              10605.897,
              3138.902
            ],
            [
              4786.728,
              10630.719,
              3218.054
            ],
            [
              4755.297,
              10643.568,
              3252.009
            ],
            [
              4721.992,
              10659.792,
              3289.056
            ],
            [
              4716.283,
              10665.468,
              3297.107
            ],
            [
              4698.316,
              10672.492,
              3316.398
            ],
            [
              4460.076,
              10654.789,
              3555.294
            ],
            [
              4403.059,
              10648.086,
              3612.704
            ],
            [
              3986.825,
              10516.866,
              4049.132
            ],
            [
              3763.072,
              10444.303,
              4284.357
            ],
            [
              3493.025,
              10350.339,
              4570.284
            ],
            [
              3349.399,
              10309.637,
              4719.567
            ],
            [
              2914.906,
              10166.42,
              5177.055
            ],
            [
              2614.276,
              10059.621,
              5496.091
            ],
            [
              2585.721,
              10053.476,
              5525.3
            ],
            [
              2538.907,
              10038.767,
              5574.371
            ],
            [
              2514.771,
              10026.972,
              5601.234
            ],
            [
              2510.834,
              9954.686,
              5673.628
            ],
            [
              2490.887,
              9959.512,
              5694.15
            ],
            [
              2489.011,
              9962.887,
              5698.011
            ],
            [
              2500.218,
              10147.473,
              5882.938
            ],
            [
              2499.092,
              10156.4,
              5891.936
            ],
            [
              2503.094,
              10163.005,
              5899.658
            ],
            [
              2508.305,
              10165.134,
              5905.287
            ],
            [
              2512.807,
              10163.937,
              5909.946
            ],
            [
              2512.143,
              10093.815,
              5980.07
            ],
            [
              2502.974,
              10018.287,
              6056.153
            ],
            [
              2500.933,
              9978.249,
              6096.243
            ],
            [
              2497.161,
              9949.375,
              6125.362
            ],
            [
              2431.148,
              9114.572,
              6962.771
            ],
            [
              2414.752,
              8997.989,
              7080.502
            ],
            [
              2321.643,
              8718.08,
              7375.491
            ],
            [
              2249.566,
              8456.702,
              7646.625
            ],
            [
              2230.567,
              8408.074,
              7698.832
            ],
            [
              2199.344,
              8292.88,
              7818.183
            ],
            [
              2161.604,
              8139.957,
              7975.694
            ],
            [
              2081.366,
              7786.33,
              8338.309
            ],
            [
              2074.435,
              7726.344,
              8398.694
            ],
            [
              2051.798,
              7655.519,
              8473.049
            ],
            [
              1937.224,
              7156.695,
              8984.862
            ],
            [
              1923.337,
              7104.632,
              9038.746
            ],
            [
              1918.341,
              7079.12,
              9064.742
            ],
            [
              1918.863,
              7072.431,
              9071.451
            ],
            [
              1928.176,
              7052.22,
              9093.705
            ],
            [
              1915.701,
              7041.319,
              9110.272
            ],
            [
              1843.043,
              6502.751,
              9653.719
            ],
            [
              1710.961,
              5614.616,
              10551.622
            ],
            [
              1705.045,
              5504.515,
              10661.881
            ],
            [
              1687.181,
              4854.718,
              11311.924
            ],
            [
              1690.373,
              4817.922,
              11348.858
            ],
            [
              1685.654,
              4772.367,
              11394.657
            ],
            [
              1681.965,
              4538.656,
              11628.397
            ],
            [
              1676.865,
              4402.935,
              11764.213
            ],
            [
              1678.187,
              4335.004,
              11832.158
            ],
            [
              1683.505,
              4273.677,
              11893.715
            ],
            [
              1693.897,
              4242.314,
              11926.755
            ],
            [
              1695.023,
              4233.387,
              11935.753
            ],
            [
              1702.519,
              4219.889,
              11951.192
            ],
            [
              1698.255,
              4198.816,
              11972.692
            ],
            [
              1674.822,
              4153.608,
              12023.612
            ],
            [
              1671.231,
              3959.972,
              12217.281
            ],
            [
              1674.798,
              3769.542,
              12407.745
            ],
            [
              1677.199,
              3724.968,
              12452.383
            ],
            [
              1684.234,
              3721.498,
              12460.228
            ],
            [
              1678.221,
              3710.477,
              12472.783
            ],
            [
              1677.947,
              3591.366,
              12591.894
            ],
            [
              1696.885,
              3464.105,
              12720.556
            ],
            [
              1701.829,
              3382.747,
              12802.065
            ],
            [
              1703.03,
              3134.473,
              13050.342
            ],
            [
              1699.891,
              3104.474,
              13080.505
            ],
            [
              1687.994,
              3054.599,
              13131.779
            ],
            [
              1659.262,
              3001.697,
              13191.98
            ],
            [
              1605.061,
              2932.568,
              13279.824
            ],
            [
              1556.997,
              2881.137,
              13350.218
            ],
            [
              1484.111,
              2813.466,
              13449.675
            ],
            [
              1478.744,
              2802.433,
              13461.944
            ],
            [
              1453.839,
              2781.743,
              13494.323
            ],
            [
              1433.991,
              2755.392,
              13527.312
            ],
            [
              1428.563,
              2741.021,
              13542.674
            ],
            [
              1382.281,
              2541.494,
              13747.498
            ],
            [
              1365.86,
              2456.079,
              13834.478
            ],
            [
              1336.284,
              2392.058,
              13905
            ],
            [
              1224.883,
              2194.846,
              14131.501
            ],
            [
              958.108,
              1933.7,
              14504.818
            ],
            [
              922.174,
              1874.247,
              14574.288
            ],
            [
              898.105,
              1863.557,
              14600.624
            ],
            [
              862.14,
              1837.501,
              14645.035
            ],
            [
              825.163,
              1791.425,
              14704.114
            ],
            [
              623.161,
              1858.587,
              14916.988
            ],
            [
              493.148,
              1911.064,
              15057.193
            ],
            [
              481.742,
              1922.405,
              15073.277
            ],
            [
              470.798,
              1923.718,
              15084.3
            ],
            [
              464.267,
              1919.385,
              15092.138
            ],
            [
              448.101,
              1917.454,
              15108.419
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5988",
              "position": {
                "x": 7133.918,
                "z": 8655.771
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6137",
              "position": {
                "x": 6919.899,
                "z": 9076.348
              },
              "distanceAlongShapeM": 494.783,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5982",
              "position": {
                "x": 5710.988,
                "z": 10187.621
              },
              "distanceAlongShapeM": 2187.337,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:17589",
              "position": {
                "x": 4786.728,
                "z": 10630.719
              },
              "distanceAlongShapeM": 3218.054,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5976",
              "position": {
                "x": 4067.464,
                "z": 10542.049
              },
              "distanceAlongShapeM": 3964.653,
              "shapeOffsetM": 0.227,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5974",
              "position": {
                "x": 3493.025,
                "z": 10350.339
              },
              "distanceAlongShapeM": 4570.284,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5972",
              "position": {
                "x": 2614.276,
                "z": 10059.621
              },
              "distanceAlongShapeM": 5496.091,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5969",
              "position": {
                "x": 2431.148,
                "z": 9114.572
              },
              "distanceAlongShapeM": 6962.771,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5966",
              "position": {
                "x": 2249.566,
                "z": 8456.702
              },
              "distanceAlongShapeM": 7646.625,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5965",
              "position": {
                "x": 2074.435,
                "z": 7726.344
              },
              "distanceAlongShapeM": 8398.694,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:646",
              "position": {
                "x": 1908.814,
                "z": 6983.559
              },
              "distanceAlongShapeM": 9168.434,
              "shapeOffsetM": 0.897,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:17945",
              "position": {
                "x": 1843.043,
                "z": 6502.751
              },
              "distanceAlongShapeM": 9653.719,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5995",
              "position": {
                "x": 1738.128,
                "z": 5791.116
              },
              "distanceAlongShapeM": 10373.046,
              "shapeOffsetM": 0.908,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5957",
              "position": {
                "x": 1690.373,
                "z": 4817.922
              },
              "distanceAlongShapeM": 11348.858,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5996",
              "position": {
                "x": 1693.572,
                "z": 4189.997
              },
              "distanceAlongShapeM": 11982.676,
              "shapeOffsetM": 0.099,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 12460.228,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 13461.944,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 14131.501,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 14574.288,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 15057.193,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            }
          ],
          "departuresSeconds": [
            21000,
            24180,
            25500,
            27000,
            29940,
            31800,
            35160,
            38580,
            41580,
            44520,
            47400,
            50580,
            53580,
            55260,
            57120,
            59700,
            60540,
            63300,
            66060,
            68520,
            71220,
            74280,
            77580,
            80700,
            83880
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_13",
      "sourceRouteId": "vilnius_bus_13",
      "mode": "bus",
      "shortName": "13",
      "longName": "Žemasis Pavilnys–Markučiai–Stotis–Vilkpėdė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_13:0",
          "sourceRouteId": "vilnius_bus_13",
          "sourceShapeId": "vilnius_bus_13_a-b",
          "directionId": 0,
          "headsign": "Vilkpėdė",
          "directionName": "Žemasis Pavilnys–Markučiai–Stotis–Vilkpėdė",
          "mode": "bus",
          "routeShortName": "13",
          "routeLongName": "Žemasis Pavilnys–Markučiai–Stotis–Vilkpėdė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5262.105,
              920.636,
              0
            ],
            [
              5159.017,
              993.88,
              126.459
            ],
            [
              4968.201,
              1134.498,
              363.49
            ],
            [
              4854.719,
              1237.993,
              517.079
            ],
            [
              4779.072,
              1262.829,
              596.699
            ],
            [
              4706.972,
              1270.896,
              669.248
            ],
            [
              4683.239,
              1278.032,
              694.031
            ],
            [
              4637.455,
              1245.514,
              750.188
            ],
            [
              4614.691,
              1235.932,
              774.886
            ],
            [
              4590.399,
              1247.532,
              801.805
            ],
            [
              4568.106,
              1262.432,
              828.62
            ],
            [
              4552.09,
              1268.306,
              845.679
            ],
            [
              4527.584,
              1268.777,
              870.189
            ],
            [
              4503.659,
              1265.896,
              894.287
            ],
            [
              4470.598,
              1257.624,
              928.367
            ],
            [
              4385.413,
              1222.52,
              1020.501
            ],
            [
              4291.558,
              1239.904,
              1115.953
            ],
            [
              3971.67,
              1244.903,
              1435.88
            ],
            [
              3914.487,
              1257.126,
              1494.355
            ],
            [
              3727.999,
              1356.417,
              1705.628
            ],
            [
              3642.49,
              1405.913,
              1804.429
            ],
            [
              3526.563,
              1450.418,
              1928.605
            ],
            [
              3456.065,
              1475.133,
              2003.31
            ],
            [
              3436.009,
              1472.174,
              2023.583
            ],
            [
              3409.272,
              1457.095,
              2054.279
            ],
            [
              3386.362,
              1439.717,
              2083.034
            ],
            [
              3313.487,
              1441.097,
              2155.923
            ],
            [
              3160.83,
              1454.003,
              2309.124
            ],
            [
              3101.371,
              1448.446,
              2368.842
            ],
            [
              3056.017,
              1438.17,
              2415.346
            ],
            [
              3023.561,
              1427.65,
              2449.464
            ],
            [
              2981.102,
              1434.017,
              2492.398
            ],
            [
              2924.375,
              1470.71,
              2559.958
            ],
            [
              2901.016,
              1497.868,
              2595.78
            ],
            [
              2870.248,
              1508.467,
              2628.322
            ],
            [
              2863.321,
              1517.503,
              2639.708
            ],
            [
              2825.769,
              1510.417,
              2677.923
            ],
            [
              2756.406,
              1492.797,
              2749.489
            ],
            [
              2671.356,
              1464.338,
              2839.174
            ],
            [
              2656.314,
              1453.488,
              2857.721
            ],
            [
              2635.614,
              1450.537,
              2878.63
            ],
            [
              2538.187,
              1415.628,
              2982.122
            ],
            [
              2526.454,
              1409.169,
              2995.516
            ],
            [
              2514.2,
              1409.399,
              3007.772
            ],
            [
              2451.312,
              1427.276,
              3073.152
            ],
            [
              2376.565,
              1466.527,
              3157.578
            ],
            [
              2338.099,
              1479.492,
              3198.17
            ],
            [
              2266.408,
              1475.267,
              3269.985
            ],
            [
              2244.855,
              1461.198,
              3295.724
            ],
            [
              2214.607,
              1430.592,
              3338.755
            ],
            [
              2183.881,
              1339.88,
              3434.529
            ],
            [
              2175.872,
              1325.557,
              3450.939
            ],
            [
              2161.497,
              1315.807,
              3468.309
            ],
            [
              2119.309,
              1302.122,
              3512.661
            ],
            [
              2063.598,
              1289.803,
              3569.717
            ],
            [
              2047.248,
              1277.862,
              3589.964
            ],
            [
              2007.868,
              1276.37,
              3629.372
            ],
            [
              1907.433,
              1252.636,
              3732.573
            ],
            [
              1817.42,
              1234.273,
              3824.44
            ],
            [
              1745.61,
              1223.362,
              3897.074
            ],
            [
              1634.607,
              1220.971,
              4008.103
            ],
            [
              1600.284,
              1213.815,
              4043.164
            ],
            [
              1535.192,
              1217.248,
              4108.346
            ],
            [
              1461.257,
              1230.864,
              4183.525
            ],
            [
              1250.055,
              1287.093,
              4402.083
            ],
            [
              1216.542,
              1288.825,
              4435.642
            ],
            [
              1174.911,
              1305.179,
              4480.369
            ],
            [
              1169.279,
              1454.457,
              4629.753
            ],
            [
              990.627,
              1492.26,
              4812.361
            ],
            [
              961.104,
              1500.597,
              4843.038
            ],
            [
              886.508,
              1548.725,
              4931.813
            ],
            [
              861.581,
              1561.429,
              4959.791
            ],
            [
              775.609,
              1587.5,
              5049.628
            ],
            [
              769.19,
              1624.355,
              5087.038
            ],
            [
              781.269,
              1649.737,
              5115.148
            ],
            [
              802.898,
              1738.399,
              5206.41
            ],
            [
              825.163,
              1791.425,
              5263.921
            ],
            [
              623.161,
              1858.587,
              5476.794
            ],
            [
              599.379,
              1863.475,
              5501.074
            ],
            [
              535.995,
              1890.241,
              5569.878
            ],
            [
              493.148,
              1911.064,
              5617.516
            ],
            [
              476.562,
              1921.386,
              5637.052
            ],
            [
              453.967,
              1920.686,
              5659.658
            ],
            [
              432.764,
              1925.527,
              5681.407
            ],
            [
              422.444,
              1925.716,
              5691.728
            ],
            [
              419.803,
              1922.424,
              5695.948
            ],
            [
              403.74,
              1926.058,
              5712.417
            ],
            [
              397.229,
              1922.837,
              5719.681
            ],
            [
              334.106,
              1822.687,
              5838.065
            ],
            [
              318.606,
              1821.856,
              5853.587
            ],
            [
              29.934,
              1735.835,
              6154.803
            ],
            [
              -11.424,
              1732.135,
              6196.327
            ],
            [
              -46.755,
              1740.57,
              6232.65
            ],
            [
              -320.217,
              1781.157,
              6509.107
            ],
            [
              -550.531,
              1853.232,
              6750.436
            ],
            [
              -582.7,
              1858.267,
              6782.996
            ],
            [
              -596.688,
              1869.651,
              6801.032
            ],
            [
              -717.241,
              1910.79,
              6928.411
            ],
            [
              -690.784,
              2018.296,
              7039.124
            ],
            [
              -657.818,
              2164.646,
              7189.141
            ],
            [
              -656.287,
              2177.977,
              7202.56
            ],
            [
              -658.686,
              2188.04,
              7212.905
            ],
            [
              -822.084,
              2251.1,
              7388.048
            ],
            [
              -883.687,
              2270.02,
              7452.491
            ],
            [
              -1046.445,
              2333.06,
              7627.032
            ],
            [
              -1117.02,
              2355.478,
              7701.082
            ],
            [
              -1465.657,
              2488.628,
              8074.279
            ],
            [
              -1523.427,
              2397.263,
              8182.376
            ],
            [
              -1557.257,
              2417.904,
              8222.006
            ],
            [
              -1586.671,
              2432.901,
              8255.023
            ],
            [
              -1589.092,
              2441.85,
              8264.294
            ],
            [
              -1615.966,
              2454.575,
              8294.028
            ],
            [
              -1665.298,
              2474.379,
              8347.187
            ],
            [
              -1973.715,
              2584.507,
              8674.676
            ],
            [
              -1980.067,
              2590.186,
              8683.196
            ],
            [
              -1990.862,
              2563.661,
              8711.834
            ],
            [
              -1996.181,
              2554.849,
              8722.126
            ],
            [
              -2002.73,
              2549.399,
              8730.647
            ],
            [
              -2002.849,
              2542.722,
              8737.325
            ],
            [
              -2009.26,
              2545.063,
              8744.15
            ],
            [
              -2019.015,
              2540.783,
              8754.802
            ],
            [
              -2077.913,
              2530.695,
              8814.558
            ],
            [
              -2083.871,
              2558.631,
              8843.123
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7364",
              "position": {
                "x": 5262.105,
                "z": 920.636
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8332",
              "position": {
                "x": 4968.201,
                "z": 1134.498
              },
              "distanceAlongShapeM": 363.49,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8335",
              "position": {
                "x": 4706.972,
                "z": 1270.896
              },
              "distanceAlongShapeM": 669.248,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8345",
              "position": {
                "x": 4172.232,
                "z": 1241.073
              },
              "distanceAlongShapeM": 1235.283,
              "shapeOffsetM": 0.695,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8336",
              "position": {
                "x": 2870.248,
                "z": 1508.467
              },
              "distanceAlongShapeM": 2628.322,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5858",
              "position": {
                "x": 2656.314,
                "z": 1453.488
              },
              "distanceAlongShapeM": 2857.721,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5855",
              "position": {
                "x": 2047.248,
                "z": 1277.862
              },
              "distanceAlongShapeM": 3589.964,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:946",
              "position": {
                "x": 1600.284,
                "z": 1213.815
              },
              "distanceAlongShapeM": 4043.164,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5428",
              "position": {
                "x": 1216.542,
                "z": 1288.825
              },
              "distanceAlongShapeM": 4435.642,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6714",
              "position": {
                "x": 769.19,
                "z": 1624.355
              },
              "distanceAlongShapeM": 5087.038,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:3590",
              "position": {
                "x": 419.803,
                "z": 1922.424
              },
              "distanceAlongShapeM": 5695.948,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 6196.327,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5167",
              "position": {
                "x": -582.7,
                "z": 1858.267
              },
              "distanceAlongShapeM": 6782.996,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5549",
              "position": {
                "x": -883.687,
                "z": 2270.02
              },
              "distanceAlongShapeM": 7452.491,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5552",
              "position": {
                "x": -1117.02,
                "z": 2355.478
              },
              "distanceAlongShapeM": 7701.082,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7941",
              "position": {
                "x": -1586.671,
                "z": 2432.901
              },
              "distanceAlongShapeM": 8255.023,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 8737.325,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            }
          ],
          "departuresSeconds": [
            18540,
            20940,
            23340,
            25680,
            28200,
            30720,
            34500,
            39480,
            44280,
            49200,
            54000,
            56400,
            58860,
            61500,
            64200,
            66600,
            70680,
            75900,
            80580
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_13:1",
          "sourceRouteId": "vilnius_bus_13",
          "sourceShapeId": "vilnius_bus_13_b-a",
          "directionId": 1,
          "headsign": "Žemasis Pavilnys",
          "directionName": "Vilkpėdė–Stotis–Markučiai–Žemasis Pavilnys",
          "mode": "bus",
          "routeShortName": "13",
          "routeLongName": "Žemasis Pavilnys–Markučiai–Stotis–Vilkpėdė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2002.849,
              2542.722,
              0
            ],
            [
              -2009.26,
              2545.063,
              6.825
            ],
            [
              -2019.015,
              2540.783,
              17.477
            ],
            [
              -2077.913,
              2530.695,
              77.234
            ],
            [
              -2083.871,
              2558.631,
              105.798
            ],
            [
              -2083.009,
              2570.861,
              118.058
            ],
            [
              -2085.352,
              2584.261,
              131.662
            ],
            [
              -2057.496,
              2590.447,
              160.197
            ],
            [
              -2051.124,
              2585.881,
              168.036
            ],
            [
              -2042.349,
              2571.254,
              185.093
            ],
            [
              -2044.403,
              2564.611,
              192.046
            ],
            [
              -2036.471,
              2538.866,
              218.985
            ],
            [
              -2016.375,
              2544.076,
              239.745
            ],
            [
              -2000.11,
              2551.579,
              257.657
            ],
            [
              -1974.301,
              2587.857,
              302.18
            ],
            [
              -1936.577,
              2568.263,
              344.688
            ],
            [
              -1765.274,
              2512.896,
              524.717
            ],
            [
              -1632.053,
              2457.088,
              669.155
            ],
            [
              -1583.952,
              2440.645,
              719.989
            ],
            [
              -1563.915,
              2442.514,
              740.113
            ],
            [
              -1560.402,
              2422.413,
              760.518
            ],
            [
              -1524.111,
              2395.048,
              805.97
            ],
            [
              -1465.597,
              2491.966,
              919.182
            ],
            [
              -1465.657,
              2488.628,
              922.521
            ],
            [
              -1177.095,
              2387.726,
              1228.215
            ],
            [
              -1141.897,
              2371.51,
              1266.969
            ],
            [
              -1046.445,
              2333.06,
              1369.875
            ],
            [
              -850.89,
              2263.864,
              1577.311
            ],
            [
              -825.149,
              2260.061,
              1603.332
            ],
            [
              -811.159,
              2248.676,
              1621.369
            ],
            [
              -650.281,
              2189.001,
              1792.957
            ],
            [
              -664.346,
              2124.688,
              1858.791
            ],
            [
              -666.138,
              2096.89,
              1886.647
            ],
            [
              -681.857,
              2048.192,
              1937.819
            ],
            [
              -715.105,
              1921.884,
              2068.429
            ],
            [
              -544.505,
              1865.369,
              2248.146
            ],
            [
              -526.486,
              1862.817,
              2266.345
            ],
            [
              -490.609,
              1848.809,
              2304.86
            ],
            [
              -470.051,
              1843.985,
              2325.977
            ],
            [
              -432.32,
              1825.49,
              2367.997
            ],
            [
              -327.19,
              1787.963,
              2479.623
            ],
            [
              -259.046,
              1774.482,
              2549.088
            ],
            [
              -147.106,
              1756.865,
              2662.406
            ],
            [
              9.981,
              1738.424,
              2820.571
            ],
            [
              41.02,
              1742.312,
              2851.853
            ],
            [
              63.816,
              1754.143,
              2877.536
            ],
            [
              97.435,
              1757.984,
              2911.374
            ],
            [
              156.41,
              1772.494,
              2972.108
            ],
            [
              318.606,
              1821.856,
              3141.649
            ],
            [
              328.524,
              1835.034,
              3158.142
            ],
            [
              355.259,
              1885.754,
              3215.477
            ],
            [
              388.342,
              1930.792,
              3271.359
            ],
            [
              389.754,
              1937.446,
              3278.161
            ],
            [
              364.123,
              1982.443,
              3329.947
            ],
            [
              364.306,
              1992.459,
              3339.964
            ],
            [
              376.139,
              2004.488,
              3356.838
            ],
            [
              393.574,
              2005.283,
              3374.292
            ],
            [
              403.209,
              2002.88,
              3384.221
            ],
            [
              452.283,
              1969.699,
              3443.46
            ],
            [
              463.689,
              1958.358,
              3459.545
            ],
            [
              466.167,
              1952.747,
              3465.679
            ],
            [
              463.343,
              1939.44,
              3479.283
            ],
            [
              459.371,
              1933.946,
              3486.061
            ],
            [
              450.885,
              1928.535,
              3496.126
            ],
            [
              432.16,
              1927.765,
              3514.867
            ],
            [
              419.803,
              1922.424,
              3528.328
            ],
            [
              401.805,
              1926.093,
              3546.697
            ],
            [
              397.27,
              1925.063,
              3551.347
            ],
            [
              384.004,
              1905.267,
              3575.177
            ],
            [
              372.531,
              1877.646,
              3605.086
            ],
            [
              344.166,
              1843.654,
              3649.358
            ],
            [
              330.657,
              1810.504,
              3685.155
            ],
            [
              391.321,
              1670.242,
              3837.974
            ],
            [
              477.846,
              1568.468,
              3971.557
            ],
            [
              485.021,
              1572.79,
              3979.934
            ],
            [
              495.103,
              1594.87,
              4004.206
            ],
            [
              502.822,
              1593.615,
              4012.027
            ],
            [
              515.619,
              1587.815,
              4026.077
            ],
            [
              552.903,
              1580.453,
              4064.081
            ],
            [
              580.051,
              1583.295,
              4091.377
            ],
            [
              658.651,
              1577.401,
              4170.198
            ],
            [
              692.229,
              1579.012,
              4203.814
            ],
            [
              741.428,
              1588.128,
              4253.851
            ],
            [
              775.609,
              1587.5,
              4288.038
            ],
            [
              809.668,
              1580.195,
              4322.872
            ],
            [
              847.494,
              1567.254,
              4362.85
            ],
            [
              881.41,
              1552.158,
              4399.973
            ],
            [
              944.603,
              1515.372,
              4473.094
            ],
            [
              979.224,
              1503.603,
              4509.661
            ],
            [
              987.526,
              1498.997,
              4519.155
            ],
            [
              1015.114,
              1490.696,
              4547.965
            ],
            [
              1169.279,
              1454.457,
              4706.332
            ],
            [
              1174.911,
              1305.179,
              4855.716
            ],
            [
              1219.91,
              1296.555,
              4901.534
            ],
            [
              1270.109,
              1290.062,
              4952.151
            ],
            [
              1288.043,
              1283.051,
              4971.406
            ],
            [
              1461.257,
              1230.864,
              5152.312
            ],
            [
              1535.192,
              1217.248,
              5227.49
            ],
            [
              1586.927,
              1224.082,
              5279.674
            ],
            [
              1634.086,
              1227.66,
              5326.969
            ],
            [
              1673.61,
              1236.945,
              5367.569
            ],
            [
              1721.874,
              1230.483,
              5416.263
            ],
            [
              1745.776,
              1232.265,
              5440.232
            ],
            [
              1775.523,
              1236.165,
              5470.234
            ],
            [
              1885.048,
              1263.072,
              5583.015
            ],
            [
              1894.159,
              1267.356,
              5593.083
            ],
            [
              1963.37,
              1277.199,
              5662.99
            ],
            [
              2112.443,
              1314.496,
              5816.658
            ],
            [
              2127.921,
              1314.207,
              5832.139
            ],
            [
              2155.776,
              1320.367,
              5860.667
            ],
            [
              2174.041,
              1331.158,
              5881.882
            ],
            [
              2182.009,
              1343.255,
              5896.367
            ],
            [
              2194.157,
              1371.972,
              5927.548
            ],
            [
              2203.248,
              1409.653,
              5966.31
            ],
            [
              2215.938,
              1432.794,
              5992.702
            ],
            [
              2225.175,
              1443.754,
              6007.035
            ],
            [
              2240.882,
              1455.706,
              6026.772
            ],
            [
              2252.719,
              1467.73,
              6043.645
            ],
            [
              2267.719,
              1476.356,
              6060.948
            ],
            [
              2303.897,
              1479.019,
              6097.224
            ],
            [
              2359.631,
              1492.448,
              6154.553
            ],
            [
              2355.491,
              1478.053,
              6169.532
            ],
            [
              2367.682,
              1474.486,
              6182.234
            ],
            [
              2429.655,
              1442.154,
              6252.135
            ],
            [
              2462.275,
              1427.071,
              6288.073
            ],
            [
              2496.871,
              1414.177,
              6324.993
            ],
            [
              2523.312,
              1413.681,
              6351.44
            ],
            [
              2540.143,
              1416.705,
              6368.539
            ],
            [
              2579.775,
              1431.547,
              6410.86
            ],
            [
              2615.559,
              1447.574,
              6450.069
            ],
            [
              2701.336,
              1480.473,
              6541.939
            ],
            [
              2890.618,
              1528.122,
              6737.126
            ],
            [
              2899.626,
              1526.839,
              6746.225
            ],
            [
              2908.446,
              1515.54,
              6760.558
            ],
            [
              2911.419,
              1502.125,
              6774.299
            ],
            [
              2930.368,
              1480.616,
              6802.964
            ],
            [
              2953.916,
              1463.474,
              6832.091
            ],
            [
              2984.641,
              1450.649,
              6865.385
            ],
            [
              3039.249,
              1438.486,
              6921.331
            ],
            [
              3058.702,
              1443.686,
              6941.467
            ],
            [
              3155.755,
              1458.552,
              7039.652
            ],
            [
              3332.252,
              1444.081,
              7216.742
            ],
            [
              3366.994,
              1438.97,
              7251.857
            ],
            [
              3387.071,
              1443.043,
              7272.343
            ],
            [
              3404.007,
              1451.628,
              7291.331
            ],
            [
              3428.249,
              1471.207,
              7322.492
            ],
            [
              3477.971,
              1473.605,
              7372.272
            ],
            [
              3655.283,
              1400.104,
              7564.214
            ],
            [
              3881.894,
              1273.333,
              7823.874
            ],
            [
              3954.279,
              1246.348,
              7901.126
            ],
            [
              4263.289,
              1246.011,
              8210.136
            ],
            [
              4382.21,
              1223.695,
              8331.133
            ],
            [
              4406.22,
              1231.028,
              8356.237
            ],
            [
              4455.723,
              1255.683,
              8411.54
            ],
            [
              4492.051,
              1266.119,
              8449.337
            ],
            [
              4525.649,
              1268.814,
              8483.044
            ],
            [
              4563.613,
              1263.632,
              8521.359
            ],
            [
              4612.069,
              1233.756,
              8578.285
            ],
            [
              4645.945,
              1250.917,
              8616.26
            ],
            [
              4667.612,
              1270.539,
              8645.492
            ],
            [
              4683.261,
              1279.145,
              8663.35
            ],
            [
              4725.115,
              1275,
              8705.409
            ],
            [
              4766.797,
              1261.952,
              8749.086
            ],
            [
              4838.79,
              1248.319,
              8822.358
            ],
            [
              4858.631,
              1240.144,
              8843.818
            ],
            [
              4880.107,
              1216.352,
              8875.869
            ],
            [
              4974.069,
              1137.724,
              8998.389
            ],
            [
              5019.254,
              1105.681,
              9053.783
            ],
            [
              5027.422,
              1094.39,
              9067.718
            ],
            [
              5229.735,
              947.981,
              9317.45
            ],
            [
              5255.227,
              931.902,
              9347.589
            ],
            [
              5280.87,
              923.613,
              9374.539
            ],
            [
              5285.255,
              916.848,
              9382.6
            ],
            [
              5282.568,
              911.334,
              9388.734
            ],
            [
              5278.054,
              911.421,
              9393.249
            ],
            [
              5262.105,
              920.636,
              9411.669
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8311",
              "position": {
                "x": -2042.349,
                "z": 2571.254
              },
              "distanceAlongShapeM": 185.093,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8309",
              "position": {
                "x": -1563.915,
                "z": 2442.514
              },
              "distanceAlongShapeM": 740.113,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5553",
              "position": {
                "x": -1177.095,
                "z": 2387.726
              },
              "distanceAlongShapeM": 1228.215,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5550",
              "position": {
                "x": -825.149,
                "z": 2260.061
              },
              "distanceAlongShapeM": 1603.332,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:640",
              "position": {
                "x": -666.138,
                "z": 2096.89
              },
              "distanceAlongShapeM": 1886.647,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 2325.977,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 2877.536,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:4267",
              "position": {
                "x": 372.531,
                "z": 1877.646
              },
              "distanceAlongShapeM": 3605.086,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 4091.377,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 4509.661,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5360",
              "position": {
                "x": 1270.109,
                "z": 1290.062
              },
              "distanceAlongShapeM": 4952.151,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5362",
              "position": {
                "x": 1673.61,
                "z": 1236.945
              },
              "distanceAlongShapeM": 5367.569,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5854",
              "position": {
                "x": 2112.443,
                "z": 1314.496
              },
              "distanceAlongShapeM": 5816.658,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5857",
              "position": {
                "x": 2701.336,
                "z": 1480.473
              },
              "distanceAlongShapeM": 6541.939,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:684",
              "position": {
                "x": 2908.446,
                "z": 1515.54
              },
              "distanceAlongShapeM": 6760.558,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:8344",
              "position": {
                "x": 4263.289,
                "z": 1246.011
              },
              "distanceAlongShapeM": 8210.136,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:8333",
              "position": {
                "x": 4725.115,
                "z": 1275
              },
              "distanceAlongShapeM": 8705.409,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8331",
              "position": {
                "x": 5019.254,
                "z": 1105.681
              },
              "distanceAlongShapeM": 9053.783,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:7364",
              "position": {
                "x": 5262.105,
                "z": 920.636
              },
              "distanceAlongShapeM": 9411.669,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            21060,
            23460,
            25980,
            28500,
            32340,
            37320,
            42180,
            47040,
            51840,
            54240,
            56640,
            59160,
            61680,
            64260,
            68520,
            73560,
            78540,
            82920
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_14",
      "sourceRouteId": "vilnius_bus_14",
      "mode": "bus",
      "shortName": "14",
      "longName": "Rudamina–Didžiasalis–Grigaičiai–Parko–Arimų g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_14:0",
          "sourceRouteId": "vilnius_bus_14",
          "sourceShapeId": "vilnius_bus_14_a-b",
          "directionId": 0,
          "headsign": "Arimų g.",
          "directionName": "Rudamina–Didžiasalis–Grigaičiai–Parko–Arimų g.",
          "mode": "bus",
          "routeShortName": "14",
          "routeLongName": "Rudamina–Didžiasalis–Grigaičiai–Parko–Arimų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              4786.728,
              10630.719,
              0
            ],
            [
              4711.134,
              10666.68,
              83.711
            ],
            [
              4700.923,
              10673.555,
              96.022
            ],
            [
              4692.067,
              10683.744,
              109.521
            ],
            [
              4689.696,
              10694.922,
              120.948
            ],
            [
              4695.768,
              10708.164,
              135.516
            ],
            [
              4704.254,
              10712.455,
              145.025
            ],
            [
              4713.948,
              10712.269,
              154.721
            ],
            [
              4731.829,
              10700.793,
              175.967
            ],
            [
              4728.321,
              10686.388,
              190.794
            ],
            [
              4731.125,
              10664.07,
              213.288
            ],
            [
              4800.987,
              10632.671,
              289.882
            ],
            [
              4923.129,
              10596.928,
              417.146
            ],
            [
              5069.204,
              10528.435,
              578.481
            ],
            [
              5273.175,
              10445.462,
              798.683
            ],
            [
              5353.305,
              10410.517,
              886.102
            ],
            [
              5426.133,
              10365.693,
              971.618
            ],
            [
              5604.156,
              10245.355,
              1186.498
            ],
            [
              5657.249,
              10216.495,
              1246.928
            ],
            [
              5922.795,
              10110.032,
              1533.02
            ],
            [
              6351.864,
              9540.585,
              2246.022
            ],
            [
              6415.66,
              9464.749,
              2345.122
            ],
            [
              6461.908,
              9417.087,
              2411.534
            ],
            [
              6520.539,
              9374.749,
              2483.854
            ],
            [
              6587.139,
              9343.386,
              2557.469
            ],
            [
              6748.008,
              9274.548,
              2732.448
            ],
            [
              6806.744,
              9237.769,
              2801.748
            ],
            [
              6844.74,
              9198.059,
              2856.709
            ],
            [
              6891.967,
              9134.787,
              2935.662
            ],
            [
              6984.236,
              8996.04,
              3102.289
            ],
            [
              7068.705,
              8855.218,
              3266.501
            ],
            [
              7120.139,
              8776.275,
              3360.721
            ],
            [
              7136.298,
              8743.672,
              3397.109
            ],
            [
              7149.16,
              8707.794,
              3435.224
            ],
            [
              7173.919,
              8587.072,
              3558.458
            ],
            [
              7189.255,
              8545.579,
              3602.694
            ],
            [
              7195.473,
              8533.21,
              3616.538
            ],
            [
              7216.951,
              8508.294,
              3649.434
            ],
            [
              7252.486,
              8475.308,
              3697.919
            ],
            [
              7270.176,
              8454.919,
              3724.912
            ],
            [
              7281.451,
              8436.884,
              3746.181
            ],
            [
              7286.978,
              8422.303,
              3761.775
            ],
            [
              7294.539,
              8379.849,
              3804.897
            ],
            [
              7319.162,
              8154.482,
              4031.605
            ],
            [
              7319.126,
              8119.972,
              4066.116
            ],
            [
              7365.587,
              7529.02,
              4658.891
            ],
            [
              7383.302,
              7379.491,
              4809.465
            ],
            [
              7394.939,
              7216.723,
              4972.649
            ],
            [
              7442.244,
              7061.042,
              5135.358
            ],
            [
              7609.017,
              6806.137,
              5439.973
            ],
            [
              7797.877,
              6558.579,
              5751.346
            ],
            [
              7843.084,
              6460.824,
              5859.047
            ],
            [
              7872.17,
              6364.504,
              5959.663
            ],
            [
              7884.177,
              6286.336,
              6038.749
            ],
            [
              7881.782,
              6198.435,
              6126.682
            ],
            [
              7866.731,
              5993.891,
              6331.779
            ],
            [
              7850.896,
              5847.254,
              6479.268
            ],
            [
              7857.115,
              5770.314,
              6556.459
            ],
            [
              7892.967,
              5624.874,
              6706.253
            ],
            [
              8203.142,
              4891.715,
              7502.324
            ],
            [
              8284.129,
              4647.401,
              7759.713
            ],
            [
              8380.527,
              4334.865,
              8086.777
            ],
            [
              8557.729,
              3739.045,
              8708.389
            ],
            [
              8562.134,
              3733.39,
              8715.557
            ],
            [
              8571.746,
              3729.858,
              8725.798
            ],
            [
              8578.087,
              3724.164,
              8734.32
            ],
            [
              8581.112,
              3714.084,
              8744.844
            ],
            [
              8577.707,
              3705.246,
              8754.315
            ],
            [
              8571.788,
              3699.798,
              8762.36
            ],
            [
              8572.299,
              3693.108,
              8769.069
            ],
            [
              8622.681,
              3534.01,
              8935.954
            ],
            [
              8664.696,
              3408.477,
              9068.331
            ],
            [
              8796.898,
              3081.852,
              9420.697
            ],
            [
              8814.021,
              3034.749,
              9470.815
            ],
            [
              8857.75,
              2834.59,
              9675.696
            ],
            [
              8896.112,
              2624.518,
              9889.241
            ],
            [
              8901.756,
              2584.326,
              9929.828
            ],
            [
              8904.196,
              2545.312,
              9968.918
            ],
            [
              8911.713,
              2534.027,
              9982.477
            ],
            [
              8920.296,
              2511.588,
              10006.501
            ],
            [
              8924.834,
              2512.61,
              10011.153
            ],
            [
              8921.939,
              2497.083,
              10026.948
            ],
            [
              8900.074,
              2500.863,
              10049.138
            ],
            [
              8891.727,
              2470.972,
              10080.172
            ],
            [
              8858.803,
              2310.209,
              10244.272
            ],
            [
              8847.277,
              2282.609,
              10274.183
            ],
            [
              8731.774,
              2154.679,
              10446.539
            ],
            [
              8712.486,
              2126.121,
              10481
            ],
            [
              8701.741,
              2105.185,
              10504.533
            ],
            [
              8693.016,
              2056.376,
              10554.116
            ],
            [
              8691.4,
              1943.966,
              10666.538
            ],
            [
              8696.422,
              1904.9,
              10705.925
            ],
            [
              8697.659,
              1838.078,
              10772.759
            ],
            [
              8710.273,
              1695.323,
              10916.07
            ],
            [
              8719.119,
              1653.953,
              10958.375
            ],
            [
              8801.992,
              1411.814,
              11214.303
            ],
            [
              8808.503,
              1382.737,
              11244.1
            ],
            [
              8821.879,
              1310.104,
              11317.955
            ],
            [
              8842.377,
              1142.697,
              11486.612
            ],
            [
              8854.097,
              1019.998,
              11609.869
            ],
            [
              8848.153,
              981.153,
              11649.167
            ],
            [
              8818.093,
              865.976,
              11768.202
            ],
            [
              8791.621,
              800.825,
              11838.525
            ],
            [
              8695.643,
              583.439,
              12076.156
            ],
            [
              8692.348,
              547.88,
              12111.868
            ],
            [
              8661.183,
              441.631,
              12222.593
            ],
            [
              8619.341,
              285.498,
              12384.235
            ],
            [
              8586.003,
              199.331,
              12476.626
            ],
            [
              8585.045,
              183.764,
              12492.223
            ],
            [
              8590.333,
              158.052,
              12518.473
            ],
            [
              8621.917,
              92.846,
              12590.925
            ],
            [
              8636.204,
              33.555,
              12651.914
            ],
            [
              8637.068,
              12.385,
              12673.102
            ],
            [
              8604.283,
              -110.532,
              12800.316
            ],
            [
              8595.54,
              -160.454,
              12850.998
            ],
            [
              8696.05,
              -133.53,
              12955.052
            ],
            [
              8718.239,
              -120.617,
              12980.724
            ],
            [
              8744.049,
              -120.024,
              13006.542
            ],
            [
              8789.403,
              -109.804,
              13053.032
            ],
            [
              8826.443,
              -96.078,
              13092.534
            ],
            [
              8853.145,
              -83.257,
              13122.155
            ],
            [
              8900.484,
              -38.566,
              13187.257
            ],
            [
              8997.947,
              60.777,
              13326.426
            ],
            [
              9045.087,
              95.45,
              13384.944
            ],
            [
              9064.009,
              106.201,
              13406.707
            ],
            [
              9090.691,
              117.908,
              13435.844
            ],
            [
              9116.151,
              132.979,
              13465.43
            ],
            [
              9141.918,
              131.345,
              13491.249
            ],
            [
              9732.975,
              142.732,
              14082.416
            ],
            [
              9769.058,
              140.884,
              14118.547
            ],
            [
              9778.039,
              138.475,
              14127.845
            ],
            [
              9786.285,
              131.627,
              14138.564
            ],
            [
              9791.884,
              121.493,
              14150.141
            ],
            [
              9800.829,
              85.686,
              14187.049
            ],
            [
              9803.746,
              38.867,
              14233.958
            ],
            [
              9829,
              -19.539,
              14297.591
            ],
            [
              9893.228,
              -127.725,
              14423.406
            ],
            [
              9950.915,
              -240.232,
              14549.84
            ],
            [
              10000.794,
              -355.92,
              14675.823
            ],
            [
              10005.012,
              -370.479,
              14690.981
            ],
            [
              9909.859,
              -387.464,
              14787.637
            ],
            [
              9765.894,
              -394.549,
              14931.776
            ],
            [
              9656.901,
              -394.558,
              15040.77
            ],
            [
              9634.914,
              -397.45,
              15062.946
            ],
            [
              9569.305,
              -420.609,
              15132.522
            ],
            [
              9549.875,
              -424.668,
              15152.372
            ],
            [
              9353.83,
              -424.029,
              15348.418
            ],
            [
              9077.667,
              -430.684,
              15624.661
            ],
            [
              8999.086,
              -425.757,
              15703.396
            ],
            [
              8637.297,
              -425.144,
              16065.186
            ],
            [
              8583.813,
              -422.956,
              16118.715
            ],
            [
              8560.674,
              -579.465,
              16276.925
            ],
            [
              8539.859,
              -652.524,
              16352.892
            ],
            [
              8531.721,
              -672.4,
              16374.369
            ],
            [
              8486.109,
              -663.69,
              16420.805
            ],
            [
              8367.171,
              -581.146,
              16565.58
            ],
            [
              8316.776,
              -617.987,
              16628.006
            ],
            [
              8223.611,
              -697.391,
              16750.418
            ],
            [
              8208.584,
              -707.11,
              16768.313
            ],
            [
              8186.511,
              -714.461,
              16791.578
            ],
            [
              8174.886,
              -715.341,
              16803.237
            ],
            [
              8111.113,
              -711.839,
              16867.106
            ],
            [
              7990.769,
              -699.414,
              16988.089
            ],
            [
              7876.316,
              -682.656,
              17103.763
            ],
            [
              7825.635,
              -669.399,
              17156.15
            ],
            [
              7675.302,
              -640.799,
              17309.179
            ],
            [
              7649.128,
              -789.458,
              17460.125
            ],
            [
              7642.645,
              -888.412,
              17559.29
            ],
            [
              7789.211,
              -879.085,
              17706.153
            ],
            [
              7854.937,
              -849.223,
              17778.345
            ],
            [
              7928.999,
              -821.755,
              17857.336
            ],
            [
              7958.873,
              -811.219,
              17889.014
            ],
            [
              8004.239,
              -799.879,
              17935.776
            ],
            [
              8037.181,
              -797.197,
              17968.827
            ],
            [
              8131.96,
              -797.979,
              18063.609
            ],
            [
              8199.6,
              -801.56,
              18131.343
            ],
            [
              8316.695,
              -815.038,
              18249.212
            ],
            [
              8390.735,
              -820.977,
              18323.49
            ],
            [
              8436.278,
              -833.024,
              18370.599
            ],
            [
              8452.882,
              -841.15,
              18389.085
            ],
            [
              8489.177,
              -864.145,
              18432.051
            ],
            [
              8593.333,
              -879.597,
              18537.347
            ],
            [
              8629.498,
              -876.985,
              18573.606
            ],
            [
              8794.329,
              -921.496,
              18744.341
            ],
            [
              8878.898,
              -948.807,
              18833.212
            ],
            [
              9226.371,
              -1049.347,
              19194.937
            ],
            [
              9252.086,
              -1053.208,
              19220.941
            ],
            [
              9273.821,
              -1062.554,
              19244.6
            ],
            [
              9471.264,
              -1119.997,
              19450.23
            ],
            [
              9672.457,
              -1183.092,
              19661.083
            ],
            [
              9718.457,
              -1204.068,
              19711.64
            ],
            [
              9984.772,
              -1298.562,
              19994.223
            ],
            [
              9948.453,
              -1403.585,
              20105.348
            ],
            [
              9942.996,
              -1481.405,
              20183.359
            ],
            [
              9920.124,
              -1591.155,
              20295.467
            ],
            [
              9910.147,
              -1637.711,
              20343.08
            ],
            [
              9897.638,
              -1681.988,
              20389.09
            ],
            [
              9883.468,
              -1712.871,
              20423.069
            ],
            [
              9889.155,
              -1718.554,
              20431.108
            ],
            [
              9889.595,
              -1728.582,
              20441.146
            ],
            [
              9866.153,
              -1771.523,
              20490.069
            ],
            [
              9862.264,
              -1772.557,
              20494.094
            ],
            [
              9855.887,
              -1769.087,
              20501.353
            ],
            [
              9855.311,
              -1765.735,
              20504.754
            ],
            [
              9859.336,
              -1758.024,
              20513.453
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17589",
              "position": {
                "x": 4786.728,
                "z": 10630.719
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -120,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5981",
              "position": {
                "x": 5750.274,
                "z": 10180.179
              },
              "distanceAlongShapeM": 1346.786,
              "shapeOffsetM": 0.91,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5986",
              "position": {
                "x": 6984.236,
                "z": 8996.04
              },
              "distanceAlongShapeM": 3102.289,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6134",
              "position": {
                "x": 7319.162,
                "z": 8154.482
              },
              "distanceAlongShapeM": 4031.605,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6131",
              "position": {
                "x": 7383.302,
                "z": 7379.491
              },
              "distanceAlongShapeM": 4809.465,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:16184",
              "position": {
                "x": 8058.864,
                "z": 5233.034
              },
              "distanceAlongShapeM": 7131.765,
              "shapeOffsetM": 0.112,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:16176",
              "position": {
                "x": 8380.527,
                "z": 4334.865
              },
              "distanceAlongShapeM": 8086.777,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:4965",
              "position": {
                "x": 8920.296,
                "z": 2511.588
              },
              "distanceAlongShapeM": 10006.501,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6030",
              "position": {
                "x": 8696.422,
                "z": 1904.9
              },
              "distanceAlongShapeM": 10705.925,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7357",
              "position": {
                "x": 8821.879,
                "z": 1310.104
              },
              "distanceAlongShapeM": 11317.955,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6035",
              "position": {
                "x": 8692.348,
                "z": 547.88
              },
              "distanceAlongShapeM": 12111.868,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 12980.724,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 13465.43,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 13902.329,
              "shapeOffsetM": 0.663,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6047",
              "position": {
                "x": 9800.829,
                "z": 85.686
              },
              "distanceAlongShapeM": 14187.049,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:16156",
              "position": {
                "x": 9909.859,
                "z": -387.464
              },
              "distanceAlongShapeM": 14787.637,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:16160",
              "position": {
                "x": 9596.607,
                "z": -410.031
              },
              "distanceAlongShapeM": 15103.256,
              "shapeOffsetM": 0.887,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:16164",
              "position": {
                "x": 9077.667,
                "z": -430.684
              },
              "distanceAlongShapeM": 15624.661,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:16158",
              "position": {
                "x": 8637.297,
                "z": -425.144
              },
              "distanceAlongShapeM": 16065.186,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5400",
              "position": {
                "x": 8486.109,
                "z": -663.69
              },
              "distanceAlongShapeM": 16420.805,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5415",
              "position": {
                "x": 7876.316,
                "z": -682.656
              },
              "distanceAlongShapeM": 17103.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6054",
              "position": {
                "x": 7958.873,
                "z": -811.219
              },
              "distanceAlongShapeM": 17889.014,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6056",
              "position": {
                "x": 8390.735,
                "z": -820.977
              },
              "distanceAlongShapeM": 18323.49,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6059",
              "position": {
                "x": 8794.329,
                "z": -921.496
              },
              "distanceAlongShapeM": 18744.341,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:6062",
              "position": {
                "x": 9252.086,
                "z": -1053.208
              },
              "distanceAlongShapeM": 19220.941,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:6065",
              "position": {
                "x": 9672.457,
                "z": -1183.092
              },
              "distanceAlongShapeM": 19661.083,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:6069",
              "position": {
                "x": 9955.997,
                "z": -1381.473
              },
              "distanceAlongShapeM": 20081.984,
              "shapeOffsetM": 0.097,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:342",
              "position": {
                "x": 9859.336,
                "z": -1758.024
              },
              "distanceAlongShapeM": 20513.453,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            }
          ],
          "departuresSeconds": [
            17100,
            21900,
            23700,
            26160,
            28620,
            30780,
            33120,
            36420,
            39300,
            43140,
            46800,
            50220,
            53880,
            56880,
            58980,
            61440,
            63780,
            66120,
            68580,
            72240,
            76620,
            79920,
            83100
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_14:1",
          "sourceRouteId": "vilnius_bus_14",
          "sourceShapeId": "vilnius_bus_14_b-a",
          "directionId": 1,
          "headsign": "Rudamina",
          "directionName": "Arimų–Parko g.–Grigaičiai–Didžiasalis–Rudamina",
          "mode": "bus",
          "routeShortName": "14",
          "routeLongName": "Rudamina–Didžiasalis–Grigaičiai–Parko–Arimų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9859.336,
              -1758.024,
              0
            ],
            [
              9897.638,
              -1681.988,
              85.139
            ],
            [
              9923.019,
              -1575.628,
              194.485
            ],
            [
              9942.374,
              -1480.279,
              291.779
            ],
            [
              9946.338,
              -1412.448,
              359.725
            ],
            [
              9955.14,
              -1360.302,
              412.608
            ],
            [
              9984.772,
              -1298.562,
              481.091
            ],
            [
              9756.88,
              -1217.097,
              723.106
            ],
            [
              9754.856,
              -1221.509,
              727.96
            ],
            [
              9705.012,
              -1199.341,
              782.512
            ],
            [
              9471.264,
              -1119.997,
              1029.358
            ],
            [
              9190.433,
              -1040.826,
              1321.137
            ],
            [
              9149.36,
              -1031.089,
              1363.348
            ],
            [
              9144.271,
              -1027.646,
              1369.492
            ],
            [
              9086.597,
              -1009.78,
              1429.87
            ],
            [
              8772.945,
              -926.631,
              1754.356
            ],
            [
              8687.842,
              -893.745,
              1845.592
            ],
            [
              8644.901,
              -880.635,
              1890.49
            ],
            [
              8624.985,
              -876.894,
              1910.753
            ],
            [
              8593.333,
              -879.597,
              1942.521
            ],
            [
              8489.821,
              -864.158,
              2047.178
            ],
            [
              8477.019,
              -859.447,
              2060.819
            ],
            [
              8459.816,
              -849.082,
              2080.904
            ],
            [
              8449.036,
              -839.959,
              2095.025
            ],
            [
              8421.519,
              -829.387,
              2124.503
            ],
            [
              8324.408,
              -816.306,
              2222.492
            ],
            [
              8300.557,
              -815.828,
              2246.347
            ],
            [
              8276.152,
              -810.886,
              2271.248
            ],
            [
              8198.955,
              -801.547,
              2349.008
            ],
            [
              8122.914,
              -798.912,
              2425.095
            ],
            [
              8006.796,
              -801.043,
              2541.233
            ],
            [
              7987.391,
              -803.996,
              2560.861
            ],
            [
              7940.535,
              -825.326,
              2612.343
            ],
            [
              7856.182,
              -851.475,
              2700.656
            ],
            [
              7787.9,
              -880.172,
              2774.724
            ],
            [
              7642.645,
              -888.412,
              2920.212
            ],
            [
              7643.176,
              -861.704,
              2946.926
            ],
            [
              7639.707,
              -841.596,
              2967.331
            ],
            [
              7644.596,
              -822.767,
              2986.784
            ],
            [
              7675.302,
              -640.799,
              3171.325
            ],
            [
              7843.017,
              -670.859,
              3341.713
            ],
            [
              7941.422,
              -683.956,
              3440.985
            ],
            [
              7983.745,
              -695.934,
              3484.971
            ],
            [
              8105.956,
              -711.736,
              3608.199
            ],
            [
              8174.886,
              -715.341,
              3677.223
            ],
            [
              8196.247,
              -711.316,
              3698.96
            ],
            [
              8219.654,
              -701.765,
              3724.241
            ],
            [
              8291.234,
              -637.515,
              3820.427
            ],
            [
              8322.689,
              -612.539,
              3860.591
            ],
            [
              8367.171,
              -581.146,
              3915.036
            ],
            [
              8434.632,
              -625.918,
              3996.002
            ],
            [
              8481.22,
              -650.233,
              4048.554
            ],
            [
              8531.721,
              -672.4,
              4103.705
            ],
            [
              8573.203,
              -469.501,
              4310.801
            ],
            [
              8571.94,
              -436.076,
              4344.249
            ],
            [
              8574.788,
              -422.774,
              4357.853
            ],
            [
              8666.486,
              -416.825,
              4449.744
            ],
            [
              8743.801,
              -420.608,
              4527.151
            ],
            [
              8906.3,
              -421.657,
              4689.654
            ],
            [
              9047.616,
              -417.831,
              4831.022
            ],
            [
              9204.269,
              -420.999,
              4987.706
            ],
            [
              9542.829,
              -422.298,
              5326.269
            ],
            [
              9555.123,
              -420.321,
              5338.721
            ],
            [
              9579.337,
              -403,
              5368.492
            ],
            [
              9636.294,
              -393.025,
              5426.316
            ],
            [
              9884.095,
              -385.825,
              5674.222
            ],
            [
              9942.297,
              -378.106,
              5732.934
            ],
            [
              9966.286,
              -371.915,
              5757.708
            ],
            [
              9985.004,
              -371.184,
              5776.441
            ],
            [
              9999.301,
              -365.91,
              5791.679
            ],
            [
              9996.949,
              -354.729,
              5803.105
            ],
            [
              9971.821,
              -321.93,
              5844.423
            ],
            [
              9967.299,
              -290.665,
              5876.013
            ],
            [
              9947.183,
              -233.476,
              5936.637
            ],
            [
              9888.206,
              -120.943,
              6063.688
            ],
            [
              9839.53,
              -40.906,
              6157.364
            ],
            [
              9813.404,
              6.385,
              6211.392
            ],
            [
              9798.056,
              44.55,
              6252.527
            ],
            [
              9791,
              78.093,
              6286.804
            ],
            [
              9786.285,
              131.627,
              6340.546
            ],
            [
              9766.321,
              133.147,
              6360.568
            ],
            [
              9682.346,
              127.063,
              6444.763
            ],
            [
              9621.808,
              131.634,
              6505.473
            ],
            [
              9517.36,
              133.756,
              6609.943
            ],
            [
              9448.882,
              128.466,
              6678.625
            ],
            [
              9389.611,
              131.895,
              6737.995
            ],
            [
              9156.08,
              129.945,
              6971.534
            ],
            [
              9090.691,
              117.908,
              7038.022
            ],
            [
              9073.545,
              99.328,
              7063.304
            ],
            [
              9049.578,
              94.246,
              7087.804
            ],
            [
              8990.008,
              50.917,
              7161.465
            ],
            [
              8869.532,
              -70.228,
              7332.318
            ],
            [
              8853.145,
              -83.257,
              7353.253
            ],
            [
              8819.883,
              -101.512,
              7391.195
            ],
            [
              8767.948,
              -118.279,
              7445.769
            ],
            [
              8695.316,
              -137.969,
              7521.023
            ],
            [
              8673.105,
              -151.995,
              7547.292
            ],
            [
              8624.063,
              -153.235,
              7596.35
            ],
            [
              8595.54,
              -160.454,
              7625.773
            ],
            [
              8604.283,
              -110.532,
              7676.455
            ],
            [
              8637.068,
              12.385,
              7803.668
            ],
            [
              8636.294,
              38.006,
              7829.302
            ],
            [
              8617.005,
              105.191,
              7899.201
            ],
            [
              8590.333,
              158.052,
              7958.41
            ],
            [
              8585.045,
              183.764,
              7984.66
            ],
            [
              8586.558,
              194.867,
              7995.865
            ],
            [
              8620.876,
              297.713,
              8104.286
            ],
            [
              8659.092,
              433.88,
              8245.714
            ],
            [
              8695.643,
              583.439,
              8399.675
            ],
            [
              8721.736,
              661.957,
              8482.415
            ],
            [
              8760.458,
              726.862,
              8557.993
            ],
            [
              8819.472,
              870.402,
              8713.19
            ],
            [
              8847.419,
              976.715,
              8823.115
            ],
            [
              8854.075,
              1018.886,
              8865.808
            ],
            [
              8852.191,
              1053.436,
              8900.41
            ],
            [
              8817.758,
              1265.655,
              9115.404
            ],
            [
              8821.341,
              1283.395,
              9133.503
            ],
            [
              8818.744,
              1314.62,
              9164.835
            ],
            [
              8804.414,
              1403.972,
              9255.329
            ],
            [
              8726.321,
              1627.089,
              9491.718
            ],
            [
              8709.628,
              1695.336,
              9561.977
            ],
            [
              8696.749,
              1857.022,
              9724.175
            ],
            [
              8689.636,
              1888.337,
              9756.288
            ],
            [
              8690.755,
              1943.979,
              9811.941
            ],
            [
              8687.807,
              2021.969,
              9889.986
            ],
            [
              8697.822,
              2070.752,
              9939.787
            ],
            [
              8713.888,
              2131.66,
              10002.778
            ],
            [
              8739.783,
              2167.877,
              10047.301
            ],
            [
              8789.814,
              2216.968,
              10117.394
            ],
            [
              8839.29,
              2270.523,
              10190.305
            ],
            [
              8861.119,
              2329.088,
              10252.805
            ],
            [
              8872.786,
              2395.65,
              10320.382
            ],
            [
              8890.213,
              2459.87,
              10386.925
            ],
            [
              8901.773,
              2553.154,
              10480.922
            ],
            [
              8885.791,
              2624.726,
              10554.257
            ],
            [
              8844.1,
              2893.869,
              10826.61
            ],
            [
              8816.266,
              3018.004,
              10953.828
            ],
            [
              8739.118,
              3225.515,
              11175.215
            ],
            [
              8665.073,
              3395.11,
              11360.27
            ],
            [
              8585.844,
              3628.266,
              11606.519
            ],
            [
              8584.911,
              3646.097,
              11624.374
            ],
            [
              8578.905,
              3668.483,
              11647.552
            ],
            [
              8568.917,
              3685.383,
              11667.183
            ],
            [
              8554.255,
              3694.584,
              11684.493
            ],
            [
              8549.249,
              3702.477,
              11693.84
            ],
            [
              8551.031,
              3726.934,
              11718.361
            ],
            [
              8525.272,
              3826.533,
              11821.238
            ],
            [
              8451.879,
              4061.794,
              12067.681
            ],
            [
              8354.625,
              4363.216,
              12384.404
            ],
            [
              8285.976,
              4610.626,
              12641.161
            ],
            [
              8176.879,
              4934.545,
              12982.959
            ],
            [
              8066.968,
              5186.114,
              13257.491
            ],
            [
              7970.313,
              5390.658,
              13483.722
            ],
            [
              7937.986,
              5485.931,
              13584.33
            ],
            [
              7871.26,
              5669.837,
              13779.967
            ],
            [
              7850.792,
              5777.119,
              13889.184
            ],
            [
              7860.873,
              6024.066,
              14136.336
            ],
            [
              7873.24,
              6126.242,
              14239.257
            ],
            [
              7881.684,
              6290.838,
              14404.071
            ],
            [
              7862.95,
              6388.066,
              14503.087
            ],
            [
              7808.99,
              6532.752,
              14657.507
            ],
            [
              7714.906,
              6673.782,
              14827.04
            ],
            [
              7583.294,
              6844.498,
              15042.599
            ],
            [
              7466.788,
              7028.271,
              15260.191
            ],
            [
              7408.088,
              7163.026,
              15407.176
            ],
            [
              7385.311,
              7252.539,
              15499.54
            ],
            [
              7364.295,
              7431.078,
              15679.312
            ],
            [
              7352.134,
              7730.788,
              15979.269
            ],
            [
              7322.275,
              8083.172,
              16332.915
            ],
            [
              7301.003,
              8183.786,
              16435.754
            ],
            [
              7307.762,
              8231.523,
              16483.967
            ],
            [
              7293.63,
              8366.508,
              16619.69
            ],
            [
              7289.46,
              8384.403,
              16638.064
            ],
            [
              7287.294,
              8405.597,
              16659.369
            ],
            [
              7277.531,
              8434.735,
              16690.099
            ],
            [
              7258.703,
              8462.939,
              16724.01
            ],
            [
              7199.15,
              8523.118,
              16808.674
            ],
            [
              7185.357,
              8544.542,
              16834.154
            ],
            [
              7179.271,
              8563.588,
              16854.149
            ],
            [
              7147.693,
              8698.916,
              16993.113
            ],
            [
              7134.896,
              8738.133,
              17034.365
            ],
            [
              7110.515,
              8779.805,
              17082.644
            ],
            [
              6964.517,
              9012.014,
              17356.937
            ],
            [
              6945.301,
              9053.583,
              17402.733
            ],
            [
              6919.899,
              9076.348,
              17436.843
            ],
            [
              6913.209,
              9097.632,
              17459.154
            ],
            [
              6869.903,
              9163.053,
              17537.609
            ],
            [
              6826.399,
              9218.458,
              17608.053
            ],
            [
              6802.977,
              9243.41,
              17642.276
            ],
            [
              6757.031,
              9273.257,
              17697.066
            ],
            [
              6502.065,
              9388.47,
              17976.854
            ],
            [
              6465.588,
              9406.996,
              18017.766
            ],
            [
              6447.825,
              9424.042,
              18042.385
            ],
            [
              6308.307,
              9593.759,
              18262.087
            ],
            [
              5941.66,
              10082.947,
              18873.426
            ],
            [
              5920.748,
              10104.506,
              18903.461
            ],
            [
              5906.059,
              10113.697,
              18920.788
            ],
            [
              5710.988,
              10187.621,
              19129.397
            ],
            [
              5616.885,
              10235.089,
              19234.794
            ],
            [
              5561.94,
              10268.438,
              19299.068
            ],
            [
              5466.994,
              10339.297,
              19417.541
            ],
            [
              5408.901,
              10377.158,
              19486.882
            ],
            [
              5325.109,
              10423.307,
              19582.542
            ],
            [
              5232.119,
              10461.84,
              19683.2
            ],
            [
              4786.728,
              10630.719,
              20159.533
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:342",
              "position": {
                "x": 9859.336,
                "z": -1758.024
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -900,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6068",
              "position": {
                "x": 9955.14,
                "z": -1360.302
              },
              "distanceAlongShapeM": 412.608,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6066",
              "position": {
                "x": 9754.856,
                "z": -1221.509
              },
              "distanceAlongShapeM": 727.96,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6064",
              "position": {
                "x": 9149.36,
                "z": -1031.089
              },
              "distanceAlongShapeM": 1363.348,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6060",
              "position": {
                "x": 8772.945,
                "z": -926.631
              },
              "distanceAlongShapeM": 1754.356,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6057",
              "position": {
                "x": 8300.557,
                "z": -815.828
              },
              "distanceAlongShapeM": 2246.347,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6055",
              "position": {
                "x": 7940.535,
                "z": -825.326
              },
              "distanceAlongShapeM": 2612.343,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5394",
              "position": {
                "x": 7639.707,
                "z": -841.596
              },
              "distanceAlongShapeM": 2967.331,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5396",
              "position": {
                "x": 7941.422,
                "z": -683.956
              },
              "distanceAlongShapeM": 3440.985,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6225",
              "position": {
                "x": 8539.64,
                "z": -631.367
              },
              "distanceAlongShapeM": 4145.492,
              "shapeOffsetM": 0.461,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:16167",
              "position": {
                "x": 8666.486,
                "z": -416.825
              },
              "distanceAlongShapeM": 4449.744,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:16165",
              "position": {
                "x": 9047.616,
                "z": -417.831
              },
              "distanceAlongShapeM": 4831.022,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:16162",
              "position": {
                "x": 9579.337,
                "z": -403
              },
              "distanceAlongShapeM": 5368.492,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6049",
              "position": {
                "x": 9971.821,
                "z": -321.93
              },
              "distanceAlongShapeM": 5844.423,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 6444.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 6678.625,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 7063.304,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 7547.292,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6032",
              "position": {
                "x": 8721.736,
                "z": 661.957
              },
              "distanceAlongShapeM": 8482.415,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7356",
              "position": {
                "x": 8817.758,
                "z": 1265.655
              },
              "distanceAlongShapeM": 9115.404,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6029",
              "position": {
                "x": 8689.636,
                "z": 1888.337
              },
              "distanceAlongShapeM": 9756.288,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:16179",
              "position": {
                "x": 8885.791,
                "z": 2624.726
              },
              "distanceAlongShapeM": 10554.257,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:16182",
              "position": {
                "x": 8525.272,
                "z": 3826.533
              },
              "distanceAlongShapeM": 11821.238,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:16180",
              "position": {
                "x": 8354.625,
                "z": 4363.216
              },
              "distanceAlongShapeM": 12384.404,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:16183",
              "position": {
                "x": 7970.313,
                "z": 5390.658
              },
              "distanceAlongShapeM": 13483.722,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6130",
              "position": {
                "x": 7364.295,
                "z": 7431.078
              },
              "distanceAlongShapeM": 15679.312,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6133",
              "position": {
                "x": 7301.003,
                "z": 8183.786
              },
              "distanceAlongShapeM": 16435.754,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6137",
              "position": {
                "x": 6919.899,
                "z": 9076.348
              },
              "distanceAlongShapeM": 17436.843,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:5982",
              "position": {
                "x": 5710.988,
                "z": 10187.621
              },
              "distanceAlongShapeM": 19129.397,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:17589",
              "position": {
                "x": 4786.728,
                "z": 10630.719
              },
              "distanceAlongShapeM": 20159.533,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            }
          ],
          "departuresSeconds": [
            18900,
            20700,
            23100,
            25500,
            27600,
            30000,
            33420,
            36360,
            39960,
            43560,
            47160,
            50760,
            53760,
            55860,
            58260,
            60660,
            63060,
            65460,
            69180,
            73560,
            76860,
            80100,
            83340
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_15",
      "sourceRouteId": "vilnius_bus_15",
      "mode": "bus",
      "shortName": "15",
      "longName": "Žolyno g.–Antakalnis–Turniškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_15:0",
          "sourceRouteId": "vilnius_bus_15",
          "sourceShapeId": "vilnius_bus_15_a-b",
          "directionId": 0,
          "headsign": "Turniškės",
          "directionName": "Žolyno g.–Antakalnis–Turniškės",
          "mode": "bus",
          "routeShortName": "15",
          "routeLongName": "Žolyno g.–Antakalnis–Turniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3855.662,
              -2234.048,
              0
            ],
            [
              3777.563,
              -2239.239,
              78.271
            ],
            [
              3730.395,
              -2245.02,
              125.792
            ],
            [
              3478.067,
              -2293.658,
              382.765
            ],
            [
              3430.234,
              -2300.543,
              431.091
            ],
            [
              3387.662,
              -2301.962,
              473.686
            ],
            [
              3196.764,
              -2272.74,
              666.808
            ],
            [
              3157.806,
              -2287.589,
              708.5
            ],
            [
              3002.929,
              -2364.816,
              881.563
            ],
            [
              2811.307,
              -2442.469,
              1088.321
            ],
            [
              2719.174,
              -2508.643,
              1201.756
            ],
            [
              2680.157,
              -2526.834,
              1244.806
            ],
            [
              2599.153,
              -2549.802,
              1329.003
            ],
            [
              2457.059,
              -2599.457,
              1479.523
            ],
            [
              2382.396,
              -2628.114,
              1559.497
            ],
            [
              2328.687,
              -2639.354,
              1614.37
            ],
            [
              2411.872,
              -3118.499,
              2100.682
            ],
            [
              2419.872,
              -3138.687,
              2122.398
            ],
            [
              2418.768,
              -3163.158,
              2146.894
            ],
            [
              2474.472,
              -3526.012,
              2513.998
            ],
            [
              2513.109,
              -3664.781,
              2658.045
            ],
            [
              2522.438,
              -3682.768,
              2678.308
            ],
            [
              2522.312,
              -3689.445,
              2684.986
            ],
            [
              2535.711,
              -3730.887,
              2728.54
            ],
            [
              2556.818,
              -3773.588,
              2776.173
            ],
            [
              2579.36,
              -3808.522,
              2817.749
            ],
            [
              2619.624,
              -3860.489,
              2883.489
            ],
            [
              2636.723,
              -3876.397,
              2906.843
            ],
            [
              2642.893,
              -3890.985,
              2922.682
            ],
            [
              2709.56,
              -3977.961,
              3032.269
            ],
            [
              3021.059,
              -4338.966,
              3509.089
            ],
            [
              3040.626,
              -4360.488,
              3538.176
            ],
            [
              3057.099,
              -4375.272,
              3560.31
            ],
            [
              3068.958,
              -4395.535,
              3583.788
            ],
            [
              3153.475,
              -4491.761,
              3711.861
            ],
            [
              3273.19,
              -4634.3,
              3898.004
            ],
            [
              3313.46,
              -4685.161,
              3962.876
            ],
            [
              3313.956,
              -4692.963,
              3970.694
            ],
            [
              3308.075,
              -4697.304,
              3978.004
            ],
            [
              3299.661,
              -4699.371,
              3986.669
            ],
            [
              3277.414,
              -4683.364,
              4014.075
            ],
            [
              3252.761,
              -4658.405,
              4049.158
            ],
            [
              3232.404,
              -4644.66,
              4073.72
            ],
            [
              3223.387,
              -4644.489,
              4082.738
            ],
            [
              3214.72,
              -4659.91,
              4100.429
            ],
            [
              3040.179,
              -4759.027,
              4301.149
            ],
            [
              2917.006,
              -4833.515,
              4445.093
            ],
            [
              2711.294,
              -4946.528,
              4679.805
            ],
            [
              2678.135,
              -4962.603,
              4716.655
            ],
            [
              2617.201,
              -4982.608,
              4780.789
            ],
            [
              2514.946,
              -5007.403,
              4886.007
            ],
            [
              2467.102,
              -5016.524,
              4934.712
            ],
            [
              2460.683,
              -5015.29,
              4941.249
            ],
            [
              2477.192,
              -4890.915,
              5066.714
            ],
            [
              2478.008,
              -4847.514,
              5110.124
            ],
            [
              2465.762,
              -4744.864,
              5213.501
            ],
            [
              2455.774,
              -4693.466,
              5265.86
            ],
            [
              2442.006,
              -4637.545,
              5323.452
            ],
            [
              2413.734,
              -4599.164,
              5371.122
            ],
            [
              2383.943,
              -4573,
              5410.77
            ],
            [
              2368.05,
              -4561.569,
              5430.347
            ],
            [
              2340.004,
              -4545.458,
              5462.692
            ],
            [
              2306.93,
              -4522.572,
              5502.912
            ],
            [
              2282.935,
              -4496.518,
              5538.332
            ],
            [
              2226.836,
              -4533.318,
              5605.424
            ],
            [
              2194.798,
              -4558.323,
              5646.065
            ],
            [
              2023.954,
              -4667.567,
              5848.85
            ],
            [
              1942.804,
              -4735.073,
              5954.408
            ],
            [
              1867.702,
              -4789.335,
              6047.061
            ],
            [
              1634.84,
              -4874.059,
              6294.857
            ],
            [
              1419.978,
              -4961.355,
              6526.776
            ],
            [
              1390.251,
              -4966.37,
              6556.924
            ],
            [
              1372.759,
              -4971.612,
              6575.183
            ],
            [
              1253.284,
              -4952.7,
              6696.146
            ],
            [
              1216.637,
              -4948.682,
              6733.012
            ],
            [
              1176.209,
              -4940.141,
              6774.333
            ],
            [
              1118.975,
              -4934.63,
              6831.832
            ],
            [
              1098.764,
              -4947.615,
              6855.855
            ],
            [
              1088.192,
              -4961.892,
              6873.62
            ],
            [
              1084.123,
              -4972.95,
              6885.402
            ],
            [
              1006.146,
              -5218.651,
              7143.18
            ],
            [
              964.277,
              -5358.147,
              7288.825
            ],
            [
              953.825,
              -5435.882,
              7367.259
            ],
            [
              918.816,
              -5587.751,
              7523.111
            ],
            [
              921.738,
              -5743.66,
              7679.047
            ],
            [
              940.076,
              -5831.945,
              7769.216
            ],
            [
              974.169,
              -5973.957,
              7915.263
            ],
            [
              974.82,
              -6008.479,
              7949.792
            ],
            [
              982.738,
              -6033.117,
              7975.671
            ],
            [
              990.841,
              -6047.739,
              7992.388
            ],
            [
              1017.677,
              -6059.367,
              8021.635
            ],
            [
              1427.777,
              -6172.718,
              8447.111
            ],
            [
              1450.249,
              -6176.475,
              8469.895
            ],
            [
              1479.222,
              -6177.013,
              8498.873
            ],
            [
              1579.802,
              -6136.578,
              8607.276
            ],
            [
              2228.31,
              -5864.8,
              9310.431
            ],
            [
              2308.196,
              -5829.56,
              9397.744
            ],
            [
              2314.172,
              -5888.675,
              9457.16
            ],
            [
              2340.269,
              -6008.283,
              9579.582
            ],
            [
              2375.169,
              -6139.189,
              9715.06
            ],
            [
              2401.266,
              -6224.287,
              9804.07
            ],
            [
              2448.194,
              -6297.53,
              9891.057
            ],
            [
              2591.157,
              -6469.434,
              10114.64
            ],
            [
              2613.25,
              -6493.228,
              10147.109
            ],
            [
              2629.114,
              -6505.772,
              10167.334
            ],
            [
              2638.687,
              -6510.406,
              10177.969
            ],
            [
              2652.808,
              -6512.898,
              10192.309
            ],
            [
              2665.25,
              -6502,
              10208.849
            ],
            [
              2766.469,
              -6291.274,
              10442.623
            ],
            [
              2777.043,
              -6277.001,
              10460.386
            ],
            [
              2812.852,
              -6256.525,
              10501.636
            ],
            [
              2840.662,
              -6250.37,
              10530.12
            ],
            [
              2857.423,
              -6249.573,
              10546.899
            ],
            [
              2873.476,
              -6252.102,
              10563.151
            ],
            [
              3082.089,
              -6357.353,
              10796.811
            ],
            [
              3095.462,
              -6365.399,
              10812.417
            ],
            [
              3096.623,
              -6372.1,
              10819.219
            ],
            [
              3095.895,
              -6376.54,
              10823.717
            ],
            [
              3086.154,
              -6380.808,
              10834.353
            ],
            [
              3072.159,
              -6371.637,
              10851.085
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1167",
              "position": {
                "x": 3855.662,
                "z": -2234.048
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4521",
              "position": {
                "x": 3280.303,
                "z": -2286.568
              },
              "distanceAlongShapeM": 582.139,
              "shapeOffsetM": 1.028,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:11046",
              "position": {
                "x": 2680.157,
                "z": -2526.834
              },
              "distanceAlongShapeM": 1244.806,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6720",
              "position": {
                "x": 2382.396,
                "z": -2628.114
              },
              "distanceAlongShapeM": 1559.497,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 2122.398,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 2678.308,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 450,
              "departureOffsetSeconds": 450
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 2906.843,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 510,
              "departureOffsetSeconds": 510
            },
            {
              "stopId": "judu:stop:3566",
              "position": {
                "x": 3057.099,
                "z": -4375.272
              },
              "distanceAlongShapeM": 3560.31,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 630,
              "departureOffsetSeconds": 630
            },
            {
              "stopId": "judu:stop:6083",
              "position": {
                "x": 2917.006,
                "z": -4833.515
              },
              "distanceAlongShapeM": 4445.093,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:16155",
              "position": {
                "x": 2468.085,
                "z": -4964.219
              },
              "distanceAlongShapeM": 4992.849,
              "shapeOffsetM": 0.617,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:16147",
              "position": {
                "x": 2194.798,
                "z": -4558.323
              },
              "distanceAlongShapeM": 5646.065,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:16148",
              "position": {
                "x": 1942.804,
                "z": -4735.073
              },
              "distanceAlongShapeM": 5954.408,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:16145",
              "position": {
                "x": 1216.637,
                "z": -4948.682
              },
              "distanceAlongShapeM": 6733.012,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:16149",
              "position": {
                "x": 953.825,
                "z": -5435.882
              },
              "distanceAlongShapeM": 7367.259,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:16150",
              "position": {
                "x": 974.169,
                "z": -5973.957
              },
              "distanceAlongShapeM": 7915.263,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:16152",
              "position": {
                "x": 1579.802,
                "z": -6136.578
              },
              "distanceAlongShapeM": 8607.276,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:16153",
              "position": {
                "x": 2129.65,
                "z": -5905.257
              },
              "distanceAlongShapeM": 9203.801,
              "shapeOffsetM": 0.821,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6095",
              "position": {
                "x": 2571.037,
                "z": -6443.45
              },
              "distanceAlongShapeM": 10081.797,
              "shapeOffsetM": 1.145,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:1028",
              "position": {
                "x": 3072.159,
                "z": -6371.637
              },
              "distanceAlongShapeM": 10851.085,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            }
          ],
          "departuresSeconds": [
            22380,
            24540,
            26640,
            28860,
            31080,
            33240,
            37020,
            39120,
            41400,
            43200,
            44820,
            46320,
            47820,
            49320,
            50820,
            52320,
            54420,
            56220,
            58200,
            60180,
            61560,
            63060,
            64620,
            66240,
            67800,
            69360,
            75660,
            77760,
            79860,
            81960,
            84000,
            86040
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_15:1",
          "sourceRouteId": "vilnius_bus_15",
          "sourceShapeId": "vilnius_bus_15_b-a",
          "directionId": 1,
          "headsign": "Žolyno g.",
          "directionName": "Turniškės–Antakalnis–Žolyno g.",
          "mode": "bus",
          "routeShortName": "15",
          "routeLongName": "Žolyno g.–Antakalnis–Turniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3072.159,
              -6371.637,
              0
            ],
            [
              3061.677,
              -6346.947,
              26.823
            ],
            [
              2902.861,
              -6264.903,
              205.579
            ],
            [
              2876.653,
              -6254.389,
              233.817
            ],
            [
              2856.114,
              -6250.661,
              254.692
            ],
            [
              2840.662,
              -6250.37,
              270.146
            ],
            [
              2811.564,
              -6256.5,
              299.883
            ],
            [
              2777.043,
              -6277.001,
              340.033
            ],
            [
              2735.637,
              -6355.262,
              428.572
            ],
            [
              2673.248,
              -6487.678,
              574.95
            ],
            [
              2663.276,
              -6504.189,
              594.238
            ],
            [
              2652.808,
              -6512.898,
              607.856
            ],
            [
              2646.349,
              -6513.89,
              614.39
            ],
            [
              2633.516,
              -6511.422,
              627.459
            ],
            [
              2604.964,
              -6488.619,
              663.999
            ],
            [
              2596.035,
              -6483.998,
              674.053
            ],
            [
              2545.165,
              -6415.132,
              759.67
            ],
            [
              2442.609,
              -6286.293,
              924.343
            ],
            [
              2423.775,
              -6260.334,
              956.415
            ],
            [
              2403.26,
              -6220.985,
              1000.791
            ],
            [
              2387.917,
              -6180.619,
              1043.974
            ],
            [
              2327.75,
              -5954.612,
              1277.853
            ],
            [
              2313.675,
              -5880.873,
              1352.923
            ],
            [
              2307.552,
              -5829.548,
              1404.612
            ],
            [
              2277.641,
              -5844.573,
              1438.084
            ],
            [
              2254.834,
              -5858.618,
              1464.868
            ],
            [
              2186.104,
              -5882.935,
              1537.774
            ],
            [
              1550.581,
              -6149.394,
              2226.896
            ],
            [
              1525.12,
              -6167.846,
              2258.341
            ],
            [
              1472.098,
              -6179.107,
              2312.545
            ],
            [
              1432.845,
              -6177.265,
              2351.841
            ],
            [
              1348.251,
              -6154.544,
              2439.433
            ],
            [
              985.005,
              -6049.858,
              2817.463
            ],
            [
              970.71,
              -6021.762,
              2848.986
            ],
            [
              965.306,
              -6000.511,
              2870.914
            ],
            [
              961.161,
              -5945.885,
              2925.697
            ],
            [
              943.844,
              -5872.091,
              3001.495
            ],
            [
              924.067,
              -5757.062,
              3118.213
            ],
            [
              914.968,
              -5656.702,
              3218.984
            ],
            [
              921.905,
              -5559.977,
              3315.957
            ],
            [
              953.714,
              -5406.935,
              3472.27
            ],
            [
              967.53,
              -5321.47,
              3558.845
            ],
            [
              978.203,
              -5301.629,
              3581.375
            ],
            [
              1054.122,
              -5062.569,
              3832.2
            ],
            [
              1069.297,
              -5008.3,
              3888.551
            ],
            [
              1070.146,
              -4997.183,
              3899.7
            ],
            [
              1086.945,
              -4959.643,
              3940.827
            ],
            [
              1095.544,
              -4947.556,
              3955.66
            ],
            [
              1104.704,
              -4939.932,
              3967.578
            ],
            [
              1118.975,
              -4934.63,
              3982.802
            ],
            [
              1142.2,
              -4932.833,
              4006.097
            ],
            [
              1277.818,
              -4949.814,
              4142.774
            ],
            [
              1313.697,
              -4960.498,
              4180.209
            ],
            [
              1359.318,
              -4966.91,
              4226.279
            ],
            [
              1389.607,
              -4966.358,
              4256.572
            ],
            [
              1429.741,
              -4955.97,
              4298.03
            ],
            [
              1621.316,
              -4873.807,
              4506.48
            ],
            [
              1827.524,
              -4801.945,
              4724.851
            ],
            [
              1854.801,
              -4790.208,
              4754.546
            ],
            [
              1888.913,
              -4757.446,
              4801.843
            ],
            [
              1911.039,
              -4745.613,
              4826.934
            ],
            [
              2211.295,
              -4537.48,
              5192.274
            ],
            [
              2213.373,
              -4529.726,
              5200.301
            ],
            [
              2275.248,
              -4494.147,
              5271.676
            ],
            [
              2318.377,
              -4530.58,
              5328.133
            ],
            [
              2409.995,
              -4592.414,
              5438.665
            ],
            [
              2434.591,
              -4620.707,
              5476.155
            ],
            [
              2445.164,
              -4640.944,
              5498.987
            ],
            [
              2469.71,
              -4740.485,
              5601.51
            ],
            [
              2478.2,
              -4802.987,
              5664.586
            ],
            [
              2480.872,
              -4866.493,
              5728.148
            ],
            [
              2477.293,
              -4919.862,
              5781.637
            ],
            [
              2464.154,
              -5001.996,
              5864.815
            ],
            [
              2467.851,
              -5010.972,
              5874.522
            ],
            [
              2480.045,
              -5013.427,
              5886.961
            ],
            [
              2496.935,
              -5005.952,
              5905.432
            ],
            [
              2653.495,
              -4971.045,
              6065.836
            ],
            [
              2718.462,
              -4942.21,
              6136.914
            ],
            [
              2868.928,
              -4854.873,
              6310.891
            ],
            [
              2882.726,
              -4840.661,
              6330.699
            ],
            [
              2908.032,
              -4831.119,
              6357.744
            ],
            [
              3213.474,
              -4657.66,
              6709.003
            ],
            [
              3218.752,
              -4651.081,
              6717.438
            ],
            [
              3220.167,
              -4644.428,
              6724.24
            ],
            [
              3217.76,
              -4635.476,
              6733.51
            ],
            [
              3140.028,
              -4589.474,
              6823.834
            ],
            [
              3137.62,
              -4580.522,
              6833.104
            ],
            [
              3139.678,
              -4573.882,
              6840.056
            ],
            [
              3146.203,
              -4569.552,
              6847.887
            ],
            [
              3156.487,
              -4570.86,
              6858.254
            ],
            [
              3202.417,
              -4595.108,
              6910.191
            ],
            [
              3210.79,
              -4595.267,
              6918.565
            ],
            [
              3216.006,
              -4592.026,
              6924.706
            ],
            [
              3220.017,
              -4584.309,
              6933.404
            ],
            [
              3218.877,
              -4576.495,
              6941.301
            ],
            [
              3190.252,
              -4557.027,
              6975.918
            ],
            [
              3172.809,
              -4525.525,
              7011.927
            ],
            [
              3060.003,
              -4392.026,
              7186.704
            ],
            [
              3021.059,
              -4338.966,
              7252.522
            ],
            [
              2961.544,
              -4283.292,
              7334.018
            ],
            [
              2937.404,
              -4265.024,
              7364.291
            ],
            [
              2920.517,
              -4237.987,
              7396.169
            ],
            [
              2810.169,
              -4110.107,
              7565.077
            ],
            [
              2739.116,
              -4050.879,
              7657.578
            ],
            [
              2661.391,
              -4003.772,
              7748.465
            ],
            [
              2636.416,
              -3995.509,
              7774.771
            ],
            [
              2619.338,
              -3978.489,
              7798.882
            ],
            [
              2604.004,
              -3971.521,
              7815.725
            ],
            [
              2521.143,
              -3923.207,
              7911.642
            ],
            [
              2505.227,
              -3912.889,
              7930.61
            ],
            [
              2488.876,
              -3891.43,
              7957.589
            ],
            [
              2479.071,
              -3864.528,
              7986.222
            ],
            [
              2475.189,
              -3831.057,
              8019.917
            ],
            [
              2503.004,
              -3722.48,
              8132
            ],
            [
              2508.663,
              -3661.358,
              8193.384
            ],
            [
              2463.001,
              -3519.117,
              8342.774
            ],
            [
              2462.068,
              -3500.174,
              8361.74
            ],
            [
              2434.072,
              -3309.282,
              8554.674
            ],
            [
              2425.512,
              -3284.63,
              8580.77
            ],
            [
              2426.678,
              -3256.82,
              8608.604
            ],
            [
              2328.687,
              -2639.354,
              9233.798
            ],
            [
              2422.077,
              -2608.82,
              9332.052
            ],
            [
              2444.816,
              -2599.227,
              9356.733
            ],
            [
              2646.504,
              -2533.994,
              9568.708
            ],
            [
              2717.262,
              -2507.494,
              9644.265
            ],
            [
              2743.995,
              -2491.298,
              9675.521
            ],
            [
              2805.445,
              -2445.699,
              9752.042
            ],
            [
              2826.856,
              -2438.309,
              9774.692
            ],
            [
              2849.016,
              -2425.368,
              9800.354
            ],
            [
              2992.535,
              -2369.073,
              9954.519
            ],
            [
              3051.699,
              -2342.359,
              10019.435
            ],
            [
              3144.148,
              -2294.01,
              10123.763
            ],
            [
              3171.465,
              -2281.167,
              10153.948
            ],
            [
              3196.764,
              -2272.74,
              10180.614
            ],
            [
              3228.339,
              -2273.338,
              10212.195
            ],
            [
              3336.988,
              -2288.755,
              10321.932
            ],
            [
              3342.08,
              -2292.192,
              10328.075
            ],
            [
              3360.683,
              -2296.997,
              10347.289
            ],
            [
              3397.349,
              -2301.032,
              10384.177
            ],
            [
              3432.188,
              -2299.467,
              10419.051
            ],
            [
              3478.067,
              -2293.658,
              10465.295
            ],
            [
              3621.692,
              -2266.33,
              10611.498
            ],
            [
              3717.486,
              -2245.887,
              10709.448
            ],
            [
              3791.201,
              -2233.932,
              10784.127
            ],
            [
              3808.621,
              -2233.151,
              10801.564
            ],
            [
              3855.166,
              -2226.246,
              10848.619
            ],
            [
              3942.025,
              -2201.185,
              10939.021
            ],
            [
              3964.664,
              -2197.164,
              10962.014
            ],
            [
              3981.588,
              -2188.581,
              10980.99
            ],
            [
              4002.486,
              -2174.508,
              11006.185
            ],
            [
              4009.595,
              -2173.53,
              11013.361
            ],
            [
              4015.997,
              -2175.879,
              11020.18
            ],
            [
              4016.493,
              -2183.681,
              11027.998
            ],
            [
              4009.878,
              -2192.461,
              11038.99
            ],
            [
              3987.905,
              -2195.381,
              11061.157
            ],
            [
              3864.811,
              -2227.543,
              11188.384
            ],
            [
              3855.662,
              -2234.048,
              11199.609
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1028",
              "position": {
                "x": 3072.159,
                "z": -6371.637
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6096",
              "position": {
                "x": 2596.035,
                "z": -6483.998
              },
              "distanceAlongShapeM": 674.053,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:4426",
              "position": {
                "x": 2254.834,
                "z": -5858.618
              },
              "distanceAlongShapeM": 1464.868,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6100",
              "position": {
                "x": 1525.12,
                "z": -6167.846
              },
              "distanceAlongShapeM": 2258.341,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:18768",
              "position": {
                "x": 965.306,
                "z": -6000.511
              },
              "distanceAlongShapeM": 2870.914,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6106",
              "position": {
                "x": 967.53,
                "z": -5321.47
              },
              "distanceAlongShapeM": 3558.845,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6107",
              "position": {
                "x": 1070.146,
                "z": -4997.183
              },
              "distanceAlongShapeM": 3899.7,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6109",
              "position": {
                "x": 1888.913,
                "z": -4757.446
              },
              "distanceAlongShapeM": 4801.843,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6110",
              "position": {
                "x": 2213.373,
                "z": -4529.726
              },
              "distanceAlongShapeM": 5200.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6084",
              "position": {
                "x": 2496.935,
                "z": -5005.952
              },
              "distanceAlongShapeM": 5905.432,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6082",
              "position": {
                "x": 2882.726,
                "z": -4840.661
              },
              "distanceAlongShapeM": 6330.699,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6079",
              "position": {
                "x": 3190.252,
                "z": -4557.027
              },
              "distanceAlongShapeM": 6975.918,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 7364.291,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 7774.771,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 8342.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 8580.77,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6723",
              "position": {
                "x": 2444.816,
                "z": -2599.227
              },
              "distanceAlongShapeM": 9356.733,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:11047",
              "position": {
                "x": 2826.856,
                "z": -2438.309
              },
              "distanceAlongShapeM": 9774.692,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:4520",
              "position": {
                "x": 3336.988,
                "z": -2288.755
              },
              "distanceAlongShapeM": 10321.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:8266",
              "position": {
                "x": 3808.621,
                "z": -2233.151
              },
              "distanceAlongShapeM": 10801.564,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            20340,
            22440,
            24540,
            26640,
            28740,
            30960,
            39300,
            41040,
            42480,
            43920,
            45360,
            46860,
            48360,
            49860,
            51300,
            52800,
            54660,
            58440,
            60240,
            62040,
            63660,
            65340,
            66960,
            71820,
            73620,
            75420,
            77580,
            79680,
            81780,
            83880,
            85980,
            87840
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_16",
      "sourceRouteId": "vilnius_bus_16",
      "mode": "bus",
      "shortName": "16",
      "longName": "Stotis–Nemėžis–Skaidiškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_16:0",
          "sourceRouteId": "vilnius_bus_16",
          "sourceShapeId": "vilnius_bus_16_a-b",
          "directionId": 0,
          "headsign": "Skaidiškės",
          "directionName": "Stotis–Nemėžis–Skaidiškės",
          "mode": "bus",
          "routeShortName": "16",
          "routeLongName": "Stotis–Nemėžis–Skaidiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              448.101,
              1917.454,
              0
            ],
            [
              414.243,
              1935.885,
              38.55
            ],
            [
              388.144,
              1955.287,
              71.07
            ],
            [
              374.884,
              1971.114,
              91.718
            ],
            [
              370.552,
              1981.213,
              102.707
            ],
            [
              369.405,
              1989.026,
              110.604
            ],
            [
              372.127,
              1996.769,
              118.811
            ],
            [
              376.723,
              2001.138,
              125.153
            ],
            [
              383.214,
              2003.246,
              131.977
            ],
            [
              391.578,
              2001.98,
              140.437
            ],
            [
              462.481,
              1962.833,
              221.428
            ],
            [
              478.32,
              1946.958,
              243.854
            ],
            [
              475.394,
              1928.087,
              262.951
            ],
            [
              494.54,
              1916.604,
              285.276
            ],
            [
              623.161,
              1858.587,
              426.377
            ],
            [
              825.163,
              1791.425,
              639.251
            ],
            [
              862.14,
              1837.501,
              698.33
            ],
            [
              869.06,
              1862.978,
              724.73
            ],
            [
              873.401,
              1888.503,
              750.621
            ],
            [
              889.31,
              1911.588,
              778.658
            ],
            [
              908.823,
              1920.135,
              799.961
            ],
            [
              941.154,
              1923.993,
              832.521
            ],
            [
              953.593,
              1933.783,
              848.351
            ],
            [
              1083.618,
              2057.184,
              1027.611
            ],
            [
              1196.071,
              2172,
              1188.323
            ],
            [
              1233.034,
              2216.96,
              1246.527
            ],
            [
              1262.402,
              2269.853,
              1307.026
            ],
            [
              1272.571,
              2296.383,
              1335.438
            ],
            [
              1295.641,
              2322.675,
              1370.416
            ],
            [
              1353.693,
              2426.246,
              1489.147
            ],
            [
              1363.843,
              2451.663,
              1516.515
            ],
            [
              1395.21,
              2612.502,
              1680.385
            ],
            [
              1412.03,
              2684.551,
              1754.371
            ],
            [
              1428.563,
              2741.021,
              1813.211
            ],
            [
              1438.754,
              2768.663,
              1842.672
            ],
            [
              1466.069,
              2814.913,
              1896.386
            ],
            [
              1513.094,
              2845.213,
              1952.328
            ],
            [
              1568.191,
              2893.175,
              2025.376
            ],
            [
              1626.949,
              2964.446,
              2117.745
            ],
            [
              1670.787,
              3031.54,
              2197.891
            ],
            [
              1688.949,
              3071.28,
              2241.584
            ],
            [
              1699.324,
              3143.448,
              2314.494
            ],
            [
              1699.269,
              3383.908,
              2554.955
            ],
            [
              1698.702,
              3422.882,
              2593.933
            ],
            [
              1683.073,
              3554.534,
              2726.509
            ],
            [
              1679.171,
              3622.514,
              2794.601
            ],
            [
              1674.798,
              3769.542,
              2941.694
            ],
            [
              1682.185,
              3784.991,
              2958.818
            ],
            [
              1743.856,
              3803.884,
              3023.318
            ],
            [
              1812.124,
              3830.447,
              3096.572
            ],
            [
              1876.708,
              3867.097,
              3170.83
            ],
            [
              2082.225,
              4019.124,
              3426.465
            ],
            [
              2137.697,
              4051.487,
              3490.687
            ],
            [
              2651.026,
              4265.645,
              4046.899
            ],
            [
              2753.781,
              4306.019,
              4157.301
            ],
            [
              2885.913,
              4363.65,
              4301.454
            ],
            [
              3782.546,
              4734.102,
              5271.601
            ],
            [
              4006.468,
              4830.032,
              5515.207
            ],
            [
              3993.412,
              4822.488,
              5530.286
            ],
            [
              4522.992,
              5032.789,
              6100.095
            ],
            [
              4822.139,
              5143.936,
              6419.222
            ],
            [
              5191.784,
              5293.78,
              6818.084
            ],
            [
              5390.118,
              5365.645,
              7029.036
            ],
            [
              5894.308,
              5558.47,
              7568.841
            ],
            [
              5940.079,
              5587.636,
              7623.115
            ],
            [
              6302.271,
              5748.669,
              8019.492
            ],
            [
              6563.825,
              5913.876,
              8328.852
            ],
            [
              6763.095,
              6063.593,
              8578.099
            ],
            [
              7005.952,
              6261.428,
              8891.337
            ],
            [
              7167.225,
              6415.217,
              9114.182
            ],
            [
              7554.365,
              6753.784,
              9628.483
            ],
            [
              7640.208,
              6815.537,
              9734.23
            ],
            [
              7656.704,
              6833.022,
              9758.269
            ],
            [
              7660.91,
              6849.638,
              9775.408
            ],
            [
              7659.928,
              6865.243,
              9791.044
            ],
            [
              7646.898,
              6892.22,
              9821.003
            ],
            [
              7605.965,
              6945.357,
              9888.078
            ],
            [
              7571.025,
              6974.995,
              9933.895
            ],
            [
              7556.886,
              6978.615,
              9948.49
            ],
            [
              7543.237,
              6974.432,
              9962.765
            ],
            [
              7526.25,
              6964.75,
              9982.318
            ],
            [
              7511.934,
              6959.467,
              9997.578
            ],
            [
              7504.208,
              6960.734,
              10005.407
            ],
            [
              7472.269,
              7011.464,
              10065.354
            ],
            [
              7418.94,
              7123.847,
              10189.748
            ],
            [
              7394.895,
              7214.498,
              10283.534
            ],
            [
              7373.806,
              7324.016,
              10395.064
            ],
            [
              7364.295,
              7431.078,
              10502.548
            ],
            [
              7352.134,
              7730.788,
              10802.505
            ],
            [
              7322.275,
              8083.172,
              11156.151
            ],
            [
              7301.003,
              8183.786,
              11258.99
            ],
            [
              7307.762,
              8231.523,
              11307.203
            ],
            [
              7293.63,
              8366.508,
              11442.925
            ],
            [
              7284.886,
              8414.551,
              11491.758
            ],
            [
              7277.531,
              8434.735,
              11513.24
            ],
            [
              7258.703,
              8462.939,
              11547.151
            ],
            [
              7199.15,
              8523.118,
              11631.815
            ],
            [
              7185.357,
              8544.542,
              11657.296
            ],
            [
              7179.271,
              8563.588,
              11677.29
            ],
            [
              7147.693,
              8698.916,
              11816.254
            ],
            [
              7134.896,
              8738.133,
              11857.506
            ],
            [
              7110.515,
              8779.805,
              11905.786
            ],
            [
              6964.517,
              9012.014,
              12180.078
            ],
            [
              6945.301,
              9053.583,
              12225.874
            ],
            [
              6966.105,
              9059.853,
              12247.602
            ],
            [
              7004.866,
              9059.09,
              12286.37
            ],
            [
              7368.796,
              9030.756,
              12651.402
            ],
            [
              7569.704,
              9026.779,
              12852.348
            ],
            [
              7573,
              9030.054,
              12856.995
            ],
            [
              7574.49,
              9040.044,
              12867.095
            ],
            [
              7579.189,
              9048.857,
              12877.082
            ],
            [
              7584.467,
              9054.318,
              12884.678
            ],
            [
              7592.953,
              9058.603,
              12894.185
            ],
            [
              7605.228,
              9058.36,
              12906.461
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:939",
              "position": {
                "x": 448.101,
                "z": 1917.454
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 778.658,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 1335.438,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 1896.386,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:16977",
              "position": {
                "x": 1743.856,
                "z": 3803.884
              },
              "distanceAlongShapeM": 3023.318,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:616",
              "position": {
                "x": 2873.526,
                "z": 4357.203
              },
              "distanceAlongShapeM": 4287.523,
              "shapeOffsetM": 0.957,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6120",
              "position": {
                "x": 4006.468,
                "z": 4830.032
              },
              "distanceAlongShapeM": 5515.207,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6122",
              "position": {
                "x": 4522.992,
                "z": 5032.789
              },
              "distanceAlongShapeM": 6100.095,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6124",
              "position": {
                "x": 5191.784,
                "z": 5293.78
              },
              "distanceAlongShapeM": 6818.084,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6126",
              "position": {
                "x": 5940.079,
                "z": 5587.636
              },
              "distanceAlongShapeM": 7623.115,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6128",
              "position": {
                "x": 7554.365,
                "z": 6753.784
              },
              "distanceAlongShapeM": 9628.483,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6130",
              "position": {
                "x": 7364.295,
                "z": 7431.078
              },
              "distanceAlongShapeM": 10502.548,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6133",
              "position": {
                "x": 7301.003,
                "z": 8183.786
              },
              "distanceAlongShapeM": 11258.99,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5985",
              "position": {
                "x": 7004.866,
                "z": 9059.09
              },
              "distanceAlongShapeM": 12286.37,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:863",
              "position": {
                "x": 7605.228,
                "z": 9058.36
              },
              "distanceAlongShapeM": 12906.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            18240,
            19500,
            21360,
            22680,
            24180,
            27660,
            29460,
            33180,
            35160,
            36960,
            38340,
            39840,
            41340,
            42720,
            44460,
            45780,
            47280,
            48900,
            50580,
            51780,
            53940,
            55140,
            56400,
            58200,
            59940,
            61320,
            63660,
            67740,
            69600,
            72360,
            73020,
            74820,
            76260,
            77760,
            79260,
            80940,
            83040
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_16:1",
          "sourceRouteId": "vilnius_bus_16",
          "sourceShapeId": "vilnius_bus_16_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Skaidiškės–Nemėžis–Stotis",
          "mode": "bus",
          "routeShortName": "16",
          "routeLongName": "Stotis–Nemėžis–Skaidiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              7605.228,
              9058.36,
              0
            ],
            [
              7614.896,
              9057.055,
              9.756
            ],
            [
              7624.343,
              9044.622,
              25.371
            ],
            [
              7624.68,
              9029.029,
              40.967
            ],
            [
              7617.464,
              9023.606,
              49.994
            ],
            [
              6945.301,
              9053.583,
              722.825
            ],
            [
              6984.236,
              8996.04,
              792.302
            ],
            [
              7068.705,
              8855.218,
              956.515
            ],
            [
              7120.139,
              8776.275,
              1050.735
            ],
            [
              7136.298,
              8743.672,
              1087.123
            ],
            [
              7149.16,
              8707.794,
              1125.237
            ],
            [
              7173.919,
              8587.072,
              1248.471
            ],
            [
              7195.473,
              8533.21,
              1306.486
            ],
            [
              7216.951,
              8508.294,
              1339.381
            ],
            [
              7252.486,
              8475.308,
              1387.866
            ],
            [
              7270.176,
              8454.919,
              1414.86
            ],
            [
              7281.451,
              8436.884,
              1436.129
            ],
            [
              7286.978,
              8422.303,
              1451.723
            ],
            [
              7294.539,
              8379.849,
              1494.845
            ],
            [
              7319.162,
              8154.482,
              1721.553
            ],
            [
              7319.126,
              8119.972,
              1756.063
            ],
            [
              7365.587,
              7529.02,
              2348.839
            ],
            [
              7383.302,
              7379.491,
              2499.413
            ],
            [
              7381.445,
              7318.298,
              2560.634
            ],
            [
              7395.496,
              7212.259,
              2667.6
            ],
            [
              7408.712,
              7161.901,
              2719.664
            ],
            [
              7434.51,
              7094.594,
              2791.746
            ],
            [
              7503.54,
              6959.633,
              2943.335
            ],
            [
              7568.305,
              6870.401,
              3053.594
            ],
            [
              7687.938,
              6714.395,
              3250.189
            ],
            [
              7763.406,
              6611.588,
              3377.723
            ],
            [
              7766.457,
              6602.621,
              3387.195
            ],
            [
              7764.9,
              6589.293,
              3400.613
            ],
            [
              7746.535,
              6575.185,
              3423.772
            ],
            [
              7735.47,
              6570.952,
              3435.619
            ],
            [
              7711.514,
              6568.088,
              3459.745
            ],
            [
              7699.981,
              6572.77,
              3472.193
            ],
            [
              7692.344,
              6578.488,
              3481.733
            ],
            [
              7668.985,
              6605.671,
              3517.574
            ],
            [
              7588.239,
              6703.015,
              3644.048
            ],
            [
              7578.018,
              6708.784,
              3655.784
            ],
            [
              7556.065,
              6709.219,
              3677.742
            ],
            [
              7543.643,
              6701.673,
              3692.277
            ],
            [
              7500.235,
              6662.455,
              3750.777
            ],
            [
              7180.388,
              6394.918,
              4167.764
            ],
            [
              7069.903,
              6294.678,
              4316.945
            ],
            [
              6778.151,
              6041.032,
              4703.54
            ],
            [
              6603.205,
              5913.103,
              4920.27
            ],
            [
              6488.726,
              5838.533,
              5056.894
            ],
            [
              6330.566,
              5742.549,
              5241.901
            ],
            [
              6193.481,
              5667.301,
              5398.28
            ],
            [
              6046.806,
              5596.689,
              5561.067
            ],
            [
              5825.963,
              5497.457,
              5803.18
            ],
            [
              5803.284,
              5493.445,
              5826.211
            ],
            [
              5770.792,
              5482.945,
              5860.357
            ],
            [
              5148.109,
              5238.96,
              6529.135
            ],
            [
              4846.366,
              5127.884,
              6850.673
            ],
            [
              4641.32,
              5041.652,
              7073.113
            ],
            [
              4457.255,
              4971.707,
              7270.02
            ],
            [
              4418.919,
              4959.082,
              7310.381
            ],
            [
              4110.611,
              4840.291,
              7640.782
            ],
            [
              3917.274,
              4757.143,
              7851.242
            ],
            [
              3791.824,
              4712.774,
              7984.306
            ],
            [
              3112.5,
              4431.742,
              8719.467
            ],
            [
              2822.207,
              4305.846,
              9035.883
            ],
            [
              2811.195,
              4303.827,
              9047.079
            ],
            [
              2180.203,
              4046.241,
              9728.623
            ],
            [
              2131.974,
              4021.536,
              9782.811
            ],
            [
              2048.32,
              3966.32,
              9883.044
            ],
            [
              1961.818,
              3896.684,
              9994.093
            ],
            [
              1908.119,
              3855.38,
              10061.839
            ],
            [
              1885.245,
              3840.22,
              10089.281
            ],
            [
              1810.879,
              3798.186,
              10174.704
            ],
            [
              1773.103,
              3779.963,
              10216.646
            ],
            [
              1723.068,
              3761.967,
              10269.819
            ],
            [
              1676.987,
              3748.35,
              10317.87
            ],
            [
              1674.7,
              3729.468,
              10336.89
            ],
            [
              1684.234,
              3721.498,
              10349.317
            ],
            [
              1678.221,
              3710.477,
              10361.871
            ],
            [
              1677.947,
              3591.366,
              10480.983
            ],
            [
              1696.885,
              3464.105,
              10609.645
            ],
            [
              1701.829,
              3382.747,
              10691.153
            ],
            [
              1703.03,
              3134.473,
              10939.43
            ],
            [
              1699.891,
              3104.474,
              10969.593
            ],
            [
              1687.994,
              3054.599,
              11020.867
            ],
            [
              1659.262,
              3001.697,
              11081.069
            ],
            [
              1605.061,
              2932.568,
              11168.913
            ],
            [
              1556.997,
              2881.137,
              11239.307
            ],
            [
              1484.111,
              2813.466,
              11338.764
            ],
            [
              1478.744,
              2802.433,
              11351.033
            ],
            [
              1453.839,
              2781.743,
              11383.411
            ],
            [
              1433.991,
              2755.392,
              11416.4
            ],
            [
              1428.563,
              2741.021,
              11431.763
            ],
            [
              1382.281,
              2541.494,
              11636.587
            ],
            [
              1365.86,
              2456.079,
              11723.566
            ],
            [
              1336.284,
              2392.058,
              11794.089
            ],
            [
              1224.883,
              2194.846,
              12020.59
            ],
            [
              958.108,
              1933.7,
              12393.907
            ],
            [
              922.174,
              1874.247,
              12463.376
            ],
            [
              898.105,
              1863.557,
              12489.712
            ],
            [
              862.14,
              1837.501,
              12534.124
            ],
            [
              825.163,
              1791.425,
              12593.203
            ],
            [
              623.161,
              1858.587,
              12806.077
            ],
            [
              493.148,
              1911.064,
              12946.281
            ],
            [
              481.742,
              1922.405,
              12962.366
            ],
            [
              470.798,
              1923.718,
              12973.389
            ],
            [
              464.267,
              1919.385,
              12981.227
            ],
            [
              448.101,
              1917.454,
              12997.507
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:863",
              "position": {
                "x": 7605.228,
                "z": 9058.36
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5986",
              "position": {
                "x": 6984.236,
                "z": 8996.04
              },
              "distanceAlongShapeM": 792.302,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6134",
              "position": {
                "x": 7319.162,
                "z": 8154.482
              },
              "distanceAlongShapeM": 1721.553,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6131",
              "position": {
                "x": 7383.302,
                "z": 7379.491
              },
              "distanceAlongShapeM": 2499.413,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6129",
              "position": {
                "x": 7500.235,
                "z": 6662.455
              },
              "distanceAlongShapeM": 3750.777,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6127",
              "position": {
                "x": 5825.963,
                "z": 5497.457
              },
              "distanceAlongShapeM": 5803.18,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6125",
              "position": {
                "x": 5148.109,
                "z": 5238.96
              },
              "distanceAlongShapeM": 6529.135,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6123",
              "position": {
                "x": 4457.255,
                "z": 4971.707
              },
              "distanceAlongShapeM": 7270.02,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6121",
              "position": {
                "x": 3917.274,
                "z": 4757.143
              },
              "distanceAlongShapeM": 7851.242,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:617",
              "position": {
                "x": 2822.207,
                "z": 4305.846
              },
              "distanceAlongShapeM": 9035.883,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 10349.317,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 11351.033,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 12020.59,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 12463.376,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 12946.281,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            19440,
            20400,
            21840,
            23520,
            25260,
            26400,
            30000,
            31800,
            35160,
            37440,
            39240,
            40380,
            42240,
            43440,
            44640,
            46440,
            48180,
            49320,
            51120,
            52920,
            54180,
            56040,
            57480,
            59040,
            61200,
            62280,
            64560,
            66900,
            69720,
            71820,
            74280,
            75360,
            76860,
            78720,
            79800,
            81180,
            82980,
            84900
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_17",
      "sourceRouteId": "vilnius_bus_17",
      "mode": "bus",
      "shortName": "17",
      "longName": "Antakalnis–Nemenčinės pl.–Antaviliai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_17:0",
          "sourceRouteId": "vilnius_bus_17",
          "sourceShapeId": "vilnius_bus_17_a-b",
          "directionId": 0,
          "headsign": "Antaviliai",
          "directionName": "Antakalnis–Nemenčinės pl.–Antaviliai",
          "mode": "bus",
          "routeShortName": "17",
          "routeLongName": "Antakalnis–Nemenčinės pl.–Antaviliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2562.319,
              -3823.788,
              0
            ],
            [
              2558.905,
              -3868.254,
              44.597
            ],
            [
              2551.422,
              -3889.265,
              66.901
            ],
            [
              2499.38,
              -3984.027,
              175.013
            ],
            [
              2491.567,
              -3988.334,
              183.935
            ],
            [
              2481.884,
              -3989.265,
              193.662
            ],
            [
              2463.931,
              -3984.475,
              212.243
            ],
            [
              2457.594,
              -3978.79,
              220.756
            ],
            [
              2451.32,
              -3969.766,
              231.747
            ],
            [
              2449.513,
              -3963.053,
              238.7
            ],
            [
              2474.189,
              -3849.964,
              354.449
            ],
            [
              2506.597,
              -3737.02,
              471.95
            ],
            [
              2515.783,
              -3728.287,
              484.625
            ],
            [
              2532.532,
              -3728.601,
              501.377
            ],
            [
              2540.76,
              -3736.549,
              512.816
            ],
            [
              2566.251,
              -3786.011,
              568.461
            ],
            [
              2598.162,
              -3836.707,
              628.365
            ],
            [
              2614.638,
              -3851.49,
              650.5
            ],
            [
              2636.723,
              -3876.397,
              683.789
            ],
            [
              2642.893,
              -3890.985,
              699.628
            ],
            [
              2709.56,
              -3977.961,
              809.215
            ],
            [
              3021.059,
              -4338.966,
              1286.034
            ],
            [
              3040.626,
              -4360.488,
              1315.121
            ],
            [
              3057.099,
              -4375.272,
              1337.255
            ],
            [
              3068.958,
              -4395.535,
              1360.733
            ],
            [
              3153.475,
              -4491.761,
              1488.806
            ],
            [
              3273.19,
              -4634.3,
              1674.949
            ],
            [
              3311.137,
              -4671.757,
              1728.269
            ],
            [
              3335.252,
              -4691.14,
              1759.208
            ],
            [
              3345.219,
              -4709.142,
              1779.784
            ],
            [
              3435.309,
              -4816.612,
              1920.02
            ],
            [
              3777.629,
              -5210.544,
              2441.907
            ],
            [
              4146.188,
              -5643.971,
              3010.848
            ],
            [
              4170.98,
              -5661.145,
              3041.008
            ],
            [
              4198.544,
              -5701.751,
              3090.086
            ],
            [
              4481.556,
              -6024.468,
              3519.32
            ],
            [
              4582.817,
              -6151.103,
              3681.463
            ],
            [
              4780.064,
              -6376.448,
              3980.94
            ],
            [
              4845.472,
              -6457.867,
              4085.378
            ],
            [
              4963.748,
              -6636.051,
              4299.244
            ],
            [
              4993.701,
              -6685.615,
              4357.156
            ],
            [
              5058.349,
              -6772.589,
              4465.525
            ],
            [
              5115.634,
              -6873.894,
              4581.904
            ],
            [
              5492.477,
              -7463.46,
              5281.617
            ],
            [
              5515.215,
              -7486.168,
              5313.753
            ],
            [
              5529.947,
              -7523.193,
              5353.602
            ],
            [
              5547.492,
              -7548.027,
              5384.008
            ],
            [
              5756.997,
              -7898.345,
              5792.193
            ],
            [
              5983.517,
              -8265.706,
              6223.778
            ],
            [
              6029.809,
              -8334.524,
              6306.716
            ],
            [
              6506.105,
              -9352.524,
              7430.63
            ],
            [
              6619.196,
              -9623.058,
              7723.85
            ],
            [
              6650.827,
              -9716.086,
              7822.109
            ],
            [
              6657.173,
              -9948.89,
              8054.999
            ],
            [
              6624.82,
              -10577.264,
              8684.206
            ],
            [
              6612.294,
              -10951.085,
              9058.237
            ],
            [
              6605.304,
              -11044.464,
              9151.877
            ],
            [
              6619.136,
              -11126.008,
              9234.585
            ],
            [
              6634.957,
              -11171.965,
              9283.19
            ],
            [
              6663.288,
              -11235.983,
              9353.196
            ],
            [
              6708.141,
              -11310.347,
              9440.04
            ],
            [
              6791.23,
              -11435.566,
              9590.318
            ],
            [
              6890.308,
              -11597.842,
              9780.45
            ],
            [
              7024.773,
              -11824.281,
              10043.804
            ],
            [
              7050.787,
              -11874.895,
              10100.712
            ],
            [
              7135.186,
              -11997.921,
              10249.905
            ],
            [
              7234.172,
              -12163.543,
              10442.853
            ],
            [
              7290.957,
              -12251.511,
              10547.556
            ],
            [
              7317.231,
              -12288.773,
              10593.15
            ],
            [
              7336.786,
              -12308.088,
              10620.636
            ],
            [
              7429.771,
              -12386.758,
              10742.437
            ],
            [
              7474.246,
              -12414.364,
              10794.782
            ],
            [
              7913.785,
              -12756.029,
              11351.495
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -780,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 683.789,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:3566",
              "position": {
                "x": 3057.099,
                "z": -4375.272
              },
              "distanceAlongShapeM": 1337.255,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6081",
              "position": {
                "x": 3335.252,
                "z": -4691.14
              },
              "distanceAlongShapeM": 1759.208,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:950",
              "position": {
                "x": 3777.629,
                "z": -5210.544
              },
              "distanceAlongShapeM": 2441.907,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6140",
              "position": {
                "x": 4170.98,
                "z": -5661.145
              },
              "distanceAlongShapeM": 3041.008,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6143",
              "position": {
                "x": 4481.556,
                "z": -6024.468
              },
              "distanceAlongShapeM": 3519.32,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6147",
              "position": {
                "x": 5058.349,
                "z": -6772.589
              },
              "distanceAlongShapeM": 4465.525,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6148",
              "position": {
                "x": 5515.215,
                "z": -7486.168
              },
              "distanceAlongShapeM": 5313.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6153",
              "position": {
                "x": 6029.809,
                "z": -8334.524
              },
              "distanceAlongShapeM": 6306.716,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6155",
              "position": {
                "x": 6506.105,
                "z": -9352.524
              },
              "distanceAlongShapeM": 7430.63,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:18878",
              "position": {
                "x": 6657.173,
                "z": -9948.89
              },
              "distanceAlongShapeM": 8054.999,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:18879",
              "position": {
                "x": 6624.82,
                "z": -10577.264
              },
              "distanceAlongShapeM": 8684.206,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6160",
              "position": {
                "x": 6612.294,
                "z": -10951.085
              },
              "distanceAlongShapeM": 9058.237,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:3610",
              "position": {
                "x": 7135.186,
                "z": -11997.921
              },
              "distanceAlongShapeM": 10249.905,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6163",
              "position": {
                "x": 7474.246,
                "z": -12414.364
              },
              "distanceAlongShapeM": 10794.782,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:18504",
              "position": {
                "x": 7913.785,
                "z": -12756.029
              },
              "distanceAlongShapeM": 11351.495,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            }
          ],
          "departuresSeconds": [
            18900,
            20400,
            23040,
            24420,
            27120,
            28560,
            31200,
            34800,
            37380,
            39300,
            41400,
            43320,
            45420,
            47340,
            49440,
            51360,
            53280,
            55020,
            57000,
            59040,
            60960,
            63000,
            65040,
            69000,
            71100,
            72960,
            74580,
            76380,
            78000,
            79800,
            81300,
            83220,
            84540
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_17:1",
          "sourceRouteId": "vilnius_bus_17",
          "sourceShapeId": "vilnius_bus_17_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Antaviliai–Nemenčinės pl.–Antakalnis",
          "mode": "bus",
          "routeShortName": "17",
          "routeLongName": "Antakalnis–Nemenčinės pl.–Antaviliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              7913.785,
              -12756.029,
              0
            ],
            [
              8103.75,
              -12904.57,
              241.146
            ],
            [
              8483.875,
              -13604.702,
              1037.813
            ],
            [
              8562.798,
              -13708.72,
              1168.384
            ],
            [
              8547.259,
              -13713.973,
              1184.786
            ],
            [
              8473.919,
              -13620.088,
              1303.922
            ],
            [
              8292.969,
              -13281.334,
              1687.975
            ],
            [
              8118.084,
              -12959.41,
              2054.335
            ],
            [
              8078.79,
              -12898.502,
              2126.818
            ],
            [
              8033.77,
              -12866.426,
              2182.096
            ],
            [
              7894.03,
              -12779.013,
              2346.925
            ],
            [
              7605.313,
              -12550.576,
              2715.083
            ],
            [
              7396.294,
              -12388.318,
              2979.69
            ],
            [
              7309.116,
              -12308.651,
              3097.786
            ],
            [
              7217.854,
              -12175.465,
              3259.24
            ],
            [
              7073.808,
              -11946.604,
              3529.659
            ],
            [
              7026.239,
              -11847.689,
              3639.418
            ],
            [
              6988.848,
              -11786.829,
              3710.846
            ],
            [
              6800.239,
              -11630.572,
              3955.774
            ],
            [
              6777.908,
              -11621.223,
              3979.983
            ],
            [
              6718.966,
              -11608.925,
              4040.194
            ],
            [
              6643.904,
              -11598.536,
              4115.972
            ],
            [
              6613.878,
              -11587.923,
              4147.819
            ],
            [
              6594.316,
              -11568.611,
              4175.307
            ],
            [
              6583.092,
              -11550.576,
              4196.549
            ],
            [
              6563.323,
              -11378.738,
              4369.521
            ],
            [
              6562.886,
              -11303.025,
              4445.235
            ],
            [
              6580.137,
              -11178.676,
              4570.775
            ],
            [
              6587.836,
              -11081.971,
              4667.786
            ],
            [
              6572.197,
              -11059.397,
              4695.249
            ],
            [
              6560.196,
              -11048.027,
              4711.78
            ],
            [
              6540.143,
              -11020.912,
              4745.504
            ],
            [
              6537.278,
              -11003.043,
              4763.602
            ],
            [
              6544.684,
              -10888.52,
              4878.365
            ],
            [
              6587.067,
              -10892.696,
              4920.953
            ],
            [
              6586.147,
              -10841.466,
              4972.191
            ],
            [
              6608.734,
              -10544.661,
              5269.854
            ],
            [
              6604.695,
              -10423.232,
              5391.35
            ],
            [
              6631.904,
              -9827.042,
              5988.161
            ],
            [
              6641.096,
              -9752.632,
              6063.136
            ],
            [
              6629.211,
              -9670.014,
              6146.605
            ],
            [
              6616.981,
              -9637.487,
              6181.355
            ],
            [
              6560.251,
              -9511.679,
              6319.362
            ],
            [
              6530.846,
              -9468.794,
              6371.359
            ],
            [
              6333.896,
              -9010.693,
              6870.003
            ],
            [
              6109.136,
              -8524.224,
              7405.885
            ],
            [
              6084.291,
              -8478.092,
              7458.282
            ],
            [
              5995.189,
              -8327.166,
              7633.547
            ],
            [
              5965.193,
              -8280.934,
              7688.658
            ],
            [
              5939.418,
              -8249.257,
              7729.496
            ],
            [
              5718.303,
              -7868.644,
              8169.676
            ],
            [
              5531.206,
              -7557.73,
              8532.543
            ],
            [
              5498.755,
              -7504.773,
              8594.652
            ],
            [
              5457.379,
              -7447.191,
              8665.558
            ],
            [
              5438.248,
              -7404.514,
              8712.327
            ],
            [
              5197.092,
              -7023.54,
              9163.212
            ],
            [
              5048.284,
              -6793.546,
              9437.148
            ],
            [
              5011.851,
              -6746.083,
              9496.982
            ],
            [
              5008.891,
              -6732.667,
              9510.721
            ],
            [
              4990.138,
              -6703.359,
              9545.515
            ],
            [
              4903.043,
              -6578.1,
              9698.077
            ],
            [
              4831.501,
              -6480.976,
              9818.707
            ],
            [
              4576.487,
              -6178.813,
              10214.098
            ],
            [
              4433.996,
              -6019.1,
              10428.135
            ],
            [
              4391.884,
              -5964.854,
              10496.809
            ],
            [
              4192.109,
              -5735.026,
              10801.327
            ],
            [
              4068.653,
              -5589.049,
              10992.509
            ],
            [
              4052.725,
              -5579.838,
              11010.908
            ],
            [
              4018.912,
              -5529.094,
              11071.886
            ],
            [
              3747.122,
              -5188.81,
              11507.389
            ],
            [
              3704.824,
              -5143.473,
              11569.394
            ],
            [
              3682.602,
              -5126.351,
              11597.446
            ],
            [
              3665.724,
              -5099.311,
              11629.322
            ],
            [
              3449.572,
              -4845.828,
              11962.452
            ],
            [
              3395.221,
              -4790.246,
              12040.191
            ],
            [
              3252.761,
              -4658.405,
              12234.296
            ],
            [
              3244.62,
              -4646.005,
              12249.13
            ],
            [
              3235.159,
              -4601.295,
              12294.83
            ],
            [
              3218.877,
              -4576.495,
              12324.497
            ],
            [
              3190.252,
              -4557.027,
              12359.114
            ],
            [
              3172.809,
              -4525.525,
              12395.123
            ],
            [
              3060.003,
              -4392.026,
              12569.9
            ],
            [
              3021.059,
              -4338.966,
              12635.718
            ],
            [
              2961.544,
              -4283.292,
              12717.215
            ],
            [
              2937.404,
              -4265.024,
              12747.488
            ],
            [
              2920.517,
              -4237.987,
              12779.365
            ],
            [
              2810.169,
              -4110.107,
              12948.273
            ],
            [
              2739.116,
              -4050.879,
              13040.774
            ],
            [
              2661.391,
              -4003.772,
              13131.661
            ],
            [
              2636.416,
              -3995.509,
              13157.967
            ],
            [
              2609.738,
              -3974.969,
              13191.636
            ],
            [
              2501.467,
              -3907.252,
              13319.34
            ],
            [
              2488.357,
              -3884.741,
              13345.39
            ],
            [
              2476.247,
              -3843.323,
              13388.542
            ],
            [
              2501.318,
              -3743.601,
              13491.368
            ],
            [
              2515.139,
              -3728.275,
              13512.005
            ],
            [
              2523.534,
              -3727.319,
              13520.454
            ],
            [
              2540.053,
              -3739.875,
              13541.203
            ],
            [
              2551,
              -3774.592,
              13577.605
            ],
            [
              2562.319,
              -3823.788,
              13628.086
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:18504",
              "position": {
                "x": 7913.785,
                "z": -12756.029
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:18564",
              "position": {
                "x": 7894.03,
                "z": -12779.013
              },
              "distanceAlongShapeM": 2346.925,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6164",
              "position": {
                "x": 7396.294,
                "z": -12388.318
              },
              "distanceAlongShapeM": 2979.69,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6162",
              "position": {
                "x": 7073.808,
                "z": -11946.604
              },
              "distanceAlongShapeM": 3529.659,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7936",
              "position": {
                "x": 6563.323,
                "z": -11378.738
              },
              "distanceAlongShapeM": 4369.521,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6159",
              "position": {
                "x": 6586.147,
                "z": -10841.466
              },
              "distanceAlongShapeM": 4972.191,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:18889",
              "position": {
                "x": 6604.695,
                "z": -10423.232
              },
              "distanceAlongShapeM": 5391.35,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:18892",
              "position": {
                "x": 6631.904,
                "z": -9827.042
              },
              "distanceAlongShapeM": 5988.161,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6154",
              "position": {
                "x": 6530.846,
                "z": -9468.794
              },
              "distanceAlongShapeM": 6371.359,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6152",
              "position": {
                "x": 5939.418,
                "z": -8249.257
              },
              "distanceAlongShapeM": 7729.496,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6149",
              "position": {
                "x": 5457.379,
                "z": -7447.191
              },
              "distanceAlongShapeM": 8665.558,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6146",
              "position": {
                "x": 5011.851,
                "z": -6746.083
              },
              "distanceAlongShapeM": 9496.982,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6144",
              "position": {
                "x": 4433.996,
                "z": -6019.1
              },
              "distanceAlongShapeM": 10428.135,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6142",
              "position": {
                "x": 4052.725,
                "z": -5579.838
              },
              "distanceAlongShapeM": 11010.908,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6141",
              "position": {
                "x": 3682.602,
                "z": -5126.351
              },
              "distanceAlongShapeM": 11597.446,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6079",
              "position": {
                "x": 3190.252,
                "z": -4557.027
              },
              "distanceAlongShapeM": 12359.114,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 12747.488,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 13157.967,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 13628.086,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            18120,
            20220,
            21720,
            24420,
            25800,
            28560,
            30060,
            32700,
            36300,
            38760,
            40680,
            42780,
            44700,
            46800,
            48720,
            50820,
            52740,
            54660,
            56400,
            58380,
            60420,
            62340,
            64380,
            66540,
            70380,
            72480,
            74280,
            75900,
            77700,
            79320,
            81120,
            82620,
            84540,
            85860
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_18",
      "sourceRouteId": "vilnius_bus_18",
      "mode": "bus",
      "shortName": "18",
      "longName": "Antakalnis–Dvarčionys–Parko g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_18:0",
          "sourceRouteId": "vilnius_bus_18",
          "sourceShapeId": "vilnius_bus_18_a-b",
          "directionId": 0,
          "headsign": "Parko g.",
          "directionName": "Antakalnis–Dvarčionys–Parko g.",
          "mode": "bus",
          "routeShortName": "18",
          "routeLongName": "Antakalnis–Dvarčionys–Parko g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2562.319,
              -3823.788,
              0
            ],
            [
              2558.905,
              -3868.254,
              44.597
            ],
            [
              2551.422,
              -3889.265,
              66.901
            ],
            [
              2499.38,
              -3984.027,
              175.013
            ],
            [
              2491.567,
              -3988.334,
              183.935
            ],
            [
              2481.884,
              -3989.265,
              193.662
            ],
            [
              2463.931,
              -3984.475,
              212.243
            ],
            [
              2457.594,
              -3978.79,
              220.756
            ],
            [
              2451.32,
              -3969.766,
              231.747
            ],
            [
              2449.513,
              -3963.053,
              238.7
            ],
            [
              2474.189,
              -3849.964,
              354.449
            ],
            [
              2506.597,
              -3737.02,
              471.95
            ],
            [
              2515.783,
              -3728.287,
              484.625
            ],
            [
              2532.532,
              -3728.601,
              501.377
            ],
            [
              2540.76,
              -3736.549,
              512.816
            ],
            [
              2566.251,
              -3786.011,
              568.461
            ],
            [
              2598.162,
              -3836.707,
              628.365
            ],
            [
              2614.638,
              -3851.49,
              650.5
            ],
            [
              2636.723,
              -3876.397,
              683.789
            ],
            [
              2642.893,
              -3890.985,
              699.628
            ],
            [
              2709.56,
              -3977.961,
              809.215
            ],
            [
              3021.059,
              -4338.966,
              1286.034
            ],
            [
              3086.352,
              -4293.444,
              1365.63
            ],
            [
              3111.27,
              -4270.537,
              1399.477
            ],
            [
              3142.482,
              -4255.542,
              1434.104
            ],
            [
              3336.938,
              -4126.748,
              1667.344
            ],
            [
              3389.682,
              -4097.691,
              1727.563
            ],
            [
              3402.776,
              -4086.807,
              1744.59
            ],
            [
              3446.229,
              -4072.046,
              1790.481
            ],
            [
              3528.69,
              -4039.102,
              1879.28
            ],
            [
              3592.048,
              -4028.061,
              1943.593
            ],
            [
              3640.634,
              -4014.513,
              1994.032
            ],
            [
              3666.294,
              -4020.567,
              2020.397
            ],
            [
              3848.026,
              -4019.578,
              2202.132
            ],
            [
              3878.881,
              -4023.507,
              2233.236
            ],
            [
              3901.964,
              -4029.514,
              2257.088
            ],
            [
              3958.181,
              -4055.079,
              2318.845
            ],
            [
              3967.843,
              -4055.264,
              2328.508
            ],
            [
              4004.416,
              -4097.154,
              2384.117
            ],
            [
              4018.762,
              -4121.92,
              2412.739
            ],
            [
              4037.773,
              -4172.381,
              2466.661
            ],
            [
              4076.734,
              -4257.734,
              2560.487
            ],
            [
              4093.076,
              -4279.199,
              2587.465
            ],
            [
              4128.571,
              -4309.937,
              2634.419
            ],
            [
              4222.379,
              -4357.378,
              2739.541
            ],
            [
              4258.043,
              -4379.213,
              2781.358
            ],
            [
              4380.127,
              -4463.938,
              2929.961
            ],
            [
              4412.655,
              -4481.261,
              2966.814
            ],
            [
              4437.325,
              -4505.114,
              3001.129
            ],
            [
              4501.026,
              -4543.076,
              3075.285
            ],
            [
              4784.007,
              -4703.272,
              3400.463
            ],
            [
              4912.858,
              -4770.329,
              3545.718
            ],
            [
              4956.995,
              -4786.768,
              3592.818
            ],
            [
              4975.65,
              -4788.242,
              3611.531
            ],
            [
              5002.978,
              -4807.696,
              3645.076
            ],
            [
              5509.413,
              -5004.55,
              4188.425
            ],
            [
              5765.06,
              -5109.726,
              4464.862
            ],
            [
              5806.767,
              -5118.333,
              4507.448
            ],
            [
              5878.72,
              -5128.645,
              4580.136
            ],
            [
              5891.491,
              -5134.461,
              4594.168
            ],
            [
              5956.294,
              -5147.973,
              4660.365
            ],
            [
              5988.132,
              -5134.123,
              4695.086
            ],
            [
              5996.656,
              -5126.497,
              4706.523
            ],
            [
              6011.57,
              -4989.855,
              4843.977
            ],
            [
              6021.457,
              -4945.517,
              4889.404
            ],
            [
              6027.558,
              -4930.051,
              4906.03
            ],
            [
              6092.568,
              -4834.468,
              5021.626
            ],
            [
              6127.551,
              -4791.735,
              5076.852
            ],
            [
              6152.504,
              -4767.731,
              5111.476
            ],
            [
              6159.829,
              -4755.629,
              5125.622
            ],
            [
              6161.4,
              -4741.187,
              5140.15
            ],
            [
              6125.058,
              -4655.865,
              5232.888
            ],
            [
              6001.369,
              -4687.956,
              5360.673
            ],
            [
              5943.166,
              -4699.064,
              5419.927
            ],
            [
              5886.829,
              -4713.549,
              5478.096
            ],
            [
              5851.081,
              -4729.55,
              5517.262
            ],
            [
              5840.819,
              -4727.123,
              5527.806
            ],
            [
              5838.439,
              -4717.057,
              5538.15
            ],
            [
              5840.414,
              -4714.869,
              5541.098
            ],
            [
              5874.614,
              -4712.197,
              5575.402
            ],
            [
              5916.029,
              -4702.987,
              5617.828
            ],
            [
              6087.551,
              -4662.924,
              5793.967
            ],
            [
              6114.775,
              -4654.551,
              5822.45
            ],
            [
              6125.058,
              -4655.865,
              5832.817
            ],
            [
              6139.053,
              -4665.046,
              5849.554
            ],
            [
              6147.186,
              -4677.451,
              5864.388
            ],
            [
              6159.97,
              -4715.553,
              5904.577
            ],
            [
              6163.114,
              -4752.353,
              5941.511
            ],
            [
              6148.487,
              -4775.446,
              5968.846
            ],
            [
              6122.934,
              -4797.211,
              6002.412
            ],
            [
              6095.897,
              -4828.966,
              6044.119
            ],
            [
              6024.895,
              -4934.452,
              6171.274
            ],
            [
              6018.15,
              -4949.906,
              6188.136
            ],
            [
              6009.703,
              -4986.479,
              6225.672
            ],
            [
              6002.309,
              -5101.002,
              6340.434
            ],
            [
              6002.517,
              -5123.272,
              6362.704
            ],
            [
              6008.718,
              -5135.639,
              6376.539
            ],
            [
              6016.589,
              -5161.399,
              6403.474
            ],
            [
              6030.604,
              -5169.466,
              6419.645
            ],
            [
              6078.772,
              -5177.089,
              6468.413
            ],
            [
              6272.282,
              -5197.581,
              6663.005
            ],
            [
              6739.794,
              -5240.179,
              7132.454
            ],
            [
              6910.827,
              -5256.916,
              7304.303
            ],
            [
              7009.8,
              -5268.893,
              7403.998
            ],
            [
              7693.739,
              -5409.394,
              8102.22
            ],
            [
              7726.958,
              -5423.416,
              8138.277
            ],
            [
              7856.678,
              -5508.39,
              8293.351
            ],
            [
              7915.742,
              -5518.477,
              8353.27
            ],
            [
              7983.422,
              -5516.49,
              8420.979
            ],
            [
              8001.075,
              -5503.484,
              8442.906
            ],
            [
              8143.655,
              -5460.694,
              8591.769
            ],
            [
              8219.756,
              -5424.367,
              8676.095
            ],
            [
              8440.114,
              -5166.053,
              9015.63
            ],
            [
              8475.919,
              -5115.561,
              9077.528
            ],
            [
              8541.174,
              -5042.283,
              9175.65
            ],
            [
              8551.775,
              -4867.708,
              9350.547
            ],
            [
              8545.916,
              -4710.614,
              9507.75
            ],
            [
              8534.844,
              -4652.5,
              9566.909
            ],
            [
              8537.072,
              -4605.786,
              9613.676
            ],
            [
              8534.412,
              -4577.9,
              9641.689
            ],
            [
              8538.438,
              -4537.902,
              9681.889
            ],
            [
              8566.956,
              -4401.54,
              9821.201
            ],
            [
              8572.237,
              -4299.223,
              9923.655
            ],
            [
              8555.68,
              -4225.412,
              9999.3
            ],
            [
              8549.648,
              -4172.965,
              10052.092
            ],
            [
              8486.05,
              -4067.036,
              10175.647
            ],
            [
              8472.64,
              -4028.914,
              10216.058
            ],
            [
              8480.952,
              -3839.82,
              10405.335
            ],
            [
              8535.854,
              -3609.358,
              10642.246
            ],
            [
              8560.053,
              -3559.747,
              10697.445
            ],
            [
              8586.431,
              -3497.933,
              10764.652
            ],
            [
              8605.259,
              -3427.06,
              10837.982
            ],
            [
              8611.532,
              -3243.492,
              11021.658
            ],
            [
              8606.733,
              -2969.524,
              11295.668
            ],
            [
              8614.689,
              -2958.552,
              11309.221
            ],
            [
              8615.893,
              -2930.743,
              11337.055
            ],
            [
              8624.784,
              -2905.316,
              11363.992
            ],
            [
              8640.718,
              -2882.258,
              11392.02
            ],
            [
              8690.941,
              -2820.925,
              11471.293
            ],
            [
              8823.576,
              -2636.564,
              11698.407
            ],
            [
              8863.989,
              -2550.542,
              11793.449
            ],
            [
              8918.227,
              -2450.327,
              11907.4
            ],
            [
              8924.565,
              -2423.735,
              11934.736
            ],
            [
              8946.946,
              -2400.808,
              11966.776
            ],
            [
              8961.152,
              -2367.696,
              12002.807
            ],
            [
              8970.878,
              -2301.095,
              12070.115
            ],
            [
              8975.292,
              -2242.179,
              12129.196
            ],
            [
              8994.31,
              -2162.405,
              12211.205
            ],
            [
              8996.625,
              -2143.526,
              12230.226
            ],
            [
              8995.741,
              -2123.469,
              12250.302
            ],
            [
              8798.868,
              -1847.85,
              12589.012
            ],
            [
              8741.282,
              -1762.079,
              12692.322
            ],
            [
              8705.113,
              -1701.233,
              12763.107
            ],
            [
              8683.694,
              -1676.309,
              12795.97
            ],
            [
              8633.675,
              -1630.77,
              12863.613
            ],
            [
              8602.364,
              -1616.781,
              12897.908
            ],
            [
              8579.919,
              -1610.763,
              12921.146
            ],
            [
              8461.891,
              -1580.558,
              13042.977
            ],
            [
              8394.509,
              -1564.732,
              13112.192
            ],
            [
              8379.708,
              -1563.322,
              13127.06
            ],
            [
              8345.129,
              -1551.495,
              13163.606
            ],
            [
              8247.522,
              -1531.726,
              13263.195
            ],
            [
              8124.401,
              -1498.088,
              13390.829
            ],
            [
              8094.331,
              -1486.354,
              13423.106
            ],
            [
              8060.506,
              -1468.978,
              13461.134
            ],
            [
              8032.526,
              -1449.493,
              13495.23
            ],
            [
              8003.39,
              -1423.305,
              13534.406
            ],
            [
              7918.757,
              -1334.778,
              13656.879
            ],
            [
              7869.616,
              -1277.019,
              13732.714
            ],
            [
              7850.146,
              -1251.025,
              13765.191
            ],
            [
              7830.876,
              -1215.015,
              13806.033
            ],
            [
              7804.558,
              -1144.353,
              13881.436
            ],
            [
              7791.221,
              -1101.783,
              13926.048
            ],
            [
              7778.817,
              -1077.043,
              13953.722
            ],
            [
              7761.946,
              -1049.988,
              13985.607
            ],
            [
              7720.825,
              -1010.204,
              14042.823
            ],
            [
              7689.684,
              -987.318,
              14081.47
            ],
            [
              7657.987,
              -959.968,
              14123.335
            ],
            [
              7648.028,
              -941.957,
              14143.916
            ],
            [
              7642.025,
              -919.572,
              14167.092
            ],
            [
              7643.176,
              -861.704,
              14224.972
            ],
            [
              7639.707,
              -841.596,
              14245.377
            ],
            [
              7644.596,
              -822.767,
              14264.83
            ],
            [
              7675.302,
              -640.799,
              14449.371
            ],
            [
              7843.017,
              -670.859,
              14619.759
            ],
            [
              7941.422,
              -683.956,
              14719.031
            ],
            [
              7983.745,
              -695.934,
              14763.017
            ],
            [
              8105.956,
              -711.736,
              14886.245
            ],
            [
              8174.886,
              -715.341,
              14955.269
            ],
            [
              8196.247,
              -711.316,
              14977.006
            ],
            [
              8219.654,
              -701.765,
              15002.287
            ],
            [
              8291.234,
              -637.515,
              15098.473
            ],
            [
              8322.689,
              -612.539,
              15138.637
            ],
            [
              8367.171,
              -581.146,
              15193.082
            ],
            [
              8434.632,
              -625.918,
              15274.048
            ],
            [
              8481.22,
              -650.233,
              15326.6
            ],
            [
              8531.721,
              -672.4,
              15381.751
            ],
            [
              8539.64,
              -631.367,
              15423.541
            ],
            [
              8559.188,
              -557.169,
              15500.271
            ],
            [
              8576.654,
              -426.152,
              15632.447
            ],
            [
              8584.228,
              -306.068,
              15752.769
            ],
            [
              8588.332,
              -198.161,
              15860.754
            ],
            [
              8595.54,
              -160.454,
              15899.144
            ],
            [
              8696.05,
              -133.53,
              16003.198
            ],
            [
              8718.239,
              -120.617,
              16028.871
            ],
            [
              8744.049,
              -120.024,
              16054.688
            ],
            [
              8789.403,
              -109.804,
              16101.179
            ],
            [
              8826.443,
              -96.078,
              16140.68
            ],
            [
              8853.145,
              -83.257,
              16170.301
            ],
            [
              8900.484,
              -38.566,
              16235.403
            ],
            [
              8997.947,
              60.777,
              16374.572
            ],
            [
              9045.087,
              95.45,
              16433.09
            ],
            [
              9064.009,
              106.201,
              16454.853
            ],
            [
              9090.691,
              117.908,
              16483.99
            ],
            [
              9116.151,
              132.979,
              16513.577
            ],
            [
              9141.918,
              131.345,
              16539.396
            ],
            [
              9732.975,
              142.732,
              17130.563
            ],
            [
              9774.103,
              135.215,
              17172.372
            ],
            [
              9799.87,
              133.577,
              17198.191
            ],
            [
              9819.925,
              136.508,
              17218.459
            ],
            [
              9849.832,
              148.145,
              17250.55
            ],
            [
              9862.037,
              145.67,
              17263.004
            ],
            [
              9870.147,
              132.145,
              17278.774
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 683.789,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 1399.477,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 1744.59,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 1994.032,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 2328.508,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6170",
              "position": {
                "x": 4412.655,
                "z": -4481.261
              },
              "distanceAlongShapeM": 2966.814,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6174",
              "position": {
                "x": 4975.65,
                "z": -4788.242
              },
              "distanceAlongShapeM": 3611.531,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6176",
              "position": {
                "x": 5878.72,
                "z": -5128.645
              },
              "distanceAlongShapeM": 4580.136,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6179",
              "position": {
                "x": 6139.84,
                "z": -4690.667
              },
              "distanceAlongShapeM": 5195.078,
              "shapeOffsetM": 0.038,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6181",
              "position": {
                "x": 5860.806,
                "z": -4726.4
              },
              "distanceAlongShapeM": 5507.098,
              "shapeOffsetM": 1.098,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8250",
              "position": {
                "x": 6147.186,
                "z": -4677.451
              },
              "distanceAlongShapeM": 5864.388,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6183",
              "position": {
                "x": 7009.8,
                "z": -5268.893
              },
              "distanceAlongShapeM": 7403.998,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:16305",
              "position": {
                "x": 8001.075,
                "z": -5503.484
              },
              "distanceAlongShapeM": 8442.906,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6189",
              "position": {
                "x": 8475.919,
                "z": -5115.561
              },
              "distanceAlongShapeM": 9077.528,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6191",
              "position": {
                "x": 8534.844,
                "z": -4652.5
              },
              "distanceAlongShapeM": 9566.909,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6192",
              "position": {
                "x": 8555.68,
                "z": -4225.412
              },
              "distanceAlongShapeM": 9999.3,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6195",
              "position": {
                "x": 8535.854,
                "z": -3609.358
              },
              "distanceAlongShapeM": 10642.246,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6199",
              "position": {
                "x": 8606.733,
                "z": -2969.524
              },
              "distanceAlongShapeM": 11295.668,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6204",
              "position": {
                "x": 8924.565,
                "z": -2423.735
              },
              "distanceAlongShapeM": 11934.736,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6207",
              "position": {
                "x": 8741.282,
                "z": -1762.079
              },
              "distanceAlongShapeM": 12692.322,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6211",
              "position": {
                "x": 8379.708,
                "z": -1563.322
              },
              "distanceAlongShapeM": 13127.06,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6217",
              "position": {
                "x": 7918.757,
                "z": -1334.778
              },
              "distanceAlongShapeM": 13656.879,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5394",
              "position": {
                "x": 7639.707,
                "z": -841.596
              },
              "distanceAlongShapeM": 14245.377,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5396",
              "position": {
                "x": 7941.422,
                "z": -683.956
              },
              "distanceAlongShapeM": 14719.031,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6225",
              "position": {
                "x": 8539.64,
                "z": -631.367
              },
              "distanceAlongShapeM": 15423.541,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 16028.871,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 16513.577,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 16950.475,
              "shapeOffsetM": 0.663,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:7444",
              "position": {
                "x": 9732.975,
                "z": 142.732
              },
              "distanceAlongShapeM": 17130.563,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            17400,
            19980,
            21300,
            22680,
            24120,
            25020,
            26460,
            28020,
            30540,
            31860,
            33720,
            35520,
            36720,
            38280,
            40320,
            41820,
            43380,
            45540,
            46620,
            48360,
            50220,
            51900,
            53520,
            55080,
            56640,
            58680,
            59700,
            60720,
            62220,
            64140,
            66180,
            67740,
            69660,
            70800,
            72720,
            74400,
            76140,
            77820,
            79320,
            80820,
            82260,
            83940
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_18:1",
          "sourceRouteId": "vilnius_bus_18",
          "sourceShapeId": "vilnius_bus_18_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Parko g.–Dvarčionys–Antakalnis",
          "mode": "bus",
          "routeShortName": "18",
          "routeLongName": "Antakalnis–Dvarčionys–Parko g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9870.147,
              132.145,
              0
            ],
            [
              9862.137,
              118.949,
              15.437
            ],
            [
              9810.14,
              131.141,
              68.844
            ],
            [
              9748.867,
              131.276,
              130.117
            ],
            [
              9682.346,
              127.063,
              196.772
            ],
            [
              9621.808,
              131.634,
              257.482
            ],
            [
              9517.36,
              133.756,
              361.952
            ],
            [
              9448.882,
              128.466,
              430.634
            ],
            [
              9389.611,
              131.895,
              490.004
            ],
            [
              9156.08,
              129.945,
              723.543
            ],
            [
              9090.691,
              117.908,
              790.031
            ],
            [
              9073.545,
              99.328,
              815.313
            ],
            [
              9049.578,
              94.246,
              839.813
            ],
            [
              8990.008,
              50.917,
              913.474
            ],
            [
              8869.532,
              -70.228,
              1084.327
            ],
            [
              8853.145,
              -83.257,
              1105.262
            ],
            [
              8819.883,
              -101.512,
              1143.204
            ],
            [
              8767.948,
              -118.279,
              1197.778
            ],
            [
              8695.316,
              -137.969,
              1273.032
            ],
            [
              8673.105,
              -151.995,
              1299.301
            ],
            [
              8624.063,
              -153.235,
              1348.359
            ],
            [
              8595.54,
              -160.454,
              1377.782
            ],
            [
              8590.933,
              -197.1,
              1414.716
            ],
            [
              8584.694,
              -314.984,
              1532.765
            ],
            [
              8567.281,
              -539.519,
              1757.974
            ],
            [
              8554.112,
              -617.185,
              1836.749
            ],
            [
              8531.721,
              -672.4,
              1896.331
            ],
            [
              8486.109,
              -663.69,
              1942.767
            ],
            [
              8367.171,
              -581.146,
              2087.542
            ],
            [
              8316.776,
              -617.987,
              2149.968
            ],
            [
              8223.611,
              -697.391,
              2272.379
            ],
            [
              8208.584,
              -707.11,
              2290.275
            ],
            [
              8186.511,
              -714.461,
              2313.54
            ],
            [
              8174.886,
              -715.341,
              2325.199
            ],
            [
              8111.113,
              -711.839,
              2389.067
            ],
            [
              7990.769,
              -699.414,
              2510.051
            ],
            [
              7876.316,
              -682.656,
              2625.725
            ],
            [
              7825.635,
              -669.399,
              2678.111
            ],
            [
              7675.302,
              -640.799,
              2831.14
            ],
            [
              7649.128,
              -789.458,
              2982.086
            ],
            [
              7642.645,
              -888.412,
              3081.252
            ],
            [
              7646.227,
              -935.241,
              3128.218
            ],
            [
              7655.475,
              -956.578,
              3151.473
            ],
            [
              7745.609,
              -1028.51,
              3266.791
            ],
            [
              7766.347,
              -1055.642,
              3300.942
            ],
            [
              7788.775,
              -1095.054,
              3346.288
            ],
            [
              7822.274,
              -1193.691,
              3450.459
            ],
            [
              7847.723,
              -1243.184,
              3506.111
            ],
            [
              7892.309,
              -1303.078,
              3580.778
            ],
            [
              7925.18,
              -1336.019,
              3627.315
            ],
            [
              7938.338,
              -1355.208,
              3650.581
            ],
            [
              7958.585,
              -1374.538,
              3678.574
            ],
            [
              7965.008,
              -1375.78,
              3685.116
            ],
            [
              7988.855,
              -1408.541,
              3725.638
            ],
            [
              8028.081,
              -1446.064,
              3779.921
            ],
            [
              8052.217,
              -1464.359,
              3810.206
            ],
            [
              8094.331,
              -1486.354,
              3857.719
            ],
            [
              8131.468,
              -1499.343,
              3897.061
            ],
            [
              8200.096,
              -1517.416,
              3968.029
            ],
            [
              8364.374,
              -1556.335,
              4136.855
            ],
            [
              8442.69,
              -1573.493,
              4217.028
            ],
            [
              8478.693,
              -1578.669,
              4253.401
            ],
            [
              8608.742,
              -1620.249,
              4389.935
            ],
            [
              8633.675,
              -1630.77,
              4416.998
            ],
            [
              8678.185,
              -1661.725,
              4471.213
            ],
            [
              8799.205,
              -1831.158,
              4679.428
            ],
            [
              8995.741,
              -2123.469,
              5031.667
            ],
            [
              8999.046,
              -2151.368,
              5059.761
            ],
            [
              8982.006,
              -2228.955,
              5139.197
            ],
            [
              8966.263,
              -2370.026,
              5281.144
            ],
            [
              8935.452,
              -2427.295,
              5346.175
            ],
            [
              8918.227,
              -2450.327,
              5374.935
            ],
            [
              8906.8,
              -2473.475,
              5400.75
            ],
            [
              8900.529,
              -2496.728,
              5424.834
            ],
            [
              8887.417,
              -2507.596,
              5441.864
            ],
            [
              8823.576,
              -2636.564,
              5585.768
            ],
            [
              8690.941,
              -2820.925,
              5812.883
            ],
            [
              8633.407,
              -2893.244,
              5905.296
            ],
            [
              8622.762,
              -2909.729,
              5924.92
            ],
            [
              8618.583,
              -2925.231,
              5940.975
            ],
            [
              8615.452,
              -3048.744,
              6064.528
            ],
            [
              8617.491,
              -3075.504,
              6091.366
            ],
            [
              8611.683,
              -3267.988,
              6283.937
            ],
            [
              8608.334,
              -3370.344,
              6386.348
            ],
            [
              8602.547,
              -3433.686,
              6449.953
            ],
            [
              8586.431,
              -3497.933,
              6516.191
            ],
            [
              8484.75,
              -3843.237,
              6876.155
            ],
            [
              8475.158,
              -3967.733,
              7001.02
            ],
            [
              8474.751,
              -4020.05,
              7053.339
            ],
            [
              8477.967,
              -4052.401,
              7085.848
            ],
            [
              8526.066,
              -4127.959,
              7175.417
            ],
            [
              8544.03,
              -4163.946,
              7215.639
            ],
            [
              8562.788,
              -4224.442,
              7278.976
            ],
            [
              8572.237,
              -4299.223,
              7354.352
            ],
            [
              8567.931,
              -4417.146,
              7472.354
            ],
            [
              8549.286,
              -4479.116,
              7537.067
            ],
            [
              8536.971,
              -4546.779,
              7605.842
            ],
            [
              8537.072,
              -4605.786,
              7664.849
            ],
            [
              8547.759,
              -4715.105,
              7774.689
            ],
            [
              8560.209,
              -4768.794,
              7829.803
            ],
            [
              8548.398,
              -5003.463,
              8064.769
            ],
            [
              8536.644,
              -5043.305,
              8106.309
            ],
            [
              8512.077,
              -5079.55,
              8150.094
            ],
            [
              8440.114,
              -5166.053,
              8262.618
            ],
            [
              8428.495,
              -5199.218,
              8297.76
            ],
            [
              8404.999,
              -5214.332,
              8325.697
            ],
            [
              8363.31,
              -5269.16,
              8394.574
            ],
            [
              8266.302,
              -5384.109,
              8544.986
            ],
            [
              8233.435,
              -5416.848,
              8591.377
            ],
            [
              8203.434,
              -5435.173,
              8626.532
            ],
            [
              8147.519,
              -5460.771,
              8688.028
            ],
            [
              7983.422,
              -5516.49,
              8861.327
            ],
            [
              7926.711,
              -5517.583,
              8918.048
            ],
            [
              7891.85,
              -5521.339,
              8953.111
            ],
            [
              7841.268,
              -5505.855,
              9006.009
            ],
            [
              7702.11,
              -5409.561,
              9175.235
            ],
            [
              7048.217,
              -5280.786,
              9841.688
            ],
            [
              6784.784,
              -5245.52,
              10107.471
            ],
            [
              6076.818,
              -5178.164,
              10818.634
            ],
            [
              6011.263,
              -5170.201,
              10884.672
            ],
            [
              5986.3,
              -5161.92,
              10910.972
            ],
            [
              5981.213,
              -5158.48,
              10917.112
            ],
            [
              5980.83,
              -5145.113,
              10930.485
            ],
            [
              5992.039,
              -5131.973,
              10947.756
            ],
            [
              5997.387,
              -5122.058,
              10959.022
            ],
            [
              6009.977,
              -5005.41,
              11076.347
            ],
            [
              6011.962,
              -4969.824,
              11111.989
            ],
            [
              6022.232,
              -4938.853,
              11144.618
            ],
            [
              6026.936,
              -4928.925,
              11155.604
            ],
            [
              6101.223,
              -4820.164,
              11287.314
            ],
            [
              6130.193,
              -4788.447,
              11330.27
            ],
            [
              6148.553,
              -4772.107,
              11354.848
            ],
            [
              6156.478,
              -4762.243,
              11367.501
            ],
            [
              6161.248,
              -4748.977,
              11381.599
            ],
            [
              6159.686,
              -4730.021,
              11400.619
            ],
            [
              6139.84,
              -4690.667,
              11444.694
            ],
            [
              6125.058,
              -4655.865,
              11482.505
            ],
            [
              6001.369,
              -4687.956,
              11610.289
            ],
            [
              5943.166,
              -4699.064,
              11669.543
            ],
            [
              5886.829,
              -4713.549,
              11727.712
            ],
            [
              5851.081,
              -4729.55,
              11766.878
            ],
            [
              5840.819,
              -4727.123,
              11777.422
            ],
            [
              5838.439,
              -4717.057,
              11787.766
            ],
            [
              5840.414,
              -4714.869,
              11790.714
            ],
            [
              5874.614,
              -4712.197,
              11825.018
            ],
            [
              5916.029,
              -4702.987,
              11867.444
            ],
            [
              6087.551,
              -4662.924,
              12043.583
            ],
            [
              6114.775,
              -4654.551,
              12072.066
            ],
            [
              6125.058,
              -4655.865,
              12082.433
            ],
            [
              6139.053,
              -4665.046,
              12099.17
            ],
            [
              6147.186,
              -4677.451,
              12114.004
            ],
            [
              6161.171,
              -4720.03,
              12158.82
            ],
            [
              6163.78,
              -4751.253,
              12190.152
            ],
            [
              6151.795,
              -4771.057,
              12213.301
            ],
            [
              6112.346,
              -4811.476,
              12269.78
            ],
            [
              6090.548,
              -4838.881,
              12304.797
            ],
            [
              6026.248,
              -4931.138,
              12417.251
            ],
            [
              6016.775,
              -4954.332,
              12442.304
            ],
            [
              6009.203,
              -5012.074,
              12500.541
            ],
            [
              6000.05,
              -5117.657,
              12606.52
            ],
            [
              6010.006,
              -5135.665,
              12627.096
            ],
            [
              6013.543,
              -5152.433,
              12644.234
            ],
            [
              6017.855,
              -5162.537,
              12655.219
            ],
            [
              6016.502,
              -5165.85,
              12658.798
            ],
            [
              5956.294,
              -5147.973,
              12721.604
            ],
            [
              5813.742,
              -5124.036,
              12866.151
            ],
            [
              5758.62,
              -5109.601,
              12923.132
            ],
            [
              5655.118,
              -5065.278,
              13035.726
            ],
            [
              5349.449,
              -4948.004,
              13363.119
            ],
            [
              5090.521,
              -4845.015,
              13641.778
            ],
            [
              4956.995,
              -4786.768,
              13787.455
            ],
            [
              4921.724,
              -4778.293,
              13823.73
            ],
            [
              4893.064,
              -4761.041,
              13857.182
            ],
            [
              4762.926,
              -4693.959,
              14003.592
            ],
            [
              4470.367,
              -4529.128,
              14339.389
            ],
            [
              4430.884,
              -4504.99,
              14385.666
            ],
            [
              4360.976,
              -4454.664,
              14471.805
            ],
            [
              4344.358,
              -4447.665,
              14489.837
            ],
            [
              4316.488,
              -4422.639,
              14527.294
            ],
            [
              4266.267,
              -4387.164,
              14588.781
            ],
            [
              4203.85,
              -4349.23,
              14661.821
            ],
            [
              4164.858,
              -4332.897,
              14704.095
            ],
            [
              4107.571,
              -4296.175,
              14772.141
            ],
            [
              4086.034,
              -4276.838,
              14801.086
            ],
            [
              4071.539,
              -4259.861,
              14823.409
            ],
            [
              4054.871,
              -4221.691,
              14865.059
            ],
            [
              4018.762,
              -4121.92,
              14971.164
            ],
            [
              3999.262,
              -4097.055,
              15002.763
            ],
            [
              3970.079,
              -4073.119,
              15040.507
            ],
            [
              3943.967,
              -4057.034,
              15071.175
            ],
            [
              3898.552,
              -4039.468,
              15119.869
            ],
            [
              3898.616,
              -4036.13,
              15123.208
            ],
            [
              3858.828,
              -4027.577,
              15163.905
            ],
            [
              3592.048,
              -4028.061,
              15430.686
            ],
            [
              3581.678,
              -4031.203,
              15441.521
            ],
            [
              3565.986,
              -4043.151,
              15461.244
            ],
            [
              3520.083,
              -4051.184,
              15507.844
            ],
            [
              3445.458,
              -4078.711,
              15587.385
            ],
            [
              3358.965,
              -4120.486,
              15683.438
            ],
            [
              3360.169,
              -4124.962,
              15688.073
            ],
            [
              3310.064,
              -4150.73,
              15744.415
            ],
            [
              3021.059,
              -4338.966,
              16089.317
            ],
            [
              2959.695,
              -4278.804,
              16175.252
            ],
            [
              2937.404,
              -4265.024,
              16201.459
            ],
            [
              2920.517,
              -4237.987,
              16233.336
            ],
            [
              2810.169,
              -4110.107,
              16402.245
            ],
            [
              2739.116,
              -4050.879,
              16494.746
            ],
            [
              2661.391,
              -4003.772,
              16585.632
            ],
            [
              2636.416,
              -3995.509,
              16611.939
            ],
            [
              2609.738,
              -3974.969,
              16645.607
            ],
            [
              2501.467,
              -3907.252,
              16773.312
            ],
            [
              2488.357,
              -3884.741,
              16799.362
            ],
            [
              2476.247,
              -3843.323,
              16842.514
            ],
            [
              2501.318,
              -3743.601,
              16945.339
            ],
            [
              2515.139,
              -3728.275,
              16965.976
            ],
            [
              2523.534,
              -3727.319,
              16974.426
            ],
            [
              2540.053,
              -3739.875,
              16995.175
            ],
            [
              2551,
              -3774.592,
              17031.577
            ],
            [
              2562.319,
              -3823.788,
              17082.058
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 196.772,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 430.634,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 815.313,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 1299.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5400",
              "position": {
                "x": 8486.109,
                "z": -663.69
              },
              "distanceAlongShapeM": 1942.767,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5415",
              "position": {
                "x": 7876.316,
                "z": -682.656
              },
              "distanceAlongShapeM": 2625.725,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6230",
              "position": {
                "x": 7745.609,
                "z": -1028.51
              },
              "distanceAlongShapeM": 3266.791,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6215",
              "position": {
                "x": 7965.008,
                "z": -1375.78
              },
              "distanceAlongShapeM": 3685.116,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6212",
              "position": {
                "x": 8478.693,
                "z": -1578.669
              },
              "distanceAlongShapeM": 4253.401,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6208",
              "position": {
                "x": 8678.185,
                "z": -1661.725
              },
              "distanceAlongShapeM": 4471.213,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6203",
              "position": {
                "x": 8900.529,
                "z": -2496.728
              },
              "distanceAlongShapeM": 5424.834,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6198",
              "position": {
                "x": 8617.491,
                "z": -3075.504
              },
              "distanceAlongShapeM": 6091.366,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:456",
              "position": {
                "x": 8522.753,
                "z": -3715.971
              },
              "distanceAlongShapeM": 6743.337,
              "shapeOffsetM": 0.506,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6193",
              "position": {
                "x": 8562.788,
                "z": -4224.442
              },
              "distanceAlongShapeM": 7278.976,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6190",
              "position": {
                "x": 8560.209,
                "z": -4768.794
              },
              "distanceAlongShapeM": 7829.803,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6188",
              "position": {
                "x": 8428.495,
                "z": -5199.218
              },
              "distanceAlongShapeM": 8297.76,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:16306",
              "position": {
                "x": 7891.85,
                "z": -5521.339
              },
              "distanceAlongShapeM": 8953.111,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6184",
              "position": {
                "x": 6930.636,
                "z": -5265.1
              },
              "distanceAlongShapeM": 9960.311,
              "shapeOffsetM": 0.055,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6179",
              "position": {
                "x": 6139.84,
                "z": -4690.667
              },
              "distanceAlongShapeM": 11444.694,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:429",
              "position": {
                "x": 5873.348,
                "z": -4711.059
              },
              "distanceAlongShapeM": 11823.844,
              "shapeOffsetM": 1.233,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6180",
              "position": {
                "x": 6155.144,
                "z": -4698.76
              },
              "distanceAlongShapeM": 12136.732,
              "shapeOffsetM": 0.912,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6177",
              "position": {
                "x": 5813.742,
                "z": -5124.036
              },
              "distanceAlongShapeM": 12866.151,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6173",
              "position": {
                "x": 4921.724,
                "z": -4778.293
              },
              "distanceAlongShapeM": 13823.73,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6171",
              "position": {
                "x": 4344.358,
                "z": -4447.665
              },
              "distanceAlongShapeM": 14489.837,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 15119.869,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 15461.244,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 15688.073,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 16201.459,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 16611.939,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 17082.058,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            19500,
            21060,
            23160,
            24720,
            25980,
            27360,
            28380,
            29700,
            31260,
            33960,
            35160,
            36960,
            38700,
            40260,
            41760,
            43380,
            44880,
            46500,
            48660,
            50040,
            51420,
            53400,
            55500,
            57000,
            58800,
            60480,
            61860,
            63000,
            64200,
            65460,
            67320,
            69420,
            71040,
            72780,
            74340,
            76080,
            77700,
            79320,
            81120,
            82500,
            83880,
            85140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_19",
      "sourceRouteId": "vilnius_bus_19",
      "mode": "bus",
      "shortName": "19",
      "longName": "Stotis–Lydos pl.–Salininkai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_19:0",
          "sourceRouteId": "vilnius_bus_19",
          "sourceShapeId": "vilnius_bus_19_a-b",
          "directionId": 0,
          "headsign": "Salininkai",
          "directionName": "Stotis–Lydos pl.–Salininkai",
          "mode": "bus",
          "routeShortName": "19",
          "routeLongName": "Stotis–Lydos pl.–Salininkai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              433.307,
              1919.951,
              0
            ],
            [
              403.923,
              1936.074,
              33.517
            ],
            [
              382.944,
              1953.155,
              60.571
            ],
            [
              371.557,
              1965.609,
              77.445
            ],
            [
              363.417,
              1979.117,
              93.216
            ],
            [
              363.117,
              1998.047,
              112.149
            ],
            [
              380.715,
              2007.745,
              132.242
            ],
            [
              401.919,
              2002.904,
              153.991
            ],
            [
              472.033,
              1955.979,
              238.359
            ],
            [
              476.345,
              1944.768,
              250.371
            ],
            [
              476.643,
              1925.838,
              269.303
            ],
            [
              530.958,
              1897.013,
              330.793
            ],
            [
              623.161,
              1858.587,
              430.683
            ],
            [
              825.163,
              1791.425,
              643.557
            ],
            [
              862.14,
              1837.501,
              702.636
            ],
            [
              869.06,
              1862.978,
              729.036
            ],
            [
              873.401,
              1888.503,
              754.927
            ],
            [
              889.31,
              1911.588,
              782.964
            ],
            [
              908.823,
              1920.135,
              804.267
            ],
            [
              941.154,
              1923.993,
              836.827
            ],
            [
              953.593,
              1933.783,
              852.657
            ],
            [
              1083.618,
              2057.184,
              1031.917
            ],
            [
              1196.071,
              2172,
              1192.629
            ],
            [
              1233.034,
              2216.96,
              1250.833
            ],
            [
              1262.402,
              2269.853,
              1311.332
            ],
            [
              1272.571,
              2296.383,
              1339.744
            ],
            [
              1295.641,
              2322.675,
              1374.722
            ],
            [
              1353.693,
              2426.246,
              1493.453
            ],
            [
              1363.843,
              2451.663,
              1520.821
            ],
            [
              1395.21,
              2612.502,
              1684.691
            ],
            [
              1412.03,
              2684.551,
              1758.677
            ],
            [
              1428.563,
              2741.021,
              1817.517
            ],
            [
              1438.754,
              2768.663,
              1846.978
            ],
            [
              1466.069,
              2814.913,
              1900.692
            ],
            [
              1478.408,
              2819.138,
              1913.735
            ],
            [
              1513.094,
              2845.213,
              1957.128
            ],
            [
              1567.546,
              2893.187,
              2029.699
            ],
            [
              1617.065,
              2953.497,
              2107.734
            ],
            [
              1672.764,
              3033.73,
              2205.405
            ],
            [
              1688.949,
              3071.28,
              2246.295
            ],
            [
              1698.328,
              3124.541,
              2300.376
            ],
            [
              1700.436,
              3377.207,
              2553.051
            ],
            [
              1694.118,
              3454.138,
              2630.24
            ],
            [
              1678.159,
              3567.984,
              2745.2
            ],
            [
              1670.163,
              3728.439,
              2905.853
            ],
            [
              1664.831,
              3754.142,
              2932.104
            ],
            [
              1667.788,
              3878.77,
              3056.767
            ],
            [
              1663.704,
              3902.223,
              3080.573
            ],
            [
              1666.884,
              3934.448,
              3112.955
            ],
            [
              1673.134,
              4166.999,
              3345.589
            ],
            [
              1673.634,
              4298.351,
              3476.943
            ],
            [
              1669.173,
              4336.284,
              3515.137
            ],
            [
              1674.124,
              4359.57,
              3538.943
            ],
            [
              1676.865,
              4402.935,
              3582.395
            ],
            [
              1687.031,
              4881.438,
              4061.006
            ],
            [
              1684.403,
              4913.771,
              4093.445
            ],
            [
              1688.75,
              4939.294,
              4119.336
            ],
            [
              1707.244,
              5553.457,
              4733.777
            ],
            [
              1715.118,
              5664.634,
              4845.233
            ],
            [
              1721.355,
              5722.407,
              4903.341
            ],
            [
              1837.248,
              6538.482,
              5727.605
            ],
            [
              1900.043,
              6998.194,
              6191.586
            ],
            [
              1909.827,
              7038.089,
              6232.662
            ],
            [
              1906.805,
              7049.277,
              6244.252
            ],
            [
              1901.784,
              7057.163,
              6253.601
            ],
            [
              1899.491,
              7072.791,
              6269.396
            ],
            [
              494.746,
              7824.496,
              7862.622
            ],
            [
              19.567,
              8090.304,
              8407.093
            ],
            [
              -46.267,
              8521.201,
              8842.991
            ],
            [
              -64.071,
              8786.47,
              9108.856
            ],
            [
              -63.142,
              8873.284,
              9195.675
            ],
            [
              -86.398,
              8909.328,
              9238.57
            ],
            [
              -231.023,
              9094.516,
              9473.54
            ],
            [
              -383.893,
              9217.507,
              9669.744
            ],
            [
              -421.991,
              9254.931,
              9723.149
            ],
            [
              -493.988,
              9311.891,
              9814.953
            ],
            [
              -530.471,
              9331.474,
              9856.359
            ],
            [
              -544.664,
              9332.843,
              9870.618
            ],
            [
              -569.939,
              9328.846,
              9896.208
            ],
            [
              -763.905,
              9287.809,
              10094.466
            ],
            [
              -800.202,
              9281.782,
              10131.261
            ],
            [
              -908.755,
              9282.619,
              10239.817
            ],
            [
              -1071.674,
              9278.861,
              10402.78
            ],
            [
              -1100.805,
              9276.043,
              10432.047
            ],
            [
              -1181.459,
              9283.052,
              10513.005
            ],
            [
              -1238.936,
              9285.193,
              10570.521
            ],
            [
              -1308.161,
              9280.864,
              10639.881
            ],
            [
              -1343.772,
              9277.047,
              10675.696
            ],
            [
              -1428.033,
              9262.966,
              10761.126
            ],
            [
              -1538.979,
              9238.226,
              10874.797
            ],
            [
              -1618.698,
              9225.174,
              10955.577
            ],
            [
              -1611.777,
              9178.296,
              11002.963
            ],
            [
              -1592.202,
              9079.986,
              11103.203
            ],
            [
              -1553.05,
              8811.006,
              11375.017
            ],
            [
              -1548.081,
              8799.785,
              11387.289
            ],
            [
              -1540.488,
              8790.744,
              11399.095
            ],
            [
              -1537.516,
              8776.22,
              11413.921
            ],
            [
              -1545.584,
              8758.552,
              11433.344
            ],
            [
              -1504.025,
              8516.246,
              11679.188
            ],
            [
              -1501.391,
              8482.803,
              11712.735
            ],
            [
              -1502.671,
              8447.203,
              11748.358
            ],
            [
              -1506.496,
              8413.875,
              11781.905
            ],
            [
              -1524.816,
              8328.484,
              11869.238
            ],
            [
              -1523.196,
              8310.644,
              11887.152
            ],
            [
              -1526.037,
              8296.223,
              11901.85
            ],
            [
              -1532.635,
              8288.548,
              11911.971
            ],
            [
              -1541.071,
              8286.472,
              11920.659
            ],
            [
              -1547.411,
              8293.264,
              11929.95
            ],
            [
              -1547.938,
              8299.953,
              11936.66
            ],
            [
              -1542.006,
              8306.527,
              11945.514
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4266",
              "position": {
                "x": 433.307,
                "z": 1919.951
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 782.964,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 1339.744,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 1900.692,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5953",
              "position": {
                "x": 1663.704,
                "z": 3902.223
              },
              "distanceAlongShapeM": 3080.573,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5955",
              "position": {
                "x": 1669.173,
                "z": 4336.284
              },
              "distanceAlongShapeM": 3515.137,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5956",
              "position": {
                "x": 1684.403,
                "z": 4913.771
              },
              "distanceAlongShapeM": 4093.445,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5958",
              "position": {
                "x": 1721.355,
                "z": 5722.407
              },
              "distanceAlongShapeM": 4903.341,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17944",
              "position": {
                "x": 1837.248,
                "z": 6538.482
              },
              "distanceAlongShapeM": 5727.605,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5960",
              "position": {
                "x": 1900.043,
                "z": 6998.194
              },
              "distanceAlongShapeM": 6191.586,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8329",
              "position": {
                "x": 1211.864,
                "z": 7439.522
              },
              "distanceAlongShapeM": 7048.704,
              "shapeOffsetM": 1.085,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6240",
              "position": {
                "x": 494.746,
                "z": 7824.496
              },
              "distanceAlongShapeM": 7862.622,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6243",
              "position": {
                "x": -46.267,
                "z": 8521.201
              },
              "distanceAlongShapeM": 8842.991,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6246",
              "position": {
                "x": -64.071,
                "z": 8786.47
              },
              "distanceAlongShapeM": 9108.856,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6248",
              "position": {
                "x": -383.893,
                "z": 9217.507
              },
              "distanceAlongShapeM": 9669.744,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6254",
              "position": {
                "x": -1100.805,
                "z": 9276.043
              },
              "distanceAlongShapeM": 10432.047,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6256",
              "position": {
                "x": -1538.979,
                "z": 9238.226
              },
              "distanceAlongShapeM": 10874.797,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6260",
              "position": {
                "x": -1540.488,
                "z": 8790.744
              },
              "distanceAlongShapeM": 11399.095,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6264",
              "position": {
                "x": -1542.006,
                "z": 8306.527
              },
              "distanceAlongShapeM": 11945.514,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            18360,
            21420,
            23160,
            24420,
            26220,
            28200,
            30240,
            34500,
            36300,
            38760,
            40800,
            42900,
            45120,
            47460,
            49320,
            52020,
            54540,
            56820,
            59340,
            60840,
            62220,
            64740,
            67140,
            71100,
            72900,
            75240,
            77400,
            79200,
            81540,
            83160
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_19:1",
          "sourceRouteId": "vilnius_bus_19",
          "sourceShapeId": "vilnius_bus_19_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Salininkai–Lydos pl.–Stotis",
          "mode": "bus",
          "routeShortName": "19",
          "routeLongName": "Stotis–Lydos pl.–Salininkai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -1542.006,
              8306.527,
              0
            ],
            [
              -1526.833,
              8324.068,
              23.193
            ],
            [
              -1510.907,
              8383.897,
              85.106
            ],
            [
              -1505.414,
              8438.346,
              139.831
            ],
            [
              -1503.229,
              8488.402,
              189.934
            ],
            [
              -1511.708,
              8556.458,
              258.517
            ],
            [
              -1543.904,
              8744.051,
              448.852
            ],
            [
              -1556.03,
              8788.795,
              495.211
            ],
            [
              -1618.698,
              9225.174,
              936.066
            ],
            [
              -1566.739,
              9239.834,
              990.054
            ],
            [
              -1337.858,
              9282.508,
              1222.878
            ],
            [
              -974.57,
              9288.252,
              1586.212
            ],
            [
              -908.755,
              9282.619,
              1652.267
            ],
            [
              -810.459,
              9286.419,
              1750.637
            ],
            [
              -775.513,
              9289.131,
              1785.688
            ],
            [
              -684.769,
              9304.197,
              1877.675
            ],
            [
              -547.894,
              9332.901,
              2017.527
            ],
            [
              -527.907,
              9330.314,
              2037.681
            ],
            [
              -475.414,
              9302.65,
              2097.017
            ],
            [
              -307.276,
              9166.028,
              2313.665
            ],
            [
              -271.763,
              9128.649,
              2365.223
            ],
            [
              -238.634,
              9102.446,
              2407.462
            ],
            [
              -222.12,
              9086.562,
              2430.376
            ],
            [
              -72.549,
              8889.039,
              2678.139
            ],
            [
              -63.142,
              8873.284,
              2696.489
            ],
            [
              -60.579,
              8836.501,
              2733.361
            ],
            [
              -56.461,
              8814.162,
              2756.076
            ],
            [
              -12.983,
              8432.653,
              3140.055
            ],
            [
              11.676,
              8118.278,
              3455.395
            ],
            [
              19.567,
              8090.304,
              3484.461
            ],
            [
              32.968,
              8081.155,
              3500.687
            ],
            [
              544.189,
              7808.007,
              4080.305
            ],
            [
              569.9,
              7800.858,
              4106.991
            ],
            [
              1061.202,
              7536.92,
              4664.702
            ],
            [
              1283.862,
              7420.383,
              4916.015
            ],
            [
              1765.211,
              7146.531,
              5469.813
            ],
            [
              1899.491,
              7072.791,
              5623.008
            ],
            [
              1909.301,
              7079.288,
              5634.774
            ],
            [
              1919.028,
              7081.334,
              5644.714
            ],
            [
              1929.964,
              7078.904,
              5655.917
            ],
            [
              1934.985,
              7071.018,
              5665.265
            ],
            [
              1935.465,
              7062.103,
              5674.193
            ],
            [
              1928.176,
              7052.22,
              5686.474
            ],
            [
              1915.701,
              7041.319,
              5703.04
            ],
            [
              1843.043,
              6502.751,
              6246.487
            ],
            [
              1738.747,
              5824.501,
              6932.709
            ],
            [
              1738.128,
              5791.116,
              6966.1
            ],
            [
              1710.961,
              5614.616,
              7144.679
            ],
            [
              1705.045,
              5504.515,
              7254.938
            ],
            [
              1687.181,
              4854.718,
              7904.981
            ],
            [
              1690.373,
              4817.922,
              7941.916
            ],
            [
              1685.654,
              4772.367,
              7987.714
            ],
            [
              1681.965,
              4538.656,
              8221.454
            ],
            [
              1676.865,
              4402.935,
              8357.27
            ],
            [
              1678.187,
              4335.004,
              8425.215
            ],
            [
              1683.505,
              4273.677,
              8486.772
            ],
            [
              1693.897,
              4242.314,
              8519.812
            ],
            [
              1695.023,
              4233.387,
              8528.81
            ],
            [
              1702.519,
              4219.889,
              8544.249
            ],
            [
              1698.255,
              4198.816,
              8565.749
            ],
            [
              1674.822,
              4153.608,
              8616.669
            ],
            [
              1671.231,
              3959.972,
              8810.339
            ],
            [
              1674.798,
              3769.542,
              9000.802
            ],
            [
              1677.199,
              3724.968,
              9045.44
            ],
            [
              1684.234,
              3721.498,
              9053.285
            ],
            [
              1678.221,
              3710.477,
              9065.84
            ],
            [
              1677.947,
              3591.366,
              9184.952
            ],
            [
              1696.885,
              3464.105,
              9313.613
            ],
            [
              1701.829,
              3382.747,
              9395.122
            ],
            [
              1703.03,
              3134.473,
              9643.399
            ],
            [
              1699.891,
              3104.474,
              9673.562
            ],
            [
              1687.994,
              3054.599,
              9724.836
            ],
            [
              1659.262,
              3001.697,
              9785.037
            ],
            [
              1605.061,
              2932.568,
              9872.881
            ],
            [
              1556.997,
              2881.137,
              9943.275
            ],
            [
              1484.111,
              2813.466,
              10042.732
            ],
            [
              1478.744,
              2802.433,
              10055.001
            ],
            [
              1453.839,
              2781.743,
              10087.38
            ],
            [
              1433.991,
              2755.392,
              10120.369
            ],
            [
              1428.563,
              2741.021,
              10135.731
            ],
            [
              1382.281,
              2541.494,
              10340.555
            ],
            [
              1365.86,
              2456.079,
              10427.535
            ],
            [
              1336.284,
              2392.058,
              10498.057
            ],
            [
              1224.883,
              2194.846,
              10724.558
            ],
            [
              958.108,
              1933.7,
              11097.875
            ],
            [
              922.174,
              1874.247,
              11167.345
            ],
            [
              898.105,
              1863.557,
              11193.681
            ],
            [
              862.14,
              1837.501,
              11238.092
            ],
            [
              825.163,
              1791.425,
              11297.172
            ],
            [
              623.161,
              1858.587,
              11510.045
            ],
            [
              493.148,
              1911.064,
              11650.25
            ],
            [
              482.346,
              1920.167,
              11664.376
            ],
            [
              476.582,
              1922.499,
              11670.594
            ],
            [
              466.222,
              1920.462,
              11681.153
            ],
            [
              444.313,
              1921.976,
              11703.114
            ],
            [
              433.307,
              1919.951,
              11714.304
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6264",
              "position": {
                "x": -1542.006,
                "z": 8306.527
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6261",
              "position": {
                "x": -1556.03,
                "z": 8788.795
              },
              "distanceAlongShapeM": 495.211,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6257",
              "position": {
                "x": -1566.739,
                "z": 9239.834
              },
              "distanceAlongShapeM": 990.054,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6253",
              "position": {
                "x": -974.57,
                "z": 9288.252
              },
              "distanceAlongShapeM": 1586.212,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6249",
              "position": {
                "x": -307.276,
                "z": 9166.028
              },
              "distanceAlongShapeM": 2313.665,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6247",
              "position": {
                "x": -56.461,
                "z": 8814.162
              },
              "distanceAlongShapeM": 2756.076,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6244",
              "position": {
                "x": -12.983,
                "z": 8432.653
              },
              "distanceAlongShapeM": 3140.055,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6241",
              "position": {
                "x": 569.9,
                "z": 7800.858
              },
              "distanceAlongShapeM": 4106.991,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:8330",
              "position": {
                "x": 1283.862,
                "z": 7420.383
              },
              "distanceAlongShapeM": 4916.015,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:646",
              "position": {
                "x": 1908.814,
                "z": 6983.559
              },
              "distanceAlongShapeM": 5761.203,
              "shapeOffsetM": 0.897,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17945",
              "position": {
                "x": 1843.043,
                "z": 6502.751
              },
              "distanceAlongShapeM": 6246.487,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5995",
              "position": {
                "x": 1738.128,
                "z": 5791.116
              },
              "distanceAlongShapeM": 6966.1,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5957",
              "position": {
                "x": 1690.373,
                "z": 4817.922
              },
              "distanceAlongShapeM": 7941.916,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5996",
              "position": {
                "x": 1693.572,
                "z": 4189.997
              },
              "distanceAlongShapeM": 8575.733,
              "shapeOffsetM": 0.099,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 9053.285,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 10055.001,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 10724.558,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 11167.345,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 11650.25,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            19440,
            20640,
            23640,
            25620,
            27420,
            29220,
            31020,
            33180,
            36600,
            38520,
            40860,
            42900,
            45060,
            47220,
            49620,
            51480,
            54420,
            56940,
            59820,
            62460,
            64440,
            65880,
            67740,
            70140,
            73200,
            75300,
            77220,
            79500,
            81180,
            84120,
            85080
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_20",
      "sourceRouteId": "vilnius_bus_20",
      "mode": "bus",
      "shortName": "20",
      "longName": "Žemieji Paneriai–Mūrinė Vokė–Lazdynai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_20:0",
          "sourceRouteId": "vilnius_bus_20",
          "sourceShapeId": "vilnius_bus_20_a1-b1",
          "directionId": 0,
          "headsign": "Lazdynai",
          "directionName": "Žemieji Paneriai–Mūrinė Vokė–Paneriškių g.–Lazdynai",
          "mode": "bus",
          "routeShortName": "20",
          "routeLongName": "Žemieji Paneriai–Mūrinė Vokė–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4333.961,
              4766.474,
              0
            ],
            [
              -4351.156,
              4780.129,
              21.957
            ],
            [
              -4357.738,
              4810.298,
              52.837
            ],
            [
              -4435.232,
              4883.989,
              159.774
            ],
            [
              -4468.845,
              4919.076,
              208.363
            ],
            [
              -4488.111,
              4924.973,
              228.512
            ],
            [
              -4510.925,
              4949.856,
              262.27
            ],
            [
              -4579.258,
              4993.33,
              343.261
            ],
            [
              -4600.366,
              5004.825,
              367.295
            ],
            [
              -4835.366,
              5155.793,
              646.609
            ],
            [
              -5032.11,
              5279.379,
              878.948
            ],
            [
              -5271.713,
              5427.062,
              1160.409
            ],
            [
              -5460.164,
              5546.035,
              1383.274
            ],
            [
              -5507.478,
              5573.554,
              1438.008
            ],
            [
              -5539.526,
              5587.456,
              1472.942
            ],
            [
              -5570.341,
              5597.997,
              1505.509
            ],
            [
              -5599.939,
              5604.064,
              1535.723
            ],
            [
              -5632.195,
              5605.723,
              1568.022
            ],
            [
              -5666.482,
              5601.851,
              1602.527
            ],
            [
              -5724.289,
              5581.678,
              1663.753
            ],
            [
              -5767.933,
              5559.039,
              1712.918
            ],
            [
              -5844.413,
              5503.558,
              1807.403
            ],
            [
              -5862.75,
              5488.283,
              1831.269
            ],
            [
              -5911.642,
              5422.317,
              1913.378
            ],
            [
              -5931.13,
              5377.005,
              1962.703
            ],
            [
              -5950.367,
              5308.312,
              2034.039
            ],
            [
              -5960.48,
              5282.88,
              2061.409
            ],
            [
              -5972.455,
              5261.931,
              2085.538
            ],
            [
              -5985.57,
              5249.907,
              2103.331
            ],
            [
              -6003.755,
              5243.534,
              2122.6
            ],
            [
              -6024.466,
              5240.544,
              2143.526
            ],
            [
              -6045.12,
              5240.892,
              2164.183
            ],
            [
              -6069.366,
              5257.998,
              2193.856
            ],
            [
              -6086.896,
              5290.575,
              2230.85
            ],
            [
              -6284.365,
              5565.511,
              2569.352
            ],
            [
              -6384.618,
              5670.718,
              2714.677
            ],
            [
              -6403.151,
              5682.161,
              2736.458
            ],
            [
              -6425.222,
              5713.7,
              2774.953
            ],
            [
              -6633.66,
              5914.22,
              3064.184
            ],
            [
              -6722.128,
              5991.393,
              3181.582
            ],
            [
              -6610.439,
              6453.723,
              3657.212
            ],
            [
              -6615.859,
              6477.191,
              3681.297
            ],
            [
              -6611.247,
              6482.68,
              3688.466
            ],
            [
              -6601.507,
              6485.856,
              3698.711
            ],
            [
              -6595.808,
              6479.082,
              3707.564
            ],
            [
              -6595.901,
              6473.518,
              3713.129
            ],
            [
              -6598.614,
              6465.771,
              3721.337
            ],
            [
              -6609.831,
              6451.487,
              3739.499
            ],
            [
              -6653.627,
              6265.205,
              3930.861
            ],
            [
              -6722.128,
              5991.393,
              4213.111
            ],
            [
              -6754.294,
              5998.609,
              4246.076
            ],
            [
              -6809.827,
              6037.383,
              4313.806
            ],
            [
              -6882.79,
              6076.446,
              4396.569
            ],
            [
              -6955.867,
              6108.831,
              4476.5
            ],
            [
              -7039.365,
              6135.823,
              4564.252
            ],
            [
              -7206.108,
              6166.42,
              4733.779
            ],
            [
              -7774.707,
              6263.751,
              5310.649
            ],
            [
              -7867.343,
              6285.312,
              5405.76
            ],
            [
              -8047.971,
              6336.143,
              5593.404
            ],
            [
              -8100.928,
              6335.897,
              5646.362
            ],
            [
              -8216.781,
              6399.018,
              5778.294
            ],
            [
              -8443.118,
              6419.411,
              6005.548
            ],
            [
              -8559.774,
              6433.557,
              6123.059
            ],
            [
              -8589.455,
              6435.153,
              6152.782
            ],
            [
              -8680.794,
              6417.715,
              6245.771
            ],
            [
              -8793.026,
              6386.142,
              6362.36
            ],
            [
              -8817.578,
              6385.428,
              6386.922
            ],
            [
              -8897.885,
              6371.145,
              6468.489
            ],
            [
              -8999.678,
              6346.078,
              6573.323
            ],
            [
              -9021.163,
              6335.294,
              6597.362
            ],
            [
              -9032.999,
              6322.127,
              6615.067
            ],
            [
              -9043.295,
              6284.446,
              6654.13
            ],
            [
              -9071.789,
              5999.937,
              6940.062
            ],
            [
              -9087.112,
              5810.947,
              7129.673
            ],
            [
              -9105.787,
              5654.292,
              7287.436
            ],
            [
              -9121.037,
              5469.753,
              7472.604
            ],
            [
              -9131.188,
              5400.901,
              7542.201
            ],
            [
              -9162.794,
              5083.047,
              7861.623
            ],
            [
              -9167.245,
              4967.349,
              7977.406
            ],
            [
              -9185.609,
              4829.613,
              8116.36
            ],
            [
              -9269.169,
              4812.038,
              8201.749
            ],
            [
              -9558.495,
              4764.378,
              8494.974
            ],
            [
              -9588.344,
              4754.839,
              8526.31
            ],
            [
              -9651.769,
              4744.725,
              8590.536
            ],
            [
              -9791.957,
              4738.068,
              8730.883
            ],
            [
              -9826.986,
              4727.497,
              8767.471
            ],
            [
              -9869.291,
              4705.911,
              8814.965
            ],
            [
              -9917.853,
              4696.669,
              8864.4
            ],
            [
              -9958.062,
              4685.067,
              8906.248
            ],
            [
              -9970.318,
              4645.189,
              8947.967
            ],
            [
              -9980.786,
              4636.451,
              8961.603
            ],
            [
              -10015.813,
              4625.879,
              8998.191
            ],
            [
              -10037.72,
              4628.455,
              9020.248
            ],
            [
              -10042.829,
              4631.876,
              9026.397
            ],
            [
              -10045.914,
              4640.83,
              9035.868
            ],
            [
              -10039.034,
              4667.436,
              9063.35
            ],
            [
              -10033.119,
              4674.021,
              9072.201
            ],
            [
              -9847.833,
              4715.586,
              9262.092
            ],
            [
              -9780.287,
              4741.22,
              9334.338
            ],
            [
              -9738.284,
              4743.887,
              9376.426
            ],
            [
              -9619.286,
              4757.562,
              9496.208
            ],
            [
              -9574.594,
              4766.863,
              9541.857
            ],
            [
              -9427.108,
              4785.641,
              9690.534
            ],
            [
              -9186.254,
              4829.624,
              9935.37
            ],
            [
              -8761.616,
              4900.668,
              10365.91
            ],
            [
              -8566.072,
              4936.448,
              10564.701
            ],
            [
              -8440.538,
              4954.439,
              10691.518
            ],
            [
              -8110.415,
              5008.04,
              11025.964
            ],
            [
              -7984.14,
              5031.572,
              11154.413
            ],
            [
              -7996.281,
              5078.524,
              11202.91
            ],
            [
              -8005.189,
              5086.463,
              11214.842
            ],
            [
              -8032.814,
              5094.708,
              11243.672
            ],
            [
              -8056.05,
              5095.089,
              11266.91
            ],
            [
              -8074.858,
              5089.832,
              11286.44
            ],
            [
              -8087.322,
              5077.791,
              11303.769
            ],
            [
              -8094.05,
              5061.204,
              11321.669
            ],
            [
              -8097.824,
              5027.871,
              11355.215
            ],
            [
              -8123.102,
              4509.547,
              11874.156
            ],
            [
              -8153.328,
              4043.622,
              12341.059
            ],
            [
              -8152.03,
              4004.64,
              12380.063
            ],
            [
              -8148.06,
              3971.18,
              12413.758
            ],
            [
              -8134.965,
              3943.136,
              12444.708
            ],
            [
              -8122.972,
              3887.281,
              12501.837
            ],
            [
              -8106.816,
              3849.168,
              12543.232
            ],
            [
              -8055.33,
              3761.496,
              12644.904
            ],
            [
              -8007.887,
              3702.832,
              12720.351
            ],
            [
              -7953.829,
              3654.078,
              12793.147
            ],
            [
              -7691.803,
              3497.261,
              13098.515
            ],
            [
              -7552.547,
              3410.361,
              13262.661
            ],
            [
              -7588.526,
              3341.938,
              13339.966
            ],
            [
              -7587.346,
              3335.24,
              13346.768
            ],
            [
              -7582.94,
              3328.488,
              13354.83
            ],
            [
              -7517.702,
              3292.902,
              13429.143
            ],
            [
              -7480.171,
              3259.999,
              13479.054
            ],
            [
              -7459.894,
              3237.4,
              13509.417
            ],
            [
              -7451.285,
              3211.655,
              13536.563
            ],
            [
              -7446.786,
              3171.506,
              13576.964
            ],
            [
              -7445.126,
              3115.82,
              13632.675
            ],
            [
              -7447.724,
              3075.788,
              13672.79
            ],
            [
              -7472.977,
              3070.64,
              13698.562
            ],
            [
              -7643.956,
              3072.351,
              13869.551
            ],
            [
              -7802.088,
              3070.505,
              14027.693
            ],
            [
              -7947.244,
              3072.892,
              14172.869
            ],
            [
              -8072.973,
              3079.409,
              14298.766
            ],
            [
              -8260.762,
              3079.146,
              14486.556
            ],
            [
              -8265.242,
              3081.446,
              14491.591
            ],
            [
              -8269.93,
              3110.465,
              14520.987
            ],
            [
              -8278.098,
              3123.957,
              14536.758
            ],
            [
              -8298.116,
              3123.171,
              14556.792
            ],
            [
              -8352.235,
              3128.509,
              14611.173
            ],
            [
              -8357.269,
              3136.383,
              14620.519
            ],
            [
              -8357.105,
              3146.399,
              14630.537
            ],
            [
              -8332.853,
              3169.379,
              14663.947
            ],
            [
              -8323.157,
              3170.334,
              14673.69
            ],
            [
              -8314.18,
              3166.848,
              14683.32
            ],
            [
              -8266.059,
              3110.402,
              14757.494
            ],
            [
              -8263.307,
              3081.414,
              14786.612
            ],
            [
              -8249.813,
              3077.854,
              14800.567
            ],
            [
              -8131.017,
              3081.474,
              14919.419
            ],
            [
              -7958.82,
              3075.309,
              15091.726
            ],
            [
              -7454.213,
              3073.669,
              15596.336
            ],
            [
              -7445.918,
              3067.966,
              15606.402
            ],
            [
              -7448.055,
              3016.795,
              15657.618
            ],
            [
              -7449.084,
              2876.551,
              15797.865
            ],
            [
              -7448.124,
              2778.576,
              15895.846
            ],
            [
              -7443.866,
              2762.921,
              15912.069
            ],
            [
              -7447.588,
              2693.965,
              15981.125
            ],
            [
              -7450.442,
              2521.47,
              16153.644
            ],
            [
              -7435.624,
              2481.15,
              16196.601
            ],
            [
              -7420.363,
              2428.578,
              16251.343
            ],
            [
              -7411.885,
              2239.197,
              16440.914
            ],
            [
              -7186.259,
              2188.702,
              16672.121
            ],
            [
              -7148.296,
              2182.506,
              16710.586
            ],
            [
              -7083.758,
              2183.659,
              16775.135
            ],
            [
              -7065.716,
              2182.246,
              16793.232
            ],
            [
              -7046.181,
              2193.053,
              16815.557
            ],
            [
              -7031.787,
              2205.059,
              16834.301
            ],
            [
              -6959.056,
              2310.713,
              16962.569
            ],
            [
              -6828.805,
              2537.858,
              17224.408
            ],
            [
              -6805.912,
              2556.4,
              17253.868
            ],
            [
              -6591.179,
              2664.13,
              17494.11
            ],
            [
              -6580.268,
              2660.608,
              17505.575
            ],
            [
              -6530.94,
              2600.784,
              17583.114
            ],
            [
              -6529.322,
              2581.832,
              17602.134
            ],
            [
              -6532.182,
              2565.182,
              17619.028
            ],
            [
              -6545.306,
              2552.044,
              17637.599
            ],
            [
              -6585.009,
              2531.558,
              17682.276
            ],
            [
              -6594.282,
              2517.242,
              17699.333
            ],
            [
              -6595.132,
              2505.011,
              17711.593
            ],
            [
              -6565.231,
              2441.059,
              17782.19
            ],
            [
              -6502.181,
              2353.175,
              17890.352
            ],
            [
              -6429.159,
              2282.933,
              17991.674
            ],
            [
              -6374.247,
              2248.616,
              18056.427
            ],
            [
              -6326.927,
              2223.331,
              18110.079
            ],
            [
              -6231.895,
              2196.131,
              18208.927
            ],
            [
              -6093.704,
              2164.862,
              18350.611
            ],
            [
              -5702.782,
              2084.789,
              18749.65
            ],
            [
              -5464.017,
              2049.57,
              18990.998
            ],
            [
              -5246.18,
              2035.846,
              19209.267
            ],
            [
              -5237.188,
              2033.466,
              19218.569
            ],
            [
              -5217.894,
              1991.949,
              19264.35
            ],
            [
              -5138.979,
              1928.265,
              19365.756
            ],
            [
              -5084.195,
              1887.255,
              19434.19
            ],
            [
              -5073.288,
              1883.729,
              19445.653
            ],
            [
              -5063.31,
              1863.521,
              19468.19
            ],
            [
              -4967.083,
              1756.123,
              19612.391
            ],
            [
              -4942.917,
              1735.672,
              19644.049
            ],
            [
              -4928.804,
              1730.978,
              19658.922
            ],
            [
              -4906.917,
              1690.529,
              19704.914
            ],
            [
              -4842.797,
              1742.865,
              19787.68
            ],
            [
              -4801.101,
              1766.641,
              19835.679
            ],
            [
              -4774.467,
              1777.316,
              19864.373
            ],
            [
              -4728.427,
              1790.998,
              19912.403
            ],
            [
              -4687.68,
              1796.979,
              19953.586
            ],
            [
              -4579.155,
              1805.134,
              20062.417
            ],
            [
              -4547.361,
              1815.72,
              20095.928
            ],
            [
              -4518.395,
              1811.882,
              20125.147
            ],
            [
              -4300.033,
              1829.272,
              20344.2
            ],
            [
              -4282.619,
              1828.972,
              20361.616
            ],
            [
              -4232.446,
              1820.314,
              20412.531
            ],
            [
              -4165.014,
              1802.452,
              20482.289
            ],
            [
              -4141.304,
              1793.136,
              20507.763
            ],
            [
              -4122.773,
              1782.797,
              20528.983
            ],
            [
              -4066.123,
              1738.403,
              20600.956
            ],
            [
              -4047.525,
              1694.666,
              20648.483
            ],
            [
              -4037.081,
              1664.429,
              20680.473
            ],
            [
              -4020.121,
              1600.683,
              20746.436
            ],
            [
              -3992.198,
              1462.162,
              20887.743
            ],
            [
              -3984.902,
              1436.432,
              20914.488
            ],
            [
              -3986.154,
              1438.68,
              20917.06
            ],
            [
              -3968.906,
              1391.627,
              20967.175
            ],
            [
              -3969.311,
              1368.257,
              20990.549
            ],
            [
              -3952.68,
              1285.592,
              21074.871
            ],
            [
              -3953.633,
              1267.797,
              21092.691
            ],
            [
              -3986.792,
              1252.786,
              21129.089
            ],
            [
              -4052.311,
              1231.656,
              21197.93
            ],
            [
              -4088.482,
              1228.943,
              21234.203
            ],
            [
              -4121.332,
              1231.737,
              21267.172
            ],
            [
              -4147.695,
              1236.645,
              21293.988
            ],
            [
              -4215.081,
              1256.734,
              21364.304
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 228.512,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5728",
              "position": {
                "x": -6069.366,
                "z": 5257.998
              },
              "distanceAlongShapeM": 2193.856,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5732",
              "position": {
                "x": -6403.151,
                "z": 5682.161
              },
              "distanceAlongShapeM": 2736.458,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 3271.618,
              "shapeOffsetM": 0.317,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:8784",
              "position": {
                "x": -6615.878,
                "z": 6476.078
              },
              "distanceAlongShapeM": 3680.216,
              "shapeOffsetM": 0.269,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5738",
              "position": {
                "x": -6754.294,
                "z": 5998.609
              },
              "distanceAlongShapeM": 4246.076,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5742",
              "position": {
                "x": -8100.928,
                "z": 6335.897
              },
              "distanceAlongShapeM": 5646.362,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6270",
              "position": {
                "x": -8793.026,
                "z": 6386.142
              },
              "distanceAlongShapeM": 6362.36,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6274",
              "position": {
                "x": -9087.112,
                "z": 5810.947
              },
              "distanceAlongShapeM": 7129.673,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6277",
              "position": {
                "x": -9121.037,
                "z": 5469.753
              },
              "distanceAlongShapeM": 7472.604,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6279",
              "position": {
                "x": -9167.245,
                "z": 4967.349
              },
              "distanceAlongShapeM": 7977.406,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6282",
              "position": {
                "x": -9588.344,
                "z": 4754.839
              },
              "distanceAlongShapeM": 8526.31,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9626",
              "position": {
                "x": -10015.813,
                "z": 4625.879
              },
              "distanceAlongShapeM": 8998.191,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6283",
              "position": {
                "x": -9574.594,
                "z": 4766.863
              },
              "distanceAlongShapeM": 9541.857,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6291",
              "position": {
                "x": -8566.072,
                "z": 4936.448
              },
              "distanceAlongShapeM": 10564.701,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6295",
              "position": {
                "x": -8134.965,
                "z": 3943.136
              },
              "distanceAlongShapeM": 12444.708,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6296",
              "position": {
                "x": -7517.702,
                "z": 3292.902
              },
              "distanceAlongShapeM": 13429.143,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:18073",
              "position": {
                "x": -8298.116,
                "z": 3123.171
              },
              "distanceAlongShapeM": 14556.792,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1770,
              "departureOffsetSeconds": 1770
            },
            {
              "stopId": "judu:stop:6301",
              "position": {
                "x": -7443.866,
                "z": 2762.921
              },
              "distanceAlongShapeM": 15912.069,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1950,
              "departureOffsetSeconds": 1950
            },
            {
              "stopId": "judu:stop:7731",
              "position": {
                "x": -7420.363,
                "z": 2428.578
              },
              "distanceAlongShapeM": 16251.343,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2010,
              "departureOffsetSeconds": 2010
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 19658.922,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2370,
              "departureOffsetSeconds": 2370
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 20095.928,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 20600.956,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 20967.175,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 21364.304,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            }
          ],
          "departuresSeconds": [
            20760,
            22680,
            26880,
            28800,
            39480,
            45780,
            53460,
            54900,
            60060,
            61920,
            65100,
            69840,
            73260,
            76140
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_20:1",
          "sourceRouteId": "vilnius_bus_20",
          "sourceShapeId": "vilnius_bus_20_b1-a1",
          "directionId": 1,
          "headsign": "Žemieji Paneriai",
          "directionName": "Lazdynai–Paneriškių g.–Mūrinė Vokė–Žemieji Paneriai",
          "mode": "bus",
          "routeShortName": "20",
          "routeLongName": "Žemieji Paneriai–Mūrinė Vokė–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4215.081,
              1256.734,
              0
            ],
            [
              -4241.916,
              1271.669,
              30.711
            ],
            [
              -4268.203,
              1281.028,
              58.614
            ],
            [
              -4527.979,
              1404.616,
              346.29
            ],
            [
              -4558.781,
              1414.051,
              378.505
            ],
            [
              -4581.673,
              1433.369,
              408.459
            ],
            [
              -4718.251,
              1519.203,
              569.77
            ],
            [
              -4838.028,
              1606.973,
              718.262
            ],
            [
              -4906.917,
              1690.529,
              826.555
            ],
            [
              -4962.228,
              1738.229,
              899.593
            ],
            [
              -5070.177,
              1876.997,
              1075.404
            ],
            [
              -5059.079,
              1884.6,
              1088.856
            ],
            [
              -5030.775,
              1917.512,
              1132.265
            ],
            [
              -4999.986,
              1944.816,
              1173.417
            ],
            [
              -4996.021,
              1950.314,
              1180.196
            ],
            [
              -4991.999,
              1959.151,
              1189.905
            ],
            [
              -4993.004,
              1975.866,
              1206.65
            ],
            [
              -4999.984,
              1982.665,
              1216.395
            ],
            [
              -5014.079,
              1988.471,
              1231.639
            ],
            [
              -5108.855,
              1954.468,
              1332.33
            ],
            [
              -5196.989,
              1931.48,
              1423.413
            ],
            [
              -5257.124,
              1923.6,
              1484.062
            ],
            [
              -5290.037,
              1923.047,
              1516.979
            ],
            [
              -5339.624,
              1928.344,
              1566.848
            ],
            [
              -5376.881,
              1937.883,
              1605.308
            ],
            [
              -5383.331,
              1937.993,
              1611.758
            ],
            [
              -5484.519,
              1982.013,
              1722.107
            ],
            [
              -5567.024,
              2024.602,
              1814.955
            ],
            [
              -5630.538,
              2045.716,
              1881.888
            ],
            [
              -5691.568,
              2061.222,
              1944.856
            ],
            [
              -6211.76,
              2165.736,
              2475.443
            ],
            [
              -6281.748,
              2185.837,
              2548.26
            ],
            [
              -6354.831,
              2213.781,
              2626.504
            ],
            [
              -6397.711,
              2234.538,
              2674.143
            ],
            [
              -6460.176,
              2280.113,
              2751.468
            ],
            [
              -6493.177,
              2312.949,
              2798.021
            ],
            [
              -6565.425,
              2390.969,
              2904.355
            ],
            [
              -6589.911,
              2431.453,
              2951.668
            ],
            [
              -6607.928,
              2472.943,
              2996.901
            ],
            [
              -6632.235,
              2485.595,
              3024.304
            ],
            [
              -6654.887,
              2481.521,
              3047.318
            ],
            [
              -6683.251,
              2483.108,
              3075.727
            ],
            [
              -6701.827,
              2491.211,
              3095.993
            ],
            [
              -6715.169,
              2503.679,
              3114.254
            ],
            [
              -6754.084,
              2568.893,
              3190.197
            ],
            [
              -6777.27,
              2571.507,
              3213.529
            ],
            [
              -6819.626,
              2546.611,
              3262.661
            ],
            [
              -6838.704,
              2524.665,
              3291.739
            ],
            [
              -6924.55,
              2368.024,
              3470.362
            ],
            [
              -6961.691,
              2307.418,
              3541.443
            ],
            [
              -7010.001,
              2234.752,
              3628.702
            ],
            [
              -7027.805,
              2211.671,
              3657.852
            ],
            [
              -7050.77,
              2188.677,
              3690.35
            ],
            [
              -7066.361,
              2182.257,
              3707.211
            ],
            [
              -7161.178,
              2183.833,
              3802.041
            ],
            [
              -7411.885,
              2239.197,
              4058.788
            ],
            [
              -7415.939,
              2306.055,
              4125.769
            ],
            [
              -7414.963,
              2365.037,
              4184.76
            ],
            [
              -7420.234,
              2397.407,
              4217.556
            ],
            [
              -7438.554,
              2460.048,
              4282.821
            ],
            [
              -7450.442,
              2521.47,
              4345.382
            ],
            [
              -7450.392,
              2797.537,
              4621.45
            ],
            [
              -7454.355,
              2830.998,
              4655.145
            ],
            [
              -7452.996,
              3069.196,
              4893.347
            ],
            [
              -7460.037,
              3072.652,
              4901.191
            ],
            [
              -7778.827,
              3072.348,
              5219.98
            ],
            [
              -8005.288,
              3074.959,
              5446.457
            ],
            [
              -8103.294,
              3079.907,
              5544.588
            ],
            [
              -8260.799,
              3076.921,
              5702.121
            ],
            [
              -8267.75,
              3085.94,
              5713.507
            ],
            [
              -8266.223,
              3100.386,
              5728.034
            ],
            [
              -8276.79,
              3125.049,
              5754.865
            ],
            [
              -8298.116,
              3123.171,
              5776.274
            ],
            [
              -8338.078,
              3126.051,
              5816.34
            ],
            [
              -8352.88,
              3128.519,
              5831.346
            ],
            [
              -8359.223,
              3135.302,
              5840.632
            ],
            [
              -8353.861,
              3147.459,
              5853.919
            ],
            [
              -8332.208,
              3169.369,
              5884.724
            ],
            [
              -8325.738,
              3170.376,
              5891.271
            ],
            [
              -8314.216,
              3164.622,
              5904.15
            ],
            [
              -8272.328,
              3121.636,
              5964.17
            ],
            [
              -8265.005,
              3095.914,
              5990.915
            ],
            [
              -8267.786,
              3083.714,
              6003.427
            ],
            [
              -8262.716,
              3078.065,
              6011.017
            ],
            [
              -8080.696,
              3080.649,
              6193.056
            ],
            [
              -7967.852,
              3075.457,
              6306.019
            ],
            [
              -7860.114,
              3073.686,
              6413.772
            ],
            [
              -7527.131,
              3073.761,
              6746.754
            ],
            [
              -7458.12,
              3071.507,
              6815.802
            ],
            [
              -7450.286,
              3076.944,
              6825.338
            ],
            [
              -7448.075,
              3093.605,
              6842.145
            ],
            [
              -7447.837,
              3185.995,
              6934.535
            ],
            [
              -7451.285,
              3211.655,
              6960.426
            ],
            [
              -7464.281,
              3245.265,
              6996.461
            ],
            [
              -7482.696,
              3263.381,
              7022.293
            ],
            [
              -7579.806,
              3322.87,
              7136.176
            ],
            [
              -7589.945,
              3334.17,
              7151.357
            ],
            [
              -7609.245,
              3337.828,
              7171.001
            ],
            [
              -7612.987,
              3345.682,
              7179.701
            ],
            [
              -7612.895,
              3351.246,
              7185.266
            ],
            [
              -7606.997,
              3356.715,
              7193.31
            ],
            [
              -7588.268,
              3357.519,
              7212.055
            ],
            [
              -7565.191,
              3387.193,
              7249.647
            ],
            [
              -7850.196,
              3558.868,
              7582.363
            ],
            [
              -7970.179,
              3640.989,
              7727.758
            ],
            [
              -8010.925,
              3675.053,
              7780.868
            ],
            [
              -8074.26,
              3748.448,
              7877.813
            ],
            [
              -8116.47,
              3811.478,
              7953.67
            ],
            [
              -8127.628,
              3839.491,
              7983.823
            ],
            [
              -8136.789,
              3831.848,
              7995.753
            ],
            [
              -8161.184,
              3958.037,
              8124.278
            ],
            [
              -8167.097,
              4030.49,
              8196.972
            ],
            [
              -8128.206,
              4592.005,
              8759.832
            ],
            [
              -8114.065,
              4903.462,
              9071.61
            ],
            [
              -8124.873,
              4913.657,
              9086.468
            ],
            [
              -8158.233,
              4926.449,
              9122.196
            ],
            [
              -8180.177,
              4926.808,
              9144.143
            ],
            [
              -8198.839,
              4930.453,
              9163.157
            ],
            [
              -8215.237,
              4954.098,
              9191.932
            ],
            [
              -8221.863,
              4983.149,
              9221.729
            ],
            [
              -8226.272,
              4989.9,
              9229.792
            ],
            [
              -8636.101,
              4917.551,
              9645.959
            ],
            [
              -8674.97,
              4909.278,
              9685.698
            ],
            [
              -9185.609,
              4829.613,
              10202.514
            ],
            [
              -9269.169,
              4812.038,
              10287.902
            ],
            [
              -9558.495,
              4764.378,
              10581.128
            ],
            [
              -9588.344,
              4754.839,
              10612.463
            ],
            [
              -9674.339,
              4746.201,
              10698.891
            ],
            [
              -9691.208,
              4740.905,
              10716.572
            ],
            [
              -9773.869,
              4738.891,
              10799.258
            ],
            [
              -9802.39,
              4731.556,
              10828.707
            ],
            [
              -9849.213,
              4710.042,
              10880.236
            ],
            [
              -10016.251,
              4679.317,
              11050.076
            ],
            [
              -10029.91,
              4672.856,
              11065.186
            ],
            [
              -10035.843,
              4665.159,
              11074.905
            ],
            [
              -10041.326,
              4645.21,
              11095.594
            ],
            [
              -10038.868,
              4637.378,
              11103.801
            ],
            [
              -10034.44,
              4631.742,
              11110.97
            ],
            [
              -10024.132,
              4630.464,
              11121.356
            ],
            [
              -10003.374,
              4636.812,
              11143.063
            ],
            [
              -9973.634,
              4639.676,
              11172.941
            ],
            [
              -9961.804,
              4652.845,
              11190.643
            ],
            [
              -9954.207,
              4683.892,
              11222.606
            ],
            [
              -9945.048,
              4691.538,
              11234.537
            ],
            [
              -9929.417,
              4700.193,
              11252.405
            ],
            [
              -9859.503,
              4712.433,
              11323.381
            ],
            [
              -9786.723,
              4742.436,
              11402.103
            ],
            [
              -9707.307,
              4743.39,
              11481.525
            ],
            [
              -9671.094,
              4747.262,
              11517.944
            ],
            [
              -9574.594,
              4766.863,
              11616.415
            ],
            [
              -9511.688,
              4784.775,
              11681.821
            ],
            [
              -9185.609,
              4829.613,
              12010.969
            ],
            [
              -9175.58,
              5010.897,
              12192.53
            ],
            [
              -9167.098,
              5056.4,
              12238.817
            ],
            [
              -9158.902,
              5124.171,
              12307.081
            ],
            [
              -9120.102,
              5527.623,
              12712.395
            ],
            [
              -9120.138,
              5525.397,
              12714.621
            ],
            [
              -9105.787,
              5654.292,
              12844.313
            ],
            [
              -9088.239,
              5861.057,
              13051.821
            ],
            [
              -9065.832,
              6048.82,
              13240.916
            ],
            [
              -9042.56,
              6290,
              13483.216
            ],
            [
              -9035.69,
              6315.492,
              13509.617
            ],
            [
              -9027.745,
              6327.608,
              13524.106
            ],
            [
              -9013.989,
              6339.63,
              13542.375
            ],
            [
              -8763.039,
              6403.466,
              13801.317
            ],
            [
              -8591.391,
              6435.185,
              13975.871
            ],
            [
              -8565.567,
              6434.764,
              14001.699
            ],
            [
              -8514.008,
              6428.359,
              14053.653
            ],
            [
              -8481.082,
              6427.822,
              14086.584
            ],
            [
              -8464.869,
              6432.011,
              14103.329
            ],
            [
              -8454.412,
              6439.632,
              14116.269
            ],
            [
              -8442.7,
              6445.007,
              14129.155
            ],
            [
              -8405.319,
              6480.019,
              14180.372
            ],
            [
              -8381.214,
              6492.984,
              14207.743
            ],
            [
              -8362.472,
              6493.791,
              14226.502
            ],
            [
              -8332.81,
              6491.081,
              14256.288
            ],
            [
              -8313.605,
              6480.748,
              14278.096
            ],
            [
              -8257.445,
              6439.757,
              14347.624
            ],
            [
              -8216.781,
              6399.018,
              14405.185
            ],
            [
              -8090.106,
              6365.775,
              14536.149
            ],
            [
              -8047.971,
              6336.143,
              14587.661
            ],
            [
              -7869.852,
              6289.806,
              14771.708
            ],
            [
              -7783.654,
              6269.464,
              14860.274
            ],
            [
              -7104.955,
              6152.496,
              15548.978
            ],
            [
              -7039.365,
              6135.823,
              15616.654
            ],
            [
              -6990.505,
              6122.766,
              15667.229
            ],
            [
              -6923.128,
              6097.155,
              15739.31
            ],
            [
              -6819.933,
              6050.909,
              15852.393
            ],
            [
              -6722.128,
              5991.393,
              15966.883
            ],
            [
              -6610.439,
              6453.723,
              16442.513
            ],
            [
              -6615.859,
              6477.191,
              16466.598
            ],
            [
              -6611.247,
              6482.68,
              16473.768
            ],
            [
              -6601.507,
              6485.856,
              16484.013
            ],
            [
              -6595.808,
              6479.082,
              16492.866
            ],
            [
              -6595.901,
              6473.518,
              16498.431
            ],
            [
              -6598.614,
              6465.771,
              16506.639
            ],
            [
              -6609.831,
              6451.487,
              16524.801
            ],
            [
              -6653.627,
              6265.205,
              16716.162
            ],
            [
              -6722.128,
              5991.393,
              16998.412
            ],
            [
              -6663.331,
              5954.79,
              17067.671
            ],
            [
              -6413.106,
              5704.591,
              17421.524
            ],
            [
              -6357.16,
              5652.447,
              17498.003
            ],
            [
              -6334.791,
              5638.714,
              17524.251
            ],
            [
              -6315.93,
              5608.341,
              17560.004
            ],
            [
              -6284.365,
              5565.511,
              17613.209
            ],
            [
              -6235.578,
              5510.146,
              17687.003
            ],
            [
              -6210.778,
              5487.465,
              17720.61
            ],
            [
              -6170.561,
              5460.073,
              17769.269
            ],
            [
              -6118.615,
              5439.162,
              17825.266
            ],
            [
              -6089.662,
              5433.109,
              17854.845
            ],
            [
              -6052.281,
              5429.14,
              17892.436
            ],
            [
              -6005.048,
              5435.024,
              17940.034
            ],
            [
              -5948.573,
              5452.996,
              17999.3
            ],
            [
              -5873.554,
              5498.484,
              18087.032
            ],
            [
              -5789.253,
              5558.286,
              18190.391
            ],
            [
              -5728.563,
              5596.222,
              18261.961
            ],
            [
              -5697.335,
              5610.165,
              18296.161
            ],
            [
              -5669.446,
              5617.486,
              18324.994
            ],
            [
              -5631.932,
              5621.303,
              18362.703
            ],
            [
              -5582.93,
              5617.134,
              18411.881
            ],
            [
              -5526.428,
              5598.366,
              18471.419
            ],
            [
              -5379.437,
              5509.043,
              18643.421
            ],
            [
              -4710.592,
              5090.204,
              19432.585
            ],
            [
              -4580.889,
              5011.17,
              19584.472
            ],
            [
              -4517.509,
              4980.025,
              19655.091
            ],
            [
              -4380.813,
              4857.45,
              19838.694
            ],
            [
              -4298.311,
              4774.766,
              19955.498
            ],
            [
              -4237.94,
              4719.179,
              20037.563
            ],
            [
              -4229.781,
              4705.68,
              20053.336
            ],
            [
              -4240.925,
              4695.853,
              20068.194
            ],
            [
              -4266.982,
              4719.679,
              20103.503
            ],
            [
              -4289.168,
              4743.439,
              20136.01
            ],
            [
              -4311.679,
              4748.279,
              20159.036
            ],
            [
              -4321.909,
              4754.022,
              20170.767
            ],
            [
              -4333.961,
              4766.474,
              20188.097
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 378.505,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 718.262,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:7730",
              "position": {
                "x": -7438.554,
                "z": 2460.048
              },
              "distanceAlongShapeM": 4282.821,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6300",
              "position": {
                "x": -7454.355,
                "z": 2830.998
              },
              "distanceAlongShapeM": 4655.145,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:18073",
              "position": {
                "x": -8298.116,
                "z": 3123.171
              },
              "distanceAlongShapeM": 5776.274,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6297",
              "position": {
                "x": -7611.222,
                "z": 3413.556
              },
              "distanceAlongShapeM": 7302.68,
              "shapeOffsetM": 1.168,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6294",
              "position": {
                "x": -8136.789,
                "z": 3831.848
              },
              "distanceAlongShapeM": 7995.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6290",
              "position": {
                "x": -8674.97,
                "z": 4909.278
              },
              "distanceAlongShapeM": 9685.698,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6282",
              "position": {
                "x": -9588.344,
                "z": 4754.839
              },
              "distanceAlongShapeM": 10612.463,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1410,
              "departureOffsetSeconds": 1410
            },
            {
              "stopId": "judu:stop:6286",
              "position": {
                "x": -10003.374,
                "z": 4636.812
              },
              "distanceAlongShapeM": 11143.063,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6283",
              "position": {
                "x": -9574.594,
                "z": 4766.863
              },
              "distanceAlongShapeM": 11616.415,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6278",
              "position": {
                "x": -9175.58,
                "z": 5010.897
              },
              "distanceAlongShapeM": 12192.53,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6276",
              "position": {
                "x": -9120.102,
                "z": 5527.623
              },
              "distanceAlongShapeM": 12712.395,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6273",
              "position": {
                "x": -9088.239,
                "z": 5861.057
              },
              "distanceAlongShapeM": 13051.821,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6271",
              "position": {
                "x": -8763.039,
                "z": 6403.466
              },
              "distanceAlongShapeM": 13801.317,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:9776",
              "position": {
                "x": -8090.106,
                "z": 6365.775
              },
              "distanceAlongShapeM": 14536.149,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 16056.92,
              "shapeOffsetM": 0.317,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:357",
              "position": {
                "x": -6598.614,
                "z": 6465.771
              },
              "distanceAlongShapeM": 16506.639,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:4410",
              "position": {
                "x": -6663.331,
                "z": 5954.79
              },
              "distanceAlongShapeM": 17067.671,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5731",
              "position": {
                "x": -6334.791,
                "z": 5638.714
              },
              "distanceAlongShapeM": 17524.251,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 19655.091,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            }
          ],
          "departuresSeconds": [
            19680,
            23700,
            25800,
            30360,
            32280,
            34260,
            42720,
            48840,
            54840,
            57000,
            58560,
            63600,
            65340,
            68340,
            72840,
            79080
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_21",
      "sourceRouteId": "vilnius_bus_21",
      "mode": "bus",
      "shortName": "21",
      "longName": "Lazdynėliai–Lazdynai–Centras",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_21:0",
          "sourceRouteId": "vilnius_bus_21",
          "sourceShapeId": "vilnius_bus_21_a-b",
          "directionId": 0,
          "headsign": "Centras",
          "directionName": "Lazdynėliai–Lazdynai–Centras",
          "mode": "bus",
          "routeShortName": "21",
          "routeLongName": "Lazdynėliai–Lazdynai–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5500.051,
              2967.452,
              0
            ],
            [
              -5505.687,
              2977.567,
              11.579
            ],
            [
              -5506.864,
              2984.266,
              18.38
            ],
            [
              -5506.789,
              2988.717,
              22.833
            ],
            [
              -5500.205,
              2996.398,
              32.949
            ],
            [
              -5484.077,
              2996.124,
              49.079
            ],
            [
              -5478.327,
              2992.687,
              55.778
            ],
            [
              -5475.234,
              2984.842,
              64.21
            ],
            [
              -5479.879,
              2939.28,
              110.009
            ],
            [
              -5471.207,
              2917.982,
              133.005
            ],
            [
              -5262.256,
              2531.491,
              572.363
            ],
            [
              -5252.978,
              2507.956,
              597.661
            ],
            [
              -5128.219,
              2256.474,
              878.389
            ],
            [
              -5121.579,
              2229.644,
              906.028
            ],
            [
              -5117.539,
              2201.745,
              934.218
            ],
            [
              -5116.022,
              2139.38,
              996.601
            ],
            [
              -5122.738,
              2123.91,
              1013.466
            ],
            [
              -5151.175,
              2121.056,
              1042.046
            ],
            [
              -5168.571,
              2122.465,
              1059.499
            ],
            [
              -5186.062,
              2118.311,
              1077.477
            ],
            [
              -5204.976,
              2106.388,
              1099.835
            ],
            [
              -5218.73,
              2094.377,
              1118.095
            ],
            [
              -5232.085,
              2067.888,
              1147.76
            ],
            [
              -5234.987,
              2049.013,
              1166.857
            ],
            [
              -5232.767,
              2027.825,
              1188.161
            ],
            [
              -5229.106,
              2015.517,
              1201.002
            ],
            [
              -5217.174,
              1996.39,
              1223.546
            ],
            [
              -5203.212,
              1982.793,
              1243.035
            ],
            [
              -5082.26,
              1887.222,
              1397.188
            ],
            [
              -5064.922,
              1882.473,
              1415.165
            ],
            [
              -5060.085,
              1863.466,
              1434.777
            ],
            [
              -4961.259,
              1757.137,
              1579.941
            ],
            [
              -4928.804,
              1730.978,
              1621.625
            ],
            [
              -4906.917,
              1690.529,
              1667.617
            ],
            [
              -4952.35,
              1636.759,
              1738.012
            ],
            [
              -4966.71,
              1626.986,
              1755.382
            ],
            [
              -4976.574,
              1616.023,
              1770.129
            ],
            [
              -4993.932,
              1581.81,
              1808.493
            ],
            [
              -4999.643,
              1549.625,
              1841.181
            ],
            [
              -5000.423,
              1503.997,
              1886.816
            ],
            [
              -4985.973,
              1443.638,
              1948.881
            ],
            [
              -4965.718,
              1383.179,
              2012.642
            ],
            [
              -4931.334,
              1319.138,
              2085.33
            ],
            [
              -4880.829,
              1254.822,
              2167.106
            ],
            [
              -4857.956,
              1234.393,
              2197.774
            ],
            [
              -4834.931,
              1222.866,
              2223.523
            ],
            [
              -4813.463,
              1195.782,
              2258.084
            ],
            [
              -4785.375,
              1178.602,
              2291.009
            ],
            [
              -4668.299,
              1122.047,
              2421.029
            ],
            [
              -4620.374,
              1095.621,
              2475.757
            ],
            [
              -4574.442,
              1065.888,
              2530.473
            ],
            [
              -4540.743,
              1037.479,
              2574.549
            ],
            [
              -4440.575,
              860.983,
              2777.489
            ],
            [
              -4425.036,
              789.47,
              2850.67
            ],
            [
              -4406.248,
              756.864,
              2888.302
            ],
            [
              -4380.992,
              725.259,
              2928.758
            ],
            [
              -4355.565,
              703.67,
              2962.115
            ],
            [
              -4324.219,
              688.657,
              2996.87
            ],
            [
              -4302.372,
              683.828,
              3019.244
            ],
            [
              -4269.507,
              682.148,
              3052.153
            ],
            [
              -4233.908,
              689.326,
              3088.468
            ],
            [
              -4200.071,
              706.552,
              3126.438
            ],
            [
              -4154.906,
              744.734,
              3185.579
            ],
            [
              -4134.494,
              768.872,
              3217.191
            ],
            [
              -4089.107,
              782.559,
              3264.597
            ],
            [
              -4026.001,
              813.75,
              3334.99
            ],
            [
              -3968.169,
              838.352,
              3397.838
            ],
            [
              -3939.526,
              853.44,
              3430.211
            ],
            [
              -3921.201,
              868.708,
              3454.063
            ],
            [
              -3904.031,
              891.787,
              3482.829
            ],
            [
              -3887.976,
              924.905,
              3519.633
            ],
            [
              -3883.393,
              966.014,
              3560.997
            ],
            [
              -3887.876,
              1005.054,
              3600.294
            ],
            [
              -3903.754,
              1056.537,
              3654.17
            ],
            [
              -3916.285,
              1077.905,
              3678.941
            ],
            [
              -3919.363,
              1123.6,
              3724.739
            ],
            [
              -3950.775,
              1246.597,
              3851.684
            ],
            [
              -3955.819,
              1253.363,
              3860.123
            ],
            [
              -3970.574,
              1258.072,
              3875.611
            ],
            [
              -4042.541,
              1237.053,
              3950.585
            ],
            [
              -4053.013,
              1228.329,
              3964.215
            ],
            [
              -4057.056,
              1218.38,
              3974.954
            ],
            [
              -4056.603,
              1207.24,
              3986.103
            ],
            [
              -4051.599,
              1198.248,
              3996.394
            ],
            [
              -4044.601,
              1192.561,
              4005.411
            ],
            [
              -4033.696,
              1189.033,
              4016.873
            ],
            [
              -4018.845,
              1189.889,
              4031.749
            ],
            [
              -3829.673,
              1236.704,
              4226.628
            ],
            [
              -3789.4,
              1252.704,
              4269.962
            ],
            [
              -3749.695,
              1273.165,
              4314.629
            ],
            [
              -3705.908,
              1305.8,
              4369.24
            ],
            [
              -3669.839,
              1339.683,
              4418.727
            ],
            [
              -3634.26,
              1382.479,
              4474.382
            ],
            [
              -3619.001,
              1406.704,
              4503.012
            ],
            [
              -3601.633,
              1440.911,
              4541.376
            ],
            [
              -3596.615,
              1469.767,
              4570.665
            ],
            [
              -3579.402,
              1495.072,
              4601.269
            ],
            [
              -3566.606,
              1526.019,
              4634.757
            ],
            [
              -3560.672,
              1570.444,
              4679.576
            ],
            [
              -3561.909,
              1610.54,
              4719.692
            ],
            [
              -3553.124,
              1670.501,
              4780.293
            ],
            [
              -3546.511,
              1753.876,
              4863.93
            ],
            [
              -3528.72,
              1849.302,
              4961
            ],
            [
              -3507.519,
              1881.216,
              4999.314
            ],
            [
              -3466.677,
              1929.485,
              5062.544
            ],
            [
              -3411.117,
              1970.818,
              5131.793
            ],
            [
              -3377.989,
              1983.599,
              5167.3
            ],
            [
              -3293.772,
              2003.28,
              5253.787
            ],
            [
              -3253.06,
              2007.021,
              5294.67
            ],
            [
              -3234.374,
              2005.581,
              5313.411
            ],
            [
              -3211.057,
              2010.74,
              5337.292
            ],
            [
              -2960.432,
              2100.974,
              5603.666
            ],
            [
              -2902.519,
              2128.901,
              5667.961
            ],
            [
              -2763.528,
              2181.007,
              5816.398
            ],
            [
              -2705.632,
              2207.819,
              5880.201
            ],
            [
              -2695.312,
              2207.637,
              5890.523
            ],
            [
              -2620.644,
              2234.153,
              5969.759
            ],
            [
              -2602.113,
              2260.544,
              6002.006
            ],
            [
              -2588.136,
              2284.788,
              6029.99
            ],
            [
              -2571.13,
              2297.847,
              6051.432
            ],
            [
              -2532.153,
              2312.745,
              6093.159
            ],
            [
              -2506.977,
              2313.414,
              6118.344
            ],
            [
              -2483.854,
              2307.44,
              6142.226
            ],
            [
              -2455.846,
              2285.795,
              6177.624
            ],
            [
              -2438.355,
              2253.203,
              6214.612
            ],
            [
              -2433.47,
              2237.532,
              6231.027
            ],
            [
              -2436.603,
              2169.681,
              6298.95
            ],
            [
              -2432.988,
              2155.146,
              6313.929
            ],
            [
              -2421.673,
              2138.248,
              6334.265
            ],
            [
              -2405.237,
              2119.033,
              6359.551
            ],
            [
              -2339.12,
              2063.317,
              6446.013
            ],
            [
              -2328.352,
              2051.995,
              6461.638
            ],
            [
              -2313.635,
              2045.055,
              6477.909
            ],
            [
              -2298.509,
              2024.75,
              6503.229
            ],
            [
              -1944.941,
              1697.877,
              6984.744
            ],
            [
              -1868.675,
              1633.068,
              7084.827
            ],
            [
              -1860.469,
              1622.903,
              7097.891
            ],
            [
              -1769.084,
              1537.785,
              7222.775
            ],
            [
              -1703.649,
              1480.959,
              7309.442
            ],
            [
              -1688.349,
              1470.667,
              7327.881
            ],
            [
              -1678.973,
              1453.802,
              7347.177
            ],
            [
              -1503.095,
              1295.926,
              7583.52
            ],
            [
              -1427.428,
              1234.46,
              7681.007
            ],
            [
              -1409.124,
              1211.868,
              7710.083
            ],
            [
              -1353.311,
              1158.548,
              7787.272
            ],
            [
              -1207.93,
              1027.923,
              7982.716
            ],
            [
              -1188.159,
              1015.323,
              8006.161
            ],
            [
              -1173.062,
              993.901,
              8032.368
            ],
            [
              -1066.972,
              902.938,
              8172.115
            ],
            [
              -958.695,
              862.029,
              8287.862
            ],
            [
              -800.989,
              807.981,
              8454.573
            ],
            [
              -799.135,
              803.495,
              8459.427
            ],
            [
              -799.94,
              794.603,
              8468.355
            ],
            [
              -808.22,
              764.696,
              8499.387
            ],
            [
              -810.251,
              723.543,
              8540.59
            ],
            [
              -829.673,
              683.817,
              8584.81
            ],
            [
              -843.054,
              478.111,
              8790.95
            ],
            [
              -804.926,
              410.63,
              8868.457
            ],
            [
              -682.331,
              234.755,
              9082.844
            ],
            [
              -671.067,
              215.627,
              9105.042
            ],
            [
              -647.308,
              102.762,
              9220.381
            ],
            [
              -591.62,
              115.115,
              9277.422
            ],
            [
              -557.893,
              125.637,
              9312.752
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:16622",
              "position": {
                "x": -5500.051,
                "z": 2967.452
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:3560",
              "position": {
                "x": -5262.256,
                "z": 2531.491
              },
              "distanceAlongShapeM": 572.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:756",
              "position": {
                "x": -5151.175,
                "z": 2121.056
              },
              "distanceAlongShapeM": 1042.046,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7350",
              "position": {
                "x": -4952.35,
                "z": 1636.759
              },
              "distanceAlongShapeM": 1738.012,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:329",
              "position": {
                "x": -4834.931,
                "z": 1222.866
              },
              "distanceAlongShapeM": 2223.523,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:4395",
              "position": {
                "x": -4540.743,
                "z": 1037.479
              },
              "distanceAlongShapeM": 2574.549,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 3217.191,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 3678.941,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6333",
              "position": {
                "x": -3596.615,
                "z": 1469.767
              },
              "distanceAlongShapeM": 4570.665,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:721",
              "position": {
                "x": -3293.772,
                "z": 2003.28
              },
              "distanceAlongShapeM": 5253.787,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 5880.201,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 6477.909,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 7084.827,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 7681.007,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 8006.161,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 8540.59,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 9312.752,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            19980,
            21300,
            22800,
            24420,
            26100,
            27600,
            37740,
            39600,
            41160,
            42720,
            44340,
            45960,
            47640,
            49260,
            50820,
            52500,
            54180,
            55860,
            57540,
            59220,
            61020,
            71280,
            73080,
            74880,
            76260,
            77640,
            79380,
            81300
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_21:1",
          "sourceRouteId": "vilnius_bus_21",
          "sourceShapeId": "vilnius_bus_21_b1-a",
          "directionId": 1,
          "headsign": "Lazdynėliai",
          "directionName": "Centras–Kauno g.–Lazdynai–Lazdynėliai",
          "mode": "bus",
          "routeShortName": "21",
          "routeLongName": "Lazdynėliai–Lazdynai–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -557.893,
              125.637,
              0
            ],
            [
              -539.176,
              126.412,
              18.733
            ],
            [
              -408.498,
              148.538,
              151.271
            ],
            [
              -385.731,
              159.258,
              176.436
            ],
            [
              -216.06,
              268.617,
              378.296
            ],
            [
              -50.385,
              441.496,
              617.744
            ],
            [
              -51.307,
              497.175,
              673.43
            ],
            [
              -56,
              522.864,
              699.545
            ],
            [
              -44.593,
              547.148,
              726.374
            ],
            [
              -34.25,
              619.32,
              799.284
            ],
            [
              -34.886,
              726.201,
              906.167
            ],
            [
              -29.964,
              784,
              964.175
            ],
            [
              -31.514,
              805.179,
              985.411
            ],
            [
              -24.076,
              823.969,
              1005.619
            ],
            [
              -6.94,
              914.942,
              1098.192
            ],
            [
              5.94,
              949.218,
              1134.808
            ],
            [
              14.89,
              980.225,
              1167.081
            ],
            [
              17.976,
              1008,
              1195.027
            ],
            [
              98.858,
              1127.869,
              1339.632
            ],
            [
              206.575,
              1304.022,
              1546.109
            ],
            [
              265.611,
              1357.493,
              1625.761
            ],
            [
              347.967,
              1416.104,
              1726.843
            ],
            [
              403.761,
              1468.519,
              1803.396
            ],
            [
              405.778,
              1472.935,
              1808.251
            ],
            [
              396.871,
              1479.777,
              1819.482
            ],
            [
              393.103,
              1485.412,
              1826.261
            ],
            [
              391.311,
              1493.238,
              1834.289
            ],
            [
              394.908,
              1548.834,
              1890.001
            ],
            [
              392.049,
              1568.924,
              1910.294
            ],
            [
              391.321,
              1670.242,
              2011.614
            ],
            [
              330.657,
              1810.504,
              2164.433
            ],
            [
              156.41,
              1772.494,
              2342.777
            ],
            [
              29.934,
              1735.835,
              2474.459
            ],
            [
              -11.424,
              1732.135,
              2515.983
            ],
            [
              -46.755,
              1740.57,
              2552.307
            ],
            [
              -320.217,
              1781.157,
              2828.764
            ],
            [
              -515.259,
              1841.463,
              3032.916
            ],
            [
              -529.526,
              1766.021,
              3109.695
            ],
            [
              -536.862,
              1752.795,
              3124.819
            ],
            [
              -542.324,
              1736.195,
              3142.294
            ],
            [
              -678.532,
              1124.155,
              3769.308
            ],
            [
              -679.739,
              1093.006,
              3800.48
            ],
            [
              -691.829,
              1066.507,
              3829.606
            ],
            [
              -722.413,
              980.227,
              3921.147
            ],
            [
              -796.476,
              807.9,
              4108.716
            ],
            [
              -803.749,
              798.012,
              4120.991
            ],
            [
              -958.695,
              862.029,
              4288.64
            ],
            [
              -1066.972,
              902.938,
              4404.387
            ],
            [
              -1103.368,
              923.63,
              4446.254
            ],
            [
              -1148.452,
              963.402,
              4506.374
            ],
            [
              -1168.303,
              971.551,
              4527.832
            ],
            [
              -1183.42,
              991.86,
              4553.15
            ],
            [
              -1484.246,
              1267.759,
              4961.337
            ],
            [
              -1502.183,
              1274.758,
              4980.591
            ],
            [
              -1524.902,
              1302.995,
              5016.833
            ],
            [
              -1970.62,
              1705.012,
              5617.069
            ],
            [
              -1985.783,
              1723.093,
              5640.666
            ],
            [
              -2263.842,
              1978.495,
              6018.219
            ],
            [
              -2290.557,
              2000.118,
              6052.589
            ],
            [
              -2318.992,
              2034.018,
              6096.835
            ],
            [
              -2425.036,
              2130.514,
              6240.212
            ],
            [
              -2441.629,
              2140.826,
              6259.748
            ],
            [
              -2453.884,
              2141.043,
              6272.005
            ],
            [
              -2464.869,
              2140.123,
              6283.029
            ],
            [
              -2491.57,
              2126.123,
              6313.177
            ],
            [
              -2514.888,
              2120.968,
              6337.059
            ],
            [
              -2528.453,
              2120.094,
              6350.652
            ],
            [
              -2551.595,
              2124.955,
              6374.298
            ],
            [
              -2561.836,
              2129.588,
              6385.539
            ],
            [
              -2579.681,
              2142.148,
              6407.361
            ],
            [
              -2607.297,
              2186.05,
              6459.226
            ],
            [
              -2618.809,
              2191.819,
              6472.103
            ],
            [
              -2640.075,
              2193.306,
              6493.421
            ],
            [
              -2665.388,
              2184.846,
              6520.11
            ],
            [
              -2681.67,
              2176.227,
              6538.532
            ],
            [
              -2690.837,
              2168.596,
              6550.46
            ],
            [
              -2738.119,
              2158.296,
              6598.851
            ],
            [
              -2899.782,
              2101.023,
              6770.359
            ],
            [
              -2971.67,
              2085.586,
              6843.886
            ],
            [
              -3158.032,
              2017.605,
              7042.26
            ],
            [
              -3215.258,
              1991.889,
              7104.999
            ],
            [
              -3240.098,
              1973.399,
              7135.966
            ],
            [
              -3275.786,
              1961.777,
              7173.498
            ],
            [
              -3353.278,
              1920.828,
              7261.144
            ],
            [
              -3402.898,
              1887.184,
              7321.094
            ],
            [
              -3447.61,
              1838.983,
              7386.84
            ],
            [
              -3464.825,
              1813.679,
              7417.444
            ],
            [
              -3479.576,
              1781.653,
              7452.704
            ],
            [
              -3552.495,
              1521.32,
              7723.057
            ],
            [
              -3555.031,
              1486.855,
              7757.616
            ],
            [
              -3569.097,
              1457.043,
              7790.579
            ],
            [
              -3608.386,
              1386.482,
              7871.341
            ],
            [
              -3647.326,
              1335.952,
              7935.135
            ],
            [
              -3697.872,
              1285.623,
              8006.464
            ],
            [
              -3750.727,
              1250.919,
              8069.694
            ],
            [
              -3785.215,
              1233.706,
              8108.239
            ],
            [
              -3881.236,
              1201.976,
              8209.366
            ],
            [
              -3947.947,
              1186.435,
              8277.864
            ],
            [
              -4025.13,
              1162.167,
              8358.772
            ],
            [
              -4031.069,
              1154.478,
              8368.488
            ],
            [
              -4035.169,
              1141.19,
              8382.394
            ],
            [
              -4036.064,
              1126.734,
              8396.878
            ],
            [
              -4034.322,
              1115.572,
              8408.175
            ],
            [
              -4024.139,
              1107.603,
              8421.105
            ],
            [
              -4011.945,
              1104.053,
              8433.806
            ],
            [
              -3919.363,
              1123.6,
              8528.429
            ],
            [
              -3891.127,
              1040.733,
              8615.974
            ],
            [
              -3876.172,
              1010.417,
              8649.778
            ],
            [
              -3879.245,
              944.791,
              8715.476
            ],
            [
              -3881.411,
              931.47,
              8728.972
            ],
            [
              -3897.582,
              891.676,
              8771.927
            ],
            [
              -3911.432,
              874.104,
              8794.3
            ],
            [
              -3948.102,
              842.457,
              8842.738
            ],
            [
              -4089.107,
              782.559,
              8995.938
            ],
            [
              -4161.662,
              727.04,
              9087.298
            ],
            [
              -4175.491,
              710.581,
              9108.795
            ],
            [
              -4241.116,
              682.771,
              9180.07
            ],
            [
              -4270.228,
              677.707,
              9209.619
            ],
            [
              -4302.372,
              683.828,
              9242.34
            ],
            [
              -4333.814,
              693.276,
              9275.171
            ],
            [
              -4354.294,
              702.534,
              9297.647
            ],
            [
              -4389.905,
              732.091,
              9343.925
            ],
            [
              -4413.832,
              765.9,
              9385.344
            ],
            [
              -4426.952,
              790.616,
              9413.327
            ],
            [
              -4443.78,
              862.151,
              9486.814
            ],
            [
              -4463.138,
              899.22,
              9528.633
            ],
            [
              -4510.16,
              977.953,
              9620.339
            ],
            [
              -4563.16,
              1046.77,
              9707.2
            ],
            [
              -4582.825,
              1066.032,
              9734.727
            ],
            [
              -4608.92,
              1086.518,
              9767.903
            ],
            [
              -4758.008,
              1156.982,
              9932.804
            ],
            [
              -4816.744,
              1192.498,
              10001.443
            ],
            [
              -4874.57,
              1243.583,
              10078.602
            ],
            [
              -4893.764,
              1252.817,
              10099.902
            ],
            [
              -4938.352,
              1323.711,
              10183.652
            ],
            [
              -4959.005,
              1360.8,
              10226.103
            ],
            [
              -4978.198,
              1407.883,
              10276.947
            ],
            [
              -4995.361,
              1460.496,
              10332.29
            ],
            [
              -5000.423,
              1503.997,
              10376.085
            ],
            [
              -5002.906,
              1547.455,
              10419.613
            ],
            [
              -4998.561,
              1575.21,
              10447.706
            ],
            [
              -4985.073,
              1609.489,
              10484.543
            ],
            [
              -4958.06,
              1642.423,
              10527.138
            ],
            [
              -4906.917,
              1690.529,
              10597.351
            ],
            [
              -4962.228,
              1738.229,
              10670.389
            ],
            [
              -4976.074,
              1758.503,
              10694.941
            ],
            [
              -5065.283,
              1861.328,
              10831.07
            ],
            [
              -5078.713,
              1868.237,
              10846.173
            ],
            [
              -5084.328,
              1879.465,
              10858.727
            ],
            [
              -5216.149,
              1980.788,
              11024.989
            ],
            [
              -5235.044,
              2007.826,
              11057.975
            ],
            [
              -5239.9,
              2025.72,
              11076.516
            ],
            [
              -5242.177,
              2043.57,
              11094.511
            ],
            [
              -5239.142,
              2070.235,
              11121.348
            ],
            [
              -5225.085,
              2100.052,
              11154.312
            ],
            [
              -5208.03,
              2116.459,
              11177.977
            ],
            [
              -5183.957,
              2128.294,
              11204.803
            ],
            [
              -5143.89,
              2132.063,
              11245.046
            ],
            [
              -5127.139,
              2130.664,
              11261.856
            ],
            [
              -5121.865,
              2137.254,
              11270.296
            ],
            [
              -5122.054,
              2163.973,
              11297.016
            ],
            [
              -5126.114,
              2190.759,
              11324.108
            ],
            [
              -5124.178,
              2228.575,
              11361.973
            ],
            [
              -5130.799,
              2256.518,
              11390.69
            ],
            [
              -5178.189,
              2353.061,
              11498.237
            ],
            [
              -5259.467,
              2505.84,
              11671.29
            ],
            [
              -5436.233,
              2849.484,
              12057.732
            ],
            [
              -5455.246,
              2869.844,
              12085.59
            ],
            [
              -5458.132,
              2889.93,
              12105.882
            ],
            [
              -5471.207,
              2917.982,
              12136.832
            ],
            [
              -5500.051,
              2967.452,
              12194.097
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 699.545,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 1195.027,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 1546.109,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 1910.294,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 2515.983,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5168",
              "position": {
                "x": -529.526,
                "z": 1766.021
              },
              "distanceAlongShapeM": 3109.695,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 3800.48,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 4527.832,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 4980.591,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 5617.069,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 6052.589,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 6550.46,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:720",
              "position": {
                "x": -3240.098,
                "z": 1973.399
              },
              "distanceAlongShapeM": 7135.966,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:790",
              "position": {
                "x": -3555.031,
                "z": 1486.855
              },
              "distanceAlongShapeM": 7757.616,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 8649.778,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 9108.795,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:16703",
              "position": {
                "x": -4563.16,
                "z": 1046.77
              },
              "distanceAlongShapeM": 9707.2,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5672",
              "position": {
                "x": -4893.764,
                "z": 1252.817
              },
              "distanceAlongShapeM": 10099.902,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7341",
              "position": {
                "x": -4962.228,
                "z": 1738.229
              },
              "distanceAlongShapeM": 10670.389,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7560",
              "position": {
                "x": -5126.114,
                "z": 2190.759
              },
              "distanceAlongShapeM": 11324.108,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:7171",
              "position": {
                "x": -5259.467,
                "z": 2505.84
              },
              "distanceAlongShapeM": 11671.29,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:16622",
              "position": {
                "x": -5500.051,
                "z": 2967.452
              },
              "distanceAlongShapeM": 12194.097,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            21540,
            22860,
            24360,
            25980,
            27900,
            29460,
            34680,
            36540,
            38040,
            39420,
            41280,
            42780,
            44340,
            46020,
            47640,
            49320,
            50940,
            52500,
            54120,
            55800,
            57480,
            59160,
            60900,
            62700,
            68040,
            69720,
            71820,
            72840,
            74640,
            76440,
            77820,
            79260,
            81000,
            82800
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_22",
      "sourceRouteId": "vilnius_bus_22",
      "mode": "bus",
      "shortName": "22",
      "longName": "Lazdynai–Oslo g.–Centras",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_22:0",
          "sourceRouteId": "vilnius_bus_22",
          "sourceShapeId": "vilnius_bus_22_a-b",
          "directionId": 0,
          "headsign": "Centras",
          "directionName": "Lazdynai–Oslo g.–Centras",
          "mode": "bus",
          "routeShortName": "22",
          "routeLongName": "Lazdynai–Oslo g.–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4066.123,
              1738.403,
              0
            ],
            [
              -4047.525,
              1694.666,
              47.526
            ],
            [
              -4037.081,
              1664.429,
              79.517
            ],
            [
              -4020.121,
              1600.683,
              145.48
            ],
            [
              -3992.198,
              1462.162,
              286.787
            ],
            [
              -3984.902,
              1436.432,
              313.532
            ],
            [
              -3986.154,
              1438.68,
              316.104
            ],
            [
              -3968.906,
              1391.627,
              366.219
            ],
            [
              -3969.311,
              1368.257,
              389.593
            ],
            [
              -3952.68,
              1285.592,
              473.914
            ],
            [
              -3953.633,
              1267.797,
              491.735
            ],
            [
              -3986.792,
              1252.786,
              528.133
            ],
            [
              -4052.311,
              1231.656,
              596.974
            ],
            [
              -4088.482,
              1228.943,
              633.247
            ],
            [
              -4121.332,
              1231.737,
              666.216
            ],
            [
              -4147.695,
              1236.645,
              693.032
            ],
            [
              -4215.081,
              1256.734,
              763.348
            ],
            [
              -4241.916,
              1271.669,
              794.06
            ],
            [
              -4268.203,
              1281.028,
              821.963
            ],
            [
              -4527.979,
              1404.616,
              1109.639
            ],
            [
              -4558.781,
              1414.051,
              1141.854
            ],
            [
              -4581.673,
              1433.369,
              1171.807
            ],
            [
              -4718.251,
              1519.203,
              1333.118
            ],
            [
              -4838.028,
              1606.973,
              1481.611
            ],
            [
              -4906.917,
              1690.529,
              1589.903
            ],
            [
              -4962.228,
              1738.229,
              1662.941
            ],
            [
              -5070.177,
              1876.997,
              1838.752
            ],
            [
              -5277.196,
              2033.034,
              2097.991
            ],
            [
              -5274.521,
              2038.555,
              2104.125
            ],
            [
              -5253.123,
              2044.87,
              2126.436
            ],
            [
              -5249.139,
              2051.481,
              2134.155
            ],
            [
              -5249.689,
              2057.056,
              2139.757
            ],
            [
              -5238.402,
              2075.788,
              2161.627
            ],
            [
              -5197.9,
              2105.154,
              2211.655
            ],
            [
              -5149.809,
              2125.485,
              2263.867
            ],
            [
              -5115.548,
              2129.353,
              2298.346
            ],
            [
              -5117.029,
              2042.549,
              2385.162
            ],
            [
              -4759.188,
              2066.486,
              2743.803
            ],
            [
              -4628.554,
              2084.282,
              2875.643
            ],
            [
              -4532.335,
              2089.308,
              2971.994
            ],
            [
              -4413.578,
              2091.718,
              3090.775
            ],
            [
              -4171.807,
              2044.134,
              3337.184
            ],
            [
              -4056.112,
              2018.757,
              3455.63
            ],
            [
              -4034.827,
              2018.389,
              3476.918
            ],
            [
              -4018.212,
              2009.195,
              3495.907
            ],
            [
              -3691.362,
              1920.037,
              3834.699
            ],
            [
              -3598.621,
              1910.632,
              3927.915
            ],
            [
              -3547.649,
              1910.858,
              3978.889
            ],
            [
              -3479.107,
              1919.683,
              4047.996
            ],
            [
              -3376.715,
              1945.728,
              4153.649
            ],
            [
              -3255.325,
              1988.136,
              4282.233
            ],
            [
              -3211.057,
              2010.74,
              4331.938
            ],
            [
              -3076.57,
              2064.047,
              4476.605
            ],
            [
              -3025.322,
              2079.847,
              4530.233
            ],
            [
              -2969.481,
              2100.019,
              4589.605
            ],
            [
              -2931.778,
              2116.056,
              4630.577
            ],
            [
              -2890.752,
              2137.6,
              4676.916
            ],
            [
              -2705.632,
              2207.819,
              4874.906
            ],
            [
              -2695.312,
              2207.637,
              4885.228
            ],
            [
              -2620.644,
              2234.153,
              4964.464
            ],
            [
              -2602.113,
              2260.544,
              4996.711
            ],
            [
              -2588.136,
              2284.788,
              5024.696
            ],
            [
              -2571.13,
              2297.847,
              5046.137
            ],
            [
              -2549.022,
              2307.476,
              5070.251
            ],
            [
              -2532.153,
              2312.745,
              5087.924
            ],
            [
              -2506.977,
              2313.414,
              5113.109
            ],
            [
              -2483.854,
              2307.44,
              5136.991
            ],
            [
              -2455.846,
              2285.795,
              5172.389
            ],
            [
              -2438.355,
              2253.203,
              5209.377
            ],
            [
              -2433.47,
              2237.532,
              5225.792
            ],
            [
              -2436.603,
              2169.681,
              5293.715
            ],
            [
              -2432.988,
              2155.146,
              5308.694
            ],
            [
              -2421.673,
              2138.248,
              5329.03
            ],
            [
              -2405.237,
              2119.033,
              5354.316
            ],
            [
              -2339.12,
              2063.317,
              5440.778
            ],
            [
              -2328.352,
              2051.995,
              5456.403
            ],
            [
              -2313.635,
              2045.055,
              5472.674
            ],
            [
              -2298.509,
              2024.75,
              5497.994
            ],
            [
              -1944.941,
              1697.877,
              5979.509
            ],
            [
              -1868.675,
              1633.068,
              6079.592
            ],
            [
              -1860.469,
              1622.903,
              6092.656
            ],
            [
              -1769.084,
              1537.785,
              6217.54
            ],
            [
              -1703.649,
              1480.959,
              6304.207
            ],
            [
              -1688.349,
              1470.667,
              6322.646
            ],
            [
              -1678.973,
              1453.802,
              6341.942
            ],
            [
              -1503.095,
              1295.926,
              6578.285
            ],
            [
              -1427.428,
              1234.46,
              6675.772
            ],
            [
              -1409.124,
              1211.868,
              6704.848
            ],
            [
              -1353.311,
              1158.548,
              6782.037
            ],
            [
              -1207.93,
              1027.923,
              6977.481
            ],
            [
              -1188.159,
              1015.323,
              7000.926
            ],
            [
              -1173.062,
              993.901,
              7027.133
            ],
            [
              -1066.972,
              902.938,
              7166.88
            ],
            [
              -958.695,
              862.029,
              7282.628
            ],
            [
              -800.989,
              807.981,
              7449.338
            ],
            [
              -799.135,
              803.495,
              7454.192
            ],
            [
              -799.94,
              794.603,
              7463.12
            ],
            [
              -808.22,
              764.696,
              7494.152
            ],
            [
              -810.251,
              723.543,
              7535.355
            ],
            [
              -824.878,
              699.315,
              7563.656
            ],
            [
              -838.2,
              496.948,
              7766.461
            ],
            [
              -838.156,
              463.551,
              7799.858
            ],
            [
              -823.183,
              435.45,
              7831.699
            ],
            [
              -689.041,
              256.028,
              8055.722
            ],
            [
              -671.067,
              215.627,
              8099.941
            ],
            [
              -634.631,
              19.041,
              8299.875
            ],
            [
              -585.127,
              -96.516,
              8425.59
            ],
            [
              -570.097,
              -121.279,
              8454.557
            ],
            [
              -567.275,
              -143.594,
              8477.05
            ],
            [
              -513.161,
              -289.293,
              8632.474
            ],
            [
              -501.093,
              -299.53,
              8648.299
            ],
            [
              -461.426,
              -352.57,
              8714.531
            ],
            [
              -449.339,
              -361.695,
              8729.675
            ],
            [
              -413.017,
              -421.354,
              8799.521
            ],
            [
              -305.298,
              -348.72,
              8929.441
            ],
            [
              -335.653,
              -209.016,
              9072.405
            ],
            [
              -372.48,
              -212.801,
              9109.427
            ],
            [
              -418.232,
              -210.859,
              9155.22
            ],
            [
              -451.474,
              -230.295,
              9193.726
            ],
            [
              -476.052,
              -269.926,
              9240.36
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 366.219,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 763.348,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 1141.854,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 1481.611,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6350",
              "position": {
                "x": -4413.578,
                "z": 2091.718
              },
              "distanceAlongShapeM": 3090.775,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6352",
              "position": {
                "x": -4034.827,
                "z": 2018.389
              },
              "distanceAlongShapeM": 3476.918,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 4874.906,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 5472.674,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 6079.592,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 6675.772,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 7000.926,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 7535.355,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 8454.557,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5258",
              "position": {
                "x": -449.339,
                "z": -361.695
              },
              "distanceAlongShapeM": 8729.675,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7663",
              "position": {
                "x": -372.48,
                "z": -212.801
              },
              "distanceAlongShapeM": 9109.427,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            19800,
            21600,
            23100,
            24120,
            25320,
            26820,
            28260,
            29700,
            32460,
            34500,
            37320,
            38700,
            41100,
            42900,
            44820,
            46680,
            48480,
            50400,
            52200,
            54060,
            55860,
            57720,
            58740,
            60360,
            61980,
            63060,
            64800,
            67260,
            69660,
            70920,
            72240,
            73740,
            75780,
            77400,
            79260,
            81000,
            82800
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_22:1",
          "sourceRouteId": "vilnius_bus_22",
          "sourceShapeId": "vilnius_bus_22_b-a",
          "directionId": 1,
          "headsign": "Lazdynai",
          "directionName": "Centras–Oslo g.–Lazdynai",
          "mode": "bus",
          "routeShortName": "22",
          "routeLongName": "Lazdynai–Oslo g.–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -476.052,
              -269.926,
              0
            ],
            [
              -501.093,
              -299.53,
              38.774
            ],
            [
              -510.139,
              -300.48,
              47.87
            ],
            [
              -513.322,
              -298.196,
              51.787
            ],
            [
              -611.52,
              -58.189,
              311.106
            ],
            [
              -615.308,
              -53.668,
              317.004
            ],
            [
              -625.745,
              -24.535,
              347.95
            ],
            [
              -646.921,
              17.037,
              394.605
            ],
            [
              -652.524,
              63.893,
              441.795
            ],
            [
              -682.331,
              234.755,
              615.238
            ],
            [
              -830.115,
              444.481,
              871.802
            ],
            [
              -843.054,
              478.111,
              907.835
            ],
            [
              -829.673,
              683.817,
              1113.975
            ],
            [
              -833.364,
              729.525,
              1159.833
            ],
            [
              -839.916,
              759.701,
              1190.711
            ],
            [
              -844.854,
              772.035,
              1203.997
            ],
            [
              -845.743,
              794.315,
              1226.295
            ],
            [
              -856.909,
              819.008,
              1253.394
            ],
            [
              -958.695,
              862.029,
              1363.899
            ],
            [
              -1094.5,
              914.565,
              1509.512
            ],
            [
              -1148.512,
              960.063,
              1580.134
            ],
            [
              -1168.303,
              971.551,
              1603.016
            ],
            [
              -1183.42,
              991.86,
              1628.334
            ],
            [
              -1484.246,
              1267.759,
              2036.521
            ],
            [
              -1502.183,
              1274.758,
              2055.776
            ],
            [
              -1524.902,
              1302.995,
              2092.017
            ],
            [
              -1970.62,
              1705.012,
              2692.253
            ],
            [
              -1985.783,
              1723.093,
              2715.85
            ],
            [
              -2263.842,
              1978.495,
              3093.403
            ],
            [
              -2290.557,
              2000.118,
              3127.773
            ],
            [
              -2318.992,
              2034.018,
              3172.019
            ],
            [
              -2425.036,
              2130.514,
              3315.396
            ],
            [
              -2441.629,
              2140.826,
              3334.933
            ],
            [
              -2464.869,
              2140.123,
              3358.183
            ],
            [
              -2491.57,
              2126.123,
              3388.332
            ],
            [
              -2503.239,
              2122.989,
              3400.414
            ],
            [
              -2528.453,
              2120.094,
              3425.794
            ],
            [
              -2543.249,
              2122.581,
              3440.798
            ],
            [
              -2561.836,
              2129.588,
              3460.662
            ],
            [
              -2579.681,
              2142.148,
              3482.484
            ],
            [
              -2607.297,
              2186.05,
              3534.349
            ],
            [
              -2618.809,
              2191.819,
              3547.226
            ],
            [
              -2640.075,
              2193.306,
              3568.544
            ],
            [
              -2665.388,
              2184.846,
              3595.233
            ],
            [
              -2681.67,
              2176.227,
              3613.655
            ],
            [
              -2690.837,
              2168.596,
              3625.583
            ],
            [
              -2745.273,
              2155.082,
              3681.671
            ],
            [
              -2858.912,
              2113.664,
              3802.623
            ],
            [
              -2885.494,
              2106.338,
              3830.196
            ],
            [
              -2963.852,
              2089.902,
              3910.259
            ],
            [
              -3175.505,
              2014.571,
              4134.918
            ],
            [
              -3269.787,
              1972.804,
              4238.038
            ],
            [
              -3463.705,
              1914.962,
              4440.398
            ],
            [
              -3534.885,
              1902.843,
              4512.603
            ],
            [
              -3642.009,
              1901.368,
              4619.737
            ],
            [
              -3703.185,
              1907.997,
              4681.271
            ],
            [
              -3763.581,
              1922.405,
              4743.361
            ],
            [
              -4034.529,
              1998.346,
              5024.751
            ],
            [
              -4082.845,
              2002.521,
              5073.248
            ],
            [
              -4108.472,
              2012.983,
              5100.927
            ],
            [
              -4294.183,
              2056.264,
              5291.615
            ],
            [
              -4414.529,
              2073.923,
              5413.25
            ],
            [
              -4474.572,
              2071.617,
              5473.337
            ],
            [
              -4495.173,
              2074.198,
              5494.099
            ],
            [
              -4714.759,
              2061.271,
              5714.066
            ],
            [
              -4881.095,
              2030.725,
              5883.183
            ],
            [
              -4920.175,
              2009.13,
              5927.833
            ],
            [
              -4946.317,
              1989.54,
              5960.501
            ],
            [
              -5070.177,
              1876.997,
              6127.854
            ],
            [
              -4961.259,
              1757.137,
              6289.809
            ],
            [
              -4928.804,
              1730.978,
              6331.493
            ],
            [
              -4906.917,
              1690.529,
              6377.485
            ],
            [
              -4842.797,
              1742.865,
              6460.252
            ],
            [
              -4801.101,
              1766.641,
              6508.25
            ],
            [
              -4774.467,
              1777.316,
              6536.944
            ],
            [
              -4728.427,
              1790.998,
              6584.974
            ],
            [
              -4687.68,
              1796.979,
              6626.158
            ],
            [
              -4579.155,
              1805.134,
              6734.989
            ],
            [
              -4547.361,
              1815.72,
              6768.499
            ],
            [
              -4518.395,
              1811.882,
              6797.718
            ],
            [
              -4300.033,
              1829.272,
              7016.771
            ],
            [
              -4282.619,
              1828.972,
              7034.188
            ],
            [
              -4257.523,
              1825.2,
              7059.566
            ],
            [
              -4165.014,
              1802.452,
              7154.831
            ],
            [
              -4141.304,
              1793.136,
              7180.305
            ],
            [
              -4122.773,
              1782.797,
              7201.525
            ],
            [
              -4066.123,
              1738.403,
              7273.498
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6356",
              "position": {
                "x": -476.052,
                "z": -269.926
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -720,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 394.605,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:683",
              "position": {
                "x": -844.854,
                "z": 772.035
              },
              "distanceAlongShapeM": 1203.997,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 1603.016,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 2055.776,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 2692.253,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 3127.773,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 3625.583,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6353",
              "position": {
                "x": -4082.845,
                "z": 2002.521
              },
              "distanceAlongShapeM": 5073.248,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6351",
              "position": {
                "x": -4474.572,
                "z": 2071.617
              },
              "distanceAlongShapeM": 5473.337,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 6331.493,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 6768.499,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 7273.498,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            }
          ],
          "departuresSeconds": [
            20520,
            22020,
            24180,
            25680,
            26880,
            28320,
            31140,
            34980,
            37380,
            39780,
            41640,
            43560,
            45360,
            47160,
            49080,
            50880,
            52740,
            54540,
            56400,
            58860,
            60360,
            61440,
            63180,
            65760,
            69600,
            72480,
            74520,
            76140,
            78000,
            79800,
            81660,
            83400
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_24",
      "sourceRouteId": "vilnius_bus_24",
      "mode": "bus",
      "shortName": "24",
      "longName": "Fabijoniškės–Ukmergės g.–Žemieji Paneriai (Apylanka per P. Žadeikos g.)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_24:0",
          "sourceRouteId": "vilnius_bus_24",
          "sourceShapeId": "vilnius_bus_24_a-b",
          "directionId": 0,
          "headsign": "Žemieji Paneriai (Apylanka per P. Žadeikos g.)",
          "directionName": "Fabijoniškės–Ukmergės g.–Žemieji Paneriai (Apylanka per P. Žadeikos g.)",
          "mode": "bus",
          "routeShortName": "24",
          "routeLongName": "Fabijoniškės–Ukmergės g.–Žemieji Paneriai (Apylanka per P. Žadeikos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2464.27,
              -5705.856,
              27.473
            ],
            [
              -2454.941,
              -5688.21,
              47.434
            ],
            [
              -2458.022,
              -5680.363,
              55.864
            ],
            [
              -2467.523,
              -5671.289,
              69.002
            ],
            [
              -2484.515,
              -5648.724,
              97.249
            ],
            [
              -2456.526,
              -5595.784,
              157.132
            ],
            [
              -2438.766,
              -5574.947,
              184.511
            ],
            [
              -2323.024,
              -5404.447,
              390.585
            ],
            [
              -2243.521,
              -5280.062,
              538.207
            ],
            [
              -2221.212,
              -5257.08,
              570.237
            ],
            [
              -2172.788,
              -5214.524,
              634.703
            ],
            [
              -2110.315,
              -5178.897,
              706.62
            ],
            [
              -2139.87,
              -5138.296,
              756.839
            ],
            [
              -2215.749,
              -4985.55,
              927.394
            ],
            [
              -2263.134,
              -4896.764,
              1028.033
            ],
            [
              -2303.85,
              -4831.475,
              1104.978
            ],
            [
              -2250.757,
              -4780.095,
              1178.861
            ],
            [
              -2249.272,
              -4768.989,
              1190.066
            ],
            [
              -2217.023,
              -4730.598,
              1240.204
            ],
            [
              -2199.094,
              -4664.123,
              1309.055
            ],
            [
              -2245.99,
              -4656.611,
              1356.55
            ],
            [
              -2248.369,
              -4645.437,
              1367.974
            ],
            [
              -2421.69,
              -4610.083,
              1544.864
            ],
            [
              -2609.045,
              -4566.695,
              1737.178
            ],
            [
              -2744.388,
              -4496.401,
              1889.687
            ],
            [
              -2770.134,
              -4531.57,
              1933.273
            ],
            [
              -2804.177,
              -4598.877,
              2008.699
            ],
            [
              -2799.786,
              -4605.634,
              2016.757
            ],
            [
              -2737.686,
              -4627.879,
              2082.721
            ],
            [
              -2739.677,
              -4631.184,
              2086.579
            ],
            [
              -2716.063,
              -4643.846,
              2113.373
            ],
            [
              -2663.507,
              -4659.245,
              2168.139
            ],
            [
              -2601.622,
              -4511.165,
              2328.63
            ],
            [
              -2575.776,
              -4470.432,
              2376.871
            ],
            [
              -2510.179,
              -4331.325,
              2530.669
            ],
            [
              -2380.854,
              -3977.381,
              2907.499
            ],
            [
              -2366.341,
              -3921.977,
              2964.773
            ],
            [
              -2313.476,
              -3774.854,
              3121.105
            ],
            [
              -2292.987,
              -3709.537,
              3189.56
            ],
            [
              -2289.819,
              -3676.197,
              3223.051
            ],
            [
              -2072.945,
              -3075.564,
              3861.638
            ],
            [
              -2044.086,
              -2974.773,
              3966.479
            ],
            [
              -2024.769,
              -2939.494,
              4006.701
            ],
            [
              -2004.312,
              -2876.403,
              4073.025
            ],
            [
              -1942.85,
              -2718.306,
              4242.65
            ],
            [
              -1911.924,
              -2646.496,
              4320.835
            ],
            [
              -1897.194,
              -2615.588,
              4355.074
            ],
            [
              -1889.264,
              -2604.597,
              4368.627
            ],
            [
              -1854.797,
              -2587.399,
              4407.146
            ],
            [
              -1805.935,
              -2485.853,
              4519.837
            ],
            [
              -1803.13,
              -2436.921,
              4568.849
            ],
            [
              -1757.32,
              -2362.039,
              4656.633
            ],
            [
              -1747.763,
              -2332.152,
              4688.01
            ],
            [
              -1727.311,
              -2305.799,
              4721.368
            ],
            [
              -1547.472,
              -2017.345,
              5061.291
            ],
            [
              -1343.434,
              -1674.784,
              5460.014
            ],
            [
              -1305.861,
              -1628.702,
              5519.472
            ],
            [
              -1268.647,
              -1602.651,
              5564.898
            ],
            [
              -1054.592,
              -1494.059,
              5804.922
            ],
            [
              -1027.103,
              -1471.176,
              5840.689
            ],
            [
              -1009.966,
              -1450.333,
              5867.673
            ],
            [
              -1001.511,
              -1410.409,
              5908.482
            ],
            [
              -985.002,
              -1352.818,
              5968.393
            ],
            [
              -969.183,
              -1226.195,
              6096.001
            ],
            [
              -953.408,
              -1066.174,
              6256.797
            ],
            [
              -934.629,
              -918.453,
              6405.707
            ],
            [
              -924.604,
              -648.119,
              6676.227
            ],
            [
              -925.676,
              -600.231,
              6724.127
            ],
            [
              -929.003,
              -570.114,
              6754.427
            ],
            [
              -964.777,
              -408.052,
              6920.39
            ],
            [
              -1000.013,
              -215.943,
              7115.704
            ],
            [
              -1017.212,
              -96.519,
              7236.36
            ],
            [
              -1029.126,
              -41.756,
              7292.404
            ],
            [
              -1032.456,
              167.59,
              7501.776
            ],
            [
              -1030.831,
              222.109,
              7556.319
            ],
            [
              -1020.545,
              292.057,
              7627.02
            ],
            [
              -1020.085,
              317.653,
              7652.62
            ],
            [
              -1024.702,
              347.793,
              7683.112
            ],
            [
              -1037.097,
              375.846,
              7713.782
            ],
            [
              -1053.401,
              401.744,
              7744.384
            ],
            [
              -1069.805,
              422.076,
              7770.508
            ],
            [
              -1102.209,
              449.376,
              7812.879
            ],
            [
              -1121.977,
              461.976,
              7836.321
            ],
            [
              -1146.339,
              470.206,
              7862.035
            ],
            [
              -1195.182,
              479.988,
              7911.849
            ],
            [
              -1304.169,
              480.829,
              8020.839
            ],
            [
              -1381.382,
              491.117,
              8098.735
            ],
            [
              -1420.535,
              501.837,
              8139.328
            ],
            [
              -1524.997,
              539.327,
              8250.315
            ],
            [
              -1569.289,
              551.25,
              8296.183
            ],
            [
              -1665.104,
              567.432,
              8393.355
            ],
            [
              -1735.128,
              583.152,
              8465.122
            ],
            [
              -1778.032,
              600.615,
              8511.443
            ],
            [
              -1818.783,
              630.284,
              8561.851
            ],
            [
              -1845.737,
              674.179,
              8613.361
            ],
            [
              -1887.316,
              766.203,
              8714.342
            ],
            [
              -2023.359,
              1241.737,
              9208.954
            ],
            [
              -2036.836,
              1282.052,
              9251.462
            ],
            [
              -2055.531,
              1319.12,
              9292.977
            ],
            [
              -2069.692,
              1357.221,
              9333.624
            ],
            [
              -2131.9,
              1450.721,
              9445.928
            ],
            [
              -2187.002,
              1508.471,
              9525.749
            ],
            [
              -2364.512,
              1685.273,
              9776.285
            ],
            [
              -2405.647,
              1730.529,
              9837.442
            ],
            [
              -2432.322,
              1754.377,
              9873.224
            ],
            [
              -2457.669,
              1780.429,
              9909.571
            ],
            [
              -2470.84,
              1801.812,
              9934.685
            ],
            [
              -2517.308,
              1910.614,
              10052.995
            ],
            [
              -2537.025,
              1963.282,
              10109.233
            ],
            [
              -2549.238,
              2002.46,
              10150.27
            ],
            [
              -2554.454,
              2035.948,
              10184.162
            ],
            [
              -2559.337,
              2088.355,
              10236.796
            ],
            [
              -2553.059,
              2151.698,
              10300.449
            ],
            [
              -2551.884,
              2181.734,
              10330.508
            ],
            [
              -2553.368,
              2207.364,
              10356.181
            ],
            [
              -2550.57,
              2256.296,
              10405.193
            ],
            [
              -2554.497,
              2289.761,
              10438.888
            ],
            [
              -2570.814,
              2352.389,
              10503.606
            ],
            [
              -2586.213,
              2430.585,
              10583.304
            ],
            [
              -2602.898,
              2582.275,
              10735.91
            ],
            [
              -2619.569,
              2661.607,
              10816.974
            ],
            [
              -2672.012,
              2798.342,
              10963.421
            ],
            [
              -2693.846,
              2841.028,
              11011.367
            ],
            [
              -2698.439,
              2873.392,
              11044.055
            ],
            [
              -2831.804,
              3253.114,
              11446.516
            ],
            [
              -2853.662,
              3294.686,
              11493.485
            ],
            [
              -2870.652,
              3319.475,
              11523.537
            ],
            [
              -2888.502,
              3332.034,
              11545.363
            ],
            [
              -2904.222,
              3355.687,
              11573.763
            ],
            [
              -3126.24,
              3576.651,
              11887
            ],
            [
              -3256.351,
              3702.491,
              12068.01
            ],
            [
              -3334.924,
              3786.24,
              12182.846
            ],
            [
              -3406.008,
              3855.385,
              12282.013
            ],
            [
              -3427.01,
              3872.449,
              12309.074
            ],
            [
              -3454.8,
              3907.442,
              12353.76
            ],
            [
              -3626.746,
              4078.528,
              12596.32
            ],
            [
              -3781.512,
              4235.95,
              12817.078
            ],
            [
              -3884.317,
              4337.92,
              12961.877
            ],
            [
              -3915.514,
              4362.95,
              13001.874
            ],
            [
              -3928.112,
              4380.98,
              13023.869
            ],
            [
              -4226.292,
              4683.356,
              13448.537
            ],
            [
              -4305.622,
              4762.647,
              13560.698
            ],
            [
              -4338.114,
              4787.696,
              13601.726
            ],
            [
              -4349.425,
              4805.702,
              13622.99
            ],
            [
              -4420.502,
              4877.057,
              13723.704
            ],
            [
              -4439.501,
              4898.534,
              13752.379
            ],
            [
              -4461.157,
              4915.604,
              13779.954
            ],
            [
              -4476.532,
              4922.548,
              13796.824
            ],
            [
              -4488.111,
              4924.973,
              13808.655
            ],
            [
              -4508.363,
              4948.698,
              13839.847
            ],
            [
              -4600.366,
              5004.825,
              13947.619
            ],
            [
              -4658.205,
              5020.288,
              14007.49
            ],
            [
              -4736.87,
              5026.089,
              14086.368
            ],
            [
              -4780.873,
              5020.164,
              14130.768
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 157.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 756.839,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5803",
              "position": {
                "x": -2249.272,
                "z": -4768.989
              },
              "distanceAlongShapeM": 1190.066,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 1356.55,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:364",
              "position": {
                "x": -2737.686,
                "z": -4627.879
              },
              "distanceAlongShapeM": 2082.721,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7896",
              "position": {
                "x": -2601.622,
                "z": -4511.165
              },
              "distanceAlongShapeM": 2328.63,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5450",
              "position": {
                "x": -2366.341,
                "z": -3921.977
              },
              "distanceAlongShapeM": 2964.773,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5451",
              "position": {
                "x": -2289.819,
                "z": -3676.197
              },
              "distanceAlongShapeM": 3223.051,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5452",
              "position": {
                "x": -2044.086,
                "z": -2974.773
              },
              "distanceAlongShapeM": 3966.479,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 4688.01,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 5908.482,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5774",
              "position": {
                "x": -1029.126,
                "z": -41.756
              },
              "distanceAlongShapeM": 7292.404,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5778",
              "position": {
                "x": -2055.531,
                "z": 1319.12
              },
              "distanceAlongShapeM": 9292.977,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5779",
              "position": {
                "x": -2457.669,
                "z": 1780.429
              },
              "distanceAlongShapeM": 9909.571,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7358",
              "position": {
                "x": -2553.368,
                "z": 2207.364
              },
              "distanceAlongShapeM": 10356.181,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 11011.367,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 11545.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 12309.074,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 13001.874,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 13601.726,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 13808.655,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5557",
              "position": {
                "x": -4780.873,
                "z": 5020.164
              },
              "distanceAlongShapeM": 14130.768,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            18660,
            19860,
            21060,
            22260,
            23460,
            24240,
            25200,
            26220,
            27120,
            28020,
            28800,
            29940,
            31080,
            32280,
            33960,
            35760,
            37860,
            40680,
            43380,
            45900,
            48660,
            50160,
            51780,
            53100,
            54840,
            55740,
            57180,
            58080,
            58980,
            59880,
            61200,
            61800,
            63180,
            64440,
            65940,
            67620,
            69840,
            71760,
            74820,
            77280,
            79800,
            82080
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_24:1",
          "sourceRouteId": "vilnius_bus_24",
          "sourceShapeId": "vilnius_bus_24_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės (Apylanka per P. Žadeikos g.)",
          "directionName": "Žemieji Paneriai–Ukmergės g.–Fabijoniškės (Apylanka per P. Žadeikos g.)",
          "mode": "bus",
          "routeShortName": "24",
          "routeLongName": "Fabijoniškės–Ukmergės g.–Žemieji Paneriai (Apylanka per P. Žadeikos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4780.873,
              5020.164,
              0
            ],
            [
              -4794.293,
              5028.186,
              15.635
            ],
            [
              -4887.841,
              5032.012,
              109.261
            ],
            [
              -4834.705,
              5081.197,
              181.667
            ],
            [
              -4785.441,
              5130.448,
              251.327
            ],
            [
              -4754.629,
              5157.75,
              292.495
            ],
            [
              -4724.691,
              5171.709,
              325.527
            ],
            [
              -4669.05,
              5178.548,
              381.587
            ],
            [
              -4632.924,
              5176.815,
              417.754
            ],
            [
              -4599.437,
              5171.788,
              451.616
            ],
            [
              -4586.132,
              5157.088,
              471.444
            ],
            [
              -4583.042,
              5111.394,
              517.242
            ],
            [
              -4580.889,
              5011.17,
              617.49
            ],
            [
              -4517.509,
              4980.025,
              688.108
            ],
            [
              -4503.635,
              4960.862,
              711.766
            ],
            [
              -4444.377,
              4915.316,
              786.505
            ],
            [
              -4189.698,
              4671.592,
              1139.014
            ],
            [
              -4166.695,
              4657.837,
              1165.816
            ],
            [
              -4146.524,
              4629.659,
              1200.47
            ],
            [
              -4048.773,
              4533.349,
              1337.696
            ],
            [
              -3823.59,
              4303.471,
              1659.489
            ],
            [
              -3802.623,
              4284.184,
              1687.978
            ],
            [
              -3780.952,
              4268.223,
              1714.892
            ],
            [
              -3768.394,
              4247.967,
              1738.725
            ],
            [
              -3367.467,
              3844.694,
              2307.383
            ],
            [
              -3344.49,
              3829.822,
              2334.753
            ],
            [
              -3315.43,
              3793.692,
              2381.119
            ],
            [
              -3282.402,
              3763.059,
              2426.166
            ],
            [
              -3142.94,
              3618.132,
              2627.296
            ],
            [
              -2996.449,
              3469.738,
              2835.816
            ],
            [
              -2905.063,
              3381.305,
              2962.984
            ],
            [
              -2851.864,
              3323.598,
              3041.472
            ],
            [
              -2827.523,
              3276.416,
              3094.563
            ],
            [
              -2808.656,
              3248.254,
              3128.46
            ],
            [
              -2806.545,
              3221.5,
              3155.297
            ],
            [
              -2772.86,
              3118.493,
              3263.672
            ],
            [
              -2707,
              2936.995,
              3456.75
            ],
            [
              -2660.341,
              2801.476,
              3600.076
            ],
            [
              -2637.179,
              2724.257,
              3680.695
            ],
            [
              -2612.218,
              2675.949,
              3735.07
            ],
            [
              -2598.361,
              2620.045,
              3792.666
            ],
            [
              -2580.479,
              2536.239,
              3878.358
            ],
            [
              -2576.299,
              2480.505,
              3934.249
            ],
            [
              -2568.347,
              2419.138,
              3996.129
            ],
            [
              -2530.947,
              2234.799,
              4184.224
            ],
            [
              -2533.314,
              2210.35,
              4208.787
            ],
            [
              -2548.095,
              2140.478,
              4280.205
            ],
            [
              -2550.229,
              2092.648,
              4328.083
            ],
            [
              -2549.196,
              2041.422,
              4379.32
            ],
            [
              -2537.883,
              1987.788,
              4434.134
            ],
            [
              -2509.509,
              1913.816,
              4513.361
            ],
            [
              -2480.295,
              1850.96,
              4582.674
            ],
            [
              -2442.052,
              1787.945,
              4656.385
            ],
            [
              -2376.353,
              1708.86,
              4759.2
            ],
            [
              -2337.094,
              1666.977,
              4816.606
            ],
            [
              -2295.02,
              1638.403,
              4867.466
            ],
            [
              -2279.955,
              1614.759,
              4895.502
            ],
            [
              -2250.859,
              1581.961,
              4939.346
            ],
            [
              -2130.979,
              1466.289,
              5105.932
            ],
            [
              -2084.281,
              1407.574,
              5180.953
            ],
            [
              -2039.718,
              1337.764,
              5263.774
            ],
            [
              -1998.617,
              1254.657,
              5356.49
            ],
            [
              -1968.033,
              1160.603,
              5455.391
            ],
            [
              -1951.907,
              1087.958,
              5529.805
            ],
            [
              -1939.203,
              1004.241,
              5614.48
            ],
            [
              -1905.098,
              854.463,
              5768.091
            ],
            [
              -1846.552,
              700.911,
              5932.426
            ],
            [
              -1780.294,
              618.466,
              6038.196
            ],
            [
              -1665.104,
              567.432,
              6164.185
            ],
            [
              -1541.563,
              550.755,
              6288.846
            ],
            [
              -1445.343,
              521.205,
              6389.502
            ],
            [
              -1378.584,
              503.312,
              6458.616
            ],
            [
              -1309.128,
              492.05,
              6528.98
            ],
            [
              -1189.179,
              491.013,
              6648.933
            ],
            [
              -1157.04,
              484.87,
              6681.654
            ],
            [
              -1128.85,
              474.345,
              6711.745
            ],
            [
              -1096.911,
              457.073,
              6748.055
            ],
            [
              -1065.072,
              434.237,
              6787.237
            ],
            [
              -1037.302,
              400.341,
              6831.056
            ],
            [
              -1011.162,
              347.549,
              6889.964
            ],
            [
              -1004.851,
              304.02,
              6933.949
            ],
            [
              -1003.617,
              265.035,
              6972.953
            ],
            [
              -1009.735,
              211.71,
              7026.628
            ],
            [
              -1014.4,
              131.642,
              7106.832
            ],
            [
              -1015.115,
              55.956,
              7182.522
            ],
            [
              -1007.35,
              -14.317,
              7253.222
            ],
            [
              -995.257,
              -59.064,
              7299.574
            ],
            [
              -996.422,
              -87.987,
              7328.521
            ],
            [
              -985.29,
              -186.151,
              7427.314
            ],
            [
              -968.032,
              -302.237,
              7544.676
            ],
            [
              -951.323,
              -377.124,
              7621.404
            ],
            [
              -922.383,
              -488.967,
              7736.931
            ],
            [
              -908.595,
              -582.727,
              7831.699
            ],
            [
              -906.835,
              -664.024,
              7913.015
            ],
            [
              -915.606,
              -793,
              8042.29
            ],
            [
              -919.543,
              -904.252,
              8153.611
            ],
            [
              -902.638,
              -968.011,
              8219.573
            ],
            [
              -906.763,
              -1018.032,
              8269.764
            ],
            [
              -903.416,
              -1047.036,
              8298.96
            ],
            [
              -878.9,
              -1081.988,
              8341.653
            ],
            [
              -875.273,
              -1095.412,
              8355.558
            ],
            [
              -879.138,
              -1130.965,
              8391.321
            ],
            [
              -892.47,
              -1155.216,
              8418.995
            ],
            [
              -917.464,
              -1182.597,
              8456.068
            ],
            [
              -926.283,
              -1206.929,
              8481.949
            ],
            [
              -917.431,
              -1323.977,
              8599.332
            ],
            [
              -911.942,
              -1448.758,
              8724.233
            ],
            [
              -922.391,
              -1491.986,
              8768.706
            ],
            [
              -939.829,
              -1529.521,
              8810.095
            ],
            [
              -961.618,
              -1558.073,
              8846.011
            ],
            [
              -995.732,
              -1590.856,
              8893.323
            ],
            [
              -1026.383,
              -1610.342,
              8929.644
            ],
            [
              -1072.441,
              -1626.213,
              8978.36
            ],
            [
              -1262.636,
              -1662.874,
              9172.055
            ],
            [
              -1320.472,
              -1688.554,
              9235.337
            ],
            [
              -1382.029,
              -1741.999,
              9316.857
            ],
            [
              -1597.414,
              -2106.624,
              9740.346
            ],
            [
              -1645.063,
              -2175.906,
              9824.432
            ],
            [
              -1682.619,
              -2257.615,
              9914.358
            ],
            [
              -1702.963,
              -2314.026,
              9974.325
            ],
            [
              -1711.936,
              -2347.263,
              10008.752
            ],
            [
              -1753.781,
              -2416.65,
              10089.78
            ],
            [
              -1791.442,
              -2468.3,
              10153.703
            ],
            [
              -1838.817,
              -2558.74,
              10255.8
            ],
            [
              -1870.389,
              -2630.537,
              10334.232
            ],
            [
              -1871.271,
              -2643.88,
              10347.604
            ],
            [
              -1912.507,
              -2715.506,
              10430.252
            ],
            [
              -1995.657,
              -2933.332,
              10663.408
            ],
            [
              -2020.861,
              -3009.696,
              10743.825
            ],
            [
              -2025.964,
              -3043.002,
              10777.519
            ],
            [
              -2242.142,
              -3640.305,
              11412.739
            ],
            [
              -2268.114,
              -3687.714,
              11466.795
            ],
            [
              -2346.255,
              -3915.653,
              11707.757
            ],
            [
              -2360.668,
              -3965.493,
              11759.639
            ],
            [
              -2466.817,
              -4247.487,
              12060.949
            ],
            [
              -2538.941,
              -4427.667,
              12255.029
            ],
            [
              -2556.572,
              -4477.451,
              12307.842
            ],
            [
              -2571.739,
              -4497.221,
              12332.76
            ],
            [
              -2635.224,
              -4626.347,
              12476.648
            ],
            [
              -2636.28,
              -4649.706,
              12500.031
            ],
            [
              -2631.949,
              -4659.802,
              12511.017
            ],
            [
              -2592.254,
              -4673.861,
              12553.128
            ],
            [
              -2567.235,
              -4679.869,
              12578.858
            ],
            [
              -2548.031,
              -4686.888,
              12599.304
            ],
            [
              -2515.304,
              -4694.145,
              12632.827
            ],
            [
              -2465.325,
              -4709.501,
              12685.112
            ],
            [
              -2409.103,
              -4736.1,
              12747.308
            ],
            [
              -2349.957,
              -4779.45,
              12820.639
            ],
            [
              -2306.893,
              -4821.402,
              12880.76
            ],
            [
              -2284.806,
              -4847.398,
              12914.872
            ],
            [
              -2241.672,
              -4921.636,
              13000.731
            ],
            [
              -2236.559,
              -4923.953,
              13006.344
            ],
            [
              -2217.405,
              -4969.935,
              13056.156
            ],
            [
              -2110.315,
              -5178.897,
              13290.961
            ],
            [
              -2127.276,
              -5190.841,
              13311.705
            ],
            [
              -2143.028,
              -5207.26,
              13334.458
            ],
            [
              -2175.503,
              -5222.268,
              13370.233
            ],
            [
              -2204.955,
              -5248.463,
              13409.649
            ],
            [
              -2230.543,
              -5274.726,
              13446.317
            ],
            [
              -2512.326,
              -5691.648,
              13949.532
            ],
            [
              -2513.285,
              -5709.442,
              13967.352
            ],
            [
              -2528.468,
              -5730.325,
              13993.171
            ],
            [
              -2529.407,
              -5747.007,
              14009.879
            ],
            [
              -2525.623,
              -5751.527,
              14015.774
            ],
            [
              -2510.288,
              -5758.477,
              14032.611
            ],
            [
              -2498.658,
              -5756.456,
              14044.415
            ],
            [
              -2480.761,
              -5727.829,
              14078.176
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5557",
              "position": {
                "x": -4780.873,
                "z": 5020.164
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -570,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 381.587,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 688.108,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 1165.816,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 1714.892,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 2334.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 3128.46,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 3735.07,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7359",
              "position": {
                "x": -2530.947,
                "z": 2234.799
              },
              "distanceAlongShapeM": 4184.224,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5780",
              "position": {
                "x": -2295.02,
                "z": 1638.403
              },
              "distanceAlongShapeM": 4867.466,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:474",
              "position": {
                "x": -995.257,
                "z": -59.064
              },
              "distanceAlongShapeM": 7299.574,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5534",
              "position": {
                "x": -902.638,
                "z": -968.011
              },
              "distanceAlongShapeM": 8219.573,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 10008.752,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:1039",
              "position": {
                "x": -1871.271,
                "z": -2643.88
              },
              "distanceAlongShapeM": 10347.604,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:986",
              "position": {
                "x": -2025.964,
                "z": -3043.002
              },
              "distanceAlongShapeM": 10777.519,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:4388",
              "position": {
                "x": -2242.142,
                "z": -3640.305
              },
              "distanceAlongShapeM": 11412.739,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:823",
              "position": {
                "x": -2360.668,
                "z": -3965.493
              },
              "distanceAlongShapeM": 11759.639,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7897",
              "position": {
                "x": -2556.572,
                "z": -4477.451
              },
              "distanceAlongShapeM": 12307.842,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 13006.344,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 13334.458,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 13967.352,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            18540,
            19740,
            21000,
            22500,
            23760,
            24960,
            26100,
            27060,
            28020,
            29040,
            29940,
            30900,
            31740,
            32700,
            34020,
            35280,
            36780,
            38160,
            40860,
            43380,
            46080,
            48600,
            51300,
            52560,
            54600,
            56040,
            57540,
            58560,
            60120,
            61020,
            62040,
            63060,
            64140,
            64740,
            66240,
            67560,
            68940,
            70320,
            72420,
            74460,
            77040,
            79500,
            82320,
            84300
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_25",
      "sourceRouteId": "vilnius_bus_25",
      "mode": "bus",
      "shortName": "25",
      "longName": "Žemieji Paneriai–Kazbėjų–V. A. Graičiūno g.–Vaidotai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_25:0",
          "sourceRouteId": "vilnius_bus_25",
          "sourceShapeId": "vilnius_bus_25_a-b",
          "directionId": 0,
          "headsign": "Vaidotai",
          "directionName": "Žemieji Paneriai–Kazbėjų–V. A. Graičiūno g.–Vaidotai",
          "mode": "bus",
          "routeShortName": "25",
          "routeLongName": "Žemieji Paneriai–Kazbėjų–V. A. Graičiūno g.–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4333.961,
              4766.474,
              0
            ],
            [
              -4351.156,
              4780.129,
              21.957
            ],
            [
              -4357.738,
              4810.298,
              52.837
            ],
            [
              -4435.232,
              4883.989,
              159.774
            ],
            [
              -4468.845,
              4919.076,
              208.363
            ],
            [
              -4488.111,
              4924.973,
              228.512
            ],
            [
              -4510.925,
              4949.856,
              262.27
            ],
            [
              -4579.258,
              4993.33,
              343.261
            ],
            [
              -4600.366,
              5004.825,
              367.295
            ],
            [
              -4835.366,
              5155.793,
              646.609
            ],
            [
              -5032.11,
              5279.379,
              878.948
            ],
            [
              -5271.713,
              5427.062,
              1160.409
            ],
            [
              -5460.164,
              5546.035,
              1383.274
            ],
            [
              -5507.478,
              5573.554,
              1438.008
            ],
            [
              -5539.526,
              5587.456,
              1472.942
            ],
            [
              -5570.341,
              5597.997,
              1505.509
            ],
            [
              -5599.939,
              5604.064,
              1535.723
            ],
            [
              -5632.195,
              5605.723,
              1568.022
            ],
            [
              -5666.482,
              5601.851,
              1602.527
            ],
            [
              -5724.289,
              5581.678,
              1663.753
            ],
            [
              -5767.933,
              5559.039,
              1712.918
            ],
            [
              -5844.413,
              5503.558,
              1807.403
            ],
            [
              -5862.75,
              5488.283,
              1831.269
            ],
            [
              -5911.642,
              5422.317,
              1913.378
            ],
            [
              -5931.13,
              5377.005,
              1962.703
            ],
            [
              -5950.367,
              5308.312,
              2034.039
            ],
            [
              -5960.48,
              5282.88,
              2061.409
            ],
            [
              -5972.455,
              5261.931,
              2085.538
            ],
            [
              -5985.57,
              5249.907,
              2103.331
            ],
            [
              -6003.755,
              5243.534,
              2122.6
            ],
            [
              -6024.466,
              5240.544,
              2143.526
            ],
            [
              -6045.12,
              5240.892,
              2164.183
            ],
            [
              -6069.366,
              5257.998,
              2193.856
            ],
            [
              -6086.896,
              5290.575,
              2230.85
            ],
            [
              -6284.365,
              5565.511,
              2569.352
            ],
            [
              -6384.618,
              5670.718,
              2714.677
            ],
            [
              -6403.151,
              5682.161,
              2736.458
            ],
            [
              -6425.222,
              5713.7,
              2774.953
            ],
            [
              -6633.66,
              5914.22,
              3064.184
            ],
            [
              -6722.128,
              5991.393,
              3181.582
            ],
            [
              -6754.294,
              5998.609,
              3214.547
            ],
            [
              -6809.827,
              6037.383,
              3282.277
            ],
            [
              -6882.79,
              6076.446,
              3365.04
            ],
            [
              -6955.867,
              6108.831,
              3444.97
            ],
            [
              -7039.365,
              6135.823,
              3532.723
            ],
            [
              -7206.108,
              6166.42,
              3702.25
            ],
            [
              -7774.707,
              6263.751,
              4279.119
            ],
            [
              -7867.343,
              6285.312,
              4374.231
            ],
            [
              -8047.971,
              6336.143,
              4561.875
            ],
            [
              -8100.928,
              6335.897,
              4614.833
            ],
            [
              -8216.781,
              6399.018,
              4746.765
            ],
            [
              -8626.991,
              6549.307,
              5183.639
            ],
            [
              -8794.097,
              6598.774,
              5357.913
            ],
            [
              -8875.212,
              6614.561,
              5440.551
            ],
            [
              -8982.209,
              6627.426,
              5548.318
            ],
            [
              -8997.202,
              6618.763,
              5565.634
            ],
            [
              -9015.208,
              6623.507,
              5584.254
            ],
            [
              -9020.857,
              6633.617,
              5595.835
            ],
            [
              -9019.959,
              6649.186,
              5611.431
            ],
            [
              -9003.584,
              6663.393,
              5633.109
            ],
            [
              -9000.086,
              6680.034,
              5650.114
            ],
            [
              -8987.422,
              6704.318,
              5677.502
            ],
            [
              -8845.474,
              7014.818,
              6018.91
            ],
            [
              -8802.47,
              7117.645,
              6130.367
            ],
            [
              -8792.189,
              7154.212,
              6168.353
            ],
            [
              -8758.246,
              7215.999,
              6238.849
            ],
            [
              -8724.175,
              7285.575,
              6316.319
            ],
            [
              -8528.627,
              7712.077,
              6785.513
            ],
            [
              -8515.313,
              7736.35,
              6813.198
            ],
            [
              -8524.884,
              7783.259,
              6861.073
            ],
            [
              -8711.68,
              7975.533,
              7129.144
            ],
            [
              -8818.357,
              8089.694,
              7285.39
            ],
            [
              -8834.969,
              8101.095,
              7305.538
            ],
            [
              -8843.831,
              8112.37,
              7319.878
            ],
            [
              -8856.585,
              8122.595,
              7336.226
            ],
            [
              -8874.579,
              8128.452,
              7355.149
            ],
            [
              -8887.316,
              8139.79,
              7372.201
            ],
            [
              -8897.56,
              8145.522,
              7383.939
            ],
            [
              -8907.731,
              8155.705,
              7398.332
            ],
            [
              -8906.995,
              8161.259,
              7403.935
            ],
            [
              -8899.245,
              8161.134,
              7411.686
            ],
            [
              -8883.261,
              8150.856,
              7430.689
            ],
            [
              -8861.626,
              8130.469,
              7460.416
            ],
            [
              -8855.958,
              8121.472,
              7471.05
            ],
            [
              -8780.83,
              8053.464,
              7572.387
            ],
            [
              -8601.132,
              7861.308,
              7835.475
            ],
            [
              -8498.841,
              7756.119,
              7982.2
            ],
            [
              -8437.312,
              7845.283,
              8090.533
            ],
            [
              -8365.648,
              7922.035,
              8195.542
            ],
            [
              -8152.148,
              8217.989,
              8560.467
            ],
            [
              -7995.129,
              8416.901,
              8813.886
            ],
            [
              -7916.015,
              8513.562,
              8938.796
            ],
            [
              -7892.232,
              8545.453,
              8978.578
            ],
            [
              -7851.162,
              8607.117,
              9052.667
            ],
            [
              -7842.491,
              8623.672,
              9071.355
            ],
            [
              -7568.726,
              8965.362,
              9509.191
            ],
            [
              -7499.264,
              9063.288,
              9629.251
            ],
            [
              -7379.193,
              9212.697,
              9820.928
            ],
            [
              -7330.726,
              9251.97,
              9883.309
            ],
            [
              -7300.013,
              9272.612,
              9920.314
            ],
            [
              -7148.088,
              9315.737,
              10078.241
            ],
            [
              -7084.925,
              9305.784,
              10142.183
            ],
            [
              -7053.289,
              9304.146,
              10173.862
            ],
            [
              -6941.95,
              9315.655,
              10285.794
            ],
            [
              -6867.196,
              9303.28,
              10361.565
            ],
            [
              -6751.719,
              9369.261,
              10494.563
            ],
            [
              -6640.226,
              9428.626,
              10620.876
            ],
            [
              -6483.264,
              9501.7,
              10794.014
            ],
            [
              -6330.267,
              9569.27,
              10961.268
            ],
            [
              -5992.713,
              9773.992,
              11356.051
            ],
            [
              -6020.289,
              9786.701,
              11386.415
            ],
            [
              -6052.07,
              9818.405,
              11431.305
            ],
            [
              -6394.984,
              10065.716,
              11854.097
            ],
            [
              -6415.306,
              10087.206,
              11883.674
            ],
            [
              -6419.587,
              10101.749,
              11898.834
            ],
            [
              -6409.212,
              10103.802,
              11909.411
            ],
            [
              -6400.868,
              10100.323,
              11918.451
            ],
            [
              -6388.113,
              10090.091,
              11934.803
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 228.512,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5728",
              "position": {
                "x": -6069.366,
                "z": 5257.998
              },
              "distanceAlongShapeM": 2193.856,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5732",
              "position": {
                "x": -6403.151,
                "z": 5682.161
              },
              "distanceAlongShapeM": 2736.458,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5738",
              "position": {
                "x": -6754.294,
                "z": 5998.609
              },
              "distanceAlongShapeM": 3214.547,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5742",
              "position": {
                "x": -8100.928,
                "z": 6335.897
              },
              "distanceAlongShapeM": 4614.833,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6450",
              "position": {
                "x": -8792.189,
                "z": 7154.212
              },
              "distanceAlongShapeM": 6168.353,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7180",
              "position": {
                "x": -8897.56,
                "z": 8145.522
              },
              "distanceAlongShapeM": 7383.939,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6454",
              "position": {
                "x": -8437.312,
                "z": 7845.283
              },
              "distanceAlongShapeM": 8090.533,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6455",
              "position": {
                "x": -8152.148,
                "z": 8217.989
              },
              "distanceAlongShapeM": 8560.467,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:10577",
              "position": {
                "x": -7995.129,
                "z": 8416.901
              },
              "distanceAlongShapeM": 8813.886,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6457",
              "position": {
                "x": -7842.491,
                "z": 8623.672
              },
              "distanceAlongShapeM": 9071.355,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:16749",
              "position": {
                "x": -7499.264,
                "z": 9063.288
              },
              "distanceAlongShapeM": 9629.251,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5756",
              "position": {
                "x": -6020.289,
                "z": 9786.701
              },
              "distanceAlongShapeM": 11386.415,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:3575",
              "position": {
                "x": -6388.113,
                "z": 10090.091
              },
              "distanceAlongShapeM": 11934.803,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            }
          ],
          "departuresSeconds": [
            21840,
            25620,
            30120,
            36300,
            37740,
            40080,
            41760,
            43680,
            45480,
            47280,
            49260,
            51300,
            53100,
            54900,
            56880,
            58680,
            60900,
            63120,
            65340,
            69600,
            71700,
            73800,
            75600,
            77940,
            79260,
            82740
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_25:1",
          "sourceRouteId": "vilnius_bus_25",
          "sourceShapeId": "vilnius_bus_25_b-a",
          "directionId": 1,
          "headsign": "Žemieji Paneriai",
          "directionName": "Vaidotai–V. A. Graičiūno–Kazbėjų g.–Žemieji Paneriai",
          "mode": "bus",
          "routeShortName": "25",
          "routeLongName": "Žemieji Paneriai–Kazbėjų–V. A. Graičiūno g.–Vaidotai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6388.113,
              10090.091,
              0
            ],
            [
              -6369.008,
              10073.073,
              25.585
            ],
            [
              -6360.795,
              10061.804,
              39.53
            ],
            [
              -6355.222,
              10047.239,
              55.124
            ],
            [
              -6354.078,
              10038.315,
              64.121
            ],
            [
              -5994.005,
              9774.014,
              510.784
            ],
            [
              -6407.173,
              9530.483,
              990.383
            ],
            [
              -6519.188,
              9478.924,
              1113.694
            ],
            [
              -6707.306,
              9397.463,
              1318.692
            ],
            [
              -6863.265,
              9306.554,
              1499.213
            ],
            [
              -6874.93,
              9304.522,
              1511.054
            ],
            [
              -6927.682,
              9318.757,
              1565.693
            ],
            [
              -7046.256,
              9299.576,
              1685.808
            ],
            [
              -7099.046,
              9311.584,
              1739.946
            ],
            [
              -7150.063,
              9313.543,
              1791.001
            ],
            [
              -7201.32,
              9301.034,
              1843.763
            ],
            [
              -7300.013,
              9272.612,
              1946.466
            ],
            [
              -7410.827,
              9175.372,
              2093.895
            ],
            [
              -7447.165,
              9126.992,
              2154.402
            ],
            [
              -7457.131,
              9110.459,
              2173.706
            ],
            [
              -7446.924,
              9102.499,
              2186.651
            ],
            [
              -7445.779,
              9093.574,
              2195.648
            ],
            [
              -7461.778,
              9063.783,
              2229.464
            ],
            [
              -7472.981,
              9050.61,
              2246.756
            ],
            [
              -7488.705,
              9037.511,
              2267.222
            ],
            [
              -7510.76,
              9032.309,
              2289.882
            ],
            [
              -7569.372,
              8965.373,
              2378.853
            ],
            [
              -7831.083,
              8610.126,
              2820.093
            ],
            [
              -7875.828,
              8560.769,
              2886.714
            ],
            [
              -7928.634,
              8492.619,
              2972.928
            ],
            [
              -7976.88,
              8426.62,
              3054.681
            ],
            [
              -7986.861,
              8408.973,
              3074.954
            ],
            [
              -8037.543,
              8351.919,
              3151.268
            ],
            [
              -8165.039,
              8180.352,
              3365.022
            ],
            [
              -8181.677,
              8150.569,
              3399.137
            ],
            [
              -8200.68,
              8134.182,
              3424.23
            ],
            [
              -8442.25,
              7819.76,
              3820.736
            ],
            [
              -8457.002,
              7786.606,
              3857.025
            ],
            [
              -8498.841,
              7756.119,
              3908.793
            ],
            [
              -8711.68,
              7975.533,
              4214.478
            ],
            [
              -8818.357,
              8089.694,
              4370.723
            ],
            [
              -8834.969,
              8101.095,
              4390.871
            ],
            [
              -8843.831,
              8112.37,
              4405.212
            ],
            [
              -8856.585,
              8122.595,
              4421.559
            ],
            [
              -8874.579,
              8128.452,
              4440.482
            ],
            [
              -8887.316,
              8139.79,
              4457.535
            ],
            [
              -8897.56,
              8145.522,
              4469.273
            ],
            [
              -8907.731,
              8155.705,
              4483.666
            ],
            [
              -8906.995,
              8161.259,
              4489.268
            ],
            [
              -8899.245,
              8161.134,
              4497.019
            ],
            [
              -8883.261,
              8150.856,
              4516.023
            ],
            [
              -8861.626,
              8130.469,
              4545.75
            ],
            [
              -8855.958,
              8121.472,
              4556.384
            ],
            [
              -8780.83,
              8053.464,
              4657.721
            ],
            [
              -8601.132,
              7861.308,
              4920.809
            ],
            [
              -8498.841,
              7756.119,
              5067.534
            ],
            [
              -8526.062,
              7710.922,
              5120.294
            ],
            [
              -8697.478,
              7338.573,
              5530.205
            ],
            [
              -8733.31,
              7240.084,
              5635.011
            ],
            [
              -8763.181,
              7190.476,
              5692.917
            ],
            [
              -8845.008,
              7003.679,
              5896.851
            ],
            [
              -8901.086,
              6891.045,
              6022.673
            ],
            [
              -8938.022,
              6803.703,
              6117.503
            ],
            [
              -8942.13,
              6789.299,
              6132.482
            ],
            [
              -8936.124,
              6761.372,
              6161.047
            ],
            [
              -8899.971,
              6720.713,
              6215.456
            ],
            [
              -8836.809,
              6672.936,
              6294.652
            ],
            [
              -8767.711,
              6632.854,
              6374.533
            ],
            [
              -8454.851,
              6491.959,
              6717.656
            ],
            [
              -8216.781,
              6399.018,
              6973.224
            ],
            [
              -8090.106,
              6365.775,
              7104.188
            ],
            [
              -8047.971,
              6336.143,
              7155.701
            ],
            [
              -7869.852,
              6289.806,
              7339.747
            ],
            [
              -7783.654,
              6269.464,
              7428.314
            ],
            [
              -7104.955,
              6152.496,
              8117.017
            ],
            [
              -6990.505,
              6122.766,
              8235.266
            ],
            [
              -6923.128,
              6097.155,
              8307.347
            ],
            [
              -6819.933,
              6050.909,
              8420.43
            ],
            [
              -6663.331,
              5954.79,
              8604.177
            ],
            [
              -6413.106,
              5704.591,
              8958.03
            ],
            [
              -6357.16,
              5652.447,
              9034.509
            ],
            [
              -6334.791,
              5638.714,
              9060.757
            ],
            [
              -6315.93,
              5608.341,
              9096.509
            ],
            [
              -6284.365,
              5565.511,
              9149.715
            ],
            [
              -6235.578,
              5510.146,
              9223.508
            ],
            [
              -6210.778,
              5487.465,
              9257.115
            ],
            [
              -6170.561,
              5460.073,
              9305.774
            ],
            [
              -6118.615,
              5439.162,
              9361.772
            ],
            [
              -6089.662,
              5433.109,
              9391.351
            ],
            [
              -6052.281,
              5429.14,
              9428.942
            ],
            [
              -6005.048,
              5435.024,
              9476.539
            ],
            [
              -5948.573,
              5452.996,
              9535.805
            ],
            [
              -5873.554,
              5498.484,
              9623.538
            ],
            [
              -5789.253,
              5558.286,
              9726.897
            ],
            [
              -5728.563,
              5596.222,
              9798.467
            ],
            [
              -5697.335,
              5610.165,
              9832.667
            ],
            [
              -5669.446,
              5617.486,
              9861.5
            ],
            [
              -5631.932,
              5621.303,
              9899.208
            ],
            [
              -5582.93,
              5617.134,
              9948.387
            ],
            [
              -5526.428,
              5598.366,
              10007.925
            ],
            [
              -5379.437,
              5509.043,
              10179.927
            ],
            [
              -4710.592,
              5090.204,
              10969.091
            ],
            [
              -4580.889,
              5011.17,
              11120.978
            ],
            [
              -4517.509,
              4980.025,
              11191.596
            ],
            [
              -4380.813,
              4857.45,
              11375.2
            ],
            [
              -4298.311,
              4774.766,
              11492.004
            ],
            [
              -4237.94,
              4719.179,
              11574.069
            ],
            [
              -4229.781,
              4705.68,
              11589.842
            ],
            [
              -4240.925,
              4695.853,
              11604.7
            ],
            [
              -4266.982,
              4719.679,
              11640.008
            ],
            [
              -4289.168,
              4743.439,
              11672.515
            ],
            [
              -4311.679,
              4748.279,
              11695.542
            ],
            [
              -4321.909,
              4754.022,
              11707.273
            ],
            [
              -4333.961,
              4766.474,
              11724.603
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3575",
              "position": {
                "x": -6388.113,
                "z": 10090.091
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -390,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4531",
              "position": {
                "x": -7461.778,
                "z": 9063.783
              },
              "distanceAlongShapeM": 2229.464,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6458",
              "position": {
                "x": -7831.083,
                "z": 8610.126
              },
              "distanceAlongShapeM": 2820.093,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:9298",
              "position": {
                "x": -7986.861,
                "z": 8408.973
              },
              "distanceAlongShapeM": 3074.954,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6456",
              "position": {
                "x": -8181.677,
                "z": 8150.569
              },
              "distanceAlongShapeM": 3399.137,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6469",
              "position": {
                "x": -8457.002,
                "z": 7786.606
              },
              "distanceAlongShapeM": 3857.025,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7180",
              "position": {
                "x": -8897.56,
                "z": 8145.522
              },
              "distanceAlongShapeM": 4469.273,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6449",
              "position": {
                "x": -8733.31,
                "z": 7240.084
              },
              "distanceAlongShapeM": 5635.011,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9115",
              "position": {
                "x": -8830.889,
                "z": 7037.958
              },
              "distanceAlongShapeM": 5859.787,
              "shapeOffsetM": 0.822,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9776",
              "position": {
                "x": -8090.106,
                "z": 6365.775
              },
              "distanceAlongShapeM": 7104.188,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:4410",
              "position": {
                "x": -6663.331,
                "z": 5954.79
              },
              "distanceAlongShapeM": 8604.177,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5731",
              "position": {
                "x": -6334.791,
                "z": 5638.714
              },
              "distanceAlongShapeM": 9060.757,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 11191.596,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            }
          ],
          "departuresSeconds": [
            23760,
            27540,
            32040,
            38220,
            39720,
            41700,
            43500,
            45300,
            47220,
            49080,
            50880,
            52980,
            54780,
            56700,
            58680,
            60660,
            62880,
            65100,
            67260,
            71520,
            73560,
            75900,
            77280,
            79560,
            80880,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_26",
      "sourceRouteId": "vilnius_bus_26",
      "mode": "bus",
      "shortName": "26",
      "longName": "Ozo g.–Kalvarijų g.–Santariškės–Didžioji Riešė–Didieji Gulbinai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_26:0",
          "sourceRouteId": "vilnius_bus_26",
          "sourceShapeId": "vilnius_bus_26_a-b",
          "directionId": 0,
          "headsign": "Didieji Gulbinai",
          "directionName": "Ozo g.–Kalvarijų g.–Santariškės–Didžioji Riešė–Didieji Gulbinai",
          "mode": "bus",
          "routeShortName": "26",
          "routeLongName": "Ozo g.–Kalvarijų g.–Santariškės–Didžioji Riešė–Didieji Gulbinai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -101.456,
              -3003.034,
              0
            ],
            [
              -96.298,
              -2967.504,
              35.902
            ],
            [
              -92.311,
              -2960.897,
              43.619
            ],
            [
              -73.485,
              -2953.447,
              63.866
            ],
            [
              -70.101,
              -2944.603,
              73.335
            ],
            [
              -69.858,
              -2931.249,
              86.692
            ],
            [
              -74.186,
              -2921.151,
              97.678
            ],
            [
              -70.518,
              -2896.726,
              122.376
            ],
            [
              -71.985,
              -2871.095,
              148.049
            ],
            [
              -69.485,
              -2839.97,
              179.275
            ],
            [
              -47.286,
              -2753.542,
              268.508
            ],
            [
              -41.828,
              -2736.943,
              285.982
            ],
            [
              -35.928,
              -2731.484,
              294.02
            ],
            [
              12.173,
              -2744.606,
              343.878
            ],
            [
              24.938,
              -2751.518,
              358.394
            ],
            [
              116.004,
              -2776.557,
              452.84
            ],
            [
              149.306,
              -2788.297,
              488.15
            ],
            [
              177.432,
              -2801.056,
              519.035
            ],
            [
              235.996,
              -2841.089,
              589.975
            ],
            [
              300.135,
              -2893.471,
              672.786
            ],
            [
              349.094,
              -2929.99,
              733.865
            ],
            [
              400.25,
              -2952.078,
              789.586
            ],
            [
              460.65,
              -2962.091,
              850.81
            ],
            [
              513.462,
              -2964.172,
              903.662
            ],
            [
              519.179,
              -2968.73,
              910.974
            ],
            [
              521.572,
              -2978.793,
              921.318
            ],
            [
              517.855,
              -3111.2,
              1053.777
            ],
            [
              511.925,
              -3153.395,
              1096.386
            ],
            [
              509.127,
              -3235.723,
              1178.763
            ],
            [
              511.316,
              -3256.915,
              1200.067
            ],
            [
              504.142,
              -3366.994,
              1310.38
            ],
            [
              489.873,
              -3512.567,
              1456.651
            ],
            [
              474.056,
              -3566.826,
              1513.168
            ],
            [
              441.104,
              -3641.923,
              1595.176
            ],
            [
              383.151,
              -3709.882,
              1684.49
            ],
            [
              303.678,
              -3791.921,
              1798.71
            ],
            [
              278.895,
              -3808.166,
              1828.343
            ],
            [
              228.358,
              -3858.451,
              1899.635
            ],
            [
              158.106,
              -3965.152,
              2027.387
            ],
            [
              127.093,
              -4040.286,
              2108.67
            ],
            [
              102.95,
              -4092.167,
              2165.894
            ],
            [
              79.561,
              -4208.631,
              2284.682
            ],
            [
              75.006,
              -4246.398,
              2322.723
            ],
            [
              72.804,
              -4296.453,
              2372.827
            ],
            [
              57.959,
              -4368.543,
              2446.43
            ],
            [
              54.707,
              -4440.844,
              2518.804
            ],
            [
              47.88,
              -4461.871,
              2540.911
            ],
            [
              42.119,
              -4495.164,
              2574.698
            ],
            [
              46.027,
              -4598.766,
              2678.375
            ],
            [
              43.323,
              -4641.02,
              2720.715
            ],
            [
              -32.111,
              -5068.242,
              3154.546
            ],
            [
              -36.204,
              -5116.037,
              3202.516
            ],
            [
              -42.927,
              -5131.5,
              3219.377
            ],
            [
              -75.729,
              -5270.057,
              3361.764
            ],
            [
              -95.037,
              -5339.84,
              3434.169
            ],
            [
              -105.993,
              -5410.888,
              3506.056
            ],
            [
              -116.661,
              -5430.732,
              3528.586
            ],
            [
              -144.967,
              -5534.861,
              3636.494
            ],
            [
              -183.275,
              -5657.733,
              3765.199
            ],
            [
              -188.212,
              -5716.645,
              3824.318
            ],
            [
              -185.377,
              -5737.848,
              3845.71
            ],
            [
              -196.91,
              -5769.923,
              3879.794
            ],
            [
              -201.665,
              -5818.819,
              3928.921
            ],
            [
              -201.086,
              -5857.793,
              3967.899
            ],
            [
              -195.599,
              -5910.215,
              4020.608
            ],
            [
              -136.015,
              -6175.138,
              4292.149
            ],
            [
              -122.378,
              -6204.331,
              4324.37
            ],
            [
              -123.468,
              -6228.802,
              4348.865
            ],
            [
              -113.557,
              -6285.758,
              4406.677
            ],
            [
              -58.166,
              -6532.794,
              4659.847
            ],
            [
              -46.468,
              -6597.576,
              4725.676
            ],
            [
              -39.377,
              -6667.839,
              4796.297
            ],
            [
              -35.045,
              -6748.072,
              4876.646
            ],
            [
              -27.041,
              -6768.256,
              4898.36
            ],
            [
              -16.965,
              -6780.686,
              4914.36
            ],
            [
              0.233,
              -6791.019,
              4934.424
            ],
            [
              10.168,
              -6811.238,
              4956.952
            ],
            [
              11.151,
              -6827.955,
              4973.698
            ],
            [
              7.024,
              -6842.352,
              4988.675
            ],
            [
              -10.864,
              -6869.857,
              5021.485
            ],
            [
              -21.671,
              -6897.49,
              5051.157
            ],
            [
              -10.612,
              -6926.637,
              5082.33
            ],
            [
              -9.853,
              -6955.595,
              5111.299
            ],
            [
              6.027,
              -7144.023,
              5300.395
            ],
            [
              16.38,
              -7176.496,
              5334.478
            ],
            [
              9.978,
              -7209.777,
              5368.369
            ],
            [
              38.024,
              -7507.525,
              5667.436
            ],
            [
              44.494,
              -7541.041,
              5701.57
            ],
            [
              45.727,
              -7614.537,
              5775.077
            ],
            [
              52.252,
              -7680.338,
              5841.2
            ],
            [
              -275.17,
              -7699.975,
              6169.211
            ],
            [
              -508.925,
              -7738.032,
              6406.043
            ],
            [
              -511.201,
              -7792.54,
              6460.598
            ],
            [
              -532.251,
              -7994.768,
              6663.919
            ],
            [
              -556.838,
              -8498.621,
              7168.372
            ],
            [
              -549.822,
              -8537.712,
              7208.087
            ],
            [
              -556.984,
              -8577.659,
              7248.671
            ],
            [
              -559.825,
              -8663.327,
              7334.386
            ],
            [
              -559.506,
              -8716.769,
              7387.829
            ],
            [
              -566.652,
              -8826.85,
              7498.142
            ],
            [
              -561.229,
              -8918.235,
              7589.687
            ],
            [
              -572.031,
              -8981.494,
              7653.862
            ],
            [
              -575.472,
              -9029.301,
              7701.793
            ],
            [
              -577.992,
              -9132.787,
              7805.309
            ],
            [
              -573.278,
              -9298.746,
              7971.335
            ],
            [
              -565.946,
              -9391.278,
              8064.158
            ],
            [
              -549.971,
              -9504.006,
              8178.012
            ],
            [
              -505.453,
              -9675.14,
              8354.842
            ],
            [
              -446.478,
              -9971.222,
              8656.739
            ],
            [
              -419.075,
              -10127.574,
              8815.475
            ],
            [
              -413.755,
              -10188.899,
              8877.031
            ],
            [
              -418.439,
              -10198.833,
              8888.014
            ],
            [
              -429.435,
              -10201.973,
              8899.45
            ],
            [
              -449.619,
              -10214.966,
              8923.453
            ],
            [
              -518.012,
              -10296.104,
              9029.571
            ],
            [
              -531.261,
              -10317.015,
              9054.326
            ],
            [
              -538.659,
              -10334.693,
              9073.49
            ],
            [
              -534.921,
              -10341.44,
              9081.203
            ],
            [
              -522.76,
              -10345.001,
              9093.875
            ],
            [
              -518.881,
              -10343.958,
              9097.892
            ],
            [
              -520.046,
              -10337.257,
              9104.693
            ],
            [
              -492.966,
              -10298.785,
              9151.74
            ],
            [
              -486.291,
              -10285.547,
              9166.566
            ],
            [
              -486.23,
              -10282.209,
              9169.905
            ],
            [
              -497.044,
              -10275.333,
              9182.719
            ],
            [
              -537.976,
              -10332.479,
              9253.012
            ],
            [
              -597.23,
              -10548.487,
              9477
            ],
            [
              -776.158,
              -10978.298,
              9942.567
            ],
            [
              -971.03,
              -11580.381,
              10575.401
            ],
            [
              -1246.263,
              -12218.875,
              11270.69
            ],
            [
              -1401.025,
              -12599.047,
              11681.157
            ],
            [
              -1425.089,
              -12649.824,
              11737.347
            ],
            [
              -1528.729,
              -12906.236,
              12013.913
            ],
            [
              -1581.108,
              -13029.98,
              12148.286
            ],
            [
              -1600.868,
              -13091.968,
              12213.346
            ],
            [
              -1607.248,
              -13160.874,
              12282.548
            ],
            [
              -1613.772,
              -13201.947,
              12324.136
            ],
            [
              -1535.187,
              -13194.451,
              12403.077
            ],
            [
              -1337.279,
              -13166.836,
              12602.903
            ],
            [
              -1197.987,
              -13144.852,
              12743.919
            ],
            [
              -1056.905,
              -13095.074,
              12893.525
            ],
            [
              -789.251,
              -12909.547,
              13219.192
            ],
            [
              -767.252,
              -12902.153,
              13242.4
            ],
            [
              -451.805,
              -13060.393,
              13595.312
            ],
            [
              -283.762,
              -13190.363,
              13807.751
            ],
            [
              -200.79,
              -13259.784,
              13915.935
            ],
            [
              -169.922,
              -13294.858,
              13962.658
            ],
            [
              -148.289,
              -13307.499,
              13987.713
            ],
            [
              -129.086,
              -13312.302,
              14007.508
            ],
            [
              -0.914,
              -13265.661,
              14143.902
            ],
            [
              70.866,
              -13243.595,
              14218.998
            ],
            [
              188.053,
              -13200.098,
              14343.997
            ],
            [
              452.066,
              -13110.317,
              14622.857
            ],
            [
              535.832,
              -13066.214,
              14717.524
            ],
            [
              641.928,
              -12996.92,
              14844.245
            ],
            [
              798.022,
              -12901.832,
              15027.021
            ],
            [
              892.848,
              -12851.26,
              15134.489
            ],
            [
              930.86,
              -12847.509,
              15172.686
            ],
            [
              943.177,
              -12842.171,
              15186.111
            ],
            [
              950.27,
              -12841.189,
              15193.271
            ],
            [
              959.085,
              -12851.371,
              15206.739
            ],
            [
              953.114,
              -12861.28,
              15218.308
            ],
            [
              937.206,
              -12852.08,
              15236.684
            ],
            [
              917.858,
              -12855.062,
              15256.261
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8460",
              "position": {
                "x": -74.186,
                "z": -2921.151
              },
              "distanceAlongShapeM": 97.678,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5080",
              "position": {
                "x": 12.173,
                "z": -2744.606
              },
              "distanceAlongShapeM": 343.878,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 1200.067,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 1798.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 2108.67,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6487",
              "position": {
                "x": 54.707,
                "z": -4440.844
              },
              "distanceAlongShapeM": 2518.804,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6488",
              "position": {
                "x": -36.204,
                "z": -5116.037
              },
              "distanceAlongShapeM": 3202.516,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6491",
              "position": {
                "x": -105.993,
                "z": -5410.888
              },
              "distanceAlongShapeM": 3506.056,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 3845.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 4324.37,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 5082.33,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 5334.478,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8716",
              "position": {
                "x": 44.494,
                "z": -7541.041
              },
              "distanceAlongShapeM": 5701.57,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:16295",
              "position": {
                "x": -511.201,
                "z": -7792.54
              },
              "distanceAlongShapeM": 6460.598,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7092",
              "position": {
                "x": -549.822,
                "z": -8537.712
              },
              "distanceAlongShapeM": 7208.087,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7374",
              "position": {
                "x": -561.229,
                "z": -8918.235
              },
              "distanceAlongShapeM": 7589.687,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7095",
              "position": {
                "x": -505.453,
                "z": -9675.14
              },
              "distanceAlongShapeM": 8354.842,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8472",
              "position": {
                "x": -520.046,
                "z": -10337.257
              },
              "distanceAlongShapeM": 9104.693,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:7098",
              "position": {
                "x": -597.23,
                "z": -10548.487
              },
              "distanceAlongShapeM": 9477,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:7100",
              "position": {
                "x": -776.158,
                "z": -10978.298
              },
              "distanceAlongShapeM": 9942.567,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7102",
              "position": {
                "x": -997.254,
                "z": -11643.363
              },
              "distanceAlongShapeM": 10643.619,
              "shapeOffsetM": 0.849,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7104",
              "position": {
                "x": -1246.263,
                "z": -12218.875
              },
              "distanceAlongShapeM": 11270.69,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:8324",
              "position": {
                "x": -1401.025,
                "z": -12599.047
              },
              "distanceAlongShapeM": 11681.157,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7107",
              "position": {
                "x": -1607.248,
                "z": -13160.874
              },
              "distanceAlongShapeM": 12282.548,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:4590",
              "position": {
                "x": -851.792,
                "z": -12954.058
              },
              "distanceAlongShapeM": 13142.434,
              "shapeOffsetM": 0.954,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:15180",
              "position": {
                "x": -63.072,
                "z": -13289.016
              },
              "distanceAlongShapeM": 14077.505,
              "shapeOffsetM": 0.692,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:15181",
              "position": {
                "x": 917.858,
                "z": -12855.062
              },
              "distanceAlongShapeM": 15256.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            20160,
            25560,
            29460,
            33360,
            36360,
            39960,
            43560,
            46260,
            49260,
            52260,
            55560,
            59460,
            67260,
            73260,
            79260
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_26:1",
          "sourceRouteId": "vilnius_bus_26",
          "sourceShapeId": "vilnius_bus_26_b-a",
          "directionId": 1,
          "headsign": "Ozo g.",
          "directionName": "Didieji Gulbinai–Didžioji Riešė–Santariškės–Kalvarijų g.–Ozo g.",
          "mode": "bus",
          "routeShortName": "26",
          "routeLongName": "Ozo g.–Kalvarijų g.–Santariškės–Didžioji Riešė–Didieji Gulbinai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              917.858,
              -12855.062,
              0
            ],
            [
              859.048,
              -12870.674,
              60.847
            ],
            [
              494.841,
              -13092.179,
              487.123
            ],
            [
              424.24,
              -13119.825,
              562.945
            ],
            [
              -58.735,
              -13298.002,
              1077.737
            ],
            [
              -131.055,
              -13314.493,
              1151.914
            ],
            [
              -152.167,
              -13308.541,
              1173.848
            ],
            [
              -197.035,
              -13265.419,
              1236.079
            ],
            [
              -254.016,
              -13216.51,
              1311.172
            ],
            [
              -430.895,
              -13077.472,
              1536.155
            ],
            [
              -486.175,
              -13040.843,
              1602.469
            ],
            [
              -625.125,
              -12972.638,
              1757.256
            ],
            [
              -669.903,
              -12959.58,
              1803.9
            ],
            [
              -720.124,
              -12927.498,
              1863.493
            ],
            [
              -760.904,
              -12906.721,
              1909.262
            ],
            [
              -775.068,
              -12907.577,
              1923.451
            ],
            [
              -999.752,
              -13063.821,
              2197.121
            ],
            [
              -1042.039,
              -13090.889,
              2247.329
            ],
            [
              -1123.74,
              -13128.379,
              2337.22
            ],
            [
              -1194.873,
              -13150.474,
              2411.706
            ],
            [
              -1354.113,
              -13173.212,
              2572.561
            ],
            [
              -1591.935,
              -13203.452,
              2812.299
            ],
            [
              -1602.883,
              -13204.369,
              2823.285
            ],
            [
              -1616.946,
              -13199.664,
              2838.114
            ],
            [
              -1618.052,
              -13189.625,
              2848.214
            ],
            [
              -1604.989,
              -13070.742,
              2967.812
            ],
            [
              -1530.762,
              -12876.142,
              3176.088
            ],
            [
              -1386.063,
              -12518.049,
              3562.311
            ],
            [
              -1244.556,
              -12195.527,
              3914.511
            ],
            [
              -985.72,
              -11538.926,
              4620.288
            ],
            [
              -963.896,
              -11505.922,
              4659.855
            ],
            [
              -930.958,
              -11427.477,
              4744.935
            ],
            [
              -754.749,
              -10897.419,
              5303.514
            ],
            [
              -734.87,
              -10865.494,
              5341.122
            ],
            [
              -630.078,
              -10621.366,
              5606.791
            ],
            [
              -582.831,
              -10464.141,
              5770.961
            ],
            [
              -580.296,
              -10430.79,
              5804.409
            ],
            [
              -561.098,
              -10401.08,
              5839.781
            ],
            [
              -546.903,
              -10363.488,
              5879.965
            ],
            [
              -543.003,
              -10361.332,
              5884.421
            ],
            [
              -532.692,
              -10360.406,
              5894.774
            ],
            [
              -526.842,
              -10357.172,
              5901.458
            ],
            [
              -520.046,
              -10337.257,
              5922.501
            ],
            [
              -485.005,
              -10285.571,
              5984.946
            ],
            [
              -486.854,
              -10281.084,
              5989.798
            ],
            [
              -495.717,
              -10273.13,
              6001.708
            ],
            [
              -494.973,
              -10267.578,
              6007.31
            ],
            [
              -456.031,
              -10213.736,
              6073.759
            ],
            [
              -433.052,
              -10188.549,
              6107.853
            ],
            [
              -425.111,
              -10176.447,
              6122.328
            ],
            [
              -422.857,
              -10158.676,
              6140.241
            ],
            [
              -447.889,
              -10013.499,
              6287.56
            ],
            [
              -544.206,
              -9576.471,
              6735.076
            ],
            [
              -555.299,
              -9513.928,
              6798.595
            ],
            [
              -562.717,
              -9497.095,
              6816.99
            ],
            [
              -566.009,
              -9430.241,
              6883.926
            ],
            [
              -581.42,
              -9286.353,
              7028.637
            ],
            [
              -582.35,
              -9053.668,
              7261.324
            ],
            [
              -573.293,
              -8909.11,
              7406.165
            ],
            [
              -580.308,
              -8870.019,
              7445.88
            ],
            [
              -573.871,
              -8834.512,
              7481.966
            ],
            [
              -566.291,
              -8522.941,
              7793.629
            ],
            [
              -563.836,
              -8494.041,
              7822.633
            ],
            [
              -567.816,
              -8465.025,
              7851.921
            ],
            [
              -527.046,
              -7743.269,
              8574.827
            ],
            [
              -368.736,
              -7711.633,
              8736.267
            ],
            [
              -239.087,
              -7698.405,
              8866.589
            ],
            [
              49.054,
              -7679.166,
              9155.372
            ],
            [
              45.727,
              -7614.537,
              9220.087
            ],
            [
              25.801,
              -7471.678,
              9364.329
            ],
            [
              8.189,
              -7201.951,
              9634.63
            ],
            [
              -2.477,
              -7116.037,
              9721.204
            ],
            [
              -15.345,
              -7080.178,
              9759.302
            ],
            [
              -10.894,
              -7047.975,
              9791.811
            ],
            [
              -21.671,
              -6897.49,
              9942.681
            ],
            [
              -33.557,
              -6878.349,
              9965.213
            ],
            [
              -59.463,
              -6851.158,
              10002.769
            ],
            [
              -67.548,
              -6835.425,
              10020.457
            ],
            [
              -70.502,
              -6820.899,
              10035.281
            ],
            [
              -64.262,
              -6796.522,
              10060.444
            ],
            [
              -53.78,
              -6786.694,
              10074.813
            ],
            [
              -43.196,
              -6771.301,
              10093.493
            ],
            [
              -44.234,
              -6722.3,
              10142.506
            ],
            [
              -50.829,
              -6695.462,
              10170.142
            ],
            [
              -48.526,
              -6639.841,
              10225.81
            ],
            [
              -52.099,
              -6588.567,
              10277.209
            ],
            [
              -70.555,
              -6505.85,
              10361.959
            ],
            [
              -125.166,
              -6286.66,
              10587.851
            ],
            [
              -158.525,
              -6137.991,
              10740.216
            ],
            [
              -182.398,
              -6069.649,
              10812.608
            ],
            [
              -186.217,
              -6031.729,
              10850.72
            ],
            [
              -210.448,
              -5912.171,
              10972.708
            ],
            [
              -214.769,
              -5866.45,
              11018.634
            ],
            [
              -215.425,
              -5796.303,
              11088.783
            ],
            [
              -201.911,
              -5690.791,
              11195.157
            ],
            [
              -179.043,
              -5602.148,
              11286.702
            ],
            [
              -176.685,
              -5578.813,
              11310.156
            ],
            [
              -152.289,
              -5512.463,
              11380.85
            ],
            [
              -104.595,
              -5334.099,
              11565.48
            ],
            [
              -97,
              -5270.783,
              11629.25
            ],
            [
              -83.553,
              -5239.857,
              11662.973
            ],
            [
              -60.518,
              -5142.312,
              11763.201
            ],
            [
              -44.586,
              -5045.75,
              11861.068
            ],
            [
              -41.097,
              -4995.718,
              11911.222
            ],
            [
              -29.601,
              -4965.87,
              11943.207
            ],
            [
              29.378,
              -4628.52,
              12285.674
            ],
            [
              28.501,
              -4570.615,
              12343.585
            ],
            [
              22.071,
              -4499.251,
              12415.239
            ],
            [
              25.378,
              -4459.234,
              12455.392
            ],
            [
              38.073,
              -4363.727,
              12551.739
            ],
            [
              46.147,
              -4344.95,
              12572.179
            ],
            [
              45.488,
              -4310.427,
              12606.708
            ],
            [
              49.82,
              -4284.902,
              12632.598
            ],
            [
              60.111,
              -4250.579,
              12668.43
            ],
            [
              104.143,
              -4062.131,
              12861.953
            ],
            [
              126.577,
              -3997.973,
              12929.921
            ],
            [
              148.043,
              -3951.609,
              12981.013
            ],
            [
              179.07,
              -3910.986,
              13032.13
            ],
            [
              264.038,
              -3810.121,
              13164.014
            ],
            [
              345.157,
              -3743.697,
              13268.859
            ],
            [
              383.579,
              -3686.512,
              13337.753
            ],
            [
              446.225,
              -3608.619,
              13437.711
            ],
            [
              460.662,
              -3594.412,
              13457.967
            ],
            [
              478.493,
              -3535.737,
              13519.291
            ],
            [
              485.73,
              -3492.453,
              13563.176
            ],
            [
              490.942,
              -3419.075,
              13636.739
            ],
            [
              493.782,
              -3334.52,
              13721.341
            ],
            [
              479.687,
              -3259.675,
              13797.502
            ],
            [
              477.905,
              -3216.226,
              13840.988
            ],
            [
              481.339,
              -3169.533,
              13887.807
            ],
            [
              500.602,
              -3103.091,
              13956.985
            ],
            [
              500.428,
              -3077.483,
              13982.593
            ],
            [
              504.445,
              -3034.141,
              14026.122
            ],
            [
              503.491,
              -2980.688,
              14079.583
            ],
            [
              491.209,
              -2982.689,
              14092.027
            ],
            [
              442.304,
              -2978.453,
              14141.115
            ],
            [
              342.529,
              -2936.549,
              14249.332
            ],
            [
              249.744,
              -2864.719,
              14366.673
            ],
            [
              215.338,
              -2842.938,
              14407.393
            ],
            [
              172.556,
              -2821.005,
              14455.47
            ],
            [
              116.826,
              -2802.176,
              14514.295
            ],
            [
              -65.348,
              -2754.326,
              14702.648
            ],
            [
              -121.383,
              -2752.193,
              14758.724
            ],
            [
              -129.658,
              -2746.476,
              14768.781
            ],
            [
              -137.39,
              -2746.336,
              14776.514
            ],
            [
              -144.538,
              -2749.545,
              14784.35
            ],
            [
              -150.64,
              -2766.133,
              14802.024
            ],
            [
              -155.198,
              -2839.524,
              14875.557
            ],
            [
              -150.85,
              -2848.509,
              14885.538
            ],
            [
              -136.817,
              -2856.556,
              14901.715
            ],
            [
              -89.924,
              -2865.202,
              14949.398
            ],
            [
              -71.361,
              -2872.22,
              14969.243
            ],
            [
              -65.08,
              -2881.24,
              14980.235
            ],
            [
              -63.322,
              -2997.049,
              15096.057
            ],
            [
              -59.258,
              -3021.614,
              15120.956
            ],
            [
              -59.623,
              -3041.646,
              15140.991
            ],
            [
              -63.026,
              -3051.603,
              15151.514
            ],
            [
              -80.503,
              -3055.737,
              15169.473
            ],
            [
              -97.635,
              -3040.954,
              15192.102
            ],
            [
              -100.111,
              -3035.342,
              15198.235
            ],
            [
              -101.456,
              -3003.034,
              15230.571
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:15181",
              "position": {
                "x": 917.858,
                "z": -12855.062
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15182",
              "position": {
                "x": -20.524,
                "z": -13283.114
              },
              "distanceAlongShapeM": 1036.735,
              "shapeOffsetM": 0.742,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:4591",
              "position": {
                "x": -669.903,
                "z": -12959.58
              },
              "distanceAlongShapeM": 1803.9,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7106",
              "position": {
                "x": -1604.989,
                "z": -13070.742
              },
              "distanceAlongShapeM": 2967.812,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8325",
              "position": {
                "x": -1386.063,
                "z": -12518.049
              },
              "distanceAlongShapeM": 3562.311,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7103",
              "position": {
                "x": -1244.556,
                "z": -12195.527
              },
              "distanceAlongShapeM": 3914.511,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:7101",
              "position": {
                "x": -985.72,
                "z": -11538.926
              },
              "distanceAlongShapeM": 4620.288,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7099",
              "position": {
                "x": -754.749,
                "z": -10897.419
              },
              "distanceAlongShapeM": 5303.514,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7097",
              "position": {
                "x": -580.296,
                "z": -10430.79
              },
              "distanceAlongShapeM": 5804.409,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:8472",
              "position": {
                "x": -520.046,
                "z": -10337.257
              },
              "distanceAlongShapeM": 5922.501,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7094",
              "position": {
                "x": -562.717,
                "z": -9497.095
              },
              "distanceAlongShapeM": 6816.99,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7343",
              "position": {
                "x": -580.308,
                "z": -8870.019
              },
              "distanceAlongShapeM": 7445.88,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:7093",
              "position": {
                "x": -567.816,
                "z": -8465.025
              },
              "distanceAlongShapeM": 7851.921,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 9364.329,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 9759.302,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 10170.142,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 10812.608,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6494",
              "position": {
                "x": -176.685,
                "z": -5578.813
              },
              "distanceAlongShapeM": 11310.156,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6492",
              "position": {
                "x": -97,
                "z": -5270.783
              },
              "distanceAlongShapeM": 11629.25,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6489",
              "position": {
                "x": -41.097,
                "z": -4995.718
              },
              "distanceAlongShapeM": 11911.222,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 12632.598,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 12981.013,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 13337.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5131",
              "position": {
                "x": 442.304,
                "z": -2978.453
              },
              "distanceAlongShapeM": 14141.115,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:8463",
              "position": {
                "x": -121.383,
                "z": -2752.193
              },
              "distanceAlongShapeM": 14758.724,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:8462",
              "position": {
                "x": -101.456,
                "z": -3003.034
              },
              "distanceAlongShapeM": 15230.571,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            22320,
            27960,
            32040,
            35880,
            38880,
            42540,
            46020,
            48780,
            51840,
            54900,
            58260,
            62220,
            69960,
            75660,
            81480
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_27",
      "sourceRouteId": "vilnius_bus_27",
      "mode": "bus",
      "shortName": "27",
      "longName": "Kalvarijų–Tuskulėnų–Olandų–Arimų g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_27:0",
          "sourceRouteId": "vilnius_bus_27",
          "sourceShapeId": "vilnius_bus_27_a-b",
          "directionId": 0,
          "headsign": "Arimų g.",
          "directionName": "Kalvarijų–Tuskulėnų–Olandų–Arimų g.",
          "mode": "bus",
          "routeShortName": "27",
          "routeLongName": "Kalvarijų–Tuskulėnų–Olandų–Arimų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              673.267,
              -1632.329,
              0
            ],
            [
              699.977,
              -1617.234,
              30.68
            ],
            [
              762.593,
              -1542.685,
              128.038
            ],
            [
              891.199,
              -1385.857,
              330.853
            ],
            [
              926.904,
              -1337.532,
              390.938
            ],
            [
              934.987,
              -1318.756,
              411.38
            ],
            [
              959.848,
              -1299.175,
              443.026
            ],
            [
              1019.189,
              -1227.908,
              535.764
            ],
            [
              1188.158,
              -1016.171,
              806.657
            ],
            [
              1209.421,
              -982.054,
              846.859
            ],
            [
              1229.046,
              -966.831,
              871.696
            ],
            [
              1246.923,
              -941.557,
              902.653
            ],
            [
              1250.475,
              -923.811,
              920.751
            ],
            [
              1249.57,
              -868.132,
              976.437
            ],
            [
              1251.689,
              -858.152,
              986.64
            ],
            [
              1263.58,
              -842.786,
              1006.069
            ],
            [
              1271.438,
              -836.252,
              1016.289
            ],
            [
              1287.032,
              -829.861,
              1033.142
            ],
            [
              1306.39,
              -829.106,
              1052.515
            ],
            [
              1381.451,
              -814.909,
              1128.907
            ],
            [
              1625.047,
              -649.1,
              1423.579
            ],
            [
              1633.071,
              -633.663,
              1440.976
            ],
            [
              1640.869,
              -630.468,
              1449.403
            ],
            [
              1650.286,
              -609.492,
              1472.397
            ],
            [
              1647.435,
              -589.4,
              1492.689
            ],
            [
              1649.076,
              -570.506,
              1511.655
            ],
            [
              1661.593,
              -556.266,
              1530.614
            ],
            [
              1707.61,
              -543.762,
              1578.299
            ],
            [
              1715.531,
              -533.89,
              1590.957
            ],
            [
              1739.19,
              -475.328,
              1654.118
            ],
            [
              1739.832,
              -440.829,
              1688.622
            ],
            [
              1737.688,
              -417.411,
              1712.138
            ],
            [
              1728.721,
              -379.394,
              1751.198
            ],
            [
              1714.349,
              -354.636,
              1779.826
            ],
            [
              1709.957,
              -313.364,
              1821.331
            ],
            [
              1701.073,
              -270.896,
              1864.718
            ],
            [
              1691.292,
              -207.259,
              1929.102
            ],
            [
              1692.553,
              -139.375,
              1996.998
            ],
            [
              1699.889,
              -91.641,
              2045.292
            ],
            [
              1722.281,
              -31.942,
              2109.052
            ],
            [
              1763.619,
              40.763,
              2192.688
            ],
            [
              1781.292,
              89.417,
              2244.452
            ],
            [
              1803.689,
              114.605,
              2278.158
            ],
            [
              1864.141,
              209.22,
              2390.435
            ],
            [
              1913.636,
              269.526,
              2468.453
            ],
            [
              1990.962,
              334.88,
              2569.697
            ],
            [
              2015.503,
              371.16,
              2613.497
            ],
            [
              2052.586,
              388.28,
              2654.342
            ],
            [
              2087.216,
              412.125,
              2696.387
            ],
            [
              2136.967,
              451.273,
              2759.693
            ],
            [
              2182.309,
              496.069,
              2823.432
            ],
            [
              2210.658,
              528.937,
              2866.837
            ],
            [
              2229.877,
              556.409,
              2900.364
            ],
            [
              2244.749,
              592.868,
              2939.74
            ],
            [
              2266.569,
              621.404,
              2975.662
            ],
            [
              2281.67,
              670.105,
              3026.65
            ],
            [
              2292.591,
              736.695,
              3094.13
            ],
            [
              2303.283,
              756.534,
              3116.666
            ],
            [
              2315.701,
              765.207,
              3131.814
            ],
            [
              2333.819,
              768.208,
              3150.178
            ],
            [
              2353.101,
              764.507,
              3169.812
            ],
            [
              2377.645,
              731.764,
              3210.733
            ],
            [
              2411.777,
              694.387,
              3261.349
            ],
            [
              2432.805,
              680.634,
              3286.476
            ],
            [
              2453.583,
              653.527,
              3320.631
            ],
            [
              2501.276,
              617.009,
              3380.698
            ],
            [
              2634.367,
              525.451,
              3542.241
            ],
            [
              2716.164,
              450.439,
              3653.225
            ],
            [
              2739.748,
              435.524,
              3681.13
            ],
            [
              2755.449,
              412.963,
              3708.616
            ],
            [
              2864.4,
              307.38,
              3860.334
            ],
            [
              2936.644,
              239.224,
              3959.654
            ],
            [
              2983.62,
              199.374,
              4021.256
            ],
            [
              3035.88,
              166.104,
              4083.207
            ],
            [
              3060.52,
              138.92,
              4119.896
            ],
            [
              3266.423,
              -23.054,
              4381.872
            ],
            [
              3339.574,
              -76.762,
              4472.623
            ],
            [
              3415.597,
              -114.94,
              4557.694
            ],
            [
              3440.614,
              -122.094,
              4583.713
            ],
            [
              3506.161,
              -134.47,
              4650.419
            ],
            [
              3501.543,
              -139.949,
              4657.585
            ],
            [
              3709.123,
              -178.405,
              4868.696
            ],
            [
              3787.457,
              -196.594,
              4949.115
            ],
            [
              3851.65,
              -212.29,
              5015.198
            ],
            [
              3930.415,
              -241.623,
              5099.249
            ],
            [
              4021.131,
              -286.771,
              5200.578
            ],
            [
              4084.273,
              -323.602,
              5273.677
            ],
            [
              4172.173,
              -380.946,
              5378.628
            ],
            [
              4231.381,
              -421.043,
              5450.136
            ],
            [
              4243.975,
              -436.869,
              5470.362
            ],
            [
              4278.232,
              -466.47,
              5515.636
            ],
            [
              4369.696,
              -539.472,
              5632.661
            ],
            [
              4440.375,
              -586.471,
              5717.541
            ],
            [
              4472.351,
              -600.444,
              5752.436
            ],
            [
              4535.503,
              -602.77,
              5815.631
            ],
            [
              4564.597,
              -598.876,
              5844.984
            ],
            [
              4590.898,
              -606.061,
              5872.249
            ],
            [
              4601.063,
              -614.05,
              5885.177
            ],
            [
              4609.25,
              -624.226,
              5898.239
            ],
            [
              4621.934,
              -702.399,
              5977.433
            ],
            [
              4631.453,
              -710.375,
              5989.853
            ],
            [
              4640.435,
              -712.774,
              5999.149
            ],
            [
              4717.315,
              -705.347,
              6076.388
            ],
            [
              4759.473,
              -692.8,
              6120.372
            ],
            [
              4778.338,
              -684.257,
              6141.082
            ],
            [
              4804.23,
              -679.19,
              6167.465
            ],
            [
              4840.866,
              -685.462,
              6204.634
            ],
            [
              4882.423,
              -704.076,
              6250.169
            ],
            [
              4967.985,
              -748.031,
              6346.361
            ],
            [
              5000.623,
              -760.907,
              6381.448
            ],
            [
              5046.39,
              -761.792,
              6427.224
            ],
            [
              5082.21,
              -743.558,
              6467.416
            ],
            [
              5126.689,
              -711.02,
              6522.526
            ],
            [
              5199.704,
              -670.129,
              6606.212
            ],
            [
              5218.484,
              -666.04,
              6625.433
            ],
            [
              5232.623,
              -668.54,
              6639.791
            ],
            [
              5269.817,
              -679.28,
              6678.504
            ],
            [
              5328.496,
              -712.702,
              6746.034
            ],
            [
              5359.244,
              -723.317,
              6778.562
            ],
            [
              5431.804,
              -739.198,
              6852.84
            ],
            [
              5488.249,
              -754.766,
              6911.393
            ],
            [
              5584.849,
              -794.495,
              7015.843
            ],
            [
              5593.099,
              -801.335,
              7026.56
            ],
            [
              5638.476,
              -822.256,
              7076.528
            ],
            [
              5749.19,
              -865.603,
              7195.425
            ],
            [
              5850.363,
              -902.086,
              7302.975
            ],
            [
              5868.107,
              -918.018,
              7326.822
            ],
            [
              5911.331,
              -950.033,
              7380.611
            ],
            [
              6008.944,
              -1036.548,
              7511.046
            ],
            [
              6087.015,
              -1067.02,
              7594.853
            ],
            [
              6340.67,
              -1153.257,
              7862.766
            ],
            [
              6400.264,
              -1172.239,
              7925.31
            ],
            [
              6429.826,
              -1177.272,
              7955.297
            ],
            [
              6466.653,
              -1173.542,
              7992.313
            ],
            [
              6499.077,
              -1164.159,
              8026.067
            ],
            [
              6529.033,
              -1149.162,
              8059.567
            ],
            [
              6568.963,
              -1118.775,
              8109.745
            ],
            [
              6606.065,
              -1068.294,
              8172.394
            ],
            [
              6629.435,
              -1027.563,
              8219.354
            ],
            [
              6647.211,
              -1008.987,
              8245.065
            ],
            [
              6694.847,
              -947.581,
              8322.782
            ],
            [
              6719.092,
              -928.019,
              8353.934
            ],
            [
              6752.36,
              -908.635,
              8392.437
            ],
            [
              6802.323,
              -892.921,
              8444.813
            ],
            [
              6838.485,
              -890.294,
              8481.071
            ],
            [
              6873.828,
              -896.557,
              8516.964
            ],
            [
              7035.561,
              -935.376,
              8683.291
            ],
            [
              7128.227,
              -945.002,
              8776.455
            ],
            [
              7158.01,
              -938.912,
              8806.855
            ],
            [
              7214.756,
              -938.922,
              8863.6
            ],
            [
              7395.103,
              -916.892,
              9045.288
            ],
            [
              7530.909,
              -897.323,
              9182.496
            ],
            [
              7545.867,
              -890.94,
              9198.759
            ],
            [
              7569.695,
              -892.527,
              9222.64
            ],
            [
              7789.211,
              -879.085,
              9442.567
            ],
            [
              7854.937,
              -849.223,
              9514.759
            ],
            [
              7928.999,
              -821.755,
              9593.75
            ],
            [
              7958.873,
              -811.219,
              9625.427
            ],
            [
              8004.239,
              -799.879,
              9672.19
            ],
            [
              8037.181,
              -797.197,
              9705.241
            ],
            [
              8131.96,
              -797.979,
              9800.023
            ],
            [
              8199.6,
              -801.56,
              9867.757
            ],
            [
              8316.695,
              -815.038,
              9985.626
            ],
            [
              8390.735,
              -820.977,
              10059.903
            ],
            [
              8436.278,
              -833.024,
              10107.013
            ],
            [
              8452.882,
              -841.15,
              10125.499
            ],
            [
              8489.177,
              -864.145,
              10168.465
            ],
            [
              8593.333,
              -879.597,
              10273.761
            ],
            [
              8629.498,
              -876.985,
              10310.02
            ],
            [
              8794.329,
              -921.496,
              10480.755
            ],
            [
              8878.898,
              -948.807,
              10569.625
            ],
            [
              9226.371,
              -1049.347,
              10931.351
            ],
            [
              9252.086,
              -1053.208,
              10957.355
            ],
            [
              9273.821,
              -1062.554,
              10981.014
            ],
            [
              9471.264,
              -1119.997,
              11186.643
            ],
            [
              9672.457,
              -1183.092,
              11397.497
            ],
            [
              9718.457,
              -1204.068,
              11448.054
            ],
            [
              9984.772,
              -1298.562,
              11730.637
            ],
            [
              9948.453,
              -1403.585,
              11841.762
            ],
            [
              9942.996,
              -1481.405,
              11919.773
            ],
            [
              9920.124,
              -1591.155,
              12031.881
            ],
            [
              9910.147,
              -1637.711,
              12079.494
            ],
            [
              9897.638,
              -1681.988,
              12125.504
            ],
            [
              9883.468,
              -1712.871,
              12159.483
            ],
            [
              9889.155,
              -1718.554,
              12167.522
            ],
            [
              9889.595,
              -1728.582,
              12177.56
            ],
            [
              9866.153,
              -1771.523,
              12226.483
            ],
            [
              9862.264,
              -1772.557,
              12230.508
            ],
            [
              9855.887,
              -1769.087,
              12237.767
            ],
            [
              9855.311,
              -1765.735,
              12241.168
            ],
            [
              9859.336,
              -1758.024,
              12249.867
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6544",
              "position": {
                "x": 934.987,
                "z": -1318.756
              },
              "distanceAlongShapeM": 411.38,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6546",
              "position": {
                "x": 1209.421,
                "z": -982.054
              },
              "distanceAlongShapeM": 846.859,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 1779.826,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6568",
              "position": {
                "x": 1781.292,
                "z": 89.417
              },
              "distanceAlongShapeM": 2244.452,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 2613.497,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 2939.74,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:931",
              "position": {
                "x": 2432.805,
                "z": 680.634
              },
              "distanceAlongShapeM": 3286.476,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:387",
              "position": {
                "x": 2739.748,
                "z": 435.524
              },
              "distanceAlongShapeM": 3681.13,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5372",
              "position": {
                "x": 3035.88,
                "z": 166.104
              },
              "distanceAlongShapeM": 4083.207,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5373",
              "position": {
                "x": 3506.161,
                "z": -134.47
              },
              "distanceAlongShapeM": 4650.419,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7587",
              "position": {
                "x": 4231.381,
                "z": -421.043
              },
              "distanceAlongShapeM": 5450.136,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5381",
              "position": {
                "x": 4564.597,
                "z": -598.876
              },
              "distanceAlongShapeM": 5844.984,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5384",
              "position": {
                "x": 5584.849,
                "z": -794.495
              },
              "distanceAlongShapeM": 7015.843,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5385",
              "position": {
                "x": 5850.363,
                "z": -902.086
              },
              "distanceAlongShapeM": 7302.975,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5389",
              "position": {
                "x": 6629.435,
                "z": -1027.563
              },
              "distanceAlongShapeM": 8219.354,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5391",
              "position": {
                "x": 7158.01,
                "z": -938.912
              },
              "distanceAlongShapeM": 8806.855,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7586",
              "position": {
                "x": 7545.867,
                "z": -890.94
              },
              "distanceAlongShapeM": 9198.759,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6054",
              "position": {
                "x": 7958.873,
                "z": -811.219
              },
              "distanceAlongShapeM": 9625.427,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6056",
              "position": {
                "x": 8390.735,
                "z": -820.977
              },
              "distanceAlongShapeM": 10059.903,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6059",
              "position": {
                "x": 8794.329,
                "z": -921.496
              },
              "distanceAlongShapeM": 10480.755,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6062",
              "position": {
                "x": 9252.086,
                "z": -1053.208
              },
              "distanceAlongShapeM": 10957.355,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6065",
              "position": {
                "x": 9672.457,
                "z": -1183.092
              },
              "distanceAlongShapeM": 11397.497,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6069",
              "position": {
                "x": 9955.997,
                "z": -1381.473
              },
              "distanceAlongShapeM": 11818.398,
              "shapeOffsetM": 0.097,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:342",
              "position": {
                "x": 9859.336,
                "z": -1758.024
              },
              "distanceAlongShapeM": 12249.867,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            18720,
            21300,
            22500,
            23580,
            25740,
            27780,
            29280,
            30840,
            33360,
            36360,
            37980,
            40620,
            41940,
            43260,
            45420,
            46740,
            48420,
            50340,
            51660,
            54000,
            55080,
            56400,
            58860,
            60120,
            61860,
            64380,
            65940,
            67740,
            71820,
            73260,
            75060,
            76740,
            78180,
            79740,
            81240,
            82680,
            84120
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_27:1",
          "sourceRouteId": "vilnius_bus_27",
          "sourceShapeId": "vilnius_bus_27_b-a",
          "directionId": 1,
          "headsign": "Kalvarijų g.",
          "directionName": "Arimų–Olandų–Šeimyniškių–Kalvarijų g.",
          "mode": "bus",
          "routeShortName": "27",
          "routeLongName": "Kalvarijų–Tuskulėnų–Olandų–Arimų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9859.336,
              -1758.024,
              0
            ],
            [
              9897.638,
              -1681.988,
              85.139
            ],
            [
              9923.019,
              -1575.628,
              194.485
            ],
            [
              9942.374,
              -1480.279,
              291.779
            ],
            [
              9946.338,
              -1412.448,
              359.725
            ],
            [
              9955.14,
              -1360.302,
              412.608
            ],
            [
              9984.772,
              -1298.562,
              481.091
            ],
            [
              9756.88,
              -1217.097,
              723.106
            ],
            [
              9754.856,
              -1221.509,
              727.96
            ],
            [
              9705.012,
              -1199.341,
              782.512
            ],
            [
              9471.264,
              -1119.997,
              1029.358
            ],
            [
              9190.433,
              -1040.826,
              1321.137
            ],
            [
              9149.36,
              -1031.089,
              1363.348
            ],
            [
              9144.271,
              -1027.646,
              1369.492
            ],
            [
              9086.597,
              -1009.78,
              1429.87
            ],
            [
              8772.945,
              -926.631,
              1754.356
            ],
            [
              8687.842,
              -893.745,
              1845.592
            ],
            [
              8644.901,
              -880.635,
              1890.49
            ],
            [
              8624.985,
              -876.894,
              1910.753
            ],
            [
              8593.333,
              -879.597,
              1942.521
            ],
            [
              8489.821,
              -864.158,
              2047.178
            ],
            [
              8477.019,
              -859.447,
              2060.819
            ],
            [
              8459.816,
              -849.082,
              2080.904
            ],
            [
              8449.036,
              -839.959,
              2095.025
            ],
            [
              8421.519,
              -829.387,
              2124.503
            ],
            [
              8324.408,
              -816.306,
              2222.492
            ],
            [
              8300.557,
              -815.828,
              2246.347
            ],
            [
              8276.152,
              -810.886,
              2271.248
            ],
            [
              8198.955,
              -801.547,
              2349.008
            ],
            [
              8122.914,
              -798.912,
              2425.095
            ],
            [
              8006.796,
              -801.043,
              2541.233
            ],
            [
              7987.391,
              -803.996,
              2560.861
            ],
            [
              7940.535,
              -825.326,
              2612.343
            ],
            [
              7856.182,
              -851.475,
              2700.656
            ],
            [
              7787.9,
              -880.172,
              2774.724
            ],
            [
              7580.675,
              -891.632,
              2982.265
            ],
            [
              7571.54,
              -897.017,
              2992.869
            ],
            [
              7532.176,
              -898.461,
              3032.26
            ],
            [
              7253.497,
              -936.349,
              3313.502
            ],
            [
              7157.256,
              -944.463,
              3410.085
            ],
            [
              7057.345,
              -942.487,
              3510.015
            ],
            [
              6862.892,
              -895.228,
              3710.128
            ],
            [
              6815.28,
              -889.836,
              3758.045
            ],
            [
              6765.34,
              -904.438,
              3810.076
            ],
            [
              6738.048,
              -915.033,
              3839.352
            ],
            [
              6715.847,
              -929.068,
              3865.618
            ],
            [
              6696.803,
              -946.506,
              3891.439
            ],
            [
              6633.281,
              -1028.752,
              3995.359
            ],
            [
              6623.841,
              -1049.718,
              4018.353
            ],
            [
              6610.042,
              -1062.806,
              4037.371
            ],
            [
              6570.962,
              -1115.475,
              4102.955
            ],
            [
              6549.276,
              -1136.201,
              4132.953
            ],
            [
              6517.922,
              -1156.737,
              4170.433
            ],
            [
              6489.321,
              -1168.421,
              4201.329
            ],
            [
              6442.717,
              -1177.525,
              4248.814
            ],
            [
              6415.045,
              -1174.755,
              4276.624
            ],
            [
              6351.562,
              -1156.81,
              4342.595
            ],
            [
              6038.333,
              -1050.482,
              4673.379
            ],
            [
              6008.944,
              -1036.548,
              4705.904
            ],
            [
              5986.688,
              -1020.528,
              4733.326
            ],
            [
              5943.683,
              -977.383,
              4794.243
            ],
            [
              5898.548,
              -944.218,
              4850.253
            ],
            [
              5884.519,
              -936.151,
              4866.436
            ],
            [
              5868.73,
              -919.144,
              4889.642
            ],
            [
              5818.307,
              -892.555,
              4946.646
            ],
            [
              5645.523,
              -824.62,
              5132.305
            ],
            [
              5547.012,
              -783.74,
              5238.962
            ],
            [
              5505.995,
              -770.697,
              5282.003
            ],
            [
              5506.77,
              -764.032,
              5288.712
            ],
            [
              5491.429,
              -757.054,
              5305.566
            ],
            [
              5455.547,
              -745.225,
              5343.347
            ],
            [
              5442.719,
              -741.636,
              5356.667
            ],
            [
              5414.378,
              -739.973,
              5385.057
            ],
            [
              5390.419,
              -745.074,
              5409.553
            ],
            [
              5367.858,
              -744.637,
              5432.118
            ],
            [
              5351.184,
              -739.86,
              5449.463
            ],
            [
              5321.211,
              -722.58,
              5484.06
            ],
            [
              5288.274,
              -691.883,
              5529.084
            ],
            [
              5253.788,
              -674.516,
              5567.697
            ],
            [
              5232.623,
              -668.54,
              5589.689
            ],
            [
              5202.97,
              -667.966,
              5619.347
            ],
            [
              5176.283,
              -680.808,
              5648.964
            ],
            [
              5087.496,
              -736.981,
              5754.028
            ],
            [
              5069.833,
              -749.999,
              5775.97
            ],
            [
              5056.79,
              -757.54,
              5791.036
            ],
            [
              5034.723,
              -764.906,
              5814.3
            ],
            [
              5012.162,
              -764.47,
              5836.865
            ],
            [
              4982.617,
              -758.333,
              5867.041
            ],
            [
              4842.155,
              -685.487,
              6025.269
            ],
            [
              4820.99,
              -679.513,
              6047.261
            ],
            [
              4797.805,
              -677.953,
              6070.498
            ],
            [
              4773.826,
              -684.17,
              6095.271
            ],
            [
              4737.406,
              -700.168,
              6135.049
            ],
            [
              4707.625,
              -706.274,
              6165.45
            ],
            [
              4668.196,
              -711.082,
              6205.17
            ],
            [
              4623.675,
              -712.452,
              6249.712
            ],
            [
              4576.725,
              -705.983,
              6297.106
            ],
            [
              4556.226,
              -698.909,
              6318.791
            ],
            [
              4509.596,
              -675.748,
              6370.856
            ],
            [
              4499.453,
              -666.647,
              6384.484
            ],
            [
              4457.4,
              -640.235,
              6434.144
            ],
            [
              4437.737,
              -623.158,
              6460.187
            ],
            [
              4426.454,
              -606.243,
              6480.52
            ],
            [
              4266.373,
              -479.602,
              6684.637
            ],
            [
              4205.92,
              -437.254,
              6758.447
            ],
            [
              4102.373,
              -355.119,
              6890.614
            ],
            [
              4073.746,
              -334.533,
              6925.874
            ],
            [
              4021.499,
              -301.251,
              6987.821
            ],
            [
              3981.246,
              -281.557,
              7032.634
            ],
            [
              3924.337,
              -255.979,
              7095.027
            ],
            [
              3871.834,
              -236.053,
              7151.184
            ],
            [
              3794.896,
              -212.322,
              7231.698
            ],
            [
              3748.025,
              -201.41,
              7279.823
            ],
            [
              3692.751,
              -191.452,
              7335.986
            ],
            [
              3533.915,
              -167.282,
              7496.651
            ],
            [
              3462.629,
              -151.456,
              7569.673
            ],
            [
              3392.114,
              -128.967,
              7643.687
            ],
            [
              3396.087,
              -123.476,
              7650.465
            ],
            [
              3343.728,
              -95.766,
              7709.705
            ],
            [
              3282.595,
              -54.531,
              7783.445
            ],
            [
              2977.671,
              191.693,
              8175.37
            ],
            [
              2941.964,
              213.518,
              8217.219
            ],
            [
              2918.591,
              239.564,
              8252.214
            ],
            [
              2850.195,
              306.534,
              8347.938
            ],
            [
              2697.486,
              451.904,
              8558.775
            ],
            [
              2677.062,
              463.42,
              8582.222
            ],
            [
              2649.901,
              493.988,
              8623.113
            ],
            [
              2582.473,
              544.237,
              8707.206
            ],
            [
              2413.667,
              623.104,
              8893.527
            ],
            [
              2393.054,
              624.603,
              8914.194
            ],
            [
              2378.182,
              622.655,
              8929.193
            ],
            [
              2363.247,
              617.369,
              8945.036
            ],
            [
              2305.672,
              573.917,
              9017.168
            ],
            [
              2269.605,
              542.307,
              9065.126
            ],
            [
              2256.376,
              524.743,
              9087.115
            ],
            [
              2223.804,
              507.54,
              9123.951
            ],
            [
              1990.962,
              334.88,
              9413.825
            ],
            [
              1973.014,
              306.27,
              9447.598
            ],
            [
              1935.827,
              283.585,
              9491.158
            ],
            [
              1864.599,
              199.192,
              9601.592
            ],
            [
              1763.619,
              40.763,
              9789.466
            ],
            [
              1759.816,
              9.663,
              9820.798
            ],
            [
              1734.841,
              -15.477,
              9856.235
            ],
            [
              1714.048,
              -58.507,
              9904.025
            ],
            [
              1702.489,
              -90.576,
              9938.114
            ],
            [
              1692.553,
              -139.375,
              9987.913
            ],
            [
              1696.284,
              -216.258,
              10064.887
            ],
            [
              1701.445,
              -250.864,
              10099.876
            ],
            [
              1720.689,
              -325.809,
              10177.252
            ],
            [
              1735.144,
              -346.116,
              10202.179
            ],
            [
              1742.617,
              -429.749,
              10286.144
            ],
            [
              1739.19,
              -475.328,
              10331.852
            ],
            [
              1717.531,
              -565.098,
              10424.199
            ],
            [
              1721.402,
              -599.681,
              10458.997
            ],
            [
              1720.009,
              -605.221,
              10464.71
            ],
            [
              1712.088,
              -615.093,
              10477.367
            ],
            [
              1700.984,
              -622.679,
              10490.815
            ],
            [
              1684.224,
              -622.368,
              10507.578
            ],
            [
              1662.848,
              -627.537,
              10529.57
            ],
            [
              1381.451,
              -814.909,
              10867.642
            ],
            [
              1363.471,
              -845.747,
              10903.339
            ],
            [
              1363.126,
              -899.177,
              10956.769
            ],
            [
              1355.02,
              -919.065,
              10978.246
            ],
            [
              1339.886,
              -935.484,
              11000.576
            ],
            [
              1325.561,
              -943.011,
              11016.758
            ],
            [
              1293.291,
              -944.641,
              11049.069
            ],
            [
              1278.507,
              -942.141,
              11064.063
            ],
            [
              1268.297,
              -936.386,
              11075.783
            ],
            [
              1257.545,
              -925.054,
              11091.404
            ],
            [
              1253.197,
              -916.068,
              11101.387
            ],
            [
              1249.597,
              -901.529,
              11116.365
            ],
            [
              1250.468,
              -889.3,
              11128.625
            ],
            [
              1243.124,
              -868.013,
              11151.144
            ],
            [
              1234.408,
              -851.153,
              11170.123
            ],
            [
              1218.52,
              -838.613,
              11190.364
            ],
            [
              1192.86,
              -831.46,
              11217.002
            ],
            [
              1154.205,
              -829.633,
              11255.7
            ],
            [
              1120.288,
              -815.648,
              11292.388
            ],
            [
              1031.058,
              -793.963,
              11384.214
            ],
            [
              773.373,
              -745.803,
              11646.361
            ],
            [
              729.54,
              -744.998,
              11690.202
            ],
            [
              702.691,
              -732.259,
              11719.919
            ],
            [
              508.13,
              -687.5,
              11919.562
            ],
            [
              443.852,
              -676.304,
              11984.808
            ],
            [
              405.738,
              -680.059,
              12023.106
            ],
            [
              364.219,
              -693.772,
              12066.832
            ],
            [
              341.718,
              -690.021,
              12089.643
            ],
            [
              238.113,
              -713.732,
              12195.927
            ],
            [
              222.179,
              -844.803,
              12327.962
            ],
            [
              221.447,
              -884.866,
              12368.032
            ],
            [
              235.23,
              -977.516,
              12461.702
            ],
            [
              262.76,
              -1129.419,
              12616.08
            ],
            [
              277.464,
              -1242.125,
              12729.74
            ],
            [
              289.419,
              -1293.552,
              12782.539
            ],
            [
              297.35,
              -1318.188,
              12808.42
            ],
            [
              296.7,
              -1353.8,
              12844.038
            ],
            [
              342.249,
              -1718.661,
              13211.732
            ],
            [
              510.658,
              -1710.612,
              13380.333
            ],
            [
              549.551,
              -1699.08,
              13420.899
            ],
            [
              585.119,
              -1693.053,
              13456.975
            ],
            [
              616.278,
              -1681.379,
              13490.249
            ],
            [
              646.312,
              -1660.778,
              13526.669
            ],
            [
              673.267,
              -1632.329,
              13565.859
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:342",
              "position": {
                "x": 9859.336,
                "z": -1758.024
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -1020,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6068",
              "position": {
                "x": 9955.14,
                "z": -1360.302
              },
              "distanceAlongShapeM": 412.608,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6066",
              "position": {
                "x": 9754.856,
                "z": -1221.509
              },
              "distanceAlongShapeM": 727.96,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6064",
              "position": {
                "x": 9149.36,
                "z": -1031.089
              },
              "distanceAlongShapeM": 1363.348,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6060",
              "position": {
                "x": 8772.945,
                "z": -926.631
              },
              "distanceAlongShapeM": 1754.356,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6057",
              "position": {
                "x": 8300.557,
                "z": -815.828
              },
              "distanceAlongShapeM": 2246.347,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6055",
              "position": {
                "x": 7940.535,
                "z": -825.326
              },
              "distanceAlongShapeM": 2612.343,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5417",
              "position": {
                "x": 7571.54,
                "z": -897.017
              },
              "distanceAlongShapeM": 2992.869,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5390",
              "position": {
                "x": 7057.345,
                "z": -942.487
              },
              "distanceAlongShapeM": 3510.015,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5388",
              "position": {
                "x": 6623.841,
                "z": -1049.718
              },
              "distanceAlongShapeM": 4018.353,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5387",
              "position": {
                "x": 5884.519,
                "z": -936.151
              },
              "distanceAlongShapeM": 4866.436,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5383",
              "position": {
                "x": 5505.995,
                "z": -770.697
              },
              "distanceAlongShapeM": 5282.003,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5382",
              "position": {
                "x": 4576.725,
                "z": -705.983
              },
              "distanceAlongShapeM": 6297.106,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5421",
              "position": {
                "x": 4205.92,
                "z": -437.254
              },
              "distanceAlongShapeM": 6758.447,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5423",
              "position": {
                "x": 3392.114,
                "z": -128.967
              },
              "distanceAlongShapeM": 7643.687,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5424",
              "position": {
                "x": 2941.964,
                "z": 213.518
              },
              "distanceAlongShapeM": 8217.219,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5425",
              "position": {
                "x": 2677.062,
                "z": 463.42
              },
              "distanceAlongShapeM": 8582.222,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 9087.115,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 9447.598,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:603",
              "position": {
                "x": 1759.816,
                "z": 9.663
              },
              "distanceAlongShapeM": 9820.798,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6566",
              "position": {
                "x": 1735.144,
                "z": -346.116
              },
              "distanceAlongShapeM": 10202.179,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5662",
              "position": {
                "x": 1154.205,
                "z": -829.633
              },
              "distanceAlongShapeM": 11255.7,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5664",
              "position": {
                "x": 729.54,
                "z": -744.998
              },
              "distanceAlongShapeM": 11690.202,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 12066.832,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 12808.42,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 13565.859,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            19260,
            21540,
            28560,
            31080,
            34140,
            35760,
            38460,
            39780,
            41100,
            43260,
            44580,
            46260,
            48120,
            49440,
            51840,
            52920,
            54240,
            56640,
            57900,
            59640,
            62040,
            63600,
            65520,
            69660,
            71100,
            72900,
            74640,
            76140,
            77640,
            79140,
            80640,
            82140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_28",
      "sourceRouteId": "vilnius_bus_28",
      "mode": "bus",
      "shortName": "28",
      "longName": "Žemieji Paneriai–Grigiškės–Valai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_28:0",
          "sourceRouteId": "vilnius_bus_28",
          "sourceShapeId": "vilnius_bus_28_a-b",
          "directionId": 0,
          "headsign": "Valai",
          "directionName": "Žemieji Paneriai–Grigiškės–Valai",
          "mode": "bus",
          "routeShortName": "28",
          "routeLongName": "Žemieji Paneriai–Grigiškės–Valai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4333.961,
              4766.474,
              0
            ],
            [
              -4351.156,
              4780.129,
              21.957
            ],
            [
              -4357.738,
              4810.298,
              52.837
            ],
            [
              -4435.232,
              4883.989,
              159.774
            ],
            [
              -4468.845,
              4919.076,
              208.363
            ],
            [
              -4488.111,
              4924.973,
              228.512
            ],
            [
              -4509.692,
              4946.495,
              258.99
            ],
            [
              -4579.258,
              4993.33,
              342.853
            ],
            [
              -4600.366,
              5004.825,
              366.888
            ],
            [
              -4803.437,
              5135.209,
              608.213
            ],
            [
              -5487.637,
              5563.199,
              1415.248
            ],
            [
              -5524.11,
              5582.742,
              1456.626
            ],
            [
              -5595.44,
              5602.875,
              1530.743
            ],
            [
              -5632.195,
              5605.723,
              1567.609
            ],
            [
              -5680.721,
              5599.865,
              1616.487
            ],
            [
              -5736.61,
              5578.547,
              1676.304
            ],
            [
              -5812.979,
              5529.744,
              1766.935
            ],
            [
              -8196.815,
              3831.718,
              4693.702
            ],
            [
              -8220.463,
              3806.503,
              4728.271
            ],
            [
              -8230.579,
              3779.952,
              4756.683
            ],
            [
              -8228.952,
              3761.001,
              4775.704
            ],
            [
              -8222.183,
              3740.854,
              4796.958
            ],
            [
              -8213.977,
              3729.587,
              4810.896
            ],
            [
              -8191.613,
              3715.863,
              4837.136
            ],
            [
              -8152.917,
              3714.116,
              4875.871
            ],
            [
              -8136.659,
              3721.642,
              4893.786
            ],
            [
              -8123.535,
              3734.785,
              4912.36
            ],
            [
              -8111.647,
              3751.288,
              4932.698
            ],
            [
              -8109.901,
              3779.089,
              4960.554
            ],
            [
              -8127.628,
              3839.491,
              5023.503
            ],
            [
              -8136.789,
              3831.848,
              5035.433
            ],
            [
              -8156.66,
              3919.002,
              5124.823
            ],
            [
              -8177.425,
              3951.624,
              5163.493
            ],
            [
              -8195.31,
              3963.048,
              5184.716
            ],
            [
              -8228.791,
              3968.049,
              5218.568
            ],
            [
              -8312.285,
              3953.83,
              5303.264
            ],
            [
              -8659.37,
              3923.869,
              5651.64
            ],
            [
              -8752.504,
              3912.026,
              5745.524
            ],
            [
              -8779.176,
              3899.101,
              5775.163
            ],
            [
              -8720.652,
              3687.761,
              5994.457
            ],
            [
              -8722.841,
              3672.212,
              6010.159
            ],
            [
              -8968.433,
              3531.486,
              6293.213
            ],
            [
              -9013.904,
              3513.299,
              6342.186
            ],
            [
              -9022.955,
              3512.332,
              6351.288
            ],
            [
              -9026.79,
              3514.621,
              6355.754
            ],
            [
              -9027.9,
              3525.77,
              6366.959
            ],
            [
              -9023.903,
              3533.498,
              6375.659
            ],
            [
              -8978.306,
              3559.475,
              6428.137
            ],
            [
              -8907.726,
              3573.916,
              6500.179
            ],
            [
              -8722.123,
              3676.653,
              6712.319
            ],
            [
              -8779.176,
              3899.101,
              6941.967
            ],
            [
              -8775.178,
              3906.828,
              6950.667
            ],
            [
              -8725.24,
              3921.601,
              7002.744
            ],
            [
              -8451.198,
              3944.967,
              7277.781
            ],
            [
              -8270.179,
              3963.16,
              7459.712
            ],
            [
              -8258.746,
              3951.842,
              7475.8
            ],
            [
              -8249.967,
              3936.114,
              7493.812
            ],
            [
              -8249.705,
              3912.733,
              7517.194
            ],
            [
              -8244.852,
              3893.729,
              7536.807
            ],
            [
              -8227.04,
              3877.853,
              7560.668
            ],
            [
              -8207.846,
              3867.521,
              7582.466
            ],
            [
              -8172.267,
              3872.504,
              7618.393
            ],
            [
              -8063.214,
              3949.752,
              7752.033
            ],
            [
              -8055.069,
              3974.108,
              7777.715
            ],
            [
              -8055.848,
              4005.29,
              7808.907
            ],
            [
              -8074.251,
              4024.515,
              7835.52
            ],
            [
              -8096.081,
              4031.552,
              7858.456
            ],
            [
              -8116.784,
              4028.552,
              7879.376
            ],
            [
              -8133.78,
              4015.473,
              7900.822
            ],
            [
              -8145.023,
              3998.959,
              7920.8
            ],
            [
              -8147.86,
              3983.421,
              7936.594
            ],
            [
              -8144.298,
              3964.439,
              7955.908
            ],
            [
              -8134.965,
              3943.136,
              7979.166
            ],
            [
              -8132.895,
              3911.933,
              8010.437
            ],
            [
              -8106.816,
              3849.168,
              8078.405
            ],
            [
              -8089.96,
              3814.383,
              8117.058
            ],
            [
              -8059.871,
              3799.418,
              8150.663
            ],
            [
              -8032.144,
              3797.85,
              8178.435
            ],
            [
              -8004.197,
              3809.637,
              8208.765
            ],
            [
              -7987.074,
              3830.506,
              8235.76
            ],
            [
              -7980.773,
              3860.458,
              8266.368
            ],
            [
              -7984.87,
              3886.128,
              8292.363
            ],
            [
              -8000.009,
              3907.527,
              8318.575
            ],
            [
              -8026.263,
              3920.203,
              8347.73
            ],
            [
              -8048.811,
              3922.799,
              8370.426
            ],
            [
              -8077.33,
              3915.475,
              8399.871
            ],
            [
              -8128.171,
              3885.14,
              8459.074
            ],
            [
              -8196.815,
              3831.718,
              8546.056
            ],
            [
              -8342.269,
              3738.365,
              8718.89
            ],
            [
              -8673.968,
              3542.289,
              9104.208
            ],
            [
              -9951.171,
              2814.843,
              10574.047
            ],
            [
              -10347.037,
              2591.844,
              11028.402
            ],
            [
              -10561.984,
              2505.092,
              11260.195
            ],
            [
              -10579.01,
              2448.591,
              11319.205
            ],
            [
              -10587.05,
              2429.795,
              11339.649
            ],
            [
              -10670.197,
              2394.378,
              11430.025
            ],
            [
              -10685.89,
              2381.268,
              11450.473
            ],
            [
              -10763.716,
              2355.784,
              11532.365
            ],
            [
              -10781.795,
              2354.956,
              11550.463
            ],
            [
              -10804.981,
              2357.549,
              11573.793
            ],
            [
              -10822.273,
              2365.615,
              11592.875
            ],
            [
              -10871.238,
              2410.915,
              11659.58
            ],
            [
              -10882.01,
              2423.329,
              11676.017
            ],
            [
              -10933.179,
              2410.779,
              11728.702
            ],
            [
              -11014.265,
              2383.116,
              11814.377
            ],
            [
              -11042.752,
              2376.885,
              11843.537
            ],
            [
              -11076.276,
              2378.527,
              11877.102
            ],
            [
              -11111.788,
              2376.859,
              11912.653
            ],
            [
              -11167.733,
              2347.684,
              11975.749
            ],
            [
              -11176.641,
              2355.616,
              11987.676
            ],
            [
              -11189.785,
              2381.426,
              12016.64
            ],
            [
              -11210.634,
              2409.582,
              12051.675
            ],
            [
              -11223.935,
              2425.375,
              12072.323
            ],
            [
              -11236.068,
              2433.358,
              12086.847
            ],
            [
              -11281.586,
              2451.884,
              12135.991
            ],
            [
              -11308.608,
              2456.76,
              12163.449
            ],
            [
              -11333.103,
              2458.258,
              12187.989
            ],
            [
              -11358.329,
              2454.201,
              12213.54
            ],
            [
              -11398.758,
              2427.006,
              12262.264
            ],
            [
              -11421.439,
              2420.682,
              12285.81
            ],
            [
              -11656.141,
              2306.359,
              12546.875
            ],
            [
              -11912.865,
              2185.688,
              12830.545
            ],
            [
              -11986.897,
              2154.558,
              12910.856
            ],
            [
              -12000.581,
              2145.866,
              12927.067
            ],
            [
              -12140.971,
              2079.03,
              13082.555
            ],
            [
              -12148.221,
              2069.124,
              13094.831
            ],
            [
              -12128.727,
              2036.54,
              13132.801
            ],
            [
              -12035.317,
              1820.251,
              13368.399
            ],
            [
              -12277.032,
              1708.233,
              13634.809
            ],
            [
              -12421.988,
              1637.007,
              13796.318
            ],
            [
              -12458.258,
              1627.549,
              13833.802
            ],
            [
              -12567.869,
              1589.167,
              13949.938
            ],
            [
              -12592.043,
              1652.989,
              14018.185
            ],
            [
              -12647.185,
              1758.475,
              14137.214
            ],
            [
              -12661.996,
              1802.116,
              14183.3
            ],
            [
              -12663.063,
              1816.603,
              14197.827
            ],
            [
              -12603.058,
              1859.092,
              14271.351
            ],
            [
              -12599.171,
              1860.145,
              14275.378
            ],
            [
              -12592.773,
              1856.707,
              14282.641
            ],
            [
              -12663.063,
              1816.603,
              14363.567
            ],
            [
              -12635.223,
              1739.367,
              14445.667
            ],
            [
              -12595.689,
              1667.516,
              14527.676
            ],
            [
              -12567.207,
              1590.27,
              14610.007
            ],
            [
              -12880.937,
              1491.574,
              14938.895
            ],
            [
              -12909.89,
              1496.471,
              14968.259
            ],
            [
              -12988.807,
              1482.097,
              15048.475
            ],
            [
              -13060.087,
              1460.926,
              15122.832
            ],
            [
              -13069.286,
              1449.935,
              15137.165
            ],
            [
              -13071.783,
              1413.24,
              15173.945
            ],
            [
              -13056.223,
              1376.267,
              15214.058
            ],
            [
              -13028.715,
              1361.375,
              15245.339
            ],
            [
              -12991.311,
              1360.802,
              15282.747
            ],
            [
              -12977.192,
              1356.133,
              15297.618
            ],
            [
              -12974.022,
              1310.445,
              15343.416
            ],
            [
              -12989.08,
              1253.905,
              15401.926
            ],
            [
              -13030.02,
              1149.897,
              15513.703
            ],
            [
              -13073.534,
              1088.227,
              15589.179
            ],
            [
              -13296.265,
              863.436,
              15905.628
            ],
            [
              -13335.311,
              798.356,
              15981.522
            ],
            [
              -13381.804,
              710.013,
              16081.353
            ],
            [
              -13413.857,
              680.447,
              16124.96
            ],
            [
              -13416.911,
              649.325,
              16156.231
            ],
            [
              -13432.827,
              620.626,
              16189.048
            ],
            [
              -13439.172,
              585.102,
              16225.134
            ],
            [
              -13437.288,
              539.434,
              16270.841
            ],
            [
              -13456.986,
              431.758,
              16380.303
            ],
            [
              -13485.064,
              324.211,
              16491.456
            ],
            [
              -13488.966,
              279.744,
              16536.093
            ],
            [
              -13487.166,
              228.512,
              16587.357
            ],
            [
              -13488.064,
              169.529,
              16646.347
            ],
            [
              -13504.299,
              77.384,
              16739.911
            ],
            [
              -13519.974,
              21.965,
              16797.504
            ],
            [
              -13518.26,
              7.468,
              16812.102
            ],
            [
              -13498.681,
              -19.545,
              16845.464
            ],
            [
              -13493.234,
              -43.004,
              16869.547
            ],
            [
              -13495.1,
              -80.823,
              16907.412
            ],
            [
              -13501.156,
              -97.428,
              16925.087
            ],
            [
              -13545.009,
              -182.473,
              17020.773
            ],
            [
              -13549.283,
              -209.124,
              17047.764
            ],
            [
              -13553.981,
              -263.597,
              17102.439
            ],
            [
              -13560.036,
              -280.202,
              17120.114
            ],
            [
              -13625.89,
              -328.179,
              17201.591
            ],
            [
              -13646.229,
              -351.246,
              17232.345
            ],
            [
              -13659.68,
              -387.776,
              17271.272
            ],
            [
              -13671.008,
              -454.393,
              17338.845
            ],
            [
              -13700.912,
              -512.935,
              17404.583
            ],
            [
              -13707.747,
              -538.434,
              17430.982
            ],
            [
              -13724.873,
              -647.263,
              17541.15
            ],
            [
              -13765.746,
              -749.052,
              17650.839
            ],
            [
              -13858.959,
              -901.254,
              17829.316
            ],
            [
              -13867.912,
              -938.966,
              17868.076
            ],
            [
              -13874.303,
              -977.829,
              17907.461
            ],
            [
              -13859.963,
              -1052.627,
              17983.622
            ],
            [
              -13853.737,
              -1067.192,
              17999.462
            ],
            [
              -13839.473,
              -1061.843,
              18014.696
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 228.512,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6294",
              "position": {
                "x": -8136.789,
                "z": 3831.848
              },
              "distanceAlongShapeM": 5035.433,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:4455",
              "position": {
                "x": -8968.433,
                "z": 3531.486
              },
              "distanceAlongShapeM": 6293.213,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:9109",
              "position": {
                "x": -10685.89,
                "z": 2381.268
              },
              "distanceAlongShapeM": 11450.473,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9834",
              "position": {
                "x": -11398.758,
                "z": 2427.006
              },
              "distanceAlongShapeM": 12262.264,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:8944",
              "position": {
                "x": -11656.141,
                "z": 2306.359
              },
              "distanceAlongShapeM": 12546.875,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6603",
              "position": {
                "x": -11912.865,
                "z": 2185.688
              },
              "distanceAlongShapeM": 12830.545,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9082",
              "position": {
                "x": -12128.727,
                "z": 2036.54
              },
              "distanceAlongShapeM": 13132.801,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 14282.641,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:16268",
              "position": {
                "x": -13073.534,
                "z": 1088.227
              },
              "distanceAlongShapeM": 15589.179,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:16266",
              "position": {
                "x": -13381.804,
                "z": 710.013
              },
              "distanceAlongShapeM": 16081.353,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:10250",
              "position": {
                "x": -13839.473,
                "z": -1061.843
              },
              "distanceAlongShapeM": 18014.696,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            }
          ],
          "departuresSeconds": [
            18300,
            19860,
            21300,
            23220,
            25020,
            26400,
            28500,
            31740,
            36540,
            41400,
            46260,
            51180,
            53100,
            55020,
            56520,
            58140,
            59820,
            61500,
            63180,
            64980,
            68280,
            72720,
            77400
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_28:1",
          "sourceRouteId": "vilnius_bus_28",
          "sourceShapeId": "vilnius_bus_28_b-a",
          "directionId": 1,
          "headsign": "Žemieji Paneriai",
          "directionName": "Valai–Grigiškės–Žemieji Paneriai",
          "mode": "bus",
          "routeShortName": "28",
          "routeLongName": "Žemieji Paneriai–Grigiškės–Valai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -13839.473,
              -1061.843,
              0
            ],
            [
              -13848.698,
              -1075.061,
              16.119
            ],
            [
              -13859.062,
              -1078.243,
              26.96
            ],
            [
              -13876.085,
              -967.784,
              138.724
            ],
            [
              -13866.235,
              -913.388,
              194.004
            ],
            [
              -13829.043,
              -841.597,
              274.856
            ],
            [
              -13771.038,
              -757.877,
              376.708
            ],
            [
              -13728.13,
              -649.44,
              493.326
            ],
            [
              -13708.29,
              -531.747,
              612.679
            ],
            [
              -13702.863,
              -514.019,
              631.219
            ],
            [
              -13668.99,
              -448.858,
              704.659
            ],
            [
              -13670.299,
              -407.651,
              745.886
            ],
            [
              -13642.837,
              -340.166,
              818.745
            ],
            [
              -13563.904,
              -280.143,
              917.907
            ],
            [
              -13553.743,
              -248.016,
              951.602
            ],
            [
              -13546.281,
              -181.341,
              1018.694
            ],
            [
              -13497.831,
              -90.8,
              1121.383
            ],
            [
              -13492.199,
              -59.717,
              1152.972
            ],
            [
              -13498.681,
              -19.545,
              1193.663
            ],
            [
              -13520.686,
              17.524,
              1236.772
            ],
            [
              -13498.768,
              101.789,
              1323.841
            ],
            [
              -13485.096,
              195.086,
              1418.134
            ],
            [
              -13485.76,
              320.882,
              1543.932
            ],
            [
              -13444.041,
              519.5,
              1746.884
            ],
            [
              -13444.925,
              588.529,
              1815.919
            ],
            [
              -13434.049,
              625.097,
              1854.07
            ],
            [
              -13420.118,
              650.487,
              1883.031
            ],
            [
              -13413.857,
              680.447,
              1913.637
            ],
            [
              -13355.045,
              773.055,
              2023.342
            ],
            [
              -13310.01,
              850.288,
              2112.746
            ],
            [
              -13281.128,
              883.242,
              2156.565
            ],
            [
              -13093.644,
              1080.743,
              2428.883
            ],
            [
              -13049.825,
              1120.145,
              2487.812
            ],
            [
              -13017.239,
              1184.208,
              2559.687
            ],
            [
              -12990.25,
              1261.715,
              2641.758
            ],
            [
              -12972.818,
              1304.861,
              2688.292
            ],
            [
              -12977.192,
              1356.133,
              2739.751
            ],
            [
              -12990.004,
              1361.895,
              2753.799
            ],
            [
              -13008.147,
              1356.607,
              2772.696
            ],
            [
              -13040.916,
              1364.902,
              2806.499
            ],
            [
              -13056.868,
              1376.277,
              2826.092
            ],
            [
              -13070.07,
              1398.742,
              2852.149
            ],
            [
              -13076.127,
              1424.438,
              2878.549
            ],
            [
              -13069.999,
              1445.494,
              2900.478
            ],
            [
              -13056.184,
              1463.092,
              2922.852
            ],
            [
              -13023.106,
              1474.83,
              2957.95
            ],
            [
              -12949.959,
              1491.52,
              3032.977
            ],
            [
              -12873.164,
              1493.681,
              3109.803
            ],
            [
              -12567.19,
              1591.383,
              3430.998
            ],
            [
              -12603.936,
              1676.549,
              3523.753
            ],
            [
              -12644.811,
              1745.081,
              3603.549
            ],
            [
              -12665.694,
              1813.304,
              3674.897
            ],
            [
              -12643.32,
              1841.902,
              3711.207
            ],
            [
              -12604.297,
              1862.45,
              3755.31
            ],
            [
              -12592.773,
              1856.707,
              3768.185
            ],
            [
              -12609.12,
              1842.488,
              3789.851
            ],
            [
              -12646.157,
              1825.248,
              3830.704
            ],
            [
              -12663.097,
              1814.378,
              3850.832
            ],
            [
              -12644.743,
              1749.532,
              3918.225
            ],
            [
              -12598.286,
              1666.443,
              4013.419
            ],
            [
              -12567.852,
              1590.28,
              4095.438
            ],
            [
              -12416.777,
              1640.266,
              4254.568
            ],
            [
              -12254.88,
              1722.36,
              4436.09
            ],
            [
              -12209.896,
              1752.832,
              4490.422
            ],
            [
              -12156.769,
              1767.592,
              4545.562
            ],
            [
              -12039.728,
              1826.999,
              4676.817
            ],
            [
              -12150.225,
              2064.703,
              4938.948
            ],
            [
              -12150.767,
              2071.39,
              4945.657
            ],
            [
              -12148.083,
              2078.027,
              4952.816
            ],
            [
              -11899.757,
              2198.842,
              5228.972
            ],
            [
              -11702.181,
              2291.494,
              5447.194
            ],
            [
              -11379.703,
              2448.97,
              5806.068
            ],
            [
              -11340.826,
              2459.492,
              5846.344
            ],
            [
              -11266.123,
              2450.528,
              5921.583
            ],
            [
              -11225.137,
              2430.96,
              5967
            ],
            [
              -11206.711,
              2412.86,
              5992.829
            ],
            [
              -11189.627,
              2391.441,
              6020.226
            ],
            [
              -11131.53,
              2270.307,
              6154.573
            ],
            [
              -10823.4,
              2416.838,
              6495.77
            ],
            [
              -10425.338,
              2577.505,
              6925.034
            ],
            [
              -10236.011,
              2675.791,
              7138.352
            ],
            [
              -9100.321,
              3317.667,
              8442.881
            ],
            [
              -8699.614,
              3552.725,
              8907.444
            ],
            [
              -8694.717,
              3576.022,
              8931.25
            ],
            [
              -8713.452,
              3654.249,
              9011.689
            ],
            [
              -8726.784,
              3667.823,
              9030.716
            ],
            [
              -8731.283,
              3669.01,
              9035.368
            ],
            [
              -8736.463,
              3667.981,
              9040.65
            ],
            [
              -8968.433,
              3531.486,
              9309.799
            ],
            [
              -9013.223,
              3515.514,
              9357.35
            ],
            [
              -9020.32,
              3515.629,
              9364.449
            ],
            [
              -9024.119,
              3520.143,
              9370.349
            ],
            [
              -9020.695,
              3532.333,
              9383.01
            ],
            [
              -9010.873,
              3541.079,
              9396.162
            ],
            [
              -8971.782,
              3563.822,
              9441.387
            ],
            [
              -8965.957,
              3564.841,
              9447.301
            ],
            [
              -8962.122,
              3562.553,
              9451.767
            ],
            [
              -8955.814,
              3553.545,
              9462.763
            ],
            [
              -8939.003,
              3555.499,
              9479.688
            ],
            [
              -8726.694,
              3673.388,
              9722.531
            ],
            [
              -8720.869,
              3674.406,
              9728.444
            ],
            [
              -8717.052,
              3671.005,
              9733.557
            ],
            [
              -8695.718,
              3593.849,
              9813.608
            ],
            [
              -8681.095,
              3580.253,
              9833.575
            ],
            [
              -8670.863,
              3574.521,
              9845.304
            ],
            [
              -8641.111,
              3578.489,
              9875.319
            ],
            [
              -8411.763,
              3711.671,
              10140.532
            ],
            [
              -8298.292,
              3783.286,
              10274.712
            ],
            [
              -8231.731,
              3827.837,
              10354.807
            ],
            [
              -7508.767,
              4341.367,
              11241.593
            ],
            [
              -6658.319,
              4940.599,
              12281.949
            ],
            [
              -6504.085,
              5052.678,
              12472.605
            ],
            [
              -5804.914,
              5548.532,
              13329.759
            ],
            [
              -5744.224,
              5586.468,
              13401.329
            ],
            [
              -5688.924,
              5611.136,
              13461.882
            ],
            [
              -5631.932,
              5621.303,
              13519.774
            ],
            [
              -5579.095,
              5614.843,
              13573.005
            ],
            [
              -5534.174,
              5598.497,
              13620.807
            ],
            [
              -5442.053,
              5547.954,
              13725.882
            ],
            [
              -4778.303,
              5132.552,
              14508.904
            ],
            [
              -4580.889,
              5011.17,
              14740.65
            ],
            [
              -4534.858,
              4984.776,
              14793.711
            ],
            [
              -4517.509,
              4980.025,
              14811.699
            ],
            [
              -4380.813,
              4857.45,
              14995.303
            ],
            [
              -4298.311,
              4774.766,
              15112.107
            ],
            [
              -4237.94,
              4719.179,
              15194.171
            ],
            [
              -4229.781,
              4705.68,
              15209.945
            ],
            [
              -4240.925,
              4695.853,
              15224.803
            ],
            [
              -4266.982,
              4719.679,
              15260.111
            ],
            [
              -4289.168,
              4743.439,
              15292.618
            ],
            [
              -4311.679,
              4748.279,
              15315.644
            ],
            [
              -4321.909,
              4754.022,
              15327.376
            ],
            [
              -4333.961,
              4766.474,
              15344.705
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:10250",
              "position": {
                "x": -13839.473,
                "z": -1061.843
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:16263",
              "position": {
                "x": -13355.045,
                "z": 773.055
              },
              "distanceAlongShapeM": 2023.342,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:16267",
              "position": {
                "x": -13093.644,
                "z": 1080.743
              },
              "distanceAlongShapeM": 2428.883,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 3768.185,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:15964",
              "position": {
                "x": -12209.896,
                "z": 1752.832
              },
              "distanceAlongShapeM": 4490.422,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:16236",
              "position": {
                "x": -12092.77,
                "z": 1942.477
              },
              "distanceAlongShapeM": 4803.893,
              "shapeOffsetM": 0.579,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:8945",
              "position": {
                "x": -11899.757,
                "z": 2198.842
              },
              "distanceAlongShapeM": 5228.972,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6604",
              "position": {
                "x": -11702.181,
                "z": 2291.494
              },
              "distanceAlongShapeM": 5447.194,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:4454",
              "position": {
                "x": -11189.627,
                "z": 2391.441
              },
              "distanceAlongShapeM": 6020.226,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:4455",
              "position": {
                "x": -8968.433,
                "z": 3531.486
              },
              "distanceAlongShapeM": 9309.799,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 14811.699,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            20460,
            20520,
            22140,
            22860,
            23580,
            25620,
            27360,
            27720,
            28680,
            31080,
            34020,
            38880,
            43740,
            48660,
            53520,
            55440,
            56520,
            57360,
            58980,
            60600,
            61440,
            62340,
            63960,
            64020,
            65700,
            66480,
            67380,
            70320,
            70620,
            74700,
            75060,
            79080,
            79740,
            83400
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_29",
      "sourceRouteId": "vilnius_bus_29",
      "mode": "bus",
      "shortName": "29",
      "longName": "Vilkpėdė–Žemaitės g.–Lazdynai–Grigiškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_29:0",
          "sourceRouteId": "vilnius_bus_29",
          "sourceShapeId": "vilnius_bus_29_a-b",
          "directionId": 0,
          "headsign": "Grigiškės",
          "directionName": "Vilkpėdė–Žemaitės g.–Lazdynai–Grigiškės",
          "mode": "bus",
          "routeShortName": "29",
          "routeLongName": "Vilkpėdė–Žemaitės g.–Lazdynai–Grigiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2002.849,
              2542.722,
              0
            ],
            [
              -2009.26,
              2545.063,
              6.825
            ],
            [
              -2019.015,
              2540.783,
              17.477
            ],
            [
              -2077.913,
              2530.695,
              77.234
            ],
            [
              -2083.871,
              2558.631,
              105.798
            ],
            [
              -2083.009,
              2570.861,
              118.058
            ],
            [
              -2085.352,
              2584.261,
              131.662
            ],
            [
              -2057.496,
              2590.447,
              160.197
            ],
            [
              -2051.124,
              2585.881,
              168.036
            ],
            [
              -2042.349,
              2571.254,
              185.093
            ],
            [
              -2044.403,
              2564.611,
              192.046
            ],
            [
              -2036.471,
              2538.866,
              218.985
            ],
            [
              -2016.375,
              2544.076,
              239.745
            ],
            [
              -2000.11,
              2551.579,
              257.657
            ],
            [
              -1974.301,
              2587.857,
              302.18
            ],
            [
              -1936.577,
              2568.263,
              344.688
            ],
            [
              -1765.274,
              2512.896,
              524.717
            ],
            [
              -1632.053,
              2457.088,
              669.155
            ],
            [
              -1563.915,
              2442.514,
              738.834
            ],
            [
              -1527.823,
              2404.02,
              791.602
            ],
            [
              -1399.067,
              2279.266,
              970.883
            ],
            [
              -1328.942,
              2195.633,
              1080.025
            ],
            [
              -1190.297,
              2047.317,
              1283.052
            ],
            [
              -1411.426,
              1768.519,
              1638.899
            ],
            [
              -1434.923,
              1753.354,
              1666.864
            ],
            [
              -1515.962,
              1659.065,
              1791.193
            ],
            [
              -1594.12,
              1581.422,
              1901.362
            ],
            [
              -1688.349,
              1470.667,
              2046.778
            ],
            [
              -1695.542,
              1465.229,
              2055.795
            ],
            [
              -1708.441,
              1465.459,
              2068.695
            ],
            [
              -1712.191,
              1472.205,
              2076.414
            ],
            [
              -1970.62,
              1705.012,
              2424.243
            ],
            [
              -1985.783,
              1723.093,
              2447.84
            ],
            [
              -2263.842,
              1978.495,
              2825.393
            ],
            [
              -2290.557,
              2000.118,
              2859.763
            ],
            [
              -2318.992,
              2034.018,
              2904.009
            ],
            [
              -2425.036,
              2130.514,
              3047.386
            ],
            [
              -2441.629,
              2140.826,
              3066.922
            ],
            [
              -2453.884,
              2141.043,
              3079.179
            ],
            [
              -2464.869,
              2140.123,
              3090.203
            ],
            [
              -2491.57,
              2126.123,
              3120.351
            ],
            [
              -2514.888,
              2120.968,
              3144.233
            ],
            [
              -2528.453,
              2120.094,
              3157.826
            ],
            [
              -2551.595,
              2124.955,
              3181.472
            ],
            [
              -2561.836,
              2129.588,
              3192.713
            ],
            [
              -2579.681,
              2142.148,
              3214.535
            ],
            [
              -2607.297,
              2186.05,
              3266.4
            ],
            [
              -2618.809,
              2191.819,
              3279.277
            ],
            [
              -2625.885,
              2193.057,
              3286.46
            ],
            [
              -2640.075,
              2193.306,
              3300.653
            ],
            [
              -2665.388,
              2184.846,
              3327.341
            ],
            [
              -2681.67,
              2176.227,
              3345.764
            ],
            [
              -2690.837,
              2168.596,
              3357.692
            ],
            [
              -2745.273,
              2155.082,
              3413.78
            ],
            [
              -2858.912,
              2113.664,
              3534.732
            ],
            [
              -2885.494,
              2106.338,
              3562.305
            ],
            [
              -2963.852,
              2089.902,
              3642.368
            ],
            [
              -3175.505,
              2014.571,
              3867.027
            ],
            [
              -3269.787,
              1972.804,
              3970.147
            ],
            [
              -3463.705,
              1914.962,
              4172.507
            ],
            [
              -3534.885,
              1902.843,
              4244.711
            ],
            [
              -3642.009,
              1901.368,
              4351.846
            ],
            [
              -3703.185,
              1907.997,
              4413.38
            ],
            [
              -3763.581,
              1922.405,
              4475.47
            ],
            [
              -4034.529,
              1998.346,
              4756.86
            ],
            [
              -4082.845,
              2002.521,
              4805.356
            ],
            [
              -4108.472,
              2012.983,
              4833.036
            ],
            [
              -4294.183,
              2056.264,
              5023.724
            ],
            [
              -4414.529,
              2073.923,
              5145.359
            ],
            [
              -4474.572,
              2071.617,
              5205.446
            ],
            [
              -4495.173,
              2074.198,
              5226.208
            ],
            [
              -4714.759,
              2061.271,
              5446.174
            ],
            [
              -4899.174,
              2029.921,
              5633.235
            ],
            [
              -4949.692,
              2018.54,
              5685.019
            ],
            [
              -5128.906,
              1951.47,
              5876.372
            ],
            [
              -5181.415,
              1936.781,
              5930.897
            ],
            [
              -5229.978,
              1926.477,
              5980.541
            ],
            [
              -5267.443,
              1923.775,
              6018.104
            ],
            [
              -5312.592,
              1924.544,
              6063.259
            ],
            [
              -5351.822,
              1931.891,
              6103.171
            ],
            [
              -5407.689,
              1947.312,
              6161.127
            ],
            [
              -5579.166,
              2031.487,
              6352.15
            ],
            [
              -5622.78,
              2046.698,
              6398.341
            ],
            [
              -6203.337,
              2167.821,
              6991.398
            ],
            [
              -6281.103,
              2185.826,
              7071.221
            ],
            [
              -6367.656,
              2218.449,
              7163.719
            ],
            [
              -6455.072,
              2276.688,
              7268.758
            ],
            [
              -6521.774,
              2339.031,
              7360.059
            ],
            [
              -6565.387,
              2393.195,
              7429.599
            ],
            [
              -6596.857,
              2440.475,
              7486.395
            ],
            [
              -6687.246,
              2630.115,
              7696.475
            ],
            [
              -6721.281,
              2678.551,
              7755.672
            ],
            [
              -6732.812,
              2722.158,
              7800.778
            ],
            [
              -6787.208,
              2826.592,
              7918.529
            ],
            [
              -6821.115,
              2882.817,
              7984.187
            ],
            [
              -6849.514,
              2921.139,
              8031.885
            ],
            [
              -6885.636,
              2960.702,
              8085.458
            ],
            [
              -6915.475,
              2990.142,
              8127.376
            ],
            [
              -6953.037,
              3020.824,
              8175.876
            ],
            [
              -7039.186,
              3079.03,
              8279.845
            ],
            [
              -7611.222,
              3413.556,
              8942.516
            ],
            [
              -7653.308,
              3444.307,
              8994.639
            ],
            [
              -7928.052,
              3612.467,
              9316.76
            ],
            [
              -8050.539,
              3660.119,
              9448.19
            ],
            [
              -8132.835,
              3679.279,
              9532.687
            ],
            [
              -8226.874,
              3690.838,
              9627.434
            ],
            [
              -8295.268,
              3691.956,
              9695.837
            ],
            [
              -8418.314,
              3666.138,
              9821.563
            ],
            [
              -8511.843,
              3629.816,
              9921.897
            ],
            [
              -8673.968,
              3542.289,
              10106.14
            ],
            [
              -10220.742,
              2662.19,
              11885.77
            ],
            [
              -10349.565,
              2595.224,
              12030.959
            ],
            [
              -10561.984,
              2505.092,
              12261.709
            ],
            [
              -10571.756,
              2458.494,
              12309.32
            ],
            [
              -10587.068,
              2428.682,
              12342.835
            ],
            [
              -10685.89,
              2381.268,
              12452.443
            ],
            [
              -10763.716,
              2355.784,
              12534.335
            ],
            [
              -10781.795,
              2354.956,
              12552.433
            ],
            [
              -10804.981,
              2357.549,
              12575.763
            ],
            [
              -10822.273,
              2365.615,
              12594.844
            ],
            [
              -10871.238,
              2410.915,
              12661.55
            ],
            [
              -10882.01,
              2423.329,
              12677.987
            ],
            [
              -10933.179,
              2410.779,
              12730.672
            ],
            [
              -11014.265,
              2383.116,
              12816.347
            ],
            [
              -11042.752,
              2376.885,
              12845.507
            ],
            [
              -11076.276,
              2378.527,
              12879.072
            ],
            [
              -11111.788,
              2376.859,
              12914.623
            ],
            [
              -11167.733,
              2347.684,
              12977.719
            ],
            [
              -11176.641,
              2355.616,
              12989.646
            ],
            [
              -11189.785,
              2381.426,
              13018.609
            ],
            [
              -11210.634,
              2409.582,
              13053.645
            ],
            [
              -11223.935,
              2425.375,
              13074.293
            ],
            [
              -11236.068,
              2433.358,
              13088.817
            ],
            [
              -11281.586,
              2451.884,
              13137.961
            ],
            [
              -11308.608,
              2456.76,
              13165.419
            ],
            [
              -11333.103,
              2458.258,
              13189.959
            ],
            [
              -11358.329,
              2454.201,
              13215.51
            ],
            [
              -11398.758,
              2427.006,
              13264.234
            ],
            [
              -11421.439,
              2420.682,
              13287.78
            ],
            [
              -11656.141,
              2306.359,
              13548.845
            ],
            [
              -11912.865,
              2185.688,
              13832.515
            ],
            [
              -11986.897,
              2154.558,
              13912.826
            ],
            [
              -12000.581,
              2145.866,
              13929.037
            ],
            [
              -12140.971,
              2079.03,
              14084.525
            ],
            [
              -12148.221,
              2069.124,
              14096.8
            ],
            [
              -12128.727,
              2036.54,
              14134.77
            ],
            [
              -12035.317,
              1820.251,
              14370.369
            ],
            [
              -12277.032,
              1708.233,
              14636.779
            ],
            [
              -12421.988,
              1637.007,
              14798.288
            ],
            [
              -12458.258,
              1627.549,
              14835.772
            ],
            [
              -12567.869,
              1589.167,
              14951.908
            ],
            [
              -12592.043,
              1652.989,
              15020.155
            ],
            [
              -12647.185,
              1758.475,
              15139.184
            ],
            [
              -12661.996,
              1802.116,
              15185.27
            ],
            [
              -12663.063,
              1816.603,
              15199.797
            ],
            [
              -12603.058,
              1859.092,
              15273.321
            ],
            [
              -12599.171,
              1860.145,
              15277.348
            ],
            [
              -12592.773,
              1856.707,
              15284.611
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8311",
              "position": {
                "x": -2042.349,
                "z": 2571.254
              },
              "distanceAlongShapeM": 185.093,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8309",
              "position": {
                "x": -1563.915,
                "z": 2442.514
              },
              "distanceAlongShapeM": 738.834,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9642",
              "position": {
                "x": -1399.067,
                "z": 2279.266
              },
              "distanceAlongShapeM": 970.883,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6365",
              "position": {
                "x": -1411.426,
                "z": 1768.519
              },
              "distanceAlongShapeM": 1638.899,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 2424.243,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 2859.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 3357.692,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6353",
              "position": {
                "x": -4082.845,
                "z": 2002.521
              },
              "distanceAlongShapeM": 4805.356,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6351",
              "position": {
                "x": -4474.572,
                "z": 2071.617
              },
              "distanceAlongShapeM": 5205.446,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6309",
              "position": {
                "x": -6721.281,
                "z": 2678.551
              },
              "distanceAlongShapeM": 7755.672,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6297",
              "position": {
                "x": -7611.222,
                "z": 3413.556
              },
              "distanceAlongShapeM": 8942.516,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9109",
              "position": {
                "x": -10685.89,
                "z": 2381.268
              },
              "distanceAlongShapeM": 12452.443,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9834",
              "position": {
                "x": -11398.758,
                "z": 2427.006
              },
              "distanceAlongShapeM": 13264.234,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8944",
              "position": {
                "x": -11656.141,
                "z": 2306.359
              },
              "distanceAlongShapeM": 13548.845,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6603",
              "position": {
                "x": -11912.865,
                "z": 2185.688
              },
              "distanceAlongShapeM": 13832.515,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:9082",
              "position": {
                "x": -12128.727,
                "z": 2036.54
              },
              "distanceAlongShapeM": 14134.77,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 15284.611,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            }
          ],
          "departuresSeconds": [
            20700,
            21780,
            22800,
            24000,
            25500,
            27000,
            28500,
            29880,
            33300,
            35520,
            37800,
            39420,
            41160,
            42960,
            44700,
            46500,
            48300,
            50040,
            51840,
            53760,
            55260,
            56520,
            57780,
            59340,
            60900,
            62460,
            64020,
            65640,
            67740,
            70620,
            72180,
            74040,
            75540,
            77220,
            78900,
            80580,
            82140,
            83700
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_29:1",
          "sourceRouteId": "vilnius_bus_29",
          "sourceShapeId": "vilnius_bus_29_b-a",
          "directionId": 1,
          "headsign": "Vilkpėdė",
          "directionName": "Grigiškės–Lazdynai–Žemaitės g.–Vilkpėdė",
          "mode": "bus",
          "routeShortName": "29",
          "routeLongName": "Vilkpėdė–Žemaitės g.–Lazdynai–Grigiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -12592.773,
              1856.707,
              0
            ],
            [
              -12609.12,
              1842.488,
              21.666
            ],
            [
              -12646.157,
              1825.248,
              62.518
            ],
            [
              -12663.097,
              1814.378,
              82.646
            ],
            [
              -12644.743,
              1749.532,
              150.039
            ],
            [
              -12598.286,
              1666.443,
              245.234
            ],
            [
              -12567.852,
              1590.28,
              327.253
            ],
            [
              -12416.777,
              1640.266,
              486.382
            ],
            [
              -12254.88,
              1722.36,
              667.904
            ],
            [
              -12209.896,
              1752.832,
              722.237
            ],
            [
              -12156.769,
              1767.592,
              777.376
            ],
            [
              -12039.728,
              1826.999,
              908.631
            ],
            [
              -12150.225,
              2064.703,
              1170.763
            ],
            [
              -12150.767,
              2071.39,
              1177.472
            ],
            [
              -12148.083,
              2078.027,
              1184.631
            ],
            [
              -11899.757,
              2198.842,
              1460.787
            ],
            [
              -11702.181,
              2291.494,
              1679.009
            ],
            [
              -11379.703,
              2448.97,
              2037.883
            ],
            [
              -11340.826,
              2459.492,
              2078.159
            ],
            [
              -11266.123,
              2450.528,
              2153.398
            ],
            [
              -11225.137,
              2430.96,
              2198.815
            ],
            [
              -11206.711,
              2412.86,
              2224.644
            ],
            [
              -11189.627,
              2391.441,
              2252.041
            ],
            [
              -11131.53,
              2270.307,
              2386.387
            ],
            [
              -10763.651,
              2441.496,
              2792.147
            ],
            [
              -10394.145,
              2591.48,
              3190.933
            ],
            [
              -10234.129,
              2672.421,
              3370.255
            ],
            [
              -8792.209,
              3494.119,
              5029.87
            ],
            [
              -8699.614,
              3552.725,
              5139.453
            ],
            [
              -8570.058,
              3621.859,
              5286.301
            ],
            [
              -8433.864,
              3702.013,
              5444.331
            ],
            [
              -8208.82,
              3847.499,
              5712.307
            ],
            [
              -8066.385,
              3953.143,
              5889.643
            ],
            [
              -8052.214,
              3990.759,
              5929.84
            ],
            [
              -8073.606,
              4024.505,
              5969.794
            ],
            [
              -8101.225,
              4032.75,
              5998.618
            ],
            [
              -8137.67,
              4014.423,
              6039.412
            ],
            [
              -8145.978,
              3980.051,
              6074.774
            ],
            [
              -8141.382,
              3945.467,
              6109.662
            ],
            [
              -8134.965,
              3943.136,
              6116.488
            ],
            [
              -8106.816,
              3849.168,
              6214.582
            ],
            [
              -8064.844,
              3771.671,
              6302.715
            ],
            [
              -8003.462,
              3697.194,
              6399.227
            ],
            [
              -7956.982,
              3658.583,
              6459.652
            ],
            [
              -7913.564,
              3630.04,
              6511.612
            ],
            [
              -7552.547,
              3410.361,
              6934.214
            ],
            [
              -7508.286,
              3394.045,
              6981.386
            ],
            [
              -7243.876,
              3227.143,
              7294.066
            ],
            [
              -6939.838,
              3038.415,
              7651.917
            ],
            [
              -6822.27,
              2929.59,
              7812.12
            ],
            [
              -6676.677,
              2683.371,
              8098.164
            ],
            [
              -6524.161,
              2389.165,
              8429.553
            ],
            [
              -6503.967,
              2362.11,
              8463.314
            ],
            [
              -6467.89,
              2320.317,
              8518.524
            ],
            [
              -6423.391,
              2280.61,
              8578.163
            ],
            [
              -6374.228,
              2249.729,
              8636.22
            ],
            [
              -6301.902,
              2215.119,
              8716.401
            ],
            [
              -6210.095,
              2187.972,
              8812.137
            ],
            [
              -5882.154,
              2122.332,
              9146.583
            ],
            [
              -5773.544,
              2097.118,
              9258.081
            ],
            [
              -5628.871,
              2067.952,
              9405.665
            ],
            [
              -5544.962,
              2032.02,
              9496.944
            ],
            [
              -5507.285,
              2009.117,
              9541.035
            ],
            [
              -5454.831,
              1982.622,
              9599.801
            ],
            [
              -5402.89,
              1963.929,
              9655.004
            ],
            [
              -5349.622,
              1947.438,
              9710.766
            ],
            [
              -5303.942,
              1939.981,
              9757.051
            ],
            [
              -5264.579,
              1940.424,
              9796.416
            ],
            [
              -5230.357,
              1942.068,
              9830.677
            ],
            [
              -5160.434,
              1956.461,
              9902.066
            ],
            [
              -5129.323,
              1964.836,
              9934.285
            ],
            [
              -4970.825,
              2027.807,
              10104.834
            ],
            [
              -4893.064,
              2047.628,
              10185.081
            ],
            [
              -4844.518,
              2056.816,
              10234.489
            ],
            [
              -4661.507,
              2081.508,
              10419.159
            ],
            [
              -4413.578,
              2091.718,
              10667.298
            ],
            [
              -4171.807,
              2044.134,
              10913.707
            ],
            [
              -4056.112,
              2018.757,
              11032.152
            ],
            [
              -4034.827,
              2018.389,
              11053.44
            ],
            [
              -4018.212,
              2009.195,
              11072.429
            ],
            [
              -3691.362,
              1920.037,
              11411.221
            ],
            [
              -3598.621,
              1910.632,
              11504.438
            ],
            [
              -3547.649,
              1910.858,
              11555.411
            ],
            [
              -3479.107,
              1919.683,
              11624.519
            ],
            [
              -3376.715,
              1945.728,
              11730.171
            ],
            [
              -3255.325,
              1988.136,
              11858.755
            ],
            [
              -3211.057,
              2010.74,
              11908.46
            ],
            [
              -3076.57,
              2064.047,
              12053.127
            ],
            [
              -3025.322,
              2079.847,
              12106.755
            ],
            [
              -2969.481,
              2100.019,
              12166.128
            ],
            [
              -2931.778,
              2116.056,
              12207.1
            ],
            [
              -2890.752,
              2137.6,
              12253.439
            ],
            [
              -2705.632,
              2207.819,
              12451.429
            ],
            [
              -2695.312,
              2207.637,
              12461.751
            ],
            [
              -2620.644,
              2234.153,
              12540.986
            ],
            [
              -2602.113,
              2260.544,
              12573.233
            ],
            [
              -2588.136,
              2284.788,
              12601.218
            ],
            [
              -2571.13,
              2297.847,
              12622.66
            ],
            [
              -2532.153,
              2312.745,
              12664.387
            ],
            [
              -2506.977,
              2313.414,
              12689.572
            ],
            [
              -2483.854,
              2307.44,
              12713.454
            ],
            [
              -2455.846,
              2285.795,
              12748.851
            ],
            [
              -2438.355,
              2253.203,
              12785.84
            ],
            [
              -2433.47,
              2237.532,
              12802.255
            ],
            [
              -2436.603,
              2169.681,
              12870.178
            ],
            [
              -2432.988,
              2155.146,
              12885.156
            ],
            [
              -2421.673,
              2138.248,
              12905.493
            ],
            [
              -2405.237,
              2119.033,
              12930.779
            ],
            [
              -2339.12,
              2063.317,
              13017.241
            ],
            [
              -2328.352,
              2051.995,
              13032.866
            ],
            [
              -2313.635,
              2045.055,
              13049.137
            ],
            [
              -2298.509,
              2024.75,
              13074.457
            ],
            [
              -1944.941,
              1697.877,
              13555.971
            ],
            [
              -1868.675,
              1633.068,
              13656.055
            ],
            [
              -1860.469,
              1622.903,
              13669.119
            ],
            [
              -1769.084,
              1537.785,
              13794.003
            ],
            [
              -1703.649,
              1480.959,
              13880.67
            ],
            [
              -1699.799,
              1479.777,
              13884.697
            ],
            [
              -1682.168,
              1491.708,
              13905.985
            ],
            [
              -1671.651,
              1502.653,
              13921.164
            ],
            [
              -1654.972,
              1533.526,
              13956.254
            ],
            [
              -1603.973,
              1571.579,
              14019.886
            ],
            [
              -1299.013,
              1921.245,
              14483.854
            ],
            [
              -1270.801,
              1947.457,
              14522.364
            ],
            [
              -1190.297,
              2047.317,
              14650.633
            ],
            [
              -1514.694,
              2380.408,
              15115.588
            ],
            [
              -1536.913,
              2400.843,
              15145.775
            ],
            [
              -1586.671,
              2432.901,
              15204.966
            ],
            [
              -1589.092,
              2441.85,
              15214.237
            ],
            [
              -1665.298,
              2474.379,
              15297.096
            ],
            [
              -1973.715,
              2584.507,
              15624.584
            ],
            [
              -1980.067,
              2590.186,
              15633.105
            ],
            [
              -1990.862,
              2563.661,
              15661.743
            ],
            [
              -1996.181,
              2554.849,
              15672.035
            ],
            [
              -2002.73,
              2549.399,
              15680.555
            ],
            [
              -2002.849,
              2542.722,
              15687.234
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15964",
              "position": {
                "x": -12209.896,
                "z": 1752.832
              },
              "distanceAlongShapeM": 722.237,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:16236",
              "position": {
                "x": -12092.77,
                "z": 1942.477
              },
              "distanceAlongShapeM": 1035.707,
              "shapeOffsetM": 0.579,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8945",
              "position": {
                "x": -11899.757,
                "z": 2198.842
              },
              "distanceAlongShapeM": 1460.787,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6604",
              "position": {
                "x": -11702.181,
                "z": 2291.494
              },
              "distanceAlongShapeM": 1679.009,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:4454",
              "position": {
                "x": -11189.627,
                "z": 2391.441
              },
              "distanceAlongShapeM": 2252.041,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6295",
              "position": {
                "x": -8134.965,
                "z": 3943.136
              },
              "distanceAlongShapeM": 6116.488,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6609",
              "position": {
                "x": -7508.286,
                "z": 3394.045
              },
              "distanceAlongShapeM": 6981.386,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6310",
              "position": {
                "x": -6676.677,
                "z": 2683.371
              },
              "distanceAlongShapeM": 8098.164,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6350",
              "position": {
                "x": -4413.578,
                "z": 2091.718
              },
              "distanceAlongShapeM": 10667.298,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6352",
              "position": {
                "x": -4034.827,
                "z": 2018.389
              },
              "distanceAlongShapeM": 11053.44,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 12451.429,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 13049.137,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 13656.055,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6410",
              "position": {
                "x": -1654.972,
                "z": 1533.526
              },
              "distanceAlongShapeM": 13956.254,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1710,
              "departureOffsetSeconds": 1710
            },
            {
              "stopId": "judu:stop:6366",
              "position": {
                "x": -1299.013,
                "z": 1921.245
              },
              "distanceAlongShapeM": 14483.854,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:9701",
              "position": {
                "x": -1232.774,
                "z": 2089.268
              },
              "distanceAlongShapeM": 14710.323,
              "shapeOffsetM": 1.162,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7941",
              "position": {
                "x": -1586.671,
                "z": 2432.901
              },
              "distanceAlongShapeM": 15204.966,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 15687.234,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            19320,
            21240,
            22860,
            24240,
            25440,
            26640,
            28020,
            29640,
            31200,
            32580,
            35880,
            38040,
            40320,
            41940,
            43620,
            45360,
            47160,
            48960,
            50820,
            52740,
            54420,
            56220,
            58020,
            59520,
            60960,
            62580,
            64200,
            65640,
            67020,
            68820,
            72900,
            74580,
            76380,
            78060,
            79740,
            81420,
            83040,
            84660
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_30",
      "sourceRouteId": "vilnius_bus_30",
      "mode": "bus",
      "shortName": "30",
      "longName": "Pilaitė–Konstitucijos pr.–Apkasų g.–Šiaurės miestelis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_30:0",
          "sourceRouteId": "vilnius_bus_30",
          "sourceShapeId": "vilnius_bus_30_a-b",
          "directionId": 0,
          "headsign": "Šiaurės miestelis",
          "directionName": "Pilaitė–Konstitucijos pr.–Apkasų g.–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "30",
          "routeLongName": "Pilaitė–Konstitucijos pr.–Apkasų g.–Šiaurės miestelis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6804.479,
              -1529.023,
              0
            ],
            [
              -6810.019,
              -1513.345,
              16.627
            ],
            [
              -6803.426,
              -1504.55,
              27.62
            ],
            [
              -6797.569,
              -1501.308,
              34.313
            ],
            [
              -6795.561,
              -1496.889,
              39.167
            ],
            [
              -6804.801,
              -1471.131,
              66.532
            ],
            [
              -6817.871,
              -1443.083,
              97.476
            ],
            [
              -6849.755,
              -1383.551,
              165.008
            ],
            [
              -6863.711,
              -1369.96,
              184.489
            ],
            [
              -6868.44,
              -1344.278,
              210.603
            ],
            [
              -6866.432,
              -1339.858,
              215.457
            ],
            [
              -6856.69,
              -1335.568,
              226.102
            ],
            [
              -6848.367,
              -1339.047,
              235.122
            ],
            [
              -6837.763,
              -1360.375,
              258.94
            ],
            [
              -6823.318,
              -1421.841,
              322.082
            ],
            [
              -6723.821,
              -1601.615,
              527.553
            ],
            [
              -6711.23,
              -1619.637,
              549.537
            ],
            [
              -6684.251,
              -1702.465,
              636.648
            ],
            [
              -6676.395,
              -1733.766,
              668.92
            ],
            [
              -6677.514,
              -1993.121,
              928.277
            ],
            [
              -6672.243,
              -2063.34,
              998.694
            ],
            [
              -6676.454,
              -2314.851,
              1250.241
            ],
            [
              -6640.332,
              -2313.23,
              1286.399
            ],
            [
              -6613.194,
              -2309.232,
              1313.83
            ],
            [
              -6575.914,
              -2315.423,
              1351.621
            ],
            [
              -6380.632,
              -2316.474,
              1546.906
            ],
            [
              -6294.875,
              -2314.577,
              1632.684
            ],
            [
              -6243.894,
              -2310.982,
              1683.791
            ],
            [
              -6220.641,
              -2308.034,
              1707.231
            ],
            [
              -6201.86,
              -2302.785,
              1726.731
            ],
            [
              -6171.35,
              -2289.941,
              1759.835
            ],
            [
              -6126.719,
              -2280.674,
              1805.418
            ],
            [
              -6104.034,
              -2273.265,
              1829.282
            ],
            [
              -5924.643,
              -2185.012,
              2029.206
            ],
            [
              -5877.169,
              -2160.211,
              2082.767
            ],
            [
              -5847.188,
              -2140.681,
              2118.548
            ],
            [
              -5795.942,
              -2121.511,
              2173.263
            ],
            [
              -5568.568,
              -2017.388,
              2423.344
            ],
            [
              -5236.974,
              -1850.486,
              2794.573
            ],
            [
              -5169.837,
              -1807.104,
              2874.507
            ],
            [
              -5127.302,
              -1769.981,
              2930.963
            ],
            [
              -5012.864,
              -1637.24,
              3106.224
            ],
            [
              -4831.761,
              -1414.361,
              3393.405
            ],
            [
              -4761.883,
              -1362.126,
              3480.649
            ],
            [
              -4704.97,
              -1314.122,
              3555.103
            ],
            [
              -4653.804,
              -1300.53,
              3608.043
            ],
            [
              -4405.208,
              -1203.507,
              3874.902
            ],
            [
              -4296.995,
              -1171.977,
              3987.615
            ],
            [
              -4247.02,
              -1152.802,
              4041.142
            ],
            [
              -4191.003,
              -1157.11,
              4097.325
            ],
            [
              -3912.099,
              -1135.223,
              4377.086
            ],
            [
              -3759.013,
              -1118.956,
              4531.034
            ],
            [
              -3705.284,
              -1106.532,
              4586.181
            ],
            [
              -3657.704,
              -1114.039,
              4634.35
            ],
            [
              -3599.031,
              -1113.947,
              4693.023
            ],
            [
              -3412.497,
              -1176.2,
              4889.67
            ],
            [
              -3355.367,
              -1190.556,
              4948.576
            ],
            [
              -3108.49,
              -1230.499,
              5198.664
            ],
            [
              -3070.013,
              -1242.306,
              5238.911
            ],
            [
              -2879.155,
              -1277.94,
              5433.067
            ],
            [
              -2839.273,
              -1283.094,
              5473.281
            ],
            [
              -2787.087,
              -1285.125,
              5525.507
            ],
            [
              -2748.376,
              -1283.58,
              5564.248
            ],
            [
              -2714.118,
              -1278.617,
              5598.864
            ],
            [
              -2670.7,
              -1266.023,
              5644.072
            ],
            [
              -2624.585,
              -1246.798,
              5694.033
            ],
            [
              -2500.301,
              -1182.198,
              5834.103
            ],
            [
              -2469.831,
              -1172.717,
              5866.014
            ],
            [
              -2418.716,
              -1162.489,
              5918.143
            ],
            [
              -2392.231,
              -1159.617,
              5944.783
            ],
            [
              -2151.528,
              -1183.918,
              6186.71
            ],
            [
              -2126.509,
              -1191.041,
              6212.723
            ],
            [
              -2118.854,
              -1195.63,
              6221.648
            ],
            [
              -1988.935,
              -1213.522,
              6352.794
            ],
            [
              -1948.388,
              -1217.583,
              6393.543
            ],
            [
              -1866.572,
              -1221.265,
              6475.442
            ],
            [
              -1794.345,
              -1220.324,
              6547.675
            ],
            [
              -1681.879,
              -1204.518,
              6661.247
            ],
            [
              -1544.075,
              -1178.035,
              6801.571
            ],
            [
              -1436.465,
              -1145.449,
              6914.008
            ],
            [
              -1393.22,
              -1142.883,
              6957.328
            ],
            [
              -1155.149,
              -1098.17,
              7199.562
            ],
            [
              -1103.929,
              -1082.392,
              7253.157
            ],
            [
              -1083.324,
              -1083.875,
              7273.816
            ],
            [
              -1022.536,
              -1073.836,
              7335.427
            ],
            [
              -998.991,
              -1055.334,
              7365.371
            ],
            [
              -969.041,
              -1039.175,
              7399.403
            ],
            [
              -947.066,
              -1036.231,
              7421.574
            ],
            [
              -930.307,
              -1036.533,
              7438.335
            ],
            [
              -906.579,
              -1043.639,
              7463.105
            ],
            [
              -895.802,
              -1053.852,
              7477.953
            ],
            [
              -890.221,
              -1066.198,
              7491.502
            ],
            [
              -876.342,
              -1083.147,
              7513.408
            ],
            [
              -864.236,
              -1091.158,
              7527.925
            ],
            [
              -845.624,
              -1095.946,
              7547.142
            ],
            [
              -813.336,
              -1093.188,
              7579.548
            ],
            [
              -786.145,
              -1086.999,
              7607.435
            ],
            [
              -775.751,
              -1082.734,
              7618.669
            ],
            [
              -717.641,
              -1078.217,
              7676.955
            ],
            [
              -647.083,
              -1062.792,
              7749.179
            ],
            [
              -535.555,
              -1028.072,
              7865.987
            ],
            [
              -464.693,
              -995.958,
              7943.786
            ],
            [
              -361.843,
              -942.16,
              8059.857
            ],
            [
              -333.702,
              -919.293,
              8096.117
            ],
            [
              -286.889,
              -897.877,
              8147.596
            ],
            [
              -196.966,
              -846.075,
              8251.373
            ],
            [
              -115.583,
              -803.025,
              8343.441
            ],
            [
              -96.647,
              -790.01,
              8366.418
            ],
            [
              -42.035,
              -765.399,
              8426.319
            ],
            [
              224.759,
              -703.469,
              8700.207
            ],
            [
              238.113,
              -713.732,
              8717.049
            ],
            [
              221.813,
              -864.834,
              8869.028
            ],
            [
              221.766,
              -902.683,
              8906.877
            ],
            [
              233.86,
              -981.944,
              8987.055
            ],
            [
              256.721,
              -1107.044,
              9114.227
            ],
            [
              276.82,
              -1242.113,
              9250.783
            ],
            [
              297.35,
              -1318.188,
              9329.58
            ],
            [
              320.249,
              -1546.82,
              9559.356
            ],
            [
              342.249,
              -1718.661,
              9732.599
            ],
            [
              356.237,
              -1764.56,
              9780.582
            ],
            [
              354.758,
              -1810.175,
              9826.222
            ],
            [
              356.121,
              -1841.371,
              9857.447
            ],
            [
              372.957,
              -1942.984,
              9960.445
            ],
            [
              426.379,
              -2158.817,
              10182.791
            ],
            [
              441.836,
              -2194.724,
              10221.884
            ],
            [
              440.947,
              -2208.066,
              10235.256
            ],
            [
              451.425,
              -2269.486,
              10297.563
            ],
            [
              777.261,
              -2147.444,
              10645.505
            ],
            [
              789.268,
              -2195.534,
              10695.071
            ],
            [
              792.091,
              -2252.361,
              10751.969
            ],
            [
              808.047,
              -2296.071,
              10798.5
            ],
            [
              810.133,
              -2322.828,
              10825.337
            ],
            [
              815.482,
              -2347.417,
              10850.502
            ],
            [
              839.035,
              -2433.57,
              10939.817
            ],
            [
              881.722,
              -2565.719,
              11078.688
            ],
            [
              898.145,
              -2653.968,
              11168.452
            ],
            [
              900.578,
              -2661.805,
              11176.659
            ],
            [
              904.362,
              -2666.328,
              11182.556
            ],
            [
              908.852,
              -2667.524,
              11187.202
            ],
            [
              920.512,
              -2664.399,
              11199.273
            ],
            [
              978.247,
              -2644.311,
              11260.403
            ],
            [
              1030.623,
              -2635.258,
              11313.555
            ],
            [
              1258.684,
              -2571.563,
              11550.345
            ],
            [
              1329.768,
              -2561.746,
              11622.103
            ],
            [
              1359.181,
              -2574.537,
              11654.177
            ],
            [
              1423.013,
              -2573.493,
              11718.017
            ],
            [
              1423.219,
              -2562.364,
              11729.147
            ],
            [
              1413.343,
              -2538.803,
              11754.695
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 258.94,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 549.537,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8067",
              "position": {
                "x": -6672.243,
                "z": -2063.34
              },
              "distanceAlongShapeM": 998.694,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7951",
              "position": {
                "x": -6613.194,
                "z": -2309.232
              },
              "distanceAlongShapeM": 1313.83,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7949",
              "position": {
                "x": -6171.35,
                "z": -2289.941
              },
              "distanceAlongShapeM": 1759.835,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8069",
              "position": {
                "x": -5847.188,
                "z": -2140.681
              },
              "distanceAlongShapeM": 2118.548,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 3555.103,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 4041.142,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7342",
              "position": {
                "x": -3705.284,
                "z": -1106.532
              },
              "distanceAlongShapeM": 4586.181,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 5198.664,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6398",
              "position": {
                "x": -2151.528,
                "z": -1183.918
              },
              "distanceAlongShapeM": 6186.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6396",
              "position": {
                "x": -1436.465,
                "z": -1145.449
              },
              "distanceAlongShapeM": 6914.008,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 7253.157,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 7618.669,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 8096.117,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 8426.319,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 9329.58,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 9780.582,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 10221.884,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:9638",
              "position": {
                "x": 808.047,
                "z": -2296.071
              },
              "distanceAlongShapeM": 10798.5,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:18532",
              "position": {
                "x": 978.247,
                "z": -2644.311
              },
              "distanceAlongShapeM": 11260.403,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9566",
              "position": {
                "x": 1329.768,
                "z": -2561.746
              },
              "distanceAlongShapeM": 11622.103,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 11754.695,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            19020,
            20940,
            22740,
            24000,
            25080,
            25800,
            27300,
            28740,
            30180,
            31380,
            32580,
            33540,
            35280,
            37440,
            39240,
            41580,
            43500,
            45240,
            46740,
            48300,
            49920,
            51540,
            53160,
            54720,
            56460,
            58080,
            59520,
            60960,
            62100,
            63480,
            65220,
            66900,
            68640,
            70260,
            71880,
            73560,
            75120,
            76680,
            78300,
            79980,
            81660
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_30:1",
          "sourceRouteId": "vilnius_bus_30",
          "sourceShapeId": "vilnius_bus_30_b-a",
          "directionId": 1,
          "headsign": "Pilaitė",
          "directionName": "Šiaurės miestelis–Apkasų g.–Konstitucijos pr.–Pilaitė",
          "mode": "bus",
          "routeShortName": "30",
          "routeLongName": "Pilaitė–Konstitucijos pr.–Apkasų g.–Šiaurės miestelis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1412.698,
              -2538.791,
              0
            ],
            [
              1427.807,
              -2523.486,
              21.507
            ],
            [
              1492.99,
              -2519.128,
              86.835
            ],
            [
              1524.687,
              -2513.037,
              119.112
            ],
            [
              1540.007,
              -2521.114,
              136.431
            ],
            [
              1543.77,
              -2526.75,
              143.207
            ],
            [
              1541.692,
              -2534.504,
              151.235
            ],
            [
              1533.274,
              -2536.574,
              159.904
            ],
            [
              1448.137,
              -2539.448,
              245.089
            ],
            [
              1439.137,
              -2538.168,
              254.18
            ],
            [
              1428.101,
              -2542.416,
              266.006
            ],
            [
              1420.142,
              -2554.515,
              280.487
            ],
            [
              1415.904,
              -2574.474,
              300.892
            ],
            [
              1275.293,
              -2579.663,
              441.599
            ],
            [
              1255.195,
              -2585.971,
              462.663
            ],
            [
              1231.149,
              -2596.659,
              488.978
            ],
            [
              1196.251,
              -2601.58,
              524.221
            ],
            [
              955.306,
              -2665.04,
              773.383
            ],
            [
              918.333,
              -2677.718,
              812.469
            ],
            [
              895.761,
              -2678.415,
              835.052
            ],
            [
              887.466,
              -2673.809,
              844.539
            ],
            [
              874.193,
              -2624.582,
              895.525
            ],
            [
              876.281,
              -2581.204,
              938.953
            ],
            [
              793.859,
              -2331.434,
              1201.971
            ],
            [
              778.436,
              -2258.79,
              1276.234
            ],
            [
              775.664,
              -2234.247,
              1300.933
            ],
            [
              777.363,
              -2141.88,
              1393.316
            ],
            [
              631.852,
              -2202.661,
              1551.011
            ],
            [
              450.781,
              -2269.474,
              1744.016
            ],
            [
              407.176,
              -2116.162,
              1903.408
            ],
            [
              406.254,
              -2096.107,
              1923.485
            ],
            [
              361.405,
              -1904.922,
              2119.859
            ],
            [
              342.249,
              -1718.661,
              2307.103
            ],
            [
              324.984,
              -1640.419,
              2387.228
            ],
            [
              326.097,
              -1614.835,
              2412.836
            ],
            [
              277.22,
              -1255.479,
              2775.5
            ],
            [
              271.867,
              -1230.89,
              2800.665
            ],
            [
              265.625,
              -1219.643,
              2813.528
            ],
            [
              267.3,
              -1198.523,
              2834.715
            ],
            [
              254.802,
              -1141.519,
              2893.073
            ],
            [
              216.915,
              -885.896,
              3151.488
            ],
            [
              223.616,
              -801.413,
              3236.237
            ],
            [
              219.901,
              -722.305,
              3315.432
            ],
            [
              73.653,
              -750.808,
              3464.432
            ],
            [
              -18.428,
              -779.188,
              3560.787
            ],
            [
              -53.078,
              -805.275,
              3604.159
            ],
            [
              -306.711,
              -924.235,
              3884.304
            ],
            [
              -475.993,
              -1014.678,
              4076.232
            ],
            [
              -534.689,
              -1051.466,
              4145.503
            ],
            [
              -673.187,
              -1080.133,
              4286.937
            ],
            [
              -763.423,
              -1114.127,
              4383.364
            ],
            [
              -829.227,
              -1116.28,
              4449.203
            ],
            [
              -865.018,
              -1134.559,
              4489.392
            ],
            [
              -891.825,
              -1155.228,
              4523.242
            ],
            [
              -898.431,
              -1164.015,
              4534.235
            ],
            [
              -907.595,
              -1171.642,
              4546.158
            ],
            [
              -917.363,
              -1177.032,
              4557.315
            ],
            [
              -929.65,
              -1179.038,
              4569.764
            ],
            [
              -961.877,
              -1178.457,
              4601.996
            ],
            [
              -977.306,
              -1175.953,
              4617.627
            ],
            [
              -995.797,
              -1164.488,
              4639.384
            ],
            [
              -1006.474,
              -1148.711,
              4658.435
            ],
            [
              -1029.882,
              -1123.799,
              4692.618
            ],
            [
              -1062.634,
              -1116.531,
              4726.167
            ],
            [
              -1096.995,
              -1127.045,
              4762.101
            ],
            [
              -1143.947,
              -1120.636,
              4809.488
            ],
            [
              -1339.338,
              -1158.32,
              5008.481
            ],
            [
              -1374.402,
              -1172.164,
              5046.179
            ],
            [
              -1791.301,
              -1230.398,
              5467.125
            ],
            [
              -1855.793,
              -1231.475,
              5531.626
            ],
            [
              -1940.187,
              -1227.747,
              5616.103
            ],
            [
              -2027.705,
              -1218.399,
              5704.119
            ],
            [
              -2166.609,
              -1198.122,
              5844.494
            ],
            [
              -2255.397,
              -1187.643,
              5933.899
            ],
            [
              -2267.097,
              -1193.002,
              5946.768
            ],
            [
              -2295.924,
              -1182.472,
              5977.457
            ],
            [
              -2392.506,
              -1175.197,
              6074.313
            ],
            [
              -2431.277,
              -1180.078,
              6113.39
            ],
            [
              -2478.584,
              -1193.714,
              6162.623
            ],
            [
              -2533.196,
              -1219.467,
              6223.003
            ],
            [
              -2617.204,
              -1266.966,
              6319.509
            ],
            [
              -2663.944,
              -1285.067,
              6369.631
            ],
            [
              -2710.565,
              -1296.491,
              6417.632
            ],
            [
              -2762.303,
              -1305.599,
              6470.165
            ],
            [
              -2808.767,
              -1308.121,
              6516.698
            ],
            [
              -2858.317,
              -1302.797,
              6566.533
            ],
            [
              -3071.028,
              -1263.439,
              6782.855
            ],
            [
              -3140.52,
              -1255.542,
              6852.794
            ],
            [
              -3159.719,
              -1247.413,
              6873.643
            ],
            [
              -3359.526,
              -1207.182,
              7077.46
            ],
            [
              -3495.953,
              -1192.555,
              7214.669
            ],
            [
              -3569.469,
              -1193.5,
              7288.191
            ],
            [
              -3626.266,
              -1196.964,
              7345.093
            ],
            [
              -3688.025,
              -1189.21,
              7407.337
            ],
            [
              -3714.785,
              -1170.933,
              7439.743
            ],
            [
              -3768.733,
              -1158.863,
              7495.025
            ],
            [
              -3858.305,
              -1156.194,
              7584.636
            ],
            [
              -4063.615,
              -1172.672,
              7790.607
            ],
            [
              -4237.967,
              -1188.581,
              7965.683
            ],
            [
              -4268.356,
              -1193.623,
              7996.487
            ],
            [
              -4294.993,
              -1205.408,
              8025.615
            ],
            [
              -4333.704,
              -1206.966,
              8064.357
            ],
            [
              -4364.15,
              -1215.347,
              8095.936
            ],
            [
              -4597.068,
              -1300.392,
              8343.894
            ],
            [
              -4637.998,
              -1318.612,
              8388.696
            ],
            [
              -4714.189,
              -1362.945,
              8476.847
            ],
            [
              -4755.992,
              -1394.51,
              8529.228
            ],
            [
              -4809.036,
              -1442.581,
              8600.814
            ],
            [
              -4834.84,
              -1481.101,
              8647.178
            ],
            [
              -5092.18,
              -1789.506,
              9048.847
            ],
            [
              -5145.16,
              -1834.242,
              9118.187
            ],
            [
              -5263.682,
              -1904.577,
              9256.008
            ],
            [
              -5341.696,
              -1943.323,
              9343.114
            ],
            [
              -5353.315,
              -1944.238,
              9354.768
            ],
            [
              -5858.685,
              -2210.618,
              9926.046
            ],
            [
              -5880.858,
              -2225.828,
              9952.934
            ],
            [
              -6049.087,
              -2302.022,
              10137.614
            ],
            [
              -6102.245,
              -2320.049,
              10193.745
            ],
            [
              -6166.945,
              -2334.543,
              10260.048
            ],
            [
              -6282.493,
              -2344.842,
              10376.054
            ],
            [
              -6377.159,
              -2339.91,
              10470.849
            ],
            [
              -6675.557,
              -2338.243,
              10769.251
            ],
            [
              -6689.755,
              -2262.309,
              10846.502
            ],
            [
              -6668.455,
              -1991.046,
              11118.6
            ],
            [
              -6680.407,
              -1819.414,
              11290.647
            ],
            [
              -6680.925,
              -1734.803,
              11375.26
            ],
            [
              -6684.251,
              -1702.465,
              11407.769
            ],
            [
              -6705.09,
              -1676.513,
              11441.052
            ],
            [
              -6747.127,
              -1568.943,
              11556.544
            ],
            [
              -6771.666,
              -1532.911,
              11600.139
            ],
            [
              -6834.733,
              -1410.519,
              11737.824
            ],
            [
              -6863.711,
              -1369.96,
              11787.671
            ],
            [
              -6868.44,
              -1344.278,
              11813.785
            ],
            [
              -6866.432,
              -1339.858,
              11818.639
            ],
            [
              -6856.69,
              -1335.568,
              11829.283
            ],
            [
              -6848.367,
              -1339.047,
              11838.304
            ],
            [
              -6837.763,
              -1360.375,
              11862.122
            ],
            [
              -6825.084,
              -1411.793,
              11915.081
            ],
            [
              -6801.411,
              -1461.169,
              11969.839
            ],
            [
              -6771.957,
              -1511.755,
              12028.375
            ],
            [
              -6765.128,
              -1527.454,
              12045.494
            ],
            [
              -6769.807,
              -1537.394,
              12056.481
            ],
            [
              -6777.653,
              -1543.942,
              12066.7
            ],
            [
              -6839.38,
              -1572.967,
              12134.911
            ],
            [
              -6855.566,
              -1577.15,
              12151.629
            ],
            [
              -6863.189,
              -1570.343,
              12161.848
            ],
            [
              -6866.907,
              -1561.375,
              12171.555
            ],
            [
              -6864.843,
              -1553.618,
              12179.583
            ],
            [
              -6804.479,
              -1529.023,
              12244.766
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 119.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9565",
              "position": {
                "x": 1231.149,
                "z": -2596.659
              },
              "distanceAlongShapeM": 488.978,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9637",
              "position": {
                "x": 874.193,
                "z": -2624.582
              },
              "distanceAlongShapeM": 895.525,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9640",
              "position": {
                "x": 793.859,
                "z": -2331.434
              },
              "distanceAlongShapeM": 1201.971,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 1903.408,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 2387.228,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 2813.528,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 3604.159,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 4145.503,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 4383.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 4762.101,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:814",
              "position": {
                "x": -1374.402,
                "z": -1172.164
              },
              "distanceAlongShapeM": 5046.179,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5906",
              "position": {
                "x": -2267.097,
                "z": -1193.002
              },
              "distanceAlongShapeM": 5946.768,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 6852.794,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 7407.337,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 8025.615,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:8060",
              "position": {
                "x": -4834.84,
                "z": -1481.101
              },
              "distanceAlongShapeM": 8647.178,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7947",
              "position": {
                "x": -5880.858,
                "z": -2225.828
              },
              "distanceAlongShapeM": 9952.934,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7948",
              "position": {
                "x": -6282.493,
                "z": -2344.842
              },
              "distanceAlongShapeM": 10376.054,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:7959",
              "position": {
                "x": -6689.755,
                "z": -2262.309
              },
              "distanceAlongShapeM": 10846.502,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 11441.052,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 11787.671,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            21420,
            22800,
            24180,
            25560,
            26880,
            28200,
            29520,
            30720,
            32400,
            34260,
            36060,
            38700,
            40380,
            42000,
            43140,
            44820,
            46620,
            48240,
            49860,
            51480,
            53100,
            54600,
            56160,
            57720,
            58680,
            59880,
            61680,
            63420,
            65220,
            66780,
            68700,
            70380,
            72060,
            73560,
            75060,
            76560,
            78060,
            79500,
            81000,
            82500,
            84000
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_31",
      "sourceRouteId": "vilnius_bus_31",
      "mode": "bus",
      "shortName": "31",
      "longName": "Stotis–Pavilnys–Naujoji Vilnia (Apylanka)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_31:0",
          "sourceRouteId": "vilnius_bus_31",
          "sourceShapeId": "vilnius_bus_31_a-b",
          "directionId": 0,
          "headsign": "Naujoji Vilnia (Apylanka)",
          "directionName": "Stotis–Pavilnys–Naujoji Vilnia (Apylanka)",
          "mode": "bus",
          "routeShortName": "31",
          "routeLongName": "Stotis–Pavilnys–Naujoji Vilnia (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              493.148,
              1911.064,
              0
            ],
            [
              476.562,
              1921.386,
              19.536
            ],
            [
              453.967,
              1920.686,
              42.142
            ],
            [
              432.764,
              1925.527,
              63.89
            ],
            [
              422.444,
              1925.716,
              74.212
            ],
            [
              419.803,
              1922.424,
              78.432
            ],
            [
              401.805,
              1926.093,
              96.8
            ],
            [
              397.27,
              1925.063,
              101.451
            ],
            [
              384.004,
              1905.267,
              125.281
            ],
            [
              372.531,
              1877.646,
              155.19
            ],
            [
              344.166,
              1843.654,
              199.462
            ],
            [
              330.657,
              1810.504,
              235.259
            ],
            [
              391.321,
              1670.242,
              388.078
            ],
            [
              477.846,
              1568.468,
              521.661
            ],
            [
              485.021,
              1572.79,
              530.037
            ],
            [
              495.103,
              1594.87,
              554.31
            ],
            [
              502.822,
              1593.615,
              562.13
            ],
            [
              515.619,
              1587.815,
              576.18
            ],
            [
              552.903,
              1580.453,
              614.184
            ],
            [
              580.051,
              1583.295,
              641.481
            ],
            [
              658.651,
              1577.401,
              720.302
            ],
            [
              692.229,
              1579.012,
              753.918
            ],
            [
              741.428,
              1588.128,
              803.955
            ],
            [
              775.609,
              1587.5,
              838.142
            ],
            [
              809.668,
              1580.195,
              872.975
            ],
            [
              847.494,
              1567.254,
              912.954
            ],
            [
              881.41,
              1552.158,
              950.077
            ],
            [
              944.603,
              1515.372,
              1023.197
            ],
            [
              979.224,
              1503.603,
              1059.764
            ],
            [
              987.526,
              1498.997,
              1069.258
            ],
            [
              1015.114,
              1490.696,
              1098.068
            ],
            [
              1169.279,
              1454.457,
              1256.436
            ],
            [
              1223.933,
              1444.542,
              1311.981
            ],
            [
              1245.249,
              1480.885,
              1354.114
            ],
            [
              1335.324,
              1607.243,
              1509.291
            ],
            [
              1391.043,
              1689.705,
              1608.814
            ],
            [
              1392.56,
              1701.923,
              1621.125
            ],
            [
              1382.145,
              1766.683,
              1686.718
            ],
            [
              1389.15,
              1796.611,
              1717.454
            ],
            [
              1389.61,
              1786.583,
              1727.493
            ],
            [
              1472.71,
              1884.123,
              1855.632
            ],
            [
              1484.045,
              1903.952,
              1878.472
            ],
            [
              1527.015,
              1994.441,
              1978.645
            ],
            [
              1530.673,
              2017.752,
              2002.241
            ],
            [
              1543.134,
              2028.653,
              2018.797
            ],
            [
              1551.767,
              2041.852,
              2034.569
            ],
            [
              1562.918,
              2051.664,
              2049.422
            ],
            [
              1590.338,
              2068.968,
              2081.846
            ],
            [
              1610.663,
              2086.403,
              2108.624
            ],
            [
              1702.063,
              2282.863,
              2325.305
            ],
            [
              1756.341,
              2356.442,
              2416.738
            ],
            [
              1770.78,
              2369.533,
              2436.228
            ],
            [
              1787.717,
              2378.124,
              2455.219
            ],
            [
              1803.322,
              2384.513,
              2472.081
            ],
            [
              1851.97,
              2398.081,
              2522.586
            ],
            [
              1901.805,
              2406.06,
              2573.055
            ],
            [
              1960.129,
              2419.446,
              2632.896
            ],
            [
              1982.789,
              2423.477,
              2655.912
            ],
            [
              2016.977,
              2422.84,
              2690.106
            ],
            [
              2300.344,
              2358.548,
              2980.675
            ],
            [
              2318.384,
              2357.098,
              2998.773
            ],
            [
              2341.44,
              2347.761,
              3023.648
            ],
            [
              2404.362,
              2330.998,
              3088.765
            ],
            [
              2453.344,
              2327.854,
              3137.847
            ],
            [
              2522.053,
              2344.378,
              3208.515
            ],
            [
              2590.678,
              2356.45,
              3278.194
            ],
            [
              2633.792,
              2350.075,
              3321.777
            ],
            [
              2719.186,
              2327.319,
              3410.151
            ],
            [
              2777.655,
              2313.974,
              3470.123
            ],
            [
              2795.071,
              2313.647,
              3487.542
            ],
            [
              2818.355,
              2316.549,
              3511.007
            ],
            [
              2887.128,
              2336.406,
              3582.589
            ],
            [
              3040.387,
              2388.067,
              3744.321
            ],
            [
              3104.436,
              2396.878,
              3808.973
            ],
            [
              3101.877,
              2398.039,
              3811.784
            ],
            [
              3127.616,
              2394.214,
              3837.806
            ],
            [
              3198.032,
              2398.45,
              3908.349
            ],
            [
              3300.456,
              2423.231,
              4013.728
            ],
            [
              3355.729,
              2445.563,
              4073.342
            ],
            [
              3441.784,
              2491.803,
              4171.033
            ],
            [
              3660.291,
              2614.568,
              4421.666
            ],
            [
              3747.601,
              2658.552,
              4519.428
            ],
            [
              3985.636,
              2755.326,
              4776.383
            ],
            [
              4043.411,
              2773.149,
              4836.845
            ],
            [
              4084.265,
              2783.502,
              4878.991
            ],
            [
              4139.27,
              2791.357,
              4934.554
            ],
            [
              4153.342,
              2751.011,
              4977.283
            ],
            [
              4169.434,
              2715.08,
              5016.654
            ],
            [
              4171.136,
              2702.801,
              5029.05
            ],
            [
              4191.056,
              2664.57,
              5072.159
            ],
            [
              4218.241,
              2635.106,
              5112.249
            ],
            [
              4239.21,
              2618.006,
              5139.307
            ],
            [
              4282.48,
              2586.007,
              5193.123
            ],
            [
              4309.254,
              2568.796,
              5224.952
            ],
            [
              4467.714,
              2520.116,
              5390.72
            ],
            [
              4610.044,
              2471.741,
              5541.047
            ],
            [
              4652.686,
              2440.864,
              5593.694
            ],
            [
              4671.824,
              2429.363,
              5616.022
            ],
            [
              4814.301,
              2355.374,
              5776.565
            ],
            [
              4977.975,
              2276.518,
              5958.244
            ],
            [
              5035.146,
              2296.566,
              6018.829
            ],
            [
              5084.32,
              2303.41,
              6068.477
            ],
            [
              5241.303,
              2346.019,
              6231.14
            ],
            [
              5248.742,
              2330.289,
              6248.54
            ],
            [
              5276.154,
              2246.264,
              6336.924
            ],
            [
              5292.838,
              2208.09,
              6378.584
            ],
            [
              5291.267,
              2193.648,
              6393.111
            ],
            [
              5302.941,
              2163.364,
              6425.568
            ],
            [
              5310.723,
              2132.042,
              6457.842
            ],
            [
              5423.002,
              2165.491,
              6574.997
            ],
            [
              5528.724,
              2193.498,
              6684.366
            ],
            [
              5588.928,
              2203.461,
              6745.389
            ],
            [
              5669.02,
              2207.471,
              6825.581
            ],
            [
              5734.986,
              2215.094,
              6891.987
            ],
            [
              5787.277,
              2216.303,
              6944.292
            ],
            [
              5891.708,
              2210.929,
              7048.86
            ],
            [
              5919.915,
              2201.473,
              7078.611
            ],
            [
              5990.282,
              2170.042,
              7155.678
            ],
            [
              6008.082,
              2156.335,
              7178.144
            ],
            [
              6021.15,
              2131.588,
              7206.129
            ],
            [
              6065.185,
              2139.635,
              7250.894
            ],
            [
              6096.19,
              2141.256,
              7281.941
            ],
            [
              6153.148,
              2150.162,
              7339.591
            ],
            [
              6184.906,
              2157.334,
              7372.149
            ],
            [
              6186.283,
              2161.76,
              7376.784
            ],
            [
              6190.088,
              2158.346,
              7381.896
            ],
            [
              6302.78,
              2179.519,
              7496.56
            ],
            [
              6370.901,
              2198.223,
              7567.202
            ],
            [
              6485.19,
              2234.946,
              7687.247
            ],
            [
              6518.994,
              2247.642,
              7723.356
            ],
            [
              6647.127,
              2266.277,
              7852.837
            ],
            [
              6648.734,
              2249.547,
              7869.645
            ],
            [
              6664.061,
              2175.769,
              7944.998
            ],
            [
              6679.103,
              2087.525,
              8034.515
            ],
            [
              6685.858,
              2037.294,
              8085.197
            ],
            [
              6713.888,
              2018.931,
              8118.707
            ],
            [
              6722.098,
              2009.863,
              8130.94
            ],
            [
              6786.815,
              1954.039,
              8216.407
            ],
            [
              6934.171,
              1835.354,
              8405.615
            ],
            [
              6985.778,
              1802.05,
              8467.035
            ],
            [
              6994.719,
              1797.421,
              8477.104
            ],
            [
              7151.902,
              1752.011,
              8640.714
            ],
            [
              7180.859,
              1748.098,
              8669.935
            ],
            [
              7232.816,
              1732.598,
              8724.154
            ],
            [
              7218.9,
              1583.694,
              8873.707
            ],
            [
              7576.848,
              1544.311,
              9233.815
            ],
            [
              7614.877,
              1542.442,
              9271.89
            ],
            [
              7753.694,
              1547.473,
              9410.798
            ],
            [
              7798.773,
              1543.236,
              9456.076
            ],
            [
              7799.733,
              1494.232,
              9505.089
            ],
            [
              7793.796,
              1487.671,
              9513.938
            ],
            [
              7754.104,
              1114.398,
              9889.316
            ],
            [
              7760.199,
              1096.464,
              9908.257
            ],
            [
              7751.793,
              1095.518,
              9916.715
            ],
            [
              7745.305,
              1028.85,
              9983.698
            ],
            [
              8019.062,
              975.52,
              10262.602
            ],
            [
              8065.959,
              965.677,
              10310.52
            ],
            [
              8092.242,
              957.359,
              10338.089
            ],
            [
              8117.792,
              944.602,
              10366.646
            ],
            [
              8150.835,
              919.449,
              10408.173
            ],
            [
              8218.031,
              860.213,
              10497.751
            ],
            [
              8287.693,
              795.361,
              10592.927
            ],
            [
              8311.795,
              774.839,
              10624.583
            ],
            [
              8341.723,
              755.313,
              10660.317
            ],
            [
              8684.194,
              591.462,
              11039.966
            ],
            [
              8696.288,
              583.426,
              11054.487
            ],
            [
              8698.711,
              575.584,
              11062.695
            ],
            [
              8694.685,
              567.872,
              11071.394
            ],
            [
              8692.348,
              547.88,
              11091.523
            ],
            [
              8661.183,
              441.631,
              11202.248
            ],
            [
              8619.341,
              285.498,
              11363.89
            ],
            [
              8586.003,
              199.331,
              11456.281
            ],
            [
              8585.045,
              183.764,
              11471.878
            ],
            [
              8590.333,
              158.052,
              11498.128
            ],
            [
              8621.917,
              92.846,
              11570.58
            ],
            [
              8636.204,
              33.555,
              11631.569
            ],
            [
              8637.068,
              12.385,
              11652.757
            ],
            [
              8604.283,
              -110.532,
              11779.97
            ],
            [
              8595.54,
              -160.454,
              11830.653
            ],
            [
              8696.05,
              -133.53,
              11934.707
            ],
            [
              8718.239,
              -120.617,
              11960.379
            ],
            [
              8744.049,
              -120.024,
              11986.197
            ],
            [
              8789.403,
              -109.804,
              12032.687
            ],
            [
              8826.443,
              -96.078,
              12072.189
            ],
            [
              8853.145,
              -83.257,
              12101.81
            ],
            [
              8900.484,
              -38.566,
              12166.912
            ],
            [
              8997.947,
              60.777,
              12306.081
            ],
            [
              9045.087,
              95.45,
              12364.599
            ],
            [
              9064.009,
              106.201,
              12386.362
            ],
            [
              9090.691,
              117.908,
              12415.499
            ],
            [
              9116.151,
              132.979,
              12445.085
            ],
            [
              9141.918,
              131.345,
              12470.904
            ],
            [
              9732.975,
              142.732,
              13062.071
            ],
            [
              9769.058,
              140.884,
              13098.201
            ],
            [
              9778.039,
              138.475,
              13107.5
            ],
            [
              9786.285,
              131.627,
              13118.218
            ],
            [
              9791.884,
              121.493,
              13129.796
            ],
            [
              9800.829,
              85.686,
              13166.704
            ],
            [
              9802.683,
              50.022,
              13202.416
            ],
            [
              9807.365,
              26.547,
              13226.353
            ],
            [
              9824.001,
              -11.644,
              13268.01
            ],
            [
              9851.507,
              -54.51,
              13318.942
            ],
            [
              9917.554,
              -168.3,
              13450.512
            ],
            [
              9939.188,
              -214.387,
              13501.423
            ],
            [
              10013.097,
              -385.117,
              13687.465
            ],
            [
              10034.288,
              -421.176,
              13729.29
            ],
            [
              10043.876,
              -456.998,
              13766.372
            ],
            [
              10126.945,
              -652.41,
              13978.708
            ],
            [
              10156.362,
              -727.603,
              14059.451
            ],
            [
              10172.333,
              -798.068,
              14131.703
            ],
            [
              10176.882,
              -859.393,
              14193.196
            ],
            [
              10171.77,
              -951.693,
              14285.638
            ],
            [
              10160.5,
              -998.221,
              14333.511
            ],
            [
              10195.194,
              -1004.498,
              14368.768
            ],
            [
              10311.235,
              -974.588,
              14488.602
            ],
            [
              10391.505,
              -959.534,
              14570.272
            ],
            [
              10442.725,
              -946.111,
              14623.221
            ],
            [
              10485.404,
              -940.307,
              14666.293
            ],
            [
              10493.533,
              -952.721,
              14681.131
            ],
            [
              10490.658,
              -967.135,
              14695.829
            ],
            [
              10477.515,
              -979.111,
              14713.61
            ],
            [
              10465.935,
              -977.76,
              14725.269
            ],
            [
              10462.113,
              -975.455,
              14729.732
            ],
            [
              10452.051,
              -963.002,
              14745.742
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4267",
              "position": {
                "x": 372.531,
                "z": 1877.646
              },
              "distanceAlongShapeM": 155.19,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 641.481,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 1059.764,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6673",
              "position": {
                "x": 1245.249,
                "z": 1480.885
              },
              "distanceAlongShapeM": 1354.114,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8821",
              "position": {
                "x": 1389.15,
                "z": 1796.611
              },
              "distanceAlongShapeM": 1717.454,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6675",
              "position": {
                "x": 1530.673,
                "z": 2017.752
              },
              "distanceAlongShapeM": 2002.241,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6678",
              "position": {
                "x": 1914.123,
                "z": 2409.17
              },
              "distanceAlongShapeM": 2585.757,
              "shapeOffsetM": 0.276,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6681",
              "position": {
                "x": 2318.384,
                "z": 2357.098
              },
              "distanceAlongShapeM": 2998.773,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6683",
              "position": {
                "x": 3101.877,
                "z": 2398.039
              },
              "distanceAlongShapeM": 3811.784,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6687",
              "position": {
                "x": 4169.434,
                "z": 2715.08
              },
              "distanceAlongShapeM": 5016.654,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6691",
              "position": {
                "x": 4467.714,
                "z": 2520.116
              },
              "distanceAlongShapeM": 5390.72,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6694",
              "position": {
                "x": 5035.146,
                "z": 2296.566
              },
              "distanceAlongShapeM": 6018.829,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:18787",
              "position": {
                "x": 5292.838,
                "z": 2208.09
              },
              "distanceAlongShapeM": 6378.584,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:19201",
              "position": {
                "x": 6186.283,
                "z": 2161.76
              },
              "distanceAlongShapeM": 7376.784,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:19206",
              "position": {
                "x": 6713.888,
                "z": 2018.931
              },
              "distanceAlongShapeM": 8118.707,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:19200",
              "position": {
                "x": 7280.06,
                "z": 1576.917
              },
              "distanceAlongShapeM": 8935.241,
              "shapeOffsetM": 0.048,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:18884",
              "position": {
                "x": 7799.733,
                "z": 1494.232
              },
              "distanceAlongShapeM": 9505.089,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:18903",
              "position": {
                "x": 7760.199,
                "z": 1096.464
              },
              "distanceAlongShapeM": 9908.257,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6035",
              "position": {
                "x": 8692.348,
                "z": 547.88
              },
              "distanceAlongShapeM": 11091.523,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 11960.379,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 12445.085,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 12881.984,
              "shapeOffsetM": 0.663,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6047",
              "position": {
                "x": 9800.829,
                "z": 85.686
              },
              "distanceAlongShapeM": 13166.704,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:6048",
              "position": {
                "x": 10034.288,
                "z": -421.176
              },
              "distanceAlongShapeM": 13729.29,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6051",
              "position": {
                "x": 10171.77,
                "z": -951.693
              },
              "distanceAlongShapeM": 14285.638,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:8373",
              "position": {
                "x": 10364.963,
                "z": -964.556
              },
              "distanceAlongShapeM": 14543.259,
              "shapeOffsetM": 0.044,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:1129",
              "position": {
                "x": 10452.051,
                "z": -963.002
              },
              "distanceAlongShapeM": 14745.742,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            }
          ],
          "departuresSeconds": [
            18420,
            19740,
            21960,
            22920,
            24120,
            25320,
            26700,
            28320,
            29520,
            30780,
            33780,
            35460,
            37140,
            39240,
            40560,
            42180,
            43920,
            45660,
            46920,
            48540,
            50280,
            52020,
            54060,
            55440,
            56460,
            57780,
            59040,
            60540,
            61920,
            63360,
            64800,
            66240,
            67620,
            69300,
            73260,
            74880,
            76500,
            78120,
            79560,
            81060,
            83220
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_31:1",
          "sourceRouteId": "vilnius_bus_31",
          "sourceShapeId": "vilnius_bus_31_b-a",
          "directionId": 1,
          "headsign": "Stotis (Apylanka)",
          "directionName": "Naujoji Vilnia–Pavilnys–Stotis (Apylanka)",
          "mode": "bus",
          "routeShortName": "31",
          "routeLongName": "Stotis–Pavilnys–Naujoji Vilnia (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              10452.051,
              -963.002,
              0
            ],
            [
              10441.943,
              -952.775,
              14.379
            ],
            [
              10427.739,
              -953.597,
              28.607
            ],
            [
              10203.619,
              -1002.443,
              257.989
            ],
            [
              10160.5,
              -998.221,
              301.313
            ],
            [
              10164.907,
              -940.42,
              359.283
            ],
            [
              10170.701,
              -909.366,
              390.873
            ],
            [
              10174.554,
              -847.099,
              453.258
            ],
            [
              10168.048,
              -786.848,
              513.86
            ],
            [
              10156.362,
              -727.603,
              574.246
            ],
            [
              10041.964,
              -455.845,
              869.101
            ],
            [
              9995.569,
              -359.154,
              976.347
            ],
            [
              9971.821,
              -321.93,
              1020.501
            ],
            [
              9967.299,
              -290.665,
              1052.091
            ],
            [
              9947.183,
              -233.476,
              1112.715
            ],
            [
              9888.206,
              -120.943,
              1239.766
            ],
            [
              9839.53,
              -40.906,
              1333.443
            ],
            [
              9813.404,
              6.385,
              1387.471
            ],
            [
              9798.056,
              44.55,
              1428.606
            ],
            [
              9791,
              78.093,
              1462.883
            ],
            [
              9786.285,
              131.627,
              1516.625
            ],
            [
              9766.321,
              133.147,
              1536.647
            ],
            [
              9682.346,
              127.063,
              1620.842
            ],
            [
              9621.808,
              131.634,
              1681.552
            ],
            [
              9517.36,
              133.756,
              1786.021
            ],
            [
              9448.882,
              128.466,
              1854.703
            ],
            [
              9389.611,
              131.895,
              1914.074
            ],
            [
              9156.08,
              129.945,
              2147.613
            ],
            [
              9090.691,
              117.908,
              2214.1
            ],
            [
              9073.545,
              99.328,
              2239.382
            ],
            [
              9049.578,
              94.246,
              2263.883
            ],
            [
              8990.008,
              50.917,
              2337.543
            ],
            [
              8869.532,
              -70.228,
              2508.396
            ],
            [
              8853.145,
              -83.257,
              2529.331
            ],
            [
              8819.883,
              -101.512,
              2567.273
            ],
            [
              8767.948,
              -118.279,
              2621.848
            ],
            [
              8695.316,
              -137.969,
              2697.102
            ],
            [
              8673.105,
              -151.995,
              2723.371
            ],
            [
              8624.063,
              -153.235,
              2772.428
            ],
            [
              8595.54,
              -160.454,
              2801.851
            ],
            [
              8604.283,
              -110.532,
              2852.533
            ],
            [
              8637.068,
              12.385,
              2979.747
            ],
            [
              8631.494,
              55.915,
              3023.633
            ],
            [
              8618.16,
              98.488,
              3068.245
            ],
            [
              8587.933,
              167.007,
              3143.135
            ],
            [
              8585.045,
              183.764,
              3160.14
            ],
            [
              8637.514,
              355.27,
              3339.492
            ],
            [
              8660.493,
              439.418,
              3426.721
            ],
            [
              8695.643,
              583.439,
              3574.969
            ],
            [
              8662.337,
              595.242,
              3610.305
            ],
            [
              8638.126,
              610.201,
              3638.765
            ],
            [
              8464.301,
              691.624,
              3830.715
            ],
            [
              8342.301,
              751.962,
              3966.82
            ],
            [
              8316.842,
              769.171,
              3997.55
            ],
            [
              8273.062,
              805.674,
              4054.551
            ],
            [
              8139.983,
              925.232,
              4233.448
            ],
            [
              8108.786,
              945.895,
              4270.868
            ],
            [
              8069.094,
              961.161,
              4313.394
            ],
            [
              8002.896,
              973.616,
              4380.754
            ],
            [
              7745.305,
              1028.85,
              4644.2
            ],
            [
              7744.926,
              1042.217,
              4657.573
            ],
            [
              7748.948,
              1082.215,
              4697.773
            ],
            [
              7748.101,
              1104.498,
              4720.071
            ],
            [
              7752.147,
              1113.323,
              4729.78
            ],
            [
              7763.904,
              1217.738,
              4834.855
            ],
            [
              7796.816,
              1542.162,
              5160.944
            ],
            [
              7665.182,
              1541.442,
              5292.58
            ],
            [
              7625.13,
              1538.898,
              5332.713
            ],
            [
              7556.811,
              1542.482,
              5401.126
            ],
            [
              7314.754,
              1569.55,
              5644.691
            ],
            [
              7312.108,
              1566.262,
              5648.911
            ],
            [
              7303.145,
              1569.78,
              5658.539
            ],
            [
              7234.269,
              1577.823,
              5727.884
            ],
            [
              7216.921,
              1581.506,
              5745.618
            ],
            [
              7230.859,
              1731.523,
              5896.281
            ],
            [
              7175.7,
              1748.2,
              5953.906
            ],
            [
              7153.793,
              1749.747,
              5975.868
            ],
            [
              6990.205,
              1797.51,
              6146.286
            ],
            [
              6934.127,
              1833.128,
              6212.719
            ],
            [
              6850.284,
              1900.464,
              6320.254
            ],
            [
              6697.293,
              2028.163,
              6519.536
            ],
            [
              6685.169,
              2035.081,
              6533.495
            ],
            [
              6658.092,
              2200.379,
              6700.995
            ],
            [
              6645.17,
              2265.203,
              6767.094
            ],
            [
              6610.185,
              2258.097,
              6802.794
            ],
            [
              6564.923,
              2253.42,
              6848.297
            ],
            [
              6509.253,
              2244.494,
              6904.678
            ],
            [
              6489.706,
              2234.858,
              6926.472
            ],
            [
              6448.85,
              2224.527,
              6968.613
            ],
            [
              6333.227,
              2185.602,
              7090.612
            ],
            [
              6171.274,
              2153.147,
              7255.786
            ],
            [
              6096.19,
              2141.256,
              7331.805
            ],
            [
              6041.878,
              2135.637,
              7386.407
            ],
            [
              6021.128,
              2130.475,
              7407.789
            ],
            [
              6016.164,
              2140.592,
              7419.058
            ],
            [
              5994.066,
              2165.515,
              7452.367
            ],
            [
              5901.318,
              2207.402,
              7554.134
            ],
            [
              5845.222,
              2209.608,
              7610.274
            ],
            [
              5804.027,
              2214.864,
              7651.803
            ],
            [
              5767.883,
              2214.454,
              7687.949
            ],
            [
              5564.331,
              2199.486,
              7892.051
            ],
            [
              5535.175,
              2193.373,
              7921.841
            ],
            [
              5306.165,
              2129.904,
              8159.483
            ],
            [
              5295.997,
              2171.291,
              8202.102
            ],
            [
              5290.966,
              2178.068,
              8210.542
            ],
            [
              5290.601,
              2192.548,
              8225.026
            ],
            [
              5241.948,
              2346.007,
              8386.012
            ],
            [
              4977.975,
              2276.518,
              8658.979
            ],
            [
              4915.878,
              2302.207,
              8726.18
            ],
            [
              4657.116,
              2436.326,
              9017.634
            ],
            [
              4613.807,
              2466.102,
              9070.192
            ],
            [
              4521.516,
              2499.046,
              9168.187
            ],
            [
              4409.806,
              2529.019,
              9283.847
            ],
            [
              4354.111,
              2552.351,
              9344.232
            ],
            [
              4310.501,
              2566.545,
              9390.094
            ],
            [
              4239.21,
              2618.006,
              9478.018
            ],
            [
              4197.939,
              2653.306,
              9532.326
            ],
            [
              4139.27,
              2791.357,
              9682.327
            ],
            [
              4071.945,
              2780.397,
              9750.539
            ],
            [
              4054.293,
              2768.488,
              9771.832
            ],
            [
              4027.135,
              2765.667,
              9799.137
            ],
            [
              3985.636,
              2755.326,
              9841.905
            ],
            [
              3748.891,
              2658.528,
              10097.674
            ],
            [
              3605.492,
              2583.325,
              10259.596
            ],
            [
              3355.665,
              2442.225,
              10546.515
            ],
            [
              3277.045,
              2413.655,
              10630.166
            ],
            [
              3197.387,
              2398.462,
              10711.259
            ],
            [
              3161.159,
              2393.58,
              10747.815
            ],
            [
              3103.02,
              2390.225,
              10806.05
            ],
            [
              3048.689,
              2383.457,
              10860.802
            ],
            [
              3026.736,
              2382.758,
              10882.766
            ],
            [
              2944.248,
              2354.255,
              10970.039
            ],
            [
              2842.347,
              2322.777,
              11076.691
            ],
            [
              2808.638,
              2314.505,
              11111.401
            ],
            [
              2767.334,
              2314.168,
              11152.706
            ],
            [
              2727.488,
              2322.71,
              11193.457
            ],
            [
              2667.167,
              2340.542,
              11256.358
            ],
            [
              2599.043,
              2355.18,
              11326.038
            ],
            [
              2575.8,
              2354.503,
              11349.29
            ],
            [
              2455.903,
              2326.693,
              11472.37
            ],
            [
              2413.996,
              2328.591,
              11514.32
            ],
            [
              2299.657,
              2356.335,
              11631.977
            ],
            [
              2273.814,
              2354.591,
              11657.879
            ],
            [
              2242.456,
              2368.536,
              11692.198
            ],
            [
              2027.256,
              2420.422,
              11913.564
            ],
            [
              2006.656,
              2423.032,
              11934.329
            ],
            [
              1982.789,
              2423.477,
              11958.2
            ],
            [
              1947.145,
              2415.235,
              11994.785
            ],
            [
              1914.644,
              2402.481,
              12029.699
            ],
            [
              1895.709,
              2390.588,
              12052.059
            ],
            [
              1838.32,
              2392.769,
              12109.489
            ],
            [
              1803.322,
              2384.513,
              12145.448
            ],
            [
              1767.472,
              2365.141,
              12186.197
            ],
            [
              1729.877,
              2321.31,
              12243.942
            ],
            [
              1698.713,
              2276.246,
              12298.733
            ],
            [
              1642.821,
              2150.374,
              12436.456
            ],
            [
              1613.971,
              2090.794,
              12502.653
            ],
            [
              1600.72,
              2072.115,
              12525.555
            ],
            [
              1577.232,
              2058.078,
              12552.918
            ],
            [
              1556.282,
              2041.768,
              12579.468
            ],
            [
              1542.345,
              2020.875,
              12604.583
            ],
            [
              1521.484,
              1974.505,
              12655.429
            ],
            [
              1523.961,
              1968.893,
              12661.564
            ],
            [
              1482.673,
              1899.524,
              12742.29
            ],
            [
              1466.095,
              1875.34,
              12771.611
            ],
            [
              1388.903,
              1783.257,
              12891.769
            ],
            [
              1384.162,
              1771.099,
              12904.818
            ],
            [
              1396.327,
              1696.287,
              12980.613
            ],
            [
              1377.026,
              1664.36,
              13017.92
            ],
            [
              1371.578,
              1648.875,
              13034.335
            ],
            [
              1223.933,
              1444.542,
              13286.429
            ],
            [
              990.627,
              1492.26,
              13524.565
            ],
            [
              961.104,
              1500.597,
              13555.242
            ],
            [
              886.508,
              1548.725,
              13644.017
            ],
            [
              861.581,
              1561.429,
              13671.995
            ],
            [
              775.609,
              1587.5,
              13761.832
            ],
            [
              769.19,
              1624.355,
              13799.242
            ],
            [
              781.269,
              1649.737,
              13827.352
            ],
            [
              802.898,
              1738.399,
              13918.613
            ],
            [
              825.163,
              1791.425,
              13976.124
            ],
            [
              623.161,
              1858.587,
              14188.998
            ],
            [
              599.379,
              1863.475,
              14213.278
            ],
            [
              535.995,
              1890.241,
              14282.081
            ],
            [
              493.148,
              1911.064,
              14329.72
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1129",
              "position": {
                "x": 10452.051,
                "z": -963.002
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -870,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6052",
              "position": {
                "x": 10164.907,
                "z": -940.42
              },
              "distanceAlongShapeM": 359.283,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6049",
              "position": {
                "x": 9971.821,
                "z": -321.93
              },
              "distanceAlongShapeM": 1020.501,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 1620.842,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 1854.703,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 2239.382,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 2723.371,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6034",
              "position": {
                "x": 8662.337,
                "z": 595.242
              },
              "distanceAlongShapeM": 3610.305,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:19076",
              "position": {
                "x": 7748.101,
                "z": 1104.498
              },
              "distanceAlongShapeM": 4720.071,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:18891",
              "position": {
                "x": 7751.004,
                "z": 1541.96
              },
              "distanceAlongShapeM": 5206.757,
              "shapeOffsetM": 0.05,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:19135",
              "position": {
                "x": 7312.108,
                "z": 1566.262
              },
              "distanceAlongShapeM": 5648.911,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:18938",
              "position": {
                "x": 6681.136,
                "z": 2059.653
              },
              "distanceAlongShapeM": 6558.395,
              "shapeOffsetM": 0.008,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:19202",
              "position": {
                "x": 6096.19,
                "z": 2141.256
              },
              "distanceAlongShapeM": 7331.805,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6695",
              "position": {
                "x": 5290.966,
                "z": 2178.068
              },
              "distanceAlongShapeM": 8210.542,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6693",
              "position": {
                "x": 4915.878,
                "z": 2302.207
              },
              "distanceAlongShapeM": 8726.18,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6690",
              "position": {
                "x": 4409.806,
                "z": 2529.019
              },
              "distanceAlongShapeM": 9283.847,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6688",
              "position": {
                "x": 4054.293,
                "z": 2768.488
              },
              "distanceAlongShapeM": 9771.832,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6682",
              "position": {
                "x": 3048.689,
                "z": 2383.457
              },
              "distanceAlongShapeM": 10860.802,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6680",
              "position": {
                "x": 2273.814,
                "z": 2354.591
              },
              "distanceAlongShapeM": 11657.879,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6679",
              "position": {
                "x": 1895.709,
                "z": 2390.588
              },
              "distanceAlongShapeM": 12052.059,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6676",
              "position": {
                "x": 1523.961,
                "z": 1968.893
              },
              "distanceAlongShapeM": 12661.564,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6674",
              "position": {
                "x": 1371.578,
                "z": 1648.875
              },
              "distanceAlongShapeM": 13034.335,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6714",
              "position": {
                "x": 769.19,
                "z": 1624.355
              },
              "distanceAlongShapeM": 13799.242,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 14329.72,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            }
          ],
          "departuresSeconds": [
            19140,
            20100,
            21240,
            22440,
            23640,
            25320,
            26580,
            27840,
            30840,
            32520,
            34200,
            36300,
            37620,
            39180,
            40920,
            42660,
            43980,
            45600,
            47340,
            49080,
            50340,
            51960,
            53520,
            54780,
            56040,
            57540,
            58920,
            60360,
            61800,
            63240,
            64680,
            66360,
            70320,
            71880,
            73680,
            75240,
            76680,
            78120,
            80100,
            81840,
            83160,
            84120
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_32",
      "sourceRouteId": "vilnius_bus_32",
      "mode": "bus",
      "shortName": "32",
      "longName": "Žvėrynas–Zujūnai–Gineitiškės–Perkūnkiemis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_32:0",
          "sourceRouteId": "vilnius_bus_32",
          "sourceShapeId": "vilnius_bus_32_a-b",
          "directionId": 0,
          "headsign": "Perkūnkiemis",
          "directionName": "Žvėrynas–Zujūnai–Gineitiškės–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "32",
          "routeLongName": "Žvėrynas–Zujūnai–Gineitiškės–Perkūnkiemis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2130.763,
              -1067.398,
              0
            ],
            [
              -2108.809,
              -1065.561,
              22.031
            ],
            [
              -2071.721,
              -1082.918,
              62.979
            ],
            [
              -2068.854,
              -1103.007,
              83.272
            ],
            [
              -2072.195,
              -1109.627,
              90.687
            ],
            [
              -2142.708,
              -1122.847,
              162.428
            ],
            [
              -2159.624,
              -1131.453,
              181.407
            ],
            [
              -2184.551,
              -1155.502,
              216.044
            ],
            [
              -2202.716,
              -1161.859,
              235.29
            ],
            [
              -2224.67,
              -1163.697,
              257.32
            ],
            [
              -2246.137,
              -1174.448,
              281.329
            ],
            [
              -2255.963,
              -1183.18,
              294.474
            ],
            [
              -2262.447,
              -1185.292,
              301.294
            ],
            [
              -2339.674,
              -1177.245,
              378.939
            ],
            [
              -2392.506,
              -1175.197,
              431.811
            ],
            [
              -2433.855,
              -1180.032,
              473.441
            ],
            [
              -2474.658,
              -1190.444,
              515.551
            ],
            [
              -2521.496,
              -1214.107,
              568.028
            ],
            [
              -2594.45,
              -1256.235,
              652.272
            ],
            [
              -2624.997,
              -1270.168,
              685.847
            ],
            [
              -2680.78,
              -1289.223,
              744.794
            ],
            [
              -2710.565,
              -1296.491,
              775.453
            ],
            [
              -2777.752,
              -1304.214,
              843.082
            ],
            [
              -2815.153,
              -1304.669,
              880.487
            ],
            [
              -2855.074,
              -1301.74,
              920.515
            ],
            [
              -3099.309,
              -1258.49,
              1168.55
            ],
            [
              -3140.52,
              -1255.542,
              1209.866
            ],
            [
              -3159.719,
              -1247.413,
              1230.715
            ],
            [
              -3359.526,
              -1207.182,
              1434.531
            ],
            [
              -3495.953,
              -1192.555,
              1571.741
            ],
            [
              -3569.469,
              -1193.5,
              1645.263
            ],
            [
              -3626.266,
              -1196.964,
              1702.165
            ],
            [
              -3688.025,
              -1189.21,
              1764.409
            ],
            [
              -3714.785,
              -1170.933,
              1796.815
            ],
            [
              -3768.733,
              -1158.863,
              1852.097
            ],
            [
              -3858.305,
              -1156.194,
              1941.708
            ],
            [
              -4237.967,
              -1188.581,
              2322.749
            ],
            [
              -4268.356,
              -1193.623,
              2353.554
            ],
            [
              -4294.993,
              -1205.408,
              2382.682
            ],
            [
              -4637.998,
              -1318.612,
              2743.884
            ],
            [
              -4714.189,
              -1362.945,
              2832.035
            ],
            [
              -4755.992,
              -1394.51,
              2884.416
            ],
            [
              -4704.903,
              -1648.085,
              3143.086
            ],
            [
              -4687.836,
              -1855.434,
              3351.136
            ],
            [
              -4692.085,
              -1877.625,
              3373.731
            ],
            [
              -4695.288,
              -1876.457,
              3377.14
            ],
            [
              -4699.327,
              -1886.406,
              3387.878
            ],
            [
              -4837.811,
              -2105.557,
              3647.117
            ],
            [
              -4877.224,
              -2186.146,
              3736.827
            ],
            [
              -4945.898,
              -2281.818,
              3854.595
            ],
            [
              -4986.974,
              -2346.794,
              3931.465
            ],
            [
              -5093.592,
              -2550.912,
              4161.752
            ],
            [
              -5127.349,
              -2640.505,
              4257.493
            ],
            [
              -5143.307,
              -2669.176,
              4290.306
            ],
            [
              -5168.552,
              -2713.273,
              4341.118
            ],
            [
              -5209.582,
              -2776.025,
              4416.093
            ],
            [
              -5246.121,
              -2839.967,
              4489.739
            ],
            [
              -5314.077,
              -2932.317,
              4604.397
            ],
            [
              -5317.185,
              -2963.434,
              4635.669
            ],
            [
              -5297.556,
              -3059.504,
              4733.724
            ],
            [
              -5280.712,
              -3129.923,
              4806.129
            ],
            [
              -5243.028,
              -3263.037,
              4944.475
            ],
            [
              -5246.705,
              -3289.691,
              4971.381
            ],
            [
              -5263.267,
              -3316.126,
              5002.575
            ],
            [
              -5367.065,
              -3394.506,
              5132.643
            ],
            [
              -5411.327,
              -3458.318,
              5210.302
            ],
            [
              -5435.257,
              -3501.326,
              5259.519
            ],
            [
              -5479.991,
              -3555.111,
              5329.477
            ],
            [
              -5519.608,
              -3611.211,
              5398.154
            ],
            [
              -5878.394,
              -3870.065,
              5840.572
            ],
            [
              -6032.238,
              -3975.444,
              6027.046
            ],
            [
              -5981.248,
              -4046.438,
              6114.453
            ],
            [
              -5888.31,
              -4189.386,
              6284.958
            ],
            [
              -5885.221,
              -4197.231,
              6293.389
            ],
            [
              -5888.005,
              -4209.429,
              6305.9
            ],
            [
              -5899.143,
              -4220.373,
              6321.515
            ],
            [
              -5914.752,
              -4229.014,
              6339.356
            ],
            [
              -5991.715,
              -4284.486,
              6434.227
            ],
            [
              -6021.757,
              -4308.468,
              6472.668
            ],
            [
              -6144.879,
              -4388.766,
              6619.66
            ],
            [
              -6182.724,
              -4417.071,
              6666.919
            ],
            [
              -6225.72,
              -4445.289,
              6718.348
            ],
            [
              -6216.303,
              -4459.92,
              6735.747
            ],
            [
              -6172.119,
              -4514.098,
              6805.658
            ],
            [
              -6145.157,
              -4557.968,
              6857.15
            ],
            [
              -6128.788,
              -4580.508,
              6885.008
            ],
            [
              -5986.791,
              -4945.811,
              7276.938
            ],
            [
              -5995.182,
              -4946.782,
              7285.384
            ],
            [
              -5980.859,
              -4975.968,
              7317.895
            ],
            [
              -5963.012,
              -5025.25,
              7370.31
            ],
            [
              -5952.422,
              -5046.58,
              7394.124
            ],
            [
              -5917.244,
              -5099.496,
              7457.666
            ],
            [
              -5870.401,
              -5148.157,
              7525.21
            ],
            [
              -5845.606,
              -5167.502,
              7556.658
            ],
            [
              -5825.757,
              -5174.517,
              7577.711
            ],
            [
              -5803.293,
              -5179.351,
              7600.688
            ],
            [
              -5783.481,
              -5188.592,
              7622.549
            ],
            [
              -5768.708,
              -5191.069,
              7637.529
            ],
            [
              -5752.59,
              -5190.229,
              7653.669
            ],
            [
              -5746.113,
              -5188.113,
              7660.483
            ],
            [
              -5723.973,
              -5174.017,
              7686.73
            ],
            [
              -5701.775,
              -5156.582,
              7714.955
            ],
            [
              -5688.177,
              -5152.36,
              7729.194
            ],
            [
              -5646.149,
              -5143.055,
              7772.24
            ],
            [
              -5599.726,
              -5140.504,
              7818.733
            ],
            [
              -5574.062,
              -5146.507,
              7845.089
            ],
            [
              -5494.645,
              -5173.461,
              7928.956
            ],
            [
              -5460.572,
              -5177.381,
              7963.254
            ],
            [
              -5416.991,
              -5190.369,
              8008.729
            ],
            [
              -5371.933,
              -5192.25,
              8053.826
            ],
            [
              -5069.27,
              -5197.42,
              8356.533
            ],
            [
              -4792.724,
              -5185.463,
              8633.337
            ],
            [
              -4742.399,
              -5180.761,
              8683.881
            ],
            [
              -4156.392,
              -5190.871,
              9269.976
            ],
            [
              -4052.012,
              -5189.34,
              9374.368
            ],
            [
              -4041.833,
              -5048.138,
              9515.936
            ],
            [
              -3824.791,
              -5050.794,
              9732.994
            ],
            [
              -3827.361,
              -5087.486,
              9769.775
            ],
            [
              -3833.268,
              -5130.798,
              9813.489
            ],
            [
              -3844.602,
              -5152.866,
              9838.297
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4898",
              "position": {
                "x": -2071.721,
                "z": -1082.918
              },
              "distanceAlongShapeM": 62.979,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 1209.866,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 1764.409,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 2382.682,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:16971",
              "position": {
                "x": -4704.903,
                "z": -1648.085
              },
              "distanceAlongShapeM": 3143.086,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:10280",
              "position": {
                "x": -4877.224,
                "z": -2186.146
              },
              "distanceAlongShapeM": 3736.827,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6746",
              "position": {
                "x": -5030.968,
                "z": -2431.757
              },
              "distanceAlongShapeM": 4027.143,
              "shapeOffsetM": 0.341,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6749",
              "position": {
                "x": -5280.712,
                "z": -3129.923
              },
              "distanceAlongShapeM": 4806.129,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:19064",
              "position": {
                "x": -5435.257,
                "z": -3501.326
              },
              "distanceAlongShapeM": 5259.519,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:8002",
              "position": {
                "x": -5519.608,
                "z": -3611.211
              },
              "distanceAlongShapeM": 5398.154,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6751",
              "position": {
                "x": -5878.394,
                "z": -3870.065
              },
              "distanceAlongShapeM": 5840.572,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:18926",
              "position": {
                "x": -5981.248,
                "z": -4046.438
              },
              "distanceAlongShapeM": 6114.453,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:18928",
              "position": {
                "x": -6182.724,
                "z": -4417.071
              },
              "distanceAlongShapeM": 6666.919,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:16896",
              "position": {
                "x": -6128.788,
                "z": -4580.508
              },
              "distanceAlongShapeM": 6885.008,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7392",
              "position": {
                "x": -5986.791,
                "z": -4945.811
              },
              "distanceAlongShapeM": 7276.938,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7845",
              "position": {
                "x": -5524.097,
                "z": -5162.941
              },
              "distanceAlongShapeM": 7897.685,
              "shapeOffsetM": 0.496,
              "arrivalOffsetSeconds": 1590,
              "departureOffsetSeconds": 1590
            },
            {
              "stopId": "judu:stop:7395",
              "position": {
                "x": -4966.766,
                "z": -5192.496
              },
              "distanceAlongShapeM": 8459.154,
              "shapeOffsetM": 0.491,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:9768",
              "position": {
                "x": -4156.392,
                "z": -5190.871
              },
              "distanceAlongShapeM": 9269.976,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 9769.775,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            }
          ],
          "departuresSeconds": [
            17880,
            19680,
            21120,
            22860,
            24720,
            26400,
            28500,
            30660,
            34080,
            36480,
            39060,
            41760,
            44220,
            46920,
            49560,
            52140,
            54840,
            57420,
            59100,
            60660,
            62820,
            64680,
            68220,
            70740,
            73320,
            75660,
            78300,
            81000
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_32:1",
          "sourceRouteId": "vilnius_bus_32",
          "sourceShapeId": "vilnius_bus_32_b-a",
          "directionId": 1,
          "headsign": "Žvėrynas",
          "directionName": "Perkūnkiemis–Gineitiškės–Zujūnai–Žvėrynas",
          "mode": "bus",
          "routeShortName": "32",
          "routeLongName": "Žvėrynas–Zujūnai–Gineitiškės–Perkūnkiemis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3844.602,
              -5152.866,
              0
            ],
            [
              -3862.028,
              -5154.789,
              17.532
            ],
            [
              -3896.745,
              -5150.846,
              52.471
            ],
            [
              -3904.981,
              -5142.911,
              63.908
            ],
            [
              -3906.076,
              -5131.759,
              75.113
            ],
            [
              -3903.757,
              -5109.535,
              97.458
            ],
            [
              -3899.68,
              -5097.361,
              110.297
            ],
            [
              -3891.837,
              -5090.818,
              120.511
            ],
            [
              -3867.269,
              -5085.679,
              145.611
            ],
            [
              -3854.099,
              -5069.209,
              166.698
            ],
            [
              -3846.764,
              -5054.865,
              182.809
            ],
            [
              -4041.833,
              -5048.138,
              377.995
            ],
            [
              -4054.156,
              -5201.548,
              531.899
            ],
            [
              -4187.417,
              -5197.013,
              665.238
            ],
            [
              -4508.755,
              -5191.462,
              986.623
            ],
            [
              -4560.955,
              -5192.789,
              1038.84
            ],
            [
              -4730.24,
              -5185.423,
              1208.286
            ],
            [
              -4792.724,
              -5185.463,
              1270.769
            ],
            [
              -4993.283,
              -5198.721,
              1471.766
            ],
            [
              -5032.717,
              -5206.951,
              1512.05
            ],
            [
              -5174.88,
              -5195.613,
              1654.664
            ],
            [
              -5316.533,
              -5192.081,
              1796.361
            ],
            [
              -5353.201,
              -5189.23,
              1833.14
            ],
            [
              -5402.218,
              -5192.847,
              1882.29
            ],
            [
              -5554.307,
              -5159.088,
              2038.081
            ],
            [
              -5574.782,
              -5150.947,
              2060.114
            ],
            [
              -5608.154,
              -5143.701,
              2094.265
            ],
            [
              -5629.424,
              -5144.453,
              2115.548
            ],
            [
              -5686.926,
              -5154.608,
              2173.94
            ],
            [
              -5717.438,
              -5168.562,
              2207.491
            ],
            [
              -5731.889,
              -5185.015,
              2229.389
            ],
            [
              -5748.764,
              -5192.521,
              2247.858
            ],
            [
              -5811.134,
              -5185.897,
              2310.579
            ],
            [
              -5822.65,
              -5181.249,
              2322.998
            ],
            [
              -5857.729,
              -5160.617,
              2363.694
            ],
            [
              -5872.995,
              -5149.226,
              2382.742
            ],
            [
              -5922.434,
              -5101.635,
              2451.365
            ],
            [
              -5939.463,
              -5080.196,
              2478.744
            ],
            [
              -5975.703,
              -5013.904,
              2554.295
            ],
            [
              -5994.12,
              -4960.159,
              2611.108
            ],
            [
              -6022.784,
              -4902.901,
              2675.14
            ],
            [
              -6031.88,
              -4869.351,
              2709.901
            ],
            [
              -6041.846,
              -4849.145,
              2732.431
            ],
            [
              -6046.072,
              -4832.375,
              2749.725
            ],
            [
              -6063.065,
              -4808.711,
              2778.859
            ],
            [
              -6077.737,
              -4723.86,
              2864.969
            ],
            [
              -6109.893,
              -4644.28,
              2950.8
            ],
            [
              -6159.176,
              -4548.826,
              3058.226
            ],
            [
              -6197.05,
              -4502.546,
              3118.028
            ],
            [
              -6208.324,
              -4483.431,
              3140.22
            ],
            [
              -6227.233,
              -4458.622,
              3171.413
            ],
            [
              -6298.045,
              -4340.543,
              3309.098
            ],
            [
              -6279.786,
              -4327.492,
              3331.541
            ],
            [
              -6244.08,
              -4311.396,
              3370.708
            ],
            [
              -6197.75,
              -4276.554,
              3428.677
            ],
            [
              -6154.126,
              -4249.46,
              3480.03
            ],
            [
              -6083.718,
              -4200.554,
              3565.757
            ],
            [
              -6051.081,
              -4175.502,
              3606.901
            ],
            [
              -6017.911,
              -4157.138,
              3644.814
            ],
            [
              -5978.113,
              -4127.754,
              3694.285
            ],
            [
              -5946.194,
              -4107.143,
              3732.28
            ],
            [
              -6027.973,
              -3989.988,
              3875.155
            ],
            [
              -6032.957,
              -3979.885,
              3886.421
            ],
            [
              -6032.75,
              -3967.643,
              3898.664
            ],
            [
              -5942.086,
              -3902.384,
              4010.373
            ],
            [
              -5844.959,
              -3836.122,
              4127.949
            ],
            [
              -5535.106,
              -3613.174,
              4509.675
            ],
            [
              -5520.062,
              -3600.071,
              4529.625
            ],
            [
              -5430.994,
              -3478.021,
              4680.719
            ],
            [
              -5413.278,
              -3459.398,
              4706.422
            ],
            [
              -5368.429,
              -3398.936,
              4781.703
            ],
            [
              -5347.435,
              -3377.03,
              4812.045
            ],
            [
              -5280.908,
              -3330.296,
              4893.346
            ],
            [
              -5264.536,
              -3314.991,
              4915.757
            ],
            [
              -5250.704,
              -3297.415,
              4938.123
            ],
            [
              -5241.664,
              -3258.608,
              4977.97
            ],
            [
              -5245.302,
              -3245.187,
              4991.875
            ],
            [
              -5288.69,
              -3144.258,
              5101.735
            ],
            [
              -5299.887,
              -3082.841,
              5164.164
            ],
            [
              -5313.303,
              -3075.933,
              5179.254
            ],
            [
              -5304.567,
              -3054.931,
              5202
            ],
            [
              -5317.716,
              -2956.745,
              5301.063
            ],
            [
              -5314.077,
              -2932.317,
              5325.761
            ],
            [
              -5224.213,
              -2802.492,
              5483.653
            ],
            [
              -5191.067,
              -2748.511,
              5546.999
            ],
            [
              -5129.111,
              -2630.456,
              5680.323
            ],
            [
              -5086.673,
              -2523.201,
              5795.669
            ],
            [
              -5019.916,
              -2388.532,
              5945.977
            ],
            [
              -4857.792,
              -2143.064,
              6240.151
            ],
            [
              -4836.919,
              -2091.101,
              6296.149
            ],
            [
              -4689.278,
              -1864.315,
              6566.759
            ],
            [
              -4687.173,
              -1854.332,
              6576.961
            ],
            [
              -4708.767,
              -1760.452,
              6673.293
            ],
            [
              -4755.992,
              -1394.51,
              7042.269
            ],
            [
              -4761.883,
              -1362.126,
              7075.185
            ],
            [
              -4704.97,
              -1314.122,
              7149.64
            ],
            [
              -4653.804,
              -1300.53,
              7202.58
            ],
            [
              -4405.208,
              -1203.507,
              7469.438
            ],
            [
              -4296.995,
              -1171.977,
              7582.151
            ],
            [
              -4247.02,
              -1152.802,
              7635.679
            ],
            [
              -4191.003,
              -1157.11,
              7691.861
            ],
            [
              -3912.099,
              -1135.223,
              7971.623
            ],
            [
              -3759.013,
              -1118.956,
              8125.57
            ],
            [
              -3705.284,
              -1106.532,
              8180.717
            ],
            [
              -3657.704,
              -1114.039,
              8228.886
            ],
            [
              -3599.031,
              -1113.947,
              8287.559
            ],
            [
              -3412.497,
              -1176.2,
              8484.206
            ],
            [
              -3355.367,
              -1190.556,
              8543.113
            ],
            [
              -3108.49,
              -1230.499,
              8793.2
            ],
            [
              -3070.013,
              -1242.306,
              8833.448
            ],
            [
              -2879.155,
              -1277.94,
              9027.603
            ],
            [
              -2839.273,
              -1283.094,
              9067.817
            ],
            [
              -2787.087,
              -1285.125,
              9120.043
            ],
            [
              -2748.376,
              -1283.58,
              9158.785
            ],
            [
              -2714.118,
              -1278.617,
              9193.4
            ],
            [
              -2670.7,
              -1266.023,
              9238.608
            ],
            [
              -2624.585,
              -1246.798,
              9288.569
            ],
            [
              -2500.301,
              -1182.198,
              9428.64
            ],
            [
              -2469.831,
              -1172.717,
              9460.551
            ],
            [
              -2418.716,
              -1162.489,
              9512.679
            ],
            [
              -2392.231,
              -1159.617,
              9539.32
            ],
            [
              -2246.137,
              -1174.448,
              9686.165
            ],
            [
              -2229.866,
              -1165.831,
              9704.577
            ],
            [
              -2190.996,
              -1155.388,
              9744.825
            ],
            [
              -2164.136,
              -1131.373,
              9780.855
            ],
            [
              -2142.708,
              -1122.847,
              9803.917
            ],
            [
              -2138.761,
              -1118.464,
              9809.815
            ],
            [
              -2144.773,
              -1093.867,
              9835.136
            ],
            [
              -2147.916,
              -1089.358,
              9840.633
            ],
            [
              -2139.925,
              -1075.028,
              9857.04
            ],
            [
              -2130.763,
              -1067.398,
              9868.963
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 166.698,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9766",
              "position": {
                "x": -4187.417,
                "z": -5197.013
              },
              "distanceAlongShapeM": 665.238,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17333",
              "position": {
                "x": -4394.793,
                "z": -5194.542
              },
              "distanceAlongShapeM": 872.625,
              "shapeOffsetM": 1.11,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:4479",
              "position": {
                "x": -5032.717,
                "z": -5206.951
              },
              "distanceAlongShapeM": 1512.05,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7844",
              "position": {
                "x": -5811.134,
                "z": -5185.897
              },
              "distanceAlongShapeM": 2310.579,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7393",
              "position": {
                "x": -6063.065,
                "z": -4808.711
              },
              "distanceAlongShapeM": 2778.859,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:16898",
              "position": {
                "x": -6197.05,
                "z": -4502.546
              },
              "distanceAlongShapeM": 3118.028,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:18927",
              "position": {
                "x": -6197.75,
                "z": -4276.554
              },
              "distanceAlongShapeM": 3428.677,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:19106",
              "position": {
                "x": -5844.959,
                "z": -3836.122
              },
              "distanceAlongShapeM": 4127.949,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:8001",
              "position": {
                "x": -5430.994,
                "z": -3478.021
              },
              "distanceAlongShapeM": 4680.719,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6748",
              "position": {
                "x": -5313.303,
                "z": -3075.933
              },
              "distanceAlongShapeM": 5179.254,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6743",
              "position": {
                "x": -5019.916,
                "z": -2388.532
              },
              "distanceAlongShapeM": 5945.977,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:10281",
              "position": {
                "x": -4836.919,
                "z": -2091.101
              },
              "distanceAlongShapeM": 6296.149,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:16973",
              "position": {
                "x": -4708.767,
                "z": -1760.452
              },
              "distanceAlongShapeM": 6673.293,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 7149.64,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 7635.679,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:7342",
              "position": {
                "x": -3705.284,
                "z": -1106.532
              },
              "distanceAlongShapeM": 8180.717,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1710,
              "departureOffsetSeconds": 1710
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 8793.2,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1830,
              "departureOffsetSeconds": 1830
            },
            {
              "stopId": "judu:stop:18480",
              "position": {
                "x": -2130.763,
                "z": -1067.398
              },
              "distanceAlongShapeM": 9868.963,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            18660,
            20280,
            22080,
            23640,
            25440,
            27540,
            29280,
            31260,
            36540,
            39180,
            41640,
            44400,
            46860,
            49500,
            52200,
            54780,
            56460,
            58020,
            60180,
            61860,
            63480,
            65580,
            67380,
            70800,
            73200,
            75720,
            78180,
            80760
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_33",
      "sourceRouteId": "vilnius_bus_33",
      "mode": "bus",
      "shortName": "33",
      "longName": "Šiaurės miestelis–Rinktinės–Olandų g.–Sukilėlių g.–Guriai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_33:0",
          "sourceRouteId": "vilnius_bus_33",
          "sourceShapeId": "vilnius_bus_33_a-b3",
          "directionId": 0,
          "headsign": "Guriai",
          "directionName": "Šiaurės miestelis–Rinktinės–Olandų g.–Sukilėlių g.–Kalnėnai–Guriai",
          "mode": "bus",
          "routeShortName": "33",
          "routeLongName": "Šiaurės miestelis–Rinktinės–Olandų g.–Sukilėlių g.–Guriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1412.698,
              -2538.791,
              0
            ],
            [
              1427.807,
              -2523.486,
              21.507
            ],
            [
              1492.99,
              -2519.128,
              86.835
            ],
            [
              1524.687,
              -2513.037,
              119.112
            ],
            [
              1540.007,
              -2521.114,
              136.431
            ],
            [
              1543.77,
              -2526.75,
              143.207
            ],
            [
              1541.692,
              -2534.504,
              151.235
            ],
            [
              1533.274,
              -2536.574,
              159.904
            ],
            [
              1448.137,
              -2539.448,
              245.089
            ],
            [
              1439.137,
              -2538.168,
              254.18
            ],
            [
              1428.101,
              -2542.416,
              266.006
            ],
            [
              1420.142,
              -2554.515,
              280.487
            ],
            [
              1415.904,
              -2574.474,
              300.892
            ],
            [
              1275.293,
              -2579.663,
              441.599
            ],
            [
              1255.195,
              -2585.971,
              462.663
            ],
            [
              1231.149,
              -2596.659,
              488.978
            ],
            [
              1196.251,
              -2601.58,
              524.221
            ],
            [
              955.306,
              -2665.04,
              773.383
            ],
            [
              918.333,
              -2677.718,
              812.469
            ],
            [
              895.761,
              -2678.415,
              835.052
            ],
            [
              887.466,
              -2673.809,
              844.539
            ],
            [
              874.193,
              -2624.582,
              895.525
            ],
            [
              876.281,
              -2581.204,
              938.953
            ],
            [
              793.859,
              -2331.434,
              1201.971
            ],
            [
              796.161,
              -2311.438,
              1222.099
            ],
            [
              783.008,
              -2255.534,
              1279.529
            ],
            [
              777.261,
              -2147.444,
              1387.772
            ],
            [
              711.928,
              -1879.065,
              1663.988
            ],
            [
              663.224,
              -1757.941,
              1794.538
            ],
            [
              616.278,
              -1681.379,
              1884.347
            ],
            [
              587.849,
              -1649.686,
              1926.922
            ],
            [
              569.208,
              -1611.494,
              1969.42
            ],
            [
              540.203,
              -1540.828,
              2045.807
            ],
            [
              521.99,
              -1479.266,
              2110.007
            ],
            [
              505.894,
              -1407.724,
              2183.338
            ],
            [
              503.887,
              -1376.517,
              2214.609
            ],
            [
              512.262,
              -1306.536,
              2285.089
            ],
            [
              526.396,
              -1238.888,
              2354.199
            ],
            [
              548.613,
              -1152.462,
              2443.434
            ],
            [
              606.765,
              -899.711,
              2702.789
            ],
            [
              630.682,
              -791.052,
              2814.049
            ],
            [
              635.244,
              -753.286,
              2852.089
            ],
            [
              647.48,
              -719,
              2888.493
            ],
            [
              718.871,
              -413.057,
              3202.655
            ],
            [
              707.215,
              -380.559,
              3237.18
            ],
            [
              685.601,
              -293.329,
              3327.048
            ],
            [
              645.363,
              9.096,
              3632.138
            ],
            [
              675.04,
              9.665,
              3661.821
            ],
            [
              707.88,
              6.836,
              3694.782
            ],
            [
              925.597,
              -42.81,
              3918.088
            ],
            [
              1129.224,
              -156.774,
              4151.437
            ],
            [
              1143.99,
              -160.386,
              4166.639
            ],
            [
              1610.786,
              -514.132,
              4752.331
            ],
            [
              1615.737,
              -525.357,
              4764.598
            ],
            [
              1648.803,
              -550.462,
              4806.115
            ],
            [
              1657.142,
              -552.844,
              4814.787
            ],
            [
              1673.279,
              -552.03,
              4830.944
            ],
            [
              1707.61,
              -543.762,
              4866.257
            ],
            [
              1715.531,
              -533.89,
              4878.914
            ],
            [
              1739.19,
              -475.328,
              4942.075
            ],
            [
              1739.832,
              -440.829,
              4976.58
            ],
            [
              1737.688,
              -417.411,
              5000.096
            ],
            [
              1728.721,
              -379.394,
              5039.156
            ],
            [
              1714.349,
              -354.636,
              5067.783
            ],
            [
              1709.957,
              -313.364,
              5109.288
            ],
            [
              1701.073,
              -270.896,
              5152.676
            ],
            [
              1691.292,
              -207.259,
              5217.06
            ],
            [
              1692.553,
              -139.375,
              5284.956
            ],
            [
              1699.889,
              -91.641,
              5333.249
            ],
            [
              1722.281,
              -31.942,
              5397.01
            ],
            [
              1763.619,
              40.763,
              5480.645
            ],
            [
              1781.292,
              89.417,
              5532.41
            ],
            [
              1803.689,
              114.605,
              5566.115
            ],
            [
              1864.141,
              209.22,
              5678.393
            ],
            [
              1913.636,
              269.526,
              5756.41
            ],
            [
              1990.962,
              334.88,
              5857.654
            ],
            [
              2015.503,
              371.16,
              5901.454
            ],
            [
              2052.586,
              388.28,
              5942.299
            ],
            [
              2087.216,
              412.125,
              5984.344
            ],
            [
              2136.967,
              451.273,
              6047.651
            ],
            [
              2182.309,
              496.069,
              6111.389
            ],
            [
              2210.658,
              528.937,
              6154.794
            ],
            [
              2229.877,
              556.409,
              6188.321
            ],
            [
              2244.749,
              592.868,
              6227.697
            ],
            [
              2266.569,
              621.404,
              6263.619
            ],
            [
              2281.67,
              670.105,
              6314.608
            ],
            [
              2285.519,
              703.43,
              6348.154
            ],
            [
              2286.06,
              732.364,
              6377.094
            ],
            [
              2274.704,
              814.957,
              6460.463
            ],
            [
              2261.392,
              861.962,
              6509.317
            ],
            [
              2144.257,
              1048.95,
              6729.964
            ],
            [
              2116.361,
              1075.075,
              6768.183
            ],
            [
              2107.082,
              1096.4,
              6791.439
            ],
            [
              2088.256,
              1124.583,
              6825.332
            ],
            [
              2063.5,
              1146.196,
              6858.195
            ],
            [
              2049.437,
              1153.138,
              6873.878
            ],
            [
              2015.466,
              1164.904,
              6909.828
            ],
            [
              1965.977,
              1174.732,
              6960.285
            ],
            [
              1928.988,
              1197.686,
              7003.817
            ],
            [
              1911.304,
              1218.054,
              7030.79
            ],
            [
              1889.313,
              1249.634,
              7069.272
            ],
            [
              1817.435,
              1512.583,
              7341.869
            ],
            [
              1773.71,
              1659.231,
              7494.896
            ],
            [
              1762.656,
              1724.004,
              7560.606
            ],
            [
              1756.881,
              1829.869,
              7666.629
            ],
            [
              1746.536,
              1863.459,
              7701.775
            ],
            [
              1759.639,
              1908.858,
              7749.027
            ],
            [
              1808.843,
              2126.139,
              7971.81
            ],
            [
              1796.441,
              2326.753,
              8172.806
            ],
            [
              1803.322,
              2384.513,
              8230.975
            ],
            [
              1851.97,
              2398.081,
              8281.48
            ],
            [
              1901.805,
              2406.06,
              8331.949
            ],
            [
              1960.129,
              2419.446,
              8391.79
            ],
            [
              1982.789,
              2423.477,
              8414.806
            ],
            [
              2016.977,
              2422.84,
              8449
            ],
            [
              2300.344,
              2358.548,
              8739.569
            ],
            [
              2318.384,
              2357.098,
              8757.667
            ],
            [
              2341.44,
              2347.761,
              8782.542
            ],
            [
              2404.362,
              2330.998,
              8847.659
            ],
            [
              2453.344,
              2327.854,
              8896.741
            ],
            [
              2522.053,
              2344.378,
              8967.409
            ],
            [
              2590.678,
              2356.45,
              9037.088
            ],
            [
              2633.792,
              2350.075,
              9080.671
            ],
            [
              2719.186,
              2327.319,
              9169.045
            ],
            [
              2777.655,
              2313.974,
              9229.017
            ],
            [
              2795.071,
              2313.647,
              9246.436
            ],
            [
              2818.355,
              2316.549,
              9269.901
            ],
            [
              2887.128,
              2336.406,
              9341.483
            ],
            [
              3040.387,
              2388.067,
              9503.215
            ],
            [
              3104.436,
              2396.878,
              9567.867
            ],
            [
              3101.877,
              2398.039,
              9570.678
            ],
            [
              3156.062,
              2397.016,
              9624.872
            ],
            [
              3223.295,
              2403.539,
              9692.421
            ],
            [
              3301.704,
              2420.981,
              9772.747
            ],
            [
              3441.784,
              2491.803,
              9929.712
            ],
            [
              3608.801,
              2587.715,
              10122.31
            ],
            [
              3711.158,
              2642.546,
              10238.428
            ],
            [
              3892.019,
              2719.259,
              10434.886
            ],
            [
              3986.281,
              2755.313,
              10535.807
            ],
            [
              3941.257,
              2898.668,
              10686.066
            ],
            [
              3900.799,
              3010.764,
              10805.24
            ],
            [
              3870.133,
              3162.751,
              10960.289
            ],
            [
              3855.951,
              3197.532,
              10997.85
            ],
            [
              3829.722,
              3243.674,
              11050.926
            ],
            [
              3776.691,
              3305.912,
              11132.693
            ],
            [
              3766.168,
              3329.49,
              11158.513
            ],
            [
              3736.764,
              3412.43,
              11246.511
            ],
            [
              3719.936,
              3443.921,
              11282.216
            ],
            [
              3679.16,
              3505.925,
              11356.426
            ],
            [
              3910.102,
              3736.428,
              11682.717
            ],
            [
              4069.05,
              3812.439,
              11858.905
            ],
            [
              4116.685,
              3839.361,
              11913.621
            ],
            [
              4455.787,
              3985.391,
              12282.83
            ],
            [
              4660.266,
              4078.321,
              12507.435
            ],
            [
              4783.97,
              3831.027,
              12783.945
            ],
            [
              4807.805,
              3794.944,
              12827.189
            ],
            [
              4845.318,
              3765.277,
              12875.015
            ],
            [
              4903.716,
              3714.056,
              12952.694
            ],
            [
              4948.434,
              3656.418,
              13025.645
            ],
            [
              4955.082,
              3632.911,
              13050.073
            ],
            [
              4967.105,
              3620.434,
              13067.401
            ],
            [
              4992.855,
              3483.006,
              13207.22
            ],
            [
              5094.075,
              3042.428,
              13659.276
            ],
            [
              5222.911,
              3063.317,
              13789.795
            ],
            [
              5300.072,
              3081.862,
              13869.154
            ],
            [
              5327.727,
              3076.874,
              13897.256
            ],
            [
              5372.372,
              3082.689,
              13942.278
            ],
            [
              5415.814,
              3092.98,
              13986.921
            ],
            [
              5455.384,
              3103.345,
              14027.826
            ],
            [
              5554.806,
              3138.154,
              14133.166
            ],
            [
              5575.001,
              3147.782,
              14155.538
            ],
            [
              5595.087,
              3151.845,
              14176.031
            ],
            [
              5611.454,
              3163.773,
              14196.284
            ],
            [
              5614.186,
              3171.512,
              14204.491
            ],
            [
              5620.144,
              3179.19,
              14214.209
            ],
            [
              5626.015,
              3182.415,
              14220.908
            ],
            [
              5632.402,
              3178.951,
              14228.174
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 119.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9565",
              "position": {
                "x": 1231.149,
                "z": -2596.659
              },
              "distanceAlongShapeM": 488.978,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9637",
              "position": {
                "x": 874.193,
                "z": -2624.582
              },
              "distanceAlongShapeM": 895.525,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9640",
              "position": {
                "x": 793.859,
                "z": -2331.434
              },
              "distanceAlongShapeM": 1201.971,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:18780",
              "position": {
                "x": 587.849,
                "z": -1649.686
              },
              "distanceAlongShapeM": 1926.922,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7326",
              "position": {
                "x": 503.887,
                "z": -1376.517
              },
              "distanceAlongShapeM": 2214.609,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7337",
              "position": {
                "x": 635.244,
                "z": -753.286
              },
              "distanceAlongShapeM": 2852.089,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7323",
              "position": {
                "x": 707.215,
                "z": -380.559
              },
              "distanceAlongShapeM": 3237.18,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 3694.782,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 4166.639,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 4752.331,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 5067.783,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6568",
              "position": {
                "x": 1781.292,
                "z": 89.417
              },
              "distanceAlongShapeM": 5532.41,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 5901.454,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 6227.697,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5925",
              "position": {
                "x": 2116.361,
                "z": 1075.075
              },
              "distanceAlongShapeM": 6768.183,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7689",
              "position": {
                "x": 1746.536,
                "z": 1863.459
              },
              "distanceAlongShapeM": 7701.775,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6678",
              "position": {
                "x": 1914.123,
                "z": 2409.17
              },
              "distanceAlongShapeM": 8344.651,
              "shapeOffsetM": 0.276,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6681",
              "position": {
                "x": 2318.384,
                "z": 2357.098
              },
              "distanceAlongShapeM": 8757.667,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6683",
              "position": {
                "x": 3101.877,
                "z": 2398.039
              },
              "distanceAlongShapeM": 9570.678,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:9661",
              "position": {
                "x": 3900.799,
                "z": 3010.764
              },
              "distanceAlongShapeM": 10805.24,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:9600",
              "position": {
                "x": 4116.685,
                "z": 3839.361
              },
              "distanceAlongShapeM": 11913.621,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:16713",
              "position": {
                "x": 4688.859,
                "z": 4020.996
              },
              "distanceAlongShapeM": 12571.496,
              "shapeOffsetM": 0.074,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:16724",
              "position": {
                "x": 4948.434,
                "z": 3656.418
              },
              "distanceAlongShapeM": 13025.645,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:7714",
              "position": {
                "x": 5327.727,
                "z": 3076.874
              },
              "distanceAlongShapeM": 13897.256,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:7716",
              "position": {
                "x": 5632.402,
                "z": 3178.951
              },
              "distanceAlongShapeM": 14228.174,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            }
          ],
          "departuresSeconds": [
            19080,
            20460,
            22500,
            25200,
            27000,
            29160,
            34200,
            36000,
            40500,
            42000,
            46800,
            48600,
            53700,
            54900,
            57600,
            61200,
            63900,
            65400,
            69900,
            70800,
            75660,
            76920,
            82440
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_33:1",
          "sourceRouteId": "vilnius_bus_33",
          "sourceShapeId": "vilnius_bus_33_b-a3",
          "directionId": 1,
          "headsign": "Šiaurės miestelis",
          "directionName": "Guriai–Kalnėnai–Sukilėlių g.–Olandų g.–Rinktinės g.–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "33",
          "routeLongName": "Šiaurės miestelis–Rinktinės–Olandų g.–Sukilėlių g.–Guriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5632.402,
              3178.951,
              0
            ],
            [
              5641.928,
              3170.973,
              12.426
            ],
            [
              5639.261,
              3166.572,
              17.572
            ],
            [
              5585.968,
              3147.569,
              74.152
            ],
            [
              5544.977,
              3130.552,
              118.534
            ],
            [
              5478.718,
              3108.459,
              188.38
            ],
            [
              5367.813,
              3080.551,
              302.742
            ],
            [
              5288.781,
              3065.382,
              383.217
            ],
            [
              5163.987,
              3053.323,
              508.592
            ],
            [
              5097.3,
              3042.366,
              576.173
            ],
            [
              5039.274,
              3279.497,
              820.301
            ],
            [
              4987.026,
              3515.403,
              1061.924
            ],
            [
              4968.138,
              3607.055,
              1155.501
            ],
            [
              4969.686,
              3620.384,
              1168.92
            ],
            [
              4948.715,
              3637.487,
              1195.981
            ],
            [
              4936.97,
              3664.432,
              1225.374
            ],
            [
              4925.678,
              3681.348,
              1245.713
            ],
            [
              4849.168,
              3764.09,
              1358.407
            ],
            [
              4819.765,
              3779.128,
              1391.433
            ],
            [
              4705.105,
              3959.455,
              1605.125
            ],
            [
              4660.137,
              4071.644,
              1725.992
            ],
            [
              4128.817,
              3832.45,
              2308.671
            ],
            [
              3925.842,
              3749.487,
              2527.946
            ],
            [
              3679.16,
              3505.925,
              2874.609
            ],
            [
              3723.807,
              3443.847,
              2951.074
            ],
            [
              3751.191,
              3356.493,
              3042.62
            ],
            [
              3767.289,
              3320.563,
              3081.991
            ],
            [
              3789.796,
              3282.284,
              3126.396
            ],
            [
              3847.839,
              3212.158,
              3217.428
            ],
            [
              3905.823,
              3037.387,
              3401.567
            ],
            [
              3986.281,
              2755.313,
              3694.891
            ],
            [
              3690.262,
              2629.584,
              4016.504
            ],
            [
              3441.784,
              2491.803,
              4300.625
            ],
            [
              3321.224,
              2429.518,
              4436.323
            ],
            [
              3223.295,
              2403.539,
              4537.641
            ],
            [
              3141.765,
              2391.72,
              4620.022
            ],
            [
              3073.951,
              2388.547,
              4687.911
            ],
            [
              3048.689,
              2383.457,
              4713.68
            ],
            [
              3026.736,
              2382.758,
              4735.644
            ],
            [
              2944.248,
              2354.255,
              4822.918
            ],
            [
              2842.347,
              2322.777,
              4929.57
            ],
            [
              2808.638,
              2314.505,
              4964.28
            ],
            [
              2767.334,
              2314.168,
              5005.585
            ],
            [
              2727.488,
              2322.71,
              5046.336
            ],
            [
              2667.167,
              2340.542,
              5109.237
            ],
            [
              2599.043,
              2355.18,
              5178.916
            ],
            [
              2575.8,
              2354.503,
              5202.169
            ],
            [
              2455.903,
              2326.693,
              5325.249
            ],
            [
              2413.996,
              2328.591,
              5367.199
            ],
            [
              2299.657,
              2356.335,
              5484.856
            ],
            [
              2273.814,
              2354.591,
              5510.758
            ],
            [
              2242.456,
              2368.536,
              5545.077
            ],
            [
              2027.256,
              2420.422,
              5766.443
            ],
            [
              2006.656,
              2423.032,
              5787.208
            ],
            [
              1982.789,
              2423.477,
              5811.079
            ],
            [
              1947.145,
              2415.235,
              5847.664
            ],
            [
              1914.644,
              2402.481,
              5882.578
            ],
            [
              1895.709,
              2390.588,
              5904.938
            ],
            [
              1838.32,
              2392.769,
              5962.368
            ],
            [
              1803.322,
              2384.513,
              5998.327
            ],
            [
              1798.959,
              2323.366,
              6059.629
            ],
            [
              1808.843,
              2126.139,
              6257.104
            ],
            [
              1771.307,
              1946.492,
              6440.631
            ],
            [
              1758.977,
              1873.247,
              6514.906
            ],
            [
              1756.881,
              1829.869,
              6558.334
            ],
            [
              1773.178,
              1769.451,
              6620.912
            ],
            [
              1767.563,
              1745.065,
              6645.937
            ],
            [
              1776.079,
              1682.565,
              6709.014
            ],
            [
              1851.599,
              1476.324,
              6928.646
            ],
            [
              1872.115,
              1434.752,
              6975.005
            ],
            [
              1901.514,
              1385.222,
              7032.603
            ],
            [
              1922.902,
              1355.88,
              7068.913
            ],
            [
              1982.258,
              1286.866,
              7159.941
            ],
            [
              2054.989,
              1208.696,
              7266.713
            ],
            [
              2130.485,
              1105.982,
              7394.187
            ],
            [
              2171.861,
              1041.755,
              7470.589
            ],
            [
              2187.13,
              1030.337,
              7489.655
            ],
            [
              2200.048,
              996.698,
              7525.688
            ],
            [
              2297.211,
              845.707,
              7705.241
            ],
            [
              2377.645,
              731.764,
              7844.714
            ],
            [
              2390.041,
              704.814,
              7874.378
            ],
            [
              2393.451,
              680.258,
              7899.169
            ],
            [
              2387.751,
              651.421,
              7928.565
            ],
            [
              2369.175,
              623.937,
              7961.737
            ],
            [
              2305.672,
              573.917,
              8042.575
            ],
            [
              2269.605,
              542.307,
              8090.533
            ],
            [
              2256.376,
              524.743,
              8112.522
            ],
            [
              2223.804,
              507.54,
              8149.358
            ],
            [
              1990.962,
              334.88,
              8439.231
            ],
            [
              1973.014,
              306.27,
              8473.005
            ],
            [
              1935.827,
              283.585,
              8516.564
            ],
            [
              1864.599,
              199.192,
              8626.999
            ],
            [
              1763.619,
              40.763,
              8814.873
            ],
            [
              1759.816,
              9.663,
              8846.204
            ],
            [
              1734.841,
              -15.477,
              8881.641
            ],
            [
              1714.048,
              -58.507,
              8929.432
            ],
            [
              1702.489,
              -90.576,
              8963.521
            ],
            [
              1692.553,
              -139.375,
              9013.32
            ],
            [
              1696.284,
              -216.258,
              9090.294
            ],
            [
              1701.445,
              -250.864,
              9125.283
            ],
            [
              1720.689,
              -325.809,
              9202.659
            ],
            [
              1735.144,
              -346.116,
              9227.585
            ],
            [
              1742.617,
              -429.749,
              9311.551
            ],
            [
              1739.19,
              -475.328,
              9357.259
            ],
            [
              1717.531,
              -565.098,
              9449.605
            ],
            [
              1721.402,
              -599.681,
              9484.404
            ],
            [
              1716.683,
              -610.725,
              9496.414
            ],
            [
              1700.984,
              -622.679,
              9516.146
            ],
            [
              1670.687,
              -622.116,
              9546.449
            ],
            [
              1655.278,
              -618.49,
              9562.278
            ],
            [
              1647.146,
              -604.98,
              9578.047
            ],
            [
              1647.435,
              -589.4,
              9593.63
            ],
            [
              1641.361,
              -569.249,
              9614.676
            ],
            [
              1626.241,
              -550.043,
              9639.12
            ],
            [
              1608.96,
              -543.043,
              9657.765
            ],
            [
              1227.773,
              -233.181,
              10149.006
            ],
            [
              1060.09,
              -128.781,
              10346.533
            ],
            [
              912.058,
              -42.561,
              10517.844
            ],
            [
              652.936,
              0.051,
              10780.446
            ],
            [
              646.469,
              -0.943,
              10786.99
            ],
            [
              667.023,
              -146.041,
              10933.536
            ],
            [
              673.645,
              -171.767,
              10960.101
            ],
            [
              684.82,
              -195.35,
              10986.198
            ],
            [
              683.338,
              -240.966,
              11031.837
            ],
            [
              694.504,
              -300.172,
              11092.088
            ],
            [
              716.179,
              -384.063,
              11178.733
            ],
            [
              718.871,
              -413.057,
              11207.852
            ],
            [
              701.12,
              -501.79,
              11298.343
            ],
            [
              662.621,
              -666.955,
              11467.936
            ],
            [
              647.48,
              -719,
              11522.138
            ],
            [
              642.877,
              -758.992,
              11562.394
            ],
            [
              653.896,
              -755.854,
              11573.852
            ],
            [
              633.66,
              -804.465,
              11626.507
            ],
            [
              601.763,
              -926.336,
              11752.483
            ],
            [
              572.282,
              -1057.158,
              11886.585
            ],
            [
              526.396,
              -1238.888,
              12074.018
            ],
            [
              517.316,
              -1312.195,
              12147.886
            ],
            [
              516.039,
              -1346.682,
              12182.396
            ],
            [
              511.377,
              -1390.013,
              12225.977
            ],
            [
              526.877,
              -1423.694,
              12263.054
            ],
            [
              528.313,
              -1486.062,
              12325.438
            ],
            [
              543.467,
              -1538.662,
              12380.178
            ],
            [
              561.361,
              -1582.406,
              12427.441
            ],
            [
              616.278,
              -1681.379,
              12540.628
            ],
            [
              662.58,
              -1757.929,
              12630.092
            ],
            [
              704.051,
              -1816.579,
              12701.923
            ],
            [
              713.36,
              -1871.299,
              12757.429
            ],
            [
              776.616,
              -2147.432,
              13040.715
            ],
            [
              789.268,
              -2195.534,
              13090.453
            ],
            [
              792.091,
              -2252.361,
              13147.351
            ],
            [
              808.047,
              -2296.071,
              13193.882
            ],
            [
              810.133,
              -2322.828,
              13220.719
            ],
            [
              815.482,
              -2347.417,
              13245.884
            ],
            [
              839.035,
              -2433.57,
              13335.199
            ],
            [
              881.722,
              -2565.719,
              13474.071
            ],
            [
              900.578,
              -2661.805,
              13571.989
            ],
            [
              904.362,
              -2666.328,
              13577.886
            ],
            [
              908.852,
              -2667.524,
              13582.533
            ],
            [
              978.247,
              -2644.311,
              13655.707
            ],
            [
              1030.623,
              -2635.258,
              13708.859
            ],
            [
              1258.684,
              -2571.563,
              13945.648
            ],
            [
              1329.768,
              -2561.746,
              14017.407
            ],
            [
              1359.181,
              -2574.537,
              14049.481
            ],
            [
              1423.013,
              -2573.493,
              14113.321
            ],
            [
              1423.219,
              -2562.364,
              14124.451
            ],
            [
              1413.343,
              -2538.803,
              14149.999
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7716",
              "position": {
                "x": 5632.402,
                "z": 3178.951
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:16230",
              "position": {
                "x": 5544.977,
                "z": 3130.552
              },
              "distanceAlongShapeM": 118.534,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7715",
              "position": {
                "x": 5288.781,
                "z": 3065.382
              },
              "distanceAlongShapeM": 383.217,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:16725",
              "position": {
                "x": 4925.678,
                "z": 3681.348
              },
              "distanceAlongShapeM": 1245.713,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:16715",
              "position": {
                "x": 4705.105,
                "z": 3959.455
              },
              "distanceAlongShapeM": 1605.125,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9599",
              "position": {
                "x": 4128.817,
                "z": 3832.45
              },
              "distanceAlongShapeM": 2308.671,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:9660",
              "position": {
                "x": 3905.823,
                "z": 3037.387
              },
              "distanceAlongShapeM": 3401.567,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6682",
              "position": {
                "x": 3048.689,
                "z": 2383.457
              },
              "distanceAlongShapeM": 4713.68,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6680",
              "position": {
                "x": 2273.814,
                "z": 2354.591
              },
              "distanceAlongShapeM": 5510.758,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6679",
              "position": {
                "x": 1895.709,
                "z": 2390.588
              },
              "distanceAlongShapeM": 5904.938,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7688",
              "position": {
                "x": 1773.178,
                "z": 1769.451
              },
              "distanceAlongShapeM": 6620.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:356",
              "position": {
                "x": 2187.13,
                "z": 1030.337
              },
              "distanceAlongShapeM": 7489.655,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 8112.522,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 8473.005,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:603",
              "position": {
                "x": 1759.816,
                "z": 9.663
              },
              "distanceAlongShapeM": 8846.204,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6566",
              "position": {
                "x": 1735.144,
                "z": -346.116
              },
              "distanceAlongShapeM": 9227.585,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 9657.765,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 10346.533,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7322",
              "position": {
                "x": 684.82,
                "z": -195.35
              },
              "distanceAlongShapeM": 10986.198,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:7324",
              "position": {
                "x": 653.896,
                "z": -755.854
              },
              "distanceAlongShapeM": 11573.852,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7325",
              "position": {
                "x": 526.877,
                "z": -1423.694
              },
              "distanceAlongShapeM": 12263.054,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7331",
              "position": {
                "x": 704.051,
                "z": -1816.579
              },
              "distanceAlongShapeM": 12701.923,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9638",
              "position": {
                "x": 808.047,
                "z": -2296.071
              },
              "distanceAlongShapeM": 13193.882,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:18532",
              "position": {
                "x": 978.247,
                "z": -2644.311
              },
              "distanceAlongShapeM": 13655.707,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:9566",
              "position": {
                "x": 1329.768,
                "z": -2561.746
              },
              "distanceAlongShapeM": 14017.407,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 14149.999,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            22080,
            23400,
            25860,
            28500,
            30300,
            32460,
            37200,
            39000,
            43500,
            45300,
            50400,
            51900,
            57000,
            58500,
            61200,
            65100,
            66900,
            69000,
            72900,
            74100,
            78600,
            79680,
            85140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_34",
      "sourceRouteId": "vilnius_bus_34",
      "mode": "bus",
      "shortName": "34",
      "longName": "Stotis–Olandų g.–Baltupiai–Jeruzalės g.–Visoriai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_34:0",
          "sourceRouteId": "vilnius_bus_34",
          "sourceShapeId": "vilnius_bus_34_a-b",
          "directionId": 0,
          "headsign": "Visoriai",
          "directionName": "Stotis–Olandų g.–Baltupiai–Jeruzalės g.–Visoriai",
          "mode": "bus",
          "routeShortName": "34",
          "routeLongName": "Stotis–Olandų g.–Baltupiai–Jeruzalės g.–Visoriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              493.148,
              1911.064,
              0
            ],
            [
              476.562,
              1921.386,
              19.536
            ],
            [
              453.967,
              1920.686,
              42.142
            ],
            [
              432.764,
              1925.527,
              63.89
            ],
            [
              422.444,
              1925.716,
              74.212
            ],
            [
              419.803,
              1922.424,
              78.432
            ],
            [
              401.805,
              1926.093,
              96.8
            ],
            [
              397.27,
              1925.063,
              101.451
            ],
            [
              384.004,
              1905.267,
              125.281
            ],
            [
              372.531,
              1877.646,
              155.19
            ],
            [
              344.166,
              1843.654,
              199.462
            ],
            [
              330.657,
              1810.504,
              235.259
            ],
            [
              391.321,
              1670.242,
              388.078
            ],
            [
              477.846,
              1568.468,
              521.661
            ],
            [
              485.021,
              1572.79,
              530.037
            ],
            [
              495.103,
              1594.87,
              554.31
            ],
            [
              502.822,
              1593.615,
              562.13
            ],
            [
              515.619,
              1587.815,
              576.18
            ],
            [
              552.903,
              1580.453,
              614.184
            ],
            [
              580.051,
              1583.295,
              641.481
            ],
            [
              658.651,
              1577.401,
              720.302
            ],
            [
              692.229,
              1579.012,
              753.918
            ],
            [
              741.428,
              1588.128,
              803.955
            ],
            [
              775.609,
              1587.5,
              838.142
            ],
            [
              809.668,
              1580.195,
              872.975
            ],
            [
              847.494,
              1567.254,
              912.954
            ],
            [
              881.41,
              1552.158,
              950.077
            ],
            [
              944.603,
              1515.372,
              1023.197
            ],
            [
              979.224,
              1503.603,
              1059.764
            ],
            [
              987.526,
              1498.997,
              1069.258
            ],
            [
              1015.114,
              1490.696,
              1098.068
            ],
            [
              1169.279,
              1454.457,
              1256.436
            ],
            [
              1174.911,
              1305.179,
              1405.82
            ],
            [
              1219.91,
              1296.555,
              1451.637
            ],
            [
              1270.109,
              1290.062,
              1502.255
            ],
            [
              1288.043,
              1283.051,
              1521.51
            ],
            [
              1461.257,
              1230.864,
              1702.415
            ],
            [
              1535.192,
              1217.248,
              1777.594
            ],
            [
              1586.927,
              1224.082,
              1829.778
            ],
            [
              1634.086,
              1227.66,
              1877.073
            ],
            [
              1673.61,
              1236.945,
              1917.673
            ],
            [
              1721.874,
              1230.483,
              1966.367
            ],
            [
              1775.523,
              1236.165,
              2020.317
            ],
            [
              1885.048,
              1263.072,
              2133.098
            ],
            [
              1894.159,
              1267.356,
              2143.166
            ],
            [
              1963.37,
              1277.199,
              2213.073
            ],
            [
              2043.065,
              1295.752,
              2294.9
            ],
            [
              2056.65,
              1297.725,
              2308.627
            ],
            [
              2074.707,
              1297.388,
              2326.687
            ],
            [
              2084.797,
              1284.954,
              2342.7
            ],
            [
              2093.452,
              1264.754,
              2364.675
            ],
            [
              2097.301,
              1229.059,
              2400.578
            ],
            [
              2095.034,
              1211.289,
              2418.492
            ],
            [
              2084.488,
              1199.24,
              2434.504
            ],
            [
              2081.118,
              1191.51,
              2442.937
            ],
            [
              2085.924,
              1172.496,
              2462.55
            ],
            [
              2161.169,
              1056.427,
              2600.874
            ],
            [
              2179.433,
              1032.707,
              2630.811
            ],
            [
              2187.13,
              1030.337,
              2638.864
            ],
            [
              2200.048,
              996.698,
              2674.898
            ],
            [
              2297.211,
              845.707,
              2854.451
            ],
            [
              2377.645,
              731.764,
              2993.923
            ],
            [
              2390.041,
              704.814,
              3023.588
            ],
            [
              2393.451,
              680.258,
              3048.379
            ],
            [
              2387.751,
              651.421,
              3077.774
            ],
            [
              2369.175,
              623.937,
              3110.946
            ],
            [
              2305.672,
              573.917,
              3191.784
            ],
            [
              2269.605,
              542.307,
              3239.743
            ],
            [
              2256.376,
              524.743,
              3261.732
            ],
            [
              2223.804,
              507.54,
              3298.568
            ],
            [
              1990.962,
              334.88,
              3588.441
            ],
            [
              1973.014,
              306.27,
              3622.215
            ],
            [
              1935.827,
              283.585,
              3665.774
            ],
            [
              1864.599,
              199.192,
              3776.209
            ],
            [
              1763.619,
              40.763,
              3964.082
            ],
            [
              1759.816,
              9.663,
              3995.414
            ],
            [
              1734.841,
              -15.477,
              4030.851
            ],
            [
              1714.048,
              -58.507,
              4078.641
            ],
            [
              1702.489,
              -90.576,
              4112.731
            ],
            [
              1692.553,
              -139.375,
              4162.53
            ],
            [
              1696.284,
              -216.258,
              4239.503
            ],
            [
              1701.445,
              -250.864,
              4274.493
            ],
            [
              1720.689,
              -325.809,
              4351.869
            ],
            [
              1735.144,
              -346.116,
              4376.795
            ],
            [
              1742.617,
              -429.749,
              4460.761
            ],
            [
              1739.19,
              -475.328,
              4506.469
            ],
            [
              1717.531,
              -565.098,
              4598.815
            ],
            [
              1721.402,
              -599.681,
              4633.613
            ],
            [
              1716.683,
              -610.725,
              4645.624
            ],
            [
              1700.984,
              -622.679,
              4665.356
            ],
            [
              1684.224,
              -622.368,
              4682.119
            ],
            [
              1662.848,
              -627.537,
              4704.111
            ],
            [
              1381.451,
              -814.909,
              5042.183
            ],
            [
              1363.471,
              -845.747,
              5077.88
            ],
            [
              1363.126,
              -899.177,
              5131.31
            ],
            [
              1355.02,
              -919.065,
              5152.787
            ],
            [
              1339.886,
              -935.484,
              5175.117
            ],
            [
              1325.561,
              -943.011,
              5191.299
            ],
            [
              1285.577,
              -943.385,
              5231.285
            ],
            [
              1262.269,
              -948.52,
              5255.152
            ],
            [
              1247.842,
              -961.612,
              5274.634
            ],
            [
              1192.361,
              -1032.948,
              5365.005
            ],
            [
              1184.819,
              -1057.3,
              5390.498
            ],
            [
              1157.377,
              -1076.831,
              5424.18
            ],
            [
              1022.871,
              -1237.996,
              5634.099
            ],
            [
              920.55,
              -1367.472,
              5799.126
            ],
            [
              905.214,
              -1395.021,
              5830.656
            ],
            [
              882.932,
              -1414.649,
              5860.35
            ],
            [
              768.148,
              -1556.146,
              6042.549
            ],
            [
              700.938,
              -1635.064,
              6146.208
            ],
            [
              640.022,
              -1687.381,
              6226.507
            ],
            [
              593.917,
              -1705.46,
              6276.03
            ],
            [
              578.225,
              -1717.417,
              6295.759
            ],
            [
              544.713,
              -1716.803,
              6329.276
            ],
            [
              351.211,
              -1722.165,
              6522.853
            ],
            [
              347.927,
              -1725.444,
              6527.494
            ],
            [
              347.744,
              -1735.46,
              6537.511
            ],
            [
              356.237,
              -1764.56,
              6567.825
            ],
            [
              354.758,
              -1810.175,
              6613.465
            ],
            [
              356.121,
              -1841.371,
              6644.69
            ],
            [
              372.957,
              -1942.984,
              6747.688
            ],
            [
              426.379,
              -2158.817,
              6970.034
            ],
            [
              441.836,
              -2194.724,
              7009.127
            ],
            [
              440.947,
              -2208.066,
              7022.499
            ],
            [
              462.343,
              -2342.047,
              7158.177
            ],
            [
              505.139,
              -2574.385,
              7394.424
            ],
            [
              511.756,
              -2776.003,
              7596.15
            ],
            [
              513.301,
              -2797.183,
              7617.386
            ],
            [
              524.563,
              -2850.825,
              7672.198
            ],
            [
              524.913,
              -2902.04,
              7723.415
            ],
            [
              518.333,
              -3049.981,
              7871.501
            ],
            [
              517.855,
              -3111.2,
              7932.723
            ],
            [
              506.223,
              -3253.482,
              8075.479
            ],
            [
              511.316,
              -3256.915,
              8081.621
            ],
            [
              504.142,
              -3366.994,
              8191.934
            ],
            [
              489.873,
              -3512.567,
              8338.205
            ],
            [
              474.056,
              -3566.826,
              8394.722
            ],
            [
              441.104,
              -3641.923,
              8476.73
            ],
            [
              383.151,
              -3709.882,
              8566.044
            ],
            [
              303.678,
              -3791.921,
              8680.264
            ],
            [
              278.895,
              -3808.166,
              8709.897
            ],
            [
              228.358,
              -3858.451,
              8781.189
            ],
            [
              158.106,
              -3965.152,
              8908.941
            ],
            [
              127.093,
              -4040.286,
              8990.223
            ],
            [
              102.95,
              -4092.167,
              9047.448
            ],
            [
              79.561,
              -4208.631,
              9166.236
            ],
            [
              75.006,
              -4246.398,
              9204.277
            ],
            [
              72.804,
              -4296.453,
              9254.381
            ],
            [
              62.209,
              -4347.469,
              9306.485
            ],
            [
              53.653,
              -4357.332,
              9319.542
            ],
            [
              38.073,
              -4363.727,
              9336.384
            ],
            [
              -1.759,
              -4357.435,
              9376.71
            ],
            [
              -43.706,
              -4361.123,
              9418.818
            ],
            [
              -86.799,
              -4356.998,
              9462.108
            ],
            [
              -112.623,
              -4359.868,
              9488.092
            ],
            [
              -137.864,
              -4366.088,
              9514.088
            ],
            [
              -171.117,
              -4387.748,
              9553.773
            ],
            [
              -197.387,
              -4415.101,
              9591.698
            ],
            [
              -229.695,
              -4455.703,
              9643.586
            ],
            [
              -260.472,
              -4482.974,
              9684.707
            ],
            [
              -335.167,
              -4516.128,
              9766.429
            ],
            [
              -368.095,
              -4519.983,
              9799.582
            ],
            [
              -469.274,
              -4521.487,
              9900.772
            ],
            [
              -484.832,
              -4526.772,
              9917.203
            ],
            [
              -495.157,
              -4527.698,
              9927.57
            ],
            [
              -531.808,
              -4523.694,
              9964.439
            ],
            [
              -716.635,
              -4519.236,
              10149.319
            ],
            [
              -810.335,
              -4855.967,
              10498.844
            ],
            [
              -844.605,
              -4970.012,
              10617.926
            ],
            [
              -859.998,
              -5037.642,
              10687.285
            ],
            [
              -867.261,
              -5083.153,
              10733.373
            ],
            [
              -868.447,
              -5113.189,
              10763.432
            ],
            [
              -863.974,
              -5257.991,
              10908.302
            ],
            [
              -873.83,
              -5375.816,
              11026.539
            ],
            [
              -864.956,
              -5383.768,
              11038.456
            ],
            [
              -826.661,
              -5403.385,
              11081.482
            ],
            [
              -674.33,
              -5492.97,
              11258.203
            ],
            [
              -589.373,
              -5532.358,
              11351.846
            ],
            [
              -565.267,
              -5552.833,
              11383.474
            ],
            [
              -421.759,
              -5631.135,
              11546.955
            ],
            [
              -383.93,
              -5640.727,
              11585.981
            ],
            [
              -342.157,
              -5645.939,
              11628.078
            ],
            [
              -257.182,
              -5648.596,
              11713.094
            ],
            [
              -196.756,
              -5655.261,
              11773.886
            ],
            [
              -180.177,
              -5664.469,
              11792.851
            ],
            [
              -177.18,
              -5676.769,
              11805.511
            ],
            [
              -185.798,
              -5725.595,
              11855.091
            ],
            [
              -185.377,
              -5737.848,
              11867.352
            ],
            [
              -196.91,
              -5769.923,
              11901.437
            ],
            [
              -201.665,
              -5818.819,
              11950.563
            ],
            [
              -201.086,
              -5857.793,
              11989.542
            ],
            [
              -195.599,
              -5910.215,
              12042.25
            ],
            [
              -136.015,
              -6175.138,
              12313.791
            ],
            [
              -122.378,
              -6204.331,
              12346.012
            ],
            [
              -123.468,
              -6228.802,
              12370.508
            ],
            [
              -113.557,
              -6285.758,
              12428.32
            ],
            [
              -58.166,
              -6532.794,
              12681.489
            ],
            [
              -46.468,
              -6597.576,
              12747.319
            ],
            [
              -39.377,
              -6667.839,
              12817.939
            ],
            [
              -35.045,
              -6748.072,
              12898.289
            ],
            [
              -27.041,
              -6768.256,
              12920.002
            ],
            [
              -16.965,
              -6780.686,
              12936.003
            ],
            [
              0.233,
              -6791.019,
              12956.067
            ],
            [
              10.168,
              -6811.238,
              12978.595
            ],
            [
              11.151,
              -6827.955,
              12995.34
            ],
            [
              7.024,
              -6842.352,
              13010.317
            ],
            [
              -2.815,
              -6852.191,
              13024.232
            ],
            [
              -13.86,
              -6857.556,
              13036.511
            ],
            [
              -37.095,
              -6860.472,
              13059.928
            ],
            [
              -47.374,
              -6859.171,
              13070.289
            ],
            [
              -59.463,
              -6851.158,
              13084.793
            ],
            [
              -78.653,
              -6844.129,
              13105.23
            ],
            [
              -94.726,
              -6842.723,
              13121.364
            ],
            [
              -112.168,
              -6845.745,
              13139.066
            ],
            [
              -131.642,
              -6854.296,
              13160.335
            ],
            [
              -156.753,
              -6889.462,
              13203.546
            ],
            [
              -179.506,
              -6901.294,
              13229.192
            ],
            [
              -377.89,
              -7081.371,
              13497.117
            ],
            [
              -432.166,
              -7127.141,
              13568.116
            ],
            [
              -475.073,
              -7149.741,
              13616.611
            ],
            [
              -543.125,
              -7174.111,
              13688.895
            ],
            [
              -668.705,
              -7210.8,
              13819.724
            ],
            [
              -673.975,
              -7217.384,
              13828.158
            ],
            [
              -654.083,
              -7256.707,
              13872.227
            ],
            [
              -633.285,
              -7281.575,
              13904.645
            ],
            [
              -627.895,
              -7303.938,
              13927.648
            ],
            [
              -546.04,
              -7512.484,
              14151.683
            ],
            [
              -517.868,
              -7627.659,
              14270.254
            ],
            [
              -515.818,
              -7656.64,
              14299.307
            ],
            [
              -519.805,
              -7734.495,
              14377.264
            ],
            [
              -528.192,
              -7735.456,
              14385.706
            ],
            [
              -535.151,
              -7728.65,
              14395.439
            ],
            [
              -543.255,
              -7714.031,
              14412.155
            ],
            [
              -546.272,
              -7702.844,
              14423.741
            ],
            [
              -547.174,
              -7646.052,
              14480.54
            ],
            [
              -637.863,
              -7641.069,
              14571.367
            ],
            [
              -661.758,
              -7645.09,
              14595.597
            ],
            [
              -677.044,
              -7635.907,
              14613.429
            ],
            [
              -928.758,
              -7670.321,
              14867.485
            ],
            [
              -968.501,
              -7696.322,
              14914.977
            ],
            [
              -995.773,
              -7709.189,
              14945.133
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4267",
              "position": {
                "x": 372.531,
                "z": 1877.646
              },
              "distanceAlongShapeM": 155.19,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 641.481,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 1059.764,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5360",
              "position": {
                "x": 1270.109,
                "z": 1290.062
              },
              "distanceAlongShapeM": 1502.255,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5362",
              "position": {
                "x": 1673.61,
                "z": 1236.945
              },
              "distanceAlongShapeM": 1917.673,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:1123",
              "position": {
                "x": 2093.452,
                "z": 1264.754
              },
              "distanceAlongShapeM": 2364.675,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:356",
              "position": {
                "x": 2187.13,
                "z": 1030.337
              },
              "distanceAlongShapeM": 2638.864,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 3261.732,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 3622.215,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:603",
              "position": {
                "x": 1759.816,
                "z": 9.663
              },
              "distanceAlongShapeM": 3995.414,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 810,
              "departureOffsetSeconds": 810
            },
            {
              "stopId": "judu:stop:6566",
              "position": {
                "x": 1735.144,
                "z": -346.116
              },
              "distanceAlongShapeM": 4376.795,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 870,
              "departureOffsetSeconds": 870
            },
            {
              "stopId": "judu:stop:6547",
              "position": {
                "x": 1184.819,
                "z": -1057.3
              },
              "distanceAlongShapeM": 5390.498,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:1032",
              "position": {
                "x": 905.214,
                "z": -1395.021
              },
              "distanceAlongShapeM": 5830.656,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:18847",
              "position": {
                "x": 578.225,
                "z": -1717.417
              },
              "distanceAlongShapeM": 6295.759,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 6567.825,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 7009.127,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 7394.424,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 8081.621,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 8680.264,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1770,
              "departureOffsetSeconds": 1770
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 8990.223,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1830,
              "departureOffsetSeconds": 1830
            },
            {
              "stopId": "judu:stop:5835",
              "position": {
                "x": -43.706,
                "z": -4361.123
              },
              "distanceAlongShapeM": 9418.818,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5834",
              "position": {
                "x": -495.157,
                "z": -4527.698
              },
              "distanceAlongShapeM": 9927.57,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 11081.482,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 11351.846,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 11867.352,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 12346.012,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6783",
              "position": {
                "x": -156.753,
                "z": -6889.462
              },
              "distanceAlongShapeM": 13203.546,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:7980",
              "position": {
                "x": -633.285,
                "z": -7281.575
              },
              "distanceAlongShapeM": 13904.645,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:7046",
              "position": {
                "x": -661.758,
                "z": -7645.09
              },
              "distanceAlongShapeM": 14595.597,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 14945.133,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            }
          ],
          "departuresSeconds": [
            18540,
            21000,
            22920,
            24780,
            26100,
            27840,
            30060,
            32160,
            35400,
            37560,
            39660,
            42120,
            44460,
            46740,
            48840,
            51600,
            53880,
            56160,
            58140,
            60120,
            61920,
            63720,
            66060,
            69720,
            71820,
            73920,
            76080,
            78180,
            80280,
            82440
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_34:1",
          "sourceRouteId": "vilnius_bus_34",
          "sourceShapeId": "vilnius_bus_34_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Visoriai–Jeruzalės g. –Baltupiai–Olandų g.–Stotis",
          "mode": "bus",
          "routeShortName": "34",
          "routeLongName": "Stotis–Olandų g.–Baltupiai–Jeruzalės g.–Visoriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -995.773,
              -7709.189,
              0
            ],
            [
              -1008.525,
              -7702.28,
              14.503
            ],
            [
              -1017.555,
              -7703.23,
              23.584
            ],
            [
              -1031.635,
              -7698.523,
              38.429
            ],
            [
              -1034.149,
              -7695.138,
              42.646
            ],
            [
              -1034.672,
              -7688.449,
              49.355
            ],
            [
              -1028.056,
              -7678.549,
              61.262
            ],
            [
              -952.572,
              -7669.891,
              137.241
            ],
            [
              -687.301,
              -7633.495,
              404.997
            ],
            [
              -638.969,
              -7631.03,
              453.392
            ],
            [
              -621.692,
              -7636.909,
              471.641
            ],
            [
              -534.281,
              -7645.173,
              559.442
            ],
            [
              -532.873,
              -7638.519,
              566.244
            ],
            [
              -544.436,
              -7601.572,
              604.958
            ],
            [
              -545.781,
              -7569.264,
              637.294
            ],
            [
              -559.134,
              -7524.492,
              684.015
            ],
            [
              -592.861,
              -7431.482,
              782.951
            ],
            [
              -636.284,
              -7340.523,
              883.743
            ],
            [
              -707.406,
              -7214.553,
              1028.405
            ],
            [
              -684.153,
              -7210.52,
              1052.005
            ],
            [
              -567.625,
              -7175.894,
              1173.569
            ],
            [
              -492.955,
              -7141.624,
              1255.727
            ],
            [
              -472.94,
              -7138.647,
              1275.962
            ],
            [
              -433.975,
              -7120.429,
              1318.976
            ],
            [
              -356.786,
              -7053.923,
              1420.864
            ],
            [
              -147.918,
              -6864.018,
              1703.158
            ],
            [
              -119.568,
              -6827.798,
              1749.154
            ],
            [
              -100.778,
              -6821.461,
              1768.984
            ],
            [
              -58.991,
              -6789.938,
              1821.327
            ],
            [
              -47.763,
              -6774.558,
              1840.37
            ],
            [
              -41.021,
              -6757.982,
              1858.264
            ],
            [
              -44.133,
              -6716.735,
              1899.628
            ],
            [
              -50.829,
              -6695.462,
              1921.931
            ],
            [
              -48.526,
              -6639.841,
              1977.599
            ],
            [
              -52.099,
              -6588.567,
              2028.997
            ],
            [
              -70.555,
              -6505.85,
              2113.748
            ],
            [
              -125.166,
              -6286.66,
              2339.639
            ],
            [
              -158.525,
              -6137.991,
              2492.005
            ],
            [
              -182.398,
              -6069.649,
              2564.397
            ],
            [
              -186.217,
              -6031.729,
              2602.508
            ],
            [
              -210.448,
              -5912.171,
              2724.497
            ],
            [
              -214.688,
              -5861.998,
              2774.849
            ],
            [
              -215.425,
              -5796.303,
              2840.548
            ],
            [
              -210.007,
              -5746.306,
              2890.838
            ],
            [
              -195.772,
              -5671.978,
              2966.516
            ],
            [
              -200.158,
              -5665.219,
              2974.574
            ],
            [
              -245.834,
              -5662.161,
              3020.353
            ],
            [
              -275.515,
              -5664.961,
              3050.165
            ],
            [
              -299.862,
              -5657.84,
              3075.532
            ],
            [
              -394.957,
              -5644.98,
              3171.493
            ],
            [
              -428.258,
              -5634.356,
              3206.448
            ],
            [
              -633.019,
              -5523.775,
              3439.16
            ],
            [
              -663.705,
              -5510.974,
              3472.41
            ],
            [
              -740.836,
              -5466.163,
              3561.612
            ],
            [
              -765.768,
              -5455.693,
              3588.653
            ],
            [
              -877.432,
              -5396.902,
              3714.849
            ],
            [
              -884.394,
              -5390.097,
              3724.585
            ],
            [
              -886.769,
              -5378.922,
              3736.009
            ],
            [
              -880.613,
              -5358.995,
              3756.866
            ],
            [
              -871.52,
              -5283.459,
              3832.947
            ],
            [
              -867.295,
              -5263.497,
              3853.352
            ],
            [
              -873.84,
              -5126.451,
              3990.554
            ],
            [
              -873.198,
              -5090.839,
              4026.172
            ],
            [
              -867.363,
              -5053.094,
              4064.365
            ],
            [
              -847.141,
              -4967.74,
              4152.082
            ],
            [
              -716.635,
              -4519.236,
              4619.187
            ],
            [
              -646.915,
              -4511.591,
              4689.325
            ],
            [
              -568.48,
              -4520.803,
              4768.299
            ],
            [
              -439.606,
              -4519.799,
              4897.176
            ],
            [
              -373.187,
              -4516.551,
              4963.675
            ],
            [
              -303.365,
              -4503.347,
              5034.734
            ],
            [
              -273.394,
              -4484.966,
              5069.892
            ],
            [
              -264.839,
              -4475.102,
              5082.949
            ],
            [
              -248.495,
              -4462.041,
              5103.872
            ],
            [
              -208.316,
              -4413.789,
              5166.662
            ],
            [
              -185.328,
              -4389.716,
              5199.948
            ],
            [
              -166.99,
              -4373.351,
              5224.526
            ],
            [
              -153.302,
              -4364.694,
              5240.722
            ],
            [
              -100.827,
              -4348.95,
              5295.508
            ],
            [
              -72.426,
              -4346.128,
              5324.048
            ],
            [
              -23.455,
              -4345.907,
              5373.02
            ],
            [
              35.096,
              -4350.314,
              5431.737
            ],
            [
              46.147,
              -4344.95,
              5444.021
            ],
            [
              45.488,
              -4310.427,
              5478.55
            ],
            [
              49.82,
              -4284.902,
              5504.44
            ],
            [
              60.111,
              -4250.579,
              5540.273
            ],
            [
              104.143,
              -4062.131,
              5733.796
            ],
            [
              126.577,
              -3997.973,
              5801.764
            ],
            [
              148.043,
              -3951.609,
              5852.856
            ],
            [
              179.07,
              -3910.986,
              5903.973
            ],
            [
              264.038,
              -3810.121,
              6035.856
            ],
            [
              345.157,
              -3743.697,
              6140.701
            ],
            [
              383.579,
              -3686.512,
              6209.595
            ],
            [
              434.283,
              -3627.326,
              6287.53
            ],
            [
              450.253,
              -3599.787,
              6319.364
            ],
            [
              463.769,
              -3565.524,
              6356.197
            ],
            [
              474.065,
              -3531.203,
              6392.029
            ],
            [
              484.063,
              -3477.95,
              6446.212
            ],
            [
              489.712,
              -3345.578,
              6578.705
            ],
            [
              488.249,
              -3319.947,
              6604.378
            ],
            [
              479.687,
              -3259.675,
              6665.255
            ],
            [
              477.905,
              -3216.226,
              6708.741
            ],
            [
              481.339,
              -3169.533,
              6755.56
            ],
            [
              500.602,
              -3103.091,
              6824.737
            ],
            [
              500.428,
              -3077.483,
              6850.346
            ],
            [
              504.445,
              -3034.141,
              6893.874
            ],
            [
              503.491,
              -2980.688,
              6947.336
            ],
            [
              505.751,
              -2962.917,
              6965.249
            ],
            [
              502.159,
              -2912.756,
              7015.539
            ],
            [
              509.397,
              -2869.472,
              7059.424
            ],
            [
              513.301,
              -2797.183,
              7131.819
            ],
            [
              494.515,
              -2626.513,
              7303.519
            ],
            [
              482.722,
              -2601.805,
              7330.897
            ],
            [
              485.911,
              -2568.466,
              7364.388
            ],
            [
              462.343,
              -2342.047,
              7592.031
            ],
            [
              451.425,
              -2269.486,
              7665.409
            ],
            [
              407.176,
              -2116.162,
              7824.99
            ],
            [
              406.254,
              -2096.107,
              7845.066
            ],
            [
              361.405,
              -1904.922,
              8041.441
            ],
            [
              342.249,
              -1718.661,
              8228.685
            ],
            [
              510.658,
              -1710.612,
              8397.286
            ],
            [
              549.551,
              -1699.08,
              8437.852
            ],
            [
              585.119,
              -1693.053,
              8473.928
            ],
            [
              616.278,
              -1681.379,
              8507.202
            ],
            [
              646.312,
              -1660.778,
              8543.622
            ],
            [
              673.267,
              -1632.329,
              8582.812
            ],
            [
              699.977,
              -1617.234,
              8613.492
            ],
            [
              891.199,
              -1385.857,
              8913.661
            ],
            [
              926.904,
              -1337.532,
              8973.746
            ],
            [
              934.987,
              -1318.756,
              8994.188
            ],
            [
              959.848,
              -1299.175,
              9025.834
            ],
            [
              1019.189,
              -1227.908,
              9118.572
            ],
            [
              1188.158,
              -1016.171,
              9389.465
            ],
            [
              1209.421,
              -982.054,
              9429.667
            ],
            [
              1229.046,
              -966.831,
              9454.504
            ],
            [
              1246.923,
              -941.557,
              9485.461
            ],
            [
              1250.475,
              -923.811,
              9503.559
            ],
            [
              1249.57,
              -868.132,
              9559.245
            ],
            [
              1251.689,
              -858.152,
              9569.448
            ],
            [
              1263.58,
              -842.786,
              9588.877
            ],
            [
              1271.438,
              -836.252,
              9599.097
            ],
            [
              1287.032,
              -829.861,
              9615.95
            ],
            [
              1306.39,
              -829.106,
              9635.323
            ],
            [
              1381.451,
              -814.909,
              9711.714
            ],
            [
              1625.047,
              -649.1,
              10006.386
            ],
            [
              1633.071,
              -633.663,
              10023.784
            ],
            [
              1640.869,
              -630.468,
              10032.211
            ],
            [
              1650.286,
              -609.492,
              10055.204
            ],
            [
              1647.435,
              -589.4,
              10075.497
            ],
            [
              1649.076,
              -570.506,
              10094.463
            ],
            [
              1661.593,
              -556.266,
              10113.422
            ],
            [
              1707.61,
              -543.762,
              10161.107
            ],
            [
              1715.531,
              -533.89,
              10173.765
            ],
            [
              1739.19,
              -475.328,
              10236.925
            ],
            [
              1739.832,
              -440.829,
              10271.43
            ],
            [
              1737.688,
              -417.411,
              10294.946
            ],
            [
              1728.721,
              -379.394,
              10334.006
            ],
            [
              1714.349,
              -354.636,
              10362.634
            ],
            [
              1709.957,
              -313.364,
              10404.138
            ],
            [
              1701.073,
              -270.896,
              10447.526
            ],
            [
              1691.292,
              -207.259,
              10511.91
            ],
            [
              1692.553,
              -139.375,
              10579.806
            ],
            [
              1699.889,
              -91.641,
              10628.1
            ],
            [
              1722.281,
              -31.942,
              10691.86
            ],
            [
              1763.619,
              40.763,
              10775.496
            ],
            [
              1781.292,
              89.417,
              10827.26
            ],
            [
              1803.689,
              114.605,
              10860.966
            ],
            [
              1864.141,
              209.22,
              10973.243
            ],
            [
              1913.636,
              269.526,
              11051.261
            ],
            [
              1990.962,
              334.88,
              11152.504
            ],
            [
              2015.503,
              371.16,
              11196.305
            ],
            [
              2052.586,
              388.28,
              11237.15
            ],
            [
              2087.216,
              412.125,
              11279.195
            ],
            [
              2136.967,
              451.273,
              11342.501
            ],
            [
              2182.309,
              496.069,
              11406.24
            ],
            [
              2210.658,
              528.937,
              11449.645
            ],
            [
              2229.877,
              556.409,
              11483.172
            ],
            [
              2244.749,
              592.868,
              11522.547
            ],
            [
              2266.569,
              621.404,
              11558.47
            ],
            [
              2281.67,
              670.105,
              11609.458
            ],
            [
              2285.519,
              703.43,
              11643.005
            ],
            [
              2286.06,
              732.364,
              11671.944
            ],
            [
              2274.704,
              814.957,
              11755.314
            ],
            [
              2261.392,
              861.962,
              11804.168
            ],
            [
              2144.257,
              1048.95,
              12024.814
            ],
            [
              2116.361,
              1075.075,
              12063.034
            ],
            [
              2107.082,
              1096.4,
              12086.29
            ],
            [
              2088.256,
              1124.583,
              12120.182
            ],
            [
              2063.5,
              1146.196,
              12153.045
            ],
            [
              2049.437,
              1153.138,
              12168.728
            ],
            [
              2015.466,
              1164.904,
              12204.679
            ],
            [
              1965.977,
              1174.732,
              12255.135
            ],
            [
              1928.988,
              1197.686,
              12298.667
            ],
            [
              1911.304,
              1218.054,
              12325.64
            ],
            [
              1889.313,
              1249.634,
              12364.123
            ],
            [
              1817.42,
              1234.273,
              12437.639
            ],
            [
              1745.61,
              1223.362,
              12510.273
            ],
            [
              1634.607,
              1220.971,
              12621.302
            ],
            [
              1600.284,
              1213.815,
              12656.363
            ],
            [
              1535.192,
              1217.248,
              12721.545
            ],
            [
              1461.257,
              1230.864,
              12796.724
            ],
            [
              1250.055,
              1287.093,
              13015.282
            ],
            [
              1216.542,
              1288.825,
              13048.841
            ],
            [
              1174.911,
              1305.179,
              13093.568
            ],
            [
              1169.279,
              1454.457,
              13242.952
            ],
            [
              990.627,
              1492.26,
              13425.56
            ],
            [
              961.104,
              1500.597,
              13456.237
            ],
            [
              886.508,
              1548.725,
              13545.012
            ],
            [
              861.581,
              1561.429,
              13572.99
            ],
            [
              775.609,
              1587.5,
              13662.827
            ],
            [
              769.19,
              1624.355,
              13700.237
            ],
            [
              781.269,
              1649.737,
              13728.347
            ],
            [
              802.898,
              1738.399,
              13819.609
            ],
            [
              825.163,
              1791.425,
              13877.12
            ],
            [
              623.161,
              1858.587,
              14089.993
            ],
            [
              599.379,
              1863.475,
              14114.273
            ],
            [
              535.995,
              1890.241,
              14183.077
            ],
            [
              493.148,
              1911.064,
              14230.715
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7047",
              "position": {
                "x": -638.969,
                "z": -7631.03
              },
              "distanceAlongShapeM": 453.392,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8326",
              "position": {
                "x": -492.955,
                "z": -7141.624
              },
              "distanceAlongShapeM": 1255.727,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:8327",
              "position": {
                "x": -119.568,
                "z": -6827.798
              },
              "distanceAlongShapeM": 1749.154,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 1921.931,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 2564.397,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 3050.165,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 3472.41,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:348",
              "position": {
                "x": -871.52,
                "z": -5283.459
              },
              "distanceAlongShapeM": 3832.947,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5833",
              "position": {
                "x": -646.915,
                "z": -4511.591
              },
              "distanceAlongShapeM": 4689.325,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 5504.44,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 5852.856,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 6209.595,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 7015.539,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 7330.897,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 7824.99,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 8582.812,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6544",
              "position": {
                "x": 934.987,
                "z": -1318.756
              },
              "distanceAlongShapeM": 8994.188,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6546",
              "position": {
                "x": 1209.421,
                "z": -982.054
              },
              "distanceAlongShapeM": 9429.667,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 10362.634,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6568",
              "position": {
                "x": 1781.292,
                "z": 89.417
              },
              "distanceAlongShapeM": 10827.26,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 11196.305,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 11522.547,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5925",
              "position": {
                "x": 2116.361,
                "z": 1075.075
              },
              "distanceAlongShapeM": 12063.034,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:946",
              "position": {
                "x": 1600.284,
                "z": 1213.815
              },
              "distanceAlongShapeM": 12656.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5428",
              "position": {
                "x": 1216.542,
                "z": 1288.825
              },
              "distanceAlongShapeM": 13048.841,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6714",
              "position": {
                "x": 769.19,
                "z": 1624.355
              },
              "distanceAlongShapeM": 13700.237,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 14230.715,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            }
          ],
          "departuresSeconds": [
            18180,
            19980,
            21840,
            22860,
            24840,
            26820,
            28800,
            31980,
            34080,
            36180,
            38760,
            41040,
            43320,
            45420,
            47880,
            50340,
            52740,
            54540,
            56400,
            58320,
            60240,
            62340,
            66240,
            68100,
            70320,
            72900,
            75000,
            77100,
            79140,
            81180,
            83280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_35",
      "sourceRouteId": "vilnius_bus_35",
      "mode": "bus",
      "shortName": "35",
      "longName": "Žalgirio–Kalvarijų g.–Naujieji Verkiai–Ožkiniai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_35:0",
          "sourceRouteId": "vilnius_bus_35",
          "sourceShapeId": "vilnius_bus_35_a-b",
          "directionId": 0,
          "headsign": "Ožkiniai",
          "directionName": "Žalgirio–Kalvarijų g.–Naujieji Verkiai–Ožkiniai",
          "mode": "bus",
          "routeShortName": "35",
          "routeLongName": "Žalgirio–Kalvarijų g.–Naujieji Verkiai–Ožkiniai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              374.58,
              -1783.82,
              0
            ],
            [
              362.96,
              -1784.721,
              11.655
            ],
            [
              354.358,
              -1796.809,
              26.492
            ],
            [
              355.721,
              -1828.005,
              57.717
            ],
            [
              364.892,
              -1890.514,
              120.895
            ],
            [
              374.87,
              -1944.132,
              175.434
            ],
            [
              407.808,
              -2081.663,
              316.854
            ],
            [
              428.936,
              -2159.977,
              397.968
            ],
            [
              441.836,
              -2194.724,
              435.032
            ],
            [
              440.947,
              -2208.066,
              448.404
            ],
            [
              462.343,
              -2342.047,
              584.083
            ],
            [
              505.139,
              -2574.385,
              820.329
            ],
            [
              511.756,
              -2776.003,
              1022.056
            ],
            [
              513.301,
              -2797.183,
              1043.292
            ],
            [
              524.563,
              -2850.825,
              1098.104
            ],
            [
              524.913,
              -2902.04,
              1149.32
            ],
            [
              518.333,
              -3049.981,
              1297.407
            ],
            [
              517.855,
              -3111.2,
              1358.628
            ],
            [
              506.223,
              -3253.482,
              1501.385
            ],
            [
              511.316,
              -3256.915,
              1507.526
            ],
            [
              504.142,
              -3366.994,
              1617.839
            ],
            [
              489.873,
              -3512.567,
              1764.11
            ],
            [
              474.056,
              -3566.826,
              1820.627
            ],
            [
              441.104,
              -3641.923,
              1902.635
            ],
            [
              383.151,
              -3709.882,
              1991.949
            ],
            [
              303.678,
              -3791.921,
              2106.169
            ],
            [
              278.895,
              -3808.166,
              2135.803
            ],
            [
              228.358,
              -3858.451,
              2207.095
            ],
            [
              158.106,
              -3965.152,
              2334.846
            ],
            [
              127.093,
              -4040.286,
              2416.129
            ],
            [
              102.95,
              -4092.167,
              2473.353
            ],
            [
              79.561,
              -4208.631,
              2592.142
            ],
            [
              75.006,
              -4246.398,
              2630.183
            ],
            [
              72.804,
              -4296.453,
              2680.287
            ],
            [
              57.959,
              -4368.543,
              2753.889
            ],
            [
              54.707,
              -4440.844,
              2826.263
            ],
            [
              47.88,
              -4461.871,
              2848.371
            ],
            [
              42.119,
              -4495.164,
              2882.158
            ],
            [
              46.027,
              -4598.766,
              2985.834
            ],
            [
              43.323,
              -4641.02,
              3028.175
            ],
            [
              -32.111,
              -5068.242,
              3462.005
            ],
            [
              -36.204,
              -5116.037,
              3509.975
            ],
            [
              -42.927,
              -5131.5,
              3526.836
            ],
            [
              -75.729,
              -5270.057,
              3669.224
            ],
            [
              -95.037,
              -5339.84,
              3741.628
            ],
            [
              -105.993,
              -5410.888,
              3813.516
            ],
            [
              -116.661,
              -5430.732,
              3836.045
            ],
            [
              -144.967,
              -5534.861,
              3943.953
            ],
            [
              -183.275,
              -5657.733,
              4072.659
            ],
            [
              -188.212,
              -5716.645,
              4131.777
            ],
            [
              -185.377,
              -5737.848,
              4153.169
            ],
            [
              -196.91,
              -5769.923,
              4187.254
            ],
            [
              -201.665,
              -5818.819,
              4236.38
            ],
            [
              -201.086,
              -5857.793,
              4275.359
            ],
            [
              -195.599,
              -5910.215,
              4328.067
            ],
            [
              -136.015,
              -6175.138,
              4599.608
            ],
            [
              -122.378,
              -6204.331,
              4631.829
            ],
            [
              -123.468,
              -6228.802,
              4656.325
            ],
            [
              -113.557,
              -6285.758,
              4714.137
            ],
            [
              -58.166,
              -6532.794,
              4967.306
            ],
            [
              -46.468,
              -6597.576,
              5033.136
            ],
            [
              -39.377,
              -6667.839,
              5103.756
            ],
            [
              -35.045,
              -6748.072,
              5184.106
            ],
            [
              -27.041,
              -6768.256,
              5205.819
            ],
            [
              -16.965,
              -6780.686,
              5221.82
            ],
            [
              0.233,
              -6791.019,
              5241.884
            ],
            [
              320.415,
              -6959.406,
              5603.644
            ],
            [
              487.772,
              -7068.233,
              5803.273
            ],
            [
              568.725,
              -7113.137,
              5895.846
            ],
            [
              607.827,
              -7122.761,
              5936.115
            ],
            [
              857.011,
              -7088.385,
              6187.659
            ],
            [
              911.972,
              -7076.04,
              6243.989
            ],
            [
              964.173,
              -7073.664,
              6296.245
            ],
            [
              999.31,
              -7088.785,
              6334.497
            ],
            [
              1056.317,
              -7139.934,
              6411.087
            ],
            [
              1073.183,
              -7168.077,
              6443.897
            ],
            [
              1095.862,
              -7195.215,
              6479.263
            ],
            [
              1133.283,
              -7225.965,
              6527.698
            ],
            [
              1291.476,
              -7341.333,
              6723.491
            ],
            [
              1307.902,
              -7358.336,
              6747.132
            ],
            [
              1326.737,
              -7384.29,
              6779.201
            ],
            [
              1553.349,
              -7767.005,
              7223.974
            ],
            [
              1621.327,
              -7885.162,
              7360.29
            ],
            [
              1632.975,
              -7916.55,
              7393.77
            ],
            [
              1640.555,
              -7958.994,
              7436.886
            ],
            [
              1640.017,
              -8022.44,
              7500.334
            ],
            [
              1642.406,
              -8067.015,
              7544.973
            ],
            [
              1655.237,
              -8103.991,
              7584.112
            ],
            [
              1677.887,
              -8132.245,
              7620.324
            ],
            [
              1694.973,
              -8148.149,
              7643.666
            ],
            [
              1731.324,
              -8201.149,
              7707.934
            ],
            [
              1750.194,
              -8224.879,
              7738.253
            ],
            [
              1771.12,
              -8241.968,
              7765.27
            ],
            [
              1800.494,
              -8254.762,
              7797.309
            ],
            [
              1956.145,
              -8296.632,
              7958.494
            ],
            [
              2001.461,
              -8317.518,
              8008.391
            ],
            [
              2065.812,
              -8353.233,
              8081.988
            ],
            [
              2107.826,
              -8378.511,
              8131.021
            ],
            [
              2156.129,
              -8411.7,
              8189.627
            ],
            [
              2317.488,
              -8560.563,
              8409.165
            ],
            [
              2642.21,
              -8852.78,
              8846.011
            ],
            [
              2792.271,
              -8984.749,
              9045.847
            ],
            [
              2937.196,
              -9115.513,
              9241.046
            ],
            [
              2992.31,
              -9162.2,
              9313.276
            ],
            [
              3013.269,
              -9177.069,
              9338.973
            ],
            [
              3028.932,
              -9199.631,
              9366.439
            ],
            [
              3134.577,
              -9330.771,
              9534.839
            ],
            [
              3236.064,
              -9273.693,
              9651.276
            ],
            [
              3253.13,
              -9256.204,
              9675.712
            ],
            [
              3308.92,
              -9131.464,
              9812.36
            ],
            [
              3319.964,
              -9126.108,
              9824.634
            ],
            [
              3332.231,
              -9124.114,
              9837.062
            ],
            [
              3357.176,
              -9132.381,
              9863.342
            ],
            [
              3379.116,
              -9129.458,
              9885.475
            ],
            [
              3431.482,
              -9015.787,
              10010.628
            ],
            [
              3480.938,
              -8919.873,
              10118.542
            ],
            [
              3562.117,
              -8814.544,
              10251.523
            ],
            [
              3591.518,
              -8791.726,
              10288.74
            ],
            [
              3664.561,
              -8741.908,
              10377.156
            ],
            [
              3699.345,
              -8706.946,
              10426.473
            ],
            [
              3684.368,
              -8682.169,
              10455.425
            ],
            [
              3678.273,
              -8664.24,
              10474.361
            ],
            [
              3654.394,
              -8633.726,
              10513.108
            ],
            [
              3621.201,
              -8585.223,
              10571.881
            ],
            [
              3606.987,
              -8520.382,
              10638.262
            ],
            [
              3594.209,
              -8447.776,
              10711.984
            ],
            [
              3584.654,
              -8408.629,
              10752.279
            ],
            [
              3573.643,
              -8378.361,
              10784.488
            ],
            [
              3571.967,
              -8364.97,
              10797.984
            ],
            [
              3567.073,
              -8351.518,
              10812.299
            ],
            [
              3552.201,
              -8321.176,
              10846.089
            ],
            [
              3359.047,
              -8051.431,
              11177.859
            ],
            [
              3339.583,
              -8025.456,
              11210.317
            ],
            [
              3325.551,
              -8018.51,
              11225.974
            ],
            [
              3324.433,
              -8009.582,
              11234.971
            ],
            [
              3330.31,
              -8005.241,
              11242.278
            ],
            [
              3336.682,
              -8008.702,
              11249.529
            ],
            [
              3345.354,
              -8026.679,
              11269.488
            ],
            [
              3573.636,
              -8344.963,
              11661.174
            ],
            [
              3579.711,
              -8364.004,
              11681.161
            ],
            [
              3610.551,
              -8536.036,
              11855.935
            ],
            [
              3620.105,
              -8575.182,
              11896.23
            ],
            [
              3634.976,
              -8605.524,
              11930.021
            ],
            [
              3682.65,
              -8671.003,
              12011.016
            ],
            [
              3689.389,
              -8688.944,
              12030.181
            ],
            [
              3699.345,
              -8706.946,
              12050.753
            ],
            [
              3741.483,
              -8657.653,
              12115.602
            ],
            [
              3791.647,
              -8626.326,
              12174.745
            ],
            [
              3858.564,
              -8594.206,
              12248.971
            ],
            [
              3887.776,
              -8581.405,
              12280.865
            ],
            [
              3917.526,
              -8574.181,
              12311.479
            ],
            [
              3985.821,
              -8571.035,
              12379.847
            ],
            [
              4016.172,
              -8566.049,
              12410.604
            ],
            [
              4061.23,
              -8499.002,
              12491.385
            ],
            [
              4079.696,
              -8475.977,
              12520.9
            ],
            [
              4100.028,
              -8456.328,
              12549.176
            ],
            [
              4149.92,
              -8439.472,
              12601.838
            ],
            [
              4184.09,
              -8436.788,
              12636.113
            ],
            [
              4222.829,
              -8430.851,
              12675.304
            ],
            [
              4242.992,
              -8420.106,
              12698.152
            ],
            [
              4256.484,
              -8421.478,
              12711.714
            ],
            [
              4281.731,
              -8414.17,
              12737.997
            ],
            [
              4307.127,
              -8399.072,
              12767.542
            ],
            [
              4316.521,
              -8379.213,
              12789.511
            ],
            [
              4323.75,
              -8371.559,
              12800.039
            ],
            [
              4352.772,
              -8368.777,
              12829.194
            ],
            [
              4394.858,
              -8356.227,
              12873.111
            ],
            [
              4421.907,
              -8355.634,
              12900.167
            ],
            [
              4447.456,
              -8366.145,
              12927.793
            ],
            [
              4495.27,
              -8390.444,
              12981.428
            ],
            [
              4552.908,
              -8406.026,
              13041.135
            ],
            [
              4580.193,
              -8426.591,
              13075.302
            ],
            [
              4609.923,
              -8453.883,
              13115.66
            ],
            [
              4628.178,
              -8475.387,
              13143.867
            ],
            [
              4655.998,
              -8501.529,
              13182.043
            ],
            [
              4667.259,
              -8518.445,
              13202.364
            ],
            [
              4715.091,
              -8575.032,
              13276.459
            ],
            [
              4821.282,
              -8709.564,
              13447.851
            ],
            [
              4857.98,
              -8742.558,
              13497.2
            ],
            [
              4880.2,
              -8758.574,
              13524.59
            ],
            [
              4910.764,
              -8775.864,
              13559.706
            ],
            [
              5190.316,
              -8865.891,
              13853.397
            ],
            [
              5211.507,
              -8868.529,
              13874.751
            ],
            [
              5231.173,
              -8883.383,
              13899.397
            ],
            [
              5278.399,
              -8904.339,
              13951.064
            ],
            [
              5409.439,
              -8951.419,
              14090.305
            ],
            [
              5530.182,
              -8998.301,
              14219.83
            ],
            [
              5548.003,
              -9008.668,
              14240.447
            ],
            [
              5547.165,
              -9018.671,
              14250.485
            ],
            [
              5543.904,
              -9020.834,
              14254.398
            ],
            [
              5531.636,
              -9022.822,
              14266.827
            ],
            [
              5529.105,
              -9020.546,
              14270.23
            ],
            [
              5527.927,
              -9014.957,
              14275.942
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6788",
              "position": {
                "x": 374.58,
                "z": -1783.82
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 435.032,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 820.329,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 1507.526,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 2106.169,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 2416.129,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6487",
              "position": {
                "x": 54.707,
                "z": -4440.844
              },
              "distanceAlongShapeM": 2826.263,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6488",
              "position": {
                "x": -36.204,
                "z": -5116.037
              },
              "distanceAlongShapeM": 3509.975,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6491",
              "position": {
                "x": -105.993,
                "z": -5410.888
              },
              "distanceAlongShapeM": 3813.516,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 4153.169,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 4631.829,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:16627",
              "position": {
                "x": 320.415,
                "z": -6959.406
              },
              "distanceAlongShapeM": 5603.644,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6797",
              "position": {
                "x": 1056.317,
                "z": -7139.934
              },
              "distanceAlongShapeM": 6411.087,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6800",
              "position": {
                "x": 1694.973,
                "z": -8148.149
              },
              "distanceAlongShapeM": 7643.666,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6803",
              "position": {
                "x": 3013.269,
                "z": -9177.069
              },
              "distanceAlongShapeM": 9338.973,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6808",
              "position": {
                "x": 3308.92,
                "z": -9131.464
              },
              "distanceAlongShapeM": 9812.36,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6810",
              "position": {
                "x": 3562.117,
                "z": -8814.544
              },
              "distanceAlongShapeM": 10251.523,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6814",
              "position": {
                "x": 3573.643,
                "z": -8378.361
              },
              "distanceAlongShapeM": 10784.488,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:738",
              "position": {
                "x": 3339.773,
                "z": -8015.44
              },
              "distanceAlongShapeM": 11256.941,
              "shapeOffsetM": 0.144,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:1064",
              "position": {
                "x": 3556.685,
                "z": -8322.375
              },
              "distanceAlongShapeM": 11632.939,
              "shapeOffsetM": 0.61,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6816",
              "position": {
                "x": 4242.992,
                "z": -8420.106
              },
              "distanceAlongShapeM": 12698.152,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6818",
              "position": {
                "x": 4655.998,
                "z": -8501.529
              },
              "distanceAlongShapeM": 13182.043,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6820",
              "position": {
                "x": 5211.507,
                "z": -8868.529
              },
              "distanceAlongShapeM": 13874.751,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:1144",
              "position": {
                "x": 5527.927,
                "z": -9014.957
              },
              "distanceAlongShapeM": 14275.942,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            43920,
            46620,
            49080,
            51480,
            52860,
            54660,
            56520,
            58380,
            60480,
            62460,
            64440,
            68040,
            71940,
            74280,
            76620,
            78960,
            81300
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_35:1",
          "sourceRouteId": "vilnius_bus_35",
          "sourceShapeId": "vilnius_bus_35_b2-a1",
          "directionId": 1,
          "headsign": "Žalgirio g.",
          "directionName": "Ožkiniai–Žalgirio g.",
          "mode": "bus",
          "routeShortName": "35",
          "routeLongName": "Žalgirio–Kalvarijų g.–Naujieji Verkiai–Ožkiniai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5527.927,
              -9014.957,
              0
            ],
            [
              5522.158,
              -9013.731,
              5.898
            ],
            [
              5505.197,
              -8992.248,
              33.269
            ],
            [
              5326.247,
              -8926.422,
              223.942
            ],
            [
              5181.908,
              -8867.954,
              379.673
            ],
            [
              5168.309,
              -8872.143,
              393.903
            ],
            [
              5160.588,
              -8871.993,
              401.626
            ],
            [
              5075.764,
              -8831.384,
              495.67
            ],
            [
              5012.471,
              -8809.005,
              562.802
            ],
            [
              4968.931,
              -8797.029,
              607.959
            ],
            [
              4931.204,
              -8784.053,
              647.856
            ],
            [
              4880.2,
              -8758.574,
              704.869
            ],
            [
              4856.05,
              -8742.521,
              733.868
            ],
            [
              4825.057,
              -8714.09,
              775.926
            ],
            [
              4777.893,
              -8656.401,
              850.441
            ],
            [
              4728.926,
              -8591.999,
              931.345
            ],
            [
              4682.36,
              -8536.549,
              1003.754
            ],
            [
              4628.135,
              -8477.613,
              1083.84
            ],
            [
              4600.957,
              -8451.483,
              1121.541
            ],
            [
              4583.775,
              -8441.133,
              1141.6
            ],
            [
              4567.43,
              -8420.779,
              1167.704
            ],
            [
              4545.829,
              -8405.89,
              1193.939
            ],
            [
              4510.007,
              -8394.067,
              1231.663
            ],
            [
              4491.387,
              -8391.482,
              1250.46
            ],
            [
              4467.148,
              -8379.883,
              1277.332
            ],
            [
              4440.42,
              -8363.783,
              1308.535
            ],
            [
              4421.264,
              -8355.621,
              1329.357
            ],
            [
              4405.819,
              -8355.324,
              1344.804
            ],
            [
              4381.945,
              -8358.205,
              1368.852
            ],
            [
              4345.651,
              -8370.867,
              1407.291
            ],
            [
              4326.946,
              -8372.734,
              1426.089
            ],
            [
              4315.856,
              -8380.314,
              1439.522
            ],
            [
              4307.749,
              -8400.197,
              1460.994
            ],
            [
              4285.57,
              -8415.357,
              1487.859
            ],
            [
              4240.89,
              -8428.971,
              1534.568
            ],
            [
              4220.749,
              -8438.604,
              1556.894
            ],
            [
              4195.673,
              -8437.01,
              1582.02
            ],
            [
              4153.116,
              -8440.647,
              1624.732
            ],
            [
              4135.013,
              -8444.753,
              1643.296
            ],
            [
              4115.601,
              -8449.947,
              1663.391
            ],
            [
              4092.822,
              -8462.87,
              1689.58
            ],
            [
              4075.728,
              -8481.468,
              1714.84
            ],
            [
              4050.55,
              -8518.837,
              1759.9
            ],
            [
              4035.882,
              -8545.275,
              1790.134
            ],
            [
              4021.341,
              -8565.035,
              1814.668
            ],
            [
              4007.035,
              -8572.554,
              1830.83
            ],
            [
              3907.209,
              -8575.097,
              1930.688
            ],
            [
              3890.393,
              -8579.229,
              1948.004
            ],
            [
              3862.489,
              -8590.941,
              1978.267
            ],
            [
              3753.964,
              -8644.532,
              2099.303
            ],
            [
              3744.679,
              -8658.827,
              2116.349
            ],
            [
              3728.98,
              -8671.887,
              2136.769
            ],
            [
              3679.595,
              -8729.948,
              2212.993
            ],
            [
              3635.803,
              -8764.738,
              2268.922
            ],
            [
              3590.167,
              -8795.04,
              2323.702
            ],
            [
              3553.349,
              -8835.53,
              2378.428
            ],
            [
              3548.675,
              -8844.347,
              2388.407
            ],
            [
              3495.433,
              -8902.337,
              2467.132
            ],
            [
              3482.225,
              -8919.898,
              2489.106
            ],
            [
              3437.527,
              -9002.543,
              2583.064
            ],
            [
              3395.857,
              -9095.265,
              2684.719
            ],
            [
              3390.888,
              -9119.662,
              2709.618
            ],
            [
              3387.544,
              -9126.278,
              2717.031
            ],
            [
              3382.955,
              -9130.644,
              2723.364
            ],
            [
              3367.386,
              -9137.028,
              2740.191
            ],
            [
              3346.691,
              -9142.201,
              2761.523
            ],
            [
              3334.467,
              -9141.969,
              2773.75
            ],
            [
              3285.429,
              -9182.228,
              2837.197
            ],
            [
              3263.784,
              -9237.481,
              2896.538
            ],
            [
              3255.081,
              -9255.128,
              2916.214
            ],
            [
              3242.519,
              -9272.702,
              2937.816
            ],
            [
              3134.577,
              -9330.771,
              3060.387
            ],
            [
              3021.317,
              -9193.92,
              3238.027
            ],
            [
              2970.687,
              -9148.431,
              3306.091
            ],
            [
              2953.441,
              -9141.425,
              3324.705
            ],
            [
              2944.749,
              -9124.562,
              3343.677
            ],
            [
              2590.264,
              -8808.384,
              3818.68
            ],
            [
              2140.228,
              -8401.383,
              4425.46
            ],
            [
              2107.826,
              -8378.511,
              4465.122
            ],
            [
              1978.502,
              -8305.956,
              4613.408
            ],
            [
              1955.502,
              -8296.62,
              4638.231
            ],
            [
              1918.925,
              -8290.37,
              4675.338
            ],
            [
              1793.436,
              -8253.517,
              4806.126
            ],
            [
              1773.051,
              -8242.004,
              4829.538
            ],
            [
              1750.194,
              -8224.879,
              4858.098
            ],
            [
              1684.136,
              -8142.38,
              4963.785
            ],
            [
              1655.922,
              -8101.778,
              5013.228
            ],
            [
              1643.486,
              -8078.168,
              5039.913
            ],
            [
              1639.977,
              -8059.177,
              5059.225
            ],
            [
              1639.433,
              -7950.068,
              5168.336
            ],
            [
              1629.362,
              -7903.123,
              5216.348
            ],
            [
              1545.21,
              -7754.608,
              5387.048
            ],
            [
              1341.067,
              -7410.16,
              5787.446
            ],
            [
              1312.907,
              -7366.221,
              5839.634
            ],
            [
              1291.476,
              -7341.333,
              5872.478
            ],
            [
              1145.93,
              -7238.444,
              6050.719
            ],
            [
              1102.154,
              -7203.124,
              6106.967
            ],
            [
              1045.977,
              -7141.97,
              6190.008
            ],
            [
              1026.954,
              -7126.033,
              6214.824
            ],
            [
              999.31,
              -7088.785,
              6261.21
            ],
            [
              951.943,
              -7073.438,
              6311.001
            ],
            [
              652.324,
              -7119.127,
              6614.084
            ],
            [
              622.009,
              -7121.909,
              6644.526
            ],
            [
              600.767,
              -7121.518,
              6665.772
            ],
            [
              577.696,
              -7115.528,
              6689.607
            ],
            [
              488.416,
              -7068.245,
              6790.635
            ],
            [
              60.82,
              -6823.295,
              7283.422
            ],
            [
              14.911,
              -6833.59,
              7330.47
            ],
            [
              -2.815,
              -6852.191,
              7356.165
            ],
            [
              -13.86,
              -6857.556,
              7368.444
            ],
            [
              -37.095,
              -6860.472,
              7391.862
            ],
            [
              -47.374,
              -6859.171,
              7402.223
            ],
            [
              -59.463,
              -6851.158,
              7416.726
            ],
            [
              -67.548,
              -6835.425,
              7434.415
            ],
            [
              -70.502,
              -6820.899,
              7449.238
            ],
            [
              -67.684,
              -6807.592,
              7462.841
            ],
            [
              -64.262,
              -6796.522,
              7474.428
            ],
            [
              -53.78,
              -6786.694,
              7488.797
            ],
            [
              -43.196,
              -6771.301,
              7507.477
            ],
            [
              -35.045,
              -6748.072,
              7532.095
            ],
            [
              -43.266,
              -6704.505,
              7576.431
            ],
            [
              -50.829,
              -6695.462,
              7588.22
            ],
            [
              -48.526,
              -6639.841,
              7643.888
            ],
            [
              -52.099,
              -6588.567,
              7695.286
            ],
            [
              -70.555,
              -6505.85,
              7780.037
            ],
            [
              -125.166,
              -6286.66,
              8005.928
            ],
            [
              -158.525,
              -6137.991,
              8158.294
            ],
            [
              -182.398,
              -6069.649,
              8230.686
            ],
            [
              -186.217,
              -6031.729,
              8268.797
            ],
            [
              -210.448,
              -5912.171,
              8390.786
            ],
            [
              -214.769,
              -5866.45,
              8436.711
            ],
            [
              -215.425,
              -5796.303,
              8506.86
            ],
            [
              -201.911,
              -5690.791,
              8613.234
            ],
            [
              -179.043,
              -5602.148,
              8704.78
            ],
            [
              -176.685,
              -5578.813,
              8728.234
            ],
            [
              -152.289,
              -5512.463,
              8798.927
            ],
            [
              -104.595,
              -5334.099,
              8983.557
            ],
            [
              -97,
              -5270.783,
              9047.327
            ],
            [
              -83.553,
              -5239.857,
              9081.05
            ],
            [
              -60.518,
              -5142.312,
              9181.279
            ],
            [
              -44.586,
              -5045.75,
              9279.146
            ],
            [
              -41.097,
              -4995.718,
              9329.3
            ],
            [
              -29.601,
              -4965.87,
              9361.285
            ],
            [
              29.378,
              -4628.52,
              9703.751
            ],
            [
              28.501,
              -4570.615,
              9761.663
            ],
            [
              22.071,
              -4499.251,
              9833.316
            ],
            [
              25.378,
              -4459.234,
              9873.469
            ],
            [
              38.073,
              -4363.727,
              9969.816
            ],
            [
              46.147,
              -4344.95,
              9990.256
            ],
            [
              45.488,
              -4310.427,
              10024.785
            ],
            [
              49.82,
              -4284.902,
              10050.675
            ],
            [
              60.111,
              -4250.579,
              10086.508
            ],
            [
              104.143,
              -4062.131,
              10280.031
            ],
            [
              126.577,
              -3997.973,
              10347.999
            ],
            [
              148.043,
              -3951.609,
              10399.091
            ],
            [
              179.07,
              -3910.986,
              10450.208
            ],
            [
              264.038,
              -3810.121,
              10582.091
            ],
            [
              345.157,
              -3743.697,
              10686.936
            ],
            [
              383.579,
              -3686.512,
              10755.83
            ],
            [
              434.283,
              -3627.326,
              10833.765
            ],
            [
              450.253,
              -3599.787,
              10865.599
            ],
            [
              463.769,
              -3565.524,
              10902.432
            ],
            [
              474.065,
              -3531.203,
              10938.264
            ],
            [
              484.063,
              -3477.95,
              10992.447
            ],
            [
              489.712,
              -3345.578,
              11124.94
            ],
            [
              488.249,
              -3319.947,
              11150.613
            ],
            [
              479.687,
              -3259.675,
              11211.49
            ],
            [
              477.905,
              -3216.226,
              11254.976
            ],
            [
              481.339,
              -3169.533,
              11301.795
            ],
            [
              500.602,
              -3103.091,
              11370.972
            ],
            [
              500.428,
              -3077.483,
              11396.581
            ],
            [
              504.445,
              -3034.141,
              11440.109
            ],
            [
              503.491,
              -2980.688,
              11493.571
            ],
            [
              505.751,
              -2962.917,
              11511.484
            ],
            [
              502.159,
              -2912.756,
              11561.774
            ],
            [
              509.397,
              -2869.472,
              11605.659
            ],
            [
              513.301,
              -2797.183,
              11678.054
            ],
            [
              494.515,
              -2626.513,
              11849.755
            ],
            [
              482.722,
              -2601.805,
              11877.132
            ],
            [
              485.911,
              -2568.466,
              11910.623
            ],
            [
              462.343,
              -2342.047,
              12138.266
            ],
            [
              451.425,
              -2269.486,
              12211.644
            ],
            [
              407.176,
              -2116.162,
              12371.225
            ],
            [
              406.254,
              -2096.107,
              12391.301
            ],
            [
              361.405,
              -1904.922,
              12587.676
            ],
            [
              342.249,
              -1718.661,
              12774.92
            ],
            [
              384.201,
              -1716.089,
              12816.95
            ],
            [
              395.76,
              -1718.527,
              12828.764
            ],
            [
              397.612,
              -1723.014,
              12833.618
            ],
            [
              399.396,
              -1766.463,
              12877.103
            ],
            [
              397.923,
              -1776.455,
              12887.203
            ],
            [
              394.599,
              -1781.96,
              12893.634
            ],
            [
              371.982,
              -1784.886,
              12916.44
            ],
            [
              374.58,
              -1783.82,
              12919.248
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1144",
              "position": {
                "x": 5527.927,
                "z": -9014.957
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6821",
              "position": {
                "x": 5122.326,
                "z": -8853.439
              },
              "distanceAlongShapeM": 444.149,
              "shapeOffsetM": 0.214,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6819",
              "position": {
                "x": 4583.775,
                "z": -8441.133
              },
              "distanceAlongShapeM": 1141.6,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6817",
              "position": {
                "x": 4220.749,
                "z": -8438.604
              },
              "distanceAlongShapeM": 1556.894,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6811",
              "position": {
                "x": 3548.675,
                "z": -8844.347
              },
              "distanceAlongShapeM": 2388.407,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6809",
              "position": {
                "x": 3346.691,
                "z": -9142.201
              },
              "distanceAlongShapeM": 2761.523,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6804",
              "position": {
                "x": 2953.441,
                "z": -9141.425
              },
              "distanceAlongShapeM": 3324.705,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6801",
              "position": {
                "x": 1918.925,
                "z": -8290.37
              },
              "distanceAlongShapeM": 4675.338,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6798",
              "position": {
                "x": 1026.954,
                "z": -7126.033
              },
              "distanceAlongShapeM": 6214.824,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:16628",
              "position": {
                "x": 229.7,
                "z": -6919.895
              },
              "distanceAlongShapeM": 7088.866,
              "shapeOffsetM": 0.125,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 7588.22,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 8230.686,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6494",
              "position": {
                "x": -176.685,
                "z": -5578.813
              },
              "distanceAlongShapeM": 8728.234,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6492",
              "position": {
                "x": -97,
                "z": -5270.783
              },
              "distanceAlongShapeM": 9047.327,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6489",
              "position": {
                "x": -41.097,
                "z": -4995.718
              },
              "distanceAlongShapeM": 9329.3,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 10050.675,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 10399.091,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 10755.83,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 11561.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 11877.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 12371.225,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6788",
              "position": {
                "x": 374.58,
                "z": -1783.82
              },
              "distanceAlongShapeM": 12919.248,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            46440,
            49260,
            52080,
            53940,
            55800,
            57600,
            59400,
            61200,
            63240,
            65280,
            67320,
            70620,
            74340,
            76620,
            78960,
            81300,
            83640
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_36",
      "sourceRouteId": "vilnius_bus_36",
      "mode": "bus",
      "shortName": "36",
      "longName": "Žalgirio–Kalvarijų g.–Balsiai–Naujaneriai–Pagubė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_36:0",
          "sourceRouteId": "vilnius_bus_36",
          "sourceShapeId": "vilnius_bus_36_a-b",
          "directionId": 0,
          "headsign": "Pagubė",
          "directionName": "Žalgirio–Kalvarijų g.–Balsiai–Naujaneriai–Pagubė",
          "mode": "bus",
          "routeShortName": "36",
          "routeLongName": "Žalgirio–Kalvarijų g.–Balsiai–Naujaneriai–Pagubė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              374.58,
              -1783.82,
              0
            ],
            [
              362.96,
              -1784.721,
              11.655
            ],
            [
              354.358,
              -1796.809,
              26.492
            ],
            [
              355.721,
              -1828.005,
              57.717
            ],
            [
              364.892,
              -1890.514,
              120.895
            ],
            [
              374.87,
              -1944.132,
              175.434
            ],
            [
              407.808,
              -2081.663,
              316.854
            ],
            [
              428.936,
              -2159.977,
              397.968
            ],
            [
              441.836,
              -2194.724,
              435.032
            ],
            [
              440.947,
              -2208.066,
              448.404
            ],
            [
              462.343,
              -2342.047,
              584.083
            ],
            [
              505.139,
              -2574.385,
              820.329
            ],
            [
              511.756,
              -2776.003,
              1022.056
            ],
            [
              513.301,
              -2797.183,
              1043.292
            ],
            [
              524.563,
              -2850.825,
              1098.104
            ],
            [
              524.913,
              -2902.04,
              1149.32
            ],
            [
              518.333,
              -3049.981,
              1297.407
            ],
            [
              517.855,
              -3111.2,
              1358.628
            ],
            [
              506.223,
              -3253.482,
              1501.385
            ],
            [
              511.316,
              -3256.915,
              1507.526
            ],
            [
              504.142,
              -3366.994,
              1617.839
            ],
            [
              489.873,
              -3512.567,
              1764.11
            ],
            [
              474.056,
              -3566.826,
              1820.627
            ],
            [
              441.104,
              -3641.923,
              1902.635
            ],
            [
              383.151,
              -3709.882,
              1991.949
            ],
            [
              303.678,
              -3791.921,
              2106.169
            ],
            [
              278.895,
              -3808.166,
              2135.803
            ],
            [
              228.358,
              -3858.451,
              2207.095
            ],
            [
              158.106,
              -3965.152,
              2334.846
            ],
            [
              127.093,
              -4040.286,
              2416.129
            ],
            [
              102.95,
              -4092.167,
              2473.353
            ],
            [
              79.561,
              -4208.631,
              2592.142
            ],
            [
              75.006,
              -4246.398,
              2630.183
            ],
            [
              72.804,
              -4296.453,
              2680.287
            ],
            [
              57.959,
              -4368.543,
              2753.889
            ],
            [
              54.707,
              -4440.844,
              2826.263
            ],
            [
              47.88,
              -4461.871,
              2848.371
            ],
            [
              42.119,
              -4495.164,
              2882.158
            ],
            [
              46.027,
              -4598.766,
              2985.834
            ],
            [
              43.323,
              -4641.02,
              3028.175
            ],
            [
              -32.111,
              -5068.242,
              3462.005
            ],
            [
              -36.204,
              -5116.037,
              3509.975
            ],
            [
              -42.927,
              -5131.5,
              3526.836
            ],
            [
              -75.729,
              -5270.057,
              3669.224
            ],
            [
              -95.037,
              -5339.84,
              3741.628
            ],
            [
              -105.993,
              -5410.888,
              3813.516
            ],
            [
              -116.661,
              -5430.732,
              3836.045
            ],
            [
              -144.967,
              -5534.861,
              3943.953
            ],
            [
              -183.275,
              -5657.733,
              4072.659
            ],
            [
              -188.212,
              -5716.645,
              4131.777
            ],
            [
              -185.377,
              -5737.848,
              4153.169
            ],
            [
              -196.91,
              -5769.923,
              4187.254
            ],
            [
              -201.665,
              -5818.819,
              4236.38
            ],
            [
              -201.086,
              -5857.793,
              4275.359
            ],
            [
              -195.599,
              -5910.215,
              4328.067
            ],
            [
              -136.015,
              -6175.138,
              4599.608
            ],
            [
              -122.378,
              -6204.331,
              4631.829
            ],
            [
              -123.468,
              -6228.802,
              4656.325
            ],
            [
              -113.557,
              -6285.758,
              4714.137
            ],
            [
              -58.166,
              -6532.794,
              4967.306
            ],
            [
              -46.468,
              -6597.576,
              5033.136
            ],
            [
              -39.377,
              -6667.839,
              5103.756
            ],
            [
              -35.045,
              -6748.072,
              5184.106
            ],
            [
              -27.041,
              -6768.256,
              5205.819
            ],
            [
              -16.965,
              -6780.686,
              5221.82
            ],
            [
              0.233,
              -6791.019,
              5241.884
            ],
            [
              320.415,
              -6959.406,
              5603.644
            ],
            [
              487.772,
              -7068.233,
              5803.273
            ],
            [
              568.725,
              -7113.137,
              5895.846
            ],
            [
              607.827,
              -7122.761,
              5936.115
            ],
            [
              857.011,
              -7088.385,
              6187.659
            ],
            [
              911.972,
              -7076.04,
              6243.989
            ],
            [
              964.173,
              -7073.664,
              6296.245
            ],
            [
              999.31,
              -7088.785,
              6334.497
            ],
            [
              1056.317,
              -7139.934,
              6411.087
            ],
            [
              1073.183,
              -7168.077,
              6443.897
            ],
            [
              1095.862,
              -7195.215,
              6479.263
            ],
            [
              1133.283,
              -7225.965,
              6527.698
            ],
            [
              1291.476,
              -7341.333,
              6723.491
            ],
            [
              1307.902,
              -7358.336,
              6747.132
            ],
            [
              1326.737,
              -7384.29,
              6779.201
            ],
            [
              1553.349,
              -7767.005,
              7223.974
            ],
            [
              1621.327,
              -7885.162,
              7360.29
            ],
            [
              1632.975,
              -7916.55,
              7393.77
            ],
            [
              1640.555,
              -7958.994,
              7436.886
            ],
            [
              1640.017,
              -8022.44,
              7500.334
            ],
            [
              1642.406,
              -8067.015,
              7544.973
            ],
            [
              1655.237,
              -8103.991,
              7584.112
            ],
            [
              1677.887,
              -8132.245,
              7620.324
            ],
            [
              1694.973,
              -8148.149,
              7643.666
            ],
            [
              1731.324,
              -8201.149,
              7707.934
            ],
            [
              1750.194,
              -8224.879,
              7738.253
            ],
            [
              1771.12,
              -8241.968,
              7765.27
            ],
            [
              1800.494,
              -8254.762,
              7797.309
            ],
            [
              1956.145,
              -8296.632,
              7958.494
            ],
            [
              2001.461,
              -8317.518,
              8008.391
            ],
            [
              2065.812,
              -8353.233,
              8081.988
            ],
            [
              2107.826,
              -8378.511,
              8131.021
            ],
            [
              2156.129,
              -8411.7,
              8189.627
            ],
            [
              2317.488,
              -8560.563,
              8409.165
            ],
            [
              2642.21,
              -8852.78,
              8846.011
            ],
            [
              2792.271,
              -8984.749,
              9045.847
            ],
            [
              2937.196,
              -9115.513,
              9241.046
            ],
            [
              2992.31,
              -9162.2,
              9313.276
            ],
            [
              3013.269,
              -9177.069,
              9338.973
            ],
            [
              3028.932,
              -9199.631,
              9366.439
            ],
            [
              3134.577,
              -9330.771,
              9534.839
            ],
            [
              3165.86,
              -9378.122,
              9591.59
            ],
            [
              3173.907,
              -9394.973,
              9610.265
            ],
            [
              3208.182,
              -9555.935,
              9774.835
            ],
            [
              3213.698,
              -9570.512,
              9790.421
            ],
            [
              3220.563,
              -9581.775,
              9803.611
            ],
            [
              3233.82,
              -9595.386,
              9822.611
            ],
            [
              3263.762,
              -9611.54,
              9856.633
            ],
            [
              3404.776,
              -9675.449,
              10011.454
            ],
            [
              3447.994,
              -9704.103,
              10063.307
            ],
            [
              3478.945,
              -9734.751,
              10106.865
            ],
            [
              3511.635,
              -9775.451,
              10159.068
            ],
            [
              3546.778,
              -9856.276,
              10247.202
            ],
            [
              3563.744,
              -9877.752,
              10274.571
            ],
            [
              3584.076,
              -9891.498,
              10299.114
            ],
            [
              3684.789,
              -9975.801,
              10430.454
            ],
            [
              3753.117,
              -10037.223,
              10522.33
            ],
            [
              3824.059,
              -10096.468,
              10614.757
            ],
            [
              3850.114,
              -10113.666,
              10645.976
            ],
            [
              3952.142,
              -10330.48,
              10885.597
            ],
            [
              3968.377,
              -10356.396,
              10916.178
            ],
            [
              4135.859,
              -10682.457,
              11282.738
            ],
            [
              4233.785,
              -10876.935,
              11500.479
            ],
            [
              4254.712,
              -10926.321,
              11554.116
            ],
            [
              4259.128,
              -10930.859,
              11560.449
            ],
            [
              4272.763,
              -10924.442,
              11575.518
            ],
            [
              4279.173,
              -10925.678,
              11582.046
            ],
            [
              4289.722,
              -10945.92,
              11604.872
            ],
            [
              4292.144,
              -10953.759,
              11613.077
            ],
            [
              4289.98,
              -10965.964,
              11625.472
            ],
            [
              4278.918,
              -10972.431,
              11638.286
            ],
            [
              4432.869,
              -11263.733,
              11967.767
            ],
            [
              4431.004,
              -11260.357,
              11971.624
            ],
            [
              4506.568,
              -11412.106,
              12141.145
            ],
            [
              4522.451,
              -11455.83,
              12187.665
            ],
            [
              4524.573,
              -11479.25,
              12211.181
            ],
            [
              4514.39,
              -11540.284,
              12273.059
            ],
            [
              4493.832,
              -11638.971,
              12373.864
            ],
            [
              4485.665,
              -11662.192,
              12398.479
            ],
            [
              4461.1,
              -11768.594,
              12507.68
            ],
            [
              4428.456,
              -11927.165,
              12669.576
            ],
            [
              4404.772,
              -12054.736,
              12799.328
            ],
            [
              4294.404,
              -12542.458,
              13299.381
            ],
            [
              4282.19,
              -12609.02,
              13367.054
            ],
            [
              4283.669,
              -12632.427,
              13390.509
            ],
            [
              4287.977,
              -12642.53,
              13401.491
            ],
            [
              4318.023,
              -12685.412,
              13453.852
            ],
            [
              4318.473,
              -12695.441,
              13463.891
            ],
            [
              4315.194,
              -12698.717,
              13468.526
            ],
            [
              4302.958,
              -12699.595,
              13480.794
            ],
            [
              4264.491,
              -12693.289,
              13519.775
            ],
            [
              4245.846,
              -12692.931,
              13538.423
            ],
            [
              4229.195,
              -12689.271,
              13555.472
            ],
            [
              4219.68,
              -12682.408,
              13567.203
            ],
            [
              4207.078,
              -12668.807,
              13585.745
            ],
            [
              4191.54,
              -12640.676,
              13617.882
            ],
            [
              4184.489,
              -12639.427,
              13625.042
            ],
            [
              4172.789,
              -12645.882,
              13638.405
            ],
            [
              4135.243,
              -12658.521,
              13678.021
            ],
            [
              4112.805,
              -12654.75,
              13700.773
            ],
            [
              3803.923,
              -12596.508,
              14015.099
            ],
            [
              3507.545,
              -12522.939,
              14320.471
            ],
            [
              3445.499,
              -12505.058,
              14385.042
            ],
            [
              3348.197,
              -12480.94,
              14485.289
            ],
            [
              3325.694,
              -12480.512,
              14507.795
            ],
            [
              3102.513,
              -12785.764,
              14885.933
            ],
            [
              3085.871,
              -12815.507,
              14920.016
            ],
            [
              3081.528,
              -12841.03,
              14945.905
            ],
            [
              3045.505,
              -12909.37,
              15023.159
            ],
            [
              3012.654,
              -12979.997,
              15101.052
            ],
            [
              2975.61,
              -13068.357,
              15196.863
            ],
            [
              2927.302,
              -13174.316,
              15313.315
            ],
            [
              2895.887,
              -13169.269,
              15345.133
            ],
            [
              2885.064,
              -13163.497,
              15357.398
            ],
            [
              2731.33,
              -13131.645,
              15514.397
            ],
            [
              2573.884,
              -13091.936,
              15676.774
            ],
            [
              2529.653,
              -13084.423,
              15721.638
            ],
            [
              2498.839,
              -13081.615,
              15752.581
            ],
            [
              2418.043,
              -13103.473,
              15836.281
            ],
            [
              2390.75,
              -13118.545,
              15867.459
            ],
            [
              2353.983,
              -13124.533,
              15904.711
            ],
            [
              2309.292,
              -13141.505,
              15952.516
            ],
            [
              2241.642,
              -13182.538,
              16031.637
            ],
            [
              2197.303,
              -13215.104,
              16086.65
            ],
            [
              2159.559,
              -13238.887,
              16131.262
            ],
            [
              2125.632,
              -13264.969,
              16174.057
            ],
            [
              2055.703,
              -13324.888,
              16266.146
            ],
            [
              2013.003,
              -13373.072,
              16330.527
            ],
            [
              2000.063,
              -13377.283,
              16344.134
            ],
            [
              1996.248,
              -13374.985,
              16348.588
            ],
            [
              1995.046,
              -13370.509,
              16353.222
            ],
            [
              1997.183,
              -13359.416,
              16364.519
            ],
            [
              2011.533,
              -13348.552,
              16382.518
            ],
            [
              2021.196,
              -13347.62,
              16392.226
            ],
            [
              2018.624,
              -13347.572,
              16394.797
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6788",
              "position": {
                "x": 374.58,
                "z": -1783.82
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -360,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 435.032,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 820.329,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 1507.526,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 2106.169,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 510,
              "departureOffsetSeconds": 510
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 2416.129,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 570,
              "departureOffsetSeconds": 570
            },
            {
              "stopId": "judu:stop:6487",
              "position": {
                "x": 54.707,
                "z": -4440.844
              },
              "distanceAlongShapeM": 2826.263,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6488",
              "position": {
                "x": -36.204,
                "z": -5116.037
              },
              "distanceAlongShapeM": 3509.975,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6491",
              "position": {
                "x": -105.993,
                "z": -5410.888
              },
              "distanceAlongShapeM": 3813.516,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 4153.169,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 4631.829,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:16627",
              "position": {
                "x": 320.415,
                "z": -6959.406
              },
              "distanceAlongShapeM": 5603.644,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6797",
              "position": {
                "x": 1056.317,
                "z": -7139.934
              },
              "distanceAlongShapeM": 6411.087,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6800",
              "position": {
                "x": 1694.973,
                "z": -8148.149
              },
              "distanceAlongShapeM": 7643.666,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6803",
              "position": {
                "x": 3013.269,
                "z": -9177.069
              },
              "distanceAlongShapeM": 9338.973,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6856",
              "position": {
                "x": 3684.789,
                "z": -9975.801
              },
              "distanceAlongShapeM": 10430.454,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:10554",
              "position": {
                "x": 3850.114,
                "z": -10113.666
              },
              "distanceAlongShapeM": 10645.976,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6860",
              "position": {
                "x": 3968.377,
                "z": -10356.396
              },
              "distanceAlongShapeM": 10916.178,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8315",
              "position": {
                "x": 4289.98,
                "z": -10965.964
              },
              "distanceAlongShapeM": 11625.472,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:8004",
              "position": {
                "x": 4493.832,
                "z": -11638.971
              },
              "distanceAlongShapeM": 12373.864,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:8005",
              "position": {
                "x": 4404.772,
                "z": -12054.736
              },
              "distanceAlongShapeM": 12799.328,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:8006",
              "position": {
                "x": 4295.286,
                "z": -12697.221
              },
              "distanceAlongShapeM": 13488.749,
              "shapeOffsetM": 1.102,
              "arrivalOffsetSeconds": 2070,
              "departureOffsetSeconds": 2070
            },
            {
              "stopId": "judu:stop:10552",
              "position": {
                "x": 3803.923,
                "z": -12596.508
              },
              "distanceAlongShapeM": 14015.099,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2190,
              "departureOffsetSeconds": 2190
            },
            {
              "stopId": "judu:stop:8008",
              "position": {
                "x": 3507.545,
                "z": -12522.939
              },
              "distanceAlongShapeM": 14320.471,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2250,
              "departureOffsetSeconds": 2250
            },
            {
              "stopId": "judu:stop:8009",
              "position": {
                "x": 3081.528,
                "z": -12841.03
              },
              "distanceAlongShapeM": 14945.905,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2370,
              "departureOffsetSeconds": 2370
            },
            {
              "stopId": "judu:stop:8363",
              "position": {
                "x": 2895.887,
                "z": -13169.269
              },
              "distanceAlongShapeM": 15345.133,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2430,
              "departureOffsetSeconds": 2430
            },
            {
              "stopId": "judu:stop:8012",
              "position": {
                "x": 2390.75,
                "z": -13118.545
              },
              "distanceAlongShapeM": 15867.459,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2490,
              "departureOffsetSeconds": 2490
            },
            {
              "stopId": "judu:stop:8011",
              "position": {
                "x": 2018.624,
                "z": -13347.572
              },
              "distanceAlongShapeM": 16394.797,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2550,
              "departureOffsetSeconds": 2550
            }
          ],
          "departuresSeconds": [
            19800,
            20880,
            22020,
            23400,
            24960,
            26160,
            28260,
            31500,
            32400,
            33480,
            36180,
            37260,
            38280,
            39300,
            40320,
            41220,
            42300,
            43200,
            44100,
            45060,
            46080,
            47100,
            48120,
            49440,
            50760,
            52200,
            54060,
            54780,
            55380,
            55980,
            56820,
            57660,
            58800,
            60120,
            61200,
            62340,
            63420,
            64560,
            66360,
            67860,
            69120,
            69840,
            70860,
            72540,
            74580,
            75900,
            77280,
            78780,
            80220,
            81600
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_36:1",
          "sourceRouteId": "vilnius_bus_36",
          "sourceShapeId": "vilnius_bus_36_b-a",
          "directionId": 1,
          "headsign": "Žalgirio g.",
          "directionName": "Pagubė–Naujaneriai–Balsiai–Kalvarijų–Žalgirio g.",
          "mode": "bus",
          "routeShortName": "36",
          "routeLongName": "Žalgirio–Kalvarijų g.–Balsiai–Naujaneriai–Pagubė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2018.624,
              -13347.572,
              0
            ],
            [
              2051.182,
              -13325.917,
              39.102
            ],
            [
              2126.959,
              -13262.768,
              137.742
            ],
            [
              2212.276,
              -13205.365,
              240.572
            ],
            [
              2263.128,
              -13168.469,
              303.399
            ],
            [
              2313.896,
              -13136.025,
              363.649
            ],
            [
              2386.334,
              -13114.009,
              439.359
            ],
            [
              2418.727,
              -13101.259,
              474.171
            ],
            [
              2473.705,
              -13084.482,
              531.651
            ],
            [
              2519.452,
              -13079.777,
              577.639
            ],
            [
              2533.573,
              -13081.157,
              591.828
            ],
            [
              2579.048,
              -13090.92,
              638.339
            ],
            [
              2628.295,
              -13105.208,
              689.617
            ],
            [
              2927.302,
              -13174.316,
              996.506
            ],
            [
              3092.532,
              -12803.387,
              1402.573
            ],
            [
              3101.185,
              -12787.965,
              1420.256
            ],
            [
              3181.668,
              -12681.505,
              1553.715
            ],
            [
              3223.998,
              -12619.965,
              1628.407
            ],
            [
              3249.211,
              -12579.253,
              1676.294
            ],
            [
              3291.479,
              -12521.053,
              1748.224
            ],
            [
              3312.582,
              -12493.622,
              1782.833
            ],
            [
              3325.694,
              -12480.512,
              1801.375
            ],
            [
              3352.033,
              -12482.126,
              1827.764
            ],
            [
              3458.421,
              -12501.964,
              1935.985
            ],
            [
              3765.709,
              -12576.851,
              2252.267
            ],
            [
              4112.805,
              -12654.75,
              2607.997
            ],
            [
              4128.878,
              -12655.058,
              2624.072
            ],
            [
              4152.109,
              -12651.051,
              2647.646
            ],
            [
              4185.196,
              -12636.101,
              2683.954
            ],
            [
              4190.961,
              -12637.325,
              2689.848
            ],
            [
              4219.165,
              -12675.718,
              2737.487
            ],
            [
              4226.773,
              -12681.431,
              2747.001
            ],
            [
              4235.045,
              -12686.043,
              2756.472
            ],
            [
              4250.432,
              -12688.566,
              2772.065
            ],
            [
              4258.811,
              -12687.613,
              2780.498
            ],
            [
              4269.397,
              -12672.231,
              2799.171
            ],
            [
              4333.362,
              -12356.175,
              3121.634
            ],
            [
              4384.004,
              -12131.153,
              3352.285
            ],
            [
              4413.388,
              -11974.746,
              3511.428
            ],
            [
              4489.159,
              -11647.787,
              3847.052
            ],
            [
              4500.864,
              -11574.536,
              3921.233
            ],
            [
              4520.672,
              -11481.402,
              4016.45
            ],
            [
              4515.699,
              -11439.001,
              4059.141
            ],
            [
              4355.864,
              -11119.751,
              4416.168
            ],
            [
              4222.101,
              -10882.277,
              4688.723
            ],
            [
              3952.142,
              -10330.48,
              5303.017
            ],
            [
              3931.49,
              -10300.026,
              5339.813
            ],
            [
              3866.759,
              -10151.835,
              5501.525
            ],
            [
              3832.039,
              -10116.66,
              5550.95
            ],
            [
              3633.404,
              -9936.97,
              5818.801
            ],
            [
              3613.674,
              -9925.461,
              5841.642
            ],
            [
              3584.076,
              -9891.498,
              5886.692
            ],
            [
              3560.012,
              -9871.001,
              5918.303
            ],
            [
              3541.801,
              -9847.275,
              5948.212
            ],
            [
              3514.661,
              -9785.528,
              6015.66
            ],
            [
              3500.953,
              -9761.888,
              6042.987
            ],
            [
              3482.098,
              -9738.151,
              6073.301
            ],
            [
              3456.873,
              -9710.952,
              6110.397
            ],
            [
              3423.2,
              -9688.046,
              6151.122
            ],
            [
              3388.156,
              -9669.567,
              6190.74
            ],
            [
              3277.145,
              -9618.474,
              6312.944
            ],
            [
              3228.737,
              -9591.949,
              6368.143
            ],
            [
              3213.634,
              -9573.85,
              6391.715
            ],
            [
              3206.315,
              -9552.559,
              6414.229
            ],
            [
              3171.376,
              -9392.699,
              6577.864
            ],
            [
              3164.552,
              -9379.21,
              6592.98
            ],
            [
              3134.577,
              -9330.771,
              6649.944
            ],
            [
              3021.317,
              -9193.92,
              6827.584
            ],
            [
              2970.687,
              -9148.431,
              6895.647
            ],
            [
              2953.441,
              -9141.425,
              6914.262
            ],
            [
              2944.749,
              -9124.562,
              6933.233
            ],
            [
              2590.264,
              -8808.384,
              7408.237
            ],
            [
              2140.228,
              -8401.383,
              8015.017
            ],
            [
              2107.826,
              -8378.511,
              8054.678
            ],
            [
              1978.502,
              -8305.956,
              8202.964
            ],
            [
              1955.502,
              -8296.62,
              8227.788
            ],
            [
              1918.925,
              -8290.37,
              8264.895
            ],
            [
              1793.436,
              -8253.517,
              8395.683
            ],
            [
              1773.051,
              -8242.004,
              8419.095
            ],
            [
              1750.194,
              -8224.879,
              8447.655
            ],
            [
              1684.136,
              -8142.38,
              8553.342
            ],
            [
              1655.922,
              -8101.778,
              8602.785
            ],
            [
              1643.486,
              -8078.168,
              8629.47
            ],
            [
              1639.977,
              -8059.177,
              8648.782
            ],
            [
              1639.433,
              -7950.068,
              8757.893
            ],
            [
              1629.362,
              -7903.123,
              8805.905
            ],
            [
              1545.21,
              -7754.608,
              8976.605
            ],
            [
              1341.067,
              -7410.16,
              9377.003
            ],
            [
              1312.907,
              -7366.221,
              9429.191
            ],
            [
              1291.476,
              -7341.333,
              9462.035
            ],
            [
              1145.93,
              -7238.444,
              9640.275
            ],
            [
              1102.154,
              -7203.124,
              9696.524
            ],
            [
              1045.977,
              -7141.97,
              9779.564
            ],
            [
              1026.954,
              -7126.033,
              9804.381
            ],
            [
              999.31,
              -7088.785,
              9850.766
            ],
            [
              951.943,
              -7073.438,
              9900.557
            ],
            [
              652.324,
              -7119.127,
              10203.64
            ],
            [
              622.009,
              -7121.909,
              10234.083
            ],
            [
              600.767,
              -7121.518,
              10255.328
            ],
            [
              577.696,
              -7115.528,
              10279.164
            ],
            [
              488.416,
              -7068.245,
              10380.192
            ],
            [
              60.82,
              -6823.295,
              10872.978
            ],
            [
              14.911,
              -6833.59,
              10920.027
            ],
            [
              -2.815,
              -6852.191,
              10945.722
            ],
            [
              -13.86,
              -6857.556,
              10958.001
            ],
            [
              -26.131,
              -6859.559,
              10970.435
            ],
            [
              -47.374,
              -6859.171,
              10991.681
            ],
            [
              -59.463,
              -6851.158,
              11006.185
            ],
            [
              -67.548,
              -6835.425,
              11023.873
            ],
            [
              -70.502,
              -6820.899,
              11038.697
            ],
            [
              -64.262,
              -6796.522,
              11063.86
            ],
            [
              -53.78,
              -6786.694,
              11078.23
            ],
            [
              -43.196,
              -6771.301,
              11096.91
            ],
            [
              -35.045,
              -6748.072,
              11121.528
            ],
            [
              -43.266,
              -6704.505,
              11165.863
            ],
            [
              -50.829,
              -6695.462,
              11177.652
            ],
            [
              -48.526,
              -6639.841,
              11233.32
            ],
            [
              -52.099,
              -6588.567,
              11284.719
            ],
            [
              -70.555,
              -6505.85,
              11369.469
            ],
            [
              -125.166,
              -6286.66,
              11595.361
            ],
            [
              -158.525,
              -6137.991,
              11747.726
            ],
            [
              -182.398,
              -6069.649,
              11820.118
            ],
            [
              -186.217,
              -6031.729,
              11858.23
            ],
            [
              -210.448,
              -5912.171,
              11980.218
            ],
            [
              -214.769,
              -5866.45,
              12026.144
            ],
            [
              -215.425,
              -5796.303,
              12096.293
            ],
            [
              -201.911,
              -5690.791,
              12202.667
            ],
            [
              -179.043,
              -5602.148,
              12294.212
            ],
            [
              -176.685,
              -5578.813,
              12317.666
            ],
            [
              -152.289,
              -5512.463,
              12388.36
            ],
            [
              -104.595,
              -5334.099,
              12572.99
            ],
            [
              -97,
              -5270.783,
              12636.76
            ],
            [
              -83.553,
              -5239.857,
              12670.483
            ],
            [
              -60.518,
              -5142.312,
              12770.711
            ],
            [
              -44.586,
              -5045.75,
              12868.578
            ],
            [
              -41.097,
              -4995.718,
              12918.732
            ],
            [
              -29.601,
              -4965.87,
              12950.717
            ],
            [
              29.378,
              -4628.52,
              13293.184
            ],
            [
              28.501,
              -4570.615,
              13351.095
            ],
            [
              22.071,
              -4499.251,
              13422.749
            ],
            [
              25.378,
              -4459.234,
              13462.901
            ],
            [
              38.073,
              -4363.727,
              13559.249
            ],
            [
              46.147,
              -4344.95,
              13579.689
            ],
            [
              45.488,
              -4310.427,
              13614.217
            ],
            [
              49.82,
              -4284.902,
              13640.108
            ],
            [
              60.111,
              -4250.579,
              13675.94
            ],
            [
              104.143,
              -4062.131,
              13869.463
            ],
            [
              126.577,
              -3997.973,
              13937.431
            ],
            [
              148.043,
              -3951.609,
              13988.523
            ],
            [
              179.07,
              -3910.986,
              14039.64
            ],
            [
              264.038,
              -3810.121,
              14171.524
            ],
            [
              345.157,
              -3743.697,
              14276.369
            ],
            [
              383.579,
              -3686.512,
              14345.263
            ],
            [
              434.283,
              -3627.326,
              14423.197
            ],
            [
              450.253,
              -3599.787,
              14455.032
            ],
            [
              463.769,
              -3565.524,
              14491.864
            ],
            [
              474.065,
              -3531.203,
              14527.697
            ],
            [
              484.063,
              -3477.95,
              14581.88
            ],
            [
              489.712,
              -3345.578,
              14714.372
            ],
            [
              488.249,
              -3319.947,
              14740.045
            ],
            [
              479.687,
              -3259.675,
              14800.922
            ],
            [
              477.905,
              -3216.226,
              14844.408
            ],
            [
              481.339,
              -3169.533,
              14891.227
            ],
            [
              500.602,
              -3103.091,
              14960.405
            ],
            [
              500.428,
              -3077.483,
              14986.013
            ],
            [
              504.445,
              -3034.141,
              15029.542
            ],
            [
              503.491,
              -2980.688,
              15083.003
            ],
            [
              505.751,
              -2962.917,
              15100.917
            ],
            [
              502.159,
              -2912.756,
              15151.207
            ],
            [
              509.397,
              -2869.472,
              15195.092
            ],
            [
              513.301,
              -2797.183,
              15267.486
            ],
            [
              494.515,
              -2626.513,
              15439.187
            ],
            [
              482.722,
              -2601.805,
              15466.565
            ],
            [
              485.911,
              -2568.466,
              15500.056
            ],
            [
              462.343,
              -2342.047,
              15727.699
            ],
            [
              451.425,
              -2269.486,
              15801.076
            ],
            [
              407.176,
              -2116.162,
              15960.657
            ],
            [
              406.254,
              -2096.107,
              15980.734
            ],
            [
              361.405,
              -1904.922,
              16177.108
            ],
            [
              342.249,
              -1718.661,
              16364.352
            ],
            [
              384.201,
              -1716.089,
              16406.382
            ],
            [
              395.76,
              -1718.527,
              16418.196
            ],
            [
              397.612,
              -1723.014,
              16423.05
            ],
            [
              399.396,
              -1766.463,
              16466.536
            ],
            [
              397.923,
              -1776.455,
              16476.636
            ],
            [
              394.599,
              -1781.96,
              16483.067
            ],
            [
              371.982,
              -1784.886,
              16505.872
            ],
            [
              374.58,
              -1783.82,
              16508.68
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8011",
              "position": {
                "x": 2018.624,
                "z": -13347.572
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -390,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8016",
              "position": {
                "x": 2445.252,
                "z": -13092.852
              },
              "distanceAlongShapeM": 501.994,
              "shapeOffsetM": 0.299,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8367",
              "position": {
                "x": 2941.349,
                "z": -13145.637
              },
              "distanceAlongShapeM": 1028.42,
              "shapeOffsetM": 1.162,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8017",
              "position": {
                "x": 3092.532,
                "z": -12803.387
              },
              "distanceAlongShapeM": 1402.573,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8018",
              "position": {
                "x": 3458.421,
                "z": -12501.964
              },
              "distanceAlongShapeM": 1935.985,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:10551",
              "position": {
                "x": 3765.709,
                "z": -12576.851
              },
              "distanceAlongShapeM": 2252.267,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:18426",
              "position": {
                "x": 4270.854,
                "z": -12663.353
              },
              "distanceAlongShapeM": 2808.162,
              "shapeOffsetM": 0.333,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8021",
              "position": {
                "x": 4413.388,
                "z": -11974.746
              },
              "distanceAlongShapeM": 3511.428,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:8022",
              "position": {
                "x": 4500.864,
                "z": -11574.536
              },
              "distanceAlongShapeM": 3921.233,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:18370",
              "position": {
                "x": 4222.101,
                "z": -10882.277
              },
              "distanceAlongShapeM": 4688.723,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6861",
              "position": {
                "x": 3931.49,
                "z": -10300.026
              },
              "distanceAlongShapeM": 5339.813,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:10556",
              "position": {
                "x": 3832.039,
                "z": -10116.66
              },
              "distanceAlongShapeM": 5550.95,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6857",
              "position": {
                "x": 3613.674,
                "z": -9925.461
              },
              "distanceAlongShapeM": 5841.642,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6804",
              "position": {
                "x": 2953.441,
                "z": -9141.425
              },
              "distanceAlongShapeM": 6914.262,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6801",
              "position": {
                "x": 1918.925,
                "z": -8290.37
              },
              "distanceAlongShapeM": 8264.895,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6798",
              "position": {
                "x": 1026.954,
                "z": -7126.033
              },
              "distanceAlongShapeM": 9804.381,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:16628",
              "position": {
                "x": 229.7,
                "z": -6919.895
              },
              "distanceAlongShapeM": 10678.423,
              "shapeOffsetM": 0.125,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 11177.652,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 11820.118,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6494",
              "position": {
                "x": -176.685,
                "z": -5578.813
              },
              "distanceAlongShapeM": 12317.666,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6492",
              "position": {
                "x": -97,
                "z": -5270.783
              },
              "distanceAlongShapeM": 12636.76,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6489",
              "position": {
                "x": -41.097,
                "z": -4995.718
              },
              "distanceAlongShapeM": 12918.732,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 13640.108,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 13988.523,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 14345.263,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 15151.207,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 15466.565,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 15960.657,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6788",
              "position": {
                "x": 374.58,
                "z": -1783.82
              },
              "distanceAlongShapeM": 16508.68,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            }
          ],
          "departuresSeconds": [
            19260,
            20400,
            22500,
            23820,
            24720,
            26400,
            27960,
            29520,
            31500,
            34260,
            35640,
            37200,
            39060,
            40140,
            41100,
            42120,
            43140,
            44100,
            45120,
            46140,
            47100,
            48060,
            49020,
            49980,
            50940,
            52440,
            53940,
            55440,
            57000,
            57900,
            58740,
            59580,
            60420,
            61260,
            62400,
            63540,
            64560,
            65700,
            66840,
            67920,
            69420,
            70860,
            72120,
            72960,
            74400,
            75900,
            77460,
            78900,
            80340,
            81780,
            83160,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_37",
      "sourceRouteId": "vilnius_bus_37",
      "mode": "bus",
      "shortName": "37",
      "longName": "Kalvarijų–Tuskulėnų–Olandų g.–Rokantiškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_37:0",
          "sourceRouteId": "vilnius_bus_37",
          "sourceShapeId": "vilnius_bus_37_a-b",
          "directionId": 0,
          "headsign": "Rokantiškės",
          "directionName": "Kalvarijų–Tuskulėnų–Olandų g.–Rokantiškės",
          "mode": "bus",
          "routeShortName": "37",
          "routeLongName": "Kalvarijų–Tuskulėnų–Olandų g.–Rokantiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              673.267,
              -1632.329,
              0
            ],
            [
              699.977,
              -1617.234,
              30.68
            ],
            [
              762.593,
              -1542.685,
              128.038
            ],
            [
              891.199,
              -1385.857,
              330.853
            ],
            [
              926.904,
              -1337.532,
              390.938
            ],
            [
              934.987,
              -1318.756,
              411.38
            ],
            [
              959.848,
              -1299.175,
              443.026
            ],
            [
              1019.189,
              -1227.908,
              535.764
            ],
            [
              1188.158,
              -1016.171,
              806.657
            ],
            [
              1209.421,
              -982.054,
              846.859
            ],
            [
              1229.046,
              -966.831,
              871.696
            ],
            [
              1246.923,
              -941.557,
              902.653
            ],
            [
              1250.475,
              -923.811,
              920.751
            ],
            [
              1249.57,
              -868.132,
              976.437
            ],
            [
              1251.689,
              -858.152,
              986.64
            ],
            [
              1263.58,
              -842.786,
              1006.069
            ],
            [
              1271.438,
              -836.252,
              1016.289
            ],
            [
              1287.032,
              -829.861,
              1033.142
            ],
            [
              1306.39,
              -829.106,
              1052.515
            ],
            [
              1381.451,
              -814.909,
              1128.907
            ],
            [
              1625.047,
              -649.1,
              1423.579
            ],
            [
              1633.071,
              -633.663,
              1440.976
            ],
            [
              1640.869,
              -630.468,
              1449.403
            ],
            [
              1650.286,
              -609.492,
              1472.397
            ],
            [
              1647.435,
              -589.4,
              1492.689
            ],
            [
              1649.076,
              -570.506,
              1511.655
            ],
            [
              1661.593,
              -556.266,
              1530.614
            ],
            [
              1707.61,
              -543.762,
              1578.299
            ],
            [
              1715.531,
              -533.89,
              1590.957
            ],
            [
              1739.19,
              -475.328,
              1654.118
            ],
            [
              1739.832,
              -440.829,
              1688.622
            ],
            [
              1737.688,
              -417.411,
              1712.138
            ],
            [
              1728.721,
              -379.394,
              1751.198
            ],
            [
              1714.349,
              -354.636,
              1779.826
            ],
            [
              1709.957,
              -313.364,
              1821.331
            ],
            [
              1701.073,
              -270.896,
              1864.718
            ],
            [
              1691.292,
              -207.259,
              1929.102
            ],
            [
              1692.553,
              -139.375,
              1996.998
            ],
            [
              1699.889,
              -91.641,
              2045.292
            ],
            [
              1722.281,
              -31.942,
              2109.052
            ],
            [
              1763.619,
              40.763,
              2192.688
            ],
            [
              1781.292,
              89.417,
              2244.452
            ],
            [
              1803.689,
              114.605,
              2278.158
            ],
            [
              1864.141,
              209.22,
              2390.435
            ],
            [
              1913.636,
              269.526,
              2468.453
            ],
            [
              1990.962,
              334.88,
              2569.697
            ],
            [
              2015.503,
              371.16,
              2613.497
            ],
            [
              2052.586,
              388.28,
              2654.342
            ],
            [
              2087.216,
              412.125,
              2696.387
            ],
            [
              2136.967,
              451.273,
              2759.693
            ],
            [
              2182.309,
              496.069,
              2823.432
            ],
            [
              2210.658,
              528.937,
              2866.837
            ],
            [
              2229.877,
              556.409,
              2900.364
            ],
            [
              2244.749,
              592.868,
              2939.74
            ],
            [
              2266.569,
              621.404,
              2975.662
            ],
            [
              2281.67,
              670.105,
              3026.65
            ],
            [
              2292.591,
              736.695,
              3094.13
            ],
            [
              2303.283,
              756.534,
              3116.666
            ],
            [
              2315.701,
              765.207,
              3131.814
            ],
            [
              2333.819,
              768.208,
              3150.178
            ],
            [
              2353.101,
              764.507,
              3169.812
            ],
            [
              2377.645,
              731.764,
              3210.733
            ],
            [
              2411.777,
              694.387,
              3261.349
            ],
            [
              2432.805,
              680.634,
              3286.476
            ],
            [
              2453.583,
              653.527,
              3320.631
            ],
            [
              2501.276,
              617.009,
              3380.698
            ],
            [
              2634.367,
              525.451,
              3542.241
            ],
            [
              2716.164,
              450.439,
              3653.225
            ],
            [
              2739.748,
              435.524,
              3681.13
            ],
            [
              2755.449,
              412.963,
              3708.616
            ],
            [
              2864.4,
              307.38,
              3860.334
            ],
            [
              2936.644,
              239.224,
              3959.654
            ],
            [
              2983.62,
              199.374,
              4021.256
            ],
            [
              3035.88,
              166.104,
              4083.207
            ],
            [
              3060.52,
              138.92,
              4119.896
            ],
            [
              3266.423,
              -23.054,
              4381.872
            ],
            [
              3339.574,
              -76.762,
              4472.623
            ],
            [
              3415.597,
              -114.94,
              4557.694
            ],
            [
              3440.614,
              -122.094,
              4583.713
            ],
            [
              3506.161,
              -134.47,
              4650.419
            ],
            [
              3501.543,
              -139.949,
              4657.585
            ],
            [
              3709.123,
              -178.405,
              4868.696
            ],
            [
              3787.457,
              -196.594,
              4949.115
            ],
            [
              3851.65,
              -212.29,
              5015.198
            ],
            [
              3930.415,
              -241.623,
              5099.249
            ],
            [
              4021.131,
              -286.771,
              5200.578
            ],
            [
              4084.273,
              -323.602,
              5273.677
            ],
            [
              4231.381,
              -421.043,
              5450.129
            ],
            [
              4241.418,
              -435.707,
              5467.9
            ],
            [
              4278.232,
              -466.47,
              5515.876
            ],
            [
              4311.285,
              -491.595,
              5557.394
            ],
            [
              4330.475,
              -499.756,
              5578.247
            ],
            [
              4344.721,
              -496.689,
              5592.819
            ],
            [
              4357.14,
              -488.021,
              5607.964
            ],
            [
              4364.509,
              -473.69,
              5624.079
            ],
            [
              4364.163,
              -458.098,
              5639.675
            ],
            [
              4359.842,
              -447.995,
              5650.662
            ],
            [
              4352.277,
              -438.944,
              5662.458
            ],
            [
              4340.823,
              -430.932,
              5676.437
            ],
            [
              4325.351,
              -430.635,
              5691.912
            ],
            [
              4312.351,
              -435.953,
              5705.957
            ],
            [
              4227.316,
              -532.291,
              5834.456
            ],
            [
              4193.305,
              -557.245,
              5876.639
            ],
            [
              4145.028,
              -586.38,
              5933.027
            ],
            [
              4118.151,
              -609.244,
              5968.314
            ],
            [
              4108.056,
              -631.317,
              5992.585
            ],
            [
              4104.514,
              -647.948,
              6009.589
            ],
            [
              4104.478,
              -683.571,
              6045.213
            ],
            [
              4108.628,
              -702.576,
              6064.665
            ],
            [
              4120.493,
              -722.842,
              6088.149
            ],
            [
              4209.147,
              -841.43,
              6236.212
            ],
            [
              4298.76,
              -943.34,
              6371.918
            ],
            [
              4339.357,
              -1012.027,
              6451.705
            ],
            [
              4411.646,
              -1109.154,
              6572.781
            ],
            [
              4521.392,
              -1337.254,
              6825.909
            ],
            [
              4532.071,
              -1351.932,
              6844.061
            ],
            [
              4572.013,
              -1387.211,
              6897.352
            ],
            [
              4585.807,
              -1407.515,
              6921.899
            ],
            [
              4687.775,
              -1502.991,
              7061.588
            ],
            [
              4747.35,
              -1556.462,
              7141.64
            ],
            [
              4855.863,
              -1646.502,
              7282.644
            ],
            [
              4873.887,
              -1681.361,
              7321.887
            ],
            [
              4892.083,
              -1707.317,
              7353.586
            ],
            [
              4935.048,
              -1752.677,
              7416.064
            ],
            [
              4957.325,
              -1767.58,
              7442.866
            ],
            [
              5027.743,
              -1793.432,
              7517.88
            ],
            [
              5112.316,
              -1820.673,
              7606.732
            ],
            [
              5148.212,
              -1831.387,
              7644.193
            ],
            [
              5188.082,
              -1836.611,
              7684.403
            ],
            [
              5235.836,
              -1834.197,
              7732.219
            ],
            [
              5256.588,
              -1827.919,
              7753.899
            ],
            [
              5278.737,
              -1816.102,
              7779.003
            ],
            [
              5309.094,
              -1779.953,
              7826.209
            ],
            [
              5323.51,
              -1767.986,
              7844.944
            ],
            [
              5345.572,
              -1760.621,
              7868.203
            ],
            [
              5394.53,
              -1762.685,
              7917.205
            ],
            [
              5423.981,
              -1773.276,
              7948.502
            ],
            [
              5446.944,
              -1785.968,
              7974.739
            ],
            [
              5457.104,
              -1793.958,
              7987.665
            ],
            [
              5471.624,
              -1809.826,
              8009.173
            ],
            [
              5523.285,
              -1838.661,
              8068.337
            ],
            [
              5537.891,
              -1850.078,
              8086.875
            ],
            [
              5539.738,
              -1854.567,
              8091.729
            ],
            [
              5537.008,
              -1862.307,
              8099.936
            ],
            [
              5531.744,
              -1867.771,
              8107.523
            ],
            [
              5520.767,
              -1868.671,
              8118.537
            ],
            [
              5513.765,
              -1864.082,
              8126.91
            ],
            [
              5512.692,
              -1852.928,
              8138.115
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6544",
              "position": {
                "x": 934.987,
                "z": -1318.756
              },
              "distanceAlongShapeM": 411.38,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6546",
              "position": {
                "x": 1209.421,
                "z": -982.054
              },
              "distanceAlongShapeM": 846.859,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 1779.826,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6568",
              "position": {
                "x": 1781.292,
                "z": 89.417
              },
              "distanceAlongShapeM": 2244.452,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 2613.497,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 2939.74,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:931",
              "position": {
                "x": 2432.805,
                "z": 680.634
              },
              "distanceAlongShapeM": 3286.476,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:387",
              "position": {
                "x": 2739.748,
                "z": 435.524
              },
              "distanceAlongShapeM": 3681.13,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5372",
              "position": {
                "x": 3035.88,
                "z": 166.104
              },
              "distanceAlongShapeM": 4083.207,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5373",
              "position": {
                "x": 3506.161,
                "z": -134.47
              },
              "distanceAlongShapeM": 4650.419,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7587",
              "position": {
                "x": 4231.381,
                "z": -421.043
              },
              "distanceAlongShapeM": 5450.129,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6881",
              "position": {
                "x": 4298.76,
                "z": -943.34
              },
              "distanceAlongShapeM": 6371.918,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6883",
              "position": {
                "x": 4572.013,
                "z": -1387.211
              },
              "distanceAlongShapeM": 6897.352,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6887",
              "position": {
                "x": 4855.863,
                "z": -1646.502
              },
              "distanceAlongShapeM": 7282.644,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 8138.115,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            }
          ],
          "departuresSeconds": [
            18300,
            21060,
            24240,
            28140,
            32280,
            37920,
            41460,
            45060,
            48420,
            52020,
            55560,
            59580,
            64020,
            70260,
            73740,
            77160,
            80460
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_37:1",
          "sourceRouteId": "vilnius_bus_37",
          "sourceShapeId": "vilnius_bus_37_b-a",
          "directionId": 1,
          "headsign": "Kalvarijų g.",
          "directionName": "Rokantiškės–Olandų–Šeimyniškių–Kalvarijų g.",
          "mode": "bus",
          "routeShortName": "37",
          "routeLongName": "Kalvarijų–Tuskulėnų–Olandų g.–Rokantiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5512.692,
              -1852.928,
              0
            ],
            [
              5511.083,
              -1836.198,
              16.808
            ],
            [
              5476.092,
              -1812.139,
              59.272
            ],
            [
              5449.436,
              -1790.469,
              93.625
            ],
            [
              5407.999,
              -1766.286,
              141.602
            ],
            [
              5375.862,
              -1761.209,
              174.138
            ],
            [
              5338.483,
              -1760.484,
              211.524
            ],
            [
              5326.818,
              -1763.597,
              223.597
            ],
            [
              5307.117,
              -1782.141,
              250.652
            ],
            [
              5287.91,
              -1808.487,
              283.256
            ],
            [
              5270.23,
              -1822.617,
              305.89
            ],
            [
              5244.88,
              -1833.259,
              333.382
            ],
            [
              5198.35,
              -1839.037,
              380.27
            ],
            [
              5188.082,
              -1836.611,
              390.82
            ],
            [
              5172.593,
              -1837.425,
              406.33
            ],
            [
              5130.275,
              -1825.473,
              450.304
            ],
            [
              4985.466,
              -1779.256,
              602.309
            ],
            [
              4964.371,
              -1769.942,
              625.369
            ],
            [
              4940.762,
              -1757.24,
              652.178
            ],
            [
              4871.116,
              -1691.327,
              748.069
            ],
            [
              4817.859,
              -1611.257,
              844.233
            ],
            [
              4761.938,
              -1568.989,
              914.332
            ],
            [
              4588.816,
              -1418.705,
              1143.583
            ],
            [
              4569.994,
              -1391.625,
              1176.562
            ],
            [
              4540.215,
              -1364.334,
              1216.955
            ],
            [
              4535.101,
              -1362.01,
              1222.572
            ],
            [
              4527.905,
              -1367.438,
              1231.586
            ],
            [
              4514.993,
              -1368.303,
              1244.527
            ],
            [
              4508.053,
              -1360.377,
              1255.062
            ],
            [
              4508.224,
              -1351.474,
              1263.966
            ],
            [
              4516.108,
              -1343.832,
              1274.946
            ],
            [
              4516.172,
              -1340.494,
              1278.285
            ],
            [
              4469.197,
              -1234.945,
              1393.816
            ],
            [
              4407.8,
              -1107.967,
              1534.857
            ],
            [
              4295.883,
              -958.871,
              1721.285
            ],
            [
              4235.714,
              -902.055,
              1804.04
            ],
            [
              4227.329,
              -868.497,
              1838.63
            ],
            [
              4130.445,
              -741.958,
              1997.999
            ],
            [
              4108.048,
              -699.225,
              2046.245
            ],
            [
              4103.316,
              -676.87,
              2069.096
            ],
            [
              4104.061,
              -637.92,
              2108.053
            ],
            [
              4108.807,
              -625.765,
              2121.102
            ],
            [
              4110.996,
              -612.447,
              2134.598
            ],
            [
              4121.07,
              -591.488,
              2157.853
            ],
            [
              4169.369,
              -561.24,
              2214.841
            ],
            [
              4184.472,
              -547.057,
              2235.56
            ],
            [
              4200.284,
              -529.547,
              2259.153
            ],
            [
              4209.133,
              -505.225,
              2285.035
            ],
            [
              4205.025,
              -483.994,
              2306.659
            ],
            [
              4149.312,
              -396.094,
              2410.729
            ],
            [
              4133.472,
              -381.319,
              2432.39
            ],
            [
              4073.746,
              -334.533,
              2508.259
            ],
            [
              4027.903,
              -303.6,
              2563.562
            ],
            [
              3901.298,
              -246.634,
              2702.392
            ],
            [
              3784.624,
              -209.9,
              2824.713
            ],
            [
              3691.504,
              -189.202,
              2920.105
            ],
            [
              3594.389,
              -175.11,
              3018.237
            ],
            [
              3481.906,
              -155.162,
              3132.475
            ],
            [
              3433.85,
              -138.665,
              3183.284
            ],
            [
              3392.114,
              -128.967,
              3226.132
            ],
            [
              3396.087,
              -123.476,
              3232.91
            ],
            [
              3343.728,
              -95.766,
              3292.15
            ],
            [
              3282.595,
              -54.531,
              3365.89
            ],
            [
              2977.671,
              191.693,
              3757.815
            ],
            [
              2941.964,
              213.518,
              3799.664
            ],
            [
              2918.591,
              239.564,
              3834.659
            ],
            [
              2850.195,
              306.534,
              3930.383
            ],
            [
              2697.486,
              451.904,
              4141.22
            ],
            [
              2677.062,
              463.42,
              4164.667
            ],
            [
              2649.901,
              493.988,
              4205.558
            ],
            [
              2582.473,
              544.237,
              4289.651
            ],
            [
              2413.667,
              623.104,
              4475.972
            ],
            [
              2393.054,
              624.603,
              4496.639
            ],
            [
              2378.182,
              622.655,
              4511.638
            ],
            [
              2363.247,
              617.369,
              4527.481
            ],
            [
              2305.672,
              573.917,
              4599.613
            ],
            [
              2269.605,
              542.307,
              4647.571
            ],
            [
              2256.376,
              524.743,
              4669.56
            ],
            [
              2223.804,
              507.54,
              4706.396
            ],
            [
              1990.962,
              334.88,
              4996.27
            ],
            [
              1973.014,
              306.27,
              5030.043
            ],
            [
              1935.827,
              283.585,
              5073.603
            ],
            [
              1864.599,
              199.192,
              5184.037
            ],
            [
              1763.619,
              40.763,
              5371.911
            ],
            [
              1759.816,
              9.663,
              5403.243
            ],
            [
              1734.841,
              -15.477,
              5438.68
            ],
            [
              1714.048,
              -58.507,
              5486.47
            ],
            [
              1702.489,
              -90.576,
              5520.559
            ],
            [
              1692.553,
              -139.375,
              5570.358
            ],
            [
              1696.284,
              -216.258,
              5647.332
            ],
            [
              1701.445,
              -250.864,
              5682.321
            ],
            [
              1720.689,
              -325.809,
              5759.697
            ],
            [
              1735.144,
              -346.116,
              5784.624
            ],
            [
              1742.617,
              -429.749,
              5868.589
            ],
            [
              1739.19,
              -475.328,
              5914.297
            ],
            [
              1717.531,
              -565.098,
              6006.644
            ],
            [
              1721.402,
              -599.681,
              6041.442
            ],
            [
              1720.009,
              -605.221,
              6047.155
            ],
            [
              1712.088,
              -615.093,
              6059.812
            ],
            [
              1700.984,
              -622.679,
              6073.26
            ],
            [
              1684.224,
              -622.368,
              6090.023
            ],
            [
              1662.848,
              -627.537,
              6112.015
            ],
            [
              1381.451,
              -814.909,
              6450.087
            ],
            [
              1363.471,
              -845.747,
              6485.784
            ],
            [
              1363.126,
              -899.177,
              6539.214
            ],
            [
              1355.02,
              -919.065,
              6560.691
            ],
            [
              1339.886,
              -935.484,
              6583.021
            ],
            [
              1325.561,
              -943.011,
              6599.203
            ],
            [
              1293.291,
              -944.641,
              6631.514
            ],
            [
              1278.507,
              -942.141,
              6646.508
            ],
            [
              1268.297,
              -936.386,
              6658.228
            ],
            [
              1257.545,
              -925.054,
              6673.849
            ],
            [
              1253.197,
              -916.068,
              6683.832
            ],
            [
              1249.597,
              -901.529,
              6698.81
            ],
            [
              1250.468,
              -889.3,
              6711.07
            ],
            [
              1243.124,
              -868.013,
              6733.589
            ],
            [
              1234.408,
              -851.153,
              6752.568
            ],
            [
              1218.52,
              -838.613,
              6772.809
            ],
            [
              1192.86,
              -831.46,
              6799.447
            ],
            [
              1154.205,
              -829.633,
              6838.145
            ],
            [
              1120.288,
              -815.648,
              6874.833
            ],
            [
              1031.058,
              -793.963,
              6966.659
            ],
            [
              773.373,
              -745.803,
              7228.807
            ],
            [
              729.54,
              -744.998,
              7272.647
            ],
            [
              702.691,
              -732.259,
              7302.364
            ],
            [
              508.13,
              -687.5,
              7502.007
            ],
            [
              443.852,
              -676.304,
              7567.253
            ],
            [
              405.738,
              -680.059,
              7605.551
            ],
            [
              364.219,
              -693.772,
              7649.277
            ],
            [
              341.718,
              -690.021,
              7672.088
            ],
            [
              238.113,
              -713.732,
              7778.372
            ],
            [
              222.179,
              -844.803,
              7910.407
            ],
            [
              221.447,
              -884.866,
              7950.477
            ],
            [
              235.23,
              -977.516,
              8044.147
            ],
            [
              262.76,
              -1129.419,
              8198.525
            ],
            [
              277.464,
              -1242.125,
              8312.185
            ],
            [
              289.419,
              -1293.552,
              8364.984
            ],
            [
              297.35,
              -1318.188,
              8390.865
            ],
            [
              296.7,
              -1353.8,
              8426.483
            ],
            [
              342.249,
              -1718.661,
              8794.177
            ],
            [
              510.658,
              -1710.612,
              8962.778
            ],
            [
              549.551,
              -1699.08,
              9003.344
            ],
            [
              585.119,
              -1693.053,
              9039.42
            ],
            [
              616.278,
              -1681.379,
              9072.694
            ],
            [
              646.312,
              -1660.778,
              9109.114
            ],
            [
              673.267,
              -1632.329,
              9148.304
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -750,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6886",
              "position": {
                "x": 4871.116,
                "z": -1691.327
              },
              "distanceAlongShapeM": 748.069,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:17889",
              "position": {
                "x": 4588.816,
                "z": -1418.705
              },
              "distanceAlongShapeM": 1143.583,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6880",
              "position": {
                "x": 4235.714,
                "z": -902.055
              },
              "distanceAlongShapeM": 1804.04,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7588",
              "position": {
                "x": 4121.07,
                "z": -591.488
              },
              "distanceAlongShapeM": 2157.853,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5423",
              "position": {
                "x": 3392.114,
                "z": -128.967
              },
              "distanceAlongShapeM": 3226.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5424",
              "position": {
                "x": 2941.964,
                "z": 213.518
              },
              "distanceAlongShapeM": 3799.664,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5425",
              "position": {
                "x": 2677.062,
                "z": 463.42
              },
              "distanceAlongShapeM": 4164.667,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 4669.56,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 5030.043,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:603",
              "position": {
                "x": 1759.816,
                "z": 9.663
              },
              "distanceAlongShapeM": 5403.243,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6566",
              "position": {
                "x": 1735.144,
                "z": -346.116
              },
              "distanceAlongShapeM": 5784.624,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5662",
              "position": {
                "x": 1154.205,
                "z": -829.633
              },
              "distanceAlongShapeM": 6838.145,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5664",
              "position": {
                "x": 729.54,
                "z": -744.998
              },
              "distanceAlongShapeM": 7272.647,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 7649.277,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 8390.865,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6542",
              "position": {
                "x": 673.267,
                "z": -1632.329
              },
              "distanceAlongShapeM": 9148.304,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            }
          ],
          "departuresSeconds": [
            19740,
            22860,
            26460,
            30540,
            36420,
            39960,
            43560,
            46920,
            50460,
            54060,
            58080,
            62340,
            68700,
            72300,
            75720,
            79080
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_38",
      "sourceRouteId": "vilnius_bus_38",
      "mode": "bus",
      "shortName": "38",
      "longName": "Antakalnis–Dvarčionys–Šilėnų g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_38:0",
          "sourceRouteId": "vilnius_bus_38",
          "sourceShapeId": "vilnius_bus_38_a1-b1",
          "directionId": 0,
          "headsign": "Šilėnų g.",
          "directionName": "Antakalnis–Dvarčionys–Vismaliukai–Šilėnų g.",
          "mode": "bus",
          "routeShortName": "38",
          "routeLongName": "Antakalnis–Dvarčionys–Šilėnų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2562.319,
              -3823.788,
              0
            ],
            [
              2558.905,
              -3868.254,
              44.597
            ],
            [
              2551.422,
              -3889.265,
              66.901
            ],
            [
              2499.38,
              -3984.027,
              175.013
            ],
            [
              2491.567,
              -3988.334,
              183.935
            ],
            [
              2481.884,
              -3989.265,
              193.662
            ],
            [
              2463.931,
              -3984.475,
              212.243
            ],
            [
              2457.594,
              -3978.79,
              220.756
            ],
            [
              2451.32,
              -3969.766,
              231.747
            ],
            [
              2449.513,
              -3963.053,
              238.7
            ],
            [
              2474.189,
              -3849.964,
              354.449
            ],
            [
              2506.597,
              -3737.02,
              471.95
            ],
            [
              2515.783,
              -3728.287,
              484.625
            ],
            [
              2532.532,
              -3728.601,
              501.377
            ],
            [
              2540.76,
              -3736.549,
              512.816
            ],
            [
              2566.251,
              -3786.011,
              568.461
            ],
            [
              2598.162,
              -3836.707,
              628.365
            ],
            [
              2614.638,
              -3851.49,
              650.5
            ],
            [
              2636.723,
              -3876.397,
              683.789
            ],
            [
              2642.893,
              -3890.985,
              699.628
            ],
            [
              2709.56,
              -3977.961,
              809.215
            ],
            [
              3021.059,
              -4338.966,
              1286.034
            ],
            [
              3086.352,
              -4293.444,
              1365.63
            ],
            [
              3111.27,
              -4270.537,
              1399.477
            ],
            [
              3142.482,
              -4255.542,
              1434.104
            ],
            [
              3336.938,
              -4126.748,
              1667.344
            ],
            [
              3389.682,
              -4097.691,
              1727.563
            ],
            [
              3402.776,
              -4086.807,
              1744.59
            ],
            [
              3446.229,
              -4072.046,
              1790.481
            ],
            [
              3528.69,
              -4039.102,
              1879.28
            ],
            [
              3592.048,
              -4028.061,
              1943.593
            ],
            [
              3640.634,
              -4014.513,
              1994.032
            ],
            [
              3666.294,
              -4020.567,
              2020.397
            ],
            [
              3848.026,
              -4019.578,
              2202.132
            ],
            [
              3878.881,
              -4023.507,
              2233.236
            ],
            [
              3901.964,
              -4029.514,
              2257.088
            ],
            [
              3958.181,
              -4055.079,
              2318.845
            ],
            [
              3967.843,
              -4055.264,
              2328.508
            ],
            [
              4004.416,
              -4097.154,
              2384.117
            ],
            [
              4018.762,
              -4121.92,
              2412.739
            ],
            [
              4037.773,
              -4172.381,
              2466.661
            ],
            [
              4076.734,
              -4257.734,
              2560.487
            ],
            [
              4093.076,
              -4279.199,
              2587.465
            ],
            [
              4128.571,
              -4309.937,
              2634.419
            ],
            [
              4222.379,
              -4357.378,
              2739.541
            ],
            [
              4258.043,
              -4379.213,
              2781.358
            ],
            [
              4380.127,
              -4463.938,
              2929.961
            ],
            [
              4412.655,
              -4481.261,
              2966.814
            ],
            [
              4437.325,
              -4505.114,
              3001.129
            ],
            [
              4501.026,
              -4543.076,
              3075.285
            ],
            [
              4784.007,
              -4703.272,
              3400.463
            ],
            [
              4912.858,
              -4770.329,
              3545.718
            ],
            [
              4956.995,
              -4786.768,
              3592.818
            ],
            [
              4975.65,
              -4788.242,
              3611.531
            ],
            [
              5002.978,
              -4807.696,
              3645.076
            ],
            [
              5509.413,
              -5004.55,
              4188.425
            ],
            [
              5765.06,
              -5109.726,
              4464.862
            ],
            [
              5806.767,
              -5118.333,
              4507.448
            ],
            [
              5878.72,
              -5128.645,
              4580.136
            ],
            [
              5891.491,
              -5134.461,
              4594.168
            ],
            [
              5956.294,
              -5147.973,
              4660.365
            ],
            [
              5988.132,
              -5134.123,
              4695.086
            ],
            [
              5996.656,
              -5126.497,
              4706.523
            ],
            [
              6011.57,
              -4989.855,
              4843.977
            ],
            [
              6021.457,
              -4945.517,
              4889.404
            ],
            [
              6027.558,
              -4930.051,
              4906.03
            ],
            [
              6092.568,
              -4834.468,
              5021.626
            ],
            [
              6127.551,
              -4791.735,
              5076.852
            ],
            [
              6152.504,
              -4767.731,
              5111.476
            ],
            [
              6159.829,
              -4755.629,
              5125.622
            ],
            [
              6161.4,
              -4741.187,
              5140.15
            ],
            [
              6125.058,
              -4655.865,
              5232.888
            ],
            [
              6001.369,
              -4687.956,
              5360.673
            ],
            [
              5943.166,
              -4699.064,
              5419.927
            ],
            [
              5886.829,
              -4713.549,
              5478.096
            ],
            [
              5851.081,
              -4729.55,
              5517.262
            ],
            [
              5840.819,
              -4727.123,
              5527.806
            ],
            [
              5838.439,
              -4717.057,
              5538.15
            ],
            [
              5840.414,
              -4714.869,
              5541.098
            ],
            [
              5874.614,
              -4712.197,
              5575.402
            ],
            [
              5916.029,
              -4702.987,
              5617.828
            ],
            [
              6087.551,
              -4662.924,
              5793.967
            ],
            [
              6114.775,
              -4654.551,
              5822.45
            ],
            [
              6125.058,
              -4655.865,
              5832.817
            ],
            [
              6139.053,
              -4665.046,
              5849.554
            ],
            [
              6147.186,
              -4677.451,
              5864.388
            ],
            [
              6159.97,
              -4715.553,
              5904.577
            ],
            [
              6163.114,
              -4752.353,
              5941.511
            ],
            [
              6148.487,
              -4775.446,
              5968.846
            ],
            [
              6122.934,
              -4797.211,
              6002.412
            ],
            [
              6095.897,
              -4828.966,
              6044.119
            ],
            [
              6024.895,
              -4934.452,
              6171.274
            ],
            [
              6018.15,
              -4949.906,
              6188.136
            ],
            [
              6009.703,
              -4986.479,
              6225.672
            ],
            [
              6002.309,
              -5101.002,
              6340.434
            ],
            [
              6002.517,
              -5123.272,
              6362.704
            ],
            [
              6008.718,
              -5135.639,
              6376.539
            ],
            [
              6016.589,
              -5161.399,
              6403.474
            ],
            [
              6030.604,
              -5169.466,
              6419.645
            ],
            [
              6078.772,
              -5177.089,
              6468.413
            ],
            [
              6272.282,
              -5197.581,
              6663.005
            ],
            [
              6739.794,
              -5240.179,
              7132.454
            ],
            [
              6910.827,
              -5256.916,
              7304.303
            ],
            [
              7009.8,
              -5268.893,
              7403.998
            ],
            [
              7655.857,
              -5403.073,
              8063.842
            ],
            [
              7709.038,
              -5417.492,
              8118.944
            ],
            [
              7740.925,
              -5433.715,
              8154.72
            ],
            [
              7791.019,
              -5473.68,
              8218.803
            ],
            [
              7852.17,
              -5508.3,
              8289.074
            ],
            [
              7919.006,
              -5516.315,
              8356.389
            ],
            [
              7947.983,
              -5516.895,
              8385.372
            ],
            [
              7967.101,
              -5527.297,
              8407.136
            ],
            [
              7968.81,
              -5538.464,
              8418.433
            ],
            [
              7801.253,
              -5670.938,
              8632.032
            ],
            [
              7791.372,
              -5681.873,
              8646.771
            ],
            [
              7782.646,
              -5699.512,
              8666.45
            ],
            [
              7724.095,
              -5954.402,
              8927.978
            ],
            [
              7696.143,
              -6031.775,
              9010.246
            ],
            [
              7655.004,
              -6156.757,
              9141.824
            ],
            [
              7645.325,
              -6189.963,
              9176.412
            ],
            [
              7635.934,
              -6240.988,
              9228.294
            ],
            [
              7604.789,
              -6349.47,
              9341.159
            ],
            [
              7581.015,
              -6443.627,
              9438.27
            ],
            [
              7581.97,
              -6460.345,
              9455.016
            ],
            [
              7624.685,
              -6611.491,
              9612.082
            ],
            [
              7818.878,
              -6820.214,
              9897.171
            ],
            [
              7824.11,
              -7009.579,
              10086.609
            ],
            [
              7811.812,
              -7044.959,
              10124.065
            ],
            [
              7822.133,
              -7044.052,
              10134.427
            ],
            [
              7890.037,
              -6997.537,
              10216.734
            ],
            [
              7946.909,
              -6955.256,
              10287.601
            ],
            [
              8132.733,
              -6873.253,
              10490.715
            ],
            [
              8270.1,
              -6831.477,
              10634.293
            ],
            [
              8500.803,
              -6728.124,
              10887.089
            ],
            [
              8661.032,
              -6734.692,
              11047.453
            ],
            [
              8726.149,
              -6795.011,
              11136.214
            ],
            [
              8743.77,
              -6815.406,
              11163.167
            ],
            [
              8769.288,
              -6859.34,
              11213.974
            ],
            [
              8811.72,
              -6990.454,
              11351.783
            ],
            [
              8831.996,
              -7038.735,
              11404.15
            ],
            [
              8840.288,
              -7074.529,
              11440.891
            ],
            [
              8842.787,
              -7110.205,
              11476.655
            ],
            [
              8833.916,
              -7166.805,
              11533.945
            ],
            [
              8808.211,
              -7259.803,
              11630.431
            ],
            [
              8804.858,
              -7266.415,
              11637.845
            ],
            [
              8689.309,
              -7344.241,
              11777.159
            ],
            [
              8711.254,
              -7373.63,
              11813.836
            ],
            [
              8754.783,
              -7450.213,
              11901.926
            ],
            [
              8815.27,
              -7516.006,
              11991.299
            ],
            [
              8840.873,
              -7555.49,
              12038.356
            ],
            [
              8838.717,
              -7566.579,
              12049.654
            ],
            [
              8830.813,
              -7575.326,
              12061.442
            ],
            [
              8740.224,
              -7629.162,
              12166.821
            ],
            [
              8636.103,
              -7460.065,
              12365.404
            ],
            [
              8621.568,
              -7446.412,
              12385.345
            ],
            [
              8611.785,
              -7420.609,
              12412.94
            ],
            [
              8598.028,
              -7400.292,
              12437.477
            ],
            [
              8710.221,
              -7329.076,
              12570.363
            ],
            [
              8772.381,
              -7280.232,
              12649.418
            ],
            [
              8800.928,
              -7269.676,
              12679.854
            ],
            [
              8831.828,
              -7174.556,
              12779.867
            ],
            [
              8841.163,
              -7126.872,
              12828.456
            ],
            [
              8842.04,
              -7083.471,
              12871.866
            ],
            [
              8822.812,
              -7015.17,
              12942.821
            ],
            [
              8792.843,
              -6936.634,
              13026.882
            ],
            [
              8763.786,
              -6844.756,
              13123.245
            ],
            [
              8731.898,
              -6797.353,
              13180.375
            ],
            [
              8683.115,
              -6757.403,
              13243.429
            ],
            [
              8666.714,
              -6740.373,
              13267.073
            ],
            [
              8681.034,
              -6732.869,
              13283.24
            ],
            [
              8768.81,
              -6723.507,
              13371.514
            ],
            [
              8836.787,
              -6705.953,
              13441.721
            ],
            [
              8904.959,
              -6710.671,
              13510.056
            ],
            [
              8918.433,
              -6713.17,
              13523.76
            ],
            [
              8935.657,
              -6721.312,
              13542.811
            ],
            [
              8953.435,
              -6733.917,
              13564.604
            ],
            [
              8964.153,
              -6745.267,
              13580.216
            ],
            [
              8991.375,
              -6800.37,
              13641.676
            ],
            [
              9004.489,
              -6820.675,
              13665.847
            ],
            [
              9020.866,
              -6838.82,
              13690.29
            ],
            [
              9048.096,
              -6861.637,
              13725.816
            ],
            [
              9099.676,
              -6890.515,
              13784.929
            ],
            [
              9130.35,
              -6902.269,
              13817.778
            ],
            [
              9162.356,
              -6911.825,
              13851.181
            ],
            [
              9247.126,
              -6923.564,
              13936.76
            ],
            [
              9337.78,
              -6930.971,
              14027.715
            ],
            [
              9409.674,
              -6942.452,
              14100.521
            ],
            [
              9455.198,
              -6952.284,
              14147.094
            ],
            [
              9476.26,
              -6961.619,
              14170.132
            ],
            [
              9516.983,
              -6985.828,
              14217.508
            ],
            [
              9530.873,
              -6999.47,
              14236.977
            ],
            [
              9549.754,
              -7021.007,
              14265.619
            ],
            [
              9558.844,
              -7049.025,
              14295.074
            ],
            [
              9556.777,
              -7055.663,
              14302.026
            ],
            [
              9542.592,
              -7056.488,
              14316.235
            ],
            [
              9536.957,
              -7048.58,
              14325.945
            ],
            [
              9537.116,
              -7040.79,
              14333.736
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 683.789,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 1399.477,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 1744.59,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 1994.032,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 2328.508,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6170",
              "position": {
                "x": 4412.655,
                "z": -4481.261
              },
              "distanceAlongShapeM": 2966.814,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6174",
              "position": {
                "x": 4975.65,
                "z": -4788.242
              },
              "distanceAlongShapeM": 3611.531,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6176",
              "position": {
                "x": 5878.72,
                "z": -5128.645
              },
              "distanceAlongShapeM": 4580.136,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6179",
              "position": {
                "x": 6139.84,
                "z": -4690.667
              },
              "distanceAlongShapeM": 5195.078,
              "shapeOffsetM": 0.038,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6181",
              "position": {
                "x": 5860.806,
                "z": -4726.4
              },
              "distanceAlongShapeM": 5507.098,
              "shapeOffsetM": 1.098,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8250",
              "position": {
                "x": 6147.186,
                "z": -4677.451
              },
              "distanceAlongShapeM": 5864.388,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6183",
              "position": {
                "x": 7009.8,
                "z": -5268.893
              },
              "distanceAlongShapeM": 7403.998,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:16307",
              "position": {
                "x": 7913.164,
                "z": -5582.996
              },
              "distanceAlongShapeM": 8489.704,
              "shapeOffsetM": 0.422,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6895",
              "position": {
                "x": 7635.934,
                "z": -6240.988
              },
              "distanceAlongShapeM": 9228.294,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6899",
              "position": {
                "x": 7824.11,
                "z": -7009.579
              },
              "distanceAlongShapeM": 10086.609,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:16425",
              "position": {
                "x": 8711.254,
                "z": -7373.63
              },
              "distanceAlongShapeM": 11813.836,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:17952",
              "position": {
                "x": 8787.127,
                "z": -7602.276
              },
              "distanceAlongShapeM": 12112.765,
              "shapeOffsetM": 0.85,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:16424",
              "position": {
                "x": 8621.568,
                "z": -7446.412
              },
              "distanceAlongShapeM": 12385.345,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:16422",
              "position": {
                "x": 8772.381,
                "z": -7280.232
              },
              "distanceAlongShapeM": 12649.418,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6901",
              "position": {
                "x": 8836.787,
                "z": -6705.953
              },
              "distanceAlongShapeM": 13441.721,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:976",
              "position": {
                "x": 9537.116,
                "z": -7040.79
              },
              "distanceAlongShapeM": 14333.736,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            23940,
            26520,
            29040,
            31500,
            34140,
            38160,
            43200,
            48120,
            53400,
            55800,
            58320,
            60840,
            65760
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_38:1",
          "sourceRouteId": "vilnius_bus_38",
          "sourceShapeId": "vilnius_bus_38_b1-a1",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Šilėnų g.–Vismaliukai–Dvarčionys–Antakalnis",
          "mode": "bus",
          "routeShortName": "38",
          "routeLongName": "Antakalnis–Dvarčionys–Šilėnų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9537.116,
              -7040.79,
              0
            ],
            [
              9533.503,
              -7028.47,
              12.839
            ],
            [
              9534.35,
              -7018.467,
              22.877
            ],
            [
              9531.404,
              -7005.047,
              36.617
            ],
            [
              9525.148,
              -6996.014,
              47.605
            ],
            [
              9464.12,
              -6956.919,
              120.081
            ],
            [
              9445.61,
              -6948.749,
              140.314
            ],
            [
              9357.668,
              -6934.715,
              229.369
            ],
            [
              9243.885,
              -6924.612,
              343.6
            ],
            [
              9201.489,
              -6919.298,
              386.328
            ],
            [
              9186.773,
              -6914.546,
              401.791
            ],
            [
              9163.621,
              -6912.964,
              424.997
            ],
            [
              9088.201,
              -6884.716,
              505.534
            ],
            [
              9029.675,
              -6849.018,
              574.087
            ],
            [
              9005.641,
              -6827.378,
              606.428
            ],
            [
              8992.924,
              -6819.328,
              621.479
            ],
            [
              8980.103,
              -6784.556,
              658.539
            ],
            [
              8955.253,
              -6739.521,
              709.975
            ],
            [
              8930.507,
              -6721.207,
              740.761
            ],
            [
              8899.142,
              -6711.667,
              773.545
            ],
            [
              8842.491,
              -6710.522,
              830.208
            ],
            [
              8819.091,
              -6721.182,
              855.922
            ],
            [
              8761.085,
              -6723.351,
              913.968
            ],
            [
              8693.31,
              -6730.89,
              982.161
            ],
            [
              8677.77,
              -6735.03,
              998.243
            ],
            [
              8670.067,
              -6733.761,
              1006.05
            ],
            [
              8668.069,
              -6737.061,
              1009.907
            ],
            [
              8667.934,
              -6743.738,
              1016.586
            ],
            [
              8738.777,
              -6807.512,
              1111.906
            ],
            [
              8766.758,
              -6857.062,
              1168.811
            ],
            [
              8790.979,
              -6933.256,
              1248.762
            ],
            [
              8839.802,
              -7066.726,
              1390.881
            ],
            [
              8841.972,
              -7086.809,
              1411.081
            ],
            [
              8841.253,
              -7122.42,
              1446.7
            ],
            [
              8828.961,
              -7188.971,
              1514.376
            ],
            [
              8810.232,
              -7255.391,
              1583.386
            ],
            [
              8802.216,
              -7269.702,
              1599.789
            ],
            [
              8688.022,
              -7344.215,
              1736.143
            ],
            [
              8711.254,
              -7373.63,
              1773.626
            ],
            [
              8754.783,
              -7450.213,
              1861.716
            ],
            [
              8815.27,
              -7516.006,
              1951.088
            ],
            [
              8840.873,
              -7555.49,
              1998.146
            ],
            [
              8838.717,
              -7566.579,
              2009.443
            ],
            [
              8830.813,
              -7575.326,
              2021.232
            ],
            [
              8740.224,
              -7629.162,
              2126.611
            ],
            [
              8636.103,
              -7460.065,
              2325.193
            ],
            [
              8621.568,
              -7446.412,
              2345.134
            ],
            [
              8611.785,
              -7420.609,
              2372.73
            ],
            [
              8598.028,
              -7400.292,
              2397.266
            ],
            [
              8710.221,
              -7329.076,
              2530.153
            ],
            [
              8772.381,
              -7280.232,
              2609.208
            ],
            [
              8804.835,
              -7267.528,
              2644.059
            ],
            [
              8815.899,
              -7229.899,
              2683.281
            ],
            [
              8832.935,
              -7183.484,
              2732.724
            ],
            [
              8843.184,
              -7122.459,
              2794.603
            ],
            [
              8841.86,
              -7092.373,
              2824.718
            ],
            [
              8836.232,
              -7052.181,
              2865.303
            ],
            [
              8800.096,
              -6960.16,
              2964.165
            ],
            [
              8772.993,
              -6867.208,
              3060.988
            ],
            [
              8755.687,
              -6831.233,
              3100.909
            ],
            [
              8740.731,
              -6806.438,
              3129.865
            ],
            [
              8660.965,
              -6738.031,
              3234.947
            ],
            [
              8507.929,
              -6726.041,
              3388.452
            ],
            [
              8370.199,
              -6785.616,
              3538.514
            ],
            [
              8277.203,
              -6830.506,
              3641.778
            ],
            [
              8157.951,
              -6868.192,
              3766.843
            ],
            [
              8080.122,
              -6895.578,
              3849.35
            ],
            [
              7948.907,
              -6951.956,
              3992.164
            ],
            [
              7916.164,
              -6979.133,
              4034.716
            ],
            [
              7854.054,
              -7025.764,
              4112.383
            ],
            [
              7826.018,
              -7043.016,
              4145.301
            ],
            [
              7811.812,
              -7044.959,
              4159.64
            ],
            [
              7806.73,
              -7009.232,
              4195.727
            ],
            [
              7814.771,
              -6832.378,
              4372.763
            ],
            [
              7811.308,
              -6812.269,
              4393.168
            ],
            [
              7628.348,
              -6621.584,
              4657.431
            ],
            [
              7581.97,
              -6460.345,
              4825.208
            ],
            [
              7581.592,
              -6446.978,
              4838.58
            ],
            [
              7614.845,
              -6297.345,
              4991.863
            ],
            [
              7650.941,
              -6166.696,
              5127.408
            ],
            [
              7709.064,
              -5997.521,
              5306.289
            ],
            [
              7737.395,
              -5901.229,
              5406.662
            ],
            [
              7780.648,
              -5702.812,
              5609.738
            ],
            [
              7791.372,
              -5681.873,
              5633.264
            ],
            [
              7932.238,
              -5563.338,
              5817.366
            ],
            [
              7942.83,
              -5549.077,
              5835.131
            ],
            [
              7942.986,
              -5541.287,
              5842.922
            ],
            [
              7938.723,
              -5528.956,
              5855.97
            ],
            [
              7929.82,
              -5523.211,
              5866.566
            ],
            [
              7918.962,
              -5518.541,
              5878.386
            ],
            [
              7891.85,
              -5521.339,
              5905.641
            ],
            [
              6930.636,
              -5265.1,
              6900.423
            ],
            [
              6784.784,
              -5245.52,
              7047.583
            ],
            [
              6137.243,
              -5184.914,
              7697.954
            ],
            [
              6011.263,
              -5170.201,
              7824.791
            ],
            [
              5986.3,
              -5161.92,
              7851.092
            ],
            [
              5981.213,
              -5158.48,
              7857.232
            ],
            [
              5980.83,
              -5145.113,
              7870.604
            ],
            [
              5992.039,
              -5131.973,
              7887.876
            ],
            [
              5997.387,
              -5122.058,
              7899.141
            ],
            [
              6009.977,
              -5005.41,
              8016.467
            ],
            [
              6011.962,
              -4969.824,
              8052.108
            ],
            [
              6022.232,
              -4938.853,
              8084.738
            ],
            [
              6026.936,
              -4928.925,
              8095.723
            ],
            [
              6101.223,
              -4820.164,
              8227.433
            ],
            [
              6130.193,
              -4788.447,
              8270.39
            ],
            [
              6148.553,
              -4772.107,
              8294.967
            ],
            [
              6156.478,
              -4762.243,
              8307.621
            ],
            [
              6161.248,
              -4748.977,
              8321.718
            ],
            [
              6159.686,
              -4730.021,
              8340.739
            ],
            [
              6139.84,
              -4690.667,
              8384.814
            ],
            [
              6125.058,
              -4655.865,
              8422.624
            ],
            [
              6001.369,
              -4687.956,
              8550.408
            ],
            [
              5943.166,
              -4699.064,
              8609.662
            ],
            [
              5886.829,
              -4713.549,
              8667.831
            ],
            [
              5851.081,
              -4729.55,
              8706.997
            ],
            [
              5840.819,
              -4727.123,
              8717.542
            ],
            [
              5838.439,
              -4717.057,
              8727.885
            ],
            [
              5840.414,
              -4714.869,
              8730.833
            ],
            [
              5874.614,
              -4712.197,
              8765.137
            ],
            [
              5916.029,
              -4702.987,
              8807.564
            ],
            [
              6087.551,
              -4662.924,
              8983.702
            ],
            [
              6114.775,
              -4654.551,
              9012.186
            ],
            [
              6125.058,
              -4655.865,
              9022.552
            ],
            [
              6139.053,
              -4665.046,
              9039.29
            ],
            [
              6147.186,
              -4677.451,
              9054.123
            ],
            [
              6161.171,
              -4720.03,
              9098.94
            ],
            [
              6163.78,
              -4751.253,
              9130.272
            ],
            [
              6151.795,
              -4771.057,
              9153.42
            ],
            [
              6112.346,
              -4811.476,
              9209.899
            ],
            [
              6090.548,
              -4838.881,
              9244.916
            ],
            [
              6026.248,
              -4931.138,
              9357.37
            ],
            [
              6016.775,
              -4954.332,
              9382.424
            ],
            [
              6009.203,
              -5012.074,
              9440.661
            ],
            [
              6000.05,
              -5117.657,
              9546.639
            ],
            [
              6010.006,
              -5135.665,
              9567.215
            ],
            [
              6013.543,
              -5152.433,
              9584.353
            ],
            [
              6017.855,
              -5162.537,
              9595.338
            ],
            [
              6016.502,
              -5165.85,
              9598.918
            ],
            [
              5956.294,
              -5147.973,
              9661.723
            ],
            [
              5813.742,
              -5124.036,
              9806.271
            ],
            [
              5758.62,
              -5109.601,
              9863.252
            ],
            [
              5655.118,
              -5065.278,
              9975.845
            ],
            [
              5349.449,
              -4948.004,
              10303.238
            ],
            [
              5090.521,
              -4845.015,
              10581.897
            ],
            [
              4956.995,
              -4786.768,
              10727.574
            ],
            [
              4921.724,
              -4778.293,
              10763.849
            ],
            [
              4893.064,
              -4761.041,
              10797.301
            ],
            [
              4762.926,
              -4693.959,
              10943.712
            ],
            [
              4470.367,
              -4529.128,
              11279.509
            ],
            [
              4430.884,
              -4504.99,
              11325.786
            ],
            [
              4360.976,
              -4454.664,
              11411.924
            ],
            [
              4344.358,
              -4447.665,
              11429.956
            ],
            [
              4316.488,
              -4422.639,
              11467.413
            ],
            [
              4266.267,
              -4387.164,
              11528.9
            ],
            [
              4203.85,
              -4349.23,
              11601.941
            ],
            [
              4164.858,
              -4332.897,
              11644.215
            ],
            [
              4107.571,
              -4296.175,
              11712.261
            ],
            [
              4086.034,
              -4276.838,
              11741.206
            ],
            [
              4071.539,
              -4259.861,
              11763.528
            ],
            [
              4054.871,
              -4221.691,
              11805.179
            ],
            [
              4018.762,
              -4121.92,
              11911.283
            ],
            [
              3999.262,
              -4097.055,
              11942.882
            ],
            [
              3970.079,
              -4073.119,
              11980.626
            ],
            [
              3943.967,
              -4057.034,
              12011.295
            ],
            [
              3898.552,
              -4039.468,
              12059.989
            ],
            [
              3898.616,
              -4036.13,
              12063.328
            ],
            [
              3858.828,
              -4027.577,
              12104.024
            ],
            [
              3592.048,
              -4028.061,
              12370.805
            ],
            [
              3581.678,
              -4031.203,
              12381.64
            ],
            [
              3565.986,
              -4043.151,
              12401.363
            ],
            [
              3520.083,
              -4051.184,
              12447.964
            ],
            [
              3445.458,
              -4078.711,
              12527.504
            ],
            [
              3358.965,
              -4120.486,
              12623.557
            ],
            [
              3360.169,
              -4124.962,
              12628.192
            ],
            [
              3310.064,
              -4150.73,
              12684.534
            ],
            [
              3021.059,
              -4338.966,
              13029.436
            ],
            [
              2959.695,
              -4278.804,
              13115.372
            ],
            [
              2937.404,
              -4265.024,
              13141.578
            ],
            [
              2920.517,
              -4237.987,
              13173.456
            ],
            [
              2810.169,
              -4110.107,
              13342.364
            ],
            [
              2739.116,
              -4050.879,
              13434.865
            ],
            [
              2661.391,
              -4003.772,
              13525.752
            ],
            [
              2636.416,
              -3995.509,
              13552.058
            ],
            [
              2609.738,
              -3974.969,
              13585.727
            ],
            [
              2501.467,
              -3907.252,
              13713.431
            ],
            [
              2488.357,
              -3884.741,
              13739.481
            ],
            [
              2476.247,
              -3843.323,
              13782.633
            ],
            [
              2501.318,
              -3743.601,
              13885.459
            ],
            [
              2515.139,
              -3728.275,
              13906.096
            ],
            [
              2523.534,
              -3727.319,
              13914.545
            ],
            [
              2540.053,
              -3739.875,
              13935.294
            ],
            [
              2551,
              -3774.592,
              13971.696
            ],
            [
              2562.319,
              -3823.788,
              14022.177
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:976",
              "position": {
                "x": 9537.116,
                "z": -7040.79
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6902",
              "position": {
                "x": 8819.091,
                "z": -6721.182
              },
              "distanceAlongShapeM": 855.922,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:16425",
              "position": {
                "x": 8711.254,
                "z": -7373.63
              },
              "distanceAlongShapeM": 1773.626,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:17952",
              "position": {
                "x": 8787.127,
                "z": -7602.276
              },
              "distanceAlongShapeM": 2072.555,
              "shapeOffsetM": 0.85,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:16424",
              "position": {
                "x": 8621.568,
                "z": -7446.412
              },
              "distanceAlongShapeM": 2345.134,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:16422",
              "position": {
                "x": 8772.381,
                "z": -7280.232
              },
              "distanceAlongShapeM": 2609.208,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6898",
              "position": {
                "x": 7806.73,
                "z": -7009.232
              },
              "distanceAlongShapeM": 4195.727,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6896",
              "position": {
                "x": 7614.845,
                "z": -6297.345
              },
              "distanceAlongShapeM": 4991.863,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:16306",
              "position": {
                "x": 7891.85,
                "z": -5521.339
              },
              "distanceAlongShapeM": 5905.641,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6184",
              "position": {
                "x": 6930.636,
                "z": -5265.1
              },
              "distanceAlongShapeM": 6900.423,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6179",
              "position": {
                "x": 6139.84,
                "z": -4690.667
              },
              "distanceAlongShapeM": 8384.814,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:429",
              "position": {
                "x": 5873.348,
                "z": -4711.059
              },
              "distanceAlongShapeM": 8763.963,
              "shapeOffsetM": 1.233,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6180",
              "position": {
                "x": 6155.144,
                "z": -4698.76
              },
              "distanceAlongShapeM": 9076.851,
              "shapeOffsetM": 0.912,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6177",
              "position": {
                "x": 5813.742,
                "z": -5124.036
              },
              "distanceAlongShapeM": 9806.271,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6173",
              "position": {
                "x": 4921.724,
                "z": -4778.293
              },
              "distanceAlongShapeM": 10763.849,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1350,
              "departureOffsetSeconds": 1350
            },
            {
              "stopId": "judu:stop:6171",
              "position": {
                "x": 4344.358,
                "z": -4447.665
              },
              "distanceAlongShapeM": 11429.956,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1410,
              "departureOffsetSeconds": 1410
            },
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 12059.989,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 12401.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 12628.192,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 13141.578,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 13552.058,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 14022.177,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1890,
              "departureOffsetSeconds": 1890
            }
          ],
          "departuresSeconds": [
            26520,
            29040,
            31440,
            33840,
            37020,
            40680,
            45540,
            50820,
            55860,
            58380,
            60780,
            63300,
            65760,
            68160
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_39",
      "sourceRouteId": "vilnius_bus_39",
      "mode": "bus",
      "shortName": "39",
      "longName": "Antakalnis–Nemenčinės pl.–Balžio g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_39:0",
          "sourceRouteId": "vilnius_bus_39",
          "sourceShapeId": "vilnius_bus_39_a-b",
          "directionId": 0,
          "headsign": "Balžio g.",
          "directionName": "Antakalnis–Nemenčinės pl.–Balžio g.",
          "mode": "bus",
          "routeShortName": "39",
          "routeLongName": "Antakalnis–Nemenčinės pl.–Balžio g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2562.319,
              -3823.788,
              0
            ],
            [
              2558.905,
              -3868.254,
              44.597
            ],
            [
              2551.422,
              -3889.265,
              66.901
            ],
            [
              2499.38,
              -3984.027,
              175.013
            ],
            [
              2491.567,
              -3988.334,
              183.935
            ],
            [
              2481.884,
              -3989.265,
              193.662
            ],
            [
              2463.931,
              -3984.475,
              212.243
            ],
            [
              2457.594,
              -3978.79,
              220.756
            ],
            [
              2451.32,
              -3969.766,
              231.747
            ],
            [
              2449.513,
              -3963.053,
              238.7
            ],
            [
              2474.189,
              -3849.964,
              354.449
            ],
            [
              2506.597,
              -3737.02,
              471.95
            ],
            [
              2515.783,
              -3728.287,
              484.625
            ],
            [
              2532.532,
              -3728.601,
              501.377
            ],
            [
              2540.76,
              -3736.549,
              512.816
            ],
            [
              2566.251,
              -3786.011,
              568.461
            ],
            [
              2598.162,
              -3836.707,
              628.365
            ],
            [
              2614.638,
              -3851.49,
              650.5
            ],
            [
              2636.723,
              -3876.397,
              683.789
            ],
            [
              2642.893,
              -3890.985,
              699.628
            ],
            [
              2709.56,
              -3977.961,
              809.215
            ],
            [
              3021.059,
              -4338.966,
              1286.034
            ],
            [
              3040.626,
              -4360.488,
              1315.121
            ],
            [
              3057.099,
              -4375.272,
              1337.255
            ],
            [
              3068.958,
              -4395.535,
              1360.733
            ],
            [
              3153.475,
              -4491.761,
              1488.806
            ],
            [
              3273.19,
              -4634.3,
              1674.949
            ],
            [
              3311.137,
              -4671.757,
              1728.269
            ],
            [
              3335.252,
              -4691.14,
              1759.208
            ],
            [
              3345.219,
              -4709.142,
              1779.784
            ],
            [
              3435.309,
              -4816.612,
              1920.02
            ],
            [
              3777.629,
              -5210.544,
              2441.907
            ],
            [
              4146.188,
              -5643.971,
              3010.848
            ],
            [
              4170.98,
              -5661.145,
              3041.008
            ],
            [
              4198.544,
              -5701.751,
              3090.086
            ],
            [
              4481.556,
              -6024.468,
              3519.32
            ],
            [
              4582.817,
              -6151.103,
              3681.463
            ],
            [
              4780.064,
              -6376.448,
              3980.94
            ],
            [
              4845.472,
              -6457.867,
              4085.378
            ],
            [
              4963.748,
              -6636.051,
              4299.244
            ],
            [
              4993.701,
              -6685.615,
              4357.156
            ],
            [
              5058.349,
              -6772.589,
              4465.525
            ],
            [
              5115.634,
              -6873.894,
              4581.904
            ],
            [
              5492.477,
              -7463.46,
              5281.617
            ],
            [
              5515.215,
              -7486.168,
              5313.753
            ],
            [
              5529.947,
              -7523.193,
              5353.602
            ],
            [
              5547.492,
              -7548.027,
              5384.008
            ],
            [
              5756.997,
              -7898.345,
              5792.193
            ],
            [
              5983.517,
              -8265.706,
              6223.778
            ],
            [
              6029.809,
              -8334.524,
              6306.716
            ],
            [
              6506.105,
              -9352.524,
              7430.63
            ],
            [
              6638.284,
              -9666.853,
              7771.62
            ],
            [
              6650.206,
              -9714.96,
              7821.182
            ],
            [
              6653.677,
              -9767.354,
              7873.69
            ],
            [
              6674.775,
              -9774.45,
              7895.95
            ],
            [
              6698.847,
              -9793.851,
              7926.867
            ],
            [
              6738.316,
              -9815.783,
              7972.02
            ],
            [
              6759.842,
              -9866.307,
              8026.939
            ],
            [
              6768.205,
              -9866.472,
              8035.303
            ],
            [
              6775.128,
              -9874.402,
              8045.83
            ],
            [
              6776.838,
              -9885.569,
              8057.127
            ],
            [
              6822.98,
              -9895.388,
              8104.302
            ],
            [
              7045.916,
              -10076.817,
              8391.734
            ],
            [
              7141.927,
              -10167.786,
              8523.997
            ],
            [
              7431.846,
              -10377.284,
              8881.687
            ],
            [
              7902.025,
              -10709.532,
              9457.41
            ],
            [
              7950.707,
              -10720.526,
              9507.318
            ],
            [
              8244.143,
              -10943.51,
              9875.864
            ],
            [
              8873.576,
              -11380.378,
              10642.049
            ],
            [
              9040.894,
              -11505.119,
              10850.749
            ],
            [
              9092.814,
              -11546.252,
              10916.988
            ],
            [
              9202.043,
              -11616.382,
              11046.793
            ],
            [
              9361.74,
              -11735.414,
              11245.971
            ],
            [
              9477.369,
              -11806.795,
              11381.858
            ],
            [
              9539.313,
              -11829.211,
              11447.732
            ],
            [
              9559.02,
              -11840.746,
              11470.567
            ],
            [
              9629.406,
              -11827.709,
              11542.151
            ],
            [
              9651.867,
              -11830.394,
              11564.771
            ],
            [
              9678.05,
              -11839.835,
              11592.604
            ],
            [
              9735.52,
              -11892.222,
              11670.368
            ],
            [
              9760.279,
              -11908.315,
              11699.898
            ],
            [
              9778.193,
              -11913.134,
              11718.448
            ],
            [
              9989.041,
              -11951.963,
              11932.842
            ],
            [
              10008.24,
              -11956.81,
              11952.643
            ],
            [
              10014.488,
              -11965.845,
              11963.628
            ],
            [
              10013.088,
              -11971.383,
              11969.34
            ],
            [
              10009.184,
              -11973.529,
              11973.795
            ],
            [
              9977.079,
              -11970.645,
              12006.03
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 683.789,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:3566",
              "position": {
                "x": 3057.099,
                "z": -4375.272
              },
              "distanceAlongShapeM": 1337.255,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6081",
              "position": {
                "x": 3335.252,
                "z": -4691.14
              },
              "distanceAlongShapeM": 1759.208,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:950",
              "position": {
                "x": 3777.629,
                "z": -5210.544
              },
              "distanceAlongShapeM": 2441.907,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6140",
              "position": {
                "x": 4170.98,
                "z": -5661.145
              },
              "distanceAlongShapeM": 3041.008,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6143",
              "position": {
                "x": 4481.556,
                "z": -6024.468
              },
              "distanceAlongShapeM": 3519.32,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6147",
              "position": {
                "x": 5058.349,
                "z": -6772.589
              },
              "distanceAlongShapeM": 4465.525,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6148",
              "position": {
                "x": 5515.215,
                "z": -7486.168
              },
              "distanceAlongShapeM": 5313.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6153",
              "position": {
                "x": 6029.809,
                "z": -8334.524
              },
              "distanceAlongShapeM": 6306.716,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6155",
              "position": {
                "x": 6506.105,
                "z": -9352.524
              },
              "distanceAlongShapeM": 7430.63,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7319",
              "position": {
                "x": 6738.316,
                "z": -9815.783
              },
              "distanceAlongShapeM": 7972.02,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6905",
              "position": {
                "x": 7950.707,
                "z": -10720.526
              },
              "distanceAlongShapeM": 9507.318,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7471",
              "position": {
                "x": 9539.313,
                "z": -11829.211
              },
              "distanceAlongShapeM": 11447.732,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7470",
              "position": {
                "x": 9977.079,
                "z": -11970.645
              },
              "distanceAlongShapeM": 12006.03,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            }
          ],
          "departuresSeconds": [
            18120,
            20400,
            21780,
            22860,
            24060,
            25440,
            26820,
            28200,
            29700,
            31080,
            32700,
            36000,
            38640,
            40440,
            42240,
            44100,
            45960,
            47820,
            49680,
            51600,
            53460,
            54480,
            55680,
            57060,
            58260,
            59460,
            60900,
            62280,
            63660,
            65040,
            66360,
            69900,
            71640,
            73500,
            75300,
            76980,
            79020,
            80700,
            82680,
            84360
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_39:1",
          "sourceRouteId": "vilnius_bus_39",
          "sourceShapeId": "vilnius_bus_39_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Balžio g.–Nemenčinės pl.–Antakalnis",
          "mode": "bus",
          "routeShortName": "39",
          "routeLongName": "Antakalnis–Nemenčinės pl.–Balžio g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9977.079,
              -11970.645,
              0
            ],
            [
              9973.403,
              -11961.663,
              9.705
            ],
            [
              9958.887,
              -11948.006,
              29.636
            ],
            [
              9791.031,
              -11914.51,
              200.802
            ],
            [
              9768.041,
              -11906.247,
              225.231
            ],
            [
              9757.844,
              -11901.585,
              236.444
            ],
            [
              9728.099,
              -11877.597,
              274.656
            ],
            [
              9692.817,
              -11841.25,
              325.311
            ],
            [
              9660.249,
              -11829.452,
              359.95
            ],
            [
              9637.1,
              -11828.979,
              383.104
            ],
            [
              9562.235,
              -11840.811,
              458.898
            ],
            [
              9527.005,
              -11833.413,
              494.897
            ],
            [
              9498.734,
              -11831.723,
              523.218
            ],
            [
              9477.369,
              -11806.795,
              556.049
            ],
            [
              9361.075,
              -11736.514,
              691.931
            ],
            [
              9177.901,
              -11601.418,
              919.535
            ],
            [
              9085.142,
              -11543.869,
              1028.696
            ],
            [
              9000.368,
              -11473.124,
              1139.11
            ],
            [
              8949.665,
              -11435.358,
              1202.333
            ],
            [
              8739.038,
              -11288.591,
              1459.051
            ],
            [
              8534.051,
              -11148.629,
              1707.264
            ],
            [
              7902.69,
              -10708.432,
              2476.932
            ],
            [
              7856.737,
              -10689.699,
              2526.557
            ],
            [
              7377.835,
              -10342.81,
              3117.893
            ],
            [
              7120.211,
              -10159.562,
              3434.042
            ],
            [
              7069.21,
              -10102.885,
              3510.288
            ],
            [
              7057.318,
              -10085.95,
              3530.981
            ],
            [
              6826.774,
              -9898.803,
              3827.923
            ],
            [
              6781.962,
              -9886.784,
              3874.319
            ],
            [
              6770.872,
              -9894.358,
              3887.748
            ],
            [
              6766.259,
              -9899.833,
              3894.908
            ],
            [
              6759.138,
              -9901.919,
              3902.328
            ],
            [
              6743.853,
              -9893.824,
              3919.624
            ],
            [
              6742.143,
              -9882.657,
              3930.921
            ],
            [
              6634.067,
              -9880.523,
              4039.018
            ],
            [
              6631.904,
              -9827.042,
              4092.543
            ],
            [
              6641.096,
              -9752.632,
              4167.518
            ],
            [
              6629.211,
              -9670.014,
              4250.987
            ],
            [
              6616.981,
              -9637.487,
              4285.737
            ],
            [
              6560.251,
              -9511.679,
              4423.744
            ],
            [
              6530.846,
              -9468.794,
              4475.742
            ],
            [
              6333.896,
              -9010.693,
              4974.386
            ],
            [
              6109.136,
              -8524.224,
              5510.267
            ],
            [
              6084.291,
              -8478.092,
              5562.664
            ],
            [
              5995.189,
              -8327.166,
              5737.929
            ],
            [
              5965.193,
              -8280.934,
              5793.04
            ],
            [
              5939.418,
              -8249.257,
              5833.878
            ],
            [
              5718.303,
              -7868.644,
              6274.058
            ],
            [
              5531.206,
              -7557.73,
              6636.926
            ],
            [
              5498.755,
              -7504.773,
              6699.034
            ],
            [
              5457.379,
              -7447.191,
              6769.941
            ],
            [
              5438.248,
              -7404.514,
              6816.709
            ],
            [
              5197.092,
              -7023.54,
              7267.595
            ],
            [
              5048.284,
              -6793.546,
              7541.53
            ],
            [
              5011.851,
              -6746.083,
              7601.364
            ],
            [
              5008.891,
              -6732.667,
              7615.103
            ],
            [
              4990.138,
              -6703.359,
              7649.898
            ],
            [
              4903.043,
              -6578.1,
              7802.46
            ],
            [
              4831.501,
              -6480.976,
              7923.089
            ],
            [
              4576.487,
              -6178.813,
              8318.48
            ],
            [
              4433.996,
              -6019.1,
              8532.517
            ],
            [
              4391.884,
              -5964.854,
              8601.191
            ],
            [
              4192.109,
              -5735.026,
              8905.709
            ],
            [
              4068.653,
              -5589.049,
              9096.891
            ],
            [
              4052.725,
              -5579.838,
              9115.29
            ],
            [
              4018.912,
              -5529.094,
              9176.268
            ],
            [
              3747.122,
              -5188.81,
              9611.771
            ],
            [
              3704.824,
              -5143.473,
              9673.776
            ],
            [
              3682.602,
              -5126.351,
              9701.829
            ],
            [
              3665.724,
              -5099.311,
              9733.704
            ],
            [
              3449.572,
              -4845.828,
              10066.834
            ],
            [
              3395.221,
              -4790.246,
              10144.573
            ],
            [
              3252.761,
              -4658.405,
              10338.679
            ],
            [
              3244.62,
              -4646.005,
              10353.512
            ],
            [
              3235.159,
              -4601.295,
              10399.212
            ],
            [
              3218.877,
              -4576.495,
              10428.879
            ],
            [
              3190.252,
              -4557.027,
              10463.497
            ],
            [
              3172.809,
              -4525.525,
              10499.505
            ],
            [
              3060.003,
              -4392.026,
              10674.283
            ],
            [
              3021.059,
              -4338.966,
              10740.101
            ],
            [
              2961.544,
              -4283.292,
              10821.597
            ],
            [
              2937.404,
              -4265.024,
              10851.87
            ],
            [
              2920.517,
              -4237.987,
              10883.747
            ],
            [
              2810.169,
              -4110.107,
              11052.656
            ],
            [
              2739.116,
              -4050.879,
              11145.156
            ],
            [
              2661.391,
              -4003.772,
              11236.043
            ],
            [
              2636.416,
              -3995.509,
              11262.349
            ],
            [
              2609.738,
              -3974.969,
              11296.018
            ],
            [
              2501.467,
              -3907.252,
              11423.722
            ],
            [
              2488.357,
              -3884.741,
              11449.773
            ],
            [
              2476.247,
              -3843.323,
              11492.925
            ],
            [
              2501.318,
              -3743.601,
              11595.75
            ],
            [
              2515.139,
              -3728.275,
              11616.387
            ],
            [
              2523.534,
              -3727.319,
              11624.837
            ],
            [
              2540.053,
              -3739.875,
              11645.586
            ],
            [
              2551,
              -3774.592,
              11681.987
            ],
            [
              2562.319,
              -3823.788,
              11732.469
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7470",
              "position": {
                "x": 9977.079,
                "z": -11970.645
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6907",
              "position": {
                "x": 9498.734,
                "z": -11831.723
              },
              "distanceAlongShapeM": 523.218,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6906",
              "position": {
                "x": 7856.737,
                "z": -10689.699
              },
              "distanceAlongShapeM": 2526.557,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:18892",
              "position": {
                "x": 6631.904,
                "z": -9827.042
              },
              "distanceAlongShapeM": 4092.543,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6154",
              "position": {
                "x": 6530.846,
                "z": -9468.794
              },
              "distanceAlongShapeM": 4475.742,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6152",
              "position": {
                "x": 5939.418,
                "z": -8249.257
              },
              "distanceAlongShapeM": 5833.878,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6149",
              "position": {
                "x": 5457.379,
                "z": -7447.191
              },
              "distanceAlongShapeM": 6769.941,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6146",
              "position": {
                "x": 5011.851,
                "z": -6746.083
              },
              "distanceAlongShapeM": 7601.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6144",
              "position": {
                "x": 4433.996,
                "z": -6019.1
              },
              "distanceAlongShapeM": 8532.517,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6142",
              "position": {
                "x": 4052.725,
                "z": -5579.838
              },
              "distanceAlongShapeM": 9115.29,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6141",
              "position": {
                "x": 3682.602,
                "z": -5126.351
              },
              "distanceAlongShapeM": 9701.829,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6079",
              "position": {
                "x": 3190.252,
                "z": -4557.027
              },
              "distanceAlongShapeM": 10463.497,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 10851.87,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 11262.349,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 11732.469,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            }
          ],
          "departuresSeconds": [
            19800,
            22020,
            23520,
            24720,
            26100,
            27540,
            28920,
            30300,
            31800,
            33180,
            34500,
            37860,
            40380,
            42120,
            43920,
            45840,
            47700,
            49560,
            51420,
            53340,
            55200,
            56280,
            57420,
            58800,
            60300,
            61500,
            62940,
            64320,
            65640,
            67140,
            68460,
            71700,
            73320,
            75180,
            77040,
            78720,
            80700,
            82440,
            84420,
            86040
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_40",
      "sourceRouteId": "vilnius_bus_40",
      "mode": "bus",
      "shortName": "40",
      "longName": "Perkūnkiemis–Fabijoniškės–S.Stanevičiaus g.–Centras (Apylanka)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_40:0",
          "sourceRouteId": "vilnius_bus_40",
          "sourceShapeId": "vilnius_bus_40_a1-b1",
          "directionId": 0,
          "headsign": "Centras (Apylanka)",
          "directionName": "Perkūnkiemis–Fabijoniškės–S.Stanevičiaus g.–Centras (Apylanka)",
          "mode": "bus",
          "routeShortName": "40",
          "routeLongName": "Perkūnkiemis–Fabijoniškės–S.Stanevičiaus g.–Centras (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3844.602,
              -5152.866,
              0
            ],
            [
              -3862.028,
              -5154.789,
              17.532
            ],
            [
              -3896.745,
              -5150.846,
              52.471
            ],
            [
              -3904.981,
              -5142.911,
              63.908
            ],
            [
              -3906.076,
              -5131.759,
              75.113
            ],
            [
              -3903.757,
              -5109.535,
              97.458
            ],
            [
              -3899.68,
              -5097.361,
              110.297
            ],
            [
              -3891.837,
              -5090.818,
              120.511
            ],
            [
              -3867.269,
              -5085.679,
              145.611
            ],
            [
              -3846.822,
              -5058.204,
              179.859
            ],
            [
              -3847.955,
              -5049.278,
              188.856
            ],
            [
              -3872.993,
              -5044.39,
              214.367
            ],
            [
              -4005.77,
              -5048.764,
              347.216
            ],
            [
              -4036.095,
              -5051.578,
              377.671
            ],
            [
              -4045.246,
              -5059.211,
              389.588
            ],
            [
              -4054.001,
              -5192.645,
              523.309
            ],
            [
              -3974.864,
              -5346.529,
              696.349
            ],
            [
              -3828.987,
              -5588.405,
              978.81
            ],
            [
              -3809.234,
              -5637.73,
              1031.944
            ],
            [
              -3680.31,
              -5890.449,
              1315.648
            ],
            [
              -3658.942,
              -5920.878,
              1352.83
            ],
            [
              -3616.192,
              -5943.888,
              1401.38
            ],
            [
              -3597.089,
              -5956.466,
              1424.251
            ],
            [
              -3499.935,
              -6109.56,
              1605.57
            ],
            [
              -3400.186,
              -5966.585,
              1779.903
            ],
            [
              -3297.953,
              -5829.221,
              1951.135
            ],
            [
              -3213.118,
              -5729.405,
              2082.133
            ],
            [
              -3175.031,
              -5687.77,
              2138.56
            ],
            [
              -3157.197,
              -5662.479,
              2169.507
            ],
            [
              -3141.704,
              -5623.788,
              2211.185
            ],
            [
              -3109.741,
              -5527.498,
              2312.64
            ],
            [
              -3092.92,
              -5486.604,
              2356.859
            ],
            [
              -3035.999,
              -5399.659,
              2460.779
            ],
            [
              -3033.871,
              -5388.564,
              2472.076
            ],
            [
              -2977.67,
              -5306.06,
              2571.904
            ],
            [
              -2859.092,
              -5120.012,
              2792.528
            ],
            [
              -2789.239,
              -4994.334,
              2936.313
            ],
            [
              -2739.468,
              -4911.72,
              3032.761
            ],
            [
              -2672.209,
              -4823.848,
              3143.419
            ],
            [
              -2619.375,
              -4786.931,
              3207.873
            ],
            [
              -2578.679,
              -4744.234,
              3266.858
            ],
            [
              -2554.472,
              -4686.774,
              3329.209
            ],
            [
              -2488.392,
              -4702.414,
              3397.115
            ],
            [
              -2436.56,
              -4722.255,
              3452.615
            ],
            [
              -2367.109,
              -4765.787,
              3534.581
            ],
            [
              -2297.39,
              -4830.477,
              3629.688
            ],
            [
              -2247.29,
              -4911.517,
              3724.964
            ],
            [
              -2236.559,
              -4923.953,
              3741.39
            ],
            [
              -2217.405,
              -4969.935,
              3791.202
            ],
            [
              -2110.315,
              -5178.897,
              4026.007
            ],
            [
              -2058.363,
              -5155.329,
              4083.055
            ],
            [
              -2028.76,
              -5156.969,
              4112.703
            ],
            [
              -1894.496,
              -5141.548,
              4247.85
            ],
            [
              -1856.383,
              -5135.547,
              4286.432
            ],
            [
              -1800.644,
              -5116.503,
              4345.335
            ],
            [
              -1770.723,
              -5100.339,
              4379.343
            ],
            [
              -1738.711,
              -5075.306,
              4419.981
            ],
            [
              -1710.503,
              -5046.865,
              4460.038
            ],
            [
              -1676.24,
              -5004.061,
              4514.866
            ],
            [
              -1664.171,
              -4977.559,
              4543.986
            ],
            [
              -1657.878,
              -4949.841,
              4572.41
            ],
            [
              -1638.506,
              -4911.224,
              4615.614
            ],
            [
              -1626.337,
              -4879.158,
              4649.911
            ],
            [
              -1604.435,
              -4807.19,
              4725.138
            ],
            [
              -1592.551,
              -4755.08,
              4778.586
            ],
            [
              -1586.265,
              -4691.738,
              4842.239
            ],
            [
              -1583.358,
              -4637.242,
              4896.812
            ],
            [
              -1588.338,
              -4591.511,
              4942.814
            ],
            [
              -1597.362,
              -4555.726,
              4979.719
            ],
            [
              -1598.126,
              -4562.392,
              4986.429
            ],
            [
              -1595.437,
              -4520.137,
              5028.769
            ],
            [
              -1616.287,
              -4244.797,
              5304.897
            ],
            [
              -1631.856,
              -4106.478,
              5444.089
            ],
            [
              -1640.178,
              -4067.366,
              5484.077
            ],
            [
              -1637.064,
              -4037.365,
              5514.239
            ],
            [
              -1635.048,
              -3960.588,
              5591.042
            ],
            [
              -1628.98,
              -3909.488,
              5642.502
            ],
            [
              -1612.999,
              -3808.47,
              5744.776
            ],
            [
              -1543.192,
              -3688.376,
              5883.684
            ],
            [
              -1515.42,
              -3648.796,
              5932.036
            ],
            [
              -1479.438,
              -3582.647,
              6007.338
            ],
            [
              -1461.972,
              -3542.883,
              6050.769
            ],
            [
              -1437.625,
              -3478.752,
              6119.366
            ],
            [
              -1385.229,
              -3323.838,
              6282.901
            ],
            [
              -1372.596,
              -3266.177,
              6341.93
            ],
            [
              -1373.246,
              -3230.542,
              6377.571
            ],
            [
              -1363.568,
              -3193.979,
              6415.393
            ],
            [
              -1359.808,
              -3163.989,
              6445.618
            ],
            [
              -1360.179,
              -3112.774,
              6496.834
            ],
            [
              -1362.723,
              -3074.878,
              6534.815
            ],
            [
              -1386.134,
              -2978.721,
              6633.781
            ],
            [
              -1409.242,
              -2901.495,
              6714.39
            ],
            [
              -1422.254,
              -2872.318,
              6746.337
            ],
            [
              -1430.357,
              -2820.964,
              6798.326
            ],
            [
              -1448.996,
              -2746.044,
              6875.53
            ],
            [
              -1452.909,
              -2712.577,
              6909.225
            ],
            [
              -1453.659,
              -2682.507,
              6939.305
            ],
            [
              -1443.344,
              -2610.331,
              7012.213
            ],
            [
              -1428.471,
              -2571.635,
              7053.67
            ],
            [
              -1415.77,
              -2546.258,
              7082.048
            ],
            [
              -1386.622,
              -2502.251,
              7134.833
            ],
            [
              -1450.559,
              -2473.275,
              7205.029
            ],
            [
              -1516.935,
              -2436.464,
              7280.929
            ],
            [
              -1567.016,
              -2425.55,
              7332.186
            ],
            [
              -1613.955,
              -2419.145,
              7379.559
            ],
            [
              -1678.312,
              -2413.543,
              7444.16
            ],
            [
              -1901.727,
              -2399.542,
              7668.014
            ],
            [
              -1905.127,
              -2409.501,
              7678.537
            ],
            [
              -1907.871,
              -2527.453,
              7796.521
            ],
            [
              -1930.967,
              -2593.836,
              7866.807
            ],
            [
              -1938.838,
              -2601.488,
              7877.785
            ],
            [
              -2055.259,
              -2914.461,
              8211.709
            ],
            [
              -2054.675,
              -2917.811,
              8215.11
            ],
            [
              -2048.251,
              -2919.038,
              8221.649
            ],
            [
              -2034.057,
              -2918.177,
              8235.87
            ],
            [
              -2023.689,
              -2915.022,
              8246.707
            ],
            [
              -2013.222,
              -2906.302,
              8260.33
            ],
            [
              -1995.719,
              -2864.311,
              8305.824
            ],
            [
              -1946.309,
              -2731.603,
              8447.431
            ],
            [
              -1893.853,
              -2608.968,
              8580.814
            ],
            [
              -1860.774,
              -2597.312,
              8615.886
            ],
            [
              -1798.045,
              -2477.088,
              8751.492
            ],
            [
              -1803.09,
              -2434.696,
              8794.183
            ],
            [
              -1743.312,
              -2335.571,
              8909.938
            ],
            [
              -1747.763,
              -2332.152,
              8915.551
            ],
            [
              -1727.311,
              -2305.799,
              8948.908
            ],
            [
              -1547.472,
              -2017.345,
              9288.831
            ],
            [
              -1343.434,
              -1674.784,
              9687.554
            ],
            [
              -1305.861,
              -1628.702,
              9747.012
            ],
            [
              -1268.647,
              -1602.651,
              9792.438
            ],
            [
              -1054.592,
              -1494.059,
              10032.462
            ],
            [
              -1027.103,
              -1471.176,
              10068.23
            ],
            [
              -1009.966,
              -1450.333,
              10095.214
            ],
            [
              -1001.511,
              -1410.409,
              10136.023
            ],
            [
              -987.78,
              -1363.9,
              10184.516
            ],
            [
              -988.723,
              -1201.352,
              10347.067
            ],
            [
              -990.397,
              -1186.85,
              10361.666
            ],
            [
              -1017.615,
              -1122.906,
              10431.161
            ],
            [
              -1020.518,
              -1105.042,
              10449.259
            ],
            [
              -1018.304,
              -1089.497,
              10464.962
            ],
            [
              -1013.532,
              -1075.111,
              10480.119
            ],
            [
              -1005.537,
              -1060.783,
              10496.526
            ],
            [
              -990.532,
              -1051.034,
              10514.42
            ],
            [
              -976.596,
              -1029.02,
              10540.475
            ],
            [
              -969.87,
              -1013.556,
              10557.338
            ],
            [
              -967.031,
              -999.135,
              10572.036
            ],
            [
              -969.129,
              -972.38,
              10598.873
            ],
            [
              -954.912,
              -934.786,
              10639.065
            ],
            [
              -945.547,
              -916.03,
              10660.029
            ],
            [
              -940.714,
              -898.305,
              10678.401
            ],
            [
              -936.79,
              -859.413,
              10717.491
            ],
            [
              -924.604,
              -648.119,
              10929.136
            ],
            [
              -926.501,
              -610.235,
              10967.067
            ],
            [
              -934.701,
              -600.068,
              10980.128
            ],
            [
              -944.29,
              -595.443,
              10990.775
            ],
            [
              -952.65,
              -594.179,
              10999.23
            ],
            [
              -963.004,
              -596.219,
              11009.783
            ],
            [
              -972.833,
              -604.948,
              11022.929
            ],
            [
              -982.803,
              -621.467,
              11042.223
            ],
            [
              -992.833,
              -641.325,
              11064.47
            ],
            [
              -992.649,
              -666.932,
              11090.078
            ],
            [
              -989.606,
              -677.006,
              11100.602
            ],
            [
              -978.263,
              -691.682,
              11119.15
            ],
            [
              -964.927,
              -703.054,
              11136.677
            ],
            [
              -939.343,
              -714.647,
              11164.765
            ],
            [
              -865.474,
              -730.449,
              11240.305
            ],
            [
              -798.395,
              -729.432,
              11307.392
            ],
            [
              -764.735,
              -722.247,
              11341.81
            ],
            [
              -714.638,
              -697.546,
              11397.665
            ],
            [
              -692.924,
              -673.447,
              11430.104
            ],
            [
              -655.859,
              -656.305,
              11470.941
            ],
            [
              -601.451,
              -607.193,
              11544.236
            ],
            [
              -500.911,
              -503.255,
              11688.845
            ],
            [
              -413.017,
              -421.354,
              11808.982
            ],
            [
              -450.326,
              -380.602,
              11864.233
            ],
            [
              -465.596,
              -369.193,
              11883.294
            ],
            [
              -470.512,
              -355.745,
              11897.612
            ],
            [
              -508.466,
              -314.982,
              11953.31
            ],
            [
              -532.258,
              -346.835,
              11993.067
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 166.686,
              "shapeOffsetM": 0.733,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15634",
              "position": {
                "x": -3828.987,
                "z": -5588.405
              },
              "distanceAlongShapeM": 978.81,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:16323",
              "position": {
                "x": -3400.186,
                "z": -5966.585
              },
              "distanceAlongShapeM": 1779.903,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:7809",
              "position": {
                "x": -3033.871,
                "z": -5388.564
              },
              "distanceAlongShapeM": 2472.076,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5518",
              "position": {
                "x": -2739.468,
                "z": -4911.72
              },
              "distanceAlongShapeM": 3032.761,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 3741.39,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 4083.055,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5813",
              "position": {
                "x": -1657.878,
                "z": -4949.841
              },
              "distanceAlongShapeM": 4572.41,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6917",
              "position": {
                "x": -1597.362,
                "z": -4555.726
              },
              "distanceAlongShapeM": 4979.719,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6921",
              "position": {
                "x": -1640.178,
                "z": -4067.366
              },
              "distanceAlongShapeM": 5484.077,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6924",
              "position": {
                "x": -1612.999,
                "z": -3808.47
              },
              "distanceAlongShapeM": 5744.776,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6928",
              "position": {
                "x": -1373.246,
                "z": -3230.542
              },
              "distanceAlongShapeM": 6377.571,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6933",
              "position": {
                "x": -1422.254,
                "z": -2872.318
              },
              "distanceAlongShapeM": 6746.337,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6937",
              "position": {
                "x": -1450.559,
                "z": -2473.275
              },
              "distanceAlongShapeM": 7205.029,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5294",
              "position": {
                "x": -1930.967,
                "z": -2593.836
              },
              "distanceAlongShapeM": 7866.807,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 8915.551,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 10136.023,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5533",
              "position": {
                "x": -969.129,
                "z": -972.38
              },
              "distanceAlongShapeM": 10598.873,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5539",
              "position": {
                "x": -692.924,
                "z": -673.447
              },
              "distanceAlongShapeM": 11430.104,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5257",
              "position": {
                "x": -465.596,
                "z": -369.193
              },
              "distanceAlongShapeM": 11883.294,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5259",
              "position": {
                "x": -532.258,
                "z": -346.835
              },
              "distanceAlongShapeM": 11993.067,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            18360,
            20100,
            21840,
            23280,
            24300,
            25260,
            26040,
            26880,
            27840,
            29820,
            30840,
            31860,
            33600,
            34200,
            35760,
            37320,
            39540,
            41220,
            42120,
            43140,
            44940,
            47700,
            48480,
            49260,
            51060,
            52920,
            54120,
            54900,
            55620,
            57000,
            58260,
            59520,
            60480,
            61500,
            63180,
            64440,
            65520,
            67620,
            68820,
            70080,
            71340,
            72960,
            74100,
            75360,
            76680,
            78000,
            79140
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_40:1",
          "sourceRouteId": "vilnius_bus_40",
          "sourceShapeId": "vilnius_bus_40_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Centras–S.Stanevičiaus g.–Fabijoniškės–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "40",
          "routeLongName": "Perkūnkiemis–Fabijoniškės–S.Stanevičiaus g.–Centras (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -532.258,
              -346.835,
              0
            ],
            [
              -695.752,
              -508.638,
              230.023
            ],
            [
              -754.191,
              -530.962,
              292.58
            ],
            [
              -813.838,
              -548.811,
              354.841
            ],
            [
              -813.253,
              -552.161,
              358.242
            ],
            [
              -859.203,
              -561.352,
              405.101
            ],
            [
              -904.203,
              -589.485,
              458.172
            ],
            [
              -914.961,
              -793.012,
              661.983
            ],
            [
              -942.768,
              -1119.8,
              989.952
            ],
            [
              -997.296,
              -1462.806,
              1337.265
            ],
            [
              -1070.7,
              -1529.393,
              1436.371
            ],
            [
              -1114.746,
              -1540.847,
              1481.881
            ],
            [
              -1223.074,
              -1577.865,
              1596.36
            ],
            [
              -1268.647,
              -1602.651,
              1648.237
            ],
            [
              -1297.383,
              -1623.287,
              1683.616
            ],
            [
              -1333.607,
              -1666.054,
              1739.662
            ],
            [
              -1382.029,
              -1741.999,
              1829.73
            ],
            [
              -1597.414,
              -2106.624,
              2253.218
            ],
            [
              -1645.063,
              -2175.906,
              2337.304
            ],
            [
              -1682.619,
              -2257.615,
              2427.23
            ],
            [
              -1702.963,
              -2314.026,
              2487.198
            ],
            [
              -1711.936,
              -2347.263,
              2521.625
            ],
            [
              -1753.781,
              -2416.65,
              2602.653
            ],
            [
              -1791.442,
              -2468.3,
              2666.575
            ],
            [
              -1802.268,
              -2497.051,
              2697.297
            ],
            [
              -1803.487,
              -2529.313,
              2729.582
            ],
            [
              -1788.281,
              -2616.415,
              2818.001
            ],
            [
              -1772.234,
              -2692.401,
              2895.663
            ],
            [
              -1749.208,
              -2738.453,
              2947.151
            ],
            [
              -1746.662,
              -2848.708,
              3057.436
            ],
            [
              -1749.429,
              -2895.414,
              3104.224
            ],
            [
              -1759.481,
              -2953.123,
              3162.801
            ],
            [
              -1775.996,
              -3011.829,
              3223.786
            ],
            [
              -1683.756,
              -3043.532,
              3321.322
            ],
            [
              -1647.191,
              -3053.091,
              3359.115
            ],
            [
              -1571.366,
              -3065.578,
              3435.962
            ],
            [
              -1551.978,
              -3062.585,
              3455.579
            ],
            [
              -1523.75,
              -3069.769,
              3484.707
            ],
            [
              -1491.596,
              -3073.684,
              3517.099
            ],
            [
              -1438.786,
              -3075.742,
              3569.949
            ],
            [
              -1362.723,
              -3074.878,
              3646.017
            ],
            [
              -1357.098,
              -3120.622,
              3692.105
            ],
            [
              -1356.687,
              -3169.611,
              3741.096
            ],
            [
              -1363.762,
              -3240.731,
              3812.567
            ],
            [
              -1372.45,
              -3294.01,
              3866.55
            ],
            [
              -1372.145,
              -3312.94,
              3885.483
            ],
            [
              -1386.916,
              -3346.073,
              3921.759
            ],
            [
              -1441.889,
              -3500.94,
              4086.093
            ],
            [
              -1479.438,
              -3582.647,
              4176.015
            ],
            [
              -1526.789,
              -3671.971,
              4277.114
            ],
            [
              -1572.531,
              -3743.513,
              4362.029
            ],
            [
              -1605.428,
              -3817.511,
              4443.01
            ],
            [
              -1619.047,
              -3858.457,
              4486.162
            ],
            [
              -1621.258,
              -3874.003,
              4501.864
            ],
            [
              -1622.014,
              -3916.292,
              4544.16
            ],
            [
              -1630.122,
              -3937.298,
              4566.677
            ],
            [
              -1635.048,
              -3960.588,
              4590.482
            ],
            [
              -1633.18,
              -4036.321,
              4666.238
            ],
            [
              -1621.037,
              -4150.087,
              4780.65
            ],
            [
              -1612.338,
              -4168.054,
              4800.612
            ],
            [
              -1616.287,
              -4244.797,
              4877.456
            ],
            [
              -1593.127,
              -4499.027,
              5132.739
            ],
            [
              -1582.077,
              -4601.642,
              5235.947
            ],
            [
              -1574.54,
              -4648.532,
              5283.44
            ],
            [
              -1585.129,
              -4736.288,
              5371.832
            ],
            [
              -1597.975,
              -4806.192,
              5442.906
            ],
            [
              -1623.216,
              -4884.78,
              5525.448
            ],
            [
              -1642.847,
              -4937.864,
              5582.046
            ],
            [
              -1696.959,
              -5045.994,
              5702.96
            ],
            [
              -1793.54,
              -5115.517,
              5821.961
            ],
            [
              -1840.927,
              -5135.823,
              5873.516
            ],
            [
              -1904.939,
              -5149.154,
              5938.901
            ],
            [
              -2065.02,
              -5167.456,
              6100.025
            ],
            [
              -2110.315,
              -5178.897,
              6146.743
            ],
            [
              -2139.87,
              -5138.296,
              6196.962
            ],
            [
              -2154.069,
              -5103.533,
              6234.512
            ],
            [
              -2263.659,
              -4890.076,
              6474.459
            ],
            [
              -2297.39,
              -4830.477,
              6542.941
            ],
            [
              -2351.324,
              -4783.879,
              6614.216
            ],
            [
              -2381.317,
              -4767.762,
              6648.265
            ],
            [
              -2406.02,
              -4743.947,
              6682.579
            ],
            [
              -2443.585,
              -4718.791,
              6727.788
            ],
            [
              -2496.725,
              -4700.04,
              6784.14
            ],
            [
              -2554.472,
              -4686.774,
              6843.391
            ],
            [
              -2573.291,
              -4730.97,
              6891.427
            ],
            [
              -2592.46,
              -4758.462,
              6924.942
            ],
            [
              -2618.048,
              -4784.728,
              6961.611
            ],
            [
              -2673.576,
              -4828.277,
              7032.179
            ],
            [
              -2687.375,
              -4843.619,
              7052.814
            ],
            [
              -2770.874,
              -4975.733,
              7209.103
            ],
            [
              -2803.001,
              -5044.187,
              7284.721
            ],
            [
              -2804.737,
              -5033.024,
              7296.018
            ],
            [
              -2888.269,
              -5167.367,
              7454.212
            ],
            [
              -3080.666,
              -5485.706,
              7826.176
            ],
            [
              -3095.828,
              -5505.478,
              7851.092
            ],
            [
              -3107.829,
              -5528.645,
              7877.183
            ],
            [
              -3153.938,
              -5660.309,
              8016.687
            ],
            [
              -3175.09,
              -5691.109,
              8054.05
            ],
            [
              -3295.455,
              -5833.718,
              8240.666
            ],
            [
              -3344.232,
              -5897.431,
              8320.906
            ],
            [
              -3437.312,
              -6027.163,
              8480.575
            ],
            [
              -3448.158,
              -6058.144,
              8513.4
            ],
            [
              -3469.092,
              -6076.703,
              8541.375
            ],
            [
              -3486.182,
              -6096.442,
              8567.485
            ],
            [
              -3492.814,
              -6107.458,
              8580.344
            ],
            [
              -3499.272,
              -6108.459,
              8586.879
            ],
            [
              -3506.862,
              -6100.534,
              8597.852
            ],
            [
              -3587.742,
              -5974.441,
              8747.655
            ],
            [
              -3599.079,
              -5959.771,
              8766.195
            ],
            [
              -3620.055,
              -5943.82,
              8792.546
            ],
            [
              -3632.854,
              -5939.144,
              8806.173
            ],
            [
              -3658.961,
              -5921.991,
              8837.411
            ],
            [
              -3677.909,
              -5900.51,
              8866.055
            ],
            [
              -3687.862,
              -5880.298,
              8888.584
            ],
            [
              -3701.111,
              -5864.482,
              8909.217
            ],
            [
              -3758.86,
              -5741.023,
              9045.515
            ],
            [
              -3885.643,
              -5512.834,
              9306.558
            ],
            [
              -3934.889,
              -5418.469,
              9413.001
            ],
            [
              -3998.014,
              -5307.164,
              9540.96
            ],
            [
              -4047.188,
              -5208.349,
              9651.335
            ],
            [
              -4050.157,
              -5193.825,
              9666.158
            ],
            [
              -4048.98,
              -5125.94,
              9734.054
            ],
            [
              -4041.71,
              -5078.197,
              9782.347
            ],
            [
              -4035.058,
              -5066.067,
              9796.181
            ],
            [
              -4020.053,
              -5055.195,
              9814.71
            ],
            [
              -3998.725,
              -5051.113,
              9836.426
            ],
            [
              -3824.791,
              -5050.794,
              10010.36
            ],
            [
              -3827.361,
              -5087.486,
              10047.142
            ],
            [
              -3833.268,
              -5130.798,
              10090.855
            ],
            [
              -3844.602,
              -5152.866,
              10115.663
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5259",
              "position": {
                "x": -532.258,
                "z": -346.835
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:10360",
              "position": {
                "x": -813.253,
                "z": -552.161
              },
              "distanceAlongShapeM": 358.242,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5289",
              "position": {
                "x": -1070.7,
                "z": -1529.393
              },
              "distanceAlongShapeM": 1436.371,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 2521.625,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:1042",
              "position": {
                "x": -1749.208,
                "z": -2738.453
              },
              "distanceAlongShapeM": 2947.151,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6940",
              "position": {
                "x": -1551.978,
                "z": -3062.585
              },
              "distanceAlongShapeM": 3455.579,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6929",
              "position": {
                "x": -1372.145,
                "z": -3312.94
              },
              "distanceAlongShapeM": 3885.483,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6926",
              "position": {
                "x": -1622.014,
                "z": -3916.292
              },
              "distanceAlongShapeM": 4544.16,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6922",
              "position": {
                "x": -1612.338,
                "z": -4168.054
              },
              "distanceAlongShapeM": 4800.612,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6918",
              "position": {
                "x": -1574.54,
                "z": -4648.532
              },
              "distanceAlongShapeM": 5283.44,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 5702.96,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 6196.962,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6763",
              "position": {
                "x": -2381.317,
                "z": -4767.762
              },
              "distanceAlongShapeM": 6648.265,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5519",
              "position": {
                "x": -2803.001,
                "z": -5044.187
              },
              "distanceAlongShapeM": 7284.721,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7810",
              "position": {
                "x": -3080.666,
                "z": -5485.706
              },
              "distanceAlongShapeM": 7826.176,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7811",
              "position": {
                "x": -3270.462,
                "z": -5804.099
              },
              "distanceAlongShapeM": 8201.91,
              "shapeOffsetM": 0.004,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:18831",
              "position": {
                "x": -3448.158,
                "z": -6058.144
              },
              "distanceAlongShapeM": 8513.4,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:15639",
              "position": {
                "x": -3701.111,
                "z": -5864.482
              },
              "distanceAlongShapeM": 8909.217,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:15636",
              "position": {
                "x": -3885.643,
                "z": -5512.834
              },
              "distanceAlongShapeM": 9306.558,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 10047.142,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            20580,
            22320,
            24120,
            25740,
            26940,
            27960,
            28740,
            29700,
            30660,
            32640,
            33660,
            34680,
            36240,
            36780,
            38220,
            39780,
            42000,
            43740,
            44640,
            45660,
            47460,
            50160,
            50880,
            51720,
            53580,
            55500,
            56700,
            57480,
            58200,
            59820,
            61140,
            62460,
            63420,
            64500,
            66240,
            67200,
            68220,
            70200,
            71400,
            72420,
            73620,
            75240,
            76380,
            77640,
            78900,
            80220,
            81360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_41",
      "sourceRouteId": "vilnius_bus_41",
      "mode": "bus",
      "shortName": "41",
      "longName": "Stotis–Eišiškių pl.–Užusienis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_41:0",
          "sourceRouteId": "vilnius_bus_41",
          "sourceShapeId": "vilnius_bus_41_a-b",
          "directionId": 0,
          "headsign": "Užusienis",
          "directionName": "Stotis–Eišiškių pl.–Užusienis",
          "mode": "bus",
          "routeShortName": "41",
          "routeLongName": "Stotis–Eišiškių pl.–Užusienis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              378.73,
              1828.551,
              0
            ],
            [
              425.25,
              1832.153,
              46.659
            ],
            [
              579.14,
              1850.487,
              201.637
            ],
            [
              587.002,
              1857.023,
              211.861
            ],
            [
              594.321,
              1869.134,
              226.012
            ],
            [
              472.814,
              1928.134,
              361.086
            ],
            [
              461.768,
              1923.883,
              372.922
            ],
            [
              443.043,
              1923.113,
              391.662
            ],
            [
              408.316,
              1929.314,
              426.939
            ],
            [
              398.702,
              1932.829,
              437.175
            ],
            [
              373.309,
              1955.558,
              471.254
            ],
            [
              366.499,
              1971.268,
              488.377
            ],
            [
              365.997,
              1979.07,
              496.195
            ],
            [
              369.323,
              1984.575,
              502.627
            ],
            [
              374.585,
              1990.045,
              510.217
            ],
            [
              389.562,
              1997.564,
              526.976
            ],
            [
              401.172,
              1997.352,
              538.587
            ],
            [
              408.871,
              1994.984,
              546.642
            ],
            [
              424.209,
              1986.911,
              563.975
            ],
            [
              467.559,
              1958.288,
              615.922
            ],
            [
              473.887,
              1951.492,
              625.208
            ],
            [
              474.993,
              1941.453,
              635.308
            ],
            [
              465.719,
              1928.264,
              651.431
            ],
            [
              461.143,
              1925.008,
              657.047
            ],
            [
              452.073,
              1922.947,
              666.349
            ],
            [
              409.585,
              1928.177,
              709.157
            ],
            [
              398.6,
              1927.265,
              720.18
            ],
            [
              334.106,
              1822.687,
              843.047
            ],
            [
              318.606,
              1821.856,
              858.568
            ],
            [
              29.934,
              1735.835,
              1159.785
            ],
            [
              -11.424,
              1732.135,
              1201.308
            ],
            [
              -46.755,
              1740.57,
              1237.632
            ],
            [
              -320.217,
              1781.157,
              1514.089
            ],
            [
              -515.259,
              1841.463,
              1718.242
            ],
            [
              -520.923,
              1849.358,
              1727.958
            ],
            [
              -526.486,
              1862.817,
              1742.522
            ],
            [
              -511.654,
              1933.795,
              1815.033
            ],
            [
              -496.901,
              1964.699,
              1849.278
            ],
            [
              -462.075,
              2106.562,
              1995.353
            ],
            [
              -436.719,
              2188.482,
              2081.107
            ],
            [
              -427.991,
              2207.248,
              2101.804
            ],
            [
              -344.32,
              2338.207,
              2257.211
            ],
            [
              -326.137,
              2380.181,
              2302.953
            ],
            [
              -285.296,
              2533.066,
              2461.199
            ],
            [
              -290.153,
              2585.475,
              2513.834
            ],
            [
              -278.622,
              2616.436,
              2546.872
            ],
            [
              -251.706,
              2819.669,
              2751.879
            ],
            [
              -239.003,
              2950.799,
              2883.623
            ],
            [
              -239.164,
              2977.519,
              2910.344
            ],
            [
              -244.788,
              3023.264,
              2956.433
            ],
            [
              -255.513,
              3072.44,
              3006.765
            ],
            [
              -253.335,
              3121.382,
              3055.756
            ],
            [
              -336.623,
              3547.03,
              3489.476
            ],
            [
              -379.958,
              3791.61,
              3737.866
            ],
            [
              -382.016,
              3856.215,
              3802.503
            ],
            [
              -345.945,
              4030.338,
              3980.323
            ],
            [
              -408.418,
              4109.394,
              4081.084
            ],
            [
              -481.301,
              4219.808,
              4213.383
            ],
            [
              -539.627,
              4314.372,
              4324.488
            ],
            [
              -578.027,
              4368.5,
              4390.854
            ],
            [
              -621.677,
              4489.515,
              4519.501
            ],
            [
              -657.683,
              4569.203,
              4606.946
            ],
            [
              -715.86,
              4708.291,
              4757.711
            ],
            [
              -753.761,
              4754.616,
              4817.564
            ],
            [
              -787.149,
              4836.482,
              4905.977
            ],
            [
              -899.06,
              5075.611,
              5169.997
            ],
            [
              -917.463,
              5129.376,
              5226.824
            ],
            [
              -979.628,
              5262.965,
              5374.17
            ],
            [
              -1065.501,
              5406.998,
              5541.859
            ],
            [
              -1113.826,
              5484.677,
              5633.343
            ],
            [
              -1139.633,
              5521.875,
              5678.617
            ],
            [
              -1160.802,
              5565.67,
              5727.259
            ],
            [
              -1252.943,
              5720.943,
              5907.813
            ],
            [
              -1341.654,
              5851.663,
              6065.792
            ],
            [
              -1434.869,
              5983.574,
              6227.314
            ],
            [
              -1434.909,
              5981.348,
              6229.541
            ],
            [
              -1471.061,
              6054.352,
              6311.005
            ],
            [
              -1511.007,
              6059.517,
              6351.284
            ],
            [
              -1581.385,
              6096.395,
              6430.738
            ],
            [
              -1632.088,
              6113.996,
              6484.41
            ],
            [
              -1694.749,
              6112.885,
              6547.08
            ],
            [
              -1751.27,
              6093.853,
              6606.72
            ],
            [
              -1776.705,
              6079.833,
              6635.763
            ],
            [
              -1788.792,
              6090.067,
              6651.601
            ],
            [
              -1821.15,
              6086.189,
              6684.19
            ],
            [
              -1845.036,
              6086.614,
              6708.08
            ],
            [
              -1894.627,
              6094.173,
              6758.244
            ],
            [
              -1950.614,
              6105.186,
              6815.304
            ],
            [
              -2037.412,
              6126.762,
              6904.743
            ],
            [
              -2168.421,
              6168.044,
              7042.102
            ],
            [
              -2286.229,
              6189.051,
              7161.768
            ],
            [
              -2312.561,
              6197.308,
              7189.364
            ],
            [
              -2336.271,
              6207.746,
              7215.27
            ],
            [
              -2382.675,
              6213.018,
              7261.972
            ],
            [
              -2379.466,
              6211.848,
              7265.387
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7914",
              "position": {
                "x": 373.309,
                "z": 1955.558
              },
              "distanceAlongShapeM": 471.254,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 1201.308,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 1815.033,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 2513.834,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 3006.765,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5304",
              "position": {
                "x": -578.027,
                "z": 4368.5
              },
              "distanceAlongShapeM": 4390.854,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8339",
              "position": {
                "x": -753.761,
                "z": 4754.616
              },
              "distanceAlongShapeM": 4817.564,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6948",
              "position": {
                "x": -899.06,
                "z": 5075.611
              },
              "distanceAlongShapeM": 5169.997,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6949",
              "position": {
                "x": -1139.633,
                "z": 5521.875
              },
              "distanceAlongShapeM": 5678.617,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8347",
              "position": {
                "x": -1434.909,
                "z": 5981.348
              },
              "distanceAlongShapeM": 6229.541,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6957",
              "position": {
                "x": -1776.705,
                "z": 6079.833
              },
              "distanceAlongShapeM": 6635.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6959",
              "position": {
                "x": -2379.466,
                "z": 6211.848
              },
              "distanceAlongShapeM": 7265.387,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            }
          ],
          "departuresSeconds": [
            18960,
            20940,
            22140,
            24300,
            25860,
            27840,
            29520,
            31320,
            35160,
            38160,
            41340,
            44640,
            47880,
            51120,
            52560,
            54540,
            55800,
            57840,
            59640,
            61560,
            63420,
            65340,
            67080,
            70920,
            74040,
            77100,
            80220
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_41:1",
          "sourceRouteId": "vilnius_bus_41",
          "sourceShapeId": "vilnius_bus_41_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Užusienis–Eišiškių pl.–Stotis",
          "mode": "bus",
          "routeShortName": "41",
          "routeLongName": "Stotis–Eišiškių pl.–Užusienis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2379.466,
              6211.848,
              0
            ],
            [
              -2395.449,
              6221.035,
              18.435
            ],
            [
              -2395.312,
              6228.825,
              26.227
            ],
            [
              -2391.359,
              6233.208,
              32.128
            ],
            [
              -2382.986,
              6231.948,
              40.596
            ],
            [
              -2362.524,
              6220.454,
              64.065
            ],
            [
              -2322.792,
              6203.055,
              107.44
            ],
            [
              -2263.732,
              6183.087,
              169.784
            ],
            [
              -2158.151,
              6164.523,
              276.984
            ],
            [
              -2120.259,
              6152.72,
              316.673
            ],
            [
              -2096.431,
              6148.959,
              340.795
            ],
            [
              -2047.663,
              6131.397,
              392.629
            ],
            [
              -1994.336,
              6115.98,
              448.14
            ],
            [
              -1874.614,
              6093.818,
              569.895
            ],
            [
              -1815.926,
              6089.436,
              628.747
            ],
            [
              -1783.588,
              6092.201,
              661.203
            ],
            [
              -1749.86,
              6100.507,
              695.938
            ],
            [
              -1742.014,
              6105.934,
              705.478
            ],
            [
              -1699.228,
              6115.191,
              749.254
            ],
            [
              -1670.118,
              6118.013,
              778.501
            ],
            [
              -1643.649,
              6117.542,
              804.974
            ],
            [
              -1605.738,
              6106.848,
              844.364
            ],
            [
              -1576.319,
              6090.738,
              877.905
            ],
            [
              -1532.112,
              6071.026,
              926.308
            ],
            [
              -1514.135,
              6065.139,
              945.224
            ],
            [
              -1502.008,
              6057.13,
              959.757
            ],
            [
              -1471.061,
              6054.352,
              990.829
            ],
            [
              -1459.639,
              6043.016,
              1006.921
            ],
            [
              -1442.825,
              6008.206,
              1045.579
            ],
            [
              -1415.255,
              5960.959,
              1100.282
            ],
            [
              -1252.943,
              5720.943,
              1390.028
            ],
            [
              -1174.644,
              5585.956,
              1546.08
            ],
            [
              -1106.766,
              5482.324,
              1669.964
            ],
            [
              -972.688,
              5253.935,
              1934.8
            ],
            [
              -871.561,
              5025.022,
              2185.056
            ],
            [
              -865.187,
              5020.454,
              2192.898
            ],
            [
              -856.066,
              4989.12,
              2225.532
            ],
            [
              -801.413,
              4869.022,
              2357.481
            ],
            [
              -766.573,
              4796.036,
              2438.356
            ],
            [
              -708.316,
              4697.023,
              2553.236
            ],
            [
              -707.871,
              4685.883,
              2564.385
            ],
            [
              -676.746,
              4621.868,
              2635.565
            ],
            [
              -601.144,
              4446.842,
              2826.221
            ],
            [
              -555.117,
              4350.275,
              2933.197
            ],
            [
              -482.27,
              4237.637,
              3067.339
            ],
            [
              -475.614,
              4213.025,
              3092.834
            ],
            [
              -396.44,
              4093.592,
              3236.128
            ],
            [
              -345.945,
              4030.338,
              3317.065
            ],
            [
              -378.367,
              3879.526,
              3471.322
            ],
            [
              -382.056,
              3853.989,
              3497.125
            ],
            [
              -382.136,
              3813.914,
              3537.199
            ],
            [
              -379.958,
              3791.61,
              3559.609
            ],
            [
              -326.239,
              3550.182,
              3806.942
            ],
            [
              -300.672,
              3393.867,
              3965.334
            ],
            [
              -259.604,
              3167.138,
              4195.752
            ],
            [
              -234.366,
              2993.018,
              4371.692
            ],
            [
              -225.435,
              2951.666,
              4413.997
            ],
            [
              -266.588,
              2603.973,
              4764.117
            ],
            [
              -287.151,
              2501.929,
              4868.213
            ],
            [
              -327.226,
              2355.709,
              5019.824
            ],
            [
              -350.367,
              2324.958,
              5058.31
            ],
            [
              -412.128,
              2228.113,
              5173.173
            ],
            [
              -425.492,
              2202.75,
              5201.841
            ],
            [
              -439.803,
              2160.707,
              5246.253
            ],
            [
              -445.668,
              2121.85,
              5285.55
            ],
            [
              -471.768,
              2034.377,
              5376.834
            ],
            [
              -499.661,
              1919.106,
              5495.431
            ],
            [
              -508.548,
              1855.813,
              5559.345
            ],
            [
              -490.609,
              1848.809,
              5578.603
            ],
            [
              -470.051,
              1843.985,
              5599.72
            ],
            [
              -432.32,
              1825.49,
              5641.74
            ],
            [
              -327.19,
              1787.963,
              5753.366
            ],
            [
              -259.046,
              1774.482,
              5822.831
            ],
            [
              -147.106,
              1756.865,
              5936.149
            ],
            [
              9.981,
              1738.424,
              6094.314
            ],
            [
              41.02,
              1742.312,
              6125.596
            ],
            [
              63.816,
              1754.143,
              6151.279
            ],
            [
              135.751,
              1771.757,
              6225.34
            ],
            [
              319.251,
              1821.845,
              6415.552
            ],
            [
              341.2,
              1822.557,
              6437.513
            ],
            [
              378.73,
              1828.551,
              6475.519
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6959",
              "position": {
                "x": -2379.466,
                "z": 6211.848
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -360,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6956",
              "position": {
                "x": -1742.014,
                "z": 6105.934
              },
              "distanceAlongShapeM": 705.478,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6961",
              "position": {
                "x": -1459.639,
                "z": 6043.016
              },
              "distanceAlongShapeM": 1006.921,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6950",
              "position": {
                "x": -1106.766,
                "z": 5482.324
              },
              "distanceAlongShapeM": 1669.964,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6947",
              "position": {
                "x": -865.187,
                "z": 5020.454
              },
              "distanceAlongShapeM": 2192.898,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5307",
              "position": {
                "x": -708.316,
                "z": 4697.023
              },
              "distanceAlongShapeM": 2553.236,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5305",
              "position": {
                "x": -482.27,
                "z": 4237.637
              },
              "distanceAlongShapeM": 3067.339,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 4413.997,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 4764.117,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 5599.72,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 6151.279,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:16581",
              "position": {
                "x": 378.73,
                "z": 1828.551
              },
              "distanceAlongShapeM": 6475.519,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            }
          ],
          "departuresSeconds": [
            20640,
            22800,
            24300,
            26100,
            27780,
            29580,
            31380,
            33180,
            36600,
            39780,
            43080,
            46320,
            49500,
            52800,
            54240,
            56220,
            57900,
            59760,
            61620,
            63540,
            65400,
            67260,
            69120,
            72600,
            75600,
            78720,
            81960
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_42",
      "sourceRouteId": "vilnius_bus_42",
      "mode": "bus",
      "shortName": "42",
      "longName": "Stotis–Eišiškių pl.–Salininkai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_42:0",
          "sourceRouteId": "vilnius_bus_42",
          "sourceShapeId": "vilnius_bus_42_a-b",
          "directionId": 0,
          "headsign": "Salininkai",
          "directionName": "Stotis–Eišiškių pl.–Salininkai",
          "mode": "bus",
          "routeShortName": "42",
          "routeLongName": "Stotis–Eišiškių pl.–Salininkai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              378.73,
              1828.551,
              0
            ],
            [
              425.25,
              1832.153,
              46.659
            ],
            [
              579.14,
              1850.487,
              201.637
            ],
            [
              587.002,
              1857.023,
              211.861
            ],
            [
              594.321,
              1869.134,
              226.012
            ],
            [
              472.814,
              1928.134,
              361.086
            ],
            [
              461.768,
              1923.883,
              372.922
            ],
            [
              443.043,
              1923.113,
              391.662
            ],
            [
              408.316,
              1929.314,
              426.939
            ],
            [
              398.702,
              1932.829,
              437.175
            ],
            [
              373.309,
              1955.558,
              471.254
            ],
            [
              366.499,
              1971.268,
              488.377
            ],
            [
              365.997,
              1979.07,
              496.195
            ],
            [
              369.323,
              1984.575,
              502.627
            ],
            [
              374.585,
              1990.045,
              510.217
            ],
            [
              389.562,
              1997.564,
              526.976
            ],
            [
              401.172,
              1997.352,
              538.587
            ],
            [
              408.871,
              1994.984,
              546.642
            ],
            [
              424.209,
              1986.911,
              563.975
            ],
            [
              467.559,
              1958.288,
              615.922
            ],
            [
              473.887,
              1951.492,
              625.208
            ],
            [
              474.993,
              1941.453,
              635.308
            ],
            [
              465.719,
              1928.264,
              651.431
            ],
            [
              461.143,
              1925.008,
              657.047
            ],
            [
              452.073,
              1922.947,
              666.349
            ],
            [
              409.585,
              1928.177,
              709.157
            ],
            [
              398.6,
              1927.265,
              720.18
            ],
            [
              334.106,
              1822.687,
              843.047
            ],
            [
              318.606,
              1821.856,
              858.568
            ],
            [
              29.934,
              1735.835,
              1159.785
            ],
            [
              -11.424,
              1732.135,
              1201.308
            ],
            [
              -46.755,
              1740.57,
              1237.632
            ],
            [
              -320.217,
              1781.157,
              1514.089
            ],
            [
              -515.259,
              1841.463,
              1718.242
            ],
            [
              -520.923,
              1849.358,
              1727.958
            ],
            [
              -526.486,
              1862.817,
              1742.522
            ],
            [
              -511.654,
              1933.795,
              1815.033
            ],
            [
              -496.901,
              1964.699,
              1849.278
            ],
            [
              -462.075,
              2106.562,
              1995.353
            ],
            [
              -436.719,
              2188.482,
              2081.107
            ],
            [
              -427.991,
              2207.248,
              2101.804
            ],
            [
              -344.32,
              2338.207,
              2257.211
            ],
            [
              -326.137,
              2380.181,
              2302.953
            ],
            [
              -285.296,
              2533.066,
              2461.199
            ],
            [
              -290.153,
              2585.475,
              2513.834
            ],
            [
              -278.622,
              2616.436,
              2546.872
            ],
            [
              -251.706,
              2819.669,
              2751.879
            ],
            [
              -239.003,
              2950.799,
              2883.623
            ],
            [
              -239.164,
              2977.519,
              2910.344
            ],
            [
              -244.788,
              3023.264,
              2956.433
            ],
            [
              -255.513,
              3072.44,
              3006.765
            ],
            [
              -253.335,
              3121.382,
              3055.756
            ],
            [
              -336.623,
              3547.03,
              3489.476
            ],
            [
              -379.958,
              3791.61,
              3737.866
            ],
            [
              -382.016,
              3856.215,
              3802.503
            ],
            [
              -345.945,
              4030.338,
              3980.323
            ],
            [
              -408.418,
              4109.394,
              4081.084
            ],
            [
              -481.301,
              4219.808,
              4213.383
            ],
            [
              -539.627,
              4314.372,
              4324.488
            ],
            [
              -578.027,
              4368.5,
              4390.854
            ],
            [
              -621.677,
              4489.515,
              4519.501
            ],
            [
              -657.683,
              4569.203,
              4606.946
            ],
            [
              -715.86,
              4708.291,
              4757.711
            ],
            [
              -753.761,
              4754.616,
              4817.564
            ],
            [
              -787.149,
              4836.482,
              4905.977
            ],
            [
              -899.06,
              5075.611,
              5169.997
            ],
            [
              -917.463,
              5129.376,
              5226.824
            ],
            [
              -979.628,
              5262.965,
              5374.17
            ],
            [
              -1065.501,
              5406.998,
              5541.859
            ],
            [
              -1113.826,
              5484.677,
              5633.343
            ],
            [
              -1139.633,
              5521.875,
              5678.617
            ],
            [
              -1160.802,
              5565.67,
              5727.259
            ],
            [
              -1252.943,
              5720.943,
              5907.813
            ],
            [
              -1341.654,
              5851.663,
              6065.792
            ],
            [
              -1434.869,
              5983.574,
              6227.314
            ],
            [
              -1434.909,
              5981.348,
              6229.541
            ],
            [
              -1471.061,
              6054.352,
              6311.005
            ],
            [
              -1667.918,
              6422.993,
              6728.916
            ],
            [
              -1679.373,
              6468.839,
              6776.171
            ],
            [
              -1707.91,
              6788.838,
              7097.44
            ],
            [
              -1715.73,
              6821.26,
              7130.791
            ],
            [
              -1712.83,
              6839.019,
              7148.786
            ],
            [
              -1721.42,
              6937.135,
              7247.277
            ],
            [
              -1729.279,
              6967.331,
              7278.479
            ],
            [
              -1746.568,
              7012.167,
              7326.533
            ],
            [
              -1767.164,
              7052.608,
              7371.917
            ],
            [
              -1986.586,
              7354.842,
              7745.402
            ],
            [
              -2025.991,
              7391.163,
              7798.993
            ],
            [
              -2098.584,
              7450.335,
              7892.647
            ],
            [
              -2040.584,
              7588.459,
              8042.454
            ],
            [
              -2023.848,
              7621.558,
              8079.544
            ],
            [
              -2003.942,
              7651.262,
              8115.301
            ],
            [
              -1949.699,
              7759.395,
              8236.276
            ],
            [
              -1905.866,
              7863.259,
              8349.011
            ],
            [
              -1804.677,
              8031.784,
              8545.581
            ],
            [
              -1769.656,
              8075.69,
              8601.743
            ],
            [
              -1704.351,
              8151.341,
              8701.682
            ],
            [
              -1667.469,
              8190.76,
              8755.665
            ],
            [
              -1631.959,
              8225.751,
              8805.518
            ],
            [
              -1597.192,
              8255.189,
              8851.074
            ],
            [
              -1555.301,
              8285.612,
              8902.847
            ],
            [
              -1542.006,
              8306.527,
              8927.629
            ],
            [
              -1526.833,
              8324.068,
              8950.822
            ],
            [
              -1510.907,
              8383.897,
              9012.735
            ],
            [
              -1505.414,
              8438.346,
              9067.461
            ],
            [
              -1503.229,
              8488.402,
              9117.564
            ],
            [
              -1511.708,
              8556.458,
              9186.146
            ],
            [
              -1543.904,
              8744.051,
              9376.482
            ],
            [
              -1556.03,
              8788.795,
              9422.84
            ],
            [
              -1618.698,
              9225.174,
              9863.696
            ],
            [
              -1566.739,
              9239.834,
              9917.683
            ],
            [
              -1337.858,
              9282.508,
              10150.508
            ],
            [
              -974.57,
              9288.252,
              10513.841
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7914",
              "position": {
                "x": 373.309,
                "z": 1955.558
              },
              "distanceAlongShapeM": 471.254,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 1201.308,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 1815.033,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 2513.834,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 3006.765,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5304",
              "position": {
                "x": -578.027,
                "z": 4368.5
              },
              "distanceAlongShapeM": 4390.854,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8339",
              "position": {
                "x": -753.761,
                "z": 4754.616
              },
              "distanceAlongShapeM": 4817.564,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6948",
              "position": {
                "x": -899.06,
                "z": 5075.611
              },
              "distanceAlongShapeM": 5169.997,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6949",
              "position": {
                "x": -1139.633,
                "z": 5521.875
              },
              "distanceAlongShapeM": 5678.617,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8347",
              "position": {
                "x": -1434.909,
                "z": 5981.348
              },
              "distanceAlongShapeM": 6229.541,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6963",
              "position": {
                "x": -1715.73,
                "z": 6821.26
              },
              "distanceAlongShapeM": 7130.791,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6967",
              "position": {
                "x": -2023.848,
                "z": 7621.558
              },
              "distanceAlongShapeM": 8079.544,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6264",
              "position": {
                "x": -1542.006,
                "z": 8306.527
              },
              "distanceAlongShapeM": 8927.629,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6261",
              "position": {
                "x": -1556.03,
                "z": 8788.795
              },
              "distanceAlongShapeM": 9422.84,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6257",
              "position": {
                "x": -1566.739,
                "z": 9239.834
              },
              "distanceAlongShapeM": 9917.683,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6253",
              "position": {
                "x": -974.57,
                "z": 9288.252
              },
              "distanceAlongShapeM": 10513.841,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            19080,
            21240,
            23400,
            25680,
            26880,
            28080,
            30660,
            33060,
            35100,
            37620,
            40020,
            42420,
            44640,
            46860,
            49140,
            51420,
            53700,
            55920,
            58200,
            59820,
            61440,
            63600,
            65820,
            68400,
            70740,
            73380,
            75540,
            77760,
            79920
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_42:1",
          "sourceRouteId": "vilnius_bus_42",
          "sourceShapeId": "vilnius_bus_42_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Salininkai–Eišiškių pl.–Stotis",
          "mode": "bus",
          "routeShortName": "42",
          "routeLongName": "Stotis–Eišiškių pl.–Salininkai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -974.57,
              9288.252,
              0
            ],
            [
              -970.754,
              9284.844,
              5.117
            ],
            [
              -956.601,
              9281.251,
              19.718
            ],
            [
              -947.577,
              9279.976,
              28.832
            ],
            [
              -933.324,
              9281.946,
              43.221
            ],
            [
              -922.828,
              9290.664,
              56.865
            ],
            [
              -911.566,
              9306.047,
              75.93
            ],
            [
              -905.066,
              9308.156,
              82.764
            ],
            [
              -888.329,
              9304.516,
              99.892
            ],
            [
              -880.696,
              9297.7,
              110.125
            ],
            [
              -878.878,
              9290.988,
              117.079
            ],
            [
              -878.978,
              9285.424,
              122.644
            ],
            [
              -881.622,
              9282.132,
              126.866
            ],
            [
              -888.748,
              9281.146,
              134.061
            ],
            [
              -908.755,
              9282.619,
              154.122
            ],
            [
              -979.918,
              9278.329,
              225.414
            ],
            [
              -1100.805,
              9276.043,
              346.322
            ],
            [
              -1181.459,
              9283.052,
              427.28
            ],
            [
              -1238.936,
              9285.193,
              484.797
            ],
            [
              -1308.161,
              9280.864,
              554.157
            ],
            [
              -1343.772,
              9277.047,
              589.972
            ],
            [
              -1428.033,
              9262.966,
              675.402
            ],
            [
              -1538.979,
              9238.226,
              789.073
            ],
            [
              -1618.698,
              9225.174,
              869.853
            ],
            [
              -1611.777,
              9178.296,
              917.238
            ],
            [
              -1592.202,
              9079.986,
              1017.479
            ],
            [
              -1553.05,
              8811.006,
              1289.293
            ],
            [
              -1548.081,
              8799.785,
              1301.565
            ],
            [
              -1540.488,
              8790.744,
              1313.371
            ],
            [
              -1537.516,
              8776.22,
              1328.197
            ],
            [
              -1545.584,
              8758.552,
              1347.619
            ],
            [
              -1504.025,
              8516.246,
              1593.464
            ],
            [
              -1501.391,
              8482.803,
              1627.011
            ],
            [
              -1502.671,
              8447.203,
              1662.634
            ],
            [
              -1506.496,
              8413.875,
              1696.18
            ],
            [
              -1524.816,
              8328.484,
              1783.514
            ],
            [
              -1523.196,
              8310.644,
              1801.428
            ],
            [
              -1526.037,
              8296.223,
              1816.126
            ],
            [
              -1532.635,
              8288.548,
              1826.247
            ],
            [
              -1550.213,
              8281.069,
              1845.35
            ],
            [
              -1597.232,
              8252.963,
              1900.129
            ],
            [
              -1633.27,
              8224.661,
              1945.952
            ],
            [
              -1763.019,
              8085.591,
              2136.15
            ],
            [
              -1804.677,
              8031.784,
              2204.198
            ],
            [
              -1903.889,
              7865.451,
              2397.873
            ],
            [
              -1952.381,
              7753.877,
              2519.529
            ],
            [
              -2057.537,
              7543.118,
              2755.065
            ],
            [
              -2098.584,
              7450.335,
              2856.521
            ],
            [
              -2070.914,
              7444.279,
              2884.846
            ],
            [
              -2050.683,
              7419.43,
              2916.889
            ],
            [
              -1961.855,
              7328.8,
              3043.792
            ],
            [
              -1773.99,
              7068.315,
              3364.955
            ],
            [
              -1717.974,
              6949.319,
              3496.476
            ],
            [
              -1717.474,
              6904.781,
              3541.017
            ],
            [
              -1680.546,
              6475.539,
              3971.845
            ],
            [
              -1667.918,
              6422.993,
              4025.886
            ],
            [
              -1471.061,
              6054.352,
              4443.797
            ],
            [
              -1459.639,
              6043.016,
              4459.889
            ],
            [
              -1442.825,
              6008.206,
              4498.547
            ],
            [
              -1415.255,
              5960.959,
              4553.25
            ],
            [
              -1252.943,
              5720.943,
              4842.996
            ],
            [
              -1174.644,
              5585.956,
              4999.048
            ],
            [
              -1106.766,
              5482.324,
              5122.931
            ],
            [
              -972.688,
              5253.935,
              5387.767
            ],
            [
              -871.561,
              5025.022,
              5638.024
            ],
            [
              -865.187,
              5020.454,
              5645.865
            ],
            [
              -856.066,
              4989.12,
              5678.5
            ],
            [
              -801.413,
              4869.022,
              5810.449
            ],
            [
              -766.573,
              4796.036,
              5891.324
            ],
            [
              -708.316,
              4697.023,
              6006.204
            ],
            [
              -707.871,
              4685.883,
              6017.353
            ],
            [
              -676.746,
              4621.868,
              6088.533
            ],
            [
              -601.144,
              4446.842,
              6279.189
            ],
            [
              -555.117,
              4350.275,
              6386.165
            ],
            [
              -482.27,
              4237.637,
              6520.307
            ],
            [
              -475.614,
              4213.025,
              6545.802
            ],
            [
              -396.44,
              4093.592,
              6689.095
            ],
            [
              -345.945,
              4030.338,
              6770.033
            ],
            [
              -378.367,
              3879.526,
              6924.29
            ],
            [
              -382.056,
              3853.989,
              6950.092
            ],
            [
              -382.136,
              3813.914,
              6990.167
            ],
            [
              -379.958,
              3791.61,
              7012.577
            ],
            [
              -326.239,
              3550.182,
              7259.91
            ],
            [
              -300.672,
              3393.867,
              7418.301
            ],
            [
              -259.604,
              3167.138,
              7648.72
            ],
            [
              -234.366,
              2993.018,
              7824.66
            ],
            [
              -225.435,
              2951.666,
              7866.965
            ],
            [
              -266.588,
              2603.973,
              8217.085
            ],
            [
              -287.151,
              2501.929,
              8321.18
            ],
            [
              -327.226,
              2355.709,
              8472.792
            ],
            [
              -350.367,
              2324.958,
              8511.278
            ],
            [
              -412.128,
              2228.113,
              8626.141
            ],
            [
              -425.492,
              2202.75,
              8654.808
            ],
            [
              -439.803,
              2160.707,
              8699.221
            ],
            [
              -445.668,
              2121.85,
              8738.518
            ],
            [
              -471.768,
              2034.377,
              8829.801
            ],
            [
              -499.661,
              1919.106,
              8948.399
            ],
            [
              -508.548,
              1855.813,
              9012.313
            ],
            [
              -490.609,
              1848.809,
              9031.57
            ],
            [
              -470.051,
              1843.985,
              9052.687
            ],
            [
              -432.32,
              1825.49,
              9094.707
            ],
            [
              -327.19,
              1787.963,
              9206.334
            ],
            [
              -259.046,
              1774.482,
              9275.799
            ],
            [
              -147.106,
              1756.865,
              9389.117
            ],
            [
              9.981,
              1738.424,
              9547.282
            ],
            [
              41.02,
              1742.312,
              9578.563
            ],
            [
              63.816,
              1754.143,
              9604.247
            ],
            [
              135.751,
              1771.757,
              9678.307
            ],
            [
              319.251,
              1821.845,
              9868.52
            ],
            [
              341.2,
              1822.557,
              9890.481
            ],
            [
              378.73,
              1828.551,
              9928.487
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6254",
              "position": {
                "x": -1100.805,
                "z": 9276.043
              },
              "distanceAlongShapeM": 346.322,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6256",
              "position": {
                "x": -1538.979,
                "z": 9238.226
              },
              "distanceAlongShapeM": 789.073,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6260",
              "position": {
                "x": -1540.488,
                "z": 8790.744
              },
              "distanceAlongShapeM": 1313.371,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6263",
              "position": {
                "x": -1532.635,
                "z": 8288.548
              },
              "distanceAlongShapeM": 1826.247,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6966",
              "position": {
                "x": -2070.914,
                "z": 7444.279
              },
              "distanceAlongShapeM": 2884.846,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6964",
              "position": {
                "x": -1717.974,
                "z": 6949.319
              },
              "distanceAlongShapeM": 3496.476,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6961",
              "position": {
                "x": -1459.639,
                "z": 6043.016
              },
              "distanceAlongShapeM": 4459.889,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6950",
              "position": {
                "x": -1106.766,
                "z": 5482.324
              },
              "distanceAlongShapeM": 5122.931,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6947",
              "position": {
                "x": -865.187,
                "z": 5020.454
              },
              "distanceAlongShapeM": 5645.865,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5307",
              "position": {
                "x": -708.316,
                "z": 4697.023
              },
              "distanceAlongShapeM": 6006.204,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5305",
              "position": {
                "x": -482.27,
                "z": 4237.637
              },
              "distanceAlongShapeM": 6520.307,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 7866.965,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 8217.085,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 9052.687,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 9604.247,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:16581",
              "position": {
                "x": 378.73,
                "z": 1828.551
              },
              "distanceAlongShapeM": 9928.487,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            18960,
            21120,
            23400,
            25740,
            28140,
            30300,
            32580,
            35160,
            36420,
            37980,
            40080,
            42360,
            44520,
            46800,
            49020,
            51360,
            53580,
            56100,
            58620,
            61020,
            63300,
            66300,
            68340,
            69540,
            71400,
            73500,
            75540,
            77640,
            79740,
            81900
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_43",
      "sourceRouteId": "vilnius_bus_43",
      "mode": "bus",
      "shortName": "43",
      "longName": "Justiniškės–Šeškinė–Žaliasis tiltas–Centras (Apylanka Rygos g.)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_43:0",
          "sourceRouteId": "vilnius_bus_43",
          "sourceShapeId": "vilnius_bus_43_a1-b_12345",
          "directionId": 0,
          "headsign": "Centras (Apylanka Rygos g.)",
          "directionName": "Justiniškės–Šeškinė–Žaliasis tiltas–Centras (Apylanka Rygos g.)",
          "mode": "bus",
          "routeShortName": "43",
          "routeLongName": "Justiniškės–Šeškinė–Žaliasis tiltas–Centras (Apylanka Rygos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4210.635,
              -2255.507,
              0
            ],
            [
              -4196.209,
              -2315.87,
              62.063
            ],
            [
              -4165.8,
              -2421.037,
              171.538
            ],
            [
              -4138.614,
              -2526.149,
              280.109
            ],
            [
              -4122.867,
              -2733.479,
              488.036
            ],
            [
              -4112.669,
              -2926.241,
              681.067
            ],
            [
              -4108.545,
              -2948.576,
              703.781
            ],
            [
              -4174.702,
              -3308.112,
              1069.352
            ],
            [
              -4111.181,
              -3286.947,
              1136.305
            ],
            [
              -4018.747,
              -3270.737,
              1230.15
            ],
            [
              -3940.176,
              -3236.477,
              1315.866
            ],
            [
              -3823.754,
              -3175.046,
              1447.501
            ],
            [
              -3810.695,
              -3165.254,
              1463.823
            ],
            [
              -3713.888,
              -3120.182,
              1570.608
            ],
            [
              -3714.983,
              -3109.031,
              1581.813
            ],
            [
              -3665.065,
              -3092.089,
              1634.528
            ],
            [
              -3645.64,
              -3086.861,
              1654.644
            ],
            [
              -3537.19,
              -3076.506,
              1763.587
            ],
            [
              -3288.387,
              -3074.173,
              2012.402
            ],
            [
              -3226.908,
              -3059.664,
              2075.569
            ],
            [
              -3088.313,
              -3020.904,
              2219.483
            ],
            [
              -3076.618,
              -3015.543,
              2232.347
            ],
            [
              -3065.626,
              -3013.509,
              2243.526
            ],
            [
              -3013.674,
              -2991.043,
              2300.127
            ],
            [
              -2972.908,
              -2981.74,
              2341.941
            ],
            [
              -2923.591,
              -2962.569,
              2394.854
            ],
            [
              -2796.251,
              -2867.959,
              2553.493
            ],
            [
              -2713.249,
              -2802.628,
              2659.122
            ],
            [
              -2678.551,
              -2772.069,
              2705.358
            ],
            [
              -2644.38,
              -2734.822,
              2755.905
            ],
            [
              -2636.314,
              -2716.04,
              2776.346
            ],
            [
              -2600.033,
              -2668.811,
              2835.902
            ],
            [
              -2574.02,
              -2619.176,
              2891.941
            ],
            [
              -2552.25,
              -2627.352,
              2915.196
            ],
            [
              -2471.713,
              -2665.511,
              3004.315
            ],
            [
              -2386.944,
              -2719.332,
              3104.727
            ],
            [
              -2340.637,
              -2761.341,
              3167.249
            ],
            [
              -2270.657,
              -2849.412,
              3279.738
            ],
            [
              -2238.843,
              -2908.976,
              3347.266
            ],
            [
              -2163.402,
              -2906.975,
              3422.734
            ],
            [
              -2137.689,
              -2910.771,
              3448.725
            ],
            [
              -2030.191,
              -2918.246,
              3556.483
            ],
            [
              -2013.906,
              -2908.516,
              3575.453
            ],
            [
              -1990.089,
              -2837.694,
              3650.173
            ],
            [
              -1938.142,
              -2707.257,
              3790.574
            ],
            [
              -1897.174,
              -2614.475,
              3891.998
            ],
            [
              -1860.754,
              -2596.199,
              3932.746
            ],
            [
              -1827.269,
              -2525.549,
              4010.93
            ],
            [
              -1801.306,
              -2479.256,
              4064.006
            ],
            [
              -1807.234,
              -2450.207,
              4093.654
            ],
            [
              -1793.772,
              -2418.163,
              4128.411
            ],
            [
              -1749.309,
              -2346.596,
              4212.664
            ],
            [
              -1747.763,
              -2332.152,
              4227.191
            ],
            [
              -1727.311,
              -2305.799,
              4260.549
            ],
            [
              -1547.472,
              -2017.345,
              4600.472
            ],
            [
              -1343.434,
              -1674.784,
              4999.195
            ],
            [
              -1305.861,
              -1628.702,
              5058.653
            ],
            [
              -1268.647,
              -1602.651,
              5104.079
            ],
            [
              -1054.592,
              -1494.059,
              5344.103
            ],
            [
              -1027.103,
              -1471.176,
              5379.871
            ],
            [
              -1009.966,
              -1450.333,
              5406.854
            ],
            [
              -1001.511,
              -1410.409,
              5447.664
            ],
            [
              -987.78,
              -1363.9,
              5496.157
            ],
            [
              -988.723,
              -1201.352,
              5658.708
            ],
            [
              -990.397,
              -1186.85,
              5673.306
            ],
            [
              -1017.615,
              -1122.906,
              5742.802
            ],
            [
              -1020.518,
              -1105.042,
              5760.9
            ],
            [
              -1018.304,
              -1089.497,
              5776.602
            ],
            [
              -1013.532,
              -1075.111,
              5791.759
            ],
            [
              -1005.537,
              -1060.783,
              5808.167
            ],
            [
              -969.041,
              -1039.175,
              5850.58
            ],
            [
              -947.066,
              -1036.231,
              5872.751
            ],
            [
              -930.307,
              -1036.533,
              5889.513
            ],
            [
              -906.579,
              -1043.639,
              5914.282
            ],
            [
              -895.802,
              -1053.852,
              5929.13
            ],
            [
              -890.221,
              -1066.198,
              5942.679
            ],
            [
              -882.043,
              -1077.478,
              5956.612
            ],
            [
              -868.708,
              -1088.851,
              5974.137
            ],
            [
              -845.624,
              -1095.946,
              5998.287
            ],
            [
              -837.245,
              -1096.097,
              6006.667
            ],
            [
              -813.336,
              -1093.188,
              6030.752
            ],
            [
              -786.145,
              -1086.999,
              6058.639
            ],
            [
              -775.751,
              -1082.734,
              6069.874
            ],
            [
              -717.641,
              -1078.217,
              6128.159
            ],
            [
              -647.083,
              -1062.792,
              6200.384
            ],
            [
              -599.769,
              -1049.176,
              6249.618
            ],
            [
              -535.555,
              -1028.072,
              6317.211
            ],
            [
              -464.693,
              -995.958,
              6395.01
            ],
            [
              -361.843,
              -942.16,
              6511.081
            ],
            [
              -333.702,
              -919.293,
              6547.342
            ],
            [
              -286.889,
              -897.877,
              6598.821
            ],
            [
              -196.966,
              -846.075,
              6702.597
            ],
            [
              -115.583,
              -803.025,
              6794.665
            ],
            [
              -96.647,
              -790.01,
              6817.642
            ],
            [
              -42.035,
              -765.399,
              6877.544
            ],
            [
              224.176,
              -700.119,
              7151.642
            ],
            [
              211.01,
              -644.216,
              7209.073
            ],
            [
              143.71,
              -480.456,
              7386.123
            ],
            [
              121.213,
              -441.083,
              7431.47
            ],
            [
              119.827,
              -411,
              7461.585
            ],
            [
              106.146,
              -277.163,
              7596.12
            ],
            [
              35.151,
              -280.322,
              7667.185
            ],
            [
              -101.904,
              -298.979,
              7805.503
            ],
            [
              -140.08,
              -306.078,
              7844.335
            ],
            [
              -153.095,
              -312.52,
              7858.857
            ],
            [
              -191.836,
              -315.156,
              7897.687
            ],
            [
              -244.276,
              -326.45,
              7951.329
            ],
            [
              -305.298,
              -348.72,
              8016.288
            ],
            [
              -335.653,
              -209.016,
              8159.252
            ],
            [
              -372.48,
              -212.801,
              8196.274
            ],
            [
              -418.232,
              -210.859,
              8242.067
            ],
            [
              -451.474,
              -230.295,
              8280.573
            ],
            [
              -476.052,
              -269.926,
              8327.207
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6990",
              "position": {
                "x": -4210.635,
                "z": -2255.507
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -1320,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6993",
              "position": {
                "x": -4108.545,
                "z": -2948.576
              },
              "distanceAlongShapeM": 703.781,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:15412",
              "position": {
                "x": -4111.181,
                "z": -3286.947
              },
              "distanceAlongShapeM": 1136.305,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7001",
              "position": {
                "x": -3665.065,
                "z": -3092.089
              },
              "distanceAlongShapeM": 1634.528,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 2300.127,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 2776.346,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7003",
              "position": {
                "x": -2163.402,
                "z": -2906.975
              },
              "distanceAlongShapeM": 3422.734,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 4227.191,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 5447.664,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 6069.874,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 6547.342,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 6877.544,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 7431.47,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5249",
              "position": {
                "x": -153.095,
                "z": -312.52
              },
              "distanceAlongShapeM": 7858.857,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6356",
              "position": {
                "x": -476.052,
                "z": -269.926
              },
              "distanceAlongShapeM": 8327.207,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            19200,
            20100,
            21000,
            21600,
            22500,
            23400,
            24300,
            25200,
            26100,
            27000,
            27900,
            28800,
            29700,
            30600,
            31800,
            33000,
            34200,
            35100,
            36300,
            37500,
            38700,
            39900,
            41100,
            42300,
            43200,
            44400,
            45600,
            46800,
            48000,
            49200,
            50400,
            51600,
            52800,
            53700,
            54600,
            55500,
            56400,
            57000,
            57900,
            58800,
            59700,
            60600,
            61800,
            62700,
            63600,
            64500,
            65400,
            66600,
            67800,
            69000,
            70200,
            71100,
            72300,
            73500,
            74700,
            75900,
            77100,
            78300,
            79500,
            80700,
            81900,
            83100,
            84000
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_43:1",
          "sourceRouteId": "vilnius_bus_43",
          "sourceShapeId": "vilnius_bus_43_b-a1_12345",
          "directionId": 1,
          "headsign": "Justiniškės (Apylanka Rygos g.)",
          "directionName": "Centras–Žaliasis tiltas–Šeškinė–Justiniškės (Apylanka Rygos g.)",
          "mode": "bus",
          "routeShortName": "43",
          "routeLongName": "Justiniškės–Šeškinė–Žaliasis tiltas–Centras (Apylanka Rygos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -476.052,
              -269.926,
              0
            ],
            [
              -501.093,
              -299.53,
              38.774
            ],
            [
              -461.426,
              -352.57,
              105.007
            ],
            [
              -449.339,
              -361.695,
              120.151
            ],
            [
              -413.017,
              -421.354,
              189.997
            ],
            [
              -305.298,
              -348.72,
              319.917
            ],
            [
              -203.339,
              -309.381,
              429.202
            ],
            [
              -102.285,
              -284.5,
              533.274
            ],
            [
              -50.388,
              -267.632,
              587.843
            ],
            [
              -22.626,
              -265.911,
              615.658
            ],
            [
              -0.545,
              -257.407,
              639.32
            ],
            [
              46.601,
              -218.189,
              700.645
            ],
            [
              70.758,
              -201.931,
              729.764
            ],
            [
              82.464,
              -196.578,
              742.636
            ],
            [
              94.753,
              -194.576,
              755.087
            ],
            [
              103.738,
              -196.966,
              764.385
            ],
            [
              115.784,
              -208.318,
              780.937
            ],
            [
              119.866,
              -267.394,
              840.153
            ],
            [
              118.552,
              -304.106,
              876.89
            ],
            [
              124.949,
              -377.696,
              950.757
            ],
            [
              130.203,
              -407.85,
              981.365
            ],
            [
              150.182,
              -443.837,
              1022.527
            ],
            [
              177.186,
              -518.917,
              1102.314
            ],
            [
              187.997,
              -562.53,
              1147.248
            ],
            [
              214.213,
              -645.388,
              1234.154
            ],
            [
              224.323,
              -656.705,
              1249.33
            ],
            [
              237.149,
              -695.903,
              1290.572
            ],
            [
              236.925,
              -708.144,
              1302.816
            ],
            [
              229.693,
              -715.805,
              1313.351
            ],
            [
              23.734,
              -765.484,
              1525.216
            ],
            [
              -53.078,
              -805.275,
              1611.723
            ],
            [
              -306.711,
              -924.235,
              1891.868
            ],
            [
              -475.993,
              -1014.678,
              2083.797
            ],
            [
              -534.689,
              -1051.466,
              2153.068
            ],
            [
              -673.187,
              -1080.133,
              2294.502
            ],
            [
              -763.423,
              -1114.127,
              2390.928
            ],
            [
              -822.801,
              -1117.509,
              2450.403
            ],
            [
              -837.686,
              -1120.58,
              2465.602
            ],
            [
              -857.223,
              -1131.36,
              2487.915
            ],
            [
              -899.68,
              -1161.766,
              2540.137
            ],
            [
              -917.464,
              -1182.597,
              2567.526
            ],
            [
              -926.283,
              -1206.929,
              2593.408
            ],
            [
              -917.431,
              -1323.977,
              2710.79
            ],
            [
              -911.942,
              -1448.758,
              2835.692
            ],
            [
              -922.391,
              -1491.986,
              2880.164
            ],
            [
              -939.829,
              -1529.521,
              2921.553
            ],
            [
              -961.618,
              -1558.073,
              2957.469
            ],
            [
              -995.732,
              -1590.856,
              3004.782
            ],
            [
              -1026.383,
              -1610.342,
              3041.103
            ],
            [
              -1072.441,
              -1626.213,
              3089.818
            ],
            [
              -1262.636,
              -1662.874,
              3283.514
            ],
            [
              -1320.472,
              -1688.554,
              3346.795
            ],
            [
              -1370.209,
              -1729.965,
              3411.515
            ],
            [
              -1651.924,
              -2199.162,
              3958.789
            ],
            [
              -1682.619,
              -2257.615,
              4024.811
            ],
            [
              -1702.963,
              -2314.026,
              4084.779
            ],
            [
              -1711.936,
              -2347.263,
              4119.205
            ],
            [
              -1753.781,
              -2416.65,
              4200.234
            ],
            [
              -1791.442,
              -2468.3,
              4264.156
            ],
            [
              -1796.31,
              -2488.251,
              4284.693
            ],
            [
              -1790.243,
              -2509.511,
              4306.801
            ],
            [
              -1775.641,
              -2522.016,
              4326.026
            ],
            [
              -1757.6,
              -2522.338,
              4344.07
            ],
            [
              -1741.372,
              -2515.948,
              4361.511
            ],
            [
              -1726.898,
              -2499.508,
              4383.414
            ],
            [
              -1700.955,
              -2454.328,
              4435.513
            ],
            [
              -1699.408,
              -2439.884,
              4450.04
            ],
            [
              -1703.055,
              -2427.574,
              4462.88
            ],
            [
              -1715.06,
              -2414.001,
              4481
            ],
            [
              -1729.117,
              -2407.071,
              4496.672
            ],
            [
              -1892.062,
              -2399.714,
              4659.783
            ],
            [
              -1904.503,
              -2410.625,
              4676.33
            ],
            [
              -1906.831,
              -2505.207,
              4770.942
            ],
            [
              -1911.955,
              -2539.626,
              4805.74
            ],
            [
              -1930.967,
              -2593.836,
              4863.187
            ],
            [
              -1945.717,
              -2625.857,
              4898.441
            ],
            [
              -2027.538,
              -2841.481,
              5129.067
            ],
            [
              -2052.018,
              -2913.405,
              5205.044
            ],
            [
              -2063.11,
              -2921.001,
              5218.487
            ],
            [
              -2092.806,
              -2923.813,
              5248.316
            ],
            [
              -2134.547,
              -2915.279,
              5290.92
            ],
            [
              -2189.877,
              -2909.844,
              5346.516
            ],
            [
              -2238.843,
              -2908.976,
              5395.49
            ],
            [
              -2253.813,
              -2880.88,
              5427.325
            ],
            [
              -2299.624,
              -2811.049,
              5510.843
            ],
            [
              -2361.565,
              -2742.045,
              5603.568
            ],
            [
              -2438.543,
              -2685.023,
              5699.366
            ],
            [
              -2496.606,
              -2651.713,
              5766.306
            ],
            [
              -2552.25,
              -2627.352,
              5827.048
            ],
            [
              -2587.598,
              -2694.635,
              5903.051
            ],
            [
              -2667.366,
              -2795.644,
              6031.759
            ],
            [
              -2878.335,
              -2954.459,
              6295.823
            ],
            [
              -2942.823,
              -2993.401,
              6371.157
            ],
            [
              -2993.467,
              -3014.776,
              6426.128
            ],
            [
              -3056.314,
              -3033.711,
              6491.765
            ],
            [
              -3148.249,
              -3057.702,
              6586.779
            ],
            [
              -3175.503,
              -3068.357,
              6616.042
            ],
            [
              -3256.271,
              -3080.301,
              6697.687
            ],
            [
              -3258.184,
              -3079.154,
              6699.918
            ],
            [
              -3398.204,
              -3088.951,
              6840.28
            ],
            [
              -3540.683,
              -3092.03,
              6982.793
            ],
            [
              -3587.831,
              -3097.887,
              7030.303
            ],
            [
              -3688.781,
              -3121.733,
              7134.032
            ],
            [
              -4068.739,
              -3292.135,
              7550.45
            ],
            [
              -4174.702,
              -3308.112,
              7657.611
            ],
            [
              -4176.922,
              -3250.186,
              7715.579
            ],
            [
              -4124.202,
              -3034.023,
              7938.078
            ],
            [
              -4119.192,
              -3005.166,
              7967.367
            ],
            [
              -4115.728,
              -2954.018,
              8018.632
            ],
            [
              -4117.064,
              -2919.485,
              8053.19
            ],
            [
              -4123.554,
              -2884.864,
              8088.415
            ],
            [
              -4122.899,
              -2847.026,
              8126.259
            ],
            [
              -4138.614,
              -2526.149,
              8447.52
            ],
            [
              -4201.835,
              -2305.753,
              8676.804
            ],
            [
              -4229.293,
              -2290.807,
              8708.066
            ],
            [
              -4250.952,
              -2275.961,
              8734.325
            ],
            [
              -4254.722,
              -2270.33,
              8741.102
            ],
            [
              -4258.829,
              -2246.881,
              8764.907
            ],
            [
              -4260.118,
              -2246.859,
              8766.196
            ],
            [
              -4255.982,
              -2231.346,
              8782.251
            ],
            [
              -4254.713,
              -2232.481,
              8783.954
            ],
            [
              -4246.201,
              -2224.835,
              8795.395
            ],
            [
              -4226.129,
              -2219.616,
              8816.135
            ],
            [
              -4210.635,
              -2255.507,
              8855.227
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6356",
              "position": {
                "x": -476.052,
                "z": -269.926
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5258",
              "position": {
                "x": -449.339,
                "z": -361.695
              },
              "distanceAlongShapeM": 120.151,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 587.843,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 1022.527,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 1611.723,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 2153.068,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 2390.928,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 4119.205,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5294",
              "position": {
                "x": -1930.967,
                "z": -2593.836
              },
              "distanceAlongShapeM": 4863.187,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5209",
              "position": {
                "x": -2092.806,
                "z": -2923.813
              },
              "distanceAlongShapeM": 5248.316,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 6031.759,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5137",
              "position": {
                "x": -3175.503,
                "z": -3068.357
              },
              "distanceAlongShapeM": 6616.042,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:15411",
              "position": {
                "x": -3782.29,
                "z": -3162.408
              },
              "distanceAlongShapeM": 7235.997,
              "shapeOffsetM": 1.151,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6995",
              "position": {
                "x": -4176.922,
                "z": -3250.186
              },
              "distanceAlongShapeM": 7715.579,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6992",
              "position": {
                "x": -4123.554,
                "z": -2884.864
              },
              "distanceAlongShapeM": 8088.415,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6990",
              "position": {
                "x": -4210.635,
                "z": -2255.507
              },
              "distanceAlongShapeM": 8855.227,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            20760,
            21660,
            22620,
            23220,
            24180,
            25140,
            26040,
            27120,
            28020,
            28980,
            29880,
            30840,
            31680,
            32640,
            33840,
            34920,
            36060,
            37020,
            38160,
            39240,
            40440,
            41640,
            42840,
            44040,
            44940,
            46140,
            47340,
            48540,
            49740,
            51000,
            52200,
            53400,
            54600,
            55500,
            56400,
            57300,
            58260,
            58860,
            59760,
            60720,
            61680,
            62580,
            63840,
            64740,
            65580,
            66420,
            68520,
            70920,
            72060,
            72960,
            74160,
            75240,
            76380,
            77580,
            78720,
            79920,
            81120
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_46",
      "sourceRouteId": "vilnius_bus_46",
      "mode": "bus",
      "shortName": "46",
      "longName": "Perkūnkiemis–Laisvės pr.–A.Goštauto g.–Centras",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_46:0",
          "sourceRouteId": "vilnius_bus_46",
          "sourceShapeId": "vilnius_bus_46_a-b",
          "directionId": 0,
          "headsign": "Centras",
          "directionName": "Perkūnkiemis–Laisvės pr.–A.Goštauto g.–Centras",
          "mode": "bus",
          "routeShortName": "46",
          "routeLongName": "Perkūnkiemis–Laisvės pr.–A.Goštauto g.–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3844.602,
              -5152.866,
              0
            ],
            [
              -3862.028,
              -5154.789,
              17.532
            ],
            [
              -3896.745,
              -5150.846,
              52.471
            ],
            [
              -3900.57,
              -5148.553,
              56.931
            ],
            [
              -3904.981,
              -5142.911,
              64.093
            ],
            [
              -3906.076,
              -5131.759,
              75.298
            ],
            [
              -3903.757,
              -5109.535,
              97.643
            ],
            [
              -3899.68,
              -5097.361,
              110.482
            ],
            [
              -3891.837,
              -5090.818,
              120.696
            ],
            [
              -3867.269,
              -5085.679,
              145.796
            ],
            [
              -3846.88,
              -5061.542,
              177.391
            ],
            [
              -3843.447,
              -5049.357,
              190.051
            ],
            [
              -3839.486,
              -5043.859,
              196.827
            ],
            [
              -3824.617,
              -5040.778,
              212.012
            ],
            [
              -3766.774,
              -5048.464,
              270.363
            ],
            [
              -3779.214,
              -4985.907,
              334.144
            ],
            [
              -3777.543,
              -4926.936,
              393.139
            ],
            [
              -3771.66,
              -4848,
              472.294
            ],
            [
              -3753.439,
              -4800.449,
              523.217
            ],
            [
              -3737.479,
              -4771.783,
              556.027
            ],
            [
              -3706.062,
              -4743.386,
              598.375
            ],
            [
              -3682.606,
              -4728.21,
              626.313
            ],
            [
              -3641.799,
              -4715.562,
              669.035
            ],
            [
              -3538.579,
              -4707.343,
              772.581
            ],
            [
              -3481.885,
              -4707.22,
              829.276
            ],
            [
              -3452.961,
              -4711.064,
              858.454
            ],
            [
              -3415.86,
              -4726.185,
              898.517
            ],
            [
              -3417.148,
              -4726.162,
              899.806
            ],
            [
              -3378.974,
              -4753.547,
              946.787
            ],
            [
              -3279.537,
              -4851.023,
              1086.033
            ],
            [
              -3074.543,
              -4733.276,
              1322.436
            ],
            [
              -3035.648,
              -4719.487,
              1363.704
            ],
            [
              -2942.026,
              -4671.037,
              1469.119
            ],
            [
              -2845.866,
              -4624.861,
              1575.792
            ],
            [
              -2810.071,
              -4604.34,
              1617.052
            ],
            [
              -2796.036,
              -4575.643,
              1648.997
            ],
            [
              -2770.134,
              -4531.57,
              1700.117
            ],
            [
              -2769.313,
              -4521.566,
              1710.156
            ],
            [
              -2771.792,
              -4515.956,
              1716.288
            ],
            [
              -2785.726,
              -4502.352,
              1735.762
            ],
            [
              -2809.985,
              -4489.679,
              1763.132
            ],
            [
              -2814.297,
              -4478.471,
              1775.141
            ],
            [
              -2835.666,
              -4448.038,
              1812.327
            ],
            [
              -2880.475,
              -4394.928,
              1881.815
            ],
            [
              -2902.49,
              -4364.484,
              1919.384
            ],
            [
              -2923.723,
              -4326.261,
              1963.109
            ],
            [
              -2938.397,
              -4244.738,
              2045.942
            ],
            [
              -2943.47,
              -4203.459,
              2087.531
            ],
            [
              -2943.332,
              -4158.933,
              2132.058
            ],
            [
              -2947.565,
              -4106.537,
              2184.624
            ],
            [
              -2936.886,
              -4048.837,
              2243.304
            ],
            [
              -2933.232,
              -3950.938,
              2341.271
            ],
            [
              -2935.53,
              -3825.104,
              2467.127
            ],
            [
              -2942.439,
              -3778.227,
              2514.51
            ],
            [
              -2941.11,
              -3739.288,
              2553.472
            ],
            [
              -2942.553,
              -3711.432,
              2581.365
            ],
            [
              -2947.139,
              -3679.068,
              2614.052
            ],
            [
              -2962.772,
              -3578.604,
              2715.726
            ],
            [
              -2994.393,
              -3434.443,
              2863.314
            ],
            [
              -3009.522,
              -3378.516,
              2921.25
            ],
            [
              -3026.974,
              -3344.813,
              2959.204
            ],
            [
              -3029.648,
              -3313.596,
              2990.535
            ],
            [
              -3083.217,
              -3134.541,
              3177.431
            ],
            [
              -3102.428,
              -3054.053,
              3260.181
            ],
            [
              -3114.845,
              -3027.118,
              3289.84
            ],
            [
              -3065.626,
              -3013.509,
              3340.906
            ],
            [
              -3013.674,
              -2991.043,
              3397.507
            ],
            [
              -2972.908,
              -2981.74,
              3439.321
            ],
            [
              -2923.591,
              -2962.569,
              3492.234
            ],
            [
              -2796.251,
              -2867.959,
              3650.873
            ],
            [
              -2713.249,
              -2802.628,
              3756.502
            ],
            [
              -2678.551,
              -2772.069,
              3802.738
            ],
            [
              -2644.38,
              -2734.822,
              3853.285
            ],
            [
              -2636.314,
              -2716.04,
              3873.726
            ],
            [
              -2600.033,
              -2668.811,
              3933.282
            ],
            [
              -2574.02,
              -2619.176,
              3989.321
            ],
            [
              -2520.523,
              -2473.175,
              4144.814
            ],
            [
              -2499.973,
              -2404.518,
              4216.48
            ],
            [
              -2490.126,
              -2357.937,
              4264.091
            ],
            [
              -2467.791,
              -2224.746,
              4399.142
            ],
            [
              -2431.725,
              -2226.496,
              4435.251
            ],
            [
              -2415.576,
              -2224.555,
              4451.516
            ],
            [
              -2373.4,
              -2245.339,
              4498.535
            ],
            [
              -2196.773,
              -2317.488,
              4689.329
            ],
            [
              -2137.182,
              -2337.47,
              4752.181
            ],
            [
              -2070.464,
              -2355.353,
              4821.254
            ],
            [
              -2038.344,
              -2361.489,
              4853.955
            ],
            [
              -1991.404,
              -2367.89,
              4901.329
            ],
            [
              -1948.856,
              -2367.533,
              4943.879
            ],
            [
              -1899.081,
              -2359.513,
              4994.296
            ],
            [
              -1862.838,
              -2351.253,
              5031.469
            ],
            [
              -1818.039,
              -2333.126,
              5079.796
            ],
            [
              -1763.981,
              -2301.806,
              5142.272
            ],
            [
              -1728.668,
              -2273.492,
              5187.534
            ],
            [
              -1674.776,
              -2215.452,
              5266.736
            ],
            [
              -1645.063,
              -2175.906,
              5316.2
            ],
            [
              -1547.472,
              -2017.345,
              5502.387
            ],
            [
              -1343.434,
              -1674.784,
              5901.11
            ],
            [
              -1305.861,
              -1628.702,
              5960.568
            ],
            [
              -1268.647,
              -1602.651,
              6005.994
            ],
            [
              -1054.592,
              -1494.059,
              6246.018
            ],
            [
              -1027.103,
              -1471.176,
              6281.786
            ],
            [
              -1009.966,
              -1450.333,
              6308.77
            ],
            [
              -1001.511,
              -1410.409,
              6349.579
            ],
            [
              -987.78,
              -1363.9,
              6398.072
            ],
            [
              -988.723,
              -1201.352,
              6560.623
            ],
            [
              -990.397,
              -1186.85,
              6575.222
            ],
            [
              -1017.615,
              -1122.906,
              6644.717
            ],
            [
              -1020.518,
              -1105.042,
              6662.815
            ],
            [
              -1018.304,
              -1089.497,
              6678.518
            ],
            [
              -1013.532,
              -1075.111,
              6693.675
            ],
            [
              -1005.537,
              -1060.783,
              6710.082
            ],
            [
              -990.532,
              -1051.034,
              6727.976
            ],
            [
              -976.596,
              -1029.02,
              6754.031
            ],
            [
              -969.87,
              -1013.556,
              6770.894
            ],
            [
              -967.031,
              -999.135,
              6785.592
            ],
            [
              -969.129,
              -972.38,
              6812.429
            ],
            [
              -954.912,
              -934.786,
              6852.621
            ],
            [
              -945.547,
              -916.03,
              6873.585
            ],
            [
              -940.714,
              -898.305,
              6891.957
            ],
            [
              -936.79,
              -859.413,
              6931.047
            ],
            [
              -926.694,
              -692.61,
              7098.154
            ],
            [
              -924.604,
              -648.119,
              7142.695
            ],
            [
              -926.501,
              -610.235,
              7180.626
            ],
            [
              -934.701,
              -600.068,
              7193.688
            ],
            [
              -944.29,
              -595.443,
              7204.334
            ],
            [
              -952.65,
              -594.179,
              7212.789
            ],
            [
              -963.004,
              -596.219,
              7223.342
            ],
            [
              -972.833,
              -604.948,
              7236.488
            ],
            [
              -992.833,
              -641.325,
              7278
            ],
            [
              -992.649,
              -666.932,
              7303.608
            ],
            [
              -989.606,
              -677.006,
              7314.132
            ],
            [
              -978.263,
              -691.682,
              7332.68
            ],
            [
              -964.927,
              -703.054,
              7350.207
            ],
            [
              -939.343,
              -714.647,
              7378.295
            ],
            [
              -865.474,
              -730.449,
              7453.835
            ],
            [
              -798.395,
              -729.432,
              7520.922
            ],
            [
              -764.735,
              -722.247,
              7555.34
            ],
            [
              -714.638,
              -697.546,
              7611.195
            ],
            [
              -692.924,
              -673.447,
              7643.634
            ],
            [
              -655.859,
              -656.305,
              7684.47
            ],
            [
              -601.451,
              -607.193,
              7757.766
            ],
            [
              -500.911,
              -503.255,
              7902.374
            ],
            [
              -413.017,
              -421.354,
              8022.512
            ],
            [
              -305.298,
              -348.72,
              8152.432
            ],
            [
              -203.339,
              -309.381,
              8261.717
            ],
            [
              -102.285,
              -284.5,
              8365.788
            ],
            [
              -50.388,
              -267.632,
              8420.358
            ],
            [
              -22.626,
              -265.911,
              8448.173
            ],
            [
              -0.545,
              -257.407,
              8471.834
            ],
            [
              58.367,
              -209.498,
              8547.769
            ],
            [
              82.464,
              -196.578,
              8575.11
            ],
            [
              94.753,
              -194.576,
              8587.562
            ],
            [
              103.738,
              -196.966,
              8596.859
            ],
            [
              115.784,
              -208.318,
              8613.411
            ],
            [
              119.866,
              -267.394,
              8672.628
            ],
            [
              118.552,
              -304.106,
              8709.364
            ],
            [
              124.949,
              -377.696,
              8783.232
            ],
            [
              130.203,
              -407.85,
              8813.839
            ],
            [
              150.182,
              -443.837,
              8855.001
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 166.876,
              "shapeOffsetM": 0.567,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7023",
              "position": {
                "x": -3417.148,
                "z": -4726.162
              },
              "distanceAlongShapeM": 899.806,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:7027",
              "position": {
                "x": -3074.543,
                "z": -4733.276
              },
              "distanceAlongShapeM": 1322.436,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6766",
              "position": {
                "x": -2809.985,
                "z": -4489.679
              },
              "distanceAlongShapeM": 1763.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6484",
              "position": {
                "x": -2923.723,
                "z": -4326.261
              },
              "distanceAlongShapeM": 1963.109,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 2184.624,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 2514.51,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6478",
              "position": {
                "x": -3026.974,
                "z": -3344.813
              },
              "distanceAlongShapeM": 2959.204,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 3397.507,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 3873.726,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:1069",
              "position": {
                "x": -2415.576,
                "z": -2224.555
              },
              "distanceAlongShapeM": 4451.516,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 6349.579,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5533",
              "position": {
                "x": -969.129,
                "z": -972.38
              },
              "distanceAlongShapeM": 6812.429,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5539",
              "position": {
                "x": -692.924,
                "z": -673.447
              },
              "distanceAlongShapeM": 7643.634,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 8420.358,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 8855.001,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            19260,
            20280,
            21300,
            23040,
            23940,
            24840,
            25740,
            27180,
            28320,
            29460,
            30600,
            33060,
            34200,
            36000,
            37440,
            38880,
            40320,
            41760,
            43200,
            44640,
            46080,
            47520,
            48960,
            50400,
            51780,
            53160,
            54540,
            56040,
            57240,
            58440,
            59580,
            60720,
            61920,
            63180,
            64440,
            67020,
            68040,
            70020,
            71460,
            72900,
            74400,
            75900,
            77400,
            78900,
            80340,
            81780,
            83220
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_46:1",
          "sourceRouteId": "vilnius_bus_46",
          "sourceShapeId": "vilnius_bus_46_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Centras–A.Goštauto g.–Laisvės pr.–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "46",
          "routeLongName": "Perkūnkiemis–Laisvės pr.–A.Goštauto g.–Centras",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              150.182,
              -443.837,
              0
            ],
            [
              177.186,
              -518.917,
              79.788
            ],
            [
              187.997,
              -562.53,
              124.721
            ],
            [
              214.213,
              -645.388,
              211.628
            ],
            [
              224.323,
              -656.705,
              226.803
            ],
            [
              237.149,
              -695.903,
              268.046
            ],
            [
              236.925,
              -708.144,
              280.289
            ],
            [
              229.693,
              -715.805,
              290.825
            ],
            [
              23.734,
              -765.484,
              502.69
            ],
            [
              -53.078,
              -805.275,
              589.197
            ],
            [
              -306.711,
              -924.235,
              869.342
            ],
            [
              -475.993,
              -1014.678,
              1061.27
            ],
            [
              -534.689,
              -1051.466,
              1130.541
            ],
            [
              -673.187,
              -1080.133,
              1271.975
            ],
            [
              -763.423,
              -1114.127,
              1368.402
            ],
            [
              -822.801,
              -1117.509,
              1427.877
            ],
            [
              -837.686,
              -1120.58,
              1443.075
            ],
            [
              -857.223,
              -1131.36,
              1465.389
            ],
            [
              -899.68,
              -1161.766,
              1517.61
            ],
            [
              -917.464,
              -1182.597,
              1545
            ],
            [
              -926.283,
              -1206.929,
              1570.881
            ],
            [
              -917.431,
              -1323.977,
              1688.264
            ],
            [
              -911.942,
              -1448.758,
              1813.165
            ],
            [
              -922.391,
              -1491.986,
              1857.638
            ],
            [
              -939.829,
              -1529.521,
              1899.026
            ],
            [
              -961.618,
              -1558.073,
              1934.942
            ],
            [
              -995.732,
              -1590.856,
              1982.255
            ],
            [
              -1026.383,
              -1610.342,
              2018.576
            ],
            [
              -1072.441,
              -1626.213,
              2067.292
            ],
            [
              -1262.636,
              -1662.874,
              2260.987
            ],
            [
              -1320.472,
              -1688.554,
              2324.269
            ],
            [
              -1370.209,
              -1729.965,
              2388.989
            ],
            [
              -1651.924,
              -2199.162,
              2936.262
            ],
            [
              -1682.619,
              -2257.615,
              3002.285
            ],
            [
              -1702.963,
              -2314.026,
              3062.252
            ],
            [
              -1711.936,
              -2347.263,
              3096.679
            ],
            [
              -1753.781,
              -2416.65,
              3177.707
            ],
            [
              -1791.442,
              -2468.3,
              3241.63
            ],
            [
              -1796.25,
              -2484.913,
              3258.924
            ],
            [
              -1794.575,
              -2499.414,
              3273.522
            ],
            [
              -1786.456,
              -2514.031,
              3290.242
            ],
            [
              -1773.708,
              -2522.051,
              3305.303
            ],
            [
              -1755.022,
              -2522.384,
              3323.992
            ],
            [
              -1739.399,
              -2513.757,
              3341.839
            ],
            [
              -1728.911,
              -2503.925,
              3356.215
            ],
            [
              -1701.579,
              -2453.204,
              3413.831
            ],
            [
              -1699.467,
              -2443.223,
              3424.034
            ],
            [
              -1706.803,
              -2420.827,
              3447.6
            ],
            [
              -1718.262,
              -2412.83,
              3461.574
            ],
            [
              -1731.05,
              -2407.036,
              3475.613
            ],
            [
              -1888.235,
              -2402.009,
              3632.879
            ],
            [
              -1933.866,
              -2394.517,
              3679.121
            ],
            [
              -2056.217,
              -2387.889,
              3801.65
            ],
            [
              -2112.099,
              -2376.878,
              3858.607
            ],
            [
              -2168.467,
              -2356.953,
              3918.394
            ],
            [
              -2220.425,
              -2342.673,
              3972.278
            ],
            [
              -2388.773,
              -2276.238,
              4153.26
            ],
            [
              -2402.929,
              -2274.874,
              4167.482
            ],
            [
              -2472.07,
              -2248.048,
              4241.645
            ],
            [
              -2470.476,
              -2303.737,
              4297.357
            ],
            [
              -2477.313,
              -2325.88,
              4320.532
            ],
            [
              -2484.017,
              -2376.97,
              4372.06
            ],
            [
              -2514.005,
              -2505.574,
              4504.113
            ],
            [
              -2552.25,
              -2627.352,
              4631.757
            ],
            [
              -2587.598,
              -2694.635,
              4707.759
            ],
            [
              -2667.366,
              -2795.644,
              4836.467
            ],
            [
              -2878.335,
              -2954.459,
              5100.532
            ],
            [
              -2942.823,
              -2993.401,
              5175.866
            ],
            [
              -2993.467,
              -3014.776,
              5230.836
            ],
            [
              -3056.314,
              -3033.711,
              5296.473
            ],
            [
              -3080.894,
              -3038.845,
              5321.583
            ],
            [
              -3066.407,
              -3094.76,
              5379.345
            ],
            [
              -3053.229,
              -3115.03,
              5403.521
            ],
            [
              -3044.503,
              -3168.617,
              5457.814
            ],
            [
              -2983.753,
              -3378.969,
              5676.763
            ],
            [
              -2968.741,
              -3404.837,
              5706.671
            ],
            [
              -2964.33,
              -3447.216,
              5749.28
            ],
            [
              -2935.834,
              -3585.756,
              5890.72
            ],
            [
              -2926.739,
              -3654.936,
              5960.495
            ],
            [
              -2914.467,
              -3799.87,
              6105.948
            ],
            [
              -2906.719,
              -3835.629,
              6142.537
            ],
            [
              -2909.141,
              -3863.417,
              6170.43
            ],
            [
              -2921.12,
              -4178.248,
              6485.488
            ],
            [
              -2914.524,
              -4206.195,
              6514.203
            ],
            [
              -2915.775,
              -4240.682,
              6548.713
            ],
            [
              -2903.306,
              -4301.016,
              6610.322
            ],
            [
              -2872.92,
              -4368.343,
              6684.188
            ],
            [
              -2823.799,
              -4432.662,
              6765.119
            ],
            [
              -2778.775,
              -4473.531,
              6825.925
            ],
            [
              -2757.796,
              -4489.485,
              6852.282
            ],
            [
              -2752.839,
              -4500.705,
              6864.548
            ],
            [
              -2810.071,
              -4604.34,
              6982.936
            ],
            [
              -2823.831,
              -4617.456,
              7001.946
            ],
            [
              -2853.869,
              -4640.305,
              7039.686
            ],
            [
              -2965.525,
              -4688.436,
              7161.274
            ],
            [
              -3120.309,
              -4771.436,
              7336.907
            ],
            [
              -3149.017,
              -4792.083,
              7372.269
            ],
            [
              -3182.74,
              -4804.851,
              7408.328
            ],
            [
              -3279.537,
              -4851.023,
              7515.574
            ],
            [
              -3386.624,
              -4748.96,
              7663.508
            ],
            [
              -3428.663,
              -4721.508,
              7713.717
            ],
            [
              -3452.961,
              -4711.064,
              7740.164
            ],
            [
              -3508.973,
              -4708.973,
              7796.215
            ],
            [
              -3543.926,
              -4718.382,
              7832.411
            ],
            [
              -3563.13,
              -4711.368,
              7852.857
            ],
            [
              -3606.358,
              -4715.067,
              7896.243
            ],
            [
              -3659.948,
              -4721.925,
              7950.27
            ],
            [
              -3686.528,
              -4731.481,
              7978.516
            ],
            [
              -3706.062,
              -4743.386,
              8001.392
            ],
            [
              -3733.537,
              -4767.398,
              8037.881
            ],
            [
              -3748.737,
              -4789.398,
              8064.621
            ],
            [
              -3760.814,
              -4817.018,
              8094.766
            ],
            [
              -3769.026,
              -4844.706,
              8123.646
            ],
            [
              -3776.333,
              -4931.41,
              8210.657
            ],
            [
              -3777.165,
              -4979.264,
              8258.518
            ],
            [
              -3766.774,
              -5048.464,
              8328.494
            ],
            [
              -3780.356,
              -5051.567,
              8342.426
            ],
            [
              -3796.475,
              -5052.4,
              8358.566
            ],
            [
              -3825.435,
              -5050.783,
              8387.571
            ],
            [
              -3827.361,
              -5087.486,
              8424.325
            ],
            [
              -3833.268,
              -5130.798,
              8468.038
            ],
            [
              -3844.602,
              -5152.866,
              8492.846
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 589.197,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 1130.541,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 1368.402,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 3096.679,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5074",
              "position": {
                "x": -2470.476,
                "z": -2303.737
              },
              "distanceAlongShapeM": 4297.357,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 4836.467,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 5403.521,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6479",
              "position": {
                "x": -2968.741,
                "z": -3404.837
              },
              "distanceAlongShapeM": 5706.671,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 6142.537,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 6514.203,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7898",
              "position": {
                "x": -2853.869,
                "z": -4640.305
              },
              "distanceAlongShapeM": 7039.686,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7028",
              "position": {
                "x": -3149.017,
                "z": -4792.083
              },
              "distanceAlongShapeM": 7372.269,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7022",
              "position": {
                "x": -3543.926,
                "z": -4718.382
              },
              "distanceAlongShapeM": 7832.411,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 8424.325,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            20880,
            21900,
            22920,
            24660,
            25620,
            26640,
            27600,
            29160,
            30420,
            31560,
            32700,
            34920,
            36060,
            37740,
            39180,
            40620,
            42060,
            43500,
            45000,
            46560,
            47940,
            49380,
            50760,
            52200,
            53640,
            55080,
            56460,
            57960,
            59160,
            60420,
            61620,
            62820,
            64200,
            65460,
            66600,
            68940,
            69960,
            71820,
            73260,
            74640,
            76080,
            77580,
            79080,
            80580,
            82020,
            83400,
            84900
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_48",
      "sourceRouteId": "vilnius_bus_48",
      "mode": "bus",
      "shortName": "48",
      "longName": "Šeškinė–Pašilaičiai–Santariškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_48:0",
          "sourceRouteId": "vilnius_bus_48",
          "sourceShapeId": "vilnius_bus_48_a-b",
          "directionId": 0,
          "headsign": "Santariškės",
          "directionName": "Šeškinė–Pašilaičiai–Santariškės",
          "mode": "bus",
          "routeShortName": "48",
          "routeLongName": "Šeškinė–Pašilaičiai–Santariškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2195.778,
              -3133.498,
              0
            ],
            [
              -2187.067,
              -3114.727,
              20.693
            ],
            [
              -2174.766,
              -3111.606,
              33.383
            ],
            [
              -1943.03,
              -3126.856,
              265.621
            ],
            [
              -1903.67,
              -3124.217,
              305.069
            ],
            [
              -1868.018,
              -3112.606,
              342.564
            ],
            [
              -1837.381,
              -3093.114,
              378.877
            ],
            [
              -1816.447,
              -3075.675,
              406.122
            ],
            [
              -1775.996,
              -3011.829,
              481.704
            ],
            [
              -1683.756,
              -3043.532,
              579.24
            ],
            [
              -1647.191,
              -3053.091,
              617.033
            ],
            [
              -1571.366,
              -3065.578,
              693.88
            ],
            [
              -1551.978,
              -3062.585,
              713.497
            ],
            [
              -1523.75,
              -3069.769,
              742.625
            ],
            [
              -1491.596,
              -3073.684,
              775.017
            ],
            [
              -1438.786,
              -3075.742,
              827.867
            ],
            [
              -1362.723,
              -3074.878,
              903.935
            ],
            [
              -1386.134,
              -2978.721,
              1002.902
            ],
            [
              -1409.242,
              -2901.495,
              1083.511
            ],
            [
              -1422.254,
              -2872.318,
              1115.458
            ],
            [
              -1430.357,
              -2820.964,
              1167.447
            ],
            [
              -1448.996,
              -2746.044,
              1244.651
            ],
            [
              -1452.909,
              -2712.577,
              1278.346
            ],
            [
              -1453.659,
              -2682.507,
              1308.426
            ],
            [
              -1443.344,
              -2610.331,
              1381.334
            ],
            [
              -1428.471,
              -2571.635,
              1422.791
            ],
            [
              -1415.77,
              -2546.258,
              1451.168
            ],
            [
              -1386.622,
              -2502.251,
              1503.953
            ],
            [
              -1450.559,
              -2473.275,
              1574.15
            ],
            [
              -1488.158,
              -2449.225,
              1618.783
            ],
            [
              -1548.409,
              -2430.336,
              1681.926
            ],
            [
              -1640.314,
              -2415.335,
              1775.047
            ],
            [
              -1771.001,
              -2406.324,
              1906.044
            ],
            [
              -1888.235,
              -2402.009,
              2023.358
            ],
            [
              -1933.866,
              -2394.517,
              2069.6
            ],
            [
              -2056.217,
              -2387.889,
              2192.129
            ],
            [
              -2112.099,
              -2376.878,
              2249.086
            ],
            [
              -2168.467,
              -2356.953,
              2308.873
            ],
            [
              -2220.425,
              -2342.673,
              2362.757
            ],
            [
              -2388.773,
              -2276.238,
              2543.739
            ],
            [
              -2402.929,
              -2274.874,
              2557.961
            ],
            [
              -2472.07,
              -2248.048,
              2632.124
            ],
            [
              -2470.476,
              -2303.737,
              2687.836
            ],
            [
              -2477.313,
              -2325.88,
              2711.011
            ],
            [
              -2484.017,
              -2376.97,
              2762.539
            ],
            [
              -2514.005,
              -2505.574,
              2894.592
            ],
            [
              -2552.25,
              -2627.352,
              3022.236
            ],
            [
              -2587.598,
              -2694.635,
              3098.238
            ],
            [
              -2667.366,
              -2795.644,
              3226.946
            ],
            [
              -2878.335,
              -2954.459,
              3491.011
            ],
            [
              -2942.823,
              -2993.401,
              3566.345
            ],
            [
              -2993.467,
              -3014.776,
              3621.315
            ],
            [
              -3056.314,
              -3033.711,
              3686.952
            ],
            [
              -3080.894,
              -3038.845,
              3712.062
            ],
            [
              -3066.407,
              -3094.76,
              3769.823
            ],
            [
              -3053.229,
              -3115.03,
              3794
            ],
            [
              -3044.503,
              -3168.617,
              3848.293
            ],
            [
              -2983.753,
              -3378.969,
              4067.242
            ],
            [
              -2968.741,
              -3404.837,
              4097.15
            ],
            [
              -2964.33,
              -3447.216,
              4139.759
            ],
            [
              -2935.834,
              -3585.756,
              4281.199
            ],
            [
              -2926.739,
              -3654.936,
              4350.974
            ],
            [
              -2914.467,
              -3799.87,
              4496.427
            ],
            [
              -2906.719,
              -3835.629,
              4533.016
            ],
            [
              -2909.141,
              -3863.417,
              4560.909
            ],
            [
              -2921.12,
              -4178.248,
              4875.967
            ],
            [
              -2914.524,
              -4206.195,
              4904.682
            ],
            [
              -2913.823,
              -4239.604,
              4938.098
            ],
            [
              -2906.681,
              -4273.126,
              4972.373
            ],
            [
              -2893.275,
              -4316.777,
              5018.036
            ],
            [
              -2874.618,
              -4354.955,
              5060.529
            ],
            [
              -2823.799,
              -4432.662,
              5153.378
            ],
            [
              -2759.103,
              -4490.576,
              5240.208
            ],
            [
              -2701.004,
              -4520.544,
              5305.581
            ],
            [
              -2600.594,
              -4562.391,
              5414.363
            ],
            [
              -2523.056,
              -4586.026,
              5495.422
            ],
            [
              -2471.67,
              -4594.727,
              5547.54
            ],
            [
              -2274.597,
              -4634.953,
              5748.676
            ],
            [
              -2190.603,
              -4657.594,
              5835.669
            ],
            [
              -2203.301,
              -4719.709,
              5899.069
            ],
            [
              -2218.687,
              -4751.72,
              5934.585
            ],
            [
              -2222.124,
              -4763.905,
              5947.245
            ],
            [
              -2297.39,
              -4830.477,
              6047.728
            ],
            [
              -2247.29,
              -4911.517,
              6143.005
            ],
            [
              -2236.559,
              -4923.953,
              6159.431
            ],
            [
              -2217.405,
              -4969.935,
              6209.243
            ],
            [
              -2110.315,
              -5178.897,
              6444.047
            ],
            [
              -2058.363,
              -5155.329,
              6501.096
            ],
            [
              -2028.76,
              -5156.969,
              6530.744
            ],
            [
              -1894.496,
              -5141.548,
              6665.89
            ],
            [
              -1856.383,
              -5135.547,
              6704.473
            ],
            [
              -1800.644,
              -5116.503,
              6763.376
            ],
            [
              -1770.723,
              -5100.339,
              6797.384
            ],
            [
              -1738.711,
              -5075.306,
              6838.022
            ],
            [
              -1710.503,
              -5046.865,
              6878.078
            ],
            [
              -1676.24,
              -5004.061,
              6932.906
            ],
            [
              -1625.643,
              -5020.551,
              6986.123
            ],
            [
              -1586.957,
              -5054.639,
              7037.685
            ],
            [
              -1465.895,
              -5129.166,
              7179.847
            ],
            [
              -1407.208,
              -5161.388,
              7246.799
            ],
            [
              -1338.038,
              -5183.78,
              7319.502
            ],
            [
              -1271.325,
              -5199.449,
              7388.031
            ],
            [
              -1246.49,
              -5215.481,
              7417.59
            ],
            [
              -1183.862,
              -5243.323,
              7486.129
            ],
            [
              -1057.683,
              -5283.443,
              7618.533
            ],
            [
              -1011.035,
              -5304.321,
              7669.64
            ],
            [
              -893.028,
              -5368.79,
              7804.108
            ],
            [
              -884.677,
              -5370.054,
              7812.554
            ],
            [
              -878.962,
              -5374.61,
              7819.863
            ],
            [
              -877.774,
              -5380.197,
              7825.576
            ],
            [
              -880.43,
              -5384.602,
              7830.72
            ],
            [
              -877.432,
              -5396.902,
              7843.38
            ],
            [
              -884.191,
              -5450.216,
              7897.12
            ],
            [
              -893.567,
              -5470.085,
              7919.09
            ],
            [
              -911.955,
              -5561.038,
              8011.884
            ],
            [
              -930.002,
              -5633.073,
              8086.145
            ],
            [
              -983.576,
              -5818.018,
              8278.693
            ],
            [
              -986.029,
              -5846.918,
              8307.697
            ],
            [
              -994.297,
              -5876.826,
              8338.727
            ],
            [
              -1014.167,
              -6014.509,
              8477.837
            ],
            [
              -1049.096,
              -6308.888,
              8774.28
            ],
            [
              -1050.642,
              -6358.956,
              8824.372
            ],
            [
              -1044.402,
              -6405.824,
              8871.654
            ],
            [
              -1036.394,
              -6426.006,
              8893.367
            ],
            [
              -1036.431,
              -6463.856,
              8931.216
            ],
            [
              -1013.612,
              -6555.552,
              9025.71
            ],
            [
              -980.393,
              -6641.87,
              9118.199
            ],
            [
              -928.004,
              -6736.327,
              9226.212
            ],
            [
              -886.521,
              -6792.738,
              9296.233
            ],
            [
              -721.383,
              -6990.538,
              9553.906
            ],
            [
              -581.383,
              -7153.38,
              9768.656
            ],
            [
              -567.625,
              -7175.894,
              9795.041
            ],
            [
              -492.955,
              -7141.624,
              9877.199
            ],
            [
              -472.94,
              -7138.647,
              9897.434
            ],
            [
              -433.975,
              -7120.429,
              9940.448
            ],
            [
              -356.786,
              -7053.923,
              10042.336
            ],
            [
              -147.918,
              -6864.018,
              10324.63
            ],
            [
              -119.568,
              -6827.798,
              10370.626
            ],
            [
              -98.203,
              -6821.508,
              10392.897
            ],
            [
              -53.78,
              -6786.694,
              10449.337
            ],
            [
              -44.707,
              -6783.519,
              10458.95
            ],
            [
              -24.066,
              -6781.669,
              10479.673
            ],
            [
              0.233,
              -6791.019,
              10505.709
            ],
            [
              10.168,
              -6811.238,
              10528.237
            ],
            [
              11.151,
              -6827.955,
              10544.983
            ],
            [
              7.024,
              -6842.352,
              10559.959
            ],
            [
              -10.864,
              -6869.857,
              10592.769
            ],
            [
              -21.671,
              -6897.49,
              10622.442
            ],
            [
              -10.612,
              -6926.637,
              10653.615
            ],
            [
              -9.853,
              -6955.595,
              10682.583
            ],
            [
              6.027,
              -7144.023,
              10871.679
            ],
            [
              16.38,
              -7176.496,
              10905.763
            ],
            [
              10.845,
              -7197.547,
              10927.529
            ],
            [
              32.291,
              -7398.322,
              11129.447
            ],
            [
              48.234,
              -7442.03,
              11175.972
            ],
            [
              37.062,
              -7489.696,
              11224.929
            ],
            [
              41.201,
              -7509.81,
              11245.465
            ],
            [
              62.699,
              -7531.354,
              11275.9
            ],
            [
              73.695,
              -7563.839,
              11310.195
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5206",
              "position": {
                "x": -2195.778,
                "z": -3133.498
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6940",
              "position": {
                "x": -1551.978,
                "z": -3062.585
              },
              "distanceAlongShapeM": 713.497,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6933",
              "position": {
                "x": -1422.254,
                "z": -2872.318
              },
              "distanceAlongShapeM": 1115.458,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6937",
              "position": {
                "x": -1450.559,
                "z": -2473.275
              },
              "distanceAlongShapeM": 1574.15,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5074",
              "position": {
                "x": -2470.476,
                "z": -2303.737
              },
              "distanceAlongShapeM": 2687.836,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 3226.946,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 3794,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6479",
              "position": {
                "x": -2968.741,
                "z": -3404.837
              },
              "distanceAlongShapeM": 4097.15,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 4533.016,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 4904.682,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:8268",
              "position": {
                "x": -2701.004,
                "z": -4520.544
              },
              "distanceAlongShapeM": 5305.581,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8270",
              "position": {
                "x": -2222.124,
                "z": -4763.905
              },
              "distanceAlongShapeM": 5947.245,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 6159.431,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 6501.096,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 6986.123,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 7388.031,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6773",
              "position": {
                "x": -884.191,
                "z": -5450.216
              },
              "distanceAlongShapeM": 7897.12,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6775",
              "position": {
                "x": -986.029,
                "z": -5846.918
              },
              "distanceAlongShapeM": 8307.697,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6777",
              "position": {
                "x": -1036.394,
                "z": -6426.006
              },
              "distanceAlongShapeM": 8893.367,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:8326",
              "position": {
                "x": -492.955,
                "z": -7141.624
              },
              "distanceAlongShapeM": 9877.199,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:8327",
              "position": {
                "x": -119.568,
                "z": -6827.798
              },
              "distanceAlongShapeM": 10370.626,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 10653.615,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 10905.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6533",
              "position": {
                "x": 73.695,
                "z": -7563.839
              },
              "distanceAlongShapeM": 11310.195,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            }
          ],
          "departuresSeconds": [
            19620,
            24960,
            33240,
            38940,
            44760,
            50760,
            57840,
            64860,
            72720,
            77760,
            82620
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_48:1",
          "sourceRouteId": "vilnius_bus_48",
          "sourceShapeId": "vilnius_bus_48_b-a",
          "directionId": 1,
          "headsign": "Šeškinė",
          "directionName": "Santariškės–Pašilaičiai–Šeškinė",
          "mode": "bus",
          "routeShortName": "48",
          "routeLongName": "Šeškinė–Pašilaičiai–Santariškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              73.695,
              -7563.839,
              0
            ],
            [
              69.345,
              -7590.477,
              26.991
            ],
            [
              45.368,
              -7598.945,
              52.419
            ],
            [
              37.787,
              -7591.014,
              63.391
            ],
            [
              25.801,
              -7471.678,
              183.328
            ],
            [
              8.189,
              -7201.951,
              453.629
            ],
            [
              -2.477,
              -7116.037,
              540.203
            ],
            [
              -15.345,
              -7080.178,
              578.301
            ],
            [
              -10.894,
              -7047.975,
              610.81
            ],
            [
              -21.671,
              -6897.49,
              761.68
            ],
            [
              -33.557,
              -6878.349,
              784.212
            ],
            [
              -59.463,
              -6851.158,
              821.767
            ],
            [
              -78.653,
              -6844.129,
              842.204
            ],
            [
              -94.726,
              -6842.723,
              858.339
            ],
            [
              -112.168,
              -6845.745,
              876.04
            ],
            [
              -131.642,
              -6854.296,
              897.309
            ],
            [
              -156.753,
              -6889.462,
              940.521
            ],
            [
              -179.506,
              -6901.294,
              966.166
            ],
            [
              -377.89,
              -7081.371,
              1234.092
            ],
            [
              -448.339,
              -7131.301,
              1320.44
            ],
            [
              -497.724,
              -7156.009,
              1375.661
            ],
            [
              -567.625,
              -7175.894,
              1448.336
            ],
            [
              -604.294,
              -7138.492,
              1500.714
            ],
            [
              -624.971,
              -7106.947,
              1538.432
            ],
            [
              -899.778,
              -6778.026,
              1967.043
            ],
            [
              -953.071,
              -6698.025,
              2063.17
            ],
            [
              -986.73,
              -6636.19,
              2133.572
            ],
            [
              -1008.903,
              -6580.129,
              2193.859
            ],
            [
              -1021.097,
              -6542.059,
              2233.834
            ],
            [
              -1040.818,
              -6457.097,
              2321.054
            ],
            [
              -1058.33,
              -6320.967,
              2458.307
            ],
            [
              -1048.455,
              -6273.276,
              2507.01
            ],
            [
              -1013.163,
              -5994.489,
              2788.021
            ],
            [
              -985.81,
              -5799.053,
              2985.363
            ],
            [
              -976.395,
              -5776.958,
              3009.38
            ],
            [
              -917.287,
              -5570.961,
              3223.689
            ],
            [
              -886.888,
              -5421.223,
              3376.482
            ],
            [
              -885.843,
              -5398.977,
              3398.752
            ],
            [
              -887.614,
              -5390.039,
              3407.864
            ],
            [
              -927.257,
              -5373.739,
              3450.727
            ],
            [
              -1090.384,
              -5275.062,
              3641.378
            ],
            [
              -1302.999,
              -5205.56,
              3865.064
            ],
            [
              -1387.604,
              -5181.778,
              3952.947
            ],
            [
              -1666.095,
              -5013.148,
              4278.514
            ],
            [
              -1677.043,
              -5012.953,
              4289.463
            ],
            [
              -1696.959,
              -5045.994,
              4328.043
            ],
            [
              -1770.723,
              -5100.339,
              4419.664
            ],
            [
              -1793.54,
              -5115.517,
              4447.068
            ],
            [
              -1840.927,
              -5135.823,
              4498.623
            ],
            [
              -1904.939,
              -5149.154,
              4564.008
            ],
            [
              -2065.02,
              -5167.456,
              4725.132
            ],
            [
              -2110.315,
              -5178.897,
              4771.85
            ],
            [
              -2139.87,
              -5138.296,
              4822.069
            ],
            [
              -2154.069,
              -5103.533,
              4859.619
            ],
            [
              -2263.659,
              -4890.076,
              5099.566
            ],
            [
              -2297.39,
              -4830.477,
              5168.048
            ],
            [
              -2351.324,
              -4783.879,
              5239.323
            ],
            [
              -2381.317,
              -4767.762,
              5273.372
            ],
            [
              -2406.02,
              -4743.947,
              5307.686
            ],
            [
              -2443.585,
              -4718.791,
              5352.895
            ],
            [
              -2496.725,
              -4700.04,
              5409.246
            ],
            [
              -2554.472,
              -4686.774,
              5468.498
            ],
            [
              -2523.056,
              -4586.026,
              5574.03
            ],
            [
              -2609.045,
              -4566.695,
              5662.165
            ],
            [
              -2630.259,
              -4564.094,
              5683.538
            ],
            [
              -2748.743,
              -4524.155,
              5808.572
            ],
            [
              -2772.397,
              -4513.719,
              5834.426
            ],
            [
              -2809.985,
              -4489.679,
              5879.044
            ],
            [
              -2814.297,
              -4478.471,
              5891.053
            ],
            [
              -2835.666,
              -4448.038,
              5928.24
            ],
            [
              -2880.475,
              -4394.928,
              5997.727
            ],
            [
              -2902.49,
              -4364.484,
              6035.297
            ],
            [
              -2923.723,
              -4326.261,
              6079.021
            ],
            [
              -2938.397,
              -4244.738,
              6161.855
            ],
            [
              -2943.47,
              -4203.459,
              6203.443
            ],
            [
              -2943.332,
              -4158.933,
              6247.97
            ],
            [
              -2947.565,
              -4106.537,
              6300.537
            ],
            [
              -2936.886,
              -4048.837,
              6359.216
            ],
            [
              -2933.232,
              -3950.938,
              6457.184
            ],
            [
              -2935.53,
              -3825.104,
              6583.039
            ],
            [
              -2942.439,
              -3778.227,
              6630.422
            ],
            [
              -2941.11,
              -3739.288,
              6669.384
            ],
            [
              -2942.553,
              -3711.432,
              6697.277
            ],
            [
              -2947.139,
              -3679.068,
              6729.964
            ],
            [
              -2962.772,
              -3578.604,
              6831.638
            ],
            [
              -2994.393,
              -3434.443,
              6979.226
            ],
            [
              -3009.522,
              -3378.516,
              7037.162
            ],
            [
              -3026.974,
              -3344.813,
              7075.116
            ],
            [
              -3029.648,
              -3313.596,
              7106.447
            ],
            [
              -3083.217,
              -3134.541,
              7293.344
            ],
            [
              -3102.428,
              -3054.053,
              7376.093
            ],
            [
              -3114.845,
              -3027.118,
              7405.753
            ],
            [
              -3065.626,
              -3013.509,
              7456.818
            ],
            [
              -3013.674,
              -2991.043,
              7513.42
            ],
            [
              -2972.908,
              -2981.74,
              7555.233
            ],
            [
              -2923.591,
              -2962.569,
              7608.146
            ],
            [
              -2796.251,
              -2867.959,
              7766.785
            ],
            [
              -2713.249,
              -2802.628,
              7872.415
            ],
            [
              -2678.551,
              -2772.069,
              7918.65
            ],
            [
              -2644.38,
              -2734.822,
              7969.198
            ],
            [
              -2636.314,
              -2716.04,
              7989.639
            ],
            [
              -2600.033,
              -2668.811,
              8049.194
            ],
            [
              -2574.02,
              -2619.176,
              8105.233
            ],
            [
              -2520.523,
              -2473.175,
              8260.726
            ],
            [
              -2499.973,
              -2404.518,
              8332.392
            ],
            [
              -2490.126,
              -2357.937,
              8380.003
            ],
            [
              -2467.791,
              -2224.746,
              8515.055
            ],
            [
              -2431.725,
              -2226.496,
              8551.163
            ],
            [
              -2415.576,
              -2224.555,
              8567.428
            ],
            [
              -2373.4,
              -2245.339,
              8614.447
            ],
            [
              -2196.773,
              -2317.488,
              8805.241
            ],
            [
              -2137.182,
              -2337.47,
              8868.093
            ],
            [
              -2015.246,
              -2367.466,
              8993.665
            ],
            [
              -1889.653,
              -2373.04,
              9119.381
            ],
            [
              -1756.388,
              -2382.093,
              9252.954
            ],
            [
              -1647.51,
              -2385.149,
              9361.875
            ],
            [
              -1597.953,
              -2389.374,
              9411.611
            ],
            [
              -1522.821,
              -2405.189,
              9488.39
            ],
            [
              -1485.023,
              -2418.11,
              9528.336
            ],
            [
              -1375.913,
              -2480.178,
              9653.864
            ],
            [
              -1386.622,
              -2502.251,
              9678.397
            ],
            [
              -1401.734,
              -2554.302,
              9732.597
            ],
            [
              -1428.63,
              -2580.538,
              9770.17
            ],
            [
              -1442.374,
              -2628.16,
              9819.736
            ],
            [
              -1451.022,
              -2679.214,
              9871.517
            ],
            [
              -1448.996,
              -2746.044,
              9938.378
            ],
            [
              -1403.403,
              -2899.373,
              10098.342
            ],
            [
              -1382.255,
              -2942.054,
              10145.975
            ],
            [
              -1380.84,
              -2971.023,
              10174.979
            ],
            [
              -1362.723,
              -3074.878,
              10280.403
            ],
            [
              -1447.826,
              -3076.694,
              10365.525
            ],
            [
              -1522.501,
              -3072.018,
              10440.347
            ],
            [
              -1600.963,
              -3062.822,
              10519.346
            ],
            [
              -1631.244,
              -3062.281,
              10549.631
            ],
            [
              -1661.95,
              -3049.487,
              10582.896
            ],
            [
              -1775.996,
              -3011.829,
              10702.998
            ],
            [
              -1790.725,
              -3042.737,
              10737.236
            ],
            [
              -1806.584,
              -3064.719,
              10764.342
            ],
            [
              -1829.59,
              -3089.913,
              10798.46
            ],
            [
              -1853.041,
              -3103.967,
              10825.8
            ],
            [
              -1875.789,
              -3114.694,
              10850.95
            ],
            [
              -1903.67,
              -3124.217,
              10880.413
            ],
            [
              -1932.077,
              -3127.051,
              10908.96
            ],
            [
              -2119.439,
              -3117.041,
              11096.589
            ],
            [
              -2119.032,
              -3130.407,
              11109.961
            ],
            [
              -2122.51,
              -3144.817,
              11124.785
            ],
            [
              -2127.881,
              -3156.967,
              11138.07
            ],
            [
              -2137,
              -3162.371,
              11148.669
            ],
            [
              -2161.481,
              -3161.937,
              11173.155
            ],
            [
              -2189.769,
              -3158.095,
              11201.702
            ],
            [
              -2192.892,
              -3152.474,
              11208.133
            ],
            [
              -2195.778,
              -3133.498,
              11227.327
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 183.328,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 578.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6783",
              "position": {
                "x": -156.753,
                "z": -6889.462
              },
              "distanceAlongShapeM": 940.521,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6778",
              "position": {
                "x": -604.294,
                "z": -7138.492
              },
              "distanceAlongShapeM": 1500.714,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6776",
              "position": {
                "x": -1058.33,
                "z": -6320.967
              },
              "distanceAlongShapeM": 2458.307,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6774",
              "position": {
                "x": -985.81,
                "z": -5799.053
              },
              "distanceAlongShapeM": 2985.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5822",
              "position": {
                "x": -927.257,
                "z": -5373.739
              },
              "distanceAlongShapeM": 3450.727,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 3952.947,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 4328.043,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 4822.069,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6763",
              "position": {
                "x": -2381.317,
                "z": -4767.762
              },
              "distanceAlongShapeM": 5273.372,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6766",
              "position": {
                "x": -2809.985,
                "z": -4489.679
              },
              "distanceAlongShapeM": 5879.044,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6484",
              "position": {
                "x": -2923.723,
                "z": -4326.261
              },
              "distanceAlongShapeM": 6079.021,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 6300.537,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 6630.422,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6478",
              "position": {
                "x": -3026.974,
                "z": -3344.813
              },
              "distanceAlongShapeM": 7075.116,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 7513.42,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 7989.639,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:1069",
              "position": {
                "x": -2415.576,
                "z": -2224.555
              },
              "distanceAlongShapeM": 8567.428,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:3512",
              "position": {
                "x": -1401.734,
                "z": -2554.302
              },
              "distanceAlongShapeM": 9732.597,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6934",
              "position": {
                "x": -1382.255,
                "z": -2942.054
              },
              "distanceAlongShapeM": 10145.975,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6941",
              "position": {
                "x": -1631.244,
                "z": -3062.281
              },
              "distanceAlongShapeM": 10549.631,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5206",
              "position": {
                "x": -2195.778,
                "z": -3133.498
              },
              "distanceAlongShapeM": 11227.327,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            }
          ],
          "departuresSeconds": [
            22260,
            28320,
            36060,
            41880,
            47760,
            54360,
            60780,
            67740,
            75300,
            80280,
            85200
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_49",
      "sourceRouteId": "vilnius_bus_49",
      "mode": "bus",
      "shortName": "49",
      "longName": "Bajorai–Ateities g.–Didlaukio g.–Žalgirio g.–Lazdynai–Bukčiai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_49:0",
          "sourceRouteId": "vilnius_bus_49",
          "sourceShapeId": "vilnius_bus_49_a-b",
          "directionId": 0,
          "headsign": "Bukčiai",
          "directionName": "Bajorai–Ateities g.–Didlaukio g.–Žalgirio g.–Lazdynai–Bukčiai",
          "mode": "bus",
          "routeShortName": "49",
          "routeLongName": "Bajorai–Ateities g.–Didlaukio g.–Žalgirio g.–Lazdynai–Bukčiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -1512.213,
              -7678.755,
              0
            ],
            [
              -1492.181,
              -7674.661,
              20.446
            ],
            [
              -1434.4,
              -7647.866,
              84.137
            ],
            [
              -1412.802,
              -7628.215,
              113.337
            ],
            [
              -1311.062,
              -7519.831,
              261.992
            ],
            [
              -1244.231,
              -7455.351,
              354.858
            ],
            [
              -1087.774,
              -7312.331,
              566.832
            ],
            [
              -1078.522,
              -7299.139,
              582.945
            ],
            [
              -1073.556,
              -7273.624,
              608.939
            ],
            [
              -1063.137,
              -7267.132,
              621.215
            ],
            [
              -1045.114,
              -7267.457,
              639.241
            ],
            [
              -1002.208,
              -7280.476,
              684.078
            ],
            [
              -979.66,
              -7279.769,
              706.638
            ],
            [
              -935.71,
              -7270.543,
              751.546
            ],
            [
              -707.406,
              -7214.553,
              986.615
            ],
            [
              -684.153,
              -7210.52,
              1010.215
            ],
            [
              -567.625,
              -7175.894,
              1131.779
            ],
            [
              -492.955,
              -7141.624,
              1213.937
            ],
            [
              -472.94,
              -7138.647,
              1234.172
            ],
            [
              -433.975,
              -7120.429,
              1277.186
            ],
            [
              -356.786,
              -7053.923,
              1379.074
            ],
            [
              -147.918,
              -6864.018,
              1661.368
            ],
            [
              -119.568,
              -6827.798,
              1707.364
            ],
            [
              -100.778,
              -6821.461,
              1727.193
            ],
            [
              -58.991,
              -6789.938,
              1779.537
            ],
            [
              -47.763,
              -6774.558,
              1798.58
            ],
            [
              -41.021,
              -6757.982,
              1816.474
            ],
            [
              -44.133,
              -6716.735,
              1857.838
            ],
            [
              -50.829,
              -6695.462,
              1880.141
            ],
            [
              -48.526,
              -6639.841,
              1935.809
            ],
            [
              -52.099,
              -6588.567,
              1987.207
            ],
            [
              -70.555,
              -6505.85,
              2071.958
            ],
            [
              -125.166,
              -6286.66,
              2297.849
            ],
            [
              -158.525,
              -6137.991,
              2450.214
            ],
            [
              -182.398,
              -6069.649,
              2522.607
            ],
            [
              -186.217,
              -6031.729,
              2560.718
            ],
            [
              -210.448,
              -5912.171,
              2682.707
            ],
            [
              -214.688,
              -5861.998,
              2733.059
            ],
            [
              -215.425,
              -5796.303,
              2798.757
            ],
            [
              -210.007,
              -5746.306,
              2849.047
            ],
            [
              -195.772,
              -5671.978,
              2924.726
            ],
            [
              -200.158,
              -5665.219,
              2932.784
            ],
            [
              -245.834,
              -5662.161,
              2978.563
            ],
            [
              -275.515,
              -5664.961,
              3008.375
            ],
            [
              -299.862,
              -5657.84,
              3033.742
            ],
            [
              -394.957,
              -5644.98,
              3129.703
            ],
            [
              -428.258,
              -5634.356,
              3164.658
            ],
            [
              -633.019,
              -5523.775,
              3397.37
            ],
            [
              -663.705,
              -5510.974,
              3430.62
            ],
            [
              -740.836,
              -5466.163,
              3519.822
            ],
            [
              -765.768,
              -5455.693,
              3546.863
            ],
            [
              -877.432,
              -5396.902,
              3673.059
            ],
            [
              -884.394,
              -5390.097,
              3682.795
            ],
            [
              -886.769,
              -5378.922,
              3694.219
            ],
            [
              -880.613,
              -5358.995,
              3715.076
            ],
            [
              -871.52,
              -5283.459,
              3791.157
            ],
            [
              -867.295,
              -5263.497,
              3811.562
            ],
            [
              -873.84,
              -5126.451,
              3948.764
            ],
            [
              -873.198,
              -5090.839,
              3984.382
            ],
            [
              -867.363,
              -5053.094,
              4022.575
            ],
            [
              -847.141,
              -4967.74,
              4110.292
            ],
            [
              -716.635,
              -4519.236,
              4577.397
            ],
            [
              -646.915,
              -4511.591,
              4647.535
            ],
            [
              -568.48,
              -4520.803,
              4726.509
            ],
            [
              -439.606,
              -4519.799,
              4855.386
            ],
            [
              -373.187,
              -4516.551,
              4921.885
            ],
            [
              -303.365,
              -4503.347,
              4992.944
            ],
            [
              -273.394,
              -4484.966,
              5028.102
            ],
            [
              -264.839,
              -4475.102,
              5041.159
            ],
            [
              -248.495,
              -4462.041,
              5062.082
            ],
            [
              -208.316,
              -4413.789,
              5124.872
            ],
            [
              -185.328,
              -4389.716,
              5158.158
            ],
            [
              -166.99,
              -4373.351,
              5182.736
            ],
            [
              -153.302,
              -4364.694,
              5198.932
            ],
            [
              -100.827,
              -4348.95,
              5253.718
            ],
            [
              -72.426,
              -4346.128,
              5282.258
            ],
            [
              -23.455,
              -4345.907,
              5331.23
            ],
            [
              35.096,
              -4350.314,
              5389.947
            ],
            [
              46.147,
              -4344.95,
              5402.231
            ],
            [
              45.488,
              -4310.427,
              5436.76
            ],
            [
              49.82,
              -4284.902,
              5462.65
            ],
            [
              60.111,
              -4250.579,
              5498.483
            ],
            [
              104.143,
              -4062.131,
              5692.006
            ],
            [
              126.577,
              -3997.973,
              5759.973
            ],
            [
              148.043,
              -3951.609,
              5811.066
            ],
            [
              179.07,
              -3910.986,
              5862.183
            ],
            [
              264.038,
              -3810.121,
              5994.066
            ],
            [
              345.157,
              -3743.697,
              6098.911
            ],
            [
              383.579,
              -3686.512,
              6167.805
            ],
            [
              434.283,
              -3627.326,
              6245.74
            ],
            [
              450.253,
              -3599.787,
              6277.574
            ],
            [
              463.769,
              -3565.524,
              6314.407
            ],
            [
              474.065,
              -3531.203,
              6350.239
            ],
            [
              484.063,
              -3477.95,
              6404.422
            ],
            [
              489.712,
              -3345.578,
              6536.915
            ],
            [
              488.249,
              -3319.947,
              6562.588
            ],
            [
              479.687,
              -3259.675,
              6623.465
            ],
            [
              477.905,
              -3216.226,
              6666.95
            ],
            [
              481.339,
              -3169.533,
              6713.77
            ],
            [
              500.602,
              -3103.091,
              6782.947
            ],
            [
              500.428,
              -3077.483,
              6808.556
            ],
            [
              504.445,
              -3034.141,
              6852.084
            ],
            [
              503.491,
              -2980.688,
              6905.546
            ],
            [
              505.751,
              -2962.917,
              6923.459
            ],
            [
              502.159,
              -2912.756,
              6973.749
            ],
            [
              509.397,
              -2869.472,
              7017.634
            ],
            [
              513.301,
              -2797.183,
              7090.029
            ],
            [
              494.515,
              -2626.513,
              7261.729
            ],
            [
              482.722,
              -2601.805,
              7289.107
            ],
            [
              485.911,
              -2568.466,
              7322.598
            ],
            [
              462.343,
              -2342.047,
              7550.241
            ],
            [
              451.425,
              -2269.486,
              7623.618
            ],
            [
              407.176,
              -2116.162,
              7783.2
            ],
            [
              406.254,
              -2096.107,
              7803.276
            ],
            [
              361.405,
              -1904.922,
              7999.651
            ],
            [
              342.249,
              -1718.661,
              8186.895
            ],
            [
              290.448,
              -1731.073,
              8240.162
            ],
            [
              249.243,
              -1728.093,
              8281.475
            ],
            [
              91.167,
              -1735.227,
              8439.712
            ],
            [
              -460.696,
              -1807.576,
              8996.296
            ],
            [
              -504.679,
              -1815.686,
              9041.022
            ],
            [
              -529.853,
              -1817.457,
              9066.258
            ],
            [
              -564.13,
              -1823.516,
              9101.066
            ],
            [
              -591.68,
              -1814.111,
              9130.177
            ],
            [
              -679.004,
              -1794.721,
              9219.627
            ],
            [
              -772.672,
              -1769.652,
              9316.592
            ],
            [
              -795.027,
              -1758.117,
              9341.748
            ],
            [
              -810.858,
              -1742.246,
              9364.164
            ],
            [
              -857.103,
              -1661.259,
              9457.424
            ],
            [
              -917.833,
              -1561.088,
              9574.567
            ],
            [
              -1006.944,
              -1461.52,
              9708.188
            ],
            [
              -1011.739,
              -1441.395,
              9728.876
            ],
            [
              -987.78,
              -1363.9,
              9809.99
            ],
            [
              -988.723,
              -1201.352,
              9972.541
            ],
            [
              -990.397,
              -1186.85,
              9987.14
            ],
            [
              -1006.474,
              -1148.711,
              10028.529
            ],
            [
              -1019.105,
              -1134.012,
              10047.909
            ],
            [
              -1029.882,
              -1123.799,
              10062.757
            ],
            [
              -1062.634,
              -1116.531,
              10096.305
            ],
            [
              -1096.995,
              -1127.045,
              10132.239
            ],
            [
              -1143.947,
              -1120.636,
              10179.627
            ],
            [
              -1339.338,
              -1158.32,
              10378.619
            ],
            [
              -1374.402,
              -1172.164,
              10416.317
            ],
            [
              -1791.301,
              -1230.398,
              10837.263
            ],
            [
              -1855.793,
              -1231.475,
              10901.765
            ],
            [
              -1940.187,
              -1227.747,
              10986.241
            ],
            [
              -2027.705,
              -1218.399,
              11074.257
            ],
            [
              -2166.609,
              -1198.122,
              11214.632
            ],
            [
              -2255.397,
              -1187.643,
              11304.037
            ],
            [
              -2267.097,
              -1193.002,
              11316.906
            ],
            [
              -2295.924,
              -1182.472,
              11347.596
            ],
            [
              -2392.506,
              -1175.197,
              11444.451
            ],
            [
              -2431.277,
              -1180.078,
              11483.528
            ],
            [
              -2478.584,
              -1193.714,
              11532.761
            ],
            [
              -2533.196,
              -1219.467,
              11593.141
            ],
            [
              -2617.204,
              -1266.966,
              11689.648
            ],
            [
              -2663.944,
              -1285.067,
              11739.769
            ],
            [
              -2710.565,
              -1296.491,
              11787.77
            ],
            [
              -2762.303,
              -1305.599,
              11840.303
            ],
            [
              -2808.767,
              -1308.121,
              11886.836
            ],
            [
              -2858.317,
              -1302.797,
              11936.671
            ],
            [
              -3071.028,
              -1263.439,
              12152.993
            ],
            [
              -3140.52,
              -1255.542,
              12222.932
            ],
            [
              -3159.719,
              -1247.413,
              12243.781
            ],
            [
              -3359.526,
              -1207.182,
              12447.598
            ],
            [
              -3495.953,
              -1192.555,
              12584.807
            ],
            [
              -3569.469,
              -1193.5,
              12658.329
            ],
            [
              -3626.266,
              -1196.964,
              12715.231
            ],
            [
              -3657.704,
              -1114.039,
              12803.915
            ],
            [
              -3680.758,
              -1067.996,
              12855.407
            ],
            [
              -3686.114,
              -1042.299,
              12881.656
            ],
            [
              -3720.918,
              -930.373,
              12998.869
            ],
            [
              -3751.541,
              -837.444,
              13096.714
            ],
            [
              -3761.526,
              -818.346,
              13118.264
            ],
            [
              -3766.218,
              -791.548,
              13145.471
            ],
            [
              -3793.988,
              -719.82,
              13222.386
            ],
            [
              -3843.779,
              -616.54,
              13337.042
            ],
            [
              -3881.258,
              -546.871,
              13416.153
            ],
            [
              -3968.98,
              -399.519,
              13587.639
            ],
            [
              -3986.683,
              -379.175,
              13614.607
            ],
            [
              -3999.719,
              -350.005,
              13646.557
            ],
            [
              -4048.201,
              -282.373,
              13729.771
            ],
            [
              -4133.499,
              -180.709,
              13862.479
            ],
            [
              -4196.245,
              -117.285,
              13951.696
            ],
            [
              -4221.08,
              -99.045,
              13982.51
            ],
            [
              -4243.751,
              -67.483,
              14021.37
            ],
            [
              -4402.336,
              85.535,
              14241.741
            ],
            [
              -4449.086,
              142,
              14315.049
            ],
            [
              -4479.797,
              193.736,
              14375.213
            ],
            [
              -4502.905,
              237.549,
              14424.746
            ],
            [
              -4519.036,
              274.562,
              14465.122
            ],
            [
              -4536.228,
              324.952,
              14518.364
            ],
            [
              -4547.048,
              370.78,
              14565.451
            ],
            [
              -4566.578,
              510.266,
              14706.298
            ],
            [
              -4574.501,
              537.119,
              14734.295
            ],
            [
              -4575.517,
              590.57,
              14787.756
            ],
            [
              -4579.623,
              651.866,
              14849.19
            ],
            [
              -4586.366,
              709.869,
              14907.583
            ],
            [
              -4584.541,
              741.007,
              14938.775
            ],
            [
              -4573.306,
              794.248,
              14993.188
            ],
            [
              -4555.909,
              830.684,
              15033.564
            ],
            [
              -4554.237,
              852.919,
              15055.863
            ],
            [
              -4568.699,
              912.168,
              15116.85
            ],
            [
              -4567.748,
              929.963,
              15134.671
            ],
            [
              -4555.854,
              946.456,
              15155.005
            ],
            [
              -4510.16,
              977.953,
              15210.503
            ],
            [
              -4440.575,
              860.983,
              15346.606
            ],
            [
              -4425.036,
              789.47,
              15419.788
            ],
            [
              -4406.248,
              756.864,
              15457.42
            ],
            [
              -4380.992,
              725.259,
              15497.876
            ],
            [
              -4355.565,
              703.67,
              15531.233
            ],
            [
              -4324.219,
              688.657,
              15565.988
            ],
            [
              -4302.372,
              683.828,
              15588.362
            ],
            [
              -4269.507,
              682.148,
              15621.271
            ],
            [
              -4233.908,
              689.326,
              15657.586
            ],
            [
              -4200.071,
              706.552,
              15695.556
            ],
            [
              -4154.906,
              744.734,
              15754.697
            ],
            [
              -4134.494,
              768.872,
              15786.308
            ],
            [
              -4089.107,
              782.559,
              15833.714
            ],
            [
              -4026.001,
              813.75,
              15904.108
            ],
            [
              -3968.169,
              838.352,
              15966.956
            ],
            [
              -3939.526,
              853.44,
              15999.329
            ],
            [
              -3921.201,
              868.708,
              16023.181
            ],
            [
              -3904.031,
              891.787,
              16051.947
            ],
            [
              -3887.976,
              924.905,
              16088.751
            ],
            [
              -3883.393,
              966.014,
              16130.115
            ],
            [
              -3887.876,
              1005.054,
              16169.412
            ],
            [
              -3903.754,
              1056.537,
              16223.287
            ],
            [
              -3916.285,
              1077.905,
              16248.058
            ],
            [
              -3919.363,
              1123.6,
              16293.857
            ],
            [
              -3949.447,
              1248.8,
              16422.621
            ],
            [
              -3955.799,
              1254.476,
              16431.14
            ],
            [
              -3966.06,
              1257.993,
              16441.986
            ],
            [
              -4052.898,
              1235.006,
              16531.815
            ],
            [
              -4088.424,
              1232.281,
              16567.445
            ],
            [
              -4119.34,
              1235.042,
              16598.484
            ],
            [
              -4215.081,
              1256.734,
              16696.652
            ],
            [
              -4241.916,
              1271.669,
              16727.363
            ],
            [
              -4268.203,
              1281.028,
              16755.266
            ],
            [
              -4527.979,
              1404.616,
              17042.942
            ],
            [
              -4558.781,
              1414.051,
              17075.157
            ],
            [
              -4581.673,
              1433.369,
              17105.111
            ],
            [
              -4718.251,
              1519.203,
              17266.422
            ],
            [
              -4838.028,
              1606.973,
              17414.914
            ],
            [
              -4855.022,
              1631.754,
              17444.963
            ],
            [
              -4943.107,
              1724.544,
              17572.904
            ],
            [
              -4962.228,
              1738.229,
              17596.417
            ],
            [
              -5069.077,
              1865.846,
              17762.859
            ],
            [
              -5076.134,
              1868.193,
              17770.295
            ],
            [
              -5119.953,
              1909.016,
              17830.184
            ],
            [
              -5214.195,
              1981.867,
              17949.302
            ],
            [
              -5228.689,
              2002.152,
              17974.232
            ],
            [
              -5236.77,
              2020.101,
              17993.916
            ],
            [
              -5240.925,
              2041.322,
              18015.54
            ],
            [
              -5239.294,
              2061.332,
              18035.617
            ],
            [
              -5227.836,
              2090.08,
              18066.564
            ],
            [
              -5213.304,
              2109.87,
              18091.116
            ],
            [
              -5193.689,
              2125.12,
              18115.962
            ],
            [
              -5147.096,
              2133.231,
              18163.255
            ],
            [
              -5074.894,
              2129.773,
              18235.541
            ],
            [
              -4973.287,
              2110.226,
              18339.01
            ],
            [
              -4894.768,
              2098.864,
              18418.347
            ],
            [
              -4850.889,
              2099.226,
              18462.228
            ],
            [
              -4603.07,
              2140.618,
              18713.48
            ],
            [
              -4527.565,
              2141.547,
              18788.99
            ],
            [
              -4479.873,
              2138.5,
              18836.779
            ],
            [
              -4449.462,
              2143.543,
              18867.606
            ],
            [
              -4390.804,
              2140.306,
              18926.352
            ],
            [
              -4376.576,
              2142.288,
              18940.718
            ],
            [
              -4195.427,
              2208.182,
              19133.479
            ],
            [
              -4108.264,
              2248.978,
              19229.718
            ],
            [
              -4011,
              2314.088,
              19346.763
            ],
            [
              -3940.43,
              2365.187,
              19433.89
            ],
            [
              -3943.03,
              2364.119,
              19436.7
            ],
            [
              -3945.224,
              2386.421,
              19459.11
            ],
            [
              -3966.145,
              2407.934,
              19489.118
            ],
            [
              -3991.012,
              2499.647,
              19584.143
            ],
            [
              -4043.609,
              2629.688,
              19724.418
            ],
            [
              -4060.699,
              2648.908,
              19750.137
            ],
            [
              -4116.103,
              2803.488,
              19914.346
            ],
            [
              -4124.654,
              2831.465,
              19943.601
            ],
            [
              -4145.675,
              2921.998,
              20036.542
            ],
            [
              -4153.919,
              2967.781,
              20083.062
            ],
            [
              -4167.738,
              3027.02,
              20143.891
            ],
            [
              -4202.041,
              3133.366,
              20255.632
            ],
            [
              -4257.982,
              3220.047,
              20358.797
            ],
            [
              -4348.426,
              3289.511,
              20472.838
            ],
            [
              -4400.946,
              3312.679,
              20530.242
            ],
            [
              -4445.196,
              3329.026,
              20577.414
            ],
            [
              -4463.829,
              3333.799,
              20596.649
            ],
            [
              -4474.19,
              3331.751,
              20607.211
            ],
            [
              -4488.953,
              3336.457,
              20622.705
            ],
            [
              -4577.094,
              3352.444,
              20712.284
            ],
            [
              -4675.31,
              3383.073,
              20815.166
            ],
            [
              -4812.939,
              3448.883,
              20967.72
            ],
            [
              -4863.809,
              3531.017,
              21064.331
            ],
            [
              -4905.518,
              3582.938,
              21130.929
            ],
            [
              -5021.008,
              3698.457,
              21294.278
            ],
            [
              -5109.31,
              3781.227,
              21415.307
            ],
            [
              -5130.963,
              3798.294,
              21442.878
            ],
            [
              -5148.233,
              3807.494,
              21462.445
            ],
            [
              -5163.662,
              3811.096,
              21478.289
            ],
            [
              -5212.112,
              3808.582,
              21526.805
            ],
            [
              -5281.969,
              3799.753,
              21597.217
            ],
            [
              -5290.357,
              3799.896,
              21605.607
            ],
            [
              -5296.032,
              3807.784,
              21615.325
            ],
            [
              -5295.311,
              3812.225,
              21619.823
            ],
            [
              -5285.519,
              3818.737,
              21631.583
            ],
            [
              -5275.233,
              3816.336,
              21642.146
            ],
            [
              -5264.358,
              3810.585,
              21654.448
            ],
            [
              -5248.891,
              3809.209,
              21669.976
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:370",
              "position": {
                "x": -1512.213,
                "z": -7678.755
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -720,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7052",
              "position": {
                "x": -1045.114,
                "z": -7267.457
              },
              "distanceAlongShapeM": 639.241,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8326",
              "position": {
                "x": -492.955,
                "z": -7141.624
              },
              "distanceAlongShapeM": 1213.937,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:8327",
              "position": {
                "x": -119.568,
                "z": -6827.798
              },
              "distanceAlongShapeM": 1707.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 1880.141,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 2522.607,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 3008.375,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 3430.62,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:348",
              "position": {
                "x": -871.52,
                "z": -5283.459
              },
              "distanceAlongShapeM": 3791.157,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5833",
              "position": {
                "x": -646.915,
                "z": -4511.591
              },
              "distanceAlongShapeM": 4647.535,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 5462.65,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 5811.066,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 6167.805,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 6973.749,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 7289.107,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 7783.2,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5498",
              "position": {
                "x": 290.448,
                "z": -1731.073
              },
              "distanceAlongShapeM": 8240.162,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5499",
              "position": {
                "x": -564.13,
                "z": -1823.516
              },
              "distanceAlongShapeM": 9101.066,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 9761.501,
              "shapeOffsetM": 0.619,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 10132.239,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:814",
              "position": {
                "x": -1374.402,
                "z": -1172.164
              },
              "distanceAlongShapeM": 10416.317,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5906",
              "position": {
                "x": -2267.097,
                "z": -1193.002
              },
              "distanceAlongShapeM": 11316.906,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 12222.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 12855.407,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 13118.264,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 13614.607,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 13982.51,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 14734.295,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 15786.308,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 16248.058,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 16696.652,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 17075.157,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 17414.914,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3420,
              "departureOffsetSeconds": 3420
            },
            {
              "stopId": "judu:stop:6401",
              "position": {
                "x": -5074.894,
                "z": 2129.773
              },
              "distanceAlongShapeM": 18235.541,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3600,
              "departureOffsetSeconds": 3600
            },
            {
              "stopId": "judu:stop:6379",
              "position": {
                "x": -4449.462,
                "z": 2143.543
              },
              "distanceAlongShapeM": 18867.606,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3720,
              "departureOffsetSeconds": 3720
            },
            {
              "stopId": "judu:stop:9102",
              "position": {
                "x": -3966.145,
                "z": 2407.934
              },
              "distanceAlongShapeM": 19489.118,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3780,
              "departureOffsetSeconds": 3780
            },
            {
              "stopId": "judu:stop:6389",
              "position": {
                "x": -4060.699,
                "z": 2648.908
              },
              "distanceAlongShapeM": 19750.137,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3840,
              "departureOffsetSeconds": 3840
            },
            {
              "stopId": "judu:stop:7722",
              "position": {
                "x": -4474.19,
                "z": 3331.751
              },
              "distanceAlongShapeM": 20607.211,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3960,
              "departureOffsetSeconds": 3960
            },
            {
              "stopId": "judu:stop:6391",
              "position": {
                "x": -4812.939,
                "z": 3448.883
              },
              "distanceAlongShapeM": 20967.72,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 4020,
              "departureOffsetSeconds": 4020
            },
            {
              "stopId": "judu:stop:639",
              "position": {
                "x": -5248.891,
                "z": 3809.209
              },
              "distanceAlongShapeM": 21669.976,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 4080,
              "departureOffsetSeconds": 4080
            }
          ],
          "departuresSeconds": [
            18420,
            20100,
            22200,
            23880,
            24900,
            26100,
            27300,
            28920,
            30360,
            31740,
            34140,
            37440,
            39840,
            41580,
            43320,
            44940,
            46440,
            47940,
            49500,
            51300,
            52920,
            54600,
            56280,
            57780,
            58680,
            59520,
            60420,
            61740,
            63360,
            65520,
            67920,
            71940,
            73860,
            75720,
            77520,
            79380,
            81420
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_49:1",
          "sourceRouteId": "vilnius_bus_49",
          "sourceShapeId": "vilnius_bus_49_b-a",
          "directionId": 1,
          "headsign": "Bajorai",
          "directionName": "Bukčiai–Lazdynai–Žalgirio g.–Didlaukio g.–Ateities g.–Bajorai",
          "mode": "bus",
          "routeShortName": "49",
          "routeLongName": "Bajorai–Ateities g.–Didlaukio g.–Žalgirio g.–Lazdynai–Bukčiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5248.891,
              3809.209,
              0
            ],
            [
              -5179.091,
              3814.699,
              70.016
            ],
            [
              -5141.135,
              3807.373,
              108.672
            ],
            [
              -5117.508,
              3792.499,
              136.592
            ],
            [
              -4888.894,
              3573.748,
              453.003
            ],
            [
              -4821.629,
              3469.07,
              577.43
            ],
            [
              -4796.885,
              3444.156,
              612.544
            ],
            [
              -4773.906,
              3429.29,
              639.912
            ],
            [
              -4728.933,
              3417.388,
              686.433
            ],
            [
              -4626.524,
              3367.764,
              800.231
            ],
            [
              -4510.831,
              3340.173,
              919.169
            ],
            [
              -4497.206,
              3344.392,
              933.432
            ],
            [
              -4441.951,
              3330.083,
              990.51
            ],
            [
              -4389.959,
              3313.604,
              1045.051
            ],
            [
              -4348.426,
              3289.511,
              1093.066
            ],
            [
              -4264.944,
              3227.96,
              1196.786
            ],
            [
              -4234.003,
              3188.464,
              1246.958
            ],
            [
              -4197.015,
              3125.487,
              1319.994
            ],
            [
              -4171.244,
              3048.231,
              1401.435
            ],
            [
              -4157.405,
              2990.106,
              1461.185
            ],
            [
              -4124.692,
              2829.24,
              1625.343
            ],
            [
              -4095.054,
              2751.917,
              1708.152
            ],
            [
              -4080.014,
              2726.053,
              1738.071
            ],
            [
              -4012.116,
              2547.88,
              1928.743
            ],
            [
              -3954.322,
              2419.974,
              2069.099
            ],
            [
              -3953.773,
              2414.399,
              2074.702
            ],
            [
              -3941.999,
              2386.365,
              2105.108
            ],
            [
              -3939.024,
              2371.842,
              2119.933
            ],
            [
              -3943.03,
              2364.119,
              2128.632
            ],
            [
              -4006.465,
              2315.123,
              2208.787
            ],
            [
              -4077.678,
              2264.034,
              2296.43
            ],
            [
              -4113.54,
              2242.39,
              2338.316
            ],
            [
              -4156.496,
              2220.868,
              2386.362
            ],
            [
              -4324.119,
              2153.629,
              2566.969
            ],
            [
              -4374.718,
              2137.803,
              2619.985
            ],
            [
              -4407.025,
              2135.02,
              2652.412
            ],
            [
              -4518.062,
              2131.364,
              2763.509
            ],
            [
              -4577.307,
              2137.949,
              2823.119
            ],
            [
              -4634.125,
              2135.585,
              2879.986
            ],
            [
              -4816.04,
              2099.743,
              3065.398
            ],
            [
              -4855.442,
              2097.078,
              3104.89
            ],
            [
              -4917.969,
              2100.374,
              3167.504
            ],
            [
              -4969.474,
              2106.821,
              3219.411
            ],
            [
              -5079.485,
              2125.398,
              3330.979
            ],
            [
              -5115.548,
              2129.353,
              3367.259
            ],
            [
              -5151.175,
              2121.056,
              3403.839
            ],
            [
              -5168.571,
              2122.465,
              3421.293
            ],
            [
              -5186.062,
              2118.311,
              3439.27
            ],
            [
              -5204.976,
              2106.388,
              3461.628
            ],
            [
              -5218.73,
              2094.377,
              3479.888
            ],
            [
              -5232.085,
              2067.888,
              3509.553
            ],
            [
              -5234.987,
              2049.013,
              3528.65
            ],
            [
              -5232.767,
              2027.825,
              3549.955
            ],
            [
              -5229.106,
              2015.517,
              3562.795
            ],
            [
              -5217.174,
              1996.39,
              3585.34
            ],
            [
              -5203.212,
              1982.793,
              3604.828
            ],
            [
              -5082.26,
              1887.222,
              3758.981
            ],
            [
              -5064.922,
              1882.473,
              3776.958
            ],
            [
              -5060.085,
              1863.466,
              3796.57
            ],
            [
              -4961.259,
              1757.137,
              3941.734
            ],
            [
              -4928.804,
              1730.978,
              3983.419
            ],
            [
              -4906.917,
              1690.529,
              4029.41
            ],
            [
              -4767.773,
              1565.694,
              4216.346
            ],
            [
              -4739.606,
              1552.966,
              4247.255
            ],
            [
              -4712.351,
              1524.668,
              4286.543
            ],
            [
              -4596.2,
              1451.429,
              4423.857
            ],
            [
              -4491.296,
              1399.532,
              4540.896
            ],
            [
              -4466.279,
              1391.309,
              4567.23
            ],
            [
              -4443.995,
              1374.227,
              4595.308
            ],
            [
              -4243.678,
              1281.718,
              4815.954
            ],
            [
              -4197.987,
              1275.363,
              4862.085
            ],
            [
              -4179.458,
              1265.024,
              4883.303
            ],
            [
              -4137.695,
              1255.397,
              4926.161
            ],
            [
              -4093.256,
              1251.289,
              4970.79
            ],
            [
              -4041.607,
              1253.735,
              5022.496
            ],
            [
              -3953.633,
              1267.797,
              5111.587
            ],
            [
              -3919.363,
              1123.6,
              5259.8
            ],
            [
              -3889.289,
              1035.135,
              5353.237
            ],
            [
              -3876.172,
              1010.417,
              5381.22
            ],
            [
              -3879.245,
              944.791,
              5446.918
            ],
            [
              -3881.411,
              931.47,
              5460.414
            ],
            [
              -3897.582,
              891.676,
              5503.369
            ],
            [
              -3911.432,
              874.104,
              5525.742
            ],
            [
              -3948.102,
              842.457,
              5574.18
            ],
            [
              -4089.107,
              782.559,
              5727.38
            ],
            [
              -4161.662,
              727.04,
              5818.74
            ],
            [
              -4175.491,
              710.581,
              5840.237
            ],
            [
              -4216.46,
              691.251,
              5885.537
            ],
            [
              -4255.417,
              676.338,
              5927.251
            ],
            [
              -4279.313,
              674.524,
              5951.216
            ],
            [
              -4304.422,
              677.184,
              5976.465
            ],
            [
              -4330.724,
              685.43,
              6004.03
            ],
            [
              -4370.887,
              712.839,
              6052.653
            ],
            [
              -4391.801,
              734.351,
              6082.656
            ],
            [
              -4418.25,
              771.542,
              6128.293
            ],
            [
              -4423.862,
              782.771,
              6140.846
            ],
            [
              -4434.785,
              785.185,
              6152.033
            ],
            [
              -4479.393,
              779.274,
              6197.03
            ],
            [
              -4503.366,
              773.007,
              6221.809
            ],
            [
              -4524.836,
              762.245,
              6245.825
            ],
            [
              -4546.478,
              741.466,
              6275.828
            ],
            [
              -4558.582,
              712.731,
              6307.008
            ],
            [
              -4562.872,
              688.314,
              6331.799
            ],
            [
              -4562.176,
              653.793,
              6366.327
            ],
            [
              -4542.083,
              471.996,
              6549.232
            ],
            [
              -4530.426,
              437.286,
              6585.847
            ],
            [
              -4533.311,
              419.524,
              6603.841
            ],
            [
              -4527.744,
              368.221,
              6655.445
            ],
            [
              -4516.259,
              323.495,
              6701.622
            ],
            [
              -4491.638,
              255.166,
              6774.252
            ],
            [
              -4427.619,
              152.763,
              6895.02
            ],
            [
              -4367.011,
              77.134,
              6991.938
            ],
            [
              -4077.229,
              -208.399,
              7398.757
            ],
            [
              -3954.469,
              -380.846,
              7610.436
            ],
            [
              -3921.604,
              -419.265,
              7660.995
            ],
            [
              -3917.323,
              -432.698,
              7675.093
            ],
            [
              -3857.936,
              -540.596,
              7798.255
            ],
            [
              -3823.641,
              -607.984,
              7873.868
            ],
            [
              -3766.483,
              -732.543,
              8010.915
            ],
            [
              -3707.64,
              -908.34,
              8196.298
            ],
            [
              -3695.741,
              -928.584,
              8219.781
            ],
            [
              -3679.35,
              -950.021,
              8246.766
            ],
            [
              -3668.232,
              -978.044,
              8276.914
            ],
            [
              -3606.925,
              -1085.98,
              8401.045
            ],
            [
              -3586.062,
              -1109.72,
              8432.651
            ],
            [
              -3575.241,
              -1117.701,
              8446.097
            ],
            [
              -3510.568,
              -1143.319,
              8515.658
            ],
            [
              -3355.367,
              -1190.556,
              8677.889
            ],
            [
              -3108.49,
              -1230.499,
              8927.977
            ],
            [
              -3070.013,
              -1242.306,
              8968.224
            ],
            [
              -2879.155,
              -1277.94,
              9162.38
            ],
            [
              -2839.273,
              -1283.094,
              9202.593
            ],
            [
              -2787.087,
              -1285.125,
              9254.82
            ],
            [
              -2748.376,
              -1283.58,
              9293.561
            ],
            [
              -2714.118,
              -1278.617,
              9328.176
            ],
            [
              -2670.7,
              -1266.023,
              9373.384
            ],
            [
              -2624.585,
              -1246.798,
              9423.346
            ],
            [
              -2500.301,
              -1182.198,
              9563.416
            ],
            [
              -2469.831,
              -1172.717,
              9595.327
            ],
            [
              -2418.716,
              -1162.489,
              9647.456
            ],
            [
              -2392.231,
              -1159.617,
              9674.096
            ],
            [
              -2151.528,
              -1183.918,
              9916.023
            ],
            [
              -2126.509,
              -1191.041,
              9942.035
            ],
            [
              -2118.854,
              -1195.63,
              9950.961
            ],
            [
              -1948.388,
              -1217.583,
              10122.834
            ],
            [
              -1827.9,
              -1221.953,
              10243.401
            ],
            [
              -1794.345,
              -1220.324,
              10276.996
            ],
            [
              -1681.879,
              -1204.518,
              10390.568
            ],
            [
              -1544.075,
              -1178.035,
              10530.893
            ],
            [
              -1436.465,
              -1145.449,
              10643.329
            ],
            [
              -1393.22,
              -1142.883,
              10686.649
            ],
            [
              -1155.149,
              -1098.17,
              10928.883
            ],
            [
              -1103.929,
              -1082.392,
              10982.478
            ],
            [
              -1083.324,
              -1083.875,
              11003.137
            ],
            [
              -1022.536,
              -1073.836,
              11064.749
            ],
            [
              -998.991,
              -1055.334,
              11094.692
            ],
            [
              -969.041,
              -1039.175,
              11128.724
            ],
            [
              -947.066,
              -1036.231,
              11150.895
            ],
            [
              -930.307,
              -1036.533,
              11167.657
            ],
            [
              -906.579,
              -1043.639,
              11192.426
            ],
            [
              -895.802,
              -1053.852,
              11207.274
            ],
            [
              -890.221,
              -1066.198,
              11220.823
            ],
            [
              -867.459,
              -1091.1,
              11254.56
            ],
            [
              -847.054,
              -1103.713,
              11278.549
            ],
            [
              -821.251,
              -1103.065,
              11304.359
            ],
            [
              -688.757,
              -1085.417,
              11438.024
            ],
            [
              -654.894,
              -1209.598,
              11566.738
            ],
            [
              -644.883,
              -1226.477,
              11586.363
            ],
            [
              -627.842,
              -1246.823,
              11612.903
            ],
            [
              -610.057,
              -1261.617,
              11636.036
            ],
            [
              -593.158,
              -1289.753,
              11668.857
            ],
            [
              -557.225,
              -1334.932,
              11726.584
            ],
            [
              -548.544,
              -1354.014,
              11747.547
            ],
            [
              -546.208,
              -1367.415,
              11761.151
            ],
            [
              -541.958,
              -1488.834,
              11882.644
            ],
            [
              -536.137,
              -1559.073,
              11953.124
            ],
            [
              -520.589,
              -1697.395,
              12092.317
            ],
            [
              -504.478,
              -1804.557,
              12200.683
            ],
            [
              -451.512,
              -1798.837,
              12253.957
            ],
            [
              -397.821,
              -1788.678,
              12308.601
            ],
            [
              -386.905,
              -1791.102,
              12319.782
            ],
            [
              -162.795,
              -1768.453,
              12545.035
            ],
            [
              -103.866,
              -1753.939,
              12605.725
            ],
            [
              91.167,
              -1735.227,
              12801.653
            ],
            [
              238.49,
              -1716.765,
              12950.129
            ],
            [
              252.628,
              -1719.249,
              12964.483
            ],
            [
              342.249,
              -1718.661,
              13054.106
            ],
            [
              356.237,
              -1764.56,
              13102.089
            ],
            [
              354.758,
              -1810.175,
              13147.729
            ],
            [
              356.121,
              -1841.371,
              13178.954
            ],
            [
              372.957,
              -1942.984,
              13281.952
            ],
            [
              426.379,
              -2158.817,
              13504.298
            ],
            [
              441.836,
              -2194.724,
              13543.391
            ],
            [
              440.947,
              -2208.066,
              13556.763
            ],
            [
              462.343,
              -2342.047,
              13692.441
            ],
            [
              505.139,
              -2574.385,
              13928.688
            ],
            [
              511.756,
              -2776.003,
              14130.414
            ],
            [
              513.301,
              -2797.183,
              14151.65
            ],
            [
              524.563,
              -2850.825,
              14206.462
            ],
            [
              524.913,
              -2902.04,
              14257.679
            ],
            [
              518.333,
              -3049.981,
              14405.765
            ],
            [
              517.855,
              -3111.2,
              14466.987
            ],
            [
              506.223,
              -3253.482,
              14609.743
            ],
            [
              511.316,
              -3256.915,
              14615.885
            ],
            [
              504.142,
              -3366.994,
              14726.198
            ],
            [
              489.873,
              -3512.567,
              14872.469
            ],
            [
              474.056,
              -3566.826,
              14928.986
            ],
            [
              441.104,
              -3641.923,
              15010.994
            ],
            [
              383.151,
              -3709.882,
              15100.308
            ],
            [
              303.678,
              -3791.921,
              15214.528
            ],
            [
              278.895,
              -3808.166,
              15244.161
            ],
            [
              228.358,
              -3858.451,
              15315.453
            ],
            [
              158.106,
              -3965.152,
              15443.205
            ],
            [
              127.093,
              -4040.286,
              15524.487
            ],
            [
              102.95,
              -4092.167,
              15581.712
            ],
            [
              79.561,
              -4208.631,
              15700.5
            ],
            [
              75.006,
              -4246.398,
              15738.541
            ],
            [
              72.804,
              -4296.453,
              15788.645
            ],
            [
              62.209,
              -4347.469,
              15840.749
            ],
            [
              53.653,
              -4357.332,
              15853.806
            ],
            [
              38.073,
              -4363.727,
              15870.648
            ],
            [
              -1.759,
              -4357.435,
              15910.974
            ],
            [
              -43.706,
              -4361.123,
              15953.082
            ],
            [
              -86.799,
              -4356.998,
              15996.372
            ],
            [
              -112.623,
              -4359.868,
              16022.356
            ],
            [
              -137.864,
              -4366.088,
              16048.352
            ],
            [
              -171.117,
              -4387.748,
              16088.037
            ],
            [
              -197.387,
              -4415.101,
              16125.962
            ],
            [
              -229.695,
              -4455.703,
              16177.85
            ],
            [
              -260.472,
              -4482.974,
              16218.971
            ],
            [
              -335.167,
              -4516.128,
              16300.693
            ],
            [
              -368.095,
              -4519.983,
              16333.846
            ],
            [
              -469.274,
              -4521.487,
              16435.036
            ],
            [
              -484.832,
              -4526.772,
              16451.467
            ],
            [
              -495.157,
              -4527.698,
              16461.834
            ],
            [
              -531.808,
              -4523.694,
              16498.703
            ],
            [
              -716.635,
              -4519.236,
              16683.583
            ],
            [
              -810.335,
              -4855.967,
              17033.108
            ],
            [
              -844.605,
              -4970.012,
              17152.19
            ],
            [
              -859.998,
              -5037.642,
              17221.549
            ],
            [
              -867.261,
              -5083.153,
              17267.637
            ],
            [
              -868.447,
              -5113.189,
              17297.696
            ],
            [
              -863.974,
              -5257.991,
              17442.566
            ],
            [
              -873.83,
              -5375.816,
              17560.803
            ],
            [
              -864.956,
              -5383.768,
              17572.72
            ],
            [
              -826.661,
              -5403.385,
              17615.746
            ],
            [
              -674.33,
              -5492.97,
              17792.467
            ],
            [
              -589.373,
              -5532.358,
              17886.11
            ],
            [
              -565.267,
              -5552.833,
              17917.738
            ],
            [
              -421.759,
              -5631.135,
              18081.219
            ],
            [
              -383.93,
              -5640.727,
              18120.245
            ],
            [
              -342.157,
              -5645.939,
              18162.342
            ],
            [
              -257.182,
              -5648.596,
              18247.358
            ],
            [
              -196.756,
              -5655.261,
              18308.15
            ],
            [
              -180.177,
              -5664.469,
              18327.115
            ],
            [
              -177.18,
              -5676.769,
              18339.775
            ],
            [
              -185.798,
              -5725.595,
              18389.355
            ],
            [
              -185.377,
              -5737.848,
              18401.616
            ],
            [
              -196.91,
              -5769.923,
              18435.701
            ],
            [
              -201.665,
              -5818.819,
              18484.827
            ],
            [
              -201.086,
              -5857.793,
              18523.806
            ],
            [
              -195.599,
              -5910.215,
              18576.514
            ],
            [
              -136.015,
              -6175.138,
              18848.055
            ],
            [
              -122.378,
              -6204.331,
              18880.276
            ],
            [
              -123.468,
              -6228.802,
              18904.772
            ],
            [
              -113.557,
              -6285.758,
              18962.584
            ],
            [
              -58.166,
              -6532.794,
              19215.753
            ],
            [
              -46.468,
              -6597.576,
              19281.583
            ],
            [
              -39.377,
              -6667.839,
              19352.203
            ],
            [
              -35.045,
              -6748.072,
              19432.553
            ],
            [
              -27.041,
              -6768.256,
              19454.266
            ],
            [
              -16.965,
              -6780.686,
              19470.267
            ],
            [
              0.233,
              -6791.019,
              19490.331
            ],
            [
              10.168,
              -6811.238,
              19512.859
            ],
            [
              11.151,
              -6827.955,
              19529.604
            ],
            [
              7.024,
              -6842.352,
              19544.581
            ],
            [
              -2.815,
              -6852.191,
              19558.496
            ],
            [
              -13.86,
              -6857.556,
              19570.775
            ],
            [
              -26.131,
              -6859.559,
              19583.208
            ],
            [
              -47.374,
              -6859.171,
              19604.455
            ],
            [
              -59.463,
              -6851.158,
              19618.959
            ],
            [
              -78.653,
              -6844.129,
              19639.396
            ],
            [
              -94.726,
              -6842.723,
              19655.53
            ],
            [
              -112.168,
              -6845.745,
              19673.232
            ],
            [
              -131.642,
              -6854.296,
              19694.501
            ],
            [
              -156.753,
              -6889.462,
              19737.712
            ],
            [
              -179.506,
              -6901.294,
              19763.357
            ],
            [
              -377.89,
              -7081.371,
              20031.283
            ],
            [
              -448.339,
              -7131.301,
              20117.631
            ],
            [
              -497.724,
              -7156.009,
              20172.852
            ],
            [
              -684.153,
              -7210.52,
              20367.088
            ],
            [
              -707.406,
              -7214.553,
              20390.688
            ],
            [
              -752.866,
              -7235.995,
              20440.951
            ],
            [
              -772.74,
              -7231.183,
              20461.399
            ],
            [
              -784.346,
              -7232.086,
              20473.04
            ],
            [
              -938.988,
              -7273.823,
              20633.216
            ],
            [
              -982.938,
              -7283.05,
              20678.124
            ],
            [
              -1022.966,
              -7289.008,
              20718.593
            ],
            [
              -1060.359,
              -7291.674,
              20756.081
            ],
            [
              -1074.66,
              -7299.209,
              20772.245
            ],
            [
              -1178.242,
              -7401.989,
              20918.166
            ],
            [
              -1241.716,
              -7458.735,
              21003.308
            ],
            [
              -1267.842,
              -7479.417,
              21036.629
            ],
            [
              -1316.994,
              -7527.517,
              21105.401
            ],
            [
              -1383.24,
              -7595.348,
              21200.214
            ],
            [
              -1421.368,
              -7639.194,
              21258.319
            ],
            [
              -1438.322,
              -7651.135,
              21279.056
            ],
            [
              -1481.803,
              -7670.394,
              21326.612
            ],
            [
              -1494.171,
              -7677.965,
              21341.113
            ],
            [
              -1503.302,
              -7684.481,
              21352.33
            ],
            [
              -1510.561,
              -7694.37,
              21364.598
            ],
            [
              -1518.384,
              -7699.796,
              21374.118
            ],
            [
              -1528.078,
              -7701.849,
              21384.027
            ],
            [
              -1535.702,
              -7696.146,
              21393.548
            ],
            [
              -1533.651,
              -7689.503,
              21400.5
            ],
            [
              -1512.213,
              -7678.755,
              21424.482
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:639",
              "position": {
                "x": -5248.891,
                "z": 3809.209
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -450,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6390",
              "position": {
                "x": -4728.933,
                "z": 3417.388
              },
              "distanceAlongShapeM": 686.433,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7723",
              "position": {
                "x": -4497.206,
                "z": 3344.392
              },
              "distanceAlongShapeM": 933.432,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6388",
              "position": {
                "x": -4080.014,
                "z": 2726.053
              },
              "distanceAlongShapeM": 1738.071,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:8328",
              "position": {
                "x": -3954.322,
                "z": 2419.974
              },
              "distanceAlongShapeM": 2069.099,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6387",
              "position": {
                "x": -4156.496,
                "z": 2220.868
              },
              "distanceAlongShapeM": 2386.362,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6381",
              "position": {
                "x": -4518.062,
                "z": 2131.364
              },
              "distanceAlongShapeM": 2763.509,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:756",
              "position": {
                "x": -5151.175,
                "z": 2121.056
              },
              "distanceAlongShapeM": 3403.839,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 3983.419,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:783",
              "position": {
                "x": -4739.606,
                "z": 1552.966
              },
              "distanceAlongShapeM": 4247.255,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:3589",
              "position": {
                "x": -4466.279,
                "z": 1391.309
              },
              "distanceAlongShapeM": 4567.23,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6317",
              "position": {
                "x": -4197.987,
                "z": 1275.363
              },
              "distanceAlongShapeM": 4862.085,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 5381.22,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 5840.237,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 6585.847,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 7398.757,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 7660.995,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 8246.766,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 8927.977,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6398",
              "position": {
                "x": -2151.528,
                "z": -1183.918
              },
              "distanceAlongShapeM": 9916.023,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6396",
              "position": {
                "x": -1436.465,
                "z": -1145.449
              },
              "distanceAlongShapeM": 10643.329,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 10982.478,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7769",
              "position": {
                "x": -610.057,
                "z": -1261.617
              },
              "distanceAlongShapeM": 11636.036,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5462",
              "position": {
                "x": -397.821,
                "z": -1788.678
              },
              "distanceAlongShapeM": 12308.601,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:17318",
              "position": {
                "x": -103.866,
                "z": -1753.939
              },
              "distanceAlongShapeM": 12605.725,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 13102.089,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 13543.391,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 13928.688,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 14615.885,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 15214.528,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 15524.487,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:5835",
              "position": {
                "x": -43.706,
                "z": -4361.123
              },
              "distanceAlongShapeM": 15953.082,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5834",
              "position": {
                "x": -495.157,
                "z": -4527.698
              },
              "distanceAlongShapeM": 16461.834,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 17615.746,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 17886.11,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 18401.616,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3540,
              "departureOffsetSeconds": 3540
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 18880.276,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3600,
              "departureOffsetSeconds": 3600
            },
            {
              "stopId": "judu:stop:6783",
              "position": {
                "x": -156.753,
                "z": -6889.462
              },
              "distanceAlongShapeM": 19737.712,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3720,
              "departureOffsetSeconds": 3720
            },
            {
              "stopId": "judu:stop:7968",
              "position": {
                "x": -752.866,
                "z": -7235.995
              },
              "distanceAlongShapeM": 20440.951,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3900,
              "departureOffsetSeconds": 3900
            },
            {
              "stopId": "judu:stop:8094",
              "position": {
                "x": -1178.242,
                "z": -7401.989
              },
              "distanceAlongShapeM": 20918.166,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 4020,
              "departureOffsetSeconds": 4020
            },
            {
              "stopId": "judu:stop:370",
              "position": {
                "x": -1512.213,
                "z": -7678.755
              },
              "distanceAlongShapeM": 21424.482,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 4080,
              "departureOffsetSeconds": 4080
            }
          ],
          "departuresSeconds": [
            19680,
            21120,
            22320,
            24000,
            25020,
            26340,
            28500,
            30480,
            32820,
            35220,
            36780,
            38700,
            39960,
            41340,
            42780,
            44520,
            46260,
            48000,
            49860,
            51360,
            52800,
            54420,
            56220,
            57900,
            59940,
            62160,
            64560,
            66120,
            67440,
            69180,
            71280,
            72900,
            74760,
            76200,
            77220,
            78780,
            80340,
            81960
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_50",
      "sourceRouteId": "vilnius_bus_50",
      "mode": "bus",
      "shortName": "50",
      "longName": "Antakalnis–Didlaukio g.–Baltupio g.–Bajorai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_50:0",
          "sourceRouteId": "vilnius_bus_50",
          "sourceShapeId": "vilnius_bus_50_a-b",
          "directionId": 0,
          "headsign": "Bajorai",
          "directionName": "Antakalnis–Didlaukio g.–Baltupio g.–Bajorai",
          "mode": "bus",
          "routeShortName": "50",
          "routeLongName": "Antakalnis–Didlaukio g.–Baltupio g.–Bajorai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2562.319,
              -3823.788,
              0
            ],
            [
              2558.905,
              -3868.254,
              44.597
            ],
            [
              2551.422,
              -3889.265,
              66.901
            ],
            [
              2499.38,
              -3984.027,
              175.013
            ],
            [
              2494.143,
              -3988.382,
              181.824
            ],
            [
              2481.156,
              -3993.705,
              195.86
            ],
            [
              2470.227,
              -3992.386,
              206.868
            ],
            [
              2459.381,
              -3986.616,
              219.154
            ],
            [
              2448.681,
              -3973.056,
              236.427
            ],
            [
              2446.334,
              -3960.766,
              248.939
            ],
            [
              2458.099,
              -3917.57,
              293.708
            ],
            [
              2495.249,
              -3757.959,
              457.586
            ],
            [
              2503.087,
              -3718.029,
              498.278
            ],
            [
              2508.663,
              -3661.358,
              555.223
            ],
            [
              2463.001,
              -3519.117,
              704.613
            ],
            [
              2462.068,
              -3500.174,
              723.579
            ],
            [
              2434.072,
              -3309.282,
              916.513
            ],
            [
              2425.512,
              -3284.63,
              942.609
            ],
            [
              2426.678,
              -3256.82,
              970.443
            ],
            [
              2328.687,
              -2639.354,
              1595.637
            ],
            [
              2308.053,
              -2536.548,
              1700.493
            ],
            [
              2296.913,
              -2511.848,
              1727.589
            ],
            [
              2295.002,
              -2476.188,
              1763.3
            ],
            [
              2274.24,
              -2414.57,
              1828.321
            ],
            [
              2234.812,
              -2316.979,
              1933.576
            ],
            [
              2177.257,
              -2188.992,
              2073.909
            ],
            [
              2082.177,
              -1964.565,
              2317.646
            ],
            [
              2062.178,
              -1896.283,
              2388.796
            ],
            [
              2031.037,
              -1906.834,
              2421.676
            ],
            [
              1998.15,
              -1907.334,
              2454.567
            ],
            [
              1855.148,
              -1935.839,
              2600.382
            ],
            [
              1712.252,
              -1958.784,
              2745.109
            ],
            [
              1647.664,
              -1965.376,
              2810.032
            ],
            [
              1609.684,
              -1962.444,
              2848.125
            ],
            [
              1294.689,
              -1879.791,
              3173.784
            ],
            [
              1221.675,
              -1853.949,
              3251.236
            ],
            [
              1060.096,
              -1806.436,
              3419.656
            ],
            [
              831.715,
              -1745.452,
              3656.039
            ],
            [
              806.202,
              -1730.511,
              3685.605
            ],
            [
              764.977,
              -1728.64,
              3726.873
            ],
            [
              722.32,
              -1734.535,
              3769.935
            ],
            [
              662.58,
              -1757.929,
              3834.093
            ],
            [
              704.051,
              -1816.579,
              3905.924
            ],
            [
              709.094,
              -1857.862,
              3947.513
            ],
            [
              776.616,
              -2147.432,
              4244.852
            ],
            [
              451.425,
              -2269.486,
              4592.194
            ],
            [
              462.343,
              -2342.047,
              4665.571
            ],
            [
              505.139,
              -2574.385,
              4901.818
            ],
            [
              511.756,
              -2776.003,
              5103.544
            ],
            [
              513.301,
              -2797.183,
              5124.78
            ],
            [
              524.563,
              -2850.825,
              5179.592
            ],
            [
              524.913,
              -2902.04,
              5230.809
            ],
            [
              518.333,
              -3049.981,
              5378.895
            ],
            [
              517.855,
              -3111.2,
              5440.117
            ],
            [
              506.223,
              -3253.482,
              5582.873
            ],
            [
              511.316,
              -3256.915,
              5589.015
            ],
            [
              504.142,
              -3366.994,
              5699.328
            ],
            [
              489.873,
              -3512.567,
              5845.599
            ],
            [
              474.056,
              -3566.826,
              5902.116
            ],
            [
              441.104,
              -3641.923,
              5984.124
            ],
            [
              383.151,
              -3709.882,
              6073.438
            ],
            [
              303.678,
              -3791.921,
              6187.658
            ],
            [
              278.895,
              -3808.166,
              6217.291
            ],
            [
              228.358,
              -3858.451,
              6288.583
            ],
            [
              158.106,
              -3965.152,
              6416.335
            ],
            [
              127.093,
              -4040.286,
              6497.617
            ],
            [
              102.95,
              -4092.167,
              6554.842
            ],
            [
              79.561,
              -4208.631,
              6673.63
            ],
            [
              75.006,
              -4246.398,
              6711.671
            ],
            [
              72.804,
              -4296.453,
              6761.775
            ],
            [
              62.209,
              -4347.469,
              6813.879
            ],
            [
              53.653,
              -4357.332,
              6826.936
            ],
            [
              38.073,
              -4363.727,
              6843.778
            ],
            [
              -1.759,
              -4357.435,
              6884.104
            ],
            [
              -43.706,
              -4361.123,
              6926.212
            ],
            [
              -86.799,
              -4356.998,
              6969.502
            ],
            [
              -112.623,
              -4359.868,
              6995.486
            ],
            [
              -137.864,
              -4366.088,
              7021.482
            ],
            [
              -171.117,
              -4387.748,
              7061.167
            ],
            [
              -197.387,
              -4415.101,
              7099.092
            ],
            [
              -229.695,
              -4455.703,
              7150.98
            ],
            [
              -260.472,
              -4482.974,
              7192.101
            ],
            [
              -335.167,
              -4516.128,
              7273.823
            ],
            [
              -368.095,
              -4519.983,
              7306.976
            ],
            [
              -469.274,
              -4521.487,
              7408.166
            ],
            [
              -484.832,
              -4526.772,
              7424.597
            ],
            [
              -495.157,
              -4527.698,
              7434.964
            ],
            [
              -531.808,
              -4523.694,
              7471.833
            ],
            [
              -716.635,
              -4519.236,
              7656.713
            ],
            [
              -810.335,
              -4855.967,
              8006.238
            ],
            [
              -844.605,
              -4970.012,
              8125.32
            ],
            [
              -852.956,
              -5004.372,
              8160.68
            ],
            [
              -867.261,
              -5083.153,
              8240.749
            ],
            [
              -868.447,
              -5113.189,
              8270.809
            ],
            [
              -863.974,
              -5257.991,
              8415.679
            ],
            [
              -873.83,
              -5375.816,
              8533.916
            ],
            [
              -880.43,
              -5384.602,
              8544.905
            ],
            [
              -877.432,
              -5396.902,
              8557.565
            ],
            [
              -884.191,
              -5450.216,
              8611.306
            ],
            [
              -893.567,
              -5470.085,
              8633.276
            ],
            [
              -911.955,
              -5561.038,
              8726.07
            ],
            [
              -930.002,
              -5633.073,
              8800.331
            ],
            [
              -983.576,
              -5818.018,
              8992.879
            ],
            [
              -986.029,
              -5846.918,
              9021.882
            ],
            [
              -994.297,
              -5876.826,
              9052.913
            ],
            [
              -1014.167,
              -6014.509,
              9192.022
            ],
            [
              -1049.096,
              -6308.888,
              9488.466
            ],
            [
              -1050.642,
              -6358.956,
              9538.557
            ],
            [
              -1044.402,
              -6405.824,
              9585.839
            ],
            [
              -1036.394,
              -6426.006,
              9607.553
            ],
            [
              -1036.431,
              -6463.856,
              9645.402
            ],
            [
              -1013.612,
              -6555.552,
              9739.895
            ],
            [
              -980.393,
              -6641.87,
              9832.385
            ],
            [
              -928.004,
              -6736.327,
              9940.398
            ],
            [
              -886.521,
              -6792.738,
              10010.419
            ],
            [
              -721.383,
              -6990.538,
              10268.092
            ],
            [
              -581.383,
              -7153.38,
              10482.841
            ],
            [
              -567.625,
              -7175.894,
              10509.226
            ],
            [
              -684.153,
              -7210.52,
              10630.79
            ],
            [
              -707.406,
              -7214.553,
              10654.39
            ],
            [
              -752.866,
              -7235.995,
              10704.654
            ],
            [
              -772.74,
              -7231.183,
              10725.101
            ],
            [
              -784.346,
              -7232.086,
              10736.743
            ],
            [
              -938.988,
              -7273.823,
              10896.918
            ],
            [
              -982.938,
              -7283.05,
              10941.826
            ],
            [
              -1022.966,
              -7289.008,
              10982.295
            ],
            [
              -1060.359,
              -7291.674,
              11019.783
            ],
            [
              -1074.66,
              -7299.209,
              11035.948
            ],
            [
              -1178.242,
              -7401.989,
              11181.868
            ],
            [
              -1241.716,
              -7458.735,
              11267.011
            ],
            [
              -1267.842,
              -7479.417,
              11300.332
            ],
            [
              -1316.994,
              -7527.517,
              11369.103
            ],
            [
              -1383.24,
              -7595.348,
              11463.917
            ],
            [
              -1421.368,
              -7639.194,
              11522.022
            ],
            [
              -1438.322,
              -7651.135,
              11542.759
            ],
            [
              -1481.803,
              -7670.394,
              11590.314
            ],
            [
              -1494.171,
              -7677.965,
              11604.816
            ],
            [
              -1503.302,
              -7684.481,
              11616.033
            ],
            [
              -1510.561,
              -7694.37,
              11628.3
            ],
            [
              -1518.384,
              -7699.796,
              11637.821
            ],
            [
              -1528.078,
              -7701.849,
              11647.73
            ],
            [
              -1535.702,
              -7696.146,
              11657.25
            ],
            [
              -1533.651,
              -7689.503,
              11664.202
            ],
            [
              -1512.213,
              -7678.755,
              11688.184
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 704.613,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 942.609,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 1727.589,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5091",
              "position": {
                "x": 2031.037,
                "z": -1906.834
              },
              "distanceAlongShapeM": 2421.676,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7042",
              "position": {
                "x": 1294.689,
                "z": -1879.791
              },
              "distanceAlongShapeM": 3173.784,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7045",
              "position": {
                "x": 831.715,
                "z": -1745.452
              },
              "distanceAlongShapeM": 3656.039,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7331",
              "position": {
                "x": 704.051,
                "z": -1816.579
              },
              "distanceAlongShapeM": 3905.924,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 4901.818,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:19086",
              "position": {
                "x": 511.316,
                "z": -3256.915
              },
              "distanceAlongShapeM": 5589.015,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5848",
              "position": {
                "x": 303.678,
                "z": -3791.921
              },
              "distanceAlongShapeM": 6187.658,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5840",
              "position": {
                "x": 127.093,
                "z": -4040.286
              },
              "distanceAlongShapeM": 6497.617,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5835",
              "position": {
                "x": -43.706,
                "z": -4361.123
              },
              "distanceAlongShapeM": 6926.212,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5834",
              "position": {
                "x": -495.157,
                "z": -4527.698
              },
              "distanceAlongShapeM": 7434.964,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6773",
              "position": {
                "x": -884.191,
                "z": -5450.216
              },
              "distanceAlongShapeM": 8611.306,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6775",
              "position": {
                "x": -986.029,
                "z": -5846.918
              },
              "distanceAlongShapeM": 9021.882,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6777",
              "position": {
                "x": -1036.394,
                "z": -6426.006
              },
              "distanceAlongShapeM": 9607.553,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7968",
              "position": {
                "x": -752.866,
                "z": -7235.995
              },
              "distanceAlongShapeM": 10704.654,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2370,
              "departureOffsetSeconds": 2370
            },
            {
              "stopId": "judu:stop:8094",
              "position": {
                "x": -1178.242,
                "z": -7401.989
              },
              "distanceAlongShapeM": 11181.868,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2490,
              "departureOffsetSeconds": 2490
            },
            {
              "stopId": "judu:stop:370",
              "position": {
                "x": -1512.213,
                "z": -7678.755
              },
              "distanceAlongShapeM": 11688.184,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2550,
              "departureOffsetSeconds": 2550
            }
          ],
          "departuresSeconds": [
            21240,
            22560,
            23700,
            25200,
            26700,
            27660,
            28920,
            30240,
            31980,
            34200,
            35940,
            37740,
            38940,
            41580,
            43380,
            45180,
            47160,
            49140,
            51000,
            52980,
            55080,
            57180,
            58440,
            59640,
            60840,
            62160,
            64020,
            65940,
            67560,
            69120,
            71100,
            73020,
            75000,
            76500,
            78540,
            80520,
            82440,
            84180
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_50:1",
          "sourceRouteId": "vilnius_bus_50",
          "sourceShapeId": "vilnius_bus_50_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Bajorai–Baltupio–Didlaukio g.–Antakalnis",
          "mode": "bus",
          "routeShortName": "50",
          "routeLongName": "Antakalnis–Didlaukio g.–Baltupio g.–Bajorai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -1512.213,
              -7678.755,
              0
            ],
            [
              -1492.181,
              -7674.661,
              20.446
            ],
            [
              -1434.4,
              -7647.866,
              84.137
            ],
            [
              -1412.802,
              -7628.215,
              113.337
            ],
            [
              -1311.062,
              -7519.831,
              261.992
            ],
            [
              -1244.231,
              -7455.351,
              354.858
            ],
            [
              -1087.774,
              -7312.331,
              566.832
            ],
            [
              -1078.522,
              -7299.139,
              582.945
            ],
            [
              -1073.556,
              -7273.624,
              608.939
            ],
            [
              -1063.137,
              -7267.132,
              621.215
            ],
            [
              -1045.114,
              -7267.457,
              639.241
            ],
            [
              -1002.208,
              -7280.476,
              684.078
            ],
            [
              -979.66,
              -7279.769,
              706.638
            ],
            [
              -935.71,
              -7270.543,
              751.546
            ],
            [
              -707.406,
              -7214.553,
              986.615
            ],
            [
              -684.153,
              -7210.52,
              1010.215
            ],
            [
              -567.625,
              -7175.894,
              1131.779
            ],
            [
              -604.294,
              -7138.492,
              1184.156
            ],
            [
              -624.971,
              -7106.947,
              1221.875
            ],
            [
              -899.778,
              -6778.026,
              1650.486
            ],
            [
              -953.071,
              -6698.025,
              1746.613
            ],
            [
              -986.73,
              -6636.19,
              1817.015
            ],
            [
              -1008.903,
              -6580.129,
              1877.302
            ],
            [
              -1021.097,
              -6542.059,
              1917.277
            ],
            [
              -1040.818,
              -6457.097,
              2004.497
            ],
            [
              -1058.33,
              -6320.967,
              2141.749
            ],
            [
              -1048.455,
              -6273.276,
              2190.452
            ],
            [
              -1013.163,
              -5994.489,
              2471.464
            ],
            [
              -985.81,
              -5799.053,
              2668.805
            ],
            [
              -976.395,
              -5776.958,
              2692.823
            ],
            [
              -917.287,
              -5570.961,
              2907.131
            ],
            [
              -886.888,
              -5421.223,
              3059.924
            ],
            [
              -885.843,
              -5398.977,
              3082.195
            ],
            [
              -887.614,
              -5390.039,
              3091.306
            ],
            [
              -884.677,
              -5370.054,
              3111.506
            ],
            [
              -880.613,
              -5358.995,
              3123.289
            ],
            [
              -871.52,
              -5283.459,
              3199.37
            ],
            [
              -867.295,
              -5263.497,
              3219.774
            ],
            [
              -873.84,
              -5126.451,
              3356.977
            ],
            [
              -873.198,
              -5090.839,
              3392.594
            ],
            [
              -867.363,
              -5053.094,
              3430.787
            ],
            [
              -847.141,
              -4967.74,
              3518.504
            ],
            [
              -716.635,
              -4519.236,
              3985.609
            ],
            [
              -646.915,
              -4511.591,
              4055.747
            ],
            [
              -568.48,
              -4520.803,
              4134.721
            ],
            [
              -439.606,
              -4519.799,
              4263.599
            ],
            [
              -373.187,
              -4516.551,
              4330.097
            ],
            [
              -303.365,
              -4503.347,
              4401.157
            ],
            [
              -273.394,
              -4484.966,
              4436.315
            ],
            [
              -264.839,
              -4475.102,
              4449.372
            ],
            [
              -248.495,
              -4462.041,
              4470.294
            ],
            [
              -208.316,
              -4413.789,
              4533.084
            ],
            [
              -185.328,
              -4389.716,
              4566.371
            ],
            [
              -166.99,
              -4373.351,
              4590.949
            ],
            [
              -153.302,
              -4364.694,
              4607.145
            ],
            [
              -100.827,
              -4348.95,
              4661.93
            ],
            [
              -72.426,
              -4346.128,
              4690.471
            ],
            [
              -23.455,
              -4345.907,
              4739.443
            ],
            [
              35.096,
              -4350.314,
              4798.16
            ],
            [
              46.147,
              -4344.95,
              4810.444
            ],
            [
              45.488,
              -4310.427,
              4844.973
            ],
            [
              49.82,
              -4284.902,
              4870.863
            ],
            [
              60.111,
              -4250.579,
              4906.695
            ],
            [
              104.143,
              -4062.131,
              5100.218
            ],
            [
              126.577,
              -3997.973,
              5168.186
            ],
            [
              148.043,
              -3951.609,
              5219.278
            ],
            [
              179.07,
              -3910.986,
              5270.395
            ],
            [
              264.038,
              -3810.121,
              5402.279
            ],
            [
              345.157,
              -3743.697,
              5507.124
            ],
            [
              383.579,
              -3686.512,
              5576.018
            ],
            [
              434.283,
              -3627.326,
              5653.953
            ],
            [
              450.253,
              -3599.787,
              5685.787
            ],
            [
              463.769,
              -3565.524,
              5722.619
            ],
            [
              474.065,
              -3531.203,
              5758.452
            ],
            [
              484.063,
              -3477.95,
              5812.635
            ],
            [
              489.712,
              -3345.578,
              5945.127
            ],
            [
              488.249,
              -3319.947,
              5970.8
            ],
            [
              479.687,
              -3259.675,
              6031.678
            ],
            [
              477.905,
              -3216.226,
              6075.163
            ],
            [
              481.339,
              -3169.533,
              6121.982
            ],
            [
              500.602,
              -3103.091,
              6191.16
            ],
            [
              500.428,
              -3077.483,
              6216.768
            ],
            [
              504.445,
              -3034.141,
              6260.297
            ],
            [
              503.491,
              -2980.688,
              6313.758
            ],
            [
              505.751,
              -2962.917,
              6331.672
            ],
            [
              502.159,
              -2912.756,
              6381.962
            ],
            [
              509.397,
              -2869.472,
              6425.847
            ],
            [
              513.301,
              -2797.183,
              6498.241
            ],
            [
              494.515,
              -2626.513,
              6669.942
            ],
            [
              482.722,
              -2601.805,
              6697.32
            ],
            [
              485.911,
              -2568.466,
              6730.811
            ],
            [
              462.343,
              -2342.047,
              6958.454
            ],
            [
              451.425,
              -2269.486,
              7031.831
            ],
            [
              407.176,
              -2116.162,
              7191.413
            ],
            [
              406.254,
              -2096.107,
              7211.489
            ],
            [
              361.405,
              -1904.922,
              7407.864
            ],
            [
              342.249,
              -1718.661,
              7595.107
            ],
            [
              510.658,
              -1710.612,
              7763.709
            ],
            [
              549.551,
              -1699.08,
              7804.275
            ],
            [
              585.119,
              -1693.053,
              7840.35
            ],
            [
              616.278,
              -1681.379,
              7873.624
            ],
            [
              662.58,
              -1757.929,
              7963.088
            ],
            [
              698.331,
              -1741.887,
              8002.274
            ],
            [
              729.45,
              -1732.439,
              8034.795
            ],
            [
              759.842,
              -1727.432,
              8065.597
            ],
            [
              793.978,
              -1729.173,
              8099.777
            ],
            [
              896.682,
              -1753.328,
              8205.284
            ],
            [
              914.226,
              -1745.858,
              8224.352
            ],
            [
              1361.731,
              -1879.919,
              8691.506
            ],
            [
              1407.74,
              -1901.923,
              8742.505
            ],
            [
              1546.922,
              -1940.127,
              8886.836
            ],
            [
              1595.11,
              -1948.815,
              8935.801
            ],
            [
              1676.994,
              -1948.109,
              9017.688
            ],
            [
              1724.765,
              -1944.545,
              9065.592
            ],
            [
              1982.08,
              -1904.808,
              9325.957
            ],
            [
              2058.602,
              -1880.631,
              9406.208
            ],
            [
              2066.336,
              -1880.775,
              9413.942
            ],
            [
              2070.784,
              -1884.198,
              9419.555
            ],
            [
              2087.852,
              -1936.84,
              9474.895
            ],
            [
              2087.374,
              -1962.435,
              9500.495
            ],
            [
              2110.719,
              -2024.1,
              9566.431
            ],
            [
              2234.812,
              -2316.979,
              9884.514
            ],
            [
              2284.924,
              -2429.242,
              10007.454
            ],
            [
              2299.015,
              -2468.47,
              10049.136
            ],
            [
              2319.691,
              -2569.05,
              10151.819
            ],
            [
              2327.089,
              -2587.001,
              10171.235
            ],
            [
              2323.492,
              -2606.972,
              10191.527
            ],
            [
              2328.687,
              -2639.354,
              10224.323
            ],
            [
              2411.872,
              -3118.499,
              10710.635
            ],
            [
              2419.872,
              -3138.687,
              10732.351
            ],
            [
              2418.768,
              -3163.158,
              10756.847
            ],
            [
              2474.472,
              -3526.012,
              11123.951
            ],
            [
              2513.109,
              -3664.781,
              11267.999
            ],
            [
              2522.438,
              -3682.768,
              11288.261
            ],
            [
              2553.555,
              -3775.753,
              11386.315
            ],
            [
              2562.319,
              -3823.788,
              11435.142
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:370",
              "position": {
                "x": -1512.213,
                "z": -7678.755
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7052",
              "position": {
                "x": -1045.114,
                "z": -7267.457
              },
              "distanceAlongShapeM": 639.241,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6778",
              "position": {
                "x": -604.294,
                "z": -7138.492
              },
              "distanceAlongShapeM": 1184.156,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6776",
              "position": {
                "x": -1058.33,
                "z": -6320.967
              },
              "distanceAlongShapeM": 2141.749,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6774",
              "position": {
                "x": -985.81,
                "z": -5799.053
              },
              "distanceAlongShapeM": 2668.805,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:348",
              "position": {
                "x": -871.52,
                "z": -5283.459
              },
              "distanceAlongShapeM": 3199.37,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5833",
              "position": {
                "x": -646.915,
                "z": -4511.591
              },
              "distanceAlongShapeM": 4055.747,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5836",
              "position": {
                "x": 49.82,
                "z": -4284.902
              },
              "distanceAlongShapeM": 4870.863,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5839",
              "position": {
                "x": 148.043,
                "z": -3951.609
              },
              "distanceAlongShapeM": 5219.278,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5846",
              "position": {
                "x": 383.579,
                "z": -3686.512
              },
              "distanceAlongShapeM": 5576.018,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 6381.962,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 6697.32,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 7191.413,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7044",
              "position": {
                "x": 914.226,
                "z": -1745.858
              },
              "distanceAlongShapeM": 8224.352,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7043",
              "position": {
                "x": 1361.731,
                "z": -1879.919
              },
              "distanceAlongShapeM": 8691.506,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 9474.895,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 10171.235,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 10732.351,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 11288.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 11435.142,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            }
          ],
          "departuresSeconds": [
            18840,
            20220,
            21240,
            22560,
            23880,
            24840,
            25800,
            26880,
            28680,
            30360,
            31260,
            32400,
            33540,
            34920,
            37140,
            38880,
            40560,
            42240,
            44460,
            46320,
            48120,
            50040,
            52020,
            53940,
            56220,
            58440,
            60600,
            62040,
            63300,
            64500,
            65700,
            67380,
            69180,
            70620,
            72240,
            73860,
            75720,
            77700,
            79500,
            81240,
            83220,
            85140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_52",
      "sourceRouteId": "vilnius_bus_52",
      "mode": "bus",
      "shortName": "52",
      "longName": "Tarandė–Ukmergės g.–Pašilaičiai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_52:0",
          "sourceRouteId": "vilnius_bus_52",
          "sourceShapeId": "vilnius_bus_52_a-b",
          "directionId": 0,
          "headsign": "Pašilaičiai",
          "directionName": "Tarandė–Ukmergės g.–Pašilaičiai",
          "mode": "bus",
          "routeShortName": "52",
          "routeLongName": "Tarandė–Ukmergės g.–Pašilaičiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6372.183,
              -6678.131,
              0
            ],
            [
              -6336.89,
              -6570.745,
              113.037
            ],
            [
              -6269.862,
              -6452.761,
              248.731
            ],
            [
              -6259.211,
              -6393.941,
              308.508
            ],
            [
              -6261.267,
              -6324.888,
              377.592
            ],
            [
              -6250.878,
              -6281.648,
              422.062
            ],
            [
              -6222.02,
              -6288.814,
              451.797
            ],
            [
              -6120.237,
              -6325.041,
              559.834
            ],
            [
              -5947.184,
              -6373.608,
              739.574
            ],
            [
              -5904.144,
              -6379.903,
              783.072
            ],
            [
              -5858.736,
              -6398.484,
              832.134
            ],
            [
              -5805.964,
              -6400.491,
              884.944
            ],
            [
              -5640.681,
              -6375.467,
              1052.11
            ],
            [
              -5591.753,
              -6376.299,
              1101.046
            ],
            [
              -5527.298,
              -6410.792,
              1174.15
            ],
            [
              -5458.944,
              -6443.125,
              1249.766
            ],
            [
              -5398.05,
              -6459.748,
              1312.888
            ],
            [
              -5211.984,
              -6537.509,
              1514.549
            ],
            [
              -5121.063,
              -6568.008,
              1610.449
            ],
            [
              -5003.068,
              -6596.745,
              1731.893
            ],
            [
              -4998.619,
              -6600.161,
              1737.502
            ],
            [
              -4726.851,
              -6673.846,
              2019.083
            ],
            [
              -4623.743,
              -6706.791,
              2127.325
            ],
            [
              -4568.082,
              -6727.787,
              2186.815
            ],
            [
              -4573.857,
              -6726.575,
              2192.715
            ],
            [
              -4501.892,
              -6735.608,
              2265.245
            ],
            [
              -4485.154,
              -6735.897,
              2281.985
            ],
            [
              -4289.756,
              -6793.82,
              2485.788
            ],
            [
              -4287.979,
              -6802.756,
              2494.899
            ],
            [
              -4293.244,
              -6809.344,
              2503.333
            ],
            [
              -4301.67,
              -6812.538,
              2512.344
            ],
            [
              -4302.229,
              -6844.812,
              2544.623
            ],
            [
              -4305.131,
              -6863.686,
              2563.719
            ],
            [
              -4319.072,
              -6887.936,
              2591.691
            ],
            [
              -4336.232,
              -6912.13,
              2621.352
            ],
            [
              -4338.98,
              -6922.102,
              2631.696
            ],
            [
              -4339.739,
              -6928.768,
              2638.405
            ],
            [
              -4337.924,
              -6935.478,
              2645.357
            ],
            [
              -4317.968,
              -6935.823,
              2665.315
            ],
            [
              -4302.855,
              -6918.273,
              2688.476
            ],
            [
              -4250.009,
              -6841.262,
              2781.875
            ],
            [
              -4210.931,
              -6778.485,
              2855.821
            ],
            [
              -4136.26,
              -6668.457,
              2988.794
            ],
            [
              -4095.853,
              -6603.478,
              3065.313
            ],
            [
              -4041.159,
              -6457.482,
              3221.217
            ],
            [
              -4021.737,
              -6414.403,
              3268.472
            ],
            [
              -3991.253,
              -6364.838,
              3326.662
            ],
            [
              -3967.007,
              -6340.768,
              3360.826
            ],
            [
              -3878.933,
              -6275.505,
              3470.445
            ],
            [
              -3859.174,
              -6250.244,
              3502.515
            ],
            [
              -3803.68,
              -6169.945,
              3600.125
            ],
            [
              -3744.108,
              -6077.471,
              3710.125
            ],
            [
              -3618.634,
              -5899.316,
              3928.031
            ],
            [
              -3485.286,
              -5750.246,
              4128.04
            ],
            [
              -3386.562,
              -5629.518,
              4283.995
            ],
            [
              -3375.968,
              -5613.005,
              4303.614
            ],
            [
              -3246.721,
              -5478.341,
              4490.267
            ],
            [
              -3136.921,
              -5351.132,
              4658.308
            ],
            [
              -3134.15,
              -5340.049,
              4669.733
            ],
            [
              -3152.804,
              -5301.872,
              4712.224
            ],
            [
              -3167.166,
              -5276.016,
              4741.801
            ],
            [
              -3174.738,
              -5266.977,
              4753.592
            ],
            [
              -3216.809,
              -5241.749,
              4802.648
            ],
            [
              -3283.977,
              -5214.968,
              4874.957
            ],
            [
              -3283.763,
              -5202.727,
              4887.201
            ],
            [
              -3277.128,
              -5191.711,
              4900.061
            ],
            [
              -3269.986,
              -5188.496,
              4907.893
            ],
            [
              -3249.554,
              -5198.873,
              4930.808
            ],
            [
              -3237.885,
              -5231.361,
              4965.328
            ],
            [
              -3198.857,
              -5246.517,
              5007.196
            ],
            [
              -3170.932,
              -5270.384,
              5043.93
            ],
            [
              -3134.11,
              -5337.823,
              5120.767
            ],
            [
              -3125.934,
              -5349.099,
              5134.695
            ],
            [
              -3113.758,
              -5352.652,
              5147.379
            ],
            [
              -3083.903,
              -5376.554,
              5185.623
            ],
            [
              -3052.839,
              -5404.93,
              5227.697
            ],
            [
              -3047.2,
              -5413.934,
              5238.322
            ],
            [
              -3034.691,
              -5398.569,
              5258.135
            ],
            [
              -3033.871,
              -5388.564,
              5268.173
            ],
            [
              -2977.67,
              -5306.06,
              5368
            ],
            [
              -2859.092,
              -5120.012,
              5588.624
            ],
            [
              -2789.239,
              -4994.334,
              5732.409
            ],
            [
              -2739.468,
              -4911.72,
              5828.858
            ],
            [
              -2678.162,
              -4832.649,
              5928.911
            ],
            [
              -2610.202,
              -4778.187,
              6016.001
            ],
            [
              -2593.143,
              -4760.677,
              6040.447
            ],
            [
              -2553.828,
              -4686.785,
              6124.147
            ],
            [
              -2531.326,
              -4689.409,
              6146.801
            ],
            [
              -2496.061,
              -4698.938,
              6183.331
            ],
            [
              -2442.961,
              -4719.916,
              6240.425
            ],
            [
              -2407.854,
              -4738.349,
              6280.076
            ],
            [
              -2377.9,
              -4756.69,
              6315.2
            ],
            [
              -2360.748,
              -4770.353,
              6337.129
            ],
            [
              -2299.967,
              -4830.431,
              6422.59
            ],
            [
              -2284.937,
              -4818.452,
              6441.81
            ],
            [
              -2261.864,
              -4788.804,
              6479.378
            ],
            [
              -2249.272,
              -4768.989,
              6502.855
            ],
            [
              -2217.023,
              -4730.598,
              6552.993
            ],
            [
              -2199.094,
              -4664.123,
              6621.844
            ],
            [
              -2245.99,
              -4656.611,
              6669.339
            ],
            [
              -2265.173,
              -4648.479,
              6690.174
            ],
            [
              -2319.72,
              -4636.38,
              6746.047
            ],
            [
              -2647.123,
              -4570.476,
              7080.017
            ],
            [
              -2704.754,
              -4550.534,
              7141
            ],
            [
              -2779.968,
              -4504.68,
              7229.091
            ],
            [
              -2809.985,
              -4489.679,
              7262.646
            ],
            [
              -2836.311,
              -4448.027,
              7311.921
            ],
            [
              -2848.061,
              -4456.725,
              7326.541
            ],
            [
              -2857.722,
              -4456.555,
              7336.203
            ],
            [
              -2897.378,
              -4403.536,
              7402.412
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7615",
              "position": {
                "x": -6372.183,
                "z": -6678.131
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -120,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8445",
              "position": {
                "x": -6222.02,
                "z": -6288.814
              },
              "distanceAlongShapeM": 451.797,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8046",
              "position": {
                "x": -5904.144,
                "z": -6379.903
              },
              "distanceAlongShapeM": 783.072,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:18905",
              "position": {
                "x": -5398.05,
                "z": -6459.748
              },
              "distanceAlongShapeM": 1312.888,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8048",
              "position": {
                "x": -5003.068,
                "z": -6596.745
              },
              "distanceAlongShapeM": 1731.893,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:8043",
              "position": {
                "x": -4623.743,
                "z": -6706.791
              },
              "distanceAlongShapeM": 2127.325,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:18824",
              "position": {
                "x": -4302.229,
                "z": -6844.812
              },
              "distanceAlongShapeM": 2544.623,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:7077",
              "position": {
                "x": -3618.634,
                "z": -5899.316
              },
              "distanceAlongShapeM": 3928.031,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9153",
              "position": {
                "x": -3375.968,
                "z": -5613.005
              },
              "distanceAlongShapeM": 4303.614,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:795",
              "position": {
                "x": -3249.554,
                "z": -5198.873
              },
              "distanceAlongShapeM": 4930.808,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7809",
              "position": {
                "x": -3033.871,
                "z": -5388.564
              },
              "distanceAlongShapeM": 5268.173,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5518",
              "position": {
                "x": -2739.468,
                "z": -4911.72
              },
              "distanceAlongShapeM": 5828.858,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5803",
              "position": {
                "x": -2249.272,
                "z": -4768.989
              },
              "distanceAlongShapeM": 6502.855,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 6669.339,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6766",
              "position": {
                "x": -2809.985,
                "z": -4489.679
              },
              "distanceAlongShapeM": 7262.646,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8275",
              "position": {
                "x": -2897.378,
                "z": -4403.536
              },
              "distanceAlongShapeM": 7402.412,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            }
          ],
          "departuresSeconds": [
            19680,
            20880,
            21720,
            22380,
            23520,
            24000,
            24720,
            25620,
            26400,
            28260,
            34260,
            35880,
            36960,
            38520,
            40080,
            41220,
            42840,
            44400,
            45600,
            47220,
            48600,
            49860,
            51480,
            52860,
            54120,
            55740,
            57120,
            58380,
            59280,
            60120,
            60960,
            61740,
            63120,
            64140,
            65820,
            69060,
            70500,
            71760,
            72960,
            74160,
            75840,
            77280,
            78720,
            80160,
            81600,
            83040,
            84600
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_52:1",
          "sourceRouteId": "vilnius_bus_52",
          "sourceShapeId": "vilnius_bus_52_b-a",
          "directionId": 1,
          "headsign": "Tarandė",
          "directionName": "Pašilaičiai–Ukmergės g.–Tarandė",
          "mode": "bus",
          "routeShortName": "52",
          "routeLongName": "Tarandė–Ukmergės g.–Pašilaičiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2897.378,
              -4403.536,
              0
            ],
            [
              -2891.133,
              -4414.778,
              12.86
            ],
            [
              -2898.042,
              -4404.638,
              25.13
            ],
            [
              -2903.603,
              -4391.181,
              39.691
            ],
            [
              -2903.934,
              -4373.364,
              57.511
            ],
            [
              -2923.723,
              -4326.261,
              108.603
            ],
            [
              -2937.753,
              -4244.749,
              191.313
            ],
            [
              -2944.718,
              -4164.475,
              271.889
            ],
            [
              -2922.72,
              -4159.295,
              294.488
            ],
            [
              -2914.524,
              -4206.195,
              342.098
            ],
            [
              -2913.823,
              -4239.604,
              375.515
            ],
            [
              -2906.681,
              -4273.126,
              409.789
            ],
            [
              -2893.275,
              -4316.777,
              455.453
            ],
            [
              -2874.618,
              -4354.955,
              497.946
            ],
            [
              -2823.799,
              -4432.662,
              590.794
            ],
            [
              -2759.103,
              -4490.576,
              677.625
            ],
            [
              -2701.004,
              -4520.544,
              742.998
            ],
            [
              -2600.594,
              -4562.391,
              851.78
            ],
            [
              -2523.056,
              -4586.026,
              932.839
            ],
            [
              -2471.67,
              -4594.727,
              984.957
            ],
            [
              -2274.597,
              -4634.953,
              1186.093
            ],
            [
              -2190.603,
              -4657.594,
              1273.086
            ],
            [
              -2203.301,
              -4719.709,
              1336.486
            ],
            [
              -2218.687,
              -4751.72,
              1372.002
            ],
            [
              -2222.124,
              -4763.905,
              1384.662
            ],
            [
              -2268.035,
              -4809.846,
              1449.611
            ],
            [
              -2298.015,
              -4829.352,
              1485.378
            ],
            [
              -2351.324,
              -4783.879,
              1555.448
            ],
            [
              -2381.317,
              -4767.762,
              1589.496
            ],
            [
              -2406.02,
              -4743.947,
              1623.81
            ],
            [
              -2443.585,
              -4718.791,
              1669.02
            ],
            [
              -2496.725,
              -4700.04,
              1725.371
            ],
            [
              -2554.472,
              -4686.774,
              1784.622
            ],
            [
              -2573.291,
              -4730.97,
              1832.658
            ],
            [
              -2592.46,
              -4758.462,
              1866.173
            ],
            [
              -2618.048,
              -4784.728,
              1902.843
            ],
            [
              -2673.576,
              -4828.277,
              1973.41
            ],
            [
              -2687.375,
              -4843.619,
              1994.045
            ],
            [
              -2713.178,
              -4882.126,
              2040.399
            ],
            [
              -2770.874,
              -4975.733,
              2150.358
            ],
            [
              -2803.001,
              -5044.187,
              2225.976
            ],
            [
              -2859.092,
              -5120.012,
              2320.292
            ],
            [
              -3038.848,
              -5415.194,
              2665.9
            ],
            [
              -3072.82,
              -5405.692,
              2701.177
            ],
            [
              -3098.772,
              -5379.632,
              2737.955
            ],
            [
              -3115.924,
              -5365.973,
              2759.881
            ],
            [
              -3137.233,
              -5332.202,
              2799.812
            ],
            [
              -3160.824,
              -5281.693,
              2855.559
            ],
            [
              -3174.738,
              -5266.977,
              2875.811
            ],
            [
              -3209.14,
              -5245.223,
              2916.515
            ],
            [
              -3278.903,
              -5219.51,
              2990.865
            ],
            [
              -3282.025,
              -5213.889,
              2997.295
            ],
            [
              -3283.119,
              -5202.738,
              3008.5
            ],
            [
              -3277.85,
              -5196.151,
              3016.935
            ],
            [
              -3271.313,
              -5190.699,
              3025.447
            ],
            [
              -3262.297,
              -5190.857,
              3034.464
            ],
            [
              -3249.554,
              -5198.873,
              3049.518
            ],
            [
              -3223.815,
              -5237.173,
              3095.664
            ],
            [
              -3186.173,
              -5257.871,
              3138.621
            ],
            [
              -3160.161,
              -5280.592,
              3173.159
            ],
            [
              -3134.091,
              -5336.71,
              3235.037
            ],
            [
              -3131.847,
              -5355.674,
              3254.133
            ],
            [
              -3176.747,
              -5418.34,
              3331.225
            ],
            [
              -3341.197,
              -5613.613,
              3586.519
            ],
            [
              -3386.425,
              -5658.464,
              3650.214
            ],
            [
              -3498.767,
              -5784.52,
              3819.066
            ],
            [
              -3580.452,
              -5888.85,
              3951.57
            ],
            [
              -3613.93,
              -5925.003,
              4000.842
            ],
            [
              -3667.305,
              -5994.205,
              4088.237
            ],
            [
              -3747.187,
              -6106.361,
              4225.933
            ],
            [
              -3835.101,
              -6236.191,
              4382.728
            ],
            [
              -4223.914,
              -6821.676,
              5085.557
            ],
            [
              -4263.049,
              -6887.792,
              5162.387
            ],
            [
              -4344.717,
              -6993.248,
              5295.769
            ],
            [
              -4360.032,
              -6985.191,
              5313.073
            ],
            [
              -4347.887,
              -6953.118,
              5347.369
            ],
            [
              -4344.207,
              -6926.464,
              5374.275
            ],
            [
              -4344.052,
              -6842.976,
              5457.764
            ],
            [
              -4346.223,
              -6819.561,
              5481.28
            ],
            [
              -4364.256,
              -6782.513,
              5522.483
            ],
            [
              -4487.787,
              -6739.191,
              5653.39
            ],
            [
              -4534.079,
              -6735.053,
              5699.867
            ],
            [
              -4573.895,
              -6728.8,
              5740.171
            ],
            [
              -4716.684,
              -6681.813,
              5890.493
            ],
            [
              -4732.817,
              -6683.762,
              5906.742
            ],
            [
              -4796.733,
              -6655.947,
              5976.448
            ],
            [
              -5091.073,
              -6584.106,
              6279.429
            ],
            [
              -5462.201,
              -6445.296,
              6675.666
            ],
            [
              -5550.967,
              -6401.483,
              6774.656
            ],
            [
              -5600.255,
              -6383.947,
              6826.971
            ],
            [
              -5647.877,
              -6382.024,
              6874.632
            ],
            [
              -5829.785,
              -6400.087,
              7057.434
            ],
            [
              -5885.757,
              -6396.912,
              7113.496
            ],
            [
              -6249.059,
              -6288.358,
              7492.67
            ],
            [
              -6258.086,
              -6327.168,
              7532.516
            ],
            [
              -6256.261,
              -6371.727,
              7577.112
            ],
            [
              -6261.762,
              -6430.634,
              7636.276
            ],
            [
              -6271.187,
              -6454.965,
              7662.369
            ],
            [
              -6332.99,
              -6568.584,
              7791.709
            ],
            [
              -6449.144,
              -6506.516,
              7923.406
            ],
            [
              -6532.802,
              -6656.505,
              8095.149
            ],
            [
              -6528.371,
              -6661.033,
              8101.484
            ],
            [
              -6411.863,
              -6701.954,
              8224.969
            ],
            [
              -6385.526,
              -6705.736,
              8251.577
            ],
            [
              -6377.008,
              -6696.974,
              8263.797
            ],
            [
              -6372.183,
              -6678.131,
              8283.248
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 342.098,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8268",
              "position": {
                "x": -2701.004,
                "z": -4520.544
              },
              "distanceAlongShapeM": 742.998,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8270",
              "position": {
                "x": -2222.124,
                "z": -4763.905
              },
              "distanceAlongShapeM": 1384.662,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6763",
              "position": {
                "x": -2381.317,
                "z": -4767.762
              },
              "distanceAlongShapeM": 1589.496,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5519",
              "position": {
                "x": -2803.001,
                "z": -5044.187
              },
              "distanceAlongShapeM": 2225.976,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:795",
              "position": {
                "x": -3249.554,
                "z": -5198.873
              },
              "distanceAlongShapeM": 3049.518,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9152",
              "position": {
                "x": -3341.197,
                "z": -5613.613
              },
              "distanceAlongShapeM": 3586.519,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7076",
              "position": {
                "x": -3580.452,
                "z": -5888.85
              },
              "distanceAlongShapeM": 3951.57,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:18904",
              "position": {
                "x": -4364.256,
                "z": -6782.513
              },
              "distanceAlongShapeM": 5522.483,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:8044",
              "position": {
                "x": -4732.817,
                "z": -6683.762
              },
              "distanceAlongShapeM": 5906.742,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:19134",
              "position": {
                "x": -5091.073,
                "z": -6584.106
              },
              "distanceAlongShapeM": 6279.429,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:19136",
              "position": {
                "x": -5462.201,
                "z": -6445.296
              },
              "distanceAlongShapeM": 6675.666,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:19137",
              "position": {
                "x": -5885.757,
                "z": -6396.912
              },
              "distanceAlongShapeM": 7113.496,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8444",
              "position": {
                "x": -6256.261,
                "z": -6371.727
              },
              "distanceAlongShapeM": 7577.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:8447",
              "position": {
                "x": -6522.222,
                "z": -6639.985
              },
              "distanceAlongShapeM": 8075.567,
              "shapeOffsetM": 1.193,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:7615",
              "position": {
                "x": -6372.183,
                "z": -6678.131
              },
              "distanceAlongShapeM": 8283.248,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            21780,
            22980,
            23880,
            24660,
            25920,
            26460,
            27360,
            28260,
            29340,
            30960,
            32280,
            33900,
            35040,
            36600,
            38100,
            39240,
            40800,
            42360,
            43560,
            45240,
            46620,
            47880,
            49500,
            50880,
            52140,
            53760,
            55080,
            56340,
            57240,
            58080,
            58860,
            59640,
            61020,
            62040,
            62880,
            63720,
            64500,
            65880,
            67080,
            68520,
            69840,
            71100,
            72300,
            73980,
            75420,
            76860,
            78300,
            79740,
            81240,
            82800
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_53",
      "sourceRouteId": "vilnius_bus_53",
      "mode": "bus",
      "shortName": "53",
      "longName": "Fabijoniškės–Kalvarijų–Pylimo g.–Stotis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_53:0",
          "sourceRouteId": "vilnius_bus_53",
          "sourceShapeId": "vilnius_bus_53_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Fabijoniškės–Kalvarijų–Pylimo g.–Stotis",
          "mode": "bus",
          "routeShortName": "53",
          "routeLongName": "Fabijoniškės–Kalvarijų–Pylimo g.–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2464.27,
              -5705.856,
              27.473
            ],
            [
              -2454.941,
              -5688.21,
              47.434
            ],
            [
              -2458.022,
              -5680.363,
              55.864
            ],
            [
              -2467.523,
              -5671.289,
              69.002
            ],
            [
              -2484.515,
              -5648.724,
              97.249
            ],
            [
              -2456.526,
              -5595.784,
              157.132
            ],
            [
              -2438.766,
              -5574.947,
              184.511
            ],
            [
              -2323.024,
              -5404.447,
              390.585
            ],
            [
              -2243.521,
              -5280.062,
              538.207
            ],
            [
              -2221.212,
              -5257.08,
              570.237
            ],
            [
              -2172.788,
              -5214.524,
              634.703
            ],
            [
              -2110.315,
              -5178.897,
              706.62
            ],
            [
              -2058.363,
              -5155.329,
              763.669
            ],
            [
              -2028.76,
              -5156.969,
              793.317
            ],
            [
              -1944.865,
              -5148.443,
              877.644
            ],
            [
              -1856.383,
              -5135.547,
              967.061
            ],
            [
              -1800.644,
              -5116.503,
              1025.963
            ],
            [
              -1770.723,
              -5100.339,
              1059.972
            ],
            [
              -1738.711,
              -5075.306,
              1100.609
            ],
            [
              -1710.503,
              -5046.865,
              1140.666
            ],
            [
              -1676.24,
              -5004.061,
              1195.494
            ],
            [
              -1664.171,
              -4977.559,
              1224.615
            ],
            [
              -1657.878,
              -4949.841,
              1253.038
            ],
            [
              -1638.506,
              -4911.224,
              1296.242
            ],
            [
              -1626.337,
              -4879.158,
              1330.54
            ],
            [
              -1604.435,
              -4807.19,
              1405.767
            ],
            [
              -1592.551,
              -4755.08,
              1459.214
            ],
            [
              -1586.265,
              -4691.738,
              1522.867
            ],
            [
              -1583.358,
              -4637.242,
              1577.441
            ],
            [
              -1588.338,
              -4591.511,
              1623.443
            ],
            [
              -1597.362,
              -4555.726,
              1660.348
            ],
            [
              -1598.126,
              -4562.392,
              1667.057
            ],
            [
              -1595.437,
              -4520.137,
              1709.397
            ],
            [
              -1616.287,
              -4244.797,
              1985.526
            ],
            [
              -1631.856,
              -4106.478,
              2124.718
            ],
            [
              -1640.178,
              -4067.366,
              2164.705
            ],
            [
              -1637.064,
              -4037.365,
              2194.868
            ],
            [
              -1635.048,
              -3960.588,
              2271.671
            ],
            [
              -1628.98,
              -3909.488,
              2323.13
            ],
            [
              -1612.999,
              -3808.47,
              2425.404
            ],
            [
              -1543.192,
              -3688.376,
              2564.313
            ],
            [
              -1515.42,
              -3648.796,
              2612.664
            ],
            [
              -1479.438,
              -3582.647,
              2687.966
            ],
            [
              -1461.972,
              -3542.883,
              2731.397
            ],
            [
              -1437.625,
              -3478.752,
              2799.994
            ],
            [
              -1385.229,
              -3323.838,
              2963.529
            ],
            [
              -1372.596,
              -3266.177,
              3022.558
            ],
            [
              -1373.246,
              -3230.542,
              3058.199
            ],
            [
              -1363.568,
              -3193.979,
              3096.021
            ],
            [
              -1359.808,
              -3163.989,
              3126.246
            ],
            [
              -1360.179,
              -3112.774,
              3177.462
            ],
            [
              -1362.723,
              -3074.878,
              3215.443
            ],
            [
              -1386.134,
              -2978.721,
              3314.409
            ],
            [
              -1409.242,
              -2901.495,
              3395.019
            ],
            [
              -1422.254,
              -2872.318,
              3426.966
            ],
            [
              -1430.357,
              -2820.964,
              3478.955
            ],
            [
              -1448.996,
              -2746.044,
              3556.158
            ],
            [
              -1452.909,
              -2712.577,
              3589.853
            ],
            [
              -1453.659,
              -2682.507,
              3619.933
            ],
            [
              -1443.344,
              -2610.331,
              3692.842
            ],
            [
              -1428.471,
              -2571.635,
              3734.298
            ],
            [
              -1415.77,
              -2546.258,
              3762.676
            ],
            [
              -1386.622,
              -2502.251,
              3815.461
            ],
            [
              -1375.913,
              -2480.178,
              3839.994
            ],
            [
              -1324.1,
              -2502.258,
              3896.316
            ],
            [
              -1292.401,
              -2531.77,
              3939.626
            ],
            [
              -1235.733,
              -2570.637,
              4008.342
            ],
            [
              -1150.916,
              -2621.142,
              4107.058
            ],
            [
              -1079.915,
              -2651.362,
              4184.222
            ],
            [
              -1012.681,
              -2675.949,
              4255.811
            ],
            [
              -916.353,
              -2695.496,
              4354.102
            ],
            [
              -830.758,
              -2702.605,
              4439.992
            ],
            [
              -592.882,
              -2700.223,
              4677.879
            ],
            [
              -320.273,
              -2701.823,
              4950.493
            ],
            [
              -192.234,
              -2714.168,
              5079.126
            ],
            [
              12.173,
              -2744.606,
              5285.787
            ],
            [
              30.716,
              -2752.737,
              5306.034
            ],
            [
              144.816,
              -2787.102,
              5425.197
            ],
            [
              177.432,
              -2801.056,
              5460.672
            ],
            [
              222.629,
              -2831.939,
              5515.413
            ],
            [
              331.278,
              -2917.419,
              5653.657
            ],
            [
              357.389,
              -2934.595,
              5684.911
            ],
            [
              386.802,
              -2947.379,
              5716.982
            ],
            [
              425.296,
              -2956.99,
              5756.658
            ],
            [
              460.671,
              -2960.978,
              5792.257
            ],
            [
              505.751,
              -2962.917,
              5837.378
            ],
            [
              502.159,
              -2912.756,
              5887.668
            ],
            [
              509.397,
              -2869.472,
              5931.553
            ],
            [
              513.301,
              -2797.183,
              6003.947
            ],
            [
              494.515,
              -2626.513,
              6175.648
            ],
            [
              482.722,
              -2601.805,
              6203.026
            ],
            [
              485.911,
              -2568.466,
              6236.517
            ],
            [
              462.343,
              -2342.047,
              6464.16
            ],
            [
              451.425,
              -2269.486,
              6537.537
            ],
            [
              407.176,
              -2116.162,
              6697.119
            ],
            [
              406.254,
              -2096.107,
              6717.195
            ],
            [
              361.405,
              -1904.922,
              6913.57
            ],
            [
              342.249,
              -1718.661,
              7100.813
            ],
            [
              324.984,
              -1640.419,
              7180.938
            ],
            [
              326.097,
              -1614.835,
              7206.546
            ],
            [
              277.22,
              -1255.479,
              7569.211
            ],
            [
              271.867,
              -1230.89,
              7594.376
            ],
            [
              265.625,
              -1219.643,
              7607.238
            ],
            [
              267.28,
              -1199.635,
              7627.315
            ],
            [
              254.802,
              -1141.519,
              7686.755
            ],
            [
              216.915,
              -885.896,
              7945.171
            ],
            [
              226.048,
              -703.492,
              8127.803
            ],
            [
              223.795,
              -685.64,
              8145.798
            ],
            [
              209.218,
              -636.391,
              8197.158
            ],
            [
              192.022,
              -589.321,
              8247.271
            ],
            [
              159.237,
              -513.023,
              8330.314
            ],
            [
              151.725,
              -500.641,
              8344.797
            ],
            [
              143.086,
              -479.332,
              8367.791
            ],
            [
              121.213,
              -441.083,
              8411.852
            ],
            [
              106.146,
              -277.163,
              8576.463
            ],
            [
              46.11,
              -280.522,
              8636.593
            ],
            [
              26.146,
              -279.045,
              8656.612
            ],
            [
              15.43,
              -265.491,
              8673.89
            ],
            [
              14.363,
              -253.226,
              8686.201
            ],
            [
              16.439,
              -245.471,
              8694.229
            ],
            [
              45.916,
              -220.403,
              8732.924
            ],
            [
              103.215,
              -190.277,
              8797.66
            ],
            [
              127.382,
              -102.772,
              8888.441
            ],
            [
              121.848,
              -52.576,
              8938.942
            ],
            [
              115.041,
              -36.866,
              8956.063
            ],
            [
              117.583,
              -3.516,
              8989.51
            ],
            [
              102.671,
              133.684,
              9127.518
            ],
            [
              63.181,
              125.497,
              9167.848
            ],
            [
              59.312,
              125.568,
              9171.717
            ],
            [
              57.419,
              127.829,
              9174.666
            ],
            [
              31.786,
              278.582,
              9327.583
            ],
            [
              4.856,
              358.112,
              9411.548
            ],
            [
              -8.924,
              380.627,
              9437.946
            ],
            [
              -39.768,
              422.378,
              9489.854
            ],
            [
              -46.8,
              425.846,
              9497.695
            ],
            [
              -51.212,
              431.492,
              9504.861
            ],
            [
              -51.307,
              497.175,
              9570.543
            ],
            [
              -56,
              522.864,
              9596.658
            ],
            [
              -44.593,
              547.148,
              9623.487
            ],
            [
              -34.25,
              619.32,
              9696.396
            ],
            [
              -34.886,
              726.201,
              9803.28
            ],
            [
              -29.964,
              784,
              9861.287
            ],
            [
              -31.514,
              805.179,
              9882.524
            ],
            [
              -24.076,
              823.969,
              9902.732
            ],
            [
              -6.94,
              914.942,
              9995.305
            ],
            [
              5.94,
              949.218,
              10031.92
            ],
            [
              14.89,
              980.225,
              10064.194
            ],
            [
              17.976,
              1008,
              10092.139
            ],
            [
              98.858,
              1127.869,
              10236.744
            ],
            [
              206.575,
              1304.022,
              10443.222
            ],
            [
              265.611,
              1357.493,
              10522.873
            ],
            [
              347.967,
              1416.104,
              10623.956
            ],
            [
              403.761,
              1468.519,
              10700.509
            ],
            [
              405.778,
              1472.935,
              10705.363
            ],
            [
              396.871,
              1479.777,
              10716.595
            ],
            [
              393.103,
              1485.412,
              10723.373
            ],
            [
              391.311,
              1493.238,
              10731.401
            ],
            [
              394.908,
              1548.834,
              10787.113
            ],
            [
              392.049,
              1568.924,
              10807.406
            ],
            [
              397.453,
              1582.184,
              10821.725
            ],
            [
              391.321,
              1670.242,
              10909.996
            ],
            [
              327.595,
              1819.466,
              11072.257
            ],
            [
              328.524,
              1835.034,
              11087.853
            ],
            [
              355.259,
              1885.754,
              11145.188
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 157.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 763.669,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5813",
              "position": {
                "x": -1657.878,
                "z": -4949.841
              },
              "distanceAlongShapeM": 1253.038,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6917",
              "position": {
                "x": -1597.362,
                "z": -4555.726
              },
              "distanceAlongShapeM": 1660.348,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6921",
              "position": {
                "x": -1640.178,
                "z": -4067.366
              },
              "distanceAlongShapeM": 2164.705,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6924",
              "position": {
                "x": -1612.999,
                "z": -3808.47
              },
              "distanceAlongShapeM": 2425.404,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6928",
              "position": {
                "x": -1373.246,
                "z": -3230.542
              },
              "distanceAlongShapeM": 3058.199,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6933",
              "position": {
                "x": -1422.254,
                "z": -2872.318
              },
              "distanceAlongShapeM": 3426.966,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7017",
              "position": {
                "x": -1324.1,
                "z": -2502.258
              },
              "distanceAlongShapeM": 3896.316,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5080",
              "position": {
                "x": 12.173,
                "z": -2744.606
              },
              "distanceAlongShapeM": 5285.787,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5481",
              "position": {
                "x": 502.159,
                "z": -2912.756
              },
              "distanceAlongShapeM": 5887.668,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 6203.026,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 6697.119,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 7180.938,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 7607.238,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 8411.852,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 8956.063,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 9596.658,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 10092.139,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 10443.222,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 10807.406,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:7573",
              "position": {
                "x": 355.259,
                "z": 1885.754
              },
              "distanceAlongShapeM": 11145.188,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            19680,
            21720,
            22260,
            22860,
            23400,
            23940,
            24480,
            24960,
            25560,
            26160,
            26820,
            27720,
            28560,
            29460,
            30300,
            30900,
            31500,
            32280,
            32760,
            33480,
            34080,
            35460,
            36900,
            38040,
            38640,
            39240,
            39840,
            40500,
            41160,
            41940,
            42780,
            43440,
            44100,
            44760,
            45420,
            46140,
            46860,
            47520,
            48240,
            49020,
            49740,
            50520,
            51300,
            51960,
            52620,
            53280,
            53940,
            54780,
            55620,
            56400,
            57240,
            57720,
            58200,
            58680,
            59160,
            59760,
            60360,
            61080,
            61800,
            62640,
            63540,
            64740,
            66000,
            66600,
            67200,
            67920,
            68640,
            69960,
            70800,
            71580,
            72360,
            73140,
            73920,
            74640,
            75240,
            75840,
            76380,
            77160,
            77940,
            78780,
            79920,
            82380,
            83400
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_53:1",
          "sourceRouteId": "vilnius_bus_53",
          "sourceShapeId": "vilnius_bus_53_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės",
          "directionName": "Stotis–Pylimo–Kalvarijų g.–Fabijoniškės",
          "mode": "bus",
          "routeShortName": "53",
          "routeLongName": "Fabijoniškės–Kalvarijų–Pylimo g.–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              355.259,
              1885.754,
              0
            ],
            [
              392.313,
              1936.286,
              62.662
            ],
            [
              391.729,
              1939.636,
              66.062
            ],
            [
              372.202,
              1965.597,
              98.547
            ],
            [
              357.795,
              1989.238,
              126.233
            ],
            [
              356.647,
              1997.052,
              134.13
            ],
            [
              359.39,
              2005.908,
              143.401
            ],
            [
              369.268,
              2016.86,
              158.15
            ],
            [
              380.898,
              2017.76,
              169.815
            ],
            [
              389.202,
              2013.156,
              179.31
            ],
            [
              477.214,
              1956.998,
              283.712
            ],
            [
              484.77,
              1946.84,
              296.372
            ],
            [
              483.983,
              1939.062,
              304.19
            ],
            [
              476.08,
              1930.301,
              315.988
            ],
            [
              460.458,
              1922.794,
              333.321
            ],
            [
              416.68,
              1928.048,
              377.412
            ],
            [
              398.6,
              1927.265,
              395.509
            ],
            [
              339.428,
              1831.495,
              508.084
            ],
            [
              330.657,
              1810.504,
              530.834
            ],
            [
              391.321,
              1670.242,
              683.653
            ],
            [
              473.433,
              1574.115,
              810.076
            ],
            [
              482.238,
              1561.708,
              825.29
            ],
            [
              479.414,
              1548.401,
              838.893
            ],
            [
              472.7,
              1534.052,
              854.736
            ],
            [
              453.691,
              1517.701,
              879.809
            ],
            [
              360.424,
              1427.008,
              1009.901
            ],
            [
              315.899,
              1391.085,
              1067.111
            ],
            [
              256.42,
              1348.755,
              1140.114
            ],
            [
              223.566,
              1315.958,
              1186.537
            ],
            [
              196.476,
              1280.829,
              1230.899
            ],
            [
              149.248,
              1202.651,
              1322.235
            ],
            [
              55.081,
              1061.873,
              1491.604
            ],
            [
              52.802,
              1042.989,
              1510.624
            ],
            [
              42.322,
              1034.274,
              1524.254
            ],
            [
              29.685,
              1013.353,
              1548.696
            ],
            [
              17.226,
              966.824,
              1596.864
            ],
            [
              -2.949,
              921.549,
              1646.431
            ],
            [
              -20.167,
              826.124,
              1743.396
            ],
            [
              -26.358,
              769.462,
              1800.396
            ],
            [
              -34.886,
              726.201,
              1844.489
            ],
            [
              -34.25,
              619.32,
              1951.373
            ],
            [
              -49.15,
              509.381,
              2062.317
            ],
            [
              -51.111,
              437.057,
              2134.668
            ],
            [
              -46.759,
              428.072,
              2144.651
            ],
            [
              -39.768,
              422.378,
              2153.667
            ],
            [
              18.234,
              348.963,
              2247.23
            ],
            [
              36.62,
              260.682,
              2337.405
            ],
            [
              56.855,
              132.292,
              2467.38
            ],
            [
              59.373,
              128.907,
              2471.599
            ],
            [
              70.978,
              128.695,
              2483.206
            ],
            [
              102.671,
              133.684,
              2515.289
            ],
            [
              116.145,
              94.475,
              2556.749
            ],
            [
              129.88,
              -107.271,
              2758.961
            ],
            [
              116.846,
              -256.206,
              2908.466
            ],
            [
              117.887,
              -305.208,
              2957.478
            ],
            [
              127.989,
              -387.771,
              3040.658
            ],
            [
              138.319,
              -422.47,
              3076.861
            ],
            [
              150.182,
              -443.837,
              3101.301
            ],
            [
              177.186,
              -518.917,
              3181.089
            ],
            [
              237.149,
              -695.903,
              3367.957
            ],
            [
              238.113,
              -713.732,
              3385.812
            ],
            [
              217.158,
              -872.542,
              3545.999
            ],
            [
              276.82,
              -1242.113,
              3920.354
            ],
            [
              297.35,
              -1318.188,
              3999.151
            ],
            [
              320.249,
              -1546.82,
              4228.927
            ],
            [
              342.249,
              -1718.661,
              4402.171
            ],
            [
              356.237,
              -1764.56,
              4450.154
            ],
            [
              354.758,
              -1810.175,
              4495.793
            ],
            [
              356.121,
              -1841.371,
              4527.019
            ],
            [
              372.957,
              -1942.984,
              4630.017
            ],
            [
              426.379,
              -2158.817,
              4852.363
            ],
            [
              441.836,
              -2194.724,
              4891.455
            ],
            [
              440.947,
              -2208.066,
              4904.827
            ],
            [
              462.343,
              -2342.047,
              5040.506
            ],
            [
              505.139,
              -2574.385,
              5276.753
            ],
            [
              511.756,
              -2776.003,
              5478.479
            ],
            [
              520.913,
              -2874.136,
              5577.038
            ],
            [
              522.633,
              -2920.924,
              5623.858
            ],
            [
              521.572,
              -2978.793,
              5681.736
            ],
            [
              442.304,
              -2978.453,
              5761.005
            ],
            [
              342.529,
              -2936.549,
              5869.222
            ],
            [
              249.744,
              -2864.719,
              5986.562
            ],
            [
              215.338,
              -2842.938,
              6027.283
            ],
            [
              172.556,
              -2821.005,
              6075.36
            ],
            [
              116.826,
              -2802.176,
              6134.184
            ],
            [
              -65.348,
              -2754.326,
              6322.537
            ],
            [
              -121.383,
              -2752.193,
              6378.613
            ],
            [
              -224.17,
              -2733.625,
              6483.064
            ],
            [
              -312.321,
              -2725.345,
              6571.603
            ],
            [
              -534.611,
              -2721.315,
              6793.93
            ],
            [
              -763.526,
              -2727.196,
              7022.92
            ],
            [
              -847.912,
              -2724.56,
              7107.347
            ],
            [
              -963.025,
              -2710.24,
              7223.347
            ],
            [
              -1021.438,
              -2696.943,
              7283.254
            ],
            [
              -1084.241,
              -2676.889,
              7349.182
            ],
            [
              -1158.443,
              -2645.498,
              7429.751
            ],
            [
              -1247.226,
              -2600.488,
              7529.292
            ],
            [
              -1307.096,
              -2560.451,
              7601.314
            ],
            [
              -1372.805,
              -2522.537,
              7677.177
            ],
            [
              -1385.067,
              -2523.43,
              7689.473
            ],
            [
              -1401.734,
              -2554.302,
              7724.556
            ],
            [
              -1428.63,
              -2580.538,
              7762.129
            ],
            [
              -1442.374,
              -2628.16,
              7811.695
            ],
            [
              -1451.022,
              -2679.214,
              7863.476
            ],
            [
              -1448.996,
              -2746.044,
              7930.337
            ],
            [
              -1403.403,
              -2899.373,
              8090.3
            ],
            [
              -1382.255,
              -2942.054,
              8137.934
            ],
            [
              -1380.84,
              -2971.023,
              8166.938
            ],
            [
              -1362.723,
              -3074.878,
              8272.361
            ],
            [
              -1357.098,
              -3120.622,
              8318.449
            ],
            [
              -1356.687,
              -3169.611,
              8367.44
            ],
            [
              -1363.762,
              -3240.731,
              8438.911
            ],
            [
              -1372.45,
              -3294.01,
              8492.894
            ],
            [
              -1372.145,
              -3312.94,
              8511.827
            ],
            [
              -1386.916,
              -3346.073,
              8548.103
            ],
            [
              -1441.889,
              -3500.94,
              8712.437
            ],
            [
              -1479.438,
              -3582.647,
              8802.359
            ],
            [
              -1526.789,
              -3671.971,
              8903.458
            ],
            [
              -1572.531,
              -3743.513,
              8988.373
            ],
            [
              -1605.428,
              -3817.511,
              9069.354
            ],
            [
              -1619.047,
              -3858.457,
              9112.506
            ],
            [
              -1621.258,
              -3874.003,
              9128.208
            ],
            [
              -1622.014,
              -3916.292,
              9170.504
            ],
            [
              -1630.122,
              -3937.298,
              9193.021
            ],
            [
              -1635.048,
              -3960.588,
              9216.826
            ],
            [
              -1633.18,
              -4036.321,
              9292.582
            ],
            [
              -1621.037,
              -4150.087,
              9406.994
            ],
            [
              -1612.338,
              -4168.054,
              9426.956
            ],
            [
              -1616.287,
              -4244.797,
              9503.8
            ],
            [
              -1593.127,
              -4499.027,
              9759.083
            ],
            [
              -1582.077,
              -4601.642,
              9862.291
            ],
            [
              -1574.54,
              -4648.532,
              9909.784
            ],
            [
              -1585.129,
              -4736.288,
              9998.176
            ],
            [
              -1597.975,
              -4806.192,
              10069.25
            ],
            [
              -1623.216,
              -4884.78,
              10151.792
            ],
            [
              -1642.847,
              -4937.864,
              10208.39
            ],
            [
              -1696.959,
              -5045.994,
              10329.304
            ],
            [
              -1793.54,
              -5115.517,
              10448.305
            ],
            [
              -1840.927,
              -5135.823,
              10499.86
            ],
            [
              -1875.217,
              -5144.118,
              10535.138
            ],
            [
              -1904.939,
              -5149.154,
              10565.284
            ],
            [
              -2065.02,
              -5167.456,
              10726.408
            ],
            [
              -2110.315,
              -5178.897,
              10773.126
            ],
            [
              -2127.276,
              -5190.841,
              10793.87
            ],
            [
              -2143.028,
              -5207.26,
              10816.623
            ],
            [
              -2175.503,
              -5222.268,
              10852.398
            ],
            [
              -2204.955,
              -5248.463,
              10891.814
            ],
            [
              -2230.543,
              -5274.726,
              10928.482
            ],
            [
              -2374.125,
              -5489.26,
              11186.63
            ],
            [
              -2484.515,
              -5648.724,
              11380.575
            ],
            [
              -2512.326,
              -5691.648,
              11431.721
            ],
            [
              -2513.285,
              -5709.442,
              11449.542
            ],
            [
              -2528.468,
              -5730.325,
              11475.361
            ],
            [
              -2529.407,
              -5747.007,
              11492.069
            ],
            [
              -2525.623,
              -5751.527,
              11497.964
            ],
            [
              -2510.288,
              -5758.477,
              11514.801
            ],
            [
              -2498.658,
              -5756.456,
              11526.604
            ],
            [
              -2480.761,
              -5727.829,
              11560.365
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5156",
              "position": {
                "x": 389.202,
                "z": 2013.156
              },
              "distanceAlongShapeM": 179.31,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 854.736,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1510.624,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 1800.396,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 2247.23,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 2556.749,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 3101.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 3999.151,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 4450.154,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 4891.455,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 5276.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5131",
              "position": {
                "x": 442.304,
                "z": -2978.453
              },
              "distanceAlongShapeM": 5761.005,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8463",
              "position": {
                "x": -121.383,
                "z": -2752.193
              },
              "distanceAlongShapeM": 6378.613,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:3512",
              "position": {
                "x": -1401.734,
                "z": -2554.302
              },
              "distanceAlongShapeM": 7724.556,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6934",
              "position": {
                "x": -1382.255,
                "z": -2942.054
              },
              "distanceAlongShapeM": 8137.934,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6929",
              "position": {
                "x": -1372.145,
                "z": -3312.94
              },
              "distanceAlongShapeM": 8511.827,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6926",
              "position": {
                "x": -1622.014,
                "z": -3916.292
              },
              "distanceAlongShapeM": 9170.504,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6922",
              "position": {
                "x": -1612.338,
                "z": -4168.054
              },
              "distanceAlongShapeM": 9426.956,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6918",
              "position": {
                "x": -1574.54,
                "z": -4648.532
              },
              "distanceAlongShapeM": 9909.784,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 10329.304,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 10816.623,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 11449.542,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            }
          ],
          "departuresSeconds": [
            19740,
            20880,
            22200,
            23580,
            24300,
            25020,
            25740,
            26280,
            26880,
            27480,
            28080,
            28620,
            29160,
            29760,
            30660,
            31560,
            32400,
            33240,
            33900,
            34500,
            35280,
            35880,
            36480,
            37260,
            38460,
            39720,
            40860,
            41460,
            42120,
            42780,
            43440,
            44160,
            44880,
            45600,
            46320,
            47040,
            47760,
            48480,
            49140,
            49800,
            50520,
            51420,
            52260,
            52980,
            53700,
            54420,
            55140,
            55860,
            56460,
            57120,
            57840,
            58560,
            59340,
            60180,
            60720,
            61260,
            61800,
            62340,
            62880,
            63420,
            64140,
            64860,
            65760,
            66660,
            67740,
            68880,
            69540,
            70260,
            70980,
            71760,
            72720,
            73680,
            74580,
            75480,
            76620,
            77820,
            78600,
            79200,
            79980,
            81060,
            81660,
            82800,
            84960,
            86160
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_54",
      "sourceRouteId": "vilnius_bus_54",
      "mode": "bus",
      "shortName": "54",
      "longName": "Pilaitė–Lazdynai–Stotis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_54:0",
          "sourceRouteId": "vilnius_bus_54",
          "sourceShapeId": "vilnius_bus_54_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Pilaitė–Lazdynai–Stotis",
          "mode": "bus",
          "routeShortName": "54",
          "routeLongName": "Pilaitė–Lazdynai–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6804.479,
              -1529.023,
              0
            ],
            [
              -6810.019,
              -1513.345,
              16.627
            ],
            [
              -6803.426,
              -1504.55,
              27.62
            ],
            [
              -6797.569,
              -1501.308,
              34.313
            ],
            [
              -6795.561,
              -1496.889,
              39.167
            ],
            [
              -6804.801,
              -1471.131,
              66.532
            ],
            [
              -6817.871,
              -1443.083,
              97.476
            ],
            [
              -6849.755,
              -1383.551,
              165.008
            ],
            [
              -6863.711,
              -1369.96,
              184.489
            ],
            [
              -6868.44,
              -1344.278,
              210.603
            ],
            [
              -6866.432,
              -1339.858,
              215.457
            ],
            [
              -6856.69,
              -1335.568,
              226.102
            ],
            [
              -6848.367,
              -1339.047,
              235.122
            ],
            [
              -6837.763,
              -1360.375,
              258.94
            ],
            [
              -6823.318,
              -1421.841,
              322.082
            ],
            [
              -6723.821,
              -1601.615,
              527.553
            ],
            [
              -6711.23,
              -1619.637,
              549.537
            ],
            [
              -6684.251,
              -1702.465,
              636.648
            ],
            [
              -6676.395,
              -1733.766,
              668.92
            ],
            [
              -6677.514,
              -1993.121,
              928.277
            ],
            [
              -6672.243,
              -2063.34,
              998.694
            ],
            [
              -6676.454,
              -2314.851,
              1250.241
            ],
            [
              -6640.332,
              -2313.23,
              1286.399
            ],
            [
              -6613.194,
              -2309.232,
              1313.83
            ],
            [
              -6575.914,
              -2315.423,
              1351.621
            ],
            [
              -6380.632,
              -2316.474,
              1546.906
            ],
            [
              -6294.875,
              -2314.577,
              1632.684
            ],
            [
              -6220.641,
              -2308.034,
              1707.206
            ],
            [
              -6201.86,
              -2302.785,
              1726.706
            ],
            [
              -6171.35,
              -2289.941,
              1759.81
            ],
            [
              -6126.719,
              -2280.674,
              1805.393
            ],
            [
              -6104.034,
              -2273.265,
              1829.257
            ],
            [
              -5924.643,
              -2185.012,
              2029.181
            ],
            [
              -5877.169,
              -2160.211,
              2082.742
            ],
            [
              -5847.188,
              -2140.681,
              2118.524
            ],
            [
              -5795.942,
              -2121.511,
              2173.238
            ],
            [
              -5568.568,
              -2017.388,
              2423.319
            ],
            [
              -5236.974,
              -1850.486,
              2794.548
            ],
            [
              -5169.837,
              -1807.104,
              2874.482
            ],
            [
              -5127.302,
              -1769.981,
              2930.938
            ],
            [
              -5012.864,
              -1637.24,
              3106.199
            ],
            [
              -4831.761,
              -1414.361,
              3393.38
            ],
            [
              -4761.883,
              -1362.126,
              3480.624
            ],
            [
              -4704.97,
              -1314.122,
              3555.078
            ],
            [
              -4653.804,
              -1300.53,
              3608.018
            ],
            [
              -4405.208,
              -1203.507,
              3874.877
            ],
            [
              -4296.995,
              -1171.977,
              3987.59
            ],
            [
              -4247.02,
              -1152.802,
              4041.117
            ],
            [
              -4191.003,
              -1157.11,
              4097.3
            ],
            [
              -3912.099,
              -1135.223,
              4377.061
            ],
            [
              -3759.013,
              -1118.956,
              4531.009
            ],
            [
              -3705.284,
              -1106.532,
              4586.156
            ],
            [
              -3657.704,
              -1114.039,
              4634.325
            ],
            [
              -3680.758,
              -1067.996,
              4685.817
            ],
            [
              -3686.114,
              -1042.299,
              4712.066
            ],
            [
              -3720.918,
              -930.373,
              4829.279
            ],
            [
              -3751.541,
              -837.444,
              4927.123
            ],
            [
              -3761.526,
              -818.346,
              4948.674
            ],
            [
              -3766.218,
              -791.548,
              4975.88
            ],
            [
              -3793.988,
              -719.82,
              5052.796
            ],
            [
              -3843.779,
              -616.54,
              5167.451
            ],
            [
              -3881.258,
              -546.871,
              5246.562
            ],
            [
              -3968.98,
              -399.519,
              5418.048
            ],
            [
              -3986.683,
              -379.175,
              5445.017
            ],
            [
              -3999.719,
              -350.005,
              5476.966
            ],
            [
              -4048.201,
              -282.373,
              5560.181
            ],
            [
              -4133.499,
              -180.709,
              5692.888
            ],
            [
              -4196.245,
              -117.285,
              5782.106
            ],
            [
              -4221.08,
              -99.045,
              5812.92
            ],
            [
              -4243.751,
              -67.483,
              5851.779
            ],
            [
              -4402.336,
              85.535,
              6072.151
            ],
            [
              -4449.086,
              142,
              6145.458
            ],
            [
              -4479.797,
              193.736,
              6205.623
            ],
            [
              -4502.905,
              237.549,
              6255.156
            ],
            [
              -4519.036,
              274.562,
              6295.532
            ],
            [
              -4536.228,
              324.952,
              6348.773
            ],
            [
              -4547.048,
              370.78,
              6395.861
            ],
            [
              -4566.578,
              510.266,
              6536.707
            ],
            [
              -4574.501,
              537.119,
              6564.705
            ],
            [
              -4575.517,
              590.57,
              6618.166
            ],
            [
              -4579.623,
              651.866,
              6679.6
            ],
            [
              -4586.366,
              709.869,
              6737.993
            ],
            [
              -4584.541,
              741.007,
              6769.184
            ],
            [
              -4573.306,
              794.248,
              6823.598
            ],
            [
              -4555.909,
              830.684,
              6863.974
            ],
            [
              -4554.237,
              852.919,
              6886.272
            ],
            [
              -4568.699,
              912.168,
              6947.26
            ],
            [
              -4567.748,
              929.963,
              6965.08
            ],
            [
              -4555.854,
              946.456,
              6985.415
            ],
            [
              -4510.16,
              977.953,
              7040.913
            ],
            [
              -4440.575,
              860.983,
              7177.016
            ],
            [
              -4425.036,
              789.47,
              7250.197
            ],
            [
              -4406.248,
              756.864,
              7287.83
            ],
            [
              -4380.992,
              725.259,
              7328.286
            ],
            [
              -4355.565,
              703.67,
              7361.642
            ],
            [
              -4324.219,
              688.657,
              7396.398
            ],
            [
              -4302.372,
              683.828,
              7418.772
            ],
            [
              -4269.507,
              682.148,
              7451.68
            ],
            [
              -4233.908,
              689.326,
              7487.995
            ],
            [
              -4200.071,
              706.552,
              7525.965
            ],
            [
              -4154.906,
              744.734,
              7585.107
            ],
            [
              -4134.494,
              768.872,
              7616.718
            ],
            [
              -4089.107,
              782.559,
              7664.124
            ],
            [
              -4026.001,
              813.75,
              7734.517
            ],
            [
              -3968.169,
              838.352,
              7797.365
            ],
            [
              -3939.526,
              853.44,
              7829.739
            ],
            [
              -3921.201,
              868.708,
              7853.59
            ],
            [
              -3904.031,
              891.787,
              7882.357
            ],
            [
              -3887.976,
              924.905,
              7919.161
            ],
            [
              -3883.393,
              966.014,
              7960.525
            ],
            [
              -3887.876,
              1005.054,
              7999.821
            ],
            [
              -3903.754,
              1056.537,
              8053.697
            ],
            [
              -3916.285,
              1077.905,
              8078.468
            ],
            [
              -3919.363,
              1123.6,
              8124.266
            ],
            [
              -3949.447,
              1248.8,
              8253.03
            ],
            [
              -3955.799,
              1254.476,
              8261.549
            ],
            [
              -3966.06,
              1257.993,
              8272.396
            ],
            [
              -4052.898,
              1235.006,
              8362.225
            ],
            [
              -4088.424,
              1232.281,
              8397.855
            ],
            [
              -4119.34,
              1235.042,
              8428.894
            ],
            [
              -4215.081,
              1256.734,
              8527.062
            ],
            [
              -4241.916,
              1271.669,
              8557.773
            ],
            [
              -4268.203,
              1281.028,
              8585.676
            ],
            [
              -4527.979,
              1404.616,
              8873.352
            ],
            [
              -4558.781,
              1414.051,
              8905.567
            ],
            [
              -4581.673,
              1433.369,
              8935.52
            ],
            [
              -4718.251,
              1519.203,
              9096.831
            ],
            [
              -4838.028,
              1606.973,
              9245.324
            ],
            [
              -4906.917,
              1690.529,
              9353.616
            ],
            [
              -4962.228,
              1738.229,
              9426.655
            ],
            [
              -5070.177,
              1876.997,
              9602.466
            ],
            [
              -5277.196,
              2033.034,
              9861.704
            ],
            [
              -5274.521,
              2038.555,
              9867.839
            ],
            [
              -5253.123,
              2044.87,
              9890.149
            ],
            [
              -5249.139,
              2051.481,
              9897.868
            ],
            [
              -5249.689,
              2057.056,
              9903.471
            ],
            [
              -5238.402,
              2075.788,
              9925.34
            ],
            [
              -5197.9,
              2105.154,
              9975.368
            ],
            [
              -5149.809,
              2125.485,
              10027.58
            ],
            [
              -5115.548,
              2129.353,
              10062.059
            ],
            [
              -5117.029,
              2042.549,
              10148.876
            ],
            [
              -4759.188,
              2066.486,
              10507.517
            ],
            [
              -4628.554,
              2084.282,
              10639.357
            ],
            [
              -4532.335,
              2089.308,
              10735.708
            ],
            [
              -4413.578,
              2091.718,
              10854.489
            ],
            [
              -4171.807,
              2044.134,
              11100.898
            ],
            [
              -4056.112,
              2018.757,
              11219.343
            ],
            [
              -4034.827,
              2018.389,
              11240.631
            ],
            [
              -4018.212,
              2009.195,
              11259.62
            ],
            [
              -3691.362,
              1920.037,
              11598.412
            ],
            [
              -3598.621,
              1910.632,
              11691.629
            ],
            [
              -3547.649,
              1910.858,
              11742.602
            ],
            [
              -3479.107,
              1919.683,
              11811.71
            ],
            [
              -3376.715,
              1945.728,
              11917.362
            ],
            [
              -3255.325,
              1988.136,
              12045.946
            ],
            [
              -3211.057,
              2010.74,
              12095.651
            ],
            [
              -3076.57,
              2064.047,
              12240.318
            ],
            [
              -3025.322,
              2079.847,
              12293.946
            ],
            [
              -2969.481,
              2100.019,
              12353.319
            ],
            [
              -2931.778,
              2116.056,
              12394.291
            ],
            [
              -2890.752,
              2137.6,
              12440.63
            ],
            [
              -2705.632,
              2207.819,
              12638.62
            ],
            [
              -2695.312,
              2207.637,
              12648.942
            ],
            [
              -2620.644,
              2234.153,
              12728.177
            ],
            [
              -2602.113,
              2260.544,
              12760.424
            ],
            [
              -2588.136,
              2284.788,
              12788.409
            ],
            [
              -2571.13,
              2297.847,
              12809.851
            ],
            [
              -2549.022,
              2307.476,
              12833.964
            ],
            [
              -2532.153,
              2312.745,
              12851.637
            ],
            [
              -2506.977,
              2313.414,
              12876.822
            ],
            [
              -2483.854,
              2307.44,
              12900.704
            ],
            [
              -2455.846,
              2285.795,
              12936.102
            ],
            [
              -2438.355,
              2253.203,
              12973.091
            ],
            [
              -2433.47,
              2237.532,
              12989.506
            ],
            [
              -2436.603,
              2169.681,
              13057.429
            ],
            [
              -2432.988,
              2155.146,
              13072.407
            ],
            [
              -2421.673,
              2138.248,
              13092.744
            ],
            [
              -2405.237,
              2119.033,
              13118.029
            ],
            [
              -2339.12,
              2063.317,
              13204.491
            ],
            [
              -2328.352,
              2051.995,
              13220.117
            ],
            [
              -2313.635,
              2045.055,
              13236.387
            ],
            [
              -2298.509,
              2024.75,
              13261.707
            ],
            [
              -1944.941,
              1697.877,
              13743.222
            ],
            [
              -1868.675,
              1633.068,
              13843.305
            ],
            [
              -1860.469,
              1622.903,
              13856.369
            ],
            [
              -1769.084,
              1537.785,
              13981.254
            ],
            [
              -1703.649,
              1480.959,
              14067.92
            ],
            [
              -1688.349,
              1470.667,
              14086.359
            ],
            [
              -1678.973,
              1453.802,
              14105.656
            ],
            [
              -1503.095,
              1295.926,
              14341.998
            ],
            [
              -1427.428,
              1234.46,
              14439.485
            ],
            [
              -1409.124,
              1211.868,
              14468.561
            ],
            [
              -1353.311,
              1158.548,
              14545.75
            ],
            [
              -1207.93,
              1027.923,
              14741.194
            ],
            [
              -1188.159,
              1015.323,
              14764.639
            ],
            [
              -1173.062,
              993.901,
              14790.846
            ],
            [
              -1066.972,
              902.938,
              14930.594
            ],
            [
              -958.695,
              862.029,
              15046.341
            ],
            [
              -807.377,
              811.436,
              15205.892
            ],
            [
              -797.848,
              839.095,
              15235.147
            ],
            [
              -793.638,
              857.944,
              15254.46
            ],
            [
              -767.948,
              887.538,
              15293.649
            ],
            [
              -708.773,
              1021.171,
              15439.798
            ],
            [
              -697.048,
              1063.262,
              15483.492
            ],
            [
              -655.787,
              1240.633,
              15665.599
            ],
            [
              -656.233,
              1287.397,
              15712.365
            ],
            [
              -631.67,
              1361.539,
              15790.47
            ],
            [
              -586.657,
              1567.786,
              16001.572
            ],
            [
              -585.791,
              1580.016,
              16013.832
            ],
            [
              -535.917,
              1805.1,
              16244.375
            ],
            [
              -530.013,
              1846.182,
              16285.88
            ],
            [
              -524.047,
              1854.98,
              16296.51
            ],
            [
              -516.247,
              1858.179,
              16304.94
            ],
            [
              -490.609,
              1848.809,
              16332.236
            ],
            [
              -470.051,
              1843.985,
              16353.354
            ],
            [
              -432.32,
              1825.49,
              16395.373
            ],
            [
              -327.19,
              1787.963,
              16507
            ],
            [
              -259.046,
              1774.482,
              16576.465
            ],
            [
              -147.106,
              1756.865,
              16689.783
            ],
            [
              9.981,
              1738.424,
              16847.948
            ],
            [
              41.02,
              1742.312,
              16879.23
            ],
            [
              63.816,
              1754.143,
              16904.913
            ],
            [
              135.751,
              1771.757,
              16978.973
            ],
            [
              319.251,
              1821.845,
              17169.186
            ],
            [
              341.2,
              1822.557,
              17191.147
            ],
            [
              378.73,
              1828.551,
              17229.153
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 258.94,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 549.537,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8067",
              "position": {
                "x": -6672.243,
                "z": -2063.34
              },
              "distanceAlongShapeM": 998.694,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7951",
              "position": {
                "x": -6613.194,
                "z": -2309.232
              },
              "distanceAlongShapeM": 1313.83,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7949",
              "position": {
                "x": -6171.35,
                "z": -2289.941
              },
              "distanceAlongShapeM": 1759.81,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8069",
              "position": {
                "x": -5847.188,
                "z": -2140.681
              },
              "distanceAlongShapeM": 2118.524,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 3555.078,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 4041.117,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 4685.817,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 4948.674,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 5445.017,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 5812.92,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 6564.705,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 7616.718,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 8078.468,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 8527.062,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 8905.567,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 9245.324,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6350",
              "position": {
                "x": -4413.578,
                "z": 2091.718
              },
              "distanceAlongShapeM": 10854.489,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6352",
              "position": {
                "x": -4034.827,
                "z": 2018.389
              },
              "distanceAlongShapeM": 11240.631,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 12638.62,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 13236.387,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 13843.305,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 14439.485,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 14764.639,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5266",
              "position": {
                "x": -793.638,
                "z": 857.944
              },
              "distanceAlongShapeM": 15254.46,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5272",
              "position": {
                "x": -656.233,
                "z": 1287.397
              },
              "distanceAlongShapeM": 15712.365,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 16353.354,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 16904.913,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:16581",
              "position": {
                "x": 378.73,
                "z": 1828.551
              },
              "distanceAlongShapeM": 17229.153,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            }
          ],
          "departuresSeconds": [
            17820,
            19200,
            20760,
            22620,
            24180,
            25920,
            27900,
            30180,
            33960,
            36180,
            38280,
            40440,
            41580,
            43500,
            45540,
            47640,
            49020,
            50880,
            52920,
            54960,
            56280,
            58440,
            60720,
            63180,
            66660,
            69060,
            71040,
            73140,
            74520,
            76140,
            78180,
            80040
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_54:1",
          "sourceRouteId": "vilnius_bus_54",
          "sourceShapeId": "vilnius_bus_54_b-a",
          "directionId": 1,
          "headsign": "Pilaitė",
          "directionName": "Stotis–Lazdynai–Pilaitė",
          "mode": "bus",
          "routeShortName": "54",
          "routeLongName": "Pilaitė–Lazdynai–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              378.73,
              1828.551,
              0
            ],
            [
              561.04,
              1848.593,
              183.408
            ],
            [
              586.961,
              1854.797,
              210.061
            ],
            [
              594.26,
              1865.796,
              223.261
            ],
            [
              591.157,
              1872.532,
              230.678
            ],
            [
              474.708,
              1925.873,
              358.762
            ],
            [
              453.987,
              1921.799,
              379.88
            ],
            [
              419.803,
              1922.424,
              414.07
            ],
            [
              403.74,
              1926.058,
              430.539
            ],
            [
              397.229,
              1922.837,
              437.803
            ],
            [
              334.106,
              1822.687,
              556.187
            ],
            [
              318.606,
              1821.856,
              571.708
            ],
            [
              29.934,
              1735.835,
              872.925
            ],
            [
              -11.424,
              1732.135,
              914.448
            ],
            [
              -46.755,
              1740.57,
              950.772
            ],
            [
              -320.217,
              1781.157,
              1227.229
            ],
            [
              -515.259,
              1841.463,
              1431.382
            ],
            [
              -529.526,
              1766.021,
              1508.16
            ],
            [
              -536.862,
              1752.795,
              1523.285
            ],
            [
              -542.324,
              1736.195,
              1540.76
            ],
            [
              -678.532,
              1124.155,
              2167.773
            ],
            [
              -679.739,
              1093.006,
              2198.945
            ],
            [
              -691.829,
              1066.507,
              2228.072
            ],
            [
              -722.413,
              980.227,
              2319.612
            ],
            [
              -796.476,
              807.9,
              2507.181
            ],
            [
              -803.749,
              798.012,
              2519.456
            ],
            [
              -958.695,
              862.029,
              2687.106
            ],
            [
              -1066.972,
              902.938,
              2802.853
            ],
            [
              -1103.368,
              923.63,
              2844.72
            ],
            [
              -1148.452,
              963.402,
              2904.84
            ],
            [
              -1168.303,
              971.551,
              2926.298
            ],
            [
              -1183.42,
              991.86,
              2951.615
            ],
            [
              -1484.246,
              1267.759,
              3359.802
            ],
            [
              -1502.183,
              1274.758,
              3379.057
            ],
            [
              -1524.902,
              1302.995,
              3415.298
            ],
            [
              -1970.62,
              1705.012,
              4015.534
            ],
            [
              -1985.783,
              1723.093,
              4039.131
            ],
            [
              -2263.842,
              1978.495,
              4416.685
            ],
            [
              -2290.557,
              2000.118,
              4451.055
            ],
            [
              -2318.992,
              2034.018,
              4495.3
            ],
            [
              -2425.036,
              2130.514,
              4638.677
            ],
            [
              -2441.629,
              2140.826,
              4658.214
            ],
            [
              -2464.869,
              2140.123,
              4681.464
            ],
            [
              -2491.57,
              2126.123,
              4711.613
            ],
            [
              -2503.239,
              2122.989,
              4723.696
            ],
            [
              -2528.453,
              2120.094,
              4749.075
            ],
            [
              -2543.249,
              2122.581,
              4764.079
            ],
            [
              -2561.836,
              2129.588,
              4783.943
            ],
            [
              -2579.681,
              2142.148,
              4805.765
            ],
            [
              -2607.297,
              2186.05,
              4857.63
            ],
            [
              -2618.809,
              2191.819,
              4870.507
            ],
            [
              -2640.075,
              2193.306,
              4891.825
            ],
            [
              -2665.388,
              2184.846,
              4918.514
            ],
            [
              -2681.67,
              2176.227,
              4936.936
            ],
            [
              -2690.837,
              2168.596,
              4948.864
            ],
            [
              -2745.273,
              2155.082,
              5004.952
            ],
            [
              -2858.912,
              2113.664,
              5125.904
            ],
            [
              -2885.494,
              2106.338,
              5153.477
            ],
            [
              -2963.852,
              2089.902,
              5233.541
            ],
            [
              -3175.505,
              2014.571,
              5458.2
            ],
            [
              -3269.787,
              1972.804,
              5561.319
            ],
            [
              -3463.705,
              1914.962,
              5763.679
            ],
            [
              -3534.885,
              1902.843,
              5835.884
            ],
            [
              -3642.009,
              1901.368,
              5943.018
            ],
            [
              -3703.185,
              1907.997,
              6004.552
            ],
            [
              -3763.581,
              1922.405,
              6066.643
            ],
            [
              -4034.529,
              1998.346,
              6348.032
            ],
            [
              -4082.845,
              2002.521,
              6396.529
            ],
            [
              -4108.472,
              2012.983,
              6424.208
            ],
            [
              -4294.183,
              2056.264,
              6614.897
            ],
            [
              -4414.529,
              2073.923,
              6736.531
            ],
            [
              -4474.572,
              2071.617,
              6796.618
            ],
            [
              -4495.173,
              2074.198,
              6817.381
            ],
            [
              -4714.759,
              2061.271,
              7037.347
            ],
            [
              -4881.095,
              2030.725,
              7206.464
            ],
            [
              -4920.175,
              2009.13,
              7251.114
            ],
            [
              -4946.317,
              1989.54,
              7283.782
            ],
            [
              -5070.177,
              1876.997,
              7451.135
            ],
            [
              -4961.259,
              1757.137,
              7613.09
            ],
            [
              -4928.804,
              1730.978,
              7654.774
            ],
            [
              -4906.917,
              1690.529,
              7700.766
            ],
            [
              -4767.773,
              1565.694,
              7887.701
            ],
            [
              -4739.606,
              1552.966,
              7918.611
            ],
            [
              -4712.351,
              1524.668,
              7957.899
            ],
            [
              -4596.2,
              1451.429,
              8095.213
            ],
            [
              -4491.296,
              1399.532,
              8212.252
            ],
            [
              -4466.279,
              1391.309,
              8238.586
            ],
            [
              -4443.995,
              1374.227,
              8266.663
            ],
            [
              -4243.678,
              1281.718,
              8487.31
            ],
            [
              -4197.987,
              1275.363,
              8533.44
            ],
            [
              -4179.458,
              1265.024,
              8554.658
            ],
            [
              -4137.695,
              1255.397,
              8597.517
            ],
            [
              -4093.256,
              1251.289,
              8642.146
            ],
            [
              -4041.607,
              1253.735,
              8693.852
            ],
            [
              -3953.633,
              1267.797,
              8782.943
            ],
            [
              -3919.363,
              1123.6,
              8931.156
            ],
            [
              -3889.289,
              1035.135,
              9024.593
            ],
            [
              -3876.172,
              1010.417,
              9052.576
            ],
            [
              -3879.245,
              944.791,
              9118.274
            ],
            [
              -3881.411,
              931.47,
              9131.769
            ],
            [
              -3897.582,
              891.676,
              9174.724
            ],
            [
              -3911.432,
              874.104,
              9197.098
            ],
            [
              -3948.102,
              842.457,
              9245.536
            ],
            [
              -4089.107,
              782.559,
              9398.735
            ],
            [
              -4161.662,
              727.04,
              9490.095
            ],
            [
              -4175.491,
              710.581,
              9511.593
            ],
            [
              -4216.46,
              691.251,
              9556.893
            ],
            [
              -4255.417,
              676.338,
              9598.607
            ],
            [
              -4279.313,
              674.524,
              9622.571
            ],
            [
              -4304.422,
              677.184,
              9647.821
            ],
            [
              -4330.724,
              685.43,
              9675.385
            ],
            [
              -4370.887,
              712.839,
              9724.009
            ],
            [
              -4391.801,
              734.351,
              9754.011
            ],
            [
              -4418.25,
              771.542,
              9799.649
            ],
            [
              -4423.862,
              782.771,
              9812.202
            ],
            [
              -4434.785,
              785.185,
              9823.389
            ],
            [
              -4479.393,
              779.274,
              9868.386
            ],
            [
              -4503.366,
              773.007,
              9893.164
            ],
            [
              -4524.836,
              762.245,
              9917.181
            ],
            [
              -4546.478,
              741.466,
              9947.184
            ],
            [
              -4558.582,
              712.731,
              9978.364
            ],
            [
              -4562.872,
              688.314,
              10003.155
            ],
            [
              -4562.176,
              653.793,
              10037.683
            ],
            [
              -4542.083,
              471.996,
              10220.587
            ],
            [
              -4530.426,
              437.286,
              10257.202
            ],
            [
              -4533.311,
              419.524,
              10275.197
            ],
            [
              -4527.744,
              368.221,
              10326.801
            ],
            [
              -4516.259,
              323.495,
              10372.977
            ],
            [
              -4491.638,
              255.166,
              10445.607
            ],
            [
              -4427.619,
              152.763,
              10566.375
            ],
            [
              -4367.011,
              77.134,
              10663.294
            ],
            [
              -4077.229,
              -208.399,
              11070.113
            ],
            [
              -3954.469,
              -380.846,
              11281.792
            ],
            [
              -3921.604,
              -419.265,
              11332.35
            ],
            [
              -3917.323,
              -432.698,
              11346.449
            ],
            [
              -3857.936,
              -540.596,
              11469.611
            ],
            [
              -3823.641,
              -607.984,
              11545.223
            ],
            [
              -3766.483,
              -732.543,
              11682.271
            ],
            [
              -3707.64,
              -908.34,
              11867.654
            ],
            [
              -3695.741,
              -928.584,
              11891.137
            ],
            [
              -3679.35,
              -950.021,
              11918.121
            ],
            [
              -3673.878,
              -969.04,
              11937.913
            ],
            [
              -3654.555,
              -1007.226,
              11980.709
            ],
            [
              -3618.236,
              -1069.084,
              12052.441
            ],
            [
              -3593.482,
              -1128.516,
              12116.822
            ],
            [
              -3583.125,
              -1163.206,
              12153.025
            ],
            [
              -3584.647,
              -1176.538,
              12166.443
            ],
            [
              -3588.728,
              -1188.712,
              12179.283
            ],
            [
              -3593.981,
              -1194.186,
              12186.87
            ],
            [
              -3599.82,
              -1196.311,
              12193.085
            ],
            [
              -3626.266,
              -1196.964,
              12219.538
            ],
            [
              -3688.025,
              -1189.21,
              12281.782
            ],
            [
              -3714.785,
              -1170.933,
              12314.188
            ],
            [
              -3768.733,
              -1158.863,
              12369.47
            ],
            [
              -3858.305,
              -1156.194,
              12459.081
            ],
            [
              -4237.967,
              -1188.581,
              12840.122
            ],
            [
              -4268.356,
              -1193.623,
              12870.927
            ],
            [
              -4294.993,
              -1205.408,
              12900.055
            ],
            [
              -4333.704,
              -1206.966,
              12938.796
            ],
            [
              -4364.15,
              -1215.347,
              12970.375
            ],
            [
              -4597.068,
              -1300.392,
              13218.333
            ],
            [
              -4637.998,
              -1318.612,
              13263.136
            ],
            [
              -4714.189,
              -1362.945,
              13351.286
            ],
            [
              -4755.992,
              -1394.51,
              13403.668
            ],
            [
              -4809.036,
              -1442.581,
              13475.254
            ],
            [
              -4834.84,
              -1481.101,
              13521.617
            ],
            [
              -5092.18,
              -1789.506,
              13923.286
            ],
            [
              -5145.16,
              -1834.242,
              13992.627
            ],
            [
              -5263.682,
              -1904.577,
              14130.447
            ],
            [
              -5341.696,
              -1943.323,
              14217.553
            ],
            [
              -5353.315,
              -1944.238,
              14229.208
            ],
            [
              -5858.685,
              -2210.618,
              14800.485
            ],
            [
              -5880.858,
              -2225.828,
              14827.373
            ],
            [
              -6049.087,
              -2302.022,
              15012.053
            ],
            [
              -6102.245,
              -2320.049,
              15068.184
            ],
            [
              -6166.945,
              -2334.543,
              15134.488
            ],
            [
              -6282.493,
              -2344.842,
              15250.494
            ],
            [
              -6377.159,
              -2339.91,
              15345.288
            ],
            [
              -6675.557,
              -2338.243,
              15643.691
            ],
            [
              -6689.755,
              -2262.309,
              15720.942
            ],
            [
              -6668.455,
              -1991.046,
              15993.039
            ],
            [
              -6680.407,
              -1819.414,
              16165.087
            ],
            [
              -6680.925,
              -1734.803,
              16249.7
            ],
            [
              -6684.251,
              -1702.465,
              16282.209
            ],
            [
              -6705.09,
              -1676.513,
              16315.492
            ],
            [
              -6747.127,
              -1568.943,
              16430.983
            ],
            [
              -6771.666,
              -1532.911,
              16474.578
            ],
            [
              -6834.733,
              -1410.519,
              16612.263
            ],
            [
              -6863.711,
              -1369.96,
              16662.11
            ],
            [
              -6868.44,
              -1344.278,
              16688.224
            ],
            [
              -6866.432,
              -1339.858,
              16693.078
            ],
            [
              -6856.69,
              -1335.568,
              16703.723
            ],
            [
              -6848.367,
              -1339.047,
              16712.744
            ],
            [
              -6837.763,
              -1360.375,
              16736.562
            ],
            [
              -6825.084,
              -1411.793,
              16789.521
            ],
            [
              -6801.411,
              -1461.169,
              16844.278
            ],
            [
              -6771.957,
              -1511.755,
              16902.814
            ],
            [
              -6765.128,
              -1527.454,
              16919.934
            ],
            [
              -6769.807,
              -1537.394,
              16930.92
            ],
            [
              -6777.653,
              -1543.942,
              16941.139
            ],
            [
              -6839.38,
              -1572.967,
              17009.35
            ],
            [
              -6855.566,
              -1577.15,
              17026.068
            ],
            [
              -6863.189,
              -1570.343,
              17036.287
            ],
            [
              -6866.907,
              -1561.375,
              17045.995
            ],
            [
              -6864.843,
              -1553.618,
              17054.023
            ],
            [
              -6804.479,
              -1529.023,
              17119.205
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3590",
              "position": {
                "x": 419.803,
                "z": 1922.424
              },
              "distanceAlongShapeM": 414.07,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 914.448,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5168",
              "position": {
                "x": -529.526,
                "z": 1766.021
              },
              "distanceAlongShapeM": 1508.16,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 2198.945,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 2926.298,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 3379.057,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 4015.534,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 4451.055,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 4948.864,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6353",
              "position": {
                "x": -4082.845,
                "z": 2002.521
              },
              "distanceAlongShapeM": 6396.529,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6351",
              "position": {
                "x": -4474.572,
                "z": 2071.617
              },
              "distanceAlongShapeM": 6796.618,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 7654.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:783",
              "position": {
                "x": -4739.606,
                "z": 1552.966
              },
              "distanceAlongShapeM": 7918.611,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:3589",
              "position": {
                "x": -4466.279,
                "z": 1391.309
              },
              "distanceAlongShapeM": 8238.586,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6317",
              "position": {
                "x": -4197.987,
                "z": 1275.363
              },
              "distanceAlongShapeM": 8533.44,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 9052.576,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 9511.593,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 10257.202,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 11070.113,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 11332.35,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 11918.121,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 12281.782,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 12900.055,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:8060",
              "position": {
                "x": -4834.84,
                "z": -1481.101
              },
              "distanceAlongShapeM": 13521.617,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:7947",
              "position": {
                "x": -5880.858,
                "z": -2225.828
              },
              "distanceAlongShapeM": 14827.373,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:7948",
              "position": {
                "x": -6282.493,
                "z": -2344.842
              },
              "distanceAlongShapeM": 15250.494,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:7959",
              "position": {
                "x": -6689.755,
                "z": -2262.309
              },
              "distanceAlongShapeM": 15720.942,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 16315.492,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 16662.11,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            }
          ],
          "departuresSeconds": [
            20760,
            22440,
            24240,
            26400,
            27960,
            30240,
            32340,
            34440,
            37560,
            39660,
            41760,
            43980,
            45180,
            46920,
            49020,
            51120,
            52500,
            54480,
            56520,
            58680,
            60180,
            62460,
            64740,
            67020,
            70500,
            72540,
            74520,
            76560,
            77940,
            79440,
            81480,
            83220
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_55",
      "sourceRouteId": "vilnius_bus_55",
      "mode": "bus",
      "shortName": "55",
      "longName": "Šiltnamių g.–Laisvės pr.–Fabijoniškės–Santariškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_55:0",
          "sourceRouteId": "vilnius_bus_55",
          "sourceShapeId": "vilnius_bus_55_a-b",
          "directionId": 0,
          "headsign": "Santariškės",
          "directionName": "Šiltnamių g.–Laisvės pr.–Fabijoniškės–Santariškės",
          "mode": "bus",
          "routeShortName": "55",
          "routeLongName": "Šiltnamių g.–Laisvės pr.–Fabijoniškės–Santariškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3606.234,
              2437.31,
              0
            ],
            [
              -3633.836,
              2445.583,
              28.815
            ],
            [
              -3763.252,
              2424.454,
              159.944
            ],
            [
              -3801.465,
              2416.211,
              199.036
            ],
            [
              -3851.875,
              2411.52,
              249.664
            ],
            [
              -3886.236,
              2402.097,
              285.294
            ],
            [
              -3907.032,
              2393.551,
              307.777
            ],
            [
              -3968.552,
              2343.41,
              387.143
            ],
            [
              -4006.465,
              2315.123,
              434.445
            ],
            [
              -4077.678,
              2264.034,
              522.089
            ],
            [
              -4113.54,
              2242.39,
              563.975
            ],
            [
              -4156.496,
              2220.868,
              612.021
            ],
            [
              -4324.119,
              2153.629,
              792.628
            ],
            [
              -4374.718,
              2137.803,
              845.644
            ],
            [
              -4407.025,
              2135.02,
              878.071
            ],
            [
              -4518.062,
              2131.364,
              989.168
            ],
            [
              -4577.307,
              2137.949,
              1048.778
            ],
            [
              -4634.125,
              2135.585,
              1105.645
            ],
            [
              -4816.04,
              2099.743,
              1291.057
            ],
            [
              -4855.442,
              2097.078,
              1330.549
            ],
            [
              -4917.969,
              2100.374,
              1393.163
            ],
            [
              -4969.474,
              2106.821,
              1445.07
            ],
            [
              -5079.485,
              2125.398,
              1556.638
            ],
            [
              -5115.548,
              2129.353,
              1592.918
            ],
            [
              -5151.175,
              2121.056,
              1629.498
            ],
            [
              -5168.571,
              2122.465,
              1646.951
            ],
            [
              -5186.062,
              2118.311,
              1664.929
            ],
            [
              -5204.976,
              2106.388,
              1687.287
            ],
            [
              -5218.73,
              2094.377,
              1705.547
            ],
            [
              -5232.085,
              2067.888,
              1735.212
            ],
            [
              -5234.987,
              2049.013,
              1754.309
            ],
            [
              -5232.767,
              2027.825,
              1775.613
            ],
            [
              -5229.106,
              2015.517,
              1788.454
            ],
            [
              -5217.174,
              1996.39,
              1810.998
            ],
            [
              -5203.212,
              1982.793,
              1830.487
            ],
            [
              -5082.26,
              1887.222,
              1984.64
            ],
            [
              -5064.922,
              1882.473,
              2002.617
            ],
            [
              -5060.085,
              1863.466,
              2022.229
            ],
            [
              -4961.259,
              1757.137,
              2167.393
            ],
            [
              -4928.804,
              1730.978,
              2209.077
            ],
            [
              -4906.917,
              1690.529,
              2255.069
            ],
            [
              -4952.35,
              1636.759,
              2325.464
            ],
            [
              -4966.71,
              1626.986,
              2342.834
            ],
            [
              -4976.574,
              1616.023,
              2357.581
            ],
            [
              -4993.932,
              1581.81,
              2395.945
            ],
            [
              -4999.643,
              1549.625,
              2428.633
            ],
            [
              -5000.423,
              1503.997,
              2474.268
            ],
            [
              -4985.973,
              1443.638,
              2536.333
            ],
            [
              -4965.718,
              1383.179,
              2600.094
            ],
            [
              -4931.334,
              1319.138,
              2672.782
            ],
            [
              -4880.829,
              1254.822,
              2754.558
            ],
            [
              -4857.956,
              1234.393,
              2785.226
            ],
            [
              -4834.931,
              1222.866,
              2810.975
            ],
            [
              -4813.463,
              1195.782,
              2845.536
            ],
            [
              -4785.375,
              1178.602,
              2878.461
            ],
            [
              -4668.299,
              1122.047,
              3008.481
            ],
            [
              -4620.374,
              1095.621,
              3063.209
            ],
            [
              -4574.442,
              1065.888,
              3117.925
            ],
            [
              -4540.743,
              1037.479,
              3162.001
            ],
            [
              -4444.368,
              865.501,
              3359.142
            ],
            [
              -4435.059,
              844.19,
              3382.398
            ],
            [
              -4426.154,
              799.508,
              3427.958
            ],
            [
              -4427.673,
              786.176,
              3441.377
            ],
            [
              -4431.619,
              781.791,
              3447.275
            ],
            [
              -4460.655,
              781.178,
              3476.318
            ],
            [
              -4494.281,
              776.19,
              3510.311
            ],
            [
              -4520.265,
              765.505,
              3538.407
            ],
            [
              -4539.27,
              748.021,
              3564.231
            ],
            [
              -4555.148,
              724.917,
              3592.265
            ],
            [
              -4560.765,
              698.297,
              3619.472
            ],
            [
              -4562.176,
              653.793,
              3663.998
            ],
            [
              -4542.083,
              471.996,
              3846.902
            ],
            [
              -4530.426,
              437.286,
              3883.517
            ],
            [
              -4533.311,
              419.524,
              3901.512
            ],
            [
              -4527.744,
              368.221,
              3953.116
            ],
            [
              -4516.259,
              323.495,
              3999.293
            ],
            [
              -4491.638,
              255.166,
              4071.922
            ],
            [
              -4427.619,
              152.763,
              4192.69
            ],
            [
              -4367.011,
              77.134,
              4289.609
            ],
            [
              -4077.229,
              -208.399,
              4696.428
            ],
            [
              -3954.469,
              -380.846,
              4908.107
            ],
            [
              -3921.604,
              -419.265,
              4958.665
            ],
            [
              -3917.323,
              -432.698,
              4972.764
            ],
            [
              -3857.936,
              -540.596,
              5095.926
            ],
            [
              -3823.641,
              -607.984,
              5171.538
            ],
            [
              -3766.483,
              -732.543,
              5308.586
            ],
            [
              -3707.64,
              -908.34,
              5493.969
            ],
            [
              -3695.741,
              -928.584,
              5517.452
            ],
            [
              -3679.35,
              -950.021,
              5544.436
            ],
            [
              -3673.878,
              -969.04,
              5564.228
            ],
            [
              -3654.555,
              -1007.226,
              5607.024
            ],
            [
              -3618.236,
              -1069.084,
              5678.756
            ],
            [
              -3599.031,
              -1113.947,
              5727.557
            ],
            [
              -3569.469,
              -1193.5,
              5812.425
            ],
            [
              -3554.873,
              -1243.849,
              5864.847
            ],
            [
              -3543.073,
              -1269.659,
              5893.226
            ],
            [
              -3520.478,
              -1415.883,
              6041.186
            ],
            [
              -3500.646,
              -1498.607,
              6126.254
            ],
            [
              -3461.302,
              -1608.388,
              6242.872
            ],
            [
              -3438.975,
              -1658.872,
              6298.073
            ],
            [
              -3418.974,
              -1694.844,
              6339.232
            ],
            [
              -3409.362,
              -1735.088,
              6380.607
            ],
            [
              -3353.575,
              -1899.704,
              6554.42
            ],
            [
              -3340.35,
              -1954.483,
              6610.772
            ],
            [
              -3339.232,
              -2037.994,
              6694.29
            ],
            [
              -3345.53,
              -2177.035,
              6833.475
            ],
            [
              -3368.406,
              -2305.768,
              6964.224
            ],
            [
              -3372.034,
              -2365.819,
              7024.384
            ],
            [
              -3365.898,
              -2420.473,
              7079.382
            ],
            [
              -3338.206,
              -2495.543,
              7159.396
            ],
            [
              -3294.464,
              -2574.233,
              7249.427
            ],
            [
              -3256.485,
              -2613.86,
              7304.315
            ],
            [
              -3240.415,
              -2653.104,
              7346.722
            ],
            [
              -3181.544,
              -2750.984,
              7460.942
            ],
            [
              -3157.274,
              -2800.391,
              7515.988
            ],
            [
              -3108.891,
              -2944.844,
              7668.329
            ],
            [
              -3088.313,
              -3020.904,
              7747.123
            ],
            [
              -3080.894,
              -3038.845,
              7766.538
            ],
            [
              -3066.407,
              -3094.76,
              7824.299
            ],
            [
              -3053.229,
              -3115.03,
              7848.476
            ],
            [
              -3044.503,
              -3168.617,
              7902.769
            ],
            [
              -2983.753,
              -3378.969,
              8121.718
            ],
            [
              -2968.741,
              -3404.837,
              8151.626
            ],
            [
              -2964.33,
              -3447.216,
              8194.234
            ],
            [
              -2935.834,
              -3585.756,
              8335.675
            ],
            [
              -2926.739,
              -3654.936,
              8405.449
            ],
            [
              -2914.467,
              -3799.87,
              8550.902
            ],
            [
              -2906.719,
              -3835.629,
              8587.491
            ],
            [
              -2909.141,
              -3863.417,
              8615.385
            ],
            [
              -2921.12,
              -4178.248,
              8930.443
            ],
            [
              -2914.524,
              -4206.195,
              8959.157
            ],
            [
              -2913.823,
              -4239.604,
              8992.574
            ],
            [
              -2906.681,
              -4273.126,
              9026.848
            ],
            [
              -2893.275,
              -4316.777,
              9072.512
            ],
            [
              -2874.618,
              -4354.955,
              9115.005
            ],
            [
              -2845.793,
              -4401.104,
              9169.416
            ],
            [
              -2823.799,
              -4432.662,
              9207.882
            ],
            [
              -2759.103,
              -4490.576,
              9294.712
            ],
            [
              -2701.004,
              -4520.544,
              9360.086
            ],
            [
              -2600.594,
              -4562.391,
              9468.867
            ],
            [
              -2523.056,
              -4586.026,
              9549.927
            ],
            [
              -2471.67,
              -4594.727,
              9602.045
            ],
            [
              -2274.597,
              -4634.953,
              9803.181
            ],
            [
              -2190.603,
              -4657.594,
              9890.173
            ],
            [
              -2134.709,
              -4666.379,
              9946.753
            ],
            [
              -2111.82,
              -4683.484,
              9975.327
            ],
            [
              -2099.157,
              -4695.955,
              9993.1
            ],
            [
              -2067.351,
              -4718.784,
              10032.251
            ],
            [
              -2007.683,
              -4768.827,
              10110.127
            ],
            [
              -1998.706,
              -4771.214,
              10119.415
            ],
            [
              -1979.306,
              -4767.106,
              10139.245
            ],
            [
              -1961.313,
              -4769.653,
              10157.418
            ],
            [
              -1950.602,
              -4783.202,
              10174.689
            ],
            [
              -1941.516,
              -4815.647,
              10208.383
            ],
            [
              -1918.262,
              -4848.345,
              10248.506
            ],
            [
              -1854.05,
              -4896.245,
              10328.616
            ],
            [
              -1743.848,
              -4966.117,
              10459.103
            ],
            [
              -1676.24,
              -5004.061,
              10536.63
            ],
            [
              -1625.643,
              -5020.551,
              10589.846
            ],
            [
              -1586.957,
              -5054.639,
              10641.409
            ],
            [
              -1465.895,
              -5129.166,
              10783.571
            ],
            [
              -1407.208,
              -5161.388,
              10850.522
            ],
            [
              -1338.038,
              -5183.78,
              10923.226
            ],
            [
              -1271.325,
              -5199.449,
              10991.755
            ],
            [
              -1246.49,
              -5215.481,
              11021.314
            ],
            [
              -1208.756,
              -5230.63,
              11061.976
            ],
            [
              -1099.904,
              -5267.098,
              11176.775
            ],
            [
              -1057.683,
              -5283.443,
              11222.049
            ],
            [
              -933.839,
              -5345.789,
              11360.701
            ],
            [
              -826.661,
              -5403.385,
              11482.374
            ],
            [
              -674.33,
              -5492.97,
              11659.095
            ],
            [
              -589.373,
              -5532.358,
              11752.738
            ],
            [
              -565.267,
              -5552.833,
              11784.366
            ],
            [
              -421.759,
              -5631.135,
              11947.847
            ],
            [
              -383.93,
              -5640.727,
              11986.873
            ],
            [
              -342.157,
              -5645.939,
              12028.969
            ],
            [
              -257.182,
              -5648.596,
              12113.986
            ],
            [
              -196.756,
              -5655.261,
              12174.778
            ],
            [
              -180.177,
              -5664.469,
              12193.743
            ],
            [
              -177.18,
              -5676.769,
              12206.403
            ],
            [
              -185.798,
              -5725.595,
              12255.983
            ],
            [
              -185.377,
              -5737.848,
              12268.244
            ],
            [
              -196.91,
              -5769.923,
              12302.329
            ],
            [
              -201.665,
              -5818.819,
              12351.455
            ],
            [
              -201.086,
              -5857.793,
              12390.434
            ],
            [
              -195.599,
              -5910.215,
              12443.142
            ],
            [
              -136.015,
              -6175.138,
              12714.683
            ],
            [
              -122.378,
              -6204.331,
              12746.904
            ],
            [
              -123.468,
              -6228.802,
              12771.4
            ],
            [
              -113.557,
              -6285.758,
              12829.211
            ],
            [
              -58.166,
              -6532.794,
              13082.381
            ],
            [
              -46.468,
              -6597.576,
              13148.211
            ],
            [
              -39.377,
              -6667.839,
              13218.831
            ],
            [
              -35.045,
              -6748.072,
              13299.181
            ],
            [
              -27.041,
              -6768.256,
              13320.894
            ],
            [
              -16.965,
              -6780.686,
              13336.895
            ],
            [
              0.233,
              -6791.019,
              13356.958
            ],
            [
              10.168,
              -6811.238,
              13379.487
            ],
            [
              11.151,
              -6827.955,
              13396.232
            ],
            [
              7.024,
              -6842.352,
              13411.209
            ],
            [
              -10.864,
              -6869.857,
              13444.019
            ],
            [
              -21.671,
              -6897.49,
              13473.691
            ],
            [
              -10.612,
              -6926.637,
              13504.865
            ],
            [
              -9.853,
              -6955.595,
              13533.833
            ],
            [
              6.027,
              -7144.023,
              13722.929
            ],
            [
              16.38,
              -7176.496,
              13757.013
            ],
            [
              9.978,
              -7209.777,
              13790.903
            ],
            [
              38.024,
              -7507.525,
              14089.97
            ],
            [
              44.494,
              -7541.041,
              14124.104
            ],
            [
              46.371,
              -7614.549,
              14197.637
            ],
            [
              74.723,
              -7859.981,
              14444.701
            ],
            [
              84.573,
              -7884.653,
              14471.266
            ],
            [
              83.096,
              -7930.269,
              14516.906
            ],
            [
              87.139,
              -8026.082,
              14612.805
            ],
            [
              96.148,
              -8132.005,
              14719.11
            ],
            [
              107.811,
              -8233.524,
              14821.297
            ],
            [
              118.182,
              -8264.884,
              14854.327
            ],
            [
              113.324,
              -8319.345,
              14909.004
            ],
            [
              119.934,
              -8345.07,
              14935.565
            ],
            [
              130.007,
              -8357.5,
              14951.564
            ],
            [
              136.801,
              -8373.21,
              14968.68
            ],
            [
              136.732,
              -8412.172,
              15007.642
            ],
            [
              134.097,
              -8415.464,
              15011.859
            ],
            [
              123.699,
              -8420.84,
              15023.564
            ],
            [
              117.305,
              -8418.496,
              15030.374
            ],
            [
              114.812,
              -8413.998,
              15035.517
            ],
            [
              112.767,
              -8385.016,
              15064.571
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9965",
              "position": {
                "x": -3606.234,
                "z": 2437.31
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -900,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6387",
              "position": {
                "x": -4156.496,
                "z": 2220.868
              },
              "distanceAlongShapeM": 612.021,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6381",
              "position": {
                "x": -4518.062,
                "z": 2131.364
              },
              "distanceAlongShapeM": 989.168,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:756",
              "position": {
                "x": -5151.175,
                "z": 2121.056
              },
              "distanceAlongShapeM": 1629.498,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7350",
              "position": {
                "x": -4952.35,
                "z": 1636.759
              },
              "distanceAlongShapeM": 2325.464,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:329",
              "position": {
                "x": -4834.931,
                "z": 1222.866
              },
              "distanceAlongShapeM": 2810.975,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:4395",
              "position": {
                "x": -4540.743,
                "z": 1037.479
              },
              "distanceAlongShapeM": 3162.001,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 3883.517,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 4696.428,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 4958.665,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 5544.436,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 5893.226,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5722",
              "position": {
                "x": -3418.974,
                "z": -1694.844
              },
              "distanceAlongShapeM": 6339.232,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6472",
              "position": {
                "x": -3345.53,
                "z": -2177.035
              },
              "distanceAlongShapeM": 6833.475,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6651",
              "position": {
                "x": -3256.485,
                "z": -2613.86
              },
              "distanceAlongShapeM": 7304.315,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 7848.476,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6479",
              "position": {
                "x": -2968.741,
                "z": -3404.837
              },
              "distanceAlongShapeM": 8151.626,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 8587.491,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 8959.157,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8268",
              "position": {
                "x": -2701.004,
                "z": -4520.544
              },
              "distanceAlongShapeM": 9360.086,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5804",
              "position": {
                "x": -2134.709,
                "z": -4666.379
              },
              "distanceAlongShapeM": 9946.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5808",
              "position": {
                "x": -1961.313,
                "z": -4769.653
              },
              "distanceAlongShapeM": 10157.418,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 10589.846,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 10991.755,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 11482.374,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 11752.738,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 12268.244,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 12746.904,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 13504.865,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 13757.013,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:8716",
              "position": {
                "x": 44.494,
                "z": -7541.041
              },
              "distanceAlongShapeM": 14124.104,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:7826",
              "position": {
                "x": 84.573,
                "z": -7884.653
              },
              "distanceAlongShapeM": 14471.266,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:16649",
              "position": {
                "x": 118.182,
                "z": -8264.884
              },
              "distanceAlongShapeM": 14854.327,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            }
          ],
          "departuresSeconds": [
            18420,
            20100,
            21780,
            23820,
            25560,
            27480,
            29400,
            31200,
            32580,
            34920,
            36660,
            38220,
            39780,
            42600,
            45540,
            47640,
            50280,
            52860,
            54960,
            56760,
            58320,
            59940,
            61560,
            63180,
            65340,
            67500,
            68880,
            70320,
            72900,
            75000,
            77280,
            79560,
            81780
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_55:1",
          "sourceRouteId": "vilnius_bus_55",
          "sourceShapeId": "vilnius_bus_55_b-a",
          "directionId": 1,
          "headsign": "Šiltnamių g.",
          "directionName": "Santariškės–Fabijoniškės–Laisvės pr.–Šiltnamių g.",
          "mode": "bus",
          "routeShortName": "55",
          "routeLongName": "Šiltnamių g.–Laisvės pr.–Fabijoniškės–Santariškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              112.767,
              -8385.016,
              0
            ],
            [
              113.12,
              -8330.473,
              54.544
            ],
            [
              110.052,
              -8287.001,
              98.125
            ],
            [
              60.212,
              -7808.507,
              579.207
            ],
            [
              51.629,
              -7784.972,
              604.259
            ],
            [
              54.874,
              -7748.294,
              641.08
            ],
            [
              42.293,
              -7591.096,
              798.78
            ],
            [
              25.801,
              -7471.678,
              919.332
            ],
            [
              8.189,
              -7201.951,
              1189.633
            ],
            [
              -2.477,
              -7116.037,
              1276.207
            ],
            [
              -15.345,
              -7080.178,
              1314.305
            ],
            [
              -10.894,
              -7047.975,
              1346.814
            ],
            [
              -21.671,
              -6897.49,
              1497.684
            ],
            [
              -33.557,
              -6878.349,
              1520.215
            ],
            [
              -59.463,
              -6851.158,
              1557.771
            ],
            [
              -67.548,
              -6835.425,
              1575.46
            ],
            [
              -70.502,
              -6820.899,
              1590.283
            ],
            [
              -64.262,
              -6796.522,
              1615.447
            ],
            [
              -53.78,
              -6786.694,
              1629.816
            ],
            [
              -43.196,
              -6771.301,
              1648.496
            ],
            [
              -44.234,
              -6722.3,
              1697.509
            ],
            [
              -50.829,
              -6695.462,
              1725.145
            ],
            [
              -48.526,
              -6639.841,
              1780.813
            ],
            [
              -52.099,
              -6588.567,
              1832.212
            ],
            [
              -70.555,
              -6505.85,
              1916.962
            ],
            [
              -125.166,
              -6286.66,
              2142.853
            ],
            [
              -158.525,
              -6137.991,
              2295.219
            ],
            [
              -182.398,
              -6069.649,
              2367.611
            ],
            [
              -186.217,
              -6031.729,
              2405.722
            ],
            [
              -210.448,
              -5912.171,
              2527.711
            ],
            [
              -214.688,
              -5861.998,
              2578.063
            ],
            [
              -215.425,
              -5796.303,
              2643.762
            ],
            [
              -210.007,
              -5746.306,
              2694.052
            ],
            [
              -195.772,
              -5671.978,
              2769.731
            ],
            [
              -200.158,
              -5665.219,
              2777.788
            ],
            [
              -245.834,
              -5662.161,
              2823.567
            ],
            [
              -275.515,
              -5664.961,
              2853.379
            ],
            [
              -299.862,
              -5657.84,
              2878.746
            ],
            [
              -394.957,
              -5644.98,
              2974.707
            ],
            [
              -428.258,
              -5634.356,
              3009.662
            ],
            [
              -633.019,
              -5523.775,
              3242.374
            ],
            [
              -663.705,
              -5510.974,
              3275.624
            ],
            [
              -740.836,
              -5466.163,
              3364.826
            ],
            [
              -765.768,
              -5455.693,
              3391.868
            ],
            [
              -887.614,
              -5390.039,
              3530.277
            ],
            [
              -927.257,
              -5373.739,
              3573.14
            ],
            [
              -1090.384,
              -5275.062,
              3763.79
            ],
            [
              -1302.999,
              -5205.56,
              3987.477
            ],
            [
              -1387.604,
              -5181.778,
              4075.36
            ],
            [
              -1687.713,
              -4997.177,
              4427.699
            ],
            [
              -1731.791,
              -4976.352,
              4476.449
            ],
            [
              -1760.592,
              -4965.819,
              4507.116
            ],
            [
              -1786.639,
              -4945.316,
              4540.264
            ],
            [
              -1870.695,
              -4890.382,
              4640.679
            ],
            [
              -2020.603,
              -4770.824,
              4832.425
            ],
            [
              -2056.897,
              -4746.801,
              4875.95
            ],
            [
              -2116.546,
              -4695.646,
              4954.53
            ],
            [
              -2169.487,
              -4665.762,
              5015.324
            ],
            [
              -2190.603,
              -4657.594,
              5037.963
            ],
            [
              -2217.593,
              -4653.776,
              5065.223
            ],
            [
              -2245.99,
              -4656.611,
              5093.761
            ],
            [
              -2265.173,
              -4648.479,
              5114.597
            ],
            [
              -2319.72,
              -4636.38,
              5170.469
            ],
            [
              -2647.123,
              -4570.476,
              5504.439
            ],
            [
              -2704.754,
              -4550.534,
              5565.423
            ],
            [
              -2779.968,
              -4504.68,
              5653.513
            ],
            [
              -2809.985,
              -4489.679,
              5687.069
            ],
            [
              -2814.297,
              -4478.471,
              5699.078
            ],
            [
              -2835.666,
              -4448.038,
              5736.264
            ],
            [
              -2880.475,
              -4394.928,
              5805.752
            ],
            [
              -2902.49,
              -4364.484,
              5843.321
            ],
            [
              -2923.723,
              -4326.261,
              5887.046
            ],
            [
              -2938.397,
              -4244.738,
              5969.879
            ],
            [
              -2943.47,
              -4203.459,
              6011.468
            ],
            [
              -2943.332,
              -4158.933,
              6055.995
            ],
            [
              -2947.565,
              -4106.537,
              6108.561
            ],
            [
              -2936.886,
              -4048.837,
              6167.241
            ],
            [
              -2933.232,
              -3950.938,
              6265.208
            ],
            [
              -2933.288,
              -3880.804,
              6335.342
            ],
            [
              -2935.53,
              -3825.104,
              6391.088
            ],
            [
              -2942.439,
              -3778.227,
              6438.471
            ],
            [
              -2941.11,
              -3739.288,
              6477.433
            ],
            [
              -2942.553,
              -3711.432,
              6505.326
            ],
            [
              -2962.772,
              -3578.604,
              6639.684
            ],
            [
              -2994.393,
              -3434.443,
              6787.272
            ],
            [
              -3009.522,
              -3378.516,
              6845.209
            ],
            [
              -3026.974,
              -3344.813,
              6883.162
            ],
            [
              -3029.648,
              -3313.596,
              6914.494
            ],
            [
              -3083.217,
              -3134.541,
              7101.39
            ],
            [
              -3102.428,
              -3054.053,
              7184.14
            ],
            [
              -3137.083,
              -2972.18,
              7273.045
            ],
            [
              -3158.619,
              -2877.179,
              7370.456
            ],
            [
              -3186.209,
              -2796.544,
              7455.68
            ],
            [
              -3248.067,
              -2685.253,
              7583.008
            ],
            [
              -3332.852,
              -2557.976,
              7735.938
            ],
            [
              -3349.352,
              -2543.216,
              7758.077
            ],
            [
              -3361.538,
              -2502.927,
              7800.168
            ],
            [
              -3386.79,
              -2435.693,
              7871.988
            ],
            [
              -3393.431,
              -2409.973,
              7898.552
            ],
            [
              -3395.464,
              -2378.768,
              7929.823
            ],
            [
              -3389.87,
              -2243.053,
              8065.653
            ],
            [
              -3384.424,
              -2226.45,
              8083.126
            ],
            [
              -3365.672,
              -2038.645,
              8271.866
            ],
            [
              -3375.166,
              -1991.724,
              8319.738
            ],
            [
              -3374.974,
              -1943.859,
              8367.603
            ],
            [
              -3391.774,
              -1872.32,
              8441.088
            ],
            [
              -3430.979,
              -1754.748,
              8565.024
            ],
            [
              -3480.186,
              -1619.191,
              8709.236
            ],
            [
              -3508.003,
              -1550.799,
              8783.068
            ],
            [
              -3525.544,
              -1521.55,
              8817.174
            ],
            [
              -3534.455,
              -1477.979,
              8861.647
            ],
            [
              -3620.717,
              -1211.532,
              9141.709
            ],
            [
              -3662.686,
              -1103.933,
              9257.204
            ],
            [
              -3680.758,
              -1067.996,
              9297.429
            ],
            [
              -3720.589,
              -911.454,
              9458.959
            ],
            [
              -3751.541,
              -837.444,
              9539.181
            ],
            [
              -3761.526,
              -818.346,
              9560.731
            ],
            [
              -3766.218,
              -791.548,
              9587.938
            ],
            [
              -3793.988,
              -719.82,
              9664.853
            ],
            [
              -3843.779,
              -616.54,
              9779.509
            ],
            [
              -3881.258,
              -546.871,
              9858.62
            ],
            [
              -3968.98,
              -399.519,
              10030.106
            ],
            [
              -3986.683,
              -379.175,
              10057.074
            ],
            [
              -3999.719,
              -350.005,
              10089.024
            ],
            [
              -4048.201,
              -282.373,
              10172.238
            ],
            [
              -4133.499,
              -180.709,
              10304.946
            ],
            [
              -4196.245,
              -117.285,
              10394.163
            ],
            [
              -4221.08,
              -99.045,
              10424.977
            ],
            [
              -4243.751,
              -67.483,
              10463.837
            ],
            [
              -4402.336,
              85.535,
              10684.208
            ],
            [
              -4449.086,
              142,
              10757.516
            ],
            [
              -4479.797,
              193.736,
              10817.68
            ],
            [
              -4502.905,
              237.549,
              10867.213
            ],
            [
              -4519.036,
              274.562,
              10907.589
            ],
            [
              -4536.228,
              324.952,
              10960.831
            ],
            [
              -4547.048,
              370.78,
              11007.918
            ],
            [
              -4566.578,
              510.266,
              11148.765
            ],
            [
              -4574.501,
              537.119,
              11176.762
            ],
            [
              -4575.517,
              590.57,
              11230.223
            ],
            [
              -4579.623,
              651.866,
              11291.657
            ],
            [
              -4586.366,
              709.869,
              11350.05
            ],
            [
              -4584.541,
              741.007,
              11381.242
            ],
            [
              -4573.306,
              794.248,
              11435.655
            ],
            [
              -4555.909,
              830.684,
              11476.032
            ],
            [
              -4554.824,
              856.269,
              11501.64
            ],
            [
              -4566.917,
              903.232,
              11550.134
            ],
            [
              -4569.191,
              921.082,
              11568.128
            ],
            [
              -4557.807,
              945.377,
              11594.958
            ],
            [
              -4520.63,
              969.228,
              11639.128
            ],
            [
              -4517.841,
              981.425,
              11651.64
            ],
            [
              -4524.608,
              1000.466,
              11671.848
            ],
            [
              -4563.16,
              1046.77,
              11732.099
            ],
            [
              -4607.63,
              1086.496,
              11791.73
            ],
            [
              -4747.102,
              1153.456,
              11946.443
            ],
            [
              -4804.625,
              1184.498,
              12011.808
            ],
            [
              -4849.214,
              1217.545,
              12067.307
            ],
            [
              -4874.57,
              1243.583,
              12103.652
            ],
            [
              -4893.764,
              1252.817,
              12124.951
            ],
            [
              -4938.352,
              1323.711,
              12208.701
            ],
            [
              -4959.005,
              1360.8,
              12251.153
            ],
            [
              -4978.198,
              1407.883,
              12301.997
            ],
            [
              -4995.361,
              1460.496,
              12357.339
            ],
            [
              -5000.423,
              1503.997,
              12401.134
            ],
            [
              -5002.906,
              1547.455,
              12444.662
            ],
            [
              -4998.561,
              1575.21,
              12472.756
            ],
            [
              -4985.073,
              1609.489,
              12509.593
            ],
            [
              -4958.06,
              1642.423,
              12552.188
            ],
            [
              -4906.917,
              1690.529,
              12622.4
            ],
            [
              -4962.228,
              1738.229,
              12695.439
            ],
            [
              -4984.325,
              1766.437,
              12731.272
            ],
            [
              -5071.031,
              1864.766,
              12862.369
            ],
            [
              -5078.694,
              1869.35,
              12871.299
            ],
            [
              -5081.805,
              1876.082,
              12878.715
            ],
            [
              -5219.905,
              1987.531,
              13056.176
            ],
            [
              -5231.838,
              2006.658,
              13078.72
            ],
            [
              -5236.713,
              2023.439,
              13096.195
            ],
            [
              -5239.294,
              2061.332,
              13134.176
            ],
            [
              -5225.18,
              2094.487,
              13170.21
            ],
            [
              -5204.824,
              2115.291,
              13199.316
            ],
            [
              -5185.303,
              2124.977,
              13221.107
            ],
            [
              -5163.278,
              2130.168,
              13243.736
            ],
            [
              -5074.894,
              2129.773,
              13332.122
            ],
            [
              -4973.287,
              2110.226,
              13435.591
            ],
            [
              -4894.768,
              2098.864,
              13514.928
            ],
            [
              -4850.889,
              2099.226,
              13558.809
            ],
            [
              -4603.07,
              2140.618,
              13810.061
            ],
            [
              -4527.565,
              2141.547,
              13885.571
            ],
            [
              -4479.873,
              2138.5,
              13933.36
            ],
            [
              -4449.462,
              2143.543,
              13964.187
            ],
            [
              -4390.804,
              2140.306,
              14022.933
            ],
            [
              -4376.576,
              2142.288,
              14037.299
            ],
            [
              -4195.427,
              2208.182,
              14230.06
            ],
            [
              -4108.264,
              2248.978,
              14326.298
            ],
            [
              -4011,
              2314.088,
              14443.344
            ],
            [
              -3940.43,
              2365.187,
              14530.471
            ],
            [
              -3943.03,
              2364.119,
              14533.281
            ],
            [
              -3910.18,
              2398.059,
              14580.515
            ],
            [
              -3774.237,
              2423.531,
              14718.824
            ],
            [
              -3651.291,
              2443.66,
              14843.407
            ],
            [
              -3633.133,
              2448.91,
              14862.309
            ],
            [
              -3620.722,
              2457.6,
              14877.459
            ],
            [
              -3623.967,
              2456.543,
              14880.872
            ],
            [
              -3576.587,
              2472.417,
              14930.84
            ],
            [
              -3570.82,
              2470.09,
              14937.058
            ],
            [
              -3565.776,
              2463.323,
              14945.498
            ],
            [
              -3564.66,
              2453.285,
              14955.598
            ],
            [
              -3569.976,
              2444.472,
              14965.89
            ],
            [
              -3577.149,
              2440.144,
              14974.268
            ],
            [
              -3606.234,
              2437.31,
              15003.491
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7830",
              "position": {
                "x": 112.767,
                "z": -8385.016
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -780,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7827",
              "position": {
                "x": 51.629,
                "z": -7784.972
              },
              "distanceAlongShapeM": 604.259,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 919.332,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 1314.305,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 1725.145,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 2367.611,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 2853.379,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 3275.624,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5822",
              "position": {
                "x": -927.257,
                "z": -5373.739
              },
              "distanceAlongShapeM": 3573.14,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 4075.36,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5812",
              "position": {
                "x": -1760.592,
                "z": -4965.819
              },
              "distanceAlongShapeM": 4507.116,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5807",
              "position": {
                "x": -2056.897,
                "z": -4746.801
              },
              "distanceAlongShapeM": 4875.95,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:8269",
              "position": {
                "x": -2245.99,
                "z": -4656.611
              },
              "distanceAlongShapeM": 5093.761,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6766",
              "position": {
                "x": -2809.985,
                "z": -4489.679
              },
              "distanceAlongShapeM": 5687.069,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6484",
              "position": {
                "x": -2923.723,
                "z": -4326.261
              },
              "distanceAlongShapeM": 5887.046,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 6108.561,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 6438.471,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6478",
              "position": {
                "x": -3026.974,
                "z": -3344.813
              },
              "distanceAlongShapeM": 6883.162,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6477",
              "position": {
                "x": -3137.083,
                "z": -2972.18
              },
              "distanceAlongShapeM": 7273.045,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6476",
              "position": {
                "x": -3349.352,
                "z": -2543.216
              },
              "distanceAlongShapeM": 7758.077,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6475",
              "position": {
                "x": -3389.87,
                "z": -2243.053
              },
              "distanceAlongShapeM": 8065.653,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5620",
              "position": {
                "x": -3375.166,
                "z": -1991.724
              },
              "distanceAlongShapeM": 8319.738,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 8817.174,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 9297.429,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 9560.731,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 10057.074,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 10424.977,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 11176.762,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:16703",
              "position": {
                "x": -4563.16,
                "z": 1046.77
              },
              "distanceAlongShapeM": 11732.099,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5672",
              "position": {
                "x": -4893.764,
                "z": 1252.817
              },
              "distanceAlongShapeM": 12124.951,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:7341",
              "position": {
                "x": -4962.228,
                "z": 1738.229
              },
              "distanceAlongShapeM": 12695.439,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6401",
              "position": {
                "x": -5074.894,
                "z": 2129.773
              },
              "distanceAlongShapeM": 13332.122,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6379",
              "position": {
                "x": -4449.462,
                "z": 2143.543
              },
              "distanceAlongShapeM": 13964.187,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:9966",
              "position": {
                "x": -3910.18,
                "z": 2398.059
              },
              "distanceAlongShapeM": 14580.515,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:9964",
              "position": {
                "x": -3623.967,
                "z": 2456.543
              },
              "distanceAlongShapeM": 14880.872,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            }
          ],
          "departuresSeconds": [
            18780,
            21540,
            23640,
            25920,
            27900,
            29640,
            31740,
            33360,
            34980,
            36660,
            38340,
            40260,
            42240,
            43980,
            46380,
            48900,
            51300,
            53640,
            56160,
            58440,
            60540,
            62340,
            64020,
            65460,
            67080,
            69060,
            70860,
            72420,
            73980,
            76260,
            78300,
            80340,
            82620
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_56",
      "sourceRouteId": "vilnius_bus_56",
      "mode": "bus",
      "shortName": "56",
      "longName": "Fabijoniškės–Šeškinė–Konstitucijos pr.–A.Goštauto g.–Vilkpėdė (Apylanka)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_56:0",
          "sourceRouteId": "vilnius_bus_56",
          "sourceShapeId": "vilnius_bus_56_a1-b1",
          "directionId": 0,
          "headsign": "Vilkpėdė (Apylanka)",
          "directionName": "Fabijoniškės–Šeškinė–Konstitucijos pr.–A.Goštauto g.–Vilkpėdė (Apylanka)",
          "mode": "bus",
          "routeShortName": "56",
          "routeLongName": "Fabijoniškės–Šeškinė–Konstitucijos pr.–A.Goštauto g.–Vilkpėdė (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2464.27,
              -5705.856,
              27.473
            ],
            [
              -2454.941,
              -5688.21,
              47.434
            ],
            [
              -2458.022,
              -5680.363,
              55.864
            ],
            [
              -2467.523,
              -5671.289,
              69.002
            ],
            [
              -2484.515,
              -5648.724,
              97.249
            ],
            [
              -2456.526,
              -5595.784,
              157.132
            ],
            [
              -2438.766,
              -5574.947,
              184.511
            ],
            [
              -2323.024,
              -5404.447,
              390.585
            ],
            [
              -2243.521,
              -5280.062,
              538.207
            ],
            [
              -2221.212,
              -5257.08,
              570.237
            ],
            [
              -2172.788,
              -5214.524,
              634.703
            ],
            [
              -2110.315,
              -5178.897,
              706.62
            ],
            [
              -2058.363,
              -5155.329,
              763.669
            ],
            [
              -2028.76,
              -5156.969,
              793.317
            ],
            [
              -1944.865,
              -5148.443,
              877.644
            ],
            [
              -1856.383,
              -5135.547,
              967.061
            ],
            [
              -1800.644,
              -5116.503,
              1025.963
            ],
            [
              -1770.723,
              -5100.339,
              1059.972
            ],
            [
              -1738.711,
              -5075.306,
              1100.609
            ],
            [
              -1710.503,
              -5046.865,
              1140.666
            ],
            [
              -1676.24,
              -5004.061,
              1195.494
            ],
            [
              -1664.171,
              -4977.559,
              1224.615
            ],
            [
              -1657.878,
              -4949.841,
              1253.038
            ],
            [
              -1638.506,
              -4911.224,
              1296.242
            ],
            [
              -1626.337,
              -4879.158,
              1330.54
            ],
            [
              -1604.435,
              -4807.19,
              1405.767
            ],
            [
              -1592.551,
              -4755.08,
              1459.214
            ],
            [
              -1586.265,
              -4691.738,
              1522.867
            ],
            [
              -1583.358,
              -4637.242,
              1577.441
            ],
            [
              -1588.338,
              -4591.511,
              1623.443
            ],
            [
              -1597.362,
              -4555.726,
              1660.348
            ],
            [
              -1598.126,
              -4562.392,
              1667.057
            ],
            [
              -1595.437,
              -4520.137,
              1709.397
            ],
            [
              -1616.287,
              -4244.797,
              1985.526
            ],
            [
              -1631.856,
              -4106.478,
              2124.718
            ],
            [
              -1640.178,
              -4067.366,
              2164.705
            ],
            [
              -1637.064,
              -4037.365,
              2194.868
            ],
            [
              -1635.048,
              -3960.588,
              2271.671
            ],
            [
              -1628.98,
              -3909.488,
              2323.13
            ],
            [
              -1612.999,
              -3808.47,
              2425.404
            ],
            [
              -1543.192,
              -3688.376,
              2564.313
            ],
            [
              -1515.42,
              -3648.796,
              2612.664
            ],
            [
              -1479.438,
              -3582.647,
              2687.966
            ],
            [
              -1461.972,
              -3542.883,
              2731.397
            ],
            [
              -1437.625,
              -3478.752,
              2799.994
            ],
            [
              -1385.229,
              -3323.838,
              2963.529
            ],
            [
              -1372.596,
              -3266.177,
              3022.558
            ],
            [
              -1373.246,
              -3230.542,
              3058.199
            ],
            [
              -1363.568,
              -3193.979,
              3096.021
            ],
            [
              -1359.808,
              -3163.989,
              3126.246
            ],
            [
              -1360.179,
              -3112.774,
              3177.462
            ],
            [
              -1362.723,
              -3074.878,
              3215.443
            ],
            [
              -1386.134,
              -2978.721,
              3314.409
            ],
            [
              -1409.242,
              -2901.495,
              3395.019
            ],
            [
              -1422.254,
              -2872.318,
              3426.966
            ],
            [
              -1430.357,
              -2820.964,
              3478.955
            ],
            [
              -1448.996,
              -2746.044,
              3556.158
            ],
            [
              -1452.909,
              -2712.577,
              3589.853
            ],
            [
              -1453.659,
              -2682.507,
              3619.933
            ],
            [
              -1443.344,
              -2610.331,
              3692.842
            ],
            [
              -1428.471,
              -2571.635,
              3734.298
            ],
            [
              -1415.77,
              -2546.258,
              3762.676
            ],
            [
              -1386.622,
              -2502.251,
              3815.461
            ],
            [
              -1450.559,
              -2473.275,
              3885.657
            ],
            [
              -1516.935,
              -2436.464,
              3961.557
            ],
            [
              -1567.016,
              -2425.55,
              4012.814
            ],
            [
              -1613.955,
              -2419.145,
              4060.188
            ],
            [
              -1678.312,
              -2413.543,
              4124.788
            ],
            [
              -1901.727,
              -2399.542,
              4348.642
            ],
            [
              -1905.127,
              -2409.501,
              4359.165
            ],
            [
              -1907.871,
              -2527.453,
              4477.15
            ],
            [
              -1930.967,
              -2593.836,
              4547.435
            ],
            [
              -1938.838,
              -2601.488,
              4558.413
            ],
            [
              -2055.259,
              -2914.461,
              4892.338
            ],
            [
              -2054.675,
              -2917.811,
              4895.738
            ],
            [
              -2034.057,
              -2918.177,
              4916.359
            ],
            [
              -2023.689,
              -2915.022,
              4927.196
            ],
            [
              -2013.222,
              -2906.302,
              4940.82
            ],
            [
              -1995.719,
              -2864.311,
              4986.313
            ],
            [
              -1946.309,
              -2731.603,
              5127.921
            ],
            [
              -1893.853,
              -2608.968,
              5261.303
            ],
            [
              -1860.774,
              -2597.312,
              5296.376
            ],
            [
              -1798.045,
              -2477.088,
              5431.981
            ],
            [
              -1803.09,
              -2434.696,
              5474.673
            ],
            [
              -1743.312,
              -2335.571,
              5590.427
            ],
            [
              -1747.763,
              -2332.152,
              5596.04
            ],
            [
              -1727.311,
              -2305.799,
              5629.398
            ],
            [
              -1547.472,
              -2017.345,
              5969.321
            ],
            [
              -1343.434,
              -1674.784,
              6368.044
            ],
            [
              -1305.861,
              -1628.702,
              6427.502
            ],
            [
              -1268.647,
              -1602.651,
              6472.928
            ],
            [
              -1054.592,
              -1494.059,
              6712.952
            ],
            [
              -1027.103,
              -1471.176,
              6748.719
            ],
            [
              -1009.966,
              -1450.333,
              6775.703
            ],
            [
              -1001.511,
              -1410.409,
              6816.512
            ],
            [
              -987.78,
              -1363.9,
              6865.006
            ],
            [
              -988.723,
              -1201.352,
              7027.557
            ],
            [
              -990.397,
              -1186.85,
              7042.155
            ],
            [
              -1017.615,
              -1122.906,
              7111.651
            ],
            [
              -1020.518,
              -1105.042,
              7129.749
            ],
            [
              -1018.304,
              -1089.497,
              7145.451
            ],
            [
              -1013.532,
              -1075.111,
              7160.608
            ],
            [
              -1005.537,
              -1060.783,
              7177.016
            ],
            [
              -969.041,
              -1039.175,
              7219.428
            ],
            [
              -947.066,
              -1036.231,
              7241.6
            ],
            [
              -930.307,
              -1036.533,
              7258.361
            ],
            [
              -906.579,
              -1043.639,
              7283.131
            ],
            [
              -895.802,
              -1053.852,
              7297.979
            ],
            [
              -890.221,
              -1066.198,
              7311.527
            ],
            [
              -882.043,
              -1077.478,
              7325.46
            ],
            [
              -868.708,
              -1088.851,
              7342.986
            ],
            [
              -845.624,
              -1095.946,
              7367.135
            ],
            [
              -837.245,
              -1096.097,
              7375.516
            ],
            [
              -813.336,
              -1093.188,
              7399.601
            ],
            [
              -786.145,
              -1086.999,
              7427.488
            ],
            [
              -775.751,
              -1082.734,
              7438.722
            ],
            [
              -717.641,
              -1078.217,
              7497.008
            ],
            [
              -647.083,
              -1062.792,
              7569.232
            ],
            [
              -599.769,
              -1049.176,
              7618.467
            ],
            [
              -535.555,
              -1028.072,
              7686.06
            ],
            [
              -464.693,
              -995.958,
              7763.859
            ],
            [
              -361.843,
              -942.16,
              7879.93
            ],
            [
              -333.702,
              -919.293,
              7916.19
            ],
            [
              -286.889,
              -897.877,
              7967.669
            ],
            [
              -196.966,
              -846.075,
              8071.446
            ],
            [
              -115.583,
              -803.025,
              8163.514
            ],
            [
              -96.647,
              -790.01,
              8186.491
            ],
            [
              -42.035,
              -765.399,
              8246.392
            ],
            [
              224.176,
              -700.119,
              8520.49
            ],
            [
              211.01,
              -644.216,
              8577.922
            ],
            [
              143.71,
              -480.456,
              8754.972
            ],
            [
              121.213,
              -441.083,
              8800.319
            ],
            [
              119.827,
              -411,
              8830.433
            ],
            [
              106.146,
              -277.163,
              8964.968
            ],
            [
              35.151,
              -280.322,
              9036.033
            ],
            [
              -101.904,
              -298.979,
              9174.352
            ],
            [
              -140.08,
              -306.078,
              9213.183
            ],
            [
              -153.095,
              -312.52,
              9227.705
            ],
            [
              -213.211,
              -320.334,
              9288.326
            ],
            [
              -272.238,
              -339.301,
              9350.326
            ],
            [
              -413.017,
              -421.354,
              9513.272
            ],
            [
              -469.726,
              -490.46,
              9602.668
            ],
            [
              -566.864,
              -584.44,
              9737.827
            ],
            [
              -678.943,
              -684.832,
              9888.294
            ],
            [
              -729.705,
              -710.633,
              9945.237
            ],
            [
              -764.735,
              -722.247,
              9982.141
            ],
            [
              -795.816,
              -729.479,
              10014.053
            ],
            [
              -837.191,
              -735.412,
              10055.851
            ],
            [
              -917.002,
              -727.295,
              10136.074
            ],
            [
              -964.927,
              -703.054,
              10189.78
            ],
            [
              -996.817,
              -683.556,
              10227.159
            ],
            [
              -1054.176,
              -610.165,
              10320.306
            ],
            [
              -1094.292,
              -545.99,
              10395.987
            ],
            [
              -1131.291,
              -451.814,
              10497.17
            ],
            [
              -1162.09,
              -335.486,
              10617.507
            ],
            [
              -1171.831,
              -267.404,
              10686.282
            ],
            [
              -1173.311,
              -206.15,
              10747.554
            ],
            [
              -1189.802,
              -11.04,
              10943.359
            ],
            [
              -1221.169,
              217.734,
              11174.273
            ],
            [
              -1222.87,
              266.746,
              11223.315
            ],
            [
              -1244.179,
              337.261,
              11296.98
            ],
            [
              -1266.107,
              373.277,
              11339.146
            ],
            [
              -1309.014,
              426.368,
              11407.407
            ],
            [
              -1352.826,
              465.002,
              11465.82
            ],
            [
              -1405.14,
              497.108,
              11527.201
            ],
            [
              -1439.818,
              505.521,
              11562.885
            ],
            [
              -1555.828,
              546.557,
              11685.939
            ],
            [
              -1726.805,
              579.664,
              11860.092
            ],
            [
              -1758.807,
              593.593,
              11894.993
            ],
            [
              -1828.277,
              640.472,
              11978.801
            ],
            [
              -1847.126,
              668.638,
              12012.692
            ],
            [
              -1893.219,
              760.742,
              12115.686
            ],
            [
              -1907.903,
              805.531,
              12162.821
            ],
            [
              -1928.849,
              897.188,
              12256.84
            ],
            [
              -1969.97,
              1051.542,
              12416.579
            ],
            [
              -1974.845,
              1103.95,
              12469.213
            ],
            [
              -1975.7,
              1128.456,
              12493.733
            ],
            [
              -1959.78,
              1189.4,
              12556.722
            ],
            [
              -1920.059,
              1246.582,
              12626.346
            ],
            [
              -1864.959,
              1297.923,
              12701.659
            ],
            [
              -1707.895,
              1459.884,
              12927.27
            ],
            [
              -1654.972,
              1533.526,
              13017.956
            ],
            [
              -1603.973,
              1571.579,
              13081.587
            ],
            [
              -1299.013,
              1921.245,
              13545.556
            ],
            [
              -1270.801,
              1947.457,
              13584.066
            ],
            [
              -1190.297,
              2047.317,
              13712.335
            ],
            [
              -1514.694,
              2380.408,
              14177.29
            ],
            [
              -1536.913,
              2400.843,
              14207.477
            ],
            [
              -1586.671,
              2432.901,
              14266.668
            ],
            [
              -1589.092,
              2441.85,
              14275.939
            ],
            [
              -1665.298,
              2474.379,
              14358.797
            ],
            [
              -1973.715,
              2584.507,
              14686.286
            ],
            [
              -1980.067,
              2590.186,
              14694.807
            ],
            [
              -1990.862,
              2563.661,
              14723.445
            ],
            [
              -1996.181,
              2554.849,
              14733.737
            ],
            [
              -2002.73,
              2549.399,
              14742.257
            ],
            [
              -2002.849,
              2542.722,
              14748.935
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 157.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 763.669,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5813",
              "position": {
                "x": -1657.878,
                "z": -4949.841
              },
              "distanceAlongShapeM": 1253.038,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6917",
              "position": {
                "x": -1597.362,
                "z": -4555.726
              },
              "distanceAlongShapeM": 1660.348,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6921",
              "position": {
                "x": -1640.178,
                "z": -4067.366
              },
              "distanceAlongShapeM": 2164.705,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6924",
              "position": {
                "x": -1612.999,
                "z": -3808.47
              },
              "distanceAlongShapeM": 2425.404,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6928",
              "position": {
                "x": -1373.246,
                "z": -3230.542
              },
              "distanceAlongShapeM": 3058.199,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6933",
              "position": {
                "x": -1422.254,
                "z": -2872.318
              },
              "distanceAlongShapeM": 3426.966,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6937",
              "position": {
                "x": -1450.559,
                "z": -2473.275
              },
              "distanceAlongShapeM": 3885.657,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5294",
              "position": {
                "x": -1930.967,
                "z": -2593.836
              },
              "distanceAlongShapeM": 4547.435,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 990,
              "departureOffsetSeconds": 990
            },
            {
              "stopId": "judu:stop:5214",
              "position": {
                "x": -1747.763,
                "z": -2332.152
              },
              "distanceAlongShapeM": 5596.04,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 6816.512,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 7438.722,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 7916.19,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 8246.392,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 8800.319,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5249",
              "position": {
                "x": -153.095,
                "z": -312.52
              },
              "distanceAlongShapeM": 9227.705,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:3551",
              "position": {
                "x": -469.726,
                "z": -490.46
              },
              "distanceAlongShapeM": 9602.668,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2010,
              "departureOffsetSeconds": 2010
            },
            {
              "stopId": "judu:stop:16553",
              "position": {
                "x": -1171.831,
                "z": -267.404
              },
              "distanceAlongShapeM": 10686.282,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2130,
              "departureOffsetSeconds": 2130
            },
            {
              "stopId": "judu:stop:16773",
              "position": {
                "x": -1221.169,
                "z": 217.734
              },
              "distanceAlongShapeM": 11174.273,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2250,
              "departureOffsetSeconds": 2250
            },
            {
              "stopId": "judu:stop:6410",
              "position": {
                "x": -1654.972,
                "z": 1533.526
              },
              "distanceAlongShapeM": 13017.956,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6366",
              "position": {
                "x": -1299.013,
                "z": 1921.245
              },
              "distanceAlongShapeM": 13545.556,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:9701",
              "position": {
                "x": -1232.774,
                "z": 2089.268
              },
              "distanceAlongShapeM": 13772.024,
              "shapeOffsetM": 1.162,
              "arrivalOffsetSeconds": 2730,
              "departureOffsetSeconds": 2730
            },
            {
              "stopId": "judu:stop:7941",
              "position": {
                "x": -1586.671,
                "z": 2432.901
              },
              "distanceAlongShapeM": 14266.668,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2850,
              "departureOffsetSeconds": 2850
            },
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 14748.935,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2910,
              "departureOffsetSeconds": 2910
            }
          ],
          "departuresSeconds": [
            18300,
            19680,
            21060,
            22740,
            24360,
            25260,
            26280,
            27960,
            29580,
            32700,
            34560,
            36360,
            38520,
            41220,
            43440,
            45660,
            48060,
            50340,
            52560,
            53760,
            54960,
            56340,
            57960,
            59760,
            61560,
            63960,
            65700,
            68220,
            70500,
            72780,
            74880,
            76980,
            79020,
            81120
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_56:1",
          "sourceRouteId": "vilnius_bus_56",
          "sourceShapeId": "vilnius_bus_56_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės",
          "directionName": "Vilkpėdė–A.Goštauto g.–Konstitucijos pr.–Šeškinė–Fabijoniškės",
          "mode": "bus",
          "routeShortName": "56",
          "routeLongName": "Fabijoniškės–Šeškinė–Konstitucijos pr.–A.Goštauto g.–Vilkpėdė (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2002.849,
              2542.722,
              0
            ],
            [
              -2009.26,
              2545.063,
              6.825
            ],
            [
              -2019.015,
              2540.783,
              17.477
            ],
            [
              -2077.913,
              2530.695,
              77.234
            ],
            [
              -2083.871,
              2558.631,
              105.798
            ],
            [
              -2083.009,
              2570.861,
              118.058
            ],
            [
              -2085.352,
              2584.261,
              131.662
            ],
            [
              -2057.496,
              2590.447,
              160.197
            ],
            [
              -2051.124,
              2585.881,
              168.036
            ],
            [
              -2042.349,
              2571.254,
              185.093
            ],
            [
              -2044.403,
              2564.611,
              192.046
            ],
            [
              -2036.471,
              2538.866,
              218.985
            ],
            [
              -2016.375,
              2544.076,
              239.745
            ],
            [
              -2000.11,
              2551.579,
              257.657
            ],
            [
              -1974.301,
              2587.857,
              302.18
            ],
            [
              -1936.577,
              2568.263,
              344.688
            ],
            [
              -1765.274,
              2512.896,
              524.717
            ],
            [
              -1632.053,
              2457.088,
              669.155
            ],
            [
              -1563.915,
              2442.514,
              738.834
            ],
            [
              -1527.823,
              2404.02,
              791.602
            ],
            [
              -1399.067,
              2279.266,
              970.883
            ],
            [
              -1328.942,
              2195.633,
              1080.025
            ],
            [
              -1190.297,
              2047.317,
              1283.052
            ],
            [
              -1411.426,
              1768.519,
              1638.899
            ],
            [
              -1687.704,
              1470.656,
              2045.164
            ],
            [
              -1774.011,
              1369.777,
              2177.925
            ],
            [
              -1888.848,
              1260.499,
              2336.447
            ],
            [
              -1928.003,
              1198.855,
              2409.476
            ],
            [
              -1944.291,
              1153.502,
              2457.664
            ],
            [
              -1942.234,
              1087.786,
              2523.413
            ],
            [
              -1927.742,
              959.508,
              2652.506
            ],
            [
              -1900.96,
              833.238,
              2781.585
            ],
            [
              -1885.184,
              777.297,
              2839.709
            ],
            [
              -1847.196,
              700.922,
              2925.009
            ],
            [
              -1817.098,
              652.518,
              2982.008
            ],
            [
              -1749.056,
              597.872,
              3069.277
            ],
            [
              -1726.706,
              585.229,
              3094.955
            ],
            [
              -1590.169,
              573.888,
              3231.962
            ],
            [
              -1491.091,
              559.872,
              3332.027
            ],
            [
              -1444.24,
              546.789,
              3380.67
            ],
            [
              -1412.22,
              533.971,
              3415.16
            ],
            [
              -1377.175,
              509.967,
              3457.638
            ],
            [
              -1269.072,
              387.802,
              3620.765
            ],
            [
              -1233.883,
              335.963,
              3683.419
            ],
            [
              -1214.794,
              285.526,
              3737.348
            ],
            [
              -1194.224,
              173.835,
              3850.918
            ],
            [
              -1189.802,
              -11.04,
              4035.845
            ],
            [
              -1173.311,
              -206.15,
              4231.651
            ],
            [
              -1150.937,
              -288.931,
              4317.402
            ],
            [
              -1145.948,
              -370.286,
              4398.91
            ],
            [
              -1128.552,
              -442.958,
              4473.635
            ],
            [
              -1103.501,
              -520.22,
              4554.857
            ],
            [
              -1089.839,
              -549.409,
              4587.086
            ],
            [
              -1080.43,
              -564.05,
              4604.49
            ],
            [
              -1026.313,
              -638.496,
              4696.527
            ],
            [
              -986.543,
              -685.967,
              4758.455
            ],
            [
              -964.927,
              -703.054,
              4786.01
            ],
            [
              -944.499,
              -714.554,
              4809.451
            ],
            [
              -887.35,
              -727.829,
              4868.122
            ],
            [
              -849.963,
              -728.502,
              4905.515
            ],
            [
              -795.111,
              -726.152,
              4960.417
            ],
            [
              -764.735,
              -722.247,
              4991.044
            ],
            [
              -725.717,
              -704.026,
              5034.106
            ],
            [
              -702.814,
              -685.514,
              5063.555
            ],
            [
              -692.924,
              -673.447,
              5079.157
            ],
            [
              -655.859,
              -656.305,
              5119.994
            ],
            [
              -601.451,
              -607.193,
              5193.29
            ],
            [
              -500.911,
              -503.255,
              5337.898
            ],
            [
              -413.017,
              -421.354,
              5458.035
            ],
            [
              -305.298,
              -348.72,
              5587.955
            ],
            [
              -203.339,
              -309.381,
              5697.24
            ],
            [
              -102.285,
              -284.5,
              5801.312
            ],
            [
              -50.388,
              -267.632,
              5855.881
            ],
            [
              -22.626,
              -265.911,
              5883.696
            ],
            [
              -0.545,
              -257.407,
              5907.358
            ],
            [
              58.367,
              -209.498,
              5983.292
            ],
            [
              82.464,
              -196.578,
              6010.634
            ],
            [
              94.753,
              -194.576,
              6023.085
            ],
            [
              103.738,
              -196.966,
              6032.383
            ],
            [
              115.784,
              -208.318,
              6048.935
            ],
            [
              119.866,
              -267.394,
              6108.151
            ],
            [
              118.552,
              -304.106,
              6144.888
            ],
            [
              124.949,
              -377.696,
              6218.755
            ],
            [
              130.203,
              -407.85,
              6249.363
            ],
            [
              150.182,
              -443.837,
              6290.525
            ],
            [
              177.186,
              -518.917,
              6370.312
            ],
            [
              187.997,
              -562.53,
              6415.246
            ],
            [
              214.213,
              -645.388,
              6502.152
            ],
            [
              224.323,
              -656.705,
              6517.328
            ],
            [
              237.149,
              -695.903,
              6558.57
            ],
            [
              236.925,
              -708.144,
              6570.814
            ],
            [
              229.693,
              -715.805,
              6581.349
            ],
            [
              23.734,
              -765.484,
              6793.214
            ],
            [
              -53.078,
              -805.275,
              6879.721
            ],
            [
              -306.711,
              -924.235,
              7159.866
            ],
            [
              -475.993,
              -1014.678,
              7351.795
            ],
            [
              -534.689,
              -1051.466,
              7421.066
            ],
            [
              -673.187,
              -1080.133,
              7562.5
            ],
            [
              -763.423,
              -1114.127,
              7658.926
            ],
            [
              -822.801,
              -1117.509,
              7718.401
            ],
            [
              -837.686,
              -1120.58,
              7733.6
            ],
            [
              -857.223,
              -1131.36,
              7755.913
            ],
            [
              -899.68,
              -1161.766,
              7808.135
            ],
            [
              -917.464,
              -1182.597,
              7835.524
            ],
            [
              -926.283,
              -1206.929,
              7861.406
            ],
            [
              -917.431,
              -1323.977,
              7978.788
            ],
            [
              -911.942,
              -1448.758,
              8103.69
            ],
            [
              -922.391,
              -1491.986,
              8148.162
            ],
            [
              -939.829,
              -1529.521,
              8189.551
            ],
            [
              -961.618,
              -1558.073,
              8225.467
            ],
            [
              -995.732,
              -1590.856,
              8272.78
            ],
            [
              -1026.383,
              -1610.342,
              8309.101
            ],
            [
              -1072.441,
              -1626.213,
              8357.816
            ],
            [
              -1262.636,
              -1662.874,
              8551.512
            ],
            [
              -1320.472,
              -1688.554,
              8614.793
            ],
            [
              -1370.209,
              -1729.965,
              8679.513
            ],
            [
              -1651.924,
              -2199.162,
              9226.787
            ],
            [
              -1682.619,
              -2257.615,
              9292.809
            ],
            [
              -1702.963,
              -2314.026,
              9352.777
            ],
            [
              -1711.936,
              -2347.263,
              9387.203
            ],
            [
              -1753.781,
              -2416.65,
              9468.232
            ],
            [
              -1791.442,
              -2468.3,
              9532.154
            ],
            [
              -1802.268,
              -2497.051,
              9562.876
            ],
            [
              -1803.487,
              -2529.313,
              9595.16
            ],
            [
              -1788.281,
              -2616.415,
              9683.58
            ],
            [
              -1772.234,
              -2692.401,
              9761.242
            ],
            [
              -1749.208,
              -2738.453,
              9812.73
            ],
            [
              -1746.662,
              -2848.708,
              9923.014
            ],
            [
              -1749.429,
              -2895.414,
              9969.802
            ],
            [
              -1759.481,
              -2953.123,
              10028.38
            ],
            [
              -1775.996,
              -3011.829,
              10089.365
            ],
            [
              -1683.756,
              -3043.532,
              10186.901
            ],
            [
              -1647.191,
              -3053.091,
              10224.694
            ],
            [
              -1571.366,
              -3065.578,
              10301.54
            ],
            [
              -1551.978,
              -3062.585,
              10321.158
            ],
            [
              -1523.75,
              -3069.769,
              10350.286
            ],
            [
              -1491.596,
              -3073.684,
              10382.677
            ],
            [
              -1438.786,
              -3075.742,
              10435.528
            ],
            [
              -1362.723,
              -3074.878,
              10511.596
            ],
            [
              -1357.098,
              -3120.622,
              10557.684
            ],
            [
              -1356.687,
              -3169.611,
              10606.675
            ],
            [
              -1363.762,
              -3240.731,
              10678.146
            ],
            [
              -1372.45,
              -3294.01,
              10732.129
            ],
            [
              -1372.145,
              -3312.94,
              10751.062
            ],
            [
              -1386.916,
              -3346.073,
              10787.338
            ],
            [
              -1441.889,
              -3500.94,
              10951.672
            ],
            [
              -1479.438,
              -3582.647,
              11041.594
            ],
            [
              -1526.789,
              -3671.971,
              11142.693
            ],
            [
              -1572.531,
              -3743.513,
              11227.608
            ],
            [
              -1605.428,
              -3817.511,
              11308.589
            ],
            [
              -1619.047,
              -3858.457,
              11351.741
            ],
            [
              -1621.258,
              -3874.003,
              11367.443
            ],
            [
              -1622.014,
              -3916.292,
              11409.739
            ],
            [
              -1630.122,
              -3937.298,
              11432.255
            ],
            [
              -1635.048,
              -3960.588,
              11456.061
            ],
            [
              -1633.18,
              -4036.321,
              11531.816
            ],
            [
              -1621.037,
              -4150.087,
              11646.229
            ],
            [
              -1612.338,
              -4168.054,
              11666.191
            ],
            [
              -1616.287,
              -4244.797,
              11743.035
            ],
            [
              -1593.127,
              -4499.027,
              11998.318
            ],
            [
              -1582.077,
              -4601.642,
              12101.526
            ],
            [
              -1574.54,
              -4648.532,
              12149.018
            ],
            [
              -1585.129,
              -4736.288,
              12237.411
            ],
            [
              -1597.975,
              -4806.192,
              12308.485
            ],
            [
              -1623.216,
              -4884.78,
              12391.027
            ],
            [
              -1642.847,
              -4937.864,
              12447.625
            ],
            [
              -1696.959,
              -5045.994,
              12568.539
            ],
            [
              -1793.54,
              -5115.517,
              12687.54
            ],
            [
              -1840.927,
              -5135.823,
              12739.095
            ],
            [
              -1904.939,
              -5149.154,
              12804.48
            ],
            [
              -2065.02,
              -5167.456,
              12965.604
            ],
            [
              -2110.315,
              -5178.897,
              13012.322
            ],
            [
              -2127.276,
              -5190.841,
              13033.066
            ],
            [
              -2143.028,
              -5207.26,
              13055.819
            ],
            [
              -2175.503,
              -5222.268,
              13091.594
            ],
            [
              -2204.955,
              -5248.463,
              13131.01
            ],
            [
              -2230.543,
              -5274.726,
              13167.677
            ],
            [
              -2512.326,
              -5691.648,
              13670.892
            ],
            [
              -2513.285,
              -5709.442,
              13688.713
            ],
            [
              -2528.468,
              -5730.325,
              13714.532
            ],
            [
              -2529.407,
              -5747.007,
              13731.24
            ],
            [
              -2525.623,
              -5751.527,
              13737.135
            ],
            [
              -2510.288,
              -5758.477,
              13753.972
            ],
            [
              -2498.658,
              -5756.456,
              13765.776
            ],
            [
              -2480.761,
              -5727.829,
              13799.537
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8311",
              "position": {
                "x": -2042.349,
                "z": 2571.254
              },
              "distanceAlongShapeM": 185.093,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8309",
              "position": {
                "x": -1563.915,
                "z": 2442.514
              },
              "distanceAlongShapeM": 738.834,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:9642",
              "position": {
                "x": -1399.067,
                "z": 2279.266
              },
              "distanceAlongShapeM": 970.883,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6365",
              "position": {
                "x": -1411.426,
                "z": 1768.519
              },
              "distanceAlongShapeM": 1638.899,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:16770",
              "position": {
                "x": -1774.011,
                "z": 1369.777
              },
              "distanceAlongShapeM": 2177.925,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:16772",
              "position": {
                "x": -1194.224,
                "z": 173.835
              },
              "distanceAlongShapeM": 3850.918,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9007",
              "position": {
                "x": -1150.937,
                "z": -288.931
              },
              "distanceAlongShapeM": 4317.402,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5539",
              "position": {
                "x": -692.924,
                "z": -673.447
              },
              "distanceAlongShapeM": 5079.157,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 5855.881,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 6290.525,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 6879.721,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 7421.066,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 7658.926,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1710,
              "departureOffsetSeconds": 1710
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 9387.203,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1890,
              "departureOffsetSeconds": 1890
            },
            {
              "stopId": "judu:stop:1042",
              "position": {
                "x": -1749.208,
                "z": -2738.453
              },
              "distanceAlongShapeM": 9812.73,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1950,
              "departureOffsetSeconds": 1950
            },
            {
              "stopId": "judu:stop:6940",
              "position": {
                "x": -1551.978,
                "z": -3062.585
              },
              "distanceAlongShapeM": 10321.158,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2070,
              "departureOffsetSeconds": 2070
            },
            {
              "stopId": "judu:stop:6929",
              "position": {
                "x": -1372.145,
                "z": -3312.94
              },
              "distanceAlongShapeM": 10751.062,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2190,
              "departureOffsetSeconds": 2190
            },
            {
              "stopId": "judu:stop:6926",
              "position": {
                "x": -1622.014,
                "z": -3916.292
              },
              "distanceAlongShapeM": 11409.739,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2310,
              "departureOffsetSeconds": 2310
            },
            {
              "stopId": "judu:stop:6922",
              "position": {
                "x": -1612.338,
                "z": -4168.054
              },
              "distanceAlongShapeM": 11666.191,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2370,
              "departureOffsetSeconds": 2370
            },
            {
              "stopId": "judu:stop:6918",
              "position": {
                "x": -1574.54,
                "z": -4648.532
              },
              "distanceAlongShapeM": 12149.018,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2490,
              "departureOffsetSeconds": 2490
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 12568.539,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2610,
              "departureOffsetSeconds": 2610
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 13055.819,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2670,
              "departureOffsetSeconds": 2670
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 13688.713,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2790,
              "departureOffsetSeconds": 2790
            }
          ],
          "departuresSeconds": [
            21180,
            22560,
            24300,
            26040,
            27840,
            28980,
            30120,
            31620,
            33120,
            36060,
            38040,
            39960,
            42180,
            44520,
            46740,
            49020,
            51240,
            53700,
            55980,
            57240,
            58740,
            59940,
            61740,
            63600,
            69360,
            71460,
            73620,
            75840,
            78060,
            80220
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_57",
      "sourceRouteId": "vilnius_bus_57",
      "mode": "bus",
      "shortName": "57",
      "longName": "Fabijoniškės–Ateities g.–Jeruzalė–Bajorai–Bukiškis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_57:0",
          "sourceRouteId": "vilnius_bus_57",
          "sourceShapeId": "vilnius_bus_57_a-b",
          "directionId": 0,
          "headsign": "Bukiškis",
          "directionName": "Fabijoniškės–Ateities g.–Jeruzalė–Bajorai–Bukiškis",
          "mode": "bus",
          "routeShortName": "57",
          "routeLongName": "Fabijoniškės–Ateities g.–Jeruzalė–Bajorai–Bukiškis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2480.761,
              -5727.829,
              0
            ],
            [
              -2464.27,
              -5705.856,
              27.473
            ],
            [
              -2454.941,
              -5688.21,
              47.434
            ],
            [
              -2458.022,
              -5680.363,
              55.864
            ],
            [
              -2467.523,
              -5671.289,
              69.002
            ],
            [
              -2484.515,
              -5648.724,
              97.249
            ],
            [
              -2456.526,
              -5595.784,
              157.132
            ],
            [
              -2438.766,
              -5574.947,
              184.511
            ],
            [
              -2323.024,
              -5404.447,
              390.585
            ],
            [
              -2243.521,
              -5280.062,
              538.207
            ],
            [
              -2221.212,
              -5257.08,
              570.237
            ],
            [
              -2172.788,
              -5214.524,
              634.703
            ],
            [
              -2110.315,
              -5178.897,
              706.62
            ],
            [
              -2058.363,
              -5155.329,
              763.669
            ],
            [
              -2028.76,
              -5156.969,
              793.317
            ],
            [
              -1894.496,
              -5141.548,
              928.463
            ],
            [
              -1856.383,
              -5135.547,
              967.046
            ],
            [
              -1800.644,
              -5116.503,
              1025.949
            ],
            [
              -1770.723,
              -5100.339,
              1059.957
            ],
            [
              -1738.711,
              -5075.306,
              1100.594
            ],
            [
              -1710.503,
              -5046.865,
              1140.651
            ],
            [
              -1676.24,
              -5004.061,
              1195.479
            ],
            [
              -1625.643,
              -5020.551,
              1248.695
            ],
            [
              -1586.957,
              -5054.639,
              1300.258
            ],
            [
              -1465.895,
              -5129.166,
              1442.42
            ],
            [
              -1407.208,
              -5161.388,
              1509.371
            ],
            [
              -1338.038,
              -5183.78,
              1582.075
            ],
            [
              -1271.325,
              -5199.449,
              1650.604
            ],
            [
              -1246.49,
              -5215.481,
              1680.163
            ],
            [
              -1208.756,
              -5230.63,
              1720.825
            ],
            [
              -1099.904,
              -5267.098,
              1835.624
            ],
            [
              -1057.683,
              -5283.443,
              1880.898
            ],
            [
              -933.839,
              -5345.789,
              2019.55
            ],
            [
              -826.661,
              -5403.385,
              2141.223
            ],
            [
              -674.33,
              -5492.97,
              2317.944
            ],
            [
              -589.373,
              -5532.358,
              2411.587
            ],
            [
              -565.267,
              -5552.833,
              2443.215
            ],
            [
              -421.759,
              -5631.135,
              2606.696
            ],
            [
              -383.93,
              -5640.727,
              2645.722
            ],
            [
              -342.157,
              -5645.939,
              2687.818
            ],
            [
              -257.182,
              -5648.596,
              2772.835
            ],
            [
              -196.756,
              -5655.261,
              2833.627
            ],
            [
              -180.177,
              -5664.469,
              2852.592
            ],
            [
              -177.18,
              -5676.769,
              2865.252
            ],
            [
              -185.798,
              -5725.595,
              2914.832
            ],
            [
              -185.377,
              -5737.848,
              2927.093
            ],
            [
              -196.91,
              -5769.923,
              2961.178
            ],
            [
              -201.665,
              -5818.819,
              3010.304
            ],
            [
              -201.086,
              -5857.793,
              3049.283
            ],
            [
              -195.599,
              -5910.215,
              3101.991
            ],
            [
              -136.015,
              -6175.138,
              3373.532
            ],
            [
              -122.378,
              -6204.331,
              3405.753
            ],
            [
              -123.468,
              -6228.802,
              3430.249
            ],
            [
              -113.557,
              -6285.758,
              3488.06
            ],
            [
              -58.166,
              -6532.794,
              3741.23
            ],
            [
              -46.468,
              -6597.576,
              3807.06
            ],
            [
              -39.377,
              -6667.839,
              3877.68
            ],
            [
              -35.045,
              -6748.072,
              3958.03
            ],
            [
              -27.041,
              -6768.256,
              3979.743
            ],
            [
              -16.965,
              -6780.686,
              3995.744
            ],
            [
              0.233,
              -6791.019,
              4015.807
            ],
            [
              10.168,
              -6811.238,
              4038.336
            ],
            [
              11.151,
              -6827.955,
              4055.081
            ],
            [
              7.024,
              -6842.352,
              4070.058
            ],
            [
              -2.815,
              -6852.191,
              4083.973
            ],
            [
              -13.86,
              -6857.556,
              4096.251
            ],
            [
              -26.131,
              -6859.559,
              4108.685
            ],
            [
              -47.374,
              -6859.171,
              4129.932
            ],
            [
              -59.463,
              -6851.158,
              4144.435
            ],
            [
              -78.653,
              -6844.129,
              4164.873
            ],
            [
              -94.726,
              -6842.723,
              4181.007
            ],
            [
              -112.168,
              -6845.745,
              4198.709
            ],
            [
              -131.642,
              -6854.296,
              4219.977
            ],
            [
              -156.753,
              -6889.462,
              4263.189
            ],
            [
              -179.506,
              -6901.294,
              4288.834
            ],
            [
              -377.89,
              -7081.371,
              4556.76
            ],
            [
              -448.339,
              -7131.301,
              4643.108
            ],
            [
              -497.724,
              -7156.009,
              4698.329
            ],
            [
              -684.153,
              -7210.52,
              4892.565
            ],
            [
              -707.406,
              -7214.553,
              4916.165
            ],
            [
              -752.866,
              -7235.995,
              4966.428
            ],
            [
              -779.861,
              -7233.281,
              4993.558
            ],
            [
              -817.998,
              -7241.497,
              5032.571
            ],
            [
              -975.194,
              -7282.076,
              5194.92
            ],
            [
              -1008.745,
              -7285.924,
              5228.691
            ],
            [
              -1020.815,
              -7276.801,
              5243.821
            ],
            [
              -1038.154,
              -7274.262,
              5261.345
            ],
            [
              -1047.829,
              -7275.201,
              5271.065
            ],
            [
              -1052.254,
              -7270.668,
              5277.4
            ],
            [
              -1063.8,
              -7268.234,
              5289.2
            ],
            [
              -1078.061,
              -7273.543,
              5304.417
            ],
            [
              -1073.172,
              -7288.103,
              5319.776
            ],
            [
              -1073.856,
              -7290.317,
              5322.094
            ],
            [
              -1077.095,
              -7291.372,
              5325.5
            ],
            [
              -1151.78,
              -7291.141,
              5400.186
            ],
            [
              -1217.998,
              -7285.497,
              5466.643
            ],
            [
              -1329.053,
              -7266.803,
              5579.261
            ],
            [
              -1377.069,
              -7251.469,
              5629.666
            ],
            [
              -1412.132,
              -7231.915,
              5669.812
            ],
            [
              -1507.971,
              -7154.497,
              5793.014
            ],
            [
              -1536.014,
              -7138.409,
              5825.345
            ],
            [
              -1559.731,
              -7132.419,
              5849.806
            ],
            [
              -1599.016,
              -7132.829,
              5889.094
            ],
            [
              -1638.222,
              -7128.788,
              5928.507
            ],
            [
              -1667.851,
              -7129.371,
              5958.142
            ],
            [
              -1685.974,
              -7134.613,
              5977.008
            ],
            [
              -1717.309,
              -7158.544,
              6016.436
            ],
            [
              -1736.997,
              -7179.344,
              6045.076
            ],
            [
              -1784.713,
              -7255.305,
              6134.78
            ],
            [
              -1799.697,
              -7265.057,
              6152.658
            ],
            [
              -1918.084,
              -7296.342,
              6275.109
            ],
            [
              -1942.097,
              -7307.046,
              6301.4
            ],
            [
              -1952.594,
              -7317.992,
              6316.565
            ],
            [
              -2033.201,
              -7361.085,
              6407.968
            ],
            [
              -2179.338,
              -7468.697,
              6589.452
            ],
            [
              -2371.269,
              -7508.706,
              6785.508
            ],
            [
              -2672.284,
              -7564.608,
              7091.671
            ],
            [
              -2720.772,
              -7575.998,
              7141.478
            ],
            [
              -2749.794,
              -7578.826,
              7170.638
            ],
            [
              -2757.498,
              -7577.576,
              7178.442
            ],
            [
              -2765.787,
              -7572.977,
              7187.921
            ],
            [
              -2768.554,
              -7547.324,
              7213.723
            ],
            [
              -2776.371,
              -7516.016,
              7245.993
            ],
            [
              -2831.651,
              -7364.756,
              7407.038
            ],
            [
              -2960.012,
              -7378.081,
              7536.089
            ],
            [
              -3094.888,
              -7395.748,
              7672.117
            ],
            [
              -3192.918,
              -7405.159,
              7770.598
            ],
            [
              -3245.112,
              -7407.584,
              7822.848
            ],
            [
              -3247.901,
              -7419.78,
              7835.36
            ],
            [
              -3243.942,
              -7487.756,
              7903.451
            ],
            [
              -3245.211,
              -7560.094,
              7975.799
            ],
            [
              -3250.692,
              -7652.395,
              8068.263
            ],
            [
              -3264.929,
              -7656.598,
              8083.109
            ],
            [
              -3295.862,
              -7658.283,
              8114.087
            ],
            [
              -3373.056,
              -7654.704,
              8191.364
            ],
            [
              -3460.119,
              -7663.2,
              8278.841
            ],
            [
              -3500.062,
              -7664.729,
              8318.813
            ],
            [
              -3625.916,
              -7682.569,
              8445.925
            ],
            [
              -3667.728,
              -7717.463,
              8500.384
            ],
            [
              -3709.931,
              -7737.878,
              8547.266
            ],
            [
              -3923.224,
              -7823.223,
              8776.999
            ],
            [
              -4560.823,
              -8099.394,
              9471.84
            ],
            [
              -4675.933,
              -7868.088,
              9730.206
            ],
            [
              -4693.512,
              -7842.182,
              9761.514
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1158",
              "position": {
                "x": -2456.526,
                "z": -5595.784
              },
              "distanceAlongShapeM": 157.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 763.669,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 1248.695,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 1650.604,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 330,
              "departureOffsetSeconds": 330
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 2141.223,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 2411.587,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 2927.093,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 3405.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6783",
              "position": {
                "x": -156.753,
                "z": -6889.462
              },
              "distanceAlongShapeM": 4263.189,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7968",
              "position": {
                "x": -752.866,
                "z": -7235.995
              },
              "distanceAlongShapeM": 4966.428,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:18018",
              "position": {
                "x": -1047.829,
                "z": -7275.201
              },
              "distanceAlongShapeM": 5271.065,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9693",
              "position": {
                "x": -1952.594,
                "z": -7317.992
              },
              "distanceAlongShapeM": 6316.565,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:9970",
              "position": {
                "x": -2371.269,
                "z": -7508.706
              },
              "distanceAlongShapeM": 6785.508,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9496",
              "position": {
                "x": -2768.73,
                "z": -7557.34
              },
              "distanceAlongShapeM": 7203.784,
              "shapeOffsetM": 1.25,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:9815",
              "position": {
                "x": -3037.466,
                "z": -7388.964
              },
              "distanceAlongShapeM": 7614.3,
              "shapeOffsetM": 0.732,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:15551",
              "position": {
                "x": -3295.862,
                "z": -7658.283
              },
              "distanceAlongShapeM": 8114.087,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1590,
              "departureOffsetSeconds": 1590
            },
            {
              "stopId": "judu:stop:15561",
              "position": {
                "x": -3923.224,
                "z": -7823.223
              },
              "distanceAlongShapeM": 8776.999,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:15556",
              "position": {
                "x": -4693.512,
                "z": -7842.182
              },
              "distanceAlongShapeM": 9761.514,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            18660,
            20160,
            21660,
            23160,
            24660,
            26460,
            27960,
            29760,
            31560,
            33960,
            36360,
            38760,
            41160,
            43560,
            45960,
            48360,
            50760,
            53160,
            55260,
            56760,
            58560,
            60060,
            61860,
            63660,
            65460,
            67560,
            69960,
            72360,
            74760,
            76860,
            79260,
            81360
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_57:1",
          "sourceRouteId": "vilnius_bus_57",
          "sourceShapeId": "vilnius_bus_57_b-a",
          "directionId": 1,
          "headsign": "Fabijoniškės",
          "directionName": "Bukiškis–Bajorai–Jeruzalė–Ateities g.–Fabijoniškės",
          "mode": "bus",
          "routeShortName": "57",
          "routeLongName": "Fabijoniškės–Ateities g.–Jeruzalė–Bajorai–Bukiškis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4693.512,
              -7842.182,
              0
            ],
            [
              -4700.113,
              -7814.238,
              28.713
            ],
            [
              -4708.231,
              -7799.626,
              45.428
            ],
            [
              -4725.002,
              -7801.564,
              62.311
            ],
            [
              -4830.883,
              -7856.518,
              181.603
            ],
            [
              -4883.816,
              -7902.363,
              251.63
            ],
            [
              -4918.989,
              -7926.25,
              294.148
            ],
            [
              -4943.298,
              -7954.777,
              331.626
            ],
            [
              -4959.979,
              -7989,
              369.699
            ],
            [
              -4966.096,
              -8007.82,
              389.488
            ],
            [
              -4952.181,
              -8247.4,
              629.471
            ],
            [
              -4941.005,
              -8308.818,
              691.898
            ],
            [
              -4929.931,
              -8301.216,
              705.33
            ],
            [
              -4909.81,
              -8291.542,
              727.656
            ],
            [
              -4767.755,
              -8453.173,
              942.84
            ],
            [
              -4686.138,
              -8423.408,
              1029.716
            ],
            [
              -4493.951,
              -8327.644,
              1244.439
            ],
            [
              -4467.942,
              -8312.508,
              1274.532
            ],
            [
              -4467.164,
              -8304.729,
              1282.35
            ],
            [
              -4516.158,
              -8197.015,
              1400.684
            ],
            [
              -4542.477,
              -8155.372,
              1449.947
            ],
            [
              -4562.168,
              -8102.711,
              1506.169
            ],
            [
              -3871.136,
              -7789.619,
              2264.819
            ],
            [
              -3753.246,
              -7748.255,
              2389.755
            ],
            [
              -3718.98,
              -7739.947,
              2425.014
            ],
            [
              -3672.311,
              -7721.836,
              2475.075
            ],
            [
              -3618.817,
              -7681.58,
              2542.024
            ],
            [
              -3309.3,
              -7653.595,
              2852.804
            ],
            [
              -3271.151,
              -7644.244,
              2892.082
            ],
            [
              -3148.064,
              -7637.497,
              3015.353
            ],
            [
              -3089.299,
              -7627.397,
              3074.98
            ],
            [
              -3033.05,
              -7613.913,
              3132.822
            ],
            [
              -2961.217,
              -7592.912,
              3207.663
            ],
            [
              -2864.673,
              -7594.612,
              3304.221
            ],
            [
              -2807.917,
              -7588.933,
              3361.261
            ],
            [
              -2765.944,
              -7581.88,
              3403.822
            ],
            [
              -2725.784,
              -7568.117,
              3446.275
            ],
            [
              -2672.284,
              -7564.608,
              3499.89
            ],
            [
              -2424.106,
              -7511.11,
              3753.769
            ],
            [
              -2200.558,
              -7467.206,
              3981.587
            ],
            [
              -1983.025,
              -7327.469,
              4240.136
            ],
            [
              -1921.302,
              -7296.285,
              4309.289
            ],
            [
              -1857.241,
              -7278.502,
              4375.772
            ],
            [
              -1808.787,
              -7269.347,
              4425.083
            ],
            [
              -1791.249,
              -7260.755,
              4444.613
            ],
            [
              -1762.836,
              -7220.072,
              4494.235
            ],
            [
              -1726.38,
              -7161.722,
              4563.038
            ],
            [
              -1713.891,
              -7147.473,
              4581.985
            ],
            [
              -1706.433,
              -7126.455,
              4604.287
            ],
            [
              -1690.122,
              -7114.501,
              4624.51
            ],
            [
              -1672.882,
              -7122.602,
              4643.558
            ],
            [
              -1630.537,
              -7131.152,
              4686.757
            ],
            [
              -1593.243,
              -7134.045,
              4724.164
            ],
            [
              -1568.683,
              -7128.919,
              4749.253
            ],
            [
              -1548.788,
              -7132.615,
              4769.488
            ],
            [
              -1518.794,
              -7147.624,
              4803.028
            ],
            [
              -1410.181,
              -7230.837,
              4939.854
            ],
            [
              -1380.891,
              -7249.174,
              4974.41
            ],
            [
              -1311.07,
              -7269.352,
              5047.088
            ],
            [
              -1233.406,
              -7282.993,
              5125.941
            ],
            [
              -1124.102,
              -7291.639,
              5235.586
            ],
            [
              -1082.888,
              -7291.268,
              5276.803
            ],
            [
              -1077.698,
              -7289.135,
              5282.413
            ],
            [
              -1076.694,
              -7269.115,
              5302.459
            ],
            [
              -1062.473,
              -7266.031,
              5317.01
            ],
            [
              -1045.114,
              -7267.457,
              5334.428
            ],
            [
              -1002.208,
              -7280.476,
              5379.265
            ],
            [
              -979.66,
              -7279.769,
              5401.824
            ],
            [
              -935.71,
              -7270.543,
              5446.733
            ],
            [
              -707.406,
              -7214.553,
              5681.801
            ],
            [
              -684.153,
              -7210.52,
              5705.401
            ],
            [
              -567.625,
              -7175.894,
              5826.965
            ],
            [
              -492.955,
              -7141.624,
              5909.124
            ],
            [
              -472.94,
              -7138.647,
              5929.359
            ],
            [
              -433.975,
              -7120.429,
              5972.372
            ],
            [
              -356.786,
              -7053.923,
              6074.261
            ],
            [
              -147.918,
              -6864.018,
              6356.554
            ],
            [
              -119.568,
              -6827.798,
              6402.55
            ],
            [
              -100.778,
              -6821.461,
              6422.38
            ],
            [
              -58.991,
              -6789.938,
              6474.724
            ],
            [
              -47.763,
              -6774.558,
              6493.767
            ],
            [
              -41.021,
              -6757.982,
              6511.661
            ],
            [
              -44.133,
              -6716.735,
              6553.025
            ],
            [
              -50.829,
              -6695.462,
              6575.327
            ],
            [
              -48.526,
              -6639.841,
              6630.995
            ],
            [
              -52.099,
              -6588.567,
              6682.394
            ],
            [
              -70.555,
              -6505.85,
              6767.144
            ],
            [
              -125.166,
              -6286.66,
              6993.036
            ],
            [
              -158.525,
              -6137.991,
              7145.401
            ],
            [
              -182.398,
              -6069.649,
              7217.793
            ],
            [
              -186.217,
              -6031.729,
              7255.905
            ],
            [
              -210.448,
              -5912.171,
              7377.894
            ],
            [
              -214.688,
              -5861.998,
              7428.245
            ],
            [
              -215.425,
              -5796.303,
              7493.944
            ],
            [
              -210.007,
              -5746.306,
              7544.234
            ],
            [
              -195.772,
              -5671.978,
              7619.913
            ],
            [
              -200.158,
              -5665.219,
              7627.971
            ],
            [
              -245.834,
              -5662.161,
              7673.749
            ],
            [
              -275.515,
              -5664.961,
              7703.561
            ],
            [
              -299.862,
              -5657.84,
              7728.928
            ],
            [
              -394.957,
              -5644.98,
              7824.89
            ],
            [
              -428.258,
              -5634.356,
              7859.844
            ],
            [
              -633.019,
              -5523.775,
              8092.557
            ],
            [
              -663.705,
              -5510.974,
              8125.806
            ],
            [
              -740.836,
              -5466.163,
              8215.009
            ],
            [
              -765.768,
              -5455.693,
              8242.05
            ],
            [
              -887.614,
              -5390.039,
              8380.459
            ],
            [
              -927.257,
              -5373.739,
              8423.323
            ],
            [
              -1090.384,
              -5275.062,
              8613.973
            ],
            [
              -1302.999,
              -5205.56,
              8837.659
            ],
            [
              -1387.604,
              -5181.778,
              8925.543
            ],
            [
              -1666.095,
              -5013.148,
              9251.109
            ],
            [
              -1677.043,
              -5012.953,
              9262.059
            ],
            [
              -1696.959,
              -5045.994,
              9300.638
            ],
            [
              -1770.723,
              -5100.339,
              9392.259
            ],
            [
              -1793.54,
              -5115.517,
              9419.663
            ],
            [
              -1816.278,
              -5126.243,
              9444.804
            ],
            [
              -1840.927,
              -5135.823,
              9471.25
            ],
            [
              -1875.217,
              -5144.118,
              9506.528
            ],
            [
              -1904.939,
              -5149.154,
              9536.674
            ],
            [
              -2065.02,
              -5167.456,
              9697.798
            ],
            [
              -2110.315,
              -5178.897,
              9744.516
            ],
            [
              -2127.276,
              -5190.841,
              9765.26
            ],
            [
              -2143.028,
              -5207.26,
              9788.013
            ],
            [
              -2175.503,
              -5222.268,
              9823.788
            ],
            [
              -2204.955,
              -5248.463,
              9863.204
            ],
            [
              -2230.543,
              -5274.726,
              9899.872
            ],
            [
              -2374.125,
              -5489.26,
              10158.02
            ],
            [
              -2484.515,
              -5648.724,
              10351.965
            ],
            [
              -2512.326,
              -5691.648,
              10403.111
            ],
            [
              -2513.285,
              -5709.442,
              10420.932
            ],
            [
              -2528.468,
              -5730.325,
              10446.751
            ],
            [
              -2529.407,
              -5747.007,
              10463.459
            ],
            [
              -2525.623,
              -5751.527,
              10469.354
            ],
            [
              -2510.288,
              -5758.477,
              10486.191
            ],
            [
              -2498.658,
              -5756.456,
              10497.994
            ],
            [
              -2480.761,
              -5727.829,
              10531.755
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:15556",
              "position": {
                "x": -4693.512,
                "z": -7842.182
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15202",
              "position": {
                "x": -4542.477,
                "z": -8155.372
              },
              "distanceAlongShapeM": 1449.947,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:15558",
              "position": {
                "x": -3871.136,
                "z": -7789.619
              },
              "distanceAlongShapeM": 2264.819,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:15550",
              "position": {
                "x": -3271.151,
                "z": -7644.244
              },
              "distanceAlongShapeM": 2892.082,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:15548",
              "position": {
                "x": -2725.784,
                "z": -7568.117
              },
              "distanceAlongShapeM": 3446.275,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:9971",
              "position": {
                "x": -2424.106,
                "z": -7511.11
              },
              "distanceAlongShapeM": 3753.769,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:9694",
              "position": {
                "x": -1983.025,
                "z": -7327.469
              },
              "distanceAlongShapeM": 4240.136,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7052",
              "position": {
                "x": -1045.114,
                "z": -7267.457
              },
              "distanceAlongShapeM": 5334.428,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:8326",
              "position": {
                "x": -492.955,
                "z": -7141.624
              },
              "distanceAlongShapeM": 5909.124,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:8327",
              "position": {
                "x": -119.568,
                "z": -6827.798
              },
              "distanceAlongShapeM": 6402.55,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 6575.327,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 7217.793,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 7703.561,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 8125.806,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5822",
              "position": {
                "x": -927.257,
                "z": -5373.739
              },
              "distanceAlongShapeM": 8423.323,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 8925.543,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 9300.638,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6915",
              "position": {
                "x": -2143.028,
                "z": -5207.26
              },
              "distanceAlongShapeM": 9788.013,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5512",
              "position": {
                "x": -2513.285,
                "z": -5709.442
              },
              "distanceAlongShapeM": 10420.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            }
          ],
          "departuresSeconds": [
            20400,
            21900,
            23400,
            24900,
            26400,
            28380,
            29880,
            31560,
            33300,
            35760,
            38160,
            40620,
            42900,
            45360,
            47820,
            50220,
            52620,
            55020,
            57120,
            58680,
            60420,
            61980,
            63780,
            65640,
            67440,
            69420,
            71760,
            74160,
            76440,
            78540,
            80940,
            83100
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_58",
      "sourceRouteId": "vilnius_bus_58",
      "mode": "bus",
      "shortName": "58",
      "longName": "Stotis–Dzūkų g.–Minsko pl.–Kalnėnai–Guriai–Grigaičiai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_58:0",
          "sourceRouteId": "vilnius_bus_58",
          "sourceShapeId": "vilnius_bus_58_a-b",
          "directionId": 0,
          "headsign": "Grigaičiai",
          "directionName": "Stotis–Dzūkų g.–Minsko pl.–Kalnėnai–Guriai–Grigaičiai",
          "mode": "bus",
          "routeShortName": "58",
          "routeLongName": "Stotis–Dzūkų g.–Minsko pl.–Kalnėnai–Guriai–Grigaičiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              379.597,
              1946.537,
              0
            ],
            [
              374.762,
              1964.437,
              18.541
            ],
            [
              365.352,
              1979.081,
              35.948
            ],
            [
              363.579,
              1988.02,
              45.061
            ],
            [
              364.971,
              1993.56,
              50.773
            ],
            [
              373.539,
              2003.423,
              63.838
            ],
            [
              379.385,
              2005.542,
              70.056
            ],
            [
              392.284,
              2005.307,
              82.958
            ],
            [
              471.993,
              1953.753,
              177.885
            ],
            [
              476.99,
              1944.756,
              188.177
            ],
            [
              476.827,
              1935.853,
              197.081
            ],
            [
              481.158,
              1925.755,
              208.069
            ],
            [
              623.161,
              1858.587,
              365.157
            ],
            [
              825.163,
              1791.425,
              578.03
            ],
            [
              862.14,
              1837.501,
              637.11
            ],
            [
              756.914,
              1939.625,
              783.745
            ],
            [
              745.631,
              1957.644,
              805.005
            ],
            [
              722.942,
              1987.005,
              842.11
            ],
            [
              680.883,
              2015.607,
              892.974
            ],
            [
              612.97,
              2076.967,
              984.501
            ],
            [
              575.791,
              2125.517,
              1045.652
            ],
            [
              554.513,
              2161.53,
              1087.481
            ],
            [
              539.42,
              2182.958,
              1113.691
            ],
            [
              519.811,
              2204.469,
              1142.798
            ],
            [
              468.195,
              2239.923,
              1205.417
            ],
            [
              433.065,
              2259.491,
              1245.63
            ],
            [
              406.177,
              2271.115,
              1274.923
            ],
            [
              348.251,
              2314.476,
              1347.28
            ],
            [
              296.511,
              2343.252,
              1406.484
            ],
            [
              241.342,
              2360.957,
              1464.424
            ],
            [
              16.426,
              2411.811,
              1695.017
            ],
            [
              -125.342,
              2457.804,
              1844.06
            ],
            [
              -108.387,
              2503.138,
              1892.461
            ],
            [
              -88.347,
              2540.623,
              1934.967
            ],
            [
              -50.951,
              2574.454,
              1985.395
            ],
            [
              -26.378,
              2577.347,
              2010.138
            ],
            [
              62.585,
              2608.012,
              2104.238
            ],
            [
              140.019,
              2643.338,
              2189.349
            ],
            [
              191.691,
              2681.359,
              2253.502
            ],
            [
              216.265,
              2684.251,
              2278.246
            ],
            [
              299.909,
              2706.103,
              2364.696
            ],
            [
              363.854,
              2709.388,
              2428.726
            ],
            [
              542.423,
              2699.443,
              2607.572
            ],
            [
              613.119,
              2683.676,
              2680.004
            ],
            [
              640.253,
              2685.405,
              2707.194
            ],
            [
              659.423,
              2675.035,
              2728.989
            ],
            [
              708.204,
              2660.781,
              2779.81
            ],
            [
              908.397,
              2633.726,
              2981.823
            ],
            [
              971.677,
              2635.902,
              3045.14
            ],
            [
              1005.385,
              2644.187,
              3079.852
            ],
            [
              1058.795,
              2671.034,
              3139.629
            ],
            [
              1076.94,
              2675.153,
              3158.236
            ],
            [
              1206.381,
              2730.654,
              3299.074
            ],
            [
              1376.192,
              2805.444,
              3484.625
            ],
            [
              1395.147,
              2818.452,
              3507.615
            ],
            [
              1465.314,
              2843.871,
              3582.244
            ],
            [
              1478.278,
              2846.971,
              3595.573
            ],
            [
              1505.249,
              2839.792,
              3623.484
            ],
            [
              1568.191,
              2893.175,
              3706.015
            ],
            [
              1642.261,
              2989.766,
              3827.737
            ],
            [
              1688.949,
              3071.28,
              3921.674
            ],
            [
              1698.766,
              3113.401,
              3964.924
            ],
            [
              1697.905,
              3171.305,
              4022.835
            ],
            [
              1701.978,
              3216.872,
              4068.584
            ],
            [
              1702.066,
              3325.968,
              4177.679
            ],
            [
              1699.765,
              3410.617,
              4262.359
            ],
            [
              1687.827,
              3497.671,
              4350.228
            ],
            [
              1676.946,
              3606.97,
              4460.068
            ],
            [
              1678.691,
              3631.429,
              4484.589
            ],
            [
              1674.798,
              3769.542,
              4622.757
            ],
            [
              1682.185,
              3784.991,
              4639.881
            ],
            [
              1743.856,
              3803.884,
              4704.38
            ],
            [
              1812.124,
              3830.447,
              4777.635
            ],
            [
              1876.708,
              3867.097,
              4851.893
            ],
            [
              2082.225,
              4019.124,
              5107.528
            ],
            [
              2137.697,
              4051.487,
              5171.75
            ],
            [
              3783.191,
              4734.089,
              6953.21
            ],
            [
              4094.837,
              4859.518,
              7289.15
            ],
            [
              4105.015,
              4851.531,
              7302.087
            ],
            [
              4106.76,
              4841.478,
              7312.29
            ],
            [
              3917.274,
              4757.143,
              7519.697
            ],
            [
              3791.824,
              4712.774,
              7652.761
            ],
            [
              2822.207,
              4305.846,
              8704.307
            ],
            [
              2770.246,
              4289.011,
              8758.927
            ],
            [
              2807.11,
              4258.26,
              8806.932
            ],
            [
              2948.179,
              4207.737,
              8956.776
            ],
            [
              2964.832,
              4200.744,
              8974.837
            ],
            [
              2982.066,
              4190.4,
              8994.938
            ],
            [
              3009.186,
              4156.492,
              9038.357
            ],
            [
              3087.299,
              4088.224,
              9142.097
            ],
            [
              3136.062,
              4038.321,
              9211.87
            ],
            [
              3298.984,
              3915.013,
              9416.194
            ],
            [
              3424.471,
              3792.407,
              9591.634
            ],
            [
              3464.987,
              3750.45,
              9649.96
            ],
            [
              3527.875,
              3696.935,
              9732.536
            ],
            [
              3577.19,
              3642.564,
              9805.94
            ],
            [
              3587.716,
              3618.986,
              9831.761
            ],
            [
              3606.524,
              3589.684,
              9866.579
            ],
            [
              3645.64,
              3542.185,
              9928.112
            ],
            [
              3678.515,
              3505.937,
              9977.048
            ],
            [
              3704.98,
              3472.036,
              10020.055
            ],
            [
              3738.636,
              3409.055,
              10091.465
            ],
            [
              3768.579,
              3320.539,
              10184.909
            ],
            [
              3800.616,
              3274.286,
              10241.173
            ],
            [
              3830.367,
              3243.662,
              10283.869
            ],
            [
              3851.689,
              3210.972,
              10322.898
            ],
            [
              3863.893,
              3174.002,
              10361.83
            ],
            [
              3887.359,
              3084.495,
              10454.362
            ],
            [
              3905.823,
              3037.387,
              10504.96
            ],
            [
              3931.529,
              2930.025,
              10615.357
            ],
            [
              3985.636,
              2755.326,
              10798.242
            ],
            [
              4071.321,
              2781.522,
              10887.843
            ],
            [
              4105.66,
              2788.66,
              10922.916
            ],
            [
              4139.27,
              2791.357,
              10956.634
            ],
            [
              4163.33,
              2800.917,
              10982.524
            ],
            [
              4290.348,
              2828.546,
              11112.511
            ],
            [
              5092.806,
              3043.566,
              11943.278
            ],
            [
              5121.945,
              3048.569,
              11972.843
            ],
            [
              5292.05,
              3067.545,
              12144.004
            ],
            [
              5437.255,
              3100.357,
              12292.869
            ],
            [
              5500.224,
              3119.175,
              12358.59
            ],
            [
              5591.84,
              3150.794,
              12455.509
            ],
            [
              5667.349,
              3183.839,
              12537.932
            ],
            [
              5815.206,
              3219.927,
              12690.13
            ],
            [
              6262.852,
              3304.704,
              13145.732
            ],
            [
              6335.309,
              3313.305,
              13218.698
            ],
            [
              6385.83,
              3322.335,
              13270.02
            ],
            [
              6562.995,
              3305.501,
              13447.983
            ],
            [
              7048.001,
              3287.047,
              13933.34
            ],
            [
              7156.927,
              3279.329,
              14042.539
            ],
            [
              7273.017,
              3274.806,
              14158.717
            ],
            [
              7362.185,
              3279.72,
              14248.02
            ],
            [
              7395.288,
              3289.084,
              14282.422
            ],
            [
              7495,
              3304.919,
              14383.383
            ],
            [
              7571.128,
              3335.693,
              14465.496
            ],
            [
              7671.041,
              3361.54,
              14568.698
            ],
            [
              7846.818,
              3437.086,
              14760.022
            ],
            [
              8259.242,
              3596.959,
              15202.349
            ],
            [
              8336.715,
              3629.921,
              15286.543
            ],
            [
              8540.995,
              3709.322,
              15505.711
            ],
            [
              8552.922,
              3724.669,
              15525.147
            ],
            [
              8562.757,
              3732.265,
              15537.574
            ],
            [
              8573.726,
              3732.044,
              15548.545
            ],
            [
              8583.316,
              3727.399,
              15559.201
            ],
            [
              8585.028,
              3716.232,
              15570.499
            ],
            [
              8582.268,
              3707.381,
              15579.77
            ],
            [
              8567.76,
              3692.086,
              15600.851
            ],
            [
              8652.84,
              3428.755,
              15877.585
            ],
            [
              8779.774,
              3128.955,
              16203.15
            ],
            [
              8815.688,
              3021.356,
              16316.584
            ],
            [
              8867.108,
              2786.53,
              16556.974
            ],
            [
              8886.289,
              2681.494,
              16663.747
            ],
            [
              8907.023,
              2557.501,
              16789.462
            ],
            [
              8905.128,
              2527.48,
              16819.542
            ],
            [
              8912.179,
              2525.112,
              16826.98
            ],
            [
              8920.296,
              2511.588,
              16842.752
            ],
            [
              8924.834,
              2512.61,
              16847.404
            ],
            [
              8921.939,
              2497.083,
              16863.199
            ],
            [
              8900.074,
              2500.863,
              16885.389
            ],
            [
              8891.727,
              2470.972,
              16916.423
            ],
            [
              8858.803,
              2310.209,
              17080.524
            ],
            [
              8847.277,
              2282.609,
              17110.434
            ],
            [
              8731.774,
              2154.679,
              17282.791
            ],
            [
              8712.486,
              2126.121,
              17317.251
            ],
            [
              8701.741,
              2105.185,
              17340.784
            ],
            [
              8693.016,
              2056.376,
              17390.367
            ],
            [
              8691.4,
              1943.966,
              17502.789
            ],
            [
              8696.422,
              1904.9,
              17542.176
            ],
            [
              8697.659,
              1838.078,
              17609.01
            ],
            [
              8710.273,
              1695.323,
              17752.321
            ],
            [
              8719.119,
              1653.953,
              17794.626
            ],
            [
              8801.992,
              1411.814,
              18050.554
            ],
            [
              8821.879,
              1310.104,
              18154.191
            ],
            [
              8853.015,
              1062.325,
              18403.918
            ],
            [
              8847.98,
              1004.536,
              18461.926
            ],
            [
              8828.842,
              919.198,
              18549.384
            ],
            [
              8792.266,
              800.812,
              18673.291
            ],
            [
              8730.298,
              670.691,
              18817.414
            ],
            [
              8715.861,
              626.45,
              18863.951
            ],
            [
              8701.178,
              569.968,
              18922.311
            ],
            [
              8695.263,
              564.52,
              18930.352
            ],
            [
              8686.836,
              562.463,
              18939.027
            ],
            [
              8674.208,
              576.077,
              18957.595
            ],
            [
              8678.901,
              584.889,
              18967.578
            ],
            [
              8686.728,
              589.185,
              18976.507
            ],
            [
              8721.736,
              661.957,
              19057.262
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3617",
              "position": {
                "x": 379.597,
                "z": 1946.537
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6005",
              "position": {
                "x": 756.914,
                "z": 1939.625
              },
              "distanceAlongShapeM": 783.745,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6008",
              "position": {
                "x": 406.177,
                "z": 2271.115
              },
              "distanceAlongShapeM": 1274.923,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6012",
              "position": {
                "x": -50.951,
                "z": 2574.454
              },
              "distanceAlongShapeM": 1985.395,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6014",
              "position": {
                "x": 191.691,
                "z": 2681.359
              },
              "distanceAlongShapeM": 2253.502,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6017",
              "position": {
                "x": 640.253,
                "z": 2685.405
              },
              "distanceAlongShapeM": 2707.194,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6019",
              "position": {
                "x": 1058.795,
                "z": 2671.034
              },
              "distanceAlongShapeM": 3139.629,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5948",
              "position": {
                "x": 1395.147,
                "z": 2818.452
              },
              "distanceAlongShapeM": 3507.615,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:16977",
              "position": {
                "x": 1743.856,
                "z": 3803.884
              },
              "distanceAlongShapeM": 4704.38,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:616",
              "position": {
                "x": 2873.526,
                "z": 4357.203
              },
              "distanceAlongShapeM": 5968.561,
              "shapeOffsetM": 0.435,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6121",
              "position": {
                "x": 3917.274,
                "z": 4757.143
              },
              "distanceAlongShapeM": 7519.697,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:617",
              "position": {
                "x": 2822.207,
                "z": 4305.846
              },
              "distanceAlongShapeM": 8704.307,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:16920",
              "position": {
                "x": 3009.186,
                "z": 4156.492
              },
              "distanceAlongShapeM": 9038.357,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1230,
              "departureOffsetSeconds": 1230
            },
            {
              "stopId": "judu:stop:9593",
              "position": {
                "x": 3527.875,
                "z": 3696.935
              },
              "distanceAlongShapeM": 9732.536,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9660",
              "position": {
                "x": 3905.823,
                "z": 3037.387
              },
              "distanceAlongShapeM": 10504.96,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7710",
              "position": {
                "x": 4207.39,
                "z": 2810.094
              },
              "distanceAlongShapeM": 11027.527,
              "shapeOffsetM": 0.397,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7711",
              "position": {
                "x": 4689.298,
                "z": 2935.561
              },
              "distanceAlongShapeM": 11525.565,
              "shapeOffsetM": 0.111,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7819",
              "position": {
                "x": 5061.022,
                "z": 3035.273
              },
              "distanceAlongShapeM": 11910.43,
              "shapeOffsetM": 0.217,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7714",
              "position": {
                "x": 5327.727,
                "z": 3076.874
              },
              "distanceAlongShapeM": 12180.86,
              "shapeOffsetM": 1.236,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:16231",
              "position": {
                "x": 5667.349,
                "z": 3183.839
              },
              "distanceAlongShapeM": 12537.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:16171",
              "position": {
                "x": 6385.83,
                "z": 3322.335
              },
              "distanceAlongShapeM": 13270.02,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:16174",
              "position": {
                "x": 7571.128,
                "z": 3335.693
              },
              "distanceAlongShapeM": 14465.496,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:4965",
              "position": {
                "x": 8920.296,
                "z": 2511.588
              },
              "distanceAlongShapeM": 16842.752,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6030",
              "position": {
                "x": 8696.422,
                "z": 1904.9
              },
              "distanceAlongShapeM": 17542.176,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7357",
              "position": {
                "x": 8821.879,
                "z": 1310.104
              },
              "distanceAlongShapeM": 18154.191,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6032",
              "position": {
                "x": 8721.736,
                "z": 661.957
              },
              "distanceAlongShapeM": 19057.262,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            }
          ],
          "departuresSeconds": [
            18720,
            22320,
            24240,
            26040,
            28440,
            32100,
            33900,
            37740,
            39900,
            43620,
            45840,
            49560,
            51660,
            55380,
            56880,
            58740,
            61080,
            63060,
            65280,
            67260,
            72420,
            76380,
            78480,
            81480
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_58:1",
          "sourceRouteId": "vilnius_bus_58",
          "sourceShapeId": "vilnius_bus_58_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Grigaičiai–Guriai–Kalnėnai–Minsko pl.–Dzūkų g.–Stotis",
          "mode": "bus",
          "routeShortName": "58",
          "routeLongName": "Stotis–Dzūkų g.–Minsko pl.–Kalnėnai–Guriai–Grigaičiai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              8721.736,
              661.957,
              0
            ],
            [
              8760.458,
              726.862,
              75.578
            ],
            [
              8819.472,
              870.402,
              230.775
            ],
            [
              8847.419,
              976.715,
              340.7
            ],
            [
              8854.075,
              1018.886,
              383.393
            ],
            [
              8852.191,
              1053.436,
              417.994
            ],
            [
              8817.758,
              1265.655,
              632.989
            ],
            [
              8821.341,
              1283.395,
              651.088
            ],
            [
              8818.744,
              1314.62,
              682.42
            ],
            [
              8804.414,
              1403.972,
              772.914
            ],
            [
              8726.321,
              1627.089,
              1009.303
            ],
            [
              8709.628,
              1695.336,
              1079.562
            ],
            [
              8696.749,
              1857.022,
              1241.76
            ],
            [
              8689.636,
              1888.337,
              1273.873
            ],
            [
              8690.755,
              1943.979,
              1329.526
            ],
            [
              8687.807,
              2021.969,
              1407.571
            ],
            [
              8697.822,
              2070.752,
              1457.372
            ],
            [
              8713.888,
              2131.66,
              1520.363
            ],
            [
              8739.783,
              2167.877,
              1564.886
            ],
            [
              8789.814,
              2216.968,
              1634.978
            ],
            [
              8839.29,
              2270.523,
              1707.889
            ],
            [
              8861.119,
              2329.088,
              1770.39
            ],
            [
              8872.786,
              2395.65,
              1837.967
            ],
            [
              8890.213,
              2459.87,
              1904.51
            ],
            [
              8901.773,
              2553.154,
              1998.507
            ],
            [
              8885.791,
              2624.726,
              2071.842
            ],
            [
              8865.706,
              2780.991,
              2229.393
            ],
            [
              8820.289,
              2993.431,
              2446.633
            ],
            [
              8799.142,
              3065.107,
              2521.363
            ],
            [
              8682.177,
              3346.895,
              2826.462
            ],
            [
              8619.988,
              3528.497,
              3018.418
            ],
            [
              8578.905,
              3668.483,
              3164.307
            ],
            [
              8566.693,
              3703.24,
              3201.147
            ],
            [
              8548.693,
              3706.941,
              3219.524
            ],
            [
              8501.01,
              3678.953,
              3274.815
            ],
            [
              8306.055,
              3613.835,
              3480.357
            ],
            [
              7726.948,
              3381.581,
              4104.301
            ],
            [
              7652.688,
              3347.433,
              4186.037
            ],
            [
              7501.876,
              3293.65,
              4346.152
            ],
            [
              7380.917,
              3280.462,
              4467.827
            ],
            [
              7211.768,
              3278.244,
              4636.991
            ],
            [
              6350.083,
              3309.676,
              5499.25
            ],
            [
              6258.117,
              3293.664,
              5592.598
            ],
            [
              6181.877,
              3289.589,
              5668.948
            ],
            [
              5984.894,
              3250.018,
              5869.866
            ],
            [
              5854.069,
              3226.963,
              6002.707
            ],
            [
              5699.028,
              3186.563,
              6162.926
            ],
            [
              5544.977,
              3130.552,
              6326.842
            ],
            [
              5478.718,
              3108.459,
              6396.688
            ],
            [
              5367.813,
              3080.551,
              6511.05
            ],
            [
              5288.781,
              3065.382,
              6591.524
            ],
            [
              5197.6,
              3056.013,
              6683.186
            ],
            [
              5165.858,
              3049.947,
              6715.502
            ],
            [
              5102.461,
              3042.266,
              6779.362
            ],
            [
              4671.063,
              2927.005,
              7225.893
            ],
            [
              4139.27,
              2791.357,
              7774.714
            ],
            [
              4071.945,
              2780.397,
              7842.926
            ],
            [
              4054.293,
              2768.488,
              7864.219
            ],
            [
              4027.135,
              2765.667,
              7891.523
            ],
            [
              3985.636,
              2755.326,
              7934.291
            ],
            [
              3953.048,
              2873.952,
              8057.312
            ],
            [
              3930.43,
              2940.065,
              8127.187
            ],
            [
              3900.799,
              3010.764,
              8203.845
            ],
            [
              3859.028,
              3189.68,
              8387.572
            ],
            [
              3859.134,
              3195.245,
              8393.137
            ],
            [
              3830.367,
              3243.662,
              8449.456
            ],
            [
              3797.453,
              3277.686,
              8496.795
            ],
            [
              3777.961,
              3304.775,
              8530.168
            ],
            [
              3765.501,
              3328.39,
              8556.868
            ],
            [
              3756.892,
              3350.819,
              8580.893
            ],
            [
              3740.466,
              3403.454,
              8636.031
            ],
            [
              3714.362,
              3456.273,
              8694.949
            ],
            [
              3678.515,
              3505.937,
              8756.199
            ],
            [
              3619.09,
              3571.634,
              8844.784
            ],
            [
              3595.247,
              3607.71,
              8888.028
            ],
            [
              3587.176,
              3624.562,
              8906.713
            ],
            [
              3502.858,
              3705.202,
              9023.384
            ],
            [
              3424.471,
              3792.407,
              9140.642
            ],
            [
              3347.764,
              3866.221,
              9247.095
            ],
            [
              3289.347,
              3917.422,
              9324.775
            ],
            [
              3181.247,
              4004.071,
              9463.316
            ],
            [
              3069.21,
              4087.452,
              9602.976
            ],
            [
              3026.126,
              4130.568,
              9663.927
            ],
            [
              2995.262,
              4171.226,
              9714.974
            ],
            [
              2976.883,
              4189.384,
              9740.81
            ],
            [
              2942.434,
              4211.185,
              9781.577
            ],
            [
              2862.876,
              4237.173,
              9865.272
            ],
            [
              2800.72,
              4261.72,
              9932.1
            ],
            [
              2770.892,
              4288.999,
              9972.521
            ],
            [
              2015.642,
              3944.664,
              10802.562
            ],
            [
              1923.333,
              3875.135,
              10918.127
            ],
            [
              1866.512,
              3839.455,
              10985.221
            ],
            [
              1783.696,
              3794.238,
              11079.577
            ],
            [
              1749.936,
              3783.733,
              11114.934
            ],
            [
              1707.019,
              3766.718,
              11161.101
            ],
            [
              1679.129,
              3759.443,
              11189.924
            ],
            [
              1684.234,
              3721.498,
              11228.211
            ],
            [
              1695.827,
              3441.86,
              11508.089
            ],
            [
              1706.996,
              3348.141,
              11602.471
            ],
            [
              1706.2,
              3235.719,
              11714.896
            ],
            [
              1703.36,
              3152.279,
              11798.385
            ],
            [
              1697.873,
              3100.058,
              11850.893
            ],
            [
              1688.949,
              3071.28,
              11881.023
            ],
            [
              1673.368,
              3031.492,
              11923.753
            ],
            [
              1650.731,
              2994.062,
              11967.496
            ],
            [
              1615.61,
              2944.618,
              12028.144
            ],
            [
              1601.066,
              2925.963,
              12051.799
            ],
            [
              1567.546,
              2893.187,
              12098.68
            ],
            [
              1513.094,
              2845.213,
              12171.251
            ],
            [
              1498.174,
              2841.037,
              12186.744
            ],
            [
              1486.04,
              2847.941,
              12200.705
            ],
            [
              1444.986,
              2826.436,
              12247.05
            ],
            [
              1406.053,
              2814.911,
              12287.653
            ],
            [
              1368.348,
              2800.023,
              12328.191
            ],
            [
              1087.927,
              2676.064,
              12634.788
            ],
            [
              965.707,
              2627.106,
              12766.449
            ],
            [
              940.631,
              2632.02,
              12792.002
            ],
            [
              813.733,
              2644.372,
              12919.499
            ],
            [
              708.204,
              2660.781,
              13026.296
            ],
            [
              612.412,
              2680.349,
              13124.067
            ],
            [
              577.598,
              2682.1,
              13158.925
            ],
            [
              552.602,
              2691.464,
              13185.617
            ],
            [
              433.484,
              2705.889,
              13305.606
            ],
            [
              299.909,
              2706.103,
              13439.181
            ],
            [
              261.02,
              2696.793,
              13479.168
            ],
            [
              216.204,
              2680.913,
              13526.715
            ],
            [
              193.403,
              2669.083,
              13552.402
            ],
            [
              159.372,
              2642.986,
              13595.288
            ],
            [
              43.03,
              2597.236,
              13720.302
            ],
            [
              -51.133,
              2564.438,
              13820.013
            ],
            [
              -80.002,
              2538.245,
              13858.994
            ],
            [
              -88.167,
              2515.016,
              13883.616
            ],
            [
              -110.666,
              2484.254,
              13921.727
            ],
            [
              -125.342,
              2457.804,
              13951.977
            ],
            [
              111.529,
              2390.041,
              14198.35
            ],
            [
              232.331,
              2362.235,
              14322.312
            ],
            [
              296.511,
              2343.252,
              14389.24
            ],
            [
              445.925,
              2257.029,
              14561.747
            ],
            [
              475.413,
              2246.471,
              14593.068
            ],
            [
              490.608,
              2230.608,
              14615.035
            ],
            [
              521.142,
              2206.671,
              14653.833
            ],
            [
              550.785,
              2169.391,
              14701.462
            ],
            [
              572.709,
              2133.366,
              14743.633
            ],
            [
              601.666,
              2093.873,
              14792.605
            ],
            [
              681.508,
              2014.483,
              14905.2
            ],
            [
              722.942,
              1987.005,
              14954.918
            ],
            [
              765.401,
              1945.036,
              15014.618
            ],
            [
              782.59,
              1932.474,
              15035.908
            ],
            [
              796.433,
              1913.295,
              15059.561
            ],
            [
              837.497,
              1865.785,
              15122.358
            ],
            [
              846.404,
              1858.942,
              15133.591
            ],
            [
              858.557,
              1853.152,
              15147.052
            ],
            [
              865.733,
              1857.473,
              15155.429
            ],
            [
              873.237,
              1879.6,
              15178.793
            ],
            [
              883.178,
              1893.889,
              15196.2
            ],
            [
              897.572,
              1904.757,
              15214.236
            ],
            [
              910.472,
              1904.52,
              15227.138
            ],
            [
              916.84,
              1899.949,
              15234.976
            ],
            [
              917.259,
              1887.696,
              15247.236
            ],
            [
              913.932,
              1882.191,
              15253.669
            ],
            [
              888.993,
              1859.272,
              15287.54
            ],
            [
              862.14,
              1837.501,
              15322.11
            ],
            [
              825.163,
              1791.425,
              15381.189
            ],
            [
              623.161,
              1858.587,
              15594.062
            ],
            [
              599.379,
              1863.475,
              15618.342
            ],
            [
              535.995,
              1890.241,
              15687.146
            ],
            [
              493.148,
              1911.064,
              15734.784
            ],
            [
              476.562,
              1921.386,
              15754.32
            ],
            [
              453.967,
              1920.686,
              15776.926
            ],
            [
              432.764,
              1925.527,
              15798.675
            ],
            [
              422.444,
              1925.716,
              15808.996
            ],
            [
              419.803,
              1922.424,
              15813.216
            ],
            [
              401.805,
              1926.093,
              15831.585
            ],
            [
              397.27,
              1925.063,
              15836.235
            ],
            [
              384.004,
              1905.267,
              15860.065
            ],
            [
              372.531,
              1877.646,
              15889.974
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6032",
              "position": {
                "x": 8721.736,
                "z": 661.957
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7356",
              "position": {
                "x": 8817.758,
                "z": 1265.655
              },
              "distanceAlongShapeM": 632.989,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6029",
              "position": {
                "x": 8689.636,
                "z": 1888.337
              },
              "distanceAlongShapeM": 1273.873,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:16179",
              "position": {
                "x": 8885.791,
                "z": 2624.726
              },
              "distanceAlongShapeM": 2071.842,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:16175",
              "position": {
                "x": 8501.01,
                "z": 3678.953
              },
              "distanceAlongShapeM": 3274.815,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:16173",
              "position": {
                "x": 7501.876,
                "z": 3293.65
              },
              "distanceAlongShapeM": 4346.152,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:16169",
              "position": {
                "x": 6258.117,
                "z": 3293.664
              },
              "distanceAlongShapeM": 5592.598,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:16230",
              "position": {
                "x": 5544.977,
                "z": 3130.552
              },
              "distanceAlongShapeM": 6326.842,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7715",
              "position": {
                "x": 5288.781,
                "z": 3065.382
              },
              "distanceAlongShapeM": 6591.524,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7818",
              "position": {
                "x": 5046.033,
                "z": 3027.77
              },
              "distanceAlongShapeM": 6837.621,
              "shapeOffsetM": 0.561,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7712",
              "position": {
                "x": 4671.063,
                "z": 2927.005
              },
              "distanceAlongShapeM": 7225.893,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6688",
              "position": {
                "x": 4054.293,
                "z": 2768.488
              },
              "distanceAlongShapeM": 7864.219,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9661",
              "position": {
                "x": 3900.799,
                "z": 3010.764
              },
              "distanceAlongShapeM": 8203.845,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9659",
              "position": {
                "x": 3502.858,
                "z": 3705.202
              },
              "distanceAlongShapeM": 9023.384,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:10614",
              "position": {
                "x": 3069.21,
                "z": 4087.452
              },
              "distanceAlongShapeM": 9602.976,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 11228.211,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:8365",
              "position": {
                "x": 1444.986,
                "z": 2826.436
              },
              "distanceAlongShapeM": 12247.05,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6020",
              "position": {
                "x": 965.707,
                "z": 2627.106
              },
              "distanceAlongShapeM": 12766.449,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6018",
              "position": {
                "x": 577.598,
                "z": 2682.1
              },
              "distanceAlongShapeM": 13158.925,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6015",
              "position": {
                "x": 159.372,
                "z": 2642.986
              },
              "distanceAlongShapeM": 13595.288,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6013",
              "position": {
                "x": -88.167,
                "z": 2515.016
              },
              "distanceAlongShapeM": 13883.616,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6009",
              "position": {
                "x": 475.413,
                "z": 2246.471
              },
              "distanceAlongShapeM": 14593.068,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6006",
              "position": {
                "x": 782.59,
                "z": 1932.474
              },
              "distanceAlongShapeM": 15035.908,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 15734.784,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            }
          ],
          "departuresSeconds": [
            21300,
            23160,
            25080,
            27420,
            29040,
            31500,
            34620,
            36840,
            40500,
            42720,
            46380,
            48660,
            52320,
            54240,
            58020,
            59700,
            61800,
            63840,
            66060,
            68280,
            70020,
            75120,
            79140,
            81180,
            84180
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_59",
      "sourceRouteId": "vilnius_bus_59",
      "mode": "bus",
      "shortName": "59",
      "longName": "Grigiškės–Lazdynai–Laisvės pr.–Žvėrynas",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_59:0",
          "sourceRouteId": "vilnius_bus_59",
          "sourceShapeId": "vilnius_bus_59_a-b",
          "directionId": 0,
          "headsign": "Žvėrynas",
          "directionName": "Grigiškės–Lazdynai–Laisvės pr.–Žvėrynas",
          "mode": "bus",
          "routeShortName": "59",
          "routeLongName": "Grigiškės–Lazdynai–Laisvės pr.–Žvėrynas",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -12592.773,
              1856.707,
              0
            ],
            [
              -12609.12,
              1842.488,
              21.666
            ],
            [
              -12646.157,
              1825.248,
              62.518
            ],
            [
              -12663.097,
              1814.378,
              82.646
            ],
            [
              -12644.743,
              1749.532,
              150.039
            ],
            [
              -12598.286,
              1666.443,
              245.234
            ],
            [
              -12567.852,
              1590.28,
              327.253
            ],
            [
              -12416.777,
              1640.266,
              486.382
            ],
            [
              -12254.88,
              1722.36,
              667.904
            ],
            [
              -12209.896,
              1752.832,
              722.237
            ],
            [
              -12156.769,
              1767.592,
              777.376
            ],
            [
              -12039.728,
              1826.999,
              908.631
            ],
            [
              -12150.225,
              2064.703,
              1170.763
            ],
            [
              -12150.767,
              2071.39,
              1177.472
            ],
            [
              -12148.083,
              2078.027,
              1184.631
            ],
            [
              -11899.757,
              2198.842,
              1460.787
            ],
            [
              -11702.181,
              2291.494,
              1679.009
            ],
            [
              -11379.703,
              2448.97,
              2037.883
            ],
            [
              -11340.826,
              2459.492,
              2078.159
            ],
            [
              -11266.123,
              2450.528,
              2153.398
            ],
            [
              -11225.137,
              2430.96,
              2198.815
            ],
            [
              -11206.711,
              2412.86,
              2224.644
            ],
            [
              -11189.627,
              2391.441,
              2252.041
            ],
            [
              -11131.53,
              2270.307,
              2386.387
            ],
            [
              -10763.651,
              2441.496,
              2792.147
            ],
            [
              -10394.145,
              2591.48,
              3190.933
            ],
            [
              -10234.129,
              2672.421,
              3370.255
            ],
            [
              -8792.209,
              3494.119,
              5029.87
            ],
            [
              -8699.614,
              3552.725,
              5139.453
            ],
            [
              -8570.058,
              3621.859,
              5286.301
            ],
            [
              -8433.864,
              3702.013,
              5444.331
            ],
            [
              -8208.82,
              3847.499,
              5712.307
            ],
            [
              -8066.385,
              3953.143,
              5889.643
            ],
            [
              -8052.214,
              3990.759,
              5929.84
            ],
            [
              -8073.606,
              4024.505,
              5969.794
            ],
            [
              -8101.225,
              4032.75,
              5998.618
            ],
            [
              -8137.67,
              4014.423,
              6039.412
            ],
            [
              -8145.978,
              3980.051,
              6074.774
            ],
            [
              -8141.382,
              3945.467,
              6109.662
            ],
            [
              -8134.965,
              3943.136,
              6116.488
            ],
            [
              -8106.816,
              3849.168,
              6214.582
            ],
            [
              -8064.844,
              3771.671,
              6302.715
            ],
            [
              -8003.462,
              3697.194,
              6399.227
            ],
            [
              -7956.982,
              3658.583,
              6459.652
            ],
            [
              -7913.564,
              3630.04,
              6511.612
            ],
            [
              -7552.547,
              3410.361,
              6934.214
            ],
            [
              -7508.286,
              3394.045,
              6981.386
            ],
            [
              -7243.876,
              3227.143,
              7294.066
            ],
            [
              -6939.838,
              3038.415,
              7651.917
            ],
            [
              -6822.27,
              2929.59,
              7812.12
            ],
            [
              -6676.677,
              2683.371,
              8098.164
            ],
            [
              -6663.874,
              2638.63,
              8144.701
            ],
            [
              -6617.665,
              2546.576,
              8247.702
            ],
            [
              -6572.047,
              2457.871,
              8347.45
            ],
            [
              -6516.148,
              2366.767,
              8454.336
            ],
            [
              -6469.844,
              2319.237,
              8520.693
            ],
            [
              -6422.765,
              2279.486,
              8582.309
            ],
            [
              -6337.172,
              2227.956,
              8682.216
            ],
            [
              -6224.837,
              2193.786,
              8799.633
            ],
            [
              -6125.197,
              2172.072,
              8901.612
            ],
            [
              -5648.753,
              2074.968,
              9387.85
            ],
            [
              -5407.978,
              2044.165,
              9630.588
            ],
            [
              -5248.741,
              2037.003,
              9789.986
            ],
            [
              -5237.188,
              2033.466,
              9802.068
            ],
            [
              -5229.201,
              2009.953,
              9826.901
            ],
            [
              -5217.875,
              1993.062,
              9847.237
            ],
            [
              -5096.905,
              1898.604,
              10000.718
            ],
            [
              -5077.101,
              1887.134,
              10023.604
            ],
            [
              -5061.716,
              1881.305,
              10040.055
            ],
            [
              -5063.879,
              1867.984,
              10053.551
            ],
            [
              -4984.799,
              1776.464,
              10174.504
            ],
            [
              -4951.187,
              1742.493,
              10222.293
            ],
            [
              -4928.804,
              1730.978,
              10247.464
            ],
            [
              -4906.917,
              1690.529,
              10293.455
            ],
            [
              -4767.773,
              1565.694,
              10480.391
            ],
            [
              -4739.606,
              1552.966,
              10511.3
            ],
            [
              -4712.351,
              1524.668,
              10550.588
            ],
            [
              -4596.2,
              1451.429,
              10687.902
            ],
            [
              -4491.296,
              1399.532,
              10804.941
            ],
            [
              -4466.279,
              1391.309,
              10831.275
            ],
            [
              -4443.995,
              1374.227,
              10859.353
            ],
            [
              -4243.678,
              1281.718,
              11079.999
            ],
            [
              -4197.987,
              1275.363,
              11126.13
            ],
            [
              -4179.458,
              1265.024,
              11147.348
            ],
            [
              -4137.695,
              1255.397,
              11190.206
            ],
            [
              -4093.256,
              1251.289,
              11234.835
            ],
            [
              -4041.607,
              1253.735,
              11286.541
            ],
            [
              -3953.633,
              1267.797,
              11375.632
            ],
            [
              -3919.363,
              1123.6,
              11523.846
            ],
            [
              -3889.289,
              1035.135,
              11617.282
            ],
            [
              -3876.172,
              1010.417,
              11645.265
            ],
            [
              -3879.245,
              944.791,
              11710.963
            ],
            [
              -3881.411,
              931.47,
              11724.459
            ],
            [
              -3897.582,
              891.676,
              11767.414
            ],
            [
              -3911.432,
              874.104,
              11789.787
            ],
            [
              -3948.102,
              842.457,
              11838.225
            ],
            [
              -4089.107,
              782.559,
              11991.425
            ],
            [
              -4161.662,
              727.04,
              12082.785
            ],
            [
              -4175.491,
              710.581,
              12104.282
            ],
            [
              -4216.46,
              691.251,
              12149.582
            ],
            [
              -4255.417,
              676.338,
              12191.296
            ],
            [
              -4279.313,
              674.524,
              12215.261
            ],
            [
              -4304.422,
              677.184,
              12240.51
            ],
            [
              -4330.724,
              685.43,
              12268.075
            ],
            [
              -4370.887,
              712.839,
              12316.698
            ],
            [
              -4391.801,
              734.351,
              12346.701
            ],
            [
              -4418.25,
              771.542,
              12392.338
            ],
            [
              -4423.862,
              782.771,
              12404.891
            ],
            [
              -4434.785,
              785.185,
              12416.078
            ],
            [
              -4479.393,
              779.274,
              12461.075
            ],
            [
              -4503.366,
              773.007,
              12485.854
            ],
            [
              -4524.836,
              762.245,
              12509.871
            ],
            [
              -4546.478,
              741.466,
              12539.873
            ],
            [
              -4558.582,
              712.731,
              12571.053
            ],
            [
              -4562.872,
              688.314,
              12595.844
            ],
            [
              -4562.176,
              653.793,
              12630.372
            ],
            [
              -4542.083,
              471.996,
              12813.277
            ],
            [
              -4530.426,
              437.286,
              12849.892
            ],
            [
              -4533.311,
              419.524,
              12867.886
            ],
            [
              -4527.744,
              368.221,
              12919.49
            ],
            [
              -4516.259,
              323.495,
              12965.667
            ],
            [
              -4491.638,
              255.166,
              13038.297
            ],
            [
              -4427.619,
              152.763,
              13159.065
            ],
            [
              -4367.011,
              77.134,
              13255.983
            ],
            [
              -4077.229,
              -208.399,
              13662.803
            ],
            [
              -3954.469,
              -380.846,
              13874.481
            ],
            [
              -3921.604,
              -419.265,
              13925.04
            ],
            [
              -3917.323,
              -432.698,
              13939.138
            ],
            [
              -3857.936,
              -540.596,
              14062.3
            ],
            [
              -3823.641,
              -607.984,
              14137.913
            ],
            [
              -3766.483,
              -732.543,
              14274.96
            ],
            [
              -3707.64,
              -908.34,
              14460.344
            ],
            [
              -3695.741,
              -928.584,
              14483.826
            ],
            [
              -3679.35,
              -950.021,
              14510.811
            ],
            [
              -3668.232,
              -978.044,
              14540.959
            ],
            [
              -3606.925,
              -1085.98,
              14665.091
            ],
            [
              -3586.062,
              -1109.72,
              14696.696
            ],
            [
              -3575.241,
              -1117.701,
              14710.142
            ],
            [
              -3510.568,
              -1143.319,
              14779.703
            ],
            [
              -3355.367,
              -1190.556,
              14941.934
            ],
            [
              -3108.49,
              -1230.499,
              15192.022
            ],
            [
              -3070.013,
              -1242.306,
              15232.269
            ],
            [
              -2879.155,
              -1277.94,
              15426.425
            ],
            [
              -2839.273,
              -1283.094,
              15466.638
            ],
            [
              -2787.087,
              -1285.125,
              15518.865
            ],
            [
              -2748.376,
              -1283.58,
              15557.606
            ],
            [
              -2714.118,
              -1278.617,
              15592.221
            ],
            [
              -2670.7,
              -1266.023,
              15637.429
            ],
            [
              -2624.585,
              -1246.798,
              15687.391
            ],
            [
              -2500.301,
              -1182.198,
              15827.461
            ],
            [
              -2469.831,
              -1172.717,
              15859.372
            ],
            [
              -2418.716,
              -1162.489,
              15911.501
            ],
            [
              -2392.231,
              -1159.617,
              15938.141
            ],
            [
              -2246.137,
              -1174.448,
              16084.986
            ],
            [
              -2229.866,
              -1165.831,
              16103.398
            ],
            [
              -2190.996,
              -1155.388,
              16143.646
            ],
            [
              -2164.136,
              -1131.373,
              16179.677
            ],
            [
              -2142.708,
              -1122.847,
              16202.738
            ],
            [
              -2138.761,
              -1118.464,
              16208.636
            ],
            [
              -2144.773,
              -1093.867,
              16233.957
            ],
            [
              -2147.916,
              -1089.358,
              16239.454
            ],
            [
              -2139.925,
              -1075.028,
              16255.862
            ],
            [
              -2130.763,
              -1067.398,
              16267.785
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:15964",
              "position": {
                "x": -12209.896,
                "z": 1752.832
              },
              "distanceAlongShapeM": 722.237,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:16236",
              "position": {
                "x": -12092.77,
                "z": 1942.477
              },
              "distanceAlongShapeM": 1035.707,
              "shapeOffsetM": 0.579,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8945",
              "position": {
                "x": -11899.757,
                "z": 2198.842
              },
              "distanceAlongShapeM": 1460.787,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6604",
              "position": {
                "x": -11702.181,
                "z": 2291.494
              },
              "distanceAlongShapeM": 1679.009,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:4454",
              "position": {
                "x": -11189.627,
                "z": 2391.441
              },
              "distanceAlongShapeM": 2252.041,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6295",
              "position": {
                "x": -8134.965,
                "z": 3943.136
              },
              "distanceAlongShapeM": 6116.488,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6609",
              "position": {
                "x": -7508.286,
                "z": 3394.045
              },
              "distanceAlongShapeM": 6981.386,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6310",
              "position": {
                "x": -6676.677,
                "z": 2683.371
              },
              "distanceAlongShapeM": 8098.164,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 10247.464,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:783",
              "position": {
                "x": -4739.606,
                "z": 1552.966
              },
              "distanceAlongShapeM": 10511.3,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:3589",
              "position": {
                "x": -4466.279,
                "z": 1391.309
              },
              "distanceAlongShapeM": 10831.275,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6317",
              "position": {
                "x": -4197.987,
                "z": 1275.363
              },
              "distanceAlongShapeM": 11126.13,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 11645.265,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 12104.282,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 12849.892,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 13662.803,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 13925.04,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 14510.811,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 15192.022,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:18480",
              "position": {
                "x": -2130.763,
                "z": -1067.398
              },
              "distanceAlongShapeM": 16267.785,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            }
          ],
          "departuresSeconds": [
            19620,
            22500,
            24540,
            26340,
            28320,
            30600,
            33000,
            36120,
            38580,
            41400,
            44100,
            46860,
            49380,
            52320,
            54780,
            57780,
            60540,
            62220,
            63840,
            66360,
            68880,
            71700,
            74460,
            77100,
            79800,
            82440
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_59:1",
          "sourceRouteId": "vilnius_bus_59",
          "sourceShapeId": "vilnius_bus_59_b-a",
          "directionId": 1,
          "headsign": "Grigiškės",
          "directionName": "Žvėrynas–Laisvės pr.–Lazdynai–Grigiškės",
          "mode": "bus",
          "routeShortName": "59",
          "routeLongName": "Grigiškės–Lazdynai–Laisvės pr.–Žvėrynas",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2130.763,
              -1067.398,
              0
            ],
            [
              -2108.809,
              -1065.561,
              22.031
            ],
            [
              -2071.721,
              -1082.918,
              62.979
            ],
            [
              -2068.854,
              -1103.007,
              83.272
            ],
            [
              -2072.195,
              -1109.627,
              90.687
            ],
            [
              -2142.708,
              -1122.847,
              162.428
            ],
            [
              -2159.624,
              -1131.453,
              181.407
            ],
            [
              -2184.551,
              -1155.502,
              216.044
            ],
            [
              -2202.716,
              -1161.859,
              235.29
            ],
            [
              -2224.67,
              -1163.697,
              257.32
            ],
            [
              -2246.137,
              -1174.448,
              281.329
            ],
            [
              -2255.963,
              -1183.18,
              294.474
            ],
            [
              -2262.447,
              -1185.292,
              301.294
            ],
            [
              -2339.674,
              -1177.245,
              378.939
            ],
            [
              -2392.506,
              -1175.197,
              431.811
            ],
            [
              -2433.855,
              -1180.032,
              473.441
            ],
            [
              -2474.658,
              -1190.444,
              515.551
            ],
            [
              -2521.496,
              -1214.107,
              568.028
            ],
            [
              -2594.45,
              -1256.235,
              652.272
            ],
            [
              -2624.997,
              -1270.168,
              685.847
            ],
            [
              -2680.78,
              -1289.223,
              744.794
            ],
            [
              -2710.565,
              -1296.491,
              775.453
            ],
            [
              -2777.752,
              -1304.214,
              843.082
            ],
            [
              -2815.153,
              -1304.669,
              880.487
            ],
            [
              -2855.074,
              -1301.74,
              920.515
            ],
            [
              -3099.309,
              -1258.49,
              1168.55
            ],
            [
              -3140.52,
              -1255.542,
              1209.866
            ],
            [
              -3159.719,
              -1247.413,
              1230.715
            ],
            [
              -3359.526,
              -1207.182,
              1434.531
            ],
            [
              -3495.953,
              -1192.555,
              1571.741
            ],
            [
              -3569.469,
              -1193.5,
              1645.263
            ],
            [
              -3626.266,
              -1196.964,
              1702.165
            ],
            [
              -3657.704,
              -1114.039,
              1790.849
            ],
            [
              -3680.758,
              -1067.996,
              1842.341
            ],
            [
              -3686.114,
              -1042.299,
              1868.59
            ],
            [
              -3720.918,
              -930.373,
              1985.803
            ],
            [
              -3751.541,
              -837.444,
              2083.647
            ],
            [
              -3761.526,
              -818.346,
              2105.198
            ],
            [
              -3766.218,
              -791.548,
              2132.404
            ],
            [
              -3793.988,
              -719.82,
              2209.32
            ],
            [
              -3843.779,
              -616.54,
              2323.975
            ],
            [
              -3881.258,
              -546.871,
              2403.086
            ],
            [
              -3968.98,
              -399.519,
              2574.572
            ],
            [
              -3986.683,
              -379.175,
              2601.541
            ],
            [
              -3999.719,
              -350.005,
              2633.49
            ],
            [
              -4048.201,
              -282.373,
              2716.705
            ],
            [
              -4133.499,
              -180.709,
              2849.412
            ],
            [
              -4196.245,
              -117.285,
              2938.63
            ],
            [
              -4221.08,
              -99.045,
              2969.444
            ],
            [
              -4243.751,
              -67.483,
              3008.303
            ],
            [
              -4402.336,
              85.535,
              3228.675
            ],
            [
              -4449.086,
              142,
              3301.982
            ],
            [
              -4479.797,
              193.736,
              3362.147
            ],
            [
              -4502.905,
              237.549,
              3411.68
            ],
            [
              -4519.036,
              274.562,
              3452.056
            ],
            [
              -4536.228,
              324.952,
              3505.297
            ],
            [
              -4547.048,
              370.78,
              3552.385
            ],
            [
              -4566.578,
              510.266,
              3693.232
            ],
            [
              -4574.501,
              537.119,
              3721.229
            ],
            [
              -4575.517,
              590.57,
              3774.69
            ],
            [
              -4579.623,
              651.866,
              3836.124
            ],
            [
              -4586.366,
              709.869,
              3894.517
            ],
            [
              -4584.541,
              741.007,
              3925.709
            ],
            [
              -4573.306,
              794.248,
              3980.122
            ],
            [
              -4555.909,
              830.684,
              4020.498
            ],
            [
              -4554.237,
              852.919,
              4042.796
            ],
            [
              -4568.699,
              912.168,
              4103.784
            ],
            [
              -4567.748,
              929.963,
              4121.604
            ],
            [
              -4555.854,
              946.456,
              4141.939
            ],
            [
              -4510.16,
              977.953,
              4197.437
            ],
            [
              -4440.575,
              860.983,
              4333.54
            ],
            [
              -4425.036,
              789.47,
              4406.721
            ],
            [
              -4406.248,
              756.864,
              4444.354
            ],
            [
              -4380.992,
              725.259,
              4484.81
            ],
            [
              -4355.565,
              703.67,
              4518.166
            ],
            [
              -4324.219,
              688.657,
              4552.922
            ],
            [
              -4302.372,
              683.828,
              4575.296
            ],
            [
              -4269.507,
              682.148,
              4608.204
            ],
            [
              -4233.908,
              689.326,
              4644.519
            ],
            [
              -4200.071,
              706.552,
              4682.489
            ],
            [
              -4154.906,
              744.734,
              4741.631
            ],
            [
              -4134.494,
              768.872,
              4773.242
            ],
            [
              -4089.107,
              782.559,
              4820.648
            ],
            [
              -4026.001,
              813.75,
              4891.041
            ],
            [
              -3968.169,
              838.352,
              4953.889
            ],
            [
              -3939.526,
              853.44,
              4986.263
            ],
            [
              -3921.201,
              868.708,
              5010.114
            ],
            [
              -3904.031,
              891.787,
              5038.881
            ],
            [
              -3887.976,
              924.905,
              5075.685
            ],
            [
              -3883.393,
              966.014,
              5117.049
            ],
            [
              -3887.876,
              1005.054,
              5156.345
            ],
            [
              -3903.754,
              1056.537,
              5210.221
            ],
            [
              -3916.285,
              1077.905,
              5234.992
            ],
            [
              -3919.363,
              1123.6,
              5280.79
            ],
            [
              -3949.447,
              1248.8,
              5409.554
            ],
            [
              -3955.799,
              1254.476,
              5418.073
            ],
            [
              -3966.06,
              1257.993,
              5428.92
            ],
            [
              -4052.898,
              1235.006,
              5518.749
            ],
            [
              -4088.424,
              1232.281,
              5554.379
            ],
            [
              -4119.34,
              1235.042,
              5585.418
            ],
            [
              -4215.081,
              1256.734,
              5683.586
            ],
            [
              -4241.916,
              1271.669,
              5714.297
            ],
            [
              -4268.203,
              1281.028,
              5742.2
            ],
            [
              -4527.979,
              1404.616,
              6029.876
            ],
            [
              -4558.781,
              1414.051,
              6062.091
            ],
            [
              -4581.673,
              1433.369,
              6092.044
            ],
            [
              -4718.251,
              1519.203,
              6253.355
            ],
            [
              -4838.028,
              1606.973,
              6401.848
            ],
            [
              -4906.917,
              1690.529,
              6510.14
            ],
            [
              -4962.228,
              1738.229,
              6583.179
            ],
            [
              -5070.177,
              1876.997,
              6758.99
            ],
            [
              -5047.925,
              1895.541,
              6787.956
            ],
            [
              -4996.021,
              1950.314,
              6863.415
            ],
            [
              -4992.511,
              1966.952,
              6880.42
            ],
            [
              -4995.545,
              1978.136,
              6892.008
            ],
            [
              -5002.507,
              1986.047,
              6902.546
            ],
            [
              -5010.228,
              1987.292,
              6910.367
            ],
            [
              -5028.345,
              1984.262,
              6928.735
            ],
            [
              -5177.583,
              1934.489,
              7086.055
            ],
            [
              -5251.262,
              1926.839,
              7160.13
            ],
            [
              -5286.129,
              1925.207,
              7195.035
            ],
            [
              -5329.267,
              1930.394,
              7238.483
            ],
            [
              -5390.957,
              1944.801,
              7301.834
            ],
            [
              -5430.093,
              1957.712,
              7343.044
            ],
            [
              -5538.852,
              2011.879,
              7464.546
            ],
            [
              -5604.833,
              2039.715,
              7536.158
            ],
            [
              -5664.553,
              2056.312,
              7598.142
            ],
            [
              -6261.201,
              2179.926,
              8207.46
            ],
            [
              -6367.656,
              2218.449,
              8320.671
            ],
            [
              -6455.072,
              2276.688,
              8425.711
            ],
            [
              -6521.774,
              2339.031,
              8517.012
            ],
            [
              -6565.387,
              2393.195,
              8586.551
            ],
            [
              -6596.857,
              2440.475,
              8643.347
            ],
            [
              -6687.246,
              2630.115,
              8853.427
            ],
            [
              -6721.281,
              2678.551,
              8912.625
            ],
            [
              -6732.812,
              2722.158,
              8957.73
            ],
            [
              -6787.208,
              2826.592,
              9075.482
            ],
            [
              -6821.115,
              2882.817,
              9141.14
            ],
            [
              -6849.514,
              2921.139,
              9188.837
            ],
            [
              -6915.475,
              2990.142,
              9284.296
            ],
            [
              -6953.037,
              3020.824,
              9332.796
            ],
            [
              -7039.186,
              3079.03,
              9436.765
            ],
            [
              -7611.222,
              3413.556,
              10099.436
            ],
            [
              -7653.308,
              3444.307,
              10151.56
            ],
            [
              -7928.052,
              3612.467,
              10473.681
            ],
            [
              -8050.539,
              3660.119,
              10605.11
            ],
            [
              -8132.835,
              3679.279,
              10689.608
            ],
            [
              -8226.874,
              3690.838,
              10784.354
            ],
            [
              -8295.268,
              3691.956,
              10852.757
            ],
            [
              -8418.314,
              3666.138,
              10978.483
            ],
            [
              -8511.843,
              3629.816,
              11078.817
            ],
            [
              -8673.968,
              3542.289,
              11263.06
            ],
            [
              -10220.742,
              2662.19,
              13042.691
            ],
            [
              -10349.565,
              2595.224,
              13187.879
            ],
            [
              -10561.984,
              2505.092,
              13418.629
            ],
            [
              -10571.756,
              2458.494,
              13466.24
            ],
            [
              -10587.068,
              2428.682,
              13499.756
            ],
            [
              -10685.89,
              2381.268,
              13609.363
            ],
            [
              -10763.716,
              2355.784,
              13691.256
            ],
            [
              -10781.795,
              2354.956,
              13709.353
            ],
            [
              -10804.981,
              2357.549,
              13732.684
            ],
            [
              -10822.273,
              2365.615,
              13751.765
            ],
            [
              -10871.238,
              2410.915,
              13818.47
            ],
            [
              -10882.01,
              2423.329,
              13834.907
            ],
            [
              -10933.179,
              2410.779,
              13887.593
            ],
            [
              -11014.265,
              2383.116,
              13973.268
            ],
            [
              -11042.752,
              2376.885,
              14002.428
            ],
            [
              -11076.276,
              2378.527,
              14035.992
            ],
            [
              -11111.788,
              2376.859,
              14071.543
            ],
            [
              -11167.733,
              2347.684,
              14134.639
            ],
            [
              -11176.641,
              2355.616,
              14146.567
            ],
            [
              -11189.785,
              2381.426,
              14175.53
            ],
            [
              -11210.634,
              2409.582,
              14210.565
            ],
            [
              -11223.935,
              2425.375,
              14231.213
            ],
            [
              -11236.068,
              2433.358,
              14245.737
            ],
            [
              -11281.586,
              2451.884,
              14294.881
            ],
            [
              -11308.608,
              2456.76,
              14322.339
            ],
            [
              -11333.103,
              2458.258,
              14346.879
            ],
            [
              -11358.329,
              2454.201,
              14372.43
            ],
            [
              -11398.758,
              2427.006,
              14421.154
            ],
            [
              -11421.439,
              2420.682,
              14444.701
            ],
            [
              -11656.141,
              2306.359,
              14705.765
            ],
            [
              -11912.865,
              2185.688,
              14989.435
            ],
            [
              -11986.897,
              2154.558,
              15069.746
            ],
            [
              -12000.581,
              2145.866,
              15085.957
            ],
            [
              -12140.971,
              2079.03,
              15241.445
            ],
            [
              -12148.221,
              2069.124,
              15253.721
            ],
            [
              -12128.727,
              2036.54,
              15291.691
            ],
            [
              -12035.317,
              1820.251,
              15527.289
            ],
            [
              -12277.032,
              1708.233,
              15793.699
            ],
            [
              -12421.988,
              1637.007,
              15955.209
            ],
            [
              -12458.258,
              1627.549,
              15992.692
            ],
            [
              -12567.869,
              1589.167,
              16108.828
            ],
            [
              -12592.043,
              1652.989,
              16177.075
            ],
            [
              -12647.185,
              1758.475,
              16296.105
            ],
            [
              -12661.996,
              1802.116,
              16342.19
            ],
            [
              -12663.063,
              1816.603,
              16356.717
            ],
            [
              -12603.058,
              1859.092,
              16430.241
            ],
            [
              -12599.171,
              1860.145,
              16434.268
            ],
            [
              -12592.773,
              1856.707,
              16441.532
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4898",
              "position": {
                "x": -2071.721,
                "z": -1082.918
              },
              "distanceAlongShapeM": 62.979,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 1209.866,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 1842.341,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 2105.198,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 2601.541,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 2969.444,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 3721.229,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 4773.242,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 690,
              "departureOffsetSeconds": 690
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 5234.992,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 5683.586,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 6062.091,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 6401.848,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6309",
              "position": {
                "x": -6721.281,
                "z": 2678.551
              },
              "distanceAlongShapeM": 8912.625,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6297",
              "position": {
                "x": -7611.222,
                "z": 3413.556
              },
              "distanceAlongShapeM": 10099.436,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:9109",
              "position": {
                "x": -10685.89,
                "z": 2381.268
              },
              "distanceAlongShapeM": 13609.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:9834",
              "position": {
                "x": -11398.758,
                "z": 2427.006
              },
              "distanceAlongShapeM": 14421.154,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:8944",
              "position": {
                "x": -11656.141,
                "z": 2306.359
              },
              "distanceAlongShapeM": 14705.765,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6603",
              "position": {
                "x": -11912.865,
                "z": 2185.688
              },
              "distanceAlongShapeM": 14989.435,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:9082",
              "position": {
                "x": -12128.727,
                "z": 2036.54
              },
              "distanceAlongShapeM": 15291.691,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 16441.532,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            19740,
            22080,
            23400,
            25380,
            27600,
            29880,
            33480,
            35700,
            38820,
            41340,
            44160,
            46800,
            49680,
            52200,
            55080,
            57720,
            59340,
            61080,
            63540,
            65940,
            69000,
            71640,
            74400,
            77100,
            79680,
            82560
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_61",
      "sourceRouteId": "vilnius_bus_61",
      "mode": "bus",
      "shortName": "61",
      "longName": "Stotis–Nemėžis–Kuprioniškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_61:0",
          "sourceRouteId": "vilnius_bus_61",
          "sourceShapeId": "vilnius_bus_61_a-b",
          "directionId": 0,
          "headsign": "Kuprioniškės",
          "directionName": "Stotis–Nemėžis–Kuprioniškės",
          "mode": "bus",
          "routeShortName": "61",
          "routeLongName": "Stotis–Nemėžis–Kuprioniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              448.101,
              1917.454,
              0
            ],
            [
              414.243,
              1935.885,
              38.55
            ],
            [
              388.144,
              1955.287,
              71.07
            ],
            [
              374.884,
              1971.114,
              91.718
            ],
            [
              370.552,
              1981.213,
              102.707
            ],
            [
              369.405,
              1989.026,
              110.604
            ],
            [
              372.127,
              1996.769,
              118.811
            ],
            [
              376.723,
              2001.138,
              125.153
            ],
            [
              383.214,
              2003.246,
              131.977
            ],
            [
              391.578,
              2001.98,
              140.437
            ],
            [
              462.481,
              1962.833,
              221.428
            ],
            [
              478.32,
              1946.958,
              243.854
            ],
            [
              475.394,
              1928.087,
              262.951
            ],
            [
              494.54,
              1916.604,
              285.276
            ],
            [
              623.161,
              1858.587,
              426.377
            ],
            [
              825.163,
              1791.425,
              639.251
            ],
            [
              862.14,
              1837.501,
              698.33
            ],
            [
              869.06,
              1862.978,
              724.73
            ],
            [
              873.401,
              1888.503,
              750.621
            ],
            [
              889.31,
              1911.588,
              778.658
            ],
            [
              908.823,
              1920.135,
              799.961
            ],
            [
              941.154,
              1923.993,
              832.521
            ],
            [
              953.593,
              1933.783,
              848.351
            ],
            [
              1083.618,
              2057.184,
              1027.611
            ],
            [
              1196.071,
              2172,
              1188.323
            ],
            [
              1233.034,
              2216.96,
              1246.527
            ],
            [
              1262.402,
              2269.853,
              1307.026
            ],
            [
              1272.571,
              2296.383,
              1335.438
            ],
            [
              1295.641,
              2322.675,
              1370.416
            ],
            [
              1353.693,
              2426.246,
              1489.147
            ],
            [
              1363.843,
              2451.663,
              1516.515
            ],
            [
              1395.21,
              2612.502,
              1680.385
            ],
            [
              1412.03,
              2684.551,
              1754.371
            ],
            [
              1428.563,
              2741.021,
              1813.211
            ],
            [
              1438.754,
              2768.663,
              1842.672
            ],
            [
              1466.069,
              2814.913,
              1896.386
            ],
            [
              1513.094,
              2845.213,
              1952.328
            ],
            [
              1568.191,
              2893.175,
              2025.376
            ],
            [
              1626.949,
              2964.446,
              2117.745
            ],
            [
              1670.787,
              3031.54,
              2197.891
            ],
            [
              1688.949,
              3071.28,
              2241.584
            ],
            [
              1699.324,
              3143.448,
              2314.494
            ],
            [
              1699.269,
              3383.908,
              2554.955
            ],
            [
              1698.702,
              3422.882,
              2593.933
            ],
            [
              1683.073,
              3554.534,
              2726.509
            ],
            [
              1679.171,
              3622.514,
              2794.601
            ],
            [
              1674.798,
              3769.542,
              2941.694
            ],
            [
              1682.185,
              3784.991,
              2958.818
            ],
            [
              1743.856,
              3803.884,
              3023.318
            ],
            [
              1812.124,
              3830.447,
              3096.572
            ],
            [
              1876.708,
              3867.097,
              3170.83
            ],
            [
              2082.225,
              4019.124,
              3426.465
            ],
            [
              2137.697,
              4051.487,
              3490.687
            ],
            [
              2651.026,
              4265.645,
              4046.899
            ],
            [
              2753.781,
              4306.019,
              4157.301
            ],
            [
              2885.913,
              4363.65,
              4301.454
            ],
            [
              3782.546,
              4734.102,
              5271.601
            ],
            [
              4006.468,
              4830.032,
              5515.207
            ],
            [
              3993.412,
              4822.488,
              5530.286
            ],
            [
              4522.992,
              5032.789,
              6100.095
            ],
            [
              4822.139,
              5143.936,
              6419.222
            ],
            [
              5116.265,
              5261.84,
              6736.1
            ],
            [
              5119.749,
              5308.53,
              6782.92
            ],
            [
              5120.284,
              5403.146,
              6877.538
            ],
            [
              5141.259,
              5519.633,
              6995.898
            ],
            [
              5112.186,
              5619.275,
              7099.694
            ],
            [
              5009.166,
              5902.915,
              7401.464
            ],
            [
              4984.974,
              5987.989,
              7489.911
            ],
            [
              4835.208,
              5924.077,
              7652.743
            ],
            [
              4784.791,
              5921.707,
              7703.217
            ],
            [
              4775.881,
              5928.557,
              7714.456
            ],
            [
              4346.137,
              6014.725,
              8152.753
            ],
            [
              3271.842,
              6271.154,
              9257.228
            ],
            [
              3238.8,
              6197.19,
              9338.237
            ],
            [
              3231.756,
              6166.152,
              9370.064
            ],
            [
              3241.744,
              5874.294,
              9662.093
            ],
            [
              3233.802,
              5829.914,
              9707.178
            ],
            [
              3237.964,
              5810.91,
              9726.632
            ],
            [
              3261.816,
              5740.326,
              9801.138
            ],
            [
              3263.992,
              5684.622,
              9856.884
            ],
            [
              3271.171,
              5654.429,
              9887.918
            ],
            [
              3302.002,
              5611.543,
              9940.737
            ],
            [
              3305.995,
              5583.637,
              9968.927
            ],
            [
              3304.817,
              5521.317,
              10031.258
            ],
            [
              3310.227,
              5500.063,
              10053.19
            ],
            [
              3323.298,
              5474.212,
              10082.158
            ],
            [
              3328.035,
              5417.346,
              10139.22
            ],
            [
              3338.019,
              5364.835,
              10192.672
            ],
            [
              3348.719,
              5350.161,
              10210.833
            ],
            [
              3397.957,
              5324.738,
              10266.247
            ],
            [
              3492.272,
              5292.895,
              10365.793
            ],
            [
              3515.108,
              5271.31,
              10397.216
            ],
            [
              3570.094,
              5174.529,
              10508.527
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:939",
              "position": {
                "x": 448.101,
                "z": 1917.454
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -780,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 778.658,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 1335.438,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 1896.386,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:16977",
              "position": {
                "x": 1743.856,
                "z": 3803.884
              },
              "distanceAlongShapeM": 3023.318,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:616",
              "position": {
                "x": 2873.526,
                "z": 4357.203
              },
              "distanceAlongShapeM": 4287.523,
              "shapeOffsetM": 0.957,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6120",
              "position": {
                "x": 4006.468,
                "z": 4830.032
              },
              "distanceAlongShapeM": 5515.207,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6122",
              "position": {
                "x": 4522.992,
                "z": 5032.789
              },
              "distanceAlongShapeM": 6100.095,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9677",
              "position": {
                "x": 5120.284,
                "z": 5403.146
              },
              "distanceAlongShapeM": 6877.538,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9678",
              "position": {
                "x": 5009.166,
                "z": 5902.915
              },
              "distanceAlongShapeM": 7401.464,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:17854",
              "position": {
                "x": 4784.791,
                "z": 5921.707
              },
              "distanceAlongShapeM": 7703.217,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:9680",
              "position": {
                "x": 4346.137,
                "z": 6014.725
              },
              "distanceAlongShapeM": 8152.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:10532",
              "position": {
                "x": 3811.243,
                "z": 6141.816
              },
              "distanceAlongShapeM": 8702.539,
              "shapeOffsetM": 0.57,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:9681",
              "position": {
                "x": 3255.717,
                "z": 6238.061
              },
              "distanceAlongShapeM": 9294.02,
              "shapeOffsetM": 1.224,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9790",
              "position": {
                "x": 3241.744,
                "z": 5874.294
              },
              "distanceAlongShapeM": 9662.093,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:9682",
              "position": {
                "x": 3302.002,
                "z": 5611.543
              },
              "distanceAlongShapeM": 9940.737,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7874",
              "position": {
                "x": 3570.094,
                "z": 5174.529
              },
              "distanceAlongShapeM": 10508.527,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            18600,
            20160,
            21780,
            22980,
            24180,
            25380,
            26580,
            27780,
            29100,
            30480,
            32040,
            33840,
            35580,
            37680,
            39480,
            41280,
            43080,
            44880,
            46680,
            48480,
            50280,
            52080,
            53880,
            55440,
            56820,
            58020,
            59220,
            60480,
            61800,
            63000,
            64200,
            65460,
            67140,
            68940,
            70980,
            72660,
            74460,
            76260,
            78060,
            79860,
            81660,
            83460,
            85260
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_61:1",
          "sourceRouteId": "vilnius_bus_61",
          "sourceShapeId": "vilnius_bus_61_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Kuprioniškės–Stotis",
          "mode": "bus",
          "routeShortName": "61",
          "routeLongName": "Stotis–Nemėžis–Kuprioniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3570.094,
              5174.529,
              0
            ],
            [
              3749.281,
              4818.228,
              398.821
            ],
            [
              3783.276,
              4738.541,
              485.456
            ],
            [
              3789.042,
              4736.205,
              491.678
            ],
            [
              4060.915,
              4841.24,
              783.135
            ],
            [
              4084.213,
              4844.135,
              806.613
            ],
            [
              4087.249,
              4834.058,
              817.137
            ],
            [
              4080.023,
              4827.516,
              826.885
            ],
            [
              3917.274,
              4757.143,
              1004.197
            ],
            [
              3791.824,
              4712.774,
              1137.262
            ],
            [
              3112.5,
              4431.742,
              1872.422
            ],
            [
              2822.207,
              4305.846,
              2188.839
            ],
            [
              2811.195,
              4303.827,
              2200.035
            ],
            [
              2180.203,
              4046.241,
              2881.578
            ],
            [
              2131.974,
              4021.536,
              2935.766
            ],
            [
              2048.32,
              3966.32,
              3036
            ],
            [
              1961.818,
              3896.684,
              3147.049
            ],
            [
              1908.119,
              3855.38,
              3214.795
            ],
            [
              1885.245,
              3840.22,
              3242.236
            ],
            [
              1810.879,
              3798.186,
              3327.659
            ],
            [
              1773.103,
              3779.963,
              3369.601
            ],
            [
              1723.068,
              3761.967,
              3422.775
            ],
            [
              1676.987,
              3748.35,
              3470.825
            ],
            [
              1674.7,
              3729.468,
              3489.846
            ],
            [
              1684.234,
              3721.498,
              3502.272
            ],
            [
              1678.221,
              3710.477,
              3514.827
            ],
            [
              1677.947,
              3591.366,
              3633.939
            ],
            [
              1696.885,
              3464.105,
              3762.6
            ],
            [
              1701.829,
              3382.747,
              3844.109
            ],
            [
              1703.03,
              3134.473,
              4092.386
            ],
            [
              1699.891,
              3104.474,
              4122.549
            ],
            [
              1687.994,
              3054.599,
              4173.823
            ],
            [
              1659.262,
              3001.697,
              4234.024
            ],
            [
              1605.061,
              2932.568,
              4321.868
            ],
            [
              1556.997,
              2881.137,
              4392.262
            ],
            [
              1484.111,
              2813.466,
              4491.719
            ],
            [
              1478.744,
              2802.433,
              4503.988
            ],
            [
              1453.839,
              2781.743,
              4536.367
            ],
            [
              1433.991,
              2755.392,
              4569.356
            ],
            [
              1428.563,
              2741.021,
              4584.718
            ],
            [
              1382.281,
              2541.494,
              4789.542
            ],
            [
              1365.86,
              2456.079,
              4876.522
            ],
            [
              1336.284,
              2392.058,
              4947.044
            ],
            [
              1224.883,
              2194.846,
              5173.545
            ],
            [
              958.108,
              1933.7,
              5546.862
            ],
            [
              922.174,
              1874.247,
              5616.332
            ],
            [
              898.105,
              1863.557,
              5642.668
            ],
            [
              862.14,
              1837.501,
              5687.079
            ],
            [
              825.163,
              1791.425,
              5746.158
            ],
            [
              623.161,
              1858.587,
              5959.032
            ],
            [
              493.148,
              1911.064,
              6099.237
            ],
            [
              481.742,
              1922.405,
              6115.321
            ],
            [
              470.798,
              1923.718,
              6126.344
            ],
            [
              464.267,
              1919.385,
              6134.182
            ],
            [
              448.101,
              1917.454,
              6150.463
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7874",
              "position": {
                "x": 3570.094,
                "z": 5174.529
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9585",
              "position": {
                "x": 3749.281,
                "z": 4818.228
              },
              "distanceAlongShapeM": 398.821,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6121",
              "position": {
                "x": 3917.274,
                "z": 4757.143
              },
              "distanceAlongShapeM": 1004.197,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:617",
              "position": {
                "x": 2822.207,
                "z": 4305.846
              },
              "distanceAlongShapeM": 2188.839,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 3502.272,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 4503.988,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 5173.545,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 5616.332,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 6099.237,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:939",
              "position": {
                "x": 448.101,
                "z": 1917.454
              },
              "distanceAlongShapeM": 6150.463,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            }
          ],
          "departuresSeconds": [
            20280,
            21840,
            23460,
            24720,
            25920,
            27240,
            28440,
            29640,
            30960,
            32340,
            33900,
            35640,
            37380,
            39480,
            41280,
            43020,
            44820,
            46740,
            48540,
            50280,
            52080,
            53940,
            55740,
            57300,
            58680,
            60180,
            61320,
            62520,
            63900,
            65100,
            66300,
            67200,
            68880,
            70680,
            72720,
            74280,
            76080,
            77940,
            79680,
            81480,
            83280,
            85080,
            86940
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_62",
      "sourceRouteId": "vilnius_bus_62",
      "mode": "bus",
      "shortName": "62",
      "longName": "Žemieji Paneriai–Mūrinė Vokė– Gureliai–Lazdynai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_62:0",
          "sourceRouteId": "vilnius_bus_62",
          "sourceShapeId": "vilnius_bus_62_a-b",
          "directionId": 0,
          "headsign": "Lazdynai",
          "directionName": "Žemieji Paneriai–Mūrinė Vokė– Gureliai–Lazdynai",
          "mode": "bus",
          "routeShortName": "62",
          "routeLongName": "Žemieji Paneriai–Mūrinė Vokė– Gureliai–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4333.961,
              4766.474,
              0
            ],
            [
              -4351.156,
              4780.129,
              21.957
            ],
            [
              -4357.738,
              4810.298,
              52.837
            ],
            [
              -4435.232,
              4883.989,
              159.774
            ],
            [
              -4468.845,
              4919.076,
              208.363
            ],
            [
              -4488.111,
              4924.973,
              228.512
            ],
            [
              -4510.925,
              4949.856,
              262.27
            ],
            [
              -4579.258,
              4993.33,
              343.261
            ],
            [
              -4600.366,
              5004.825,
              367.295
            ],
            [
              -4835.366,
              5155.793,
              646.609
            ],
            [
              -5032.11,
              5279.379,
              878.948
            ],
            [
              -5271.713,
              5427.062,
              1160.409
            ],
            [
              -5460.164,
              5546.035,
              1383.274
            ],
            [
              -5507.478,
              5573.554,
              1438.008
            ],
            [
              -5539.526,
              5587.456,
              1472.942
            ],
            [
              -5570.341,
              5597.997,
              1505.509
            ],
            [
              -5599.939,
              5604.064,
              1535.723
            ],
            [
              -5632.195,
              5605.723,
              1568.022
            ],
            [
              -5666.482,
              5601.851,
              1602.527
            ],
            [
              -5724.289,
              5581.678,
              1663.753
            ],
            [
              -5767.933,
              5559.039,
              1712.918
            ],
            [
              -5844.413,
              5503.558,
              1807.403
            ],
            [
              -5862.75,
              5488.283,
              1831.269
            ],
            [
              -5911.642,
              5422.317,
              1913.378
            ],
            [
              -5931.13,
              5377.005,
              1962.703
            ],
            [
              -5950.367,
              5308.312,
              2034.039
            ],
            [
              -5960.48,
              5282.88,
              2061.409
            ],
            [
              -5972.455,
              5261.931,
              2085.538
            ],
            [
              -5985.57,
              5249.907,
              2103.331
            ],
            [
              -6003.755,
              5243.534,
              2122.6
            ],
            [
              -6024.466,
              5240.544,
              2143.526
            ],
            [
              -6045.12,
              5240.892,
              2164.183
            ],
            [
              -6069.366,
              5257.998,
              2193.856
            ],
            [
              -6086.896,
              5290.575,
              2230.85
            ],
            [
              -6284.365,
              5565.511,
              2569.352
            ],
            [
              -6384.618,
              5670.718,
              2714.677
            ],
            [
              -6403.151,
              5682.161,
              2736.458
            ],
            [
              -6425.222,
              5713.7,
              2774.953
            ],
            [
              -6633.66,
              5914.22,
              3064.184
            ],
            [
              -6722.128,
              5991.393,
              3181.582
            ],
            [
              -6610.439,
              6453.723,
              3657.212
            ],
            [
              -6615.859,
              6477.191,
              3681.297
            ],
            [
              -6611.247,
              6482.68,
              3688.466
            ],
            [
              -6601.507,
              6485.856,
              3698.711
            ],
            [
              -6595.808,
              6479.082,
              3707.564
            ],
            [
              -6595.901,
              6473.518,
              3713.129
            ],
            [
              -6598.614,
              6465.771,
              3721.337
            ],
            [
              -6609.831,
              6451.487,
              3739.499
            ],
            [
              -6653.627,
              6265.205,
              3930.861
            ],
            [
              -6722.128,
              5991.393,
              4213.111
            ],
            [
              -6754.294,
              5998.609,
              4246.076
            ],
            [
              -6809.827,
              6037.383,
              4313.806
            ],
            [
              -6882.79,
              6076.446,
              4396.569
            ],
            [
              -6955.867,
              6108.831,
              4476.5
            ],
            [
              -7039.365,
              6135.823,
              4564.252
            ],
            [
              -7206.108,
              6166.42,
              4733.779
            ],
            [
              -7774.707,
              6263.751,
              5310.649
            ],
            [
              -7867.343,
              6285.312,
              5405.76
            ],
            [
              -8047.971,
              6336.143,
              5593.404
            ],
            [
              -8100.928,
              6335.897,
              5646.362
            ],
            [
              -8216.781,
              6399.018,
              5778.294
            ],
            [
              -8443.118,
              6419.411,
              6005.548
            ],
            [
              -8559.774,
              6433.557,
              6123.059
            ],
            [
              -8589.455,
              6435.153,
              6152.782
            ],
            [
              -8680.794,
              6417.715,
              6245.771
            ],
            [
              -8793.026,
              6386.142,
              6362.36
            ],
            [
              -8817.578,
              6385.428,
              6386.922
            ],
            [
              -8897.885,
              6371.145,
              6468.489
            ],
            [
              -8999.678,
              6346.078,
              6573.323
            ],
            [
              -9021.163,
              6335.294,
              6597.362
            ],
            [
              -9032.999,
              6322.127,
              6615.067
            ],
            [
              -9043.295,
              6284.446,
              6654.13
            ],
            [
              -9071.789,
              5999.937,
              6940.062
            ],
            [
              -9087.112,
              5810.947,
              7129.673
            ],
            [
              -9105.787,
              5654.292,
              7287.436
            ],
            [
              -9121.037,
              5469.753,
              7472.604
            ],
            [
              -9131.188,
              5400.901,
              7542.201
            ],
            [
              -9162.794,
              5083.047,
              7861.623
            ],
            [
              -9167.245,
              4967.349,
              7977.406
            ],
            [
              -9185.609,
              4829.613,
              8116.36
            ],
            [
              -9269.169,
              4812.038,
              8201.749
            ],
            [
              -9558.495,
              4764.378,
              8494.974
            ],
            [
              -9588.344,
              4754.839,
              8526.31
            ],
            [
              -9674.339,
              4746.201,
              8612.738
            ],
            [
              -9691.208,
              4740.905,
              8630.419
            ],
            [
              -9773.869,
              4738.891,
              8713.104
            ],
            [
              -9802.39,
              4731.556,
              8742.554
            ],
            [
              -9849.213,
              4710.042,
              8794.082
            ],
            [
              -10016.251,
              4679.317,
              8963.923
            ],
            [
              -10029.91,
              4672.856,
              8979.033
            ],
            [
              -10035.843,
              4665.159,
              8988.751
            ],
            [
              -10041.326,
              4645.21,
              9009.44
            ],
            [
              -10038.868,
              4637.378,
              9017.648
            ],
            [
              -10034.44,
              4631.742,
              9024.816
            ],
            [
              -10024.132,
              4630.464,
              9035.203
            ],
            [
              -10003.374,
              4636.812,
              9056.91
            ],
            [
              -9985.268,
              4638.749,
              9075.119
            ],
            [
              -9974.208,
              4644.138,
              9087.422
            ],
            [
              -9966.985,
              4651.815,
              9097.963
            ],
            [
              -9956.86,
              4679.482,
              9127.424
            ],
            [
              -9956.789,
              4683.933,
              9131.876
            ],
            [
              -9961.898,
              4687.354,
              9138.026
            ],
            [
              -10095.11,
              4672.784,
              9272.031
            ],
            [
              -10234.242,
              4691.698,
              9412.444
            ],
            [
              -10328.863,
              4708.788,
              9508.595
            ],
            [
              -10457.848,
              4716.402,
              9637.805
            ],
            [
              -10625.087,
              4713.487,
              9805.069
            ],
            [
              -10645.983,
              4820.681,
              9914.281
            ],
            [
              -10656.837,
              4909.906,
              10004.163
            ],
            [
              -10709.285,
              5185.685,
              10284.885
            ],
            [
              -10725.756,
              5287.243,
              10387.77
            ],
            [
              -10747.257,
              5356.598,
              10460.381
            ],
            [
              -10770.707,
              5466.058,
              10572.325
            ],
            [
              -10773.201,
              5471.663,
              10578.46
            ],
            [
              -10785.271,
              5484.098,
              10595.79
            ],
            [
              -10799.977,
              5493.236,
              10613.103
            ],
            [
              -10816.008,
              5500.168,
              10630.569
            ],
            [
              -10854.979,
              5526.386,
              10677.538
            ],
            [
              -10936.846,
              5575.542,
              10773.03
            ],
            [
              -10955.931,
              5593.653,
              10799.34
            ],
            [
              -10973.058,
              5654.033,
              10862.102
            ],
            [
              -10992.852,
              5750.076,
              10960.164
            ],
            [
              -10990.06,
              5763.39,
              10973.767
            ],
            [
              -10980.062,
              5783.27,
              10996.019
            ],
            [
              -10955.774,
              5808.49,
              11031.032
            ],
            [
              -10898.789,
              5859.91,
              11107.787
            ],
            [
              -10872.164,
              5869.508,
              11136.089
            ],
            [
              -10795.047,
              5887.215,
              11215.213
            ],
            [
              -10745.688,
              5905.359,
              11267.802
            ],
            [
              -10731.991,
              5914.048,
              11284.022
            ],
            [
              -10703.077,
              5945.872,
              11327.02
            ],
            [
              -10692.678,
              5950.16,
              11338.268
            ],
            [
              -10690.148,
              5946.781,
              11342.49
            ],
            [
              -10692.138,
              5943.473,
              11346.35
            ],
            [
              -10703.828,
              5939.205,
              11358.795
            ],
            [
              -10737.924,
              5906.349,
              11406.145
            ],
            [
              -10772.994,
              5893.545,
              11443.479
            ],
            [
              -10833.937,
              5877.81,
              11506.421
            ],
            [
              -10887.815,
              5859.737,
              11563.249
            ],
            [
              -10906.676,
              5851.129,
              11583.981
            ],
            [
              -10974.862,
              5785.414,
              11678.68
            ],
            [
              -10976.799,
              5785.444,
              11680.617
            ],
            [
              -10986.902,
              5758.888,
              11709.031
            ],
            [
              -10985.039,
              5713.219,
              11754.737
            ],
            [
              -10959.105,
              5597.043,
              11873.773
            ],
            [
              -10950.296,
              5582.433,
              11890.833
            ],
            [
              -10886.221,
              5551.368,
              11962.042
            ],
            [
              -10778.242,
              5479.535,
              12091.732
            ],
            [
              -10759.827,
              5419.133,
              12154.878
            ],
            [
              -10743.002,
              5339.834,
              12235.943
            ],
            [
              -10725.721,
              5289.468,
              12289.191
            ],
            [
              -10643.067,
              4841.785,
              12744.44
            ],
            [
              -10625.016,
              4717.939,
              12869.595
            ],
            [
              -10404.928,
              4715.562,
              13089.696
            ],
            [
              -10343.026,
              4711.239,
              13151.749
            ],
            [
              -10142.866,
              4673.545,
              13355.426
            ],
            [
              -10106.797,
              4668.517,
              13391.844
            ],
            [
              -10049.863,
              4676.514,
              13449.337
            ],
            [
              -10001.283,
              4686.87,
              13499.008
            ],
            [
              -9954.065,
              4692.795,
              13546.597
            ],
            [
              -9954.87,
              4682.79,
              13556.635
            ],
            [
              -9971.053,
              4639.635,
              13602.724
            ],
            [
              -9996.31,
              4634.472,
              13628.504
            ],
            [
              -10015.813,
              4625.879,
              13649.816
            ],
            [
              -10037.72,
              4628.455,
              13671.874
            ],
            [
              -10042.829,
              4631.876,
              13678.023
            ],
            [
              -10045.914,
              4640.83,
              13687.494
            ],
            [
              -10043.084,
              4656.369,
              13703.288
            ],
            [
              -10039.034,
              4667.436,
              13715.073
            ],
            [
              -10033.119,
              4674.021,
              13723.924
            ],
            [
              -9847.833,
              4715.586,
              13913.815
            ],
            [
              -9780.287,
              4741.22,
              13986.062
            ],
            [
              -9738.284,
              4743.887,
              14028.149
            ],
            [
              -9619.286,
              4757.562,
              14147.931
            ],
            [
              -9574.594,
              4766.863,
              14193.58
            ],
            [
              -9427.108,
              4785.641,
              14342.257
            ],
            [
              -9186.254,
              4829.624,
              14587.094
            ],
            [
              -8761.616,
              4900.668,
              15017.634
            ],
            [
              -8566.072,
              4936.448,
              15216.424
            ],
            [
              -8440.538,
              4954.439,
              15343.242
            ],
            [
              -8110.415,
              5008.04,
              15677.687
            ],
            [
              -7984.14,
              5031.572,
              15806.137
            ],
            [
              -7996.281,
              5078.524,
              15854.634
            ],
            [
              -8005.189,
              5086.463,
              15866.566
            ],
            [
              -8032.814,
              5094.708,
              15895.395
            ],
            [
              -8056.05,
              5095.089,
              15918.634
            ],
            [
              -8074.858,
              5089.832,
              15938.163
            ],
            [
              -8087.322,
              5077.791,
              15955.493
            ],
            [
              -8094.05,
              5061.204,
              15973.393
            ],
            [
              -8097.824,
              5027.871,
              16006.939
            ],
            [
              -8123.102,
              4509.547,
              16525.879
            ],
            [
              -8153.328,
              4043.622,
              16992.783
            ],
            [
              -8152.03,
              4004.64,
              17031.787
            ],
            [
              -8148.06,
              3971.18,
              17065.482
            ],
            [
              -8134.965,
              3943.136,
              17096.432
            ],
            [
              -8122.972,
              3887.281,
              17153.56
            ],
            [
              -8106.816,
              3849.168,
              17194.956
            ],
            [
              -8055.33,
              3761.496,
              17296.628
            ],
            [
              -8007.887,
              3702.832,
              17372.075
            ],
            [
              -7953.829,
              3654.078,
              17444.871
            ],
            [
              -7691.803,
              3497.261,
              17750.239
            ],
            [
              -7552.547,
              3410.361,
              17914.384
            ],
            [
              -7508.286,
              3394.045,
              17961.556
            ],
            [
              -7243.876,
              3227.143,
              18274.237
            ],
            [
              -6939.838,
              3038.415,
              18632.088
            ],
            [
              -6822.27,
              2929.59,
              18792.291
            ],
            [
              -6676.677,
              2683.371,
              19078.335
            ],
            [
              -6663.874,
              2638.63,
              19124.872
            ],
            [
              -6617.665,
              2546.576,
              19227.873
            ],
            [
              -6572.047,
              2457.871,
              19327.62
            ],
            [
              -6516.148,
              2366.767,
              19434.507
            ],
            [
              -6469.844,
              2319.237,
              19500.863
            ],
            [
              -6422.765,
              2279.486,
              19562.479
            ],
            [
              -6337.172,
              2227.956,
              19662.386
            ],
            [
              -6224.837,
              2193.786,
              19779.804
            ],
            [
              -5648.753,
              2074.968,
              20368.013
            ],
            [
              -5407.978,
              2044.165,
              20610.751
            ],
            [
              -5248.741,
              2037.003,
              20770.149
            ],
            [
              -5237.188,
              2033.466,
              20782.231
            ],
            [
              -5229.201,
              2009.953,
              20807.064
            ],
            [
              -5217.875,
              1993.062,
              20827.4
            ],
            [
              -5096.905,
              1898.604,
              20980.881
            ],
            [
              -5077.101,
              1887.134,
              21003.767
            ],
            [
              -5061.716,
              1881.305,
              21020.218
            ],
            [
              -5063.879,
              1867.984,
              21033.714
            ],
            [
              -4984.799,
              1776.464,
              21154.667
            ],
            [
              -4951.187,
              1742.493,
              21202.455
            ],
            [
              -4928.804,
              1730.978,
              21227.626
            ],
            [
              -4906.917,
              1690.529,
              21273.618
            ],
            [
              -4842.797,
              1742.865,
              21356.385
            ],
            [
              -4801.101,
              1766.641,
              21404.384
            ],
            [
              -4774.467,
              1777.316,
              21433.077
            ],
            [
              -4728.427,
              1790.998,
              21481.108
            ],
            [
              -4687.68,
              1796.979,
              21522.291
            ],
            [
              -4579.155,
              1805.134,
              21631.122
            ],
            [
              -4547.361,
              1815.72,
              21664.632
            ],
            [
              -4518.395,
              1811.882,
              21693.851
            ],
            [
              -4369.14,
              1824.898,
              21843.672
            ],
            [
              -4282.619,
              1828.972,
              21930.289
            ],
            [
              -4232.446,
              1820.314,
              21981.204
            ],
            [
              -4165.014,
              1802.452,
              22050.962
            ],
            [
              -4141.304,
              1793.136,
              22076.436
            ],
            [
              -4122.773,
              1782.797,
              22097.656
            ],
            [
              -4066.123,
              1738.403,
              22169.629
            ],
            [
              -4047.525,
              1694.666,
              22217.156
            ],
            [
              -4037.081,
              1664.429,
              22249.146
            ],
            [
              -4020.121,
              1600.683,
              22315.109
            ],
            [
              -3992.198,
              1462.162,
              22456.416
            ],
            [
              -3984.902,
              1436.432,
              22483.161
            ],
            [
              -3986.154,
              1438.68,
              22485.733
            ],
            [
              -3968.906,
              1391.627,
              22535.848
            ],
            [
              -3969.311,
              1368.257,
              22559.222
            ],
            [
              -3952.68,
              1285.592,
              22643.544
            ],
            [
              -3953.633,
              1267.797,
              22661.364
            ],
            [
              -3986.792,
              1252.786,
              22697.762
            ],
            [
              -4052.311,
              1231.656,
              22766.603
            ],
            [
              -4088.482,
              1228.943,
              22802.876
            ],
            [
              -4121.332,
              1231.737,
              22835.845
            ],
            [
              -4147.695,
              1236.645,
              22862.661
            ],
            [
              -4215.081,
              1256.734,
              22932.977
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 228.512,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5728",
              "position": {
                "x": -6069.366,
                "z": 5257.998
              },
              "distanceAlongShapeM": 2193.856,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5732",
              "position": {
                "x": -6403.151,
                "z": 5682.161
              },
              "distanceAlongShapeM": 2736.458,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 3271.618,
              "shapeOffsetM": 0.317,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:8784",
              "position": {
                "x": -6615.878,
                "z": 6476.078
              },
              "distanceAlongShapeM": 3680.216,
              "shapeOffsetM": 0.269,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5738",
              "position": {
                "x": -6754.294,
                "z": 5998.609
              },
              "distanceAlongShapeM": 4246.076,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5742",
              "position": {
                "x": -8100.928,
                "z": 6335.897
              },
              "distanceAlongShapeM": 5646.362,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6270",
              "position": {
                "x": -8793.026,
                "z": 6386.142
              },
              "distanceAlongShapeM": 6362.36,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6274",
              "position": {
                "x": -9087.112,
                "z": 5810.947
              },
              "distanceAlongShapeM": 7129.673,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6277",
              "position": {
                "x": -9121.037,
                "z": 5469.753
              },
              "distanceAlongShapeM": 7472.604,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6279",
              "position": {
                "x": -9167.245,
                "z": 4967.349
              },
              "distanceAlongShapeM": 7977.406,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6282",
              "position": {
                "x": -9588.344,
                "z": 4754.839
              },
              "distanceAlongShapeM": 8526.31,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6286",
              "position": {
                "x": -10003.374,
                "z": 4636.812
              },
              "distanceAlongShapeM": 9056.91,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:15829",
              "position": {
                "x": -10645.983,
                "z": 4820.681
              },
              "distanceAlongShapeM": 9914.281,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:15833",
              "position": {
                "x": -10816.008,
                "z": 5500.168
              },
              "distanceAlongShapeM": 10630.569,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:15837",
              "position": {
                "x": -10692.138,
                "z": 5943.473
              },
              "distanceAlongShapeM": 11346.35,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:15835",
              "position": {
                "x": -10886.221,
                "z": 5551.368
              },
              "distanceAlongShapeM": 11962.042,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:15831",
              "position": {
                "x": -10643.067,
                "z": 4841.785
              },
              "distanceAlongShapeM": 12744.44,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:9626",
              "position": {
                "x": -10015.813,
                "z": 4625.879
              },
              "distanceAlongShapeM": 13649.816,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6283",
              "position": {
                "x": -9574.594,
                "z": 4766.863
              },
              "distanceAlongShapeM": 14193.58,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6291",
              "position": {
                "x": -8566.072,
                "z": 4936.448
              },
              "distanceAlongShapeM": 15216.424,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6295",
              "position": {
                "x": -8134.965,
                "z": 3943.136
              },
              "distanceAlongShapeM": 17096.432,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6609",
              "position": {
                "x": -7508.286,
                "z": 3394.045
              },
              "distanceAlongShapeM": 17961.556,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6310",
              "position": {
                "x": -6676.677,
                "z": 2683.371
              },
              "distanceAlongShapeM": 19078.335,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 21227.626,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2610,
              "departureOffsetSeconds": 2610
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 21664.632,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2670,
              "departureOffsetSeconds": 2670
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 22169.629,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2730,
              "departureOffsetSeconds": 2730
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 22535.848,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 22932.977,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            }
          ],
          "departuresSeconds": [
            19440,
            23040,
            26460,
            30300,
            34860,
            38880,
            42180,
            45660,
            49020,
            52620,
            55620,
            60300,
            64620,
            68880,
            72180,
            75720,
            79260,
            82020
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_62:1",
          "sourceRouteId": "vilnius_bus_62",
          "sourceShapeId": "vilnius_bus_62_b-a",
          "directionId": 1,
          "headsign": "Žemieji Paneriai",
          "directionName": "Lazdynai–Mūrinė Vokė–Gureliai–Žemieji Paneriai",
          "mode": "bus",
          "routeShortName": "62",
          "routeLongName": "Žemieji Paneriai–Mūrinė Vokė– Gureliai–Lazdynai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4215.081,
              1256.734,
              0
            ],
            [
              -4241.916,
              1271.669,
              30.711
            ],
            [
              -4268.203,
              1281.028,
              58.614
            ],
            [
              -4527.979,
              1404.616,
              346.29
            ],
            [
              -4558.781,
              1414.051,
              378.505
            ],
            [
              -4581.673,
              1433.369,
              408.459
            ],
            [
              -4718.251,
              1519.203,
              569.77
            ],
            [
              -4838.028,
              1606.973,
              718.262
            ],
            [
              -4906.917,
              1690.529,
              826.555
            ],
            [
              -4962.228,
              1738.229,
              899.593
            ],
            [
              -5070.177,
              1876.997,
              1075.404
            ],
            [
              -5047.925,
              1895.541,
              1104.37
            ],
            [
              -4996.021,
              1950.314,
              1179.83
            ],
            [
              -4992.511,
              1966.952,
              1196.834
            ],
            [
              -4995.545,
              1978.136,
              1208.422
            ],
            [
              -5002.507,
              1986.047,
              1218.96
            ],
            [
              -5010.228,
              1987.292,
              1226.781
            ],
            [
              -5028.345,
              1984.262,
              1245.149
            ],
            [
              -5177.583,
              1934.489,
              1402.469
            ],
            [
              -5251.262,
              1926.839,
              1476.544
            ],
            [
              -5286.129,
              1925.207,
              1511.449
            ],
            [
              -5329.267,
              1930.394,
              1554.897
            ],
            [
              -5390.957,
              1944.801,
              1618.248
            ],
            [
              -5430.093,
              1957.712,
              1659.458
            ],
            [
              -5538.852,
              2011.879,
              1780.96
            ],
            [
              -5604.833,
              2039.715,
              1852.572
            ],
            [
              -5664.553,
              2056.312,
              1914.556
            ],
            [
              -6261.201,
              2179.926,
              2523.874
            ],
            [
              -6367.656,
              2218.449,
              2637.085
            ],
            [
              -6455.072,
              2276.688,
              2742.125
            ],
            [
              -6521.774,
              2339.031,
              2833.426
            ],
            [
              -6565.387,
              2393.195,
              2902.966
            ],
            [
              -6596.857,
              2440.475,
              2959.762
            ],
            [
              -6687.246,
              2630.115,
              3169.841
            ],
            [
              -6721.281,
              2678.551,
              3229.039
            ],
            [
              -6732.812,
              2722.158,
              3274.145
            ],
            [
              -6787.208,
              2826.592,
              3391.896
            ],
            [
              -6821.115,
              2882.817,
              3457.554
            ],
            [
              -6849.514,
              2921.139,
              3505.252
            ],
            [
              -6915.475,
              2990.142,
              3600.71
            ],
            [
              -6953.037,
              3020.824,
              3649.211
            ],
            [
              -7039.186,
              3079.03,
              3753.179
            ],
            [
              -7611.222,
              3413.556,
              4415.851
            ],
            [
              -7650.801,
              3439.813,
              4463.347
            ],
            [
              -7850.196,
              3558.868,
              4695.581
            ],
            [
              -7970.179,
              3640.989,
              4840.976
            ],
            [
              -8010.925,
              3675.053,
              4894.085
            ],
            [
              -8074.26,
              3748.448,
              4991.03
            ],
            [
              -8116.47,
              3811.478,
              5066.888
            ],
            [
              -8127.628,
              3839.491,
              5097.04
            ],
            [
              -8136.789,
              3831.848,
              5108.971
            ],
            [
              -8161.184,
              3958.037,
              5237.495
            ],
            [
              -8167.097,
              4030.49,
              5310.189
            ],
            [
              -8128.206,
              4592.005,
              5873.05
            ],
            [
              -8114.065,
              4903.462,
              6184.827
            ],
            [
              -8124.873,
              4913.657,
              6199.685
            ],
            [
              -8158.233,
              4926.449,
              6235.413
            ],
            [
              -8180.177,
              4926.808,
              6257.36
            ],
            [
              -8198.839,
              4930.453,
              6276.375
            ],
            [
              -8215.237,
              4954.098,
              6305.149
            ],
            [
              -8221.863,
              4983.149,
              6334.946
            ],
            [
              -8226.272,
              4989.9,
              6343.009
            ],
            [
              -8636.101,
              4917.551,
              6759.176
            ],
            [
              -8674.97,
              4909.278,
              6798.916
            ],
            [
              -9185.609,
              4829.613,
              7315.731
            ],
            [
              -9269.169,
              4812.038,
              7401.119
            ],
            [
              -9558.495,
              4764.378,
              7694.345
            ],
            [
              -9588.344,
              4754.839,
              7725.681
            ],
            [
              -9674.339,
              4746.201,
              7812.109
            ],
            [
              -9691.208,
              4740.905,
              7829.789
            ],
            [
              -9773.869,
              4738.891,
              7912.475
            ],
            [
              -9802.39,
              4731.556,
              7941.924
            ],
            [
              -9849.213,
              4710.042,
              7993.453
            ],
            [
              -10016.251,
              4679.317,
              8163.293
            ],
            [
              -10029.91,
              4672.856,
              8178.403
            ],
            [
              -10035.843,
              4665.159,
              8188.122
            ],
            [
              -10041.326,
              4645.21,
              8208.811
            ],
            [
              -10038.868,
              4637.378,
              8217.019
            ],
            [
              -10034.44,
              4631.742,
              8224.187
            ],
            [
              -10024.132,
              4630.464,
              8234.574
            ],
            [
              -10003.374,
              4636.812,
              8256.28
            ],
            [
              -9985.268,
              4638.749,
              8274.489
            ],
            [
              -9974.208,
              4644.138,
              8286.792
            ],
            [
              -9966.985,
              4651.815,
              8297.333
            ],
            [
              -9956.86,
              4679.482,
              8326.795
            ],
            [
              -9956.789,
              4683.933,
              8331.247
            ],
            [
              -9961.898,
              4687.354,
              8337.396
            ],
            [
              -10095.11,
              4672.784,
              8471.402
            ],
            [
              -10234.242,
              4691.698,
              8611.814
            ],
            [
              -10328.863,
              4708.788,
              8707.966
            ],
            [
              -10457.848,
              4716.402,
              8837.176
            ],
            [
              -10625.087,
              4713.487,
              9004.44
            ],
            [
              -10645.983,
              4820.681,
              9113.651
            ],
            [
              -10656.837,
              4909.906,
              9203.533
            ],
            [
              -10709.285,
              5185.685,
              9484.256
            ],
            [
              -10725.756,
              5287.243,
              9587.14
            ],
            [
              -10747.257,
              5356.598,
              9659.752
            ],
            [
              -10770.707,
              5466.058,
              9771.695
            ],
            [
              -10773.201,
              5471.663,
              9777.83
            ],
            [
              -10785.271,
              5484.098,
              9795.161
            ],
            [
              -10799.977,
              5493.236,
              9812.474
            ],
            [
              -10816.008,
              5500.168,
              9829.94
            ],
            [
              -10854.979,
              5526.386,
              9876.909
            ],
            [
              -10936.846,
              5575.542,
              9972.4
            ],
            [
              -10955.931,
              5593.653,
              9998.71
            ],
            [
              -10973.058,
              5654.033,
              10061.473
            ],
            [
              -10992.852,
              5750.076,
              10159.534
            ],
            [
              -10990.06,
              5763.39,
              10173.138
            ],
            [
              -10980.062,
              5783.27,
              10195.39
            ],
            [
              -10955.774,
              5808.49,
              10230.403
            ],
            [
              -10898.789,
              5859.91,
              10307.158
            ],
            [
              -10872.164,
              5869.508,
              10335.46
            ],
            [
              -10795.047,
              5887.215,
              10414.584
            ],
            [
              -10745.688,
              5905.359,
              10467.172
            ],
            [
              -10731.991,
              5914.048,
              10483.393
            ],
            [
              -10703.077,
              5945.872,
              10526.391
            ],
            [
              -10692.678,
              5950.16,
              10537.639
            ],
            [
              -10690.148,
              5946.781,
              10541.86
            ],
            [
              -10692.138,
              5943.473,
              10545.72
            ],
            [
              -10703.828,
              5939.205,
              10558.165
            ],
            [
              -10737.924,
              5906.349,
              10605.515
            ],
            [
              -10772.994,
              5893.545,
              10642.849
            ],
            [
              -10833.937,
              5877.81,
              10705.792
            ],
            [
              -10887.815,
              5859.737,
              10762.62
            ],
            [
              -10906.676,
              5851.129,
              10783.352
            ],
            [
              -10974.862,
              5785.414,
              10878.051
            ],
            [
              -10976.799,
              5785.444,
              10879.988
            ],
            [
              -10986.902,
              5758.888,
              10908.401
            ],
            [
              -10985.039,
              5713.219,
              10954.108
            ],
            [
              -10959.105,
              5597.043,
              11073.144
            ],
            [
              -10950.296,
              5582.433,
              11090.204
            ],
            [
              -10886.221,
              5551.368,
              11161.412
            ],
            [
              -10778.242,
              5479.535,
              11291.103
            ],
            [
              -10759.827,
              5419.133,
              11354.249
            ],
            [
              -10743.002,
              5339.834,
              11435.314
            ],
            [
              -10725.721,
              5289.468,
              11488.561
            ],
            [
              -10643.067,
              4841.785,
              11943.811
            ],
            [
              -10625.016,
              4717.939,
              12068.965
            ],
            [
              -10404.928,
              4715.562,
              12289.066
            ],
            [
              -10343.026,
              4711.239,
              12351.119
            ],
            [
              -10142.866,
              4673.545,
              12554.797
            ],
            [
              -10106.797,
              4668.517,
              12591.215
            ],
            [
              -10049.863,
              4676.514,
              12648.708
            ],
            [
              -10001.283,
              4686.87,
              12698.379
            ],
            [
              -9954.065,
              4692.795,
              12745.968
            ],
            [
              -9954.87,
              4682.79,
              12756.006
            ],
            [
              -9971.053,
              4639.635,
              12802.095
            ],
            [
              -9996.31,
              4634.472,
              12827.875
            ],
            [
              -10015.813,
              4625.879,
              12849.187
            ],
            [
              -10037.72,
              4628.455,
              12871.244
            ],
            [
              -10042.829,
              4631.876,
              12877.394
            ],
            [
              -10045.914,
              4640.83,
              12886.864
            ],
            [
              -10043.084,
              4656.369,
              12902.659
            ],
            [
              -10039.034,
              4667.436,
              12914.444
            ],
            [
              -10033.119,
              4674.021,
              12923.295
            ],
            [
              -9847.833,
              4715.586,
              13113.186
            ],
            [
              -9780.287,
              4741.22,
              13185.433
            ],
            [
              -9738.284,
              4743.887,
              13227.52
            ],
            [
              -9619.286,
              4757.562,
              13347.302
            ],
            [
              -9574.594,
              4766.863,
              13392.951
            ],
            [
              -9511.688,
              4784.775,
              13458.357
            ],
            [
              -9185.609,
              4829.613,
              13787.505
            ],
            [
              -9175.58,
              5010.897,
              13969.067
            ],
            [
              -9167.098,
              5056.4,
              14015.353
            ],
            [
              -9158.902,
              5124.171,
              14083.618
            ],
            [
              -9120.102,
              5527.623,
              14488.931
            ],
            [
              -9120.138,
              5525.397,
              14491.157
            ],
            [
              -9105.787,
              5654.292,
              14620.849
            ],
            [
              -9088.239,
              5861.057,
              14828.357
            ],
            [
              -9065.832,
              6048.82,
              15017.452
            ],
            [
              -9042.56,
              6290,
              15259.752
            ],
            [
              -9035.69,
              6315.492,
              15286.153
            ],
            [
              -9027.745,
              6327.608,
              15300.642
            ],
            [
              -9013.989,
              6339.63,
              15318.911
            ],
            [
              -8763.039,
              6403.466,
              15577.853
            ],
            [
              -8591.391,
              6435.185,
              15752.407
            ],
            [
              -8565.567,
              6434.764,
              15778.235
            ],
            [
              -8514.008,
              6428.359,
              15830.19
            ],
            [
              -8481.082,
              6427.822,
              15863.12
            ],
            [
              -8464.869,
              6432.011,
              15879.865
            ],
            [
              -8454.412,
              6439.632,
              15892.805
            ],
            [
              -8442.7,
              6445.007,
              15905.691
            ],
            [
              -8405.319,
              6480.019,
              15956.908
            ],
            [
              -8381.214,
              6492.984,
              15984.279
            ],
            [
              -8346.332,
              6493.528,
              16019.165
            ],
            [
              -8332.81,
              6491.081,
              16032.907
            ],
            [
              -8313.605,
              6480.748,
              16054.715
            ],
            [
              -8257.445,
              6439.757,
              16124.244
            ],
            [
              -8216.781,
              6399.018,
              16181.804
            ],
            [
              -8090.106,
              6365.775,
              16312.768
            ],
            [
              -8047.971,
              6336.143,
              16364.28
            ],
            [
              -7869.852,
              6289.806,
              16548.327
            ],
            [
              -7783.654,
              6269.464,
              16636.893
            ],
            [
              -7104.955,
              6152.496,
              17325.597
            ],
            [
              -7039.365,
              6135.823,
              17393.273
            ],
            [
              -6990.505,
              6122.766,
              17443.848
            ],
            [
              -6923.128,
              6097.155,
              17515.929
            ],
            [
              -6819.933,
              6050.909,
              17629.012
            ],
            [
              -6722.128,
              5991.393,
              17743.502
            ],
            [
              -6610.439,
              6453.723,
              18219.132
            ],
            [
              -6615.859,
              6477.191,
              18243.217
            ],
            [
              -6611.247,
              6482.68,
              18250.387
            ],
            [
              -6601.507,
              6485.856,
              18260.632
            ],
            [
              -6595.808,
              6479.082,
              18269.485
            ],
            [
              -6595.901,
              6473.518,
              18275.05
            ],
            [
              -6598.614,
              6465.771,
              18283.258
            ],
            [
              -6609.831,
              6451.487,
              18301.42
            ],
            [
              -6653.627,
              6265.205,
              18492.781
            ],
            [
              -6722.128,
              5991.393,
              18775.032
            ],
            [
              -6663.331,
              5954.79,
              18844.29
            ],
            [
              -6413.106,
              5704.591,
              19198.143
            ],
            [
              -6357.16,
              5652.447,
              19274.622
            ],
            [
              -6334.791,
              5638.714,
              19300.871
            ],
            [
              -6315.93,
              5608.341,
              19336.623
            ],
            [
              -6284.365,
              5565.511,
              19389.828
            ],
            [
              -6235.578,
              5510.146,
              19463.622
            ],
            [
              -6210.778,
              5487.465,
              19497.229
            ],
            [
              -6170.561,
              5460.073,
              19545.888
            ],
            [
              -6118.615,
              5439.162,
              19601.885
            ],
            [
              -6089.662,
              5433.109,
              19631.464
            ],
            [
              -6052.281,
              5429.14,
              19669.055
            ],
            [
              -6005.048,
              5435.024,
              19716.653
            ],
            [
              -5948.573,
              5452.996,
              19775.919
            ],
            [
              -5873.554,
              5498.484,
              19863.651
            ],
            [
              -5789.253,
              5558.286,
              19967.01
            ],
            [
              -5728.563,
              5596.222,
              20038.58
            ],
            [
              -5697.335,
              5610.165,
              20072.78
            ],
            [
              -5669.446,
              5617.486,
              20101.613
            ],
            [
              -5631.932,
              5621.303,
              20139.322
            ],
            [
              -5582.93,
              5617.134,
              20188.5
            ],
            [
              -5526.428,
              5598.366,
              20248.038
            ],
            [
              -5379.437,
              5509.043,
              20420.041
            ],
            [
              -4710.592,
              5090.204,
              21209.204
            ],
            [
              -4580.889,
              5011.17,
              21361.091
            ],
            [
              -4517.509,
              4980.025,
              21431.71
            ],
            [
              -4380.813,
              4857.45,
              21615.313
            ],
            [
              -4298.311,
              4774.766,
              21732.117
            ],
            [
              -4237.94,
              4719.179,
              21814.182
            ],
            [
              -4229.781,
              4705.68,
              21829.955
            ],
            [
              -4240.925,
              4695.853,
              21844.813
            ],
            [
              -4266.982,
              4719.679,
              21880.122
            ],
            [
              -4289.168,
              4743.439,
              21912.629
            ],
            [
              -4311.679,
              4748.279,
              21935.655
            ],
            [
              -4321.909,
              4754.022,
              21947.386
            ],
            [
              -4333.961,
              4766.474,
              21964.716
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -510,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 378.505,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 718.262,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6309",
              "position": {
                "x": -6721.281,
                "z": 2678.551
              },
              "distanceAlongShapeM": 3229.039,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6297",
              "position": {
                "x": -7611.222,
                "z": 3413.556
              },
              "distanceAlongShapeM": 4415.851,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6294",
              "position": {
                "x": -8136.789,
                "z": 3831.848
              },
              "distanceAlongShapeM": 5108.971,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6290",
              "position": {
                "x": -8674.97,
                "z": 4909.278
              },
              "distanceAlongShapeM": 6798.916,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6282",
              "position": {
                "x": -9588.344,
                "z": 4754.839
              },
              "distanceAlongShapeM": 7725.681,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6286",
              "position": {
                "x": -10003.374,
                "z": 4636.812
              },
              "distanceAlongShapeM": 8256.28,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:15829",
              "position": {
                "x": -10645.983,
                "z": 4820.681
              },
              "distanceAlongShapeM": 9113.651,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:15833",
              "position": {
                "x": -10816.008,
                "z": 5500.168
              },
              "distanceAlongShapeM": 9829.94,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:15837",
              "position": {
                "x": -10692.138,
                "z": 5943.473
              },
              "distanceAlongShapeM": 10545.72,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:15835",
              "position": {
                "x": -10886.221,
                "z": 5551.368
              },
              "distanceAlongShapeM": 11161.412,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:15831",
              "position": {
                "x": -10643.067,
                "z": 4841.785
              },
              "distanceAlongShapeM": 11943.811,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9626",
              "position": {
                "x": -10015.813,
                "z": 4625.879
              },
              "distanceAlongShapeM": 12849.187,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6283",
              "position": {
                "x": -9574.594,
                "z": 4766.863
              },
              "distanceAlongShapeM": 13392.951,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6278",
              "position": {
                "x": -9175.58,
                "z": 5010.897
              },
              "distanceAlongShapeM": 13969.067,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6276",
              "position": {
                "x": -9120.102,
                "z": 5527.623
              },
              "distanceAlongShapeM": 14488.931,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6273",
              "position": {
                "x": -9088.239,
                "z": 5861.057
              },
              "distanceAlongShapeM": 14828.357,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6271",
              "position": {
                "x": -8763.039,
                "z": 6403.466
              },
              "distanceAlongShapeM": 15577.853,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:9776",
              "position": {
                "x": -8090.106,
                "z": 6365.775
              },
              "distanceAlongShapeM": 16312.768,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:9967",
              "position": {
                "x": -6701.294,
                "z": 6078.986
              },
              "distanceAlongShapeM": 17833.539,
              "shapeOffsetM": 0.317,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:357",
              "position": {
                "x": -6598.614,
                "z": 6465.771
              },
              "distanceAlongShapeM": 18283.258,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:4410",
              "position": {
                "x": -6663.331,
                "z": 5954.79
              },
              "distanceAlongShapeM": 18844.29,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5731",
              "position": {
                "x": -6334.791,
                "z": 5638.714
              },
              "distanceAlongShapeM": 19300.871,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 21431.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            }
          ],
          "departuresSeconds": [
            19680,
            22620,
            26520,
            30000,
            33720,
            38280,
            42300,
            45660,
            49020,
            52500,
            56280,
            59400,
            64140,
            68580,
            72360,
            75900,
            79080,
            82740
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_63",
      "sourceRouteId": "vilnius_bus_63",
      "mode": "bus",
      "shortName": "63",
      "longName": "Žvėrynas–Pilaitės pr.–Karveliškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_63:0",
          "sourceRouteId": "vilnius_bus_63",
          "sourceShapeId": "vilnius_bus_63_a-b",
          "directionId": 0,
          "headsign": "Karveliškės",
          "directionName": "Žvėrynas–Pilaitės pr.–Karveliškės",
          "mode": "bus",
          "routeShortName": "63",
          "routeLongName": "Žvėrynas–Pilaitės pr.–Karveliškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2130.763,
              -1067.398,
              0
            ],
            [
              -2108.809,
              -1065.561,
              22.031
            ],
            [
              -2071.721,
              -1082.918,
              62.979
            ],
            [
              -2068.854,
              -1103.007,
              83.272
            ],
            [
              -2072.195,
              -1109.627,
              90.687
            ],
            [
              -2142.708,
              -1122.847,
              162.428
            ],
            [
              -2159.624,
              -1131.453,
              181.407
            ],
            [
              -2184.551,
              -1155.502,
              216.044
            ],
            [
              -2202.716,
              -1161.859,
              235.29
            ],
            [
              -2224.67,
              -1163.697,
              257.32
            ],
            [
              -2246.137,
              -1174.448,
              281.329
            ],
            [
              -2255.963,
              -1183.18,
              294.474
            ],
            [
              -2262.447,
              -1185.292,
              301.294
            ],
            [
              -2339.674,
              -1177.245,
              378.939
            ],
            [
              -2392.506,
              -1175.197,
              431.811
            ],
            [
              -2433.855,
              -1180.032,
              473.441
            ],
            [
              -2474.658,
              -1190.444,
              515.551
            ],
            [
              -2521.496,
              -1214.107,
              568.028
            ],
            [
              -2594.45,
              -1256.235,
              652.272
            ],
            [
              -2624.997,
              -1270.168,
              685.847
            ],
            [
              -2680.78,
              -1289.223,
              744.794
            ],
            [
              -2710.565,
              -1296.491,
              775.453
            ],
            [
              -2777.752,
              -1304.214,
              843.082
            ],
            [
              -2815.153,
              -1304.669,
              880.487
            ],
            [
              -2855.074,
              -1301.74,
              920.515
            ],
            [
              -3099.309,
              -1258.49,
              1168.55
            ],
            [
              -3140.52,
              -1255.542,
              1209.866
            ],
            [
              -3159.719,
              -1247.413,
              1230.715
            ],
            [
              -3359.526,
              -1207.182,
              1434.531
            ],
            [
              -3495.953,
              -1192.555,
              1571.741
            ],
            [
              -3569.469,
              -1193.5,
              1645.263
            ],
            [
              -3626.266,
              -1196.964,
              1702.165
            ],
            [
              -3688.025,
              -1189.21,
              1764.409
            ],
            [
              -3714.785,
              -1170.933,
              1796.815
            ],
            [
              -3768.733,
              -1158.863,
              1852.097
            ],
            [
              -3858.305,
              -1156.194,
              1941.708
            ],
            [
              -4063.615,
              -1172.672,
              2147.679
            ],
            [
              -4237.967,
              -1188.581,
              2322.755
            ],
            [
              -4268.356,
              -1193.623,
              2353.559
            ],
            [
              -4294.993,
              -1205.408,
              2382.687
            ],
            [
              -4333.704,
              -1206.966,
              2421.429
            ],
            [
              -4364.15,
              -1215.347,
              2453.008
            ],
            [
              -4597.068,
              -1300.392,
              2700.966
            ],
            [
              -4637.998,
              -1318.612,
              2745.768
            ],
            [
              -4714.189,
              -1362.945,
              2833.919
            ],
            [
              -4755.992,
              -1394.51,
              2886.3
            ],
            [
              -4809.036,
              -1442.581,
              2957.886
            ],
            [
              -4834.84,
              -1481.101,
              3004.25
            ],
            [
              -5092.18,
              -1789.506,
              3405.918
            ],
            [
              -5145.16,
              -1834.242,
              3475.259
            ],
            [
              -5263.682,
              -1904.577,
              3613.08
            ],
            [
              -5341.696,
              -1943.323,
              3700.186
            ],
            [
              -5353.315,
              -1944.238,
              3711.84
            ],
            [
              -5858.685,
              -2210.618,
              4283.118
            ],
            [
              -5880.858,
              -2225.828,
              4310.006
            ],
            [
              -6049.087,
              -2302.022,
              4494.685
            ],
            [
              -6102.245,
              -2320.049,
              4550.817
            ],
            [
              -6166.945,
              -2334.543,
              4617.12
            ],
            [
              -6282.493,
              -2344.842,
              4733.126
            ],
            [
              -6377.159,
              -2339.91,
              4827.92
            ],
            [
              -6675.557,
              -2338.243,
              5126.323
            ],
            [
              -6743.953,
              -2342.665,
              5194.862
            ],
            [
              -6892.765,
              -2337.952,
              5343.748
            ],
            [
              -6953.428,
              -2342.505,
              5404.582
            ],
            [
              -7022.394,
              -2342.468,
              5473.548
            ],
            [
              -7057.945,
              -2348.555,
              5509.617
            ],
            [
              -7082.45,
              -2349.26,
              5534.131
            ],
            [
              -7159.459,
              -2329.054,
              5613.747
            ],
            [
              -7293.506,
              -2327.939,
              5747.799
            ],
            [
              -7577.175,
              -2332.143,
              6031.5
            ],
            [
              -7627.546,
              -2337.989,
              6082.209
            ],
            [
              -7864.838,
              -2344.091,
              6319.579
            ],
            [
              -7926.163,
              -2349.76,
              6381.165
            ],
            [
              -7948.145,
              -2353.85,
              6403.524
            ],
            [
              -8020.127,
              -2380.496,
              6480.28
            ],
            [
              -8196.744,
              -2459.97,
              6673.954
            ],
            [
              -8274.722,
              -2498.766,
              6761.05
            ],
            [
              -8768.854,
              -2723.349,
              7303.825
            ],
            [
              -8836.225,
              -2744.516,
              7374.442
            ],
            [
              -8885.999,
              -2753.725,
              7425.061
            ],
            [
              -9059.016,
              -2772.066,
              7599.048
            ],
            [
              -9106.213,
              -2781.319,
              7647.143
            ],
            [
              -9165.186,
              -2801.514,
              7709.479
            ],
            [
              -9383.037,
              -2882.593,
              7941.927
            ],
            [
              -9462.876,
              -2918.039,
              8029.282
            ],
            [
              -9640.43,
              -2978.63,
              8216.89
            ],
            [
              -9797.309,
              -3036.22,
              8384.005
            ],
            [
              -10065.1,
              -3138.793,
              8670.768
            ],
            [
              -10141.388,
              -3154.27,
              8748.61
            ],
            [
              -10178.808,
              -3157.012,
              8786.13
            ],
            [
              -10233.515,
              -3152.799,
              8841
            ],
            [
              -10324.141,
              -3137.995,
              8932.827
            ],
            [
              -10579.633,
              -3076.045,
              9195.723
            ],
            [
              -10704.284,
              -3052.916,
              9322.501
            ],
            [
              -10761.968,
              -3033.078,
              9383.501
            ],
            [
              -10849.933,
              -3012.762,
              9473.781
            ],
            [
              -10931.438,
              -2991.436,
              9558.03
            ],
            [
              -10944.844,
              -2983.432,
              9573.644
            ],
            [
              -10952.552,
              -2941.009,
              9616.761
            ],
            [
              -10960.523,
              -2915.28,
              9643.696
            ],
            [
              -10988.098,
              -2865.865,
              9700.285
            ],
            [
              -11029.76,
              -2810.662,
              9769.445
            ],
            [
              -11082.622,
              -2770.868,
              9835.611
            ],
            [
              -11131.081,
              -2737.822,
              9894.265
            ],
            [
              -11233.535,
              -2654.947,
              10026.042
            ],
            [
              -11321.574,
              -2556.717,
              10157.951
            ],
            [
              -11361.884,
              -2497.086,
              10229.929
            ],
            [
              -11384.956,
              -2447.744,
              10284.398
            ],
            [
              -11399.791,
              -2407.437,
              10327.348
            ],
            [
              -11406.46,
              -2380.617,
              10354.985
            ],
            [
              -11412.342,
              -2303.716,
              10432.111
            ],
            [
              -11414.047,
              -2248.031,
              10487.822
            ],
            [
              -11422.752,
              -2186.67,
              10549.797
            ],
            [
              -11430.832,
              -2167.619,
              10570.49
            ],
            [
              -11442.831,
              -2151.847,
              10590.308
            ],
            [
              -11463.119,
              -2130.379,
              10619.847
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4898",
              "position": {
                "x": -2071.721,
                "z": -1082.918
              },
              "distanceAlongShapeM": 62.979,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 1209.866,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 1764.409,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 2382.687,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8060",
              "position": {
                "x": -4834.84,
                "z": -1481.101
              },
              "distanceAlongShapeM": 3004.25,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7947",
              "position": {
                "x": -5880.858,
                "z": -2225.828
              },
              "distanceAlongShapeM": 4310.006,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7948",
              "position": {
                "x": -6282.493,
                "z": -2344.842
              },
              "distanceAlongShapeM": 4733.126,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7950",
              "position": {
                "x": -6743.953,
                "z": -2342.665
              },
              "distanceAlongShapeM": 5194.862,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:8370",
              "position": {
                "x": -7627.546,
                "z": -2337.989
              },
              "distanceAlongShapeM": 6082.209,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:19051",
              "position": {
                "x": -8274.722,
                "z": -2498.766
              },
              "distanceAlongShapeM": 6761.05,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7700",
              "position": {
                "x": -9462.876,
                "z": -2918.039
              },
              "distanceAlongShapeM": 8029.282,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7702",
              "position": {
                "x": -10704.284,
                "z": -3052.916
              },
              "distanceAlongShapeM": 9322.501,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7692",
              "position": {
                "x": -11463.119,
                "z": -2130.379
              },
              "distanceAlongShapeM": 10619.847,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            19200,
            21900,
            24540,
            28020,
            32160,
            35700,
            38460,
            41160,
            43860,
            46560,
            49260,
            51960,
            54660,
            57360,
            60300,
            63300,
            66300,
            69540,
            73860,
            76860,
            79560,
            82260
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_63:1",
          "sourceRouteId": "vilnius_bus_63",
          "sourceShapeId": "vilnius_bus_63_b-a",
          "directionId": 1,
          "headsign": "Žvėrynas",
          "directionName": "Karveliškės–Pilaitės pr.–Žvėrynas",
          "mode": "bus",
          "routeShortName": "63",
          "routeLongName": "Žvėrynas–Pilaitės pr.–Karveliškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -11463.119,
              -2130.379,
              0
            ],
            [
              -11478.95,
              -2112.32,
              24.015
            ],
            [
              -11480.134,
              -2105.622,
              30.817
            ],
            [
              -11472.906,
              -2096.83,
              42.198
            ],
            [
              -11468.378,
              -2095.788,
              46.845
            ],
            [
              -11462.613,
              -2098.105,
              53.058
            ],
            [
              -11451.851,
              -2110.518,
              69.487
            ],
            [
              -11421.863,
              -2171.1,
              137.085
            ],
            [
              -11415.768,
              -2193.459,
              160.259
            ],
            [
              -11412.478,
              -2230.245,
              197.192
            ],
            [
              -11410.759,
              -2326.004,
              292.967
            ],
            [
              -11403.308,
              -2385.119,
              352.549
            ],
            [
              -11384.868,
              -2442.18,
              412.516
            ],
            [
              -11370.573,
              -2475.799,
              449.048
            ],
            [
              -11333.536,
              -2538.718,
              522.059
            ],
            [
              -11267.786,
              -2619.9,
              626.527
            ],
            [
              -11241.109,
              -2644.809,
              663.025
            ],
            [
              -11205.501,
              -2675.425,
              709.986
            ],
            [
              -11032.929,
              -2807.273,
              927.16
            ],
            [
              -11013.864,
              -2824.271,
              952.703
            ],
            [
              -10985.538,
              -2867.019,
              1003.983
            ],
            [
              -10969.888,
              -2896.209,
              1037.104
            ],
            [
              -10945.588,
              -2948.912,
              1095.139
            ],
            [
              -10945.869,
              -2966.718,
              1112.948
            ],
            [
              -10941.553,
              -2979.031,
              1125.995
            ],
            [
              -10933.962,
              -2988.056,
              1137.788
            ],
            [
              -10910.892,
              -2996.213,
              1162.258
            ],
            [
              -10783.07,
              -3022.726,
              1292.801
            ],
            [
              -10408.881,
              -3117.721,
              1678.86
            ],
            [
              -10364.569,
              -3127.333,
              1724.202
            ],
            [
              -10252.772,
              -3148.039,
              1837.901
            ],
            [
              -10213.526,
              -3152.005,
              1877.347
            ],
            [
              -10132.906,
              -3147.727,
              1958.08
            ],
            [
              -10044.985,
              -3130.209,
              2047.729
            ],
            [
              -9814.167,
              -3042.628,
              2294.604
            ],
            [
              -9595.599,
              -2955.975,
              2529.723
            ],
            [
              -9481.578,
              -2918.851,
              2649.635
            ],
            [
              -9152.855,
              -2796.148,
              3000.513
            ],
            [
              -9059.624,
              -2769.83,
              3097.386
            ],
            [
              -8909.23,
              -2755.574,
              3248.455
            ],
            [
              -8882.796,
              -2754.89,
              3274.898
            ],
            [
              -8845.962,
              -2748.81,
              3312.23
            ],
            [
              -8768.872,
              -2724.462,
              3393.074
            ],
            [
              -8572.12,
              -2634.162,
              3609.558
            ],
            [
              -8422.08,
              -2563.144,
              3775.557
            ],
            [
              -8320.689,
              -2511.371,
              3889.401
            ],
            [
              -8261.598,
              -2484.51,
              3954.311
            ],
            [
              -7980.509,
              -2362.223,
              4260.848
            ],
            [
              -7940.983,
              -2349.516,
              4302.366
            ],
            [
              -7448.799,
              -2325.363,
              4795.143
            ],
            [
              -7201.894,
              -2322.782,
              5042.061
            ],
            [
              -7172.861,
              -2321.039,
              5071.147
            ],
            [
              -7097.84,
              -2344.551,
              5149.766
            ],
            [
              -7004.314,
              -2340.543,
              5243.377
            ],
            [
              -6921.172,
              -2340.817,
              5326.52
            ],
            [
              -6862.312,
              -2328.441,
              5386.667
            ],
            [
              -6640.332,
              -2313.23,
              5609.167
            ],
            [
              -6613.194,
              -2309.232,
              5636.599
            ],
            [
              -6575.914,
              -2315.423,
              5674.389
            ],
            [
              -6380.632,
              -2316.474,
              5869.674
            ],
            [
              -6294.875,
              -2314.577,
              5955.452
            ],
            [
              -6243.894,
              -2310.982,
              6006.559
            ],
            [
              -6220.641,
              -2308.034,
              6029.999
            ],
            [
              -6201.86,
              -2302.785,
              6049.5
            ],
            [
              -6171.35,
              -2289.941,
              6082.603
            ],
            [
              -6126.719,
              -2280.674,
              6128.186
            ],
            [
              -6104.034,
              -2273.265,
              6152.05
            ],
            [
              -5924.643,
              -2185.012,
              6351.974
            ],
            [
              -5877.169,
              -2160.211,
              6405.536
            ],
            [
              -5847.188,
              -2140.681,
              6441.317
            ],
            [
              -5795.942,
              -2121.511,
              6496.032
            ],
            [
              -5568.568,
              -2017.388,
              6746.112
            ],
            [
              -5236.974,
              -1850.486,
              7117.341
            ],
            [
              -5169.837,
              -1807.104,
              7197.275
            ],
            [
              -5127.302,
              -1769.981,
              7253.731
            ],
            [
              -5012.864,
              -1637.24,
              7428.992
            ],
            [
              -4831.761,
              -1414.361,
              7716.173
            ],
            [
              -4761.883,
              -1362.126,
              7803.417
            ],
            [
              -4704.97,
              -1314.122,
              7877.872
            ],
            [
              -4653.804,
              -1300.53,
              7930.812
            ],
            [
              -4405.208,
              -1203.507,
              8197.67
            ],
            [
              -4296.995,
              -1171.977,
              8310.383
            ],
            [
              -4247.02,
              -1152.802,
              8363.911
            ],
            [
              -4191.003,
              -1157.11,
              8420.093
            ],
            [
              -3912.099,
              -1135.223,
              8699.855
            ],
            [
              -3759.013,
              -1118.956,
              8853.802
            ],
            [
              -3705.284,
              -1106.532,
              8908.949
            ],
            [
              -3657.704,
              -1114.039,
              8957.118
            ],
            [
              -3599.031,
              -1113.947,
              9015.791
            ],
            [
              -3412.497,
              -1176.2,
              9212.438
            ],
            [
              -3355.367,
              -1190.556,
              9271.345
            ],
            [
              -3108.49,
              -1230.499,
              9521.432
            ],
            [
              -3070.013,
              -1242.306,
              9561.68
            ],
            [
              -2879.155,
              -1277.94,
              9755.835
            ],
            [
              -2839.273,
              -1283.094,
              9796.049
            ],
            [
              -2787.087,
              -1285.125,
              9848.275
            ],
            [
              -2748.376,
              -1283.58,
              9887.017
            ],
            [
              -2714.118,
              -1278.617,
              9921.632
            ],
            [
              -2670.7,
              -1266.023,
              9966.84
            ],
            [
              -2624.585,
              -1246.798,
              10016.801
            ],
            [
              -2500.301,
              -1182.198,
              10156.872
            ],
            [
              -2469.831,
              -1172.717,
              10188.783
            ],
            [
              -2418.716,
              -1162.489,
              10240.911
            ],
            [
              -2392.231,
              -1159.617,
              10267.552
            ],
            [
              -2246.137,
              -1174.448,
              10414.397
            ],
            [
              -2229.866,
              -1165.831,
              10432.809
            ],
            [
              -2190.996,
              -1155.388,
              10473.057
            ],
            [
              -2164.136,
              -1131.373,
              10509.087
            ],
            [
              -2142.708,
              -1122.847,
              10532.149
            ],
            [
              -2138.761,
              -1118.464,
              10538.047
            ],
            [
              -2144.773,
              -1093.867,
              10563.368
            ],
            [
              -2147.916,
              -1089.358,
              10568.865
            ],
            [
              -2139.925,
              -1075.028,
              10585.272
            ],
            [
              -2130.763,
              -1067.398,
              10597.195
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4686",
              "position": {
                "x": -11439.329,
                "z": -2134.091
              },
              "distanceAlongShapeM": 96.168,
              "shapeOffsetM": 0.764,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7703",
              "position": {
                "x": -10783.07,
                "z": -3022.726
              },
              "distanceAlongShapeM": 1292.801,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:7701",
              "position": {
                "x": -9595.599,
                "z": -2955.975
              },
              "distanceAlongShapeM": 2529.723,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7699",
              "position": {
                "x": -8261.598,
                "z": -2484.51
              },
              "distanceAlongShapeM": 3954.311,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:8371",
              "position": {
                "x": -7448.799,
                "z": -2325.363
              },
              "distanceAlongShapeM": 4795.143,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7951",
              "position": {
                "x": -6613.194,
                "z": -2309.232
              },
              "distanceAlongShapeM": 5636.599,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:7949",
              "position": {
                "x": -6171.35,
                "z": -2289.941
              },
              "distanceAlongShapeM": 6082.603,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:8069",
              "position": {
                "x": -5847.188,
                "z": -2140.681
              },
              "distanceAlongShapeM": 6441.317,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 7877.872,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 8363.911,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1350,
              "departureOffsetSeconds": 1350
            },
            {
              "stopId": "judu:stop:7342",
              "position": {
                "x": -3705.284,
                "z": -1106.532
              },
              "distanceAlongShapeM": 8908.949,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 9521.432,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:18480",
              "position": {
                "x": -2130.763,
                "z": -1067.398
              },
              "distanceAlongShapeM": 10597.195,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1710,
              "departureOffsetSeconds": 1710
            }
          ],
          "departuresSeconds": [
            21840,
            24600,
            27360,
            31020,
            35100,
            38400,
            41100,
            43800,
            46500,
            49200,
            51900,
            54720,
            57420,
            60300,
            63300,
            66360,
            69420,
            72480,
            76380,
            79440,
            82200,
            85020
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_65",
      "sourceRouteId": "vilnius_bus_65",
      "mode": "bus",
      "shortName": "65",
      "longName": "Ožkiniai–Naujieji Verkiai–Balsių g.–Pagubė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_65:0",
          "sourceRouteId": "vilnius_bus_65",
          "sourceShapeId": "vilnius_bus_65_a-b",
          "directionId": 0,
          "headsign": "Pagubė",
          "directionName": "Ožkiniai–Naujieji Verkiai–Balsių g.–Pagubė",
          "mode": "bus",
          "routeShortName": "65",
          "routeLongName": "Ožkiniai–Naujieji Verkiai–Balsių g.–Pagubė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5527.927,
              -9014.957,
              0
            ],
            [
              5522.158,
              -9013.731,
              5.898
            ],
            [
              5505.197,
              -8992.248,
              33.269
            ],
            [
              5326.247,
              -8926.422,
              223.942
            ],
            [
              5181.908,
              -8867.954,
              379.673
            ],
            [
              5168.309,
              -8872.143,
              393.903
            ],
            [
              5160.588,
              -8871.993,
              401.626
            ],
            [
              5075.764,
              -8831.384,
              495.67
            ],
            [
              5012.471,
              -8809.005,
              562.802
            ],
            [
              4968.931,
              -8797.029,
              607.959
            ],
            [
              4931.204,
              -8784.053,
              647.856
            ],
            [
              4880.2,
              -8758.574,
              704.869
            ],
            [
              4856.05,
              -8742.521,
              733.868
            ],
            [
              4825.057,
              -8714.09,
              775.926
            ],
            [
              4777.893,
              -8656.401,
              850.441
            ],
            [
              4728.926,
              -8591.999,
              931.345
            ],
            [
              4682.36,
              -8536.549,
              1003.754
            ],
            [
              4628.135,
              -8477.613,
              1083.84
            ],
            [
              4600.957,
              -8451.483,
              1121.541
            ],
            [
              4583.775,
              -8441.133,
              1141.6
            ],
            [
              4567.43,
              -8420.779,
              1167.704
            ],
            [
              4545.829,
              -8405.89,
              1193.939
            ],
            [
              4510.007,
              -8394.067,
              1231.663
            ],
            [
              4491.387,
              -8391.482,
              1250.46
            ],
            [
              4467.148,
              -8379.883,
              1277.332
            ],
            [
              4440.42,
              -8363.783,
              1308.535
            ],
            [
              4421.264,
              -8355.621,
              1329.357
            ],
            [
              4405.819,
              -8355.324,
              1344.804
            ],
            [
              4381.945,
              -8358.205,
              1368.852
            ],
            [
              4345.651,
              -8370.867,
              1407.291
            ],
            [
              4326.946,
              -8372.734,
              1426.089
            ],
            [
              4315.856,
              -8380.314,
              1439.522
            ],
            [
              4307.749,
              -8400.197,
              1460.994
            ],
            [
              4285.57,
              -8415.357,
              1487.859
            ],
            [
              4240.89,
              -8428.971,
              1534.568
            ],
            [
              4220.749,
              -8438.604,
              1556.894
            ],
            [
              4195.673,
              -8437.01,
              1582.02
            ],
            [
              4153.116,
              -8440.647,
              1624.732
            ],
            [
              4115.601,
              -8449.947,
              1663.384
            ],
            [
              4092.822,
              -8462.87,
              1689.573
            ],
            [
              4075.728,
              -8481.468,
              1714.833
            ],
            [
              4050.55,
              -8518.837,
              1759.893
            ],
            [
              4035.882,
              -8545.275,
              1790.127
            ],
            [
              4021.341,
              -8565.035,
              1814.661
            ],
            [
              4007.035,
              -8572.554,
              1830.822
            ],
            [
              3907.209,
              -8575.097,
              1930.681
            ],
            [
              3890.393,
              -8579.229,
              1947.997
            ],
            [
              3862.489,
              -8590.941,
              1978.26
            ],
            [
              3753.964,
              -8644.532,
              2099.296
            ],
            [
              3744.679,
              -8658.827,
              2116.342
            ],
            [
              3728.98,
              -8671.887,
              2136.762
            ],
            [
              3699.345,
              -8706.946,
              2182.669
            ],
            [
              3684.368,
              -8682.169,
              2211.621
            ],
            [
              3678.273,
              -8664.24,
              2230.557
            ],
            [
              3654.394,
              -8633.726,
              2269.304
            ],
            [
              3621.201,
              -8585.223,
              2328.078
            ],
            [
              3606.987,
              -8520.382,
              2394.458
            ],
            [
              3594.209,
              -8447.776,
              2468.18
            ],
            [
              3584.654,
              -8408.629,
              2508.476
            ],
            [
              3573.643,
              -8378.361,
              2540.684
            ],
            [
              3571.967,
              -8364.97,
              2554.18
            ],
            [
              3567.073,
              -8351.518,
              2568.495
            ],
            [
              3552.201,
              -8321.176,
              2602.286
            ],
            [
              3359.047,
              -8051.431,
              2934.055
            ],
            [
              3339.583,
              -8025.456,
              2966.514
            ],
            [
              3325.551,
              -8018.51,
              2982.17
            ],
            [
              3323.747,
              -8011.796,
              2989.122
            ],
            [
              3327.071,
              -8006.293,
              2995.551
            ],
            [
              3330.31,
              -8005.241,
              2998.957
            ],
            [
              3336.682,
              -8008.702,
              3006.208
            ],
            [
              3345.354,
              -8026.679,
              3026.168
            ],
            [
              3573.636,
              -8344.963,
              3417.853
            ],
            [
              3579.711,
              -8364.004,
              3437.84
            ],
            [
              3610.551,
              -8536.036,
              3612.614
            ],
            [
              3620.105,
              -8575.182,
              3652.91
            ],
            [
              3634.976,
              -8605.524,
              3686.7
            ],
            [
              3682.65,
              -8671.003,
              3767.695
            ],
            [
              3689.389,
              -8688.944,
              3786.86
            ],
            [
              3699.345,
              -8706.946,
              3807.432
            ],
            [
              3679.595,
              -8729.948,
              3837.749
            ],
            [
              3635.803,
              -8764.738,
              3893.678
            ],
            [
              3590.167,
              -8795.04,
              3948.458
            ],
            [
              3553.349,
              -8835.53,
              4003.185
            ],
            [
              3548.675,
              -8844.347,
              4013.164
            ],
            [
              3495.433,
              -8902.337,
              4091.889
            ],
            [
              3482.225,
              -8919.898,
              4113.862
            ],
            [
              3437.527,
              -9002.543,
              4207.82
            ],
            [
              3414.033,
              -9053.306,
              4263.757
            ],
            [
              3395.857,
              -9095.265,
              4309.483
            ],
            [
              3390.888,
              -9119.662,
              4334.382
            ],
            [
              3387.544,
              -9126.278,
              4341.795
            ],
            [
              3382.955,
              -9130.644,
              4348.128
            ],
            [
              3367.386,
              -9137.028,
              4364.955
            ],
            [
              3346.691,
              -9142.201,
              4386.287
            ],
            [
              3334.467,
              -9141.969,
              4398.514
            ],
            [
              3285.429,
              -9182.228,
              4461.961
            ],
            [
              3263.784,
              -9237.481,
              4521.302
            ],
            [
              3255.081,
              -9255.128,
              4540.978
            ],
            [
              3242.519,
              -9272.702,
              4562.58
            ],
            [
              3134.577,
              -9330.771,
              4685.151
            ],
            [
              3165.86,
              -9378.122,
              4741.902
            ],
            [
              3173.907,
              -9394.973,
              4760.577
            ],
            [
              3208.182,
              -9555.935,
              4925.147
            ],
            [
              3213.698,
              -9570.512,
              4940.732
            ],
            [
              3220.563,
              -9581.775,
              4953.923
            ],
            [
              3233.82,
              -9595.386,
              4972.923
            ],
            [
              3263.762,
              -9611.54,
              5006.944
            ],
            [
              3404.776,
              -9675.449,
              5161.766
            ],
            [
              3447.994,
              -9704.103,
              5213.619
            ],
            [
              3478.945,
              -9734.751,
              5257.176
            ],
            [
              3511.635,
              -9775.451,
              5309.379
            ],
            [
              3546.778,
              -9856.276,
              5397.514
            ],
            [
              3563.744,
              -9877.752,
              5424.883
            ],
            [
              3584.076,
              -9891.498,
              5449.425
            ],
            [
              3684.789,
              -9975.801,
              5580.766
            ],
            [
              3753.117,
              -10037.223,
              5672.642
            ],
            [
              3824.059,
              -10096.468,
              5765.069
            ],
            [
              3850.114,
              -10113.666,
              5796.288
            ],
            [
              3866.759,
              -10151.835,
              5837.929
            ],
            [
              3913.653,
              -10156.072,
              5885.015
            ],
            [
              3939.124,
              -10136.521,
              5917.124
            ],
            [
              3958.891,
              -10112.407,
              5948.304
            ],
            [
              3976.835,
              -10082.692,
              5983.017
            ],
            [
              4005.224,
              -10078.783,
              6011.674
            ],
            [
              4078.021,
              -10074.611,
              6084.591
            ],
            [
              4616.81,
              -10066.046,
              6623.448
            ],
            [
              4852.251,
              -10070.594,
              6858.932
            ],
            [
              4899.81,
              -10073.74,
              6906.596
            ],
            [
              4837.14,
              -10286.278,
              7128.181
            ],
            [
              5053.091,
              -10366.163,
              7358.434
            ],
            [
              5073.204,
              -10357.647,
              7380.276
            ],
            [
              5062.718,
              -10367.463,
              7394.64
            ],
            [
              4895.201,
              -10311.894,
              7571.132
            ],
            [
              4833.28,
              -10286.204,
              7638.171
            ],
            [
              4729.917,
              -10573.66,
              7943.646
            ],
            [
              4715.978,
              -10629.055,
              8000.768
            ],
            [
              4699.103,
              -10669.92,
              8044.981
            ],
            [
              4668.42,
              -10726.105,
              8108.998
            ],
            [
              4649.938,
              -10750.241,
              8139.397
            ],
            [
              4628.284,
              -10772.089,
              8170.158
            ],
            [
              4582.682,
              -10801.268,
              8224.296
            ],
            [
              4522.866,
              -10833.513,
              8292.25
            ],
            [
              4504.193,
              -10834.266,
              8310.938
            ],
            [
              4279.816,
              -10925.69,
              8553.226
            ],
            [
              4292.187,
              -10951.534,
              8581.877
            ],
            [
              4289.98,
              -10965.964,
              8596.475
            ],
            [
              4278.918,
              -10972.431,
              8609.289
            ],
            [
              4432.869,
              -11263.733,
              8938.77
            ],
            [
              4431.004,
              -11260.357,
              8942.627
            ],
            [
              4495.442,
              -11388.513,
              9086.071
            ],
            [
              4506.568,
              -11412.106,
              9112.156
            ],
            [
              4522.451,
              -11455.83,
              9158.675
            ],
            [
              4524.573,
              -11479.25,
              9182.191
            ],
            [
              4514.39,
              -11540.284,
              9244.069
            ],
            [
              4493.832,
              -11638.971,
              9344.874
            ],
            [
              4485.665,
              -11662.192,
              9369.49
            ],
            [
              4441.273,
              -11862.841,
              9574.991
            ],
            [
              4404.772,
              -12054.736,
              9770.327
            ],
            [
              4294.404,
              -12542.458,
              10270.38
            ],
            [
              4282.19,
              -12609.02,
              10338.053
            ],
            [
              4283.669,
              -12632.427,
              10361.507
            ],
            [
              4287.977,
              -12642.53,
              10372.49
            ],
            [
              4318.023,
              -12685.412,
              10424.851
            ],
            [
              4318.473,
              -12695.441,
              10434.89
            ],
            [
              4315.194,
              -12698.717,
              10439.525
            ],
            [
              4302.958,
              -12699.595,
              10451.793
            ],
            [
              4264.491,
              -12693.289,
              10490.774
            ],
            [
              4245.846,
              -12692.931,
              10509.422
            ],
            [
              4229.195,
              -12689.271,
              10526.47
            ],
            [
              4219.68,
              -12682.408,
              10538.202
            ],
            [
              4207.078,
              -12668.807,
              10556.744
            ],
            [
              4191.54,
              -12640.676,
              10588.881
            ],
            [
              4184.489,
              -12639.427,
              10596.041
            ],
            [
              4172.789,
              -12645.882,
              10609.404
            ],
            [
              4135.243,
              -12658.521,
              10649.02
            ],
            [
              4112.805,
              -12654.75,
              10671.772
            ],
            [
              3803.923,
              -12596.508,
              10986.098
            ],
            [
              3507.545,
              -12522.939,
              11291.47
            ],
            [
              3445.499,
              -12505.058,
              11356.041
            ],
            [
              3348.197,
              -12480.94,
              11456.288
            ],
            [
              3325.694,
              -12480.512,
              11478.794
            ],
            [
              3102.513,
              -12785.764,
              11856.932
            ],
            [
              3085.871,
              -12815.507,
              11891.015
            ],
            [
              3081.528,
              -12841.03,
              11916.904
            ],
            [
              3045.505,
              -12909.37,
              11994.158
            ],
            [
              3012.654,
              -12979.997,
              12072.051
            ],
            [
              2975.61,
              -13068.357,
              12167.862
            ],
            [
              2927.302,
              -13174.316,
              12284.314
            ],
            [
              2895.887,
              -13169.269,
              12316.132
            ],
            [
              2885.064,
              -13163.497,
              12328.397
            ],
            [
              2731.33,
              -13131.645,
              12485.396
            ],
            [
              2573.884,
              -13091.936,
              12647.773
            ],
            [
              2529.653,
              -13084.423,
              12692.637
            ],
            [
              2498.839,
              -13081.615,
              12723.58
            ],
            [
              2418.043,
              -13103.473,
              12807.28
            ],
            [
              2390.75,
              -13118.545,
              12838.457
            ],
            [
              2353.983,
              -13124.533,
              12875.709
            ],
            [
              2309.292,
              -13141.505,
              12923.514
            ],
            [
              2241.642,
              -13182.538,
              13002.636
            ],
            [
              2197.303,
              -13215.104,
              13057.649
            ],
            [
              2159.559,
              -13238.887,
              13102.261
            ],
            [
              2125.632,
              -13264.969,
              13145.056
            ],
            [
              2055.703,
              -13324.888,
              13237.144
            ],
            [
              2013.003,
              -13373.072,
              13301.526
            ],
            [
              2000.063,
              -13377.283,
              13315.133
            ],
            [
              1996.248,
              -13374.985,
              13319.587
            ],
            [
              1995.046,
              -13370.509,
              13324.221
            ],
            [
              1997.183,
              -13359.416,
              13335.518
            ],
            [
              2011.533,
              -13348.552,
              13353.517
            ],
            [
              2021.196,
              -13347.62,
              13363.224
            ],
            [
              2018.624,
              -13347.572,
              13365.796
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1144",
              "position": {
                "x": 5527.927,
                "z": -9014.957
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -360,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6821",
              "position": {
                "x": 5122.326,
                "z": -8853.439
              },
              "distanceAlongShapeM": 444.149,
              "shapeOffsetM": 0.214,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6819",
              "position": {
                "x": 4583.775,
                "z": -8441.133
              },
              "distanceAlongShapeM": 1141.6,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6817",
              "position": {
                "x": 4220.749,
                "z": -8438.604
              },
              "distanceAlongShapeM": 1556.894,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6814",
              "position": {
                "x": 3573.643,
                "z": -8378.361
              },
              "distanceAlongShapeM": 2540.684,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:738",
              "position": {
                "x": 3339.773,
                "z": -8015.44
              },
              "distanceAlongShapeM": 3013.62,
              "shapeOffsetM": 0.144,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:1064",
              "position": {
                "x": 3556.685,
                "z": -8322.375
              },
              "distanceAlongShapeM": 3389.618,
              "shapeOffsetM": 0.61,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6811",
              "position": {
                "x": 3548.675,
                "z": -8844.347
              },
              "distanceAlongShapeM": 4013.164,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6809",
              "position": {
                "x": 3346.691,
                "z": -9142.201
              },
              "distanceAlongShapeM": 4386.287,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6856",
              "position": {
                "x": 3684.789,
                "z": -9975.801
              },
              "distanceAlongShapeM": 5580.766,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:10554",
              "position": {
                "x": 3850.114,
                "z": -10113.666
              },
              "distanceAlongShapeM": 5796.288,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9046",
              "position": {
                "x": 4200.33,
                "z": -10072.504
              },
              "distanceAlongShapeM": 6206.917,
              "shapeOffsetM": 0.162,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:9048",
              "position": {
                "x": 4616.81,
                "z": -10066.046
              },
              "distanceAlongShapeM": 6623.448,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:15114",
              "position": {
                "x": 4852.251,
                "z": -10070.594
              },
              "distanceAlongShapeM": 6858.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 7380.276,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:16870",
              "position": {
                "x": 4715.978,
                "z": -10629.055
              },
              "distanceAlongShapeM": 8000.768,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9053",
              "position": {
                "x": 4522.866,
                "z": -10833.513
              },
              "distanceAlongShapeM": 8292.25,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:8315",
              "position": {
                "x": 4289.98,
                "z": -10965.964
              },
              "distanceAlongShapeM": 8596.475,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:8004",
              "position": {
                "x": 4493.832,
                "z": -11638.971
              },
              "distanceAlongShapeM": 9344.874,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8005",
              "position": {
                "x": 4404.772,
                "z": -12054.736
              },
              "distanceAlongShapeM": 9770.327,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:8006",
              "position": {
                "x": 4295.286,
                "z": -12697.221
              },
              "distanceAlongShapeM": 10459.748,
              "shapeOffsetM": 1.102,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:10552",
              "position": {
                "x": 3803.923,
                "z": -12596.508
              },
              "distanceAlongShapeM": 10986.098,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:8008",
              "position": {
                "x": 3507.545,
                "z": -12522.939
              },
              "distanceAlongShapeM": 11291.47,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:8009",
              "position": {
                "x": 3081.528,
                "z": -12841.03
              },
              "distanceAlongShapeM": 11916.904,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:8363",
              "position": {
                "x": 2895.887,
                "z": -13169.269
              },
              "distanceAlongShapeM": 12316.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:8012",
              "position": {
                "x": 2390.75,
                "z": -13118.545
              },
              "distanceAlongShapeM": 12838.457,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:8011",
              "position": {
                "x": 2018.624,
                "z": -13347.572
              },
              "distanceAlongShapeM": 13365.796,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            21180,
            26640,
            33180,
            38580,
            43920,
            50040,
            56340,
            61320,
            66300
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_65:1",
          "sourceRouteId": "vilnius_bus_65",
          "sourceShapeId": "vilnius_bus_65_b-a",
          "directionId": 1,
          "headsign": "Ožkiniai",
          "directionName": "Pagubė–Balsių g.–Naujieji Verkiai–Ožkiniai",
          "mode": "bus",
          "routeShortName": "65",
          "routeLongName": "Ožkiniai–Naujieji Verkiai–Balsių g.–Pagubė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2018.624,
              -13347.572,
              0
            ],
            [
              2051.182,
              -13325.917,
              39.102
            ],
            [
              2126.959,
              -13262.768,
              137.742
            ],
            [
              2212.276,
              -13205.365,
              240.572
            ],
            [
              2263.128,
              -13168.469,
              303.399
            ],
            [
              2313.896,
              -13136.025,
              363.649
            ],
            [
              2386.334,
              -13114.009,
              439.359
            ],
            [
              2418.727,
              -13101.259,
              474.171
            ],
            [
              2473.705,
              -13084.482,
              531.651
            ],
            [
              2519.452,
              -13079.777,
              577.639
            ],
            [
              2533.573,
              -13081.157,
              591.828
            ],
            [
              2579.048,
              -13090.92,
              638.339
            ],
            [
              2628.295,
              -13105.208,
              689.617
            ],
            [
              2927.302,
              -13174.316,
              996.506
            ],
            [
              3092.532,
              -12803.387,
              1402.573
            ],
            [
              3101.185,
              -12787.965,
              1420.256
            ],
            [
              3181.668,
              -12681.505,
              1553.715
            ],
            [
              3223.998,
              -12619.965,
              1628.407
            ],
            [
              3249.211,
              -12579.253,
              1676.294
            ],
            [
              3291.479,
              -12521.053,
              1748.224
            ],
            [
              3312.582,
              -12493.622,
              1782.833
            ],
            [
              3325.694,
              -12480.512,
              1801.375
            ],
            [
              3352.033,
              -12482.126,
              1827.764
            ],
            [
              3458.421,
              -12501.964,
              1935.985
            ],
            [
              3765.709,
              -12576.851,
              2252.267
            ],
            [
              4112.805,
              -12654.75,
              2607.997
            ],
            [
              4128.878,
              -12655.058,
              2624.072
            ],
            [
              4152.109,
              -12651.051,
              2647.646
            ],
            [
              4185.196,
              -12636.101,
              2683.954
            ],
            [
              4190.961,
              -12637.325,
              2689.848
            ],
            [
              4219.165,
              -12675.718,
              2737.487
            ],
            [
              4226.773,
              -12681.431,
              2747.001
            ],
            [
              4235.045,
              -12686.043,
              2756.472
            ],
            [
              4250.432,
              -12688.566,
              2772.065
            ],
            [
              4258.811,
              -12687.613,
              2780.498
            ],
            [
              4269.397,
              -12672.231,
              2799.171
            ],
            [
              4333.362,
              -12356.175,
              3121.634
            ],
            [
              4384.004,
              -12131.153,
              3352.285
            ],
            [
              4413.388,
              -11974.746,
              3511.428
            ],
            [
              4489.159,
              -11647.787,
              3847.052
            ],
            [
              4500.864,
              -11574.536,
              3921.233
            ],
            [
              4516.791,
              -11515.839,
              3982.052
            ],
            [
              4522.858,
              -11468.084,
              4030.191
            ],
            [
              4516.342,
              -11439.013,
              4059.983
            ],
            [
              4472.42,
              -11347.991,
              4161.048
            ],
            [
              4287.622,
              -10988.184,
              4565.537
            ],
            [
              4283.377,
              -10974.743,
              4579.632
            ],
            [
              4288.179,
              -10959.25,
              4595.853
            ],
            [
              4287.063,
              -10950.322,
              4604.85
            ],
            [
              4279.795,
              -10926.803,
              4629.466
            ],
            [
              4282.474,
              -10921.288,
              4635.598
            ],
            [
              4545.72,
              -10816.141,
              4919.066
            ],
            [
              4558.82,
              -10804.147,
              4936.827
            ],
            [
              4606.823,
              -10783.921,
              4988.917
            ],
            [
              4646.679,
              -10752.405,
              5039.729
            ],
            [
              4702.534,
              -10658.854,
              5148.685
            ],
            [
              4764.013,
              -10474.123,
              5343.378
            ],
            [
              4835.253,
              -10284.015,
              5546.395
            ],
            [
              4885.039,
              -10305.018,
              5600.429
            ],
            [
              5017.928,
              -10354.349,
              5742.18
            ],
            [
              5040.869,
              -10365.926,
              5767.877
            ],
            [
              5073.204,
              -10357.647,
              5801.254
            ],
            [
              5060.745,
              -10369.652,
              5818.556
            ],
            [
              5026.912,
              -10355.636,
              5855.177
            ],
            [
              4837.097,
              -10288.504,
              6056.514
            ],
            [
              4899.767,
              -10075.966,
              6278.099
            ],
            [
              4160.961,
              -10078.428,
              7016.909
            ],
            [
              4078.021,
              -10074.611,
              7099.937
            ],
            [
              4005.224,
              -10078.783,
              7172.853
            ],
            [
              3981.274,
              -10086.117,
              7197.902
            ],
            [
              3966.973,
              -10093.636,
              7214.059
            ],
            [
              3948.343,
              -10125.564,
              7251.025
            ],
            [
              3935.179,
              -10140.898,
              7271.234
            ],
            [
              3924.074,
              -10149.592,
              7285.338
            ],
            [
              3913.675,
              -10154.959,
              7297.04
            ],
            [
              3866.759,
              -10151.835,
              7344.06
            ],
            [
              3832.039,
              -10116.66,
              7393.485
            ],
            [
              3633.404,
              -9936.97,
              7661.336
            ],
            [
              3613.674,
              -9925.461,
              7684.177
            ],
            [
              3584.076,
              -9891.498,
              7729.228
            ],
            [
              3560.012,
              -9871.001,
              7760.838
            ],
            [
              3541.801,
              -9847.275,
              7790.747
            ],
            [
              3514.661,
              -9785.528,
              7858.195
            ],
            [
              3500.953,
              -9761.888,
              7885.522
            ],
            [
              3482.098,
              -9738.151,
              7915.837
            ],
            [
              3456.873,
              -9710.952,
              7952.932
            ],
            [
              3423.2,
              -9688.046,
              7993.657
            ],
            [
              3388.156,
              -9669.567,
              8033.276
            ],
            [
              3277.145,
              -9618.474,
              8155.48
            ],
            [
              3240.19,
              -9598.846,
              8197.323
            ],
            [
              3228.737,
              -9591.949,
              8210.693
            ],
            [
              3213.634,
              -9573.85,
              8234.266
            ],
            [
              3206.315,
              -9552.559,
              8256.779
            ],
            [
              3171.376,
              -9392.699,
              8420.414
            ],
            [
              3134.577,
              -9330.771,
              8492.45
            ],
            [
              3236.064,
              -9273.693,
              8608.887
            ],
            [
              3253.13,
              -9256.204,
              8633.322
            ],
            [
              3308.92,
              -9131.464,
              8769.97
            ],
            [
              3319.964,
              -9126.108,
              8782.245
            ],
            [
              3332.231,
              -9124.114,
              8794.673
            ],
            [
              3357.176,
              -9132.381,
              8820.952
            ],
            [
              3379.116,
              -9129.458,
              8843.085
            ],
            [
              3431.482,
              -9015.787,
              8968.239
            ],
            [
              3480.938,
              -8919.873,
              9076.152
            ],
            [
              3562.117,
              -8814.544,
              9209.134
            ],
            [
              3591.518,
              -8791.726,
              9246.351
            ],
            [
              3664.561,
              -8741.908,
              9334.766
            ],
            [
              3699.345,
              -8706.946,
              9384.083
            ],
            [
              3684.368,
              -8682.169,
              9413.035
            ],
            [
              3678.273,
              -8664.24,
              9431.971
            ],
            [
              3654.394,
              -8633.726,
              9470.718
            ],
            [
              3621.201,
              -8585.223,
              9529.492
            ],
            [
              3606.987,
              -8520.382,
              9595.872
            ],
            [
              3594.209,
              -8447.776,
              9669.594
            ],
            [
              3584.654,
              -8408.629,
              9709.89
            ],
            [
              3573.643,
              -8378.361,
              9742.098
            ],
            [
              3571.967,
              -8364.97,
              9755.594
            ],
            [
              3567.073,
              -8351.518,
              9769.909
            ],
            [
              3552.201,
              -8321.176,
              9803.7
            ],
            [
              3359.047,
              -8051.431,
              10135.469
            ],
            [
              3339.583,
              -8025.456,
              10167.928
            ],
            [
              3325.551,
              -8018.51,
              10183.584
            ],
            [
              3323.747,
              -8011.796,
              10190.536
            ],
            [
              3327.071,
              -8006.293,
              10196.965
            ],
            [
              3330.31,
              -8005.241,
              10200.371
            ],
            [
              3336.682,
              -8008.702,
              10207.622
            ],
            [
              3345.354,
              -8026.679,
              10227.582
            ],
            [
              3573.636,
              -8344.963,
              10619.267
            ],
            [
              3579.711,
              -8364.004,
              10639.254
            ],
            [
              3610.551,
              -8536.036,
              10814.028
            ],
            [
              3620.105,
              -8575.182,
              10854.324
            ],
            [
              3634.976,
              -8605.524,
              10888.114
            ],
            [
              3682.65,
              -8671.003,
              10969.109
            ],
            [
              3689.389,
              -8688.944,
              10988.274
            ],
            [
              3699.345,
              -8706.946,
              11008.846
            ],
            [
              3741.483,
              -8657.653,
              11073.695
            ],
            [
              3791.647,
              -8626.326,
              11132.838
            ],
            [
              3858.564,
              -8594.206,
              11207.064
            ],
            [
              3887.776,
              -8581.405,
              11238.958
            ],
            [
              3917.526,
              -8574.181,
              11269.573
            ],
            [
              3985.821,
              -8571.035,
              11337.94
            ],
            [
              4016.172,
              -8566.049,
              11368.698
            ],
            [
              4061.23,
              -8499.002,
              11449.478
            ],
            [
              4079.696,
              -8475.977,
              11478.993
            ],
            [
              4100.028,
              -8456.328,
              11507.269
            ],
            [
              4149.92,
              -8439.472,
              11559.931
            ],
            [
              4184.09,
              -8436.788,
              11594.207
            ],
            [
              4222.829,
              -8430.851,
              11633.398
            ],
            [
              4242.992,
              -8420.106,
              11656.245
            ],
            [
              4256.484,
              -8421.478,
              11669.807
            ],
            [
              4281.731,
              -8414.17,
              11696.09
            ],
            [
              4307.127,
              -8399.072,
              11725.636
            ],
            [
              4316.521,
              -8379.213,
              11747.604
            ],
            [
              4323.75,
              -8371.559,
              11758.132
            ],
            [
              4352.772,
              -8368.777,
              11787.287
            ],
            [
              4394.858,
              -8356.227,
              11831.205
            ],
            [
              4421.907,
              -8355.634,
              11858.261
            ],
            [
              4447.456,
              -8366.145,
              11885.887
            ],
            [
              4495.27,
              -8390.444,
              11939.521
            ],
            [
              4552.908,
              -8406.026,
              11999.228
            ],
            [
              4580.193,
              -8426.591,
              12033.395
            ],
            [
              4609.923,
              -8453.883,
              12073.753
            ],
            [
              4628.178,
              -8475.387,
              12101.96
            ],
            [
              4655.998,
              -8501.529,
              12140.136
            ],
            [
              4667.259,
              -8518.445,
              12160.458
            ],
            [
              4715.091,
              -8575.032,
              12234.552
            ],
            [
              4821.282,
              -8709.564,
              12405.944
            ],
            [
              4857.98,
              -8742.558,
              12455.293
            ],
            [
              4880.2,
              -8758.574,
              12482.684
            ],
            [
              4910.764,
              -8775.864,
              12517.799
            ],
            [
              5190.316,
              -8865.891,
              12811.49
            ],
            [
              5211.507,
              -8868.529,
              12832.844
            ],
            [
              5231.173,
              -8883.383,
              12857.49
            ],
            [
              5278.399,
              -8904.339,
              12909.157
            ],
            [
              5409.439,
              -8951.419,
              13048.398
            ],
            [
              5530.182,
              -8998.301,
              13177.923
            ],
            [
              5548.003,
              -9008.668,
              13198.54
            ],
            [
              5547.165,
              -9018.671,
              13208.579
            ],
            [
              5543.904,
              -9020.834,
              13212.491
            ],
            [
              5531.636,
              -9022.822,
              13224.92
            ],
            [
              5529.105,
              -9020.546,
              13228.323
            ],
            [
              5527.927,
              -9014.957,
              13234.035
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8011",
              "position": {
                "x": 2018.624,
                "z": -13347.572
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8016",
              "position": {
                "x": 2445.252,
                "z": -13092.852
              },
              "distanceAlongShapeM": 501.994,
              "shapeOffsetM": 0.299,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8367",
              "position": {
                "x": 2941.349,
                "z": -13145.637
              },
              "distanceAlongShapeM": 1028.42,
              "shapeOffsetM": 1.162,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8017",
              "position": {
                "x": 3092.532,
                "z": -12803.387
              },
              "distanceAlongShapeM": 1402.573,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8018",
              "position": {
                "x": 3458.421,
                "z": -12501.964
              },
              "distanceAlongShapeM": 1935.985,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:10551",
              "position": {
                "x": 3765.709,
                "z": -12576.851
              },
              "distanceAlongShapeM": 2252.267,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:18426",
              "position": {
                "x": 4270.854,
                "z": -12663.353
              },
              "distanceAlongShapeM": 2808.162,
              "shapeOffsetM": 0.333,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8021",
              "position": {
                "x": 4413.388,
                "z": -11974.746
              },
              "distanceAlongShapeM": 3511.428,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:8022",
              "position": {
                "x": 4500.864,
                "z": -11574.536
              },
              "distanceAlongShapeM": 3921.233,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:9798",
              "position": {
                "x": 4287.063,
                "z": -10950.322
              },
              "distanceAlongShapeM": 4604.85,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:9054",
              "position": {
                "x": 4558.82,
                "z": -10804.147
              },
              "distanceAlongShapeM": 4936.827,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:16832",
              "position": {
                "x": 4764.013,
                "z": -10474.123
              },
              "distanceAlongShapeM": 5343.378,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 5801.254,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:15113",
              "position": {
                "x": 4825.104,
                "z": -10076.748
              },
              "distanceAlongShapeM": 6352.765,
              "shapeOffsetM": 0.533,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9047",
              "position": {
                "x": 4559.944,
                "z": -10078.309
              },
              "distanceAlongShapeM": 6617.928,
              "shapeOffsetM": 1.21,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9045",
              "position": {
                "x": 4160.961,
                "z": -10078.428
              },
              "distanceAlongShapeM": 7016.909,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:10556",
              "position": {
                "x": 3832.039,
                "z": -10116.66
              },
              "distanceAlongShapeM": 7393.485,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6857",
              "position": {
                "x": 3613.674,
                "z": -9925.461
              },
              "distanceAlongShapeM": 7684.177,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6808",
              "position": {
                "x": 3308.92,
                "z": -9131.464
              },
              "distanceAlongShapeM": 8769.97,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6810",
              "position": {
                "x": 3562.117,
                "z": -8814.544
              },
              "distanceAlongShapeM": 9209.134,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6814",
              "position": {
                "x": 3573.643,
                "z": -8378.361
              },
              "distanceAlongShapeM": 9742.098,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:738",
              "position": {
                "x": 3339.773,
                "z": -8015.44
              },
              "distanceAlongShapeM": 10215.034,
              "shapeOffsetM": 0.144,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:1064",
              "position": {
                "x": 3556.685,
                "z": -8322.375
              },
              "distanceAlongShapeM": 10591.032,
              "shapeOffsetM": 0.61,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6816",
              "position": {
                "x": 4242.992,
                "z": -8420.106
              },
              "distanceAlongShapeM": 11656.245,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6818",
              "position": {
                "x": 4655.998,
                "z": -8501.529
              },
              "distanceAlongShapeM": 12140.136,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6820",
              "position": {
                "x": 5211.507,
                "z": -8868.529
              },
              "distanceAlongShapeM": 12832.844,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:1144",
              "position": {
                "x": 5527.927,
                "z": -9014.957
              },
              "distanceAlongShapeM": 13234.035,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            }
          ],
          "departuresSeconds": [
            23700,
            29220,
            36240,
            40980,
            46920,
            54000,
            58860,
            63840,
            68880
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_68",
      "sourceRouteId": "vilnius_bus_68",
      "mode": "bus",
      "shortName": "68",
      "longName": "Lazdynai–Mūrinė Vokė–Lentvaris–Grigiškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_68:0",
          "sourceRouteId": "vilnius_bus_68",
          "sourceShapeId": "vilnius_bus_68_a-b",
          "directionId": 0,
          "headsign": "Grigiškės",
          "directionName": "Lazdynai–Mūrinė Vokė–Lentvaris–Grigiškės",
          "mode": "bus",
          "routeShortName": "68",
          "routeLongName": "Lazdynai–Mūrinė Vokė–Lentvaris–Grigiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4215.081,
              1256.734,
              0
            ],
            [
              -4241.916,
              1271.669,
              30.711
            ],
            [
              -4268.203,
              1281.028,
              58.614
            ],
            [
              -4527.979,
              1404.616,
              346.29
            ],
            [
              -4558.781,
              1414.051,
              378.505
            ],
            [
              -4581.673,
              1433.369,
              408.459
            ],
            [
              -4718.251,
              1519.203,
              569.77
            ],
            [
              -4838.028,
              1606.973,
              718.262
            ],
            [
              -4906.917,
              1690.529,
              826.555
            ],
            [
              -4962.228,
              1738.229,
              899.593
            ],
            [
              -5070.177,
              1876.997,
              1075.404
            ],
            [
              -5047.925,
              1895.541,
              1104.37
            ],
            [
              -4996.021,
              1950.314,
              1179.83
            ],
            [
              -4992.511,
              1966.952,
              1196.834
            ],
            [
              -4995.545,
              1978.136,
              1208.422
            ],
            [
              -5002.507,
              1986.047,
              1218.96
            ],
            [
              -5010.228,
              1987.292,
              1226.781
            ],
            [
              -5028.345,
              1984.262,
              1245.149
            ],
            [
              -5177.583,
              1934.489,
              1402.469
            ],
            [
              -5251.262,
              1926.839,
              1476.544
            ],
            [
              -5286.129,
              1925.207,
              1511.449
            ],
            [
              -5329.267,
              1930.394,
              1554.897
            ],
            [
              -5390.957,
              1944.801,
              1618.248
            ],
            [
              -5430.093,
              1957.712,
              1659.458
            ],
            [
              -5538.852,
              2011.879,
              1780.96
            ],
            [
              -5604.833,
              2039.715,
              1852.572
            ],
            [
              -5664.553,
              2056.312,
              1914.556
            ],
            [
              -6261.201,
              2179.926,
              2523.874
            ],
            [
              -6367.656,
              2218.449,
              2637.085
            ],
            [
              -6455.072,
              2276.688,
              2742.125
            ],
            [
              -6521.774,
              2339.031,
              2833.426
            ],
            [
              -6565.387,
              2393.195,
              2902.966
            ],
            [
              -6596.857,
              2440.475,
              2959.762
            ],
            [
              -6687.246,
              2630.115,
              3169.841
            ],
            [
              -6721.281,
              2678.551,
              3229.039
            ],
            [
              -6732.812,
              2722.158,
              3274.145
            ],
            [
              -6787.208,
              2826.592,
              3391.896
            ],
            [
              -6821.115,
              2882.817,
              3457.554
            ],
            [
              -6849.514,
              2921.139,
              3505.252
            ],
            [
              -6915.475,
              2990.142,
              3600.71
            ],
            [
              -6953.037,
              3020.824,
              3649.211
            ],
            [
              -7039.186,
              3079.03,
              3753.179
            ],
            [
              -7611.222,
              3413.556,
              4415.851
            ],
            [
              -7650.801,
              3439.813,
              4463.347
            ],
            [
              -7850.196,
              3558.868,
              4695.581
            ],
            [
              -7970.179,
              3640.989,
              4840.976
            ],
            [
              -8010.925,
              3675.053,
              4894.085
            ],
            [
              -8074.26,
              3748.448,
              4991.03
            ],
            [
              -8116.47,
              3811.478,
              5066.888
            ],
            [
              -8127.628,
              3839.491,
              5097.04
            ],
            [
              -8136.789,
              3831.848,
              5108.971
            ],
            [
              -8161.184,
              3958.037,
              5237.495
            ],
            [
              -8167.097,
              4030.49,
              5310.189
            ],
            [
              -8128.206,
              4592.005,
              5873.05
            ],
            [
              -8114.065,
              4903.462,
              6184.827
            ],
            [
              -8124.873,
              4913.657,
              6199.685
            ],
            [
              -8158.233,
              4926.449,
              6235.413
            ],
            [
              -8180.177,
              4926.808,
              6257.36
            ],
            [
              -8198.839,
              4930.453,
              6276.375
            ],
            [
              -8215.237,
              4954.098,
              6305.149
            ],
            [
              -8221.863,
              4983.149,
              6334.946
            ],
            [
              -8226.272,
              4989.9,
              6343.009
            ],
            [
              -8636.101,
              4917.551,
              6759.176
            ],
            [
              -8674.97,
              4909.278,
              6798.916
            ],
            [
              -9185.609,
              4829.613,
              7315.731
            ],
            [
              -9269.169,
              4812.038,
              7401.119
            ],
            [
              -9558.495,
              4764.378,
              7694.345
            ],
            [
              -9588.344,
              4754.839,
              7725.681
            ],
            [
              -9674.339,
              4746.201,
              7812.109
            ],
            [
              -9691.208,
              4740.905,
              7829.789
            ],
            [
              -9773.869,
              4738.891,
              7912.475
            ],
            [
              -9802.39,
              4731.556,
              7941.924
            ],
            [
              -9849.213,
              4710.042,
              7993.453
            ],
            [
              -10016.251,
              4679.317,
              8163.293
            ],
            [
              -10029.91,
              4672.856,
              8178.403
            ],
            [
              -10035.843,
              4665.159,
              8188.122
            ],
            [
              -10041.326,
              4645.21,
              8208.811
            ],
            [
              -10038.868,
              4637.378,
              8217.019
            ],
            [
              -10034.44,
              4631.742,
              8224.187
            ],
            [
              -10024.132,
              4630.464,
              8234.574
            ],
            [
              -10003.374,
              4636.812,
              8256.28
            ],
            [
              -9985.268,
              4638.749,
              8274.489
            ],
            [
              -9974.208,
              4644.138,
              8286.792
            ],
            [
              -9966.985,
              4651.815,
              8297.333
            ],
            [
              -9956.86,
              4679.482,
              8326.795
            ],
            [
              -9956.789,
              4683.933,
              8331.247
            ],
            [
              -9961.898,
              4687.354,
              8337.396
            ],
            [
              -10095.11,
              4672.784,
              8471.402
            ],
            [
              -10133.849,
              4672.288,
              8510.145
            ],
            [
              -10283.166,
              4700.269,
              8662.06
            ],
            [
              -10348.224,
              4709.095,
              8727.715
            ],
            [
              -10488.216,
              4714.658,
              8867.817
            ],
            [
              -10818.872,
              4705.42,
              9198.603
            ],
            [
              -10909.241,
              4705.733,
              9288.972
            ],
            [
              -11064.862,
              4702.619,
              9444.624
            ],
            [
              -11095.805,
              4705.332,
              9475.685
            ],
            [
              -11491.699,
              4899.664,
              9916.704
            ],
            [
              -11511.323,
              4924.461,
              9948.326
            ],
            [
              -11575.795,
              4971.107,
              10027.904
            ],
            [
              -11609.044,
              4991.663,
              10066.993
            ],
            [
              -11621.882,
              4996.316,
              10080.649
            ],
            [
              -11659.874,
              5002.475,
              10119.137
            ],
            [
              -11800.902,
              4983.524,
              10261.433
            ],
            [
              -11847.406,
              4982.021,
              10307.961
            ],
            [
              -11885.871,
              4999.317,
              10350.135
            ],
            [
              -11995.222,
              5107.879,
              10504.224
            ],
            [
              -12040.673,
              5174.26,
              10584.674
            ],
            [
              -12077.728,
              5199.324,
              10629.41
            ],
            [
              -12102.186,
              5204.156,
              10654.34
            ],
            [
              -13347.739,
              5147.603,
              11901.177
            ],
            [
              -13626.273,
              5128.461,
              12180.367
            ],
            [
              -13650.748,
              5132.171,
              12205.122
            ],
            [
              -13690.153,
              5130.542,
              12244.561
            ],
            [
              -13794.302,
              5116.536,
              12349.647
            ],
            [
              -13943.169,
              5090.957,
              12500.696
            ],
            [
              -14183.883,
              5053.4,
              12744.323
            ],
            [
              -14298.188,
              5050.665,
              12858.66
            ],
            [
              -14383.928,
              5058.631,
              12944.769
            ],
            [
              -14396.886,
              5055.486,
              12958.104
            ],
            [
              -14410.306,
              5064.593,
              12974.322
            ],
            [
              -14428.956,
              5069.325,
              12993.563
            ],
            [
              -14436.701,
              5069.441,
              13001.309
            ],
            [
              -14454.178,
              5066.363,
              13019.054
            ],
            [
              -14462.006,
              5060.915,
              13028.592
            ],
            [
              -14475.76,
              5047.764,
              13047.621
            ],
            [
              -14481.073,
              5037.825,
              13058.891
            ],
            [
              -14483.955,
              5017.832,
              13079.091
            ],
            [
              -14482.731,
              5013.361,
              13083.726
            ],
            [
              -14470.073,
              4996.474,
              13104.83
            ],
            [
              -14470.189,
              4988.684,
              13112.622
            ],
            [
              -14478.713,
              4979.907,
              13124.856
            ],
            [
              -14492.912,
              4980.119,
              13139.057
            ],
            [
              -14508.88,
              4991.49,
              13158.66
            ],
            [
              -14530.79,
              4994.044,
              13180.719
            ],
            [
              -14639.218,
              4995.666,
              13289.158
            ],
            [
              -14655.303,
              4999.246,
              13305.637
            ],
            [
              -14684.975,
              5000.802,
              13335.35
            ],
            [
              -14705.711,
              4995.546,
              13356.742
            ],
            [
              -14720.043,
              4986.855,
              13373.503
            ],
            [
              -14756.022,
              4955.111,
              13421.483
            ],
            [
              -14780.067,
              4944.339,
              13447.832
            ],
            [
              -14785.859,
              4945.538,
              13453.747
            ],
            [
              -14787.001,
              4955.573,
              13463.847
            ],
            [
              -14781.902,
              4994.457,
              13503.063
            ],
            [
              -14777.88,
              5004.415,
              13513.803
            ],
            [
              -14771.31,
              5012.109,
              13523.92
            ],
            [
              -14708.06,
              5011.165,
              13587.177
            ],
            [
              -14697.039,
              5014.34,
              13598.647
            ],
            [
              -14688.731,
              5008.65,
              13608.716
            ],
            [
              -14670.081,
              5003.919,
              13627.957
            ],
            [
              -14621.13,
              4996.509,
              13677.466
            ],
            [
              -14555.945,
              4995.534,
              13742.659
            ],
            [
              -14511.99,
              4999.328,
              13786.776
            ],
            [
              -14489.863,
              5011.241,
              13811.906
            ],
            [
              -14480.828,
              5011.106,
              13820.943
            ],
            [
              -14469.922,
              5006.49,
              13832.785
            ],
            [
              -14468.698,
              5002.019,
              13837.42
            ],
            [
              -14468.798,
              4995.342,
              13844.098
            ],
            [
              -14472.871,
              4982.045,
              13858.005
            ],
            [
              -14478.134,
              4975.445,
              13866.446
            ],
            [
              -14475.769,
              4960.939,
              13881.144
            ],
            [
              -14497.189,
              4910.056,
              13936.352
            ],
            [
              -14827.838,
              4208.156,
              14712.233
            ],
            [
              -14867.749,
              4128.605,
              14801.235
            ],
            [
              -14869.884,
              4115.279,
              14814.731
            ],
            [
              -14912.921,
              4042.454,
              14899.322
            ],
            [
              -14923.825,
              4003.656,
              14939.623
            ],
            [
              -14920.815,
              3945.728,
              14997.629
            ],
            [
              -14912.825,
              3918.894,
              15025.627
            ],
            [
              -14827.178,
              3776.25,
              15192.009
            ],
            [
              -14759.237,
              3658.357,
              15328.077
            ],
            [
              -14721.023,
              3624.392,
              15379.204
            ],
            [
              -14685.258,
              3599.369,
              15422.854
            ],
            [
              -14655.133,
              3585.561,
              15455.993
            ],
            [
              -14637.745,
              3583.075,
              15473.557
            ],
            [
              -14582.87,
              3584.48,
              15528.45
            ],
            [
              -14538.201,
              3593.83,
              15574.087
            ],
            [
              -14221.29,
              3682.577,
              15903.19
            ],
            [
              -14179.98,
              3683.068,
              15944.503
            ],
            [
              -14149.059,
              3679.263,
              15975.657
            ],
            [
              -14111.176,
              3666.448,
              16015.649
            ],
            [
              -14028.02,
              3617.329,
              16112.228
            ],
            [
              -13979.062,
              3568.725,
              16181.216
            ],
            [
              -13933.196,
              3529.072,
              16241.846
            ],
            [
              -13746.7,
              3358.166,
              16494.807
            ],
            [
              -13685.979,
              3277.099,
              16596.094
            ],
            [
              -13659.152,
              3258.882,
              16628.521
            ],
            [
              -13609.745,
              3240.322,
              16681.299
            ],
            [
              -13575.042,
              3230.89,
              16717.261
            ],
            [
              -13500.118,
              3193.018,
              16801.213
            ],
            [
              -13456.807,
              3155.625,
              16858.433
            ],
            [
              -13432.053,
              3128.533,
              16895.131
            ],
            [
              -13214.852,
              2688.868,
              17385.519
            ],
            [
              -13178.797,
              2641.565,
              17444.997
            ],
            [
              -13063.86,
              2563,
              17584.219
            ],
            [
              -13030.828,
              2529.1,
              17631.551
            ],
            [
              -12936.975,
              2296.127,
              17882.718
            ],
            [
              -12916.15,
              2265.753,
              17919.546
            ],
            [
              -12918.307,
              2251.315,
              17934.144
            ],
            [
              -12897.858,
              2196.457,
              17992.689
            ],
            [
              -12824.021,
              2047.275,
              18159.145
            ],
            [
              -12807.017,
              2020.298,
              18191.033
            ],
            [
              -12700.869,
              1875.069,
              18370.918
            ],
            [
              -12695.099,
              1872.754,
              18377.136
            ],
            [
              -12695.83,
              1867.199,
              18382.738
            ],
            [
              -12673.142,
              1832.343,
              18424.328
            ],
            [
              -12665.015,
              1815.52,
              18443.011
            ],
            [
              -12627.875,
              1839.437,
              18487.185
            ],
            [
              -12614.702,
              1857.045,
              18509.175
            ],
            [
              -12597.151,
              1865.68,
              18528.736
            ],
            [
              -12592.773,
              1856.707,
              18538.719
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -720,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 378.505,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 718.262,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6309",
              "position": {
                "x": -6721.281,
                "z": 2678.551
              },
              "distanceAlongShapeM": 3229.039,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6297",
              "position": {
                "x": -7611.222,
                "z": 3413.556
              },
              "distanceAlongShapeM": 4415.851,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6294",
              "position": {
                "x": -8136.789,
                "z": 3831.848
              },
              "distanceAlongShapeM": 5108.971,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6290",
              "position": {
                "x": -8674.97,
                "z": 4909.278
              },
              "distanceAlongShapeM": 6798.916,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6282",
              "position": {
                "x": -9588.344,
                "z": 4754.839
              },
              "distanceAlongShapeM": 7725.681,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6286",
              "position": {
                "x": -10003.374,
                "z": 4636.812
              },
              "distanceAlongShapeM": 8256.28,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:9683",
              "position": {
                "x": -10818.872,
                "z": 4705.42
              },
              "distanceAlongShapeM": 9198.603,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9482",
              "position": {
                "x": -11491.699,
                "z": 4899.664
              },
              "distanceAlongShapeM": 9916.704,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9627",
              "position": {
                "x": -11995.222,
                "z": 5107.879
              },
              "distanceAlongShapeM": 10504.224,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:16879",
              "position": {
                "x": -12788.934,
                "z": 5172.452
              },
              "distanceAlongShapeM": 11341.819,
              "shapeOffsetM": 0.522,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:9483",
              "position": {
                "x": -13626.273,
                "z": 5128.461
              },
              "distanceAlongShapeM": 12180.367,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:17320",
              "position": {
                "x": -14396.886,
                "z": 5055.486
              },
              "distanceAlongShapeM": 12958.104,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:16903",
              "position": {
                "x": -14697.039,
                "z": 5014.34
              },
              "distanceAlongShapeM": 13598.647,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:9685",
              "position": {
                "x": -14869.884,
                "z": 4115.279
              },
              "distanceAlongShapeM": 14814.731,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:9686",
              "position": {
                "x": -14028.02,
                "z": 3617.329
              },
              "distanceAlongShapeM": 16112.228,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:9485",
              "position": {
                "x": -12916.15,
                "z": 2265.753
              },
              "distanceAlongShapeM": 17919.546,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9484",
              "position": {
                "x": -12695.099,
                "z": 1872.754
              },
              "distanceAlongShapeM": 18377.136,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 18538.719,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            17340,
            19500,
            21840,
            23460,
            25500,
            27720,
            30600,
            32100,
            34260,
            36780,
            38520,
            40620,
            42780,
            44820,
            46860,
            49080,
            51240,
            53040,
            55080,
            56100,
            57840,
            60000,
            62580,
            64200,
            66720,
            68760,
            71100,
            73440,
            75540,
            77760,
            80040,
            82500
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_68:1",
          "sourceRouteId": "vilnius_bus_68",
          "sourceShapeId": "vilnius_bus_68_b-a",
          "directionId": 1,
          "headsign": "Lazdynai",
          "directionName": "Grigiškės–Lentvaris–Mūrinė Vokė–Lazdynai",
          "mode": "bus",
          "routeShortName": "68",
          "routeLongName": "Lazdynai–Mūrinė Vokė–Lentvaris–Grigiškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -12592.773,
              1856.707,
              0
            ],
            [
              -12592.18,
              1853.358,
              3.401
            ],
            [
              -12594.845,
              1847.834,
              9.535
            ],
            [
              -12627.23,
              1839.428,
              42.993
            ],
            [
              -12666.305,
              1815.54,
              88.791
            ],
            [
              -12673.804,
              1831.24,
              106.19
            ],
            [
              -12705.978,
              1878.487,
              163.351
            ],
            [
              -12716.737,
              1892.011,
              180.632
            ],
            [
              -12727.005,
              1895.508,
              191.48
            ],
            [
              -12726.85,
              1905.524,
              201.497
            ],
            [
              -12803.301,
              2010.222,
              331.136
            ],
            [
              -12815.265,
              2029.33,
              353.68
            ],
            [
              -12897.961,
              2189.78,
              534.187
            ],
            [
              -12941.964,
              2307.335,
              659.709
            ],
            [
              -12949.008,
              2310.783,
              667.551
            ],
            [
              -12946.309,
              2318.533,
              675.758
            ],
            [
              -13002.076,
              2468.55,
              835.805
            ],
            [
              -13017.029,
              2503.287,
              873.623
            ],
            [
              -13025.821,
              2519.005,
              891.634
            ],
            [
              -13034.036,
              2530.263,
              905.57
            ],
            [
              -13065.846,
              2559.691,
              948.905
            ],
            [
              -13088.796,
              2577.853,
              978.172
            ],
            [
              -13132.862,
              2607.469,
              1031.266
            ],
            [
              -13178.118,
              2643.781,
              1089.288
            ],
            [
              -13200.932,
              2670.845,
              1124.686
            ],
            [
              -13224.935,
              2704.606,
              1166.11
            ],
            [
              -13276.185,
              2813.364,
              1286.337
            ],
            [
              -13420.117,
              3107.201,
              1613.533
            ],
            [
              -13442.834,
              3140.942,
              1654.208
            ],
            [
              -13465.075,
              3163.543,
              1685.918
            ],
            [
              -13498.199,
              3191.875,
              1729.506
            ],
            [
              -13516.706,
              3205.514,
              1752.495
            ],
            [
              -13555.093,
              3227.248,
              1796.608
            ],
            [
              -13639.254,
              3251.902,
              1884.305
            ],
            [
              -13657.183,
              3261.079,
              1904.447
            ],
            [
              -13673.788,
              3272.462,
              1924.579
            ],
            [
              -13697.95,
              3296.204,
              1958.454
            ],
            [
              -13725.118,
              3334.463,
              2005.378
            ],
            [
              -13753.017,
              3367.167,
              2048.364
            ],
            [
              -13908.319,
              3509.773,
              2259.209
            ],
            [
              -14028.783,
              3609.548,
              2415.627
            ],
            [
              -14037.087,
              3615.239,
              2425.694
            ],
            [
              -14048.039,
              3616.518,
              2436.72
            ],
            [
              -14049.195,
              3625.44,
              2445.717
            ],
            [
              -14077.91,
              3647.023,
              2481.639
            ],
            [
              -14097.744,
              3658.453,
              2504.531
            ],
            [
              -14147.786,
              3678.131,
              2558.302
            ],
            [
              -14178.061,
              3681.926,
              2588.814
            ],
            [
              -14216.162,
              3680.273,
              2626.951
            ],
            [
              -14262.802,
              3668.73,
              2674.998
            ],
            [
              -14568.692,
              3583.155,
              2992.633
            ],
            [
              -14584.21,
              3581.161,
              3008.279
            ],
            [
              -14626.132,
              3582.901,
              3050.237
            ],
            [
              -14669.177,
              3595.789,
              3095.17
            ],
            [
              -14694.819,
              3607.304,
              3123.279
            ],
            [
              -14722.314,
              3624.412,
              3155.661
            ],
            [
              -14732.009,
              3623.443,
              3165.404
            ],
            [
              -14843.689,
              3794.306,
              3369.528
            ],
            [
              -14875.121,
              3850.431,
              3433.856
            ],
            [
              -14907.961,
              3898.785,
              3492.307
            ],
            [
              -14924.075,
              3943.551,
              3539.884
            ],
            [
              -14926.307,
              4010.372,
              3606.743
            ],
            [
              -14922.17,
              4028.121,
              3624.967
            ],
            [
              -14914.807,
              4045.821,
              3644.138
            ],
            [
              -14761.762,
              4354.104,
              3988.32
            ],
            [
              -14477.722,
              4959.855,
              4657.359
            ],
            [
              -14478.913,
              4966.552,
              4664.16
            ],
            [
              -14485.896,
              4974.448,
              4674.702
            ],
            [
              -14505.024,
              4990.319,
              4699.557
            ],
            [
              -14508.88,
              4991.49,
              4703.586
            ],
            [
              -14557.897,
              4994.45,
              4752.693
            ],
            [
              -14617.291,
              4994.225,
              4812.087
            ],
            [
              -14668.195,
              5000.551,
              4863.382
            ],
            [
              -14683.684,
              5000.783,
              4878.874
            ],
            [
              -14703.13,
              4995.508,
              4899.022
            ],
            [
              -14720.026,
              4987.968,
              4917.524
            ],
            [
              -14757.958,
              4955.14,
              4967.689
            ],
            [
              -14769.691,
              4947.523,
              4981.678
            ],
            [
              -14780.067,
              4944.339,
              4992.532
            ],
            [
              -14787.134,
              4946.67,
              4999.972
            ],
            [
              -14781.885,
              4995.57,
              5049.153
            ],
            [
              -14777.88,
              5004.415,
              5058.863
            ],
            [
              -14770.681,
              5010.987,
              5068.61
            ],
            [
              -14760.967,
              5013.068,
              5078.545
            ],
            [
              -14708.06,
              5011.165,
              5131.486
            ],
            [
              -14697.039,
              5014.34,
              5142.955
            ],
            [
              -14684.23,
              5007.47,
              5157.49
            ],
            [
              -14664.306,
              5001.607,
              5178.259
            ],
            [
              -14614.047,
              4995.29,
              5228.913
            ],
            [
              -14508.763,
              4999.28,
              5334.273
            ],
            [
              -14502.905,
              5002.532,
              5340.973
            ],
            [
              -14488.985,
              5026.812,
              5368.961
            ],
            [
              -14486.203,
              5040.128,
              5382.564
            ],
            [
              -14478.308,
              5050.028,
              5395.227
            ],
            [
              -14467.186,
              5059.88,
              5410.085
            ],
            [
              -14450.255,
              5069.644,
              5429.629
            ],
            [
              -14421.823,
              5071.444,
              5458.118
            ],
            [
              -14385.135,
              5064.215,
              5495.512
            ],
            [
              -14325.212,
              5056.637,
              5555.912
            ],
            [
              -14305.749,
              5063.023,
              5576.396
            ],
            [
              -14291.005,
              5056.123,
              5592.675
            ],
            [
              -14263.914,
              5054.603,
              5619.808
            ],
            [
              -14210.312,
              5056.023,
              5673.429
            ],
            [
              -14146.961,
              5061.749,
              5737.039
            ],
            [
              -14062.806,
              5077.178,
              5822.597
            ],
            [
              -13936.002,
              5095.302,
              5950.689
            ],
            [
              -13715.953,
              5132.046,
              6173.785
            ],
            [
              -13686.858,
              5134.945,
              6203.024
            ],
            [
              -13668.056,
              5140.226,
              6222.553
            ],
            [
              -13195.198,
              5159.748,
              6695.814
            ],
            [
              -12654.97,
              5193.77,
              7237.112
            ],
            [
              -12102.797,
              5206.392,
              7789.43
            ],
            [
              -12068.116,
              5194.722,
              7826.021
            ],
            [
              -12048.943,
              5182.18,
              7848.932
            ],
            [
              -12031.758,
              5166.33,
              7872.311
            ],
            [
              -11968.984,
              5093,
              7968.839
            ],
            [
              -11944.96,
              5060.346,
              8009.379
            ],
            [
              -11906.247,
              5017.444,
              8067.165
            ],
            [
              -11887.79,
              5000.46,
              8092.248
            ],
            [
              -11853.808,
              4985.46,
              8129.392
            ],
            [
              -11828.009,
              4983.946,
              8155.236
            ],
            [
              -11802.839,
              4983.554,
              8180.41
            ],
            [
              -11679.271,
              5000.551,
              8305.14
            ],
            [
              -11652.775,
              5002.364,
              8331.699
            ],
            [
              -11614.19,
              4992.857,
              8371.438
            ],
            [
              -11499.863,
              4914.263,
              8510.174
            ],
            [
              -11460.859,
              4890.277,
              8555.963
            ],
            [
              -11439.701,
              4881.04,
              8579.05
            ],
            [
              -11426.2,
              4877.489,
              8593.01
            ],
            [
              -11287.32,
              4800.732,
              8751.69
            ],
            [
              -11111.886,
              4708.924,
              8949.694
            ],
            [
              -11086.839,
              4700.738,
              8976.044
            ],
            [
              -10937.69,
              4702.842,
              9125.209
            ],
            [
              -10706.995,
              4718.123,
              9356.409
            ],
            [
              -10616.051,
              4713.344,
              9447.478
            ],
            [
              -10437.93,
              4710.52,
              9625.622
            ],
            [
              -10390.138,
              4711.988,
              9673.437
            ],
            [
              -10343.689,
              4710.137,
              9719.923
            ],
            [
              -10129.941,
              4674.452,
              9936.628
            ],
            [
              -10101.024,
              4666.199,
              9966.7
            ],
            [
              -9972.224,
              4687.519,
              10097.253
            ],
            [
              -9957.955,
              4691.744,
              10112.134
            ],
            [
              -9954.172,
              4686.118,
              10118.914
            ],
            [
              -9960.839,
              4672.866,
              10133.748
            ],
            [
              -9966.949,
              4654.04,
              10153.541
            ],
            [
              -9974.262,
              4640.799,
              10168.667
            ],
            [
              -9987.867,
              4637.677,
              10182.627
            ],
            [
              -10015.813,
              4625.879,
              10212.961
            ],
            [
              -10037.72,
              4628.455,
              10235.019
            ],
            [
              -10042.829,
              4631.876,
              10241.168
            ],
            [
              -10045.914,
              4640.83,
              10250.639
            ],
            [
              -10043.084,
              4656.369,
              10266.433
            ],
            [
              -10039.034,
              4667.436,
              10278.218
            ],
            [
              -10033.119,
              4674.021,
              10287.069
            ],
            [
              -9847.833,
              4715.586,
              10476.96
            ],
            [
              -9780.287,
              4741.22,
              10549.207
            ],
            [
              -9738.284,
              4743.887,
              10591.294
            ],
            [
              -9619.286,
              4757.562,
              10711.076
            ],
            [
              -9574.594,
              4766.863,
              10756.725
            ],
            [
              -9427.108,
              4785.641,
              10905.402
            ],
            [
              -9186.254,
              4829.624,
              11150.239
            ],
            [
              -8761.616,
              4900.668,
              11580.779
            ],
            [
              -8566.072,
              4936.448,
              11779.569
            ],
            [
              -8440.538,
              4954.439,
              11906.387
            ],
            [
              -8110.415,
              5008.04,
              12240.832
            ],
            [
              -7984.14,
              5031.572,
              12369.282
            ],
            [
              -7996.281,
              5078.524,
              12417.779
            ],
            [
              -8005.189,
              5086.463,
              12429.711
            ],
            [
              -8032.814,
              5094.708,
              12458.54
            ],
            [
              -8056.05,
              5095.089,
              12481.779
            ],
            [
              -8074.858,
              5089.832,
              12501.308
            ],
            [
              -8087.322,
              5077.791,
              12518.638
            ],
            [
              -8094.05,
              5061.204,
              12536.538
            ],
            [
              -8097.824,
              5027.871,
              12570.084
            ],
            [
              -8123.102,
              4509.547,
              13089.024
            ],
            [
              -8153.328,
              4043.622,
              13555.928
            ],
            [
              -8152.03,
              4004.64,
              13594.932
            ],
            [
              -8148.06,
              3971.18,
              13628.626
            ],
            [
              -8134.965,
              3943.136,
              13659.577
            ],
            [
              -8122.972,
              3887.281,
              13716.705
            ],
            [
              -8106.816,
              3849.168,
              13758.101
            ],
            [
              -8055.33,
              3761.496,
              13859.773
            ],
            [
              -8007.887,
              3702.832,
              13935.22
            ],
            [
              -7953.829,
              3654.078,
              14008.016
            ],
            [
              -7691.803,
              3497.261,
              14313.384
            ],
            [
              -7552.547,
              3410.361,
              14477.529
            ],
            [
              -7508.286,
              3394.045,
              14524.701
            ],
            [
              -7243.876,
              3227.143,
              14837.382
            ],
            [
              -6939.838,
              3038.415,
              15195.233
            ],
            [
              -6822.27,
              2929.59,
              15355.436
            ],
            [
              -6676.677,
              2683.371,
              15641.48
            ],
            [
              -6663.874,
              2638.63,
              15688.017
            ],
            [
              -6617.665,
              2546.576,
              15791.018
            ],
            [
              -6572.047,
              2457.871,
              15890.765
            ],
            [
              -6516.148,
              2366.767,
              15997.652
            ],
            [
              -6469.844,
              2319.237,
              16064.008
            ],
            [
              -6422.765,
              2279.486,
              16125.624
            ],
            [
              -6367.208,
              2245.158,
              16190.931
            ],
            [
              -6337.172,
              2227.956,
              16225.544
            ],
            [
              -6224.837,
              2193.786,
              16342.961
            ],
            [
              -5648.753,
              2074.968,
              16931.171
            ],
            [
              -5407.978,
              2044.165,
              17173.908
            ],
            [
              -5248.741,
              2037.003,
              17333.307
            ],
            [
              -5237.188,
              2033.466,
              17345.389
            ],
            [
              -5229.201,
              2009.953,
              17370.221
            ],
            [
              -5217.875,
              1993.062,
              17390.558
            ],
            [
              -5096.905,
              1898.604,
              17544.038
            ],
            [
              -5077.101,
              1887.134,
              17566.924
            ],
            [
              -5061.716,
              1881.305,
              17583.376
            ],
            [
              -5063.879,
              1867.984,
              17596.871
            ],
            [
              -4984.799,
              1776.464,
              17717.824
            ],
            [
              -4951.187,
              1742.493,
              17765.613
            ],
            [
              -4928.804,
              1730.978,
              17790.784
            ],
            [
              -4906.917,
              1690.529,
              17836.776
            ],
            [
              -4952.35,
              1636.759,
              17907.17
            ],
            [
              -4966.71,
              1626.986,
              17924.54
            ],
            [
              -4976.574,
              1616.023,
              17939.288
            ],
            [
              -4993.932,
              1581.81,
              17977.652
            ],
            [
              -4999.643,
              1549.625,
              18010.34
            ],
            [
              -5000.423,
              1503.997,
              18055.974
            ],
            [
              -4985.973,
              1443.638,
              18118.04
            ],
            [
              -4965.718,
              1383.179,
              18181.801
            ],
            [
              -4931.334,
              1319.138,
              18254.488
            ],
            [
              -4880.829,
              1254.822,
              18336.265
            ],
            [
              -4857.956,
              1234.393,
              18366.933
            ],
            [
              -4834.931,
              1222.866,
              18392.682
            ],
            [
              -4813.463,
              1195.782,
              18427.243
            ],
            [
              -4785.375,
              1178.602,
              18460.168
            ],
            [
              -4668.299,
              1122.047,
              18590.188
            ],
            [
              -4620.374,
              1095.621,
              18644.916
            ],
            [
              -4574.442,
              1065.888,
              18699.631
            ],
            [
              -4540.743,
              1037.479,
              18743.708
            ],
            [
              -4440.575,
              860.983,
              18946.647
            ],
            [
              -4425.036,
              789.47,
              19019.829
            ],
            [
              -4406.248,
              756.864,
              19057.461
            ],
            [
              -4380.992,
              725.259,
              19097.917
            ],
            [
              -4355.565,
              703.67,
              19131.274
            ],
            [
              -4324.219,
              688.657,
              19166.029
            ],
            [
              -4302.372,
              683.828,
              19188.403
            ],
            [
              -4269.507,
              682.148,
              19221.311
            ],
            [
              -4233.908,
              689.326,
              19257.626
            ],
            [
              -4200.071,
              706.552,
              19295.596
            ],
            [
              -4154.906,
              744.734,
              19354.738
            ],
            [
              -4134.494,
              768.872,
              19386.349
            ],
            [
              -4089.107,
              782.559,
              19433.755
            ],
            [
              -4026.001,
              813.75,
              19504.149
            ],
            [
              -3968.169,
              838.352,
              19566.996
            ],
            [
              -3939.526,
              853.44,
              19599.37
            ],
            [
              -3921.201,
              868.708,
              19623.222
            ],
            [
              -3904.031,
              891.787,
              19651.988
            ],
            [
              -3887.976,
              924.905,
              19688.792
            ],
            [
              -3883.393,
              966.014,
              19730.156
            ],
            [
              -3887.876,
              1005.054,
              19769.452
            ],
            [
              -3903.754,
              1056.537,
              19823.328
            ],
            [
              -3916.285,
              1077.905,
              19848.099
            ],
            [
              -3919.363,
              1123.6,
              19893.898
            ],
            [
              -3949.447,
              1248.8,
              20022.661
            ],
            [
              -3955.799,
              1254.476,
              20031.18
            ],
            [
              -3966.06,
              1257.993,
              20042.027
            ],
            [
              -4052.898,
              1235.006,
              20131.856
            ],
            [
              -4088.424,
              1232.281,
              20167.486
            ],
            [
              -4119.34,
              1235.042,
              20198.525
            ],
            [
              -4215.081,
              1256.734,
              20296.693
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9614",
              "position": {
                "x": -12592.773,
                "z": 1856.707
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9615",
              "position": {
                "x": -12727.005,
                "z": 1895.508
              },
              "distanceAlongShapeM": 191.48,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:9616",
              "position": {
                "x": -12949.008,
                "z": 2310.783
              },
              "distanceAlongShapeM": 667.551,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9688",
              "position": {
                "x": -14048.039,
                "z": 3616.518
              },
              "distanceAlongShapeM": 2436.72,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9689",
              "position": {
                "x": -14732.009,
                "z": 3623.443
              },
              "distanceAlongShapeM": 3165.404,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:9690",
              "position": {
                "x": -14924.075,
                "z": 3943.551
              },
              "distanceAlongShapeM": 3539.884,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:16903",
              "position": {
                "x": -14697.039,
                "z": 5014.34
              },
              "distanceAlongShapeM": 5142.955,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:9618",
              "position": {
                "x": -14305.749,
                "z": 5063.023
              },
              "distanceAlongShapeM": 5576.396,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9692",
              "position": {
                "x": -13668.056,
                "z": 5140.226
              },
              "distanceAlongShapeM": 6222.553,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:16880",
              "position": {
                "x": -12654.97,
                "z": 5193.77
              },
              "distanceAlongShapeM": 7237.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:9628",
              "position": {
                "x": -11968.984,
                "z": 5093
              },
              "distanceAlongShapeM": 7968.839,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9481",
              "position": {
                "x": -11426.2,
                "z": 4877.489
              },
              "distanceAlongShapeM": 8593.01,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9479",
              "position": {
                "x": -10706.995,
                "z": 4718.123
              },
              "distanceAlongShapeM": 9356.409,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9626",
              "position": {
                "x": -10015.813,
                "z": 4625.879
              },
              "distanceAlongShapeM": 10212.961,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6283",
              "position": {
                "x": -9574.594,
                "z": 4766.863
              },
              "distanceAlongShapeM": 10756.725,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6291",
              "position": {
                "x": -8566.072,
                "z": 4936.448
              },
              "distanceAlongShapeM": 11779.569,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6295",
              "position": {
                "x": -8134.965,
                "z": 3943.136
              },
              "distanceAlongShapeM": 13659.577,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6609",
              "position": {
                "x": -7508.286,
                "z": 3394.045
              },
              "distanceAlongShapeM": 14524.701,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6310",
              "position": {
                "x": -6676.677,
                "z": 2683.371
              },
              "distanceAlongShapeM": 15641.48,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7350",
              "position": {
                "x": -4952.35,
                "z": 1636.759
              },
              "distanceAlongShapeM": 17907.17,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:329",
              "position": {
                "x": -4834.931,
                "z": 1222.866
              },
              "distanceAlongShapeM": 18392.682,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:4395",
              "position": {
                "x": -4540.743,
                "z": 1037.479
              },
              "distanceAlongShapeM": 18743.708,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 19386.349,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 19848.099,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 20296.693,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            }
          ],
          "departuresSeconds": [
            18660,
            20100,
            22140,
            23640,
            25200,
            26640,
            28740,
            31020,
            33480,
            35220,
            37320,
            39600,
            41700,
            43680,
            45720,
            47820,
            49860,
            51900,
            54060,
            56100,
            58080,
            59160,
            60960,
            63120,
            65580,
            67680,
            69960,
            72180,
            74220,
            76560,
            78780,
            80820,
            82920
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_69",
      "sourceRouteId": "vilnius_bus_69",
      "mode": "bus",
      "shortName": "69",
      "longName": "Šiaurės miestelis–Kernavės g.–Lazdynai–Lazdynėliai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_69:0",
          "sourceRouteId": "vilnius_bus_69",
          "sourceShapeId": "vilnius_bus_69_a-b",
          "directionId": 0,
          "headsign": "Lazdynėliai",
          "directionName": "Šiaurės miestelis–Kernavės g.–Lazdynai–Lazdynėliai",
          "mode": "bus",
          "routeShortName": "69",
          "routeLongName": "Šiaurės miestelis–Kernavės g.–Lazdynai–Lazdynėliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1412.698,
              -2538.791,
              0
            ],
            [
              1427.807,
              -2523.486,
              21.507
            ],
            [
              1492.99,
              -2519.128,
              86.835
            ],
            [
              1524.687,
              -2513.037,
              119.112
            ],
            [
              1540.007,
              -2521.114,
              136.431
            ],
            [
              1543.77,
              -2526.75,
              143.207
            ],
            [
              1541.692,
              -2534.504,
              151.235
            ],
            [
              1533.274,
              -2536.574,
              159.904
            ],
            [
              1448.137,
              -2539.448,
              245.089
            ],
            [
              1439.137,
              -2538.168,
              254.18
            ],
            [
              1428.101,
              -2542.416,
              266.006
            ],
            [
              1420.142,
              -2554.515,
              280.487
            ],
            [
              1415.904,
              -2574.474,
              300.892
            ],
            [
              1275.293,
              -2579.663,
              441.599
            ],
            [
              1255.195,
              -2585.971,
              462.663
            ],
            [
              1231.149,
              -2596.659,
              488.978
            ],
            [
              1196.251,
              -2601.58,
              524.221
            ],
            [
              955.306,
              -2665.04,
              773.383
            ],
            [
              918.333,
              -2677.718,
              812.469
            ],
            [
              895.761,
              -2678.415,
              835.052
            ],
            [
              887.466,
              -2673.809,
              844.539
            ],
            [
              874.193,
              -2624.582,
              895.525
            ],
            [
              876.281,
              -2581.204,
              938.953
            ],
            [
              793.859,
              -2331.434,
              1201.971
            ],
            [
              790.106,
              -2290.175,
              1243.4
            ],
            [
              783.069,
              -2252.196,
              1282.026
            ],
            [
              779.214,
              -2216.501,
              1317.928
            ],
            [
              778.263,
              -2163.048,
              1371.39
            ],
            [
              706.997,
              -1866.729,
              1676.158
            ],
            [
              692.307,
              -1824.156,
              1721.194
            ],
            [
              638.805,
              -1718.529,
              1839.598
            ],
            [
              623.163,
              -1692.637,
              1869.848
            ],
            [
              616.718,
              -1692.519,
              1876.294
            ],
            [
              592.004,
              -1704.311,
              1903.677
            ],
            [
              578.225,
              -1717.417,
              1922.694
            ],
            [
              475.715,
              -1717.765,
              2025.205
            ],
            [
              322.189,
              -1722.747,
              2178.811
            ],
            [
              290.448,
              -1731.073,
              2211.626
            ],
            [
              177.023,
              -1729.001,
              2325.071
            ],
            [
              91.167,
              -1735.227,
              2411.152
            ],
            [
              -162.795,
              -1768.453,
              2667.277
            ],
            [
              -168.225,
              -1677.069,
              2758.822
            ],
            [
              -167.82,
              -1654.812,
              2781.083
            ],
            [
              -178.311,
              -1629.017,
              2808.93
            ],
            [
              -188.193,
              -1534.212,
              2904.248
            ],
            [
              -198.199,
              -1481.708,
              2957.697
            ],
            [
              -209.054,
              -1475.945,
              2969.988
            ],
            [
              -210.765,
              -1463.668,
              2982.383
            ],
            [
              -208.106,
              -1459.264,
              2987.528
            ],
            [
              -226.936,
              -1431.091,
              3021.414
            ],
            [
              -253.009,
              -1269.199,
              3185.392
            ],
            [
              -258.082,
              -1229.03,
              3225.88
            ],
            [
              -259.872,
              -1185.581,
              3269.365
            ],
            [
              -293.042,
              -1094.808,
              3366.01
            ],
            [
              -326.277,
              -1114.243,
              3404.511
            ],
            [
              -359.955,
              -1122.538,
              3439.195
            ],
            [
              -398.89,
              -1136.304,
              3480.492
            ],
            [
              -455.246,
              -1008.375,
              3620.285
            ],
            [
              -507.939,
              -1034.138,
              3678.939
            ],
            [
              -534.689,
              -1051.466,
              3710.81
            ],
            [
              -673.187,
              -1080.133,
              3852.244
            ],
            [
              -763.423,
              -1114.127,
              3948.671
            ],
            [
              -829.227,
              -1116.28,
              4014.51
            ],
            [
              -865.018,
              -1134.559,
              4054.699
            ],
            [
              -891.825,
              -1155.228,
              4088.549
            ],
            [
              -898.431,
              -1164.015,
              4099.542
            ],
            [
              -907.595,
              -1171.642,
              4111.465
            ],
            [
              -917.363,
              -1177.032,
              4122.622
            ],
            [
              -929.65,
              -1179.038,
              4135.07
            ],
            [
              -961.877,
              -1178.457,
              4167.303
            ],
            [
              -977.306,
              -1175.953,
              4182.933
            ],
            [
              -995.797,
              -1164.488,
              4204.691
            ],
            [
              -1006.474,
              -1148.711,
              4223.741
            ],
            [
              -1029.882,
              -1123.799,
              4257.925
            ],
            [
              -1062.634,
              -1116.531,
              4291.474
            ],
            [
              -1096.995,
              -1127.045,
              4327.408
            ],
            [
              -1143.947,
              -1120.636,
              4374.795
            ],
            [
              -1339.338,
              -1158.32,
              4573.787
            ],
            [
              -1374.402,
              -1172.164,
              4611.485
            ],
            [
              -1791.301,
              -1230.398,
              5032.431
            ],
            [
              -1855.793,
              -1231.475,
              5096.933
            ],
            [
              -1940.187,
              -1227.747,
              5181.409
            ],
            [
              -2027.705,
              -1218.399,
              5269.425
            ],
            [
              -2166.609,
              -1198.122,
              5409.801
            ],
            [
              -2255.397,
              -1187.643,
              5499.205
            ],
            [
              -2267.097,
              -1193.002,
              5512.074
            ],
            [
              -2295.924,
              -1182.472,
              5542.764
            ],
            [
              -2392.506,
              -1175.197,
              5639.62
            ],
            [
              -2431.277,
              -1180.078,
              5678.696
            ],
            [
              -2478.584,
              -1193.714,
              5727.929
            ],
            [
              -2533.196,
              -1219.467,
              5788.309
            ],
            [
              -2617.204,
              -1266.966,
              5884.816
            ],
            [
              -2663.944,
              -1285.067,
              5934.938
            ],
            [
              -2710.565,
              -1296.491,
              5982.938
            ],
            [
              -2762.303,
              -1305.599,
              6035.472
            ],
            [
              -2808.767,
              -1308.121,
              6082.004
            ],
            [
              -2858.317,
              -1302.797,
              6131.839
            ],
            [
              -3071.028,
              -1263.439,
              6348.161
            ],
            [
              -3140.52,
              -1255.542,
              6418.1
            ],
            [
              -3159.719,
              -1247.413,
              6438.95
            ],
            [
              -3359.526,
              -1207.182,
              6642.766
            ],
            [
              -3495.953,
              -1192.555,
              6779.975
            ],
            [
              -3569.469,
              -1193.5,
              6853.497
            ],
            [
              -3626.266,
              -1196.964,
              6910.399
            ],
            [
              -3657.704,
              -1114.039,
              6999.083
            ],
            [
              -3680.758,
              -1067.996,
              7050.576
            ],
            [
              -3686.114,
              -1042.299,
              7076.825
            ],
            [
              -3720.918,
              -930.373,
              7194.038
            ],
            [
              -3751.541,
              -837.444,
              7291.882
            ],
            [
              -3761.526,
              -818.346,
              7313.433
            ],
            [
              -3766.218,
              -791.548,
              7340.639
            ],
            [
              -3793.988,
              -719.82,
              7417.555
            ],
            [
              -3843.779,
              -616.54,
              7532.21
            ],
            [
              -3881.258,
              -546.871,
              7611.321
            ],
            [
              -3968.98,
              -399.519,
              7782.807
            ],
            [
              -3986.683,
              -379.175,
              7809.775
            ],
            [
              -3999.719,
              -350.005,
              7841.725
            ],
            [
              -4048.201,
              -282.373,
              7924.94
            ],
            [
              -4133.499,
              -180.709,
              8057.647
            ],
            [
              -4196.245,
              -117.285,
              8146.864
            ],
            [
              -4221.08,
              -99.045,
              8177.678
            ],
            [
              -4243.751,
              -67.483,
              8216.538
            ],
            [
              -4402.336,
              85.535,
              8436.91
            ],
            [
              -4449.086,
              142,
              8510.217
            ],
            [
              -4479.797,
              193.736,
              8570.381
            ],
            [
              -4502.905,
              237.549,
              8619.915
            ],
            [
              -4519.036,
              274.562,
              8660.29
            ],
            [
              -4536.228,
              324.952,
              8713.532
            ],
            [
              -4547.048,
              370.78,
              8760.62
            ],
            [
              -4566.578,
              510.266,
              8901.466
            ],
            [
              -4574.501,
              537.119,
              8929.464
            ],
            [
              -4575.517,
              590.57,
              8982.924
            ],
            [
              -4579.623,
              651.866,
              9044.359
            ],
            [
              -4586.366,
              709.869,
              9102.752
            ],
            [
              -4584.541,
              741.007,
              9133.943
            ],
            [
              -4573.306,
              794.248,
              9188.356
            ],
            [
              -4555.909,
              830.684,
              9228.733
            ],
            [
              -4554.237,
              852.919,
              9251.031
            ],
            [
              -4568.699,
              912.168,
              9312.019
            ],
            [
              -4567.748,
              929.963,
              9329.839
            ],
            [
              -4555.854,
              946.456,
              9350.174
            ],
            [
              -4510.16,
              977.953,
              9405.671
            ],
            [
              -4440.575,
              860.983,
              9541.775
            ],
            [
              -4425.036,
              789.47,
              9614.956
            ],
            [
              -4406.248,
              756.864,
              9652.588
            ],
            [
              -4380.992,
              725.259,
              9693.045
            ],
            [
              -4355.565,
              703.67,
              9726.401
            ],
            [
              -4324.219,
              688.657,
              9761.156
            ],
            [
              -4302.372,
              683.828,
              9783.53
            ],
            [
              -4269.507,
              682.148,
              9816.439
            ],
            [
              -4233.908,
              689.326,
              9852.754
            ],
            [
              -4200.071,
              706.552,
              9890.724
            ],
            [
              -4154.906,
              744.734,
              9949.865
            ],
            [
              -4134.494,
              768.872,
              9981.477
            ],
            [
              -4089.107,
              782.559,
              10028.883
            ],
            [
              -4026.001,
              813.75,
              10099.276
            ],
            [
              -3968.169,
              838.352,
              10162.124
            ],
            [
              -3939.526,
              853.44,
              10194.497
            ],
            [
              -3921.201,
              868.708,
              10218.349
            ],
            [
              -3904.031,
              891.787,
              10247.115
            ],
            [
              -3894.03,
              910.538,
              10268.367
            ],
            [
              -3887.976,
              924.905,
              10283.957
            ],
            [
              -3883.393,
              966.014,
              10325.321
            ],
            [
              -3887.876,
              1005.054,
              10364.617
            ],
            [
              -3903.754,
              1056.537,
              10418.493
            ],
            [
              -3916.285,
              1077.905,
              10443.264
            ],
            [
              -3919.363,
              1123.6,
              10489.063
            ],
            [
              -3953.633,
              1267.797,
              10637.276
            ],
            [
              -4003.354,
              1451.223,
              10827.322
            ],
            [
              -4002.478,
              1464.567,
              10840.694
            ],
            [
              -4050.827,
              1690.271,
              11071.518
            ],
            [
              -4137.78,
              1773.038,
              11191.565
            ],
            [
              -4148.475,
              1788.807,
              11210.62
            ],
            [
              -4177.913,
              1802.674,
              11243.16
            ],
            [
              -4315.532,
              1828.426,
              11383.167
            ],
            [
              -4369.14,
              1824.898,
              11436.892
            ],
            [
              -4499.314,
              1795.969,
              11570.241
            ],
            [
              -4609.774,
              1787.849,
              11680.999
            ],
            [
              -4563.222,
              1793.728,
              11727.921
            ],
            [
              -4774.467,
              1777.316,
              11939.802
            ],
            [
              -4906.917,
              1690.529,
              12098.153
            ],
            [
              -4962.228,
              1738.229,
              12171.192
            ],
            [
              -4976.074,
              1758.503,
              12195.743
            ],
            [
              -5065.283,
              1861.328,
              12331.872
            ],
            [
              -5078.713,
              1868.237,
              12346.976
            ],
            [
              -5084.328,
              1879.465,
              12359.529
            ],
            [
              -5216.149,
              1980.788,
              12525.791
            ],
            [
              -5235.044,
              2007.826,
              12558.777
            ],
            [
              -5239.9,
              2025.72,
              12577.318
            ],
            [
              -5242.177,
              2043.57,
              12595.313
            ],
            [
              -5239.142,
              2070.235,
              12622.15
            ],
            [
              -5225.085,
              2100.052,
              12655.114
            ],
            [
              -5208.03,
              2116.459,
              12678.78
            ],
            [
              -5183.957,
              2128.294,
              12705.605
            ],
            [
              -5143.89,
              2132.063,
              12745.849
            ],
            [
              -5127.139,
              2130.664,
              12762.658
            ],
            [
              -5121.865,
              2137.254,
              12771.098
            ],
            [
              -5122.054,
              2163.973,
              12797.819
            ],
            [
              -5126.114,
              2190.759,
              12824.91
            ],
            [
              -5124.178,
              2228.575,
              12862.775
            ],
            [
              -5130.799,
              2256.518,
              12891.492
            ],
            [
              -5178.189,
              2353.061,
              12999.039
            ],
            [
              -5259.467,
              2505.84,
              13172.092
            ],
            [
              -5436.233,
              2849.484,
              13558.534
            ],
            [
              -5455.246,
              2869.844,
              13586.392
            ],
            [
              -5458.132,
              2889.93,
              13606.685
            ],
            [
              -5471.207,
              2917.982,
              13637.634
            ],
            [
              -5500.051,
              2967.452,
              13694.899
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 119.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9565",
              "position": {
                "x": 1231.149,
                "z": -2596.659
              },
              "distanceAlongShapeM": 488.978,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:9637",
              "position": {
                "x": 874.193,
                "z": -2624.582
              },
              "distanceAlongShapeM": 895.525,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9640",
              "position": {
                "x": 793.859,
                "z": -2331.434
              },
              "distanceAlongShapeM": 1201.971,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:18847",
              "position": {
                "x": 578.225,
                "z": -1717.417
              },
              "distanceAlongShapeM": 1922.694,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5498",
              "position": {
                "x": 290.448,
                "z": -1731.073
              },
              "distanceAlongShapeM": 2211.626,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17315",
              "position": {
                "x": -226.936,
                "z": -1431.091
              },
              "distanceAlongShapeM": 3021.414,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17323",
              "position": {
                "x": -326.277,
                "z": -1114.243
              },
              "distanceAlongShapeM": 3404.511,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 3710.81,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 3948.671,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 4327.408,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:814",
              "position": {
                "x": -1374.402,
                "z": -1172.164
              },
              "distanceAlongShapeM": 4611.485,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5906",
              "position": {
                "x": -2267.097,
                "z": -1193.002
              },
              "distanceAlongShapeM": 5512.074,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 6418.1,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 7050.576,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 7313.433,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 7809.775,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 8177.678,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 8929.464,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5703",
              "position": {
                "x": -4134.494,
                "z": 768.872
              },
              "distanceAlongShapeM": 9981.477,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2070,
              "departureOffsetSeconds": 2070
            },
            {
              "stopId": "judu:stop:5702",
              "position": {
                "x": -3916.285,
                "z": 1077.905
              },
              "distanceAlongShapeM": 10443.264,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5698",
              "position": {
                "x": -4003.354,
                "z": 1451.223
              },
              "distanceAlongShapeM": 10827.322,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5694",
              "position": {
                "x": -4137.78,
                "z": 1773.038
              },
              "distanceAlongShapeM": 11191.565,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5692",
              "position": {
                "x": -4609.774,
                "z": 1787.849
              },
              "distanceAlongShapeM": 11680.999,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:7341",
              "position": {
                "x": -4962.228,
                "z": 1738.229
              },
              "distanceAlongShapeM": 12171.192,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:7560",
              "position": {
                "x": -5126.114,
                "z": 2190.759
              },
              "distanceAlongShapeM": 12824.91,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:7171",
              "position": {
                "x": -5259.467,
                "z": 2505.84
              },
              "distanceAlongShapeM": 13172.092,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:16622",
              "position": {
                "x": -5500.051,
                "z": 2967.452
              },
              "distanceAlongShapeM": 13694.899,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            }
          ],
          "departuresSeconds": [
            17880,
            19800,
            22020,
            23880,
            25800,
            26880,
            28980,
            32220,
            33660,
            34860,
            37440,
            39660,
            41880,
            44040,
            46260,
            48480,
            50640,
            52860,
            54960,
            57060,
            58560,
            60240,
            62160,
            64080,
            66240,
            68940,
            70740,
            73140,
            75420,
            77520,
            79620,
            81720
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_69:1",
          "sourceRouteId": "vilnius_bus_69",
          "sourceShapeId": "vilnius_bus_69_b-a",
          "directionId": 1,
          "headsign": "Šiaurės miestelis",
          "directionName": "Lazdynėliai–Lazdynai–Kernavės g.–Kalvarijų–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "69",
          "routeLongName": "Šiaurės miestelis–Kernavės g.–Lazdynai–Lazdynėliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5500.051,
              2967.452,
              0
            ],
            [
              -5505.687,
              2977.567,
              11.579
            ],
            [
              -5506.864,
              2984.266,
              18.38
            ],
            [
              -5506.789,
              2988.717,
              22.833
            ],
            [
              -5500.205,
              2996.398,
              32.949
            ],
            [
              -5484.077,
              2996.124,
              49.079
            ],
            [
              -5478.327,
              2992.687,
              55.778
            ],
            [
              -5475.234,
              2984.842,
              64.21
            ],
            [
              -5479.879,
              2939.28,
              110.009
            ],
            [
              -5471.207,
              2917.982,
              133.005
            ],
            [
              -5262.256,
              2531.491,
              572.363
            ],
            [
              -5252.978,
              2507.956,
              597.661
            ],
            [
              -5128.219,
              2256.474,
              878.389
            ],
            [
              -5121.579,
              2229.644,
              906.028
            ],
            [
              -5117.539,
              2201.745,
              934.218
            ],
            [
              -5116.022,
              2139.38,
              996.601
            ],
            [
              -5122.738,
              2123.91,
              1013.466
            ],
            [
              -5151.175,
              2121.056,
              1042.046
            ],
            [
              -5168.571,
              2122.465,
              1059.499
            ],
            [
              -5186.062,
              2118.311,
              1077.477
            ],
            [
              -5204.976,
              2106.388,
              1099.835
            ],
            [
              -5218.73,
              2094.377,
              1118.095
            ],
            [
              -5232.085,
              2067.888,
              1147.76
            ],
            [
              -5234.987,
              2049.013,
              1166.857
            ],
            [
              -5232.767,
              2027.825,
              1188.161
            ],
            [
              -5229.106,
              2015.517,
              1201.002
            ],
            [
              -5217.174,
              1996.39,
              1223.546
            ],
            [
              -5203.212,
              1982.793,
              1243.035
            ],
            [
              -5082.26,
              1887.222,
              1397.188
            ],
            [
              -5064.922,
              1882.473,
              1415.165
            ],
            [
              -5060.085,
              1863.466,
              1434.777
            ],
            [
              -4961.259,
              1757.137,
              1579.941
            ],
            [
              -4928.804,
              1730.978,
              1621.625
            ],
            [
              -4906.917,
              1690.529,
              1667.617
            ],
            [
              -4842.797,
              1742.865,
              1750.384
            ],
            [
              -4801.101,
              1766.641,
              1798.383
            ],
            [
              -4774.467,
              1777.316,
              1827.076
            ],
            [
              -4728.427,
              1790.998,
              1875.106
            ],
            [
              -4687.68,
              1796.979,
              1916.29
            ],
            [
              -4579.155,
              1805.134,
              2025.121
            ],
            [
              -4547.361,
              1815.72,
              2058.631
            ],
            [
              -4518.395,
              1811.882,
              2087.85
            ],
            [
              -4300.033,
              1829.272,
              2306.903
            ],
            [
              -4282.619,
              1828.972,
              2324.32
            ],
            [
              -4257.523,
              1825.2,
              2349.698
            ],
            [
              -4165.014,
              1802.452,
              2444.963
            ],
            [
              -4141.304,
              1793.136,
              2470.437
            ],
            [
              -4122.773,
              1782.797,
              2491.657
            ],
            [
              -4066.123,
              1738.403,
              2563.63
            ],
            [
              -4047.525,
              1694.666,
              2611.157
            ],
            [
              -4037.081,
              1664.429,
              2643.147
            ],
            [
              -4020.121,
              1600.683,
              2709.111
            ],
            [
              -3992.198,
              1462.162,
              2850.417
            ],
            [
              -3984.902,
              1436.432,
              2877.162
            ],
            [
              -3986.154,
              1438.68,
              2879.735
            ],
            [
              -3968.906,
              1391.627,
              2929.849
            ],
            [
              -3971.11,
              1376.08,
              2945.552
            ],
            [
              -3953.873,
              1291.178,
              3032.186
            ],
            [
              -3953.633,
              1267.797,
              3055.568
            ],
            [
              -3919.363,
              1123.6,
              3203.782
            ],
            [
              -3889.289,
              1035.135,
              3297.219
            ],
            [
              -3876.172,
              1010.417,
              3325.202
            ],
            [
              -3879.245,
              944.791,
              3390.899
            ],
            [
              -3886.86,
              914.867,
              3421.777
            ],
            [
              -3897.582,
              891.676,
              3447.328
            ],
            [
              -3911.432,
              874.104,
              3469.701
            ],
            [
              -3948.102,
              842.457,
              3518.139
            ],
            [
              -4089.107,
              782.559,
              3671.339
            ],
            [
              -4161.662,
              727.04,
              3762.699
            ],
            [
              -4175.491,
              710.581,
              3784.196
            ],
            [
              -4216.46,
              691.251,
              3829.496
            ],
            [
              -4255.417,
              676.338,
              3871.21
            ],
            [
              -4279.313,
              674.524,
              3895.175
            ],
            [
              -4304.422,
              677.184,
              3920.424
            ],
            [
              -4330.724,
              685.43,
              3947.989
            ],
            [
              -4370.887,
              712.839,
              3996.612
            ],
            [
              -4391.801,
              734.351,
              4026.615
            ],
            [
              -4418.25,
              771.542,
              4072.252
            ],
            [
              -4423.862,
              782.771,
              4084.805
            ],
            [
              -4434.785,
              785.185,
              4095.992
            ],
            [
              -4479.393,
              779.274,
              4140.989
            ],
            [
              -4503.366,
              773.007,
              4165.768
            ],
            [
              -4524.836,
              762.245,
              4189.784
            ],
            [
              -4546.478,
              741.466,
              4219.787
            ],
            [
              -4558.582,
              712.731,
              4250.967
            ],
            [
              -4562.872,
              688.314,
              4275.758
            ],
            [
              -4562.176,
              653.793,
              4310.286
            ],
            [
              -4542.083,
              471.996,
              4493.19
            ],
            [
              -4530.426,
              437.286,
              4529.805
            ],
            [
              -4533.311,
              419.524,
              4547.8
            ],
            [
              -4527.744,
              368.221,
              4599.404
            ],
            [
              -4516.259,
              323.495,
              4645.581
            ],
            [
              -4491.638,
              255.166,
              4718.21
            ],
            [
              -4427.619,
              152.763,
              4838.979
            ],
            [
              -4367.011,
              77.134,
              4935.897
            ],
            [
              -4077.229,
              -208.399,
              5342.716
            ],
            [
              -3954.469,
              -380.846,
              5554.395
            ],
            [
              -3921.604,
              -419.265,
              5604.954
            ],
            [
              -3917.323,
              -432.698,
              5619.052
            ],
            [
              -3857.936,
              -540.596,
              5742.214
            ],
            [
              -3823.641,
              -607.984,
              5817.827
            ],
            [
              -3766.483,
              -732.543,
              5954.874
            ],
            [
              -3707.64,
              -908.34,
              6140.257
            ],
            [
              -3695.741,
              -928.584,
              6163.74
            ],
            [
              -3679.35,
              -950.021,
              6190.725
            ],
            [
              -3668.232,
              -978.044,
              6220.873
            ],
            [
              -3606.925,
              -1085.98,
              6345.004
            ],
            [
              -3586.062,
              -1109.72,
              6376.61
            ],
            [
              -3575.241,
              -1117.701,
              6390.056
            ],
            [
              -3510.568,
              -1143.319,
              6459.617
            ],
            [
              -3355.367,
              -1190.556,
              6621.848
            ],
            [
              -3108.49,
              -1230.499,
              6871.936
            ],
            [
              -3070.013,
              -1242.306,
              6912.183
            ],
            [
              -2879.155,
              -1277.94,
              7106.338
            ],
            [
              -2839.273,
              -1283.094,
              7146.552
            ],
            [
              -2787.087,
              -1285.125,
              7198.779
            ],
            [
              -2748.376,
              -1283.58,
              7237.52
            ],
            [
              -2714.118,
              -1278.617,
              7272.135
            ],
            [
              -2670.7,
              -1266.023,
              7317.343
            ],
            [
              -2624.585,
              -1246.798,
              7367.305
            ],
            [
              -2500.301,
              -1182.198,
              7507.375
            ],
            [
              -2469.831,
              -1172.717,
              7539.286
            ],
            [
              -2418.716,
              -1162.489,
              7591.415
            ],
            [
              -2392.231,
              -1159.617,
              7618.055
            ],
            [
              -2151.528,
              -1183.918,
              7859.982
            ],
            [
              -2126.509,
              -1191.041,
              7885.994
            ],
            [
              -2118.854,
              -1195.63,
              7894.92
            ],
            [
              -1948.388,
              -1217.583,
              8066.793
            ],
            [
              -1827.9,
              -1221.953,
              8187.36
            ],
            [
              -1794.345,
              -1220.324,
              8220.955
            ],
            [
              -1747.175,
              -1214.486,
              8268.485
            ],
            [
              -1624.316,
              -1194.413,
              8392.973
            ],
            [
              -1544.075,
              -1178.035,
              8474.868
            ],
            [
              -1436.465,
              -1145.449,
              8587.304
            ],
            [
              -1393.22,
              -1142.883,
              8630.624
            ],
            [
              -1155.149,
              -1098.17,
              8872.859
            ],
            [
              -1103.929,
              -1082.392,
              8926.453
            ],
            [
              -1061.953,
              -1078.693,
              8968.592
            ],
            [
              -1023.12,
              -1070.486,
              9008.283
            ],
            [
              -991.176,
              -1051.022,
              9045.689
            ],
            [
              -945.757,
              -1035.141,
              9093.805
            ],
            [
              -919.31,
              -1034.504,
              9120.26
            ],
            [
              -900.214,
              -1048.207,
              9143.764
            ],
            [
              -890.221,
              -1066.198,
              9164.344
            ],
            [
              -873.824,
              -1086.532,
              9190.465
            ],
            [
              -856.017,
              -1100.212,
              9212.92
            ],
            [
              -827.072,
              -1104.073,
              9242.121
            ],
            [
              -688.757,
              -1085.417,
              9381.689
            ],
            [
              -656.163,
              -1208.462,
              9508.977
            ],
            [
              -632.999,
              -1246.73,
              9553.71
            ],
            [
              -615.134,
              -1221.449,
              9584.667
            ],
            [
              -548.807,
              -1190.364,
              9657.916
            ],
            [
              -430.03,
              -1146.872,
              9784.405
            ],
            [
              -296.224,
              -1092.523,
              9928.828
            ],
            [
              -250.988,
              -1157.912,
              10008.338
            ],
            [
              -249.259,
              -1204.699,
              10055.158
            ],
            [
              -224.798,
              -1384.374,
              10236.49
            ],
            [
              -216.864,
              -1409.009,
              10262.371
            ],
            [
              -200.028,
              -1440.486,
              10298.067
            ],
            [
              -189.294,
              -1452.926,
              10314.498
            ],
            [
              -180.997,
              -1457.53,
              10323.987
            ],
            [
              -177.916,
              -1465.378,
              10332.419
            ],
            [
              -183.939,
              -1477.515,
              10345.968
            ],
            [
              -168.843,
              -1604.698,
              10474.043
            ],
            [
              -169.129,
              -1655.901,
              10525.248
            ],
            [
              -156.792,
              -1757.43,
              10627.523
            ],
            [
              91.167,
              -1735.227,
              10876.474
            ],
            [
              238.49,
              -1716.765,
              11024.95
            ],
            [
              330.69,
              -1716.223,
              11117.151
            ],
            [
              544.836,
              -1710.126,
              11331.384
            ],
            [
              573.294,
              -1705.081,
              11360.286
            ],
            [
              608.985,
              -1692.377,
              11398.17
            ],
            [
              629.004,
              -1690.518,
              11418.276
            ],
            [
              693.218,
              -1809.701,
              11553.656
            ],
            [
              704.051,
              -1816.579,
              11566.488
            ],
            [
              713.36,
              -1871.299,
              11621.994
            ],
            [
              776.616,
              -2147.432,
              11905.28
            ],
            [
              789.268,
              -2195.534,
              11955.018
            ],
            [
              792.091,
              -2252.361,
              12011.916
            ],
            [
              808.047,
              -2296.071,
              12058.447
            ],
            [
              810.133,
              -2322.828,
              12085.284
            ],
            [
              815.482,
              -2347.417,
              12110.449
            ],
            [
              839.035,
              -2433.57,
              12199.764
            ],
            [
              881.722,
              -2565.719,
              12338.636
            ],
            [
              898.145,
              -2653.968,
              12428.399
            ],
            [
              900.578,
              -2661.805,
              12436.606
            ],
            [
              904.362,
              -2666.328,
              12442.503
            ],
            [
              908.852,
              -2667.524,
              12447.149
            ],
            [
              920.512,
              -2664.399,
              12459.22
            ],
            [
              978.247,
              -2644.311,
              12520.35
            ],
            [
              1030.623,
              -2635.258,
              12573.503
            ],
            [
              1258.684,
              -2571.563,
              12810.292
            ],
            [
              1329.768,
              -2561.746,
              12882.05
            ],
            [
              1359.181,
              -2574.537,
              12914.124
            ],
            [
              1423.013,
              -2573.493,
              12977.964
            ],
            [
              1423.219,
              -2562.364,
              12989.095
            ],
            [
              1413.343,
              -2538.803,
              13014.642
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:16622",
              "position": {
                "x": -5500.051,
                "z": 2967.452
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -120,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:3560",
              "position": {
                "x": -5262.256,
                "z": 2531.491
              },
              "distanceAlongShapeM": 572.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:756",
              "position": {
                "x": -5151.175,
                "z": 2121.056
              },
              "distanceAlongShapeM": 1042.046,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 1621.625,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 2058.631,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 2563.63,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 2929.849,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5701",
              "position": {
                "x": -3876.172,
                "z": 1010.417
              },
              "distanceAlongShapeM": 3325.202,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5704",
              "position": {
                "x": -4175.491,
                "z": 710.581
              },
              "distanceAlongShapeM": 3784.196,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 4529.805,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 5342.716,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 5604.954,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 6190.725,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 6871.936,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6398",
              "position": {
                "x": -2151.528,
                "z": -1183.918
              },
              "distanceAlongShapeM": 7859.982,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6396",
              "position": {
                "x": -1436.465,
                "z": -1145.449
              },
              "distanceAlongShapeM": 8587.304,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 8926.453,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:17495",
              "position": {
                "x": -615.134,
                "z": -1221.449
              },
              "distanceAlongShapeM": 9584.667,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:17317",
              "position": {
                "x": -250.988,
                "z": -1157.912
              },
              "distanceAlongShapeM": 10008.338,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:17313",
              "position": {
                "x": -178.826,
                "z": -1515.457
              },
              "distanceAlongShapeM": 10384.249,
              "shapeOffsetM": 0.605,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:17318",
              "position": {
                "x": -103.866,
                "z": -1753.939
              },
              "distanceAlongShapeM": 10680.55,
              "shapeOffsetM": 1.244,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7691",
              "position": {
                "x": 238.49,
                "z": -1716.765
              },
              "distanceAlongShapeM": 11024.95,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7331",
              "position": {
                "x": 704.051,
                "z": -1816.579
              },
              "distanceAlongShapeM": 11566.488,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9638",
              "position": {
                "x": 808.047,
                "z": -2296.071
              },
              "distanceAlongShapeM": 12058.447,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:18532",
              "position": {
                "x": 978.247,
                "z": -2644.311
              },
              "distanceAlongShapeM": 12520.35,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:9566",
              "position": {
                "x": 1329.768,
                "z": -2561.746
              },
              "distanceAlongShapeM": 12882.05,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 13014.642,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            20520,
            22440,
            24660,
            26700,
            28800,
            30000,
            32040,
            35280,
            36600,
            37800,
            40380,
            42600,
            44880,
            47040,
            49260,
            51480,
            53640,
            55860,
            57960,
            60060,
            61740,
            63420,
            65340,
            67260,
            69360,
            72000,
            73680,
            76080,
            78240,
            80280,
            82320,
            84420
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_73",
      "sourceRouteId": "vilnius_bus_73",
      "mode": "bus",
      "shortName": "73",
      "longName": "Justiniškės–Centras–Naugarduko g.–Vilkpėdė (Apylanka Rygos g.)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_73:0",
          "sourceRouteId": "vilnius_bus_73",
          "sourceShapeId": "vilnius_bus_73_a1-b",
          "directionId": 0,
          "headsign": "Vilkpėdė (Apylanka Rygos g.)",
          "directionName": "Justiniškės–Centras–Naugarduko g.–Vilkpėdė (Apylanka Rygos g.)",
          "mode": "bus",
          "routeShortName": "73",
          "routeLongName": "Justiniškės–Centras–Naugarduko g.–Vilkpėdė (Apylanka Rygos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4258.81,
              -2245.769,
              0
            ],
            [
              -4261.214,
              -2235.708,
              10.344
            ],
            [
              -4255.906,
              -2226.894,
              20.633
            ],
            [
              -4235.795,
              -2219.449,
              42.078
            ],
            [
              -4226.11,
              -2218.503,
              51.809
            ],
            [
              -4222.301,
              -2221.909,
              56.918
            ],
            [
              -4216.3,
              -2247.616,
              83.316
            ],
            [
              -4210.635,
              -2255.507,
              93.03
            ],
            [
              -4196.209,
              -2315.87,
              155.092
            ],
            [
              -4165.8,
              -2421.037,
              264.568
            ],
            [
              -4138.614,
              -2526.149,
              373.139
            ],
            [
              -4122.867,
              -2733.479,
              581.066
            ],
            [
              -4112.669,
              -2926.241,
              774.097
            ],
            [
              -4108.545,
              -2948.576,
              796.81
            ],
            [
              -4174.702,
              -3308.112,
              1162.382
            ],
            [
              -4111.181,
              -3286.947,
              1229.335
            ],
            [
              -4018.747,
              -3270.737,
              1323.18
            ],
            [
              -3940.176,
              -3236.477,
              1408.895
            ],
            [
              -3823.754,
              -3175.046,
              1540.531
            ],
            [
              -3810.695,
              -3165.254,
              1556.853
            ],
            [
              -3713.888,
              -3120.182,
              1663.638
            ],
            [
              -3714.983,
              -3109.031,
              1674.843
            ],
            [
              -3665.065,
              -3092.089,
              1727.558
            ],
            [
              -3645.64,
              -3086.861,
              1747.674
            ],
            [
              -3537.19,
              -3076.506,
              1856.617
            ],
            [
              -3288.387,
              -3074.173,
              2105.432
            ],
            [
              -3226.908,
              -3059.664,
              2168.599
            ],
            [
              -3088.313,
              -3020.904,
              2312.512
            ],
            [
              -3076.618,
              -3015.543,
              2325.377
            ],
            [
              -3065.626,
              -3013.509,
              2336.555
            ],
            [
              -3013.674,
              -2991.043,
              2393.157
            ],
            [
              -2972.908,
              -2981.74,
              2434.971
            ],
            [
              -2923.591,
              -2962.569,
              2487.883
            ],
            [
              -2796.251,
              -2867.959,
              2646.523
            ],
            [
              -2713.249,
              -2802.628,
              2752.152
            ],
            [
              -2678.551,
              -2772.069,
              2798.388
            ],
            [
              -2644.38,
              -2734.822,
              2848.935
            ],
            [
              -2636.314,
              -2716.04,
              2869.376
            ],
            [
              -2600.033,
              -2668.811,
              2928.932
            ],
            [
              -2574.02,
              -2619.176,
              2984.971
            ],
            [
              -2545.641,
              -2545.091,
              3064.305
            ],
            [
              -2520.523,
              -2473.175,
              3140.481
            ],
            [
              -2499.973,
              -2404.518,
              3212.147
            ],
            [
              -2490.126,
              -2357.937,
              3259.758
            ],
            [
              -2467.791,
              -2224.746,
              3394.809
            ],
            [
              -2431.725,
              -2226.496,
              3430.918
            ],
            [
              -2415.576,
              -2224.555,
              3447.183
            ],
            [
              -2373.4,
              -2245.339,
              3494.201
            ],
            [
              -2196.773,
              -2317.488,
              3684.996
            ],
            [
              -2137.182,
              -2337.47,
              3747.848
            ],
            [
              -2070.464,
              -2355.353,
              3816.921
            ],
            [
              -1991.404,
              -2367.89,
              3896.969
            ],
            [
              -1948.856,
              -2367.533,
              3939.519
            ],
            [
              -1899.081,
              -2359.513,
              3989.936
            ],
            [
              -1862.838,
              -2351.253,
              4027.108
            ],
            [
              -1818.039,
              -2333.126,
              4075.435
            ],
            [
              -1763.981,
              -2301.806,
              4137.911
            ],
            [
              -1728.668,
              -2273.492,
              4183.174
            ],
            [
              -1674.776,
              -2215.452,
              4262.375
            ],
            [
              -1645.063,
              -2175.906,
              4311.84
            ],
            [
              -1547.472,
              -2017.345,
              4498.027
            ],
            [
              -1343.434,
              -1674.784,
              4896.75
            ],
            [
              -1305.861,
              -1628.702,
              4956.208
            ],
            [
              -1268.647,
              -1602.651,
              5001.634
            ],
            [
              -1054.592,
              -1494.059,
              5241.658
            ],
            [
              -1027.103,
              -1471.176,
              5277.425
            ],
            [
              -1009.966,
              -1450.333,
              5304.409
            ],
            [
              -1001.511,
              -1410.409,
              5345.219
            ],
            [
              -987.78,
              -1363.9,
              5393.712
            ],
            [
              -988.723,
              -1201.352,
              5556.263
            ],
            [
              -990.397,
              -1186.85,
              5570.861
            ],
            [
              -1017.615,
              -1122.906,
              5640.357
            ],
            [
              -1020.518,
              -1105.042,
              5658.455
            ],
            [
              -1018.304,
              -1089.497,
              5674.157
            ],
            [
              -1013.532,
              -1075.111,
              5689.314
            ],
            [
              -1005.537,
              -1060.783,
              5705.722
            ],
            [
              -990.532,
              -1051.034,
              5723.616
            ],
            [
              -976.596,
              -1029.02,
              5749.67
            ],
            [
              -969.87,
              -1013.556,
              5766.534
            ],
            [
              -967.031,
              -999.135,
              5781.231
            ],
            [
              -969.129,
              -972.38,
              5808.068
            ],
            [
              -954.912,
              -934.786,
              5848.261
            ],
            [
              -945.547,
              -916.03,
              5869.225
            ],
            [
              -940.714,
              -898.305,
              5887.597
            ],
            [
              -936.79,
              -859.413,
              5926.686
            ],
            [
              -924.604,
              -648.119,
              6138.331
            ],
            [
              -926.501,
              -610.235,
              6176.263
            ],
            [
              -934.701,
              -600.068,
              6189.324
            ],
            [
              -944.29,
              -595.443,
              6199.97
            ],
            [
              -952.65,
              -594.179,
              6208.426
            ],
            [
              -963.004,
              -596.219,
              6218.979
            ],
            [
              -972.833,
              -604.948,
              6232.124
            ],
            [
              -992.833,
              -641.325,
              6273.636
            ],
            [
              -992.649,
              -666.932,
              6299.245
            ],
            [
              -989.606,
              -677.006,
              6309.768
            ],
            [
              -978.263,
              -691.682,
              6328.316
            ],
            [
              -964.927,
              -703.054,
              6345.843
            ],
            [
              -939.343,
              -714.647,
              6373.931
            ],
            [
              -865.474,
              -730.449,
              6449.471
            ],
            [
              -798.395,
              -729.432,
              6516.558
            ],
            [
              -764.735,
              -722.247,
              6550.976
            ],
            [
              -714.638,
              -697.546,
              6606.831
            ],
            [
              -692.924,
              -673.447,
              6639.27
            ],
            [
              -655.859,
              -656.305,
              6680.107
            ],
            [
              -601.451,
              -607.193,
              6753.402
            ],
            [
              -500.911,
              -503.255,
              6898.011
            ],
            [
              -413.017,
              -421.354,
              7018.148
            ],
            [
              -450.326,
              -380.602,
              7073.399
            ],
            [
              -465.596,
              -369.193,
              7092.461
            ],
            [
              -470.512,
              -355.745,
              7106.779
            ],
            [
              -508.466,
              -314.982,
              7162.476
            ],
            [
              -611.52,
              -58.189,
              7439.175
            ],
            [
              -615.308,
              -53.668,
              7445.074
            ],
            [
              -625.745,
              -24.535,
              7476.019
            ],
            [
              -646.921,
              17.037,
              7522.674
            ],
            [
              -652.524,
              63.893,
              7569.865
            ],
            [
              -679.973,
              222.467,
              7730.797
            ],
            [
              -691.721,
              250.51,
              7761.201
            ],
            [
              -832.714,
              443.415,
              8000.139
            ],
            [
              -840.816,
              459.146,
              8017.833
            ],
            [
              -843.214,
              469.208,
              8028.178
            ],
            [
              -833.842,
              667.193,
              8226.385
            ],
            [
              -824.942,
              731.6,
              8291.403
            ],
            [
              -800.789,
              819.11,
              8382.185
            ],
            [
              -793.638,
              857.944,
              8421.672
            ],
            [
              -767.948,
              887.538,
              8460.861
            ],
            [
              -708.773,
              1021.171,
              8607.01
            ],
            [
              -697.048,
              1063.262,
              8650.703
            ],
            [
              -655.787,
              1240.633,
              8832.811
            ],
            [
              -656.233,
              1287.397,
              8879.576
            ],
            [
              -631.67,
              1361.539,
              8957.682
            ],
            [
              -586.657,
              1567.786,
              9168.784
            ],
            [
              -623.076,
              1587.369,
              9210.134
            ],
            [
              -767.651,
              1691.281,
              9388.178
            ],
            [
              -978.813,
              1859.839,
              9658.365
            ],
            [
              -1190.297,
              2047.317,
              9940.984
            ],
            [
              -1514.694,
              2380.408,
              10405.939
            ],
            [
              -1536.913,
              2400.843,
              10436.126
            ],
            [
              -1586.671,
              2432.901,
              10495.317
            ],
            [
              -1589.092,
              2441.85,
              10504.588
            ],
            [
              -1665.298,
              2474.379,
              10587.446
            ],
            [
              -1973.715,
              2584.507,
              10914.935
            ],
            [
              -1980.067,
              2590.186,
              10923.456
            ],
            [
              -1990.862,
              2563.661,
              10952.094
            ],
            [
              -1996.181,
              2554.849,
              10962.386
            ],
            [
              -2002.73,
              2549.399,
              10970.906
            ],
            [
              -2002.849,
              2542.722,
              10977.584
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6990",
              "position": {
                "x": -4210.635,
                "z": -2255.507
              },
              "distanceAlongShapeM": 93.03,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6993",
              "position": {
                "x": -4108.545,
                "z": -2948.576
              },
              "distanceAlongShapeM": 796.81,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:15412",
              "position": {
                "x": -4111.181,
                "z": -3286.947
              },
              "distanceAlongShapeM": 1229.335,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7001",
              "position": {
                "x": -3665.065,
                "z": -3092.089
              },
              "distanceAlongShapeM": 1727.558,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 2393.157,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 2869.376,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:1069",
              "position": {
                "x": -2415.576,
                "z": -2224.555
              },
              "distanceAlongShapeM": 3447.183,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5220",
              "position": {
                "x": -1001.511,
                "z": -1410.409
              },
              "distanceAlongShapeM": 5345.219,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5533",
              "position": {
                "x": -969.129,
                "z": -972.38
              },
              "distanceAlongShapeM": 5808.068,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5539",
              "position": {
                "x": -692.924,
                "z": -673.447
              },
              "distanceAlongShapeM": 6639.27,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5257",
              "position": {
                "x": -465.596,
                "z": -369.193
              },
              "distanceAlongShapeM": 7092.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 7522.674,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5266",
              "position": {
                "x": -793.638,
                "z": 857.944
              },
              "distanceAlongShapeM": 8421.672,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5272",
              "position": {
                "x": -656.233,
                "z": 1287.397
              },
              "distanceAlongShapeM": 8879.576,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5645",
              "position": {
                "x": -623.076,
                "z": 1587.369
              },
              "distanceAlongShapeM": 9210.134,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5649",
              "position": {
                "x": -978.813,
                "z": 1859.839
              },
              "distanceAlongShapeM": 9658.365,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:9701",
              "position": {
                "x": -1232.774,
                "z": 2089.268
              },
              "distanceAlongShapeM": 10000.673,
              "shapeOffsetM": 1.162,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:7941",
              "position": {
                "x": -1586.671,
                "z": 2432.901
              },
              "distanceAlongShapeM": 10495.317,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 10977.584,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            }
          ],
          "departuresSeconds": [
            19440,
            20700,
            22080,
            23040,
            23940,
            25200,
            26940,
            28440,
            30360,
            32040,
            33960,
            36120,
            38400,
            40320,
            42240,
            44400,
            46560,
            48420,
            50580,
            52740,
            54660,
            56100,
            57120,
            57960,
            59640,
            61560,
            63240,
            64980,
            66540,
            68940,
            71040,
            73200,
            75000,
            76680,
            78780,
            80460,
            81900
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_73:1",
          "sourceRouteId": "vilnius_bus_73",
          "sourceShapeId": "vilnius_bus_73_b-a1",
          "directionId": 1,
          "headsign": "Justiniškės (Apylanka Rygos g.)",
          "directionName": "Vilkpėdė–Naugarduko g.–Centras–Justiniškės (Apylanka Rygos g.)",
          "mode": "bus",
          "routeShortName": "73",
          "routeLongName": "Justiniškės–Centras–Naugarduko g.–Vilkpėdė (Apylanka Rygos g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2002.849,
              2542.722,
              0
            ],
            [
              -2009.26,
              2545.063,
              6.825
            ],
            [
              -2019.015,
              2540.783,
              17.477
            ],
            [
              -2077.913,
              2530.695,
              77.234
            ],
            [
              -2083.871,
              2558.631,
              105.798
            ],
            [
              -2083.009,
              2570.861,
              118.058
            ],
            [
              -2085.352,
              2584.261,
              131.662
            ],
            [
              -2057.496,
              2590.447,
              160.197
            ],
            [
              -2051.124,
              2585.881,
              168.036
            ],
            [
              -2042.349,
              2571.254,
              185.093
            ],
            [
              -2044.403,
              2564.611,
              192.046
            ],
            [
              -2036.471,
              2538.866,
              218.985
            ],
            [
              -2016.375,
              2544.076,
              239.745
            ],
            [
              -2000.11,
              2551.579,
              257.657
            ],
            [
              -1974.301,
              2587.857,
              302.18
            ],
            [
              -1936.577,
              2568.263,
              344.688
            ],
            [
              -1765.274,
              2512.896,
              524.717
            ],
            [
              -1632.053,
              2457.088,
              669.155
            ],
            [
              -1563.915,
              2442.514,
              738.834
            ],
            [
              -1527.823,
              2404.02,
              791.602
            ],
            [
              -1399.067,
              2279.266,
              970.883
            ],
            [
              -1328.942,
              2195.633,
              1080.025
            ],
            [
              -1190.297,
              2047.317,
              1283.052
            ],
            [
              -1176.911,
              2038.172,
              1299.263
            ],
            [
              -1135.911,
              2021.851,
              1343.393
            ],
            [
              -1124.175,
              1992.697,
              1374.82
            ],
            [
              -768.296,
              1691.292,
              1841.184
            ],
            [
              -740.744,
              1680.777,
              1870.675
            ],
            [
              -729.98,
              1669.45,
              1886.299
            ],
            [
              -624.77,
              1600.758,
              2011.949
            ],
            [
              -585.791,
              1580.016,
              2056.103
            ],
            [
              -581.357,
              1575.483,
              2062.445
            ],
            [
              -578.293,
              1566.522,
              2071.915
            ],
            [
              -659.332,
              1222.885,
              2424.978
            ],
            [
              -678.532,
              1124.155,
              2525.558
            ],
            [
              -679.739,
              1093.006,
              2556.73
            ],
            [
              -691.829,
              1066.507,
              2585.856
            ],
            [
              -722.413,
              980.227,
              2677.397
            ],
            [
              -789.726,
              824.476,
              2847.071
            ],
            [
              -808.22,
              764.696,
              2909.647
            ],
            [
              -810.251,
              723.543,
              2950.85
            ],
            [
              -824.878,
              699.315,
              2979.151
            ],
            [
              -838.2,
              496.948,
              3181.956
            ],
            [
              -838.156,
              463.551,
              3215.353
            ],
            [
              -823.183,
              435.45,
              3247.194
            ],
            [
              -689.041,
              256.028,
              3471.217
            ],
            [
              -671.067,
              215.627,
              3515.436
            ],
            [
              -634.631,
              19.041,
              3715.37
            ],
            [
              -585.127,
              -96.516,
              3841.085
            ],
            [
              -570.097,
              -121.279,
              3870.052
            ],
            [
              -567.275,
              -143.594,
              3892.545
            ],
            [
              -513.161,
              -289.293,
              4047.969
            ],
            [
              -501.093,
              -299.53,
              4063.793
            ],
            [
              -508.466,
              -314.982,
              4080.914
            ],
            [
              -532.258,
              -346.835,
              4120.672
            ],
            [
              -695.752,
              -508.638,
              4350.695
            ],
            [
              -754.191,
              -530.962,
              4413.252
            ],
            [
              -813.838,
              -548.811,
              4475.513
            ],
            [
              -813.253,
              -552.161,
              4478.914
            ],
            [
              -859.203,
              -561.352,
              4525.773
            ],
            [
              -900.035,
              -572.862,
              4568.196
            ],
            [
              -908.595,
              -582.727,
              4581.257
            ],
            [
              -919.624,
              -908.704,
              4907.421
            ],
            [
              -906.184,
              -950.135,
              4950.978
            ],
            [
              -902.638,
              -968.011,
              4969.202
            ],
            [
              -906.763,
              -1018.032,
              5019.392
            ],
            [
              -903.416,
              -1047.036,
              5048.589
            ],
            [
              -878.9,
              -1081.988,
              5091.282
            ],
            [
              -875.273,
              -1095.412,
              5105.187
            ],
            [
              -879.138,
              -1130.965,
              5140.95
            ],
            [
              -892.47,
              -1155.216,
              5168.624
            ],
            [
              -917.464,
              -1182.597,
              5205.697
            ],
            [
              -926.283,
              -1206.929,
              5231.578
            ],
            [
              -917.431,
              -1323.977,
              5348.961
            ],
            [
              -911.942,
              -1448.758,
              5473.862
            ],
            [
              -922.391,
              -1491.986,
              5518.335
            ],
            [
              -939.829,
              -1529.521,
              5559.723
            ],
            [
              -961.618,
              -1558.073,
              5595.639
            ],
            [
              -995.732,
              -1590.856,
              5642.952
            ],
            [
              -1026.383,
              -1610.342,
              5679.273
            ],
            [
              -1072.441,
              -1626.213,
              5727.988
            ],
            [
              -1262.636,
              -1662.874,
              5921.684
            ],
            [
              -1320.472,
              -1688.554,
              5984.965
            ],
            [
              -1382.029,
              -1741.999,
              6066.486
            ],
            [
              -1597.414,
              -2106.624,
              6489.974
            ],
            [
              -1645.063,
              -2175.906,
              6574.06
            ],
            [
              -1682.619,
              -2257.615,
              6663.986
            ],
            [
              -1702.963,
              -2314.026,
              6723.954
            ],
            [
              -1711.936,
              -2347.263,
              6758.381
            ],
            [
              -1753.781,
              -2416.65,
              6839.409
            ],
            [
              -1791.442,
              -2468.3,
              6903.331
            ],
            [
              -1796.25,
              -2484.913,
              6920.626
            ],
            [
              -1794.575,
              -2499.414,
              6935.224
            ],
            [
              -1786.456,
              -2514.031,
              6951.944
            ],
            [
              -1773.708,
              -2522.051,
              6967.005
            ],
            [
              -1755.022,
              -2522.384,
              6985.694
            ],
            [
              -1739.399,
              -2513.757,
              7003.541
            ],
            [
              -1728.911,
              -2503.925,
              7017.917
            ],
            [
              -1701.579,
              -2453.204,
              7075.533
            ],
            [
              -1699.467,
              -2443.223,
              7085.735
            ],
            [
              -1706.803,
              -2420.827,
              7109.301
            ],
            [
              -1718.262,
              -2412.83,
              7123.275
            ],
            [
              -1731.05,
              -2407.036,
              7137.315
            ],
            [
              -1888.235,
              -2402.009,
              7294.58
            ],
            [
              -1933.866,
              -2394.517,
              7340.822
            ],
            [
              -2056.217,
              -2387.889,
              7463.352
            ],
            [
              -2112.099,
              -2376.878,
              7520.309
            ],
            [
              -2168.467,
              -2356.953,
              7580.095
            ],
            [
              -2220.425,
              -2342.673,
              7633.979
            ],
            [
              -2388.773,
              -2276.238,
              7814.962
            ],
            [
              -2402.929,
              -2274.874,
              7829.184
            ],
            [
              -2472.07,
              -2248.048,
              7903.347
            ],
            [
              -2470.476,
              -2303.737,
              7959.059
            ],
            [
              -2477.313,
              -2325.88,
              7982.234
            ],
            [
              -2484.017,
              -2376.97,
              8033.761
            ],
            [
              -2514.005,
              -2505.574,
              8165.815
            ],
            [
              -2552.25,
              -2627.352,
              8293.458
            ],
            [
              -2587.598,
              -2694.635,
              8369.461
            ],
            [
              -2667.366,
              -2795.644,
              8498.169
            ],
            [
              -2878.335,
              -2954.459,
              8762.233
            ],
            [
              -2942.823,
              -2993.401,
              8837.567
            ],
            [
              -2993.467,
              -3014.776,
              8892.538
            ],
            [
              -3056.314,
              -3033.711,
              8958.175
            ],
            [
              -3148.249,
              -3057.702,
              9053.189
            ],
            [
              -3175.503,
              -3068.357,
              9082.452
            ],
            [
              -3256.271,
              -3080.301,
              9164.097
            ],
            [
              -3258.184,
              -3079.154,
              9166.328
            ],
            [
              -3398.204,
              -3088.951,
              9306.69
            ],
            [
              -3540.683,
              -3092.03,
              9449.203
            ],
            [
              -3587.831,
              -3097.887,
              9496.713
            ],
            [
              -3688.781,
              -3121.733,
              9600.442
            ],
            [
              -4068.739,
              -3292.135,
              10016.86
            ],
            [
              -4174.702,
              -3308.112,
              10124.021
            ],
            [
              -4176.922,
              -3250.186,
              10181.989
            ],
            [
              -4124.202,
              -3034.023,
              10404.488
            ],
            [
              -4119.192,
              -3005.166,
              10433.777
            ],
            [
              -4115.728,
              -2954.018,
              10485.042
            ],
            [
              -4117.064,
              -2919.485,
              10519.6
            ],
            [
              -4123.554,
              -2884.864,
              10554.825
            ],
            [
              -4139.258,
              -2526.138,
              10913.894
            ],
            [
              -4203.711,
              -2302.381,
              11146.748
            ],
            [
              -4254.136,
              -2273.68,
              11204.77
            ],
            [
              -4258.81,
              -2245.769,
              11233.069
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:19255",
              "position": {
                "x": -2002.849,
                "z": 2542.722
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8311",
              "position": {
                "x": -2042.349,
                "z": 2571.254
              },
              "distanceAlongShapeM": 185.093,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:8309",
              "position": {
                "x": -1563.915,
                "z": 2442.514
              },
              "distanceAlongShapeM": 738.834,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:9642",
              "position": {
                "x": -1399.067,
                "z": 2279.266
              },
              "distanceAlongShapeM": 970.883,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5655",
              "position": {
                "x": -1135.911,
                "z": 2021.851
              },
              "distanceAlongShapeM": 1343.393,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6852",
              "position": {
                "x": -740.744,
                "z": 1680.777
              },
              "distanceAlongShapeM": 1870.675,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 2556.73,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 2950.85,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 3870.052,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5259",
              "position": {
                "x": -532.258,
                "z": -346.835
              },
              "distanceAlongShapeM": 4120.672,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:10360",
              "position": {
                "x": -813.253,
                "z": -552.161
              },
              "distanceAlongShapeM": 4478.914,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5534",
              "position": {
                "x": -902.638,
                "z": -968.011
              },
              "distanceAlongShapeM": 4969.202,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5290",
              "position": {
                "x": -1711.936,
                "z": -2347.263
              },
              "distanceAlongShapeM": 6758.381,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1410,
              "departureOffsetSeconds": 1410
            },
            {
              "stopId": "judu:stop:5074",
              "position": {
                "x": -2470.476,
                "z": -2303.737
              },
              "distanceAlongShapeM": 7959.059,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 8498.169,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1770,
              "departureOffsetSeconds": 1770
            },
            {
              "stopId": "judu:stop:5137",
              "position": {
                "x": -3175.503,
                "z": -3068.357
              },
              "distanceAlongShapeM": 9082.452,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1890,
              "departureOffsetSeconds": 1890
            },
            {
              "stopId": "judu:stop:15411",
              "position": {
                "x": -3782.29,
                "z": -3162.408
              },
              "distanceAlongShapeM": 9702.407,
              "shapeOffsetM": 1.151,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6995",
              "position": {
                "x": -4176.922,
                "z": -3250.186
              },
              "distanceAlongShapeM": 10181.989,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6992",
              "position": {
                "x": -4123.554,
                "z": -2884.864
              },
              "distanceAlongShapeM": 10554.825,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:18975",
              "position": {
                "x": -4258.81,
                "z": -2245.769
              },
              "distanceAlongShapeM": 11233.069,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            }
          ],
          "departuresSeconds": [
            19800,
            22020,
            23520,
            24960,
            26340,
            27120,
            28440,
            30360,
            31920,
            33900,
            35280,
            37020,
            39000,
            41280,
            43260,
            45180,
            47400,
            49500,
            51420,
            53520,
            55860,
            57960,
            59460,
            60660,
            61440,
            63240,
            65160,
            66720,
            68340,
            70140,
            72000,
            73860,
            75960,
            77640,
            79260,
            81420,
            82920,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_74",
      "sourceRouteId": "vilnius_bus_74",
      "mode": "bus",
      "shortName": "74",
      "longName": "Stotis–Subačiaus–Parko g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_74:0",
          "sourceRouteId": "vilnius_bus_74",
          "sourceShapeId": "vilnius_bus_74_a-b",
          "directionId": 0,
          "headsign": "Parko g.",
          "directionName": "Stotis–Subačiaus–Parko g.",
          "mode": "bus",
          "routeShortName": "74",
          "routeLongName": "Stotis–Subačiaus–Parko g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              493.148,
              1911.064,
              0
            ],
            [
              476.562,
              1921.386,
              19.536
            ],
            [
              453.967,
              1920.686,
              42.142
            ],
            [
              432.764,
              1925.527,
              63.89
            ],
            [
              422.444,
              1925.716,
              74.212
            ],
            [
              419.803,
              1922.424,
              78.432
            ],
            [
              401.805,
              1926.093,
              96.8
            ],
            [
              397.27,
              1925.063,
              101.451
            ],
            [
              384.004,
              1905.267,
              125.281
            ],
            [
              372.531,
              1877.646,
              155.19
            ],
            [
              344.166,
              1843.654,
              199.462
            ],
            [
              330.657,
              1810.504,
              235.259
            ],
            [
              391.321,
              1670.242,
              388.078
            ],
            [
              477.846,
              1568.468,
              521.661
            ],
            [
              485.021,
              1572.79,
              530.037
            ],
            [
              495.103,
              1594.87,
              554.31
            ],
            [
              502.822,
              1593.615,
              562.13
            ],
            [
              515.619,
              1587.815,
              576.18
            ],
            [
              552.903,
              1580.453,
              614.184
            ],
            [
              580.051,
              1583.295,
              641.481
            ],
            [
              658.651,
              1577.401,
              720.302
            ],
            [
              692.229,
              1579.012,
              753.918
            ],
            [
              741.428,
              1588.128,
              803.955
            ],
            [
              775.609,
              1587.5,
              838.142
            ],
            [
              809.668,
              1580.195,
              872.975
            ],
            [
              847.494,
              1567.254,
              912.954
            ],
            [
              881.41,
              1552.158,
              950.077
            ],
            [
              944.603,
              1515.372,
              1023.197
            ],
            [
              979.224,
              1503.603,
              1059.764
            ],
            [
              987.526,
              1498.997,
              1069.258
            ],
            [
              1015.114,
              1490.696,
              1098.068
            ],
            [
              1169.279,
              1454.457,
              1256.436
            ],
            [
              1174.911,
              1305.179,
              1405.82
            ],
            [
              1219.91,
              1296.555,
              1451.637
            ],
            [
              1270.109,
              1290.062,
              1502.255
            ],
            [
              1288.043,
              1283.051,
              1521.51
            ],
            [
              1461.257,
              1230.864,
              1702.415
            ],
            [
              1535.192,
              1217.248,
              1777.594
            ],
            [
              1586.927,
              1224.082,
              1829.778
            ],
            [
              1634.086,
              1227.66,
              1877.073
            ],
            [
              1673.61,
              1236.945,
              1917.673
            ],
            [
              1721.874,
              1230.483,
              1966.367
            ],
            [
              1775.523,
              1236.165,
              2020.317
            ],
            [
              1885.048,
              1263.072,
              2133.098
            ],
            [
              1894.159,
              1267.356,
              2143.166
            ],
            [
              1963.37,
              1277.199,
              2213.073
            ],
            [
              2043.065,
              1295.752,
              2294.9
            ],
            [
              2056.65,
              1297.725,
              2308.627
            ],
            [
              2074.707,
              1297.388,
              2326.687
            ],
            [
              2084.797,
              1284.954,
              2342.7
            ],
            [
              2093.452,
              1264.754,
              2364.675
            ],
            [
              2097.301,
              1229.059,
              2400.578
            ],
            [
              2095.034,
              1211.289,
              2418.492
            ],
            [
              2084.488,
              1199.24,
              2434.504
            ],
            [
              2081.118,
              1191.51,
              2442.937
            ],
            [
              2085.924,
              1172.496,
              2462.55
            ],
            [
              2161.169,
              1056.427,
              2600.874
            ],
            [
              2179.433,
              1032.707,
              2630.811
            ],
            [
              2187.13,
              1030.337,
              2638.864
            ],
            [
              2200.631,
              993.348,
              2678.24
            ],
            [
              2292.177,
              852.481,
              2846.241
            ],
            [
              2377.645,
              731.764,
              2994.151
            ],
            [
              2411.777,
              694.387,
              3044.767
            ],
            [
              2432.805,
              680.634,
              3069.894
            ],
            [
              2453.583,
              653.527,
              3104.049
            ],
            [
              2501.276,
              617.009,
              3164.117
            ],
            [
              2634.367,
              525.451,
              3325.659
            ],
            [
              2716.164,
              450.439,
              3436.643
            ],
            [
              2739.748,
              435.524,
              3464.549
            ],
            [
              2755.449,
              412.963,
              3492.035
            ],
            [
              2936.644,
              239.224,
              3743.066
            ],
            [
              2983.62,
              199.374,
              3804.668
            ],
            [
              3035.88,
              166.104,
              3866.62
            ],
            [
              3060.52,
              138.92,
              3903.309
            ],
            [
              3266.423,
              -23.054,
              4165.285
            ],
            [
              3339.574,
              -76.762,
              4256.035
            ],
            [
              3415.597,
              -114.94,
              4341.106
            ],
            [
              3440.614,
              -122.094,
              4367.126
            ],
            [
              3506.161,
              -134.47,
              4433.832
            ],
            [
              3501.543,
              -139.949,
              4440.997
            ],
            [
              3709.123,
              -178.405,
              4652.109
            ],
            [
              3851.65,
              -212.29,
              4798.609
            ],
            [
              3930.415,
              -241.623,
              4882.659
            ],
            [
              4021.131,
              -286.771,
              4983.989
            ],
            [
              4084.273,
              -323.602,
              5057.087
            ],
            [
              4231.381,
              -421.043,
              5233.54
            ],
            [
              4243.975,
              -436.869,
              5253.766
            ],
            [
              4278.232,
              -466.47,
              5299.04
            ],
            [
              4369.718,
              -538.359,
              5415.391
            ],
            [
              4422.518,
              -576.109,
              5480.299
            ],
            [
              4472.265,
              -604.896,
              5537.774
            ],
            [
              4515.715,
              -625.769,
              5585.978
            ],
            [
              4558.025,
              -638.827,
              5630.257
            ],
            [
              4617.783,
              -649.996,
              5691.049
            ],
            [
              4673.822,
              -653.3,
              5747.186
            ],
            [
              4754.55,
              -647.061,
              5828.155
            ],
            [
              4785.642,
              -639.867,
              5860.068
            ],
            [
              4844.087,
              -618.728,
              5922.219
            ],
            [
              5036.703,
              -528.931,
              6134.738
            ],
            [
              5111.461,
              -498.092,
              6215.607
            ],
            [
              5156.243,
              -483.372,
              6262.746
            ],
            [
              5224.275,
              -466.876,
              6332.75
            ],
            [
              5273.441,
              -458.923,
              6382.555
            ],
            [
              5284.486,
              -454.683,
              6394.386
            ],
            [
              5327.098,
              -452.169,
              6437.071
            ],
            [
              5348.35,
              -453.695,
              6458.378
            ],
            [
              5548.153,
              -426.402,
              6660.036
            ],
            [
              5629.574,
              -417.965,
              6741.894
            ],
            [
              5749.654,
              -411.396,
              6862.153
            ],
            [
              5806.942,
              -416.966,
              6919.711
            ],
            [
              5963.202,
              -440.053,
              7077.668
            ],
            [
              5998.528,
              -447.422,
              7113.754
            ],
            [
              6073.561,
              -468.928,
              7191.808
            ],
            [
              6189.436,
              -512.386,
              7315.565
            ],
            [
              6360.739,
              -590.332,
              7503.767
            ],
            [
              6402.87,
              -612.311,
              7551.286
            ],
            [
              6557.754,
              -672.13,
              7717.321
            ],
            [
              6602.659,
              -684.146,
              7763.806
            ],
            [
              6682.351,
              -697.96,
              7844.686
            ],
            [
              6780.934,
              -702.128,
              7943.357
            ],
            [
              6864.177,
              -699.316,
              8026.648
            ],
            [
              6937.971,
              -685.187,
              8101.783
            ],
            [
              7035.236,
              -658.162,
              8202.732
            ],
            [
              7126.343,
              -616.546,
              8302.893
            ],
            [
              7192.221,
              -578.885,
              8378.777
            ],
            [
              7263.567,
              -525.747,
              8467.737
            ],
            [
              7363.253,
              -442,
              8597.932
            ],
            [
              7412.953,
              -407.361,
              8658.512
            ],
            [
              7461.255,
              -378.261,
              8714.902
            ],
            [
              7507.446,
              -358.026,
              8765.332
            ],
            [
              7566.531,
              -338.048,
              8827.703
            ],
            [
              7666.431,
              -308.863,
              8931.778
            ],
            [
              7747.458,
              -288.21,
              9015.397
            ],
            [
              7874.837,
              -271.823,
              9143.825
            ],
            [
              7914.141,
              -273.721,
              9183.174
            ],
            [
              7971.362,
              -282.656,
              9241.089
            ],
            [
              8031.717,
              -296.108,
              9302.925
            ],
            [
              8097.029,
              -319.679,
              9372.36
            ],
            [
              8139.799,
              -341.687,
              9420.461
            ],
            [
              8190.705,
              -376.104,
              9481.909
            ],
            [
              8213.534,
              -395.487,
              9511.857
            ],
            [
              8367.171,
              -581.146,
              9752.842
            ],
            [
              8434.632,
              -625.918,
              9833.807
            ],
            [
              8481.22,
              -650.233,
              9886.359
            ],
            [
              8531.721,
              -672.4,
              9941.511
            ],
            [
              8539.64,
              -631.367,
              9983.301
            ],
            [
              8559.188,
              -557.169,
              10060.03
            ],
            [
              8576.654,
              -426.152,
              10192.207
            ],
            [
              8584.228,
              -306.068,
              10312.529
            ],
            [
              8588.332,
              -198.161,
              10420.514
            ],
            [
              8595.54,
              -160.454,
              10458.904
            ],
            [
              8696.05,
              -133.53,
              10562.958
            ],
            [
              8718.239,
              -120.617,
              10588.631
            ],
            [
              8744.049,
              -120.024,
              10614.448
            ],
            [
              8789.403,
              -109.804,
              10660.939
            ],
            [
              8826.443,
              -96.078,
              10700.44
            ],
            [
              8853.145,
              -83.257,
              10730.061
            ],
            [
              8900.484,
              -38.566,
              10795.163
            ],
            [
              8997.947,
              60.777,
              10934.332
            ],
            [
              9045.087,
              95.45,
              10992.85
            ],
            [
              9064.009,
              106.201,
              11014.613
            ],
            [
              9090.691,
              117.908,
              11043.75
            ],
            [
              9116.151,
              132.979,
              11073.336
            ],
            [
              9141.918,
              131.345,
              11099.155
            ],
            [
              9732.975,
              142.732,
              11690.322
            ],
            [
              9774.103,
              135.215,
              11732.131
            ],
            [
              9799.87,
              133.577,
              11757.95
            ],
            [
              9819.925,
              136.508,
              11778.218
            ],
            [
              9849.832,
              148.145,
              11810.31
            ],
            [
              9862.037,
              145.67,
              11822.763
            ],
            [
              9870.147,
              132.145,
              11838.533
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4267",
              "position": {
                "x": 372.531,
                "z": 1877.646
              },
              "distanceAlongShapeM": 155.19,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 641.481,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 1059.764,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5360",
              "position": {
                "x": 1270.109,
                "z": 1290.062
              },
              "distanceAlongShapeM": 1502.255,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5362",
              "position": {
                "x": 1673.61,
                "z": 1236.945
              },
              "distanceAlongShapeM": 1917.673,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:1123",
              "position": {
                "x": 2093.452,
                "z": 1264.754
              },
              "distanceAlongShapeM": 2364.675,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:356",
              "position": {
                "x": 2187.13,
                "z": 1030.337
              },
              "distanceAlongShapeM": 2638.864,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:931",
              "position": {
                "x": 2432.805,
                "z": 680.634
              },
              "distanceAlongShapeM": 3069.894,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:387",
              "position": {
                "x": 2739.748,
                "z": 435.524
              },
              "distanceAlongShapeM": 3464.549,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5372",
              "position": {
                "x": 3035.88,
                "z": 166.104
              },
              "distanceAlongShapeM": 3866.62,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5373",
              "position": {
                "x": 3506.161,
                "z": -134.47
              },
              "distanceAlongShapeM": 4433.832,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7587",
              "position": {
                "x": 4231.381,
                "z": -421.043
              },
              "distanceAlongShapeM": 5233.54,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6719",
              "position": {
                "x": 5284.486,
                "z": -454.683
              },
              "distanceAlongShapeM": 6394.386,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6721",
              "position": {
                "x": 5749.654,
                "z": -411.396
              },
              "distanceAlongShapeM": 6862.153,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6724",
              "position": {
                "x": 6496.953,
                "z": -648.669
              },
              "distanceAlongShapeM": 7652.15,
              "shapeOffsetM": 0.021,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6727",
              "position": {
                "x": 7874.837,
                "z": -271.823
              },
              "distanceAlongShapeM": 9143.825,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6225",
              "position": {
                "x": 8539.64,
                "z": -631.367
              },
              "distanceAlongShapeM": 9983.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 10588.631,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 11073.336,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 11510.235,
              "shapeOffsetM": 0.663,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7444",
              "position": {
                "x": 9732.975,
                "z": 142.732
              },
              "distanceAlongShapeM": 11690.322,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            18900,
            20280,
            21060,
            21780,
            22380,
            23220,
            24060,
            24900,
            25680,
            26460,
            27120,
            27960,
            28680,
            29580,
            30420,
            31260,
            31980,
            33420,
            35220,
            37260,
            38520,
            40440,
            42000,
            43380,
            45060,
            46620,
            47940,
            49680,
            51240,
            52500,
            54600,
            55260,
            56040,
            56880,
            57720,
            58500,
            59400,
            60180,
            61080,
            62040,
            63000,
            63780,
            64560,
            65340,
            66180,
            68160,
            70020,
            72780,
            74760,
            76500,
            77700,
            79260,
            80760,
            82020
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_74:1",
          "sourceRouteId": "vilnius_bus_74",
          "sourceShapeId": "vilnius_bus_74_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Parko–Subačiaus g.–Stotis",
          "mode": "bus",
          "routeShortName": "74",
          "routeLongName": "Stotis–Subačiaus–Parko g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9870.147,
              132.145,
              0
            ],
            [
              9862.137,
              118.949,
              15.437
            ],
            [
              9810.14,
              131.141,
              68.844
            ],
            [
              9748.867,
              131.276,
              130.117
            ],
            [
              9682.346,
              127.063,
              196.772
            ],
            [
              9621.808,
              131.634,
              257.482
            ],
            [
              9517.36,
              133.756,
              361.952
            ],
            [
              9448.882,
              128.466,
              430.634
            ],
            [
              9389.611,
              131.895,
              490.004
            ],
            [
              9156.08,
              129.945,
              723.543
            ],
            [
              9090.691,
              117.908,
              790.031
            ],
            [
              9073.545,
              99.328,
              815.313
            ],
            [
              9049.578,
              94.246,
              839.813
            ],
            [
              8990.008,
              50.917,
              913.474
            ],
            [
              8869.532,
              -70.228,
              1084.327
            ],
            [
              8853.145,
              -83.257,
              1105.262
            ],
            [
              8819.883,
              -101.512,
              1143.204
            ],
            [
              8767.948,
              -118.279,
              1197.778
            ],
            [
              8695.316,
              -137.969,
              1273.032
            ],
            [
              8673.105,
              -151.995,
              1299.301
            ],
            [
              8624.063,
              -153.235,
              1348.359
            ],
            [
              8595.54,
              -160.454,
              1377.782
            ],
            [
              8590.933,
              -197.1,
              1414.716
            ],
            [
              8584.694,
              -314.984,
              1532.765
            ],
            [
              8567.281,
              -539.519,
              1757.974
            ],
            [
              8554.112,
              -617.185,
              1836.749
            ],
            [
              8531.721,
              -672.4,
              1896.331
            ],
            [
              8486.109,
              -663.69,
              1942.767
            ],
            [
              8367.171,
              -581.146,
              2087.542
            ],
            [
              8314.693,
              -528.882,
              2161.606
            ],
            [
              8254.878,
              -456.433,
              2255.556
            ],
            [
              8204.93,
              -406.448,
              2326.219
            ],
            [
              8163.673,
              -373.337,
              2379.12
            ],
            [
              8140.11,
              -358.393,
              2407.023
            ],
            [
              8089.693,
              -331.779,
              2464.033
            ],
            [
              8068.574,
              -323.563,
              2486.693
            ],
            [
              7987.101,
              -301.896,
              2570.999
            ],
            [
              7941.44,
              -295.418,
              2617.117
            ],
            [
              7927.813,
              -299.599,
              2631.371
            ],
            [
              7910.517,
              -293.688,
              2649.649
            ],
            [
              7877.639,
              -293.032,
              2682.534
            ],
            [
              7803.39,
              -297.118,
              2756.895
            ],
            [
              7662.12,
              -331.043,
              2902.182
            ],
            [
              7525.898,
              -370.639,
              3044.042
            ],
            [
              7481.619,
              -392.025,
              3093.215
            ],
            [
              7422.914,
              -425.371,
              3160.729
            ],
            [
              7391.551,
              -445.901,
              3198.214
            ],
            [
              7274.84,
              -542.67,
              3349.824
            ],
            [
              7223.786,
              -580.623,
              3413.44
            ],
            [
              7148.018,
              -629.221,
              3503.455
            ],
            [
              7093.297,
              -657.084,
              3564.861
            ],
            [
              6995.189,
              -694.109,
              3669.723
            ],
            [
              6921.973,
              -711.59,
              3744.996
            ],
            [
              6856.67,
              -720.321,
              3810.881
            ],
            [
              6795.988,
              -723.577,
              3871.65
            ],
            [
              6712.188,
              -721.926,
              3955.466
            ],
            [
              6649.147,
              -714.005,
              4019.003
            ],
            [
              6571.433,
              -698.004,
              4098.347
            ],
            [
              6523.349,
              -683.7,
              4148.514
            ],
            [
              6449.764,
              -654.422,
              4227.709
            ],
            [
              6436.249,
              -653.044,
              4241.295
            ],
            [
              6365.394,
              -616.028,
              4321.236
            ],
            [
              6247.14,
              -562.5,
              4451.04
            ],
            [
              6102.584,
              -501.78,
              4607.831
            ],
            [
              6033.375,
              -479.275,
              4680.607
            ],
            [
              5958.9,
              -462.234,
              4757.007
            ],
            [
              5902.989,
              -452.237,
              4813.805
            ],
            [
              5819.293,
              -445.038,
              4897.81
            ],
            [
              5710.368,
              -441.803,
              5006.783
            ],
            [
              5691.565,
              -447.003,
              5026.292
            ],
            [
              5642.614,
              -443.824,
              5075.345
            ],
            [
              5383.59,
              -465.511,
              5335.276
            ],
            [
              5245.719,
              -491.784,
              5475.628
            ],
            [
              5168.103,
              -503.64,
              5554.144
            ],
            [
              5099.964,
              -525.701,
              5625.766
            ],
            [
              5024.562,
              -556.529,
              5707.226
            ],
            [
              4957.541,
              -587.519,
              5781.065
            ],
            [
              4906.057,
              -615.47,
              5839.647
            ],
            [
              4828.015,
              -649.59,
              5924.821
            ],
            [
              4765.144,
              -666.191,
              5989.847
            ],
            [
              4704.378,
              -673.927,
              6051.104
            ],
            [
              4650.166,
              -676.224,
              6105.364
            ],
            [
              4614.755,
              -673.316,
              6140.895
            ],
            [
              4552.441,
              -660.985,
              6204.417
            ],
            [
              4508.24,
              -645.664,
              6251.199
            ],
            [
              4426.454,
              -606.243,
              6341.989
            ],
            [
              4266.373,
              -479.602,
              6546.106
            ],
            [
              4205.92,
              -437.254,
              6619.916
            ],
            [
              4102.373,
              -355.119,
              6752.084
            ],
            [
              4073.746,
              -334.533,
              6787.344
            ],
            [
              4021.499,
              -301.251,
              6849.291
            ],
            [
              3924.337,
              -255.979,
              6956.482
            ],
            [
              3871.834,
              -236.053,
              7012.639
            ],
            [
              3794.896,
              -212.322,
              7093.154
            ],
            [
              3748.025,
              -201.41,
              7141.278
            ],
            [
              3692.751,
              -191.452,
              7197.442
            ],
            [
              3533.915,
              -167.282,
              7358.107
            ],
            [
              3462.629,
              -151.456,
              7431.128
            ],
            [
              3392.114,
              -128.967,
              7505.143
            ],
            [
              3396.087,
              -123.476,
              7511.921
            ],
            [
              3343.728,
              -95.766,
              7571.16
            ],
            [
              3282.595,
              -54.531,
              7644.9
            ],
            [
              2977.671,
              191.693,
              8036.826
            ],
            [
              2941.964,
              213.518,
              8078.674
            ],
            [
              2918.591,
              239.564,
              8113.67
            ],
            [
              2733.61,
              417.827,
              8370.565
            ],
            [
              2697.486,
              451.904,
              8420.226
            ],
            [
              2677.062,
              463.42,
              8443.673
            ],
            [
              2656.286,
              490.528,
              8477.827
            ],
            [
              2582.473,
              544.237,
              8569.112
            ],
            [
              2406.492,
              653.296,
              8776.147
            ],
            [
              2359.589,
              697.591,
              8840.66
            ],
            [
              2330.053,
              739.334,
              8891.795
            ],
            [
              2306.383,
              784.307,
              8942.617
            ],
            [
              2285.937,
              829.219,
              8991.965
            ],
            [
              2237.179,
              912.511,
              9088.478
            ],
            [
              2178.144,
              998.221,
              9192.552
            ],
            [
              2116.361,
              1075.075,
              9291.161
            ],
            [
              2107.082,
              1096.4,
              9314.416
            ],
            [
              2088.256,
              1124.583,
              9348.309
            ],
            [
              2063.5,
              1146.196,
              9381.172
            ],
            [
              2049.437,
              1153.138,
              9396.855
            ],
            [
              2015.466,
              1164.904,
              9432.806
            ],
            [
              1965.977,
              1174.732,
              9483.262
            ],
            [
              1928.988,
              1197.686,
              9526.794
            ],
            [
              1911.304,
              1218.054,
              9553.767
            ],
            [
              1889.313,
              1249.634,
              9592.25
            ],
            [
              1817.42,
              1234.273,
              9665.766
            ],
            [
              1745.61,
              1223.362,
              9738.4
            ],
            [
              1634.607,
              1220.971,
              9849.428
            ],
            [
              1600.284,
              1213.815,
              9884.49
            ],
            [
              1535.192,
              1217.248,
              9949.672
            ],
            [
              1461.257,
              1230.864,
              10024.851
            ],
            [
              1250.055,
              1287.093,
              10243.409
            ],
            [
              1216.542,
              1288.825,
              10276.967
            ],
            [
              1174.911,
              1305.179,
              10321.695
            ],
            [
              1169.279,
              1454.457,
              10471.079
            ],
            [
              990.627,
              1492.26,
              10653.687
            ],
            [
              961.104,
              1500.597,
              10684.364
            ],
            [
              886.508,
              1548.725,
              10773.139
            ],
            [
              861.581,
              1561.429,
              10801.117
            ],
            [
              775.609,
              1587.5,
              10890.954
            ],
            [
              769.19,
              1624.355,
              10928.364
            ],
            [
              781.269,
              1649.737,
              10956.474
            ],
            [
              802.898,
              1738.399,
              11047.736
            ],
            [
              825.163,
              1791.425,
              11105.247
            ],
            [
              623.161,
              1858.587,
              11318.12
            ],
            [
              599.379,
              1863.475,
              11342.4
            ],
            [
              535.995,
              1890.241,
              11411.203
            ],
            [
              493.148,
              1911.064,
              11458.842
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 196.772,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 430.634,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 815.313,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 1299.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5400",
              "position": {
                "x": 8486.109,
                "z": -663.69
              },
              "distanceAlongShapeM": 1942.767,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6729",
              "position": {
                "x": 7927.813,
                "z": -299.599
              },
              "distanceAlongShapeM": 2631.371,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6725",
              "position": {
                "x": 6436.249,
                "z": -653.044
              },
              "distanceAlongShapeM": 4241.295,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6722",
              "position": {
                "x": 5691.565,
                "z": -447.003
              },
              "distanceAlongShapeM": 5026.292,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6732",
              "position": {
                "x": 5245.719,
                "z": -491.784
              },
              "distanceAlongShapeM": 5475.628,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5421",
              "position": {
                "x": 4205.92,
                "z": -437.254
              },
              "distanceAlongShapeM": 6619.916,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5423",
              "position": {
                "x": 3392.114,
                "z": -128.967
              },
              "distanceAlongShapeM": 7505.143,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5424",
              "position": {
                "x": 2941.964,
                "z": 213.518
              },
              "distanceAlongShapeM": 8078.674,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5425",
              "position": {
                "x": 2677.062,
                "z": 463.42
              },
              "distanceAlongShapeM": 8443.673,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5925",
              "position": {
                "x": 2116.361,
                "z": 1075.075
              },
              "distanceAlongShapeM": 9291.161,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:946",
              "position": {
                "x": 1600.284,
                "z": 1213.815
              },
              "distanceAlongShapeM": 9884.49,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5428",
              "position": {
                "x": 1216.542,
                "z": 1288.825
              },
              "distanceAlongShapeM": 10276.967,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6714",
              "position": {
                "x": 769.19,
                "z": 1624.355
              },
              "distanceAlongShapeM": 10928.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:8264",
              "position": {
                "x": 493.148,
                "z": 1911.064
              },
              "distanceAlongShapeM": 11458.842,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            }
          ],
          "departuresSeconds": [
            19140,
            19860,
            20460,
            21240,
            22020,
            22860,
            23640,
            24360,
            25080,
            25920,
            26640,
            27540,
            28380,
            29220,
            29940,
            31380,
            33120,
            35160,
            36480,
            38400,
            39900,
            41280,
            42960,
            44520,
            45840,
            47580,
            49140,
            50400,
            52140,
            53160,
            53940,
            54780,
            55620,
            56400,
            57300,
            58080,
            58980,
            59940,
            60900,
            61680,
            62460,
            63240,
            64080,
            65100,
            66060,
            66960,
            67920,
            70800,
            72780,
            74520,
            75720,
            77340,
            78900,
            80100,
            81720,
            83100,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_75",
      "sourceRouteId": "vilnius_bus_75",
      "mode": "bus",
      "shortName": "75",
      "longName": "Santariškės–Visorių g.–Fabijoniškės–Šeškinė–Justiniškės–Pilaitė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_75:0",
          "sourceRouteId": "vilnius_bus_75",
          "sourceShapeId": "vilnius_bus_75_a-b",
          "directionId": 0,
          "headsign": "Pilaitė",
          "directionName": "Santariškės–Visorių g.–Fabijoniškės–Šeškinė–Justiniškės–Pilaitė",
          "mode": "bus",
          "routeShortName": "75",
          "routeLongName": "Santariškės–Visorių g.–Fabijoniškės–Šeškinė–Justiniškės–Pilaitė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              73.695,
              -7563.839,
              0
            ],
            [
              69.345,
              -7590.477,
              26.991
            ],
            [
              45.368,
              -7598.945,
              52.419
            ],
            [
              37.787,
              -7591.014,
              63.391
            ],
            [
              25.801,
              -7471.678,
              183.328
            ],
            [
              8.189,
              -7201.951,
              453.629
            ],
            [
              -2.477,
              -7116.037,
              540.203
            ],
            [
              -15.345,
              -7080.178,
              578.301
            ],
            [
              -10.894,
              -7047.975,
              610.81
            ],
            [
              -21.671,
              -6897.49,
              761.68
            ],
            [
              -33.557,
              -6878.349,
              784.212
            ],
            [
              -59.463,
              -6851.158,
              821.767
            ],
            [
              -67.548,
              -6835.425,
              839.456
            ],
            [
              -70.502,
              -6820.899,
              854.279
            ],
            [
              -64.262,
              -6796.522,
              879.443
            ],
            [
              -53.78,
              -6786.694,
              893.812
            ],
            [
              -43.196,
              -6771.301,
              912.492
            ],
            [
              -44.234,
              -6722.3,
              961.505
            ],
            [
              -50.829,
              -6695.462,
              989.141
            ],
            [
              -48.526,
              -6639.841,
              1044.809
            ],
            [
              -52.099,
              -6588.567,
              1096.208
            ],
            [
              -70.555,
              -6505.85,
              1180.958
            ],
            [
              -125.166,
              -6286.66,
              1406.85
            ],
            [
              -158.525,
              -6137.991,
              1559.215
            ],
            [
              -182.398,
              -6069.649,
              1631.607
            ],
            [
              -186.217,
              -6031.729,
              1669.719
            ],
            [
              -210.448,
              -5912.171,
              1791.707
            ],
            [
              -214.688,
              -5861.998,
              1842.059
            ],
            [
              -215.425,
              -5796.303,
              1907.758
            ],
            [
              -210.007,
              -5746.306,
              1958.048
            ],
            [
              -195.772,
              -5671.978,
              2033.727
            ],
            [
              -200.158,
              -5665.219,
              2041.784
            ],
            [
              -245.834,
              -5662.161,
              2087.563
            ],
            [
              -275.515,
              -5664.961,
              2117.375
            ],
            [
              -299.862,
              -5657.84,
              2142.742
            ],
            [
              -394.957,
              -5644.98,
              2238.703
            ],
            [
              -428.258,
              -5634.356,
              2273.658
            ],
            [
              -633.019,
              -5523.775,
              2506.37
            ],
            [
              -663.705,
              -5510.974,
              2539.62
            ],
            [
              -740.836,
              -5466.163,
              2628.822
            ],
            [
              -765.768,
              -5455.693,
              2655.864
            ],
            [
              -887.614,
              -5390.039,
              2794.273
            ],
            [
              -927.257,
              -5373.739,
              2837.136
            ],
            [
              -988.998,
              -5332.549,
              2911.355
            ],
            [
              -1085.313,
              -5279.606,
              3021.262
            ],
            [
              -1171.043,
              -5246.894,
              3113.021
            ],
            [
              -1178.106,
              -5245.653,
              3120.193
            ],
            [
              -1187.142,
              -5246.604,
              3129.278
            ],
            [
              -1250.872,
              -5423.576,
              3317.376
            ],
            [
              -1257.227,
              -5454.633,
              3349.076
            ],
            [
              -1255.691,
              -5512.549,
              3407.012
            ],
            [
              -1287.303,
              -5515.321,
              3438.745
            ],
            [
              -1342.216,
              -5524.354,
              3494.397
            ],
            [
              -1438.174,
              -5559.37,
              3596.544
            ],
            [
              -1444.089,
              -5565.944,
              3605.387
            ],
            [
              -1477.108,
              -5575.371,
              3639.725
            ],
            [
              -1554.915,
              -5604.036,
              3722.645
            ],
            [
              -1589.241,
              -5614.554,
              3758.546
            ],
            [
              -1589.985,
              -5620.107,
              3764.149
            ],
            [
              -1593.888,
              -5622.263,
              3768.608
            ],
            [
              -1597.732,
              -5621.081,
              3772.629
            ],
            [
              -1600.268,
              -5618.809,
              3776.034
            ],
            [
              -1601.94,
              -5604.307,
              3790.632
            ],
            [
              -1683.803,
              -5391.33,
              4018.8
            ],
            [
              -1721.215,
              -5286.018,
              4130.56
            ],
            [
              -1734.269,
              -5223.444,
              4194.481
            ],
            [
              -1744.096,
              -5196.552,
              4223.113
            ],
            [
              -1762.78,
              -5160.595,
              4263.634
            ],
            [
              -1787.18,
              -5120.083,
              4310.927
            ],
            [
              -1783.781,
              -5110.125,
              4321.449
            ],
            [
              -1777.866,
              -5103.551,
              4330.292
            ],
            [
              -1755.713,
              -5089.474,
              4356.54
            ],
            [
              -1730.884,
              -5069.879,
              4388.169
            ],
            [
              -1682.819,
              -5011.736,
              4463.607
            ],
            [
              -1672.861,
              -4995.216,
              4482.896
            ],
            [
              -1662.744,
              -4969.792,
              4510.259
            ],
            [
              -1657.878,
              -4949.841,
              4530.795
            ],
            [
              -1638.506,
              -4911.224,
              4573.999
            ],
            [
              -1626.337,
              -4879.158,
              4608.296
            ],
            [
              -1604.435,
              -4807.19,
              4683.523
            ],
            [
              -1592.551,
              -4755.08,
              4736.971
            ],
            [
              -1586.265,
              -4691.738,
              4800.624
            ],
            [
              -1583.358,
              -4637.242,
              4855.197
            ],
            [
              -1588.338,
              -4591.511,
              4901.199
            ],
            [
              -1597.362,
              -4555.726,
              4938.104
            ],
            [
              -1598.126,
              -4562.392,
              4944.814
            ],
            [
              -1595.437,
              -4520.137,
              4987.154
            ],
            [
              -1616.287,
              -4244.797,
              5263.282
            ],
            [
              -1631.856,
              -4106.478,
              5402.474
            ],
            [
              -1640.178,
              -4067.366,
              5442.462
            ],
            [
              -1637.064,
              -4037.365,
              5472.624
            ],
            [
              -1635.048,
              -3960.588,
              5549.428
            ],
            [
              -1628.98,
              -3909.488,
              5600.887
            ],
            [
              -1612.999,
              -3808.47,
              5703.161
            ],
            [
              -1543.192,
              -3688.376,
              5842.069
            ],
            [
              -1515.42,
              -3648.796,
              5890.421
            ],
            [
              -1479.438,
              -3582.647,
              5965.723
            ],
            [
              -1461.972,
              -3542.883,
              6009.154
            ],
            [
              -1437.625,
              -3478.752,
              6077.751
            ],
            [
              -1385.229,
              -3323.838,
              6241.286
            ],
            [
              -1372.596,
              -3266.177,
              6300.315
            ],
            [
              -1373.246,
              -3230.542,
              6335.956
            ],
            [
              -1363.568,
              -3193.979,
              6373.778
            ],
            [
              -1359.808,
              -3163.989,
              6404.003
            ],
            [
              -1360.179,
              -3112.774,
              6455.219
            ],
            [
              -1362.723,
              -3074.878,
              6493.2
            ],
            [
              -1447.826,
              -3076.694,
              6578.322
            ],
            [
              -1522.501,
              -3072.018,
              6653.144
            ],
            [
              -1600.963,
              -3062.822,
              6732.143
            ],
            [
              -1631.244,
              -3062.281,
              6762.428
            ],
            [
              -1661.95,
              -3049.487,
              6795.693
            ],
            [
              -1775.996,
              -3011.829,
              6915.795
            ],
            [
              -1790.725,
              -3042.737,
              6950.034
            ],
            [
              -1806.584,
              -3064.719,
              6977.139
            ],
            [
              -1829.59,
              -3089.913,
              7011.257
            ],
            [
              -1853.041,
              -3103.967,
              7038.597
            ],
            [
              -1875.789,
              -3114.694,
              7063.747
            ],
            [
              -1903.67,
              -3124.217,
              7093.21
            ],
            [
              -1932.077,
              -3127.051,
              7121.758
            ],
            [
              -2119.439,
              -3117.041,
              7309.386
            ],
            [
              -2201.28,
              -3116.702,
              7391.228
            ],
            [
              -2258.422,
              -3104.556,
              7449.647
            ],
            [
              -2286.96,
              -3078.446,
              7488.327
            ],
            [
              -2300.838,
              -3061.502,
              7510.229
            ],
            [
              -2310.167,
              -3042.412,
              7531.477
            ],
            [
              -2315.611,
              -3022.278,
              7552.334
            ],
            [
              -2313.79,
              -2992.253,
              7582.414
            ],
            [
              -2304.843,
              -2960.128,
              7615.762
            ],
            [
              -2272.642,
              -2925.075,
              7663.36
            ],
            [
              -2238.843,
              -2908.976,
              7700.797
            ],
            [
              -2253.813,
              -2880.88,
              7732.632
            ],
            [
              -2299.624,
              -2811.049,
              7816.15
            ],
            [
              -2361.565,
              -2742.045,
              7908.875
            ],
            [
              -2438.543,
              -2685.023,
              8004.673
            ],
            [
              -2496.606,
              -2651.713,
              8071.613
            ],
            [
              -2552.25,
              -2627.352,
              8132.355
            ],
            [
              -2587.598,
              -2694.635,
              8208.358
            ],
            [
              -2667.366,
              -2795.644,
              8337.066
            ],
            [
              -2878.335,
              -2954.459,
              8601.13
            ],
            [
              -2942.823,
              -2993.401,
              8676.464
            ],
            [
              -2993.467,
              -3014.776,
              8731.435
            ],
            [
              -3056.314,
              -3033.711,
              8797.072
            ],
            [
              -3148.249,
              -3057.702,
              8892.086
            ],
            [
              -3175.503,
              -3068.357,
              8921.349
            ],
            [
              -3258.301,
              -3085.832,
              9005.97
            ],
            [
              -3322.825,
              -3090.269,
              9070.646
            ],
            [
              -3543.885,
              -3090.861,
              9291.708
            ],
            [
              -3642.787,
              -3108.062,
              9392.094
            ],
            [
              -3706.235,
              -3124.768,
              9457.704
            ],
            [
              -3740.623,
              -3064.057,
              9527.479
            ],
            [
              -3746.718,
              -3043.913,
              9548.525
            ],
            [
              -3749.61,
              -3024.938,
              9567.719
            ],
            [
              -3794.804,
              -2918.397,
              9683.449
            ],
            [
              -3982.054,
              -2455.389,
              10182.887
            ],
            [
              -4002.758,
              -2422.747,
              10221.542
            ],
            [
              -4007.392,
              -2392.61,
              10252.033
            ],
            [
              -4034.259,
              -2306.427,
              10342.306
            ],
            [
              -4048.116,
              -2250.527,
              10399.899
            ],
            [
              -4058.635,
              -2188.005,
              10463.3
            ],
            [
              -4065.192,
              -2119.986,
              10531.634
            ],
            [
              -4071.681,
              -2010.779,
              10641.034
            ],
            [
              -4063.29,
              -1898.49,
              10753.636
            ],
            [
              -4045.475,
              -1837.572,
              10817.105
            ],
            [
              -4006.94,
              -1771.447,
              10893.639
            ],
            [
              -3981.93,
              -1741.824,
              10932.408
            ],
            [
              -3941.981,
              -1705.781,
              10986.213
            ],
            [
              -3883.226,
              -1663.385,
              11058.667
            ],
            [
              -3846.769,
              -1642.867,
              11100.502
            ],
            [
              -3813.688,
              -1631.196,
              11135.581
            ],
            [
              -3809.119,
              -1627.936,
              11141.194
            ],
            [
              -3761.37,
              -1625.426,
              11189.009
            ],
            [
              -3487.628,
              -1602.363,
              11463.72
            ],
            [
              -3508.003,
              -1550.799,
              11519.163
            ],
            [
              -3525.544,
              -1521.55,
              11553.269
            ],
            [
              -3534.455,
              -1477.979,
              11597.741
            ],
            [
              -3626.266,
              -1196.964,
              11893.374
            ],
            [
              -3688.025,
              -1189.21,
              11955.618
            ],
            [
              -3714.785,
              -1170.933,
              11988.025
            ],
            [
              -3768.733,
              -1158.863,
              12043.306
            ],
            [
              -3858.305,
              -1156.194,
              12132.918
            ],
            [
              -4237.967,
              -1188.581,
              12513.959
            ],
            [
              -4268.356,
              -1193.623,
              12544.763
            ],
            [
              -4294.993,
              -1205.408,
              12573.891
            ],
            [
              -4333.704,
              -1206.966,
              12612.633
            ],
            [
              -4364.15,
              -1215.347,
              12644.212
            ],
            [
              -4597.068,
              -1300.392,
              12892.17
            ],
            [
              -4637.998,
              -1318.612,
              12936.972
            ],
            [
              -4714.189,
              -1362.945,
              13025.123
            ],
            [
              -4755.992,
              -1394.51,
              13077.504
            ],
            [
              -4809.036,
              -1442.581,
              13149.09
            ],
            [
              -4834.84,
              -1481.101,
              13195.454
            ],
            [
              -5089.015,
              -1792.899,
              13597.727
            ],
            [
              -5145.804,
              -1834.231,
              13667.964
            ],
            [
              -5350.813,
              -1948.734,
              13902.782
            ],
            [
              -5768.874,
              -2159.819,
              14371.11
            ],
            [
              -5758.969,
              -2298.023,
              14509.669
            ],
            [
              -5764.309,
              -2346.913,
              14558.85
            ],
            [
              -5743.082,
              -2349.5,
              14580.234
            ],
            [
              -5699.018,
              -2373.624,
              14630.47
            ],
            [
              -5700.051,
              -1978.421,
              15025.675
            ],
            [
              -5728.848,
              -1889.99,
              15118.677
            ],
            [
              -5825.26,
              -1949.582,
              15232.02
            ],
            [
              -5930.998,
              -1988.982,
              15344.859
            ],
            [
              -6228.224,
              -1992.872,
              15642.111
            ],
            [
              -6278.639,
              -2000.929,
              15693.165
            ],
            [
              -6312.718,
              -1995.903,
              15727.613
            ],
            [
              -6605.358,
              -1995.443,
              16020.253
            ],
            [
              -6631.209,
              -1999.462,
              16046.415
            ],
            [
              -6677.514,
              -1993.121,
              16093.152
            ],
            [
              -6680.925,
              -1734.803,
              16351.492
            ],
            [
              -6684.251,
              -1702.465,
              16384.001
            ],
            [
              -6705.09,
              -1676.513,
              16417.285
            ],
            [
              -6747.127,
              -1568.943,
              16532.776
            ],
            [
              -6771.666,
              -1532.911,
              16576.371
            ],
            [
              -6834.733,
              -1410.519,
              16714.056
            ],
            [
              -6863.711,
              -1369.96,
              16763.903
            ],
            [
              -6868.44,
              -1344.278,
              16790.017
            ],
            [
              -6866.432,
              -1339.858,
              16794.871
            ],
            [
              -6856.69,
              -1335.568,
              16805.516
            ],
            [
              -6848.367,
              -1339.047,
              16814.536
            ],
            [
              -6837.763,
              -1360.375,
              16838.355
            ],
            [
              -6825.084,
              -1411.793,
              16891.313
            ],
            [
              -6801.411,
              -1461.169,
              16946.071
            ],
            [
              -6771.957,
              -1511.755,
              17004.607
            ],
            [
              -6765.128,
              -1527.454,
              17021.727
            ],
            [
              -6769.807,
              -1537.394,
              17032.713
            ],
            [
              -6777.653,
              -1543.942,
              17042.932
            ],
            [
              -6839.38,
              -1572.967,
              17111.143
            ],
            [
              -6855.566,
              -1577.15,
              17127.861
            ],
            [
              -6863.189,
              -1570.343,
              17138.08
            ],
            [
              -6866.907,
              -1561.375,
              17147.788
            ],
            [
              -6864.843,
              -1553.618,
              17155.815
            ],
            [
              -6804.479,
              -1529.023,
              17220.998
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 183.328,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 578.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 989.141,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 1631.607,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 2117.375,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 2539.62,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5822",
              "position": {
                "x": -927.257,
                "z": -5373.739
              },
              "distanceAlongShapeM": 2837.136,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:17872",
              "position": {
                "x": -1444.089,
                "z": -5565.944
              },
              "distanceAlongShapeM": 3605.387,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5813",
              "position": {
                "x": -1657.878,
                "z": -4949.841
              },
              "distanceAlongShapeM": 4530.795,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6917",
              "position": {
                "x": -1597.362,
                "z": -4555.726
              },
              "distanceAlongShapeM": 4938.104,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6921",
              "position": {
                "x": -1640.178,
                "z": -4067.366
              },
              "distanceAlongShapeM": 5442.462,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6924",
              "position": {
                "x": -1612.999,
                "z": -3808.47
              },
              "distanceAlongShapeM": 5703.161,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6928",
              "position": {
                "x": -1373.246,
                "z": -3230.542
              },
              "distanceAlongShapeM": 6335.956,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6941",
              "position": {
                "x": -1631.244,
                "z": -3062.281
              },
              "distanceAlongShapeM": 6762.428,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:733",
              "position": {
                "x": -2258.422,
                "z": -3104.556
              },
              "distanceAlongShapeM": 7449.647,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:393",
              "position": {
                "x": -2667.366,
                "z": -2795.644
              },
              "distanceAlongShapeM": 8337.066,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5137",
              "position": {
                "x": -3175.503,
                "z": -3068.357
              },
              "distanceAlongShapeM": 8921.349,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6580",
              "position": {
                "x": -3740.623,
                "z": -3064.057
              },
              "distanceAlongShapeM": 9527.479,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6581",
              "position": {
                "x": -4002.758,
                "z": -2422.747
              },
              "distanceAlongShapeM": 10221.542,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6588",
              "position": {
                "x": -4045.475,
                "z": -1837.572
              },
              "distanceAlongShapeM": 10817.105,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6591",
              "position": {
                "x": -3809.119,
                "z": -1627.936
              },
              "distanceAlongShapeM": 11141.194,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 11553.269,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:4991",
              "position": {
                "x": -3688.025,
                "z": -1189.21
              },
              "distanceAlongShapeM": 11955.618,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:4988",
              "position": {
                "x": -4294.993,
                "z": -1205.408
              },
              "distanceAlongShapeM": 12573.891,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:8060",
              "position": {
                "x": -4834.84,
                "z": -1481.101
              },
              "distanceAlongShapeM": 13195.454,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:17769",
              "position": {
                "x": -5758.969,
                "z": -2298.023
              },
              "distanceAlongShapeM": 14509.669,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:6619",
              "position": {
                "x": -5825.26,
                "z": -1949.582
              },
              "distanceAlongShapeM": 15232.02,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:6614",
              "position": {
                "x": -6278.639,
                "z": -2000.929
              },
              "distanceAlongShapeM": 15693.165,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:6612",
              "position": {
                "x": -6631.209,
                "z": -1999.462
              },
              "distanceAlongShapeM": 16046.415,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 16417.285,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 16763.903,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3420,
              "departureOffsetSeconds": 3420
            }
          ],
          "departuresSeconds": [
            18960,
            21120,
            22560,
            24240,
            25680,
            27060,
            28860,
            30780,
            32580,
            34440,
            37260,
            39540,
            41820,
            44940,
            47580,
            49920,
            53160,
            56160,
            57240,
            58740,
            60000,
            61260,
            64800,
            66000,
            67320,
            68700,
            71880,
            74940,
            77760,
            79740,
            82560
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_75:1",
          "sourceRouteId": "vilnius_bus_75",
          "sourceShapeId": "vilnius_bus_75_b-a",
          "directionId": 1,
          "headsign": "Santariškės",
          "directionName": "Pilaitė–Justiniškės–Šeškinė–Fabijoniškės–Visorių g.–Santariškės",
          "mode": "bus",
          "routeShortName": "75",
          "routeLongName": "Santariškės–Visorių g.–Fabijoniškės–Šeškinė–Justiniškės–Pilaitė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6804.479,
              -1529.023,
              0
            ],
            [
              -6810.019,
              -1513.345,
              16.627
            ],
            [
              -6803.426,
              -1504.55,
              27.62
            ],
            [
              -6797.569,
              -1501.308,
              34.313
            ],
            [
              -6795.561,
              -1496.889,
              39.167
            ],
            [
              -6804.801,
              -1471.131,
              66.532
            ],
            [
              -6817.871,
              -1443.083,
              97.476
            ],
            [
              -6849.755,
              -1383.551,
              165.008
            ],
            [
              -6863.711,
              -1369.96,
              184.489
            ],
            [
              -6868.44,
              -1344.278,
              210.603
            ],
            [
              -6866.432,
              -1339.858,
              215.457
            ],
            [
              -6856.69,
              -1335.568,
              226.102
            ],
            [
              -6848.367,
              -1339.047,
              235.122
            ],
            [
              -6837.763,
              -1360.375,
              258.94
            ],
            [
              -6823.318,
              -1421.841,
              322.082
            ],
            [
              -6723.821,
              -1601.615,
              527.553
            ],
            [
              -6711.23,
              -1619.637,
              549.537
            ],
            [
              -6684.251,
              -1702.465,
              636.648
            ],
            [
              -6676.395,
              -1733.766,
              668.92
            ],
            [
              -6677.514,
              -1993.121,
              928.277
            ],
            [
              -6624.485,
              -1982.877,
              982.286
            ],
            [
              -6584.624,
              -1989.111,
              1022.631
            ],
            [
              -6371.248,
              -1988.24,
              1236.01
            ],
            [
              -6349.244,
              -1983.044,
              1258.619
            ],
            [
              -6317.742,
              -1988.026,
              1290.512
            ],
            [
              -6227.58,
              -1992.883,
              1380.805
            ],
            [
              -5930.998,
              -1988.982,
              1677.413
            ],
            [
              -5876.852,
              -1950.936,
              1743.589
            ],
            [
              -5858.789,
              -1950.128,
              1761.67
            ],
            [
              -5698.314,
              -1876.036,
              1938.424
            ],
            [
              -5670.434,
              -1866.49,
              1967.893
            ],
            [
              -5643.33,
              -1864.723,
              1995.055
            ],
            [
              -5613.098,
              -1868.576,
              2025.531
            ],
            [
              -5587.453,
              -1876.804,
              2052.464
            ],
            [
              -5564.291,
              -1879.423,
              2075.773
            ],
            [
              -5542.342,
              -1877.57,
              2097.8
            ],
            [
              -5509.95,
              -1868.102,
              2131.548
            ],
            [
              -5409.021,
              -1770.744,
              2271.78
            ],
            [
              -5308.183,
              -1678.952,
              2408.14
            ],
            [
              -5285.361,
              -1663.756,
              2435.558
            ],
            [
              -5276.945,
              -1661.673,
              2444.228
            ],
            [
              -5229.899,
              -1662.476,
              2491.281
            ],
            [
              -5012.864,
              -1637.24,
              2709.779
            ],
            [
              -4867.118,
              -1446.038,
              2950.195
            ],
            [
              -4763.191,
              -1363.217,
              3083.086
            ],
            [
              -4704.97,
              -1314.122,
              3159.244
            ],
            [
              -4653.804,
              -1300.53,
              3212.184
            ],
            [
              -4405.208,
              -1203.507,
              3479.043
            ],
            [
              -4296.995,
              -1171.977,
              3591.756
            ],
            [
              -4247.02,
              -1152.802,
              3645.283
            ],
            [
              -4191.003,
              -1157.11,
              3701.466
            ],
            [
              -3912.099,
              -1135.223,
              3981.227
            ],
            [
              -3759.013,
              -1118.956,
              4135.175
            ],
            [
              -3705.284,
              -1106.532,
              4190.322
            ],
            [
              -3657.704,
              -1114.039,
              4238.491
            ],
            [
              -3599.031,
              -1113.947,
              4297.164
            ],
            [
              -3569.469,
              -1193.5,
              4382.032
            ],
            [
              -3554.873,
              -1243.849,
              4434.453
            ],
            [
              -3543.073,
              -1269.659,
              4462.832
            ],
            [
              -3520.478,
              -1415.883,
              4610.792
            ],
            [
              -3500.646,
              -1498.607,
              4695.86
            ],
            [
              -3461.302,
              -1608.388,
              4812.479
            ],
            [
              -3462.063,
              -1615.054,
              4819.188
            ],
            [
              -3466.007,
              -1619.438,
              4825.085
            ],
            [
              -3480.186,
              -1619.191,
              4839.266
            ],
            [
              -3518.951,
              -1624.08,
              4878.339
            ],
            [
              -3542.913,
              -1630.342,
              4903.105
            ],
            [
              -3571.837,
              -1625.385,
              4932.45
            ],
            [
              -3644.74,
              -1628.568,
              5005.423
            ],
            [
              -3721.548,
              -1633.911,
              5082.417
            ],
            [
              -3788.083,
              -1641.66,
              5149.402
            ],
            [
              -3841.2,
              -1656.322,
              5204.505
            ],
            [
              -3882.188,
              -1677.875,
              5250.814
            ],
            [
              -3931.102,
              -1710.422,
              5309.567
            ],
            [
              -3978.977,
              -1757.46,
              5376.684
            ],
            [
              -4022.062,
              -1825.732,
              5457.414
            ],
            [
              -4044.37,
              -1885.459,
              5521.171
            ],
            [
              -4052.817,
              -1926.501,
              5563.073
            ],
            [
              -4053.048,
              -1939.856,
              5576.43
            ],
            [
              -4048.884,
              -1959.966,
              5596.966
            ],
            [
              -4055.493,
              -2006.606,
              5644.073
            ],
            [
              -4046.573,
              -2161.497,
              5799.22
            ],
            [
              -4020.612,
              -2299.985,
              5940.12
            ],
            [
              -3990.129,
              -2400.702,
              6045.349
            ],
            [
              -3964.263,
              -2470.17,
              6119.476
            ],
            [
              -3946.156,
              -2503.88,
              6157.742
            ],
            [
              -3932.856,
              -2517.469,
              6176.756
            ],
            [
              -3932.443,
              -2530.835,
              6190.128
            ],
            [
              -3926.386,
              -2553.204,
              6213.303
            ],
            [
              -3765.67,
              -2947.847,
              6639.417
            ],
            [
              -3698.78,
              -3103.747,
              6809.061
            ],
            [
              -3687.144,
              -3101.723,
              6820.871
            ],
            [
              -3665.065,
              -3092.089,
              6844.961
            ],
            [
              -3645.64,
              -3086.861,
              6865.077
            ],
            [
              -3537.19,
              -3076.506,
              6974.02
            ],
            [
              -3288.387,
              -3074.173,
              7222.835
            ],
            [
              -3226.908,
              -3059.664,
              7286.002
            ],
            [
              -3088.313,
              -3020.904,
              7429.915
            ],
            [
              -3076.618,
              -3015.543,
              7442.78
            ],
            [
              -3065.626,
              -3013.509,
              7453.958
            ],
            [
              -3013.674,
              -2991.043,
              7510.56
            ],
            [
              -2972.908,
              -2981.74,
              7552.374
            ],
            [
              -2923.591,
              -2962.569,
              7605.286
            ],
            [
              -2796.251,
              -2867.959,
              7763.926
            ],
            [
              -2713.249,
              -2802.628,
              7869.555
            ],
            [
              -2678.551,
              -2772.069,
              7915.791
            ],
            [
              -2644.38,
              -2734.822,
              7966.338
            ],
            [
              -2636.314,
              -2716.04,
              7986.779
            ],
            [
              -2600.033,
              -2668.811,
              8046.335
            ],
            [
              -2574.02,
              -2619.176,
              8102.374
            ],
            [
              -2552.25,
              -2627.352,
              8125.629
            ],
            [
              -2471.713,
              -2665.511,
              8214.748
            ],
            [
              -2386.944,
              -2719.332,
              8315.16
            ],
            [
              -2340.637,
              -2761.341,
              8377.682
            ],
            [
              -2270.657,
              -2849.412,
              8490.171
            ],
            [
              -2238.843,
              -2908.976,
              8557.699
            ],
            [
              -2271.353,
              -2925.098,
              8593.988
            ],
            [
              -2292.95,
              -2943.64,
              8622.452
            ],
            [
              -2307.637,
              -2972.324,
              8654.677
            ],
            [
              -2313.343,
              -3003.393,
              8686.266
            ],
            [
              -2311.942,
              -3033.475,
              8716.38
            ],
            [
              -2302.653,
              -3054.791,
              8739.632
            ],
            [
              -2286.96,
              -3078.446,
              8768.02
            ],
            [
              -2258.264,
              -3095.653,
              8801.48
            ],
            [
              -2237.746,
              -3101.583,
              8822.837
            ],
            [
              -2215.841,
              -3101.972,
              8844.746
            ],
            [
              -2074.36,
              -3118.955,
              8987.242
            ],
            [
              -1943.03,
              -3126.856,
              9118.81
            ],
            [
              -1903.67,
              -3124.217,
              9158.258
            ],
            [
              -1868.018,
              -3112.606,
              9195.753
            ],
            [
              -1837.381,
              -3093.114,
              9232.066
            ],
            [
              -1816.447,
              -3075.675,
              9259.311
            ],
            [
              -1775.996,
              -3011.829,
              9334.893
            ],
            [
              -1683.756,
              -3043.532,
              9432.429
            ],
            [
              -1647.191,
              -3053.091,
              9470.222
            ],
            [
              -1571.366,
              -3065.578,
              9547.069
            ],
            [
              -1551.978,
              -3062.585,
              9566.686
            ],
            [
              -1523.75,
              -3069.769,
              9595.815
            ],
            [
              -1491.596,
              -3073.684,
              9628.206
            ],
            [
              -1438.786,
              -3075.742,
              9681.056
            ],
            [
              -1362.723,
              -3074.878,
              9757.125
            ],
            [
              -1357.098,
              -3120.622,
              9803.212
            ],
            [
              -1356.687,
              -3169.611,
              9852.203
            ],
            [
              -1363.762,
              -3240.731,
              9923.674
            ],
            [
              -1372.45,
              -3294.01,
              9977.657
            ],
            [
              -1372.145,
              -3312.94,
              9996.59
            ],
            [
              -1386.916,
              -3346.073,
              10032.866
            ],
            [
              -1441.889,
              -3500.94,
              10197.201
            ],
            [
              -1479.438,
              -3582.647,
              10287.123
            ],
            [
              -1526.789,
              -3671.971,
              10388.221
            ],
            [
              -1572.531,
              -3743.513,
              10473.136
            ],
            [
              -1605.428,
              -3817.511,
              10554.117
            ],
            [
              -1619.047,
              -3858.457,
              10597.269
            ],
            [
              -1621.258,
              -3874.003,
              10612.971
            ],
            [
              -1622.014,
              -3916.292,
              10655.267
            ],
            [
              -1630.122,
              -3937.298,
              10677.784
            ],
            [
              -1635.048,
              -3960.588,
              10701.589
            ],
            [
              -1633.18,
              -4036.321,
              10777.345
            ],
            [
              -1621.037,
              -4150.087,
              10891.757
            ],
            [
              -1612.338,
              -4168.054,
              10911.72
            ],
            [
              -1616.287,
              -4244.797,
              10988.563
            ],
            [
              -1593.127,
              -4499.027,
              11243.846
            ],
            [
              -1582.077,
              -4601.642,
              11347.054
            ],
            [
              -1574.54,
              -4648.532,
              11394.547
            ],
            [
              -1585.129,
              -4736.288,
              11482.939
            ],
            [
              -1597.975,
              -4806.192,
              11554.013
            ],
            [
              -1623.216,
              -4884.78,
              11636.556
            ],
            [
              -1642.847,
              -4937.864,
              11693.153
            ],
            [
              -1696.959,
              -5045.994,
              11814.067
            ],
            [
              -1723.84,
              -5072.231,
              11851.63
            ],
            [
              -1779.253,
              -5109.092,
              11918.184
            ],
            [
              -1785.792,
              -5114.542,
              11926.696
            ],
            [
              -1787.2,
              -5121.196,
              11933.497
            ],
            [
              -1739.044,
              -5202.208,
              12027.741
            ],
            [
              -1721.116,
              -5280.454,
              12108.015
            ],
            [
              -1691.717,
              -5365.585,
              12198.079
            ],
            [
              -1598.761,
              -5606.591,
              12456.39
            ],
            [
              -1589.202,
              -5612.328,
              12467.539
            ],
            [
              -1548.277,
              -5593.022,
              12512.789
            ],
            [
              -1523.689,
              -5586.783,
              12538.156
            ],
            [
              -1421.877,
              -5548.53,
              12646.917
            ],
            [
              -1333.101,
              -5518.952,
              12740.491
            ],
            [
              -1293.722,
              -5514.092,
              12780.169
            ],
            [
              -1258.266,
              -5512.502,
              12815.66
            ],
            [
              -1259.079,
              -5450.147,
              12878.021
            ],
            [
              -1252.12,
              -5421.328,
              12907.668
            ],
            [
              -1201.889,
              -5278.623,
              13058.955
            ],
            [
              -1187.102,
              -5244.378,
              13096.256
            ],
            [
              -1181.246,
              -5241.144,
              13102.946
            ],
            [
              -1067.322,
              -5282.156,
              13224.027
            ],
            [
              -979.178,
              -5323.82,
              13321.522
            ],
            [
              -879.042,
              -5379.061,
              13435.884
            ],
            [
              -826.661,
              -5403.385,
              13493.637
            ],
            [
              -674.33,
              -5492.97,
              13670.358
            ],
            [
              -589.373,
              -5532.358,
              13764.002
            ],
            [
              -565.267,
              -5552.833,
              13795.629
            ],
            [
              -421.759,
              -5631.135,
              13959.11
            ],
            [
              -383.93,
              -5640.727,
              13998.136
            ],
            [
              -342.157,
              -5645.939,
              14040.233
            ],
            [
              -257.182,
              -5648.596,
              14125.249
            ],
            [
              -196.756,
              -5655.261,
              14186.041
            ],
            [
              -180.177,
              -5664.469,
              14205.006
            ],
            [
              -177.18,
              -5676.769,
              14217.666
            ],
            [
              -185.798,
              -5725.595,
              14267.247
            ],
            [
              -185.377,
              -5737.848,
              14279.507
            ],
            [
              -196.91,
              -5769.923,
              14313.592
            ],
            [
              -201.665,
              -5818.819,
              14362.719
            ],
            [
              -201.086,
              -5857.793,
              14401.697
            ],
            [
              -195.599,
              -5910.215,
              14454.405
            ],
            [
              -136.015,
              -6175.138,
              14725.946
            ],
            [
              -122.378,
              -6204.331,
              14758.167
            ],
            [
              -123.468,
              -6228.802,
              14782.663
            ],
            [
              -113.557,
              -6285.758,
              14840.475
            ],
            [
              -58.166,
              -6532.794,
              15093.645
            ],
            [
              -46.468,
              -6597.576,
              15159.474
            ],
            [
              -39.377,
              -6667.839,
              15230.094
            ],
            [
              -35.045,
              -6748.072,
              15310.444
            ],
            [
              -27.041,
              -6768.256,
              15332.157
            ],
            [
              -16.965,
              -6780.686,
              15348.158
            ],
            [
              0.233,
              -6791.019,
              15368.222
            ],
            [
              10.168,
              -6811.238,
              15390.75
            ],
            [
              11.151,
              -6827.955,
              15407.495
            ],
            [
              7.024,
              -6842.352,
              15422.472
            ],
            [
              -10.864,
              -6869.857,
              15455.282
            ],
            [
              -21.671,
              -6897.49,
              15484.954
            ],
            [
              -10.612,
              -6926.637,
              15516.128
            ],
            [
              -9.853,
              -6955.595,
              15545.096
            ],
            [
              6.027,
              -7144.023,
              15734.192
            ],
            [
              16.38,
              -7176.496,
              15768.276
            ],
            [
              9.192,
              -7217.555,
              15809.959
            ],
            [
              48.234,
              -7442.03,
              16037.804
            ],
            [
              37.062,
              -7489.696,
              16086.762
            ],
            [
              41.201,
              -7509.81,
              16107.297
            ],
            [
              62.699,
              -7531.354,
              16137.732
            ],
            [
              73.695,
              -7563.839,
              16172.028
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 258.94,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 549.537,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6611",
              "position": {
                "x": -6624.485,
                "z": -1982.877
              },
              "distanceAlongShapeM": 982.286,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6615",
              "position": {
                "x": -6349.244,
                "z": -1983.044
              },
              "distanceAlongShapeM": 1258.619,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6618",
              "position": {
                "x": -5876.852,
                "z": -1950.936
              },
              "distanceAlongShapeM": 1743.589,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6621",
              "position": {
                "x": -5276.945,
                "z": -1661.673
              },
              "distanceAlongShapeM": 2444.228,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:8934",
              "position": {
                "x": -4704.97,
                "z": -1314.122
              },
              "distanceAlongShapeM": 3159.244,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:4989",
              "position": {
                "x": -4247.02,
                "z": -1152.802
              },
              "distanceAlongShapeM": 3645.283,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 4462.832,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6597",
              "position": {
                "x": -3542.913,
                "z": -1630.342
              },
              "distanceAlongShapeM": 4903.105,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6587",
              "position": {
                "x": -4048.884,
                "z": -1959.966
              },
              "distanceAlongShapeM": 5596.966,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6582",
              "position": {
                "x": -3932.856,
                "z": -2517.469
              },
              "distanceAlongShapeM": 6176.756,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7001",
              "position": {
                "x": -3665.065,
                "z": -3092.089
              },
              "distanceAlongShapeM": 6844.961,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:855",
              "position": {
                "x": -3013.674,
                "z": -2991.043
              },
              "distanceAlongShapeM": 7510.56,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:394",
              "position": {
                "x": -2636.314,
                "z": -2716.04
              },
              "distanceAlongShapeM": 7986.779,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5208",
              "position": {
                "x": -2215.841,
                "z": -3101.972
              },
              "distanceAlongShapeM": 8844.746,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6940",
              "position": {
                "x": -1551.978,
                "z": -3062.585
              },
              "distanceAlongShapeM": 9566.686,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6929",
              "position": {
                "x": -1372.145,
                "z": -3312.94
              },
              "distanceAlongShapeM": 9996.59,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6926",
              "position": {
                "x": -1622.014,
                "z": -3916.292
              },
              "distanceAlongShapeM": 10655.267,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6922",
              "position": {
                "x": -1612.338,
                "z": -4168.054
              },
              "distanceAlongShapeM": 10911.72,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6918",
              "position": {
                "x": -1574.54,
                "z": -4648.532
              },
              "distanceAlongShapeM": 11394.547,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 11814.067,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:17871",
              "position": {
                "x": -1548.277,
                "z": -5593.022
              },
              "distanceAlongShapeM": 12512.789,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 13493.637,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 13764.002,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 14279.507,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 14758.167,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 15516.128,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 15768.276,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:6533",
              "position": {
                "x": 73.695,
                "z": -7563.839
              },
              "distanceAlongShapeM": 16172.028,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            }
          ],
          "departuresSeconds": [
            17880,
            19320,
            22980,
            24720,
            26400,
            28260,
            30360,
            33360,
            35220,
            37380,
            40980,
            43440,
            45840,
            49080,
            51900,
            53220,
            54600,
            55920,
            57120,
            60300,
            61620,
            63060,
            64380,
            67800,
            71160,
            73620,
            76140,
            78660,
            81240
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_76",
      "sourceRouteId": "vilnius_bus_76",
      "mode": "bus",
      "shortName": "76",
      "longName": "Ateities–Balsių g.–Sakališkės–Bireliai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_76:0",
          "sourceRouteId": "vilnius_bus_76",
          "sourceShapeId": "vilnius_bus_76_a-b",
          "directionId": 0,
          "headsign": "Bireliai",
          "directionName": "Ateities–Balsių g.–Sakališkės–Bireliai",
          "mode": "bus",
          "routeShortName": "76",
          "routeLongName": "Ateities–Balsių g.–Sakališkės–Bireliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -835.417,
              -5317.507,
              0
            ],
            [
              -866.829,
              -5344.771,
              41.593
            ],
            [
              -872.825,
              -5355.796,
              54.143
            ],
            [
              -873.83,
              -5375.816,
              74.188
            ],
            [
              -864.956,
              -5383.768,
              86.105
            ],
            [
              -826.661,
              -5403.385,
              129.132
            ],
            [
              -674.33,
              -5492.97,
              305.852
            ],
            [
              -589.373,
              -5532.358,
              399.496
            ],
            [
              -565.267,
              -5552.833,
              431.124
            ],
            [
              -421.759,
              -5631.135,
              594.604
            ],
            [
              -383.93,
              -5640.727,
              633.63
            ],
            [
              -342.157,
              -5645.939,
              675.727
            ],
            [
              -257.182,
              -5648.596,
              760.743
            ],
            [
              -196.756,
              -5655.261,
              821.536
            ],
            [
              -180.177,
              -5664.469,
              840.5
            ],
            [
              -177.18,
              -5676.769,
              853.16
            ],
            [
              -185.798,
              -5725.595,
              902.741
            ],
            [
              -185.377,
              -5737.848,
              915.001
            ],
            [
              -196.91,
              -5769.923,
              949.086
            ],
            [
              -201.665,
              -5818.819,
              998.213
            ],
            [
              -201.086,
              -5857.793,
              1037.191
            ],
            [
              -195.599,
              -5910.215,
              1089.9
            ],
            [
              -136.015,
              -6175.138,
              1361.44
            ],
            [
              -122.378,
              -6204.331,
              1393.661
            ],
            [
              -123.468,
              -6228.802,
              1418.157
            ],
            [
              -113.557,
              -6285.758,
              1475.969
            ],
            [
              -58.166,
              -6532.794,
              1729.139
            ],
            [
              -46.468,
              -6597.576,
              1794.968
            ],
            [
              -39.377,
              -6667.839,
              1865.588
            ],
            [
              -35.045,
              -6748.072,
              1945.938
            ],
            [
              -27.041,
              -6768.256,
              1967.651
            ],
            [
              -16.965,
              -6780.686,
              1983.652
            ],
            [
              320.415,
              -6959.406,
              2365.446
            ],
            [
              487.772,
              -7068.233,
              2565.075
            ],
            [
              568.725,
              -7113.137,
              2657.647
            ],
            [
              607.827,
              -7122.761,
              2697.916
            ],
            [
              857.011,
              -7088.385,
              2949.46
            ],
            [
              911.972,
              -7076.04,
              3005.791
            ],
            [
              964.173,
              -7073.664,
              3058.046
            ],
            [
              999.31,
              -7088.785,
              3096.298
            ],
            [
              1056.317,
              -7139.934,
              3172.889
            ],
            [
              1073.183,
              -7168.077,
              3205.698
            ],
            [
              1095.862,
              -7195.215,
              3241.065
            ],
            [
              1133.283,
              -7225.965,
              3289.5
            ],
            [
              1291.476,
              -7341.333,
              3485.292
            ],
            [
              1307.902,
              -7358.336,
              3508.934
            ],
            [
              1326.737,
              -7384.29,
              3541.002
            ],
            [
              1553.349,
              -7767.005,
              3985.776
            ],
            [
              1621.327,
              -7885.162,
              4122.092
            ],
            [
              1632.975,
              -7916.55,
              4155.571
            ],
            [
              1640.555,
              -7958.994,
              4198.688
            ],
            [
              1640.017,
              -8022.44,
              4262.136
            ],
            [
              1642.406,
              -8067.015,
              4306.774
            ],
            [
              1655.237,
              -8103.991,
              4345.914
            ],
            [
              1677.887,
              -8132.245,
              4382.125
            ],
            [
              1694.973,
              -8148.149,
              4405.467
            ],
            [
              1731.324,
              -8201.149,
              4469.736
            ],
            [
              1750.194,
              -8224.879,
              4500.054
            ],
            [
              1771.12,
              -8241.968,
              4527.071
            ],
            [
              1800.494,
              -8254.762,
              4559.111
            ],
            [
              1956.145,
              -8296.632,
              4720.295
            ],
            [
              2001.461,
              -8317.518,
              4770.193
            ],
            [
              2065.812,
              -8353.233,
              4843.79
            ],
            [
              2107.826,
              -8378.511,
              4892.822
            ],
            [
              2156.129,
              -8411.7,
              4951.428
            ],
            [
              2317.488,
              -8560.563,
              5170.967
            ],
            [
              2642.21,
              -8852.78,
              5607.813
            ],
            [
              2792.271,
              -8984.749,
              5807.648
            ],
            [
              2937.196,
              -9115.513,
              6002.847
            ],
            [
              2992.31,
              -9162.2,
              6075.077
            ],
            [
              3013.269,
              -9177.069,
              6100.774
            ],
            [
              3028.932,
              -9199.631,
              6128.241
            ],
            [
              3134.577,
              -9330.771,
              6296.641
            ],
            [
              3165.86,
              -9378.122,
              6353.392
            ],
            [
              3173.907,
              -9394.973,
              6372.066
            ],
            [
              3208.182,
              -9555.935,
              6536.636
            ],
            [
              3213.698,
              -9570.512,
              6552.222
            ],
            [
              3220.563,
              -9581.775,
              6565.413
            ],
            [
              3233.82,
              -9595.386,
              6584.413
            ],
            [
              3263.762,
              -9611.54,
              6618.434
            ],
            [
              3404.776,
              -9675.449,
              6773.255
            ],
            [
              3447.994,
              -9704.103,
              6825.109
            ],
            [
              3478.945,
              -9734.751,
              6868.666
            ],
            [
              3511.635,
              -9775.451,
              6920.869
            ],
            [
              3546.778,
              -9856.276,
              7009.004
            ],
            [
              3563.744,
              -9877.752,
              7036.373
            ],
            [
              3584.076,
              -9891.498,
              7060.915
            ],
            [
              3684.789,
              -9975.801,
              7192.255
            ],
            [
              3753.117,
              -10037.223,
              7284.132
            ],
            [
              3824.059,
              -10096.468,
              7376.559
            ],
            [
              3850.114,
              -10113.666,
              7407.778
            ],
            [
              3866.759,
              -10151.835,
              7449.419
            ],
            [
              3913.653,
              -10156.072,
              7496.504
            ],
            [
              3939.124,
              -10136.521,
              7528.614
            ],
            [
              3958.891,
              -10112.407,
              7559.794
            ],
            [
              3976.835,
              -10082.692,
              7594.507
            ],
            [
              4005.224,
              -10078.783,
              7623.164
            ],
            [
              4078.021,
              -10074.611,
              7696.08
            ],
            [
              4616.81,
              -10066.046,
              8234.937
            ],
            [
              4852.251,
              -10070.594,
              8470.422
            ],
            [
              4899.81,
              -10073.74,
              8518.085
            ],
            [
              4837.14,
              -10286.278,
              8739.671
            ],
            [
              5053.091,
              -10366.163,
              8969.924
            ],
            [
              5073.204,
              -10357.647,
              8991.766
            ],
            [
              5062.718,
              -10367.463,
              9006.129
            ],
            [
              4895.201,
              -10311.894,
              9182.622
            ],
            [
              4833.28,
              -10286.204,
              9249.661
            ],
            [
              4729.917,
              -10573.66,
              9555.136
            ],
            [
              4715.978,
              -10629.055,
              9612.258
            ],
            [
              4699.103,
              -10669.92,
              9656.47
            ],
            [
              4668.42,
              -10726.105,
              9720.487
            ],
            [
              4649.938,
              -10750.241,
              9750.886
            ],
            [
              4628.284,
              -10772.089,
              9781.647
            ],
            [
              4582.682,
              -10801.268,
              9835.786
            ],
            [
              4522.866,
              -10833.513,
              9903.739
            ],
            [
              4504.193,
              -10834.266,
              9922.428
            ],
            [
              4279.816,
              -10925.69,
              10164.715
            ],
            [
              4292.187,
              -10951.534,
              10193.367
            ],
            [
              4289.98,
              -10965.964,
              10207.965
            ],
            [
              4278.918,
              -10972.431,
              10220.779
            ],
            [
              4432.869,
              -11263.733,
              10550.26
            ],
            [
              4431.004,
              -11260.357,
              10554.116
            ],
            [
              4495.442,
              -11388.513,
              10697.561
            ],
            [
              4506.568,
              -11412.106,
              10723.645
            ],
            [
              4522.451,
              -11455.83,
              10770.165
            ],
            [
              4524.573,
              -11479.25,
              10793.681
            ],
            [
              4514.39,
              -11540.284,
              10855.559
            ],
            [
              4493.832,
              -11638.971,
              10956.364
            ],
            [
              4485.665,
              -11662.192,
              10980.979
            ],
            [
              4441.273,
              -11862.841,
              11186.481
            ],
            [
              4404.772,
              -12054.736,
              11381.817
            ],
            [
              4294.404,
              -12542.458,
              11881.87
            ],
            [
              4282.19,
              -12609.02,
              11949.543
            ],
            [
              4283.669,
              -12632.427,
              11972.997
            ],
            [
              4293.57,
              -12652.657,
              11995.52
            ],
            [
              4318.023,
              -12685.412,
              12036.396
            ],
            [
              4318.473,
              -12695.441,
              12046.434
            ],
            [
              4315.194,
              -12698.717,
              12051.07
            ],
            [
              4302.958,
              -12699.595,
              12063.338
            ],
            [
              4264.491,
              -12693.289,
              12102.319
            ],
            [
              4245.846,
              -12692.931,
              12120.966
            ],
            [
              4229.195,
              -12689.271,
              12138.015
            ],
            [
              4219.68,
              -12682.408,
              12149.747
            ],
            [
              4207.078,
              -12668.807,
              12168.289
            ],
            [
              4191.54,
              -12640.676,
              12200.426
            ],
            [
              4184.489,
              -12639.427,
              12207.586
            ],
            [
              4172.789,
              -12645.882,
              12220.949
            ],
            [
              4135.243,
              -12658.521,
              12260.564
            ],
            [
              4112.805,
              -12654.75,
              12283.317
            ],
            [
              3803.923,
              -12596.508,
              12597.643
            ],
            [
              3507.545,
              -12522.939,
              12903.014
            ],
            [
              3445.499,
              -12505.058,
              12967.586
            ],
            [
              3348.197,
              -12480.94,
              13067.832
            ],
            [
              3325.694,
              -12480.512,
              13090.339
            ],
            [
              3102.513,
              -12785.764,
              13468.477
            ],
            [
              3085.871,
              -12815.507,
              13502.559
            ],
            [
              3081.528,
              -12841.03,
              13528.449
            ],
            [
              3045.505,
              -12909.37,
              13605.702
            ],
            [
              3012.654,
              -12979.997,
              13683.595
            ],
            [
              2975.61,
              -13068.357,
              13779.407
            ],
            [
              2927.302,
              -13174.316,
              13895.859
            ],
            [
              2926.385,
              -13188.772,
              13910.343
            ],
            [
              2803.507,
              -13463.652,
              14211.438
            ],
            [
              2691.801,
              -13726.501,
              14497.039
            ],
            [
              2583.372,
              -13952.676,
              14747.862
            ],
            [
              2569.887,
              -13985.82,
              14783.643
            ],
            [
              2559.617,
              -14019.024,
              14818.4
            ],
            [
              2558.345,
              -14052.398,
              14851.799
            ],
            [
              2561.815,
              -14107.014,
              14906.525
            ],
            [
              2554.192,
              -14170.327,
              14970.295
            ],
            [
              2548.799,
              -14183.585,
              14984.607
            ],
            [
              2527.601,
              -14319.005,
              15121.676
            ],
            [
              2524.288,
              -14392.418,
              15195.165
            ],
            [
              2500.535,
              -14561.189,
              15365.598
            ],
            [
              2487.814,
              -14622.179,
              15427.901
            ],
            [
              2473.57,
              -14729.898,
              15536.558
            ],
            [
              2470.083,
              -14846.726,
              15653.438
            ],
            [
              2939.985,
              -15050.429,
              16165.594
            ],
            [
              2961.063,
              -15057.508,
              16187.829
            ],
            [
              3081.096,
              -15066.465,
              16308.196
            ],
            [
              3099.13,
              -15064.581,
              16326.328
            ],
            [
              3102.922,
              -15067.992,
              16331.429
            ],
            [
              3104.039,
              -15076.92,
              16340.426
            ],
            [
              3099.972,
              -15087.975,
              16352.206
            ],
            [
              3094.81,
              -15088.991,
              16357.466
            ],
            [
              3085.299,
              -15082.131,
              16369.194
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5827",
              "position": {
                "x": -835.417,
                "z": -5317.507
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 129.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 399.496,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 915.001,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 1393.661,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:16627",
              "position": {
                "x": 320.415,
                "z": -6959.406
              },
              "distanceAlongShapeM": 2365.446,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6797",
              "position": {
                "x": 1056.317,
                "z": -7139.934
              },
              "distanceAlongShapeM": 3172.889,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6800",
              "position": {
                "x": 1694.973,
                "z": -8148.149
              },
              "distanceAlongShapeM": 4405.467,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6803",
              "position": {
                "x": 3013.269,
                "z": -9177.069
              },
              "distanceAlongShapeM": 6100.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6856",
              "position": {
                "x": 3684.789,
                "z": -9975.801
              },
              "distanceAlongShapeM": 7192.255,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:10554",
              "position": {
                "x": 3850.114,
                "z": -10113.666
              },
              "distanceAlongShapeM": 7407.778,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:9046",
              "position": {
                "x": 4200.33,
                "z": -10072.504
              },
              "distanceAlongShapeM": 7818.407,
              "shapeOffsetM": 0.162,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9048",
              "position": {
                "x": 4616.81,
                "z": -10066.046
              },
              "distanceAlongShapeM": 8234.937,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:15114",
              "position": {
                "x": 4852.251,
                "z": -10070.594
              },
              "distanceAlongShapeM": 8470.422,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 8991.766,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:16870",
              "position": {
                "x": 4715.978,
                "z": -10629.055
              },
              "distanceAlongShapeM": 9612.258,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:9053",
              "position": {
                "x": 4522.866,
                "z": -10833.513
              },
              "distanceAlongShapeM": 9903.739,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:8315",
              "position": {
                "x": 4289.98,
                "z": -10965.964
              },
              "distanceAlongShapeM": 10207.965,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8004",
              "position": {
                "x": 4493.832,
                "z": -11638.971
              },
              "distanceAlongShapeM": 10956.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:8005",
              "position": {
                "x": 4404.772,
                "z": -12054.736
              },
              "distanceAlongShapeM": 11381.817,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:8006",
              "position": {
                "x": 4295.286,
                "z": -12697.221
              },
              "distanceAlongShapeM": 12071.293,
              "shapeOffsetM": 1.102,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:10552",
              "position": {
                "x": 3803.923,
                "z": -12596.508
              },
              "distanceAlongShapeM": 12597.643,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:8008",
              "position": {
                "x": 3507.545,
                "z": -12522.939
              },
              "distanceAlongShapeM": 12903.014,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:8009",
              "position": {
                "x": 3081.528,
                "z": -12841.03
              },
              "distanceAlongShapeM": 13528.449,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:8368",
              "position": {
                "x": 2926.385,
                "z": -13188.772
              },
              "distanceAlongShapeM": 13910.343,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9001",
              "position": {
                "x": 2691.801,
                "z": -13726.501
              },
              "distanceAlongShapeM": 14497.039,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:8010",
              "position": {
                "x": 2561.815,
                "z": -14107.014
              },
              "distanceAlongShapeM": 14906.525,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:4777",
              "position": {
                "x": 2470.439,
                "z": -14827.807
              },
              "distanceAlongShapeM": 15634.517,
              "shapeOffsetM": 0.208,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:8025",
              "position": {
                "x": 3085.299,
                "z": -15082.131
              },
              "distanceAlongShapeM": 16369.194,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            }
          ],
          "departuresSeconds": [
            19860,
            21000,
            22860,
            24360,
            26100,
            27240,
            28200,
            31500,
            33120,
            34740,
            37020,
            38400,
            39600,
            41400,
            42900,
            44700,
            46200,
            47700,
            49200,
            51000,
            52500,
            53400,
            54600,
            55500,
            57000,
            58500,
            60000,
            61200,
            62400,
            65580,
            67500,
            70020,
            71220,
            72600,
            74100,
            75900,
            76800,
            78600,
            80100,
            81480,
            82380
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_76:1",
          "sourceRouteId": "vilnius_bus_76",
          "sourceShapeId": "vilnius_bus_76_b-a",
          "directionId": 1,
          "headsign": "Ateities st.",
          "directionName": "Bireliai–Sakališkės–Balsių g.–Ateities st.",
          "mode": "bus",
          "routeShortName": "76",
          "routeLongName": "Ateities–Balsių g.–Sakališkės–Bireliai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3085.299,
              -15082.131,
              0
            ],
            [
              3082.318,
              -15069.828,
              12.659
            ],
            [
              3077.884,
              -15066.404,
              18.261
            ],
            [
              3035.495,
              -15064.486,
              60.693
            ],
            [
              2986.766,
              -15057.996,
              109.853
            ],
            [
              2945.831,
              -15047.2,
              152.187
            ],
            [
              2876.877,
              -15022.515,
              225.427
            ],
            [
              2693.825,
              -14946.69,
              423.561
            ],
            [
              2552.927,
              -14885.026,
              577.362
            ],
            [
              2464.215,
              -14851.069,
              672.351
            ],
            [
              2461.841,
              -14806.493,
              716.99
            ],
            [
              2471.488,
              -14772.163,
              752.649
            ],
            [
              2474.275,
              -14726.572,
              798.326
            ],
            [
              2483.602,
              -14641.025,
              884.379
            ],
            [
              2505.39,
              -14542.354,
              985.427
            ],
            [
              2508.737,
              -14501.226,
              1026.691
            ],
            [
              2523.709,
              -14389.068,
              1139.845
            ],
            [
              2531.276,
              -14294.582,
              1234.633
            ],
            [
              2555.15,
              -14153.646,
              1377.576
            ],
            [
              2556.296,
              -14126.949,
              1404.298
            ],
            [
              2552.901,
              -14102.393,
              1429.088
            ],
            [
              2558.072,
              -14066.866,
              1464.989
            ],
            [
              2555.278,
              -14044.548,
              1487.482
            ],
            [
              2556.962,
              -14023.427,
              1508.669
            ],
            [
              2574.785,
              -13964.76,
              1569.984
            ],
            [
              2769.294,
              -13538.708,
              2038.336
            ],
            [
              2827.721,
              -13407.333,
              2182.118
            ],
            [
              2927.302,
              -13174.316,
              2435.521
            ],
            [
              3092.532,
              -12803.387,
              2841.587
            ],
            [
              3101.185,
              -12787.965,
              2859.27
            ],
            [
              3204.803,
              -12648.546,
              3032.978
            ],
            [
              3249.211,
              -12579.253,
              3115.28
            ],
            [
              3312.582,
              -12493.622,
              3221.809
            ],
            [
              3325.694,
              -12480.512,
              3240.351
            ],
            [
              3352.033,
              -12482.126,
              3266.74
            ],
            [
              3458.421,
              -12501.964,
              3374.961
            ],
            [
              3765.709,
              -12576.851,
              3691.243
            ],
            [
              4112.805,
              -12654.75,
              4046.973
            ],
            [
              4128.878,
              -12655.058,
              4063.049
            ],
            [
              4152.109,
              -12651.051,
              4086.622
            ],
            [
              4185.196,
              -12636.101,
              4122.931
            ],
            [
              4190.961,
              -12637.325,
              4128.824
            ],
            [
              4219.165,
              -12675.718,
              4176.464
            ],
            [
              4226.773,
              -12681.431,
              4185.978
            ],
            [
              4235.045,
              -12686.043,
              4195.449
            ],
            [
              4250.432,
              -12688.566,
              4211.041
            ],
            [
              4258.811,
              -12687.613,
              4219.474
            ],
            [
              4264.062,
              -12682.148,
              4227.053
            ],
            [
              4269.397,
              -12672.231,
              4238.314
            ],
            [
              4333.362,
              -12356.175,
              4560.778
            ],
            [
              4384.004,
              -12131.153,
              4791.428
            ],
            [
              4413.388,
              -11974.746,
              4950.571
            ],
            [
              4489.159,
              -11647.787,
              5286.196
            ],
            [
              4500.864,
              -11574.536,
              5360.376
            ],
            [
              4516.791,
              -11515.839,
              5421.196
            ],
            [
              4522.858,
              -11468.084,
              5469.334
            ],
            [
              4516.342,
              -11439.013,
              5499.126
            ],
            [
              4472.42,
              -11347.991,
              5600.192
            ],
            [
              4287.622,
              -10988.184,
              6004.68
            ],
            [
              4283.377,
              -10974.743,
              6018.776
            ],
            [
              4288.179,
              -10959.25,
              6034.996
            ],
            [
              4287.063,
              -10950.322,
              6043.993
            ],
            [
              4279.795,
              -10926.803,
              6068.61
            ],
            [
              4282.474,
              -10921.288,
              6074.741
            ],
            [
              4545.72,
              -10816.141,
              6358.21
            ],
            [
              4558.82,
              -10804.147,
              6375.97
            ],
            [
              4606.823,
              -10783.921,
              6428.061
            ],
            [
              4646.679,
              -10752.405,
              6478.872
            ],
            [
              4702.534,
              -10658.854,
              6587.828
            ],
            [
              4764.013,
              -10474.123,
              6782.521
            ],
            [
              4835.253,
              -10284.015,
              6985.538
            ],
            [
              4885.039,
              -10305.018,
              7039.573
            ],
            [
              5017.928,
              -10354.349,
              7181.323
            ],
            [
              5040.869,
              -10365.926,
              7207.02
            ],
            [
              5073.204,
              -10357.647,
              7240.398
            ],
            [
              5060.745,
              -10369.652,
              7257.699
            ],
            [
              5026.912,
              -10355.636,
              7294.32
            ],
            [
              4837.097,
              -10288.504,
              7495.657
            ],
            [
              4899.767,
              -10075.966,
              7717.242
            ],
            [
              4160.961,
              -10078.428,
              8456.052
            ],
            [
              4078.021,
              -10074.611,
              8539.08
            ],
            [
              4005.224,
              -10078.783,
              8611.997
            ],
            [
              3981.274,
              -10086.117,
              8637.045
            ],
            [
              3966.973,
              -10093.636,
              8653.202
            ],
            [
              3948.343,
              -10125.564,
              8690.168
            ],
            [
              3935.179,
              -10140.898,
              8710.377
            ],
            [
              3924.074,
              -10149.592,
              8724.481
            ],
            [
              3913.675,
              -10154.959,
              8736.184
            ],
            [
              3866.759,
              -10151.835,
              8783.203
            ],
            [
              3832.039,
              -10116.66,
              8832.628
            ],
            [
              3633.404,
              -9936.97,
              9100.479
            ],
            [
              3613.674,
              -9925.461,
              9123.321
            ],
            [
              3584.076,
              -9891.498,
              9168.371
            ],
            [
              3560.012,
              -9871.001,
              9199.981
            ],
            [
              3541.801,
              -9847.275,
              9229.89
            ],
            [
              3514.661,
              -9785.528,
              9297.338
            ],
            [
              3500.953,
              -9761.888,
              9324.665
            ],
            [
              3482.098,
              -9738.151,
              9354.98
            ],
            [
              3456.873,
              -9710.952,
              9392.075
            ],
            [
              3423.2,
              -9688.046,
              9432.801
            ],
            [
              3388.156,
              -9669.567,
              9472.419
            ],
            [
              3277.145,
              -9618.474,
              9594.623
            ],
            [
              3228.737,
              -9591.949,
              9649.822
            ],
            [
              3213.634,
              -9573.85,
              9673.394
            ],
            [
              3206.315,
              -9552.559,
              9695.908
            ],
            [
              3171.376,
              -9392.699,
              9859.542
            ],
            [
              3164.552,
              -9379.21,
              9874.659
            ],
            [
              3134.577,
              -9330.771,
              9931.622
            ],
            [
              3021.317,
              -9193.92,
              10109.262
            ],
            [
              2970.687,
              -9148.431,
              10177.326
            ],
            [
              2953.441,
              -9141.425,
              10195.94
            ],
            [
              2944.749,
              -9124.562,
              10214.912
            ],
            [
              2590.264,
              -8808.384,
              10689.915
            ],
            [
              2140.228,
              -8401.383,
              11296.695
            ],
            [
              2107.826,
              -8378.511,
              11336.357
            ],
            [
              1978.502,
              -8305.956,
              11484.643
            ],
            [
              1955.502,
              -8296.62,
              11509.466
            ],
            [
              1918.925,
              -8290.37,
              11546.574
            ],
            [
              1793.436,
              -8253.517,
              11677.362
            ],
            [
              1773.051,
              -8242.004,
              11700.774
            ],
            [
              1750.194,
              -8224.879,
              11729.333
            ],
            [
              1684.136,
              -8142.38,
              11835.021
            ],
            [
              1655.922,
              -8101.778,
              11884.463
            ],
            [
              1643.486,
              -8078.168,
              11911.148
            ],
            [
              1639.977,
              -8059.177,
              11930.461
            ],
            [
              1639.433,
              -7950.068,
              12039.571
            ],
            [
              1629.362,
              -7903.123,
              12087.584
            ],
            [
              1545.21,
              -7754.608,
              12258.284
            ],
            [
              1341.067,
              -7410.16,
              12658.681
            ],
            [
              1312.907,
              -7366.221,
              12710.87
            ],
            [
              1291.476,
              -7341.333,
              12743.714
            ],
            [
              1145.93,
              -7238.444,
              12921.954
            ],
            [
              1102.154,
              -7203.124,
              12978.202
            ],
            [
              1045.977,
              -7141.97,
              13061.243
            ],
            [
              1026.954,
              -7126.033,
              13086.059
            ],
            [
              999.31,
              -7088.785,
              13132.445
            ],
            [
              951.943,
              -7073.438,
              13182.236
            ],
            [
              652.324,
              -7119.127,
              13485.319
            ],
            [
              622.009,
              -7121.909,
              13515.761
            ],
            [
              600.767,
              -7121.518,
              13537.007
            ],
            [
              577.696,
              -7115.528,
              13560.843
            ],
            [
              488.416,
              -7068.245,
              13661.87
            ],
            [
              60.82,
              -6823.295,
              14154.657
            ],
            [
              14.911,
              -6833.59,
              14201.706
            ],
            [
              -2.815,
              -6852.191,
              14227.401
            ],
            [
              -13.86,
              -6857.556,
              14239.679
            ],
            [
              -37.095,
              -6860.472,
              14263.097
            ],
            [
              -47.374,
              -6859.171,
              14273.458
            ],
            [
              -59.463,
              -6851.158,
              14287.962
            ],
            [
              -67.548,
              -6835.425,
              14305.65
            ],
            [
              -70.502,
              -6820.899,
              14320.474
            ],
            [
              -67.684,
              -6807.592,
              14334.077
            ],
            [
              -64.262,
              -6796.522,
              14345.663
            ],
            [
              -53.78,
              -6786.694,
              14360.032
            ],
            [
              -43.196,
              -6771.301,
              14378.713
            ],
            [
              -35.045,
              -6748.072,
              14403.331
            ],
            [
              -43.266,
              -6704.505,
              14447.666
            ],
            [
              -50.829,
              -6695.462,
              14459.455
            ],
            [
              -48.526,
              -6639.841,
              14515.123
            ],
            [
              -52.099,
              -6588.567,
              14566.522
            ],
            [
              -70.555,
              -6505.85,
              14651.272
            ],
            [
              -125.166,
              -6286.66,
              14877.164
            ],
            [
              -158.525,
              -6137.991,
              15029.529
            ],
            [
              -182.398,
              -6069.649,
              15101.921
            ],
            [
              -186.217,
              -6031.729,
              15140.033
            ],
            [
              -210.448,
              -5912.171,
              15262.021
            ],
            [
              -214.688,
              -5861.998,
              15312.373
            ],
            [
              -215.425,
              -5796.303,
              15378.072
            ],
            [
              -210.007,
              -5746.306,
              15428.362
            ],
            [
              -195.772,
              -5671.978,
              15504.041
            ],
            [
              -200.158,
              -5665.219,
              15512.098
            ],
            [
              -245.834,
              -5662.161,
              15557.877
            ],
            [
              -275.515,
              -5664.961,
              15587.689
            ],
            [
              -299.862,
              -5657.84,
              15613.056
            ],
            [
              -394.957,
              -5644.98,
              15709.017
            ],
            [
              -428.258,
              -5634.356,
              15743.972
            ],
            [
              -633.019,
              -5523.775,
              15976.684
            ],
            [
              -663.705,
              -5510.974,
              16009.934
            ],
            [
              -740.836,
              -5466.163,
              16099.136
            ],
            [
              -765.768,
              -5455.693,
              16126.178
            ],
            [
              -877.432,
              -5396.902,
              16252.373
            ],
            [
              -884.394,
              -5390.097,
              16262.109
            ],
            [
              -886.769,
              -5378.922,
              16273.534
            ],
            [
              -872.164,
              -5283.447,
              16370.119
            ],
            [
              -865.423,
              -5266.87,
              16388.014
            ],
            [
              -855.623,
              -5259.254,
              16400.426
            ],
            [
              -842.1,
              -5259.499,
              16413.951
            ],
            [
              -827.993,
              -5263.093,
              16428.508
            ],
            [
              -821.07,
              -5272.124,
              16439.887
            ],
            [
              -820.003,
              -5284.389,
              16452.199
            ],
            [
              -835.417,
              -5317.507,
              16488.729
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8025",
              "position": {
                "x": 3085.299,
                "z": -15082.131
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:8024",
              "position": {
                "x": 2461.841,
                "z": -14806.493
              },
              "distanceAlongShapeM": 716.99,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:8364",
              "position": {
                "x": 2552.901,
                "z": -14102.393
              },
              "distanceAlongShapeM": 1429.088,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9002",
              "position": {
                "x": 2696.204,
                "z": -13697.639
              },
              "distanceAlongShapeM": 1863.405,
              "shapeOffsetM": 0.484,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:8367",
              "position": {
                "x": 2941.349,
                "z": -13145.637
              },
              "distanceAlongShapeM": 2467.434,
              "shapeOffsetM": 1.162,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:8017",
              "position": {
                "x": 3092.532,
                "z": -12803.387
              },
              "distanceAlongShapeM": 2841.587,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:8018",
              "position": {
                "x": 3458.421,
                "z": -12501.964
              },
              "distanceAlongShapeM": 3374.961,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:10551",
              "position": {
                "x": 3765.709,
                "z": -12576.851
              },
              "distanceAlongShapeM": 3691.243,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:18426",
              "position": {
                "x": 4270.854,
                "z": -12663.353
              },
              "distanceAlongShapeM": 4247.305,
              "shapeOffsetM": 0.333,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:8021",
              "position": {
                "x": 4413.388,
                "z": -11974.746
              },
              "distanceAlongShapeM": 4950.571,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:8022",
              "position": {
                "x": 4500.864,
                "z": -11574.536
              },
              "distanceAlongShapeM": 5360.376,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9798",
              "position": {
                "x": 4287.063,
                "z": -10950.322
              },
              "distanceAlongShapeM": 6043.993,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 870,
              "departureOffsetSeconds": 870
            },
            {
              "stopId": "judu:stop:9054",
              "position": {
                "x": 4558.82,
                "z": -10804.147
              },
              "distanceAlongShapeM": 6375.97,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 930,
              "departureOffsetSeconds": 930
            },
            {
              "stopId": "judu:stop:16832",
              "position": {
                "x": 4764.013,
                "z": -10474.123
              },
              "distanceAlongShapeM": 6782.521,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 7240.398,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:15113",
              "position": {
                "x": 4825.104,
                "z": -10076.748
              },
              "distanceAlongShapeM": 7791.908,
              "shapeOffsetM": 0.533,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9047",
              "position": {
                "x": 4559.944,
                "z": -10078.309
              },
              "distanceAlongShapeM": 8057.072,
              "shapeOffsetM": 1.21,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:9045",
              "position": {
                "x": 4160.961,
                "z": -10078.428
              },
              "distanceAlongShapeM": 8456.052,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:10556",
              "position": {
                "x": 3832.039,
                "z": -10116.66
              },
              "distanceAlongShapeM": 8832.628,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6857",
              "position": {
                "x": 3613.674,
                "z": -9925.461
              },
              "distanceAlongShapeM": 9123.321,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6804",
              "position": {
                "x": 2953.441,
                "z": -9141.425
              },
              "distanceAlongShapeM": 10195.94,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6801",
              "position": {
                "x": 1918.925,
                "z": -8290.37
              },
              "distanceAlongShapeM": 11546.574,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6798",
              "position": {
                "x": 1026.954,
                "z": -7126.033
              },
              "distanceAlongShapeM": 13086.059,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:16628",
              "position": {
                "x": 229.7,
                "z": -6919.895
              },
              "distanceAlongShapeM": 13960.102,
              "shapeOffsetM": 0.125,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 14459.455,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 15101.921,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 15587.689,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 16009.934,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5827",
              "position": {
                "x": -835.417,
                "z": -5317.507
              },
              "distanceAlongShapeM": 16488.729,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2550,
              "departureOffsetSeconds": 2550
            }
          ],
          "departuresSeconds": [
            20100,
            21420,
            22800,
            23700,
            24600,
            26100,
            27600,
            29100,
            30600,
            31800,
            34500,
            36000,
            38100,
            39900,
            41400,
            42900,
            44700,
            45900,
            47700,
            49200,
            51000,
            52200,
            54000,
            55500,
            56700,
            57900,
            58800,
            60300,
            61800,
            63300,
            64800,
            66000,
            68700,
            70800,
            72900,
            74040,
            75600,
            77100,
            78720,
            79620,
            81360,
            82860,
            84300,
            85140
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_87",
      "sourceRouteId": "vilnius_bus_87",
      "mode": "bus",
      "shortName": "87",
      "longName": "Ateities g.–Molėtų pl.–Riešė–Bendorėliai–Šeškinė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_87:0",
          "sourceRouteId": "vilnius_bus_87",
          "sourceShapeId": "vilnius_bus_87_a-b",
          "directionId": 0,
          "headsign": "Šeškinė",
          "directionName": "Ateities g.–Molėtų pl.–Riešė–Bendorėliai–Šeškinė",
          "mode": "bus",
          "routeShortName": "87",
          "routeLongName": "Ateities g.–Molėtų pl.–Riešė–Bendorėliai–Šeškinė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -835.417,
              -5317.507,
              0
            ],
            [
              -866.829,
              -5344.771,
              41.593
            ],
            [
              -872.825,
              -5355.796,
              54.143
            ],
            [
              -873.83,
              -5375.816,
              74.188
            ],
            [
              -864.956,
              -5383.768,
              86.105
            ],
            [
              -826.661,
              -5403.385,
              129.132
            ],
            [
              -674.33,
              -5492.97,
              305.852
            ],
            [
              -589.373,
              -5532.358,
              399.496
            ],
            [
              -565.267,
              -5552.833,
              431.124
            ],
            [
              -421.759,
              -5631.135,
              594.604
            ],
            [
              -383.93,
              -5640.727,
              633.63
            ],
            [
              -342.157,
              -5645.939,
              675.727
            ],
            [
              -257.182,
              -5648.596,
              760.743
            ],
            [
              -196.756,
              -5655.261,
              821.536
            ],
            [
              -180.177,
              -5664.469,
              840.5
            ],
            [
              -177.18,
              -5676.769,
              853.16
            ],
            [
              -185.798,
              -5725.595,
              902.741
            ],
            [
              -185.377,
              -5737.848,
              915.001
            ],
            [
              -196.91,
              -5769.923,
              949.086
            ],
            [
              -201.665,
              -5818.819,
              998.213
            ],
            [
              -201.086,
              -5857.793,
              1037.191
            ],
            [
              -195.599,
              -5910.215,
              1089.9
            ],
            [
              -136.015,
              -6175.138,
              1361.44
            ],
            [
              -122.378,
              -6204.331,
              1393.661
            ],
            [
              -123.468,
              -6228.802,
              1418.157
            ],
            [
              -113.557,
              -6285.758,
              1475.969
            ],
            [
              -58.166,
              -6532.794,
              1729.139
            ],
            [
              -46.468,
              -6597.576,
              1794.968
            ],
            [
              -39.377,
              -6667.839,
              1865.588
            ],
            [
              -35.045,
              -6748.072,
              1945.938
            ],
            [
              -27.041,
              -6768.256,
              1967.651
            ],
            [
              -16.965,
              -6780.686,
              1983.652
            ],
            [
              0.233,
              -6791.019,
              2003.716
            ],
            [
              10.168,
              -6811.238,
              2026.244
            ],
            [
              11.151,
              -6827.955,
              2042.99
            ],
            [
              7.024,
              -6842.352,
              2057.966
            ],
            [
              -2.815,
              -6852.191,
              2071.881
            ],
            [
              -13.86,
              -6857.556,
              2084.16
            ],
            [
              -37.095,
              -6860.472,
              2107.577
            ],
            [
              -47.374,
              -6859.171,
              2117.939
            ],
            [
              -59.463,
              -6851.158,
              2132.442
            ],
            [
              -78.653,
              -6844.129,
              2152.879
            ],
            [
              -94.726,
              -6842.723,
              2169.014
            ],
            [
              -112.168,
              -6845.745,
              2186.715
            ],
            [
              -131.642,
              -6854.296,
              2207.984
            ],
            [
              -156.753,
              -6889.462,
              2251.195
            ],
            [
              -179.506,
              -6901.294,
              2276.841
            ],
            [
              -377.89,
              -7081.371,
              2544.766
            ],
            [
              -432.166,
              -7127.141,
              2615.765
            ],
            [
              -475.073,
              -7149.741,
              2664.26
            ],
            [
              -543.125,
              -7174.111,
              2736.544
            ],
            [
              -668.705,
              -7210.8,
              2867.374
            ],
            [
              -673.975,
              -7217.384,
              2875.807
            ],
            [
              -654.083,
              -7256.707,
              2919.876
            ],
            [
              -633.285,
              -7281.575,
              2952.295
            ],
            [
              -587.268,
              -7407.092,
              3085.981
            ],
            [
              -545.055,
              -7529.2,
              3215.18
            ],
            [
              -539.123,
              -7557.139,
              3243.741
            ],
            [
              -523.297,
              -7607.522,
              3296.551
            ],
            [
              -514.753,
              -7668.905,
              3358.526
            ],
            [
              -511.201,
              -7792.54,
              3482.212
            ],
            [
              -532.251,
              -7994.768,
              3685.533
            ],
            [
              -556.838,
              -8498.621,
              4189.986
            ],
            [
              -549.822,
              -8537.712,
              4229.701
            ],
            [
              -556.984,
              -8577.659,
              4270.285
            ],
            [
              -559.825,
              -8663.327,
              4356
            ],
            [
              -559.506,
              -8716.769,
              4409.442
            ],
            [
              -566.652,
              -8826.85,
              4519.756
            ],
            [
              -561.229,
              -8918.235,
              4611.301
            ],
            [
              -572.031,
              -8981.494,
              4675.475
            ],
            [
              -575.472,
              -9029.301,
              4723.406
            ],
            [
              -577.992,
              -9132.787,
              4826.923
            ],
            [
              -573.278,
              -9298.746,
              4992.949
            ],
            [
              -565.946,
              -9391.278,
              5085.771
            ],
            [
              -549.971,
              -9504.006,
              5199.625
            ],
            [
              -505.453,
              -9675.14,
              5376.455
            ],
            [
              -446.478,
              -9971.222,
              5678.353
            ],
            [
              -419.075,
              -10127.574,
              5837.089
            ],
            [
              -413.755,
              -10188.899,
              5898.644
            ],
            [
              -418.439,
              -10198.833,
              5909.628
            ],
            [
              -429.435,
              -10201.973,
              5921.063
            ],
            [
              -449.619,
              -10214.966,
              5945.067
            ],
            [
              -518.012,
              -10296.104,
              6051.185
            ],
            [
              -531.261,
              -10317.015,
              6075.94
            ],
            [
              -538.659,
              -10334.693,
              6095.103
            ],
            [
              -534.921,
              -10341.44,
              6102.817
            ],
            [
              -522.76,
              -10345.001,
              6115.488
            ],
            [
              -518.881,
              -10343.958,
              6119.506
            ],
            [
              -520.046,
              -10337.257,
              6126.307
            ],
            [
              -492.966,
              -10298.785,
              6173.354
            ],
            [
              -486.291,
              -10285.547,
              6188.179
            ],
            [
              -486.23,
              -10282.209,
              6191.518
            ],
            [
              -497.044,
              -10275.333,
              6204.333
            ],
            [
              -537.976,
              -10332.479,
              6274.625
            ],
            [
              -597.23,
              -10548.487,
              6498.613
            ],
            [
              -776.158,
              -10978.298,
              6964.181
            ],
            [
              -971.03,
              -11580.381,
              7597.015
            ],
            [
              -1246.263,
              -12218.875,
              8292.304
            ],
            [
              -1401.025,
              -12599.047,
              8702.77
            ],
            [
              -1425.089,
              -12649.824,
              8758.961
            ],
            [
              -1528.729,
              -12906.236,
              9035.526
            ],
            [
              -1581.108,
              -13029.98,
              9169.899
            ],
            [
              -1600.868,
              -13091.968,
              9234.96
            ],
            [
              -1607.248,
              -13160.874,
              9304.162
            ],
            [
              -1618.874,
              -13199.63,
              9344.623
            ],
            [
              -1626.045,
              -13205.067,
              9353.622
            ],
            [
              -1683.899,
              -13204.031,
              9411.486
            ],
            [
              -1727.008,
              -13205.485,
              9454.62
            ],
            [
              -1911.274,
              -13225.568,
              9639.976
            ],
            [
              -3274.864,
              -13357.272,
              11009.912
            ],
            [
              -3419.319,
              -13381.456,
              11156.378
            ],
            [
              -3482.333,
              -13381.465,
              11219.391
            ],
            [
              -3529.121,
              -13372.853,
              11266.965
            ],
            [
              -3653.025,
              -13361.78,
              11391.363
            ],
            [
              -3699.988,
              -13363.186,
              11438.348
            ],
            [
              -3734.836,
              -13370.37,
              11473.928
            ],
            [
              -3778.76,
              -13381.849,
              11519.327
            ],
            [
              -3809.808,
              -13392.44,
              11552.132
            ],
            [
              -3834.974,
              -13397.567,
              11577.815
            ],
            [
              -3865.906,
              -13401.481,
              11608.993
            ],
            [
              -3908.311,
              -13399.629,
              11651.438
            ],
            [
              -3955.176,
              -13395.473,
              11698.488
            ],
            [
              -4017.977,
              -13383.248,
              11762.467
            ],
            [
              -4110.017,
              -13351.591,
              11859.8
            ],
            [
              -4161.094,
              -13330.666,
              11914.996
            ],
            [
              -4419.691,
              -13151.407,
              12229.649
            ],
            [
              -4474.224,
              -13107.047,
              12299.946
            ],
            [
              -4857.299,
              -12760.906,
              12816.24
            ],
            [
              -4916.984,
              -12716.464,
              12890.654
            ],
            [
              -5070.056,
              -12642.589,
              13060.62
            ],
            [
              -5098.153,
              -12630.975,
              13091.023
            ],
            [
              -5142.322,
              -12619.086,
              13136.764
            ],
            [
              -5192.164,
              -12600.42,
              13189.986
            ],
            [
              -5240.815,
              -12587.341,
              13240.365
            ],
            [
              -5267.741,
              -12582.428,
              13267.735
            ],
            [
              -5287.066,
              -12584.323,
              13287.154
            ],
            [
              -5295.915,
              -12575.266,
              13299.816
            ],
            [
              -5312.699,
              -12165.314,
              13710.111
            ],
            [
              -5330.138,
              -12019.184,
              13857.278
            ],
            [
              -5349.116,
              -11925.35,
              13953.013
            ],
            [
              -5376.15,
              -11813.566,
              14068.019
            ],
            [
              -5396.72,
              -11737.516,
              14146.802
            ],
            [
              -5407.215,
              -11711.732,
              14174.639
            ],
            [
              -5551.037,
              -11130.406,
              14773.492
            ],
            [
              -5561.701,
              -11038.941,
              14865.577
            ],
            [
              -5582.239,
              -10922.816,
              14983.504
            ],
            [
              -5604.006,
              -10727.633,
              15179.897
            ],
            [
              -5637.047,
              -10400.899,
              15508.298
            ],
            [
              -5671.872,
              -10027.38,
              15883.437
            ],
            [
              -5672.079,
              -9888.224,
              16022.592
            ],
            [
              -5670.035,
              -9843.731,
              16067.133
            ],
            [
              -5663.147,
              -9779.281,
              16131.949
            ],
            [
              -5648.18,
              -9693.819,
              16218.713
            ],
            [
              -5545.898,
              -9280.331,
              16644.662
            ],
            [
              -5524.911,
              -9219.462,
              16709.048
            ],
            [
              -5448.187,
              -9022.618,
              16920.317
            ],
            [
              -5360.064,
              -8837.102,
              17125.699
            ],
            [
              -5338.257,
              -8766.228,
              17199.851
            ],
            [
              -5325.706,
              -8709.669,
              17257.786
            ],
            [
              -5316.882,
              -8645.253,
              17322.804
            ],
            [
              -5304.974,
              -8588.683,
              17380.614
            ],
            [
              -5290.247,
              -8555.538,
              17416.883
            ],
            [
              -5267.703,
              -8516.961,
              17461.565
            ],
            [
              -5173.871,
              -8374.961,
              17631.766
            ],
            [
              -5177.012,
              -8370.454,
              17637.259
            ],
            [
              -5178.147,
              -8361.529,
              17646.256
            ],
            [
              -5176.121,
              -8355.997,
              17652.147
            ],
            [
              -5179.244,
              -8350.378,
              17658.576
            ],
            [
              -5277.223,
              -8283.023,
              17777.473
            ],
            [
              -5286.156,
              -8278.418,
              17787.523
            ],
            [
              -5297.115,
              -8279.344,
              17798.521
            ],
            [
              -5304.742,
              -8273.647,
              17808.041
            ],
            [
              -5307.183,
              -8265.813,
              17816.247
            ],
            [
              -5307.031,
              -8256.91,
              17825.151
            ],
            [
              -5299.857,
              -8251.467,
              17834.156
            ],
            [
              -5290.81,
              -8249.395,
              17843.438
            ],
            [
              -5209.243,
              -8147.26,
              17974.146
            ],
            [
              -5185.923,
              -8138.753,
              17998.969
            ],
            [
              -5157.683,
              -8143.689,
              18027.637
            ],
            [
              -5140.951,
              -8143.975,
              18044.372
            ],
            [
              -5131.184,
              -8137.463,
              18056.111
            ],
            [
              -5120.696,
              -8126.511,
              18071.275
            ],
            [
              -4982.793,
              -7892.872,
              18342.576
            ],
            [
              -4894.752,
              -7751.892,
              18508.789
            ],
            [
              -4882.046,
              -7724.279,
              18539.184
            ],
            [
              -4761.02,
              -7574.962,
              18731.39
            ],
            [
              -4620.121,
              -7393.706,
              18960.968
            ],
            [
              -4514.978,
              -7232.989,
              19153.022
            ],
            [
              -4344.717,
              -6993.248,
              19447.071
            ],
            [
              -4337.156,
              -6965.549,
              19475.784
            ],
            [
              -4337.04,
              -6958.871,
              19482.463
            ],
            [
              -4347.128,
              -6946.452,
              19498.463
            ],
            [
              -4350.759,
              -6933.03,
              19512.367
            ],
            [
              -4349.817,
              -6878.499,
              19566.906
            ],
            [
              -4344.052,
              -6842.976,
              19602.895
            ],
            [
              -4336.077,
              -6828.642,
              19619.298
            ],
            [
              -4328.861,
              -6820.974,
              19629.827
            ],
            [
              -4317.802,
              -6814.486,
              19642.648
            ],
            [
              -4318.023,
              -6789.991,
              19667.144
            ],
            [
              -4305.109,
              -6787.988,
              19680.212
            ],
            [
              -4294.204,
              -6790.403,
              19691.381
            ],
            [
              -4291.745,
              -6797.125,
              19698.538
            ],
            [
              -4293.186,
              -6806.006,
              19707.535
            ],
            [
              -4304.284,
              -6814.719,
              19721.645
            ],
            [
              -4302.229,
              -6844.812,
              19751.808
            ],
            [
              -4305.131,
              -6863.686,
              19770.904
            ],
            [
              -4319.072,
              -6887.936,
              19798.876
            ],
            [
              -4336.232,
              -6912.13,
              19828.537
            ],
            [
              -4339.739,
              -6928.768,
              19845.541
            ],
            [
              -4337.924,
              -6935.478,
              19852.493
            ],
            [
              -4317.968,
              -6935.823,
              19872.451
            ],
            [
              -4302.855,
              -6918.273,
              19895.611
            ],
            [
              -4250.009,
              -6841.262,
              19989.01
            ],
            [
              -4167.288,
              -6712.448,
              20142.098
            ],
            [
              -4136.26,
              -6668.457,
              20195.931
            ],
            [
              -4095.853,
              -6603.478,
              20272.449
            ],
            [
              -4041.159,
              -6457.482,
              20428.354
            ],
            [
              -4021.737,
              -6414.403,
              20475.608
            ],
            [
              -3991.253,
              -6364.838,
              20533.798
            ],
            [
              -3967.007,
              -6340.768,
              20567.962
            ],
            [
              -3878.933,
              -6275.505,
              20677.581
            ],
            [
              -3859.174,
              -6250.244,
              20709.652
            ],
            [
              -3803.68,
              -6169.945,
              20807.261
            ],
            [
              -3744.108,
              -6077.471,
              20917.262
            ],
            [
              -3618.634,
              -5899.316,
              21135.167
            ],
            [
              -3485.286,
              -5750.246,
              21335.176
            ],
            [
              -3386.562,
              -5629.518,
              21491.131
            ],
            [
              -3375.968,
              -5613.005,
              21510.75
            ],
            [
              -3323.404,
              -5553.81,
              21589.914
            ],
            [
              -3282.741,
              -5512.22,
              21648.08
            ],
            [
              -3111.162,
              -5314.848,
              21909.604
            ],
            [
              -3040.755,
              -5230.366,
              22019.579
            ],
            [
              -3010.272,
              -5181.92,
              22076.817
            ],
            [
              -2985.976,
              -5155.629,
              22112.615
            ],
            [
              -2932.971,
              -5071.956,
              22211.664
            ],
            [
              -2914.996,
              -5038.876,
              22249.313
            ],
            [
              -2884.805,
              -5007.124,
              22293.127
            ],
            [
              -2783.196,
              -4834.137,
              22493.748
            ],
            [
              -2685.035,
              -4674.45,
              22681.193
            ],
            [
              -2617.123,
              -4549.854,
              22823.095
            ],
            [
              -2601.622,
              -4511.165,
              22864.774
            ],
            [
              -2575.776,
              -4470.432,
              22913.014
            ],
            [
              -2510.179,
              -4331.325,
              23066.812
            ],
            [
              -2380.854,
              -3977.381,
              23443.643
            ],
            [
              -2366.341,
              -3921.977,
              23500.916
            ],
            [
              -2313.476,
              -3774.854,
              23657.249
            ],
            [
              -2292.987,
              -3709.537,
              23725.704
            ],
            [
              -2289.819,
              -3676.197,
              23759.195
            ],
            [
              -2072.945,
              -3075.564,
              24397.782
            ],
            [
              -2044.086,
              -2974.773,
              24502.623
            ],
            [
              -2039.765,
              -2949.246,
              24528.513
            ],
            [
              -2051.75,
              -2934.561,
              24547.468
            ],
            [
              -2070.236,
              -2923.101,
              24569.218
            ],
            [
              -2092.806,
              -2923.813,
              24591.8
            ],
            [
              -2134.547,
              -2915.279,
              24634.404
            ],
            [
              -2189.877,
              -2909.844,
              24690
            ],
            [
              -2238.843,
              -2908.976,
              24738.974
            ],
            [
              -2271.353,
              -2925.098,
              24775.262
            ],
            [
              -2292.95,
              -2943.64,
              24803.727
            ],
            [
              -2307.637,
              -2972.324,
              24835.952
            ],
            [
              -2313.343,
              -3003.393,
              24867.541
            ],
            [
              -2311.942,
              -3033.475,
              24897.655
            ],
            [
              -2302.653,
              -3054.791,
              24920.907
            ],
            [
              -2286.96,
              -3078.446,
              24949.295
            ],
            [
              -2258.264,
              -3095.653,
              24982.754
            ],
            [
              -2237.746,
              -3101.583,
              25004.112
            ],
            [
              -2215.841,
              -3101.972,
              25026.02
            ],
            [
              -2134.198,
              -3113.439,
              25108.465
            ],
            [
              -2119.439,
              -3117.041,
              25123.657
            ],
            [
              -2116.961,
              -3122.651,
              25129.79
            ],
            [
              -2121.142,
              -3140.388,
              25148.014
            ],
            [
              -2128.466,
              -3153.617,
              25163.135
            ],
            [
              -2145.98,
              -3159.985,
              25181.77
            ],
            [
              -2161.481,
              -3161.937,
              25197.394
            ],
            [
              -2189.769,
              -3158.095,
              25225.942
            ],
            [
              -2192.892,
              -3152.474,
              25232.372
            ],
            [
              -2195.778,
              -3133.498,
              25251.566
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5827",
              "position": {
                "x": -835.417,
                "z": -5317.507
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5828",
              "position": {
                "x": -826.661,
                "z": -5403.385
              },
              "distanceAlongShapeM": 129.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6633",
              "position": {
                "x": -589.373,
                "z": -5532.358
              },
              "distanceAlongShapeM": 399.496,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6497",
              "position": {
                "x": -185.377,
                "z": -5737.848
              },
              "distanceAlongShapeM": 915.001,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6500",
              "position": {
                "x": -122.378,
                "z": -6204.331
              },
              "distanceAlongShapeM": 1393.661,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6783",
              "position": {
                "x": -156.753,
                "z": -6889.462
              },
              "distanceAlongShapeM": 2251.195,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:7980",
              "position": {
                "x": -633.285,
                "z": -7281.575
              },
              "distanceAlongShapeM": 2952.295,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:16295",
              "position": {
                "x": -511.201,
                "z": -7792.54
              },
              "distanceAlongShapeM": 3482.212,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7092",
              "position": {
                "x": -549.822,
                "z": -8537.712
              },
              "distanceAlongShapeM": 4229.701,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:7374",
              "position": {
                "x": -561.229,
                "z": -8918.235
              },
              "distanceAlongShapeM": 4611.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7095",
              "position": {
                "x": -505.453,
                "z": -9675.14
              },
              "distanceAlongShapeM": 5376.455,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:8472",
              "position": {
                "x": -520.046,
                "z": -10337.257
              },
              "distanceAlongShapeM": 6126.307,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7098",
              "position": {
                "x": -597.23,
                "z": -10548.487
              },
              "distanceAlongShapeM": 6498.613,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7100",
              "position": {
                "x": -776.158,
                "z": -10978.298
              },
              "distanceAlongShapeM": 6964.181,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7102",
              "position": {
                "x": -997.254,
                "z": -11643.363
              },
              "distanceAlongShapeM": 7665.233,
              "shapeOffsetM": 0.849,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7104",
              "position": {
                "x": -1246.263,
                "z": -12218.875
              },
              "distanceAlongShapeM": 8292.304,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:8324",
              "position": {
                "x": -1401.025,
                "z": -12599.047
              },
              "distanceAlongShapeM": 8702.77,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:7107",
              "position": {
                "x": -1607.248,
                "z": -13160.874
              },
              "distanceAlongShapeM": 9304.162,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7344",
              "position": {
                "x": -2212.085,
                "z": -13254.716
              },
              "distanceAlongShapeM": 9942.196,
              "shapeOffsetM": 0.093,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7110",
              "position": {
                "x": -3119.012,
                "z": -13343.313
              },
              "distanceAlongShapeM": 10853.44,
              "shapeOffsetM": 1.089,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:10122",
              "position": {
                "x": -3482.333,
                "z": -13381.465
              },
              "distanceAlongShapeM": 11219.391,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:10091",
              "position": {
                "x": -5142.322,
                "z": -12619.086
              },
              "distanceAlongShapeM": 13136.764,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:10094",
              "position": {
                "x": -5407.215,
                "z": -11711.732
              },
              "distanceAlongShapeM": 14174.639,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:10096",
              "position": {
                "x": -5551.037,
                "z": -11130.406
              },
              "distanceAlongShapeM": 14773.492,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:10098",
              "position": {
                "x": -5671.872,
                "z": -10027.38
              },
              "distanceAlongShapeM": 15883.437,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:10100",
              "position": {
                "x": -5448.187,
                "z": -9022.618
              },
              "distanceAlongShapeM": 16920.317,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:7082",
              "position": {
                "x": -5267.811,
                "z": -8221.957
              },
              "distanceAlongShapeM": 17879.229,
              "shapeOffsetM": 0.849,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:18939",
              "position": {
                "x": -4882.046,
                "z": -7724.279
              },
              "distanceAlongShapeM": 18539.184,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:18824",
              "position": {
                "x": -4302.229,
                "z": -6844.812
              },
              "distanceAlongShapeM": 19751.808,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:7077",
              "position": {
                "x": -3618.634,
                "z": -5899.316
              },
              "distanceAlongShapeM": 21135.167,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:9153",
              "position": {
                "x": -3375.968,
                "z": -5613.005
              },
              "distanceAlongShapeM": 21510.75,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:5443",
              "position": {
                "x": -2914.996,
                "z": -5038.876
              },
              "distanceAlongShapeM": 22249.313,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            },
            {
              "stopId": "judu:stop:7896",
              "position": {
                "x": -2601.622,
                "z": -4511.165
              },
              "distanceAlongShapeM": 22864.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3420,
              "departureOffsetSeconds": 3420
            },
            {
              "stopId": "judu:stop:5450",
              "position": {
                "x": -2366.341,
                "z": -3921.977
              },
              "distanceAlongShapeM": 23500.916,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3540,
              "departureOffsetSeconds": 3540
            },
            {
              "stopId": "judu:stop:5451",
              "position": {
                "x": -2289.819,
                "z": -3676.197
              },
              "distanceAlongShapeM": 23759.195,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3600,
              "departureOffsetSeconds": 3600
            },
            {
              "stopId": "judu:stop:5452",
              "position": {
                "x": -2044.086,
                "z": -2974.773
              },
              "distanceAlongShapeM": 24502.623,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3720,
              "departureOffsetSeconds": 3720
            },
            {
              "stopId": "judu:stop:5209",
              "position": {
                "x": -2092.806,
                "z": -2923.813
              },
              "distanceAlongShapeM": 24591.8,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3780,
              "departureOffsetSeconds": 3780
            },
            {
              "stopId": "judu:stop:5208",
              "position": {
                "x": -2215.841,
                "z": -3101.972
              },
              "distanceAlongShapeM": 25026.02,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3840,
              "departureOffsetSeconds": 3840
            },
            {
              "stopId": "judu:stop:5206",
              "position": {
                "x": -2195.778,
                "z": -3133.498
              },
              "distanceAlongShapeM": 25251.566,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3900,
              "departureOffsetSeconds": 3900
            }
          ],
          "departuresSeconds": [
            18900,
            20100,
            21780,
            23460,
            24720,
            26040,
            27360,
            28740,
            31620,
            32820,
            35220,
            36720,
            38580,
            39600,
            40860,
            42660,
            44640,
            45960,
            47220,
            48360,
            49800,
            51660,
            53460,
            55020,
            56220,
            57360,
            58440,
            59580,
            61080,
            64500,
            66060,
            67680,
            68520,
            69240,
            71100,
            72420,
            73800,
            75360,
            76860,
            78300,
            79740,
            81300
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_87:1",
          "sourceRouteId": "vilnius_bus_87",
          "sourceShapeId": "vilnius_bus_87_b-a",
          "directionId": 1,
          "headsign": "Ateities g.",
          "directionName": "Šeškinė–Bendorėliai–Riešė–Molėtų pl.–Ateities g.",
          "mode": "bus",
          "routeShortName": "87",
          "routeLongName": "Ateities g.–Molėtų pl.–Riešė–Bendorėliai–Šeškinė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2195.778,
              -3133.498,
              0
            ],
            [
              -2187.067,
              -3114.727,
              20.693
            ],
            [
              -2174.766,
              -3111.606,
              33.383
            ],
            [
              -1943.03,
              -3126.856,
              265.621
            ],
            [
              -1903.67,
              -3124.217,
              305.069
            ],
            [
              -1868.018,
              -3112.606,
              342.564
            ],
            [
              -1816.447,
              -3075.675,
              405.995
            ],
            [
              -1790.686,
              -3040.511,
              449.586
            ],
            [
              -1771.148,
              -2992.991,
              500.966
            ],
            [
              -1760.293,
              -2926.391,
              568.444
            ],
            [
              -1751.757,
              -2845.278,
              650.006
            ],
            [
              -1755.82,
              -2783.978,
              711.44
            ],
            [
              -1781.888,
              -2655.492,
              842.543
            ],
            [
              -1792.088,
              -2613.008,
              886.235
            ],
            [
              -1805.103,
              -2583.832,
              918.182
            ],
            [
              -1815.859,
              -2572.508,
              933.8
            ],
            [
              -1829.935,
              -2566.691,
              949.031
            ],
            [
              -1848.195,
              -2578.611,
              970.837
            ],
            [
              -1871.271,
              -2643.88,
              1040.066
            ],
            [
              -1912.507,
              -2715.506,
              1122.713
            ],
            [
              -1995.657,
              -2933.332,
              1355.87
            ],
            [
              -2020.861,
              -3009.696,
              1436.286
            ],
            [
              -2025.964,
              -3043.002,
              1469.981
            ],
            [
              -2242.142,
              -3640.305,
              2105.2
            ],
            [
              -2268.114,
              -3687.714,
              2159.256
            ],
            [
              -2346.255,
              -3915.653,
              2400.218
            ],
            [
              -2360.668,
              -3965.493,
              2452.1
            ],
            [
              -2466.817,
              -4247.487,
              2753.411
            ],
            [
              -2538.941,
              -4427.667,
              2947.49
            ],
            [
              -2556.572,
              -4477.451,
              3000.303
            ],
            [
              -2704.304,
              -4744.243,
              3305.267
            ],
            [
              -2811.577,
              -4909.336,
              3502.151
            ],
            [
              -2905.084,
              -5061.315,
              3680.591
            ],
            [
              -2916.619,
              -5094.508,
              3715.732
            ],
            [
              -2950.713,
              -5128.419,
              3763.818
            ],
            [
              -3045.536,
              -5245.867,
              3914.768
            ],
            [
              -3100.371,
              -5323.943,
              4010.176
            ],
            [
              -3306.232,
              -5566.356,
              4328.206
            ],
            [
              -3328.612,
              -5593.795,
              4363.614
            ],
            [
              -3341.197,
              -5613.613,
              4387.09
            ],
            [
              -3386.425,
              -5658.464,
              4450.786
            ],
            [
              -3498.767,
              -5784.52,
              4619.638
            ],
            [
              -3580.452,
              -5888.85,
              4752.142
            ],
            [
              -3613.93,
              -5925.003,
              4801.414
            ],
            [
              -3667.305,
              -5994.205,
              4888.808
            ],
            [
              -3747.187,
              -6106.361,
              5026.505
            ],
            [
              -4223.914,
              -6821.676,
              5886.123
            ],
            [
              -4263.049,
              -6887.792,
              5962.953
            ],
            [
              -4307.275,
              -6950.48,
              6039.672
            ],
            [
              -4409.742,
              -7104.56,
              6224.712
            ],
            [
              -4661.216,
              -7462.018,
              6661.765
            ],
            [
              -4717.852,
              -7535.629,
              6754.642
            ],
            [
              -4734.153,
              -7547.594,
              6774.863
            ],
            [
              -4803.927,
              -7636.564,
              6887.931
            ],
            [
              -4829.015,
              -7672.869,
              6932.061
            ],
            [
              -4835.152,
              -7692.802,
              6952.916
            ],
            [
              -4858.971,
              -7730.242,
              6997.291
            ],
            [
              -4884.932,
              -7779.891,
              7053.318
            ],
            [
              -4960.969,
              -7896.586,
              7192.6
            ],
            [
              -5171.533,
              -8275.925,
              7626.46
            ],
            [
              -5199.17,
              -8311.075,
              7671.174
            ],
            [
              -5290.938,
              -8445.318,
              7833.786
            ],
            [
              -5293.95,
              -8470.87,
              7859.515
            ],
            [
              -5287.8,
              -8487.674,
              7877.409
            ],
            [
              -5273.833,
              -8499.044,
              7895.419
            ],
            [
              -5261.702,
              -8504.818,
              7908.854
            ],
            [
              -5261.987,
              -8521.511,
              7925.55
            ],
            [
              -5279.212,
              -8550.16,
              7958.978
            ],
            [
              -5298.066,
              -8598.82,
              8011.163
            ],
            [
              -5327.11,
              -8754.173,
              8169.208
            ],
            [
              -5338.809,
              -8798.502,
              8215.054
            ],
            [
              -5444.763,
              -9048.28,
              8486.376
            ],
            [
              -5455.021,
              -9083.728,
              8523.278
            ],
            [
              -5493.78,
              -9167.672,
              8615.738
            ],
            [
              -5538.859,
              -9282.678,
              8739.263
            ],
            [
              -5643.866,
              -9705.024,
              9174.468
            ],
            [
              -5654.709,
              -9774.972,
              9245.251
            ],
            [
              -5665.097,
              -9893.909,
              9364.641
            ],
            [
              -5664.019,
              -9981.871,
              9452.61
            ],
            [
              -5586.115,
              -10848.165,
              10322.399
            ],
            [
              -5504.608,
              -11274.802,
              10756.753
            ],
            [
              -5373.594,
              -11776.873,
              11275.636
            ],
            [
              -5321.684,
              -12013.763,
              11518.146
            ],
            [
              -5313.143,
              -12078.476,
              11583.42
            ],
            [
              -5305.097,
              -12172.124,
              11677.413
            ],
            [
              -5289.824,
              -12557.559,
              12063.151
            ],
            [
              -5284.171,
              -12565.448,
              12072.857
            ],
            [
              -5250.911,
              -12576.036,
              12107.761
            ],
            [
              -5110.762,
              -12616.287,
              12253.575
            ],
            [
              -5079.356,
              -12622.392,
              12285.57
            ],
            [
              -5043.092,
              -12645.278,
              12328.451
            ],
            [
              -4939.103,
              -12693.82,
              12443.212
            ],
            [
              -4883.141,
              -12730.405,
              12510.072
            ],
            [
              -4850.736,
              -12753.227,
              12549.706
            ],
            [
              -4598.768,
              -12983.554,
              12891.084
            ],
            [
              -4430.33,
              -13134.524,
              13117.277
            ],
            [
              -4361.11,
              -13184.704,
              13202.773
            ],
            [
              -4138.011,
              -13334.406,
              13471.443
            ],
            [
              -4051.073,
              -13363.748,
              13563.199
            ],
            [
              -3978.104,
              -13382.829,
              13638.621
            ],
            [
              -3908.175,
              -13391.839,
              13709.129
            ],
            [
              -3861.231,
              -13391.544,
              13756.073
            ],
            [
              -3812.263,
              -13385.718,
              13805.387
            ],
            [
              -3768.923,
              -13370.889,
              13851.193
            ],
            [
              -3721.785,
              -13359.466,
              13899.695
            ],
            [
              -3681.153,
              -13352.383,
              13940.941
            ],
            [
              -3631.638,
              -13352.135,
              13990.456
            ],
            [
              -3604.075,
              -13357.07,
              14018.457
            ],
            [
              -3442.285,
              -13371.034,
              14180.849
            ],
            [
              -3399.821,
              -13369.552,
              14223.339
            ],
            [
              -3225.094,
              -13342.561,
              14400.138
            ],
            [
              -3029.835,
              -13318.165,
              14596.915
            ],
            [
              -1907.218,
              -13214.508,
              15724.308
            ],
            [
              -1717.167,
              -13194.529,
              15915.406
            ],
            [
              -1629.703,
              -13193.869,
              16002.873
            ],
            [
              -1625.786,
              -13190.6,
              16007.975
            ],
            [
              -1620.264,
              -13169.547,
              16029.74
            ],
            [
              -1607.037,
              -13077.385,
              16122.846
            ],
            [
              -1530.762,
              -12876.142,
              16338.059
            ],
            [
              -1386.063,
              -12518.049,
              16724.282
            ],
            [
              -1244.556,
              -12195.527,
              17076.482
            ],
            [
              -985.72,
              -11538.926,
              17782.259
            ],
            [
              -963.896,
              -11505.922,
              17821.826
            ],
            [
              -930.958,
              -11427.477,
              17906.906
            ],
            [
              -754.749,
              -10897.419,
              18465.485
            ],
            [
              -734.87,
              -10865.494,
              18503.093
            ],
            [
              -630.078,
              -10621.366,
              18768.762
            ],
            [
              -582.831,
              -10464.141,
              18932.932
            ],
            [
              -580.296,
              -10430.79,
              18966.38
            ],
            [
              -561.098,
              -10401.08,
              19001.753
            ],
            [
              -546.903,
              -10363.488,
              19041.936
            ],
            [
              -543.003,
              -10361.332,
              19046.392
            ],
            [
              -532.692,
              -10360.406,
              19056.745
            ],
            [
              -526.842,
              -10357.172,
              19063.429
            ],
            [
              -520.046,
              -10337.257,
              19084.472
            ],
            [
              -485.005,
              -10285.571,
              19146.917
            ],
            [
              -486.854,
              -10281.084,
              19151.77
            ],
            [
              -495.717,
              -10273.13,
              19163.679
            ],
            [
              -494.973,
              -10267.578,
              19169.281
            ],
            [
              -456.031,
              -10213.736,
              19235.73
            ],
            [
              -433.052,
              -10188.549,
              19269.824
            ],
            [
              -425.111,
              -10176.447,
              19284.299
            ],
            [
              -422.857,
              -10158.676,
              19302.212
            ],
            [
              -447.889,
              -10013.499,
              19449.532
            ],
            [
              -544.206,
              -9576.471,
              19897.047
            ],
            [
              -555.299,
              -9513.928,
              19960.566
            ],
            [
              -562.717,
              -9497.095,
              19978.961
            ],
            [
              -566.009,
              -9430.241,
              20045.897
            ],
            [
              -581.42,
              -9286.353,
              20190.608
            ],
            [
              -582.35,
              -9053.668,
              20423.295
            ],
            [
              -573.293,
              -8909.11,
              20568.136
            ],
            [
              -580.308,
              -8870.019,
              20607.851
            ],
            [
              -573.871,
              -8834.512,
              20643.937
            ],
            [
              -566.291,
              -8522.941,
              20955.6
            ],
            [
              -563.836,
              -8494.041,
              20984.604
            ],
            [
              -567.816,
              -8465.025,
              21013.892
            ],
            [
              -535.864,
              -7874.472,
              21605.309
            ],
            [
              -539.071,
              -7696.295,
              21783.514
            ],
            [
              -529.998,
              -7657.496,
              21823.36
            ],
            [
              -539.024,
              -7587.198,
              21894.235
            ],
            [
              -551.05,
              -7540.224,
              21942.724
            ],
            [
              -600.885,
              -7412.411,
              22079.909
            ],
            [
              -641.916,
              -7331.515,
              22170.616
            ],
            [
              -699.26,
              -7226.946,
              22289.877
            ],
            [
              -700.949,
              -7213.556,
              22303.372
            ],
            [
              -541.073,
              -7167.469,
              22469.759
            ],
            [
              -513.796,
              -7154.605,
              22499.917
            ],
            [
              -492.955,
              -7141.624,
              22524.47
            ],
            [
              -472.94,
              -7138.647,
              22544.705
            ],
            [
              -433.975,
              -7120.429,
              22587.718
            ],
            [
              -356.786,
              -7053.923,
              22689.607
            ],
            [
              -147.918,
              -6864.018,
              22971.9
            ],
            [
              -119.568,
              -6827.798,
              23017.896
            ],
            [
              -100.778,
              -6821.461,
              23037.726
            ],
            [
              -58.991,
              -6789.938,
              23090.07
            ],
            [
              -47.763,
              -6774.558,
              23109.113
            ],
            [
              -41.021,
              -6757.982,
              23127.007
            ],
            [
              -44.133,
              -6716.735,
              23168.371
            ],
            [
              -50.829,
              -6695.462,
              23190.674
            ],
            [
              -48.526,
              -6639.841,
              23246.341
            ],
            [
              -52.099,
              -6588.567,
              23297.74
            ],
            [
              -70.555,
              -6505.85,
              23382.491
            ],
            [
              -125.166,
              -6286.66,
              23608.382
            ],
            [
              -158.525,
              -6137.991,
              23760.747
            ],
            [
              -182.398,
              -6069.649,
              23833.14
            ],
            [
              -186.217,
              -6031.729,
              23871.251
            ],
            [
              -210.448,
              -5912.171,
              23993.24
            ],
            [
              -214.688,
              -5861.998,
              24043.592
            ],
            [
              -215.425,
              -5796.303,
              24109.29
            ],
            [
              -210.007,
              -5746.306,
              24159.58
            ],
            [
              -195.772,
              -5671.978,
              24235.259
            ],
            [
              -200.158,
              -5665.219,
              24243.317
            ],
            [
              -245.834,
              -5662.161,
              24289.095
            ],
            [
              -275.515,
              -5664.961,
              24318.907
            ],
            [
              -299.862,
              -5657.84,
              24344.275
            ],
            [
              -394.957,
              -5644.98,
              24440.236
            ],
            [
              -428.258,
              -5634.356,
              24475.19
            ],
            [
              -633.019,
              -5523.775,
              24707.903
            ],
            [
              -663.705,
              -5510.974,
              24741.152
            ],
            [
              -740.836,
              -5466.163,
              24830.355
            ],
            [
              -765.768,
              -5455.693,
              24857.396
            ],
            [
              -877.432,
              -5396.902,
              24983.591
            ],
            [
              -884.394,
              -5390.097,
              24993.327
            ],
            [
              -886.769,
              -5378.922,
              25004.752
            ],
            [
              -871.52,
              -5283.459,
              25101.426
            ],
            [
              -865.423,
              -5266.87,
              25119.099
            ],
            [
              -855.623,
              -5259.254,
              25131.51
            ],
            [
              -842.1,
              -5259.499,
              25145.036
            ],
            [
              -827.993,
              -5263.093,
              25159.593
            ],
            [
              -821.07,
              -5272.124,
              25170.972
            ],
            [
              -820.003,
              -5284.389,
              25183.283
            ],
            [
              -835.417,
              -5317.507,
              25219.813
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5206",
              "position": {
                "x": -2195.778,
                "z": -3133.498
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:1039",
              "position": {
                "x": -1871.271,
                "z": -2643.88
              },
              "distanceAlongShapeM": 1040.066,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:986",
              "position": {
                "x": -2025.964,
                "z": -3043.002
              },
              "distanceAlongShapeM": 1469.981,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:4388",
              "position": {
                "x": -2242.142,
                "z": -3640.305
              },
              "distanceAlongShapeM": 2105.2,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:823",
              "position": {
                "x": -2360.668,
                "z": -3965.493
              },
              "distanceAlongShapeM": 2452.1,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7897",
              "position": {
                "x": -2556.572,
                "z": -4477.451
              },
              "distanceAlongShapeM": 3000.303,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:446",
              "position": {
                "x": -2704.304,
                "z": -4744.243
              },
              "distanceAlongShapeM": 3305.267,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:481",
              "position": {
                "x": -2916.619,
                "z": -5094.508
              },
              "distanceAlongShapeM": 3715.732,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:9152",
              "position": {
                "x": -3341.197,
                "z": -5613.613
              },
              "distanceAlongShapeM": 4387.09,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7076",
              "position": {
                "x": -3580.452,
                "z": -5888.85
              },
              "distanceAlongShapeM": 4752.142,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:18721",
              "position": {
                "x": -4884.932,
                "z": -7779.891
              },
              "distanceAlongShapeM": 7053.318,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7080",
              "position": {
                "x": -5171.533,
                "z": -8275.925
              },
              "distanceAlongShapeM": 7626.46,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:10099",
              "position": {
                "x": -5455.021,
                "z": -9083.728
              },
              "distanceAlongShapeM": 8523.278,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:10097",
              "position": {
                "x": -5645.443,
                "z": -10175.887
              },
              "distanceAlongShapeM": 9647.509,
              "shapeOffsetM": 1.125,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:10095",
              "position": {
                "x": -5504.608,
                "z": -11274.802
              },
              "distanceAlongShapeM": 10756.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:10092",
              "position": {
                "x": -5373.594,
                "z": -11776.873
              },
              "distanceAlongShapeM": 11275.636,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:10089",
              "position": {
                "x": -5079.356,
                "z": -12622.392
              },
              "distanceAlongShapeM": 12285.57,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:10123",
              "position": {
                "x": -3631.638,
                "z": -13352.135
              },
              "distanceAlongShapeM": 13990.456,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7109",
              "position": {
                "x": -3029.835,
                "z": -13318.165
              },
              "distanceAlongShapeM": 14596.915,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7108",
              "position": {
                "x": -2108.818,
                "z": -13233.177
              },
              "distanceAlongShapeM": 15521.845,
              "shapeOffsetM": 0.053,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7106",
              "position": {
                "x": -1604.989,
                "z": -13070.742
              },
              "distanceAlongShapeM": 16129.784,
              "shapeOffsetM": 0.439,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:8325",
              "position": {
                "x": -1386.063,
                "z": -12518.049
              },
              "distanceAlongShapeM": 16724.282,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:7103",
              "position": {
                "x": -1244.556,
                "z": -12195.527
              },
              "distanceAlongShapeM": 17076.482,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7101",
              "position": {
                "x": -985.72,
                "z": -11538.926
              },
              "distanceAlongShapeM": 17782.259,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:7099",
              "position": {
                "x": -754.749,
                "z": -10897.419
              },
              "distanceAlongShapeM": 18465.485,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:7097",
              "position": {
                "x": -580.296,
                "z": -10430.79
              },
              "distanceAlongShapeM": 18966.38,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:8472",
              "position": {
                "x": -520.046,
                "z": -10337.257
              },
              "distanceAlongShapeM": 19084.472,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:7094",
              "position": {
                "x": -562.717,
                "z": -9497.095
              },
              "distanceAlongShapeM": 19978.961,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:7343",
              "position": {
                "x": -580.308,
                "z": -8870.019
              },
              "distanceAlongShapeM": 20607.851,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:7093",
              "position": {
                "x": -567.816,
                "z": -8465.025
              },
              "distanceAlongShapeM": 21013.892,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:16291",
              "position": {
                "x": -539.071,
                "z": -7696.295
              },
              "distanceAlongShapeM": 21783.514,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:8326",
              "position": {
                "x": -492.955,
                "z": -7141.624
              },
              "distanceAlongShapeM": 22524.47,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:8327",
              "position": {
                "x": -119.568,
                "z": -6827.798
              },
              "distanceAlongShapeM": 23017.896,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:6503",
              "position": {
                "x": -50.829,
                "z": -6695.462
              },
              "distanceAlongShapeM": 23190.674,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:6501",
              "position": {
                "x": -182.398,
                "z": -6069.649
              },
              "distanceAlongShapeM": 23833.14,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3360,
              "departureOffsetSeconds": 3360
            },
            {
              "stopId": "judu:stop:6640",
              "position": {
                "x": -275.515,
                "z": -5664.961
              },
              "distanceAlongShapeM": 24318.907,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3480,
              "departureOffsetSeconds": 3480
            },
            {
              "stopId": "judu:stop:6634",
              "position": {
                "x": -663.705,
                "z": -5510.974
              },
              "distanceAlongShapeM": 24741.152,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3540,
              "departureOffsetSeconds": 3540
            },
            {
              "stopId": "judu:stop:348",
              "position": {
                "x": -871.52,
                "z": -5283.459
              },
              "distanceAlongShapeM": 25101.426,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3660,
              "departureOffsetSeconds": 3660
            }
          ],
          "departuresSeconds": [
            17880,
            19200,
            20460,
            21780,
            22980,
            24180,
            25920,
            27360,
            28800,
            30240,
            31860,
            34500,
            36060,
            37080,
            38100,
            39660,
            41280,
            42840,
            44040,
            45360,
            47220,
            49140,
            50460,
            51780,
            52980,
            54600,
            56280,
            58020,
            59520,
            61560,
            62400,
            63300,
            64620,
            68220,
            69720,
            71280,
            72780,
            73980,
            75420,
            76740,
            78120,
            79560,
            80940,
            82260,
            83760
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_88",
      "sourceRouteId": "vilnius_bus_88",
      "mode": "bus",
      "shortName": "88",
      "longName": "Oro uostas–Centras–Europos aikštė",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_88:0",
          "sourceRouteId": "vilnius_bus_88",
          "sourceShapeId": "vilnius_bus_88_a-b",
          "directionId": 0,
          "headsign": "Europos aikštė",
          "directionName": "Oro uostas–Centras–Europos aikštė",
          "mode": "bus",
          "routeShortName": "88",
          "routeLongName": "Oro uostas–Centras–Europos aikštė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              190.96,
              4943.45,
              0
            ],
            [
              173.065,
              4882.548,
              63.476
            ],
            [
              169.736,
              4877.043,
              69.91
            ],
            [
              106.811,
              4896,
              135.629
            ],
            [
              65.284,
              4920.133,
              183.658
            ],
            [
              56.935,
              4922.512,
              192.34
            ],
            [
              38.922,
              4890.556,
              229.023
            ],
            [
              8.764,
              4794.253,
              329.937
            ],
            [
              -10.098,
              4715.557,
              410.862
            ],
            [
              -20.79,
              4660.091,
              467.35
            ],
            [
              -26.278,
              4606.755,
              520.967
            ],
            [
              -28.3,
              4495.47,
              632.271
            ],
            [
              -27.162,
              4273.918,
              853.826
            ],
            [
              -18.208,
              4269.302,
              863.899
            ],
            [
              130.759,
              4261.026,
              1013.096
            ],
            [
              341.111,
              4256.078,
              1223.507
            ],
            [
              343.708,
              4221.52,
              1258.161
            ],
            [
              366.01,
              4064.148,
              1417.106
            ],
            [
              363.124,
              4047.502,
              1434
            ],
            [
              389.082,
              3807.684,
              1675.219
            ],
            [
              406.919,
              3759.489,
              1726.609
            ],
            [
              430.163,
              3724.555,
              1768.57
            ],
            [
              456.693,
              3692.899,
              1809.872
            ],
            [
              510.785,
              3650.72,
              1878.465
            ],
            [
              565.222,
              3627.459,
              1937.664
            ],
            [
              683.997,
              3593,
              2061.337
            ],
            [
              739.323,
              3583.079,
              2117.545
            ],
            [
              805.719,
              3578.521,
              2184.097
            ],
            [
              892.824,
              3576.921,
              2271.217
            ],
            [
              954.888,
              3582.459,
              2333.527
            ],
            [
              1096.827,
              3614.356,
              2479.006
            ],
            [
              1674.798,
              3769.542,
              3077.449
            ],
            [
              1677.927,
              3729.408,
              3117.705
            ],
            [
              1684.234,
              3721.498,
              3127.822
            ],
            [
              1678.221,
              3710.477,
              3140.377
            ],
            [
              1677.947,
              3591.366,
              3259.489
            ],
            [
              1696.885,
              3464.105,
              3388.15
            ],
            [
              1701.035,
              3409.48,
              3442.933
            ],
            [
              1703.03,
              3134.473,
              3717.947
            ],
            [
              1699.891,
              3104.474,
              3748.11
            ],
            [
              1687.994,
              3054.599,
              3799.385
            ],
            [
              1659.262,
              3001.697,
              3859.586
            ],
            [
              1605.061,
              2932.568,
              3947.43
            ],
            [
              1556.997,
              2881.137,
              4017.824
            ],
            [
              1484.111,
              2813.466,
              4117.281
            ],
            [
              1478.744,
              2802.433,
              4129.55
            ],
            [
              1453.839,
              2781.743,
              4161.928
            ],
            [
              1433.991,
              2755.392,
              4194.917
            ],
            [
              1428.563,
              2741.021,
              4210.28
            ],
            [
              1397.31,
              2621.369,
              4333.946
            ],
            [
              1363.781,
              2448.324,
              4510.209
            ],
            [
              1344.313,
              2407.494,
              4555.442
            ],
            [
              1234.304,
              2215.824,
              4776.439
            ],
            [
              1203.934,
              2178.534,
              4824.531
            ],
            [
              1224.883,
              2194.846,
              4851.082
            ],
            [
              958.108,
              1933.7,
              5224.399
            ],
            [
              922.174,
              1874.247,
              5293.869
            ],
            [
              898.105,
              1863.557,
              5320.204
            ],
            [
              862.14,
              1837.501,
              5364.616
            ],
            [
              825.163,
              1791.425,
              5423.695
            ],
            [
              799.305,
              1718.426,
              5501.138
            ],
            [
              783.991,
              1657.48,
              5563.979
            ],
            [
              776.254,
              1587.488,
              5634.397
            ],
            [
              718.067,
              1580.764,
              5692.971
            ],
            [
              677.252,
              1571.494,
              5734.826
            ],
            [
              534.824,
              1579.67,
              5877.489
            ],
            [
              500.201,
              1591.437,
              5914.056
            ],
            [
              472.7,
              1534.052,
              5977.69
            ],
            [
              453.691,
              1517.701,
              6002.764
            ],
            [
              360.424,
              1427.008,
              6132.856
            ],
            [
              315.899,
              1391.085,
              6190.066
            ],
            [
              256.42,
              1348.755,
              6263.069
            ],
            [
              223.566,
              1315.958,
              6309.492
            ],
            [
              196.476,
              1280.829,
              6353.854
            ],
            [
              149.248,
              1202.651,
              6445.19
            ],
            [
              55.081,
              1061.873,
              6614.559
            ],
            [
              52.802,
              1042.989,
              6633.579
            ],
            [
              42.322,
              1034.274,
              6647.209
            ],
            [
              29.685,
              1013.353,
              6671.651
            ],
            [
              17.226,
              966.824,
              6719.819
            ],
            [
              -2.949,
              921.549,
              6769.386
            ],
            [
              -20.167,
              826.124,
              6866.351
            ],
            [
              -26.358,
              769.462,
              6923.351
            ],
            [
              -34.886,
              726.201,
              6967.444
            ],
            [
              -34.25,
              619.32,
              7074.328
            ],
            [
              -49.15,
              509.381,
              7185.272
            ],
            [
              -51.111,
              437.057,
              7257.623
            ],
            [
              -46.759,
              428.072,
              7267.606
            ],
            [
              -39.768,
              422.378,
              7276.622
            ],
            [
              18.234,
              348.963,
              7370.185
            ],
            [
              36.62,
              260.682,
              7460.36
            ],
            [
              56.855,
              132.292,
              7590.335
            ],
            [
              59.373,
              128.907,
              7594.554
            ],
            [
              70.978,
              128.695,
              7606.161
            ],
            [
              102.671,
              133.684,
              7638.244
            ],
            [
              116.145,
              94.475,
              7679.704
            ],
            [
              129.88,
              -107.271,
              7881.916
            ],
            [
              116.846,
              -256.206,
              8031.421
            ],
            [
              117.887,
              -305.208,
              8080.433
            ],
            [
              127.989,
              -387.771,
              8163.613
            ],
            [
              138.319,
              -422.47,
              8199.816
            ],
            [
              150.182,
              -443.837,
              8224.256
            ],
            [
              177.186,
              -518.917,
              8304.044
            ],
            [
              187.997,
              -562.53,
              8348.978
            ],
            [
              214.213,
              -645.388,
              8435.884
            ],
            [
              224.323,
              -656.705,
              8451.059
            ],
            [
              237.149,
              -695.903,
              8492.302
            ],
            [
              236.925,
              -708.144,
              8504.545
            ],
            [
              229.693,
              -715.805,
              8515.081
            ],
            [
              23.734,
              -765.484,
              8726.946
            ],
            [
              -53.078,
              -805.275,
              8813.453
            ],
            [
              -93.184,
              -812.338,
              8854.177
            ],
            [
              -182.323,
              -856.36,
              8953.593
            ],
            [
              -201.117,
              -861.585,
              8973.1
            ],
            [
              -349.798,
              -953.511,
              9147.904
            ],
            [
              -450.734,
              -1008.456,
              9262.826
            ],
            [
              -402.133,
              -1137.359,
              9400.586
            ],
            [
              -391.115,
              -1134.219,
              9412.043
            ],
            [
              -261.739,
              -1075.338,
              9554.188
            ],
            [
              -135.883,
              -997.471,
              9702.184
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9750",
              "position": {
                "x": 366.01,
                "z": 4064.148
              },
              "distanceAlongShapeM": 1417.106,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5998",
              "position": {
                "x": 1684.234,
                "z": 3721.498
              },
              "distanceAlongShapeM": 3127.822,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5947",
              "position": {
                "x": 1478.744,
                "z": 2802.433
              },
              "distanceAlongShapeM": 4129.55,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5945",
              "position": {
                "x": 1224.883,
                "z": 2194.846
              },
              "distanceAlongShapeM": 4851.082,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5942",
              "position": {
                "x": 922.174,
                "z": 1874.247
              },
              "distanceAlongShapeM": 5293.869,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:15581",
              "position": {
                "x": 677.252,
                "z": 1571.494
              },
              "distanceAlongShapeM": 5734.826,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 5977.69,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 6633.579,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 6923.351,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 7370.185,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 7679.704,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 8224.256,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 8813.453,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            }
          ],
          "departuresSeconds": [
            19140,
            20640,
            22440,
            24060,
            25740,
            27420,
            29160,
            30900,
            32700,
            34500,
            36300,
            41700,
            44340,
            46740,
            49140,
            51540,
            54180,
            56760,
            58560,
            60360,
            62160,
            63960,
            65760,
            67560,
            69420,
            73080,
            74940,
            77280,
            79500,
            81660,
            83820,
            86040,
            88260
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_88:1",
          "sourceRouteId": "vilnius_bus_88",
          "sourceShapeId": "vilnius_bus_88_b-a",
          "directionId": 1,
          "headsign": "Oro uostas",
          "directionName": "Europos aikštė–Centras–Oro uostas",
          "mode": "bus",
          "routeShortName": "88",
          "routeLongName": "Oro uostas–Centras–Europos aikštė",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -144.948,
              -999.533,
              0
            ],
            [
              -111.147,
              -984.562,
              36.968
            ],
            [
              -194.732,
              -865.04,
              182.817
            ],
            [
              -199.062,
              -854.943,
              193.804
            ],
            [
              -193.763,
              -847.246,
              203.147
            ],
            [
              -168.966,
              -830.998,
              232.794
            ],
            [
              -118.847,
              -805.192,
              289.167
            ],
            [
              -82.324,
              -782.478,
              332.176
            ],
            [
              -42.035,
              -765.399,
              375.936
            ],
            [
              224.176,
              -700.119,
              650.034
            ],
            [
              211.01,
              -644.216,
              707.465
            ],
            [
              143.71,
              -480.456,
              884.515
            ],
            [
              121.213,
              -441.083,
              929.862
            ],
            [
              106.146,
              -277.163,
              1094.473
            ],
            [
              46.11,
              -280.522,
              1154.603
            ],
            [
              26.146,
              -279.045,
              1174.622
            ],
            [
              15.43,
              -265.491,
              1191.9
            ],
            [
              14.363,
              -253.226,
              1204.212
            ],
            [
              16.439,
              -245.471,
              1212.239
            ],
            [
              45.916,
              -220.403,
              1250.934
            ],
            [
              103.215,
              -190.277,
              1315.67
            ],
            [
              127.382,
              -102.772,
              1406.451
            ],
            [
              121.848,
              -52.576,
              1456.952
            ],
            [
              115.041,
              -36.866,
              1474.073
            ],
            [
              117.583,
              -3.516,
              1507.52
            ],
            [
              102.671,
              133.684,
              1645.528
            ],
            [
              63.181,
              125.497,
              1685.858
            ],
            [
              59.312,
              125.568,
              1689.727
            ],
            [
              57.419,
              127.829,
              1692.676
            ],
            [
              31.786,
              278.582,
              1845.593
            ],
            [
              4.856,
              358.112,
              1929.558
            ],
            [
              -8.924,
              380.627,
              1955.956
            ],
            [
              -39.768,
              422.378,
              2007.864
            ],
            [
              -46.8,
              425.846,
              2015.705
            ],
            [
              -51.212,
              431.492,
              2022.871
            ],
            [
              -51.307,
              497.175,
              2088.553
            ],
            [
              -56,
              522.864,
              2114.668
            ],
            [
              -44.593,
              547.148,
              2141.497
            ],
            [
              -34.25,
              619.32,
              2214.406
            ],
            [
              -34.886,
              726.201,
              2321.29
            ],
            [
              -29.964,
              784,
              2379.297
            ],
            [
              -31.514,
              805.179,
              2400.534
            ],
            [
              -24.076,
              823.969,
              2420.742
            ],
            [
              -6.94,
              914.942,
              2513.315
            ],
            [
              5.94,
              949.218,
              2549.93
            ],
            [
              14.89,
              980.225,
              2582.204
            ],
            [
              17.976,
              1008,
              2610.149
            ],
            [
              98.858,
              1127.869,
              2754.754
            ],
            [
              206.575,
              1304.022,
              2961.232
            ],
            [
              266.256,
              1357.482,
              3041.355
            ],
            [
              337.506,
              1408.502,
              3128.988
            ],
            [
              360.424,
              1427.008,
              3158.445
            ],
            [
              406.382,
              1470.698,
              3221.855
            ],
            [
              500.704,
              1583.635,
              3369
            ],
            [
              509.834,
              1589.034,
              3379.607
            ],
            [
              522.692,
              1586.572,
              3392.699
            ],
            [
              534.824,
              1579.67,
              3406.656
            ],
            [
              580.051,
              1583.295,
              3452.028
            ],
            [
              676.126,
              1580.42,
              3548.146
            ],
            [
              720.084,
              1585.18,
              3592.361
            ],
            [
              776.254,
              1587.488,
              3648.579
            ],
            [
              769.19,
              1624.355,
              3686.116
            ],
            [
              781.269,
              1649.737,
              3714.226
            ],
            [
              802.898,
              1738.399,
              3805.488
            ],
            [
              825.163,
              1791.425,
              3862.999
            ],
            [
              862.14,
              1837.501,
              3922.078
            ],
            [
              869.06,
              1862.978,
              3948.478
            ],
            [
              873.401,
              1888.503,
              3974.369
            ],
            [
              889.31,
              1911.588,
              4002.405
            ],
            [
              908.823,
              1920.135,
              4023.708
            ],
            [
              941.154,
              1923.993,
              4056.269
            ],
            [
              953.593,
              1933.783,
              4072.099
            ],
            [
              1083.618,
              2057.184,
              4251.359
            ],
            [
              1196.071,
              2172,
              4412.07
            ],
            [
              1233.034,
              2216.96,
              4470.275
            ],
            [
              1262.402,
              2269.853,
              4530.774
            ],
            [
              1272.571,
              2296.383,
              4559.186
            ],
            [
              1295.641,
              2322.675,
              4594.164
            ],
            [
              1353.693,
              2426.246,
              4712.895
            ],
            [
              1363.843,
              2451.663,
              4740.263
            ],
            [
              1395.21,
              2612.502,
              4904.133
            ],
            [
              1412.03,
              2684.551,
              4978.119
            ],
            [
              1428.563,
              2741.021,
              5036.959
            ],
            [
              1438.754,
              2768.663,
              5066.42
            ],
            [
              1466.069,
              2814.913,
              5120.134
            ],
            [
              1480.947,
              2816.864,
              5135.14
            ],
            [
              1584.045,
              2912.919,
              5276.05
            ],
            [
              1624.327,
              2962.268,
              5339.752
            ],
            [
              1644.883,
              2991.944,
              5375.852
            ],
            [
              1682.229,
              3056.932,
              5450.807
            ],
            [
              1693.837,
              3091.227,
              5487.013
            ],
            [
              1697.848,
              3133.456,
              5529.432
            ],
            [
              1698.943,
              3192.437,
              5588.423
            ],
            [
              1697.261,
              3310.472,
              5706.47
            ],
            [
              1700.204,
              3399.476,
              5795.523
            ],
            [
              1674.097,
              3592.551,
              5990.354
            ],
            [
              1669.889,
              3748.482,
              6146.342
            ],
            [
              1617.274,
              3730.533,
              6201.935
            ],
            [
              1602.913,
              3721.893,
              6218.694
            ],
            [
              1586.762,
              3721.079,
              6234.866
            ],
            [
              1086.216,
              3598.966,
              6750.092
            ],
            [
              972.811,
              3574.337,
              6866.141
            ],
            [
              908.77,
              3566.608,
              6930.646
            ],
            [
              815.757,
              3562.751,
              7023.74
            ],
            [
              771.943,
              3566.895,
              7067.749
            ],
            [
              685.084,
              3581.848,
              7155.886
            ],
            [
              566.974,
              3617.408,
              7279.232
            ],
            [
              386.18,
              3684.169,
              7471.959
            ],
            [
              313.695,
              3708.87,
              7548.538
            ],
            [
              296.98,
              3712.515,
              7565.646
            ],
            [
              262.055,
              3708.699,
              7600.778
            ],
            [
              231.242,
              3682.544,
              7641.195
            ],
            [
              228.738,
              3651.419,
              7672.42
            ],
            [
              239.2,
              3623.397,
              7702.331
            ],
            [
              258.938,
              3608.566,
              7727.02
            ],
            [
              278.193,
              3602.648,
              7747.164
            ],
            [
              304.708,
              3605.504,
              7773.833
            ],
            [
              321.687,
              3616.326,
              7793.967
            ],
            [
              336.289,
              3638.324,
              7820.37
            ],
            [
              367.859,
              3741.278,
              7928.056
            ],
            [
              373.006,
              3775.694,
              7962.855
            ],
            [
              376.156,
              3806.807,
              7994.127
            ],
            [
              342.825,
              4102.421,
              8291.614
            ],
            [
              333.674,
              4131.532,
              8322.129
            ],
            [
              328.708,
              4248.511,
              8439.214
            ],
            [
              -16.313,
              4267.041,
              8784.732
            ],
            [
              -27.868,
              4270.591,
              8796.82
            ],
            [
              -30.045,
              4292.895,
              8819.23
            ],
            [
              -28.186,
              4359.654,
              8886.016
            ],
            [
              -33.24,
              4507.805,
              9034.252
            ],
            [
              -26.822,
              4612.332,
              9138.976
            ],
            [
              -9.27,
              4725.561,
              9253.558
            ],
            [
              19.778,
              4831.903,
              9363.795
            ],
            [
              33.779,
              4891.762,
              9425.27
            ],
            [
              49.008,
              4912.637,
              9451.11
            ],
            [
              65.892,
              4953.519,
              9495.341
            ],
            [
              77.939,
              5047.924,
              9590.512
            ],
            [
              190.244,
              5045.879,
              9702.835
            ],
            [
              184.689,
              4953.583,
              9795.298
            ],
            [
              190.96,
              4943.45,
              9807.215
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 375.936,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 929.862,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 1474.073,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 2114.668,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 2610.149,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 2961.232,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 3452.028,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6714",
              "position": {
                "x": 769.19,
                "z": 1624.355
              },
              "distanceAlongShapeM": 3686.116,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5941",
              "position": {
                "x": 889.31,
                "z": 1911.588
              },
              "distanceAlongShapeM": 4002.405,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5944",
              "position": {
                "x": 1272.571,
                "z": 2296.383
              },
              "distanceAlongShapeM": 4559.186,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5946",
              "position": {
                "x": 1466.069,
                "z": 2814.913
              },
              "distanceAlongShapeM": 5120.134,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:16978",
              "position": {
                "x": 1602.913,
                "z": 3721.893
              },
              "distanceAlongShapeM": 6218.694,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:9738",
              "position": {
                "x": 333.674,
                "z": 4131.532
              },
              "distanceAlongShapeM": 8322.129,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 9807.215,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            21480,
            23580,
            24840,
            26340,
            28380,
            29760,
            32040,
            33660,
            35580,
            37140,
            39120,
            44580,
            46800,
            49380,
            51780,
            54300,
            56700,
            59580,
            61320,
            63180,
            65040,
            66540,
            68820,
            70440,
            72420,
            75360,
            77520,
            79740,
            81900,
            84060,
            86400,
            88380,
            90540
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_89",
      "sourceRouteId": "vilnius_bus_89",
      "mode": "bus",
      "shortName": "89",
      "longName": "Nepriklausomybės aikštė–Senamiestis–Drujos g.–Stotis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_89:0",
          "sourceRouteId": "vilnius_bus_89",
          "sourceShapeId": "vilnius_bus_89_a1-b1",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Nepriklausomybės aikštė–Senamiestis–Drujos g.–Stotis",
          "mode": "bus",
          "routeShortName": "89",
          "routeLongName": "Nepriklausomybės aikštė–Senamiestis–Drujos g.–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -1089.899,
              -409.142,
              0
            ],
            [
              -881.279,
              -355.007,
              215.529
            ],
            [
              -857.097,
              -444.501,
              308.232
            ],
            [
              -850.143,
              -488.042,
              352.325
            ],
            [
              -859.203,
              -561.352,
              426.192
            ],
            [
              -900.035,
              -572.862,
              468.616
            ],
            [
              -908.595,
              -582.727,
              481.677
            ],
            [
              -919.624,
              -908.704,
              807.841
            ],
            [
              -906.184,
              -950.135,
              851.397
            ],
            [
              -902.638,
              -968.011,
              869.621
            ],
            [
              -906.763,
              -1018.032,
              919.812
            ],
            [
              -903.416,
              -1047.036,
              949.009
            ],
            [
              -876.342,
              -1083.147,
              994.142
            ],
            [
              -864.236,
              -1091.158,
              1008.659
            ],
            [
              -845.624,
              -1095.946,
              1027.876
            ],
            [
              -813.336,
              -1093.188,
              1060.282
            ],
            [
              -786.145,
              -1086.999,
              1088.169
            ],
            [
              -775.751,
              -1082.734,
              1099.403
            ],
            [
              -717.641,
              -1078.217,
              1157.689
            ],
            [
              -647.083,
              -1062.792,
              1229.913
            ],
            [
              -599.769,
              -1049.176,
              1279.148
            ],
            [
              -511.525,
              -1018.488,
              1372.575
            ],
            [
              -361.843,
              -942.16,
              1540.595
            ],
            [
              -333.702,
              -919.293,
              1576.856
            ],
            [
              -286.889,
              -897.877,
              1628.335
            ],
            [
              -196.966,
              -846.075,
              1732.112
            ],
            [
              -115.583,
              -803.025,
              1824.18
            ],
            [
              -96.647,
              -790.01,
              1847.157
            ],
            [
              -42.035,
              -765.399,
              1907.058
            ],
            [
              224.8,
              -701.243,
              2181.497
            ],
            [
              237.149,
              -695.903,
              2194.952
            ],
            [
              292.85,
              -682.448,
              2252.255
            ],
            [
              331.506,
              -684.268,
              2290.954
            ],
            [
              436.802,
              -673.948,
              2396.754
            ],
            [
              647.48,
              -719,
              2612.195
            ],
            [
              718.871,
              -413.057,
              2926.357
            ],
            [
              707.215,
              -380.559,
              2960.882
            ],
            [
              685.601,
              -293.329,
              3050.749
            ],
            [
              645.363,
              9.096,
              3355.84
            ],
            [
              675.04,
              9.665,
              3385.522
            ],
            [
              707.88,
              6.836,
              3418.483
            ],
            [
              925.597,
              -42.81,
              3641.789
            ],
            [
              1129.224,
              -156.774,
              3875.138
            ],
            [
              1143.99,
              -160.386,
              3890.34
            ],
            [
              1610.786,
              -514.132,
              4476.032
            ],
            [
              1615.737,
              -525.357,
              4488.299
            ],
            [
              1648.803,
              -550.462,
              4529.816
            ],
            [
              1662.944,
              -552.951,
              4544.174
            ],
            [
              1695.279,
              -547.986,
              4576.888
            ],
            [
              1707.61,
              -543.762,
              4589.923
            ],
            [
              1715.531,
              -533.89,
              4602.58
            ],
            [
              1739.19,
              -475.328,
              4665.741
            ],
            [
              1739.832,
              -440.829,
              4700.245
            ],
            [
              1737.688,
              -417.411,
              4723.761
            ],
            [
              1728.721,
              -379.394,
              4762.821
            ],
            [
              1714.349,
              -354.636,
              4791.449
            ],
            [
              1709.957,
              -313.364,
              4832.954
            ],
            [
              1701.073,
              -270.896,
              4876.341
            ],
            [
              1691.292,
              -207.259,
              4940.725
            ],
            [
              1692.553,
              -139.375,
              5008.621
            ],
            [
              1699.889,
              -91.641,
              5056.915
            ],
            [
              1722.281,
              -31.942,
              5120.675
            ],
            [
              1763.619,
              40.763,
              5204.311
            ],
            [
              1781.292,
              89.417,
              5256.075
            ],
            [
              1803.689,
              114.605,
              5289.781
            ],
            [
              1864.141,
              209.22,
              5402.058
            ],
            [
              1913.636,
              269.526,
              5480.076
            ],
            [
              1990.962,
              334.88,
              5581.32
            ],
            [
              2015.503,
              371.16,
              5625.12
            ],
            [
              2052.586,
              388.28,
              5665.965
            ],
            [
              2087.216,
              412.125,
              5708.01
            ],
            [
              2136.967,
              451.273,
              5771.317
            ],
            [
              2182.309,
              496.069,
              5835.055
            ],
            [
              2210.658,
              528.937,
              5878.46
            ],
            [
              2229.877,
              556.409,
              5911.987
            ],
            [
              2244.749,
              592.868,
              5951.363
            ],
            [
              2266.569,
              621.404,
              5987.285
            ],
            [
              2281.67,
              670.105,
              6038.273
            ],
            [
              2285.519,
              703.43,
              6071.82
            ],
            [
              2286.06,
              732.364,
              6100.759
            ],
            [
              2274.704,
              814.957,
              6184.129
            ],
            [
              2261.392,
              861.962,
              6232.983
            ],
            [
              2144.257,
              1048.95,
              6453.63
            ],
            [
              2116.361,
              1075.075,
              6491.849
            ],
            [
              2077.146,
              1151.508,
              6577.754
            ],
            [
              1962.725,
              1277.211,
              6747.735
            ],
            [
              1820.714,
              1376.707,
              6921.132
            ],
            [
              1335.201,
              1600.566,
              7455.768
            ],
            [
              1290.364,
              1618.093,
              7503.91
            ],
            [
              1243.92,
              1653.461,
              7562.287
            ],
            [
              1199.83,
              1676.54,
              7612.053
            ],
            [
              1160.734,
              1690.621,
              7653.606
            ],
            [
              1108.739,
              1704.939,
              7707.537
            ],
            [
              1010.266,
              1717.886,
              7806.857
            ],
            [
              938.963,
              1734.784,
              7880.135
            ],
            [
              825.163,
              1791.425,
              8007.252
            ],
            [
              806.931,
              1747.23,
              8055.06
            ],
            [
              793.112,
              1697.389,
              8106.782
            ],
            [
              776.254,
              1587.488,
              8217.968
            ],
            [
              725.161,
              1580.634,
              8269.518
            ],
            [
              677.252,
              1571.494,
              8318.291
            ],
            [
              547.057,
              1578.333,
              8448.666
            ],
            [
              540.526,
              1574,
              8456.504
            ],
            [
              538.245,
              1555.117,
              8475.524
            ],
            [
              539.372,
              1546.19,
              8484.521
            ],
            [
              526.059,
              1488.546,
              8543.683
            ],
            [
              550.286,
              1402.383,
              8633.187
            ],
            [
              562.185,
              1347.617,
              8689.231
            ],
            [
              570.819,
              1290.684,
              8746.815
            ],
            [
              610.822,
              1291.064,
              8786.821
            ],
            [
              666.704,
              1277.793,
              8844.256
            ],
            [
              652.304,
              1231.302,
              8892.927
            ],
            [
              642.928,
              1212.549,
              8913.893
            ],
            [
              625.814,
              1193.937,
              8939.177
            ],
            [
              597.738,
              1175.527,
              8972.751
            ],
            [
              569.784,
              1163.794,
              9003.067
            ],
            [
              561.02,
              1178.426,
              9020.123
            ],
            [
              538.233,
              1202.222,
              9053.07
            ],
            [
              480.119,
              1234.456,
              9119.525
            ],
            [
              468.674,
              1243.572,
              9134.157
            ],
            [
              419.241,
              1362.479,
              9262.93
            ],
            [
              359.779,
              1427.02,
              9350.687
            ],
            [
              405.737,
              1470.709,
              9414.097
            ],
            [
              393.083,
              1484.3,
              9432.667
            ],
            [
              388.711,
              1492.172,
              9441.672
            ],
            [
              393.15,
              1523.261,
              9473.076
            ],
            [
              392.049,
              1568.924,
              9518.752
            ],
            [
              397.453,
              1582.184,
              9533.071
            ],
            [
              391.321,
              1670.242,
              9621.342
            ],
            [
              330.657,
              1810.504,
              9774.161
            ],
            [
              327.072,
              1826.155,
              9790.217
            ],
            [
              328.524,
              1835.034,
              9799.214
            ],
            [
              355.259,
              1885.754,
              9856.549
            ],
            [
              388.342,
              1930.792,
              9912.432
            ],
            [
              389.754,
              1937.446,
              9919.234
            ],
            [
              364.123,
              1982.443,
              9971.019
            ],
            [
              364.306,
              1992.459,
              9981.036
            ],
            [
              376.139,
              2004.488,
              9997.911
            ],
            [
              393.574,
              2005.283,
              10015.364
            ],
            [
              403.209,
              2002.88,
              10025.293
            ],
            [
              452.283,
              1969.699,
              10084.532
            ],
            [
              463.689,
              1958.358,
              10100.617
            ],
            [
              466.167,
              1952.747,
              10106.751
            ],
            [
              465.38,
              1944.969,
              10114.569
            ],
            [
              459.371,
              1933.946,
              10127.123
            ],
            [
              450.885,
              1928.535,
              10137.188
            ],
            [
              432.16,
              1927.765,
              10155.929
            ],
            [
              419.803,
              1922.424,
              10169.39
            ],
            [
              401.805,
              1926.093,
              10187.758
            ],
            [
              397.27,
              1925.063,
              10192.409
            ],
            [
              384.004,
              1905.267,
              10216.239
            ],
            [
              372.531,
              1877.646,
              10246.148
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9004",
              "position": {
                "x": -1089.899,
                "z": -409.142
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -660,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5534",
              "position": {
                "x": -902.638,
                "z": -968.011
              },
              "distanceAlongShapeM": 869.621,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 1099.403,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 1576.856,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 1907.058,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 2252.255,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7323",
              "position": {
                "x": 707.215,
                "z": -380.559
              },
              "distanceAlongShapeM": 2960.882,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 3418.483,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 3890.34,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 4476.032,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6565",
              "position": {
                "x": 1714.349,
                "z": -354.636
              },
              "distanceAlongShapeM": 4791.449,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6568",
              "position": {
                "x": 1781.292,
                "z": 89.417
              },
              "distanceAlongShapeM": 5256.075,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6571",
              "position": {
                "x": 2015.503,
                "z": 371.16
              },
              "distanceAlongShapeM": 5625.12,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6574",
              "position": {
                "x": 2244.749,
                "z": 592.868
              },
              "distanceAlongShapeM": 5951.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5925",
              "position": {
                "x": 2116.361,
                "z": 1075.075
              },
              "distanceAlongShapeM": 6491.849,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7841",
              "position": {
                "x": 1290.364,
                "z": 1618.093
              },
              "distanceAlongShapeM": 7503.91,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:15581",
              "position": {
                "x": 677.252,
                "z": 1571.494
              },
              "distanceAlongShapeM": 8318.291,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:9313",
              "position": {
                "x": 539.372,
                "z": 1546.19
              },
              "distanceAlongShapeM": 8484.521,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:17352",
              "position": {
                "x": 561.02,
                "z": 1178.426
              },
              "distanceAlongShapeM": 9020.123,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 9518.752,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:7573",
              "position": {
                "x": 355.259,
                "z": 1885.754
              },
              "distanceAlongShapeM": 9856.549,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            22200,
            24900,
            27900,
            32520,
            35700,
            38100,
            40800,
            43500,
            46200,
            48780,
            52020,
            54600,
            57600,
            60600,
            65700,
            68940,
            71400,
            74100,
            76800,
            79200
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_89:1",
          "sourceRouteId": "vilnius_bus_89",
          "sourceShapeId": "vilnius_bus_89_b1-a1",
          "directionId": 1,
          "headsign": "Nepriklausomybės aikštė (Apylanka per Bazilijonų st.)",
          "directionName": "Stotis–Drujos g.–Senamiestis–Nepriklausomybės aikštė (Apylanka per Bazilijonų st.)",
          "mode": "bus",
          "routeShortName": "89",
          "routeLongName": "Nepriklausomybės aikštė–Senamiestis–Drujos g.–Stotis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              372.531,
              1877.646,
              0
            ],
            [
              359.991,
              1862.29,
              19.825
            ],
            [
              332.13,
              1820.496,
              70.055
            ],
            [
              338.234,
              1801.46,
              90.046
            ],
            [
              385.278,
              1692.617,
              208.621
            ],
            [
              391.321,
              1670.242,
              231.797
            ],
            [
              474.682,
              1571.866,
              360.743
            ],
            [
              481.233,
              1577.312,
              369.262
            ],
            [
              491.817,
              1591.59,
              387.035
            ],
            [
              500.867,
              1592.538,
              396.134
            ],
            [
              516.202,
              1584.464,
              413.465
            ],
            [
              543.167,
              1577.291,
              441.368
            ],
            [
              539.372,
              1546.19,
              472.7
            ],
            [
              526.059,
              1488.546,
              531.862
            ],
            [
              550.286,
              1402.383,
              621.366
            ],
            [
              562.185,
              1347.617,
              677.41
            ],
            [
              570.819,
              1290.684,
              734.994
            ],
            [
              610.822,
              1291.064,
              774.999
            ],
            [
              666.704,
              1277.793,
              832.435
            ],
            [
              652.304,
              1231.302,
              881.105
            ],
            [
              642.928,
              1212.549,
              902.071
            ],
            [
              625.814,
              1193.937,
              927.355
            ],
            [
              597.738,
              1175.527,
              960.929
            ],
            [
              569.784,
              1163.794,
              991.246
            ],
            [
              550.927,
              1190.857,
              1024.231
            ],
            [
              535.009,
              1202.281,
              1043.824
            ],
            [
              490.899,
              1224.24,
              1093.097
            ],
            [
              467.968,
              1240.245,
              1121.061
            ],
            [
              461.017,
              1248.165,
              1131.599
            ],
            [
              443.734,
              1290.784,
              1177.589
            ],
            [
              419.241,
              1362.479,
              1253.352
            ],
            [
              468.301,
              1399.431,
              1314.772
            ],
            [
              480.921,
              1419.238,
              1338.258
            ],
            [
              514.98,
              1517.693,
              1442.437
            ],
            [
              520.065,
              1548.77,
              1473.928
            ],
            [
              526.216,
              1567.582,
              1493.72
            ],
            [
              534.824,
              1579.67,
              1508.56
            ],
            [
              542,
              1583.992,
              1516.936
            ],
            [
              580.051,
              1583.295,
              1554.994
            ],
            [
              658.651,
              1577.401,
              1633.815
            ],
            [
              692.229,
              1579.012,
              1667.431
            ],
            [
              741.428,
              1588.128,
              1717.467
            ],
            [
              775.609,
              1587.5,
              1751.655
            ],
            [
              809.668,
              1580.195,
              1786.488
            ],
            [
              847.494,
              1567.254,
              1826.467
            ],
            [
              881.41,
              1552.158,
              1863.59
            ],
            [
              944.603,
              1515.372,
              1936.71
            ],
            [
              979.224,
              1503.603,
              1973.277
            ],
            [
              987.526,
              1498.997,
              1982.771
            ],
            [
              1015.114,
              1490.696,
              2011.581
            ],
            [
              1169.279,
              1454.457,
              2169.949
            ],
            [
              1223.933,
              1444.542,
              2225.494
            ],
            [
              1245.249,
              1480.885,
              2267.627
            ],
            [
              1335.324,
              1607.243,
              2422.804
            ],
            [
              1396.909,
              1588.292,
              2487.239
            ],
            [
              1416.531,
              1567.89,
              2515.545
            ],
            [
              1502.107,
              1520.663,
              2613.288
            ],
            [
              1842.1,
              1381.875,
              2980.517
            ],
            [
              1893.84,
              1354.194,
              3039.197
            ],
            [
              1982.258,
              1286.866,
              3150.331
            ],
            [
              2054.989,
              1208.696,
              3257.103
            ],
            [
              2130.485,
              1105.982,
              3384.577
            ],
            [
              2171.861,
              1041.755,
              3460.979
            ],
            [
              2187.13,
              1030.337,
              3480.045
            ],
            [
              2200.048,
              996.698,
              3516.079
            ],
            [
              2297.211,
              845.707,
              3695.631
            ],
            [
              2377.645,
              731.764,
              3835.104
            ],
            [
              2390.041,
              704.814,
              3864.768
            ],
            [
              2393.451,
              680.258,
              3889.559
            ],
            [
              2387.751,
              651.421,
              3918.955
            ],
            [
              2369.175,
              623.937,
              3952.127
            ],
            [
              2305.672,
              573.917,
              4032.965
            ],
            [
              2269.605,
              542.307,
              4080.923
            ],
            [
              2256.376,
              524.743,
              4102.912
            ],
            [
              2223.804,
              507.54,
              4139.748
            ],
            [
              1990.962,
              334.88,
              4429.621
            ],
            [
              1973.014,
              306.27,
              4463.395
            ],
            [
              1935.827,
              283.585,
              4506.955
            ],
            [
              1864.599,
              199.192,
              4617.389
            ],
            [
              1763.619,
              40.763,
              4805.263
            ],
            [
              1759.816,
              9.663,
              4836.594
            ],
            [
              1734.841,
              -15.477,
              4872.031
            ],
            [
              1714.048,
              -58.507,
              4919.822
            ],
            [
              1702.489,
              -90.576,
              4953.911
            ],
            [
              1692.553,
              -139.375,
              5003.71
            ],
            [
              1696.284,
              -216.258,
              5080.684
            ],
            [
              1701.445,
              -250.864,
              5115.673
            ],
            [
              1720.689,
              -325.809,
              5193.049
            ],
            [
              1735.144,
              -346.116,
              5217.976
            ],
            [
              1742.617,
              -429.749,
              5301.941
            ],
            [
              1739.19,
              -475.328,
              5347.649
            ],
            [
              1717.531,
              -565.098,
              5439.995
            ],
            [
              1721.402,
              -599.681,
              5474.794
            ],
            [
              1716.683,
              -610.725,
              5486.804
            ],
            [
              1706.848,
              -619.449,
              5499.95
            ],
            [
              1695.162,
              -623.684,
              5512.38
            ],
            [
              1670.687,
              -622.116,
              5536.906
            ],
            [
              1655.278,
              -618.49,
              5552.735
            ],
            [
              1647.146,
              -604.98,
              5568.504
            ],
            [
              1647.435,
              -589.4,
              5584.087
            ],
            [
              1641.361,
              -569.249,
              5605.134
            ],
            [
              1626.241,
              -550.043,
              5629.577
            ],
            [
              1608.96,
              -543.043,
              5648.222
            ],
            [
              1227.773,
              -233.181,
              6139.463
            ],
            [
              1060.09,
              -128.781,
              6336.99
            ],
            [
              912.058,
              -42.561,
              6508.301
            ],
            [
              652.936,
              0.051,
              6770.903
            ],
            [
              646.469,
              -0.943,
              6777.447
            ],
            [
              667.023,
              -146.041,
              6923.993
            ],
            [
              673.645,
              -171.767,
              6950.558
            ],
            [
              684.82,
              -195.35,
              6976.655
            ],
            [
              683.338,
              -240.966,
              7022.294
            ],
            [
              694.504,
              -300.172,
              7082.545
            ],
            [
              716.179,
              -384.063,
              7169.191
            ],
            [
              718.871,
              -413.057,
              7198.309
            ],
            [
              701.12,
              -501.79,
              7288.8
            ],
            [
              662.621,
              -666.955,
              7458.393
            ],
            [
              647.48,
              -719,
              7512.595
            ],
            [
              508.13,
              -687.5,
              7655.461
            ],
            [
              443.852,
              -676.304,
              7720.706
            ],
            [
              405.738,
              -680.059,
              7759.005
            ],
            [
              364.219,
              -693.772,
              7802.73
            ],
            [
              341.718,
              -690.021,
              7825.541
            ],
            [
              238.113,
              -713.732,
              7931.825
            ],
            [
              219.901,
              -722.305,
              7951.954
            ],
            [
              73.653,
              -750.808,
              8100.954
            ],
            [
              36.063,
              -761.255,
              8139.969
            ],
            [
              -18.428,
              -779.188,
              8197.335
            ],
            [
              -53.078,
              -805.275,
              8240.707
            ],
            [
              -306.711,
              -924.235,
              8520.852
            ],
            [
              -475.993,
              -1014.678,
              8712.78
            ],
            [
              -534.689,
              -1051.466,
              8782.051
            ],
            [
              -673.187,
              -1080.133,
              8923.485
            ],
            [
              -763.423,
              -1114.127,
              9019.912
            ],
            [
              -829.227,
              -1116.28,
              9085.751
            ],
            [
              -865.018,
              -1134.559,
              9125.94
            ],
            [
              -891.825,
              -1155.228,
              9159.79
            ],
            [
              -898.431,
              -1164.015,
              9170.783
            ],
            [
              -907.595,
              -1171.642,
              9182.706
            ],
            [
              -917.363,
              -1177.032,
              9193.863
            ],
            [
              -929.65,
              -1179.038,
              9206.311
            ],
            [
              -961.877,
              -1178.457,
              9238.544
            ],
            [
              -977.306,
              -1175.953,
              9254.174
            ],
            [
              -995.797,
              -1164.488,
              9275.932
            ],
            [
              -1006.474,
              -1148.711,
              9294.982
            ],
            [
              -1017.615,
              -1122.906,
              9323.089
            ],
            [
              -1020.518,
              -1105.042,
              9341.187
            ],
            [
              -1018.304,
              -1089.497,
              9356.89
            ],
            [
              -1013.532,
              -1075.111,
              9372.047
            ],
            [
              -1005.537,
              -1060.783,
              9388.454
            ],
            [
              -990.532,
              -1051.034,
              9406.348
            ],
            [
              -973.897,
              -1022.389,
              9439.473
            ],
            [
              -968.48,
              -1008.015,
              9454.834
            ],
            [
              -969.129,
              -972.38,
              9490.475
            ],
            [
              -938.721,
              -895.001,
              9573.614
            ],
            [
              -924.604,
              -648.119,
              9820.899
            ],
            [
              -924.747,
              -620.286,
              9848.733
            ],
            [
              -931.518,
              -602.352,
              9867.902
            ],
            [
              -950.716,
              -594.214,
              9888.754
            ],
            [
              -959.096,
              -594.063,
              9897.136
            ],
            [
              -985.161,
              -609.179,
              9927.267
            ],
            [
              -1012.636,
              -630.95,
              9962.321
            ],
            [
              -1031.45,
              -637.291,
              9982.175
            ],
            [
              -1041.099,
              -636.004,
              9991.909
            ],
            [
              -1094.292,
              -545.99,
              10096.466
            ],
            [
              -1119.562,
              -480.969,
              10166.225
            ],
            [
              -1126.878,
              -457.46,
              10190.846
            ],
            [
              -1129.037,
              -434.043,
              10214.362
            ],
            [
              -1126.359,
              -428.525,
              10220.496
            ],
            [
              -1089.899,
              -409.142,
              10261.788
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4267",
              "position": {
                "x": 372.531,
                "z": 1877.646
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -360,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9313",
              "position": {
                "x": 539.372,
                "z": 1546.19
              },
              "distanceAlongShapeM": 472.7,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:17352",
              "position": {
                "x": 561.02,
                "z": 1178.426
              },
              "distanceAlongShapeM": 1008.261,
              "shapeOffsetM": 1.175,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5355",
              "position": {
                "x": 580.051,
                "z": 1583.295
              },
              "distanceAlongShapeM": 1554.994,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5358",
              "position": {
                "x": 979.224,
                "z": 1503.603
              },
              "distanceAlongShapeM": 1973.277,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6673",
              "position": {
                "x": 1245.249,
                "z": 1480.885
              },
              "distanceAlongShapeM": 2267.627,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7840",
              "position": {
                "x": 1396.909,
                "z": 1588.292
              },
              "distanceAlongShapeM": 2487.239,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:356",
              "position": {
                "x": 2187.13,
                "z": 1030.337
              },
              "distanceAlongShapeM": 3480.045,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6572",
              "position": {
                "x": 2256.376,
                "z": 524.743
              },
              "distanceAlongShapeM": 4102.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:449",
              "position": {
                "x": 1973.014,
                "z": 306.27
              },
              "distanceAlongShapeM": 4463.395,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:603",
              "position": {
                "x": 1759.816,
                "z": 9.663
              },
              "distanceAlongShapeM": 4836.594,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6566",
              "position": {
                "x": 1735.144,
                "z": -346.116
              },
              "distanceAlongShapeM": 5217.976,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 5648.222,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 6336.99,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7322",
              "position": {
                "x": 684.82,
                "z": -195.35
              },
              "distanceAlongShapeM": 6976.655,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 7802.73,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 8240.707,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 8782.051,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 9019.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5533",
              "position": {
                "x": -969.129,
                "z": -972.38
              },
              "distanceAlongShapeM": 9490.475,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:9004",
              "position": {
                "x": -1089.899,
                "z": -409.142
              },
              "distanceAlongShapeM": 10261.788,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            19620,
            22200,
            24900,
            27420,
            30660,
            35160,
            38220,
            40800,
            43500,
            46080,
            51360,
            54600,
            57600,
            60660,
            63900,
            68400,
            71400,
            74100,
            76500,
            79200,
            81900
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_114",
      "sourceRouteId": "vilnius_bus_114",
      "mode": "bus",
      "shortName": "114",
      "longName": "Šiaurės miestelis–Antakalnis–Mileišiškių –S.Kerbedžio g.–Dvarčionys–Vinciūniškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_114:0",
          "sourceRouteId": "vilnius_bus_114",
          "sourceShapeId": "vilnius_bus_114_a-b",
          "directionId": 0,
          "headsign": "Vinciūniškės",
          "directionName": "Šiaurės miestelis–Antakalnis–Mileišiškių –S.Kerbedžio g.–Dvarčionys–Vinciūniškės",
          "mode": "bus",
          "routeShortName": "114",
          "routeLongName": "Šiaurės miestelis–Antakalnis–Mileišiškių –S.Kerbedžio g.–Dvarčionys–Vinciūniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1412.698,
              -2538.791,
              0
            ],
            [
              1427.807,
              -2523.486,
              21.507
            ],
            [
              1492.99,
              -2519.128,
              86.835
            ],
            [
              1524.687,
              -2513.037,
              119.112
            ],
            [
              1547.822,
              -2516.806,
              142.552
            ],
            [
              1556.615,
              -2529.215,
              157.761
            ],
            [
              1556.64,
              -2562.613,
              191.158
            ],
            [
              1562.253,
              -2572.736,
              202.734
            ],
            [
              1574.454,
              -2575.189,
              215.179
            ],
            [
              1684.596,
              -2579.462,
              325.404
            ],
            [
              1689.647,
              -2585.122,
              332.99
            ],
            [
              1696.386,
              -2638.684,
              386.973
            ],
            [
              1690.652,
              -2669.748,
              418.563
            ],
            [
              1690.731,
              -2873.474,
              622.289
            ],
            [
              1700.851,
              -3126.37,
              875.387
            ],
            [
              1709.563,
              -3177.741,
              927.492
            ],
            [
              1701.896,
              -3208.77,
              959.453
            ],
            [
              1697.306,
              -3247.648,
              998.602
            ],
            [
              1679.831,
              -3286.287,
              1041.008
            ],
            [
              1593.247,
              -3437.193,
              1214.989
            ],
            [
              1582.257,
              -3473.726,
              1253.139
            ],
            [
              1566.424,
              -3493.47,
              1278.448
            ],
            [
              1520.486,
              -3572.771,
              1370.094
            ],
            [
              1584,
              -3657.444,
              1475.941
            ],
            [
              1660.25,
              -3750.148,
              1595.974
            ],
            [
              1866.498,
              -3989.997,
              1912.306
            ],
            [
              1889.999,
              -4008.247,
              1942.061
            ],
            [
              1892.95,
              -4022.775,
              1956.885
            ],
            [
              1975.005,
              -4114.479,
              2079.941
            ],
            [
              2057.826,
              -4199.52,
              2198.648
            ],
            [
              2170.271,
              -4319.627,
              2363.176
            ],
            [
              2237.981,
              -4385.463,
              2457.617
            ],
            [
              2278.639,
              -4416.283,
              2508.636
            ],
            [
              2288.882,
              -4419.815,
              2519.471
            ],
            [
              2297.234,
              -4421.084,
              2527.919
            ],
            [
              2310.823,
              -4417.999,
              2541.853
            ],
            [
              2320.672,
              -4408.165,
              2555.771
            ],
            [
              2330.583,
              -4394.991,
              2572.257
            ],
            [
              2336.672,
              -4379.52,
              2588.883
            ],
            [
              2336.174,
              -4371.718,
              2596.701
            ],
            [
              2346.709,
              -4359.67,
              2612.706
            ],
            [
              2358.18,
              -4332.053,
              2642.61
            ],
            [
              2390.982,
              -4163.454,
              2814.371
            ],
            [
              2453.858,
              -3937.529,
              3048.882
            ],
            [
              2472.257,
              -3849.927,
              3138.395
            ],
            [
              2499.323,
              -3746.903,
              3244.915
            ],
            [
              2506.601,
              -3702.509,
              3289.901
            ],
            [
              2508.663,
              -3661.358,
              3331.105
            ],
            [
              2463.001,
              -3519.117,
              3480.495
            ],
            [
              2462.068,
              -3500.174,
              3499.461
            ],
            [
              2434.072,
              -3309.282,
              3692.395
            ],
            [
              2425.512,
              -3284.63,
              3718.491
            ],
            [
              2426.678,
              -3256.82,
              3746.325
            ],
            [
              2328.687,
              -2639.354,
              4371.519
            ],
            [
              2422.077,
              -2608.82,
              4469.773
            ],
            [
              2444.816,
              -2599.227,
              4494.453
            ],
            [
              2646.504,
              -2533.994,
              4706.428
            ],
            [
              2717.262,
              -2507.494,
              4781.986
            ],
            [
              2743.995,
              -2491.298,
              4813.242
            ],
            [
              2805.445,
              -2445.699,
              4889.763
            ],
            [
              2826.856,
              -2438.309,
              4912.413
            ],
            [
              2849.016,
              -2425.368,
              4938.075
            ],
            [
              2992.535,
              -2369.073,
              5092.24
            ],
            [
              3051.699,
              -2342.359,
              5157.155
            ],
            [
              3144.148,
              -2294.01,
              5261.484
            ],
            [
              3171.465,
              -2281.167,
              5291.669
            ],
            [
              3196.764,
              -2272.74,
              5318.335
            ],
            [
              3228.339,
              -2273.338,
              5349.916
            ],
            [
              3336.988,
              -2288.755,
              5459.653
            ],
            [
              3342.08,
              -2292.192,
              5465.796
            ],
            [
              3369.017,
              -2299.382,
              5493.676
            ],
            [
              3397.349,
              -2301.032,
              5522.056
            ],
            [
              3430.9,
              -2299.443,
              5555.644
            ],
            [
              3478.067,
              -2293.658,
              5603.165
            ],
            [
              3484.236,
              -2308.248,
              5619.005
            ],
            [
              3493.711,
              -2318.447,
              5632.926
            ],
            [
              3501.381,
              -2321.933,
              5641.351
            ],
            [
              3511.025,
              -2323.229,
              5651.082
            ],
            [
              3520.089,
              -2321.175,
              5660.375
            ],
            [
              3550.396,
              -2320.637,
              5690.687
            ],
            [
              3610.218,
              -2327.341,
              5750.884
            ],
            [
              3749.625,
              -2352.259,
              5892.5
            ],
            [
              3826.539,
              -2341.479,
              5970.166
            ],
            [
              3880.667,
              -2342.511,
              6024.304
            ],
            [
              3899.892,
              -2348.445,
              6044.424
            ],
            [
              3964.854,
              -2389.762,
              6121.412
            ],
            [
              4006.724,
              -2425.073,
              6176.184
            ],
            [
              4021.161,
              -2445.388,
              6201.106
            ],
            [
              4040.888,
              -2492.522,
              6252.202
            ],
            [
              4043.21,
              -2505.925,
              6265.805
            ],
            [
              4042.848,
              -2524.844,
              6284.727
            ],
            [
              4028.232,
              -2581.341,
              6343.084
            ],
            [
              4028.883,
              -2614.751,
              6376.501
            ],
            [
              4035.694,
              -2629.354,
              6392.614
            ],
            [
              4048.304,
              -2644.068,
              6411.992
            ],
            [
              4085.016,
              -2679.281,
              6462.861
            ],
            [
              4090.171,
              -2679.379,
              6468.017
            ],
            [
              4122.734,
              -2695.588,
              6504.391
            ],
            [
              4140.69,
              -2700.385,
              6522.977
            ],
            [
              4203.083,
              -2707.145,
              6585.735
            ],
            [
              4239.229,
              -2704.498,
              6621.979
            ],
            [
              4464.241,
              -2835.727,
              6882.461
            ],
            [
              4654.319,
              -2972.975,
              7116.91
            ],
            [
              4760.242,
              -3061.85,
              7255.181
            ],
            [
              4805.406,
              -3092.779,
              7309.92
            ],
            [
              4843.655,
              -3114.669,
              7353.99
            ],
            [
              4866.097,
              -3120.669,
              7377.22
            ],
            [
              4905.333,
              -3124.766,
              7416.669
            ],
            [
              4920.495,
              -3140.644,
              7438.624
            ],
            [
              5113.031,
              -3382.607,
              7747.843
            ],
            [
              5185.975,
              -3443.023,
              7842.558
            ],
            [
              5236.028,
              -3487.411,
              7909.457
            ],
            [
              5455.183,
              -3551.781,
              8137.87
            ],
            [
              5524.904,
              -3578.742,
              8212.623
            ],
            [
              5554.684,
              -3604.927,
              8252.277
            ],
            [
              5627.808,
              -3688.733,
              8363.5
            ],
            [
              5809.614,
              -3717.882,
              8547.628
            ],
            [
              5846.782,
              -3728.627,
              8586.318
            ],
            [
              5857.776,
              -3726.615,
              8597.495
            ],
            [
              5881.829,
              -3715.952,
              8623.805
            ],
            [
              5898.795,
              -3705.15,
              8643.918
            ],
            [
              5913.076,
              -3699.863,
              8659.146
            ],
            [
              5960.297,
              -3690.766,
              8707.236
            ],
            [
              6114.794,
              -3699.355,
              8861.971
            ],
            [
              6126.903,
              -3706.272,
              8875.916
            ],
            [
              6143.708,
              -3736.659,
              8910.641
            ],
            [
              6166.31,
              -3767.161,
              8948.604
            ],
            [
              6239.965,
              -3823.155,
              9041.127
            ],
            [
              6248.766,
              -3834.461,
              9055.454
            ],
            [
              6251.015,
              -3851.204,
              9072.348
            ],
            [
              6258.199,
              -3879.177,
              9101.229
            ],
            [
              6263.134,
              -3890.407,
              9113.495
            ],
            [
              6266.355,
              -3890.47,
              9116.716
            ],
            [
              6269.26,
              -3939.511,
              9165.844
            ],
            [
              6268.004,
              -3970.658,
              9197.016
            ],
            [
              6264.991,
              -3992.865,
              9219.426
            ],
            [
              6256.159,
              -4016.071,
              9244.256
            ],
            [
              6198.296,
              -4075.053,
              9326.882
            ],
            [
              6188.198,
              -4097.121,
              9351.15
            ],
            [
              6189.072,
              -4118.291,
              9372.338
            ],
            [
              6214.303,
              -4178.903,
              9437.992
            ],
            [
              6222.196,
              -4203.55,
              9463.872
            ],
            [
              6223.005,
              -4228.058,
              9488.393
            ],
            [
              6194.764,
              -4321.02,
              9585.55
            ],
            [
              6148.893,
              -4425.883,
              9700.007
            ],
            [
              6140.019,
              -4451.314,
              9726.943
            ],
            [
              6139.813,
              -4494.728,
              9770.357
            ],
            [
              6146.888,
              -4528.265,
              9804.632
            ],
            [
              6113.79,
              -4573.262,
              9860.49
            ],
            [
              6101.095,
              -4596.392,
              9886.875
            ],
            [
              6100.769,
              -4613.085,
              9903.571
            ],
            [
              6110.802,
              -4660.039,
              9951.586
            ],
            [
              6125.058,
              -4655.865,
              9966.44
            ],
            [
              6132.078,
              -4659.343,
              9974.274
            ],
            [
              6138.322,
              -4669.485,
              9986.184
            ],
            [
              6147.186,
              -4677.451,
              9998.102
            ],
            [
              6159.97,
              -4715.553,
              10038.291
            ],
            [
              6163.114,
              -4752.353,
              10075.225
            ],
            [
              6148.487,
              -4775.446,
              10102.56
            ],
            [
              6122.934,
              -4797.211,
              10136.127
            ],
            [
              6095.897,
              -4828.966,
              10177.833
            ],
            [
              6024.895,
              -4934.452,
              10304.988
            ],
            [
              6018.15,
              -4949.906,
              10321.85
            ],
            [
              6009.703,
              -4986.479,
              10359.386
            ],
            [
              6002.309,
              -5101.002,
              10474.148
            ],
            [
              6002.517,
              -5123.272,
              10496.418
            ],
            [
              6008.718,
              -5135.639,
              10510.253
            ],
            [
              6016.589,
              -5161.399,
              10537.188
            ],
            [
              6030.604,
              -5169.466,
              10553.359
            ],
            [
              6078.772,
              -5177.089,
              10602.127
            ],
            [
              6272.282,
              -5197.581,
              10796.719
            ],
            [
              6910.827,
              -5256.916,
              11438.014
            ],
            [
              7009.8,
              -5268.893,
              11537.71
            ],
            [
              7655.857,
              -5403.073,
              12197.554
            ],
            [
              7709.038,
              -5417.492,
              12252.655
            ],
            [
              7740.925,
              -5433.715,
              12288.431
            ],
            [
              7791.019,
              -5473.68,
              12352.514
            ],
            [
              7852.17,
              -5508.3,
              12422.785
            ],
            [
              7919.006,
              -5516.315,
              12490.1
            ],
            [
              7947.983,
              -5516.895,
              12519.083
            ],
            [
              7967.101,
              -5527.297,
              12540.847
            ],
            [
              7968.81,
              -5538.464,
              12552.144
            ],
            [
              7801.253,
              -5670.938,
              12765.744
            ],
            [
              7791.372,
              -5681.873,
              12780.482
            ],
            [
              7782.646,
              -5699.512,
              12800.161
            ],
            [
              7724.095,
              -5954.402,
              13061.69
            ],
            [
              7696.143,
              -6031.775,
              13143.957
            ],
            [
              7655.004,
              -6156.757,
              13275.536
            ],
            [
              7645.325,
              -6189.963,
              13310.124
            ],
            [
              7635.934,
              -6240.988,
              13362.005
            ],
            [
              7604.789,
              -6349.47,
              13474.87
            ],
            [
              7581.015,
              -6443.627,
              13571.982
            ],
            [
              7581.97,
              -6460.345,
              13588.727
            ],
            [
              7624.685,
              -6611.491,
              13745.794
            ],
            [
              7818.878,
              -6820.214,
              14030.883
            ],
            [
              7824.11,
              -7009.579,
              14220.32
            ],
            [
              7818.117,
              -7019.479,
              14231.893
            ],
            [
              7811.812,
              -7044.959,
              14258.142
            ],
            [
              7776.828,
              -7087.679,
              14313.358
            ],
            [
              7706.597,
              -7121.902,
              14391.484
            ],
            [
              7166.969,
              -7283.727,
              14954.854
            ],
            [
              6850.874,
              -7507.92,
              15342.383
            ],
            [
              6900.891,
              -7583.5,
              15433.014
            ],
            [
              6955.262,
              -7699.245,
              15560.893
            ],
            [
              6973.046,
              -7744.129,
              15609.172
            ],
            [
              6996.798,
              -7780.224,
              15652.381
            ],
            [
              7011.315,
              -7794.985,
              15673.084
            ],
            [
              7036.905,
              -7803.285,
              15699.986
            ],
            [
              7078.052,
              -7806.327,
              15741.245
            ],
            [
              7104.995,
              -7811.314,
              15768.646
            ],
            [
              7131.894,
              -7818.527,
              15796.496
            ],
            [
              7161.279,
              -7830.243,
              15828.13
            ],
            [
              7246.906,
              -7895.4,
              15935.729
            ],
            [
              7256.96,
              -7907.846,
              15951.728
            ],
            [
              7272.92,
              -7947.129,
              15994.129
            ],
            [
              7284.728,
              -7968.516,
              16018.559
            ],
            [
              7366.111,
              -8020.232,
              16114.984
            ],
            [
              7388.169,
              -8011.764,
              16138.612
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 119.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 386.973,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 927.492,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6873",
              "position": {
                "x": 1553.844,
                "z": -3615.694
              },
              "distanceAlongShapeM": 1424.447,
              "shapeOffsetM": 0.929,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6874",
              "position": {
                "x": 1889.999,
                "z": -4008.247
              },
              "distanceAlongShapeM": 1942.061,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5476",
              "position": {
                "x": 2336.174,
                "z": -4371.718
              },
              "distanceAlongShapeM": 2596.701,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 3480.495,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 3718.491,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6723",
              "position": {
                "x": 2444.816,
                "z": -2599.227
              },
              "distanceAlongShapeM": 4494.453,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:11047",
              "position": {
                "x": 2826.856,
                "z": -2438.309
              },
              "distanceAlongShapeM": 4912.413,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:4520",
              "position": {
                "x": 3336.988,
                "z": -2288.755
              },
              "distanceAlongShapeM": 5459.653,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9756",
              "position": {
                "x": 4203.083,
                "z": -2707.145
              },
              "distanceAlongShapeM": 6585.735,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9612",
              "position": {
                "x": 4464.241,
                "z": -2835.727
              },
              "distanceAlongShapeM": 6882.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:10548",
              "position": {
                "x": 4920.495,
                "z": -3140.644
              },
              "distanceAlongShapeM": 7438.624,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:10611",
              "position": {
                "x": 5185.975,
                "z": -3443.023
              },
              "distanceAlongShapeM": 7842.558,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:10544",
              "position": {
                "x": 5809.614,
                "z": -3717.882
              },
              "distanceAlongShapeM": 8547.628,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:10539",
              "position": {
                "x": 6126.903,
                "z": -3706.272
              },
              "distanceAlongShapeM": 8875.916,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:10538",
              "position": {
                "x": 6266.355,
                "z": -3890.47
              },
              "distanceAlongShapeM": 9116.716,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:8250",
              "position": {
                "x": 6147.186,
                "z": -4677.451
              },
              "distanceAlongShapeM": 9998.102,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6183",
              "position": {
                "x": 7009.8,
                "z": -5268.893
              },
              "distanceAlongShapeM": 11537.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:16307",
              "position": {
                "x": 7913.164,
                "z": -5582.996
              },
              "distanceAlongShapeM": 12623.415,
              "shapeOffsetM": 0.422,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6895",
              "position": {
                "x": 7635.934,
                "z": -6240.988
              },
              "distanceAlongShapeM": 13362.005,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6899",
              "position": {
                "x": 7824.11,
                "z": -7009.579
              },
              "distanceAlongShapeM": 14220.32,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:9925",
              "position": {
                "x": 7388.169,
                "z": -8011.764
              },
              "distanceAlongShapeM": 16138.612,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            17580,
            18780,
            19980,
            20940,
            21960,
            22980,
            24180,
            25380,
            26880,
            28620,
            30420,
            32280,
            33660,
            35100,
            36480,
            37920,
            39360,
            40740,
            42120,
            43500,
            44880,
            46320,
            47760,
            49140,
            50460,
            51660,
            52860,
            54060,
            55260,
            56460,
            57660,
            58920,
            60240,
            61560,
            63060,
            64620,
            66420,
            67980,
            69540,
            71100,
            72660,
            74160,
            75660,
            77100,
            78540,
            80040,
            81480
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_114:1",
          "sourceRouteId": "vilnius_bus_114",
          "sourceShapeId": "vilnius_bus_114_b-a",
          "directionId": 1,
          "headsign": "Šiaurės miestelis",
          "directionName": "Vinciūniškės–Dvarčionys–S.Kerbedžio–Mileišiškių g.–Antakalnis–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "114",
          "routeLongName": "Šiaurės miestelis–Antakalnis–Mileišiškių –S.Kerbedžio g.–Dvarčionys–Vinciūniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              7388.169,
              -8011.764,
              0
            ],
            [
              7392.298,
              -8030.772,
              19.451
            ],
            [
              7385.796,
              -8033.983,
              26.703
            ],
            [
              7296.69,
              -7982.113,
              129.806
            ],
            [
              7272.188,
              -7951.567,
              168.965
            ],
            [
              7261.178,
              -7922.403,
              200.139
            ],
            [
              7251.212,
              -7905.506,
              219.756
            ],
            [
              7194.238,
              -7856.503,
              294.904
            ],
            [
              7168.803,
              -7840.412,
              325.002
            ],
            [
              7142.059,
              -7825.408,
              355.667
            ],
            [
              7106.216,
              -7814.678,
              393.082
            ],
            [
              7038.104,
              -7807.762,
              461.544
            ],
            [
              7020.837,
              -7801.853,
              479.794
            ],
            [
              7006.876,
              -7791.557,
              497.141
            ],
            [
              6982.969,
              -7763.251,
              534.191
            ],
            [
              6850.874,
              -7507.92,
              821.669
            ],
            [
              7002.029,
              -7418.507,
              997.289
            ],
            [
              7095.904,
              -7327.963,
              1127.714
            ],
            [
              7135.786,
              -7297.582,
              1177.85
            ],
            [
              7183.903,
              -7274.044,
              1231.417
            ],
            [
              7345.687,
              -7233.838,
              1398.121
            ],
            [
              7689.816,
              -7123.794,
              1759.417
            ],
            [
              7771.634,
              -7089.802,
              1848.015
            ],
            [
              7812.456,
              -7044.972,
              1908.646
            ],
            [
              7806.73,
              -7009.232,
              1944.842
            ],
            [
              7814.771,
              -6832.378,
              2121.878
            ],
            [
              7811.308,
              -6812.269,
              2142.283
            ],
            [
              7628.348,
              -6621.584,
              2406.547
            ],
            [
              7581.97,
              -6460.345,
              2574.323
            ],
            [
              7581.592,
              -6446.978,
              2587.695
            ],
            [
              7614.845,
              -6297.345,
              2740.978
            ],
            [
              7650.941,
              -6166.696,
              2876.523
            ],
            [
              7709.064,
              -5997.521,
              3055.404
            ],
            [
              7737.395,
              -5901.229,
              3155.777
            ],
            [
              7780.648,
              -5702.812,
              3358.854
            ],
            [
              7791.372,
              -5681.873,
              3382.379
            ],
            [
              7932.238,
              -5563.338,
              3566.482
            ],
            [
              7942.83,
              -5549.077,
              3584.246
            ],
            [
              7942.986,
              -5541.287,
              3592.037
            ],
            [
              7938.723,
              -5528.956,
              3605.085
            ],
            [
              7918.962,
              -5518.541,
              3627.423
            ],
            [
              7891.85,
              -5521.339,
              3654.679
            ],
            [
              6930.636,
              -5265.1,
              4649.461
            ],
            [
              6784.784,
              -5245.52,
              4796.62
            ],
            [
              6076.818,
              -5178.164,
              5507.784
            ],
            [
              6011.263,
              -5170.201,
              5573.821
            ],
            [
              5986.3,
              -5161.92,
              5600.122
            ],
            [
              5981.213,
              -5158.48,
              5606.262
            ],
            [
              5980.83,
              -5145.113,
              5619.634
            ],
            [
              5992.039,
              -5131.973,
              5636.906
            ],
            [
              5997.387,
              -5122.058,
              5648.171
            ],
            [
              6009.977,
              -5005.41,
              5765.497
            ],
            [
              6011.962,
              -4969.824,
              5801.138
            ],
            [
              6022.232,
              -4938.853,
              5833.768
            ],
            [
              6026.936,
              -4928.925,
              5844.753
            ],
            [
              6101.223,
              -4820.164,
              5976.463
            ],
            [
              6130.193,
              -4788.447,
              6019.42
            ],
            [
              6148.553,
              -4772.107,
              6043.997
            ],
            [
              6156.478,
              -4762.243,
              6056.651
            ],
            [
              6161.248,
              -4748.977,
              6070.748
            ],
            [
              6159.686,
              -4730.021,
              6089.769
            ],
            [
              6139.84,
              -4690.667,
              6133.844
            ],
            [
              6133.322,
              -4661.594,
              6163.638
            ],
            [
              6125.058,
              -4655.865,
              6173.693
            ],
            [
              6110.78,
              -4661.152,
              6188.919
            ],
            [
              6101.325,
              -4617.549,
              6233.535
            ],
            [
              6101.052,
              -4598.618,
              6252.468
            ],
            [
              6101.783,
              -4594.179,
              6256.967
            ],
            [
              6117.098,
              -4568.873,
              6286.546
            ],
            [
              6146.866,
              -4529.378,
              6336.003
            ],
            [
              6139.834,
              -4493.616,
              6372.45
            ],
            [
              6140.171,
              -4443.524,
              6422.543
            ],
            [
              6167.112,
              -4383.935,
              6487.939
            ],
            [
              6211.204,
              -4271.244,
              6608.949
            ],
            [
              6222.896,
              -4233.622,
              6648.346
            ],
            [
              6220.952,
              -4201.299,
              6680.727
            ],
            [
              6189.072,
              -4118.291,
              6769.647
            ],
            [
              6190.927,
              -4089.382,
              6798.615
            ],
            [
              6196.964,
              -4077.254,
              6812.163
            ],
            [
              6258.844,
              -4010.557,
              6903.144
            ],
            [
              6265.035,
              -3990.639,
              6924.002
            ],
            [
              6269.041,
              -3950.64,
              6964.201
            ],
            [
              6246.942,
              -3828.858,
              7087.972
            ],
            [
              6187.197,
              -3786.496,
              7161.212
            ],
            [
              6163.132,
              -3764.872,
              7193.564
            ],
            [
              6119.752,
              -3709.471,
              7263.928
            ],
            [
              6114.794,
              -3699.355,
              7275.194
            ],
            [
              6058.663,
              -3702.709,
              7331.426
            ],
            [
              6036.247,
              -3695.591,
              7354.945
            ],
            [
              5962.874,
              -3690.816,
              7428.473
            ],
            [
              5924.736,
              -3696.751,
              7467.069
            ],
            [
              5907.235,
              -3701.975,
              7485.334
            ],
            [
              5890.29,
              -3711.664,
              7504.853
            ],
            [
              5882.321,
              -3723.754,
              7519.334
            ],
            [
              5853.868,
              -3728.765,
              7548.225
            ],
            [
              5649.001,
              -3692.485,
              7756.279
            ],
            [
              5619.049,
              -3675.203,
              7790.859
            ],
            [
              5549.682,
              -3597.037,
              7895.367
            ],
            [
              5514.018,
              -3575.191,
              7937.19
            ],
            [
              5432.143,
              -3543.541,
              8024.969
            ],
            [
              5361.69,
              -3521.02,
              8098.934
            ],
            [
              5257.158,
              -3494.5,
              8206.778
            ],
            [
              5215.327,
              -3491.463,
              8248.719
            ],
            [
              5183.226,
              -3451.876,
              8299.685
            ],
            [
              5126.838,
              -3401.8,
              8375.099
            ],
            [
              5099.073,
              -3371.205,
              8416.414
            ],
            [
              4968.169,
              -3208.362,
              8625.349
            ],
            [
              4915.877,
              -3146.122,
              8706.64
            ],
            [
              4904.689,
              -3124.753,
              8730.76
            ],
            [
              4867.364,
              -3121.806,
              8768.201
            ],
            [
              4845.566,
              -3115.819,
              8790.806
            ],
            [
              4827.72,
              -3105.456,
              8811.443
            ],
            [
              4654.319,
              -2972.975,
              9029.662
            ],
            [
              4431.036,
              -2819.503,
              9300.602
            ],
            [
              4422.037,
              -2818.217,
              9309.693
            ],
            [
              4248.143,
              -2710.235,
              9514.385
            ],
            [
              4239.187,
              -2706.724,
              9524.006
            ],
            [
              4206.906,
              -2709.445,
              9556.4
            ],
            [
              4148.315,
              -2706.097,
              9615.087
            ],
            [
              4083.685,
              -2681.482,
              9684.246
            ],
            [
              4052.842,
              -2676.439,
              9715.499
            ],
            [
              4056.942,
              -2664.271,
              9728.339
            ],
            [
              4062.246,
              -2656.58,
              9737.681
            ],
            [
              4038.186,
              -2633.855,
              9770.776
            ],
            [
              4030.752,
              -2618.127,
              9788.173
            ],
            [
              4029.18,
              -2599.171,
              9807.193
            ],
            [
              4031.022,
              -2570.262,
              9836.162
            ],
            [
              4042.933,
              -2520.392,
              9887.434
            ],
            [
              4043.189,
              -2507.038,
              9900.79
            ],
            [
              4039.684,
              -2488.046,
              9920.103
            ],
            [
              4014.866,
              -2437.475,
              9976.436
            ],
            [
              3997.186,
              -2418.211,
              10002.583
            ],
            [
              3943.887,
              -2373.776,
              10071.975
            ],
            [
              3899.892,
              -2348.445,
              10122.741
            ],
            [
              3872.892,
              -2344.59,
              10150.016
            ],
            [
              3841.296,
              -2345.1,
              10181.616
            ],
            [
              3772.844,
              -2351.588,
              10250.375
            ],
            [
              3727.135,
              -2348.491,
              10296.188
            ],
            [
              3642.975,
              -2333.53,
              10381.667
            ],
            [
              3597.932,
              -2329.334,
              10426.906
            ],
            [
              3525.677,
              -2332.413,
              10499.227
            ],
            [
              3501.94,
              -2326.396,
              10523.714
            ],
            [
              3483.591,
              -2308.236,
              10549.53
            ],
            [
              3478.067,
              -2293.658,
              10565.12
            ],
            [
              3430.234,
              -2300.543,
              10613.445
            ],
            [
              3387.662,
              -2301.962,
              10656.04
            ],
            [
              3196.764,
              -2272.74,
              10849.162
            ],
            [
              3157.806,
              -2287.589,
              10890.854
            ],
            [
              3002.929,
              -2364.816,
              11063.918
            ],
            [
              2811.307,
              -2442.469,
              11270.676
            ],
            [
              2719.174,
              -2508.643,
              11384.11
            ],
            [
              2680.157,
              -2526.834,
              11427.16
            ],
            [
              2599.153,
              -2549.802,
              11511.358
            ],
            [
              2457.059,
              -2599.457,
              11661.877
            ],
            [
              2382.396,
              -2628.114,
              11741.851
            ],
            [
              2328.687,
              -2639.354,
              11796.724
            ],
            [
              2411.872,
              -3118.499,
              12283.036
            ],
            [
              2419.872,
              -3138.687,
              12304.752
            ],
            [
              2418.768,
              -3163.158,
              12329.248
            ],
            [
              2474.472,
              -3526.012,
              12696.352
            ],
            [
              2513.109,
              -3664.781,
              12840.4
            ],
            [
              2522.438,
              -3682.768,
              12860.662
            ],
            [
              2525.989,
              -3699.534,
              12877.8
            ],
            [
              2553.555,
              -3775.753,
              12958.851
            ],
            [
              2561.118,
              -3784.801,
              12970.643
            ],
            [
              2567.953,
              -3798.289,
              12985.764
            ],
            [
              2577.339,
              -3847.448,
              13035.812
            ],
            [
              2577.544,
              -3870.831,
              13059.195
            ],
            [
              2568.689,
              -3896.269,
              13086.13
            ],
            [
              2541.856,
              -3952.541,
              13148.472
            ],
            [
              2519.328,
              -3985.515,
              13188.408
            ],
            [
              2483.001,
              -4032.703,
              13247.958
            ],
            [
              2454.012,
              -4066.67,
              13292.614
            ],
            [
              2436.763,
              -4093.064,
              13324.145
            ],
            [
              2406.107,
              -4181.549,
              13417.79
            ],
            [
              2398.976,
              -4218.153,
              13455.082
            ],
            [
              2394.879,
              -4264.833,
              13501.941
            ],
            [
              2388.205,
              -4311.465,
              13549.048
            ],
            [
              2381.138,
              -4344.73,
              13583.055
            ],
            [
              2383.36,
              -4363.697,
              13602.152
            ],
            [
              2363.369,
              -4398.946,
              13642.675
            ],
            [
              2340.823,
              -4433.034,
              13683.545
            ],
            [
              2328.252,
              -4450.61,
              13705.154
            ],
            [
              2298.04,
              -4481.215,
              13748.159
            ],
            [
              2296.004,
              -4486.743,
              13754.05
            ],
            [
              2297.644,
              -4502.36,
              13769.752
            ],
            [
              2324.901,
              -4526.249,
              13805.997
            ],
            [
              2369.547,
              -4550.465,
              13856.787
            ],
            [
              2386.895,
              -4553.017,
              13874.322
            ],
            [
              2397.928,
              -4548.771,
              13886.143
            ],
            [
              2404.556,
              -4538.876,
              13898.053
            ],
            [
              2405.535,
              -4521.082,
              13915.874
            ],
            [
              2396.166,
              -4505.32,
              13934.21
            ],
            [
              2310.611,
              -4463.639,
              14029.377
            ],
            [
              2261.601,
              -4431.549,
              14087.958
            ],
            [
              2254.143,
              -4416.937,
              14104.364
            ],
            [
              2239.684,
              -4397.741,
              14128.396
            ],
            [
              2101.811,
              -4259.344,
              14323.749
            ],
            [
              2005.819,
              -4155.131,
              14465.434
            ],
            [
              1848.669,
              -3978.532,
              14701.831
            ],
            [
              1832.856,
              -3962.652,
              14724.242
            ],
            [
              1811.224,
              -3947.777,
              14750.494
            ],
            [
              1800.044,
              -3925.303,
              14775.595
            ],
            [
              1667.691,
              -3765.872,
              14982.805
            ],
            [
              1499.686,
              -3582.404,
              15231.574
            ],
            [
              1509.056,
              -3563.653,
              15252.536
            ],
            [
              1545.21,
              -3525.36,
              15305.199
            ],
            [
              1607.644,
              -3390.704,
              15453.626
            ],
            [
              1620.009,
              -3384.254,
              15467.572
            ],
            [
              1689.847,
              -3267.548,
              15603.578
            ],
            [
              1697.306,
              -3247.648,
              15624.83
            ],
            [
              1696.944,
              -3128.524,
              15743.955
            ],
            [
              1687.839,
              -3098.296,
              15775.523
            ],
            [
              1691.619,
              -3068.309,
              15805.748
            ],
            [
              1690.731,
              -2873.474,
              16000.585
            ],
            [
              1688.435,
              -2754.314,
              16119.767
            ],
            [
              1682.19,
              -2639.533,
              16234.718
            ],
            [
              1679.485,
              -2611.651,
              16262.73
            ],
            [
              1675.868,
              -2598.225,
              16276.635
            ],
            [
              1670.837,
              -2591.452,
              16285.072
            ],
            [
              1656.786,
              -2584.511,
              16300.744
            ],
            [
              1621.888,
              -2589.429,
              16335.987
            ],
            [
              1614.3,
              -2581.496,
              16346.965
            ],
            [
              1426.817,
              -2576.903,
              16534.504
            ],
            [
              1419.812,
              -2572.32,
              16542.876
            ],
            [
              1413.343,
              -2538.803,
              16577.011
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:9925",
              "position": {
                "x": 7388.169,
                "z": -8011.764
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6898",
              "position": {
                "x": 7806.73,
                "z": -7009.232
              },
              "distanceAlongShapeM": 1944.842,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6896",
              "position": {
                "x": 7614.845,
                "z": -6297.345
              },
              "distanceAlongShapeM": 2740.978,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:16306",
              "position": {
                "x": 7891.85,
                "z": -5521.339
              },
              "distanceAlongShapeM": 3654.679,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6184",
              "position": {
                "x": 6930.636,
                "z": -5265.1
              },
              "distanceAlongShapeM": 4649.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6179",
              "position": {
                "x": 6139.84,
                "z": -4690.667
              },
              "distanceAlongShapeM": 6133.844,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:10537",
              "position": {
                "x": 6262.545,
                "z": -3920.454
              },
              "distanceAlongShapeM": 6995.062,
              "shapeOffsetM": 1.002,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:10541",
              "position": {
                "x": 6058.663,
                "z": -3702.709
              },
              "distanceAlongShapeM": 7331.426,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:10543",
              "position": {
                "x": 5882.321,
                "z": -3723.754
              },
              "distanceAlongShapeM": 7519.334,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:10609",
              "position": {
                "x": 5215.327,
                "z": -3491.463
              },
              "distanceAlongShapeM": 8248.719,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:10545",
              "position": {
                "x": 4915.877,
                "z": -3146.122
              },
              "distanceAlongShapeM": 8706.64,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9613",
              "position": {
                "x": 4422.037,
                "z": -2818.217
              },
              "distanceAlongShapeM": 9309.693,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9755",
              "position": {
                "x": 4148.315,
                "z": -2706.097
              },
              "distanceAlongShapeM": 9615.087,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:4521",
              "position": {
                "x": 3280.303,
                "z": -2286.568
              },
              "distanceAlongShapeM": 10764.493,
              "shapeOffsetM": 1.028,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:11046",
              "position": {
                "x": 2680.157,
                "z": -2526.834
              },
              "distanceAlongShapeM": 11427.16,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6720",
              "position": {
                "x": 2382.396,
                "z": -2628.114
              },
              "distanceAlongShapeM": 11741.851,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 12304.752,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 12860.662,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5485",
              "position": {
                "x": 2577.544,
                "z": -3870.831
              },
              "distanceAlongShapeM": 13059.195,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5490",
              "position": {
                "x": 2383.36,
                "z": -4363.697
              },
              "distanceAlongShapeM": 13602.152,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5491",
              "position": {
                "x": 2261.601,
                "z": -4431.549
              },
              "distanceAlongShapeM": 14087.958,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5494",
              "position": {
                "x": 1811.224,
                "z": -3947.777
              },
              "distanceAlongShapeM": 14750.494,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 15453.626,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 15775.523,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5013",
              "position": {
                "x": 1621.888,
                "z": -2589.429
              },
              "distanceAlongShapeM": 16335.987,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 16577.011,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            }
          ],
          "departuresSeconds": [
            20160,
            21360,
            22560,
            23520,
            24480,
            25680,
            27000,
            28320,
            29700,
            31260,
            33240,
            35220,
            36540,
            37860,
            39240,
            40620,
            42060,
            43440,
            44820,
            46200,
            47580,
            49020,
            50460,
            51900,
            53220,
            54540,
            55740,
            56940,
            58200,
            59400,
            60600,
            61800,
            63000,
            64200,
            65820,
            67440,
            69120,
            70680,
            72240,
            73800,
            75360,
            76920,
            78360,
            79800,
            81180,
            82620,
            84060
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_115",
      "sourceRouteId": "vilnius_bus_115",
      "mode": "bus",
      "shortName": "115",
      "longName": "Antakalnis–Rokantiškės–Parko–Linksmoji g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_115:0",
          "sourceRouteId": "vilnius_bus_115",
          "sourceShapeId": "vilnius_bus_115_a-b",
          "directionId": 0,
          "headsign": "Linksmoji g.",
          "directionName": "Antakalnis–Rokantiškės–Parko–Linksmoji g.",
          "mode": "bus",
          "routeShortName": "115",
          "routeLongName": "Antakalnis–Rokantiškės–Parko–Linksmoji g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2562.319,
              -3823.788,
              0
            ],
            [
              2558.905,
              -3868.254,
              44.597
            ],
            [
              2551.422,
              -3889.265,
              66.901
            ],
            [
              2499.38,
              -3984.027,
              175.013
            ],
            [
              2494.143,
              -3988.382,
              181.824
            ],
            [
              2481.156,
              -3993.705,
              195.86
            ],
            [
              2470.227,
              -3992.386,
              206.868
            ],
            [
              2459.381,
              -3986.616,
              219.154
            ],
            [
              2448.681,
              -3973.056,
              236.427
            ],
            [
              2446.334,
              -3960.766,
              248.939
            ],
            [
              2458.099,
              -3917.57,
              293.708
            ],
            [
              2495.249,
              -3757.959,
              457.586
            ],
            [
              2503.087,
              -3718.029,
              498.278
            ],
            [
              2508.663,
              -3661.358,
              555.223
            ],
            [
              2463.001,
              -3519.117,
              704.613
            ],
            [
              2462.068,
              -3500.174,
              723.579
            ],
            [
              2434.072,
              -3309.282,
              916.513
            ],
            [
              2425.512,
              -3284.63,
              942.609
            ],
            [
              2426.678,
              -3256.82,
              970.443
            ],
            [
              2328.687,
              -2639.354,
              1595.637
            ],
            [
              2422.077,
              -2608.82,
              1693.891
            ],
            [
              2444.816,
              -2599.227,
              1718.572
            ],
            [
              2646.504,
              -2533.994,
              1930.546
            ],
            [
              2717.262,
              -2507.494,
              2006.104
            ],
            [
              2743.995,
              -2491.298,
              2037.36
            ],
            [
              2805.445,
              -2445.699,
              2113.881
            ],
            [
              2826.856,
              -2438.309,
              2136.531
            ],
            [
              2849.016,
              -2425.368,
              2162.193
            ],
            [
              2992.535,
              -2369.073,
              2316.358
            ],
            [
              3051.699,
              -2342.359,
              2381.273
            ],
            [
              3171.465,
              -2281.167,
              2515.766
            ],
            [
              3196.764,
              -2272.74,
              2542.432
            ],
            [
              3228.339,
              -2273.338,
              2574.013
            ],
            [
              3336.988,
              -2288.755,
              2683.75
            ],
            [
              3342.08,
              -2292.192,
              2689.893
            ],
            [
              3369.017,
              -2299.382,
              2717.774
            ],
            [
              3397.349,
              -2301.032,
              2746.154
            ],
            [
              3430.9,
              -2299.443,
              2779.741
            ],
            [
              3478.067,
              -2293.658,
              2827.262
            ],
            [
              3484.236,
              -2308.248,
              2843.102
            ],
            [
              3493.711,
              -2318.447,
              2857.024
            ],
            [
              3501.381,
              -2321.933,
              2865.448
            ],
            [
              3511.025,
              -2323.229,
              2875.179
            ],
            [
              3520.089,
              -2321.175,
              2884.473
            ],
            [
              3550.396,
              -2320.637,
              2914.784
            ],
            [
              3610.218,
              -2327.341,
              2974.981
            ],
            [
              3749.625,
              -2352.259,
              3116.597
            ],
            [
              3826.539,
              -2341.479,
              3194.263
            ],
            [
              3880.667,
              -2342.511,
              3248.401
            ],
            [
              3899.892,
              -2348.445,
              3268.521
            ],
            [
              3964.854,
              -2389.762,
              3345.509
            ],
            [
              4006.724,
              -2425.073,
              3400.281
            ],
            [
              4021.161,
              -2445.388,
              3425.203
            ],
            [
              4040.888,
              -2492.522,
              3476.299
            ],
            [
              4043.21,
              -2505.925,
              3489.902
            ],
            [
              4042.848,
              -2524.844,
              3508.824
            ],
            [
              4028.232,
              -2581.341,
              3567.181
            ],
            [
              4028.883,
              -2614.751,
              3600.598
            ],
            [
              4035.694,
              -2629.354,
              3616.711
            ],
            [
              4048.304,
              -2644.068,
              3636.089
            ],
            [
              4085.016,
              -2679.281,
              3686.959
            ],
            [
              4090.171,
              -2679.379,
              3692.114
            ],
            [
              4122.734,
              -2695.588,
              3728.488
            ],
            [
              4140.69,
              -2700.385,
              3747.074
            ],
            [
              4203.083,
              -2707.145,
              3809.832
            ],
            [
              4239.229,
              -2704.498,
              3846.076
            ],
            [
              4464.241,
              -2835.727,
              4106.558
            ],
            [
              4654.319,
              -2972.975,
              4341.008
            ],
            [
              4713.226,
              -2892.84,
              4440.464
            ],
            [
              4793.805,
              -2791.972,
              4569.566
            ],
            [
              4891.784,
              -2691.442,
              4709.945
            ],
            [
              4967.946,
              -2619.437,
              4814.756
            ],
            [
              5031.266,
              -2544.958,
              4912.513
            ],
            [
              5036.12,
              -2527.239,
              4930.885
            ],
            [
              5088.724,
              -2473.706,
              5005.938
            ],
            [
              5098.884,
              -2448.298,
              5033.302
            ],
            [
              5101.164,
              -2397.131,
              5084.52
            ],
            [
              5134.955,
              -2316.516,
              5171.93
            ],
            [
              5141.854,
              -2226.475,
              5262.236
            ],
            [
              5139.063,
              -2204.155,
              5284.729
            ],
            [
              5133.716,
              -2180.673,
              5308.812
            ],
            [
              5085.52,
              -2039.469,
              5458.015
            ],
            [
              5074.329,
              -2018.1,
              5482.137
            ],
            [
              5052.205,
              -1995.407,
              5513.831
            ],
            [
              5019.081,
              -1974.728,
              5552.879
            ],
            [
              4991.135,
              -1953.035,
              5588.257
            ],
            [
              4976.206,
              -1924.915,
              5620.094
            ],
            [
              4965.809,
              -1895.769,
              5651.039
            ],
            [
              4936.143,
              -1829.514,
              5723.633
            ],
            [
              4897.969,
              -1736.375,
              5824.29
            ],
            [
              4896.938,
              -1722.996,
              5837.709
            ],
            [
              4900.182,
              -1721.946,
              5841.119
            ],
            [
              4917.239,
              -1740.087,
              5866.02
            ],
            [
              4968.109,
              -1776.694,
              5928.692
            ],
            [
              5116.14,
              -1822.973,
              6083.788
            ],
            [
              5175.773,
              -1839.713,
              6145.726
            ],
            [
              5211.862,
              -1840.412,
              6181.822
            ],
            [
              5242.904,
              -1835.447,
              6213.258
            ],
            [
              5278.028,
              -1819.428,
              6251.863
            ],
            [
              5293.732,
              -1807.487,
              6271.592
            ],
            [
              5297.084,
              -1800.872,
              6279.007
            ],
            [
              5314.207,
              -1782.278,
              6304.284
            ],
            [
              5333.177,
              -1768.174,
              6327.923
            ],
            [
              5375.862,
              -1761.209,
              6371.173
            ],
            [
              5407.956,
              -1768.511,
              6404.087
            ],
            [
              5456.996,
              -1799.522,
              6462.109
            ],
            [
              5533.959,
              -1853.341,
              6556.023
            ],
            [
              5535.828,
              -1856.717,
              6559.882
            ],
            [
              5535.01,
              -1865.608,
              6568.81
            ],
            [
              5523.989,
              -1868.733,
              6580.265
            ],
            [
              5513.721,
              -1866.307,
              6590.815
            ],
            [
              5511.295,
              -1858.467,
              6599.022
            ],
            [
              5512.692,
              -1852.928,
              6604.735
            ],
            [
              5517.956,
              -1847.464,
              6612.322
            ],
            [
              5535.27,
              -1852.254,
              6630.286
            ],
            [
              5663.954,
              -1931.573,
              6781.452
            ],
            [
              5726.307,
              -1973.978,
              6856.859
            ],
            [
              5809.795,
              -2023.477,
              6953.917
            ],
            [
              5909.138,
              -2053.247,
              7057.625
            ],
            [
              5956.225,
              -2051.94,
              7104.73
            ],
            [
              6035.685,
              -2043.473,
              7184.64
            ],
            [
              6104.704,
              -2041.484,
              7253.687
            ],
            [
              6231.263,
              -2064.001,
              7382.234
            ],
            [
              6264.085,
              -2066.871,
              7415.181
            ],
            [
              6454.692,
              -2110.689,
              7610.76
            ],
            [
              6496.983,
              -2123.766,
              7655.026
            ],
            [
              6572.924,
              -2163.111,
              7740.555
            ],
            [
              6607.328,
              -2183.827,
              7780.714
            ],
            [
              6714.097,
              -2261.632,
              7912.825
            ],
            [
              6731.855,
              -2276.455,
              7935.957
            ],
            [
              6746.566,
              -2282.311,
              7951.791
            ],
            [
              6792.187,
              -2289.891,
              7998.036
            ],
            [
              6898.797,
              -2277.521,
              8105.362
            ],
            [
              6977.721,
              -2263.494,
              8185.522
            ],
            [
              7198.611,
              -2242.259,
              8407.431
            ],
            [
              7327.2,
              -2226.996,
              8536.923
            ],
            [
              7366.707,
              -2217.76,
              8577.495
            ],
            [
              7380.924,
              -1988.705,
              8806.991
            ],
            [
              7380.054,
              -1967.535,
              8828.178
            ],
            [
              7377.543,
              -1964.146,
              8832.397
            ],
            [
              7367.276,
              -1961.715,
              8842.948
            ],
            [
              7373.54,
              -1938.461,
              8867.031
            ],
            [
              7384.694,
              -1928.662,
              8881.878
            ],
            [
              7401.508,
              -1666.26,
              9144.818
            ],
            [
              7407.216,
              -1638.542,
              9173.119
            ],
            [
              7454.75,
              -1614.993,
              9226.166
            ],
            [
              7561.865,
              -1578.157,
              9339.438
            ],
            [
              7872.398,
              -1460.767,
              9671.418
            ],
            [
              7885.444,
              -1453.235,
              9686.483
            ],
            [
              7894.644,
              -1444.512,
              9699.161
            ],
            [
              7938.338,
              -1355.208,
              9798.581
            ],
            [
              7869.616,
              -1277.019,
              9902.678
            ],
            [
              7850.146,
              -1251.025,
              9935.155
            ],
            [
              7830.876,
              -1215.015,
              9975.997
            ],
            [
              7804.558,
              -1144.353,
              10051.401
            ],
            [
              7791.221,
              -1101.783,
              10096.012
            ],
            [
              7778.817,
              -1077.043,
              10123.687
            ],
            [
              7761.946,
              -1049.988,
              10155.571
            ],
            [
              7720.825,
              -1010.204,
              10212.788
            ],
            [
              7689.684,
              -987.318,
              10251.434
            ],
            [
              7657.987,
              -959.968,
              10293.3
            ],
            [
              7648.028,
              -941.957,
              10313.88
            ],
            [
              7642.025,
              -919.572,
              10337.057
            ],
            [
              7643.176,
              -861.704,
              10394.936
            ],
            [
              7639.707,
              -841.596,
              10415.341
            ],
            [
              7644.596,
              -822.767,
              10434.794
            ],
            [
              7675.302,
              -640.799,
              10619.335
            ],
            [
              7843.017,
              -670.859,
              10789.723
            ],
            [
              7941.422,
              -683.956,
              10888.996
            ],
            [
              7983.745,
              -695.934,
              10932.981
            ],
            [
              8105.956,
              -711.736,
              11056.209
            ],
            [
              8174.886,
              -715.341,
              11125.233
            ],
            [
              8196.247,
              -711.316,
              11146.97
            ],
            [
              8219.654,
              -701.765,
              11172.251
            ],
            [
              8291.234,
              -637.515,
              11268.437
            ],
            [
              8322.689,
              -612.539,
              11308.601
            ],
            [
              8367.171,
              -581.146,
              11363.046
            ],
            [
              8434.632,
              -625.918,
              11444.012
            ],
            [
              8481.22,
              -650.233,
              11496.564
            ],
            [
              8531.721,
              -672.4,
              11551.715
            ],
            [
              8539.64,
              -631.367,
              11593.505
            ],
            [
              8559.188,
              -557.169,
              11670.235
            ],
            [
              8576.654,
              -426.152,
              11802.412
            ],
            [
              8584.228,
              -306.068,
              11922.734
            ],
            [
              8588.332,
              -198.161,
              12030.719
            ],
            [
              8595.54,
              -160.454,
              12069.108
            ],
            [
              8696.05,
              -133.53,
              12173.162
            ],
            [
              8718.239,
              -120.617,
              12198.835
            ],
            [
              8744.049,
              -120.024,
              12224.652
            ],
            [
              8789.403,
              -109.804,
              12271.143
            ],
            [
              8826.443,
              -96.078,
              12310.644
            ],
            [
              8853.145,
              -83.257,
              12340.265
            ],
            [
              8900.484,
              -38.566,
              12405.367
            ],
            [
              8997.947,
              60.777,
              12544.536
            ],
            [
              9045.087,
              95.45,
              12603.055
            ],
            [
              9064.009,
              106.201,
              12624.818
            ],
            [
              9090.691,
              117.908,
              12653.955
            ],
            [
              9116.151,
              132.979,
              12683.541
            ],
            [
              9141.918,
              131.345,
              12709.36
            ],
            [
              9732.975,
              142.732,
              13300.527
            ],
            [
              9768.99,
              137.546,
              13336.913
            ],
            [
              9787.111,
              140.517,
              13355.276
            ],
            [
              9775.961,
              226.468,
              13441.947
            ],
            [
              9750.774,
              351.671,
              13569.658
            ],
            [
              9711.942,
              440.412,
              13666.524
            ],
            [
              9681.966,
              488.893,
              13723.524
            ],
            [
              9609.069,
              583.893,
              13843.269
            ],
            [
              9546.296,
              637.493,
              13925.813
            ],
            [
              9473.758,
              686.837,
              14013.543
            ],
            [
              9388.742,
              725.301,
              14106.855
            ],
            [
              9331.068,
              744.282,
              14167.572
            ],
            [
              9277.061,
              753.169,
              14222.306
            ],
            [
              9213.935,
              757.787,
              14285.601
            ],
            [
              9179.069,
              756.266,
              14320.5
            ],
            [
              9140.267,
              751.484,
              14359.595
            ],
            [
              9063.69,
              760.825,
              14436.74
            ],
            [
              9023.088,
              762.758,
              14477.388
            ],
            [
              8994.783,
              766.67,
              14505.962
            ],
            [
              8994.917,
              773.347,
              14512.64
            ],
            [
              9023.312,
              773.887,
              14541.041
            ],
            [
              9172.201,
              767.538,
              14690.065
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 704.613,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 942.609,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6723",
              "position": {
                "x": 2444.816,
                "z": -2599.227
              },
              "distanceAlongShapeM": 1718.572,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:11047",
              "position": {
                "x": 2826.856,
                "z": -2438.309
              },
              "distanceAlongShapeM": 2136.531,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:4520",
              "position": {
                "x": 3336.988,
                "z": -2288.755
              },
              "distanceAlongShapeM": 2683.75,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:9756",
              "position": {
                "x": 4203.083,
                "z": -2707.145
              },
              "distanceAlongShapeM": 3809.832,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:9612",
              "position": {
                "x": 4464.241,
                "z": -2835.727
              },
              "distanceAlongShapeM": 4106.558,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9675",
              "position": {
                "x": 4793.805,
                "z": -2791.972
              },
              "distanceAlongShapeM": 4569.566,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:9968",
              "position": {
                "x": 5036.12,
                "z": -2527.239
              },
              "distanceAlongShapeM": 4930.885,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9609",
              "position": {
                "x": 5140.178,
                "z": -2246.481
              },
              "distanceAlongShapeM": 5242.16,
              "shapeOffsetM": 0.143,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 6604.735,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:10319",
              "position": {
                "x": 5956.225,
                "z": -2051.94
              },
              "distanceAlongShapeM": 7104.73,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9606",
              "position": {
                "x": 6264.085,
                "z": -2066.871
              },
              "distanceAlongShapeM": 7415.181,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:10531",
              "position": {
                "x": 6607.328,
                "z": -2183.827
              },
              "distanceAlongShapeM": 7780.714,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9604",
              "position": {
                "x": 6977.721,
                "z": -2263.494
              },
              "distanceAlongShapeM": 8185.522,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:14663",
              "position": {
                "x": 7198.611,
                "z": -2242.259
              },
              "distanceAlongShapeM": 8407.431,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:548",
              "position": {
                "x": 7367.276,
                "z": -1961.715
              },
              "distanceAlongShapeM": 8842.948,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6218",
              "position": {
                "x": 7454.75,
                "z": -1614.993
              },
              "distanceAlongShapeM": 9226.166,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6217",
              "position": {
                "x": 7918.757,
                "z": -1334.778
              },
              "distanceAlongShapeM": 9826.853,
              "shapeOffsetM": 1.22,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5394",
              "position": {
                "x": 7639.707,
                "z": -841.596
              },
              "distanceAlongShapeM": 10415.341,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5396",
              "position": {
                "x": 7941.422,
                "z": -683.956
              },
              "distanceAlongShapeM": 10888.996,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6225",
              "position": {
                "x": 8539.64,
                "z": -631.367
              },
              "distanceAlongShapeM": 11593.505,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 12198.835,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 12683.541,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 13120.439,
              "shapeOffsetM": 0.663,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7444",
              "position": {
                "x": 9732.975,
                "z": 142.732
              },
              "distanceAlongShapeM": 13300.527,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:17007",
              "position": {
                "x": 9681.966,
                "z": 488.893
              },
              "distanceAlongShapeM": 13723.524,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:16454",
              "position": {
                "x": 9179.069,
                "z": 756.266
              },
              "distanceAlongShapeM": 14320.5,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:16453",
              "position": {
                "x": 9172.201,
                "z": 767.538
              },
              "distanceAlongShapeM": 14690.065,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            }
          ],
          "departuresSeconds": [
            17520,
            19500,
            20940,
            22020,
            23040,
            23880,
            25320,
            26940,
            27840,
            29280,
            32100,
            34140,
            36240,
            37740,
            40020,
            42060,
            43500,
            45780,
            48060,
            49680,
            51720,
            53640,
            54600,
            55560,
            56700,
            58020,
            59580,
            61260,
            63360,
            64920,
            66900,
            68700,
            71580,
            73860,
            76140,
            78540,
            81000
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_115:1",
          "sourceRouteId": "vilnius_bus_115",
          "sourceShapeId": "vilnius_bus_115_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Linksmoji–Parko g.–Rokantiškės–Antakalnis",
          "mode": "bus",
          "routeShortName": "115",
          "routeLongName": "Antakalnis–Rokantiškės–Parko–Linksmoji g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9172.201,
              767.538,
              0
            ],
            [
              9194.013,
              761.53,
              22.624
            ],
            [
              9297.028,
              751.652,
              126.112
            ],
            [
              9354.837,
              739.348,
              185.215
            ],
            [
              9475.025,
              685.698,
              316.834
            ],
            [
              9548.875,
              637.441,
              405.054
            ],
            [
              9650.145,
              541.866,
              544.302
            ],
            [
              9696.796,
              488.592,
              615.114
            ],
            [
              9750.91,
              358.348,
              756.153
            ],
            [
              9760.037,
              331.443,
              784.564
            ],
            [
              9774.016,
              257.68,
              859.64
            ],
            [
              9785.97,
              179.506,
              938.723
            ],
            [
              9786.285,
              131.627,
              986.602
            ],
            [
              9682.346,
              127.063,
              1090.641
            ],
            [
              9621.808,
              131.634,
              1151.351
            ],
            [
              9517.36,
              133.756,
              1255.821
            ],
            [
              9448.882,
              128.466,
              1324.503
            ],
            [
              9389.611,
              131.895,
              1383.873
            ],
            [
              9156.08,
              129.945,
              1617.413
            ],
            [
              9090.691,
              117.908,
              1683.9
            ],
            [
              9073.545,
              99.328,
              1709.182
            ],
            [
              9049.578,
              94.246,
              1733.682
            ],
            [
              8990.008,
              50.917,
              1807.343
            ],
            [
              8869.532,
              -70.228,
              1978.196
            ],
            [
              8853.145,
              -83.257,
              1999.131
            ],
            [
              8819.883,
              -101.512,
              2037.073
            ],
            [
              8767.948,
              -118.279,
              2091.648
            ],
            [
              8695.316,
              -137.969,
              2166.902
            ],
            [
              8673.105,
              -151.995,
              2193.17
            ],
            [
              8624.063,
              -153.235,
              2242.228
            ],
            [
              8595.54,
              -160.454,
              2271.651
            ],
            [
              8590.933,
              -197.1,
              2308.585
            ],
            [
              8584.694,
              -314.984,
              2426.634
            ],
            [
              8567.281,
              -539.519,
              2651.843
            ],
            [
              8554.112,
              -617.185,
              2730.618
            ],
            [
              8531.721,
              -672.4,
              2790.2
            ],
            [
              8486.109,
              -663.69,
              2836.636
            ],
            [
              8367.171,
              -581.146,
              2981.411
            ],
            [
              8316.776,
              -617.987,
              3043.837
            ],
            [
              8223.611,
              -697.391,
              3166.248
            ],
            [
              8208.584,
              -707.11,
              3184.144
            ],
            [
              8186.511,
              -714.461,
              3207.409
            ],
            [
              8174.886,
              -715.341,
              3219.068
            ],
            [
              8111.113,
              -711.839,
              3282.937
            ],
            [
              7990.769,
              -699.414,
              3403.92
            ],
            [
              7876.316,
              -682.656,
              3519.594
            ],
            [
              7825.635,
              -669.399,
              3571.98
            ],
            [
              7675.302,
              -640.799,
              3725.009
            ],
            [
              7649.128,
              -789.458,
              3875.956
            ],
            [
              7642.645,
              -888.412,
              3975.121
            ],
            [
              7646.227,
              -935.241,
              4022.087
            ],
            [
              7655.475,
              -956.578,
              4045.342
            ],
            [
              7745.609,
              -1028.51,
              4160.66
            ],
            [
              7766.347,
              -1055.642,
              4194.811
            ],
            [
              7788.775,
              -1095.054,
              4240.158
            ],
            [
              7822.274,
              -1193.691,
              4344.328
            ],
            [
              7847.723,
              -1243.184,
              4399.98
            ],
            [
              7892.309,
              -1303.078,
              4474.647
            ],
            [
              7925.18,
              -1336.019,
              4521.184
            ],
            [
              7938.338,
              -1355.208,
              4544.45
            ],
            [
              7930.115,
              -1379.536,
              4570.131
            ],
            [
              7905.223,
              -1431.364,
              4627.626
            ],
            [
              7895.889,
              -1446.764,
              4645.634
            ],
            [
              7884.732,
              -1456.56,
              4660.481
            ],
            [
              7863.219,
              -1468.377,
              4685.026
            ],
            [
              7407.216,
              -1638.542,
              5171.745
            ],
            [
              7402.863,
              -1662.947,
              5196.536
            ],
            [
              7383.829,
              -1939.778,
              5474.02
            ],
            [
              7384.989,
              -1978.766,
              5513.025
            ],
            [
              7366.707,
              -2217.76,
              5752.718
            ],
            [
              7285.671,
              -2240.645,
              5836.923
            ],
            [
              6885.221,
              -2279.48,
              6239.252
            ],
            [
              6758.788,
              -2283.666,
              6365.754
            ],
            [
              6733.788,
              -2276.493,
              6391.762
            ],
            [
              6602.107,
              -2187.064,
              6550.94
            ],
            [
              6582.95,
              -2177.781,
              6572.228
            ],
            [
              6542.211,
              -2151.374,
              6620.777
            ],
            [
              6503.317,
              -2129.457,
              6665.42
            ],
            [
              6436.091,
              -2105.871,
              6736.664
            ],
            [
              6181.107,
              -2057.452,
              6996.205
            ],
            [
              6111.061,
              -2046.061,
              7067.171
            ],
            [
              6042.064,
              -2046.938,
              7136.174
            ],
            [
              5963.871,
              -2056.543,
              7214.954
            ],
            [
              5942.047,
              -2051.663,
              7237.317
            ],
            [
              5884.65,
              -2052.769,
              7294.725
            ],
            [
              5828.911,
              -2034.982,
              7353.233
            ],
            [
              5764.388,
              -2004.779,
              7424.475
            ],
            [
              5745.315,
              -1991.048,
              7447.977
            ],
            [
              5726.821,
              -1980.668,
              7469.184
            ],
            [
              5697.118,
              -1950.031,
              7511.856
            ],
            [
              5679.291,
              -1938.551,
              7533.06
            ],
            [
              5636.118,
              -1904.313,
              7588.161
            ],
            [
              5590.731,
              -1884.504,
              7637.683
            ],
            [
              5512.372,
              -1836.223,
              7729.722
            ],
            [
              5504.167,
              -1827.157,
              7741.949
            ],
            [
              5498.389,
              -1825.931,
              7747.856
            ],
            [
              5496.819,
              -1840.374,
              7762.383
            ],
            [
              5499.115,
              -1854.891,
              7777.081
            ],
            [
              5503.432,
              -1864.994,
              7788.068
            ],
            [
              5510.456,
              -1868.47,
              7795.905
            ],
            [
              5516.944,
              -1866.37,
              7802.724
            ],
            [
              5512.692,
              -1852.928,
              7816.823
            ],
            [
              5512.908,
              -1841.799,
              7827.953
            ],
            [
              5509.859,
              -1832.834,
              7837.423
            ],
            [
              5474.159,
              -1812.101,
              7878.707
            ],
            [
              5451.992,
              -1791.632,
              7908.879
            ],
            [
              5415.045,
              -1768.649,
              7952.391
            ],
            [
              5375.862,
              -1761.209,
              7992.274
            ],
            [
              5340.438,
              -1759.408,
              8027.744
            ],
            [
              5316.356,
              -1771.187,
              8054.553
            ],
            [
              5272.851,
              -1820.441,
              8120.269
            ],
            [
              5263.076,
              -1825.818,
              8131.425
            ],
            [
              5249.413,
              -1832.233,
              8146.519
            ],
            [
              5225.46,
              -1837.335,
              8171.009
            ],
            [
              5188.082,
              -1836.611,
              8208.394
            ],
            [
              5153.346,
              -1832.599,
              8243.361
            ],
            [
              4971.288,
              -1778.982,
              8433.15
            ],
            [
              4961.707,
              -1774.344,
              8443.795
            ],
            [
              4949.033,
              -1762.966,
              8460.827
            ],
            [
              4912.749,
              -1738.887,
              8504.373
            ],
            [
              4896.938,
              -1722.996,
              8526.79
            ],
            [
              4894.317,
              -1725.172,
              8530.196
            ],
            [
              4917.69,
              -1783.513,
              8593.045
            ],
            [
              4983.058,
              -1937.294,
              8760.142
            ],
            [
              4991.178,
              -1950.81,
              8775.909
            ],
            [
              5006.988,
              -1966.701,
              8798.326
            ],
            [
              5059.766,
              -2004.459,
              8863.219
            ],
            [
              5072.439,
              -2015.837,
              8880.251
            ],
            [
              5086.057,
              -2045.045,
              8912.478
            ],
            [
              5138.076,
              -2188.551,
              9065.12
            ],
            [
              5142.221,
              -2207.556,
              9084.573
            ],
            [
              5141.833,
              -2227.588,
              9104.608
            ],
            [
              5148.706,
              -2238.854,
              9117.805
            ],
            [
              5137.92,
              -2296.535,
              9176.486
            ],
            [
              5132.226,
              -2324.256,
              9204.786
            ],
            [
              5107.973,
              -2378.337,
              9264.056
            ],
            [
              5099.037,
              -2407.11,
              9294.184
            ],
            [
              5099.572,
              -2446.085,
              9333.163
            ],
            [
              5089.862,
              -2481.521,
              9369.906
            ],
            [
              5066.9,
              -2502.229,
              9400.826
            ],
            [
              4994.322,
              -2588.775,
              9513.776
            ],
            [
              4939.1,
              -2644.485,
              9592.217
            ],
            [
              4796.941,
              -2796.486,
              9800.337
            ],
            [
              4754.396,
              -2863.575,
              9879.779
            ],
            [
              4654.319,
              -2972.975,
              10028.048
            ],
            [
              4431.036,
              -2819.503,
              10298.988
            ],
            [
              4422.037,
              -2818.217,
              10308.079
            ],
            [
              4248.143,
              -2710.235,
              10512.771
            ],
            [
              4239.187,
              -2706.724,
              10522.392
            ],
            [
              4206.906,
              -2709.445,
              10554.786
            ],
            [
              4148.315,
              -2706.097,
              10613.473
            ],
            [
              4083.685,
              -2681.482,
              10682.632
            ],
            [
              4052.842,
              -2676.439,
              10713.885
            ],
            [
              4056.942,
              -2664.271,
              10726.725
            ],
            [
              4062.246,
              -2656.58,
              10736.067
            ],
            [
              4038.186,
              -2633.855,
              10769.162
            ],
            [
              4030.752,
              -2618.127,
              10786.559
            ],
            [
              4029.18,
              -2599.171,
              10805.579
            ],
            [
              4031.022,
              -2570.262,
              10834.548
            ],
            [
              4042.933,
              -2520.392,
              10885.82
            ],
            [
              4043.189,
              -2507.038,
              10899.176
            ],
            [
              4039.684,
              -2488.046,
              10918.489
            ],
            [
              4014.866,
              -2437.475,
              10974.822
            ],
            [
              3997.186,
              -2418.211,
              11000.969
            ],
            [
              3943.887,
              -2373.776,
              11070.361
            ],
            [
              3899.892,
              -2348.445,
              11121.127
            ],
            [
              3872.892,
              -2344.59,
              11148.402
            ],
            [
              3841.296,
              -2345.1,
              11180.001
            ],
            [
              3772.844,
              -2351.588,
              11248.761
            ],
            [
              3727.135,
              -2348.491,
              11294.574
            ],
            [
              3642.975,
              -2333.53,
              11380.053
            ],
            [
              3597.932,
              -2329.334,
              11425.292
            ],
            [
              3525.677,
              -2332.413,
              11497.613
            ],
            [
              3501.94,
              -2326.396,
              11522.1
            ],
            [
              3483.591,
              -2308.236,
              11547.916
            ],
            [
              3478.067,
              -2293.658,
              11563.506
            ],
            [
              3430.234,
              -2300.543,
              11611.831
            ],
            [
              3387.662,
              -2301.962,
              11654.426
            ],
            [
              3196.764,
              -2272.74,
              11847.548
            ],
            [
              3157.806,
              -2287.589,
              11889.24
            ],
            [
              3002.929,
              -2364.816,
              12062.304
            ],
            [
              2811.307,
              -2442.469,
              12269.062
            ],
            [
              2719.174,
              -2508.643,
              12382.496
            ],
            [
              2680.157,
              -2526.834,
              12425.546
            ],
            [
              2599.153,
              -2549.802,
              12509.743
            ],
            [
              2457.059,
              -2599.457,
              12660.263
            ],
            [
              2382.396,
              -2628.114,
              12740.237
            ],
            [
              2328.687,
              -2639.354,
              12795.11
            ],
            [
              2411.872,
              -3118.499,
              13281.422
            ],
            [
              2419.872,
              -3138.687,
              13303.138
            ],
            [
              2418.768,
              -3163.158,
              13327.634
            ],
            [
              2474.472,
              -3526.012,
              13694.738
            ],
            [
              2513.109,
              -3664.781,
              13838.786
            ],
            [
              2522.438,
              -3682.768,
              13859.048
            ],
            [
              2553.555,
              -3775.753,
              13957.102
            ],
            [
              2562.319,
              -3823.788,
              14005.929
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:16453",
              "position": {
                "x": 9172.201,
                "z": 767.538
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17009",
              "position": {
                "x": 9696.796,
                "z": 488.592
              },
              "distanceAlongShapeM": 615.114,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 1090.641,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 1324.503,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 1709.182,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 2193.17,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5400",
              "position": {
                "x": 8486.109,
                "z": -663.69
              },
              "distanceAlongShapeM": 2836.636,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5415",
              "position": {
                "x": 7876.316,
                "z": -682.656
              },
              "distanceAlongShapeM": 3519.594,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6230",
              "position": {
                "x": 7745.609,
                "z": -1028.51
              },
              "distanceAlongShapeM": 4160.66,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6216",
              "position": {
                "x": 7930.115,
                "z": -1379.536
              },
              "distanceAlongShapeM": 4570.131,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6219",
              "position": {
                "x": 7487.751,
                "z": -1608.969
              },
              "distanceAlongShapeM": 5085.953,
              "shapeOffsetM": 0.45,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6221",
              "position": {
                "x": 7384.989,
                "z": -1978.766
              },
              "distanceAlongShapeM": 5513.025,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:10612",
              "position": {
                "x": 7285.671,
                "z": -2240.645
              },
              "distanceAlongShapeM": 5836.923,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9605",
              "position": {
                "x": 6885.221,
                "z": -2279.48
              },
              "distanceAlongShapeM": 6239.252,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:10530",
              "position": {
                "x": 6582.95,
                "z": -2177.781
              },
              "distanceAlongShapeM": 6572.228,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9607",
              "position": {
                "x": 6326.245,
                "z": -2085.902
              },
              "distanceAlongShapeM": 6848.307,
              "shapeOffsetM": 0.874,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:10317",
              "position": {
                "x": 5963.871,
                "z": -2056.543
              },
              "distanceAlongShapeM": 7214.954,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 7816.823,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:9608",
              "position": {
                "x": 5148.706,
                "z": -2238.854
              },
              "distanceAlongShapeM": 9117.805,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9969",
              "position": {
                "x": 5089.862,
                "z": -2481.521
              },
              "distanceAlongShapeM": 9369.906,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:9676",
              "position": {
                "x": 4754.396,
                "z": -2863.575
              },
              "distanceAlongShapeM": 9879.779,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:9613",
              "position": {
                "x": 4422.037,
                "z": -2818.217
              },
              "distanceAlongShapeM": 10308.079,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:9755",
              "position": {
                "x": 4148.315,
                "z": -2706.097
              },
              "distanceAlongShapeM": 10613.473,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:4521",
              "position": {
                "x": 3280.303,
                "z": -2286.568
              },
              "distanceAlongShapeM": 11762.879,
              "shapeOffsetM": 1.028,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:11046",
              "position": {
                "x": 2680.157,
                "z": -2526.834
              },
              "distanceAlongShapeM": 12425.546,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6720",
              "position": {
                "x": 2382.396,
                "z": -2628.114
              },
              "distanceAlongShapeM": 12740.237,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 13303.138,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 13859.048,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5483",
              "position": {
                "x": 2562.319,
                "z": -3823.788
              },
              "distanceAlongShapeM": 14005.929,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            }
          ],
          "departuresSeconds": [
            19560,
            20880,
            22440,
            24000,
            24840,
            26100,
            26940,
            28560,
            30180,
            31080,
            32640,
            34980,
            37080,
            39120,
            40740,
            43020,
            45060,
            46440,
            48660,
            50940,
            52860,
            54720,
            56580,
            57900,
            59100,
            60300,
            61620,
            62880,
            64800,
            66780,
            68460,
            70380,
            72540,
            74940,
            77400,
            79680,
            81840,
            84000
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_116",
      "sourceRouteId": "vilnius_bus_116",
      "mode": "bus",
      "shortName": "116",
      "longName": "Žvėrynas–Gudelių šilas–Lazdynai–Ungurių g. (Apylanka)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_116:0",
          "sourceRouteId": "vilnius_bus_116",
          "sourceShapeId": "vilnius_bus_116_a1-b1",
          "directionId": 0,
          "headsign": "Ungurių g. (Apylanka)",
          "directionName": "Žvėrynas–Gudelių šilas–Lazdynai–Ungurių g. (Apylanka)",
          "mode": "bus",
          "routeShortName": "116",
          "routeLongName": "Žvėrynas–Gudelių šilas–Lazdynai–Ungurių g. (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2123.206,
              -1077.551,
              0
            ],
            [
              -2103.81,
              -1074.556,
              19.626
            ],
            [
              -2090.919,
              -1074.785,
              32.519
            ],
            [
              -2071.721,
              -1082.918,
              53.369
            ],
            [
              -2068.854,
              -1103.007,
              73.661
            ],
            [
              -2072.195,
              -1109.627,
              81.077
            ],
            [
              -2142.708,
              -1122.847,
              152.818
            ],
            [
              -2159.624,
              -1131.453,
              171.797
            ],
            [
              -2184.551,
              -1155.502,
              206.434
            ],
            [
              -2202.716,
              -1161.859,
              225.68
            ],
            [
              -2224.67,
              -1163.697,
              247.71
            ],
            [
              -2246.137,
              -1174.448,
              271.719
            ],
            [
              -2255.963,
              -1183.18,
              284.864
            ],
            [
              -2262.447,
              -1185.292,
              291.684
            ],
            [
              -2339.674,
              -1177.245,
              369.328
            ],
            [
              -2392.506,
              -1175.197,
              422.2
            ],
            [
              -2433.855,
              -1180.032,
              463.831
            ],
            [
              -2474.658,
              -1190.444,
              505.941
            ],
            [
              -2521.496,
              -1214.107,
              558.418
            ],
            [
              -2594.45,
              -1256.235,
              642.661
            ],
            [
              -2624.997,
              -1270.168,
              676.237
            ],
            [
              -2680.78,
              -1289.223,
              735.183
            ],
            [
              -2710.565,
              -1296.491,
              765.843
            ],
            [
              -2777.752,
              -1304.214,
              833.472
            ],
            [
              -2815.153,
              -1304.669,
              870.876
            ],
            [
              -2855.074,
              -1301.74,
              910.905
            ],
            [
              -3099.309,
              -1258.49,
              1158.939
            ],
            [
              -3140.52,
              -1255.542,
              1200.255
            ],
            [
              -3159.719,
              -1247.413,
              1221.105
            ],
            [
              -3359.526,
              -1207.182,
              1424.921
            ],
            [
              -3495.953,
              -1192.555,
              1562.13
            ],
            [
              -3569.469,
              -1193.5,
              1635.652
            ],
            [
              -3626.266,
              -1196.964,
              1692.554
            ],
            [
              -3657.704,
              -1114.039,
              1781.238
            ],
            [
              -3680.758,
              -1067.996,
              1832.731
            ],
            [
              -3686.114,
              -1042.299,
              1858.98
            ],
            [
              -3720.918,
              -930.373,
              1976.193
            ],
            [
              -3751.541,
              -837.444,
              2074.037
            ],
            [
              -3761.526,
              -818.346,
              2095.588
            ],
            [
              -3766.218,
              -791.548,
              2122.794
            ],
            [
              -3793.988,
              -719.82,
              2199.71
            ],
            [
              -3843.779,
              -616.54,
              2314.365
            ],
            [
              -3881.258,
              -546.871,
              2393.476
            ],
            [
              -3968.98,
              -399.519,
              2564.962
            ],
            [
              -3986.683,
              -379.175,
              2591.93
            ],
            [
              -3999.719,
              -350.005,
              2623.88
            ],
            [
              -4048.201,
              -282.373,
              2707.095
            ],
            [
              -4133.499,
              -180.709,
              2839.802
            ],
            [
              -4196.245,
              -117.285,
              2929.019
            ],
            [
              -4221.08,
              -99.045,
              2959.833
            ],
            [
              -4245.021,
              -66.348,
              3000.358
            ],
            [
              -4257.704,
              -53.884,
              3018.14
            ],
            [
              -4302.199,
              -16.38,
              3076.332
            ],
            [
              -4338.333,
              19.866,
              3127.512
            ],
            [
              -4359.301,
              38.038,
              3155.26
            ],
            [
              -4372.725,
              44.949,
              3170.358
            ],
            [
              -4380.461,
              45.082,
              3178.096
            ],
            [
              -4440.12,
              26.073,
              3240.709
            ],
            [
              -4464.714,
              20.93,
              3265.836
            ],
            [
              -4478.879,
              22.287,
              3280.065
            ],
            [
              -4489.743,
              28.04,
              3292.359
            ],
            [
              -4530.309,
              106.663,
              3380.829
            ],
            [
              -4592.389,
              246.88,
              3534.175
            ],
            [
              -4608.183,
              266.076,
              3559.033
            ],
            [
              -4606.683,
              278.296,
              3571.344
            ],
            [
              -4634.224,
              364.486,
              3661.827
            ],
            [
              -4642.013,
              399.129,
              3697.335
            ],
            [
              -4647.057,
              405.894,
              3705.774
            ],
            [
              -4689.1,
              398.824,
              3748.408
            ],
            [
              -4691.149,
              392.18,
              3755.361
            ],
            [
              -4702.716,
              394.605,
              3767.179
            ],
            [
              -4828.883,
              371.165,
              3895.505
            ],
            [
              -4896.754,
              362.309,
              3963.951
            ],
            [
              -4951.161,
              348.768,
              4020.018
            ],
            [
              -5014.234,
              318.678,
              4089.902
            ],
            [
              -5076.777,
              281.898,
              4162.457
            ],
            [
              -5110.283,
              321.432,
              4214.28
            ],
            [
              -5126.003,
              345.077,
              4242.674
            ],
            [
              -5130.743,
              369.649,
              4267.698
            ],
            [
              -5143.087,
              402.142,
              4302.458
            ],
            [
              -5246.703,
              604.285,
              4529.61
            ],
            [
              -5257.987,
              623.401,
              4551.808
            ],
            [
              -5270.712,
              633.637,
              4568.139
            ],
            [
              -5269.252,
              643.631,
              4578.239
            ],
            [
              -5287.913,
              684.024,
              4622.734
            ],
            [
              -5304.033,
              684.298,
              4638.857
            ],
            [
              -5367.982,
              678.708,
              4703.049
            ],
            [
              -5415.868,
              669.503,
              4751.811
            ],
            [
              -5465.175,
              652.531,
              4803.958
            ],
            [
              -5472.135,
              660.441,
              4814.495
            ],
            [
              -5495.218,
              706.474,
              4865.991
            ],
            [
              -5524.047,
              755.945,
              4923.249
            ],
            [
              -5584.133,
              825.983,
              5015.529
            ],
            [
              -5631.872,
              863.528,
              5076.263
            ],
            [
              -5674.076,
              923.242,
              5149.386
            ],
            [
              -5693.1,
              942.489,
              5176.449
            ],
            [
              -5766.263,
              1040.576,
              5298.816
            ],
            [
              -5722.779,
              1094.386,
              5367.999
            ],
            [
              -5705.296,
              1136.391,
              5413.498
            ],
            [
              -5699.817,
              1155.223,
              5433.11
            ],
            [
              -5700.805,
              1173.051,
              5450.965
            ],
            [
              -5707.997,
              1205.455,
              5484.158
            ],
            [
              -5707.088,
              1221.024,
              5499.754
            ],
            [
              -5693.946,
              1235.273,
              5519.138
            ],
            [
              -5660.054,
              1255.85,
              5558.788
            ],
            [
              -5554.355,
              1326.415,
              5685.876
            ],
            [
              -5499.41,
              1371.123,
              5756.713
            ],
            [
              -5487.499,
              1388.732,
              5777.972
            ],
            [
              -5486.438,
              1413.204,
              5802.467
            ],
            [
              -5491.201,
              1436.662,
              5826.404
            ],
            [
              -5514.76,
              1454.873,
              5856.181
            ],
            [
              -5500.232,
              1474.664,
              5880.732
            ],
            [
              -5452.321,
              1522.831,
              5948.669
            ],
            [
              -5293.275,
              1657.048,
              6156.779
            ],
            [
              -5286.75,
              1661.39,
              6164.617
            ],
            [
              -5277.683,
              1663.462,
              6173.918
            ],
            [
              -5219.619,
              1663.586,
              6231.981
            ],
            [
              -5185.058,
              1685.261,
              6272.777
            ],
            [
              -5167.872,
              1709.458,
              6302.456
            ],
            [
              -5113.315,
              1806.489,
              6413.773
            ],
            [
              -5092.923,
              1829.518,
              6444.533
            ],
            [
              -5078.505,
              1842.63,
              6464.021
            ],
            [
              -5067.56,
              1841.33,
              6475.044
            ],
            [
              -5058.626,
              1835.611,
              6485.652
            ],
            [
              -5051.474,
              1838.829,
              6493.494
            ],
            [
              -5037.304,
              1837.474,
              6507.728
            ],
            [
              -5023.305,
              1826.102,
              6525.764
            ],
            [
              -4928.804,
              1730.978,
              6659.849
            ],
            [
              -4906.917,
              1690.529,
              6705.841
            ],
            [
              -4842.797,
              1742.865,
              6788.608
            ],
            [
              -4801.101,
              1766.641,
              6836.607
            ],
            [
              -4774.467,
              1777.316,
              6865.3
            ],
            [
              -4728.427,
              1790.998,
              6913.33
            ],
            [
              -4687.68,
              1796.979,
              6954.514
            ],
            [
              -4579.155,
              1805.134,
              7063.345
            ],
            [
              -4547.361,
              1815.72,
              7096.855
            ],
            [
              -4518.395,
              1811.882,
              7126.074
            ],
            [
              -4300.033,
              1829.272,
              7345.127
            ],
            [
              -4282.619,
              1828.972,
              7362.544
            ],
            [
              -4232.446,
              1820.314,
              7413.458
            ],
            [
              -4165.014,
              1802.452,
              7483.216
            ],
            [
              -4141.304,
              1793.136,
              7508.69
            ],
            [
              -4122.773,
              1782.797,
              7529.91
            ],
            [
              -4066.123,
              1738.403,
              7601.884
            ],
            [
              -4047.525,
              1694.666,
              7649.41
            ],
            [
              -4037.081,
              1664.429,
              7681.4
            ],
            [
              -4020.121,
              1600.683,
              7747.364
            ],
            [
              -3992.198,
              1462.162,
              7888.671
            ],
            [
              -3984.902,
              1436.432,
              7915.415
            ],
            [
              -3986.154,
              1438.68,
              7917.988
            ],
            [
              -3968.906,
              1391.627,
              7968.103
            ],
            [
              -3969.311,
              1368.257,
              7991.477
            ],
            [
              -3952.68,
              1285.592,
              8075.798
            ],
            [
              -3953.633,
              1267.797,
              8093.618
            ],
            [
              -3986.792,
              1252.786,
              8130.016
            ],
            [
              -4052.311,
              1231.656,
              8198.858
            ],
            [
              -4088.482,
              1228.943,
              8235.13
            ],
            [
              -4121.332,
              1231.737,
              8268.099
            ],
            [
              -4147.695,
              1236.645,
              8294.916
            ],
            [
              -4215.081,
              1256.734,
              8365.232
            ],
            [
              -4241.916,
              1271.669,
              8395.943
            ],
            [
              -4268.203,
              1281.028,
              8423.846
            ],
            [
              -4527.979,
              1404.616,
              8711.522
            ],
            [
              -4558.781,
              1414.051,
              8743.737
            ],
            [
              -4581.673,
              1433.369,
              8773.69
            ],
            [
              -4718.251,
              1519.203,
              8935.002
            ],
            [
              -4838.028,
              1606.973,
              9083.494
            ],
            [
              -4855.022,
              1631.754,
              9113.543
            ],
            [
              -4943.107,
              1724.544,
              9241.484
            ],
            [
              -4962.228,
              1738.229,
              9264.997
            ],
            [
              -5069.077,
              1865.846,
              9431.439
            ],
            [
              -5076.134,
              1868.193,
              9438.875
            ],
            [
              -5119.953,
              1909.016,
              9498.764
            ],
            [
              -5214.195,
              1981.867,
              9617.881
            ],
            [
              -5228.689,
              2002.152,
              9642.812
            ],
            [
              -5236.77,
              2020.101,
              9662.496
            ],
            [
              -5240.925,
              2041.322,
              9684.12
            ],
            [
              -5239.294,
              2061.332,
              9704.196
            ],
            [
              -5227.836,
              2090.08,
              9735.144
            ],
            [
              -5213.304,
              2109.87,
              9759.696
            ],
            [
              -5193.689,
              2125.12,
              9784.542
            ],
            [
              -5147.096,
              2133.231,
              9831.835
            ],
            [
              -5074.894,
              2129.773,
              9904.12
            ],
            [
              -4973.287,
              2110.226,
              10007.59
            ],
            [
              -4894.768,
              2098.864,
              10086.927
            ],
            [
              -4850.889,
              2099.226,
              10130.808
            ],
            [
              -4603.07,
              2140.618,
              10382.06
            ],
            [
              -4527.565,
              2141.547,
              10457.57
            ],
            [
              -4479.873,
              2138.5,
              10505.359
            ],
            [
              -4449.462,
              2143.543,
              10536.186
            ],
            [
              -4390.804,
              2140.306,
              10594.932
            ],
            [
              -4376.576,
              2142.288,
              10609.298
            ],
            [
              -4195.427,
              2208.182,
              10802.059
            ],
            [
              -4108.264,
              2248.978,
              10898.297
            ],
            [
              -4011,
              2314.088,
              11015.343
            ],
            [
              -3940.43,
              2365.187,
              11102.47
            ],
            [
              -3943.03,
              2364.119,
              11105.28
            ],
            [
              -3945.224,
              2386.421,
              11127.69
            ],
            [
              -3966.145,
              2407.934,
              11157.698
            ],
            [
              -3991.012,
              2499.647,
              11252.723
            ],
            [
              -4043.609,
              2629.688,
              11392.998
            ],
            [
              -4060.699,
              2648.908,
              11418.717
            ],
            [
              -4116.103,
              2803.488,
              11582.926
            ],
            [
              -4124.654,
              2831.465,
              11612.181
            ],
            [
              -4145.675,
              2921.998,
              11705.122
            ],
            [
              -4153.919,
              2967.781,
              11751.642
            ],
            [
              -4167.738,
              3027.02,
              11812.47
            ],
            [
              -4202.041,
              3133.366,
              11924.212
            ],
            [
              -4257.982,
              3220.047,
              12027.377
            ],
            [
              -4348.426,
              3289.511,
              12141.418
            ],
            [
              -4400.946,
              3312.679,
              12198.822
            ],
            [
              -4445.196,
              3329.026,
              12245.994
            ],
            [
              -4463.829,
              3333.799,
              12265.229
            ],
            [
              -4474.19,
              3331.751,
              12275.791
            ],
            [
              -4488.953,
              3336.457,
              12291.285
            ],
            [
              -4510.831,
              3340.173,
              12313.477
            ],
            [
              -4451.839,
              3955.87,
              12931.994
            ],
            [
              -4445.917,
              3962.447,
              12940.844
            ],
            [
              -4442.026,
              3963.493,
              12944.873
            ],
            [
              -4415.001,
              3958.576,
              12972.342
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:4898",
              "position": {
                "x": -2071.721,
                "z": -1082.918
              },
              "distanceAlongShapeM": 53.369,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 1200.255,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 1832.731,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 2095.588,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 2591.93,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 2959.833,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5920",
              "position": {
                "x": -4608.183,
                "z": 266.076
              },
              "distanceAlongShapeM": 3559.033,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:19220",
              "position": {
                "x": -4691.149,
                "z": 392.18
              },
              "distanceAlongShapeM": 3755.361,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:19223",
              "position": {
                "x": -5270.712,
                "z": 633.637
              },
              "distanceAlongShapeM": 4568.139,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9961",
              "position": {
                "x": -5693.1,
                "z": 942.489
              },
              "distanceAlongShapeM": 5176.449,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:9636",
              "position": {
                "x": -5452.321,
                "z": 1522.831
              },
              "distanceAlongShapeM": 5948.669,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 6659.849,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5691",
              "position": {
                "x": -4547.361,
                "z": 1815.72
              },
              "distanceAlongShapeM": 7096.855,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5693",
              "position": {
                "x": -4066.123,
                "z": 1738.403
              },
              "distanceAlongShapeM": 7601.884,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1230,
              "departureOffsetSeconds": 1230
            },
            {
              "stopId": "judu:stop:5697",
              "position": {
                "x": -3968.906,
                "z": 1391.627
              },
              "distanceAlongShapeM": 7968.103,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1290,
              "departureOffsetSeconds": 1290
            },
            {
              "stopId": "judu:stop:6318",
              "position": {
                "x": -4215.081,
                "z": 1256.734
              },
              "distanceAlongShapeM": 8365.232,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6319",
              "position": {
                "x": -4558.781,
                "z": 1414.051
              },
              "distanceAlongShapeM": 8743.737,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6320",
              "position": {
                "x": -4838.028,
                "z": 1606.973
              },
              "distanceAlongShapeM": 9083.494,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7341",
              "position": {
                "x": -4962.228,
                "z": 1738.229
              },
              "distanceAlongShapeM": 9264.997,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1530,
              "departureOffsetSeconds": 1530
            },
            {
              "stopId": "judu:stop:6401",
              "position": {
                "x": -5074.894,
                "z": 2129.773
              },
              "distanceAlongShapeM": 9904.12,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6379",
              "position": {
                "x": -4449.462,
                "z": 2143.543
              },
              "distanceAlongShapeM": 10536.186,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:9102",
              "position": {
                "x": -3966.145,
                "z": 2407.934
              },
              "distanceAlongShapeM": 11157.698,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6389",
              "position": {
                "x": -4060.699,
                "z": 2648.908
              },
              "distanceAlongShapeM": 11418.717,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:7722",
              "position": {
                "x": -4474.19,
                "z": 3331.751
              },
              "distanceAlongShapeM": 12275.791,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:10264",
              "position": {
                "x": -4415.001,
                "z": 3958.576
              },
              "distanceAlongShapeM": 12972.342,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            }
          ],
          "departuresSeconds": [
            20040,
            25320,
            28320,
            31320,
            34320,
            38460,
            41400,
            44160,
            46860,
            49560,
            52260,
            54900,
            57720,
            60360,
            66000,
            73020,
            78300,
            83520
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_116:1",
          "sourceRouteId": "vilnius_bus_116",
          "sourceShapeId": "vilnius_bus_116_b1-a1",
          "directionId": 1,
          "headsign": "Žvėrynas (Apylanka)",
          "directionName": "Ungurių g.–Lazdynai–Gudelių šilas–Žvėrynas (Apylanka)",
          "mode": "bus",
          "routeShortName": "116",
          "routeLongName": "Žvėrynas–Gudelių šilas–Lazdynai–Ungurių g. (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4415.001,
              3958.576,
              0
            ],
            [
              -4451.839,
              3955.87,
              36.937
            ],
            [
              -4465.718,
              3786.903,
              206.473
            ],
            [
              -4510.831,
              3340.173,
              655.475
            ],
            [
              -4497.206,
              3344.392,
              669.738
            ],
            [
              -4441.951,
              3330.083,
              726.816
            ],
            [
              -4389.959,
              3313.604,
              781.357
            ],
            [
              -4348.426,
              3289.511,
              829.372
            ],
            [
              -4264.944,
              3227.96,
              933.092
            ],
            [
              -4234.003,
              3188.464,
              983.264
            ],
            [
              -4197.015,
              3125.487,
              1056.3
            ],
            [
              -4171.244,
              3048.231,
              1137.741
            ],
            [
              -4157.405,
              2990.106,
              1197.491
            ],
            [
              -4124.692,
              2829.24,
              1361.649
            ],
            [
              -4095.054,
              2751.917,
              1444.458
            ],
            [
              -4080.014,
              2726.053,
              1474.377
            ],
            [
              -4012.116,
              2547.88,
              1665.049
            ],
            [
              -3954.322,
              2419.974,
              1805.405
            ],
            [
              -3953.773,
              2414.399,
              1811.008
            ],
            [
              -3941.999,
              2386.365,
              1841.414
            ],
            [
              -3939.024,
              2371.842,
              1856.239
            ],
            [
              -3943.03,
              2364.119,
              1864.938
            ],
            [
              -4006.465,
              2315.123,
              1945.093
            ],
            [
              -4077.678,
              2264.034,
              2032.736
            ],
            [
              -4113.54,
              2242.39,
              2074.622
            ],
            [
              -4156.496,
              2220.868,
              2122.668
            ],
            [
              -4324.119,
              2153.629,
              2303.275
            ],
            [
              -4374.718,
              2137.803,
              2356.291
            ],
            [
              -4407.025,
              2135.02,
              2388.718
            ],
            [
              -4518.062,
              2131.364,
              2499.815
            ],
            [
              -4577.307,
              2137.949,
              2559.425
            ],
            [
              -4634.125,
              2135.585,
              2616.292
            ],
            [
              -4816.04,
              2099.743,
              2801.704
            ],
            [
              -4855.442,
              2097.078,
              2841.196
            ],
            [
              -4917.969,
              2100.374,
              2903.81
            ],
            [
              -4969.474,
              2106.821,
              2955.717
            ],
            [
              -5079.485,
              2125.398,
              3067.285
            ],
            [
              -5115.548,
              2129.353,
              3103.565
            ],
            [
              -5151.175,
              2121.056,
              3140.145
            ],
            [
              -5168.571,
              2122.465,
              3157.599
            ],
            [
              -5186.062,
              2118.311,
              3175.576
            ],
            [
              -5204.976,
              2106.388,
              3197.934
            ],
            [
              -5218.73,
              2094.377,
              3216.194
            ],
            [
              -5232.085,
              2067.888,
              3245.859
            ],
            [
              -5234.987,
              2049.013,
              3264.956
            ],
            [
              -5232.767,
              2027.825,
              3286.261
            ],
            [
              -5229.106,
              2015.517,
              3299.101
            ],
            [
              -5217.174,
              1996.39,
              3321.646
            ],
            [
              -5203.212,
              1982.793,
              3341.134
            ],
            [
              -5082.26,
              1887.222,
              3495.287
            ],
            [
              -5064.922,
              1882.473,
              3513.264
            ],
            [
              -5060.085,
              1863.466,
              3532.876
            ],
            [
              -4961.259,
              1757.137,
              3678.04
            ],
            [
              -4928.804,
              1730.978,
              3719.725
            ],
            [
              -4906.917,
              1690.529,
              3765.716
            ],
            [
              -4767.773,
              1565.694,
              3952.652
            ],
            [
              -4739.606,
              1552.966,
              3983.561
            ],
            [
              -4712.351,
              1524.668,
              4022.849
            ],
            [
              -4596.2,
              1451.429,
              4160.163
            ],
            [
              -4491.296,
              1399.532,
              4277.202
            ],
            [
              -4466.279,
              1391.309,
              4303.536
            ],
            [
              -4443.995,
              1374.227,
              4331.614
            ],
            [
              -4243.678,
              1281.718,
              4552.26
            ],
            [
              -4197.987,
              1275.363,
              4598.391
            ],
            [
              -4179.458,
              1265.024,
              4619.609
            ],
            [
              -4137.695,
              1255.397,
              4662.467
            ],
            [
              -4093.256,
              1251.289,
              4707.096
            ],
            [
              -4041.607,
              1253.735,
              4758.802
            ],
            [
              -3953.633,
              1267.797,
              4847.893
            ],
            [
              -4003.354,
              1451.223,
              5037.939
            ],
            [
              -4002.478,
              1464.567,
              5051.311
            ],
            [
              -4050.827,
              1690.271,
              5282.135
            ],
            [
              -4137.78,
              1773.038,
              5402.182
            ],
            [
              -4148.475,
              1788.807,
              5421.236
            ],
            [
              -4177.913,
              1802.674,
              5453.776
            ],
            [
              -4315.532,
              1828.426,
              5593.784
            ],
            [
              -4369.14,
              1824.898,
              5647.509
            ],
            [
              -4499.314,
              1795.969,
              5780.858
            ],
            [
              -4609.774,
              1787.849,
              5891.616
            ],
            [
              -4563.222,
              1793.728,
              5938.538
            ],
            [
              -4774.467,
              1777.316,
              6150.419
            ],
            [
              -4906.917,
              1690.529,
              6308.77
            ],
            [
              -4962.228,
              1738.229,
              6381.808
            ],
            [
              -5044.455,
              1834.256,
              6508.23
            ],
            [
              -5051.474,
              1838.829,
              6516.607
            ],
            [
              -5059.29,
              1834.509,
              6525.537
            ],
            [
              -5065.758,
              1833.507,
              6532.083
            ],
            [
              -5077.292,
              1838.156,
              6544.518
            ],
            [
              -5083.779,
              1836.041,
              6551.342
            ],
            [
              -5108.061,
              1811.965,
              6585.536
            ],
            [
              -5127.846,
              1786.699,
              6617.627
            ],
            [
              -5175.896,
              1692.897,
              6723.02
            ],
            [
              -5200.708,
              1675.509,
              6753.318
            ],
            [
              -5218.292,
              1665.79,
              6773.409
            ],
            [
              -5284.777,
              1663.583,
              6839.931
            ],
            [
              -5299.781,
              1653.82,
              6857.832
            ],
            [
              -5320.874,
              1627.462,
              6891.59
            ],
            [
              -5369.224,
              1591.549,
              6951.819
            ],
            [
              -5472.179,
              1493.112,
              7094.261
            ],
            [
              -5514.76,
              1454.873,
              7151.491
            ],
            [
              -5493.079,
              1440.033,
              7177.764
            ],
            [
              -5485.092,
              1416.521,
              7202.597
            ],
            [
              -5486.816,
              1390.947,
              7228.229
            ],
            [
              -5513.881,
              1354.671,
              7273.488
            ],
            [
              -5671.13,
              1249.358,
              7462.745
            ],
            [
              -5691.973,
              1237.466,
              7486.742
            ],
            [
              -5702.499,
              1225.399,
              7502.754
            ],
            [
              -5699.704,
              1161.9,
              7566.315
            ],
            [
              -5701.94,
              1144.127,
              7584.228
            ],
            [
              -5714.151,
              1108.711,
              7621.69
            ],
            [
              -5737.988,
              1072.38,
              7665.143
            ],
            [
              -5763.038,
              1040.521,
              7705.671
            ],
            [
              -5682.1,
              944.529,
              7831.231
            ],
            [
              -5677.832,
              929.985,
              7846.389
            ],
            [
              -5640.73,
              873.697,
              7913.805
            ],
            [
              -5575.883,
              818.05,
              7999.255
            ],
            [
              -5510.827,
              736.796,
              8103.343
            ],
            [
              -5467.754,
              652.574,
              8197.94
            ],
            [
              -5426.184,
              669.679,
              8242.891
            ],
            [
              -5362.103,
              683.06,
              8308.355
            ],
            [
              -5285.903,
              688.442,
              8384.745
            ],
            [
              -5276.705,
              660.456,
              8414.204
            ],
            [
              -5267.128,
              654.727,
              8425.364
            ],
            [
              -5262.292,
              635.72,
              8444.976
            ],
            [
              -5206.708,
              529.019,
              8565.287
            ],
            [
              -5136.299,
              384.215,
              8726.302
            ],
            [
              -5127.026,
              360.679,
              8751.598
            ],
            [
              -5124.106,
              342.818,
              8769.696
            ],
            [
              -5115.953,
              329.321,
              8785.465
            ],
            [
              -5078.009,
              285.258,
              8843.613
            ],
            [
              -5070.272,
              285.126,
              8851.352
            ],
            [
              -5037.01,
              306.822,
              8891.064
            ],
            [
              -4981.01,
              338.147,
              8955.23
            ],
            [
              -4938.834,
              353.01,
              8999.948
            ],
            [
              -4877.961,
              367.553,
              9062.535
            ],
            [
              -4716.939,
              392.623,
              9225.496
            ],
            [
              -4696.116,
              403.397,
              9248.942
            ],
            [
              -4674.194,
              403.021,
              9270.867
            ],
            [
              -4648.953,
              408.153,
              9296.625
            ],
            [
              -4636.172,
              401.255,
              9311.148
            ],
            [
              -4621.181,
              335.318,
              9378.767
            ],
            [
              -4591.687,
              250.208,
              9468.843
            ],
            [
              -4576.066,
              220.996,
              9501.969
            ],
            [
              -4568.349,
              219.75,
              9509.787
            ],
            [
              -4568.029,
              200.82,
              9528.719
            ],
            [
              -4518.608,
              112.027,
              9630.34
            ],
            [
              -4427.619,
              152.763,
              9730.031
            ],
            [
              -4384.818,
              166.497,
              9774.982
            ],
            [
              -4348.598,
              172.552,
              9811.704
            ],
            [
              -4322.828,
              170.994,
              9837.521
            ],
            [
              -4281.834,
              154.702,
              9881.634
            ],
            [
              -4267.159,
              145.543,
              9898.932
            ],
            [
              -4264.012,
              141.036,
              9904.429
            ],
            [
              -4264.811,
              132.144,
              9913.357
            ],
            [
              -4317.184,
              49.557,
              10011.15
            ],
            [
              -4317.318,
              41.767,
              10018.941
            ],
            [
              -4314.854,
              35.045,
              10026.1
            ],
            [
              -4265.47,
              -18.127,
              10098.668
            ],
            [
              -4077.229,
              -208.399,
              10366.321
            ],
            [
              -3954.469,
              -380.846,
              10578
            ],
            [
              -3921.604,
              -419.265,
              10628.559
            ],
            [
              -3917.323,
              -432.698,
              10642.657
            ],
            [
              -3857.936,
              -540.596,
              10765.819
            ],
            [
              -3823.641,
              -607.984,
              10841.431
            ],
            [
              -3766.483,
              -732.543,
              10978.479
            ],
            [
              -3707.64,
              -908.34,
              11163.862
            ],
            [
              -3695.741,
              -928.584,
              11187.345
            ],
            [
              -3679.35,
              -950.021,
              11214.329
            ],
            [
              -3668.232,
              -978.044,
              11244.478
            ],
            [
              -3606.925,
              -1085.98,
              11368.609
            ],
            [
              -3586.062,
              -1109.72,
              11400.215
            ],
            [
              -3575.241,
              -1117.701,
              11413.661
            ],
            [
              -3510.568,
              -1143.319,
              11483.222
            ],
            [
              -3355.367,
              -1190.556,
              11645.453
            ],
            [
              -3108.49,
              -1230.499,
              11895.54
            ],
            [
              -3070.013,
              -1242.306,
              11935.788
            ],
            [
              -2879.155,
              -1277.94,
              12129.943
            ],
            [
              -2839.273,
              -1283.094,
              12170.157
            ],
            [
              -2787.087,
              -1285.125,
              12222.383
            ],
            [
              -2748.376,
              -1283.58,
              12261.125
            ],
            [
              -2714.118,
              -1278.617,
              12295.74
            ],
            [
              -2670.7,
              -1266.023,
              12340.948
            ],
            [
              -2624.585,
              -1246.798,
              12390.91
            ],
            [
              -2500.301,
              -1182.198,
              12530.98
            ],
            [
              -2469.831,
              -1172.717,
              12562.891
            ],
            [
              -2418.716,
              -1162.489,
              12615.02
            ],
            [
              -2392.231,
              -1159.617,
              12641.66
            ],
            [
              -2246.137,
              -1174.448,
              12788.505
            ],
            [
              -2229.866,
              -1165.831,
              12806.917
            ],
            [
              -2190.996,
              -1155.388,
              12847.165
            ],
            [
              -2164.136,
              -1131.373,
              12883.195
            ],
            [
              -2142.708,
              -1122.847,
              12906.257
            ],
            [
              -2147.916,
              -1089.358,
              12940.149
            ],
            [
              -2143.266,
              -1081.648,
              12949.153
            ],
            [
              -2123.206,
              -1077.551,
              12969.627
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:10264",
              "position": {
                "x": -4415.001,
                "z": 3958.576
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -300,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7723",
              "position": {
                "x": -4497.206,
                "z": 3344.392
              },
              "distanceAlongShapeM": 669.738,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6388",
              "position": {
                "x": -4080.014,
                "z": 2726.053
              },
              "distanceAlongShapeM": 1474.377,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:8328",
              "position": {
                "x": -3954.322,
                "z": 2419.974
              },
              "distanceAlongShapeM": 1805.405,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6387",
              "position": {
                "x": -4156.496,
                "z": 2220.868
              },
              "distanceAlongShapeM": 2122.668,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6381",
              "position": {
                "x": -4518.062,
                "z": 2131.364
              },
              "distanceAlongShapeM": 2499.815,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:756",
              "position": {
                "x": -5151.175,
                "z": 2121.056
              },
              "distanceAlongShapeM": 3140.145,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:437",
              "position": {
                "x": -4928.804,
                "z": 1730.978
              },
              "distanceAlongShapeM": 3719.725,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:783",
              "position": {
                "x": -4739.606,
                "z": 1552.966
              },
              "distanceAlongShapeM": 3983.561,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:3589",
              "position": {
                "x": -4466.279,
                "z": 1391.309
              },
              "distanceAlongShapeM": 4303.536,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6317",
              "position": {
                "x": -4197.987,
                "z": 1275.363
              },
              "distanceAlongShapeM": 4598.391,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5698",
              "position": {
                "x": -4003.354,
                "z": 1451.223
              },
              "distanceAlongShapeM": 5037.939,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5694",
              "position": {
                "x": -4137.78,
                "z": 1773.038
              },
              "distanceAlongShapeM": 5402.182,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5692",
              "position": {
                "x": -4609.774,
                "z": 1787.849
              },
              "distanceAlongShapeM": 5891.616,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:7341",
              "position": {
                "x": -4962.228,
                "z": 1738.229
              },
              "distanceAlongShapeM": 6381.808,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9635",
              "position": {
                "x": -5472.179,
                "z": 1493.112
              },
              "distanceAlongShapeM": 7094.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9466",
              "position": {
                "x": -5682.1,
                "z": 944.529
              },
              "distanceAlongShapeM": 7831.231,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:19222",
              "position": {
                "x": -5267.128,
                "z": 654.727
              },
              "distanceAlongShapeM": 8425.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:19221",
              "position": {
                "x": -4696.116,
                "z": 403.397
              },
              "distanceAlongShapeM": 9248.942,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:351",
              "position": {
                "x": -4568.349,
                "z": 219.75
              },
              "distanceAlongShapeM": 9509.787,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 10366.321,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 10628.559,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 11214.329,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 11895.54,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:18481",
              "position": {
                "x": -2146.884,
                "z": -1103.849
              },
              "distanceAlongShapeM": 12925.672,
              "shapeOffsetM": 1.207,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            22500,
            27840,
            30840,
            33840,
            36840,
            40920,
            43860,
            46620,
            49320,
            52020,
            54720,
            57360,
            60120,
            63060,
            68760,
            75480,
            80700,
            85920
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_117",
      "sourceRouteId": "vilnius_bus_117",
      "mode": "bus",
      "shortName": "117",
      "longName": "Pilaitė–Kriaučiūnai–Platiniškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_117:0",
          "sourceRouteId": "vilnius_bus_117",
          "sourceShapeId": "vilnius_bus_117_a-b",
          "directionId": 0,
          "headsign": "Platiniškės",
          "directionName": "Pilaitė–Kriaučiūnai–Platiniškės",
          "mode": "bus",
          "routeShortName": "117",
          "routeLongName": "Pilaitė–Kriaučiūnai–Platiniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6804.479,
              -1529.023,
              0
            ],
            [
              -6810.019,
              -1513.345,
              16.627
            ],
            [
              -6803.426,
              -1504.55,
              27.62
            ],
            [
              -6797.569,
              -1501.308,
              34.313
            ],
            [
              -6795.561,
              -1496.889,
              39.167
            ],
            [
              -6804.801,
              -1471.131,
              66.532
            ],
            [
              -6817.871,
              -1443.083,
              97.476
            ],
            [
              -6849.755,
              -1383.551,
              165.008
            ],
            [
              -6863.711,
              -1369.96,
              184.489
            ],
            [
              -6869.747,
              -1345.369,
              209.81
            ],
            [
              -6867.739,
              -1340.95,
              214.664
            ],
            [
              -6861.864,
              -1336.595,
              221.977
            ],
            [
              -6854.775,
              -1336.714,
              229.067
            ],
            [
              -6850.945,
              -1339.004,
              233.53
            ],
            [
              -6837.763,
              -1360.375,
              258.639
            ],
            [
              -6823.318,
              -1421.841,
              321.78
            ],
            [
              -6723.821,
              -1601.615,
              527.251
            ],
            [
              -6711.23,
              -1619.637,
              549.236
            ],
            [
              -6684.251,
              -1702.465,
              636.346
            ],
            [
              -6676.395,
              -1733.766,
              668.618
            ],
            [
              -6677.514,
              -1993.121,
              927.976
            ],
            [
              -6624.485,
              -1982.877,
              981.985
            ],
            [
              -6584.624,
              -1989.111,
              1022.33
            ],
            [
              -6371.248,
              -1988.24,
              1235.709
            ],
            [
              -6349.244,
              -1983.044,
              1258.318
            ],
            [
              -6317.742,
              -1988.026,
              1290.211
            ],
            [
              -6227.58,
              -1992.883,
              1380.504
            ],
            [
              -5930.998,
              -1988.982,
              1677.112
            ],
            [
              -5876.852,
              -1950.936,
              1743.288
            ],
            [
              -5847.02,
              -1940.308,
              1774.956
            ],
            [
              -5728.848,
              -1889.99,
              1903.395
            ],
            [
              -5758.838,
              -1833.821,
              1967.068
            ],
            [
              -5785.188,
              -1791.074,
              2017.285
            ],
            [
              -5805.95,
              -1722.817,
              2088.629
            ],
            [
              -5836.275,
              -1572.022,
              2242.443
            ],
            [
              -5847.216,
              -1532.875,
              2283.091
            ],
            [
              -5860.279,
              -1504.824,
              2314.034
            ],
            [
              -5883.029,
              -1477.722,
              2349.419
            ],
            [
              -5931.315,
              -1435.718,
              2413.417
            ],
            [
              -5981.722,
              -1404.809,
              2472.547
            ],
            [
              -6075.788,
              -1363.147,
              2575.426
            ],
            [
              -6173.116,
              -1323.657,
              2680.46
            ],
            [
              -6226.123,
              -1293.821,
              2741.287
            ],
            [
              -6299.989,
              -1239.145,
              2833.187
            ],
            [
              -6390.202,
              -1159.705,
              2953.392
            ],
            [
              -6455.067,
              -1106.295,
              3037.416
            ],
            [
              -6514.982,
              -1065.215,
              3110.062
            ],
            [
              -6539.27,
              -1052.563,
              3137.447
            ],
            [
              -6594.991,
              -1030.478,
              3197.386
            ],
            [
              -6657.841,
              -1010.502,
              3263.334
            ],
            [
              -6736.019,
              -1020.325,
              3342.126
            ],
            [
              -6752.777,
              -1020.045,
              3358.887
            ],
            [
              -6917.945,
              -988.344,
              3527.07
            ],
            [
              -6950.818,
              -987.796,
              3559.947
            ],
            [
              -7253.728,
              -1058.451,
              3870.989
            ],
            [
              -7427.868,
              -1101.203,
              4050.3
            ],
            [
              -7470.74,
              -1120.53,
              4097.326
            ],
            [
              -7610.88,
              -1212.833,
              4265.132
            ],
            [
              -7647.212,
              -1226.704,
              4304.023
            ],
            [
              -7713.892,
              -1243.413,
              4372.765
            ],
            [
              -7831.874,
              -1282.655,
              4497.101
            ],
            [
              -7860.95,
              -1286.629,
              4526.448
            ],
            [
              -7977.831,
              -1259.101,
              4646.527
            ],
            [
              -8020.904,
              -1251.714,
              4690.229
            ],
            [
              -8051.288,
              -1256.78,
              4721.032
            ],
            [
              -8452.042,
              -1478.415,
              5178.99
            ],
            [
              -8515.066,
              -1508.554,
              5248.85
            ],
            [
              -8556.749,
              -1534.59,
              5297.996
            ],
            [
              -8626.725,
              -1595.786,
              5390.956
            ],
            [
              -8690.69,
              -1604.762,
              5455.549
            ],
            [
              -8709.289,
              -1598.893,
              5475.052
            ],
            [
              -8725.846,
              -1586.378,
              5495.806
            ],
            [
              -8740.988,
              -1566.095,
              5521.118
            ],
            [
              -8752.208,
              -1542.535,
              5547.213
            ],
            [
              -8779.931,
              -1503.123,
              5595.399
            ],
            [
              -8799.03,
              -1488.341,
              5619.55
            ],
            [
              -8820.761,
              -1476.855,
              5644.13
            ],
            [
              -8861.201,
              -1466.179,
              5685.956
            ],
            [
              -8927.005,
              -1429.488,
              5761.297
            ],
            [
              -9101.082,
              -1350.968,
              5952.263
            ],
            [
              -9157.938,
              -1318.879,
              6017.55
            ],
            [
              -9177.774,
              -1309.652,
              6039.427
            ],
            [
              -9247.183,
              -1296.284,
              6110.112
            ],
            [
              -9269.133,
              -1298.156,
              6132.141
            ],
            [
              -9703.871,
              -1472.597,
              6600.572
            ],
            [
              -9873.922,
              -1544.45,
              6785.18
            ],
            [
              -9917.227,
              -1551.548,
              6829.063
            ],
            [
              -9904.748,
              -1577.351,
              6857.725
            ],
            [
              -9873.073,
              -1692.516,
              6977.166
            ],
            [
              -9860.057,
              -1725.006,
              7012.167
            ],
            [
              -9831.896,
              -1777.777,
              7071.982
            ],
            [
              -9806.152,
              -1820.491,
              7121.853
            ],
            [
              -9767.735,
              -1876.766,
              7189.991
            ],
            [
              -9757.782,
              -1899.19,
              7214.525
            ],
            [
              -9745.017,
              -1987.335,
              7303.59
            ],
            [
              -9735.296,
              -2024.226,
              7341.74
            ],
            [
              -9695.037,
              -2126.172,
              7451.347
            ],
            [
              -9670.693,
              -2175.543,
              7506.394
            ],
            [
              -9660.329,
              -2212.445,
              7544.723
            ],
            [
              -9653.868,
              -2251.51,
              7584.319
            ],
            [
              -9647.692,
              -2308.381,
              7641.524
            ],
            [
              -9620.129,
              -2478.027,
              7813.395
            ],
            [
              -9617.964,
              -2503.665,
              7839.124
            ],
            [
              -9613.078,
              -2520.441,
              7856.598
            ],
            [
              -9580.307,
              -2566.609,
              7913.214
            ],
            [
              -9525.29,
              -2632.06,
              7998.716
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 258.639,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 549.236,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6611",
              "position": {
                "x": -6624.485,
                "z": -1982.877
              },
              "distanceAlongShapeM": 981.985,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6615",
              "position": {
                "x": -6349.244,
                "z": -1983.044
              },
              "distanceAlongShapeM": 1258.318,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6618",
              "position": {
                "x": -5876.852,
                "z": -1950.936
              },
              "distanceAlongShapeM": 1743.288,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:17118",
              "position": {
                "x": -5823.871,
                "z": -1639.024
              },
              "distanceAlongShapeM": 2174.311,
              "shapeOffsetM": 1.049,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:17179",
              "position": {
                "x": -6173.116,
                "z": -1323.657
              },
              "distanceAlongShapeM": 2680.46,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:17121",
              "position": {
                "x": -6539.27,
                "z": -1052.563
              },
              "distanceAlongShapeM": 3137.447,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:17186",
              "position": {
                "x": -6863.951,
                "z": -998.15
              },
              "distanceAlongShapeM": 3472.195,
              "shapeOffsetM": 0.547,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17190",
              "position": {
                "x": -7150.175,
                "z": -1034.569
              },
              "distanceAlongShapeM": 3764.717,
              "shapeOffsetM": 0.265,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:17194",
              "position": {
                "x": -7610.88,
                "z": -1212.833
              },
              "distanceAlongShapeM": 4265.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:17203",
              "position": {
                "x": -8452.042,
                "z": -1478.415
              },
              "distanceAlongShapeM": 5178.99,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17208",
              "position": {
                "x": -8861.201,
                "z": -1466.179
              },
              "distanceAlongShapeM": 5685.956,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7625",
              "position": {
                "x": -9904.748,
                "z": -1577.351
              },
              "distanceAlongShapeM": 6857.725,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7624",
              "position": {
                "x": -9525.29,
                "z": -2632.06
              },
              "distanceAlongShapeM": 7998.716,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            }
          ],
          "departuresSeconds": [
            19380,
            20940,
            22920,
            24360,
            25800,
            27600,
            29400,
            30960,
            33780,
            35400,
            37020,
            38640,
            40200,
            41760,
            43380,
            44940,
            46380,
            48060,
            49740,
            51540,
            53100,
            55020,
            56700,
            58200,
            59820,
            61380,
            63000,
            64680,
            66360,
            68160,
            70800,
            72660,
            74160,
            75660,
            77280,
            78840,
            80280,
            81840,
            83280,
            84720
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_117:1",
          "sourceRouteId": "vilnius_bus_117",
          "sourceShapeId": "vilnius_bus_117_b-a2",
          "directionId": 1,
          "headsign": "Pilaitė",
          "directionName": "Platiniškės–Pilaitė",
          "mode": "bus",
          "routeShortName": "117",
          "routeLongName": "Pilaitė–Kriaučiūnai–Platiniškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -9525.29,
              -2632.06,
              0
            ],
            [
              -9522.803,
              -2637.666,
              6.133
            ],
            [
              -9524.772,
              -2639.86,
              9.081
            ],
            [
              -9529.228,
              -2636.449,
              14.694
            ],
            [
              -9611.217,
              -2524.924,
              153.113
            ],
            [
              -9616.801,
              -2511.476,
              167.674
            ],
            [
              -9621.06,
              -2495.823,
              183.897
            ],
            [
              -9633.75,
              -2403.225,
              277.36
            ],
            [
              -9650.771,
              -2299.426,
              382.545
            ],
            [
              -9655.156,
              -2251.489,
              430.683
            ],
            [
              -9662.262,
              -2212.414,
              470.399
            ],
            [
              -9667.686,
              -2188.95,
              494.481
            ],
            [
              -9695.735,
              -2129.501,
              560.216
            ],
            [
              -9732.271,
              -2036.52,
              660.117
            ],
            [
              -9742.689,
              -2002.957,
              695.259
            ],
            [
              -9749.152,
              -1963.892,
              734.855
            ],
            [
              -9752.268,
              -1917.089,
              781.762
            ],
            [
              -9757.782,
              -1899.19,
              800.491
            ],
            [
              -9770.904,
              -1873.376,
              829.449
            ],
            [
              -9816.876,
              -1805.848,
              911.14
            ],
            [
              -9855.151,
              -1740.67,
              986.726
            ],
            [
              -9876.278,
              -1691.351,
              1040.379
            ],
            [
              -9914.254,
              -1567.18,
              1170.227
            ],
            [
              -9915.294,
              -1551.579,
              1185.863
            ],
            [
              -9882.318,
              -1545.429,
              1219.407
            ],
            [
              -9847.302,
              -1532.632,
              1256.688
            ],
            [
              -9287.287,
              -1304.542,
              1861.372
            ],
            [
              -9269.151,
              -1299.269,
              1880.259
            ],
            [
              -9240.112,
              -1297.512,
              1909.351
            ],
            [
              -9211.163,
              -1301.32,
              1938.55
            ],
            [
              -9175.858,
              -1310.796,
              1975.103
            ],
            [
              -9147.698,
              -1323.497,
              2005.995
            ],
            [
              -9099.148,
              -1351,
              2061.794
            ],
            [
              -9063.327,
              -1368.278,
              2101.565
            ],
            [
              -8962.808,
              -1411.096,
              2210.823
            ],
            [
              -8878.976,
              -1449.193,
              2302.906
            ],
            [
              -8857.262,
              -1461.79,
              2328.009
            ],
            [
              -8804.758,
              -1483.795,
              2384.938
            ],
            [
              -8783.725,
              -1498.608,
              2410.664
            ],
            [
              -8760.977,
              -1526.808,
              2446.895
            ],
            [
              -8737.211,
              -1571.722,
              2497.709
            ],
            [
              -8720.799,
              -1593.14,
              2524.692
            ],
            [
              -8706.73,
              -1600.048,
              2540.366
            ],
            [
              -8686.179,
              -1604.836,
              2561.467
            ],
            [
              -8677.801,
              -1604.972,
              2569.846
            ],
            [
              -8628.032,
              -1596.878,
              2620.27
            ],
            [
              -8616.967,
              -1590.379,
              2633.102
            ],
            [
              -8588.102,
              -1559.681,
              2675.239
            ],
            [
              -8550.894,
              -1531.346,
              2722.008
            ],
            [
              -8448.084,
              -1472.913,
              2840.263
            ],
            [
              -8436.946,
              -1461.964,
              2855.882
            ],
            [
              -8209.956,
              -1339.891,
              3113.614
            ],
            [
              -8068.082,
              -1258.731,
              3277.062
            ],
            [
              -8051.252,
              -1254.555,
              3294.403
            ],
            [
              -8020.904,
              -1251.714,
              3324.883
            ],
            [
              -7941.222,
              -1267.496,
              3406.114
            ],
            [
              -7896.952,
              -1280.47,
              3452.246
            ],
            [
              -7871.226,
              -1284.233,
              3478.245
            ],
            [
              -7829.922,
              -1281.574,
              3519.635
            ],
            [
              -7722.308,
              -1245.501,
              3633.134
            ],
            [
              -7627.085,
              -1218.131,
              3732.213
            ],
            [
              -7533.831,
              -1153.995,
              3845.392
            ],
            [
              -7492.783,
              -1127.958,
              3894.002
            ],
            [
              -7457.02,
              -1109.626,
              3934.189
            ],
            [
              -7429.783,
              -1100.058,
              3963.058
            ],
            [
              -7062.071,
              -1009.319,
              4341.8
            ],
            [
              -7007.005,
              -993.538,
              4399.082
            ],
            [
              -6950.78,
              -985.57,
              4455.869
            ],
            [
              -6926.269,
              -984.865,
              4480.391
            ],
            [
              -6865.81,
              -993.667,
              4541.487
            ],
            [
              -6793.235,
              -1010.463,
              4615.98
            ],
            [
              -6750.162,
              -1017.863,
              4659.685
            ],
            [
              -6670.013,
              -1005.845,
              4740.729
            ],
            [
              -6650.088,
              -1009.518,
              4760.99
            ],
            [
              -6550.722,
              -1043.465,
              4865.994
            ],
            [
              -6502.736,
              -1065.421,
              4918.765
            ],
            [
              -6456.225,
              -1098.484,
              4975.83
            ],
            [
              -6395.265,
              -1154.054,
              5058.317
            ],
            [
              -6278.318,
              -1253.981,
              5212.142
            ],
            [
              -6242.049,
              -1282.421,
              5258.232
            ],
            [
              -6219.734,
              -1297.268,
              5285.035
            ],
            [
              -6160.094,
              -1316.084,
              5347.573
            ],
            [
              -6117.287,
              -1339.07,
              5396.161
            ],
            [
              -6043.087,
              -1373.717,
              5478.051
            ],
            [
              -5931.315,
              -1435.718,
              5605.868
            ],
            [
              -5889.893,
              -1464.248,
              5656.165
            ],
            [
              -5855.843,
              -1509.352,
              5712.678
            ],
            [
              -5832.257,
              -1563.184,
              5771.451
            ],
            [
              -5772.699,
              -1776.814,
              5993.227
            ],
            [
              -5728.848,
              -1889.99,
              6114.601
            ],
            [
              -5825.26,
              -1949.582,
              6227.944
            ],
            [
              -5930.998,
              -1988.982,
              6340.783
            ],
            [
              -6228.224,
              -1992.872,
              6638.035
            ],
            [
              -6278.639,
              -2000.929,
              6689.09
            ],
            [
              -6312.718,
              -1995.903,
              6723.537
            ],
            [
              -6605.358,
              -1995.443,
              7016.178
            ],
            [
              -6631.209,
              -1999.462,
              7042.339
            ],
            [
              -6677.514,
              -1993.121,
              7089.076
            ],
            [
              -6680.925,
              -1734.803,
              7347.417
            ],
            [
              -6684.251,
              -1702.465,
              7379.926
            ],
            [
              -6705.09,
              -1676.513,
              7413.209
            ],
            [
              -6747.127,
              -1568.943,
              7528.7
            ],
            [
              -6771.666,
              -1532.911,
              7572.295
            ],
            [
              -6834.733,
              -1410.519,
              7709.98
            ],
            [
              -6863.711,
              -1369.96,
              7759.827
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7624",
              "position": {
                "x": -9525.29,
                "z": -2632.06
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17205",
              "position": {
                "x": -8436.946,
                "z": -1461.964
              },
              "distanceAlongShapeM": 2855.882,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:17196",
              "position": {
                "x": -7533.831,
                "z": -1153.995
              },
              "distanceAlongShapeM": 3845.392,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:17191",
              "position": {
                "x": -7212.918,
                "z": -1046.884
              },
              "distanceAlongShapeM": 4186.346,
              "shapeOffsetM": 0.331,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:17124",
              "position": {
                "x": -6865.81,
                "z": -993.667
              },
              "distanceAlongShapeM": 4541.487,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17123",
              "position": {
                "x": -6502.736,
                "z": -1065.421
              },
              "distanceAlongShapeM": 4918.765,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:17181",
              "position": {
                "x": -6160.094,
                "z": -1316.084
              },
              "distanceAlongShapeM": 5347.573,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:17120",
              "position": {
                "x": -5784.265,
                "z": -1736.542
              },
              "distanceAlongShapeM": 5951.329,
              "shapeOffsetM": 0.326,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6619",
              "position": {
                "x": -5825.26,
                "z": -1949.582
              },
              "distanceAlongShapeM": 6227.944,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6614",
              "position": {
                "x": -6278.639,
                "z": -2000.929
              },
              "distanceAlongShapeM": 6689.09,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6612",
              "position": {
                "x": -6631.209,
                "z": -1999.462
              },
              "distanceAlongShapeM": 7042.339,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 7413.209,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 7759.827,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            }
          ],
          "departuresSeconds": [
            20520,
            22080,
            24060,
            25500,
            27000,
            28800,
            30540,
            32100,
            34920,
            36540,
            38160,
            39780,
            41400,
            42960,
            44520,
            46080,
            47520,
            49200,
            50880,
            52680,
            54240,
            56160,
            57840,
            59340,
            60960,
            62640,
            64260,
            65820,
            67500,
            69300,
            71940,
            73800,
            75300,
            76740,
            78360,
            79920,
            81360,
            82920,
            84360,
            85800
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_118",
      "sourceRouteId": "vilnius_bus_118",
      "mode": "bus",
      "shortName": "118",
      "longName": "Pilaitė–Varnės g.–Perkūnkiemis",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_118:0",
          "sourceRouteId": "vilnius_bus_118",
          "sourceShapeId": "vilnius_bus_118_a-b",
          "directionId": 0,
          "headsign": "Perkūnkiemis",
          "directionName": "Pilaitė–Varnės g.–Perkūnkiemis",
          "mode": "bus",
          "routeShortName": "118",
          "routeLongName": "Pilaitė–Varnės g.–Perkūnkiemis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -6804.479,
              -1529.023,
              0
            ],
            [
              -6810.019,
              -1513.345,
              16.627
            ],
            [
              -6803.426,
              -1504.55,
              27.62
            ],
            [
              -6797.569,
              -1501.308,
              34.313
            ],
            [
              -6795.561,
              -1496.889,
              39.167
            ],
            [
              -6804.801,
              -1471.131,
              66.532
            ],
            [
              -6817.871,
              -1443.083,
              97.476
            ],
            [
              -6849.755,
              -1383.551,
              165.008
            ],
            [
              -6863.711,
              -1369.96,
              184.489
            ],
            [
              -6868.44,
              -1344.278,
              210.603
            ],
            [
              -6866.432,
              -1339.858,
              215.457
            ],
            [
              -6856.69,
              -1335.568,
              226.102
            ],
            [
              -6848.367,
              -1339.047,
              235.122
            ],
            [
              -6837.763,
              -1360.375,
              258.94
            ],
            [
              -6823.318,
              -1421.841,
              322.082
            ],
            [
              -6723.821,
              -1601.615,
              527.553
            ],
            [
              -6711.23,
              -1619.637,
              549.537
            ],
            [
              -6684.251,
              -1702.465,
              636.648
            ],
            [
              -6676.395,
              -1733.766,
              668.92
            ],
            [
              -6677.514,
              -1993.121,
              928.277
            ],
            [
              -6624.485,
              -1982.877,
              982.286
            ],
            [
              -6584.624,
              -1989.111,
              1022.631
            ],
            [
              -6371.248,
              -1988.24,
              1236.01
            ],
            [
              -6349.244,
              -1983.044,
              1258.619
            ],
            [
              -6228.224,
              -1992.872,
              1380.037
            ],
            [
              -6226.946,
              -2337.985,
              1725.152
            ],
            [
              -6282.493,
              -2344.842,
              1781.12
            ],
            [
              -6377.159,
              -2339.91,
              1875.914
            ],
            [
              -6675.557,
              -2338.243,
              2174.317
            ],
            [
              -6743.953,
              -2342.665,
              2242.856
            ],
            [
              -6850.862,
              -2337.538,
              2349.888
            ],
            [
              -6995.956,
              -2341.796,
              2495.045
            ],
            [
              -7074.036,
              -2347.174,
              2573.309
            ],
            [
              -7144.675,
              -2331.526,
              2645.661
            ],
            [
              -7190.977,
              -2325.19,
              2692.394
            ],
            [
              -7292.824,
              -2325.724,
              2794.243
            ],
            [
              -7577.175,
              -2332.143,
              3078.666
            ],
            [
              -7614.971,
              -2551.929,
              3301.678
            ],
            [
              -7634.3,
              -2629.533,
              3381.653
            ],
            [
              -7663.789,
              -2775.986,
              3531.046
            ],
            [
              -7286.304,
              -2825.655,
              3911.785
            ],
            [
              -7256.777,
              -2832.825,
              3942.17
            ],
            [
              -6974.963,
              -2976.665,
              4258.57
            ],
            [
              -6950.908,
              -3002.67,
              4293.995
            ],
            [
              -6630.291,
              -3560.176,
              4937.119
            ],
            [
              -6501.997,
              -3825.043,
              5231.421
            ],
            [
              -6448.898,
              -3886.047,
              5312.298
            ],
            [
              -6427.689,
              -3927.592,
              5358.943
            ],
            [
              -6372.221,
              -4000.883,
              5450.857
            ],
            [
              -6364.166,
              -4019.943,
              5471.549
            ],
            [
              -6322.08,
              -3969.444,
              5537.286
            ],
            [
              -6293.895,
              -3940.975,
              5577.347
            ],
            [
              -6263.208,
              -3917.001,
              5616.288
            ],
            [
              -6205.298,
              -3883.468,
              5683.207
            ],
            [
              -6138.862,
              -3841.173,
              5761.962
            ],
            [
              -6129.144,
              -3837.998,
              5772.187
            ],
            [
              -6059.941,
              -3937.127,
              5893.082
            ],
            [
              -6039.248,
              -3970.873,
              5932.667
            ],
            [
              -6027.766,
              -3977.746,
              5946.049
            ],
            [
              -5981.248,
              -4046.438,
              6029.009
            ],
            [
              -5888.31,
              -4189.386,
              6199.514
            ],
            [
              -5885.278,
              -4200.57,
              6211.101
            ],
            [
              -5888.005,
              -4209.429,
              6220.371
            ],
            [
              -5899.143,
              -4220.373,
              6235.985
            ],
            [
              -5914.752,
              -4229.014,
              6253.827
            ],
            [
              -5991.715,
              -4284.486,
              6348.697
            ],
            [
              -6021.757,
              -4308.468,
              6387.138
            ],
            [
              -6144.879,
              -4388.766,
              6534.131
            ],
            [
              -6182.724,
              -4417.071,
              6581.389
            ],
            [
              -6225.72,
              -4445.289,
              6632.818
            ],
            [
              -6216.303,
              -4459.92,
              6650.217
            ],
            [
              -6172.119,
              -4514.098,
              6720.128
            ],
            [
              -6145.157,
              -4557.968,
              6771.621
            ],
            [
              -6128.788,
              -4580.508,
              6799.478
            ],
            [
              -5986.791,
              -4945.811,
              7191.408
            ],
            [
              -5995.182,
              -4946.782,
              7199.855
            ],
            [
              -5980.859,
              -4975.968,
              7232.365
            ],
            [
              -5963.012,
              -5025.25,
              7284.78
            ],
            [
              -5952.422,
              -5046.58,
              7308.594
            ],
            [
              -5917.244,
              -5099.496,
              7372.136
            ],
            [
              -5870.401,
              -5148.157,
              7439.68
            ],
            [
              -5845.606,
              -5167.502,
              7471.128
            ],
            [
              -5825.757,
              -5174.517,
              7492.181
            ],
            [
              -5803.293,
              -5179.351,
              7515.159
            ],
            [
              -5783.481,
              -5188.592,
              7537.02
            ],
            [
              -5768.708,
              -5191.069,
              7551.999
            ],
            [
              -5752.59,
              -5190.229,
              7568.139
            ],
            [
              -5746.113,
              -5188.113,
              7574.954
            ],
            [
              -5723.973,
              -5174.017,
              7601.2
            ],
            [
              -5701.775,
              -5156.582,
              7629.426
            ],
            [
              -5688.177,
              -5152.36,
              7643.665
            ],
            [
              -5646.149,
              -5143.055,
              7686.711
            ],
            [
              -5599.726,
              -5140.504,
              7733.203
            ],
            [
              -5574.062,
              -5146.507,
              7759.56
            ],
            [
              -5494.645,
              -5173.461,
              7843.426
            ],
            [
              -5460.572,
              -5177.381,
              7877.724
            ],
            [
              -5416.991,
              -5190.369,
              7923.199
            ],
            [
              -5371.933,
              -5192.25,
              7968.297
            ],
            [
              -5069.27,
              -5197.42,
              8271.003
            ],
            [
              -4792.724,
              -5185.463,
              8547.808
            ],
            [
              -4742.399,
              -5180.761,
              8598.352
            ],
            [
              -4156.392,
              -5190.871,
              9184.447
            ],
            [
              -4052.012,
              -5189.34,
              9288.838
            ],
            [
              -4041.833,
              -5048.138,
              9430.406
            ],
            [
              -3824.791,
              -5050.794,
              9647.465
            ],
            [
              -3827.361,
              -5087.486,
              9684.246
            ],
            [
              -3833.268,
              -5130.798,
              9727.96
            ],
            [
              -3844.602,
              -5152.866,
              9752.768
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7694",
              "position": {
                "x": -6837.763,
                "z": -1360.375
              },
              "distanceAlongShapeM": 258.94,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:4526",
              "position": {
                "x": -6711.23,
                "z": -1619.637
              },
              "distanceAlongShapeM": 549.537,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6611",
              "position": {
                "x": -6624.485,
                "z": -1982.877
              },
              "distanceAlongShapeM": 982.286,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6615",
              "position": {
                "x": -6349.244,
                "z": -1983.044
              },
              "distanceAlongShapeM": 1258.619,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:7948",
              "position": {
                "x": -6282.493,
                "z": -2344.842
              },
              "distanceAlongShapeM": 1781.12,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7950",
              "position": {
                "x": -6743.953,
                "z": -2342.665
              },
              "distanceAlongShapeM": 2242.856,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:17221",
              "position": {
                "x": -7614.971,
                "z": -2551.929
              },
              "distanceAlongShapeM": 3301.678,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17225",
              "position": {
                "x": -6974.963,
                "z": -2976.665
              },
              "distanceAlongShapeM": 4258.57,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:17230",
              "position": {
                "x": -6448.898,
                "z": -3886.047
              },
              "distanceAlongShapeM": 5312.298,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:18926",
              "position": {
                "x": -5981.248,
                "z": -4046.438
              },
              "distanceAlongShapeM": 6029.009,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:18928",
              "position": {
                "x": -6182.724,
                "z": -4417.071
              },
              "distanceAlongShapeM": 6581.389,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:16896",
              "position": {
                "x": -6128.788,
                "z": -4580.508
              },
              "distanceAlongShapeM": 6799.478,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7392",
              "position": {
                "x": -5986.791,
                "z": -4945.811
              },
              "distanceAlongShapeM": 7191.408,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7845",
              "position": {
                "x": -5524.097,
                "z": -5162.941
              },
              "distanceAlongShapeM": 7812.156,
              "shapeOffsetM": 0.496,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7395",
              "position": {
                "x": -4966.766,
                "z": -5192.496
              },
              "distanceAlongShapeM": 8373.625,
              "shapeOffsetM": 0.491,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9768",
              "position": {
                "x": -4156.392,
                "z": -5190.871
              },
              "distanceAlongShapeM": 9184.447,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 9684.246,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            19920,
            22020,
            23940,
            26040,
            29100,
            31380,
            34860,
            36960,
            39120,
            41220,
            43380,
            45540,
            47700,
            49860,
            52020,
            54180,
            56340,
            58560,
            60840,
            63120,
            65400,
            67500,
            70740,
            72840,
            74820,
            76800,
            78780,
            80760,
            82740,
            84720
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_118:1",
          "sourceRouteId": "vilnius_bus_118",
          "sourceShapeId": "vilnius_bus_118_b-a",
          "directionId": 1,
          "headsign": "Pilaitė",
          "directionName": "Perkūnkiemis–Varnės g.–Pilaitė",
          "mode": "bus",
          "routeShortName": "118",
          "routeLongName": "Pilaitė–Varnės g.–Perkūnkiemis",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3844.602,
              -5152.866,
              0
            ],
            [
              -3862.028,
              -5154.789,
              17.532
            ],
            [
              -3896.745,
              -5150.846,
              52.471
            ],
            [
              -3904.981,
              -5142.911,
              63.908
            ],
            [
              -3906.076,
              -5131.759,
              75.113
            ],
            [
              -3903.757,
              -5109.535,
              97.458
            ],
            [
              -3899.68,
              -5097.361,
              110.297
            ],
            [
              -3891.837,
              -5090.818,
              120.511
            ],
            [
              -3867.269,
              -5085.679,
              145.611
            ],
            [
              -3854.099,
              -5069.209,
              166.698
            ],
            [
              -3846.764,
              -5054.865,
              182.809
            ],
            [
              -4041.833,
              -5048.138,
              377.995
            ],
            [
              -4054.156,
              -5201.548,
              531.899
            ],
            [
              -4187.417,
              -5197.013,
              665.238
            ],
            [
              -4508.755,
              -5191.462,
              986.623
            ],
            [
              -4560.955,
              -5192.789,
              1038.84
            ],
            [
              -4730.24,
              -5185.423,
              1208.286
            ],
            [
              -4792.724,
              -5185.463,
              1270.769
            ],
            [
              -4993.283,
              -5198.721,
              1471.766
            ],
            [
              -5032.717,
              -5206.951,
              1512.05
            ],
            [
              -5174.88,
              -5195.613,
              1654.664
            ],
            [
              -5316.533,
              -5192.081,
              1796.361
            ],
            [
              -5353.201,
              -5189.23,
              1833.14
            ],
            [
              -5402.218,
              -5192.847,
              1882.29
            ],
            [
              -5554.307,
              -5159.088,
              2038.081
            ],
            [
              -5574.782,
              -5150.947,
              2060.114
            ],
            [
              -5608.154,
              -5143.701,
              2094.265
            ],
            [
              -5629.424,
              -5144.453,
              2115.548
            ],
            [
              -5686.926,
              -5154.608,
              2173.94
            ],
            [
              -5717.438,
              -5168.562,
              2207.491
            ],
            [
              -5731.889,
              -5185.015,
              2229.389
            ],
            [
              -5748.764,
              -5192.521,
              2247.858
            ],
            [
              -5760.999,
              -5192.313,
              2260.095
            ],
            [
              -5811.134,
              -5185.897,
              2310.639
            ],
            [
              -5822.65,
              -5181.249,
              2323.058
            ],
            [
              -5857.729,
              -5160.617,
              2363.754
            ],
            [
              -5872.995,
              -5149.226,
              2382.802
            ],
            [
              -5922.434,
              -5101.635,
              2451.425
            ],
            [
              -5939.463,
              -5080.196,
              2478.804
            ],
            [
              -5975.703,
              -5013.904,
              2554.355
            ],
            [
              -5994.12,
              -4960.159,
              2611.168
            ],
            [
              -6022.784,
              -4902.901,
              2675.2
            ],
            [
              -6031.88,
              -4869.351,
              2709.961
            ],
            [
              -6041.846,
              -4849.145,
              2732.491
            ],
            [
              -6046.072,
              -4832.375,
              2749.785
            ],
            [
              -6063.065,
              -4808.711,
              2778.919
            ],
            [
              -6077.737,
              -4723.86,
              2865.029
            ],
            [
              -6109.893,
              -4644.28,
              2950.86
            ],
            [
              -6159.176,
              -4548.826,
              3058.286
            ],
            [
              -6197.05,
              -4502.546,
              3118.088
            ],
            [
              -6208.324,
              -4483.431,
              3140.28
            ],
            [
              -6227.233,
              -4458.622,
              3171.473
            ],
            [
              -6298.045,
              -4340.543,
              3309.158
            ],
            [
              -6279.786,
              -4327.492,
              3331.601
            ],
            [
              -6244.08,
              -4311.396,
              3370.768
            ],
            [
              -6197.75,
              -4276.554,
              3428.737
            ],
            [
              -6079.778,
              -4196.168,
              3571.493
            ],
            [
              -6038.123,
              -4171.268,
              3620.023
            ],
            [
              -5967.012,
              -4119.036,
              3708.255
            ],
            [
              -5944.261,
              -4107.176,
              3733.912
            ],
            [
              -6027.216,
              -3983.321,
              3882.981
            ],
            [
              -6041.862,
              -3973.055,
              3900.866
            ],
            [
              -6131.777,
              -3841.293,
              4060.384
            ],
            [
              -6280.255,
              -3934.525,
              4235.707
            ],
            [
              -6309.766,
              -3965.198,
              4278.272
            ],
            [
              -6362.99,
              -4026.641,
              4359.561
            ],
            [
              -6408.888,
              -3959.078,
              4441.241
            ],
            [
              -6476.96,
              -3868.878,
              4554.244
            ],
            [
              -6508.289,
              -3816.032,
              4615.679
            ],
            [
              -6572.986,
              -3678.023,
              4768.1
            ],
            [
              -6727.805,
              -3380.432,
              5103.554
            ],
            [
              -6894.905,
              -3083.755,
              5444.053
            ],
            [
              -6926.964,
              -3035.352,
              5502.11
            ],
            [
              -6964.803,
              -2985.741,
              5564.505
            ],
            [
              -7072.814,
              -2931.62,
              5685.316
            ],
            [
              -7107.861,
              -2907.659,
              5727.771
            ],
            [
              -7242.051,
              -2838.635,
              5878.672
            ],
            [
              -7274.762,
              -2829.186,
              5912.721
            ],
            [
              -7667.048,
              -2778.158,
              6308.311
            ],
            [
              -7641.001,
              -2645.006,
              6443.987
            ],
            [
              -7632.312,
              -2587.264,
              6502.379
            ],
            [
              -7577.175,
              -2332.143,
              6763.391
            ],
            [
              -7448.799,
              -2325.363,
              6891.946
            ],
            [
              -7201.894,
              -2322.782,
              7138.864
            ],
            [
              -7172.861,
              -2321.039,
              7167.95
            ],
            [
              -7097.84,
              -2344.551,
              7246.569
            ],
            [
              -7004.314,
              -2340.543,
              7340.18
            ],
            [
              -6921.172,
              -2340.817,
              7423.323
            ],
            [
              -6862.312,
              -2328.441,
              7483.47
            ],
            [
              -6640.332,
              -2313.23,
              7705.97
            ],
            [
              -6613.194,
              -2309.232,
              7733.401
            ],
            [
              -6383.798,
              -2313.082,
              7962.83
            ],
            [
              -6296.126,
              -2312.33,
              8050.505
            ],
            [
              -6225.814,
              -2309.061,
              8120.893
            ],
            [
              -6228.224,
              -1992.872,
              8437.09
            ],
            [
              -6278.639,
              -2000.929,
              8488.144
            ],
            [
              -6312.718,
              -1995.903,
              8522.592
            ],
            [
              -6605.358,
              -1995.443,
              8815.232
            ],
            [
              -6631.209,
              -1999.462,
              8841.394
            ],
            [
              -6677.514,
              -1993.121,
              8888.131
            ],
            [
              -6680.925,
              -1734.803,
              9146.471
            ],
            [
              -6684.251,
              -1702.465,
              9178.98
            ],
            [
              -6705.09,
              -1676.513,
              9212.264
            ],
            [
              -6747.127,
              -1568.943,
              9327.755
            ],
            [
              -6771.666,
              -1532.911,
              9371.35
            ],
            [
              -6834.733,
              -1410.519,
              9509.035
            ],
            [
              -6863.711,
              -1369.96,
              9558.882
            ],
            [
              -6869.747,
              -1345.369,
              9584.203
            ],
            [
              -6867.739,
              -1340.95,
              9589.057
            ],
            [
              -6861.864,
              -1336.595,
              9596.37
            ],
            [
              -6854.775,
              -1336.714,
              9603.46
            ],
            [
              -6850.945,
              -1339.004,
              9607.923
            ],
            [
              -6837.763,
              -1360.375,
              9633.032
            ],
            [
              -6825.084,
              -1411.793,
              9685.991
            ],
            [
              -6801.411,
              -1461.169,
              9740.748
            ],
            [
              -6771.957,
              -1511.755,
              9799.284
            ],
            [
              -6765.128,
              -1527.454,
              9816.404
            ],
            [
              -6769.807,
              -1537.394,
              9827.391
            ],
            [
              -6777.653,
              -1543.942,
              9837.61
            ],
            [
              -6839.38,
              -1572.967,
              9905.821
            ],
            [
              -6855.566,
              -1577.15,
              9922.538
            ],
            [
              -6863.189,
              -1570.343,
              9932.757
            ],
            [
              -6866.907,
              -1561.375,
              9942.465
            ],
            [
              -6864.843,
              -1553.618,
              9950.493
            ],
            [
              -6804.479,
              -1529.023,
              10015.675
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 166.698,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9766",
              "position": {
                "x": -4187.417,
                "z": -5197.013
              },
              "distanceAlongShapeM": 665.238,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17333",
              "position": {
                "x": -4394.793,
                "z": -5194.542
              },
              "distanceAlongShapeM": 872.625,
              "shapeOffsetM": 1.11,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:4479",
              "position": {
                "x": -5032.717,
                "z": -5206.951
              },
              "distanceAlongShapeM": 1512.05,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:7844",
              "position": {
                "x": -5811.134,
                "z": -5185.897
              },
              "distanceAlongShapeM": 2310.639,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:7393",
              "position": {
                "x": -6063.065,
                "z": -4808.711
              },
              "distanceAlongShapeM": 2778.919,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:16898",
              "position": {
                "x": -6197.05,
                "z": -4502.546
              },
              "distanceAlongShapeM": 3118.088,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:18927",
              "position": {
                "x": -6197.75,
                "z": -4276.554
              },
              "distanceAlongShapeM": 3428.737,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17232",
              "position": {
                "x": -6476.96,
                "z": -3868.878
              },
              "distanceAlongShapeM": 4554.244,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:17228",
              "position": {
                "x": -7072.814,
                "z": -2931.62
              },
              "distanceAlongShapeM": 5685.316,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:17223",
              "position": {
                "x": -7632.312,
                "z": -2587.264
              },
              "distanceAlongShapeM": 6502.379,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:8371",
              "position": {
                "x": -7448.799,
                "z": -2325.363
              },
              "distanceAlongShapeM": 6891.946,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7951",
              "position": {
                "x": -6613.194,
                "z": -2309.232
              },
              "distanceAlongShapeM": 7733.401,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6614",
              "position": {
                "x": -6278.639,
                "z": -2000.929
              },
              "distanceAlongShapeM": 8488.144,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6612",
              "position": {
                "x": -6631.209,
                "z": -1999.462
              },
              "distanceAlongShapeM": 8841.394,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:7695",
              "position": {
                "x": -6705.09,
                "z": -1676.513
              },
              "distanceAlongShapeM": 9212.264,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:7693",
              "position": {
                "x": -6863.711,
                "z": -1369.96
              },
              "distanceAlongShapeM": 9558.882,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            21600,
            23760,
            26460,
            28680,
            30960,
            33540,
            36720,
            38820,
            41040,
            43020,
            45180,
            47340,
            49500,
            51660,
            53820,
            55980,
            58260,
            60480,
            62700,
            65040,
            67200,
            69300,
            72600,
            74700,
            76620,
            78480,
            80520,
            82500,
            84300,
            86280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_119",
      "sourceRouteId": "vilnius_bus_119",
      "mode": "bus",
      "shortName": "119",
      "longName": "Šiaurės miestelis–Antakalnis–Rokantiškės–Egliškės",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_119:0",
          "sourceRouteId": "vilnius_bus_119",
          "sourceShapeId": "vilnius_bus_119_a-b",
          "directionId": 0,
          "headsign": "Egliškės",
          "directionName": "Šiaurės miestelis–Antakalnis–Rokantiškės–Egliškės",
          "mode": "bus",
          "routeShortName": "119",
          "routeLongName": "Šiaurės miestelis–Antakalnis–Rokantiškės–Egliškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1412.698,
              -2538.791,
              0
            ],
            [
              1427.807,
              -2523.486,
              21.507
            ],
            [
              1492.99,
              -2519.128,
              86.835
            ],
            [
              1524.687,
              -2513.037,
              119.112
            ],
            [
              1549.069,
              -2519.056,
              144.226
            ],
            [
              1557.925,
              -2528.126,
              156.902
            ],
            [
              1557.243,
              -2564.85,
              193.633
            ],
            [
              1565.454,
              -2573.909,
              205.859
            ],
            [
              1658.884,
              -2575.644,
              299.305
            ],
            [
              1668.591,
              -2573.598,
              309.225
            ],
            [
              1675.2,
              -2564.815,
              320.217
            ],
            [
              1674.783,
              -2552.562,
              332.478
            ],
            [
              1670.083,
              -2527.983,
              357.502
            ],
            [
              1679.06,
              -2495.866,
              390.85
            ],
            [
              1670.601,
              -2049.296,
              837.5
            ],
            [
              1665.105,
              -1963.474,
              923.498
            ],
            [
              1667.869,
              -1953.506,
              933.842
            ],
            [
              1676.994,
              -1948.109,
              944.443
            ],
            [
              1704.019,
              -1950.838,
              971.606
            ],
            [
              1835.898,
              -1931.027,
              1104.964
            ],
            [
              1974.971,
              -1905.788,
              1246.309
            ],
            [
              2068.207,
              -1884.15,
              1342.022
            ],
            [
              2081.948,
              -1873.274,
              1359.547
            ],
            [
              2103.214,
              -1873.671,
              1380.817
            ],
            [
              2192.003,
              -1848.613,
              1473.074
            ],
            [
              2201.025,
              -1848.782,
              1482.098
            ],
            [
              2213.852,
              -1852.361,
              1495.414
            ],
            [
              2234.245,
              -1864.989,
              1519.401
            ],
            [
              2252.809,
              -1872.015,
              1539.25
            ],
            [
              2259.919,
              -1871.035,
              1546.427
            ],
            [
              2493.279,
              -1768.537,
              1801.306
            ],
            [
              2535.981,
              -1760.432,
              1844.77
            ],
            [
              2561.157,
              -1758.678,
              1870.007
            ],
            [
              2583.027,
              -1761.316,
              1892.035
            ],
            [
              2604.98,
              -1759.502,
              1914.063
            ],
            [
              2739.18,
              -1719.722,
              2054.034
            ],
            [
              2791.156,
              -1698.435,
              2110.201
            ],
            [
              3079.727,
              -1541.344,
              2438.76
            ],
            [
              3132.044,
              -1502.255,
              2504.066
            ],
            [
              3257.789,
              -1398.875,
              2666.853
            ],
            [
              3308.736,
              -1364.215,
              2728.471
            ],
            [
              3354.919,
              -1342.825,
              2779.367
            ],
            [
              3461.835,
              -1314.795,
              2889.897
            ],
            [
              3531.951,
              -1289.408,
              2964.467
            ],
            [
              3598.191,
              -1230.551,
              3053.078
            ],
            [
              3619.736,
              -1216.488,
              3078.806
            ],
            [
              3648.201,
              -1211.463,
              3107.712
            ],
            [
              3750.302,
              -1233.445,
              3212.152
            ],
            [
              3788.224,
              -1239.733,
              3250.592
            ],
            [
              3871.327,
              -1243.544,
              3333.782
            ],
            [
              3891.867,
              -1248.388,
              3354.886
            ],
            [
              4020.745,
              -1319.871,
              3502.261
            ],
            [
              4085.226,
              -1353.387,
              3574.932
            ],
            [
              4121.234,
              -1358.529,
              3611.305
            ],
            [
              4500.92,
              -1362.466,
              3991.012
            ],
            [
              4516.752,
              -1343.845,
              4015.454
            ],
            [
              4527.688,
              -1345.168,
              4026.469
            ],
            [
              4535.789,
              -1359.796,
              4043.191
            ],
            [
              4572.013,
              -1387.211,
              4088.619
            ],
            [
              4585.807,
              -1407.515,
              4113.166
            ],
            [
              4687.775,
              -1502.991,
              4252.855
            ],
            [
              4747.35,
              -1556.462,
              4332.907
            ],
            [
              4855.863,
              -1646.502,
              4473.912
            ],
            [
              4873.887,
              -1681.361,
              4513.155
            ],
            [
              4892.083,
              -1707.317,
              4544.854
            ],
            [
              4935.048,
              -1752.677,
              4607.332
            ],
            [
              4957.325,
              -1767.58,
              4634.134
            ],
            [
              5027.743,
              -1793.432,
              4709.147
            ],
            [
              5112.316,
              -1820.673,
              4797.999
            ],
            [
              5148.212,
              -1831.387,
              4835.46
            ],
            [
              5188.082,
              -1836.611,
              4875.671
            ],
            [
              5235.836,
              -1834.197,
              4923.486
            ],
            [
              5256.588,
              -1827.919,
              4945.167
            ],
            [
              5278.737,
              -1816.102,
              4970.271
            ],
            [
              5309.094,
              -1779.953,
              5017.476
            ],
            [
              5323.51,
              -1767.986,
              5036.211
            ],
            [
              5345.572,
              -1760.621,
              5059.471
            ],
            [
              5394.53,
              -1762.685,
              5108.472
            ],
            [
              5407.355,
              -1766.273,
              5121.789
            ],
            [
              5446.944,
              -1785.968,
              5166.007
            ],
            [
              5457.104,
              -1793.958,
              5178.932
            ],
            [
              5471.624,
              -1809.826,
              5200.441
            ],
            [
              5512.459,
              -1831.771,
              5246.799
            ],
            [
              5537.891,
              -1850.078,
              5278.135
            ],
            [
              5539.738,
              -1854.567,
              5282.989
            ],
            [
              5537.008,
              -1862.307,
              5291.196
            ],
            [
              5531.744,
              -1867.771,
              5298.783
            ],
            [
              5520.767,
              -1868.671,
              5309.797
            ],
            [
              5515.655,
              -1866.345,
              5315.413
            ],
            [
              5513.765,
              -1864.082,
              5318.362
            ],
            [
              5512.692,
              -1852.928,
              5329.567
            ],
            [
              5517.956,
              -1847.464,
              5337.154
            ],
            [
              5535.27,
              -1852.254,
              5355.118
            ],
            [
              5663.954,
              -1931.573,
              5506.284
            ],
            [
              5726.307,
              -1973.978,
              5581.691
            ],
            [
              5809.795,
              -2023.477,
              5678.749
            ],
            [
              5909.138,
              -2053.247,
              5782.457
            ],
            [
              5956.225,
              -2051.94,
              5829.562
            ],
            [
              6035.685,
              -2043.473,
              5909.472
            ],
            [
              6104.704,
              -2041.484,
              5978.519
            ],
            [
              6231.263,
              -2064.001,
              6107.066
            ],
            [
              6264.085,
              -2066.871,
              6140.013
            ],
            [
              6454.692,
              -2110.689,
              6335.592
            ],
            [
              6496.983,
              -2123.766,
              6379.858
            ],
            [
              6572.924,
              -2163.111,
              6465.386
            ],
            [
              6607.328,
              -2183.827,
              6505.546
            ],
            [
              6714.097,
              -2261.632,
              6637.657
            ],
            [
              6731.855,
              -2276.455,
              6660.789
            ],
            [
              6746.566,
              -2282.311,
              6676.623
            ],
            [
              6792.187,
              -2289.891,
              6722.868
            ],
            [
              6827.716,
              -2286.138,
              6758.595
            ],
            [
              6898.797,
              -2277.521,
              6830.197
            ],
            [
              6977.721,
              -2263.494,
              6910.357
            ],
            [
              7198.611,
              -2242.259,
              7132.266
            ],
            [
              7366.707,
              -2217.76,
              7302.138
            ],
            [
              7413.992,
              -2206.453,
              7350.756
            ],
            [
              7496.697,
              -2196.963,
              7434.003
            ],
            [
              7554.804,
              -2192.552,
              7492.278
            ],
            [
              7596.002,
              -2195.598,
              7533.588
            ],
            [
              7635.022,
              -2210.847,
              7575.483
            ],
            [
              7779.904,
              -2283.871,
              7737.727
            ],
            [
              7810.08,
              -2290.039,
              7768.527
            ],
            [
              7871.964,
              -2290.161,
              7830.411
            ],
            [
              7915.027,
              -2296.587,
              7873.951
            ],
            [
              7945.78,
              -2306.107,
              7906.144
            ],
            [
              7987.932,
              -2325.875,
              7952.701
            ],
            [
              8080.277,
              -2382.273,
              8060.906
            ],
            [
              8154.223,
              -2423.832,
              8145.73
            ],
            [
              8171.842,
              -2445.337,
              8173.531
            ],
            [
              8197.194,
              -2466.998,
              8206.876
            ],
            [
              8283.308,
              -2576.713,
              8346.35
            ],
            [
              8324.275,
              -2623.18,
              8408.298
            ],
            [
              8361.264,
              -2675.134,
              8472.074
            ],
            [
              8375.149,
              -2689.885,
              8492.332
            ],
            [
              8401.809,
              -2710.46,
              8526.008
            ],
            [
              8500.719,
              -2760.319,
              8636.774
            ],
            [
              8528.246,
              -2769.778,
              8665.881
            ],
            [
              8612.872,
              -2792.634,
              8753.539
            ],
            [
              8666.681,
              -2809.303,
              8809.871
            ],
            [
              8690.941,
              -2820.925,
              8836.771
            ],
            [
              8759.143,
              -2859.038,
              8914.9
            ],
            [
              8803.174,
              -2881.078,
              8964.139
            ],
            [
              8865.284,
              -2933.543,
              9045.442
            ],
            [
              9009.148,
              -3086.745,
              9255.603
            ],
            [
              9240.243,
              -3387.561,
              9634.939
            ],
            [
              9288.766,
              -3441.984,
              9707.852
            ],
            [
              9304.929,
              -3471.257,
              9741.291
            ],
            [
              9316.277,
              -3483.734,
              9758.156
            ],
            [
              9353.766,
              -3446.642,
              9810.894
            ],
            [
              9395.324,
              -3399.614,
              9873.653
            ],
            [
              9459.816,
              -3334.125,
              9965.566
            ],
            [
              9470.282,
              -3326.545,
              9978.489
            ],
            [
              9469.728,
              -3322.08,
              9982.987
            ],
            [
              9473.131,
              -3313.243,
              9992.457
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7589",
              "position": {
                "x": 1524.687,
                "z": -2513.037
              },
              "distanceAlongShapeM": 119.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 357.502,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17239",
              "position": {
                "x": 2081.948,
                "z": -1873.274
              },
              "distanceAlongShapeM": 1359.547,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:17241",
              "position": {
                "x": 2493.279,
                "z": -1768.537
              },
              "distanceAlongShapeM": 1801.306,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:17246",
              "position": {
                "x": 2944.889,
                "z": -1614.499
              },
              "distanceAlongShapeM": 2285.355,
              "shapeOffsetM": 0.217,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6883",
              "position": {
                "x": 4572.013,
                "z": -1387.211
              },
              "distanceAlongShapeM": 4088.619,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6887",
              "position": {
                "x": 4855.863,
                "z": -1646.502
              },
              "distanceAlongShapeM": 4473.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 5329.567,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:10319",
              "position": {
                "x": 5956.225,
                "z": -2051.94
              },
              "distanceAlongShapeM": 5829.562,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9606",
              "position": {
                "x": 6264.085,
                "z": -2066.871
              },
              "distanceAlongShapeM": 6140.013,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:10531",
              "position": {
                "x": 6607.328,
                "z": -2183.827
              },
              "distanceAlongShapeM": 6505.546,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9604",
              "position": {
                "x": 6977.721,
                "z": -2263.494
              },
              "distanceAlongShapeM": 6910.357,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:14663",
              "position": {
                "x": 7198.611,
                "z": -2242.259
              },
              "distanceAlongShapeM": 7132.266,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:17253",
              "position": {
                "x": 7871.964,
                "z": -2290.161
              },
              "distanceAlongShapeM": 7830.411,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:17256",
              "position": {
                "x": 8154.223,
                "z": -2423.832
              },
              "distanceAlongShapeM": 8145.73,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:17263",
              "position": {
                "x": 8803.174,
                "z": -2881.078
              },
              "distanceAlongShapeM": 8964.139,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:18566",
              "position": {
                "x": 9022.984,
                "z": -3103.724
              },
              "distanceAlongShapeM": 9277.497,
              "shapeOffsetM": 0.629,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:17272",
              "position": {
                "x": 9288.766,
                "z": -3441.984
              },
              "distanceAlongShapeM": 9707.852,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:17268",
              "position": {
                "x": 9473.131,
                "z": -3313.243
              },
              "distanceAlongShapeM": 9992.457,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            }
          ],
          "departuresSeconds": [
            19200,
            20640,
            21840,
            23040,
            24120,
            25200,
            26280,
            27420,
            28560,
            29880,
            31440,
            33000,
            34260,
            35520,
            36840,
            38220,
            39600,
            40980,
            42360,
            43740,
            45120,
            46500,
            47940,
            49320,
            50700,
            52140,
            53460,
            54780,
            56160,
            57000,
            58200,
            59460,
            60600,
            61560,
            62580,
            63840,
            65100,
            66120,
            67620,
            69300,
            70260,
            71580,
            72900,
            74400,
            75600,
            76980,
            78360,
            79680,
            81000,
            82320,
            83640
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_119:1",
          "sourceRouteId": "vilnius_bus_119",
          "sourceShapeId": "vilnius_bus_119_b-a",
          "directionId": 1,
          "headsign": "Šiaurės miestelis",
          "directionName": "Egliškės–Rokantiškės–Antakalnis–Šiaurės miestelis",
          "mode": "bus",
          "routeShortName": "119",
          "routeLongName": "Šiaurės miestelis–Antakalnis–Rokantiškės–Egliškės",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9473.131,
              -3313.243,
              0
            ],
            [
              9477.686,
              -3311.109,
              5.03
            ],
            [
              9482.037,
              -3318.991,
              14.033
            ],
            [
              9463.082,
              -3331.965,
              37.003
            ],
            [
              9355.032,
              -3447.781,
              195.396
            ],
            [
              9335.852,
              -3471.885,
              226.199
            ],
            [
              9316.831,
              -3488.198,
              251.258
            ],
            [
              9248.257,
              -3405.537,
              358.66
            ],
            [
              9200.117,
              -3332.196,
              446.389
            ],
            [
              8991.288,
              -3077.477,
              775.769
            ],
            [
              8959.306,
              -3033.412,
              830.217
            ],
            [
              8896.068,
              -2973.13,
              917.584
            ],
            [
              8843.025,
              -2918.621,
              993.642
            ],
            [
              8781.89,
              -2881.762,
              1065.029
            ],
            [
              8690.941,
              -2820.925,
              1174.449
            ],
            [
              8678.811,
              -2815.114,
              1187.899
            ],
            [
              8648.73,
              -2804.488,
              1219.802
            ],
            [
              8489.833,
              -2756.76,
              1385.712
            ],
            [
              8417.095,
              -2719.673,
              1467.36
            ],
            [
              8390.99,
              -2703.563,
              1498.036
            ],
            [
              8366.929,
              -2681.927,
              1530.393
            ],
            [
              8316.077,
              -2614.109,
              1615.159
            ],
            [
              8263.757,
              -2555.168,
              1693.971
            ],
            [
              8238.718,
              -2517.928,
              1738.847
            ],
            [
              8207.88,
              -2480.571,
              1787.287
            ],
            [
              8188.906,
              -2462.378,
              1813.574
            ],
            [
              8167.954,
              -2446.373,
              1839.94
            ],
            [
              8141.847,
              -2430.264,
              1870.618
            ],
            [
              8119.694,
              -2409.781,
              1900.788
            ],
            [
              8070.056,
              -2377.616,
              1959.937
            ],
            [
              8014.018,
              -2343.096,
              2025.754
            ],
            [
              7948.291,
              -2309.497,
              2099.571
            ],
            [
              7907.228,
              -2299.771,
              2141.77
            ],
            [
              7871.208,
              -2295.712,
              2178.017
            ],
            [
              7849.877,
              -2298.626,
              2199.547
            ],
            [
              7781.215,
              -2282.784,
              2270.013
            ],
            [
              7679.71,
              -2232.89,
              2383.118
            ],
            [
              7635.067,
              -2208.622,
              2433.931
            ],
            [
              7592.135,
              -2195.521,
              2478.817
            ],
            [
              7565.781,
              -2191.657,
              2505.453
            ],
            [
              7423.035,
              -2205.519,
              2648.87
            ],
            [
              7343.999,
              -2225.103,
              2730.297
            ],
            [
              7312.312,
              -2230.04,
              2762.365
            ],
            [
              7285.671,
              -2240.645,
              2791.039
            ],
            [
              6885.221,
              -2279.48,
              3193.369
            ],
            [
              6758.788,
              -2283.666,
              3319.871
            ],
            [
              6733.788,
              -2276.493,
              3345.879
            ],
            [
              6602.107,
              -2187.064,
              3505.057
            ],
            [
              6582.95,
              -2177.781,
              3526.344
            ],
            [
              6542.211,
              -2151.374,
              3574.893
            ],
            [
              6503.317,
              -2129.457,
              3619.537
            ],
            [
              6436.091,
              -2105.871,
              3690.781
            ],
            [
              6181.107,
              -2057.452,
              3950.321
            ],
            [
              6111.061,
              -2046.061,
              4021.287
            ],
            [
              6042.064,
              -2046.938,
              4090.29
            ],
            [
              5963.871,
              -2056.543,
              4169.071
            ],
            [
              5942.047,
              -2051.663,
              4191.433
            ],
            [
              5884.65,
              -2052.769,
              4248.841
            ],
            [
              5828.911,
              -2034.982,
              4307.349
            ],
            [
              5764.388,
              -2004.779,
              4378.592
            ],
            [
              5745.315,
              -1991.048,
              4402.093
            ],
            [
              5726.821,
              -1980.668,
              4423.3
            ],
            [
              5697.118,
              -1950.031,
              4465.972
            ],
            [
              5679.291,
              -1938.551,
              4487.176
            ],
            [
              5636.118,
              -1904.313,
              4542.277
            ],
            [
              5590.731,
              -1884.504,
              4591.799
            ],
            [
              5512.372,
              -1836.223,
              4683.838
            ],
            [
              5504.167,
              -1827.157,
              4696.066
            ],
            [
              5498.389,
              -1825.931,
              4701.973
            ],
            [
              5496.819,
              -1840.374,
              4716.5
            ],
            [
              5499.115,
              -1854.891,
              4731.197
            ],
            [
              5503.432,
              -1864.994,
              4742.184
            ],
            [
              5510.456,
              -1868.47,
              4750.022
            ],
            [
              5516.944,
              -1866.37,
              4756.841
            ],
            [
              5512.692,
              -1852.928,
              4770.939
            ],
            [
              5511.083,
              -1836.198,
              4787.747
            ],
            [
              5476.092,
              -1812.139,
              4830.211
            ],
            [
              5449.436,
              -1790.469,
              4864.564
            ],
            [
              5407.999,
              -1766.286,
              4912.541
            ],
            [
              5375.862,
              -1761.209,
              4945.077
            ],
            [
              5338.483,
              -1760.484,
              4982.463
            ],
            [
              5326.818,
              -1763.597,
              4994.536
            ],
            [
              5307.117,
              -1782.141,
              5021.591
            ],
            [
              5287.91,
              -1808.487,
              5054.196
            ],
            [
              5270.23,
              -1822.617,
              5076.829
            ],
            [
              5244.88,
              -1833.259,
              5104.321
            ],
            [
              5198.35,
              -1839.037,
              5151.209
            ],
            [
              5188.082,
              -1836.611,
              5161.759
            ],
            [
              5172.593,
              -1837.425,
              5177.269
            ],
            [
              4985.466,
              -1779.256,
              5373.229
            ],
            [
              4940.762,
              -1757.24,
              5423.06
            ],
            [
              4871.116,
              -1691.327,
              5518.952
            ],
            [
              4817.859,
              -1611.257,
              5615.115
            ],
            [
              4761.938,
              -1568.989,
              5685.214
            ],
            [
              4588.816,
              -1418.705,
              5914.465
            ],
            [
              4535.725,
              -1363.135,
              5991.321
            ],
            [
              4529.838,
              -1367.475,
              5998.634
            ],
            [
              4518.882,
              -1367.264,
              6009.593
            ],
            [
              4506.098,
              -1361.452,
              6023.636
            ],
            [
              4351.306,
              -1364.048,
              6178.449
            ],
            [
              4139.174,
              -1364.438,
              6390.582
            ],
            [
              4110.9,
              -1359.444,
              6419.293
            ],
            [
              4076.911,
              -1349.889,
              6454.601
            ],
            [
              3898.312,
              -1248.511,
              6659.965
            ],
            [
              3861.701,
              -1241.134,
              6697.313
            ],
            [
              3808.141,
              -1243.453,
              6750.923
            ],
            [
              3786.914,
              -1240.822,
              6772.313
            ],
            [
              3754.771,
              -1235.756,
              6804.851
            ],
            [
              3663.026,
              -1211.745,
              6899.687
            ],
            [
              3635.268,
              -1213.444,
              6927.497
            ],
            [
              3605.26,
              -1231.799,
              6962.673
            ],
            [
              3512.298,
              -1305.734,
              7081.452
            ],
            [
              3365.833,
              -1345.259,
              7233.156
            ],
            [
              3321.066,
              -1359.996,
              7280.287
            ],
            [
              3073.135,
              -1549.012,
              7592.051
            ],
            [
              2977.926,
              -1606.216,
              7703.123
            ],
            [
              2869.934,
              -1657.616,
              7822.723
            ],
            [
              2778.12,
              -1705.983,
              7926.498
            ],
            [
              2746.955,
              -1717.642,
              7959.772
            ],
            [
              2617.246,
              -1758.619,
              8095.8
            ],
            [
              2535.96,
              -1761.545,
              8177.139
            ],
            [
              2369.041,
              -1827.436,
              8356.592
            ],
            [
              2272.849,
              -1869.051,
              8461.4
            ],
            [
              2224.183,
              -1885.952,
              8512.918
            ],
            [
              2215.971,
              -1876.892,
              8525.145
            ],
            [
              2211.149,
              -1858.99,
              8543.685
            ],
            [
              2204.247,
              -1848.842,
              8555.958
            ],
            [
              2079.807,
              -1884.367,
              8685.37
            ],
            [
              2031.037,
              -1906.834,
              8739.066
            ],
            [
              1998.15,
              -1907.334,
              8771.957
            ],
            [
              1855.148,
              -1935.839,
              8917.772
            ],
            [
              1712.252,
              -1958.784,
              9062.499
            ],
            [
              1677.37,
              -1962.589,
              9097.588
            ],
            [
              1675.815,
              -2011.543,
              9146.566
            ],
            [
              1684.596,
              -2579.462,
              9714.554
            ],
            [
              1621.888,
              -2589.429,
              9778.049
            ],
            [
              1614.3,
              -2581.496,
              9789.027
            ],
            [
              1426.817,
              -2576.903,
              9976.566
            ],
            [
              1419.812,
              -2572.32,
              9984.938
            ],
            [
              1413.343,
              -2538.803,
              10019.073
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17268",
              "position": {
                "x": 9473.131,
                "z": -3313.243
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -120,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17270",
              "position": {
                "x": 9248.257,
                "z": -3405.537
              },
              "distanceAlongShapeM": 358.66,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:18565",
              "position": {
                "x": 8991.288,
                "z": -3077.477
              },
              "distanceAlongShapeM": 775.769,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17265",
              "position": {
                "x": 8781.89,
                "z": -2881.762
              },
              "distanceAlongShapeM": 1065.029,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17258",
              "position": {
                "x": 8141.847,
                "z": -2430.264
              },
              "distanceAlongShapeM": 1870.618,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:17252",
              "position": {
                "x": 7849.877,
                "z": -2298.626
              },
              "distanceAlongShapeM": 2199.547,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:10612",
              "position": {
                "x": 7285.671,
                "z": -2240.645
              },
              "distanceAlongShapeM": 2791.039,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:9605",
              "position": {
                "x": 6885.221,
                "z": -2279.48
              },
              "distanceAlongShapeM": 3193.369,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:10530",
              "position": {
                "x": 6582.95,
                "z": -2177.781
              },
              "distanceAlongShapeM": 3526.344,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:9607",
              "position": {
                "x": 6326.245,
                "z": -2085.902
              },
              "distanceAlongShapeM": 3802.424,
              "shapeOffsetM": 0.874,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:10317",
              "position": {
                "x": 5963.871,
                "z": -2056.543
              },
              "distanceAlongShapeM": 4169.071,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6888",
              "position": {
                "x": 5512.692,
                "z": -1852.928
              },
              "distanceAlongShapeM": 4770.939,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6886",
              "position": {
                "x": 4871.116,
                "z": -1691.327
              },
              "distanceAlongShapeM": 5518.952,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17889",
              "position": {
                "x": 4588.816,
                "z": -1418.705
              },
              "distanceAlongShapeM": 5914.465,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:17248",
              "position": {
                "x": 2977.926,
                "z": -1606.216
              },
              "distanceAlongShapeM": 7703.123,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:17242",
              "position": {
                "x": 2480.742,
                "z": -1783.887
              },
              "distanceAlongShapeM": 8236.703,
              "shapeOffsetM": 0.507,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5091",
              "position": {
                "x": 2031.037,
                "z": -1906.834
              },
              "distanceAlongShapeM": 8739.066,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5013",
              "position": {
                "x": 1621.888,
                "z": -2589.429
              },
              "distanceAlongShapeM": 9778.049,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:15167",
              "position": {
                "x": 1413.343,
                "z": -2538.803
              },
              "distanceAlongShapeM": 10019.073,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            }
          ],
          "departuresSeconds": [
            20820,
            22320,
            23580,
            24720,
            25800,
            27060,
            28200,
            29280,
            30420,
            31800,
            33360,
            34800,
            36060,
            37320,
            38640,
            40020,
            41400,
            42720,
            44100,
            45540,
            46980,
            48420,
            49860,
            51240,
            52620,
            54060,
            55440,
            56880,
            58260,
            59040,
            60240,
            61500,
            62640,
            63600,
            64620,
            65880,
            67020,
            67980,
            69480,
            71100,
            72120,
            73440,
            74700,
            76140,
            77340,
            78720,
            80100,
            81420,
            82740,
            84060,
            85380
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_120",
      "sourceRouteId": "vilnius_bus_120",
      "mode": "bus",
      "shortName": "120",
      "longName": "Visoriai–Santariškės–Žaliųjų Ežerų g.–Kryžiokai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_120:0",
          "sourceRouteId": "vilnius_bus_120",
          "sourceShapeId": "vilnius_bus_120_a-b",
          "directionId": 0,
          "headsign": "Kryžiokai",
          "directionName": "Visoriai–Santariškės–Žaliųjų Ežerų g.–Kryžiokai",
          "mode": "bus",
          "routeShortName": "120",
          "routeLongName": "Visoriai–Santariškės–Žaliųjų Ežerų g.–Kryžiokai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -995.773,
              -7709.189,
              0
            ],
            [
              -1008.525,
              -7702.28,
              14.503
            ],
            [
              -1017.555,
              -7703.23,
              23.584
            ],
            [
              -1031.635,
              -7698.523,
              38.429
            ],
            [
              -1034.149,
              -7695.138,
              42.646
            ],
            [
              -1034.672,
              -7688.449,
              49.355
            ],
            [
              -1028.056,
              -7678.549,
              61.262
            ],
            [
              -952.572,
              -7669.891,
              137.241
            ],
            [
              -687.301,
              -7633.495,
              404.997
            ],
            [
              -638.969,
              -7631.03,
              453.392
            ],
            [
              -608.156,
              -7636.041,
              484.61
            ],
            [
              -579.213,
              -7637.679,
              513.599
            ],
            [
              -565.114,
              -7641.274,
              528.149
            ],
            [
              -558.176,
              -7649.193,
              538.677
            ],
            [
              -554.82,
              -7712.708,
              602.281
            ],
            [
              -555.807,
              -7731.616,
              621.214
            ],
            [
              -545.691,
              -7741.818,
              635.582
            ],
            [
              -527.026,
              -7742.157,
              654.25
            ],
            [
              -486.981,
              -7735.09,
              694.913
            ],
            [
              -366.081,
              -7707.228,
              818.982
            ],
            [
              -195.16,
              -7690.299,
              990.74
            ],
            [
              49.054,
              -7679.166,
              1235.208
            ],
            [
              39.921,
              -7579.921,
              1334.873
            ],
            [
              25.801,
              -7471.678,
              1444.032
            ],
            [
              8.189,
              -7201.951,
              1714.334
            ],
            [
              -2.477,
              -7116.037,
              1800.908
            ],
            [
              -15.345,
              -7080.178,
              1839.005
            ],
            [
              -10.894,
              -7047.975,
              1871.514
            ],
            [
              -21.671,
              -6897.49,
              2022.384
            ],
            [
              -33.557,
              -6878.349,
              2044.916
            ],
            [
              -59.463,
              -6851.158,
              2082.472
            ],
            [
              -67.548,
              -6835.425,
              2100.16
            ],
            [
              -70.502,
              -6820.899,
              2114.984
            ],
            [
              -64.262,
              -6796.522,
              2140.147
            ],
            [
              -53.78,
              -6786.694,
              2154.517
            ],
            [
              -44.707,
              -6783.519,
              2164.129
            ],
            [
              -24.066,
              -6781.669,
              2184.852
            ],
            [
              0.233,
              -6791.019,
              2210.889
            ],
            [
              320.415,
              -6959.406,
              2572.649
            ],
            [
              487.772,
              -7068.233,
              2772.278
            ],
            [
              568.725,
              -7113.137,
              2864.851
            ],
            [
              607.827,
              -7122.761,
              2905.12
            ],
            [
              857.011,
              -7088.385,
              3156.664
            ],
            [
              911.972,
              -7076.04,
              3212.994
            ],
            [
              964.173,
              -7073.664,
              3265.25
            ],
            [
              999.31,
              -7088.785,
              3303.502
            ],
            [
              1056.317,
              -7139.934,
              3380.092
            ],
            [
              1073.183,
              -7168.077,
              3412.902
            ],
            [
              1095.862,
              -7195.215,
              3448.268
            ],
            [
              1133.283,
              -7225.965,
              3496.703
            ],
            [
              1291.476,
              -7341.333,
              3692.496
            ],
            [
              1307.902,
              -7358.336,
              3716.137
            ],
            [
              1326.737,
              -7384.29,
              3748.206
            ],
            [
              1553.349,
              -7767.005,
              4192.979
            ],
            [
              1621.327,
              -7885.162,
              4329.295
            ],
            [
              1632.975,
              -7916.55,
              4362.775
            ],
            [
              1640.555,
              -7958.994,
              4405.891
            ],
            [
              1640.017,
              -8022.44,
              4469.339
            ],
            [
              1642.406,
              -8067.015,
              4513.978
            ],
            [
              1655.237,
              -8103.991,
              4553.117
            ],
            [
              1677.887,
              -8132.245,
              4589.329
            ],
            [
              1694.973,
              -8148.149,
              4612.671
            ],
            [
              1731.324,
              -8201.149,
              4676.939
            ],
            [
              1750.194,
              -8224.879,
              4707.258
            ],
            [
              1771.12,
              -8241.968,
              4734.275
            ],
            [
              1800.494,
              -8254.762,
              4766.314
            ],
            [
              1956.145,
              -8296.632,
              4927.499
            ],
            [
              2001.461,
              -8317.518,
              4977.396
            ],
            [
              2065.812,
              -8353.233,
              5050.993
            ],
            [
              2107.826,
              -8378.511,
              5100.026
            ],
            [
              2156.129,
              -8411.7,
              5158.632
            ],
            [
              2317.488,
              -8560.563,
              5378.17
            ],
            [
              2642.21,
              -8852.78,
              5815.016
            ],
            [
              2792.271,
              -8984.749,
              6014.851
            ],
            [
              2937.196,
              -9115.513,
              6210.051
            ],
            [
              2992.31,
              -9162.2,
              6282.281
            ],
            [
              3013.269,
              -9177.069,
              6307.978
            ],
            [
              3028.932,
              -9199.631,
              6335.444
            ],
            [
              3134.577,
              -9330.771,
              6503.844
            ],
            [
              3165.86,
              -9378.122,
              6560.595
            ],
            [
              3173.907,
              -9394.973,
              6579.27
            ],
            [
              3208.182,
              -9555.935,
              6743.84
            ],
            [
              3213.698,
              -9570.512,
              6759.426
            ],
            [
              3220.563,
              -9581.775,
              6772.616
            ],
            [
              3233.82,
              -9595.386,
              6791.616
            ],
            [
              3263.762,
              -9611.54,
              6825.637
            ],
            [
              3404.776,
              -9675.449,
              6980.459
            ],
            [
              3447.994,
              -9704.103,
              7032.312
            ],
            [
              3478.945,
              -9734.751,
              7075.87
            ],
            [
              3511.635,
              -9775.451,
              7128.073
            ],
            [
              3546.778,
              -9856.276,
              7216.207
            ],
            [
              3563.744,
              -9877.752,
              7243.576
            ],
            [
              3584.076,
              -9891.498,
              7268.119
            ],
            [
              3684.789,
              -9975.801,
              7399.459
            ],
            [
              3753.117,
              -10037.223,
              7491.335
            ],
            [
              3824.059,
              -10096.468,
              7583.762
            ],
            [
              3850.114,
              -10113.666,
              7614.981
            ],
            [
              3866.759,
              -10151.835,
              7656.622
            ],
            [
              3913.653,
              -10156.072,
              7703.708
            ],
            [
              3939.124,
              -10136.521,
              7735.817
            ],
            [
              3958.891,
              -10112.407,
              7766.998
            ],
            [
              3976.835,
              -10082.692,
              7801.71
            ],
            [
              4005.224,
              -10078.783,
              7830.367
            ],
            [
              4078.021,
              -10074.611,
              7903.284
            ],
            [
              4616.81,
              -10066.046,
              8442.141
            ],
            [
              4852.251,
              -10070.594,
              8677.625
            ],
            [
              4899.81,
              -10073.74,
              8725.289
            ],
            [
              4837.14,
              -10286.278,
              8946.874
            ],
            [
              5053.091,
              -10366.163,
              9177.127
            ],
            [
              5073.204,
              -10357.647,
              9198.969
            ],
            [
              5076.7,
              -10343.242,
              9213.792
            ],
            [
              5138.706,
              -10364.484,
              9279.336
            ],
            [
              5193.747,
              -10214.146,
              9439.433
            ],
            [
              5483.07,
              -10293.25,
              9739.375
            ],
            [
              5760.739,
              -10375.486,
              10028.966
            ],
            [
              5754.276,
              -10409.871,
              10063.954
            ],
            [
              5657.014,
              -10678.501,
              10349.649
            ],
            [
              5652.72,
              -10700.683,
              10372.243
            ],
            [
              5537.763,
              -11052.467,
              10742.333
            ],
            [
              5459.292,
              -11282.501,
              10985.384
            ],
            [
              5342.766,
              -11253.514,
              11105.461
            ],
            [
              5282.147,
              -11227.842,
              11171.293
            ],
            [
              5096.144,
              -11165.225,
              11367.552
            ],
            [
              5048.769,
              -11153.173,
              11416.436
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7047",
              "position": {
                "x": -638.969,
                "z": -7631.03
              },
              "distanceAlongShapeM": 453.392,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 1444.032,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 1839.005,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:16627",
              "position": {
                "x": 320.415,
                "z": -6959.406
              },
              "distanceAlongShapeM": 2572.649,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6797",
              "position": {
                "x": 1056.317,
                "z": -7139.934
              },
              "distanceAlongShapeM": 3380.092,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6800",
              "position": {
                "x": 1694.973,
                "z": -8148.149
              },
              "distanceAlongShapeM": 4612.671,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6803",
              "position": {
                "x": 3013.269,
                "z": -9177.069
              },
              "distanceAlongShapeM": 6307.978,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6856",
              "position": {
                "x": 3684.789,
                "z": -9975.801
              },
              "distanceAlongShapeM": 7399.459,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:10554",
              "position": {
                "x": 3850.114,
                "z": -10113.666
              },
              "distanceAlongShapeM": 7614.981,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:9046",
              "position": {
                "x": 4200.33,
                "z": -10072.504
              },
              "distanceAlongShapeM": 8025.61,
              "shapeOffsetM": 0.162,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:9048",
              "position": {
                "x": 4616.81,
                "z": -10066.046
              },
              "distanceAlongShapeM": 8442.141,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:15114",
              "position": {
                "x": 4852.251,
                "z": -10070.594
              },
              "distanceAlongShapeM": 8677.625,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 9198.969,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:17133",
              "position": {
                "x": 5483.07,
                "z": -10293.25
              },
              "distanceAlongShapeM": 9739.375,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:19105",
              "position": {
                "x": 5735.162,
                "z": -10367.193
              },
              "distanceAlongShapeM": 10002.086,
              "shapeOffsetM": 0.688,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:17131",
              "position": {
                "x": 5652.72,
                "z": -10700.683
              },
              "distanceAlongShapeM": 10372.243,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:17792",
              "position": {
                "x": 5537.763,
                "z": -11052.467
              },
              "distanceAlongShapeM": 10742.333,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:17130",
              "position": {
                "x": 5342.766,
                "z": -11253.514
              },
              "distanceAlongShapeM": 11105.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:17129",
              "position": {
                "x": 5048.769,
                "z": -11153.173
              },
              "distanceAlongShapeM": 11416.436,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            }
          ],
          "departuresSeconds": [
            19800,
            20880,
            22260,
            23640,
            25140,
            26640,
            28440,
            29880,
            31320,
            33900,
            36480,
            38280,
            40080,
            42000,
            43920,
            45840,
            47760,
            49740,
            51660,
            53460,
            55200,
            56940,
            57960,
            58980,
            60660,
            61980,
            63300,
            65160,
            67320,
            68700,
            70080,
            71460,
            72660,
            75060,
            76740,
            78480,
            80280
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_120:1",
          "sourceRouteId": "vilnius_bus_120",
          "sourceShapeId": "vilnius_bus_120_b-a",
          "directionId": 1,
          "headsign": "Visoriai",
          "directionName": "Kryžiokai–Žaliųjų Ežerų g.–Santariškės–Visoriai",
          "mode": "bus",
          "routeShortName": "120",
          "routeLongName": "Visoriai–Santariškės–Žaliųjų Ežerų g.–Kryžiokai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              5048.769,
              -11153.173,
              0
            ],
            [
              4891.08,
              -11090.001,
              169.872
            ],
            [
              4694.841,
              -11023.862,
              376.957
            ],
            [
              4603.236,
              -11003.168,
              470.87
            ],
            [
              4535.923,
              -10823.745,
              662.504
            ],
            [
              4558.82,
              -10804.147,
              692.643
            ],
            [
              4623.16,
              -10770.877,
              765.077
            ],
            [
              4671.079,
              -10721.704,
              833.737
            ],
            [
              4731.911,
              -10570.358,
              996.85
            ],
            [
              4764.013,
              -10474.123,
              1098.298
            ],
            [
              4835.253,
              -10284.015,
              1301.316
            ],
            [
              5060.766,
              -10368.539,
              1542.149
            ],
            [
              5073.204,
              -10357.647,
              1558.681
            ],
            [
              5060.745,
              -10369.652,
              1575.982
            ],
            [
              5026.912,
              -10355.636,
              1612.603
            ],
            [
              4837.097,
              -10288.504,
              1813.94
            ],
            [
              4899.767,
              -10075.966,
              2035.526
            ],
            [
              4160.961,
              -10078.428,
              2774.335
            ],
            [
              4078.021,
              -10074.611,
              2857.363
            ],
            [
              4005.224,
              -10078.783,
              2930.28
            ],
            [
              3981.274,
              -10086.117,
              2955.328
            ],
            [
              3966.973,
              -10093.636,
              2971.486
            ],
            [
              3948.343,
              -10125.564,
              3008.452
            ],
            [
              3935.179,
              -10140.898,
              3028.661
            ],
            [
              3924.074,
              -10149.592,
              3042.765
            ],
            [
              3913.675,
              -10154.959,
              3054.467
            ],
            [
              3866.759,
              -10151.835,
              3101.487
            ],
            [
              3832.039,
              -10116.66,
              3150.912
            ],
            [
              3633.404,
              -9936.97,
              3418.762
            ],
            [
              3613.674,
              -9925.461,
              3441.604
            ],
            [
              3584.076,
              -9891.498,
              3486.654
            ],
            [
              3560.012,
              -9871.001,
              3518.265
            ],
            [
              3541.801,
              -9847.275,
              3548.173
            ],
            [
              3514.661,
              -9785.528,
              3615.622
            ],
            [
              3500.953,
              -9761.888,
              3642.949
            ],
            [
              3482.098,
              -9738.151,
              3673.263
            ],
            [
              3456.873,
              -9710.952,
              3710.358
            ],
            [
              3423.2,
              -9688.046,
              3751.084
            ],
            [
              3388.156,
              -9669.567,
              3790.702
            ],
            [
              3277.145,
              -9618.474,
              3912.906
            ],
            [
              3228.737,
              -9591.949,
              3968.105
            ],
            [
              3213.634,
              -9573.85,
              3991.677
            ],
            [
              3206.315,
              -9552.559,
              4014.191
            ],
            [
              3171.376,
              -9392.699,
              4177.826
            ],
            [
              3164.552,
              -9379.21,
              4192.942
            ],
            [
              3134.577,
              -9330.771,
              4249.905
            ],
            [
              3021.317,
              -9193.92,
              4427.546
            ],
            [
              2970.687,
              -9148.431,
              4495.609
            ],
            [
              2953.441,
              -9141.425,
              4514.224
            ],
            [
              2944.749,
              -9124.562,
              4533.195
            ],
            [
              2590.264,
              -8808.384,
              5008.199
            ],
            [
              2140.228,
              -8401.383,
              5614.979
            ],
            [
              2107.826,
              -8378.511,
              5654.64
            ],
            [
              1978.502,
              -8305.956,
              5802.926
            ],
            [
              1955.502,
              -8296.62,
              5827.75
            ],
            [
              1918.925,
              -8290.37,
              5864.857
            ],
            [
              1793.436,
              -8253.517,
              5995.645
            ],
            [
              1773.051,
              -8242.004,
              6019.057
            ],
            [
              1750.194,
              -8224.879,
              6047.617
            ],
            [
              1684.136,
              -8142.38,
              6153.304
            ],
            [
              1655.922,
              -8101.778,
              6202.747
            ],
            [
              1643.486,
              -8078.168,
              6229.432
            ],
            [
              1639.977,
              -8059.177,
              6248.744
            ],
            [
              1639.433,
              -7950.068,
              6357.855
            ],
            [
              1629.362,
              -7903.123,
              6405.867
            ],
            [
              1545.21,
              -7754.608,
              6576.567
            ],
            [
              1341.067,
              -7410.16,
              6976.965
            ],
            [
              1312.907,
              -7366.221,
              7029.153
            ],
            [
              1291.476,
              -7341.333,
              7061.997
            ],
            [
              1145.93,
              -7238.444,
              7240.237
            ],
            [
              1102.154,
              -7203.124,
              7296.486
            ],
            [
              1045.977,
              -7141.97,
              7379.526
            ],
            [
              1026.954,
              -7126.033,
              7404.343
            ],
            [
              999.31,
              -7088.785,
              7450.728
            ],
            [
              951.943,
              -7073.438,
              7500.519
            ],
            [
              652.324,
              -7119.127,
              7803.602
            ],
            [
              622.009,
              -7121.909,
              7834.045
            ],
            [
              600.767,
              -7121.518,
              7855.29
            ],
            [
              577.696,
              -7115.528,
              7879.126
            ],
            [
              327.732,
              -6981.805,
              8162.611
            ],
            [
              229.7,
              -6919.895,
              8278.556
            ],
            [
              60.82,
              -6823.295,
              8473.111
            ],
            [
              14.911,
              -6833.59,
              8520.16
            ],
            [
              7.024,
              -6842.352,
              8531.949
            ],
            [
              -10.864,
              -6869.857,
              8564.759
            ],
            [
              -21.671,
              -6897.49,
              8594.431
            ],
            [
              -10.612,
              -6926.637,
              8625.605
            ],
            [
              -9.853,
              -6955.595,
              8654.573
            ],
            [
              6.027,
              -7144.023,
              8843.669
            ],
            [
              16.38,
              -7176.496,
              8877.753
            ],
            [
              9.978,
              -7209.777,
              8911.644
            ],
            [
              38.024,
              -7507.525,
              9210.71
            ],
            [
              44.494,
              -7541.041,
              9244.844
            ],
            [
              49.677,
              -7680.291,
              9384.191
            ],
            [
              -112.073,
              -7688.472,
              9546.148
            ],
            [
              -235.869,
              -7698.463,
              9670.347
            ],
            [
              -384.304,
              -7718.029,
              9820.066
            ],
            [
              -496.736,
              -7740.48,
              9934.718
            ],
            [
              -530.928,
              -7744.312,
              9969.124
            ],
            [
              -541.206,
              -7743.013,
              9979.483
            ],
            [
              -548.225,
              -7739.546,
              9987.312
            ],
            [
              -551.986,
              -7733.911,
              9994.086
            ],
            [
              -555.282,
              -7702.681,
              10025.49
            ],
            [
              -552.847,
              -7674.894,
              10053.384
            ],
            [
              -555.823,
              -7661.481,
              10067.123
            ],
            [
              -560.167,
              -7652.496,
              10077.102
            ],
            [
              -567.106,
              -7644.578,
              10087.631
            ],
            [
              -661.758,
              -7645.09,
              10182.284
            ],
            [
              -677.044,
              -7635.907,
              10200.116
            ],
            [
              -928.758,
              -7670.321,
              10454.172
            ],
            [
              -968.501,
              -7696.322,
              10501.664
            ],
            [
              -995.773,
              -7709.189,
              10531.82
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17129",
              "position": {
                "x": 5048.769,
                "z": -11153.173
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:9054",
              "position": {
                "x": 4558.82,
                "z": -10804.147
              },
              "distanceAlongShapeM": 692.643,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:16832",
              "position": {
                "x": 4764.013,
                "z": -10474.123
              },
              "distanceAlongShapeM": 1098.298,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:9081",
              "position": {
                "x": 5073.204,
                "z": -10357.647
              },
              "distanceAlongShapeM": 1558.681,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:15113",
              "position": {
                "x": 4825.104,
                "z": -10076.748
              },
              "distanceAlongShapeM": 2110.191,
              "shapeOffsetM": 0.533,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:9047",
              "position": {
                "x": 4559.944,
                "z": -10078.309
              },
              "distanceAlongShapeM": 2375.355,
              "shapeOffsetM": 1.21,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:9045",
              "position": {
                "x": 4160.961,
                "z": -10078.428
              },
              "distanceAlongShapeM": 2774.335,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:10556",
              "position": {
                "x": 3832.039,
                "z": -10116.66
              },
              "distanceAlongShapeM": 3150.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6857",
              "position": {
                "x": 3613.674,
                "z": -9925.461
              },
              "distanceAlongShapeM": 3441.604,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6804",
              "position": {
                "x": 2953.441,
                "z": -9141.425
              },
              "distanceAlongShapeM": 4514.224,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6801",
              "position": {
                "x": 1918.925,
                "z": -8290.37
              },
              "distanceAlongShapeM": 5864.857,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6798",
              "position": {
                "x": 1026.954,
                "z": -7126.033
              },
              "distanceAlongShapeM": 7404.343,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:16628",
              "position": {
                "x": 229.7,
                "z": -6919.895
              },
              "distanceAlongShapeM": 8278.556,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 8625.605,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 8877.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:8716",
              "position": {
                "x": 44.494,
                "z": -7541.041
              },
              "distanceAlongShapeM": 9244.844,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7046",
              "position": {
                "x": -661.758,
                "z": -7645.09
              },
              "distanceAlongShapeM": 10182.284,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 10531.82,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            }
          ],
          "departuresSeconds": [
            21480,
            22560,
            24000,
            25380,
            27000,
            28500,
            30300,
            31740,
            33120,
            35640,
            38220,
            40020,
            41820,
            43800,
            45720,
            47580,
            49500,
            51480,
            53400,
            55260,
            56940,
            58680,
            59760,
            60780,
            62520,
            63840,
            65160,
            66960,
            69120,
            70440,
            71820,
            73200,
            74340,
            76740,
            78420,
            80160,
            81960
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_121",
      "sourceRouteId": "vilnius_bus_121",
      "mode": "bus",
      "shortName": "121",
      "longName": "Santariškės–Mažieji Gulbinai–Didžiųjų Gulbinų g.",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_121:0",
          "sourceRouteId": "vilnius_bus_121",
          "sourceShapeId": "vilnius_bus_121_a-b",
          "directionId": 0,
          "headsign": "Didžiųjų Gulbinų g.",
          "directionName": "Santariškės–Mažieji Gulbinai–Didžiųjų Gulbinų g.",
          "mode": "bus",
          "routeShortName": "121",
          "routeLongName": "Santariškės–Mažieji Gulbinai–Didžiųjų Gulbinų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              73.695,
              -7563.839,
              0
            ],
            [
              69.345,
              -7590.477,
              26.991
            ],
            [
              45.368,
              -7598.945,
              52.419
            ],
            [
              37.787,
              -7591.014,
              63.391
            ],
            [
              25.801,
              -7471.678,
              183.328
            ],
            [
              8.189,
              -7201.951,
              453.629
            ],
            [
              -2.477,
              -7116.037,
              540.203
            ],
            [
              -15.345,
              -7080.178,
              578.301
            ],
            [
              -10.894,
              -7047.975,
              610.81
            ],
            [
              -21.671,
              -6897.49,
              761.68
            ],
            [
              -33.557,
              -6878.349,
              784.212
            ],
            [
              -59.463,
              -6851.158,
              821.767
            ],
            [
              -67.548,
              -6835.425,
              839.456
            ],
            [
              -70.502,
              -6820.899,
              854.279
            ],
            [
              -64.262,
              -6796.522,
              879.443
            ],
            [
              -53.78,
              -6786.694,
              893.812
            ],
            [
              -33.722,
              -6781.493,
              914.533
            ],
            [
              -15.095,
              -6784.06,
              933.337
            ],
            [
              0.233,
              -6791.019,
              950.17
            ],
            [
              320.415,
              -6959.406,
              1311.931
            ],
            [
              487.772,
              -7068.233,
              1511.56
            ],
            [
              568.725,
              -7113.137,
              1604.133
            ],
            [
              607.827,
              -7122.761,
              1644.401
            ],
            [
              857.011,
              -7088.385,
              1895.946
            ],
            [
              911.972,
              -7076.04,
              1952.276
            ],
            [
              964.173,
              -7073.664,
              2004.532
            ],
            [
              999.31,
              -7088.785,
              2042.784
            ],
            [
              1056.317,
              -7139.934,
              2119.374
            ],
            [
              1073.183,
              -7168.077,
              2152.184
            ],
            [
              1095.862,
              -7195.215,
              2187.55
            ],
            [
              1133.283,
              -7225.965,
              2235.985
            ],
            [
              1291.476,
              -7341.333,
              2431.778
            ],
            [
              1307.902,
              -7358.336,
              2455.419
            ],
            [
              1326.737,
              -7384.29,
              2487.488
            ],
            [
              1553.349,
              -7767.005,
              2932.261
            ],
            [
              1621.327,
              -7885.162,
              3068.577
            ],
            [
              1632.975,
              -7916.55,
              3102.057
            ],
            [
              1640.555,
              -7958.994,
              3145.173
            ],
            [
              1640.017,
              -8022.44,
              3208.621
            ],
            [
              1642.406,
              -8067.015,
              3253.26
            ],
            [
              1655.237,
              -8103.991,
              3292.399
            ],
            [
              1677.887,
              -8132.245,
              3328.611
            ],
            [
              1694.973,
              -8148.149,
              3351.953
            ],
            [
              1750.194,
              -8224.879,
              3446.488
            ],
            [
              1723.021,
              -8266.677,
              3496.342
            ],
            [
              1711.915,
              -8275.376,
              3510.45
            ],
            [
              1697.738,
              -8310.736,
              3548.546
            ],
            [
              1689.186,
              -8355.107,
              3593.734
            ],
            [
              1673.991,
              -8375.976,
              3619.548
            ],
            [
              1649.227,
              -8392.213,
              3649.161
            ],
            [
              1605.078,
              -8516.076,
              3780.657
            ],
            [
              1504.242,
              -8607.714,
              3916.913
            ],
            [
              1432.991,
              -8735.528,
              4063.245
            ],
            [
              1397.836,
              -8826.162,
              4160.458
            ],
            [
              1364.062,
              -9015.902,
              4353.18
            ],
            [
              1330.965,
              -9099.896,
              4443.459
            ],
            [
              1324.72,
              -9124.272,
              4468.622
            ],
            [
              1320.872,
              -9262.244,
              4606.649
            ],
            [
              1308.077,
              -9362.2,
              4707.42
            ],
            [
              1288.184,
              -9463.137,
              4810.299
            ],
            [
              1249.061,
              -9629.401,
              4981.103
            ],
            [
              1249.976,
              -9649.456,
              5001.18
            ],
            [
              1264.718,
              -9722.091,
              5075.296
            ],
            [
              1236.873,
              -9766.105,
              5127.378
            ],
            [
              1180.954,
              -9831.865,
              5213.699
            ],
            [
              1170.228,
              -9855.044,
              5239.24
            ],
            [
              1151.066,
              -9951.543,
              5337.622
            ],
            [
              1129.1,
              -10025.724,
              5414.988
            ],
            [
              1112.29,
              -10169.023,
              5559.269
            ],
            [
              1088.102,
              -10224.239,
              5619.55
            ],
            [
              1064.785,
              -10267.224,
              5668.452
            ],
            [
              1059.145,
              -10293.838,
              5695.657
            ],
            [
              1056.202,
              -10313.822,
              5715.857
            ],
            [
              1058.178,
              -10346.143,
              5748.238
            ],
            [
              1096.893,
              -10479.337,
              5886.945
            ],
            [
              1101.709,
              -10497.239,
              5905.483
            ],
            [
              1102.769,
              -10509.504,
              5917.794
            ],
            [
              1077.737,
              -10749.505,
              6159.097
            ],
            [
              1074.858,
              -10939.819,
              6349.432
            ],
            [
              1066.085,
              -10961.921,
              6373.213
            ],
            [
              1065.009,
              -10985.28,
              6396.596
            ],
            [
              965.873,
              -11058.035,
              6519.564
            ],
            [
              860.109,
              -11176.313,
              6678.233
            ],
            [
              834.021,
              -11230.381,
              6738.266
            ],
            [
              744.712,
              -11433.572,
              6960.218
            ],
            [
              724.934,
              -11494.437,
              7024.216
            ],
            [
              728.136,
              -11530.12,
              7060.042
            ],
            [
              747.873,
              -11576.128,
              7110.105
            ],
            [
              808.818,
              -11689.691,
              7238.988
            ],
            [
              814.071,
              -11718.733,
              7268.501
            ],
            [
              807.832,
              -11743.109,
              7293.664
            ],
            [
              788.116,
              -11800.635,
              7354.474
            ],
            [
              739.315,
              -11830.906,
              7411.902
            ],
            [
              746.162,
              -11843.278,
              7426.042
            ],
            [
              768.175,
              -11870.402,
              7460.975
            ],
            [
              776.021,
              -11898.379,
              7490.031
            ],
            [
              851.195,
              -12042.263,
              7652.37
            ],
            [
              887.734,
              -12118.64,
              7737.036
            ],
            [
              910.804,
              -12158.03,
              7782.686
            ],
            [
              920.871,
              -12204.973,
              7830.696
            ],
            [
              956.064,
              -12319.176,
              7950.199
            ],
            [
              969.905,
              -12370.642,
              8003.493
            ],
            [
              970.198,
              -12389.573,
              8022.427
            ],
            [
              967.256,
              -12409.558,
              8042.626
            ],
            [
              959.957,
              -12421.668,
              8056.766
            ],
            [
              947.165,
              -12452.603,
              8090.242
            ],
            [
              939.939,
              -12530.398,
              8168.371
            ],
            [
              941.173,
              -12602.783,
              8240.767
            ],
            [
              954.247,
              -12660.914,
              8300.35
            ],
            [
              958.983,
              -12717.778,
              8357.411
            ],
            [
              960.155,
              -12793.501,
              8433.143
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7831",
              "position": {
                "x": 25.801,
                "z": -7471.678
              },
              "distanceAlongShapeM": 183.328,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6526",
              "position": {
                "x": -15.345,
                "z": -7080.178
              },
              "distanceAlongShapeM": 578.301,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:16627",
              "position": {
                "x": 320.415,
                "z": -6959.406
              },
              "distanceAlongShapeM": 1311.931,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6797",
              "position": {
                "x": 1056.317,
                "z": -7139.934
              },
              "distanceAlongShapeM": 2119.374,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6800",
              "position": {
                "x": 1694.973,
                "z": -8148.149
              },
              "distanceAlongShapeM": 3351.953,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:17034",
              "position": {
                "x": 1320.872,
                "z": -9262.244
              },
              "distanceAlongShapeM": 4606.649,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:17036",
              "position": {
                "x": 1260.221,
                "z": -9582.851
              },
              "distanceAlongShapeM": 4933.235,
              "shapeOffsetM": 0.201,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:17038",
              "position": {
                "x": 1074.858,
                "z": -10939.819
              },
              "distanceAlongShapeM": 6349.432,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:17040",
              "position": {
                "x": 768.175,
                "z": -11870.402
              },
              "distanceAlongShapeM": 7460.975,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17150",
              "position": {
                "x": 910.804,
                "z": -12158.03
              },
              "distanceAlongShapeM": 7782.686,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:17153",
              "position": {
                "x": 960.155,
                "z": -12793.501
              },
              "distanceAlongShapeM": 8433.143,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            }
          ],
          "departuresSeconds": [
            18840,
            20340,
            21660,
            22980,
            24300,
            25860,
            27420,
            33240,
            34740,
            36240,
            37680,
            39120,
            40440,
            41760,
            43080,
            44400,
            45720,
            47040,
            51960,
            53280,
            54600,
            55920,
            57240,
            58620,
            60000,
            61800,
            67800,
            69300,
            70800,
            72120,
            76800,
            78120,
            79440,
            80760
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_121:1",
          "sourceRouteId": "vilnius_bus_121",
          "sourceShapeId": "vilnius_bus_121_b-a",
          "directionId": 1,
          "headsign": "Santariškės",
          "directionName": "Didžiųjų Gulbinų g.–Mažieji Gulbinai–Santariškės",
          "mode": "bus",
          "routeShortName": "121",
          "routeLongName": "Santariškės–Mažieji Gulbinai–Didžiųjų Gulbinų g.",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              960.155,
              -12793.501,
              0
            ],
            [
              954.77,
              -12841.272,
              48.073
            ],
            [
              959.188,
              -12845.807,
              54.404
            ],
            [
              960.309,
              -12854.734,
              63.401
            ],
            [
              953.155,
              -12859.054,
              71.759
            ],
            [
              946.083,
              -12858.924,
              78.832
            ],
            [
              941.022,
              -12854.377,
              85.635
            ],
            [
              941.187,
              -12845.474,
              94.539
            ],
            [
              945.127,
              -12841.094,
              100.43
            ],
            [
              952.24,
              -12838.999,
              107.845
            ],
            [
              957.831,
              -12780.099,
              167.01
            ],
            [
              953.696,
              -12725.473,
              221.792
            ],
            [
              954.252,
              -12695.425,
              251.845
            ],
            [
              938.72,
              -12561.547,
              386.622
            ],
            [
              938.817,
              -12521.471,
              426.697
            ],
            [
              940.7,
              -12489.221,
              459.002
            ],
            [
              944.306,
              -12468.136,
              480.393
            ],
            [
              947.829,
              -12451.502,
              497.396
            ],
            [
              963.939,
              -12415.062,
              537.238
            ],
            [
              970.137,
              -12392.912,
              560.239
            ],
            [
              969.905,
              -12370.642,
              582.51
            ],
            [
              946.873,
              -12294.515,
              662.046
            ],
            [
              924.004,
              -12209.484,
              750.098
            ],
            [
              912.965,
              -12180.335,
              781.267
            ],
            [
              888.089,
              -12134.232,
              833.653
            ],
            [
              854.807,
              -12055.689,
              918.957
            ],
            [
              747.161,
              -11858.882,
              1143.279
            ],
            [
              738.008,
              -11831.995,
              1171.682
            ],
            [
              780.256,
              -11808.283,
              1220.129
            ],
            [
              786.81,
              -11801.724,
              1229.401
            ],
            [
              813.928,
              -11726.523,
              1309.342
            ],
            [
              814.113,
              -11716.507,
              1319.36
            ],
            [
              806.93,
              -11687.43,
              1349.311
            ],
            [
              734.82,
              -11551.395,
              1503.276
            ],
            [
              722.157,
              -11505.518,
              1550.869
            ],
            [
              725.221,
              -11478.857,
              1577.706
            ],
            [
              848.827,
              -11195.03,
              1887.28
            ],
            [
              887.696,
              -11145.651,
              1950.122
            ],
            [
              963.259,
              -11060.213,
              2064.181
            ],
            [
              982.882,
              -11042.763,
              2090.44
            ],
            [
              1031.777,
              -11008.043,
              2150.408
            ],
            [
              1061.711,
              -10989.672,
              2185.53
            ],
            [
              1085.734,
              -10665.045,
              2511.045
            ],
            [
              1094.725,
              -10561.678,
              2614.802
            ],
            [
              1102.167,
              -10507.266,
              2669.72
            ],
            [
              1101.107,
              -10495.001,
              2682.031
            ],
            [
              1055.291,
              -10328.278,
              2854.936
            ],
            [
              1056.696,
              -10287.113,
              2896.124
            ],
            [
              1062.007,
              -10278.305,
              2906.409
            ],
            [
              1068.81,
              -10258.393,
              2927.452
            ],
            [
              1078.85,
              -10237.426,
              2950.698
            ],
            [
              1102.146,
              -10195.554,
              2998.615
            ],
            [
              1112.31,
              -10167.91,
              3028.068
            ],
            [
              1121.966,
              -10063.443,
              3132.98
            ],
            [
              1135.322,
              -10002.461,
              3195.408
            ],
            [
              1156.727,
              -9923.816,
              3276.914
            ],
            [
              1163.177,
              -9888.311,
              3312.999
            ],
            [
              1174.855,
              -9848.45,
              3354.536
            ],
            [
              1180.249,
              -9835.191,
              3368.85
            ],
            [
              1221,
              -9789.19,
              3430.306
            ],
            [
              1250.028,
              -9750.764,
              3478.464
            ],
            [
              1260.132,
              -9726.459,
              3504.785
            ],
            [
              1260.025,
              -9697.513,
              3533.732
            ],
            [
              1252.904,
              -9665.096,
              3566.921
            ],
            [
              1249.811,
              -9658.359,
              3574.334
            ],
            [
              1248.751,
              -9646.094,
              3586.645
            ],
            [
              1251.114,
              -9622.759,
              3610.099
            ],
            [
              1254.93,
              -9590.545,
              3642.538
            ],
            [
              1265.694,
              -9530.629,
              3703.414
            ],
            [
              1280.715,
              -9484.151,
              3752.259
            ],
            [
              1293.265,
              -9432.06,
              3805.84
            ],
            [
              1305.255,
              -9375.507,
              3863.651
            ],
            [
              1314.091,
              -9315.555,
              3924.25
            ],
            [
              1321.175,
              -9176.529,
              4063.457
            ],
            [
              1319.782,
              -9147.558,
              4092.461
            ],
            [
              1326.275,
              -9109.828,
              4130.745
            ],
            [
              1347.109,
              -9062.345,
              4182.598
            ],
            [
              1358.106,
              -9024.698,
              4221.818
            ],
            [
              1369.144,
              -8984.826,
              4263.191
            ],
            [
              1377.898,
              -8929.325,
              4319.377
            ],
            [
              1392.733,
              -8858.352,
              4391.884
            ],
            [
              1407.175,
              -8808.524,
              4443.763
            ],
            [
              1430.19,
              -8747.722,
              4508.775
            ],
            [
              1448.91,
              -8710.219,
              4550.69
            ],
            [
              1472.861,
              -8668.36,
              4598.917
            ],
            [
              1513.956,
              -8604.555,
              4674.811
            ],
            [
              1597.191,
              -8524.836,
              4790.064
            ],
            [
              1605.763,
              -8513.863,
              4803.988
            ],
            [
              1609.748,
              -8507.257,
              4811.703
            ],
            [
              1643.892,
              -8402.133,
              4922.233
            ],
            [
              1681.236,
              -8367.205,
              4973.366
            ],
            [
              1689.227,
              -8352.881,
              4989.768
            ],
            [
              1690.161,
              -8337.313,
              5005.364
            ],
            [
              1701.225,
              -8296.328,
              5047.815
            ],
            [
              1705.895,
              -8287.509,
              5057.795
            ],
            [
              1752.021,
              -8230.48,
              5131.143
            ],
            [
              1729.933,
              -8206.689,
              5163.607
            ],
            [
              1707.948,
              -8177.335,
              5200.281
            ],
            [
              1655.86,
              -8105.116,
              5289.324
            ],
            [
              1647.161,
              -8088.255,
              5308.297
            ],
            [
              1638.752,
              -8055.814,
              5341.81
            ],
            [
              1638.936,
              -7976.776,
              5420.848
            ],
            [
              1635.841,
              -7935.528,
              5462.212
            ],
            [
              1631.127,
              -7912.062,
              5486.147
            ],
            [
              1621.244,
              -7889.613,
              5510.675
            ],
            [
              1583.29,
              -7818.772,
              5591.044
            ],
            [
              1329.126,
              -7394.353,
              6085.746
            ],
            [
              1304.019,
              -7359.377,
              6128.8
            ],
            [
              1271.77,
              -7327.608,
              6174.069
            ],
            [
              1154.195,
              -7244.164,
              6318.246
            ],
            [
              1098.957,
              -7201.951,
              6387.767
            ],
            [
              1026.954,
              -7126.033,
              6492.399
            ],
            [
              999.31,
              -7088.785,
              6538.785
            ],
            [
              951.943,
              -7073.438,
              6588.576
            ],
            [
              652.324,
              -7119.127,
              6891.659
            ],
            [
              622.009,
              -7121.909,
              6922.101
            ],
            [
              600.767,
              -7121.518,
              6943.347
            ],
            [
              577.696,
              -7115.528,
              6967.183
            ],
            [
              488.416,
              -7068.245,
              7068.21
            ],
            [
              60.82,
              -6823.295,
              7560.997
            ],
            [
              14.911,
              -6833.59,
              7608.046
            ],
            [
              7.024,
              -6842.352,
              7619.835
            ],
            [
              -10.864,
              -6869.857,
              7652.645
            ],
            [
              -21.671,
              -6897.49,
              7682.317
            ],
            [
              -10.612,
              -6926.637,
              7713.491
            ],
            [
              -9.853,
              -6955.595,
              7742.459
            ],
            [
              6.027,
              -7144.023,
              7931.555
            ],
            [
              16.38,
              -7176.496,
              7965.638
            ],
            [
              10.845,
              -7197.547,
              7987.405
            ],
            [
              32.291,
              -7398.322,
              8189.323
            ],
            [
              48.234,
              -7442.03,
              8235.847
            ],
            [
              37.062,
              -7489.696,
              8284.804
            ],
            [
              41.201,
              -7509.81,
              8305.34
            ],
            [
              62.699,
              -7531.354,
              8335.775
            ],
            [
              73.695,
              -7563.839,
              8370.071
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17153",
              "position": {
                "x": 960.155,
                "z": -12793.501
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17152",
              "position": {
                "x": 888.089,
                "z": -12134.232
              },
              "distanceAlongShapeM": 833.653,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:17041",
              "position": {
                "x": 747.161,
                "z": -11858.882
              },
              "distanceAlongShapeM": 1143.279,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:17039",
              "position": {
                "x": 1067.094,
                "z": -10907.39
              },
              "distanceAlongShapeM": 2267.985,
              "shapeOffsetM": 0.704,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:17037",
              "position": {
                "x": 1265.694,
                "z": -9530.629
              },
              "distanceAlongShapeM": 3703.414,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 390,
              "departureOffsetSeconds": 390
            },
            {
              "stopId": "judu:stop:17033",
              "position": {
                "x": 1319.782,
                "z": -9147.558
              },
              "distanceAlongShapeM": 4092.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6798",
              "position": {
                "x": 1026.954,
                "z": -7126.033
              },
              "distanceAlongShapeM": 6492.399,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:16628",
              "position": {
                "x": 229.7,
                "z": -6919.895
              },
              "distanceAlongShapeM": 7366.442,
              "shapeOffsetM": 0.125,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6525",
              "position": {
                "x": -10.612,
                "z": -6926.637
              },
              "distanceAlongShapeM": 7713.491,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6532",
              "position": {
                "x": 16.38,
                "z": -7176.496
              },
              "distanceAlongShapeM": 7965.638,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6533",
              "position": {
                "x": 73.695,
                "z": -7563.839
              },
              "distanceAlongShapeM": 8370.071,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            }
          ],
          "departuresSeconds": [
            19800,
            21300,
            22620,
            23940,
            25260,
            31200,
            32700,
            34200,
            35700,
            37200,
            38640,
            40080,
            41400,
            42720,
            44040,
            45360,
            50280,
            51600,
            52920,
            54240,
            55560,
            56880,
            58200,
            59580,
            65460,
            67260,
            68760,
            70260,
            75120,
            76500,
            77760,
            79080,
            80400,
            81720
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_122",
      "sourceRouteId": "vilnius_bus_122",
      "mode": "bus",
      "shortName": "122",
      "longName": "Naujininkai–Kalnėnai–Guriai–Pavilnys–Naujoji Vilnia (Apylanka)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_122:0",
          "sourceRouteId": "vilnius_bus_122",
          "sourceShapeId": "vilnius_bus_122_a-b",
          "directionId": 0,
          "headsign": "Naujoji Vilnia (Apylanka)",
          "directionName": "Naujininkai–Kalnėnai–Guriai–Pavilnys–Naujoji Vilnia (Apylanka)",
          "mode": "bus",
          "routeShortName": "122",
          "routeLongName": "Naujininkai–Kalnėnai–Guriai–Pavilnys–Naujoji Vilnia (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -196.145,
              2858.737,
              0
            ],
            [
              -195.016,
              2849.811,
              8.997
            ],
            [
              -197.819,
              2837.616,
              21.51
            ],
            [
              -204.996,
              2833.294,
              29.888
            ],
            [
              -247.211,
              2818.474,
              74.629
            ],
            [
              -235.939,
              2941.838,
              198.506
            ],
            [
              -233.72,
              2993.006,
              249.722
            ],
            [
              -255.513,
              3072.44,
              332.092
            ],
            [
              -257.286,
              3117.001,
              376.688
            ],
            [
              -267.064,
              3182.859,
              443.267
            ],
            [
              -302.93,
              3376.096,
              639.806
            ],
            [
              -343.116,
              3580.544,
              848.165
            ],
            [
              -348.015,
              3595.105,
              863.528
            ],
            [
              -373.784,
              3597.798,
              889.437
            ],
            [
              -490.971,
              3577.653,
              1008.343
            ],
            [
              -509.843,
              3569.088,
              1029.068
            ],
            [
              -519.218,
              3550.333,
              1050.036
            ],
            [
              -518.774,
              3539.193,
              1061.185
            ],
            [
              -513.794,
              3529.084,
              1072.454
            ],
            [
              -504.316,
              3517.78,
              1087.205
            ],
            [
              -496.029,
              3512.064,
              1097.272
            ],
            [
              -468.245,
              3513.789,
              1125.11
            ],
            [
              -455.865,
              3520.244,
              1139.072
            ],
            [
              -318.9,
              3563.407,
              1282.678
            ],
            [
              -105.268,
              3669.742,
              1521.31
            ],
            [
              5.271,
              3714.489,
              1640.563
            ],
            [
              57.758,
              3725.78,
              1694.251
            ],
            [
              134.079,
              3734.409,
              1771.058
            ],
            [
              245.04,
              3731.274,
              1882.063
            ],
            [
              313.918,
              3721.112,
              1951.687
            ],
            [
              483.909,
              3663.458,
              2131.189
            ],
            [
              526.148,
              3643.76,
              2177.795
            ],
            [
              597.32,
              3617.966,
              2253.497
            ],
            [
              680.187,
              3596.409,
              2339.122
            ],
            [
              792.211,
              3580.995,
              2452.201
            ],
            [
              953.761,
              3591.386,
              2614.085
            ],
            [
              1039.238,
              3606.511,
              2700.89
            ],
            [
              1165.109,
              3642.042,
              2831.679
            ],
            [
              1250.045,
              3662.739,
              2919.101
            ],
            [
              1545.858,
              3742.988,
              3225.606
            ],
            [
              1743.856,
              3803.884,
              3432.757
            ],
            [
              1812.124,
              3830.447,
              3506.011
            ],
            [
              1876.708,
              3867.097,
              3580.269
            ],
            [
              2082.225,
              4019.124,
              3835.904
            ],
            [
              2137.697,
              4051.487,
              3900.126
            ],
            [
              3783.191,
              4734.089,
              5681.586
            ],
            [
              4094.837,
              4859.518,
              6017.526
            ],
            [
              4105.015,
              4851.531,
              6030.463
            ],
            [
              4106.76,
              4841.478,
              6040.666
            ],
            [
              3917.274,
              4757.143,
              6248.073
            ],
            [
              3791.824,
              4712.774,
              6381.137
            ],
            [
              2822.207,
              4305.846,
              7432.683
            ],
            [
              2770.246,
              4289.011,
              7487.303
            ],
            [
              2807.11,
              4258.26,
              7535.308
            ],
            [
              2948.179,
              4207.737,
              7685.152
            ],
            [
              2964.832,
              4200.744,
              7703.213
            ],
            [
              2982.066,
              4190.4,
              7723.314
            ],
            [
              3009.186,
              4156.492,
              7766.733
            ],
            [
              3087.299,
              4088.224,
              7870.473
            ],
            [
              3136.062,
              4038.321,
              7940.246
            ],
            [
              3298.984,
              3915.013,
              8144.57
            ],
            [
              3424.471,
              3792.407,
              8320.01
            ],
            [
              3464.987,
              3750.45,
              8378.337
            ],
            [
              3527.875,
              3696.935,
              8460.912
            ],
            [
              3679.16,
              3505.925,
              8704.576
            ],
            [
              3844.888,
              3667.535,
              8936.058
            ],
            [
              3893.05,
              3722.281,
              9008.973
            ],
            [
              3914.016,
              3738.58,
              9035.529
            ],
            [
              4011.736,
              3785.701,
              9144.018
            ],
            [
              4116.685,
              3839.361,
              9261.888
            ],
            [
              4455.787,
              3985.391,
              9631.098
            ],
            [
              4660.266,
              4078.321,
              9855.703
            ],
            [
              4783.97,
              3831.027,
              10132.212
            ],
            [
              4807.805,
              3794.944,
              10175.456
            ],
            [
              4845.318,
              3765.277,
              10223.282
            ],
            [
              4903.716,
              3714.056,
              10300.961
            ],
            [
              4948.434,
              3656.418,
              10373.912
            ],
            [
              4964.008,
              3627.173,
              10407.045
            ],
            [
              4995.715,
              3497.423,
              10540.613
            ],
            [
              5047.769,
              3251.502,
              10791.983
            ],
            [
              5066.309,
              3175.442,
              10870.27
            ],
            [
              5092.784,
              3042.453,
              11005.869
            ],
            [
              5046.033,
              3027.77,
              11054.872
            ],
            [
              4671.063,
              2927.005,
              11443.145
            ],
            [
              4632.851,
              2919.946,
              11482.003
            ],
            [
              4422.655,
              2862.75,
              11699.842
            ],
            [
              4139.27,
              2791.357,
              11992.082
            ],
            [
              4153.342,
              2751.011,
              12034.812
            ],
            [
              4169.434,
              2715.08,
              12074.182
            ],
            [
              4171.136,
              2702.801,
              12086.578
            ],
            [
              4191.056,
              2664.57,
              12129.688
            ],
            [
              4218.241,
              2635.106,
              12169.778
            ],
            [
              4282.48,
              2586.007,
              12250.631
            ],
            [
              4309.254,
              2568.796,
              12282.46
            ],
            [
              4467.714,
              2520.116,
              12448.228
            ],
            [
              4610.044,
              2471.741,
              12598.555
            ],
            [
              4652.686,
              2440.864,
              12651.202
            ],
            [
              4671.824,
              2429.363,
              12673.53
            ],
            [
              4814.301,
              2355.374,
              12834.073
            ],
            [
              4977.975,
              2276.518,
              13015.752
            ],
            [
              5035.146,
              2296.566,
              13076.337
            ],
            [
              5084.32,
              2303.41,
              13125.985
            ],
            [
              5241.303,
              2346.019,
              13288.648
            ],
            [
              5248.742,
              2330.289,
              13306.048
            ],
            [
              5276.154,
              2246.264,
              13394.432
            ],
            [
              5292.838,
              2208.09,
              13436.092
            ],
            [
              5291.934,
              2194.748,
              13449.465
            ],
            [
              5310.766,
              2134.268,
              13512.81
            ],
            [
              5382.085,
              2151.811,
              13586.255
            ],
            [
              5561.127,
              2200.662,
              13771.841
            ],
            [
              5722.731,
              2215.333,
              13934.11
            ],
            [
              5789.901,
              2218.479,
              14001.353
            ],
            [
              5836.257,
              2213.123,
              14048.017
            ],
            [
              5887.192,
              2211.017,
              14098.997
            ],
            [
              5905.833,
              2207.314,
              14118.002
            ],
            [
              5985.832,
              2173.469,
              14204.866
            ],
            [
              6001.763,
              2163.138,
              14223.852
            ],
            [
              6021.215,
              2134.927,
              14258.12
            ],
            [
              6133.108,
              2148.327,
              14370.813
            ],
            [
              6139.08,
              2123.718,
              14396.136
            ],
            [
              6139.225,
              2098.11,
              14421.744
            ],
            [
              6156.232,
              1911.861,
              14608.768
            ],
            [
              6182.699,
              1648.612,
              14873.345
            ],
            [
              6188.112,
              1628.467,
              14894.204
            ],
            [
              6187.271,
              1618.464,
              14904.242
            ],
            [
              6199.269,
              1539.187,
              14984.422
            ],
            [
              6224.257,
              1398.425,
              15127.384
            ],
            [
              6229.987,
              1361.575,
              15164.677
            ],
            [
              6230.798,
              1337.067,
              15189.199
            ],
            [
              6233.848,
              1328.101,
              15198.669
            ],
            [
              6229.182,
              1320.4,
              15207.674
            ],
            [
              6225.273,
              1252.567,
              15275.62
            ],
            [
              6214.267,
              1250.556,
              15286.809
            ],
            [
              6211.086,
              1252.844,
              15290.728
            ],
            [
              6209.926,
              1259.547,
              15297.53
            ],
            [
              6223.709,
              1271.523,
              15315.789
            ],
            [
              6225.883,
              1283.726,
              15328.184
            ],
            [
              6226.275,
              1303.758,
              15348.219
            ],
            [
              6230.066,
              1332.629,
              15377.338
            ],
            [
              6228.205,
              1369.403,
              15414.16
            ],
            [
              6214.679,
              1436.464,
              15482.571
            ],
            [
              6187.097,
              1609.561,
              15657.852
            ],
            [
              6178.873,
              1650.913,
              15700.014
            ],
            [
              6160.788,
              1814.918,
              15865.012
            ],
            [
              6154.188,
              1906.335,
              15956.668
            ],
            [
              6131.13,
              2146.139,
              16197.578
            ],
            [
              6173.875,
              2154.21,
              16241.079
            ],
            [
              6186.283,
              2161.76,
              16255.603
            ],
            [
              6190.088,
              2158.346,
              16260.715
            ],
            [
              6302.78,
              2179.519,
              16375.379
            ],
            [
              6339.743,
              2188.814,
              16413.493
            ],
            [
              6485.19,
              2234.946,
              16566.081
            ],
            [
              6518.994,
              2247.642,
              16602.19
            ],
            [
              6647.127,
              2266.277,
              16731.671
            ],
            [
              6648.734,
              2249.547,
              16748.479
            ],
            [
              6664.061,
              2175.769,
              16823.832
            ],
            [
              6679.103,
              2087.525,
              16913.349
            ],
            [
              6685.858,
              2037.294,
              16964.032
            ],
            [
              6713.888,
              2018.931,
              16997.541
            ],
            [
              6722.098,
              2009.863,
              17009.774
            ],
            [
              6786.815,
              1954.039,
              17095.241
            ],
            [
              6934.171,
              1835.354,
              17284.449
            ],
            [
              6994.719,
              1797.421,
              17355.899
            ],
            [
              7151.902,
              1752.011,
              17519.509
            ],
            [
              7180.859,
              1748.098,
              17548.73
            ],
            [
              7232.816,
              1732.598,
              17602.949
            ],
            [
              7218.9,
              1583.694,
              17752.502
            ],
            [
              7576.848,
              1544.311,
              18112.61
            ],
            [
              7614.877,
              1542.442,
              18150.685
            ],
            [
              7753.694,
              1547.473,
              18289.593
            ],
            [
              7798.773,
              1543.236,
              18334.871
            ],
            [
              7799.733,
              1494.232,
              18383.884
            ],
            [
              7793.796,
              1487.671,
              18392.733
            ],
            [
              7754.104,
              1114.398,
              18768.11
            ],
            [
              7760.199,
              1096.464,
              18787.052
            ],
            [
              7751.793,
              1095.518,
              18795.51
            ],
            [
              7745.305,
              1028.85,
              18862.493
            ],
            [
              8019.062,
              975.52,
              19141.396
            ],
            [
              8065.959,
              965.677,
              19189.315
            ],
            [
              8092.242,
              957.359,
              19216.883
            ],
            [
              8117.792,
              944.602,
              19245.441
            ],
            [
              8150.835,
              919.449,
              19286.968
            ],
            [
              8218.031,
              860.213,
              19376.545
            ],
            [
              8287.693,
              795.361,
              19471.722
            ],
            [
              8311.795,
              774.839,
              19503.378
            ],
            [
              8341.723,
              755.313,
              19539.112
            ],
            [
              8684.194,
              591.462,
              19918.761
            ],
            [
              8696.288,
              583.426,
              19933.282
            ],
            [
              8698.711,
              575.584,
              19941.49
            ],
            [
              8694.685,
              567.872,
              19950.189
            ],
            [
              8692.348,
              547.88,
              19970.317
            ],
            [
              8661.183,
              441.631,
              20081.043
            ],
            [
              8619.341,
              285.498,
              20242.685
            ],
            [
              8586.003,
              199.331,
              20335.076
            ],
            [
              8585.045,
              183.764,
              20350.672
            ],
            [
              8590.333,
              158.052,
              20376.923
            ],
            [
              8621.917,
              92.846,
              20449.375
            ],
            [
              8636.204,
              33.555,
              20510.364
            ],
            [
              8637.068,
              12.385,
              20531.552
            ],
            [
              8604.283,
              -110.532,
              20658.765
            ],
            [
              8595.54,
              -160.454,
              20709.448
            ],
            [
              8696.05,
              -133.53,
              20813.502
            ],
            [
              8718.239,
              -120.617,
              20839.174
            ],
            [
              8744.049,
              -120.024,
              20864.992
            ],
            [
              8789.403,
              -109.804,
              20911.482
            ],
            [
              8826.443,
              -96.078,
              20950.984
            ],
            [
              8853.145,
              -83.257,
              20980.604
            ],
            [
              8900.484,
              -38.566,
              21045.706
            ],
            [
              8997.947,
              60.777,
              21184.875
            ],
            [
              9045.087,
              95.45,
              21243.394
            ],
            [
              9064.009,
              106.201,
              21265.157
            ],
            [
              9090.691,
              117.908,
              21294.294
            ],
            [
              9116.151,
              132.979,
              21323.88
            ],
            [
              9141.918,
              131.345,
              21349.699
            ],
            [
              9732.975,
              142.732,
              21940.866
            ],
            [
              9768.99,
              137.546,
              21977.253
            ],
            [
              9787.111,
              140.517,
              21995.615
            ],
            [
              9775.961,
              226.468,
              22082.287
            ],
            [
              9750.774,
              351.671,
              22209.998
            ],
            [
              9711.942,
              440.412,
              22306.863
            ],
            [
              9660.167,
              527.189,
              22407.912
            ],
            [
              9646.989,
              545.27,
              22430.286
            ],
            [
              9586.931,
              605.495,
              22515.339
            ],
            [
              9548.875,
              637.441,
              22565.025
            ],
            [
              9462.887,
              691.511,
              22666.601
            ],
            [
              9420.067,
              711.306,
              22713.775
            ],
            [
              9384.895,
              726.492,
              22752.085
            ],
            [
              9356.704,
              735.97,
              22781.827
            ],
            [
              9300.852,
              749.348,
              22839.259
            ],
            [
              9244.219,
              756.061,
              22896.288
            ],
            [
              9179.069,
              756.266,
              22961.439
            ],
            [
              9150.142,
              761.304,
              22990.801
            ],
            [
              9052.195,
              766.624,
              23088.892
            ],
            [
              9037.229,
              760.246,
              23105.161
            ],
            [
              9023.688,
              760.52,
              23118.705
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -60,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 332.092,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6024",
              "position": {
                "x": 1319.455,
                "z": 3681.496
              },
              "distanceAlongShapeM": 2991,
              "shapeOffsetM": 0.071,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:16977",
              "position": {
                "x": 1743.856,
                "z": 3803.884
              },
              "distanceAlongShapeM": 3432.757,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:616",
              "position": {
                "x": 2873.526,
                "z": 4357.203
              },
              "distanceAlongShapeM": 4696.937,
              "shapeOffsetM": 0.435,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6121",
              "position": {
                "x": 3917.274,
                "z": 4757.143
              },
              "distanceAlongShapeM": 6248.073,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:617",
              "position": {
                "x": 2822.207,
                "z": 4305.846
              },
              "distanceAlongShapeM": 7432.683,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:16920",
              "position": {
                "x": 3009.186,
                "z": 4156.492
              },
              "distanceAlongShapeM": 7766.733,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:9593",
              "position": {
                "x": 3527.875,
                "z": 3696.935
              },
              "distanceAlongShapeM": 8460.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9600",
              "position": {
                "x": 4116.685,
                "z": 3839.361
              },
              "distanceAlongShapeM": 9261.888,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:16713",
              "position": {
                "x": 4688.859,
                "z": 4020.996
              },
              "distanceAlongShapeM": 9919.763,
              "shapeOffsetM": 0.074,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:16724",
              "position": {
                "x": 4948.434,
                "z": 3656.418
              },
              "distanceAlongShapeM": 10373.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7818",
              "position": {
                "x": 5046.033,
                "z": 3027.77
              },
              "distanceAlongShapeM": 11054.872,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:7712",
              "position": {
                "x": 4671.063,
                "z": 2927.005
              },
              "distanceAlongShapeM": 11443.145,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6687",
              "position": {
                "x": 4169.434,
                "z": 2715.08
              },
              "distanceAlongShapeM": 12074.182,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6691",
              "position": {
                "x": 4467.714,
                "z": 2520.116
              },
              "distanceAlongShapeM": 12448.228,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6694",
              "position": {
                "x": 5035.146,
                "z": 2296.566
              },
              "distanceAlongShapeM": 13076.337,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:18787",
              "position": {
                "x": 5292.838,
                "z": 2208.09
              },
              "distanceAlongShapeM": 13436.092,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:19203",
              "position": {
                "x": 6139.08,
                "z": 2123.718
              },
              "distanceAlongShapeM": 14396.136,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:19208",
              "position": {
                "x": 6188.112,
                "z": 1628.467
              },
              "distanceAlongShapeM": 14894.204,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:19204",
              "position": {
                "x": 6233.848,
                "z": 1328.101
              },
              "distanceAlongShapeM": 15198.669,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:19201",
              "position": {
                "x": 6186.283,
                "z": 2161.76
              },
              "distanceAlongShapeM": 16255.603,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:19206",
              "position": {
                "x": 6713.888,
                "z": 2018.931
              },
              "distanceAlongShapeM": 16997.541,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:19200",
              "position": {
                "x": 7280.06,
                "z": 1576.917
              },
              "distanceAlongShapeM": 17814.036,
              "shapeOffsetM": 0.048,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:18884",
              "position": {
                "x": 7799.733,
                "z": 1494.232
              },
              "distanceAlongShapeM": 18383.884,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:18903",
              "position": {
                "x": 7760.199,
                "z": 1096.464
              },
              "distanceAlongShapeM": 18787.052,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:6035",
              "position": {
                "x": 8692.348,
                "z": 547.88
              },
              "distanceAlongShapeM": 19970.317,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:6040",
              "position": {
                "x": 8718.239,
                "z": -120.617
              },
              "distanceAlongShapeM": 20839.174,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3210,
              "departureOffsetSeconds": 3210
            },
            {
              "stopId": "judu:stop:6042",
              "position": {
                "x": 9116.151,
                "z": 132.979
              },
              "distanceAlongShapeM": 21323.88,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3270,
              "departureOffsetSeconds": 3270
            },
            {
              "stopId": "judu:stop:6044",
              "position": {
                "x": 9552.934,
                "z": 138.6
              },
              "distanceAlongShapeM": 21760.778,
              "shapeOffsetM": 0.663,
              "arrivalOffsetSeconds": 3330,
              "departureOffsetSeconds": 3330
            },
            {
              "stopId": "judu:stop:7444",
              "position": {
                "x": 9732.975,
                "z": 142.732
              },
              "distanceAlongShapeM": 21940.866,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3390,
              "departureOffsetSeconds": 3390
            },
            {
              "stopId": "judu:stop:17007",
              "position": {
                "x": 9681.966,
                "z": 488.893
              },
              "distanceAlongShapeM": 22363.856,
              "shapeOffsetM": 0.902,
              "arrivalOffsetSeconds": 3450,
              "departureOffsetSeconds": 3450
            },
            {
              "stopId": "judu:stop:16454",
              "position": {
                "x": 9179.069,
                "z": 756.266
              },
              "distanceAlongShapeM": 22961.439,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3510,
              "departureOffsetSeconds": 3510
            }
          ],
          "departuresSeconds": [
            19200,
            21600,
            23820,
            26460,
            29100,
            31620,
            34080,
            36720,
            39300,
            42840,
            45480,
            48060,
            51300,
            54000,
            56400,
            58980,
            61680,
            64140,
            66720,
            69300,
            72600,
            75540,
            78360,
            81240
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_122:1",
          "sourceRouteId": "vilnius_bus_122",
          "sourceShapeId": "vilnius_bus_122_b-a",
          "directionId": 1,
          "headsign": "Naujininkai (Apylanka)",
          "directionName": "Naujoji Vilnia–Pavilnys–Guriai–Kalnėnai–Naujininkai (Apylanka)",
          "mode": "bus",
          "routeShortName": "122",
          "routeLongName": "Naujininkai–Kalnėnai–Guriai–Pavilnys–Naujoji Vilnia (Apylanka)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              9023.688,
              760.52,
              0
            ],
            [
              9003.031,
              759.823,
              20.669
            ],
            [
              8997.984,
              765.492,
              28.258
            ],
            [
              8998.097,
              771.056,
              33.823
            ],
            [
              9003.945,
              773.164,
              40.04
            ],
            [
              9172.201,
              767.538,
              208.39
            ],
            [
              9194.013,
              761.53,
              231.014
            ],
            [
              9297.028,
              751.652,
              334.502
            ],
            [
              9354.837,
              739.348,
              393.606
            ],
            [
              9475.025,
              685.698,
              525.225
            ],
            [
              9548.875,
              637.441,
              613.444
            ],
            [
              9650.145,
              541.866,
              752.692
            ],
            [
              9696.796,
              488.592,
              823.505
            ],
            [
              9750.91,
              358.348,
              964.543
            ],
            [
              9760.037,
              331.443,
              992.954
            ],
            [
              9774.016,
              257.68,
              1068.03
            ],
            [
              9785.97,
              179.506,
              1147.113
            ],
            [
              9786.285,
              131.627,
              1194.992
            ],
            [
              9682.346,
              127.063,
              1299.032
            ],
            [
              9621.808,
              131.634,
              1359.742
            ],
            [
              9517.36,
              133.756,
              1464.211
            ],
            [
              9448.882,
              128.466,
              1532.893
            ],
            [
              9389.611,
              131.895,
              1592.263
            ],
            [
              9156.08,
              129.945,
              1825.803
            ],
            [
              9090.691,
              117.908,
              1892.29
            ],
            [
              9073.545,
              99.328,
              1917.572
            ],
            [
              9049.578,
              94.246,
              1942.073
            ],
            [
              8990.008,
              50.917,
              2015.733
            ],
            [
              8869.532,
              -70.228,
              2186.586
            ],
            [
              8853.145,
              -83.257,
              2207.521
            ],
            [
              8819.883,
              -101.512,
              2245.463
            ],
            [
              8767.948,
              -118.279,
              2300.038
            ],
            [
              8695.316,
              -137.969,
              2375.292
            ],
            [
              8673.105,
              -151.995,
              2401.561
            ],
            [
              8624.063,
              -153.235,
              2450.618
            ],
            [
              8595.54,
              -160.454,
              2480.041
            ],
            [
              8604.283,
              -110.532,
              2530.723
            ],
            [
              8637.068,
              12.385,
              2657.937
            ],
            [
              8631.494,
              55.915,
              2701.823
            ],
            [
              8618.16,
              98.488,
              2746.435
            ],
            [
              8587.933,
              167.007,
              2821.325
            ],
            [
              8585.045,
              183.764,
              2838.33
            ],
            [
              8637.514,
              355.27,
              3017.682
            ],
            [
              8660.493,
              439.418,
              3104.911
            ],
            [
              8695.643,
              583.439,
              3253.159
            ],
            [
              8662.337,
              595.242,
              3288.495
            ],
            [
              8638.126,
              610.201,
              3316.955
            ],
            [
              8464.301,
              691.624,
              3508.904
            ],
            [
              8342.301,
              751.962,
              3645.01
            ],
            [
              8316.842,
              769.171,
              3675.74
            ],
            [
              8273.062,
              805.674,
              3732.741
            ],
            [
              8139.983,
              925.232,
              3911.638
            ],
            [
              8108.786,
              945.895,
              3949.058
            ],
            [
              8069.094,
              961.161,
              3991.584
            ],
            [
              8002.896,
              973.616,
              4058.944
            ],
            [
              7745.305,
              1028.85,
              4322.39
            ],
            [
              7744.926,
              1042.217,
              4335.763
            ],
            [
              7748.948,
              1082.215,
              4375.963
            ],
            [
              7748.101,
              1104.498,
              4398.261
            ],
            [
              7752.147,
              1113.323,
              4407.97
            ],
            [
              7763.904,
              1217.738,
              4513.045
            ],
            [
              7796.816,
              1542.162,
              4839.134
            ],
            [
              7665.182,
              1541.442,
              4970.77
            ],
            [
              7625.13,
              1538.898,
              5010.903
            ],
            [
              7556.811,
              1542.482,
              5079.316
            ],
            [
              7314.754,
              1569.55,
              5322.881
            ],
            [
              7312.108,
              1566.262,
              5327.101
            ],
            [
              7303.145,
              1569.78,
              5336.729
            ],
            [
              7234.269,
              1577.823,
              5406.074
            ],
            [
              7216.921,
              1581.506,
              5423.808
            ],
            [
              7230.859,
              1731.523,
              5574.471
            ],
            [
              7175.7,
              1748.2,
              5632.096
            ],
            [
              7153.793,
              1749.747,
              5654.058
            ],
            [
              7083.887,
              1771.168,
              5727.172
            ],
            [
              6999.813,
              1793.98,
              5814.286
            ],
            [
              6990.205,
              1797.51,
              5824.522
            ],
            [
              6962.778,
              1813.637,
              5856.339
            ],
            [
              6934.127,
              1833.128,
              5890.991
            ],
            [
              6850.284,
              1900.464,
              5998.526
            ],
            [
              6697.293,
              2028.163,
              6197.808
            ],
            [
              6685.169,
              2035.081,
              6211.767
            ],
            [
              6643.88,
              2265.228,
              6445.587
            ],
            [
              6518.972,
              2246.529,
              6571.887
            ],
            [
              6502.114,
              2242.407,
              6589.242
            ],
            [
              6487.77,
              2234.896,
              6605.434
            ],
            [
              6326.711,
              2182.39,
              6774.835
            ],
            [
              6133.043,
              2144.988,
              6972.082
            ],
            [
              6139.08,
              2123.718,
              6994.192
            ],
            [
              6153.014,
              1945.322,
              7173.131
            ],
            [
              6183.213,
              1641.922,
              7478.031
            ],
            [
              6231.212,
              1358.211,
              7765.773
            ],
            [
              6232.11,
              1338.155,
              7785.85
            ],
            [
              6230.014,
              1297.005,
              7827.053
            ],
            [
              6228.136,
              1266.983,
              7857.133
            ],
            [
              6225.252,
              1251.454,
              7872.928
            ],
            [
              6211.02,
              1249.506,
              7887.292
            ],
            [
              6209.238,
              1257.334,
              7895.321
            ],
            [
              6219.151,
              1269.386,
              7910.926
            ],
            [
              6223.064,
              1271.536,
              7915.39
            ],
            [
              6226.014,
              1290.404,
              7934.487
            ],
            [
              6229.299,
              1359.362,
              8003.524
            ],
            [
              6177.844,
              1664.292,
              8312.765
            ],
            [
              6131.152,
              2147.252,
              8797.977
            ],
            [
              6096.19,
              2141.256,
              8833.449
            ],
            [
              6041.878,
              2135.637,
              8888.051
            ],
            [
              6021.128,
              2130.475,
              8909.433
            ],
            [
              6016.164,
              2140.592,
              8920.702
            ],
            [
              5994.066,
              2165.515,
              8954.011
            ],
            [
              5901.318,
              2207.402,
              9055.778
            ],
            [
              5845.222,
              2209.608,
              9111.918
            ],
            [
              5804.027,
              2214.864,
              9153.447
            ],
            [
              5767.883,
              2214.454,
              9189.593
            ],
            [
              5564.331,
              2199.486,
              9393.695
            ],
            [
              5535.175,
              2193.373,
              9423.485
            ],
            [
              5306.165,
              2129.904,
              9661.127
            ],
            [
              5295.997,
              2171.291,
              9703.745
            ],
            [
              5290.966,
              2178.068,
              9712.186
            ],
            [
              5290.601,
              2192.548,
              9726.67
            ],
            [
              5241.948,
              2346.007,
              9887.656
            ],
            [
              4977.975,
              2276.518,
              10160.623
            ],
            [
              4915.878,
              2302.207,
              10227.824
            ],
            [
              4657.116,
              2436.326,
              10519.278
            ],
            [
              4613.807,
              2466.102,
              10571.835
            ],
            [
              4521.516,
              2499.046,
              10669.83
            ],
            [
              4409.806,
              2529.019,
              10785.491
            ],
            [
              4354.111,
              2552.351,
              10845.876
            ],
            [
              4310.501,
              2566.545,
              10891.738
            ],
            [
              4270.372,
              2594.031,
              10940.377
            ],
            [
              4200.477,
              2651.031,
              11030.568
            ],
            [
              4185.377,
              2671.358,
              11055.89
            ],
            [
              4171.029,
              2697.237,
              11085.48
            ],
            [
              4139.27,
              2791.357,
              11184.814
            ],
            [
              4163.33,
              2800.917,
              11210.704
            ],
            [
              4290.348,
              2828.546,
              11340.692
            ],
            [
              5090.204,
              3042.503,
              12168.669
            ],
            [
              4969.795,
              3592.55,
              12731.742
            ],
            [
              4957.082,
              3636.213,
              12777.218
            ],
            [
              4925.678,
              3681.348,
              12832.203
            ],
            [
              4849.168,
              3764.09,
              12944.897
            ],
            [
              4819.765,
              3779.128,
              12977.923
            ],
            [
              4705.105,
              3959.455,
              13191.615
            ],
            [
              4660.137,
              4071.644,
              13312.482
            ],
            [
              4128.817,
              3832.45,
              13895.161
            ],
            [
              3964.209,
              3764.342,
              14073.303
            ],
            [
              3925.736,
              3743.923,
              14116.858
            ],
            [
              3679.16,
              3505.925,
              14459.558
            ],
            [
              3424.471,
              3792.407,
              14842.884
            ],
            [
              3347.764,
              3866.221,
              14949.338
            ],
            [
              3289.347,
              3917.422,
              15027.017
            ],
            [
              3181.247,
              4004.071,
              15165.558
            ],
            [
              3069.21,
              4087.452,
              15305.218
            ],
            [
              3026.126,
              4130.568,
              15366.17
            ],
            [
              2995.262,
              4171.226,
              15417.216
            ],
            [
              2976.883,
              4189.384,
              15443.052
            ],
            [
              2942.434,
              4211.185,
              15483.819
            ],
            [
              2862.876,
              4237.173,
              15567.515
            ],
            [
              2800.72,
              4261.72,
              15634.343
            ],
            [
              2770.892,
              4288.999,
              15674.763
            ],
            [
              2389.026,
              4132.511,
              16087.449
            ],
            [
              2135.283,
              4025.927,
              16362.668
            ],
            [
              2047.695,
              3967.445,
              16467.986
            ],
            [
              1944.126,
              3882.541,
              16601.908
            ],
            [
              1902.229,
              3851.037,
              16654.329
            ],
            [
              1851.944,
              3819.688,
              16713.585
            ],
            [
              1756.889,
              3775.811,
              16818.278
            ],
            [
              1645.829,
              3738.909,
              16935.308
            ],
            [
              1602.913,
              3721.893,
              16981.475
            ],
            [
              1516.08,
              3703.463,
              17070.242
            ],
            [
              1224.91,
              3629.806,
              17370.584
            ],
            [
              1029.191,
              3586.658,
              17571.003
            ],
            [
              917.824,
              3567.555,
              17683.997
            ],
            [
              833.864,
              3564.645,
              17768.007
            ],
            [
              784.868,
              3567.771,
              17817.103
            ],
            [
              649.135,
              3592.526,
              17955.074
            ],
            [
              518.202,
              3632.773,
              18092.054
            ],
            [
              399.689,
              3681.696,
              18220.267
            ],
            [
              300.831,
              3711.331,
              18323.472
            ],
            [
              233.202,
              3719.244,
              18391.562
            ],
            [
              170.01,
              3722.623,
              18454.845
            ],
            [
              40.154,
              3716.081,
              18584.865
            ],
            [
              -65.324,
              3665.677,
              18701.768
            ],
            [
              -147.694,
              3608.172,
              18802.225
            ],
            [
              -174.028,
              3579.706,
              18841.004
            ],
            [
              -199.192,
              3544.539,
              18884.246
            ],
            [
              -221.836,
              3505.987,
              18928.956
            ],
            [
              -248.814,
              3477.532,
              18968.167
            ],
            [
              -305.834,
              3429.584,
              19042.668
            ],
            [
              -294.039,
              3332.52,
              19140.446
            ],
            [
              -238.76,
              3035.4,
              19442.664
            ],
            [
              -233.72,
              2993.006,
              19485.357
            ],
            [
              -225.435,
              2951.666,
              19527.518
            ],
            [
              -239.307,
              2898.483,
              19582.481
            ],
            [
              -217.937,
              2902.548,
              19604.234
            ],
            [
              -207.051,
              2897.898,
              19616.072
            ],
            [
              -196.145,
              2858.737,
              19656.723
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:16453",
              "position": {
                "x": 9172.201,
                "z": 767.538
              },
              "distanceAlongShapeM": 208.39,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17009",
              "position": {
                "x": 9696.796,
                "z": 488.592
              },
              "distanceAlongShapeM": 823.505,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6073",
              "position": {
                "x": 9682.346,
                "z": 127.063
              },
              "distanceAlongShapeM": 1299.032,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6045",
              "position": {
                "x": 9448.882,
                "z": 128.466
              },
              "distanceAlongShapeM": 1532.893,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6043",
              "position": {
                "x": 9073.545,
                "z": 99.328
              },
              "distanceAlongShapeM": 1917.572,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6041",
              "position": {
                "x": 8673.105,
                "z": -151.995
              },
              "distanceAlongShapeM": 2401.561,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6034",
              "position": {
                "x": 8662.337,
                "z": 595.242
              },
              "distanceAlongShapeM": 3288.495,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:19076",
              "position": {
                "x": 7748.101,
                "z": 1104.498
              },
              "distanceAlongShapeM": 4398.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:18891",
              "position": {
                "x": 7751.004,
                "z": 1541.96
              },
              "distanceAlongShapeM": 4884.947,
              "shapeOffsetM": 0.05,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:19135",
              "position": {
                "x": 7312.108,
                "z": 1566.262
              },
              "distanceAlongShapeM": 5327.101,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:18938",
              "position": {
                "x": 6681.136,
                "z": 2059.653
              },
              "distanceAlongShapeM": 6236.664,
              "shapeOffsetM": 0.369,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:19203",
              "position": {
                "x": 6139.08,
                "z": 2123.718
              },
              "distanceAlongShapeM": 6994.192,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:18983",
              "position": {
                "x": 6229.125,
                "z": 1350.459
              },
              "distanceAlongShapeM": 7994.623,
              "shapeOffsetM": 0.25,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:19209",
              "position": {
                "x": 6176.772,
                "z": 1675.446
              },
              "distanceAlongShapeM": 8323.97,
              "shapeOffsetM": 0.006,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:19202",
              "position": {
                "x": 6096.19,
                "z": 2141.256
              },
              "distanceAlongShapeM": 8833.449,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6695",
              "position": {
                "x": 5290.966,
                "z": 2178.068
              },
              "distanceAlongShapeM": 9712.186,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6693",
              "position": {
                "x": 4915.878,
                "z": 2302.207
              },
              "distanceAlongShapeM": 10227.824,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6690",
              "position": {
                "x": 4409.806,
                "z": 2529.019
              },
              "distanceAlongShapeM": 10785.491,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7710",
              "position": {
                "x": 4207.39,
                "z": 2810.094
              },
              "distanceAlongShapeM": 11255.707,
              "shapeOffsetM": 0.397,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7711",
              "position": {
                "x": 4689.298,
                "z": 2935.561
              },
              "distanceAlongShapeM": 11753.746,
              "shapeOffsetM": 0.288,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:7819",
              "position": {
                "x": 5061.022,
                "z": 3035.273
              },
              "distanceAlongShapeM": 12138.61,
              "shapeOffsetM": 0.557,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:16725",
              "position": {
                "x": 4925.678,
                "z": 3681.348
              },
              "distanceAlongShapeM": 12832.203,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:16715",
              "position": {
                "x": 4705.105,
                "z": 3959.455
              },
              "distanceAlongShapeM": 13191.615,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:9599",
              "position": {
                "x": 4128.817,
                "z": 3832.45
              },
              "distanceAlongShapeM": 13895.161,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:9659",
              "position": {
                "x": 3502.858,
                "z": 3705.202
              },
              "distanceAlongShapeM": 14725.628,
              "shapeOffsetM": 0.643,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:10614",
              "position": {
                "x": 3069.21,
                "z": 4087.452
              },
              "distanceAlongShapeM": 15305.218,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:16978",
              "position": {
                "x": 1602.913,
                "z": 3721.893
              },
              "distanceAlongShapeM": 16981.475,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 19527.518,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 19656.723,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            }
          ],
          "departuresSeconds": [
            23040,
            25740,
            28200,
            30660,
            33360,
            36000,
            39420,
            42060,
            44700,
            47340,
            49980,
            52620,
            55560,
            58200,
            60660,
            63240,
            65940,
            69120,
            72180,
            75060,
            77940,
            80400,
            82380,
            84840
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_123",
      "sourceRouteId": "vilnius_bus_123",
      "mode": "bus",
      "shortName": "123",
      "longName": "Žemieji Paneriai (Vaduvos g.) – Centras (Lukiškių g.)",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_123:0",
          "sourceRouteId": "vilnius_bus_123",
          "sourceShapeId": "vilnius_bus_123_a-b",
          "directionId": 0,
          "headsign": "Centras (Lukiškių g.)",
          "directionName": "Žemieji Paneriai (Vaduvos g.) – Centras (Lukiškių g.)",
          "mode": "bus",
          "routeShortName": "123",
          "routeLongName": "Žemieji Paneriai (Vaduvos g.) – Centras (Lukiškių g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4679.19,
              5603.961,
              0
            ],
            [
              -4686.726,
              5616.335,
              14.489
            ],
            [
              -4731.683,
              5630.464,
              61.613
            ],
            [
              -4761.281,
              5636.537,
              91.827
            ],
            [
              -4772.178,
              5641.176,
              103.671
            ],
            [
              -4792.834,
              5641.529,
              124.33
            ],
            [
              -4797.181,
              5651.623,
              135.32
            ],
            [
              -4795.814,
              5656.052,
              139.955
            ],
            [
              -4793.175,
              5659.346,
              144.177
            ],
            [
              -4786.036,
              5661.451,
              151.619
            ],
            [
              -4778.974,
              5659.103,
              159.061
            ],
            [
              -4772.709,
              5647.864,
              171.928
            ],
            [
              -4754.161,
              5637.528,
              193.162
            ],
            [
              -4684.125,
              5617.404,
              266.032
            ],
            [
              -4663.072,
              5602.571,
              291.786
            ],
            [
              -4640.177,
              5582.141,
              322.47
            ],
            [
              -4596.898,
              5507.928,
              408.381
            ],
            [
              -4573.874,
              5457.44,
              463.872
            ],
            [
              -4564.139,
              5422.764,
              499.888
            ],
            [
              -4560.164,
              5315.829,
              606.897
            ],
            [
              -4579.295,
              5179.234,
              744.825
            ],
            [
              -4580.889,
              5011.17,
              912.897
            ],
            [
              -4517.509,
              4980.025,
              983.516
            ],
            [
              -4503.635,
              4960.862,
              1007.174
            ],
            [
              -4444.377,
              4915.316,
              1081.913
            ],
            [
              -4189.698,
              4671.592,
              1434.422
            ],
            [
              -4166.695,
              4657.837,
              1461.224
            ],
            [
              -4146.524,
              4629.659,
              1495.878
            ],
            [
              -4048.773,
              4533.349,
              1633.103
            ],
            [
              -3823.59,
              4303.471,
              1954.896
            ],
            [
              -3802.623,
              4284.184,
              1983.386
            ],
            [
              -3780.952,
              4268.223,
              2010.3
            ],
            [
              -3768.394,
              4247.967,
              2034.133
            ],
            [
              -3367.467,
              3844.694,
              2602.79
            ],
            [
              -3344.49,
              3829.822,
              2630.16
            ],
            [
              -3315.43,
              3793.692,
              2676.526
            ],
            [
              -3282.402,
              3763.059,
              2721.574
            ],
            [
              -3142.94,
              3618.132,
              2922.704
            ],
            [
              -2996.449,
              3469.738,
              3131.224
            ],
            [
              -2905.063,
              3381.305,
              3258.392
            ],
            [
              -2851.864,
              3323.598,
              3336.879
            ],
            [
              -2827.523,
              3276.416,
              3389.97
            ],
            [
              -2808.656,
              3248.254,
              3423.867
            ],
            [
              -2806.545,
              3221.5,
              3450.705
            ],
            [
              -2772.86,
              3118.493,
              3559.08
            ],
            [
              -2707,
              2936.995,
              3752.157
            ],
            [
              -2660.341,
              2801.476,
              3895.484
            ],
            [
              -2637.179,
              2724.257,
              3976.102
            ],
            [
              -2612.218,
              2675.949,
              4030.477
            ],
            [
              -2598.361,
              2620.045,
              4088.074
            ],
            [
              -2580.479,
              2536.239,
              4173.766
            ],
            [
              -2576.299,
              2480.505,
              4229.657
            ],
            [
              -2568.347,
              2419.138,
              4291.537
            ],
            [
              -2530.947,
              2234.799,
              4479.632
            ],
            [
              -2533.314,
              2210.35,
              4504.195
            ],
            [
              -2548.095,
              2140.478,
              4575.613
            ],
            [
              -2550.229,
              2092.648,
              4623.491
            ],
            [
              -2549.196,
              2041.422,
              4674.727
            ],
            [
              -2537.883,
              1987.788,
              4729.541
            ],
            [
              -2509.509,
              1913.816,
              4808.769
            ],
            [
              -2480.295,
              1850.96,
              4878.081
            ],
            [
              -2442.052,
              1787.945,
              4951.793
            ],
            [
              -2399.099,
              1735.979,
              5019.213
            ],
            [
              -2337.094,
              1666.977,
              5111.981
            ],
            [
              -2295.02,
              1638.403,
              5162.841
            ],
            [
              -2031.979,
              1337.627,
              5562.412
            ],
            [
              -1983.792,
              1217.657,
              5691.697
            ],
            [
              -1971.707,
              1062.705,
              5847.12
            ],
            [
              -1865.262,
              736.867,
              6189.904
            ],
            [
              -1847.196,
              700.922,
              6230.133
            ],
            [
              -1784.083,
              622.987,
              6330.419
            ],
            [
              -1786.057,
              620.796,
              6333.368
            ],
            [
              -1777.149,
              613.958,
              6344.598
            ],
            [
              -1716.29,
              590.609,
              6409.782
            ],
            [
              -1583.117,
              571.535,
              6544.315
            ],
            [
              -1473.801,
              552.884,
              6655.21
            ],
            [
              -1382.194,
              517.849,
              6753.288
            ],
            [
              -1304.906,
              439.653,
              6863.234
            ],
            [
              -1304.242,
              440.754,
              6864.52
            ],
            [
              -1268.912,
              396.705,
              6920.986
            ],
            [
              -1250.068,
              368.537,
              6954.877
            ],
            [
              -1227.675,
              322.493,
              7006.077
            ],
            [
              -1219.127,
              295.623,
              7034.275
            ],
            [
              -1215.153,
              265.494,
              7064.664
            ],
            [
              -1194.224,
              173.835,
              7158.683
            ],
            [
              -1189.802,
              -11.04,
              7343.61
            ],
            [
              -1173.311,
              -206.15,
              7539.416
            ],
            [
              -1150.937,
              -288.931,
              7625.167
            ],
            [
              -1145.948,
              -370.286,
              7706.675
            ],
            [
              -1128.552,
              -442.958,
              7781.4
            ],
            [
              -1103.501,
              -520.22,
              7862.622
            ],
            [
              -1089.839,
              -549.409,
              7894.85
            ],
            [
              -1080.43,
              -564.05,
              7912.254
            ],
            [
              -1026.313,
              -638.496,
              8004.291
            ],
            [
              -986.543,
              -685.967,
              8066.22
            ],
            [
              -964.927,
              -703.054,
              8093.774
            ],
            [
              -944.499,
              -714.554,
              8117.216
            ],
            [
              -887.35,
              -727.829,
              8175.887
            ],
            [
              -849.963,
              -728.502,
              8213.28
            ],
            [
              -795.111,
              -726.152,
              8268.182
            ],
            [
              -764.735,
              -722.247,
              8298.808
            ],
            [
              -725.717,
              -704.026,
              8341.871
            ],
            [
              -702.814,
              -685.514,
              8371.32
            ],
            [
              -692.924,
              -673.447,
              8386.922
            ],
            [
              -655.859,
              -656.305,
              8427.758
            ],
            [
              -601.451,
              -607.193,
              8501.054
            ],
            [
              -500.911,
              -503.255,
              8645.662
            ],
            [
              -413.017,
              -421.354,
              8765.8
            ],
            [
              -305.298,
              -348.72,
              8895.72
            ],
            [
              -335.653,
              -209.016,
              9038.684
            ],
            [
              -372.48,
              -212.801,
              9075.705
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17506",
              "position": {
                "x": -4640.177,
                "z": 5582.141
              },
              "distanceAlongShapeM": 322.47,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:17507",
              "position": {
                "x": -4560.164,
                "z": 5315.829
              },
              "distanceAlongShapeM": 606.897,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 983.516,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 1461.224,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 2010.3,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 2630.16,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 3423.867,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 4030.477,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7359",
              "position": {
                "x": -2530.947,
                "z": 2234.799
              },
              "distanceAlongShapeM": 4479.632,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5780",
              "position": {
                "x": -2295.02,
                "z": 1638.403
              },
              "distanceAlongShapeM": 5162.841,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:16772",
              "position": {
                "x": -1194.224,
                "z": 173.835
              },
              "distanceAlongShapeM": 7158.683,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9007",
              "position": {
                "x": -1150.937,
                "z": -288.931
              },
              "distanceAlongShapeM": 7625.167,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5539",
              "position": {
                "x": -692.924,
                "z": -673.447
              },
              "distanceAlongShapeM": 8386.922,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7663",
              "position": {
                "x": -372.48,
                "z": -212.801
              },
              "distanceAlongShapeM": 9075.705,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            }
          ],
          "departuresSeconds": [
            19800,
            21600,
            23580,
            25560,
            27540,
            29520,
            31500,
            33660,
            36540,
            38700,
            40740,
            42660,
            44580,
            46500,
            48420,
            50340,
            52260,
            54360,
            56460,
            58620,
            60600,
            62700,
            64860,
            67020,
            69240,
            72000,
            74220,
            76320,
            78120,
            79920,
            81720,
            83520
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_123:1",
          "sourceRouteId": "vilnius_bus_123",
          "sourceShapeId": "vilnius_bus_123_b-a",
          "directionId": 1,
          "headsign": "Žemieji Paneriai (Vaduvos g.)",
          "directionName": "Centras (Lukiškių g.) – Žemieji Paneriai (Vaduvos g.)",
          "mode": "bus",
          "routeShortName": "123",
          "routeLongName": "Žemieji Paneriai (Vaduvos g.) – Centras (Lukiškių g.)",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -372.48,
              -212.801,
              0
            ],
            [
              -418.232,
              -210.859,
              45.793
            ],
            [
              -451.474,
              -230.295,
              84.3
            ],
            [
              -476.052,
              -269.926,
              130.934
            ],
            [
              -501.093,
              -299.53,
              169.708
            ],
            [
              -510.139,
              -300.48,
              178.803
            ],
            [
              -513.322,
              -298.196,
              182.721
            ],
            [
              -611.52,
              -58.189,
              442.039
            ],
            [
              -615.308,
              -53.668,
              447.938
            ],
            [
              -625.745,
              -24.535,
              478.883
            ],
            [
              -646.921,
              17.037,
              525.538
            ],
            [
              -658.953,
              100.746,
              610.108
            ],
            [
              -724.996,
              86.353,
              677.701
            ],
            [
              -736.157,
              75.422,
              693.323
            ],
            [
              -743.833,
              78.9,
              701.751
            ],
            [
              -798.875,
              66.534,
              758.165
            ],
            [
              -863.023,
              49.879,
              824.439
            ],
            [
              -870.86,
              44.454,
              833.971
            ],
            [
              -894.129,
              41.533,
              857.423
            ],
            [
              -1188.147,
              -26.655,
              1159.244
            ],
            [
              -1194.241,
              29.116,
              1215.347
            ],
            [
              -1202.035,
              133.899,
              1320.419
            ],
            [
              -1211.213,
              197.517,
              1384.696
            ],
            [
              -1221.169,
              217.734,
              1407.232
            ],
            [
              -1216.908,
              275.545,
              1465.2
            ],
            [
              -1295.108,
              410.533,
              1621.204
            ],
            [
              -1421.18,
              501.848,
              1776.871
            ],
            [
              -1665.104,
              567.432,
              2029.458
            ],
            [
              -1779.282,
              602.863,
              2149.007
            ],
            [
              -1835.797,
              652.851,
              2224.457
            ],
            [
              -1892.692,
              754.053,
              2340.556
            ],
            [
              -2014.022,
              1222.647,
              2824.603
            ],
            [
              -2055.531,
              1319.12,
              2929.627
            ],
            [
              -2069.692,
              1357.221,
              2970.274
            ],
            [
              -2131.9,
              1450.721,
              3082.578
            ],
            [
              -2187.002,
              1508.471,
              3162.398
            ],
            [
              -2364.512,
              1685.273,
              3412.935
            ],
            [
              -2405.647,
              1730.529,
              3474.092
            ],
            [
              -2432.322,
              1754.377,
              3509.874
            ],
            [
              -2457.669,
              1780.429,
              3546.221
            ],
            [
              -2470.84,
              1801.812,
              3571.335
            ],
            [
              -2517.308,
              1910.614,
              3689.644
            ],
            [
              -2537.025,
              1963.282,
              3745.883
            ],
            [
              -2549.238,
              2002.46,
              3786.92
            ],
            [
              -2554.454,
              2035.948,
              3820.812
            ],
            [
              -2559.337,
              2088.355,
              3873.446
            ],
            [
              -2553.059,
              2151.698,
              3937.099
            ],
            [
              -2551.884,
              2181.734,
              3967.158
            ],
            [
              -2553.368,
              2207.364,
              3992.831
            ],
            [
              -2550.57,
              2256.296,
              4041.843
            ],
            [
              -2554.497,
              2289.761,
              4075.538
            ],
            [
              -2570.814,
              2352.389,
              4140.256
            ],
            [
              -2586.213,
              2430.585,
              4219.954
            ],
            [
              -2602.898,
              2582.275,
              4372.56
            ],
            [
              -2619.569,
              2661.607,
              4453.624
            ],
            [
              -2672.012,
              2798.342,
              4600.071
            ],
            [
              -2693.846,
              2841.028,
              4648.017
            ],
            [
              -2698.439,
              2873.392,
              4680.705
            ],
            [
              -2831.804,
              3253.114,
              5083.166
            ],
            [
              -2853.662,
              3294.686,
              5130.135
            ],
            [
              -2870.652,
              3319.475,
              5160.187
            ],
            [
              -2888.502,
              3332.034,
              5182.012
            ],
            [
              -2904.222,
              3355.687,
              5210.413
            ],
            [
              -3126.24,
              3576.651,
              5523.65
            ],
            [
              -3256.351,
              3702.491,
              5704.66
            ],
            [
              -3334.924,
              3786.24,
              5819.496
            ],
            [
              -3406.008,
              3855.385,
              5918.663
            ],
            [
              -3427.01,
              3872.449,
              5945.723
            ],
            [
              -3454.8,
              3907.442,
              5990.409
            ],
            [
              -3626.746,
              4078.528,
              6232.969
            ],
            [
              -3781.512,
              4235.95,
              6453.728
            ],
            [
              -3884.317,
              4337.92,
              6598.527
            ],
            [
              -3915.514,
              4362.95,
              6638.524
            ],
            [
              -3928.112,
              4380.98,
              6660.519
            ],
            [
              -4226.292,
              4683.356,
              7085.186
            ],
            [
              -4305.622,
              4762.647,
              7197.348
            ],
            [
              -4338.114,
              4787.696,
              7238.376
            ],
            [
              -4349.425,
              4805.702,
              7259.639
            ],
            [
              -4420.502,
              4877.057,
              7360.354
            ],
            [
              -4439.501,
              4898.534,
              7389.029
            ],
            [
              -4461.157,
              4915.604,
              7416.604
            ],
            [
              -4476.532,
              4922.548,
              7433.474
            ],
            [
              -4488.111,
              4924.973,
              7445.304
            ],
            [
              -4508.363,
              4948.698,
              7476.497
            ],
            [
              -4600.366,
              5004.825,
              7584.269
            ],
            [
              -4658.205,
              5020.288,
              7644.14
            ],
            [
              -4736.87,
              5026.089,
              7723.018
            ],
            [
              -4780.873,
              5020.164,
              7767.418
            ],
            [
              -4794.293,
              5028.186,
              7783.053
            ],
            [
              -4887.841,
              5032.012,
              7876.679
            ],
            [
              -4834.705,
              5081.197,
              7949.085
            ],
            [
              -4785.441,
              5130.448,
              8018.745
            ],
            [
              -4754.629,
              5157.75,
              8059.913
            ],
            [
              -4724.691,
              5171.709,
              8092.945
            ],
            [
              -4669.05,
              5178.548,
              8149.005
            ],
            [
              -4623.964,
              5172.209,
              8194.534
            ],
            [
              -4586.132,
              5157.088,
              8235.277
            ],
            [
              -4572.818,
              5218.085,
              8297.71
            ],
            [
              -4570.174,
              5259.228,
              8338.937
            ],
            [
              -4570.105,
              5376.112,
              8455.821
            ],
            [
              -4563.99,
              5393.818,
              8474.554
            ],
            [
              -4571.029,
              5435.127,
              8516.458
            ],
            [
              -4575.223,
              5454.123,
              8535.912
            ],
            [
              -4590.806,
              5486.673,
              8572
            ],
            [
              -4645.968,
              5583.354,
              8683.31
            ],
            [
              -4661.838,
              5599.211,
              8705.744
            ],
            [
              -4679.19,
              5603.961,
              8723.735
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6356",
              "position": {
                "x": -476.052,
                "z": -269.926
              },
              "distanceAlongShapeM": 130.934,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 525.538,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5936",
              "position": {
                "x": -736.157,
                "z": 75.422
              },
              "distanceAlongShapeM": 693.323,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:19193",
              "position": {
                "x": -870.86,
                "z": 44.454
              },
              "distanceAlongShapeM": 833.971,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:16773",
              "position": {
                "x": -1221.169,
                "z": 217.734
              },
              "distanceAlongShapeM": 1407.232,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5778",
              "position": {
                "x": -2055.531,
                "z": 1319.12
              },
              "distanceAlongShapeM": 2929.627,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5779",
              "position": {
                "x": -2457.669,
                "z": 1780.429
              },
              "distanceAlongShapeM": 3546.221,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7358",
              "position": {
                "x": -2553.368,
                "z": 2207.364
              },
              "distanceAlongShapeM": 3992.831,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 4648.017,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 5182.012,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 5945.723,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 6638.524,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1050,
              "departureOffsetSeconds": 1050
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 7238.376,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 7445.304,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5557",
              "position": {
                "x": -4780.873,
                "z": 5020.164
              },
              "distanceAlongShapeM": 7767.418,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 8149.005,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:17504",
              "position": {
                "x": -4570.105,
                "z": 5376.112
              },
              "distanceAlongShapeM": 8455.821,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:17505",
              "position": {
                "x": -4679.19,
                "z": 5603.961
              },
              "distanceAlongShapeM": 8723.735,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            }
          ],
          "departuresSeconds": [
            21360,
            23220,
            25200,
            27180,
            29280,
            31200,
            33180,
            35340,
            38220,
            40380,
            42240,
            44340,
            46260,
            48120,
            50040,
            51900,
            54240,
            56400,
            58140,
            60360,
            62520,
            64680,
            66600,
            68700,
            70860,
            73560,
            75720,
            77820,
            79620,
            81420,
            83220,
            85080
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_bus_125",
      "sourceRouteId": "vilnius_bus_125",
      "mode": "bus",
      "shortName": "125",
      "longName": "Gabijos progimnazija–Visorių g.–Bajorai– Visoriai",
      "color": "0073AC",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_bus_125:0",
          "sourceRouteId": "vilnius_bus_125",
          "sourceShapeId": "vilnius_bus_125_a-b",
          "directionId": 0,
          "headsign": "Visoriai",
          "directionName": "Gabijos progimnazija–Visorių g.–Bajorai– Visoriai",
          "mode": "bus",
          "routeShortName": "125",
          "routeLongName": "Gabijos progimnazija–Visorių g.–Bajorai– Visoriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3249.554,
              -5198.873,
              0
            ],
            [
              -3237.885,
              -5231.361,
              34.52
            ],
            [
              -3198.857,
              -5246.517,
              76.388
            ],
            [
              -3170.932,
              -5270.384,
              113.122
            ],
            [
              -3134.11,
              -5337.823,
              189.959
            ],
            [
              -3125.934,
              -5349.099,
              203.887
            ],
            [
              -3113.758,
              -5352.652,
              216.571
            ],
            [
              -3083.903,
              -5376.554,
              254.815
            ],
            [
              -3052.839,
              -5404.93,
              296.889
            ],
            [
              -3047.2,
              -5413.934,
              307.513
            ],
            [
              -3034.691,
              -5398.569,
              327.326
            ],
            [
              -3033.871,
              -5388.564,
              337.364
            ],
            [
              -2977.67,
              -5306.06,
              437.192
            ],
            [
              -2859.092,
              -5120.012,
              657.816
            ],
            [
              -2789.239,
              -4994.334,
              801.601
            ],
            [
              -2739.468,
              -4911.72,
              898.049
            ],
            [
              -2672.209,
              -4823.848,
              1008.708
            ],
            [
              -2619.375,
              -4786.931,
              1073.161
            ],
            [
              -2578.679,
              -4744.234,
              1132.146
            ],
            [
              -2554.472,
              -4686.774,
              1194.497
            ],
            [
              -2488.392,
              -4702.414,
              1262.403
            ],
            [
              -2436.56,
              -4722.255,
              1317.903
            ],
            [
              -2367.109,
              -4765.787,
              1399.869
            ],
            [
              -2297.39,
              -4830.477,
              1494.976
            ],
            [
              -2247.29,
              -4911.517,
              1590.252
            ],
            [
              -2236.559,
              -4923.953,
              1606.678
            ],
            [
              -2217.405,
              -4969.935,
              1656.49
            ],
            [
              -2110.315,
              -5178.897,
              1891.295
            ],
            [
              -2058.363,
              -5155.329,
              1948.343
            ],
            [
              -2028.76,
              -5156.969,
              1977.992
            ],
            [
              -1894.496,
              -5141.548,
              2113.138
            ],
            [
              -1856.383,
              -5135.547,
              2151.721
            ],
            [
              -1800.644,
              -5116.503,
              2210.623
            ],
            [
              -1770.723,
              -5100.339,
              2244.631
            ],
            [
              -1738.711,
              -5075.306,
              2285.269
            ],
            [
              -1710.503,
              -5046.865,
              2325.326
            ],
            [
              -1676.24,
              -5004.061,
              2380.154
            ],
            [
              -1625.643,
              -5020.551,
              2433.37
            ],
            [
              -1586.957,
              -5054.639,
              2484.932
            ],
            [
              -1465.895,
              -5129.166,
              2627.095
            ],
            [
              -1407.208,
              -5161.388,
              2694.046
            ],
            [
              -1338.038,
              -5183.78,
              2766.75
            ],
            [
              -1271.325,
              -5199.449,
              2835.278
            ],
            [
              -1183.862,
              -5243.323,
              2933.129
            ],
            [
              -1239.325,
              -5390.387,
              3090.304
            ],
            [
              -1248.276,
              -5422.51,
              3123.65
            ],
            [
              -1253.867,
              -5446.901,
              3148.674
            ],
            [
              -1254.947,
              -5506.996,
              3208.779
            ],
            [
              -1340.908,
              -5523.264,
              3296.266
            ],
            [
              -1444.089,
              -5565.944,
              3407.925
            ],
            [
              -1495.217,
              -5579.5,
              3460.82
            ],
            [
              -1670.871,
              -5640.925,
              3646.904
            ],
            [
              -1700.749,
              -5654.863,
              3679.873
            ],
            [
              -1745.15,
              -5688.581,
              3735.626
            ],
            [
              -1794.861,
              -5731.109,
              3801.046
            ],
            [
              -1819.161,
              -5757.393,
              3836.842
            ],
            [
              -1834.625,
              -5793.854,
              3876.447
            ],
            [
              -1866.226,
              -5832.254,
              3926.177
            ],
            [
              -1886.236,
              -5870.86,
              3969.662
            ],
            [
              -1910.032,
              -5977.306,
              4078.735
            ],
            [
              -1912.222,
              -6064.099,
              4165.555
            ],
            [
              -1905.973,
              -6110.966,
              4212.837
            ],
            [
              -1872.982,
              -6247.368,
              4353.172
            ],
            [
              -1854.277,
              -6390.195,
              4497.219
            ],
            [
              -1844.77,
              -6434.894,
              4542.918
            ],
            [
              -1843.78,
              -6451.61,
              4559.663
            ],
            [
              -1847.198,
              -6462.682,
              4571.25
            ],
            [
              -1853.15,
              -6471.481,
              4581.874
            ],
            [
              -1878.981,
              -6475.474,
              4608.011
            ],
            [
              -1982.769,
              -6481.417,
              4711.969
            ],
            [
              -2132.245,
              -6485.438,
              4861.5
            ],
            [
              -2163.266,
              -6491.566,
              4893.119
            ],
            [
              -2268.229,
              -6527.552,
              5004.081
            ],
            [
              -2245.232,
              -6719.436,
              5197.338
            ],
            [
              -2244.952,
              -6776.215,
              5254.118
            ],
            [
              -2253.317,
              -6848.427,
              5326.812
            ],
            [
              -2252.91,
              -6861.793,
              5340.184
            ],
            [
              -2228.705,
              -6876.694,
              5368.609
            ],
            [
              -2110.952,
              -6917.749,
              5493.313
            ],
            [
              -2031.2,
              -6959.244,
              5583.215
            ],
            [
              -1963.72,
              -7002.749,
              5663.503
            ],
            [
              -1937.041,
              -7023.262,
              5697.157
            ],
            [
              -1903.786,
              -7036.1,
              5732.803
            ],
            [
              -1819.254,
              -7062.099,
              5821.243
            ],
            [
              -1672.218,
              -7121.5,
              5979.825
            ],
            [
              -1671.07,
              -7129.314,
              5987.722
            ],
            [
              -1691.867,
              -7140.074,
              6011.138
            ],
            [
              -1721.231,
              -7161.814,
              6047.673
            ],
            [
              -1758.211,
              -7213.475,
              6111.207
            ],
            [
              -1780.772,
              -7250.922,
              6154.925
            ],
            [
              -1795.815,
              -7264.013,
              6174.866
            ],
            [
              -1813.976,
              -7271.481,
              6194.503
            ],
            [
              -1905.151,
              -7293.233,
              6288.236
            ],
            [
              -1927.838,
              -7301.734,
              6312.464
            ],
            [
              -1952.594,
              -7317.992,
              6342.081
            ],
            [
              -2033.201,
              -7361.085,
              6433.484
            ],
            [
              -2179.338,
              -7468.697,
              6614.967
            ],
            [
              -2371.269,
              -7508.706,
              6811.024
            ],
            [
              -2672.284,
              -7564.608,
              7117.186
            ],
            [
              -2720.772,
              -7575.998,
              7166.994
            ],
            [
              -2749.794,
              -7578.826,
              7196.154
            ],
            [
              -2757.498,
              -7577.576,
              7203.958
            ],
            [
              -2765.787,
              -7572.977,
              7213.437
            ],
            [
              -2768.554,
              -7547.324,
              7239.239
            ],
            [
              -2776.371,
              -7516.016,
              7271.508
            ],
            [
              -2831.651,
              -7364.756,
              7432.553
            ],
            [
              -2960.012,
              -7378.081,
              7561.605
            ],
            [
              -3037.466,
              -7388.964,
              7639.819
            ],
            [
              -3196.78,
              -7405.092,
              7799.948
            ],
            [
              -3243.181,
              -7407.617,
              7846.418
            ],
            [
              -3247.121,
              -7412.001,
              7852.312
            ],
            [
              -3244.879,
              -7614.647,
              8054.97
            ],
            [
              -3249.912,
              -7644.616,
              8085.359
            ],
            [
              -3240.979,
              -7649.226,
              8095.41
            ],
            [
              -3135.153,
              -7635.497,
              8202.123
            ],
            [
              -3078.28,
              -7623.138,
              8260.324
            ],
            [
              -2956.692,
              -7591.879,
              8385.866
            ],
            [
              -2909.025,
              -7590.491,
              8433.553
            ],
            [
              -2880.14,
              -7595.453,
              8462.861
            ],
            [
              -2802.026,
              -7583.471,
              8541.888
            ],
            [
              -2725.784,
              -7568.117,
              8619.661
            ],
            [
              -2672.284,
              -7564.608,
              8673.276
            ],
            [
              -2424.106,
              -7511.11,
              8927.154
            ],
            [
              -2200.558,
              -7467.206,
              9154.973
            ],
            [
              -1983.025,
              -7327.469,
              9413.521
            ],
            [
              -1921.302,
              -7296.285,
              9482.675
            ],
            [
              -1857.241,
              -7278.502,
              9549.158
            ],
            [
              -1808.787,
              -7269.347,
              9598.469
            ],
            [
              -1791.249,
              -7260.755,
              9617.999
            ],
            [
              -1762.836,
              -7220.072,
              9667.621
            ],
            [
              -1726.38,
              -7161.722,
              9736.423
            ],
            [
              -1713.891,
              -7147.473,
              9755.371
            ],
            [
              -1706.433,
              -7126.455,
              9777.673
            ],
            [
              -1690.122,
              -7114.501,
              9797.895
            ],
            [
              -1672.882,
              -7122.602,
              9816.944
            ],
            [
              -1630.537,
              -7131.152,
              9860.143
            ],
            [
              -1593.243,
              -7134.045,
              9897.549
            ],
            [
              -1568.683,
              -7128.919,
              9922.639
            ],
            [
              -1548.788,
              -7132.615,
              9942.874
            ],
            [
              -1518.794,
              -7147.624,
              9976.414
            ],
            [
              -1410.181,
              -7230.837,
              10113.239
            ],
            [
              -1380.891,
              -7249.174,
              10147.796
            ],
            [
              -1311.07,
              -7269.352,
              10220.474
            ],
            [
              -1233.406,
              -7282.993,
              10299.327
            ],
            [
              -1124.102,
              -7291.639,
              10408.972
            ],
            [
              -1082.888,
              -7291.268,
              10450.188
            ],
            [
              -1077.698,
              -7289.135,
              10455.799
            ],
            [
              -1076.694,
              -7269.115,
              10475.844
            ],
            [
              -1062.473,
              -7266.031,
              10490.396
            ],
            [
              -1045.114,
              -7267.457,
              10507.813
            ],
            [
              -1002.208,
              -7280.476,
              10552.65
            ],
            [
              -979.66,
              -7279.769,
              10575.21
            ],
            [
              -935.71,
              -7270.543,
              10620.118
            ],
            [
              -707.406,
              -7214.553,
              10855.187
            ],
            [
              -684.153,
              -7210.52,
              10878.787
            ],
            [
              -633.285,
              -7281.575,
              10966.174
            ],
            [
              -627.895,
              -7303.938,
              10989.177
            ],
            [
              -546.04,
              -7512.484,
              11213.212
            ],
            [
              -517.868,
              -7627.659,
              11331.782
            ],
            [
              -515.818,
              -7656.64,
              11360.836
            ],
            [
              -519.805,
              -7734.495,
              11438.792
            ],
            [
              -528.192,
              -7735.456,
              11447.234
            ],
            [
              -535.151,
              -7728.65,
              11456.968
            ],
            [
              -543.255,
              -7714.031,
              11473.683
            ],
            [
              -546.272,
              -7702.844,
              11485.27
            ],
            [
              -547.174,
              -7646.052,
              11542.069
            ],
            [
              -637.863,
              -7641.069,
              11632.895
            ],
            [
              -661.758,
              -7645.09,
              11657.126
            ],
            [
              -677.044,
              -7635.907,
              11674.957
            ],
            [
              -928.758,
              -7670.321,
              11929.014
            ],
            [
              -968.501,
              -7696.322,
              11976.506
            ],
            [
              -995.773,
              -7709.189,
              12006.661
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:795",
              "position": {
                "x": -3249.554,
                "z": -5198.873
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7809",
              "position": {
                "x": -3033.871,
                "z": -5388.564
              },
              "distanceAlongShapeM": 337.364,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5518",
              "position": {
                "x": -2739.468,
                "z": -4911.72
              },
              "distanceAlongShapeM": 898.049,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6911",
              "position": {
                "x": -2236.559,
                "z": -4923.953
              },
              "distanceAlongShapeM": 1606.678,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6913",
              "position": {
                "x": -2058.363,
                "z": -5155.329
              },
              "distanceAlongShapeM": 1948.343,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5810",
              "position": {
                "x": -1625.643,
                "z": -5020.551
              },
              "distanceAlongShapeM": 2433.37,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5815",
              "position": {
                "x": -1271.325,
                "z": -5199.449
              },
              "distanceAlongShapeM": 2835.278,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:17872",
              "position": {
                "x": -1444.089,
                "z": -5565.944
              },
              "distanceAlongShapeM": 3407.925,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:17863",
              "position": {
                "x": -1834.625,
                "z": -5793.854
              },
              "distanceAlongShapeM": 3876.447,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17866",
              "position": {
                "x": -1872.982,
                "z": -6247.368
              },
              "distanceAlongShapeM": 4353.172,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:17869",
              "position": {
                "x": -2264.276,
                "z": -6558.793
              },
              "distanceAlongShapeM": 5035.57,
              "shapeOffsetM": 0.208,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:9693",
              "position": {
                "x": -1952.594,
                "z": -7317.992
              },
              "distanceAlongShapeM": 6342.081,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:9970",
              "position": {
                "x": -2371.269,
                "z": -7508.706
              },
              "distanceAlongShapeM": 6811.024,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:9496",
              "position": {
                "x": -2768.73,
                "z": -7557.34
              },
              "distanceAlongShapeM": 7229.3,
              "shapeOffsetM": 1.25,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:9815",
              "position": {
                "x": -3037.466,
                "z": -7388.964
              },
              "distanceAlongShapeM": 7639.819,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:15548",
              "position": {
                "x": -2725.784,
                "z": -7568.117
              },
              "distanceAlongShapeM": 8619.661,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:9971",
              "position": {
                "x": -2424.106,
                "z": -7511.11
              },
              "distanceAlongShapeM": 8927.154,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:9694",
              "position": {
                "x": -1983.025,
                "z": -7327.469
              },
              "distanceAlongShapeM": 9413.521,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7052",
              "position": {
                "x": -1045.114,
                "z": -7267.457
              },
              "distanceAlongShapeM": 10507.813,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7980",
              "position": {
                "x": -633.285,
                "z": -7281.575
              },
              "distanceAlongShapeM": 10966.174,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7046",
              "position": {
                "x": -661.758,
                "z": -7645.09
              },
              "distanceAlongShapeM": 11657.126,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 12006.661,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            17940,
            20520,
            22500,
            25260,
            27420,
            30540,
            33060,
            37140,
            39720,
            42300,
            44700,
            47220,
            50220,
            52680,
            55140,
            58080,
            60480,
            63540,
            66420,
            70440,
            72960,
            75660,
            78060,
            80640
          ]
        },
        {
          "id": "judu:pattern:vilnius_bus_125:1",
          "sourceRouteId": "vilnius_bus_125",
          "sourceShapeId": "vilnius_bus_125_b-a",
          "directionId": 1,
          "headsign": "Gabijos progimnazija",
          "directionName": "Visoriai–Bajorai–Visorių g.–Gabijos progimnazija",
          "mode": "bus",
          "routeShortName": "125",
          "routeLongName": "Gabijos progimnazija–Visorių g.–Bajorai– Visoriai",
          "routeColor": "0073AC",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -995.773,
              -7709.189,
              0
            ],
            [
              -1008.525,
              -7702.28,
              14.503
            ],
            [
              -1017.555,
              -7703.23,
              23.584
            ],
            [
              -1031.635,
              -7698.523,
              38.429
            ],
            [
              -1034.149,
              -7695.138,
              42.646
            ],
            [
              -1034.672,
              -7688.449,
              49.355
            ],
            [
              -1028.056,
              -7678.549,
              61.262
            ],
            [
              -952.572,
              -7669.891,
              137.241
            ],
            [
              -687.301,
              -7633.495,
              404.997
            ],
            [
              -638.969,
              -7631.03,
              453.392
            ],
            [
              -576.036,
              -7639.963,
              516.956
            ],
            [
              -525.25,
              -7644.223,
              567.92
            ],
            [
              -547.168,
              -7539.181,
              675.224
            ],
            [
              -607.804,
              -7403.38,
              823.948
            ],
            [
              -698.737,
              -7233.634,
              1016.516
            ],
            [
              -752.866,
              -7235.995,
              1070.697
            ],
            [
              -779.861,
              -7233.281,
              1097.827
            ],
            [
              -817.998,
              -7241.497,
              1136.84
            ],
            [
              -975.194,
              -7282.076,
              1299.189
            ],
            [
              -999.07,
              -7284.985,
              1323.241
            ],
            [
              -1008.745,
              -7285.924,
              1332.962
            ],
            [
              -1020.815,
              -7276.801,
              1348.092
            ],
            [
              -1038.154,
              -7274.262,
              1365.615
            ],
            [
              -1047.829,
              -7275.201,
              1375.336
            ],
            [
              -1052.254,
              -7270.668,
              1381.671
            ],
            [
              -1063.8,
              -7268.234,
              1393.471
            ],
            [
              -1078.061,
              -7273.543,
              1408.688
            ],
            [
              -1073.172,
              -7288.103,
              1424.047
            ],
            [
              -1073.856,
              -7290.317,
              1426.364
            ],
            [
              -1077.095,
              -7291.372,
              1429.77
            ],
            [
              -1151.78,
              -7291.141,
              1504.456
            ],
            [
              -1217.998,
              -7285.497,
              1570.914
            ],
            [
              -1329.053,
              -7266.803,
              1683.531
            ],
            [
              -1377.069,
              -7251.469,
              1733.936
            ],
            [
              -1412.132,
              -7231.915,
              1774.083
            ],
            [
              -1507.971,
              -7154.497,
              1897.285
            ],
            [
              -1536.014,
              -7138.409,
              1929.615
            ],
            [
              -1559.731,
              -7132.419,
              1954.077
            ],
            [
              -1599.016,
              -7132.829,
              1993.364
            ],
            [
              -1638.222,
              -7128.788,
              2032.777
            ],
            [
              -1667.851,
              -7129.371,
              2062.413
            ],
            [
              -1685.974,
              -7134.613,
              2081.278
            ],
            [
              -1717.309,
              -7158.544,
              2120.706
            ],
            [
              -1736.997,
              -7179.344,
              2149.346
            ],
            [
              -1784.713,
              -7255.305,
              2239.051
            ],
            [
              -1799.697,
              -7265.057,
              2256.928
            ],
            [
              -1918.084,
              -7296.342,
              2379.379
            ],
            [
              -1942.097,
              -7307.046,
              2405.671
            ],
            [
              -1952.594,
              -7317.992,
              2420.836
            ],
            [
              -2033.201,
              -7361.085,
              2512.239
            ],
            [
              -2179.338,
              -7468.697,
              2693.722
            ],
            [
              -2371.269,
              -7508.706,
              2889.779
            ],
            [
              -2672.284,
              -7564.608,
              3195.941
            ],
            [
              -2720.772,
              -7575.998,
              3245.749
            ],
            [
              -2749.794,
              -7578.826,
              3274.908
            ],
            [
              -2757.498,
              -7577.576,
              3282.713
            ],
            [
              -2765.787,
              -7572.977,
              3292.192
            ],
            [
              -2768.554,
              -7547.324,
              3317.994
            ],
            [
              -2776.371,
              -7516.016,
              3350.263
            ],
            [
              -2831.651,
              -7364.756,
              3511.308
            ],
            [
              -2960.012,
              -7378.081,
              3640.36
            ],
            [
              -3037.466,
              -7388.964,
              3718.574
            ],
            [
              -3196.78,
              -7405.092,
              3878.702
            ],
            [
              -3243.181,
              -7407.617,
              3925.172
            ],
            [
              -3247.121,
              -7412.001,
              3931.067
            ],
            [
              -3244.879,
              -7614.647,
              4133.725
            ],
            [
              -3249.912,
              -7644.616,
              4164.113
            ],
            [
              -3240.979,
              -7649.226,
              4174.165
            ],
            [
              -3135.153,
              -7635.497,
              4280.878
            ],
            [
              -3078.28,
              -7623.138,
              4339.079
            ],
            [
              -2956.692,
              -7591.879,
              4464.62
            ],
            [
              -2909.025,
              -7590.491,
              4512.308
            ],
            [
              -2880.14,
              -7595.453,
              4541.616
            ],
            [
              -2802.026,
              -7583.471,
              4620.643
            ],
            [
              -2725.784,
              -7568.117,
              4698.416
            ],
            [
              -2672.284,
              -7564.608,
              4752.031
            ],
            [
              -2424.106,
              -7511.11,
              5005.909
            ],
            [
              -2200.558,
              -7467.206,
              5233.728
            ],
            [
              -1983.025,
              -7327.469,
              5492.276
            ],
            [
              -1916.757,
              -7294.139,
              5566.454
            ],
            [
              -1802.895,
              -7263.886,
              5684.266
            ],
            [
              -1791.15,
              -7255.19,
              5698.88
            ],
            [
              -1725.113,
              -7162.858,
              5812.397
            ],
            [
              -1689.896,
              -7137.883,
              5855.571
            ],
            [
              -1676.259,
              -7131.447,
              5870.65
            ],
            [
              -1676.1,
              -7122.544,
              5879.555
            ],
            [
              -1688.211,
              -7115.648,
              5893.491
            ],
            [
              -1835.287,
              -7058.473,
              6051.29
            ],
            [
              -1926.217,
              -7030.134,
              6146.533
            ],
            [
              -1961.907,
              -7009.46,
              6187.779
            ],
            [
              -1982.833,
              -6991.276,
              6215.502
            ],
            [
              -2000.015,
              -6979.838,
              6236.143
            ],
            [
              -2079.043,
              -6933.902,
              6327.552
            ],
            [
              -2123.104,
              -6913.08,
              6376.284
            ],
            [
              -2181.307,
              -6890.895,
              6438.572
            ],
            [
              -2240.837,
              -6870.913,
              6501.367
            ],
            [
              -2249.127,
              -6866.313,
              6510.847
            ],
            [
              -2254.703,
              -6853.968,
              6524.393
            ],
            [
              -2247.724,
              -6787.298,
              6591.427
            ],
            [
              -2270.745,
              -6524.168,
              6855.563
            ],
            [
              -2187.789,
              -6494.47,
              6943.675
            ],
            [
              -2141.922,
              -6486.379,
              6990.25
            ],
            [
              -2092.915,
              -6482.797,
              7039.387
            ],
            [
              -1922.838,
              -6479.145,
              7209.504
            ],
            [
              -1864.134,
              -6473.512,
              7268.477
            ],
            [
              -1849.892,
              -6469.313,
              7283.326
            ],
            [
              -1843.998,
              -6463.852,
              7291.36
            ],
            [
              -1844.225,
              -6440.47,
              7314.743
            ],
            [
              -1867.547,
              -6339.863,
              7418.018
            ],
            [
              -1867.259,
              -6287.547,
              7470.335
            ],
            [
              -1893.157,
              -6186.894,
              7574.266
            ],
            [
              -1916.006,
              -6059.579,
              7703.616
            ],
            [
              -1912.3,
              -5996.191,
              7767.112
            ],
            [
              -1895.885,
              -5906.312,
              7858.478
            ],
            [
              -1884.75,
              -5859.754,
              7906.348
            ],
            [
              -1855.289,
              -5796.825,
              7975.832
            ],
            [
              -1807.996,
              -5745.347,
              8045.736
            ],
            [
              -1760.119,
              -5697.219,
              8113.623
            ],
            [
              -1720.968,
              -5668.974,
              8161.898
            ],
            [
              -1679.985,
              -5646.328,
              8208.722
            ],
            [
              -1602.159,
              -5616.549,
              8292.051
            ],
            [
              -1596.889,
              -5609.964,
              8300.485
            ],
            [
              -1589.222,
              -5613.441,
              8308.904
            ],
            [
              -1569.785,
              -5607.109,
              8329.346
            ],
            [
              -1548.277,
              -5593.022,
              8355.056
            ],
            [
              -1320.847,
              -5518.058,
              8594.523
            ],
            [
              -1262.11,
              -5511.32,
              8653.645
            ],
            [
              -1258.186,
              -5508.051,
              8658.752
            ],
            [
              -1256.303,
              -5439.064,
              8727.764
            ],
            [
              -1183.862,
              -5243.323,
              8936.48
            ],
            [
              -1361.885,
              -5184.465,
              9123.98
            ],
            [
              -1387.604,
              -5181.778,
              9149.839
            ],
            [
              -1666.095,
              -5013.148,
              9475.406
            ],
            [
              -1677.043,
              -5012.953,
              9486.355
            ],
            [
              -1696.959,
              -5045.994,
              9524.935
            ],
            [
              -1770.723,
              -5100.339,
              9616.556
            ],
            [
              -1793.54,
              -5115.517,
              9643.96
            ],
            [
              -1840.927,
              -5135.823,
              9695.515
            ],
            [
              -1904.939,
              -5149.154,
              9760.9
            ],
            [
              -2065.02,
              -5167.456,
              9922.024
            ],
            [
              -2110.315,
              -5178.897,
              9968.742
            ],
            [
              -2139.87,
              -5138.296,
              10018.961
            ],
            [
              -2154.069,
              -5103.533,
              10056.511
            ],
            [
              -2263.659,
              -4890.076,
              10296.457
            ],
            [
              -2297.39,
              -4830.477,
              10364.94
            ],
            [
              -2351.324,
              -4783.879,
              10436.215
            ],
            [
              -2381.317,
              -4767.762,
              10470.264
            ],
            [
              -2406.02,
              -4743.947,
              10504.577
            ],
            [
              -2443.585,
              -4718.791,
              10549.787
            ],
            [
              -2496.725,
              -4700.04,
              10606.138
            ],
            [
              -2554.472,
              -4686.774,
              10665.39
            ],
            [
              -2573.291,
              -4730.97,
              10713.426
            ],
            [
              -2592.46,
              -4758.462,
              10746.941
            ],
            [
              -2618.048,
              -4784.728,
              10783.61
            ],
            [
              -2673.576,
              -4828.277,
              10854.178
            ],
            [
              -2687.375,
              -4843.619,
              10874.812
            ],
            [
              -2713.178,
              -4882.126,
              10921.166
            ],
            [
              -2770.874,
              -4975.733,
              11031.125
            ],
            [
              -2803.001,
              -5044.187,
              11106.743
            ],
            [
              -2859.092,
              -5120.012,
              11201.06
            ],
            [
              -3038.848,
              -5415.194,
              11546.668
            ],
            [
              -3072.82,
              -5405.692,
              11581.944
            ],
            [
              -3098.772,
              -5379.632,
              11618.722
            ],
            [
              -3115.924,
              -5365.973,
              11640.649
            ],
            [
              -3137.233,
              -5332.202,
              11680.58
            ],
            [
              -3160.824,
              -5281.693,
              11736.326
            ],
            [
              -3174.738,
              -5266.977,
              11756.578
            ],
            [
              -3209.14,
              -5245.223,
              11797.282
            ],
            [
              -3278.903,
              -5219.51,
              11871.633
            ],
            [
              -3282.025,
              -5213.889,
              11878.062
            ],
            [
              -3283.119,
              -5202.738,
              11889.267
            ],
            [
              -3271.313,
              -5190.699,
              11906.129
            ],
            [
              -3262.297,
              -5190.857,
              11915.145
            ],
            [
              -3249.554,
              -5198.873,
              11930.2
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1115",
              "position": {
                "x": -995.773,
                "z": -7709.189
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -600,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:7047",
              "position": {
                "x": -638.969,
                "z": -7631.03
              },
              "distanceAlongShapeM": 453.392,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:7968",
              "position": {
                "x": -752.866,
                "z": -7235.995
              },
              "distanceAlongShapeM": 1070.697,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:18018",
              "position": {
                "x": -1047.829,
                "z": -7275.201
              },
              "distanceAlongShapeM": 1375.336,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:9693",
              "position": {
                "x": -1952.594,
                "z": -7317.992
              },
              "distanceAlongShapeM": 2420.836,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:9970",
              "position": {
                "x": -2371.269,
                "z": -7508.706
              },
              "distanceAlongShapeM": 2889.779,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:9496",
              "position": {
                "x": -2768.73,
                "z": -7557.34
              },
              "distanceAlongShapeM": 3308.055,
              "shapeOffsetM": 1.25,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:9815",
              "position": {
                "x": -3037.466,
                "z": -7388.964
              },
              "distanceAlongShapeM": 3718.574,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:15548",
              "position": {
                "x": -2725.784,
                "z": -7568.117
              },
              "distanceAlongShapeM": 4698.416,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:9971",
              "position": {
                "x": -2424.106,
                "z": -7511.11
              },
              "distanceAlongShapeM": 5005.909,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:9694",
              "position": {
                "x": -1983.025,
                "z": -7327.469
              },
              "distanceAlongShapeM": 5492.276,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:17867",
              "position": {
                "x": -2187.789,
                "z": -6494.47
              },
              "distanceAlongShapeM": 6943.675,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:17865",
              "position": {
                "x": -1867.547,
                "z": -6339.863
              },
              "distanceAlongShapeM": 7418.018,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:17862",
              "position": {
                "x": -1855.289,
                "z": -5796.825
              },
              "distanceAlongShapeM": 7975.832,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:17871",
              "position": {
                "x": -1548.277,
                "z": -5593.022
              },
              "distanceAlongShapeM": 8355.056,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5814",
              "position": {
                "x": -1387.604,
                "z": -5181.778
              },
              "distanceAlongShapeM": 9149.839,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5811",
              "position": {
                "x": -1696.959,
                "z": -5045.994
              },
              "distanceAlongShapeM": 9524.935,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6914",
              "position": {
                "x": -2139.87,
                "z": -5138.296
              },
              "distanceAlongShapeM": 10018.961,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6763",
              "position": {
                "x": -2381.317,
                "z": -4767.762
              },
              "distanceAlongShapeM": 10470.264,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5519",
              "position": {
                "x": -2803.001,
                "z": -5044.187
              },
              "distanceAlongShapeM": 11106.743,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:795",
              "position": {
                "x": -3249.554,
                "z": -5198.873
              },
              "distanceAlongShapeM": 11930.2,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            20280,
            23100,
            25200,
            28080,
            30660,
            34980,
            37380,
            40080,
            42540,
            45060,
            47580,
            50100,
            52860,
            55500,
            58140,
            61020,
            63960,
            67980,
            70680,
            73380,
            75780,
            78360,
            80460
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_nightbus_N8",
      "sourceRouteId": "vilnius_nightbus_N8",
      "mode": "bus",
      "shortName": "N8",
      "longName": "Europos aikštė–Centras–Stotis–Naujininkai–Oro uostas",
      "color": "000000",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_nightbus_N8:0",
          "sourceRouteId": "vilnius_nightbus_N8",
          "sourceShapeId": "vilnius_nightbus_N8_a-b",
          "directionId": 0,
          "headsign": "Oro uostas",
          "directionName": "Europos aikštė–Centras–Stotis–Naujininkai–Oro uostas",
          "mode": "bus",
          "routeShortName": "N8",
          "routeLongName": "Europos aikštė–Centras–Stotis–Naujininkai–Oro uostas",
          "routeColor": "000000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -144.948,
              -999.533,
              0
            ],
            [
              -111.147,
              -984.562,
              36.968
            ],
            [
              -194.732,
              -865.04,
              182.817
            ],
            [
              -199.062,
              -854.943,
              193.804
            ],
            [
              -193.763,
              -847.246,
              203.147
            ],
            [
              -168.966,
              -830.998,
              232.794
            ],
            [
              -118.847,
              -805.192,
              289.167
            ],
            [
              -82.324,
              -782.478,
              332.176
            ],
            [
              -42.035,
              -765.399,
              375.936
            ],
            [
              224.176,
              -700.119,
              650.034
            ],
            [
              211.01,
              -644.216,
              707.465
            ],
            [
              143.71,
              -480.456,
              884.515
            ],
            [
              121.213,
              -441.083,
              929.862
            ],
            [
              106.146,
              -277.163,
              1094.473
            ],
            [
              46.11,
              -280.522,
              1154.603
            ],
            [
              26.146,
              -279.045,
              1174.622
            ],
            [
              15.43,
              -265.491,
              1191.9
            ],
            [
              14.363,
              -253.226,
              1204.212
            ],
            [
              16.439,
              -245.471,
              1212.239
            ],
            [
              45.916,
              -220.403,
              1250.934
            ],
            [
              103.215,
              -190.277,
              1315.67
            ],
            [
              127.382,
              -102.772,
              1406.451
            ],
            [
              121.848,
              -52.576,
              1456.952
            ],
            [
              115.041,
              -36.866,
              1474.073
            ],
            [
              117.583,
              -3.516,
              1507.52
            ],
            [
              102.671,
              133.684,
              1645.528
            ],
            [
              63.181,
              125.497,
              1685.858
            ],
            [
              59.312,
              125.568,
              1689.727
            ],
            [
              57.419,
              127.829,
              1692.676
            ],
            [
              31.786,
              278.582,
              1845.593
            ],
            [
              4.856,
              358.112,
              1929.558
            ],
            [
              -8.924,
              380.627,
              1955.956
            ],
            [
              -39.768,
              422.378,
              2007.864
            ],
            [
              -46.8,
              425.846,
              2015.705
            ],
            [
              -51.212,
              431.492,
              2022.871
            ],
            [
              -51.307,
              497.175,
              2088.553
            ],
            [
              -56,
              522.864,
              2114.668
            ],
            [
              -44.593,
              547.148,
              2141.497
            ],
            [
              -34.25,
              619.32,
              2214.406
            ],
            [
              -34.886,
              726.201,
              2321.29
            ],
            [
              -29.964,
              784,
              2379.297
            ],
            [
              -31.514,
              805.179,
              2400.534
            ],
            [
              -24.076,
              823.969,
              2420.742
            ],
            [
              -6.94,
              914.942,
              2513.315
            ],
            [
              5.94,
              949.218,
              2549.93
            ],
            [
              14.89,
              980.225,
              2582.204
            ],
            [
              17.976,
              1008,
              2610.149
            ],
            [
              98.858,
              1127.869,
              2754.754
            ],
            [
              206.575,
              1304.022,
              2961.232
            ],
            [
              265.611,
              1357.493,
              3040.883
            ],
            [
              347.967,
              1416.104,
              3141.966
            ],
            [
              403.761,
              1468.519,
              3218.519
            ],
            [
              405.778,
              1472.935,
              3223.373
            ],
            [
              396.871,
              1479.777,
              3234.605
            ],
            [
              393.103,
              1485.412,
              3241.383
            ],
            [
              391.311,
              1493.238,
              3249.411
            ],
            [
              394.908,
              1548.834,
              3305.124
            ],
            [
              392.049,
              1568.924,
              3325.416
            ],
            [
              390.304,
              1614.599,
              3371.124
            ],
            [
              391.036,
              1654.661,
              3411.194
            ],
            [
              386.324,
              1679.239,
              3436.219
            ],
            [
              339.3,
              1789.195,
              3555.808
            ],
            [
              328.864,
              1818.329,
              3586.755
            ],
            [
              328.986,
              1825.007,
              3593.433
            ],
            [
              341.729,
              1851.491,
              3622.824
            ],
            [
              382.191,
              1911.98,
              3695.598
            ],
            [
              388.24,
              1925.228,
              3710.161
            ],
            [
              387.819,
              1937.481,
              3722.422
            ],
            [
              377.301,
              1962.164,
              3749.253
            ],
            [
              365.148,
              1967.953,
              3762.714
            ],
            [
              365.392,
              1981.307,
              3776.07
            ],
            [
              368.739,
              1987.925,
              3783.487
            ],
            [
              383.133,
              1998.795,
              3801.523
            ],
            [
              393.432,
              1997.493,
              3811.904
            ],
            [
              406.251,
              1992.806,
              3825.553
            ],
            [
              468.163,
              1956.05,
              3897.554
            ],
            [
              473.242,
              1951.504,
              3904.37
            ],
            [
              475.7,
              1944.78,
              3911.529
            ],
            [
              474.81,
              1931.437,
              3924.902
            ],
            [
              481.158,
              1925.755,
              3933.421
            ],
            [
              623.161,
              1858.587,
              4090.509
            ],
            [
              825.163,
              1791.425,
              4303.383
            ],
            [
              862.14,
              1837.501,
              4362.462
            ],
            [
              756.914,
              1939.625,
              4509.097
            ],
            [
              745.631,
              1957.644,
              4530.357
            ],
            [
              722.942,
              1987.005,
              4567.463
            ],
            [
              680.883,
              2015.607,
              4618.326
            ],
            [
              612.97,
              2076.967,
              4709.853
            ],
            [
              575.791,
              2125.517,
              4771.004
            ],
            [
              554.513,
              2161.53,
              4812.833
            ],
            [
              539.42,
              2182.958,
              4839.043
            ],
            [
              519.811,
              2204.469,
              4868.15
            ],
            [
              468.195,
              2239.923,
              4930.769
            ],
            [
              433.065,
              2259.491,
              4970.982
            ],
            [
              406.177,
              2271.115,
              5000.275
            ],
            [
              348.251,
              2314.476,
              5072.632
            ],
            [
              296.511,
              2343.252,
              5131.836
            ],
            [
              241.342,
              2360.957,
              5189.776
            ],
            [
              16.426,
              2411.811,
              5420.369
            ],
            [
              -125.342,
              2457.804,
              5569.412
            ],
            [
              -287.151,
              2501.929,
              5737.129
            ],
            [
              -290.153,
              2585.475,
              5820.729
            ],
            [
              -278.622,
              2616.436,
              5853.768
            ],
            [
              -251.706,
              2819.669,
              6058.775
            ],
            [
              -239.003,
              2950.799,
              6190.519
            ],
            [
              -239.164,
              2977.519,
              6217.24
            ],
            [
              -244.788,
              3023.264,
              6263.329
            ],
            [
              -255.513,
              3072.44,
              6313.661
            ],
            [
              -253.335,
              3121.382,
              6362.652
            ],
            [
              -378.969,
              3774.894,
              7028.13
            ],
            [
              -384.152,
              3809.498,
              7063.12
            ],
            [
              -385.02,
              3832.891,
              7086.529
            ],
            [
              -382.299,
              3876.258,
              7129.981
            ],
            [
              -328.221,
              4117.961,
              7377.661
            ],
            [
              -328.523,
              4136.892,
              7396.593
            ],
            [
              -271.052,
              4387.439,
              7653.648
            ],
            [
              -225.312,
              4631.519,
              7901.976
            ],
            [
              -199.899,
              4822.533,
              8094.673
            ],
            [
              -199.233,
              4859.257,
              8131.403
            ],
            [
              -191.024,
              4884.712,
              8158.15
            ],
            [
              -172.749,
              5038.005,
              8312.528
            ],
            [
              -160.849,
              5053.375,
              8331.966
            ],
            [
              181.228,
              5047.157,
              8674.1
            ],
            [
              185.04,
              5043.748,
              8679.213
            ],
            [
              184.043,
              4953.595,
              8769.372
            ],
            [
              190.96,
              4943.45,
              8781.651
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 375.936,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 929.862,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 1474.073,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 2114.668,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5339",
              "position": {
                "x": -31.514,
                "z": 805.179
              },
              "distanceAlongShapeM": 2400.534,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 2610.149,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 2961.232,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 3325.416,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:8262",
              "position": {
                "x": 365.148,
                "z": 1967.953
              },
              "distanceAlongShapeM": 3762.714,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6005",
              "position": {
                "x": 756.914,
                "z": 1939.625
              },
              "distanceAlongShapeM": 4509.097,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6008",
              "position": {
                "x": 406.177,
                "z": 2271.115
              },
              "distanceAlongShapeM": 5000.275,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 5820.729,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5175",
              "position": {
                "x": -255.513,
                "z": 3072.44
              },
              "distanceAlongShapeM": 6313.661,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5180",
              "position": {
                "x": -328.523,
                "z": 4136.892
              },
              "distanceAlongShapeM": 7396.593,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5182",
              "position": {
                "x": -232.492,
                "z": 4591.573
              },
              "distanceAlongShapeM": 7861.392,
              "shapeOffsetM": 0.301,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:8240",
              "position": {
                "x": -199.233,
                "z": 4859.257
              },
              "distanceAlongShapeM": 8131.403,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 8781.651,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            }
          ],
          "departuresSeconds": [
            86880,
            88860,
            90900,
            92880,
            94920,
            96900,
            101160,
            103140,
            105180,
            107160
          ]
        },
        {
          "id": "judu:pattern:vilnius_nightbus_N8:1",
          "sourceRouteId": "vilnius_nightbus_N8",
          "sourceShapeId": "vilnius_nightbus_N8_b-a",
          "directionId": 1,
          "headsign": "Europos aikštė",
          "directionName": "Oro uostas–Naujininkai–Stotis–Centras–Europos aikštė",
          "mode": "bus",
          "routeShortName": "N8",
          "routeLongName": "Europos aikštė–Centras–Stotis–Naujininkai–Oro uostas",
          "routeColor": "000000",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              190.96,
              4943.45,
              0
            ],
            [
              180.147,
              4916.929,
              28.64
            ],
            [
              171.149,
              4883.696,
              63.07
            ],
            [
              160.096,
              4879.445,
              74.912
            ],
            [
              101.063,
              4899.444,
              137.241
            ],
            [
              60.141,
              4921.34,
              183.652
            ],
            [
              56.975,
              4924.737,
              188.296
            ],
            [
              65.084,
              4944.628,
              209.776
            ],
            [
              70.713,
              4970.13,
              235.892
            ],
            [
              75.861,
              5040.169,
              306.12
            ],
            [
              -161.696,
              5042.258,
              543.687
            ],
            [
              -168.272,
              5035.698,
              552.975
            ],
            [
              -168.292,
              4998.962,
              589.711
            ],
            [
              -175.836,
              4974.608,
              615.206
            ],
            [
              -229.992,
              4551.452,
              1041.814
            ],
            [
              -236.808,
              4531.537,
              1062.862
            ],
            [
              -315.819,
              4161.153,
              1441.581
            ],
            [
              -323.098,
              4115.642,
              1487.67
            ],
            [
              -345.945,
              4030.338,
              1575.98
            ],
            [
              -378.367,
              3879.526,
              1730.238
            ],
            [
              -382.056,
              3853.989,
              1756.04
            ],
            [
              -382.136,
              3813.914,
              1796.115
            ],
            [
              -379.958,
              3791.61,
              1818.525
            ],
            [
              -326.239,
              3550.182,
              2065.858
            ],
            [
              -300.672,
              3393.867,
              2224.249
            ],
            [
              -259.604,
              3167.138,
              2454.668
            ],
            [
              -234.366,
              2993.018,
              2630.608
            ],
            [
              -215.859,
              2945.926,
              2681.205
            ],
            [
              -225.435,
              2951.666,
              2692.369
            ],
            [
              -255.316,
              2762.96,
              2883.427
            ],
            [
              -266.588,
              2603.973,
              3042.813
            ],
            [
              -274.712,
              2582.969,
              3065.333
            ],
            [
              -285.719,
              2509.695,
              3139.429
            ],
            [
              -323.718,
              2371.231,
              3283.013
            ],
            [
              -331.076,
              2356.892,
              3299.129
            ],
            [
              -329.887,
              2351.305,
              3304.842
            ],
            [
              -313.862,
              2345.448,
              3321.904
            ],
            [
              -250.285,
              2328.71,
              3387.647
            ],
            [
              -202.713,
              2318.942,
              3436.211
            ],
            [
              -198.158,
              2321.085,
              3441.246
            ],
            [
              -184.007,
              2318.602,
              3455.613
            ],
            [
              -158.79,
              2321.484,
              3480.994
            ],
            [
              -133.775,
              2313.237,
              3507.333
            ],
            [
              347.135,
              2006.132,
              4077.936
            ],
            [
              360.014,
              2004.783,
              4090.886
            ],
            [
              380.736,
              2008.857,
              4112.004
            ],
            [
              392.929,
              2005.295,
              4124.708
            ],
            [
              440.775,
              1975.476,
              4181.085
            ],
            [
              479.21,
              1960.301,
              4222.407
            ],
            [
              486.04,
              1945.704,
              4238.523
            ],
            [
              477.309,
              1926.939,
              4259.22
            ],
            [
              467.471,
              1918.213,
              4272.37
            ],
            [
              410.21,
              1927.053,
              4330.309
            ],
            [
              405.736,
              1929.361,
              4335.344
            ],
            [
              398.6,
              1927.265,
              4342.781
            ],
            [
              329.489,
              1817.205,
              4472.741
            ],
            [
              330.657,
              1810.504,
              4479.542
            ],
            [
              391.321,
              1670.242,
              4632.361
            ],
            [
              473.433,
              1574.115,
              4758.784
            ],
            [
              482.238,
              1561.708,
              4773.998
            ],
            [
              479.414,
              1548.401,
              4787.601
            ],
            [
              472.7,
              1534.052,
              4803.444
            ],
            [
              453.691,
              1517.701,
              4828.517
            ],
            [
              360.424,
              1427.008,
              4958.609
            ],
            [
              315.899,
              1391.085,
              5015.819
            ],
            [
              256.42,
              1348.755,
              5088.823
            ],
            [
              223.566,
              1315.958,
              5135.245
            ],
            [
              196.476,
              1280.829,
              5179.607
            ],
            [
              149.248,
              1202.651,
              5270.943
            ],
            [
              55.081,
              1061.873,
              5440.312
            ],
            [
              52.802,
              1042.989,
              5459.332
            ],
            [
              38.996,
              1028.769,
              5479.152
            ],
            [
              -5.066,
              911.568,
              5604.361
            ],
            [
              -20.812,
              826.136,
              5691.232
            ],
            [
              -26.358,
              769.462,
              5748.177
            ],
            [
              -32.708,
              739.521,
              5778.785
            ],
            [
              -31.911,
              641.542,
              5876.767
            ],
            [
              -49.15,
              509.381,
              6010.047
            ],
            [
              -49.278,
              431.457,
              6087.971
            ],
            [
              18.234,
              348.963,
              6194.569
            ],
            [
              38.092,
              270.675,
              6275.336
            ],
            [
              60.241,
              141.136,
              6406.755
            ],
            [
              63.906,
              129.937,
              6418.538
            ],
            [
              96.95,
              138.241,
              6452.609
            ],
            [
              107.728,
              128.025,
              6467.459
            ],
            [
              116.145,
              94.475,
              6502.049
            ],
            [
              124.691,
              -38.156,
              6634.955
            ],
            [
              129.098,
              -79.426,
              6676.459
            ],
            [
              129.88,
              -107.271,
              6704.316
            ],
            [
              116.846,
              -256.206,
              6853.82
            ],
            [
              117.887,
              -305.208,
              6902.833
            ],
            [
              127.989,
              -387.771,
              6986.012
            ],
            [
              138.319,
              -422.47,
              7022.216
            ],
            [
              150.182,
              -443.837,
              7046.655
            ],
            [
              177.186,
              -518.917,
              7126.443
            ],
            [
              187.997,
              -562.53,
              7171.377
            ],
            [
              214.213,
              -645.388,
              7258.283
            ],
            [
              224.323,
              -656.705,
              7273.459
            ],
            [
              237.149,
              -695.903,
              7314.701
            ],
            [
              236.925,
              -708.144,
              7326.945
            ],
            [
              229.693,
              -715.805,
              7337.48
            ],
            [
              23.734,
              -765.484,
              7549.345
            ],
            [
              -53.078,
              -805.275,
              7635.852
            ],
            [
              -93.184,
              -812.338,
              7676.576
            ],
            [
              -182.323,
              -856.36,
              7775.992
            ],
            [
              -201.117,
              -861.585,
              7795.499
            ],
            [
              -349.798,
              -953.511,
              7970.303
            ],
            [
              -450.734,
              -1008.456,
              8085.226
            ],
            [
              -402.133,
              -1137.359,
              8222.986
            ],
            [
              -391.115,
              -1134.219,
              8234.442
            ],
            [
              -261.739,
              -1075.338,
              8376.587
            ],
            [
              -135.883,
              -997.471,
              8524.583
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:18375",
              "position": {
                "x": 190.96,
                "z": 4943.45
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -240,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5184",
              "position": {
                "x": -168.292,
                "z": 4998.962
              },
              "distanceAlongShapeM": 589.711,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:410",
              "position": {
                "x": -229.992,
                "z": 4551.452
              },
              "distanceAlongShapeM": 1041.814,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5181",
              "position": {
                "x": -323.098,
                "z": 4115.642
              },
              "distanceAlongShapeM": 1487.67,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:7414",
              "position": {
                "x": -225.435,
                "z": 2951.666
              },
              "distanceAlongShapeM": 2692.369,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 3042.813,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 4222.407,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 4803.444,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 5459.332,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 5748.177,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 6194.569,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 6502.049,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 7046.655,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 7635.852,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            }
          ],
          "departuresSeconds": [
            84600,
            86640,
            88740,
            90720,
            92760,
            94740,
            99000,
            100980,
            103020,
            105000
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_1",
      "sourceRouteId": "vilnius_trol_1",
      "mode": "trolleybus",
      "shortName": "1",
      "longName": "Karoliniškės–Žvėrynas–Stotis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_1:0",
          "sourceRouteId": "vilnius_trol_1",
          "sourceShapeId": "vilnius_trol_1_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Karoliniškės–Žvėrynas–Stotis",
          "mode": "trolleybus",
          "routeShortName": "1",
          "routeLongName": "Karoliniškės–Žvėrynas–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4631.619,
              553.685,
              0
            ],
            [
              -4628.075,
              534.7,
              19.313
            ],
            [
              -4631.834,
              503.595,
              50.645
            ],
            [
              -4642.705,
              471.499,
              84.532
            ],
            [
              -4646.407,
              443.732,
              112.544
            ],
            [
              -4641.216,
              408.021,
              148.631
            ],
            [
              -4613.144,
              315.143,
              245.658
            ],
            [
              -4593.43,
              261.37,
              302.931
            ],
            [
              -4582.265,
              235.574,
              331.039
            ],
            [
              -4568.349,
              219.75,
              352.112
            ],
            [
              -4568.029,
              200.82,
              371.044
            ],
            [
              -4518.608,
              112.027,
              472.664
            ],
            [
              -4509.454,
              81.813,
              504.235
            ],
            [
              -4478.955,
              17.836,
              575.11
            ],
            [
              -4459.487,
              -12.556,
              611.203
            ],
            [
              -4426.085,
              -57.659,
              667.328
            ],
            [
              -4398.274,
              -90.421,
              710.302
            ],
            [
              -4367.713,
              -113.212,
              748.426
            ],
            [
              -4345.341,
              -124.73,
              773.589
            ],
            [
              -4335.314,
              -141.601,
              793.214
            ],
            [
              -4247.163,
              -227.726,
              916.454
            ],
            [
              -4197.821,
              -283.125,
              990.641
            ],
            [
              -4155.783,
              -350.644,
              1070.177
            ],
            [
              -4080.976,
              -462.146,
              1204.448
            ],
            [
              -4057.587,
              -489.267,
              1240.262
            ],
            [
              -4052.757,
              -508.276,
              1259.874
            ],
            [
              -3962.534,
              -660.121,
              1436.502
            ],
            [
              -3958.061,
              -662.425,
              1441.534
            ],
            [
              -3950.306,
              -661.447,
              1449.35
            ],
            [
              -3806.746,
              -600.485,
              1605.318
            ],
            [
              -3694.685,
              -571.263,
              1721.126
            ],
            [
              -3695.742,
              -557.886,
              1734.545
            ],
            [
              -3728.082,
              -489.418,
              1810.267
            ],
            [
              -3741.232,
              -466.925,
              1836.322
            ],
            [
              -3745.668,
              -462.395,
              1842.661
            ],
            [
              -3755.943,
              -459.99,
              1853.214
            ],
            [
              -3839.114,
              -496.394,
              1944.003
            ],
            [
              -3852.238,
              -509.525,
              1962.569
            ],
            [
              -3858.936,
              -523.881,
              1978.409
            ],
            [
              -3860.379,
              -532.761,
              1987.407
            ],
            [
              -3823.641,
              -607.984,
              2071.121
            ],
            [
              -3766.483,
              -732.543,
              2208.169
            ],
            [
              -3707.64,
              -908.34,
              2393.552
            ],
            [
              -3695.741,
              -928.584,
              2417.035
            ],
            [
              -3679.35,
              -950.021,
              2444.019
            ],
            [
              -3668.232,
              -978.044,
              2474.168
            ],
            [
              -3606.925,
              -1085.98,
              2598.299
            ],
            [
              -3586.062,
              -1109.72,
              2629.905
            ],
            [
              -3575.241,
              -1117.701,
              2643.351
            ],
            [
              -3510.568,
              -1143.319,
              2712.912
            ],
            [
              -3355.367,
              -1190.556,
              2875.143
            ],
            [
              -3108.49,
              -1230.499,
              3125.231
            ],
            [
              -3070.013,
              -1242.306,
              3165.478
            ],
            [
              -2879.155,
              -1277.94,
              3359.633
            ],
            [
              -2839.273,
              -1283.094,
              3399.847
            ],
            [
              -2787.087,
              -1285.125,
              3452.073
            ],
            [
              -2748.376,
              -1283.58,
              3490.815
            ],
            [
              -2714.118,
              -1278.617,
              3525.43
            ],
            [
              -2670.7,
              -1266.023,
              3570.638
            ],
            [
              -2624.585,
              -1246.798,
              3620.6
            ],
            [
              -2500.301,
              -1182.198,
              3760.67
            ],
            [
              -2469.831,
              -1172.717,
              3792.581
            ],
            [
              -2418.716,
              -1162.489,
              3844.71
            ],
            [
              -2392.231,
              -1159.617,
              3871.35
            ],
            [
              -2246.137,
              -1174.448,
              4018.195
            ],
            [
              -2236.291,
              -1164.604,
              4032.118
            ],
            [
              -2207.813,
              -1158.429,
              4061.258
            ],
            [
              -2189.628,
              -1150.959,
              4080.917
            ],
            [
              -2165.425,
              -1131.35,
              4112.067
            ],
            [
              -2151.107,
              -1123.812,
              4128.249
            ],
            [
              -2142.708,
              -1122.847,
              4136.703
            ],
            [
              -2107.685,
              -1111.223,
              4173.604
            ],
            [
              -2052.076,
              -1102.191,
              4229.942
            ],
            [
              -1847.467,
              -1053.508,
              4440.262
            ],
            [
              -1839.367,
              -996.878,
              4497.469
            ],
            [
              -1839.595,
              -973.496,
              4520.852
            ],
            [
              -1831.662,
              -962.505,
              4534.407
            ],
            [
              -1768.396,
              -596.269,
              4906.067
            ],
            [
              -1771.243,
              -575.067,
              4927.459
            ],
            [
              -1761.137,
              -550.756,
              4953.787
            ],
            [
              -1691.384,
              -146.787,
              5363.734
            ],
            [
              -1686.504,
              -90.1,
              5420.631
            ],
            [
              -1682.437,
              -79.04,
              5432.414
            ],
            [
              -1670.247,
              -10.238,
              5502.288
            ],
            [
              -1661.707,
              -1.484,
              5514.518
            ],
            [
              -1388.929,
              -38.642,
              5789.815
            ],
            [
              -1362.417,
              -34.664,
              5816.624
            ],
            [
              -1329.577,
              -37.478,
              5849.584
            ],
            [
              -1190.447,
              -11.028,
              5991.206
            ],
            [
              -1025.306,
              27.195,
              6160.712
            ],
            [
              -994.12,
              39.993,
              6194.422
            ],
            [
              -949.475,
              48.095,
              6239.797
            ],
            [
              -919.958,
              39.772,
              6270.465
            ],
            [
              -857.805,
              53.124,
              6334.036
            ],
            [
              -724.996,
              86.353,
              6470.939
            ],
            [
              -591.62,
              115.115,
              6607.381
            ],
            [
              -557.893,
              125.637,
              6642.711
            ],
            [
              -539.176,
              126.412,
              6661.444
            ],
            [
              -408.498,
              148.538,
              6793.982
            ],
            [
              -385.731,
              159.258,
              6819.147
            ],
            [
              -216.06,
              268.617,
              7021.007
            ],
            [
              -50.385,
              441.496,
              7260.456
            ],
            [
              -51.307,
              497.175,
              7316.141
            ],
            [
              -56,
              522.864,
              7342.256
            ],
            [
              -44.593,
              547.148,
              7369.085
            ],
            [
              -34.25,
              619.32,
              7441.995
            ],
            [
              -34.886,
              726.201,
              7548.878
            ],
            [
              -29.964,
              784,
              7606.886
            ],
            [
              -31.514,
              805.179,
              7628.122
            ],
            [
              -24.076,
              823.969,
              7648.33
            ],
            [
              -6.94,
              914.942,
              7740.903
            ],
            [
              5.94,
              949.218,
              7777.519
            ],
            [
              14.89,
              980.225,
              7809.792
            ],
            [
              17.976,
              1008,
              7837.738
            ],
            [
              98.858,
              1127.869,
              7982.343
            ],
            [
              206.575,
              1304.022,
              8188.82
            ],
            [
              265.611,
              1357.493,
              8268.472
            ],
            [
              347.967,
              1416.104,
              8369.554
            ],
            [
              403.761,
              1468.519,
              8446.107
            ],
            [
              405.778,
              1472.935,
              8450.962
            ],
            [
              396.871,
              1479.777,
              8462.193
            ],
            [
              393.103,
              1485.412,
              8468.972
            ],
            [
              391.311,
              1493.238,
              8477
            ],
            [
              394.908,
              1548.834,
              8532.712
            ],
            [
              392.049,
              1568.924,
              8553.005
            ],
            [
              397.453,
              1582.184,
              8567.323
            ],
            [
              391.321,
              1670.242,
              8655.594
            ],
            [
              327.595,
              1819.466,
              8817.856
            ],
            [
              328.524,
              1835.034,
              8833.452
            ],
            [
              390.297,
              1931.87,
              8948.313
            ],
            [
              384.797,
              1948.669,
              8965.989
            ],
            [
              364.123,
              1982.443,
              9005.589
            ],
            [
              361.04,
              1990.292,
              9014.022
            ],
            [
              361.142,
              1995.857,
              9019.587
            ],
            [
              367.089,
              2003.541,
              9029.304
            ],
            [
              374.225,
              2005.637,
              9036.741
            ],
            [
              387.77,
              2005.389,
              9050.288
            ],
            [
              447.829,
              1973.12,
              9118.467
            ],
            [
              479.21,
              1960.301,
              9152.365
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5924",
              "position": {
                "x": -4631.834,
                "z": 503.595
              },
              "distanceAlongShapeM": 50.645,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:351",
              "position": {
                "x": -4568.349,
                "z": 219.75
              },
              "distanceAlongShapeM": 352.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6400",
              "position": {
                "x": -4345.341,
                "z": -124.73
              },
              "distanceAlongShapeM": 773.589,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:596",
              "position": {
                "x": -4057.587,
                "z": -489.267
              },
              "distanceAlongShapeM": 1240.262,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 2444.019,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 3125.231,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6430",
              "position": {
                "x": -2107.685,
                "z": -1111.223
              },
              "distanceAlongShapeM": 4173.604,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6433",
              "position": {
                "x": -1839.595,
                "z": -973.496
              },
              "distanceAlongShapeM": 4520.852,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6434",
              "position": {
                "x": -1771.243,
                "z": -575.067
              },
              "distanceAlongShapeM": 4927.459,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6437",
              "position": {
                "x": -1686.504,
                "z": -90.1
              },
              "distanceAlongShapeM": 5420.631,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:18852",
              "position": {
                "x": -1457.753,
                "z": -28.505
              },
              "distanceAlongShapeM": 5720.252,
              "shapeOffsetM": 0.755,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5881",
              "position": {
                "x": -949.475,
                "z": 48.095
              },
              "distanceAlongShapeM": 6239.797,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 6642.711,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 7342.256,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 7837.738,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 8188.82,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 8553.005,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 9152.365,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            19020,
            20340,
            21960,
            23520,
            25200,
            26940,
            28500,
            30300,
            32520,
            35460,
            37440,
            39360,
            40860,
            42360,
            44040,
            45780,
            47340,
            48900,
            50700,
            52200,
            53700,
            55500,
            57300,
            58860,
            60660,
            62640,
            64560,
            67620,
            69660,
            71460,
            73020,
            74580,
            76140,
            77700,
            79260,
            80700,
            82140
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_1:1",
          "sourceRouteId": "vilnius_trol_1",
          "sourceShapeId": "vilnius_trol_1_b-a",
          "directionId": 1,
          "headsign": "Karoliniškės",
          "directionName": "Stotis–Žvėrynas–Karoliniškės",
          "mode": "trolleybus",
          "routeShortName": "1",
          "routeLongName": "Karoliniškės–Žvėrynas–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              479.21,
              1960.301,
              0
            ],
            [
              486.04,
              1945.704,
              16.116
            ],
            [
              477.309,
              1926.939,
              36.813
            ],
            [
              467.471,
              1918.213,
              49.963
            ],
            [
              410.21,
              1927.053,
              107.902
            ],
            [
              405.736,
              1929.361,
              112.937
            ],
            [
              398.6,
              1927.265,
              120.374
            ],
            [
              329.489,
              1817.205,
              250.334
            ],
            [
              330.657,
              1810.504,
              257.135
            ],
            [
              391.321,
              1670.242,
              409.954
            ],
            [
              473.433,
              1574.115,
              536.377
            ],
            [
              482.238,
              1561.708,
              551.591
            ],
            [
              479.414,
              1548.401,
              565.194
            ],
            [
              472.7,
              1534.052,
              581.037
            ],
            [
              453.691,
              1517.701,
              606.11
            ],
            [
              360.424,
              1427.008,
              736.202
            ],
            [
              315.899,
              1391.085,
              793.412
            ],
            [
              256.42,
              1348.755,
              866.416
            ],
            [
              223.566,
              1315.958,
              912.838
            ],
            [
              196.476,
              1280.829,
              957.2
            ],
            [
              149.248,
              1202.651,
              1048.536
            ],
            [
              55.081,
              1061.873,
              1217.905
            ],
            [
              52.802,
              1042.989,
              1236.925
            ],
            [
              42.322,
              1034.274,
              1250.555
            ],
            [
              29.685,
              1013.353,
              1274.997
            ],
            [
              17.226,
              966.824,
              1323.165
            ],
            [
              -2.949,
              921.549,
              1372.732
            ],
            [
              -20.167,
              826.124,
              1469.698
            ],
            [
              -26.358,
              769.462,
              1526.697
            ],
            [
              -34.886,
              726.201,
              1570.79
            ],
            [
              -34.25,
              619.32,
              1677.674
            ],
            [
              -49.15,
              509.381,
              1788.618
            ],
            [
              -50.587,
              430.368,
              1867.644
            ],
            [
              -55.202,
              424.885,
              1874.81
            ],
            [
              -86.677,
              396.514,
              1917.185
            ],
            [
              -97.297,
              380.009,
              1936.811
            ],
            [
              -191.175,
              289.316,
              2067.342
            ],
            [
              -216.06,
              268.617,
              2099.71
            ],
            [
              -386.375,
              159.27,
              2302.107
            ],
            [
              -408.498,
              148.538,
              2326.694
            ],
            [
              -583.944,
              111.636,
              2505.979
            ],
            [
              -658.953,
              100.746,
              2581.775
            ],
            [
              -724.996,
              86.353,
              2649.368
            ],
            [
              -736.157,
              75.422,
              2664.99
            ],
            [
              -743.833,
              78.9,
              2673.417
            ],
            [
              -798.875,
              66.534,
              2729.831
            ],
            [
              -863.023,
              49.879,
              2796.106
            ],
            [
              -870.86,
              44.454,
              2805.638
            ],
            [
              -877.911,
              46.807,
              2813.072
            ],
            [
              -930.978,
              36.63,
              2867.106
            ],
            [
              -998.108,
              33.385,
              2934.314
            ],
            [
              -1226.73,
              -20.397,
              3169.176
            ],
            [
              -1327.722,
              -41.964,
              3272.446
            ],
            [
              -1378.268,
              -55.531,
              3324.781
            ],
            [
              -1438.145,
              -50.007,
              3384.913
            ],
            [
              -1471.431,
              -36.053,
              3421.005
            ],
            [
              -1661.707,
              -1.484,
              3614.395
            ],
            [
              -1691.384,
              -146.787,
              3762.698
            ],
            [
              -1712.987,
              -273.309,
              3891.051
            ],
            [
              -1710.567,
              -282.258,
              3900.321
            ],
            [
              -1719.483,
              -312.156,
              3931.52
            ],
            [
              -1768.396,
              -596.269,
              4219.813
            ],
            [
              -1770.261,
              -628.519,
              4252.117
            ],
            [
              -1778.412,
              -651.752,
              4276.738
            ],
            [
              -1847.467,
              -1053.508,
              4684.386
            ],
            [
              -1903.255,
              -1072.553,
              4743.336
            ],
            [
              -1911.753,
              -1079.081,
              4754.052
            ],
            [
              -1954.393,
              -1083.889,
              4796.961
            ],
            [
              -2142.708,
              -1122.847,
              4989.264
            ],
            [
              -2154.408,
              -1128.206,
              5002.133
            ],
            [
              -2189.766,
              -1158.749,
              5048.856
            ],
            [
              -2202.091,
              -1162.983,
              5061.888
            ],
            [
              -2218.205,
              -1162.698,
              5078.004
            ],
            [
              -2227.932,
              -1165.865,
              5088.234
            ],
            [
              -2246.137,
              -1174.448,
              5108.361
            ],
            [
              -2255.397,
              -1187.643,
              5124.481
            ],
            [
              -2267.097,
              -1193.002,
              5137.35
            ],
            [
              -2295.924,
              -1182.472,
              5168.04
            ],
            [
              -2392.506,
              -1175.197,
              5264.895
            ],
            [
              -2431.277,
              -1180.078,
              5303.972
            ],
            [
              -2478.584,
              -1193.714,
              5353.205
            ],
            [
              -2533.196,
              -1219.467,
              5413.585
            ],
            [
              -2617.204,
              -1266.966,
              5510.092
            ],
            [
              -2663.944,
              -1285.067,
              5560.213
            ],
            [
              -2710.565,
              -1296.491,
              5608.214
            ],
            [
              -2762.303,
              -1305.599,
              5660.747
            ],
            [
              -2806.189,
              -1308.166,
              5704.709
            ],
            [
              -2858.961,
              -1302.785,
              5757.754
            ],
            [
              -3085.169,
              -1260.965,
              5987.795
            ],
            [
              -3140.52,
              -1255.542,
              6043.412
            ],
            [
              -3159.719,
              -1247.413,
              6064.261
            ],
            [
              -3359.526,
              -1207.182,
              6268.077
            ],
            [
              -3495.953,
              -1192.555,
              6405.287
            ],
            [
              -3569.469,
              -1193.5,
              6478.809
            ],
            [
              -3626.266,
              -1196.964,
              6535.711
            ],
            [
              -3657.704,
              -1114.039,
              6624.395
            ],
            [
              -3680.758,
              -1067.996,
              6675.887
            ],
            [
              -3686.114,
              -1042.299,
              6702.136
            ],
            [
              -3720.918,
              -930.373,
              6819.349
            ],
            [
              -3751.541,
              -837.444,
              6917.193
            ],
            [
              -3761.526,
              -818.346,
              6938.744
            ],
            [
              -3766.218,
              -791.548,
              6965.95
            ],
            [
              -3793.988,
              -719.82,
              7042.866
            ],
            [
              -3843.779,
              -616.54,
              7157.521
            ],
            [
              -3881.258,
              -546.871,
              7236.632
            ],
            [
              -3892.746,
              -539.992,
              7250.022
            ],
            [
              -3915.211,
              -534.036,
              7273.263
            ],
            [
              -4013.321,
              -576.864,
              7380.314
            ],
            [
              -4103.192,
              -441.723,
              7542.609
            ],
            [
              -4126.033,
              -420.177,
              7574.009
            ],
            [
              -4131.488,
              -400.045,
              7594.867
            ],
            [
              -4155.783,
              -350.644,
              7649.918
            ],
            [
              -4237.762,
              -243.473,
              7784.849
            ],
            [
              -4352.037,
              -139.086,
              7939.624
            ],
            [
              -4426.18,
              -63.224,
              8045.701
            ],
            [
              -4449.727,
              -45.007,
              8075.472
            ],
            [
              -4460.208,
              -16.996,
              8105.38
            ],
            [
              -4494.728,
              38.145,
              8170.435
            ],
            [
              -4530.309,
              106.663,
              8247.64
            ],
            [
              -4592.389,
              246.88,
              8400.986
            ],
            [
              -4608.183,
              266.076,
              8425.844
            ],
            [
              -4641.216,
              408.021,
              8571.581
            ],
            [
              -4663.089,
              486.32,
              8652.879
            ],
            [
              -4661.513,
              502.991,
              8669.624
            ],
            [
              -4670.535,
              540.995,
              8708.684
            ],
            [
              -4686.12,
              572.432,
              8743.772
            ],
            [
              -4701.876,
              593.853,
              8770.364
            ],
            [
              -4704.928,
              603.925,
              8780.888
            ],
            [
              -4702.177,
              613.896,
              8791.232
            ],
            [
              -4693.036,
              620.419,
              8802.462
            ],
            [
              -4675.626,
              620.12,
              8819.874
            ],
            [
              -4661.537,
              614.312,
              8835.114
            ],
            [
              -4631.619,
              553.685,
              8902.72
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 581.037,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1236.925,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 1526.697,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 1936.811,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5936",
              "position": {
                "x": -736.157,
                "z": 75.422
              },
              "distanceAlongShapeM": 2664.99,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:19193",
              "position": {
                "x": -870.86,
                "z": 44.454
              },
              "distanceAlongShapeM": 2805.638,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6438",
              "position": {
                "x": -1438.145,
                "z": -50.007
              },
              "distanceAlongShapeM": 3384.913,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6436",
              "position": {
                "x": -1710.567,
                "z": -282.258
              },
              "distanceAlongShapeM": 3900.321,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6435",
              "position": {
                "x": -1770.261,
                "z": -628.519
              },
              "distanceAlongShapeM": 4252.117,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6432",
              "position": {
                "x": -1911.753,
                "z": -1079.081
              },
              "distanceAlongShapeM": 4754.052,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 6043.412,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 6675.887,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 6938.744,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5915",
              "position": {
                "x": -4126.033,
                "z": -420.177
              },
              "distanceAlongShapeM": 7574.009,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5919",
              "position": {
                "x": -4449.727,
                "z": -45.007
              },
              "distanceAlongShapeM": 8075.472,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5920",
              "position": {
                "x": -4608.183,
                "z": 266.076
              },
              "distanceAlongShapeM": 8425.844,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5923",
              "position": {
                "x": -4663.089,
                "z": 486.32
              },
              "distanceAlongShapeM": 8652.879,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            }
          ],
          "departuresSeconds": [
            21000,
            22320,
            23940,
            25500,
            27300,
            29100,
            30660,
            32400,
            34620,
            37560,
            39480,
            41400,
            42960,
            44460,
            46140,
            47880,
            49440,
            51000,
            52860,
            54360,
            55860,
            57660,
            59460,
            60960,
            62760,
            64740,
            66660,
            69660,
            71700,
            73500,
            75060,
            76560,
            78120,
            79680,
            81180,
            82620
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_2",
      "sourceRouteId": "vilnius_trol_2",
      "mode": "trolleybus",
      "shortName": "2",
      "longName": "Saulėtekis–Žygimantų g.–Stotis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_2:0",
          "sourceRouteId": "vilnius_trol_2",
          "sourceShapeId": "vilnius_trol_2_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Saulėtekis–Žygimantų g.–Stotis",
          "mode": "trolleybus",
          "routeShortName": "2",
          "routeLongName": "Saulėtekis–Žygimantų g.–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3954.003,
              -4105.097,
              0
            ],
            [
              3949.042,
              -4094.982,
              11.266
            ],
            [
              3942.445,
              -4069.251,
              37.829
            ],
            [
              3936.216,
              -4058,
              50.69
            ],
            [
              3917.749,
              -4046.514,
              72.437
            ],
            [
              3898.552,
              -4039.468,
              92.886
            ],
            [
              3898.616,
              -4036.13,
              96.225
            ],
            [
              3858.828,
              -4027.577,
              136.922
            ],
            [
              3592.048,
              -4028.061,
              403.703
            ],
            [
              3581.678,
              -4031.203,
              414.538
            ],
            [
              3565.986,
              -4043.151,
              434.261
            ],
            [
              3520.083,
              -4051.184,
              480.861
            ],
            [
              3445.458,
              -4078.711,
              560.402
            ],
            [
              3358.965,
              -4120.486,
              656.455
            ],
            [
              3360.169,
              -4124.962,
              661.09
            ],
            [
              3310.064,
              -4150.73,
              717.432
            ],
            [
              3021.059,
              -4338.966,
              1062.334
            ],
            [
              2959.695,
              -4278.804,
              1148.269
            ],
            [
              2937.404,
              -4265.024,
              1174.476
            ],
            [
              2920.517,
              -4237.987,
              1206.353
            ],
            [
              2810.169,
              -4110.107,
              1375.262
            ],
            [
              2739.116,
              -4050.879,
              1467.763
            ],
            [
              2661.391,
              -4003.772,
              1558.649
            ],
            [
              2636.416,
              -3995.509,
              1584.956
            ],
            [
              2619.338,
              -3978.489,
              1609.067
            ],
            [
              2604.004,
              -3971.521,
              1625.909
            ],
            [
              2521.143,
              -3923.207,
              1721.827
            ],
            [
              2505.227,
              -3912.889,
              1740.795
            ],
            [
              2488.876,
              -3891.43,
              1767.773
            ],
            [
              2479.071,
              -3864.528,
              1796.407
            ],
            [
              2475.189,
              -3831.057,
              1830.102
            ],
            [
              2503.004,
              -3722.48,
              1942.185
            ],
            [
              2508.663,
              -3661.358,
              2003.569
            ],
            [
              2463.001,
              -3519.117,
              2152.959
            ],
            [
              2462.068,
              -3500.174,
              2171.925
            ],
            [
              2434.072,
              -3309.282,
              2364.859
            ],
            [
              2425.512,
              -3284.63,
              2390.955
            ],
            [
              2426.678,
              -3256.82,
              2418.789
            ],
            [
              2328.687,
              -2639.354,
              3043.983
            ],
            [
              2308.053,
              -2536.548,
              3148.839
            ],
            [
              2296.913,
              -2511.848,
              3175.935
            ],
            [
              2295.002,
              -2476.188,
              3211.646
            ],
            [
              2274.24,
              -2414.57,
              3276.667
            ],
            [
              2234.812,
              -2316.979,
              3381.922
            ],
            [
              2177.257,
              -2188.992,
              3522.255
            ],
            [
              2082.177,
              -1964.565,
              3765.992
            ],
            [
              2062.178,
              -1896.283,
              3837.142
            ],
            [
              2050.931,
              -1842.637,
              3891.954
            ],
            [
              2043.488,
              -1826.913,
              3909.351
            ],
            [
              2041.617,
              -1789.027,
              3947.283
            ],
            [
              1994.191,
              -1532.095,
              4208.556
            ],
            [
              1983.608,
              -1511.859,
              4231.392
            ],
            [
              1983.607,
              -1477.349,
              4265.902
            ],
            [
              1966.491,
              -1323.401,
              4420.798
            ],
            [
              1951.301,
              -996.936,
              4747.616
            ],
            [
              1944.999,
              -954.515,
              4790.503
            ],
            [
              1921.875,
              -915.121,
              4836.182
            ],
            [
              1920.773,
              -905.081,
              4846.283
            ],
            [
              1905.301,
              -870.282,
              4884.366
            ],
            [
              1842.792,
              -798.983,
              4979.186
            ],
            [
              1722.529,
              -643.118,
              5176.055
            ],
            [
              1706.703,
              -627.239,
              5198.474
            ],
            [
              1655.278,
              -618.49,
              5250.638
            ],
            [
              1647.146,
              -604.98,
              5266.406
            ],
            [
              1647.435,
              -589.4,
              5281.989
            ],
            [
              1641.361,
              -569.249,
              5303.036
            ],
            [
              1626.241,
              -550.043,
              5327.479
            ],
            [
              1608.96,
              -543.043,
              5346.124
            ],
            [
              1227.773,
              -233.181,
              5837.366
            ],
            [
              1060.09,
              -128.781,
              6034.893
            ],
            [
              1042.305,
              -113.981,
              6058.03
            ],
            [
              992.552,
              -84.12,
              6116.056
            ],
            [
              920.398,
              -44.941,
              6198.161
            ],
            [
              895.357,
              -38.914,
              6223.918
            ],
            [
              797.689,
              -19.306,
              6323.534
            ],
            [
              670.384,
              1.958,
              6452.603
            ],
            [
              652.936,
              0.051,
              6470.154
            ],
            [
              630.873,
              -7.336,
              6493.422
            ],
            [
              604.636,
              -31.346,
              6528.987
            ],
            [
              564.962,
              -49.544,
              6572.635
            ],
            [
              476.44,
              -129.188,
              6691.712
            ],
            [
              402.286,
              -199.078,
              6793.611
            ],
            [
              346.776,
              -237.026,
              6860.852
            ],
            [
              281.176,
              -262.545,
              6931.241
            ],
            [
              119.684,
              -277.409,
              7093.416
            ],
            [
              35.151,
              -280.322,
              7177.999
            ],
            [
              26.146,
              -279.045,
              7187.095
            ],
            [
              15.43,
              -265.491,
              7204.373
            ],
            [
              14.363,
              -253.226,
              7216.684
            ],
            [
              16.439,
              -245.471,
              7224.712
            ],
            [
              25.627,
              -236.732,
              7237.392
            ],
            [
              45.916,
              -220.403,
              7263.436
            ],
            [
              103.215,
              -190.277,
              7328.172
            ],
            [
              127.382,
              -102.772,
              7418.953
            ],
            [
              121.848,
              -52.576,
              7469.454
            ],
            [
              115.041,
              -36.866,
              7486.575
            ],
            [
              117.583,
              -3.516,
              7520.022
            ],
            [
              102.671,
              133.684,
              7658.03
            ],
            [
              63.181,
              125.497,
              7698.36
            ],
            [
              59.312,
              125.568,
              7702.229
            ],
            [
              57.419,
              127.829,
              7705.178
            ],
            [
              31.786,
              278.582,
              7858.095
            ],
            [
              4.856,
              358.112,
              7942.06
            ],
            [
              -8.924,
              380.627,
              7968.458
            ],
            [
              -39.768,
              422.378,
              8020.366
            ],
            [
              -46.8,
              425.846,
              8028.207
            ],
            [
              -51.212,
              431.492,
              8035.373
            ],
            [
              -51.307,
              497.175,
              8101.055
            ],
            [
              -56,
              522.864,
              8127.17
            ],
            [
              -44.593,
              547.148,
              8153.999
            ],
            [
              -34.25,
              619.32,
              8226.908
            ],
            [
              -34.886,
              726.201,
              8333.792
            ],
            [
              -29.964,
              784,
              8391.799
            ],
            [
              -31.514,
              805.179,
              8413.036
            ],
            [
              -24.076,
              823.969,
              8433.244
            ],
            [
              -6.94,
              914.942,
              8525.817
            ],
            [
              5.94,
              949.218,
              8562.432
            ],
            [
              14.89,
              980.225,
              8594.706
            ],
            [
              17.976,
              1008,
              8622.651
            ],
            [
              98.858,
              1127.869,
              8767.256
            ],
            [
              206.575,
              1304.022,
              8973.734
            ],
            [
              265.611,
              1357.493,
              9053.385
            ],
            [
              347.967,
              1416.104,
              9154.468
            ],
            [
              403.761,
              1468.519,
              9231.021
            ],
            [
              405.778,
              1472.935,
              9235.875
            ],
            [
              396.871,
              1479.777,
              9247.107
            ],
            [
              393.103,
              1485.412,
              9253.885
            ],
            [
              391.311,
              1493.238,
              9261.913
            ],
            [
              394.908,
              1548.834,
              9317.625
            ],
            [
              392.049,
              1568.924,
              9337.918
            ],
            [
              397.453,
              1582.184,
              9352.237
            ],
            [
              391.321,
              1670.242,
              9440.508
            ],
            [
              330.657,
              1810.504,
              9593.327
            ],
            [
              327.072,
              1826.155,
              9609.383
            ],
            [
              328.524,
              1835.034,
              9618.38
            ],
            [
              390.297,
              1931.87,
              9733.241
            ],
            [
              384.797,
              1948.669,
              9750.917
            ],
            [
              364.123,
              1982.443,
              9790.517
            ],
            [
              361.04,
              1990.292,
              9798.95
            ],
            [
              363.158,
              2000.273,
              9809.153
            ],
            [
              374.225,
              2005.637,
              9821.451
            ],
            [
              387.77,
              2005.389,
              9834.998
            ],
            [
              447.829,
              1973.12,
              9903.177
            ],
            [
              479.21,
              1960.301,
              9937.075
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 92.886,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 434.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 661.09,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 1174.476,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 1584.956,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 2152.959,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 2390.955,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 3175.935,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5818",
              "position": {
                "x": 2043.488,
                "z": -1826.913
              },
              "distanceAlongShapeM": 3909.351,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5819",
              "position": {
                "x": 1983.608,
                "z": -1511.859
              },
              "distanceAlongShapeM": 4231.392,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5820",
              "position": {
                "x": 1921.875,
                "z": -915.121
              },
              "distanceAlongShapeM": 4836.182,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 5346.124,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 6034.893,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 6528.987,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 7486.575,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 8127.17,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 8622.651,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 8973.734,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 9337.918,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 9937.075,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            18840,
            19680,
            20280,
            20760,
            21480,
            22080,
            22560,
            22920,
            23340,
            23700,
            24060,
            24480,
            24900,
            25320,
            25680,
            26100,
            26520,
            26940,
            27420,
            27900,
            28320,
            28800,
            29160,
            29640,
            30120,
            30900,
            31620,
            32400,
            33240,
            33840,
            34500,
            35040,
            35580,
            36180,
            36960,
            37740,
            38640,
            39360,
            40080,
            40740,
            41340,
            41940,
            42540,
            43200,
            43920,
            44640,
            45300,
            46020,
            46620,
            47280,
            47880,
            48480,
            49200,
            49920,
            50580,
            51240,
            51840,
            52200,
            52680,
            53100,
            53520,
            53940,
            54360,
            54780,
            55200,
            55620,
            56040,
            56400,
            56880,
            57360,
            57840,
            58320,
            58740,
            59160,
            59640,
            60060,
            60480,
            60900,
            61320,
            61740,
            62160,
            62640,
            63120,
            63600,
            64080,
            64500,
            64920,
            65400,
            66000,
            66780,
            67500,
            68280,
            69000,
            69720,
            70320,
            70920,
            71580,
            72180,
            72900,
            73620,
            74280,
            74880,
            75600,
            76200,
            76800,
            77400,
            78240,
            79080,
            79920,
            81060,
            82200,
            83400
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_2:1",
          "sourceRouteId": "vilnius_trol_2",
          "sourceShapeId": "vilnius_trol_2_b-a",
          "directionId": 1,
          "headsign": "Saulėtekis",
          "directionName": "Stotis–Žygimantų g.–Saulėtekis",
          "mode": "trolleybus",
          "routeShortName": "2",
          "routeLongName": "Saulėtekis–Žygimantų g.–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              479.21,
              1960.301,
              0
            ],
            [
              486.04,
              1945.704,
              16.116
            ],
            [
              477.309,
              1926.939,
              36.813
            ],
            [
              467.471,
              1918.213,
              49.963
            ],
            [
              410.21,
              1927.053,
              107.902
            ],
            [
              405.736,
              1929.361,
              112.937
            ],
            [
              398.6,
              1927.265,
              120.374
            ],
            [
              329.489,
              1817.205,
              250.334
            ],
            [
              330.657,
              1810.504,
              257.135
            ],
            [
              391.321,
              1670.242,
              409.954
            ],
            [
              473.433,
              1574.115,
              536.377
            ],
            [
              482.238,
              1561.708,
              551.591
            ],
            [
              479.414,
              1548.401,
              565.194
            ],
            [
              472.7,
              1534.052,
              581.037
            ],
            [
              453.691,
              1517.701,
              606.11
            ],
            [
              360.424,
              1427.008,
              736.202
            ],
            [
              315.899,
              1391.085,
              793.412
            ],
            [
              256.42,
              1348.755,
              866.416
            ],
            [
              223.566,
              1315.958,
              912.838
            ],
            [
              196.476,
              1280.829,
              957.2
            ],
            [
              149.248,
              1202.651,
              1048.536
            ],
            [
              55.081,
              1061.873,
              1217.905
            ],
            [
              52.802,
              1042.989,
              1236.925
            ],
            [
              42.322,
              1034.274,
              1250.555
            ],
            [
              29.685,
              1013.353,
              1274.997
            ],
            [
              17.226,
              966.824,
              1323.165
            ],
            [
              -2.949,
              921.549,
              1372.732
            ],
            [
              -20.167,
              826.124,
              1469.698
            ],
            [
              -26.358,
              769.462,
              1526.697
            ],
            [
              -34.886,
              726.201,
              1570.79
            ],
            [
              -34.25,
              619.32,
              1677.674
            ],
            [
              -49.15,
              509.381,
              1788.618
            ],
            [
              -51.111,
              437.057,
              1860.969
            ],
            [
              -46.759,
              428.072,
              1870.952
            ],
            [
              -39.768,
              422.378,
              1879.968
            ],
            [
              18.234,
              348.963,
              1973.531
            ],
            [
              36.62,
              260.682,
              2063.706
            ],
            [
              56.855,
              132.292,
              2193.681
            ],
            [
              59.373,
              128.907,
              2197.9
            ],
            [
              70.978,
              128.695,
              2209.507
            ],
            [
              102.671,
              133.684,
              2241.59
            ],
            [
              116.145,
              94.475,
              2283.05
            ],
            [
              117.953,
              52.139,
              2325.424
            ],
            [
              129.077,
              -80.538,
              2458.567
            ],
            [
              129.194,
              -109.485,
              2487.514
            ],
            [
              121.85,
              -193.956,
              2572.304
            ],
            [
              119.866,
              -267.394,
              2645.768
            ],
            [
              179.196,
              -267.363,
              2705.098
            ],
            [
              270.197,
              -263.458,
              2796.182
            ],
            [
              305.837,
              -254.09,
              2833.033
            ],
            [
              342.264,
              -236.944,
              2873.294
            ],
            [
              410.165,
              -191.43,
              2955.038
            ],
            [
              461.971,
              -144.509,
              3024.934
            ],
            [
              541.549,
              -60.247,
              3140.833
            ],
            [
              554.165,
              -40.44,
              3164.317
            ],
            [
              588.702,
              -21.035,
              3203.932
            ],
            [
              628.519,
              4.952,
              3251.479
            ],
            [
              645.363,
              9.096,
              3268.825
            ],
            [
              675.04,
              9.665,
              3298.508
            ],
            [
              707.88,
              6.836,
              3331.469
            ],
            [
              925.597,
              -42.81,
              3554.775
            ],
            [
              1129.224,
              -156.774,
              3788.124
            ],
            [
              1143.99,
              -160.386,
              3803.326
            ],
            [
              1610.786,
              -514.132,
              4389.018
            ],
            [
              1615.737,
              -525.357,
              4401.285
            ],
            [
              1648.803,
              -550.462,
              4442.802
            ],
            [
              1657.142,
              -552.844,
              4451.474
            ],
            [
              1686.795,
              -553.394,
              4481.133
            ],
            [
              1704.118,
              -558.169,
              4499.101
            ],
            [
              1714.932,
              -566.163,
              4512.549
            ],
            [
              1727.769,
              -638.763,
              4586.274
            ],
            [
              1737.731,
              -657.873,
              4607.826
            ],
            [
              1757.197,
              -686.066,
              4642.086
            ],
            [
              1866.79,
              -826.148,
              4819.944
            ],
            [
              1905.301,
              -870.282,
              4878.518
            ],
            [
              1927.219,
              -905.201,
              4919.746
            ],
            [
              1944,
              -938.911,
              4957.402
            ],
            [
              1949.844,
              -971.304,
              4990.319
            ],
            [
              1961.738,
              -990.451,
              5012.859
            ],
            [
              1968.757,
              -1305.631,
              5328.117
            ],
            [
              1988.222,
              -1471.868,
              5495.49
            ],
            [
              2032.094,
              -1677.525,
              5705.774
            ],
            [
              2032.074,
              -1713.148,
              5741.397
            ],
            [
              2048.644,
              -1792.498,
              5822.459
            ],
            [
              2069.62,
              -1877.497,
              5910.008
            ],
            [
              2087.852,
              -1936.84,
              5972.088
            ],
            [
              2087.374,
              -1962.435,
              5997.688
            ],
            [
              2110.719,
              -2024.1,
              6063.624
            ],
            [
              2234.812,
              -2316.979,
              6381.708
            ],
            [
              2284.924,
              -2429.242,
              6504.647
            ],
            [
              2299.015,
              -2468.47,
              6546.329
            ],
            [
              2319.691,
              -2569.05,
              6649.012
            ],
            [
              2327.089,
              -2587.001,
              6668.428
            ],
            [
              2323.492,
              -2606.972,
              6688.721
            ],
            [
              2328.687,
              -2639.354,
              6721.516
            ],
            [
              2411.872,
              -3118.499,
              7207.829
            ],
            [
              2419.872,
              -3138.687,
              7229.545
            ],
            [
              2418.768,
              -3163.158,
              7254.04
            ],
            [
              2474.472,
              -3526.012,
              7621.144
            ],
            [
              2513.109,
              -3664.781,
              7765.192
            ],
            [
              2522.438,
              -3682.768,
              7785.454
            ],
            [
              2522.312,
              -3689.445,
              7792.133
            ],
            [
              2535.711,
              -3730.887,
              7835.687
            ],
            [
              2556.818,
              -3773.588,
              7883.319
            ],
            [
              2598.204,
              -3834.482,
              7956.946
            ],
            [
              2619.624,
              -3860.489,
              7990.639
            ],
            [
              2636.723,
              -3876.397,
              8013.993
            ],
            [
              2642.893,
              -3890.985,
              8029.832
            ],
            [
              2709.56,
              -3977.961,
              8139.419
            ],
            [
              3021.059,
              -4338.966,
              8616.239
            ],
            [
              3086.352,
              -4293.444,
              8695.835
            ],
            [
              3111.27,
              -4270.537,
              8729.682
            ],
            [
              3142.482,
              -4255.542,
              8764.309
            ],
            [
              3336.938,
              -4126.748,
              8997.549
            ],
            [
              3389.682,
              -4097.691,
              9057.768
            ],
            [
              3402.776,
              -4086.807,
              9074.795
            ],
            [
              3446.229,
              -4072.046,
              9120.686
            ],
            [
              3528.69,
              -4039.102,
              9209.484
            ],
            [
              3592.048,
              -4028.061,
              9273.797
            ],
            [
              3640.634,
              -4014.513,
              9324.237
            ],
            [
              3666.294,
              -4020.567,
              9350.601
            ],
            [
              3848.026,
              -4019.578,
              9532.337
            ],
            [
              3878.881,
              -4023.507,
              9563.441
            ],
            [
              3901.964,
              -4029.514,
              9587.292
            ],
            [
              3958.181,
              -4055.079,
              9649.049
            ],
            [
              3967.843,
              -4055.264,
              9658.713
            ],
            [
              4018.762,
              -4121.92,
              9742.593
            ],
            [
              4037.773,
              -4172.381,
              9796.516
            ],
            [
              4032.364,
              -4185.636,
              9810.832
            ],
            [
              4021.265,
              -4193.217,
              9824.273
            ],
            [
              4012.248,
              -4193.045,
              9833.292
            ],
            [
              3999.472,
              -4187.234,
              9847.327
            ],
            [
              3957.337,
              -4132.992,
              9916.012
            ],
            [
              3954.003,
              -4105.097,
              9944.106
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 581.037,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1236.925,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 1526.697,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 1973.531,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 2283.05,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 3331.469,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 3803.326,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 4389.018,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5826",
              "position": {
                "x": 1961.738,
                "z": -990.451
              },
              "distanceAlongShapeM": 5012.859,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6702",
              "position": {
                "x": 2032.094,
                "z": -1677.525
              },
              "distanceAlongShapeM": 5705.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 5972.088,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 6668.428,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 7229.545,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 7785.454,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 8013.993,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 8729.682,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 9074.795,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 9324.237,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 9658.713,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            18840,
            19980,
            21000,
            21840,
            22440,
            22920,
            23700,
            24300,
            24780,
            25140,
            25560,
            25980,
            26340,
            26940,
            27420,
            27840,
            28200,
            28620,
            29040,
            29460,
            29940,
            30420,
            30840,
            31380,
            31680,
            32220,
            32640,
            33420,
            34080,
            34860,
            35700,
            36300,
            36960,
            37500,
            37980,
            38580,
            39360,
            40140,
            40980,
            41700,
            42420,
            43080,
            43680,
            44280,
            44880,
            45540,
            46260,
            46980,
            47640,
            48360,
            48960,
            49620,
            50220,
            50820,
            51540,
            52260,
            52920,
            53580,
            54180,
            54540,
            55020,
            55440,
            55860,
            56340,
            56760,
            57180,
            57600,
            58020,
            58440,
            58800,
            59340,
            59820,
            60300,
            60780,
            61200,
            61620,
            62100,
            62520,
            62940,
            63360,
            63780,
            64200,
            64620,
            65100,
            65580,
            66060,
            66540,
            66960,
            67380,
            67860,
            68460,
            69240,
            69960,
            70680,
            71400,
            72120,
            72720,
            73260,
            73860,
            74460,
            75180,
            75900,
            76560,
            77160,
            77820,
            78420,
            79020,
            79620,
            80460,
            81240,
            82080,
            83220,
            84360
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_3",
      "sourceRouteId": "vilnius_trol_3",
      "mode": "trolleybus",
      "shortName": "3",
      "longName": "Karoliniškės–Žvėrynas–Žirmūnai–Valakampiai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_3:0",
          "sourceRouteId": "vilnius_trol_3",
          "sourceShapeId": "vilnius_trol_3_a-b",
          "directionId": 0,
          "headsign": "Valakampiai",
          "directionName": "Karoliniškės–Žvėrynas–Žirmūnai–Valakampiai",
          "mode": "trolleybus",
          "routeShortName": "3",
          "routeLongName": "Karoliniškės–Žvėrynas–Žirmūnai–Valakampiai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4631.619,
              553.685,
              0
            ],
            [
              -4628.075,
              534.7,
              19.313
            ],
            [
              -4631.834,
              503.595,
              50.645
            ],
            [
              -4642.705,
              471.499,
              84.532
            ],
            [
              -4646.407,
              443.732,
              112.544
            ],
            [
              -4641.216,
              408.021,
              148.631
            ],
            [
              -4613.144,
              315.143,
              245.658
            ],
            [
              -4593.43,
              261.37,
              302.931
            ],
            [
              -4582.265,
              235.574,
              331.039
            ],
            [
              -4568.349,
              219.75,
              352.112
            ],
            [
              -4568.029,
              200.82,
              371.044
            ],
            [
              -4518.608,
              112.027,
              472.664
            ],
            [
              -4509.454,
              81.813,
              504.235
            ],
            [
              -4478.955,
              17.836,
              575.11
            ],
            [
              -4459.487,
              -12.556,
              611.203
            ],
            [
              -4426.085,
              -57.659,
              667.328
            ],
            [
              -4398.274,
              -90.421,
              710.302
            ],
            [
              -4367.713,
              -113.212,
              748.426
            ],
            [
              -4345.341,
              -124.73,
              773.589
            ],
            [
              -4335.314,
              -141.601,
              793.214
            ],
            [
              -4247.163,
              -227.726,
              916.454
            ],
            [
              -4197.821,
              -283.125,
              990.641
            ],
            [
              -4155.783,
              -350.644,
              1070.177
            ],
            [
              -4080.976,
              -462.146,
              1204.448
            ],
            [
              -4057.587,
              -489.267,
              1240.262
            ],
            [
              -4052.757,
              -508.276,
              1259.874
            ],
            [
              -3962.534,
              -660.121,
              1436.502
            ],
            [
              -3958.061,
              -662.425,
              1441.534
            ],
            [
              -3950.306,
              -661.447,
              1449.35
            ],
            [
              -3806.746,
              -600.485,
              1605.318
            ],
            [
              -3694.685,
              -571.263,
              1721.126
            ],
            [
              -3695.742,
              -557.886,
              1734.545
            ],
            [
              -3728.082,
              -489.418,
              1810.267
            ],
            [
              -3741.232,
              -466.925,
              1836.322
            ],
            [
              -3745.668,
              -462.395,
              1842.661
            ],
            [
              -3755.943,
              -459.99,
              1853.214
            ],
            [
              -3839.114,
              -496.394,
              1944.003
            ],
            [
              -3852.238,
              -509.525,
              1962.569
            ],
            [
              -3858.936,
              -523.881,
              1978.409
            ],
            [
              -3860.379,
              -532.761,
              1987.407
            ],
            [
              -3823.641,
              -607.984,
              2071.121
            ],
            [
              -3766.483,
              -732.543,
              2208.169
            ],
            [
              -3707.64,
              -908.34,
              2393.552
            ],
            [
              -3695.741,
              -928.584,
              2417.035
            ],
            [
              -3679.35,
              -950.021,
              2444.019
            ],
            [
              -3668.232,
              -978.044,
              2474.168
            ],
            [
              -3606.925,
              -1085.98,
              2598.299
            ],
            [
              -3586.062,
              -1109.72,
              2629.905
            ],
            [
              -3575.241,
              -1117.701,
              2643.351
            ],
            [
              -3510.568,
              -1143.319,
              2712.912
            ],
            [
              -3355.367,
              -1190.556,
              2875.143
            ],
            [
              -3108.49,
              -1230.499,
              3125.231
            ],
            [
              -3070.013,
              -1242.306,
              3165.478
            ],
            [
              -2879.155,
              -1277.94,
              3359.633
            ],
            [
              -2839.273,
              -1283.094,
              3399.847
            ],
            [
              -2787.087,
              -1285.125,
              3452.073
            ],
            [
              -2748.376,
              -1283.58,
              3490.815
            ],
            [
              -2714.118,
              -1278.617,
              3525.43
            ],
            [
              -2670.7,
              -1266.023,
              3570.638
            ],
            [
              -2624.585,
              -1246.798,
              3620.6
            ],
            [
              -2500.301,
              -1182.198,
              3760.67
            ],
            [
              -2469.831,
              -1172.717,
              3792.581
            ],
            [
              -2418.716,
              -1162.489,
              3844.71
            ],
            [
              -2392.231,
              -1159.617,
              3871.35
            ],
            [
              -2246.137,
              -1174.448,
              4018.195
            ],
            [
              -2236.291,
              -1164.604,
              4032.118
            ],
            [
              -2207.813,
              -1158.429,
              4061.258
            ],
            [
              -2189.628,
              -1150.959,
              4080.917
            ],
            [
              -2165.425,
              -1131.35,
              4112.067
            ],
            [
              -2151.107,
              -1123.812,
              4128.249
            ],
            [
              -2142.708,
              -1122.847,
              4136.703
            ],
            [
              -2107.685,
              -1111.223,
              4173.604
            ],
            [
              -2052.076,
              -1102.191,
              4229.942
            ],
            [
              -1847.467,
              -1053.508,
              4440.262
            ],
            [
              -1839.367,
              -996.878,
              4497.469
            ],
            [
              -1839.595,
              -973.496,
              4520.852
            ],
            [
              -1831.662,
              -962.505,
              4534.407
            ],
            [
              -1768.396,
              -596.269,
              4906.067
            ],
            [
              -1771.243,
              -575.067,
              4927.459
            ],
            [
              -1761.137,
              -550.756,
              4953.787
            ],
            [
              -1691.384,
              -146.787,
              5363.734
            ],
            [
              -1686.504,
              -90.1,
              5420.631
            ],
            [
              -1682.437,
              -79.04,
              5432.414
            ],
            [
              -1670.247,
              -10.238,
              5502.288
            ],
            [
              -1661.707,
              -1.484,
              5514.518
            ],
            [
              -1388.929,
              -38.642,
              5789.815
            ],
            [
              -1362.417,
              -34.664,
              5816.624
            ],
            [
              -1329.577,
              -37.478,
              5849.584
            ],
            [
              -1190.447,
              -11.028,
              5991.206
            ],
            [
              -1025.306,
              27.195,
              6160.712
            ],
            [
              -994.12,
              39.993,
              6194.422
            ],
            [
              -949.475,
              48.095,
              6239.797
            ],
            [
              -919.958,
              39.772,
              6270.465
            ],
            [
              -857.805,
              53.124,
              6334.036
            ],
            [
              -724.996,
              86.353,
              6470.939
            ],
            [
              -591.62,
              115.115,
              6607.381
            ],
            [
              -557.893,
              125.637,
              6642.711
            ],
            [
              -539.176,
              126.412,
              6661.444
            ],
            [
              -408.498,
              148.538,
              6793.982
            ],
            [
              -385.731,
              159.258,
              6819.147
            ],
            [
              -216.06,
              268.617,
              7021.007
            ],
            [
              -55.202,
              424.885,
              7245.273
            ],
            [
              -39.768,
              422.378,
              7260.909
            ],
            [
              18.234,
              348.963,
              7354.472
            ],
            [
              36.62,
              260.682,
              7444.647
            ],
            [
              56.855,
              132.292,
              7574.622
            ],
            [
              59.373,
              128.907,
              7578.841
            ],
            [
              70.978,
              128.695,
              7590.448
            ],
            [
              102.671,
              133.684,
              7622.532
            ],
            [
              116.145,
              94.475,
              7663.991
            ],
            [
              117.953,
              52.139,
              7706.365
            ],
            [
              129.077,
              -80.538,
              7839.508
            ],
            [
              129.194,
              -109.485,
              7868.455
            ],
            [
              121.85,
              -193.956,
              7953.245
            ],
            [
              119.866,
              -267.394,
              8026.709
            ],
            [
              179.196,
              -267.363,
              8086.039
            ],
            [
              270.197,
              -263.458,
              8177.123
            ],
            [
              305.837,
              -254.09,
              8213.974
            ],
            [
              342.264,
              -236.944,
              8254.235
            ],
            [
              410.165,
              -191.43,
              8335.979
            ],
            [
              461.971,
              -144.509,
              8405.875
            ],
            [
              541.549,
              -60.247,
              8521.774
            ],
            [
              554.165,
              -40.44,
              8545.258
            ],
            [
              588.702,
              -21.035,
              8584.873
            ],
            [
              628.519,
              4.952,
              8632.42
            ],
            [
              645.363,
              9.096,
              8649.767
            ],
            [
              675.04,
              9.665,
              8679.449
            ],
            [
              707.88,
              6.836,
              8712.41
            ],
            [
              925.597,
              -42.81,
              8935.716
            ],
            [
              1129.224,
              -156.774,
              9169.065
            ],
            [
              1143.99,
              -160.386,
              9184.267
            ],
            [
              1610.786,
              -514.132,
              9769.959
            ],
            [
              1615.737,
              -525.357,
              9782.226
            ],
            [
              1648.803,
              -550.462,
              9823.743
            ],
            [
              1662.944,
              -552.951,
              9838.101
            ],
            [
              1683.01,
              -548.871,
              9858.578
            ],
            [
              1698.481,
              -549.159,
              9874.052
            ],
            [
              1706.196,
              -550.415,
              9881.869
            ],
            [
              1713.204,
              -554.998,
              9890.242
            ],
            [
              1719.444,
              -566.247,
              9903.106
            ],
            [
              1721.402,
              -599.681,
              9936.597
            ],
            [
              1720.009,
              -605.221,
              9942.309
            ],
            [
              1712.088,
              -615.093,
              9954.967
            ],
            [
              1700.984,
              -622.679,
              9968.414
            ],
            [
              1684.224,
              -622.368,
              9985.177
            ],
            [
              1662.848,
              -627.537,
              10007.169
            ],
            [
              1583.13,
              -683.945,
              10104.826
            ],
            [
              1381.451,
              -814.909,
              10345.296
            ],
            [
              1363.471,
              -845.747,
              10380.993
            ],
            [
              1362.208,
              -879.121,
              10414.391
            ],
            [
              1367.85,
              -922.642,
              10458.276
            ],
            [
              1384.491,
              -964.14,
              10502.987
            ],
            [
              1464.439,
              -1103.664,
              10663.792
            ],
            [
              1480.223,
              -1121.768,
              10687.811
            ],
            [
              1488.813,
              -1145.306,
              10712.867
            ],
            [
              1537.374,
              -1238.606,
              10818.048
            ],
            [
              1587.871,
              -1366.453,
              10955.506
            ],
            [
              1626.598,
              -1502.988,
              11097.428
            ],
            [
              1647.564,
              -1589.097,
              11186.053
            ],
            [
              1670.179,
              -1759.844,
              11358.291
            ],
            [
              1676.751,
              -1787.797,
              11387.006
            ],
            [
              1672.408,
              -1813.321,
              11412.897
            ],
            [
              1677.37,
              -1962.589,
              11562.247
            ],
            [
              1684.587,
              -2475.93,
              12075.639
            ],
            [
              1691.063,
              -2612.98,
              12212.842
            ],
            [
              1696.386,
              -2638.684,
              12239.091
            ],
            [
              1690.652,
              -2669.748,
              12270.68
            ],
            [
              1690.731,
              -2873.474,
              12474.406
            ],
            [
              1700.851,
              -3126.37,
              12727.504
            ],
            [
              1709.563,
              -3177.741,
              12779.609
            ],
            [
              1701.896,
              -3208.77,
              12811.57
            ],
            [
              1697.306,
              -3247.648,
              12850.719
            ],
            [
              1679.831,
              -3286.287,
              12893.125
            ],
            [
              1593.247,
              -3437.193,
              13067.106
            ],
            [
              1582.257,
              -3473.726,
              13105.257
            ],
            [
              1566.424,
              -3493.47,
              13130.565
            ],
            [
              1520.486,
              -3572.771,
              13222.211
            ],
            [
              1584,
              -3657.444,
              13328.058
            ],
            [
              1660.25,
              -3750.148,
              13448.091
            ],
            [
              1866.498,
              -3989.997,
              13764.423
            ],
            [
              1889.999,
              -4008.247,
              13794.179
            ],
            [
              2239.227,
              -4387.713,
              14309.887
            ],
            [
              2241.845,
              -4385.536,
              14313.292
            ],
            [
              2278.681,
              -4414.057,
              14359.879
            ],
            [
              2318.758,
              -4441.526,
              14408.466
            ],
            [
              2353.827,
              -4461.109,
              14448.632
            ],
            [
              2406.203,
              -4485.47,
              14506.396
            ],
            [
              2429.992,
              -4488.143,
              14530.335
            ],
            [
              2442.271,
              -4486.147,
              14542.775
            ],
            [
              2441.69,
              -4482.796,
              14546.176
            ],
            [
              2454.801,
              -4470.797,
              14563.95
            ],
            [
              2456.963,
              -4458.592,
              14576.345
            ],
            [
              2455.031,
              -4458.555,
              14578.277
            ],
            [
              2441.777,
              -4443.834,
              14598.086
            ],
            [
              2402.241,
              -4421.94,
              14643.28
            ],
            [
              2384.311,
              -4416.038,
              14662.156
            ],
            [
              2354.704,
              -4414.369,
              14691.81
            ],
            [
              2298.04,
              -4481.215,
              14779.441
            ],
            [
              2194.798,
              -4558.323,
              14908.3
            ],
            [
              2023.954,
              -4667.567,
              15111.085
            ],
            [
              1942.804,
              -4735.073,
              15216.643
            ],
            [
              1867.702,
              -4789.335,
              15309.296
            ],
            [
              1634.84,
              -4874.059,
              15557.092
            ],
            [
              1419.978,
              -4961.355,
              15789.011
            ],
            [
              1390.251,
              -4966.37,
              15819.158
            ],
            [
              1372.759,
              -4971.612,
              15837.418
            ],
            [
              1253.284,
              -4952.7,
              15958.381
            ],
            [
              1216.637,
              -4948.682,
              15995.247
            ],
            [
              1176.209,
              -4940.141,
              16036.568
            ],
            [
              1118.975,
              -4934.63,
              16094.067
            ],
            [
              1098.764,
              -4947.615,
              16118.09
            ],
            [
              1088.192,
              -4961.892,
              16135.855
            ],
            [
              1084.123,
              -4972.95,
              16147.637
            ],
            [
              1006.146,
              -5218.651,
              16405.415
            ],
            [
              964.277,
              -5358.147,
              16551.059
            ],
            [
              953.825,
              -5435.882,
              16629.493
            ],
            [
              918.816,
              -5587.751,
              16785.346
            ],
            [
              921.738,
              -5743.66,
              16941.282
            ],
            [
              940.076,
              -5831.945,
              17031.451
            ],
            [
              974.169,
              -5973.957,
              17177.498
            ],
            [
              972.745,
              -6016.234,
              17219.799
            ],
            [
              988.868,
              -6049.929,
              17257.153
            ],
            [
              982.245,
              -6059.826,
              17269.062
            ],
            [
              959.69,
              -6060.523,
              17291.628
            ],
            [
              954.724,
              -6050.412,
              17302.893
            ],
            [
              952.792,
              -6050.376,
              17304.824
            ],
            [
              952.957,
              -6041.473,
              17313.729
            ],
            [
              957.71,
              -6028.202,
              17327.826
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5924",
              "position": {
                "x": -4631.834,
                "z": 503.595
              },
              "distanceAlongShapeM": 50.645,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:351",
              "position": {
                "x": -4568.349,
                "z": 219.75
              },
              "distanceAlongShapeM": 352.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6400",
              "position": {
                "x": -4345.341,
                "z": -124.73
              },
              "distanceAlongShapeM": 773.589,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:596",
              "position": {
                "x": -4057.587,
                "z": -489.267
              },
              "distanceAlongShapeM": 1240.262,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 2444.019,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 3125.231,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6430",
              "position": {
                "x": -2107.685,
                "z": -1111.223
              },
              "distanceAlongShapeM": 4173.604,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6433",
              "position": {
                "x": -1839.595,
                "z": -973.496
              },
              "distanceAlongShapeM": 4520.852,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6434",
              "position": {
                "x": -1771.243,
                "z": -575.067
              },
              "distanceAlongShapeM": 4927.459,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6437",
              "position": {
                "x": -1686.504,
                "z": -90.1
              },
              "distanceAlongShapeM": 5420.631,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:18852",
              "position": {
                "x": -1457.753,
                "z": -28.505
              },
              "distanceAlongShapeM": 5720.252,
              "shapeOffsetM": 0.755,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5881",
              "position": {
                "x": -949.475,
                "z": 48.095
              },
              "distanceAlongShapeM": 6239.797,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 6642.711,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 7354.472,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 7663.991,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 8712.41,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1950,
              "departureOffsetSeconds": 1950
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 9184.267,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2070,
              "departureOffsetSeconds": 2070
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 9769.959,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2130,
              "departureOffsetSeconds": 2130
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 10687.811,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2370,
              "departureOffsetSeconds": 2370
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 11387.006,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2490,
              "departureOffsetSeconds": 2490
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 12239.091,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 12779.609,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:6873",
              "position": {
                "x": 1553.844,
                "z": -3615.694
              },
              "distanceAlongShapeM": 13276.564,
              "shapeOffsetM": 0.929,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:6874",
              "position": {
                "x": 1889.999,
                "z": -4008.247
              },
              "distanceAlongShapeM": 13794.179,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:16147",
              "position": {
                "x": 2194.798,
                "z": -4558.323
              },
              "distanceAlongShapeM": 14908.3,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:16148",
              "position": {
                "x": 1942.804,
                "z": -4735.073
              },
              "distanceAlongShapeM": 15216.643,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:16145",
              "position": {
                "x": 1216.637,
                "z": -4948.682
              },
              "distanceAlongShapeM": 15995.247,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3420,
              "departureOffsetSeconds": 3420
            },
            {
              "stopId": "judu:stop:16149",
              "position": {
                "x": 953.825,
                "z": -5435.882
              },
              "distanceAlongShapeM": 16629.493,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3540,
              "departureOffsetSeconds": 3540
            },
            {
              "stopId": "judu:stop:6104",
              "position": {
                "x": 957.71,
                "z": -6028.202
              },
              "distanceAlongShapeM": 17327.826,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3660,
              "departureOffsetSeconds": 3660
            }
          ],
          "departuresSeconds": [
            36600,
            38040,
            39180,
            40080,
            40800,
            41400,
            42360,
            43440,
            44760,
            46080,
            47220,
            48360,
            49260,
            50640,
            51840,
            52980,
            53820,
            54540,
            55440,
            56580,
            57600,
            59100,
            60300,
            61680,
            62580,
            63540,
            64680,
            66840,
            68640,
            70440
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_3:1",
          "sourceRouteId": "vilnius_trol_3",
          "sourceShapeId": "vilnius_trol_3_b-a",
          "directionId": 1,
          "headsign": "Karoliniškės",
          "directionName": "Valakampiai–Žirmūnai–Žvėrynas–Karoliniškės",
          "mode": "trolleybus",
          "routeShortName": "3",
          "routeLongName": "Karoliniškės–Žvėrynas–Žirmūnai–Valakampiai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              957.71,
              -6028.202,
              0
            ],
            [
              969.464,
              -6019.513,
              14.617
            ],
            [
              971.662,
              -6005.081,
              29.215
            ],
            [
              920.286,
              -5752.539,
              286.93
            ],
            [
              917.22,
              -5604.42,
              435.08
            ],
            [
              929.255,
              -5545.64,
              495.08
            ],
            [
              940.974,
              -5469.042,
              572.569
            ],
            [
              967.53,
              -5321.47,
              722.512
            ],
            [
              978.203,
              -5301.629,
              745.042
            ],
            [
              1054.122,
              -5062.569,
              995.867
            ],
            [
              1069.297,
              -5008.3,
              1052.218
            ],
            [
              1070.146,
              -4997.183,
              1063.367
            ],
            [
              1086.945,
              -4959.643,
              1104.494
            ],
            [
              1095.544,
              -4947.556,
              1119.327
            ],
            [
              1104.704,
              -4939.932,
              1131.245
            ],
            [
              1118.975,
              -4934.63,
              1146.469
            ],
            [
              1142.2,
              -4932.833,
              1169.764
            ],
            [
              1277.818,
              -4949.814,
              1306.441
            ],
            [
              1313.697,
              -4960.498,
              1343.876
            ],
            [
              1340.018,
              -4965.439,
              1370.658
            ],
            [
              1389.607,
              -4966.358,
              1420.254
            ],
            [
              1429.741,
              -4955.97,
              1461.712
            ],
            [
              1621.316,
              -4873.807,
              1670.162
            ],
            [
              1827.524,
              -4801.945,
              1888.533
            ],
            [
              1854.801,
              -4790.208,
              1918.228
            ],
            [
              1888.913,
              -4757.446,
              1965.525
            ],
            [
              1911.039,
              -4745.613,
              1990.616
            ],
            [
              2211.295,
              -4537.48,
              2355.956
            ],
            [
              2213.373,
              -4529.726,
              2363.983
            ],
            [
              2277.782,
              -4496.421,
              2436.494
            ],
            [
              2199.275,
              -4353.568,
              2599.498
            ],
            [
              1944.045,
              -4081.617,
              2972.458
            ],
            [
              1863.859,
              -3993.288,
              3091.756
            ],
            [
              1811.224,
              -3947.777,
              3161.338
            ],
            [
              1800.044,
              -3925.303,
              3186.439
            ],
            [
              1667.691,
              -3765.872,
              3393.649
            ],
            [
              1499.686,
              -3582.404,
              3642.417
            ],
            [
              1509.056,
              -3563.653,
              3663.38
            ],
            [
              1545.21,
              -3525.36,
              3716.043
            ],
            [
              1607.644,
              -3390.704,
              3864.47
            ],
            [
              1620.009,
              -3384.254,
              3878.415
            ],
            [
              1689.847,
              -3267.548,
              4014.421
            ],
            [
              1697.306,
              -3247.648,
              4035.673
            ],
            [
              1696.944,
              -3128.524,
              4154.798
            ],
            [
              1687.839,
              -3098.296,
              4186.367
            ],
            [
              1693.427,
              -3075.022,
              4210.303
            ],
            [
              1690.731,
              -2873.474,
              4411.869
            ],
            [
              1684.353,
              -2661.838,
              4623.601
            ],
            [
              1677.945,
              -2590.471,
              4695.255
            ],
            [
              1676.674,
              -2554.823,
              4730.925
            ],
            [
              1670.083,
              -2527.983,
              4758.563
            ],
            [
              1679.06,
              -2495.866,
              4791.911
            ],
            [
              1670.601,
              -2049.296,
              5238.561
            ],
            [
              1665.105,
              -1963.474,
              5324.559
            ],
            [
              1665.702,
              -1896.69,
              5391.346
            ],
            [
              1663.09,
              -1759.712,
              5528.348
            ],
            [
              1653.419,
              -1725.022,
              5564.361
            ],
            [
              1660.464,
              -1692.869,
              5597.277
            ],
            [
              1642.718,
              -1572.308,
              5719.137
            ],
            [
              1626.598,
              -1502.988,
              5790.307
            ],
            [
              1590.763,
              -1384.318,
              5914.269
            ],
            [
              1541.473,
              -1260.946,
              6047.123
            ],
            [
              1439.941,
              -1068.699,
              6264.534
            ],
            [
              1418.417,
              -1047.149,
              6294.992
            ],
            [
              1413.029,
              -1024.784,
              6317.997
            ],
            [
              1381.79,
              -970.77,
              6380.394
            ],
            [
              1372.327,
              -959.462,
              6395.139
            ],
            [
              1333.941,
              -943.166,
              6436.841
            ],
            [
              1307.513,
              -942.677,
              6463.273
            ],
            [
              1293.291,
              -944.641,
              6477.629
            ],
            [
              1278.507,
              -942.141,
              6492.623
            ],
            [
              1268.297,
              -936.386,
              6504.344
            ],
            [
              1257.545,
              -925.054,
              6519.965
            ],
            [
              1253.197,
              -916.068,
              6529.947
            ],
            [
              1249.597,
              -901.529,
              6544.925
            ],
            [
              1249.57,
              -868.132,
              6578.323
            ],
            [
              1251.689,
              -858.152,
              6588.525
            ],
            [
              1263.58,
              -842.786,
              6607.954
            ],
            [
              1271.438,
              -836.252,
              6618.175
            ],
            [
              1287.032,
              -829.861,
              6635.027
            ],
            [
              1306.39,
              -829.106,
              6654.4
            ],
            [
              1381.451,
              -814.909,
              6730.792
            ],
            [
              1598.931,
              -666.427,
              6994.126
            ],
            [
              1632.324,
              -639.216,
              7037.201
            ],
            [
              1644.195,
              -624.964,
              7055.75
            ],
            [
              1650.286,
              -609.492,
              7072.378
            ],
            [
              1647.435,
              -589.4,
              7092.67
            ],
            [
              1641.361,
              -569.249,
              7113.717
            ],
            [
              1626.241,
              -550.043,
              7138.161
            ],
            [
              1608.96,
              -543.043,
              7156.806
            ],
            [
              1227.773,
              -233.181,
              7648.047
            ],
            [
              1060.09,
              -128.781,
              7845.574
            ],
            [
              1042.305,
              -113.981,
              7868.711
            ],
            [
              992.552,
              -84.12,
              7926.738
            ],
            [
              920.398,
              -44.941,
              8008.843
            ],
            [
              797.689,
              -19.306,
              8134.201
            ],
            [
              670.384,
              1.958,
              8263.269
            ],
            [
              652.936,
              0.051,
              8280.821
            ],
            [
              630.873,
              -7.336,
              8304.088
            ],
            [
              604.636,
              -31.346,
              8339.653
            ],
            [
              564.962,
              -49.544,
              8383.301
            ],
            [
              476.44,
              -129.188,
              8502.379
            ],
            [
              402.286,
              -199.078,
              8604.277
            ],
            [
              346.776,
              -237.026,
              8671.519
            ],
            [
              291.552,
              -259.395,
              8731.101
            ],
            [
              265.664,
              -264.488,
              8757.486
            ],
            [
              119.684,
              -277.409,
              8904.037
            ],
            [
              35.151,
              -280.322,
              8988.62
            ],
            [
              26.146,
              -279.045,
              8997.715
            ],
            [
              15.43,
              -265.491,
              9014.993
            ],
            [
              14.363,
              -253.226,
              9027.305
            ],
            [
              16.439,
              -245.471,
              9035.333
            ],
            [
              45.916,
              -220.403,
              9074.027
            ],
            [
              103.215,
              -190.277,
              9138.764
            ],
            [
              127.382,
              -102.772,
              9229.544
            ],
            [
              121.848,
              -52.576,
              9280.045
            ],
            [
              115.041,
              -36.866,
              9297.166
            ],
            [
              117.583,
              -3.516,
              9330.613
            ],
            [
              102.671,
              133.684,
              9468.621
            ],
            [
              63.181,
              125.497,
              9508.951
            ],
            [
              59.312,
              125.568,
              9512.82
            ],
            [
              57.419,
              127.829,
              9515.769
            ],
            [
              31.786,
              278.582,
              9668.686
            ],
            [
              4.856,
              358.112,
              9752.652
            ],
            [
              -8.924,
              380.627,
              9779.049
            ],
            [
              -39.768,
              422.378,
              9830.958
            ],
            [
              -46.8,
              425.846,
              9838.798
            ],
            [
              -52.603,
              425.951,
              9844.602
            ],
            [
              -86.677,
              396.514,
              9889.631
            ],
            [
              -97.297,
              380.009,
              9909.258
            ],
            [
              -191.175,
              289.316,
              10039.789
            ],
            [
              -216.06,
              268.617,
              10072.157
            ],
            [
              -386.375,
              159.27,
              10274.553
            ],
            [
              -408.498,
              148.538,
              10299.141
            ],
            [
              -583.944,
              111.636,
              10478.425
            ],
            [
              -658.953,
              100.746,
              10554.221
            ],
            [
              -724.996,
              86.353,
              10621.814
            ],
            [
              -736.157,
              75.422,
              10637.436
            ],
            [
              -743.833,
              78.9,
              10645.864
            ],
            [
              -798.875,
              66.534,
              10702.278
            ],
            [
              -863.023,
              49.879,
              10768.553
            ],
            [
              -870.86,
              44.454,
              10778.084
            ],
            [
              -877.911,
              46.807,
              10785.518
            ],
            [
              -930.978,
              36.63,
              10839.552
            ],
            [
              -998.108,
              33.385,
              10906.76
            ],
            [
              -1226.73,
              -20.397,
              11141.623
            ],
            [
              -1327.722,
              -41.964,
              11244.892
            ],
            [
              -1378.268,
              -55.531,
              11297.227
            ],
            [
              -1438.145,
              -50.007,
              11357.359
            ],
            [
              -1471.431,
              -36.053,
              11393.451
            ],
            [
              -1661.707,
              -1.484,
              11586.842
            ],
            [
              -1691.384,
              -146.787,
              11735.144
            ],
            [
              -1712.987,
              -273.309,
              11863.497
            ],
            [
              -1710.567,
              -282.258,
              11872.767
            ],
            [
              -1719.483,
              -312.156,
              11903.967
            ],
            [
              -1768.396,
              -596.269,
              12192.259
            ],
            [
              -1770.261,
              -628.519,
              12224.563
            ],
            [
              -1778.412,
              -651.752,
              12249.184
            ],
            [
              -1847.467,
              -1053.508,
              12656.832
            ],
            [
              -1903.255,
              -1072.553,
              12715.782
            ],
            [
              -1911.753,
              -1079.081,
              12726.498
            ],
            [
              -1954.393,
              -1083.889,
              12769.408
            ],
            [
              -2142.708,
              -1122.847,
              12961.71
            ],
            [
              -2154.408,
              -1128.206,
              12974.579
            ],
            [
              -2189.766,
              -1158.749,
              13021.302
            ],
            [
              -2202.091,
              -1162.983,
              13034.335
            ],
            [
              -2218.205,
              -1162.698,
              13050.451
            ],
            [
              -2227.932,
              -1165.865,
              13060.681
            ],
            [
              -2246.137,
              -1174.448,
              13080.807
            ],
            [
              -2255.397,
              -1187.643,
              13096.927
            ],
            [
              -2267.097,
              -1193.002,
              13109.796
            ],
            [
              -2295.924,
              -1182.472,
              13140.486
            ],
            [
              -2392.506,
              -1175.197,
              13237.342
            ],
            [
              -2431.277,
              -1180.078,
              13276.418
            ],
            [
              -2478.584,
              -1193.714,
              13325.651
            ],
            [
              -2533.196,
              -1219.467,
              13386.031
            ],
            [
              -2617.204,
              -1266.966,
              13482.538
            ],
            [
              -2663.944,
              -1285.067,
              13532.66
            ],
            [
              -2710.565,
              -1296.491,
              13580.66
            ],
            [
              -2762.303,
              -1305.599,
              13633.194
            ],
            [
              -2806.189,
              -1308.166,
              13677.155
            ],
            [
              -2858.961,
              -1302.785,
              13730.201
            ],
            [
              -3085.169,
              -1260.965,
              13960.242
            ],
            [
              -3140.52,
              -1255.542,
              14015.858
            ],
            [
              -3159.719,
              -1247.413,
              14036.707
            ],
            [
              -3359.526,
              -1207.182,
              14240.524
            ],
            [
              -3495.953,
              -1192.555,
              14377.733
            ],
            [
              -3569.469,
              -1193.5,
              14451.255
            ],
            [
              -3626.266,
              -1196.964,
              14508.157
            ],
            [
              -3657.704,
              -1114.039,
              14596.841
            ],
            [
              -3680.758,
              -1067.996,
              14648.333
            ],
            [
              -3686.114,
              -1042.299,
              14674.582
            ],
            [
              -3720.918,
              -930.373,
              14791.795
            ],
            [
              -3751.541,
              -837.444,
              14889.64
            ],
            [
              -3761.526,
              -818.346,
              14911.19
            ],
            [
              -3766.218,
              -791.548,
              14938.397
            ],
            [
              -3793.988,
              -719.82,
              15015.312
            ],
            [
              -3843.779,
              -616.54,
              15129.968
            ],
            [
              -3881.258,
              -546.871,
              15209.079
            ],
            [
              -3892.746,
              -539.992,
              15222.468
            ],
            [
              -3915.211,
              -534.036,
              15245.709
            ],
            [
              -4013.321,
              -576.864,
              15352.76
            ],
            [
              -4103.192,
              -441.723,
              15515.055
            ],
            [
              -4126.033,
              -420.177,
              15546.455
            ],
            [
              -4131.488,
              -400.045,
              15567.313
            ],
            [
              -4155.783,
              -350.644,
              15622.365
            ],
            [
              -4237.762,
              -243.473,
              15757.295
            ],
            [
              -4352.037,
              -139.086,
              15912.07
            ],
            [
              -4426.18,
              -63.224,
              16018.148
            ],
            [
              -4449.727,
              -45.007,
              16047.919
            ],
            [
              -4460.208,
              -16.996,
              16077.826
            ],
            [
              -4494.728,
              38.145,
              16142.881
            ],
            [
              -4530.309,
              106.663,
              16220.086
            ],
            [
              -4592.389,
              246.88,
              16373.433
            ],
            [
              -4608.183,
              266.076,
              16398.29
            ],
            [
              -4641.216,
              408.021,
              16544.028
            ],
            [
              -4663.089,
              486.32,
              16625.325
            ],
            [
              -4661.513,
              502.991,
              16642.07
            ],
            [
              -4670.535,
              540.995,
              16681.13
            ],
            [
              -4686.12,
              572.432,
              16716.219
            ],
            [
              -4701.876,
              593.853,
              16742.811
            ],
            [
              -4704.928,
              603.925,
              16753.334
            ],
            [
              -4702.177,
              613.896,
              16763.678
            ],
            [
              -4693.036,
              620.419,
              16774.908
            ],
            [
              -4675.626,
              620.12,
              16792.32
            ],
            [
              -4661.537,
              614.312,
              16807.56
            ],
            [
              -4631.619,
              553.685,
              16875.167
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6104",
              "position": {
                "x": 957.71,
                "z": -6028.202
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -330,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6106",
              "position": {
                "x": 967.53,
                "z": -5321.47
              },
              "distanceAlongShapeM": 722.512,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6107",
              "position": {
                "x": 1070.146,
                "z": -4997.183
              },
              "distanceAlongShapeM": 1063.367,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6109",
              "position": {
                "x": 1888.913,
                "z": -4757.446
              },
              "distanceAlongShapeM": 1965.525,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6110",
              "position": {
                "x": 2213.373,
                "z": -4529.726
              },
              "distanceAlongShapeM": 2363.983,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5494",
              "position": {
                "x": 1811.224,
                "z": -3947.777
              },
              "distanceAlongShapeM": 3161.338,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 3864.47,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 4186.367,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 4758.563,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 5564.361,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 6294.992,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 7156.806,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 7845.574,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 8339.653,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 9297.166,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 9909.258,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5936",
              "position": {
                "x": -736.157,
                "z": 75.422
              },
              "distanceAlongShapeM": 10637.436,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:19193",
              "position": {
                "x": -870.86,
                "z": 44.454
              },
              "distanceAlongShapeM": 10778.084,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6438",
              "position": {
                "x": -1438.145,
                "z": -50.007
              },
              "distanceAlongShapeM": 11357.359,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:6436",
              "position": {
                "x": -1710.567,
                "z": -282.258
              },
              "distanceAlongShapeM": 11872.767,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:6435",
              "position": {
                "x": -1770.261,
                "z": -628.519
              },
              "distanceAlongShapeM": 12224.563,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:6432",
              "position": {
                "x": -1911.753,
                "z": -1079.081
              },
              "distanceAlongShapeM": 12726.498,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2850,
              "departureOffsetSeconds": 2850
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 14015.858,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 14648.333,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 14911.19,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            },
            {
              "stopId": "judu:stop:5915",
              "position": {
                "x": -4126.033,
                "z": -420.177
              },
              "distanceAlongShapeM": 15546.455,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3420,
              "departureOffsetSeconds": 3420
            },
            {
              "stopId": "judu:stop:5919",
              "position": {
                "x": -4449.727,
                "z": -45.007
              },
              "distanceAlongShapeM": 16047.919,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3540,
              "departureOffsetSeconds": 3540
            },
            {
              "stopId": "judu:stop:5920",
              "position": {
                "x": -4608.183,
                "z": 266.076
              },
              "distanceAlongShapeM": 16398.29,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3600,
              "departureOffsetSeconds": 3600
            },
            {
              "stopId": "judu:stop:5923",
              "position": {
                "x": -4663.089,
                "z": 486.32
              },
              "distanceAlongShapeM": 16625.325,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3660,
              "departureOffsetSeconds": 3660
            }
          ],
          "departuresSeconds": [
            40560,
            42060,
            43080,
            44040,
            44820,
            45420,
            46380,
            47460,
            48720,
            50220,
            51120,
            52320,
            53220,
            54660,
            55860,
            57120,
            58020,
            58920,
            59940,
            61320,
            62100,
            63660,
            64920,
            66300,
            67200,
            68100,
            69060,
            70920,
            72600,
            74220
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_4",
      "sourceRouteId": "vilnius_trol_4",
      "mode": "trolleybus",
      "shortName": "4",
      "longName": "Antakalnis–Centras–Žemieji Paneriai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_4:0",
          "sourceRouteId": "vilnius_trol_4",
          "sourceShapeId": "vilnius_trol_4_a-b",
          "directionId": 0,
          "headsign": "Žemieji Paneriai",
          "directionName": "Antakalnis–Centras–Žemieji Paneriai",
          "mode": "trolleybus",
          "routeShortName": "4",
          "routeLongName": "Antakalnis–Centras–Žemieji Paneriai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2551.422,
              -3889.265,
              0
            ],
            [
              2499.38,
              -3984.027,
              108.112
            ],
            [
              2494.143,
              -3988.382,
              114.923
            ],
            [
              2481.156,
              -3993.705,
              128.959
            ],
            [
              2470.227,
              -3992.386,
              139.967
            ],
            [
              2459.381,
              -3986.616,
              152.253
            ],
            [
              2448.681,
              -3973.056,
              169.526
            ],
            [
              2446.334,
              -3960.766,
              182.038
            ],
            [
              2458.099,
              -3917.57,
              226.807
            ],
            [
              2495.249,
              -3757.959,
              390.685
            ],
            [
              2503.087,
              -3718.029,
              431.377
            ],
            [
              2508.663,
              -3661.358,
              488.322
            ],
            [
              2463.001,
              -3519.117,
              637.712
            ],
            [
              2462.068,
              -3500.174,
              656.678
            ],
            [
              2434.072,
              -3309.282,
              849.612
            ],
            [
              2425.512,
              -3284.63,
              875.708
            ],
            [
              2426.678,
              -3256.82,
              903.542
            ],
            [
              2373.189,
              -2912.935,
              1251.562
            ],
            [
              2328.687,
              -2639.354,
              1528.739
            ],
            [
              2308.053,
              -2536.548,
              1633.596
            ],
            [
              2296.913,
              -2511.848,
              1660.692
            ],
            [
              2295.002,
              -2476.188,
              1696.403
            ],
            [
              2274.24,
              -2414.57,
              1761.424
            ],
            [
              2234.812,
              -2316.979,
              1866.679
            ],
            [
              2177.257,
              -2188.992,
              2007.012
            ],
            [
              2082.177,
              -1964.565,
              2250.749
            ],
            [
              2062.178,
              -1896.283,
              2321.899
            ],
            [
              2050.931,
              -1842.637,
              2376.711
            ],
            [
              2043.488,
              -1826.913,
              2394.108
            ],
            [
              2041.617,
              -1789.027,
              2432.04
            ],
            [
              1994.191,
              -1532.095,
              2693.312
            ],
            [
              1983.608,
              -1511.859,
              2716.148
            ],
            [
              1983.607,
              -1477.349,
              2750.659
            ],
            [
              1966.491,
              -1323.401,
              2905.555
            ],
            [
              1951.301,
              -996.936,
              3232.373
            ],
            [
              1944.999,
              -954.515,
              3275.26
            ],
            [
              1921.875,
              -915.121,
              3320.939
            ],
            [
              1920.773,
              -905.081,
              3331.039
            ],
            [
              1905.301,
              -870.282,
              3369.123
            ],
            [
              1842.792,
              -798.983,
              3463.943
            ],
            [
              1722.529,
              -643.118,
              3660.811
            ],
            [
              1706.703,
              -627.239,
              3683.231
            ],
            [
              1655.278,
              -618.49,
              3735.395
            ],
            [
              1647.146,
              -604.98,
              3751.163
            ],
            [
              1647.435,
              -589.4,
              3766.746
            ],
            [
              1641.361,
              -569.249,
              3787.793
            ],
            [
              1626.241,
              -550.043,
              3812.236
            ],
            [
              1608.96,
              -543.043,
              3830.881
            ],
            [
              1227.773,
              -233.181,
              4322.122
            ],
            [
              1060.09,
              -128.781,
              4519.649
            ],
            [
              1042.305,
              -113.981,
              4542.787
            ],
            [
              992.552,
              -84.12,
              4600.813
            ],
            [
              920.398,
              -44.941,
              4682.918
            ],
            [
              797.689,
              -19.306,
              4808.276
            ],
            [
              670.384,
              1.958,
              4937.345
            ],
            [
              652.936,
              0.051,
              4954.896
            ],
            [
              630.873,
              -7.336,
              4978.164
            ],
            [
              604.636,
              -31.346,
              5013.729
            ],
            [
              564.962,
              -49.544,
              5057.377
            ],
            [
              476.44,
              -129.188,
              5176.454
            ],
            [
              402.286,
              -199.078,
              5278.353
            ],
            [
              346.776,
              -237.026,
              5345.594
            ],
            [
              291.552,
              -259.395,
              5405.177
            ],
            [
              265.664,
              -264.488,
              5431.562
            ],
            [
              119.684,
              -277.409,
              5578.112
            ],
            [
              35.151,
              -280.322,
              5662.695
            ],
            [
              -101.904,
              -298.979,
              5801.014
            ],
            [
              -140.08,
              -306.078,
              5839.845
            ],
            [
              -153.095,
              -312.52,
              5854.367
            ],
            [
              -191.836,
              -315.156,
              5893.197
            ],
            [
              -244.276,
              -326.45,
              5946.839
            ],
            [
              -305.298,
              -348.72,
              6011.798
            ],
            [
              -413.017,
              -421.354,
              6141.718
            ],
            [
              -450.326,
              -380.602,
              6196.969
            ],
            [
              -465.596,
              -369.193,
              6216.031
            ],
            [
              -470.512,
              -355.745,
              6230.349
            ],
            [
              -508.466,
              -314.982,
              6286.046
            ],
            [
              -611.52,
              -58.189,
              6562.745
            ],
            [
              -615.308,
              -53.668,
              6568.644
            ],
            [
              -625.745,
              -24.535,
              6599.589
            ],
            [
              -646.921,
              17.037,
              6646.244
            ],
            [
              -652.524,
              63.893,
              6693.435
            ],
            [
              -682.331,
              234.755,
              6866.877
            ],
            [
              -830.115,
              444.481,
              7123.441
            ],
            [
              -843.054,
              478.111,
              7159.474
            ],
            [
              -829.673,
              683.817,
              7365.615
            ],
            [
              -833.364,
              729.525,
              7411.472
            ],
            [
              -839.916,
              759.701,
              7442.35
            ],
            [
              -844.854,
              772.035,
              7455.637
            ],
            [
              -845.743,
              794.315,
              7477.935
            ],
            [
              -856.909,
              819.008,
              7505.034
            ],
            [
              -958.695,
              862.029,
              7615.539
            ],
            [
              -1094.5,
              914.565,
              7761.151
            ],
            [
              -1148.512,
              960.063,
              7831.773
            ],
            [
              -1168.303,
              971.551,
              7854.656
            ],
            [
              -1183.42,
              991.86,
              7879.974
            ],
            [
              -1484.246,
              1267.759,
              8288.16
            ],
            [
              -1502.183,
              1274.758,
              8307.415
            ],
            [
              -1524.902,
              1302.995,
              8343.657
            ],
            [
              -1970.62,
              1705.012,
              8943.892
            ],
            [
              -1985.783,
              1723.093,
              8967.489
            ],
            [
              -2263.842,
              1978.495,
              9345.043
            ],
            [
              -2290.557,
              2000.118,
              9379.413
            ],
            [
              -2318.992,
              2034.018,
              9423.659
            ],
            [
              -2425.036,
              2130.514,
              9567.036
            ],
            [
              -2441.629,
              2140.826,
              9586.572
            ],
            [
              -2464.869,
              2140.123,
              9609.823
            ],
            [
              -2491.57,
              2126.123,
              9639.971
            ],
            [
              -2514.888,
              2120.968,
              9663.853
            ],
            [
              -2528.453,
              2120.094,
              9677.446
            ],
            [
              -2551.595,
              2124.955,
              9701.093
            ],
            [
              -2561.836,
              2129.588,
              9712.334
            ],
            [
              -2579.681,
              2142.148,
              9734.155
            ],
            [
              -2585.368,
              2148.928,
              9743.004
            ],
            [
              -2589.062,
              2159.012,
              9753.743
            ],
            [
              -2606.026,
              2184.914,
              9784.707
            ],
            [
              -2610.326,
              2197.235,
              9797.757
            ],
            [
              -2613.804,
              2219.561,
              9820.351
            ],
            [
              -2614.214,
              2232.927,
              9833.724
            ],
            [
              -2611.32,
              2250.687,
              9851.718
            ],
            [
              -2605.925,
              2263.95,
              9866.037
            ],
            [
              -2595.955,
              2280.473,
              9885.334
            ],
            [
              -2588.136,
              2284.788,
              9894.265
            ],
            [
              -2577.443,
              2305.751,
              9917.797
            ],
            [
              -2591.532,
              2385.037,
              9998.325
            ],
            [
              -2598.371,
              2436.365,
              10050.107
            ],
            [
              -2602.959,
              2542.201,
              10156.042
            ],
            [
              -2607.706,
              2602.398,
              10216.426
            ],
            [
              -2619.569,
              2661.607,
              10276.812
            ],
            [
              -2672.012,
              2798.342,
              10423.259
            ],
            [
              -2693.846,
              2841.028,
              10471.205
            ],
            [
              -2698.439,
              2873.392,
              10503.894
            ],
            [
              -2831.804,
              3253.114,
              10906.355
            ],
            [
              -2853.662,
              3294.686,
              10953.323
            ],
            [
              -2870.652,
              3319.475,
              10983.375
            ],
            [
              -2888.502,
              3332.034,
              11005.201
            ],
            [
              -2904.222,
              3355.687,
              11033.601
            ],
            [
              -3126.24,
              3576.651,
              11346.838
            ],
            [
              -3256.351,
              3702.491,
              11527.848
            ],
            [
              -3334.924,
              3786.24,
              11642.685
            ],
            [
              -3406.008,
              3855.385,
              11741.851
            ],
            [
              -3427.01,
              3872.449,
              11768.912
            ],
            [
              -3454.8,
              3907.442,
              11813.598
            ],
            [
              -3626.746,
              4078.528,
              12056.158
            ],
            [
              -3781.512,
              4235.95,
              12276.916
            ],
            [
              -3884.317,
              4337.92,
              12421.715
            ],
            [
              -3915.514,
              4362.95,
              12461.713
            ],
            [
              -3928.112,
              4380.98,
              12483.707
            ],
            [
              -4226.292,
              4683.356,
              12908.375
            ],
            [
              -4305.622,
              4762.647,
              13020.536
            ],
            [
              -4338.114,
              4787.696,
              13061.564
            ],
            [
              -4349.425,
              4805.702,
              13082.828
            ],
            [
              -4420.502,
              4877.057,
              13183.543
            ],
            [
              -4439.501,
              4898.534,
              13212.217
            ],
            [
              -4461.157,
              4915.604,
              13239.792
            ],
            [
              -4476.532,
              4922.548,
              13256.662
            ],
            [
              -4488.111,
              4924.973,
              13268.493
            ],
            [
              -4508.363,
              4948.698,
              13299.686
            ],
            [
              -4600.366,
              5004.825,
              13407.457
            ],
            [
              -4658.205,
              5020.288,
              13467.328
            ],
            [
              -4736.87,
              5026.089,
              13546.206
            ],
            [
              -4780.873,
              5020.164,
              13590.606
            ],
            [
              -4794.293,
              5028.186,
              13606.242
            ],
            [
              -4826.695,
              5058.796,
              13650.817
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1017",
              "position": {
                "x": 2551.422,
                "z": -3889.265
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 637.712,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 875.708,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 1660.692,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5818",
              "position": {
                "x": 2043.488,
                "z": -1826.913
              },
              "distanceAlongShapeM": 2394.108,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5819",
              "position": {
                "x": 1983.608,
                "z": -1511.859
              },
              "distanceAlongShapeM": 2716.148,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5820",
              "position": {
                "x": 1921.875,
                "z": -915.121
              },
              "distanceAlongShapeM": 3320.939,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 3830.881,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 4519.649,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 5013.729,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5249",
              "position": {
                "x": -153.095,
                "z": -312.52
              },
              "distanceAlongShapeM": 5854.367,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5257",
              "position": {
                "x": -465.596,
                "z": -369.193
              },
              "distanceAlongShapeM": 6216.031,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 6646.244,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:683",
              "position": {
                "x": -844.854,
                "z": 772.035
              },
              "distanceAlongShapeM": 7455.637,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 7854.656,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 8307.415,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 8943.892,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 9379.413,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 10471.205,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 11005.201,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 11768.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 12461.713,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 13061.564,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 13268.493,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 13650.817,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            }
          ],
          "departuresSeconds": [
            18060,
            19200,
            20340,
            21180,
            22260,
            22980,
            23700,
            24480,
            25200,
            25800,
            26460,
            27060,
            27780,
            28620,
            29760,
            30900,
            32040,
            33060,
            33780,
            34560,
            35280,
            35880,
            37080,
            38280,
            39000,
            39720,
            40740,
            41640,
            42840,
            43920,
            44940,
            45780,
            46680,
            47580,
            48360,
            49440,
            50580,
            51900,
            52860,
            53820,
            54780,
            55560,
            56220,
            56760,
            57540,
            58020,
            58920,
            59520,
            60180,
            61140,
            62220,
            63300,
            64320,
            65520,
            66780,
            68100,
            68940,
            69720,
            70500,
            71400,
            72480,
            73560,
            74640,
            75540,
            76440,
            77280,
            78180,
            79020,
            79800,
            80520,
            81720
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_4:1",
          "sourceRouteId": "vilnius_trol_4",
          "sourceShapeId": "vilnius_trol_4_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Žemieji Paneriai–Centras–Antakalnis",
          "mode": "trolleybus",
          "routeShortName": "4",
          "routeLongName": "Antakalnis–Centras–Žemieji Paneriai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4826.695,
              5058.796,
              0
            ],
            [
              -4834.705,
              5081.197,
              23.79
            ],
            [
              -4785.441,
              5130.448,
              93.45
            ],
            [
              -4754.629,
              5157.75,
              134.618
            ],
            [
              -4724.691,
              5171.709,
              167.65
            ],
            [
              -4669.05,
              5178.548,
              223.71
            ],
            [
              -4632.924,
              5176.815,
              259.877
            ],
            [
              -4599.437,
              5171.788,
              293.739
            ],
            [
              -4586.132,
              5157.088,
              313.567
            ],
            [
              -4583.042,
              5111.394,
              359.365
            ],
            [
              -4580.889,
              5011.17,
              459.613
            ],
            [
              -4517.509,
              4980.025,
              530.231
            ],
            [
              -4503.635,
              4960.862,
              553.889
            ],
            [
              -4444.377,
              4915.316,
              628.628
            ],
            [
              -4189.698,
              4671.592,
              981.137
            ],
            [
              -4166.695,
              4657.837,
              1007.939
            ],
            [
              -4146.524,
              4629.659,
              1042.593
            ],
            [
              -4048.773,
              4533.349,
              1179.819
            ],
            [
              -3823.59,
              4303.471,
              1501.612
            ],
            [
              -3802.623,
              4284.184,
              1530.101
            ],
            [
              -3780.952,
              4268.223,
              1557.015
            ],
            [
              -3768.394,
              4247.967,
              1580.848
            ],
            [
              -3367.467,
              3844.694,
              2149.506
            ],
            [
              -3344.49,
              3829.822,
              2176.876
            ],
            [
              -3315.43,
              3793.692,
              2223.242
            ],
            [
              -3282.402,
              3763.059,
              2268.289
            ],
            [
              -3142.94,
              3618.132,
              2469.419
            ],
            [
              -2996.449,
              3469.738,
              2677.939
            ],
            [
              -2905.063,
              3381.305,
              2805.107
            ],
            [
              -2851.864,
              3323.598,
              2883.595
            ],
            [
              -2827.523,
              3276.416,
              2936.686
            ],
            [
              -2808.656,
              3248.254,
              2970.583
            ],
            [
              -2806.545,
              3221.5,
              2997.42
            ],
            [
              -2772.86,
              3118.493,
              3105.795
            ],
            [
              -2707,
              2936.995,
              3298.873
            ],
            [
              -2660.341,
              2801.476,
              3442.199
            ],
            [
              -2637.179,
              2724.257,
              3522.818
            ],
            [
              -2612.218,
              2675.949,
              3577.193
            ],
            [
              -2609.483,
              2648.071,
              3605.205
            ],
            [
              -2582.373,
              2575.235,
              3682.923
            ],
            [
              -2570.531,
              2514.913,
              3744.396
            ],
            [
              -2558.338,
              2437.886,
              3822.382
            ],
            [
              -2547.004,
              2385.365,
              3876.112
            ],
            [
              -2539.07,
              2359.622,
              3903.05
            ],
            [
              -2526.132,
              2324.884,
              3940.119
            ],
            [
              -2519.194,
              2315.856,
              3951.505
            ],
            [
              -2487.744,
              2306.396,
              3984.347
            ],
            [
              -2471.111,
              2298.31,
              4002.842
            ],
            [
              -2454.576,
              2284.659,
              4024.283
            ],
            [
              -2442.556,
              2271.088,
              4042.412
            ],
            [
              -2433.47,
              2237.532,
              4077.177
            ],
            [
              -2436.603,
              2169.681,
              4145.1
            ],
            [
              -2432.988,
              2155.146,
              4160.078
            ],
            [
              -2421.673,
              2138.248,
              4180.415
            ],
            [
              -2405.237,
              2119.033,
              4205.7
            ],
            [
              -2339.12,
              2063.317,
              4292.162
            ],
            [
              -2328.352,
              2051.995,
              4307.788
            ],
            [
              -2313.635,
              2045.055,
              4324.059
            ],
            [
              -2298.509,
              2024.75,
              4349.378
            ],
            [
              -1944.941,
              1697.877,
              4830.893
            ],
            [
              -1868.675,
              1633.068,
              4930.976
            ],
            [
              -1860.469,
              1622.903,
              4944.04
            ],
            [
              -1769.084,
              1537.785,
              5068.925
            ],
            [
              -1703.649,
              1480.959,
              5155.592
            ],
            [
              -1688.349,
              1470.667,
              5174.03
            ],
            [
              -1678.973,
              1453.802,
              5193.327
            ],
            [
              -1503.095,
              1295.926,
              5429.669
            ],
            [
              -1427.428,
              1234.46,
              5527.156
            ],
            [
              -1409.124,
              1211.868,
              5556.232
            ],
            [
              -1353.311,
              1158.548,
              5633.421
            ],
            [
              -1207.93,
              1027.923,
              5828.865
            ],
            [
              -1188.159,
              1015.323,
              5852.31
            ],
            [
              -1173.062,
              993.901,
              5878.517
            ],
            [
              -1066.972,
              902.938,
              6018.265
            ],
            [
              -958.695,
              862.029,
              6134.012
            ],
            [
              -800.989,
              807.981,
              6300.722
            ],
            [
              -799.135,
              803.495,
              6305.577
            ],
            [
              -799.94,
              794.603,
              6314.504
            ],
            [
              -808.22,
              764.696,
              6345.537
            ],
            [
              -810.251,
              723.543,
              6386.74
            ],
            [
              -824.878,
              699.315,
              6415.04
            ],
            [
              -838.2,
              496.948,
              6617.845
            ],
            [
              -838.156,
              463.551,
              6651.243
            ],
            [
              -823.183,
              435.45,
              6683.084
            ],
            [
              -689.041,
              256.028,
              6907.107
            ],
            [
              -671.067,
              215.627,
              6951.326
            ],
            [
              -634.631,
              19.041,
              7151.26
            ],
            [
              -585.127,
              -96.516,
              7276.974
            ],
            [
              -570.097,
              -121.279,
              7305.941
            ],
            [
              -567.275,
              -143.594,
              7328.435
            ],
            [
              -513.161,
              -289.293,
              7483.858
            ],
            [
              -501.093,
              -299.53,
              7499.683
            ],
            [
              -461.426,
              -352.57,
              7565.915
            ],
            [
              -449.339,
              -361.695,
              7581.06
            ],
            [
              -413.017,
              -421.354,
              7650.906
            ],
            [
              -305.298,
              -348.72,
              7780.826
            ],
            [
              -203.339,
              -309.381,
              7890.111
            ],
            [
              -102.285,
              -284.5,
              7994.182
            ],
            [
              -50.388,
              -267.632,
              8048.752
            ],
            [
              -22.626,
              -265.911,
              8076.567
            ],
            [
              -0.545,
              -257.407,
              8100.229
            ],
            [
              58.367,
              -209.498,
              8176.163
            ],
            [
              82.464,
              -196.578,
              8203.504
            ],
            [
              94.753,
              -194.576,
              8215.956
            ],
            [
              103.738,
              -196.966,
              8225.253
            ],
            [
              115.784,
              -208.318,
              8241.805
            ],
            [
              119.866,
              -267.394,
              8301.022
            ],
            [
              241.125,
              -266.267,
              8422.287
            ],
            [
              291.552,
              -259.395,
              8473.179
            ],
            [
              357.234,
              -229.425,
              8545.375
            ],
            [
              436.36,
              -169.644,
              8644.545
            ],
            [
              541.549,
              -60.247,
              8796.31
            ],
            [
              554.165,
              -40.44,
              8819.794
            ],
            [
              588.702,
              -21.035,
              8859.408
            ],
            [
              628.519,
              4.952,
              8906.956
            ],
            [
              645.363,
              9.096,
              8924.302
            ],
            [
              675.04,
              9.665,
              8953.985
            ],
            [
              707.88,
              6.836,
              8986.946
            ],
            [
              925.597,
              -42.81,
              9210.251
            ],
            [
              1129.224,
              -156.774,
              9443.601
            ],
            [
              1143.99,
              -160.386,
              9458.802
            ],
            [
              1610.786,
              -514.132,
              10044.494
            ],
            [
              1615.737,
              -525.357,
              10056.762
            ],
            [
              1648.803,
              -550.462,
              10098.279
            ],
            [
              1657.142,
              -552.844,
              10106.951
            ],
            [
              1686.795,
              -553.394,
              10136.609
            ],
            [
              1704.118,
              -558.169,
              10154.578
            ],
            [
              1714.932,
              -566.163,
              10168.025
            ],
            [
              1727.769,
              -638.763,
              10241.751
            ],
            [
              1737.731,
              -657.873,
              10263.302
            ],
            [
              1757.197,
              -686.066,
              10297.563
            ],
            [
              1866.79,
              -826.148,
              10475.421
            ],
            [
              1905.301,
              -870.282,
              10533.995
            ],
            [
              1927.219,
              -905.201,
              10575.223
            ],
            [
              1944,
              -938.911,
              10612.879
            ],
            [
              1949.844,
              -971.304,
              10645.795
            ],
            [
              1961.738,
              -990.451,
              10668.336
            ],
            [
              1968.757,
              -1305.631,
              10983.594
            ],
            [
              1988.222,
              -1471.868,
              11150.967
            ],
            [
              2032.094,
              -1677.525,
              11361.25
            ],
            [
              2032.074,
              -1713.148,
              11396.874
            ],
            [
              2048.644,
              -1792.498,
              11477.936
            ],
            [
              2069.62,
              -1877.497,
              11565.484
            ],
            [
              2087.852,
              -1936.84,
              11627.565
            ],
            [
              2087.374,
              -1962.435,
              11653.165
            ],
            [
              2110.719,
              -2024.1,
              11719.101
            ],
            [
              2234.812,
              -2316.979,
              12037.184
            ],
            [
              2284.924,
              -2429.242,
              12160.124
            ],
            [
              2299.015,
              -2468.47,
              12201.806
            ],
            [
              2319.691,
              -2569.05,
              12304.489
            ],
            [
              2327.089,
              -2587.001,
              12323.905
            ],
            [
              2323.492,
              -2606.972,
              12344.197
            ],
            [
              2328.687,
              -2639.354,
              12376.993
            ],
            [
              2411.872,
              -3118.499,
              12863.305
            ],
            [
              2419.872,
              -3138.687,
              12885.021
            ],
            [
              2418.768,
              -3163.158,
              12909.517
            ],
            [
              2474.472,
              -3526.012,
              13276.621
            ],
            [
              2513.109,
              -3664.781,
              13420.669
            ],
            [
              2522.438,
              -3682.768,
              13440.931
            ],
            [
              2542.483,
              -3747.714,
              13508.9
            ],
            [
              2553.555,
              -3775.753,
              13539.046
            ],
            [
              2562.319,
              -3823.788,
              13587.874
            ],
            [
              2551.422,
              -3889.265,
              13654.251
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 223.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 530.231,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 1007.939,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 1557.015,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 2176.876,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 2970.583,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 3577.193,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 4324.059,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 4930.976,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 5527.156,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 5852.31,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 6386.74,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 7305.941,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5258",
              "position": {
                "x": -449.339,
                "z": -361.695
              },
              "distanceAlongShapeM": 7581.06,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 8048.752,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 8986.946,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 9458.802,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 10044.494,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5826",
              "position": {
                "x": 1961.738,
                "z": -990.451
              },
              "distanceAlongShapeM": 10668.336,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6702",
              "position": {
                "x": 2032.094,
                "z": -1677.525
              },
              "distanceAlongShapeM": 11361.25,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 11627.565,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 12323.905,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 12885.021,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 13440.931,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:1017",
              "position": {
                "x": 2551.422,
                "z": -3889.265
              },
              "distanceAlongShapeM": 13654.251,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            }
          ],
          "departuresSeconds": [
            18720,
            19860,
            21060,
            22140,
            23340,
            24540,
            25620,
            26400,
            27300,
            28200,
            28980,
            29580,
            30300,
            31080,
            31800,
            32580,
            33600,
            34620,
            35580,
            36480,
            37200,
            37980,
            38700,
            39180,
            40440,
            41580,
            42360,
            43140,
            44160,
            45060,
            46140,
            47280,
            48240,
            49140,
            50100,
            51180,
            52260,
            53220,
            54300,
            55320,
            56280,
            57240,
            58320,
            59160,
            60060,
            60900,
            61560,
            62220,
            63120,
            63720,
            64320,
            65100,
            66120,
            67140,
            68220,
            69240,
            70320,
            71460,
            72240,
            73020,
            73800,
            74700,
            75660,
            76620,
            77640,
            78600,
            79500,
            80280,
            81060,
            81840,
            82560,
            83280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_6",
      "sourceRouteId": "vilnius_trol_6",
      "mode": "trolleybus",
      "shortName": "6",
      "longName": "Žirmūnai–Kalvarijų–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_6:0",
          "sourceRouteId": "vilnius_trol_6",
          "sourceShapeId": "vilnius_trol_6_a-b",
          "directionId": 0,
          "headsign": "Žemieji Paneriai (Apylanka be Reformatų st.)",
          "directionName": "Žirmūnai–Kalvarijų–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "mode": "trolleybus",
          "routeShortName": "6",
          "routeLongName": "Žirmūnai–Kalvarijų–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1016.673,
              -4299.303,
              0
            ],
            [
              1017.645,
              -4281.509,
              17.821
            ],
            [
              1022.257,
              -4276.027,
              24.984
            ],
            [
              1106.613,
              -4278.698,
              109.382
            ],
            [
              1128.033,
              -4270.188,
              132.431
            ],
            [
              1147.356,
              -4270.545,
              151.757
            ],
            [
              1188.702,
              -4264.63,
              193.524
            ],
            [
              1202.517,
              -4249.3,
              214.16
            ],
            [
              1214.522,
              -4227.257,
              239.261
            ],
            [
              1220.978,
              -4191.753,
              275.347
            ],
            [
              1217.195,
              -3943.429,
              523.7
            ],
            [
              1219.986,
              -3862.213,
              604.964
            ],
            [
              1375.611,
              -3774.922,
              783.398
            ],
            [
              1393.375,
              -3755.212,
              809.932
            ],
            [
              1412.221,
              -3746.656,
              830.629
            ],
            [
              1499.686,
              -3582.404,
              1016.717
            ],
            [
              1482.767,
              -3556.485,
              1047.669
            ],
            [
              1455.5,
              -3532.601,
              1083.917
            ],
            [
              1443.07,
              -3507.879,
              1111.588
            ],
            [
              1391.152,
              -3457.934,
              1183.63
            ],
            [
              1338.486,
              -3413.541,
              1252.51
            ],
            [
              1317.474,
              -3399.793,
              1277.62
            ],
            [
              978.337,
              -3198.709,
              1671.89
            ],
            [
              945.685,
              -3186.974,
              1706.587
            ],
            [
              931.778,
              -3172.246,
              1726.843
            ],
            [
              710.47,
              -3045.716,
              1981.769
            ],
            [
              679.709,
              -3036.244,
              2013.955
            ],
            [
              665.217,
              -3018.166,
              2037.125
            ],
            [
              641.604,
              -3005.487,
              2063.927
            ],
            [
              624.331,
              -2998.49,
              2082.563
            ],
            [
              521.572,
              -2978.793,
              2187.193
            ],
            [
              506.876,
              -2971.844,
              2203.449
            ],
            [
              502.159,
              -2912.756,
              2262.725
            ],
            [
              509.397,
              -2869.472,
              2306.61
            ],
            [
              513.301,
              -2797.183,
              2379.004
            ],
            [
              494.515,
              -2626.513,
              2550.705
            ],
            [
              482.722,
              -2601.805,
              2578.083
            ],
            [
              485.911,
              -2568.466,
              2611.574
            ],
            [
              462.343,
              -2342.047,
              2839.217
            ],
            [
              451.425,
              -2269.486,
              2912.594
            ],
            [
              407.176,
              -2116.162,
              3072.176
            ],
            [
              406.254,
              -2096.107,
              3092.252
            ],
            [
              361.405,
              -1904.922,
              3288.627
            ],
            [
              342.249,
              -1718.661,
              3475.87
            ],
            [
              324.984,
              -1640.419,
              3555.995
            ],
            [
              326.097,
              -1614.835,
              3581.603
            ],
            [
              277.22,
              -1255.479,
              3944.268
            ],
            [
              271.867,
              -1230.89,
              3969.433
            ],
            [
              265.625,
              -1219.643,
              3982.295
            ],
            [
              267.28,
              -1199.635,
              4002.372
            ],
            [
              254.802,
              -1141.519,
              4061.812
            ],
            [
              216.915,
              -885.896,
              4320.228
            ],
            [
              226.048,
              -703.492,
              4502.86
            ],
            [
              223.795,
              -685.64,
              4520.855
            ],
            [
              209.218,
              -636.391,
              4572.215
            ],
            [
              192.022,
              -589.321,
              4622.328
            ],
            [
              159.237,
              -513.023,
              4705.371
            ],
            [
              151.725,
              -500.641,
              4719.855
            ],
            [
              143.086,
              -479.332,
              4742.848
            ],
            [
              121.213,
              -441.083,
              4786.909
            ],
            [
              106.146,
              -277.163,
              4951.521
            ],
            [
              46.11,
              -280.522,
              5011.65
            ],
            [
              26.146,
              -279.045,
              5031.669
            ],
            [
              15.43,
              -265.491,
              5048.947
            ],
            [
              14.363,
              -253.226,
              5061.259
            ],
            [
              16.439,
              -245.471,
              5069.286
            ],
            [
              45.916,
              -220.403,
              5107.981
            ],
            [
              103.215,
              -190.277,
              5172.717
            ],
            [
              127.382,
              -102.772,
              5263.498
            ],
            [
              121.848,
              -52.576,
              5313.999
            ],
            [
              115.041,
              -36.866,
              5331.12
            ],
            [
              117.583,
              -3.516,
              5364.567
            ],
            [
              102.671,
              133.684,
              5502.575
            ],
            [
              63.181,
              125.497,
              5542.905
            ],
            [
              59.312,
              125.568,
              5546.774
            ],
            [
              57.419,
              127.829,
              5549.723
            ],
            [
              31.786,
              278.582,
              5702.64
            ],
            [
              4.856,
              358.112,
              5786.606
            ],
            [
              -8.924,
              380.627,
              5813.003
            ],
            [
              -39.768,
              422.378,
              5864.912
            ],
            [
              -46.8,
              425.846,
              5872.752
            ],
            [
              -55.202,
              424.885,
              5881.209
            ],
            [
              -86.677,
              396.514,
              5923.584
            ],
            [
              -97.297,
              380.009,
              5943.21
            ],
            [
              -216.06,
              268.617,
              6106.038
            ],
            [
              -407.853,
              148.526,
              6332.326
            ],
            [
              -402.875,
              316.534,
              6500.407
            ],
            [
              -399.691,
              349.873,
              6533.898
            ],
            [
              -377.245,
              378.41,
              6570.205
            ],
            [
              -261.81,
              448.677,
              6705.345
            ],
            [
              -291.826,
              642.924,
              6901.897
            ],
            [
              -330.752,
              844.011,
              7106.717
            ],
            [
              -575.219,
              737.113,
              7373.534
            ],
            [
              -620.556,
              726.8,
              7420.03
            ],
            [
              -799.94,
              794.603,
              7611.8
            ],
            [
              -810.157,
              800.354,
              7623.524
            ],
            [
              -958.695,
              862.029,
              7784.357
            ],
            [
              -1066.972,
              902.938,
              7900.104
            ],
            [
              -1103.368,
              923.63,
              7941.971
            ],
            [
              -1148.452,
              963.402,
              8002.091
            ],
            [
              -1168.303,
              971.551,
              8023.549
            ],
            [
              -1183.42,
              991.86,
              8048.867
            ],
            [
              -1484.246,
              1267.759,
              8457.054
            ],
            [
              -1502.183,
              1274.758,
              8476.309
            ],
            [
              -1524.902,
              1302.995,
              8512.55
            ],
            [
              -1970.62,
              1705.012,
              9112.786
            ],
            [
              -1985.783,
              1723.093,
              9136.383
            ],
            [
              -2263.842,
              1978.495,
              9513.936
            ],
            [
              -2290.557,
              2000.118,
              9548.306
            ],
            [
              -2318.992,
              2034.018,
              9592.552
            ],
            [
              -2425.036,
              2130.514,
              9735.929
            ],
            [
              -2441.629,
              2140.826,
              9755.465
            ],
            [
              -2464.869,
              2140.123,
              9778.716
            ],
            [
              -2491.57,
              2126.123,
              9808.865
            ],
            [
              -2514.888,
              2120.968,
              9832.746
            ],
            [
              -2528.453,
              2120.094,
              9846.339
            ],
            [
              -2551.595,
              2124.955,
              9869.986
            ],
            [
              -2561.836,
              2129.588,
              9881.227
            ],
            [
              -2579.681,
              2142.148,
              9903.048
            ],
            [
              -2585.368,
              2148.928,
              9911.897
            ],
            [
              -2589.062,
              2159.012,
              9922.637
            ],
            [
              -2606.026,
              2184.914,
              9953.6
            ],
            [
              -2610.326,
              2197.235,
              9966.65
            ],
            [
              -2613.804,
              2219.561,
              9989.245
            ],
            [
              -2614.214,
              2232.927,
              10002.617
            ],
            [
              -2611.32,
              2250.687,
              10020.611
            ],
            [
              -2605.925,
              2263.95,
              10034.93
            ],
            [
              -2595.955,
              2280.473,
              10054.228
            ],
            [
              -2588.136,
              2284.788,
              10063.158
            ],
            [
              -2577.443,
              2305.751,
              10086.69
            ],
            [
              -2591.532,
              2385.037,
              10167.219
            ],
            [
              -2598.371,
              2436.365,
              10219
            ],
            [
              -2602.959,
              2542.201,
              10324.936
            ],
            [
              -2607.706,
              2602.398,
              10385.32
            ],
            [
              -2619.569,
              2661.607,
              10445.705
            ],
            [
              -2672.012,
              2798.342,
              10592.152
            ],
            [
              -2693.846,
              2841.028,
              10640.099
            ],
            [
              -2698.439,
              2873.392,
              10672.787
            ],
            [
              -2831.804,
              3253.114,
              11075.248
            ],
            [
              -2853.662,
              3294.686,
              11122.216
            ],
            [
              -2870.652,
              3319.475,
              11152.269
            ],
            [
              -2888.502,
              3332.034,
              11174.094
            ],
            [
              -2904.222,
              3355.687,
              11202.494
            ],
            [
              -3126.24,
              3576.651,
              11515.731
            ],
            [
              -3256.351,
              3702.491,
              11696.741
            ],
            [
              -3334.924,
              3786.24,
              11811.578
            ],
            [
              -3406.008,
              3855.385,
              11910.744
            ],
            [
              -3427.01,
              3872.449,
              11937.805
            ],
            [
              -3454.8,
              3907.442,
              11982.491
            ],
            [
              -3626.746,
              4078.528,
              12225.051
            ],
            [
              -3781.512,
              4235.95,
              12445.81
            ],
            [
              -3884.317,
              4337.92,
              12590.608
            ],
            [
              -3915.514,
              4362.95,
              12630.606
            ],
            [
              -3928.112,
              4380.98,
              12652.601
            ],
            [
              -4226.292,
              4683.356,
              13077.268
            ],
            [
              -4305.622,
              4762.647,
              13189.43
            ],
            [
              -4338.114,
              4787.696,
              13230.458
            ],
            [
              -4349.425,
              4805.702,
              13251.721
            ],
            [
              -4420.502,
              4877.057,
              13352.436
            ],
            [
              -4439.501,
              4898.534,
              13381.11
            ],
            [
              -4461.157,
              4915.604,
              13408.686
            ],
            [
              -4476.532,
              4922.548,
              13425.556
            ],
            [
              -4488.111,
              4924.973,
              13437.386
            ],
            [
              -4508.363,
              4948.698,
              13468.579
            ],
            [
              -4600.366,
              5004.825,
              13576.35
            ],
            [
              -4658.205,
              5020.288,
              13636.221
            ],
            [
              -4736.87,
              5026.089,
              13715.1
            ],
            [
              -4780.873,
              5020.164,
              13759.5
            ],
            [
              -4794.293,
              5028.186,
              13775.135
            ],
            [
              -4826.695,
              5058.796,
              13819.71
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 132.431,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 809.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5125",
              "position": {
                "x": 1455.5,
                "z": -3532.601
              },
              "distanceAlongShapeM": 1083.917,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5127",
              "position": {
                "x": 945.685,
                "z": -3186.974
              },
              "distanceAlongShapeM": 1706.587,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5128",
              "position": {
                "x": 679.709,
                "z": -3036.244
              },
              "distanceAlongShapeM": 2013.955,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 2578.083,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 3072.176,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 3555.995,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 3982.295,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 4786.909,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 5331.12,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 5943.21,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5524",
              "position": {
                "x": -620.556,
                "z": 726.8
              },
              "distanceAlongShapeM": 7420.03,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 8023.549,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 8476.309,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 9112.786,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 9548.306,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 10640.099,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 11174.094,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 11937.805,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 12630.606,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 13230.458,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 13437.386,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 13819.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            }
          ],
          "departuresSeconds": [
            18240,
            18840,
            19680,
            20160,
            20640,
            21120,
            21600,
            22080,
            22560,
            23040,
            23580,
            24060,
            24540,
            25200,
            25920,
            26640,
            27360,
            27960,
            28500,
            29040,
            29700,
            30300,
            31320,
            32340,
            33300,
            34260,
            35220,
            36120,
            37020,
            37860,
            38880,
            39900,
            40800,
            41640,
            42540,
            43440,
            44340,
            45300,
            46320,
            47340,
            48300,
            49260,
            50160,
            51060,
            51960,
            52800,
            53220,
            53640,
            54060,
            54480,
            55020,
            55440,
            55920,
            56460,
            57000,
            57840,
            58740,
            59580,
            60420,
            61020,
            61620,
            62220,
            62820,
            63420,
            64020,
            64920,
            66060,
            67200,
            68340,
            69360,
            70320,
            71340,
            72420,
            73500,
            74340,
            75180,
            76080,
            76980,
            77880,
            78780,
            79680,
            80760
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_6:1",
          "sourceRouteId": "vilnius_trol_6",
          "sourceShapeId": "vilnius_trol_6_b-a",
          "directionId": 1,
          "headsign": "Žirmūnai (Apylanka be Reformatų st.)",
          "directionName": "Žemieji Paneriai–V. Kudirkos–Kalvarijų g.–Žirmūnai (Apylanka be Reformatų st.)",
          "mode": "trolleybus",
          "routeShortName": "6",
          "routeLongName": "Žirmūnai–Kalvarijų–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4826.695,
              5058.796,
              0
            ],
            [
              -4834.705,
              5081.197,
              23.79
            ],
            [
              -4785.441,
              5130.448,
              93.45
            ],
            [
              -4754.629,
              5157.75,
              134.618
            ],
            [
              -4724.691,
              5171.709,
              167.65
            ],
            [
              -4669.05,
              5178.548,
              223.71
            ],
            [
              -4632.924,
              5176.815,
              259.877
            ],
            [
              -4599.437,
              5171.788,
              293.739
            ],
            [
              -4586.132,
              5157.088,
              313.567
            ],
            [
              -4583.042,
              5111.394,
              359.365
            ],
            [
              -4580.889,
              5011.17,
              459.613
            ],
            [
              -4517.509,
              4980.025,
              530.231
            ],
            [
              -4503.635,
              4960.862,
              553.889
            ],
            [
              -4444.377,
              4915.316,
              628.628
            ],
            [
              -4189.698,
              4671.592,
              981.137
            ],
            [
              -4166.695,
              4657.837,
              1007.939
            ],
            [
              -4146.524,
              4629.659,
              1042.593
            ],
            [
              -4048.773,
              4533.349,
              1179.819
            ],
            [
              -3823.59,
              4303.471,
              1501.612
            ],
            [
              -3802.623,
              4284.184,
              1530.101
            ],
            [
              -3780.952,
              4268.223,
              1557.015
            ],
            [
              -3768.394,
              4247.967,
              1580.848
            ],
            [
              -3367.467,
              3844.694,
              2149.506
            ],
            [
              -3344.49,
              3829.822,
              2176.876
            ],
            [
              -3315.43,
              3793.692,
              2223.242
            ],
            [
              -3282.402,
              3763.059,
              2268.289
            ],
            [
              -3142.94,
              3618.132,
              2469.419
            ],
            [
              -2996.449,
              3469.738,
              2677.939
            ],
            [
              -2905.063,
              3381.305,
              2805.107
            ],
            [
              -2851.864,
              3323.598,
              2883.595
            ],
            [
              -2827.523,
              3276.416,
              2936.686
            ],
            [
              -2808.656,
              3248.254,
              2970.583
            ],
            [
              -2806.545,
              3221.5,
              2997.42
            ],
            [
              -2772.86,
              3118.493,
              3105.795
            ],
            [
              -2707,
              2936.995,
              3298.873
            ],
            [
              -2660.341,
              2801.476,
              3442.199
            ],
            [
              -2637.179,
              2724.257,
              3522.818
            ],
            [
              -2612.218,
              2675.949,
              3577.193
            ],
            [
              -2609.483,
              2648.071,
              3605.205
            ],
            [
              -2582.373,
              2575.235,
              3682.923
            ],
            [
              -2570.531,
              2514.913,
              3744.396
            ],
            [
              -2558.338,
              2437.886,
              3822.382
            ],
            [
              -2547.004,
              2385.365,
              3876.112
            ],
            [
              -2539.07,
              2359.622,
              3903.05
            ],
            [
              -2526.132,
              2324.884,
              3940.119
            ],
            [
              -2519.194,
              2315.856,
              3951.505
            ],
            [
              -2487.744,
              2306.396,
              3984.347
            ],
            [
              -2471.111,
              2298.31,
              4002.842
            ],
            [
              -2454.576,
              2284.659,
              4024.283
            ],
            [
              -2442.556,
              2271.088,
              4042.412
            ],
            [
              -2433.47,
              2237.532,
              4077.177
            ],
            [
              -2436.603,
              2169.681,
              4145.1
            ],
            [
              -2432.988,
              2155.146,
              4160.078
            ],
            [
              -2421.673,
              2138.248,
              4180.415
            ],
            [
              -2405.237,
              2119.033,
              4205.7
            ],
            [
              -2339.12,
              2063.317,
              4292.162
            ],
            [
              -2328.352,
              2051.995,
              4307.788
            ],
            [
              -2313.635,
              2045.055,
              4324.059
            ],
            [
              -2298.509,
              2024.75,
              4349.378
            ],
            [
              -1944.941,
              1697.877,
              4830.893
            ],
            [
              -1868.675,
              1633.068,
              4930.976
            ],
            [
              -1860.469,
              1622.903,
              4944.04
            ],
            [
              -1769.084,
              1537.785,
              5068.925
            ],
            [
              -1703.649,
              1480.959,
              5155.592
            ],
            [
              -1688.349,
              1470.667,
              5174.03
            ],
            [
              -1678.973,
              1453.802,
              5193.327
            ],
            [
              -1503.095,
              1295.926,
              5429.669
            ],
            [
              -1427.428,
              1234.46,
              5527.156
            ],
            [
              -1409.124,
              1211.868,
              5556.232
            ],
            [
              -1353.311,
              1158.548,
              5633.421
            ],
            [
              -1207.93,
              1027.923,
              5828.865
            ],
            [
              -1188.159,
              1015.323,
              5852.31
            ],
            [
              -1173.062,
              993.901,
              5878.517
            ],
            [
              -1066.972,
              902.938,
              6018.265
            ],
            [
              -958.695,
              862.029,
              6134.012
            ],
            [
              -800.989,
              807.981,
              6300.722
            ],
            [
              -799.135,
              803.495,
              6305.577
            ],
            [
              -799.94,
              794.603,
              6314.504
            ],
            [
              -808.22,
              764.696,
              6345.537
            ],
            [
              -810.251,
              723.543,
              6386.74
            ],
            [
              -829.673,
              683.817,
              6430.959
            ],
            [
              -843.054,
              478.111,
              6637.1
            ],
            [
              -804.926,
              410.63,
              6714.607
            ],
            [
              -682.331,
              234.755,
              6928.993
            ],
            [
              -671.067,
              215.627,
              6951.192
            ],
            [
              -647.308,
              102.762,
              7066.53
            ],
            [
              -591.62,
              115.115,
              7123.571
            ],
            [
              -557.893,
              125.637,
              7158.902
            ],
            [
              -539.176,
              126.412,
              7177.635
            ],
            [
              -408.498,
              148.538,
              7310.173
            ],
            [
              -385.731,
              159.258,
              7335.338
            ],
            [
              -216.06,
              268.617,
              7537.198
            ],
            [
              -55.202,
              424.885,
              7761.464
            ],
            [
              -39.768,
              422.378,
              7777.1
            ],
            [
              18.234,
              348.963,
              7870.663
            ],
            [
              36.62,
              260.682,
              7960.838
            ],
            [
              56.855,
              132.292,
              8090.813
            ],
            [
              59.373,
              128.907,
              8095.032
            ],
            [
              70.978,
              128.695,
              8106.639
            ],
            [
              102.671,
              133.684,
              8138.722
            ],
            [
              116.145,
              94.475,
              8180.182
            ],
            [
              129.88,
              -107.271,
              8382.394
            ],
            [
              116.846,
              -256.206,
              8531.899
            ],
            [
              117.887,
              -305.208,
              8580.911
            ],
            [
              127.989,
              -387.771,
              8664.091
            ],
            [
              138.319,
              -422.47,
              8700.294
            ],
            [
              150.182,
              -443.837,
              8724.734
            ],
            [
              177.186,
              -518.917,
              8804.522
            ],
            [
              237.149,
              -695.903,
              8991.39
            ],
            [
              238.113,
              -713.732,
              9009.245
            ],
            [
              217.158,
              -872.542,
              9169.432
            ],
            [
              276.82,
              -1242.113,
              9543.787
            ],
            [
              297.35,
              -1318.188,
              9622.584
            ],
            [
              320.249,
              -1546.82,
              9852.36
            ],
            [
              342.249,
              -1718.661,
              10025.604
            ],
            [
              356.237,
              -1764.56,
              10073.586
            ],
            [
              354.758,
              -1810.175,
              10119.226
            ],
            [
              356.121,
              -1841.371,
              10150.452
            ],
            [
              372.957,
              -1942.984,
              10253.45
            ],
            [
              426.379,
              -2158.817,
              10475.795
            ],
            [
              441.836,
              -2194.724,
              10514.888
            ],
            [
              440.947,
              -2208.066,
              10528.26
            ],
            [
              462.343,
              -2342.047,
              10663.939
            ],
            [
              505.139,
              -2574.385,
              10900.185
            ],
            [
              511.756,
              -2776.003,
              11101.912
            ],
            [
              513.301,
              -2797.183,
              11123.148
            ],
            [
              524.563,
              -2850.825,
              11177.96
            ],
            [
              524.913,
              -2902.04,
              11229.176
            ],
            [
              521.837,
              -2964.325,
              11291.537
            ],
            [
              532.044,
              -2970.079,
              11303.254
            ],
            [
              602.169,
              -2976.932,
              11373.713
            ],
            [
              619.319,
              -2990.605,
              11395.647
            ],
            [
              631.438,
              -2997.507,
              11409.594
            ],
            [
              906.98,
              -3153.977,
              11726.462
            ],
            [
              1026.951,
              -3218.53,
              11862.698
            ],
            [
              1027.41,
              -3228.558,
              11872.736
            ],
            [
              1043.901,
              -3277.845,
              11924.709
            ],
            [
              1066.821,
              -3362.875,
              12012.774
            ],
            [
              1066.595,
              -3375.116,
              12025.017
            ],
            [
              1098.437,
              -3500.388,
              12154.273
            ],
            [
              1100.082,
              -3516.004,
              12169.975
            ],
            [
              1090.736,
              -3742.933,
              12397.097
            ],
            [
              1117.962,
              -3769.041,
              12434.818
            ],
            [
              1133.882,
              -3779.354,
              12453.786
            ],
            [
              1147.08,
              -3797.41,
              12476.152
            ],
            [
              1219.986,
              -3862.213,
              12573.695
            ],
            [
              1220.734,
              -4100.462,
              12811.945
            ],
            [
              1228.325,
              -4142.906,
              12855.063
            ],
            [
              1222.034,
              -4169.508,
              12882.398
            ],
            [
              1223.554,
              -4191.801,
              12904.743
            ],
            [
              1219.757,
              -4222.901,
              12936.075
            ],
            [
              1209.725,
              -4242.754,
              12958.318
            ],
            [
              1201.125,
              -4254.841,
              12973.152
            ],
            [
              1180.185,
              -4272.266,
              13000.394
            ],
            [
              1169.776,
              -4277.639,
              13012.108
            ],
            [
              1151.036,
              -4280.633,
              13031.086
            ],
            [
              1136.221,
              -4280.359,
              13045.903
            ],
            [
              1097.226,
              -4298.563,
              13088.939
            ],
            [
              1061.102,
              -4335.747,
              13140.78
            ],
            [
              1050.796,
              -4335.556,
              13151.087
            ],
            [
              1023.347,
              -4321.691,
              13181.84
            ],
            [
              1017.05,
              -4313.782,
              13191.95
            ],
            [
              1016.673,
              -4299.303,
              13206.434
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 223.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 530.231,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 1007.939,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 1557.015,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 2176.876,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 2970.583,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 3577.193,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 4324.059,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 4930.976,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 5527.156,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 5852.31,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 6386.74,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 7158.902,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 7870.663,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 8180.182,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 8724.734,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 9622.584,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 10073.586,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 10514.888,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 10900.185,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6846",
              "position": {
                "x": 602.169,
                "z": -2976.932
              },
              "distanceAlongShapeM": 11373.713,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:6847",
              "position": {
                "x": 1066.821,
                "z": -3362.875
              },
              "distanceAlongShapeM": 12012.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5147",
              "position": {
                "x": 1133.882,
                "z": -3779.354
              },
              "distanceAlongShapeM": 12453.786,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 12855.063,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 13031.086,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            }
          ],
          "departuresSeconds": [
            19800,
            20460,
            21360,
            22020,
            22980,
            23580,
            24120,
            24660,
            25200,
            25740,
            26220,
            26760,
            27360,
            27900,
            28500,
            29160,
            29880,
            30600,
            31320,
            31920,
            32520,
            33060,
            33660,
            34140,
            35100,
            36060,
            37020,
            37920,
            38820,
            39720,
            40620,
            41520,
            42480,
            43500,
            44460,
            45300,
            46140,
            47100,
            48000,
            48960,
            49980,
            51000,
            52080,
            53040,
            53820,
            54660,
            55620,
            56400,
            56880,
            57360,
            57960,
            58440,
            58980,
            59460,
            59940,
            60480,
            61020,
            61920,
            62880,
            63840,
            64620,
            66240,
            67500,
            69840,
            70920,
            72000,
            72960,
            73920,
            74880,
            75840,
            76860,
            77700,
            78600,
            79500,
            80400,
            81300,
            82260,
            83220
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_7",
      "sourceRouteId": "vilnius_trol_7",
      "mode": "trolleybus",
      "shortName": "7",
      "longName": "Perkūnkiemis–Justiniškės–Žvėrynas–Stotis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_7:0",
          "sourceRouteId": "vilnius_trol_7",
          "sourceShapeId": "vilnius_trol_7_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Perkūnkiemis–Justiniškės–Žvėrynas–Stotis",
          "mode": "trolleybus",
          "routeShortName": "7",
          "routeLongName": "Perkūnkiemis–Justiniškės–Žvėrynas–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3921.595,
              -5098.093,
              0
            ],
            [
              -3918.942,
              -5093.687,
              5.144
            ],
            [
              -3911.137,
              -5089.369,
              14.063
            ],
            [
              -3894.999,
              -5087.423,
              30.318
            ],
            [
              -3881.494,
              -5088.771,
              43.89
            ],
            [
              -3870.508,
              -5086.736,
              55.063
            ],
            [
              -3858.762,
              -5078.034,
              69.681
            ],
            [
              -3854.099,
              -5069.209,
              79.662
            ],
            [
              -3845.592,
              -5061.565,
              91.099
            ],
            [
              -3838.726,
              -5037.193,
              116.419
            ],
            [
              -3828.914,
              -4880.4,
              273.519
            ],
            [
              -3839.647,
              -4756.647,
              397.737
            ],
            [
              -3856.989,
              -4679.534,
              476.776
            ],
            [
              -3893.073,
              -4568.698,
              593.338
            ],
            [
              -3919.183,
              -4476.961,
              688.718
            ],
            [
              -3925.083,
              -4445.689,
              720.542
            ],
            [
              -3938.125,
              -4417.632,
              751.482
            ],
            [
              -3934.344,
              -4385.414,
              783.921
            ],
            [
              -3933.945,
              -4325.308,
              844.029
            ],
            [
              -3923.556,
              -4246.45,
              923.568
            ],
            [
              -3863.253,
              -4076.062,
              1104.312
            ],
            [
              -3846.667,
              -4048.52,
              1136.463
            ],
            [
              -3724.705,
              -3815.753,
              1399.247
            ],
            [
              -3681.09,
              -3716.323,
              1507.822
            ],
            [
              -3652.775,
              -3644.457,
              1585.065
            ],
            [
              -3636.19,
              -3580.18,
              1651.447
            ],
            [
              -3633.854,
              -3520.107,
              1711.566
            ],
            [
              -3624.82,
              -3482.415,
              1750.325
            ],
            [
              -3626.214,
              -3414.484,
              1818.27
            ],
            [
              -3629.537,
              -3383.256,
              1849.674
            ],
            [
              -3641.883,
              -3315.135,
              1918.905
            ],
            [
              -3659.519,
              -3254.715,
              1981.847
            ],
            [
              -3681.569,
              -3188.651,
              2051.493
            ],
            [
              -3706.235,
              -3124.768,
              2119.972
            ],
            [
              -3740.623,
              -3064.057,
              2189.747
            ],
            [
              -3746.718,
              -3043.913,
              2210.792
            ],
            [
              -3749.61,
              -3024.938,
              2229.986
            ],
            [
              -3794.804,
              -2918.397,
              2345.717
            ],
            [
              -3982.054,
              -2455.389,
              2845.155
            ],
            [
              -4002.758,
              -2422.747,
              2883.809
            ],
            [
              -4007.392,
              -2392.61,
              2914.3
            ],
            [
              -4034.259,
              -2306.427,
              3004.574
            ],
            [
              -4048.116,
              -2250.527,
              3062.166
            ],
            [
              -4058.635,
              -2188.005,
              3125.567
            ],
            [
              -4065.192,
              -2119.986,
              3193.902
            ],
            [
              -4071.681,
              -2010.779,
              3303.301
            ],
            [
              -4069.66,
              -1968.512,
              3345.617
            ],
            [
              -4063.29,
              -1898.49,
              3415.928
            ],
            [
              -4045.475,
              -1837.572,
              3479.397
            ],
            [
              -4006.94,
              -1771.447,
              3555.931
            ],
            [
              -3981.93,
              -1741.824,
              3594.7
            ],
            [
              -3941.981,
              -1705.781,
              3648.505
            ],
            [
              -3883.226,
              -1663.385,
              3720.959
            ],
            [
              -3846.769,
              -1642.867,
              3762.793
            ],
            [
              -3813.688,
              -1631.196,
              3797.872
            ],
            [
              -3809.119,
              -1627.936,
              3803.486
            ],
            [
              -3761.37,
              -1625.426,
              3851.301
            ],
            [
              -3487.628,
              -1602.363,
              4126.012
            ],
            [
              -3508.003,
              -1550.799,
              4181.455
            ],
            [
              -3525.544,
              -1521.55,
              4215.561
            ],
            [
              -3534.455,
              -1477.979,
              4260.033
            ],
            [
              -3626.266,
              -1196.964,
              4555.666
            ],
            [
              -3644.163,
              -1151.011,
              4604.982
            ],
            [
              -3645.883,
              -1138.735,
              4617.377
            ],
            [
              -3642.486,
              -1128.776,
              4627.9
            ],
            [
              -3630.73,
              -1120.075,
              4642.526
            ],
            [
              -3599.031,
              -1113.947,
              4674.812
            ],
            [
              -3412.497,
              -1176.2,
              4871.459
            ],
            [
              -3355.367,
              -1190.556,
              4930.366
            ],
            [
              -3108.49,
              -1230.499,
              5180.453
            ],
            [
              -3070.013,
              -1242.306,
              5220.701
            ],
            [
              -2879.155,
              -1277.94,
              5414.856
            ],
            [
              -2839.273,
              -1283.094,
              5455.07
            ],
            [
              -2787.087,
              -1285.125,
              5507.296
            ],
            [
              -2748.376,
              -1283.58,
              5546.038
            ],
            [
              -2714.118,
              -1278.617,
              5580.653
            ],
            [
              -2670.7,
              -1266.023,
              5625.861
            ],
            [
              -2624.585,
              -1246.798,
              5675.822
            ],
            [
              -2500.301,
              -1182.198,
              5815.893
            ],
            [
              -2469.831,
              -1172.717,
              5847.804
            ],
            [
              -2418.716,
              -1162.489,
              5899.932
            ],
            [
              -2392.231,
              -1159.617,
              5926.573
            ],
            [
              -2246.137,
              -1174.448,
              6073.418
            ],
            [
              -2236.291,
              -1164.604,
              6087.341
            ],
            [
              -2207.813,
              -1158.429,
              6116.48
            ],
            [
              -2189.628,
              -1150.959,
              6136.14
            ],
            [
              -2165.425,
              -1131.35,
              6167.29
            ],
            [
              -2151.107,
              -1123.812,
              6183.471
            ],
            [
              -2142.708,
              -1122.847,
              6191.925
            ],
            [
              -2107.685,
              -1111.223,
              6228.827
            ],
            [
              -2052.076,
              -1102.191,
              6285.164
            ],
            [
              -1847.467,
              -1053.508,
              6495.485
            ],
            [
              -1839.367,
              -996.878,
              6552.692
            ],
            [
              -1839.595,
              -973.496,
              6576.075
            ],
            [
              -1831.662,
              -962.505,
              6589.629
            ],
            [
              -1768.396,
              -596.269,
              6961.29
            ],
            [
              -1771.243,
              -575.067,
              6982.682
            ],
            [
              -1761.137,
              -550.756,
              7009.01
            ],
            [
              -1691.384,
              -146.787,
              7418.957
            ],
            [
              -1686.504,
              -90.1,
              7475.854
            ],
            [
              -1682.437,
              -79.04,
              7487.637
            ],
            [
              -1670.247,
              -10.238,
              7557.511
            ],
            [
              -1661.707,
              -1.484,
              7569.74
            ],
            [
              -1388.929,
              -38.642,
              7845.037
            ],
            [
              -1362.417,
              -34.664,
              7871.847
            ],
            [
              -1329.577,
              -37.478,
              7904.807
            ],
            [
              -1190.447,
              -11.028,
              8046.429
            ],
            [
              -1025.306,
              27.195,
              8215.935
            ],
            [
              -994.12,
              39.993,
              8249.645
            ],
            [
              -949.475,
              48.095,
              8295.02
            ],
            [
              -919.958,
              39.772,
              8325.688
            ],
            [
              -857.805,
              53.124,
              8389.259
            ],
            [
              -724.996,
              86.353,
              8526.162
            ],
            [
              -591.62,
              115.115,
              8662.604
            ],
            [
              -557.893,
              125.637,
              8697.934
            ],
            [
              -539.176,
              126.412,
              8716.667
            ],
            [
              -408.498,
              148.538,
              8849.205
            ],
            [
              -385.731,
              159.258,
              8874.37
            ],
            [
              -216.06,
              268.617,
              9076.23
            ],
            [
              -50.385,
              441.496,
              9315.678
            ],
            [
              -51.307,
              497.175,
              9371.364
            ],
            [
              -56,
              522.864,
              9397.479
            ],
            [
              -44.593,
              547.148,
              9424.308
            ],
            [
              -34.25,
              619.32,
              9497.217
            ],
            [
              -34.886,
              726.201,
              9604.101
            ],
            [
              -29.964,
              784,
              9662.109
            ],
            [
              -31.514,
              805.179,
              9683.345
            ],
            [
              -24.076,
              823.969,
              9703.553
            ],
            [
              -6.94,
              914.942,
              9796.126
            ],
            [
              5.94,
              949.218,
              9832.742
            ],
            [
              14.89,
              980.225,
              9865.015
            ],
            [
              17.976,
              1008,
              9892.961
            ],
            [
              98.858,
              1127.869,
              10037.565
            ],
            [
              206.575,
              1304.022,
              10244.043
            ],
            [
              265.611,
              1357.493,
              10323.695
            ],
            [
              347.967,
              1416.104,
              10424.777
            ],
            [
              403.761,
              1468.519,
              10501.33
            ],
            [
              405.778,
              1472.935,
              10506.184
            ],
            [
              396.871,
              1479.777,
              10517.416
            ],
            [
              393.103,
              1485.412,
              10524.195
            ],
            [
              391.311,
              1493.238,
              10532.223
            ],
            [
              394.908,
              1548.834,
              10587.935
            ],
            [
              392.049,
              1568.924,
              10608.228
            ],
            [
              397.453,
              1582.184,
              10622.546
            ],
            [
              391.321,
              1670.242,
              10710.817
            ],
            [
              327.595,
              1819.466,
              10873.079
            ],
            [
              328.524,
              1835.034,
              10888.675
            ],
            [
              390.297,
              1931.87,
              11003.535
            ],
            [
              384.797,
              1948.669,
              11021.212
            ],
            [
              364.123,
              1982.443,
              11060.812
            ],
            [
              361.04,
              1990.292,
              11069.244
            ],
            [
              361.142,
              1995.857,
              11074.81
            ],
            [
              367.089,
              2003.541,
              11084.526
            ],
            [
              374.225,
              2005.637,
              11091.963
            ],
            [
              387.77,
              2005.389,
              11105.511
            ],
            [
              447.829,
              1973.12,
              11173.69
            ],
            [
              479.21,
              1960.301,
              11207.588
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 79.662,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:687",
              "position": {
                "x": -3938.125,
                "z": -4417.632
              },
              "distanceAlongShapeM": 751.482,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:949",
              "position": {
                "x": -3863.253,
                "z": -4076.062
              },
              "distanceAlongShapeM": 1104.312,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:542",
              "position": {
                "x": -3683.061,
                "z": -3718.515
              },
              "distanceAlongShapeM": 1505.022,
              "shapeOffsetM": 0.925,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5060",
              "position": {
                "x": -3633.854,
                "z": -3520.107
              },
              "distanceAlongShapeM": 1711.566,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6580",
              "position": {
                "x": -3740.623,
                "z": -3064.057
              },
              "distanceAlongShapeM": 2189.747,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6581",
              "position": {
                "x": -4002.758,
                "z": -2422.747
              },
              "distanceAlongShapeM": 2883.809,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6588",
              "position": {
                "x": -4045.475,
                "z": -1837.572
              },
              "distanceAlongShapeM": 3479.397,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6591",
              "position": {
                "x": -3809.119,
                "z": -1627.936
              },
              "distanceAlongShapeM": 3803.486,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 4215.561,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 5180.453,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6430",
              "position": {
                "x": -2107.685,
                "z": -1111.223
              },
              "distanceAlongShapeM": 6228.827,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6433",
              "position": {
                "x": -1839.595,
                "z": -973.496
              },
              "distanceAlongShapeM": 6576.075,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6434",
              "position": {
                "x": -1771.243,
                "z": -575.067
              },
              "distanceAlongShapeM": 6982.682,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6437",
              "position": {
                "x": -1686.504,
                "z": -90.1
              },
              "distanceAlongShapeM": 7475.854,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:18852",
              "position": {
                "x": -1457.753,
                "z": -28.505
              },
              "distanceAlongShapeM": 7775.475,
              "shapeOffsetM": 0.755,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5881",
              "position": {
                "x": -949.475,
                "z": 48.095
              },
              "distanceAlongShapeM": 8295.02,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 8697.934,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 9397.479,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 9892.961,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 10244.043,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 10608.228,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 11207.588,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            }
          ],
          "departuresSeconds": [
            17820,
            18780,
            19380,
            19980,
            20700,
            21420,
            22020,
            22500,
            22920,
            23340,
            23700,
            24060,
            24420,
            24720,
            25020,
            25320,
            25620,
            25920,
            26220,
            26580,
            27000,
            27420,
            27840,
            28260,
            28680,
            29160,
            29640,
            30120,
            30600,
            31080,
            31500,
            31980,
            32400,
            32820,
            33240,
            33720,
            34380,
            34920,
            35400,
            35940,
            36480,
            37080,
            37680,
            38280,
            38880,
            39420,
            39900,
            40380,
            40860,
            41280,
            41760,
            42240,
            42720,
            43260,
            43860,
            44400,
            44940,
            45420,
            45900,
            46380,
            46800,
            47280,
            47760,
            48240,
            48840,
            49440,
            50040,
            50520,
            51000,
            51420,
            51840,
            52260,
            52620,
            52980,
            53340,
            53700,
            54060,
            54420,
            54780,
            55200,
            55560,
            55980,
            56340,
            56700,
            57000,
            57300,
            57660,
            58020,
            58380,
            58740,
            59100,
            59400,
            59700,
            60000,
            60420,
            60840,
            61200,
            61620,
            61980,
            62340,
            62700,
            63060,
            63420,
            63780,
            64140,
            64680,
            65280,
            65940,
            66720,
            67500,
            68040,
            68640,
            69180,
            69720,
            70260,
            71040,
            71820,
            72420,
            73020,
            73620,
            74280,
            74760,
            75300,
            75780,
            76260,
            76800,
            77280,
            77880,
            78480,
            79080,
            79980,
            80880,
            81780,
            82680,
            83160
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_7:1",
          "sourceRouteId": "vilnius_trol_7",
          "sourceShapeId": "vilnius_trol_7_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Stotis–Žvėrynas–Justiniškės–Perkūnkiemis",
          "mode": "trolleybus",
          "routeShortName": "7",
          "routeLongName": "Perkūnkiemis–Justiniškės–Žvėrynas–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              479.21,
              1960.301,
              0
            ],
            [
              486.04,
              1945.704,
              16.116
            ],
            [
              477.309,
              1926.939,
              36.813
            ],
            [
              467.471,
              1918.213,
              49.963
            ],
            [
              410.21,
              1927.053,
              107.902
            ],
            [
              405.736,
              1929.361,
              112.937
            ],
            [
              398.6,
              1927.265,
              120.374
            ],
            [
              329.489,
              1817.205,
              250.334
            ],
            [
              330.657,
              1810.504,
              257.135
            ],
            [
              391.321,
              1670.242,
              409.954
            ],
            [
              473.433,
              1574.115,
              536.377
            ],
            [
              482.238,
              1561.708,
              551.591
            ],
            [
              479.414,
              1548.401,
              565.194
            ],
            [
              472.7,
              1534.052,
              581.037
            ],
            [
              453.691,
              1517.701,
              606.11
            ],
            [
              360.424,
              1427.008,
              736.202
            ],
            [
              315.899,
              1391.085,
              793.412
            ],
            [
              256.42,
              1348.755,
              866.416
            ],
            [
              223.566,
              1315.958,
              912.838
            ],
            [
              196.476,
              1280.829,
              957.2
            ],
            [
              149.248,
              1202.651,
              1048.536
            ],
            [
              55.081,
              1061.873,
              1217.905
            ],
            [
              52.802,
              1042.989,
              1236.925
            ],
            [
              42.322,
              1034.274,
              1250.555
            ],
            [
              29.685,
              1013.353,
              1274.997
            ],
            [
              17.226,
              966.824,
              1323.165
            ],
            [
              -2.949,
              921.549,
              1372.732
            ],
            [
              -20.167,
              826.124,
              1469.698
            ],
            [
              -26.358,
              769.462,
              1526.697
            ],
            [
              -34.886,
              726.201,
              1570.79
            ],
            [
              -34.25,
              619.32,
              1677.674
            ],
            [
              -49.15,
              509.381,
              1788.618
            ],
            [
              -50.587,
              430.368,
              1867.644
            ],
            [
              -86.677,
              396.514,
              1917.127
            ],
            [
              -97.297,
              380.009,
              1936.754
            ],
            [
              -191.175,
              289.316,
              2067.284
            ],
            [
              -216.06,
              268.617,
              2099.653
            ],
            [
              -386.375,
              159.27,
              2302.049
            ],
            [
              -408.498,
              148.538,
              2326.637
            ],
            [
              -583.944,
              111.636,
              2505.921
            ],
            [
              -658.953,
              100.746,
              2581.717
            ],
            [
              -724.996,
              86.353,
              2649.31
            ],
            [
              -736.157,
              75.422,
              2664.932
            ],
            [
              -743.833,
              78.9,
              2673.36
            ],
            [
              -798.875,
              66.534,
              2729.774
            ],
            [
              -863.023,
              49.879,
              2796.048
            ],
            [
              -870.86,
              44.454,
              2805.58
            ],
            [
              -877.911,
              46.807,
              2813.014
            ],
            [
              -930.978,
              36.63,
              2867.048
            ],
            [
              -998.108,
              33.385,
              2934.256
            ],
            [
              -1226.73,
              -20.397,
              3169.118
            ],
            [
              -1327.722,
              -41.964,
              3272.388
            ],
            [
              -1378.268,
              -55.531,
              3324.723
            ],
            [
              -1438.145,
              -50.007,
              3384.855
            ],
            [
              -1471.431,
              -36.053,
              3420.947
            ],
            [
              -1661.707,
              -1.484,
              3614.337
            ],
            [
              -1691.384,
              -146.787,
              3762.64
            ],
            [
              -1712.987,
              -273.309,
              3890.993
            ],
            [
              -1710.567,
              -282.258,
              3900.263
            ],
            [
              -1719.483,
              -312.156,
              3931.462
            ],
            [
              -1768.396,
              -596.269,
              4219.755
            ],
            [
              -1770.261,
              -628.519,
              4252.059
            ],
            [
              -1778.412,
              -651.752,
              4276.68
            ],
            [
              -1847.467,
              -1053.508,
              4684.328
            ],
            [
              -1903.255,
              -1072.553,
              4743.278
            ],
            [
              -1911.753,
              -1079.081,
              4753.994
            ],
            [
              -1954.393,
              -1083.889,
              4796.903
            ],
            [
              -2142.708,
              -1122.847,
              4989.206
            ],
            [
              -2154.408,
              -1128.206,
              5002.075
            ],
            [
              -2189.766,
              -1158.749,
              5048.798
            ],
            [
              -2202.091,
              -1162.983,
              5061.83
            ],
            [
              -2218.205,
              -1162.698,
              5077.946
            ],
            [
              -2227.932,
              -1165.865,
              5088.176
            ],
            [
              -2246.137,
              -1174.448,
              5108.303
            ],
            [
              -2255.397,
              -1187.643,
              5124.423
            ],
            [
              -2267.097,
              -1193.002,
              5137.292
            ],
            [
              -2295.924,
              -1182.472,
              5167.982
            ],
            [
              -2392.506,
              -1175.197,
              5264.838
            ],
            [
              -2431.277,
              -1180.078,
              5303.914
            ],
            [
              -2478.584,
              -1193.714,
              5353.147
            ],
            [
              -2533.196,
              -1219.467,
              5413.527
            ],
            [
              -2617.204,
              -1266.966,
              5510.034
            ],
            [
              -2663.944,
              -1285.067,
              5560.155
            ],
            [
              -2710.565,
              -1296.491,
              5608.156
            ],
            [
              -2762.303,
              -1305.599,
              5660.69
            ],
            [
              -2806.189,
              -1308.166,
              5704.651
            ],
            [
              -2858.961,
              -1302.785,
              5757.697
            ],
            [
              -3085.169,
              -1260.965,
              5987.738
            ],
            [
              -3140.52,
              -1255.542,
              6043.354
            ],
            [
              -3159.719,
              -1247.413,
              6064.203
            ],
            [
              -3359.526,
              -1207.182,
              6268.02
            ],
            [
              -3495.953,
              -1192.555,
              6405.229
            ],
            [
              -3539.254,
              -1198.48,
              6448.932
            ],
            [
              -3554.175,
              -1203.786,
              6464.769
            ],
            [
              -3558.842,
              -1212.61,
              6474.751
            ],
            [
              -3559.094,
              -1227.077,
              6489.221
            ],
            [
              -3554.873,
              -1243.849,
              6506.516
            ],
            [
              -3543.073,
              -1269.659,
              6534.895
            ],
            [
              -3520.478,
              -1415.883,
              6682.855
            ],
            [
              -3500.646,
              -1498.607,
              6767.922
            ],
            [
              -3461.302,
              -1608.388,
              6884.541
            ],
            [
              -3462.063,
              -1615.054,
              6891.25
            ],
            [
              -3466.007,
              -1619.438,
              6897.147
            ],
            [
              -3480.186,
              -1619.191,
              6911.328
            ],
            [
              -3518.951,
              -1624.08,
              6950.401
            ],
            [
              -3542.913,
              -1630.342,
              6975.167
            ],
            [
              -3571.837,
              -1625.385,
              7004.513
            ],
            [
              -3721.548,
              -1633.911,
              7154.466
            ],
            [
              -3788.083,
              -1641.66,
              7221.451
            ],
            [
              -3841.2,
              -1656.322,
              7276.555
            ],
            [
              -3882.188,
              -1677.875,
              7322.864
            ],
            [
              -3931.102,
              -1710.422,
              7381.617
            ],
            [
              -3978.977,
              -1757.46,
              7448.733
            ],
            [
              -4022.062,
              -1825.732,
              7529.464
            ],
            [
              -4044.37,
              -1885.459,
              7593.221
            ],
            [
              -4052.817,
              -1926.501,
              7635.123
            ],
            [
              -4053.048,
              -1939.856,
              7648.48
            ],
            [
              -4048.884,
              -1959.966,
              7669.016
            ],
            [
              -4055.493,
              -2006.606,
              7716.122
            ],
            [
              -4046.573,
              -2161.497,
              7871.27
            ],
            [
              -4020.612,
              -2299.985,
              8012.17
            ],
            [
              -3990.129,
              -2400.702,
              8117.399
            ],
            [
              -3964.263,
              -2470.17,
              8191.526
            ],
            [
              -3946.156,
              -2503.88,
              8229.792
            ],
            [
              -3932.856,
              -2517.469,
              8248.806
            ],
            [
              -3932.443,
              -2530.835,
              8262.178
            ],
            [
              -3926.386,
              -2553.204,
              8285.353
            ],
            [
              -3841.707,
              -2761.732,
              8510.418
            ],
            [
              -3765.67,
              -2947.847,
              8711.466
            ],
            [
              -3690.695,
              -3120.586,
              8899.775
            ],
            [
              -3680.304,
              -3153.05,
              8933.861
            ],
            [
              -3662.711,
              -3178.96,
              8965.18
            ],
            [
              -3658.589,
              -3201.296,
              8987.894
            ],
            [
              -3639.586,
              -3257.288,
              9047.022
            ],
            [
              -3617.301,
              -3346.734,
              9139.202
            ],
            [
              -3610.443,
              -3396.948,
              9189.882
            ],
            [
              -3607.737,
              -3500.524,
              9293.494
            ],
            [
              -3620.065,
              -3579.347,
              9373.275
            ],
            [
              -3625.467,
              -3630.461,
              9424.674
            ],
            [
              -3640.182,
              -3661.375,
              9458.911
            ],
            [
              -3673.181,
              -3743.178,
              9547.119
            ],
            [
              -3862.172,
              -4125.062,
              9973.21
            ],
            [
              -3875.164,
              -4168.252,
              10018.311
            ],
            [
              -3892.491,
              -4201.348,
              10055.668
            ],
            [
              -3906.204,
              -4248.978,
              10105.233
            ],
            [
              -3915.447,
              -4298.912,
              10156.015
            ],
            [
              -3918.758,
              -4341.156,
              10198.389
            ],
            [
              -3917.895,
              -4365.662,
              10222.91
            ],
            [
              -3914.159,
              -4410.256,
              10267.66
            ],
            [
              -3903.629,
              -4471.665,
              10329.966
            ],
            [
              -3893.942,
              -4507.456,
              10367.045
            ],
            [
              -3883.947,
              -4525.441,
              10387.621
            ],
            [
              -3876.856,
              -4562.301,
              10425.156
            ],
            [
              -3837.687,
              -4680.982,
              10550.134
            ],
            [
              -3830.05,
              -4723.417,
              10593.251
            ],
            [
              -3816.509,
              -4833.861,
              10704.521
            ],
            [
              -3815.714,
              -4936.291,
              10806.954
            ],
            [
              -3827.361,
              -5087.486,
              10958.597
            ],
            [
              -3832.624,
              -5130.81,
              11002.239
            ],
            [
              -3844.602,
              -5152.866,
              11027.338
            ],
            [
              -3879.396,
              -5153.374,
              11062.136
            ],
            [
              -3922.484,
              -5149.286,
              11105.417
            ],
            [
              -3928.106,
              -5139.169,
              11116.991
            ],
            [
              -3926.238,
              -5105.805,
              11150.407
            ],
            [
              -3921.595,
              -5098.093,
              11159.409
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 581.037,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1236.925,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 1526.697,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 1936.754,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5936",
              "position": {
                "x": -736.157,
                "z": 75.422
              },
              "distanceAlongShapeM": 2664.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:19193",
              "position": {
                "x": -870.86,
                "z": 44.454
              },
              "distanceAlongShapeM": 2805.58,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:6438",
              "position": {
                "x": -1438.145,
                "z": -50.007
              },
              "distanceAlongShapeM": 3384.855,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6436",
              "position": {
                "x": -1710.567,
                "z": -282.258
              },
              "distanceAlongShapeM": 3900.263,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6435",
              "position": {
                "x": -1770.261,
                "z": -628.519
              },
              "distanceAlongShapeM": 4252.059,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6432",
              "position": {
                "x": -1911.753,
                "z": -1079.081
              },
              "distanceAlongShapeM": 4753.994,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 6043.354,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 6534.895,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6597",
              "position": {
                "x": -3542.913,
                "z": -1630.342
              },
              "distanceAlongShapeM": 6975.167,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6587",
              "position": {
                "x": -4048.884,
                "z": -1959.966
              },
              "distanceAlongShapeM": 7669.016,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6582",
              "position": {
                "x": -3932.856,
                "z": -2517.469
              },
              "distanceAlongShapeM": 8248.806,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5063",
              "position": {
                "x": -3662.711,
                "z": -3178.96
              },
              "distanceAlongShapeM": 8965.18,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5140",
              "position": {
                "x": -3625.467,
                "z": -3630.461
              },
              "distanceAlongShapeM": 9424.674,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5141",
              "position": {
                "x": -3875.164,
                "z": -4168.252
              },
              "distanceAlongShapeM": 10018.311,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6925",
              "position": {
                "x": -3883.947,
                "z": -4525.441
              },
              "distanceAlongShapeM": 10387.621,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 10958.597,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            }
          ],
          "departuresSeconds": [
            18600,
            20280,
            21240,
            21840,
            22440,
            23160,
            23880,
            24480,
            24960,
            25380,
            25860,
            26220,
            26580,
            27000,
            27300,
            27600,
            27900,
            28200,
            28500,
            28800,
            29160,
            29580,
            30000,
            30420,
            30840,
            31260,
            31740,
            32160,
            32640,
            33120,
            33600,
            34020,
            34380,
            34800,
            35160,
            35580,
            36060,
            36720,
            37260,
            37740,
            38340,
            38880,
            39480,
            40080,
            40680,
            41280,
            41820,
            42300,
            42780,
            43260,
            43680,
            44160,
            44640,
            45120,
            45660,
            46260,
            46800,
            47340,
            47820,
            48300,
            48720,
            49140,
            49620,
            50100,
            50580,
            51180,
            51840,
            52440,
            52860,
            53340,
            53760,
            54180,
            54600,
            54960,
            55320,
            55680,
            56100,
            56460,
            56820,
            57180,
            57600,
            57960,
            58380,
            58740,
            59100,
            59400,
            59700,
            60060,
            60420,
            60780,
            61140,
            61500,
            61800,
            62100,
            62400,
            62820,
            63300,
            63600,
            64020,
            64380,
            64740,
            65100,
            65460,
            65880,
            66240,
            66540,
            67080,
            67680,
            68340,
            69120,
            69900,
            70440,
            70980,
            71520,
            72060,
            72600,
            73380,
            74160,
            74760,
            75360,
            75960,
            76620,
            77100,
            77640,
            78120,
            78600,
            79140,
            79620,
            80220,
            80820,
            81360,
            82260,
            83160,
            84060
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_9",
      "sourceRouteId": "vilnius_trol_9",
      "mode": "trolleybus",
      "shortName": "9",
      "longName": "Karoliniškės–Šeimyniškių g.–Žirmūnai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_9:0",
          "sourceRouteId": "vilnius_trol_9",
          "sourceShapeId": "vilnius_trol_9_a-b",
          "directionId": 0,
          "headsign": "Žirmūnai",
          "directionName": "Karoliniškės–Šeimyniškių g.–Žirmūnai",
          "mode": "trolleybus",
          "routeShortName": "9",
          "routeLongName": "Karoliniškės–Šeimyniškių g.–Žirmūnai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4631.619,
              553.685,
              0
            ],
            [
              -4628.075,
              534.7,
              19.313
            ],
            [
              -4631.834,
              503.595,
              50.645
            ],
            [
              -4642.705,
              471.499,
              84.532
            ],
            [
              -4646.407,
              443.732,
              112.544
            ],
            [
              -4641.216,
              408.021,
              148.631
            ],
            [
              -4613.144,
              315.143,
              245.658
            ],
            [
              -4582.265,
              235.574,
              331.008
            ],
            [
              -4568.349,
              219.75,
              352.081
            ],
            [
              -4568.029,
              200.82,
              371.014
            ],
            [
              -4518.608,
              112.027,
              472.634
            ],
            [
              -4509.454,
              81.813,
              504.204
            ],
            [
              -4478.955,
              17.836,
              575.079
            ],
            [
              -4459.487,
              -12.556,
              611.172
            ],
            [
              -4426.085,
              -57.659,
              667.297
            ],
            [
              -4398.274,
              -90.421,
              710.271
            ],
            [
              -4367.713,
              -113.212,
              748.395
            ],
            [
              -4345.341,
              -124.73,
              773.558
            ],
            [
              -4335.314,
              -141.601,
              793.184
            ],
            [
              -4247.163,
              -227.726,
              916.423
            ],
            [
              -4197.821,
              -283.125,
              990.61
            ],
            [
              -4155.783,
              -350.644,
              1070.147
            ],
            [
              -4080.976,
              -462.146,
              1204.417
            ],
            [
              -4057.587,
              -489.267,
              1240.231
            ],
            [
              -4052.757,
              -508.276,
              1259.844
            ],
            [
              -3962.534,
              -660.121,
              1436.471
            ],
            [
              -3958.061,
              -662.425,
              1441.503
            ],
            [
              -3950.306,
              -661.447,
              1449.319
            ],
            [
              -3806.746,
              -600.485,
              1605.287
            ],
            [
              -3694.685,
              -571.263,
              1721.096
            ],
            [
              -3695.742,
              -557.886,
              1734.514
            ],
            [
              -3728.082,
              -489.418,
              1810.236
            ],
            [
              -3741.232,
              -466.925,
              1836.291
            ],
            [
              -3745.668,
              -462.395,
              1842.63
            ],
            [
              -3755.943,
              -459.99,
              1853.184
            ],
            [
              -3839.114,
              -496.394,
              1943.973
            ],
            [
              -3852.238,
              -509.525,
              1962.538
            ],
            [
              -3858.936,
              -523.881,
              1978.379
            ],
            [
              -3860.379,
              -532.761,
              1987.376
            ],
            [
              -3823.641,
              -607.984,
              2071.091
            ],
            [
              -3766.483,
              -732.543,
              2208.138
            ],
            [
              -3707.64,
              -908.34,
              2393.522
            ],
            [
              -3695.741,
              -928.584,
              2417.004
            ],
            [
              -3679.35,
              -950.021,
              2443.989
            ],
            [
              -3668.232,
              -978.044,
              2474.137
            ],
            [
              -3606.925,
              -1085.98,
              2598.269
            ],
            [
              -3586.062,
              -1109.72,
              2629.874
            ],
            [
              -3575.241,
              -1117.701,
              2643.32
            ],
            [
              -3510.568,
              -1143.319,
              2712.881
            ],
            [
              -3355.367,
              -1190.556,
              2875.112
            ],
            [
              -3108.49,
              -1230.499,
              3125.2
            ],
            [
              -3070.013,
              -1242.306,
              3165.447
            ],
            [
              -2879.155,
              -1277.94,
              3359.603
            ],
            [
              -2839.273,
              -1283.094,
              3399.817
            ],
            [
              -2787.087,
              -1285.125,
              3452.043
            ],
            [
              -2748.376,
              -1283.58,
              3490.784
            ],
            [
              -2714.118,
              -1278.617,
              3525.399
            ],
            [
              -2670.7,
              -1266.023,
              3570.607
            ],
            [
              -2624.585,
              -1246.798,
              3620.569
            ],
            [
              -2500.301,
              -1182.198,
              3760.639
            ],
            [
              -2469.831,
              -1172.717,
              3792.55
            ],
            [
              -2418.716,
              -1162.489,
              3844.679
            ],
            [
              -2392.231,
              -1159.617,
              3871.319
            ],
            [
              -2151.528,
              -1183.918,
              4113.246
            ],
            [
              -2126.509,
              -1191.041,
              4139.258
            ],
            [
              -2118.854,
              -1195.63,
              4148.184
            ],
            [
              -1988.935,
              -1213.522,
              4279.329
            ],
            [
              -1948.388,
              -1217.583,
              4320.079
            ],
            [
              -1827.9,
              -1221.953,
              4440.646
            ],
            [
              -1794.345,
              -1220.324,
              4474.241
            ],
            [
              -1747.175,
              -1214.486,
              4521.771
            ],
            [
              -1624.316,
              -1194.413,
              4646.258
            ],
            [
              -1544.075,
              -1178.035,
              4728.153
            ],
            [
              -1436.465,
              -1145.449,
              4840.59
            ],
            [
              -1393.22,
              -1142.883,
              4883.91
            ],
            [
              -1155.149,
              -1098.17,
              5126.144
            ],
            [
              -1103.929,
              -1082.392,
              5179.739
            ],
            [
              -1083.324,
              -1083.875,
              5200.398
            ],
            [
              -1022.536,
              -1073.836,
              5262.009
            ],
            [
              -998.991,
              -1055.334,
              5291.953
            ],
            [
              -969.041,
              -1039.175,
              5325.985
            ],
            [
              -947.066,
              -1036.231,
              5348.156
            ],
            [
              -930.307,
              -1036.533,
              5364.917
            ],
            [
              -906.579,
              -1043.639,
              5389.687
            ],
            [
              -895.802,
              -1053.852,
              5404.535
            ],
            [
              -890.221,
              -1066.198,
              5418.084
            ],
            [
              -882.043,
              -1077.478,
              5432.016
            ],
            [
              -864.236,
              -1091.158,
              5454.471
            ],
            [
              -845.624,
              -1095.946,
              5473.689
            ],
            [
              -813.336,
              -1093.188,
              5506.094
            ],
            [
              -786.145,
              -1086.999,
              5533.981
            ],
            [
              -775.751,
              -1082.734,
              5545.216
            ],
            [
              -717.641,
              -1078.217,
              5603.501
            ],
            [
              -647.083,
              -1062.792,
              5675.726
            ],
            [
              -599.769,
              -1049.176,
              5724.96
            ],
            [
              -511.525,
              -1018.488,
              5818.388
            ],
            [
              -361.843,
              -942.16,
              5986.408
            ],
            [
              -333.702,
              -919.293,
              6022.668
            ],
            [
              -286.889,
              -897.877,
              6074.148
            ],
            [
              -196.966,
              -846.075,
              6177.924
            ],
            [
              -115.583,
              -803.025,
              6269.992
            ],
            [
              -96.647,
              -790.01,
              6292.969
            ],
            [
              -42.035,
              -765.399,
              6352.871
            ],
            [
              224.8,
              -701.243,
              6627.31
            ],
            [
              237.149,
              -695.903,
              6640.764
            ],
            [
              292.85,
              -682.448,
              6698.067
            ],
            [
              331.506,
              -684.268,
              6736.766
            ],
            [
              436.802,
              -673.948,
              6842.567
            ],
            [
              647.48,
              -719,
              7058.007
            ],
            [
              692.52,
              -724.28,
              7103.356
            ],
            [
              729.304,
              -722.729,
              7140.172
            ],
            [
              752.305,
              -734.284,
              7165.913
            ],
            [
              1031.058,
              -793.963,
              7450.983
            ],
            [
              1157.03,
              -816.326,
              7578.924
            ],
            [
              1200.176,
              -819.349,
              7622.177
            ],
            [
              1220.015,
              -827.509,
              7643.627
            ],
            [
              1248.96,
              -831.383,
              7672.83
            ],
            [
              1325.104,
              -828.339,
              7749.036
            ],
            [
              1339.141,
              -836.391,
              7765.218
            ],
            [
              1354.364,
              -850.032,
              7785.659
            ],
            [
              1360.583,
              -862.393,
              7799.496
            ],
            [
              1367.85,
              -922.642,
              7860.182
            ],
            [
              1384.491,
              -964.14,
              7904.893
            ],
            [
              1464.439,
              -1103.664,
              8065.698
            ],
            [
              1480.223,
              -1121.768,
              8089.717
            ],
            [
              1488.813,
              -1145.306,
              8114.773
            ],
            [
              1537.374,
              -1238.606,
              8219.954
            ],
            [
              1587.871,
              -1366.453,
              8357.412
            ],
            [
              1626.598,
              -1502.988,
              8499.333
            ],
            [
              1647.564,
              -1589.097,
              8587.958
            ],
            [
              1670.179,
              -1759.844,
              8760.196
            ],
            [
              1676.751,
              -1787.797,
              8788.912
            ],
            [
              1672.408,
              -1813.321,
              8814.803
            ],
            [
              1677.37,
              -1962.589,
              8964.152
            ],
            [
              1684.587,
              -2475.93,
              9477.544
            ],
            [
              1691.063,
              -2612.98,
              9614.747
            ],
            [
              1696.386,
              -2638.684,
              9640.996
            ],
            [
              1690.652,
              -2669.748,
              9672.585
            ],
            [
              1690.731,
              -2873.474,
              9876.311
            ],
            [
              1700.851,
              -3126.37,
              10129.41
            ],
            [
              1709.563,
              -3177.741,
              10181.515
            ],
            [
              1701.896,
              -3208.77,
              10213.476
            ],
            [
              1697.306,
              -3247.648,
              10252.624
            ],
            [
              1679.831,
              -3286.287,
              10295.031
            ],
            [
              1593.247,
              -3437.193,
              10469.012
            ],
            [
              1582.257,
              -3473.726,
              10507.162
            ],
            [
              1566.424,
              -3493.47,
              10532.471
            ],
            [
              1509.807,
              -3592.611,
              10646.64
            ],
            [
              1412.221,
              -3746.656,
              10828.993
            ],
            [
              1401.002,
              -3760.92,
              10847.141
            ],
            [
              1342.825,
              -3805.485,
              10920.425
            ],
            [
              1325.974,
              -3810.739,
              10938.076
            ],
            [
              1219.986,
              -3862.213,
              11055.902
            ],
            [
              1220.734,
              -4100.462,
              11294.152
            ],
            [
              1228.325,
              -4142.906,
              11337.27
            ],
            [
              1222.034,
              -4169.508,
              11364.605
            ],
            [
              1223.554,
              -4191.801,
              11386.95
            ],
            [
              1219.757,
              -4222.901,
              11418.282
            ],
            [
              1209.725,
              -4242.754,
              11440.525
            ],
            [
              1201.125,
              -4254.841,
              11455.359
            ],
            [
              1180.185,
              -4272.266,
              11482.601
            ],
            [
              1169.776,
              -4277.639,
              11494.315
            ],
            [
              1151.036,
              -4280.633,
              11513.293
            ],
            [
              1136.221,
              -4280.359,
              11528.11
            ],
            [
              1097.226,
              -4298.563,
              11571.146
            ],
            [
              1061.102,
              -4335.747,
              11622.987
            ],
            [
              1050.796,
              -4335.556,
              11633.294
            ],
            [
              1023.347,
              -4321.691,
              11664.047
            ],
            [
              1017.05,
              -4313.782,
              11674.157
            ],
            [
              1016.673,
              -4299.303,
              11688.641
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5924",
              "position": {
                "x": -4631.834,
                "z": 503.595
              },
              "distanceAlongShapeM": 50.645,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:351",
              "position": {
                "x": -4568.349,
                "z": 219.75
              },
              "distanceAlongShapeM": 352.081,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6400",
              "position": {
                "x": -4345.341,
                "z": -124.73
              },
              "distanceAlongShapeM": 773.558,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:596",
              "position": {
                "x": -4057.587,
                "z": -489.267
              },
              "distanceAlongShapeM": 1240.231,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 2443.989,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 3125.2,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:6398",
              "position": {
                "x": -2151.528,
                "z": -1183.918
              },
              "distanceAlongShapeM": 4113.246,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6396",
              "position": {
                "x": -1436.465,
                "z": -1145.449
              },
              "distanceAlongShapeM": 4840.59,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 5179.739,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 5545.216,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 6022.668,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 6352.871,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 6698.067,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5665",
              "position": {
                "x": 729.304,
                "z": -722.729
              },
              "distanceAlongShapeM": 7140.172,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6660",
              "position": {
                "x": 1200.176,
                "z": -819.349
              },
              "distanceAlongShapeM": 7622.177,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 8089.717,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 8788.912,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 9640.996,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 10181.515,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 10507.162,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 10920.425,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 11337.27,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 11513.293,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            }
          ],
          "departuresSeconds": [
            18480,
            20100,
            21420,
            22440,
            23520,
            24360,
            25140,
            25920,
            26700,
            27840,
            29040,
            30240,
            31680,
            32880,
            34080,
            35220,
            37740,
            39480,
            41580,
            43740,
            45780,
            47820,
            50040,
            51420,
            52380,
            53340,
            54300,
            55320,
            56460,
            57240,
            58320,
            59160,
            60360,
            61560,
            62880,
            64500,
            66120,
            68520,
            70740,
            72480,
            74580,
            76440,
            78300,
            80280,
            82260
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_9:1",
          "sourceRouteId": "vilnius_trol_9",
          "sourceShapeId": "vilnius_trol_9_b-a",
          "directionId": 1,
          "headsign": "Karoliniškės",
          "directionName": "Žirmūnai–Šeimyniškių g.–Karoliniškės",
          "mode": "trolleybus",
          "routeShortName": "9",
          "routeLongName": "Karoliniškės–Šeimyniškių g.–Žirmūnai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1016.673,
              -4299.303,
              0
            ],
            [
              1017.645,
              -4281.509,
              17.821
            ],
            [
              1022.257,
              -4276.027,
              24.984
            ],
            [
              1106.613,
              -4278.698,
              109.382
            ],
            [
              1128.033,
              -4270.188,
              132.431
            ],
            [
              1147.356,
              -4270.545,
              151.757
            ],
            [
              1188.702,
              -4264.63,
              193.524
            ],
            [
              1202.517,
              -4249.3,
              214.16
            ],
            [
              1214.522,
              -4227.257,
              239.261
            ],
            [
              1220.978,
              -4191.753,
              275.347
            ],
            [
              1217.195,
              -3943.429,
              523.7
            ],
            [
              1219.986,
              -3862.213,
              604.964
            ],
            [
              1375.611,
              -3774.922,
              783.398
            ],
            [
              1393.375,
              -3755.212,
              809.932
            ],
            [
              1412.221,
              -3746.656,
              830.629
            ],
            [
              1509.056,
              -3563.653,
              1037.673
            ],
            [
              1556.885,
              -3486.613,
              1128.352
            ],
            [
              1607.644,
              -3390.704,
              1236.865
            ],
            [
              1620.009,
              -3384.254,
              1250.811
            ],
            [
              1689.847,
              -3267.548,
              1386.817
            ],
            [
              1697.306,
              -3247.648,
              1408.069
            ],
            [
              1696.944,
              -3128.524,
              1527.194
            ],
            [
              1687.839,
              -3098.296,
              1558.763
            ],
            [
              1693.427,
              -3075.022,
              1582.698
            ],
            [
              1690.731,
              -2873.474,
              1784.265
            ],
            [
              1684.353,
              -2661.838,
              1995.997
            ],
            [
              1677.945,
              -2590.471,
              2067.651
            ],
            [
              1676.674,
              -2554.823,
              2103.321
            ],
            [
              1670.083,
              -2527.983,
              2130.959
            ],
            [
              1679.06,
              -2495.866,
              2164.307
            ],
            [
              1670.601,
              -2049.296,
              2610.957
            ],
            [
              1665.105,
              -1963.474,
              2696.955
            ],
            [
              1665.702,
              -1896.69,
              2763.741
            ],
            [
              1663.09,
              -1759.712,
              2900.744
            ],
            [
              1653.419,
              -1725.022,
              2936.757
            ],
            [
              1660.464,
              -1692.869,
              2969.673
            ],
            [
              1642.718,
              -1572.308,
              3091.532
            ],
            [
              1626.598,
              -1502.988,
              3162.702
            ],
            [
              1590.763,
              -1384.318,
              3286.665
            ],
            [
              1541.473,
              -1260.946,
              3419.518
            ],
            [
              1439.941,
              -1068.699,
              3636.93
            ],
            [
              1418.417,
              -1047.149,
              3667.388
            ],
            [
              1413.029,
              -1024.784,
              3690.392
            ],
            [
              1381.79,
              -970.77,
              3752.79
            ],
            [
              1372.327,
              -959.462,
              3767.534
            ],
            [
              1333.941,
              -943.166,
              3809.236
            ],
            [
              1307.513,
              -942.677,
              3835.668
            ],
            [
              1293.291,
              -944.641,
              3850.025
            ],
            [
              1278.507,
              -942.141,
              3865.019
            ],
            [
              1268.297,
              -936.386,
              3876.74
            ],
            [
              1257.545,
              -925.054,
              3892.36
            ],
            [
              1253.197,
              -916.068,
              3902.343
            ],
            [
              1249.597,
              -901.529,
              3917.321
            ],
            [
              1250.468,
              -889.3,
              3929.581
            ],
            [
              1243.124,
              -868.013,
              3952.1
            ],
            [
              1234.408,
              -851.153,
              3971.079
            ],
            [
              1218.52,
              -838.613,
              3991.32
            ],
            [
              1192.86,
              -831.46,
              4017.959
            ],
            [
              1154.205,
              -829.633,
              4056.657
            ],
            [
              1120.288,
              -815.648,
              4093.344
            ],
            [
              1031.058,
              -793.963,
              4185.17
            ],
            [
              773.373,
              -745.803,
              4447.318
            ],
            [
              729.54,
              -744.998,
              4491.158
            ],
            [
              702.691,
              -732.259,
              4520.876
            ],
            [
              508.13,
              -687.5,
              4720.519
            ],
            [
              443.852,
              -676.304,
              4785.764
            ],
            [
              405.738,
              -680.059,
              4824.062
            ],
            [
              364.219,
              -693.772,
              4867.788
            ],
            [
              341.718,
              -690.021,
              4890.599
            ],
            [
              238.113,
              -713.732,
              4996.883
            ],
            [
              219.901,
              -722.305,
              5017.011
            ],
            [
              73.653,
              -750.808,
              5166.012
            ],
            [
              -18.428,
              -779.188,
              5262.367
            ],
            [
              -53.078,
              -805.275,
              5305.739
            ],
            [
              -306.711,
              -924.235,
              5585.884
            ],
            [
              -475.993,
              -1014.678,
              5777.812
            ],
            [
              -534.689,
              -1051.466,
              5847.083
            ],
            [
              -673.187,
              -1080.133,
              5988.517
            ],
            [
              -763.423,
              -1114.127,
              6084.944
            ],
            [
              -829.227,
              -1116.28,
              6150.783
            ],
            [
              -865.018,
              -1134.559,
              6190.972
            ],
            [
              -891.825,
              -1155.228,
              6224.822
            ],
            [
              -898.431,
              -1164.015,
              6235.815
            ],
            [
              -907.595,
              -1171.642,
              6247.738
            ],
            [
              -917.363,
              -1177.032,
              6258.895
            ],
            [
              -929.65,
              -1179.038,
              6271.344
            ],
            [
              -961.877,
              -1178.457,
              6303.576
            ],
            [
              -977.306,
              -1175.953,
              6319.207
            ],
            [
              -995.797,
              -1164.488,
              6340.964
            ],
            [
              -1006.474,
              -1148.711,
              6360.015
            ],
            [
              -1029.882,
              -1123.799,
              6394.198
            ],
            [
              -1062.634,
              -1116.531,
              6427.747
            ],
            [
              -1096.995,
              -1127.045,
              6463.681
            ],
            [
              -1143.947,
              -1120.636,
              6511.068
            ],
            [
              -1339.338,
              -1158.32,
              6710.06
            ],
            [
              -1374.402,
              -1172.164,
              6747.759
            ],
            [
              -1791.301,
              -1230.398,
              7168.705
            ],
            [
              -1855.793,
              -1231.475,
              7233.206
            ],
            [
              -1940.187,
              -1227.747,
              7317.683
            ],
            [
              -2027.705,
              -1218.399,
              7405.699
            ],
            [
              -2166.609,
              -1198.122,
              7546.074
            ],
            [
              -2255.397,
              -1187.643,
              7635.479
            ],
            [
              -2267.097,
              -1193.002,
              7648.348
            ],
            [
              -2295.924,
              -1182.472,
              7679.037
            ],
            [
              -2392.506,
              -1175.197,
              7775.893
            ],
            [
              -2431.277,
              -1180.078,
              7814.97
            ],
            [
              -2478.584,
              -1193.714,
              7864.203
            ],
            [
              -2533.196,
              -1219.467,
              7924.583
            ],
            [
              -2617.204,
              -1266.966,
              8021.089
            ],
            [
              -2663.944,
              -1285.067,
              8071.211
            ],
            [
              -2710.565,
              -1296.491,
              8119.212
            ],
            [
              -2762.303,
              -1305.599,
              8171.745
            ],
            [
              -2808.767,
              -1308.121,
              8218.278
            ],
            [
              -2858.317,
              -1302.797,
              8268.113
            ],
            [
              -3071.028,
              -1263.439,
              8484.435
            ],
            [
              -3140.52,
              -1255.542,
              8554.374
            ],
            [
              -3159.719,
              -1247.413,
              8575.223
            ],
            [
              -3359.526,
              -1207.182,
              8779.039
            ],
            [
              -3495.953,
              -1192.555,
              8916.249
            ],
            [
              -3569.469,
              -1193.5,
              8989.771
            ],
            [
              -3626.266,
              -1196.964,
              9046.673
            ],
            [
              -3657.704,
              -1114.039,
              9135.357
            ],
            [
              -3680.758,
              -1067.996,
              9186.849
            ],
            [
              -3686.114,
              -1042.299,
              9213.098
            ],
            [
              -3720.918,
              -930.373,
              9330.311
            ],
            [
              -3751.541,
              -837.444,
              9428.155
            ],
            [
              -3761.526,
              -818.346,
              9449.706
            ],
            [
              -3766.218,
              -791.548,
              9476.912
            ],
            [
              -3793.988,
              -719.82,
              9553.828
            ],
            [
              -3843.779,
              -616.54,
              9668.483
            ],
            [
              -3881.258,
              -546.871,
              9747.594
            ],
            [
              -3892.746,
              -539.992,
              9760.984
            ],
            [
              -3915.211,
              -534.036,
              9784.225
            ],
            [
              -4013.321,
              -576.864,
              9891.276
            ],
            [
              -4103.192,
              -441.723,
              10053.571
            ],
            [
              -4126.033,
              -420.177,
              10084.971
            ],
            [
              -4131.488,
              -400.045,
              10105.829
            ],
            [
              -4155.783,
              -350.644,
              10160.88
            ],
            [
              -4237.762,
              -243.473,
              10295.811
            ],
            [
              -4352.037,
              -139.086,
              10450.586
            ],
            [
              -4426.18,
              -63.224,
              10556.663
            ],
            [
              -4449.727,
              -45.007,
              10586.434
            ],
            [
              -4460.208,
              -16.996,
              10616.342
            ],
            [
              -4494.728,
              38.145,
              10681.397
            ],
            [
              -4530.309,
              106.663,
              10758.602
            ],
            [
              -4592.389,
              246.88,
              10911.948
            ],
            [
              -4608.183,
              266.076,
              10936.806
            ],
            [
              -4641.216,
              408.021,
              11082.543
            ],
            [
              -4663.089,
              486.32,
              11163.841
            ],
            [
              -4661.513,
              502.991,
              11180.586
            ],
            [
              -4670.535,
              540.995,
              11219.646
            ],
            [
              -4686.12,
              572.432,
              11254.734
            ],
            [
              -4701.876,
              593.853,
              11281.326
            ],
            [
              -4704.928,
              603.925,
              11291.85
            ],
            [
              -4702.177,
              613.896,
              11302.194
            ],
            [
              -4693.036,
              620.419,
              11313.424
            ],
            [
              -4675.626,
              620.12,
              11330.836
            ],
            [
              -4661.537,
              614.312,
              11346.076
            ],
            [
              -4631.619,
              553.685,
              11413.683
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 132.431,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 809.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 1236.865,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 330,
              "departureOffsetSeconds": 330
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 1558.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 390,
              "departureOffsetSeconds": 390
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 2130.959,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 510,
              "departureOffsetSeconds": 510
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 2936.757,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 690,
              "departureOffsetSeconds": 690
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 3667.388,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 810,
              "departureOffsetSeconds": 810
            },
            {
              "stopId": "judu:stop:5662",
              "position": {
                "x": 1154.205,
                "z": -829.633
              },
              "distanceAlongShapeM": 4056.657,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 930,
              "departureOffsetSeconds": 930
            },
            {
              "stopId": "judu:stop:5664",
              "position": {
                "x": 729.54,
                "z": -744.998
              },
              "distanceAlongShapeM": 4491.158,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 4867.788,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 5305.739,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 5847.083,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 6084.944,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 6463.681,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:814",
              "position": {
                "x": -1374.402,
                "z": -1172.164
              },
              "distanceAlongShapeM": 6747.759,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5906",
              "position": {
                "x": -2267.097,
                "z": -1193.002
              },
              "distanceAlongShapeM": 7648.348,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 8554.374,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 9186.849,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 9449.706,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5915",
              "position": {
                "x": -4126.033,
                "z": -420.177
              },
              "distanceAlongShapeM": 10084.971,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5919",
              "position": {
                "x": -4449.727,
                "z": -45.007
              },
              "distanceAlongShapeM": 10586.434,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5920",
              "position": {
                "x": -4608.183,
                "z": 266.076
              },
              "distanceAlongShapeM": 10936.806,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5923",
              "position": {
                "x": -4663.089,
                "z": 486.32
              },
              "distanceAlongShapeM": 11163.841,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            21180,
            22800,
            24180,
            25560,
            26640,
            27600,
            28440,
            29340,
            30420,
            31380,
            32460,
            33720,
            35040,
            36300,
            37260,
            38580,
            40800,
            42780,
            44820,
            46920,
            49200,
            51120,
            53340,
            54900,
            55920,
            56880,
            58020,
            59100,
            60300,
            61080,
            62100,
            63000,
            64140,
            65340,
            66660,
            68160,
            69720,
            71640,
            73680,
            75360,
            77400,
            79140,
            81120,
            83160
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_10",
      "sourceRouteId": "vilnius_trol_10",
      "mode": "trolleybus",
      "shortName": "10",
      "longName": "Saulėtekis–Kalvarijų g.–Naujininkai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_10:0",
          "sourceRouteId": "vilnius_trol_10",
          "sourceShapeId": "vilnius_trol_10_a-b",
          "directionId": 0,
          "headsign": "Naujininkai",
          "directionName": "Saulėtekis–Kalvarijų g.–Naujininkai",
          "mode": "trolleybus",
          "routeShortName": "10",
          "routeLongName": "Saulėtekis–Kalvarijų g.–Naujininkai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3954.003,
              -4105.097,
              0
            ],
            [
              3949.042,
              -4094.982,
              11.266
            ],
            [
              3942.445,
              -4069.251,
              37.829
            ],
            [
              3936.216,
              -4058,
              50.69
            ],
            [
              3917.749,
              -4046.514,
              72.437
            ],
            [
              3898.552,
              -4039.468,
              92.886
            ],
            [
              3898.616,
              -4036.13,
              96.225
            ],
            [
              3858.828,
              -4027.577,
              136.922
            ],
            [
              3592.048,
              -4028.061,
              403.703
            ],
            [
              3581.678,
              -4031.203,
              414.538
            ],
            [
              3565.986,
              -4043.151,
              434.261
            ],
            [
              3520.083,
              -4051.184,
              480.861
            ],
            [
              3445.458,
              -4078.711,
              560.402
            ],
            [
              3358.965,
              -4120.486,
              656.455
            ],
            [
              3360.169,
              -4124.962,
              661.09
            ],
            [
              3310.064,
              -4150.73,
              717.432
            ],
            [
              3021.059,
              -4338.966,
              1062.334
            ],
            [
              2959.695,
              -4278.804,
              1148.269
            ],
            [
              2937.404,
              -4265.024,
              1174.476
            ],
            [
              2920.517,
              -4237.987,
              1206.353
            ],
            [
              2810.169,
              -4110.107,
              1375.262
            ],
            [
              2739.116,
              -4050.879,
              1467.763
            ],
            [
              2661.391,
              -4003.772,
              1558.649
            ],
            [
              2636.416,
              -3995.509,
              1584.956
            ],
            [
              2624.428,
              -3981.925,
              1603.073
            ],
            [
              2519.252,
              -3920.945,
              1724.648
            ],
            [
              2497.02,
              -3903.829,
              1752.706
            ],
            [
              2481.543,
              -3870.14,
              1789.779
            ],
            [
              2477.598,
              -3840.008,
              1820.168
            ],
            [
              2486.808,
              -3795.651,
              1865.472
            ],
            [
              2503.376,
              -3736.96,
              1926.457
            ],
            [
              2508.032,
              -3729.254,
              1935.459
            ],
            [
              2515.825,
              -3726.061,
              1943.881
            ],
            [
              2523.534,
              -3727.319,
              1951.692
            ],
            [
              2538.183,
              -3736.5,
              1968.981
            ],
            [
              2569.676,
              -3809.454,
              2048.442
            ],
            [
              2576.842,
              -3839.646,
              2079.473
            ],
            [
              2577.544,
              -3870.831,
              2110.665
            ],
            [
              2568.689,
              -3896.269,
              2137.601
            ],
            [
              2541.856,
              -3952.541,
              2199.943
            ],
            [
              2519.328,
              -3985.515,
              2239.878
            ],
            [
              2483.001,
              -4032.703,
              2299.429
            ],
            [
              2454.012,
              -4066.67,
              2344.085
            ],
            [
              2436.763,
              -4093.064,
              2375.615
            ],
            [
              2406.107,
              -4181.549,
              2469.261
            ],
            [
              2398.976,
              -4218.153,
              2506.552
            ],
            [
              2394.879,
              -4264.833,
              2553.412
            ],
            [
              2388.205,
              -4311.465,
              2600.519
            ],
            [
              2381.138,
              -4344.73,
              2634.526
            ],
            [
              2383.36,
              -4363.697,
              2653.623
            ],
            [
              2363.369,
              -4398.946,
              2694.146
            ],
            [
              2340.823,
              -4433.034,
              2735.015
            ],
            [
              2328.252,
              -4450.61,
              2756.625
            ],
            [
              2298.04,
              -4481.215,
              2799.63
            ],
            [
              2296.004,
              -4486.743,
              2805.521
            ],
            [
              2297.644,
              -4502.36,
              2821.223
            ],
            [
              2324.901,
              -4526.249,
              2857.467
            ],
            [
              2369.547,
              -4550.465,
              2908.258
            ],
            [
              2386.895,
              -4553.017,
              2925.792
            ],
            [
              2397.928,
              -4548.771,
              2937.614
            ],
            [
              2404.556,
              -4538.876,
              2949.524
            ],
            [
              2405.535,
              -4521.082,
              2967.345
            ],
            [
              2396.166,
              -4505.32,
              2985.68
            ],
            [
              2310.611,
              -4463.639,
              3080.848
            ],
            [
              2261.601,
              -4431.549,
              3139.429
            ],
            [
              2254.143,
              -4416.937,
              3155.834
            ],
            [
              2239.684,
              -4397.741,
              3179.867
            ],
            [
              2101.811,
              -4259.344,
              3375.219
            ],
            [
              2005.819,
              -4155.131,
              3516.905
            ],
            [
              1848.669,
              -3978.532,
              3753.302
            ],
            [
              1832.856,
              -3962.652,
              3775.712
            ],
            [
              1811.224,
              -3947.777,
              3801.965
            ],
            [
              1800.044,
              -3925.303,
              3827.066
            ],
            [
              1667.691,
              -3765.872,
              4034.276
            ],
            [
              1499.686,
              -3582.404,
              4283.044
            ],
            [
              1482.767,
              -3556.485,
              4313.996
            ],
            [
              1455.5,
              -3532.601,
              4350.245
            ],
            [
              1443.07,
              -3507.879,
              4377.916
            ],
            [
              1391.152,
              -3457.934,
              4449.957
            ],
            [
              1338.486,
              -3413.541,
              4518.837
            ],
            [
              1317.474,
              -3399.793,
              4543.947
            ],
            [
              978.337,
              -3198.709,
              4938.218
            ],
            [
              945.685,
              -3186.974,
              4972.914
            ],
            [
              931.778,
              -3172.246,
              4993.171
            ],
            [
              710.47,
              -3045.716,
              5248.096
            ],
            [
              679.709,
              -3036.244,
              5280.283
            ],
            [
              665.217,
              -3018.166,
              5303.452
            ],
            [
              624.331,
              -2998.49,
              5348.827
            ],
            [
              521.572,
              -2978.793,
              5453.456
            ],
            [
              506.876,
              -2971.844,
              5469.712
            ],
            [
              502.159,
              -2912.756,
              5528.989
            ],
            [
              509.397,
              -2869.472,
              5572.873
            ],
            [
              513.301,
              -2797.183,
              5645.268
            ],
            [
              494.515,
              -2626.513,
              5816.969
            ],
            [
              482.722,
              -2601.805,
              5844.347
            ],
            [
              485.911,
              -2568.466,
              5877.838
            ],
            [
              462.343,
              -2342.047,
              6105.48
            ],
            [
              451.425,
              -2269.486,
              6178.858
            ],
            [
              407.176,
              -2116.162,
              6338.439
            ],
            [
              406.254,
              -2096.107,
              6358.516
            ],
            [
              361.405,
              -1904.922,
              6554.89
            ],
            [
              342.249,
              -1718.661,
              6742.134
            ],
            [
              324.984,
              -1640.419,
              6822.258
            ],
            [
              326.097,
              -1614.835,
              6847.867
            ],
            [
              277.22,
              -1255.479,
              7210.531
            ],
            [
              271.867,
              -1230.89,
              7235.696
            ],
            [
              265.625,
              -1219.643,
              7248.559
            ],
            [
              267.28,
              -1199.635,
              7268.635
            ],
            [
              254.802,
              -1141.519,
              7328.076
            ],
            [
              216.915,
              -885.896,
              7586.491
            ],
            [
              226.048,
              -703.492,
              7769.124
            ],
            [
              223.795,
              -685.64,
              7787.118
            ],
            [
              209.218,
              -636.391,
              7838.479
            ],
            [
              192.022,
              -589.321,
              7888.591
            ],
            [
              159.237,
              -513.023,
              7971.635
            ],
            [
              151.725,
              -500.641,
              7986.118
            ],
            [
              143.086,
              -479.332,
              8009.112
            ],
            [
              121.213,
              -441.083,
              8053.173
            ],
            [
              119.827,
              -411,
              8083.287
            ],
            [
              106.146,
              -277.163,
              8217.822
            ],
            [
              35.151,
              -280.322,
              8288.887
            ],
            [
              -101.904,
              -298.979,
              8427.206
            ],
            [
              -140.08,
              -306.078,
              8466.037
            ],
            [
              -153.095,
              -312.52,
              8480.559
            ],
            [
              -191.836,
              -315.156,
              8519.389
            ],
            [
              -244.276,
              -326.45,
              8573.031
            ],
            [
              -305.298,
              -348.72,
              8637.99
            ],
            [
              -413.017,
              -421.354,
              8767.91
            ],
            [
              -450.326,
              -380.602,
              8823.161
            ],
            [
              -465.596,
              -369.193,
              8842.223
            ],
            [
              -470.512,
              -355.745,
              8856.541
            ],
            [
              -508.466,
              -314.982,
              8912.238
            ],
            [
              -611.52,
              -58.189,
              9188.938
            ],
            [
              -615.308,
              -53.668,
              9194.836
            ],
            [
              -625.745,
              -24.535,
              9225.782
            ],
            [
              -646.921,
              17.037,
              9272.436
            ],
            [
              -652.524,
              63.893,
              9319.627
            ],
            [
              -679.973,
              222.467,
              9480.559
            ],
            [
              -691.721,
              250.51,
              9510.963
            ],
            [
              -832.714,
              443.415,
              9749.901
            ],
            [
              -840.816,
              459.146,
              9767.596
            ],
            [
              -843.214,
              469.208,
              9777.94
            ],
            [
              -833.842,
              667.193,
              9976.147
            ],
            [
              -824.942,
              731.6,
              10041.166
            ],
            [
              -800.789,
              819.11,
              10131.947
            ],
            [
              -793.638,
              857.944,
              10171.434
            ],
            [
              -767.948,
              887.538,
              10210.623
            ],
            [
              -708.773,
              1021.171,
              10356.772
            ],
            [
              -697.048,
              1063.262,
              10400.466
            ],
            [
              -655.787,
              1240.633,
              10582.573
            ],
            [
              -656.233,
              1287.397,
              10629.339
            ],
            [
              -631.67,
              1361.539,
              10707.444
            ],
            [
              -535.917,
              1805.1,
              11161.222
            ],
            [
              -511.654,
              1933.795,
              11292.185
            ],
            [
              -496.901,
              1964.699,
              11326.429
            ],
            [
              -462.075,
              2106.562,
              11472.504
            ],
            [
              -436.719,
              2188.482,
              11558.259
            ],
            [
              -427.991,
              2207.248,
              11578.956
            ],
            [
              -344.32,
              2338.207,
              11734.362
            ],
            [
              -326.137,
              2380.181,
              11780.104
            ],
            [
              -285.296,
              2533.066,
              11938.351
            ],
            [
              -290.153,
              2585.475,
              11990.985
            ],
            [
              -278.461,
              2625.339,
              12032.528
            ],
            [
              -246.605,
              2887.483,
              12296.601
            ],
            [
              -243.843,
              2897.452,
              12306.945
            ],
            [
              -220.477,
              2904.821,
              12331.445
            ],
            [
              -210.175,
              2903.521,
              12341.829
            ],
            [
              -203.362,
              2887.812,
              12358.952
            ],
            [
              -196.145,
              2858.737,
              12388.909
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 92.886,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 434.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 661.09,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 1174.476,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 1584.956,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5485",
              "position": {
                "x": 2577.544,
                "z": -3870.831
              },
              "distanceAlongShapeM": 2110.665,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5490",
              "position": {
                "x": 2383.36,
                "z": -4363.697
              },
              "distanceAlongShapeM": 2653.623,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5491",
              "position": {
                "x": 2261.601,
                "z": -4431.549
              },
              "distanceAlongShapeM": 3139.429,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5494",
              "position": {
                "x": 1811.224,
                "z": -3947.777
              },
              "distanceAlongShapeM": 3801.965,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5125",
              "position": {
                "x": 1455.5,
                "z": -3532.601
              },
              "distanceAlongShapeM": 4350.245,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5127",
              "position": {
                "x": 945.685,
                "z": -3186.974
              },
              "distanceAlongShapeM": 4972.914,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5128",
              "position": {
                "x": 679.709,
                "z": -3036.244
              },
              "distanceAlongShapeM": 5280.283,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5347",
              "position": {
                "x": 482.722,
                "z": -2601.805
              },
              "distanceAlongShapeM": 5844.347,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5351",
              "position": {
                "x": 407.176,
                "z": -2116.162
              },
              "distanceAlongShapeM": 6338.439,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:5467",
              "position": {
                "x": 324.984,
                "z": -1640.419
              },
              "distanceAlongShapeM": 6822.258,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5378",
              "position": {
                "x": 265.625,
                "z": -1219.643
              },
              "distanceAlongShapeM": 7248.559,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 8053.173,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5249",
              "position": {
                "x": -153.095,
                "z": -312.52
              },
              "distanceAlongShapeM": 8480.559,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5257",
              "position": {
                "x": -465.596,
                "z": -369.193
              },
              "distanceAlongShapeM": 8842.223,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 9272.436,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5266",
              "position": {
                "x": -793.638,
                "z": 857.944
              },
              "distanceAlongShapeM": 10171.434,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5272",
              "position": {
                "x": -656.233,
                "z": 1287.397
              },
              "distanceAlongShapeM": 10629.339,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 11292.185,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 11990.985,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 12388.909,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            }
          ],
          "departuresSeconds": [
            19440,
            20400,
            21480,
            22800,
            23400,
            24240,
            25020,
            25740,
            27180,
            28620,
            30360,
            31860,
            32820,
            33840,
            35280,
            36780,
            37980,
            39300,
            40560,
            42000,
            43380,
            44580,
            46080,
            47400,
            49140,
            50280,
            51480,
            53100,
            54480,
            55200,
            56040,
            57240,
            58440,
            59040,
            60180,
            61680,
            62700,
            63660,
            64920,
            66660,
            68220,
            69960,
            71400,
            72960,
            74220,
            75480,
            77040,
            78300,
            79620,
            80700,
            82020
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_10:1",
          "sourceRouteId": "vilnius_trol_10",
          "sourceShapeId": "vilnius_trol_10_b-a",
          "directionId": 1,
          "headsign": "Saulėtekis",
          "directionName": "Naujininkai–Kalvarijų g.–Saulėtekis",
          "mode": "trolleybus",
          "routeShortName": "10",
          "routeLongName": "Saulėtekis–Kalvarijų g.–Naujininkai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -196.145,
              2858.737,
              0
            ],
            [
              -195.763,
              2844.258,
              14.484
            ],
            [
              -203.04,
              2834.371,
              26.761
            ],
            [
              -247.856,
              2818.486,
              74.308
            ],
            [
              -266.588,
              2603.973,
              289.638
            ],
            [
              -287.151,
              2501.929,
              393.733
            ],
            [
              -327.226,
              2355.709,
              545.345
            ],
            [
              -350.367,
              2324.958,
              583.83
            ],
            [
              -412.128,
              2228.113,
              698.693
            ],
            [
              -425.492,
              2202.75,
              727.361
            ],
            [
              -439.803,
              2160.707,
              771.773
            ],
            [
              -445.668,
              2121.85,
              811.07
            ],
            [
              -471.768,
              2034.377,
              902.354
            ],
            [
              -499.661,
              1919.106,
              1020.952
            ],
            [
              -508.548,
              1855.813,
              1084.866
            ],
            [
              -515.259,
              1841.463,
              1100.708
            ],
            [
              -529.526,
              1766.021,
              1177.487
            ],
            [
              -536.862,
              1752.795,
              1192.611
            ],
            [
              -542.324,
              1736.195,
              1210.086
            ],
            [
              -601.244,
              1474.539,
              1478.295
            ],
            [
              -678.532,
              1124.155,
              1837.101
            ],
            [
              -679.739,
              1093.006,
              1868.273
            ],
            [
              -691.829,
              1066.507,
              1897.4
            ],
            [
              -722.413,
              980.227,
              1988.94
            ],
            [
              -789.726,
              824.476,
              2158.615
            ],
            [
              -808.22,
              764.696,
              2221.191
            ],
            [
              -810.251,
              723.543,
              2262.393
            ],
            [
              -824.878,
              699.315,
              2290.694
            ],
            [
              -838.2,
              496.948,
              2493.499
            ],
            [
              -838.156,
              463.551,
              2526.897
            ],
            [
              -823.183,
              435.45,
              2558.737
            ],
            [
              -689.041,
              256.028,
              2782.761
            ],
            [
              -671.067,
              215.627,
              2826.979
            ],
            [
              -634.631,
              19.041,
              3026.913
            ],
            [
              -585.127,
              -96.516,
              3152.628
            ],
            [
              -570.097,
              -121.279,
              3181.595
            ],
            [
              -567.275,
              -143.594,
              3204.088
            ],
            [
              -513.161,
              -289.293,
              3359.512
            ],
            [
              -501.093,
              -299.53,
              3375.337
            ],
            [
              -461.426,
              -352.57,
              3441.569
            ],
            [
              -449.339,
              -361.695,
              3456.714
            ],
            [
              -413.017,
              -421.354,
              3526.56
            ],
            [
              -305.298,
              -348.72,
              3656.479
            ],
            [
              -203.339,
              -309.381,
              3765.765
            ],
            [
              -102.285,
              -284.5,
              3869.836
            ],
            [
              -50.388,
              -267.632,
              3924.406
            ],
            [
              -22.626,
              -265.911,
              3952.22
            ],
            [
              -0.545,
              -257.407,
              3975.882
            ],
            [
              58.367,
              -209.498,
              4051.816
            ],
            [
              82.464,
              -196.578,
              4079.158
            ],
            [
              94.753,
              -194.576,
              4091.61
            ],
            [
              103.738,
              -196.966,
              4100.907
            ],
            [
              115.784,
              -208.318,
              4117.459
            ],
            [
              119.866,
              -267.394,
              4176.676
            ],
            [
              118.552,
              -304.106,
              4213.412
            ],
            [
              124.949,
              -377.696,
              4287.28
            ],
            [
              130.203,
              -407.85,
              4317.887
            ],
            [
              150.182,
              -443.837,
              4359.049
            ],
            [
              237.149,
              -695.903,
              4625.695
            ],
            [
              238.113,
              -713.732,
              4643.55
            ],
            [
              217.158,
              -872.542,
              4803.737
            ],
            [
              276.82,
              -1242.113,
              5178.092
            ],
            [
              297.35,
              -1318.188,
              5256.889
            ],
            [
              320.249,
              -1546.82,
              5486.665
            ],
            [
              342.249,
              -1718.661,
              5659.909
            ],
            [
              356.237,
              -1764.56,
              5707.892
            ],
            [
              354.758,
              -1810.175,
              5753.531
            ],
            [
              356.121,
              -1841.371,
              5784.757
            ],
            [
              372.957,
              -1942.984,
              5887.755
            ],
            [
              426.379,
              -2158.817,
              6110.101
            ],
            [
              441.836,
              -2194.724,
              6149.193
            ],
            [
              440.947,
              -2208.066,
              6162.566
            ],
            [
              462.343,
              -2342.047,
              6298.244
            ],
            [
              505.139,
              -2574.385,
              6534.491
            ],
            [
              511.756,
              -2776.003,
              6736.217
            ],
            [
              513.301,
              -2797.183,
              6757.453
            ],
            [
              524.563,
              -2850.825,
              6812.265
            ],
            [
              524.913,
              -2902.04,
              6863.482
            ],
            [
              521.837,
              -2964.325,
              6925.843
            ],
            [
              532.044,
              -2970.079,
              6937.559
            ],
            [
              602.169,
              -2976.932,
              7008.018
            ],
            [
              666.107,
              -3004.824,
              7077.775
            ],
            [
              900.139,
              -3140.492,
              7348.287
            ],
            [
              1021.838,
              -3216.21,
              7491.618
            ],
            [
              1074.9,
              -3239.454,
              7549.548
            ],
            [
              1095.125,
              -3260.979,
              7579.085
            ],
            [
              1260.9,
              -3357.556,
              7770.939
            ],
            [
              1339.233,
              -3407.989,
              7864.104
            ],
            [
              1373.568,
              -3433.117,
              7906.651
            ],
            [
              1493.843,
              -3550.011,
              8074.372
            ],
            [
              1520.486,
              -3572.771,
              8109.413
            ],
            [
              1584,
              -3657.444,
              8215.26
            ],
            [
              1660.25,
              -3750.148,
              8335.294
            ],
            [
              1866.498,
              -3989.997,
              8651.626
            ],
            [
              1889.999,
              -4008.247,
              8681.381
            ],
            [
              1892.95,
              -4022.775,
              8696.205
            ],
            [
              1975.005,
              -4114.479,
              8819.261
            ],
            [
              2057.826,
              -4199.52,
              8937.967
            ],
            [
              2170.271,
              -4319.627,
              9102.496
            ],
            [
              2237.981,
              -4385.463,
              9196.936
            ],
            [
              2278.639,
              -4416.283,
              9247.956
            ],
            [
              2288.882,
              -4419.815,
              9258.79
            ],
            [
              2297.234,
              -4421.084,
              9267.238
            ],
            [
              2310.823,
              -4417.999,
              9281.172
            ],
            [
              2320.672,
              -4408.165,
              9295.091
            ],
            [
              2330.583,
              -4394.991,
              9311.577
            ],
            [
              2336.672,
              -4379.52,
              9328.203
            ],
            [
              2336.174,
              -4371.718,
              9336.021
            ],
            [
              2352.029,
              -4350.863,
              9362.218
            ],
            [
              2362.441,
              -4310.981,
              9403.437
            ],
            [
              2385.909,
              -4193.416,
              9523.321
            ],
            [
              2408.961,
              -4098.109,
              9621.377
            ],
            [
              2465.77,
              -3886.543,
              9840.437
            ],
            [
              2502.69,
              -3739.173,
              9992.361
            ],
            [
              2513.829,
              -3729.363,
              10007.204
            ],
            [
              2523.534,
              -3727.319,
              10017.122
            ],
            [
              2532.532,
              -3728.601,
              10026.21
            ],
            [
              2540.76,
              -3736.549,
              10037.65
            ],
            [
              2566.251,
              -3786.011,
              10093.294
            ],
            [
              2598.162,
              -3836.707,
              10153.198
            ],
            [
              2614.638,
              -3851.49,
              10175.334
            ],
            [
              2636.723,
              -3876.397,
              10208.622
            ],
            [
              2642.893,
              -3890.985,
              10224.461
            ],
            [
              2709.56,
              -3977.961,
              10334.048
            ],
            [
              3021.059,
              -4338.966,
              10810.867
            ],
            [
              3086.352,
              -4293.444,
              10890.463
            ],
            [
              3111.27,
              -4270.537,
              10924.311
            ],
            [
              3142.482,
              -4255.542,
              10958.938
            ],
            [
              3336.938,
              -4126.748,
              11192.178
            ],
            [
              3389.682,
              -4097.691,
              11252.397
            ],
            [
              3402.776,
              -4086.807,
              11269.423
            ],
            [
              3446.229,
              -4072.046,
              11315.315
            ],
            [
              3528.69,
              -4039.102,
              11404.113
            ],
            [
              3592.048,
              -4028.061,
              11468.426
            ],
            [
              3640.634,
              -4014.513,
              11518.866
            ],
            [
              3666.294,
              -4020.567,
              11545.23
            ],
            [
              3848.026,
              -4019.578,
              11726.965
            ],
            [
              3878.881,
              -4023.507,
              11758.069
            ],
            [
              3901.964,
              -4029.514,
              11781.921
            ],
            [
              3958.181,
              -4055.079,
              11843.678
            ],
            [
              3967.843,
              -4055.264,
              11853.342
            ],
            [
              4018.762,
              -4121.92,
              11937.222
            ],
            [
              4037.773,
              -4172.381,
              11991.144
            ],
            [
              4032.364,
              -4185.636,
              12005.461
            ],
            [
              4021.265,
              -4193.217,
              12018.902
            ],
            [
              4012.248,
              -4193.045,
              12027.921
            ],
            [
              3999.472,
              -4187.234,
              12041.956
            ],
            [
              3957.337,
              -4132.992,
              12110.641
            ],
            [
              3954.003,
              -4105.097,
              12138.735
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -450,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 289.638,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5168",
              "position": {
                "x": -529.526,
                "z": 1766.021
              },
              "distanceAlongShapeM": 1177.487,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 1868.273,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 2262.393,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 3181.595,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5258",
              "position": {
                "x": -449.339,
                "z": -361.695
              },
              "distanceAlongShapeM": 3456.714,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 3924.406,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 4359.049,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1050,
              "departureOffsetSeconds": 1050
            },
            {
              "stopId": "judu:stop:6843",
              "position": {
                "x": 297.35,
                "z": -1318.188
              },
              "distanceAlongShapeM": 5256.889,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1290,
              "departureOffsetSeconds": 1290
            },
            {
              "stopId": "judu:stop:6844",
              "position": {
                "x": 356.237,
                "z": -1764.56
              },
              "distanceAlongShapeM": 5707.892,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1470,
              "departureOffsetSeconds": 1470
            },
            {
              "stopId": "judu:stop:6845",
              "position": {
                "x": 441.836,
                "z": -2194.724
              },
              "distanceAlongShapeM": 6149.193,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1530,
              "departureOffsetSeconds": 1530
            },
            {
              "stopId": "judu:stop:5469",
              "position": {
                "x": 505.139,
                "z": -2574.385
              },
              "distanceAlongShapeM": 6534.491,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1650,
              "departureOffsetSeconds": 1650
            },
            {
              "stopId": "judu:stop:6846",
              "position": {
                "x": 602.169,
                "z": -2976.932
              },
              "distanceAlongShapeM": 7008.018,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6871",
              "position": {
                "x": 1074.9,
                "z": -3239.454
              },
              "distanceAlongShapeM": 7549.548,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6873",
              "position": {
                "x": 1553.844,
                "z": -3615.694
              },
              "distanceAlongShapeM": 8163.766,
              "shapeOffsetM": 0.929,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6874",
              "position": {
                "x": 1889.999,
                "z": -4008.247
              },
              "distanceAlongShapeM": 8681.381,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:5476",
              "position": {
                "x": 2336.174,
                "z": -4371.718
              },
              "distanceAlongShapeM": 9336.021,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 10208.622,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 10924.311,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 11269.423,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 11518.866,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 11853.342,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            }
          ],
          "departuresSeconds": [
            19860,
            21240,
            22500,
            23700,
            24780,
            26220,
            26820,
            27840,
            28740,
            29640,
            31140,
            32340,
            34080,
            35340,
            36420,
            37320,
            38700,
            40200,
            41400,
            42780,
            44040,
            45420,
            46860,
            48060,
            49860,
            51060,
            52860,
            54000,
            54900,
            56520,
            57960,
            58920,
            59760,
            60960,
            62160,
            62820,
            64080,
            65520,
            66540,
            67500,
            68640,
            70140,
            71760,
            73260,
            74760,
            76260,
            77520,
            78900,
            80100,
            81480,
            82620,
            83820
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_12",
      "sourceRouteId": "vilnius_trol_12",
      "mode": "trolleybus",
      "shortName": "12",
      "longName": "Žirmūnai–Šeimyniškių–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_12:0",
          "sourceRouteId": "vilnius_trol_12",
          "sourceShapeId": "vilnius_trol_12_a-b",
          "directionId": 0,
          "headsign": "Žemieji Paneriai (Apylanka be Reformatų st.)",
          "directionName": "Žirmūnai–Šeimyniškių–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "mode": "trolleybus",
          "routeShortName": "12",
          "routeLongName": "Žirmūnai–Šeimyniškių–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1016.673,
              -4299.303,
              0
            ],
            [
              1017.645,
              -4281.509,
              17.821
            ],
            [
              1022.257,
              -4276.027,
              24.984
            ],
            [
              1106.613,
              -4278.698,
              109.382
            ],
            [
              1128.033,
              -4270.188,
              132.431
            ],
            [
              1147.356,
              -4270.545,
              151.757
            ],
            [
              1188.702,
              -4264.63,
              193.524
            ],
            [
              1202.517,
              -4249.3,
              214.16
            ],
            [
              1214.522,
              -4227.257,
              239.261
            ],
            [
              1220.978,
              -4191.753,
              275.347
            ],
            [
              1217.195,
              -3943.429,
              523.7
            ],
            [
              1219.986,
              -3862.213,
              604.964
            ],
            [
              1375.611,
              -3774.922,
              783.398
            ],
            [
              1393.375,
              -3755.212,
              809.932
            ],
            [
              1412.221,
              -3746.656,
              830.629
            ],
            [
              1509.056,
              -3563.653,
              1037.673
            ],
            [
              1556.885,
              -3486.613,
              1128.352
            ],
            [
              1607.644,
              -3390.704,
              1236.865
            ],
            [
              1620.009,
              -3384.254,
              1250.811
            ],
            [
              1689.847,
              -3267.548,
              1386.817
            ],
            [
              1697.306,
              -3247.648,
              1408.069
            ],
            [
              1696.944,
              -3128.524,
              1527.194
            ],
            [
              1687.839,
              -3098.296,
              1558.763
            ],
            [
              1693.427,
              -3075.022,
              1582.698
            ],
            [
              1690.731,
              -2873.474,
              1784.265
            ],
            [
              1684.353,
              -2661.838,
              1995.997
            ],
            [
              1677.945,
              -2590.471,
              2067.651
            ],
            [
              1676.674,
              -2554.823,
              2103.321
            ],
            [
              1670.083,
              -2527.983,
              2130.959
            ],
            [
              1679.06,
              -2495.866,
              2164.307
            ],
            [
              1670.601,
              -2049.296,
              2610.957
            ],
            [
              1665.105,
              -1963.474,
              2696.955
            ],
            [
              1665.702,
              -1896.69,
              2763.741
            ],
            [
              1663.09,
              -1759.712,
              2900.744
            ],
            [
              1653.419,
              -1725.022,
              2936.757
            ],
            [
              1660.464,
              -1692.869,
              2969.673
            ],
            [
              1642.718,
              -1572.308,
              3091.532
            ],
            [
              1626.598,
              -1502.988,
              3162.702
            ],
            [
              1590.763,
              -1384.318,
              3286.665
            ],
            [
              1541.473,
              -1260.946,
              3419.518
            ],
            [
              1439.941,
              -1068.699,
              3636.93
            ],
            [
              1418.417,
              -1047.149,
              3667.388
            ],
            [
              1413.029,
              -1024.784,
              3690.392
            ],
            [
              1381.79,
              -970.77,
              3752.79
            ],
            [
              1372.327,
              -959.462,
              3767.534
            ],
            [
              1333.941,
              -943.166,
              3809.236
            ],
            [
              1307.513,
              -942.677,
              3835.668
            ],
            [
              1293.291,
              -944.641,
              3850.025
            ],
            [
              1278.507,
              -942.141,
              3865.019
            ],
            [
              1268.297,
              -936.386,
              3876.74
            ],
            [
              1257.545,
              -925.054,
              3892.36
            ],
            [
              1253.197,
              -916.068,
              3902.343
            ],
            [
              1249.597,
              -901.529,
              3917.321
            ],
            [
              1250.468,
              -889.3,
              3929.581
            ],
            [
              1243.124,
              -868.013,
              3952.1
            ],
            [
              1234.408,
              -851.153,
              3971.079
            ],
            [
              1218.52,
              -838.613,
              3991.32
            ],
            [
              1192.86,
              -831.46,
              4017.959
            ],
            [
              1154.205,
              -829.633,
              4056.657
            ],
            [
              1120.288,
              -815.648,
              4093.344
            ],
            [
              1031.058,
              -793.963,
              4185.17
            ],
            [
              773.373,
              -745.803,
              4447.318
            ],
            [
              729.54,
              -744.998,
              4491.158
            ],
            [
              702.691,
              -732.259,
              4520.876
            ],
            [
              508.13,
              -687.5,
              4720.519
            ],
            [
              443.852,
              -676.304,
              4785.764
            ],
            [
              405.738,
              -680.059,
              4824.062
            ],
            [
              364.219,
              -693.772,
              4867.788
            ],
            [
              341.718,
              -690.021,
              4890.599
            ],
            [
              238.113,
              -713.732,
              4996.883
            ],
            [
              229.733,
              -713.579,
              5005.264
            ],
            [
              224.637,
              -710.146,
              5011.408
            ],
            [
              203.858,
              -647.426,
              5077.481
            ],
            [
              166.201,
              -555.453,
              5176.864
            ],
            [
              159.237,
              -513.023,
              5219.862
            ],
            [
              121.213,
              -441.083,
              5301.233
            ],
            [
              106.146,
              -277.163,
              5465.844
            ],
            [
              46.11,
              -280.522,
              5525.973
            ],
            [
              26.146,
              -279.045,
              5545.992
            ],
            [
              15.43,
              -265.491,
              5563.271
            ],
            [
              14.363,
              -253.226,
              5575.582
            ],
            [
              16.439,
              -245.471,
              5583.61
            ],
            [
              45.916,
              -220.403,
              5622.304
            ],
            [
              103.215,
              -190.277,
              5687.041
            ],
            [
              127.382,
              -102.772,
              5777.822
            ],
            [
              121.848,
              -52.576,
              5828.322
            ],
            [
              115.041,
              -36.866,
              5845.443
            ],
            [
              117.583,
              -3.516,
              5878.891
            ],
            [
              102.671,
              133.684,
              6016.898
            ],
            [
              63.181,
              125.497,
              6057.229
            ],
            [
              59.312,
              125.568,
              6061.098
            ],
            [
              57.419,
              127.829,
              6064.047
            ],
            [
              31.786,
              278.582,
              6216.963
            ],
            [
              4.856,
              358.112,
              6300.929
            ],
            [
              -8.924,
              380.627,
              6327.327
            ],
            [
              -39.768,
              422.378,
              6379.235
            ],
            [
              -46.8,
              425.846,
              6387.075
            ],
            [
              -55.202,
              424.885,
              6395.532
            ],
            [
              -86.677,
              396.514,
              6437.907
            ],
            [
              -97.297,
              380.009,
              6457.534
            ],
            [
              -216.06,
              268.617,
              6620.361
            ],
            [
              -407.853,
              148.526,
              6846.65
            ],
            [
              -402.875,
              316.534,
              7014.731
            ],
            [
              -399.691,
              349.873,
              7048.222
            ],
            [
              -377.245,
              378.41,
              7084.529
            ],
            [
              -261.81,
              448.677,
              7219.668
            ],
            [
              -291.826,
              642.924,
              7416.22
            ],
            [
              -330.752,
              844.011,
              7621.04
            ],
            [
              -575.219,
              737.113,
              7887.857
            ],
            [
              -620.556,
              726.8,
              7934.353
            ],
            [
              -799.94,
              794.603,
              8126.124
            ],
            [
              -810.157,
              800.354,
              8137.848
            ],
            [
              -958.695,
              862.029,
              8298.681
            ],
            [
              -1066.972,
              902.938,
              8414.428
            ],
            [
              -1103.368,
              923.63,
              8456.295
            ],
            [
              -1148.452,
              963.402,
              8516.415
            ],
            [
              -1168.303,
              971.551,
              8537.873
            ],
            [
              -1183.42,
              991.86,
              8563.191
            ],
            [
              -1484.246,
              1267.759,
              8971.377
            ],
            [
              -1502.183,
              1274.758,
              8990.632
            ],
            [
              -1524.902,
              1302.995,
              9026.874
            ],
            [
              -1970.62,
              1705.012,
              9627.109
            ],
            [
              -1985.783,
              1723.093,
              9650.706
            ],
            [
              -2263.842,
              1978.495,
              10028.26
            ],
            [
              -2290.557,
              2000.118,
              10062.63
            ],
            [
              -2318.992,
              2034.018,
              10106.875
            ],
            [
              -2425.036,
              2130.514,
              10250.252
            ],
            [
              -2441.629,
              2140.826,
              10269.789
            ],
            [
              -2464.869,
              2140.123,
              10293.04
            ],
            [
              -2491.57,
              2126.123,
              10323.188
            ],
            [
              -2514.888,
              2120.968,
              10347.07
            ],
            [
              -2528.453,
              2120.094,
              10360.663
            ],
            [
              -2551.595,
              2124.955,
              10384.309
            ],
            [
              -2561.836,
              2129.588,
              10395.55
            ],
            [
              -2579.681,
              2142.148,
              10417.372
            ],
            [
              -2585.368,
              2148.928,
              10426.221
            ],
            [
              -2589.062,
              2159.012,
              10436.96
            ],
            [
              -2606.026,
              2184.914,
              10467.924
            ],
            [
              -2610.326,
              2197.235,
              10480.974
            ],
            [
              -2613.804,
              2219.561,
              10503.568
            ],
            [
              -2614.214,
              2232.927,
              10516.94
            ],
            [
              -2611.32,
              2250.687,
              10534.935
            ],
            [
              -2605.925,
              2263.95,
              10549.254
            ],
            [
              -2595.955,
              2280.473,
              10568.551
            ],
            [
              -2588.136,
              2284.788,
              10577.482
            ],
            [
              -2577.443,
              2305.751,
              10601.014
            ],
            [
              -2591.532,
              2385.037,
              10681.542
            ],
            [
              -2598.371,
              2436.365,
              10733.324
            ],
            [
              -2602.959,
              2542.201,
              10839.259
            ],
            [
              -2607.706,
              2602.398,
              10899.643
            ],
            [
              -2619.569,
              2661.607,
              10960.029
            ],
            [
              -2672.012,
              2798.342,
              11106.476
            ],
            [
              -2693.846,
              2841.028,
              11154.422
            ],
            [
              -2698.439,
              2873.392,
              11187.11
            ],
            [
              -2831.804,
              3253.114,
              11589.571
            ],
            [
              -2853.662,
              3294.686,
              11636.54
            ],
            [
              -2870.652,
              3319.475,
              11666.592
            ],
            [
              -2888.502,
              3332.034,
              11688.418
            ],
            [
              -2904.222,
              3355.687,
              11716.818
            ],
            [
              -3126.24,
              3576.651,
              12030.055
            ],
            [
              -3256.351,
              3702.491,
              12211.065
            ],
            [
              -3334.924,
              3786.24,
              12325.901
            ],
            [
              -3406.008,
              3855.385,
              12425.068
            ],
            [
              -3427.01,
              3872.449,
              12452.129
            ],
            [
              -3454.8,
              3907.442,
              12496.815
            ],
            [
              -3626.746,
              4078.528,
              12739.375
            ],
            [
              -3781.512,
              4235.95,
              12960.133
            ],
            [
              -3884.317,
              4337.92,
              13104.932
            ],
            [
              -3915.514,
              4362.95,
              13144.929
            ],
            [
              -3928.112,
              4380.98,
              13166.924
            ],
            [
              -4226.292,
              4683.356,
              13591.592
            ],
            [
              -4305.622,
              4762.647,
              13703.753
            ],
            [
              -4338.114,
              4787.696,
              13744.781
            ],
            [
              -4349.425,
              4805.702,
              13766.045
            ],
            [
              -4420.502,
              4877.057,
              13866.759
            ],
            [
              -4439.501,
              4898.534,
              13895.434
            ],
            [
              -4461.157,
              4915.604,
              13923.009
            ],
            [
              -4476.532,
              4922.548,
              13939.879
            ],
            [
              -4488.111,
              4924.973,
              13951.71
            ],
            [
              -4508.363,
              4948.698,
              13982.903
            ],
            [
              -4600.366,
              5004.825,
              14090.674
            ],
            [
              -4658.205,
              5020.288,
              14150.545
            ],
            [
              -4736.87,
              5026.089,
              14229.423
            ],
            [
              -4780.873,
              5020.164,
              14273.823
            ],
            [
              -4794.293,
              5028.186,
              14289.459
            ],
            [
              -4826.695,
              5058.796,
              14334.033
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 132.431,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 809.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 1236.865,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 1558.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 2130.959,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 2936.757,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 3667.388,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5662",
              "position": {
                "x": 1154.205,
                "z": -829.633
              },
              "distanceAlongShapeM": 4056.657,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5664",
              "position": {
                "x": 729.54,
                "z": -744.998
              },
              "distanceAlongShapeM": 4491.158,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5244",
              "position": {
                "x": 121.213,
                "z": -441.083
              },
              "distanceAlongShapeM": 5301.233,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 5845.443,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5334",
              "position": {
                "x": -97.297,
                "z": 380.009
              },
              "distanceAlongShapeM": 6457.534,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5524",
              "position": {
                "x": -620.556,
                "z": 726.8
              },
              "distanceAlongShapeM": 7934.353,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5579",
              "position": {
                "x": -1168.303,
                "z": 971.551
              },
              "distanceAlongShapeM": 8537.873,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6343",
              "position": {
                "x": -1502.183,
                "z": 1274.758
              },
              "distanceAlongShapeM": 8990.632,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 9627.109,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 10062.63,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 11154.422,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 11688.418,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 12452.129,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 13144.929,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 13744.781,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 13951.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            },
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 14334.033,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3300,
              "departureOffsetSeconds": 3300
            }
          ],
          "departuresSeconds": [
            17940,
            19560,
            20580,
            21720,
            22860,
            23580,
            24360,
            25260,
            26700,
            28080,
            29400,
            30600,
            32160,
            33900,
            36000,
            38460,
            41280,
            43620,
            46080,
            48900,
            51480,
            52740,
            54180,
            55560,
            56580,
            57300,
            58380,
            59940,
            61020,
            62520,
            64080,
            65820,
            66960,
            67920,
            70560,
            72960,
            75360,
            77460,
            79860
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_12:1",
          "sourceRouteId": "vilnius_trol_12",
          "sourceShapeId": "vilnius_trol_12_b-a",
          "directionId": 1,
          "headsign": "Žirmūnai (Apylanka be Reformatų st.)",
          "directionName": "Žemieji Paneriai–V. Kudirkos–Šeimyniškių g.–Žirmūnai (Apylanka be Reformatų st.)",
          "mode": "trolleybus",
          "routeShortName": "12",
          "routeLongName": "Žirmūnai–Šeimyniškių–Tauro g.–Žemieji Paneriai (Apylanka be Reformatų st.)",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -4826.695,
              5058.796,
              0
            ],
            [
              -4834.705,
              5081.197,
              23.79
            ],
            [
              -4785.441,
              5130.448,
              93.45
            ],
            [
              -4754.629,
              5157.75,
              134.618
            ],
            [
              -4724.691,
              5171.709,
              167.65
            ],
            [
              -4669.05,
              5178.548,
              223.71
            ],
            [
              -4632.924,
              5176.815,
              259.877
            ],
            [
              -4599.437,
              5171.788,
              293.739
            ],
            [
              -4586.132,
              5157.088,
              313.567
            ],
            [
              -4583.042,
              5111.394,
              359.365
            ],
            [
              -4580.889,
              5011.17,
              459.613
            ],
            [
              -4517.509,
              4980.025,
              530.231
            ],
            [
              -4503.635,
              4960.862,
              553.889
            ],
            [
              -4444.377,
              4915.316,
              628.628
            ],
            [
              -4189.698,
              4671.592,
              981.137
            ],
            [
              -4166.695,
              4657.837,
              1007.939
            ],
            [
              -4146.524,
              4629.659,
              1042.593
            ],
            [
              -4048.773,
              4533.349,
              1179.819
            ],
            [
              -3823.59,
              4303.471,
              1501.612
            ],
            [
              -3802.623,
              4284.184,
              1530.101
            ],
            [
              -3780.952,
              4268.223,
              1557.015
            ],
            [
              -3768.394,
              4247.967,
              1580.848
            ],
            [
              -3367.467,
              3844.694,
              2149.506
            ],
            [
              -3344.49,
              3829.822,
              2176.876
            ],
            [
              -3315.43,
              3793.692,
              2223.242
            ],
            [
              -3282.402,
              3763.059,
              2268.289
            ],
            [
              -3142.94,
              3618.132,
              2469.419
            ],
            [
              -2996.449,
              3469.738,
              2677.939
            ],
            [
              -2905.063,
              3381.305,
              2805.107
            ],
            [
              -2851.864,
              3323.598,
              2883.595
            ],
            [
              -2827.523,
              3276.416,
              2936.686
            ],
            [
              -2808.656,
              3248.254,
              2970.583
            ],
            [
              -2806.545,
              3221.5,
              2997.42
            ],
            [
              -2772.86,
              3118.493,
              3105.795
            ],
            [
              -2707,
              2936.995,
              3298.873
            ],
            [
              -2660.341,
              2801.476,
              3442.199
            ],
            [
              -2637.179,
              2724.257,
              3522.818
            ],
            [
              -2612.218,
              2675.949,
              3577.193
            ],
            [
              -2609.483,
              2648.071,
              3605.205
            ],
            [
              -2582.373,
              2575.235,
              3682.923
            ],
            [
              -2570.531,
              2514.913,
              3744.396
            ],
            [
              -2558.338,
              2437.886,
              3822.382
            ],
            [
              -2547.004,
              2385.365,
              3876.112
            ],
            [
              -2539.07,
              2359.622,
              3903.05
            ],
            [
              -2526.132,
              2324.884,
              3940.119
            ],
            [
              -2519.194,
              2315.856,
              3951.505
            ],
            [
              -2487.744,
              2306.396,
              3984.347
            ],
            [
              -2471.111,
              2298.31,
              4002.842
            ],
            [
              -2454.576,
              2284.659,
              4024.283
            ],
            [
              -2442.556,
              2271.088,
              4042.412
            ],
            [
              -2433.47,
              2237.532,
              4077.177
            ],
            [
              -2436.603,
              2169.681,
              4145.1
            ],
            [
              -2432.988,
              2155.146,
              4160.078
            ],
            [
              -2421.673,
              2138.248,
              4180.415
            ],
            [
              -2405.237,
              2119.033,
              4205.7
            ],
            [
              -2339.12,
              2063.317,
              4292.162
            ],
            [
              -2328.352,
              2051.995,
              4307.788
            ],
            [
              -2313.635,
              2045.055,
              4324.059
            ],
            [
              -2298.509,
              2024.75,
              4349.378
            ],
            [
              -1944.941,
              1697.877,
              4830.893
            ],
            [
              -1868.675,
              1633.068,
              4930.976
            ],
            [
              -1860.469,
              1622.903,
              4944.04
            ],
            [
              -1769.084,
              1537.785,
              5068.925
            ],
            [
              -1703.649,
              1480.959,
              5155.592
            ],
            [
              -1688.349,
              1470.667,
              5174.03
            ],
            [
              -1678.973,
              1453.802,
              5193.327
            ],
            [
              -1503.095,
              1295.926,
              5429.669
            ],
            [
              -1427.428,
              1234.46,
              5527.156
            ],
            [
              -1409.124,
              1211.868,
              5556.232
            ],
            [
              -1353.311,
              1158.548,
              5633.421
            ],
            [
              -1207.93,
              1027.923,
              5828.865
            ],
            [
              -1188.159,
              1015.323,
              5852.31
            ],
            [
              -1173.062,
              993.901,
              5878.517
            ],
            [
              -1066.972,
              902.938,
              6018.265
            ],
            [
              -958.695,
              862.029,
              6134.012
            ],
            [
              -800.989,
              807.981,
              6300.722
            ],
            [
              -799.135,
              803.495,
              6305.577
            ],
            [
              -799.94,
              794.603,
              6314.504
            ],
            [
              -808.22,
              764.696,
              6345.537
            ],
            [
              -810.251,
              723.543,
              6386.74
            ],
            [
              -829.673,
              683.817,
              6430.959
            ],
            [
              -843.054,
              478.111,
              6637.1
            ],
            [
              -804.926,
              410.63,
              6714.607
            ],
            [
              -682.331,
              234.755,
              6928.993
            ],
            [
              -671.067,
              215.627,
              6951.192
            ],
            [
              -647.308,
              102.762,
              7066.53
            ],
            [
              -591.62,
              115.115,
              7123.571
            ],
            [
              -557.893,
              125.637,
              7158.902
            ],
            [
              -539.176,
              126.412,
              7177.635
            ],
            [
              -408.498,
              148.538,
              7310.173
            ],
            [
              -385.731,
              159.258,
              7335.338
            ],
            [
              -216.06,
              268.617,
              7537.198
            ],
            [
              -55.202,
              424.885,
              7761.464
            ],
            [
              -39.768,
              422.378,
              7777.1
            ],
            [
              18.234,
              348.963,
              7870.663
            ],
            [
              36.62,
              260.682,
              7960.838
            ],
            [
              56.855,
              132.292,
              8090.813
            ],
            [
              59.373,
              128.907,
              8095.032
            ],
            [
              70.978,
              128.695,
              8106.639
            ],
            [
              102.671,
              133.684,
              8138.722
            ],
            [
              116.145,
              94.475,
              8180.182
            ],
            [
              129.88,
              -107.271,
              8382.394
            ],
            [
              116.846,
              -256.206,
              8531.899
            ],
            [
              117.887,
              -305.208,
              8580.911
            ],
            [
              127.989,
              -387.771,
              8664.091
            ],
            [
              138.319,
              -422.47,
              8700.294
            ],
            [
              150.182,
              -443.837,
              8724.734
            ],
            [
              177.186,
              -518.917,
              8804.522
            ],
            [
              186.708,
              -562.507,
              8849.14
            ],
            [
              214.213,
              -645.388,
              8936.466
            ],
            [
              224.323,
              -656.705,
              8951.642
            ],
            [
              237.149,
              -695.903,
              8992.884
            ],
            [
              292.85,
              -682.448,
              9050.187
            ],
            [
              331.506,
              -684.268,
              9088.886
            ],
            [
              436.802,
              -673.948,
              9194.686
            ],
            [
              647.48,
              -719,
              9410.127
            ],
            [
              692.52,
              -724.28,
              9455.476
            ],
            [
              729.304,
              -722.729,
              9492.292
            ],
            [
              752.305,
              -734.284,
              9518.033
            ],
            [
              1031.058,
              -793.963,
              9803.103
            ],
            [
              1157.03,
              -816.326,
              9931.044
            ],
            [
              1200.176,
              -819.349,
              9974.296
            ],
            [
              1220.015,
              -827.509,
              9995.747
            ],
            [
              1248.96,
              -831.383,
              10024.95
            ],
            [
              1325.104,
              -828.339,
              10101.155
            ],
            [
              1339.141,
              -836.391,
              10117.338
            ],
            [
              1354.364,
              -850.032,
              10137.778
            ],
            [
              1360.583,
              -862.393,
              10151.615
            ],
            [
              1367.85,
              -922.642,
              10212.302
            ],
            [
              1384.491,
              -964.14,
              10257.012
            ],
            [
              1464.439,
              -1103.664,
              10417.818
            ],
            [
              1480.223,
              -1121.768,
              10441.836
            ],
            [
              1488.813,
              -1145.306,
              10466.892
            ],
            [
              1537.374,
              -1238.606,
              10572.073
            ],
            [
              1587.871,
              -1366.453,
              10709.532
            ],
            [
              1626.598,
              -1502.988,
              10851.453
            ],
            [
              1647.564,
              -1589.097,
              10940.078
            ],
            [
              1670.179,
              -1759.844,
              11112.316
            ],
            [
              1676.751,
              -1787.797,
              11141.032
            ],
            [
              1672.408,
              -1813.321,
              11166.922
            ],
            [
              1677.37,
              -1962.589,
              11316.272
            ],
            [
              1684.587,
              -2475.93,
              11829.664
            ],
            [
              1691.063,
              -2612.98,
              11966.867
            ],
            [
              1696.386,
              -2638.684,
              11993.116
            ],
            [
              1690.652,
              -2669.748,
              12024.705
            ],
            [
              1690.731,
              -2873.474,
              12228.431
            ],
            [
              1700.851,
              -3126.37,
              12481.529
            ],
            [
              1709.563,
              -3177.741,
              12533.634
            ],
            [
              1701.896,
              -3208.77,
              12565.596
            ],
            [
              1697.306,
              -3247.648,
              12604.744
            ],
            [
              1679.831,
              -3286.287,
              12647.151
            ],
            [
              1593.247,
              -3437.193,
              12821.132
            ],
            [
              1582.257,
              -3473.726,
              12859.282
            ],
            [
              1566.424,
              -3493.47,
              12884.591
            ],
            [
              1509.807,
              -3592.611,
              12998.759
            ],
            [
              1412.221,
              -3746.656,
              13181.113
            ],
            [
              1401.002,
              -3760.92,
              13199.26
            ],
            [
              1342.825,
              -3805.485,
              13272.545
            ],
            [
              1325.974,
              -3810.739,
              13290.196
            ],
            [
              1219.986,
              -3862.213,
              13408.022
            ],
            [
              1220.734,
              -4100.462,
              13646.272
            ],
            [
              1228.325,
              -4142.906,
              13689.389
            ],
            [
              1222.034,
              -4169.508,
              13716.725
            ],
            [
              1223.554,
              -4191.801,
              13739.07
            ],
            [
              1219.757,
              -4222.901,
              13770.401
            ],
            [
              1209.725,
              -4242.754,
              13792.645
            ],
            [
              1201.125,
              -4254.841,
              13807.479
            ],
            [
              1180.185,
              -4272.266,
              13834.721
            ],
            [
              1169.776,
              -4277.639,
              13846.435
            ],
            [
              1151.036,
              -4280.633,
              13865.413
            ],
            [
              1136.221,
              -4280.359,
              13880.23
            ],
            [
              1097.226,
              -4298.563,
              13923.265
            ],
            [
              1061.102,
              -4335.747,
              13975.107
            ],
            [
              1050.796,
              -4335.556,
              13985.414
            ],
            [
              1023.347,
              -4321.691,
              14016.167
            ],
            [
              1017.05,
              -4313.782,
              14026.276
            ],
            [
              1016.673,
              -4299.303,
              14040.761
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1076",
              "position": {
                "x": -4826.695,
                "z": 5058.796
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -480,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 223.71,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 530.231,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 1007.939,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 1557.015,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 2176.876,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 2970.583,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 3577.193,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 4324.059,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 4930.976,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6842",
              "position": {
                "x": -1427.428,
                "z": 1234.46
              },
              "distanceAlongShapeM": 5527.156,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5580",
              "position": {
                "x": -1188.159,
                "z": 1015.323
              },
              "distanceAlongShapeM": 5852.31,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 6386.74,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5332",
              "position": {
                "x": -557.893,
                "z": 125.637
              },
              "distanceAlongShapeM": 7158.902,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 7870.663,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 8180.182,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5245",
              "position": {
                "x": 150.182,
                "z": -443.837
              },
              "distanceAlongShapeM": 8724.734,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 9050.187,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2070,
              "departureOffsetSeconds": 2070
            },
            {
              "stopId": "judu:stop:5665",
              "position": {
                "x": 729.304,
                "z": -722.729
              },
              "distanceAlongShapeM": 9492.292,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6660",
              "position": {
                "x": 1200.176,
                "z": -819.349
              },
              "distanceAlongShapeM": 9974.296,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 10441.836,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 11141.032,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 11993.116,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 12533.634,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 12859.282,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 13272.545,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 13689.389,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3180,
              "departureOffsetSeconds": 3180
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 13865.413,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3240,
              "departureOffsetSeconds": 3240
            }
          ],
          "departuresSeconds": [
            19860,
            21240,
            22920,
            24240,
            25440,
            26580,
            27540,
            28260,
            29280,
            30780,
            32160,
            33240,
            34380,
            35940,
            37560,
            39720,
            42060,
            44940,
            47220,
            49680,
            52500,
            55140,
            56640,
            58080,
            59520,
            60840,
            61440,
            62580,
            64140,
            66720,
            71760,
            73980,
            76440,
            78780,
            81000,
            83280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_15",
      "sourceRouteId": "vilnius_trol_15",
      "mode": "trolleybus",
      "shortName": "15",
      "longName": "Stotis–Žemieji Paneriai–Titnago g.",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_15:0",
          "sourceRouteId": "vilnius_trol_15",
          "sourceShapeId": "vilnius_trol_15_a-b",
          "directionId": 0,
          "headsign": "Titnago g.",
          "directionName": "Stotis–Žemieji Paneriai–Titnago g.",
          "mode": "trolleybus",
          "routeShortName": "15",
          "routeLongName": "Stotis–Žemieji Paneriai–Titnago g.",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              373.827,
              1913.246,
              0
            ],
            [
              381.688,
              1919.781,
              10.224
            ],
            [
              390.297,
              1931.87,
              25.064
            ],
            [
              381.613,
              1950.953,
              46.03
            ],
            [
              374.681,
              1959.986,
              57.417
            ],
            [
              359.73,
              1989.203,
              90.237
            ],
            [
              357.312,
              1998.153,
              99.508
            ],
            [
              360.055,
              2007.009,
              108.778
            ],
            [
              365.317,
              2012.479,
              116.368
            ],
            [
              381.462,
              2013.297,
              132.534
            ],
            [
              469.575,
              1962.704,
              234.14
            ],
            [
              481.002,
              1952.475,
              249.475
            ],
            [
              482.211,
              1948,
              254.111
            ],
            [
              476.141,
              1933.639,
              269.702
            ],
            [
              470.194,
              1925.956,
              279.418
            ],
            [
              463.683,
              1922.735,
              286.682
            ],
            [
              447.558,
              1923.03,
              302.809
            ],
            [
              415.411,
              1929.184,
              335.541
            ],
            [
              398.6,
              1927.265,
              352.46
            ],
            [
              334.106,
              1822.687,
              475.327
            ],
            [
              318.606,
              1821.856,
              490.849
            ],
            [
              29.934,
              1735.835,
              792.065
            ],
            [
              -11.424,
              1732.135,
              833.588
            ],
            [
              -46.755,
              1740.57,
              869.912
            ],
            [
              -320.217,
              1781.157,
              1146.369
            ],
            [
              -550.531,
              1853.232,
              1387.698
            ],
            [
              -582.7,
              1858.267,
              1420.258
            ],
            [
              -596.688,
              1869.651,
              1438.294
            ],
            [
              -1032.712,
              2019.998,
              1899.511
            ],
            [
              -1048.212,
              2019.164,
              1915.033
            ],
            [
              -1075.687,
              2034.129,
              1946.319
            ],
            [
              -1134.042,
              2054.101,
              2007.998
            ],
            [
              -1154.642,
              2056.697,
              2028.761
            ],
            [
              -1164.417,
              2051.306,
              2039.924
            ],
            [
              -1208.37,
              2010.905,
              2099.624
            ],
            [
              -1267.715,
              1939.609,
              2192.387
            ],
            [
              -1394.1,
              1799.379,
              2381.166
            ],
            [
              -1411.426,
              1768.519,
              2416.557
            ],
            [
              -1434.923,
              1753.354,
              2444.523
            ],
            [
              -1515.962,
              1659.065,
              2568.852
            ],
            [
              -1594.12,
              1581.422,
              2679.021
            ],
            [
              -1692.298,
              1466.285,
              2830.333
            ],
            [
              -1701.366,
              1464.22,
              2839.634
            ],
            [
              -1708.441,
              1465.459,
              2846.816
            ],
            [
              -1712.191,
              1472.205,
              2854.534
            ],
            [
              -1970.62,
              1705.012,
              3202.363
            ],
            [
              -1985.783,
              1723.093,
              3225.96
            ],
            [
              -2263.842,
              1978.495,
              3603.513
            ],
            [
              -2290.557,
              2000.118,
              3637.883
            ],
            [
              -2318.992,
              2034.018,
              3682.129
            ],
            [
              -2425.036,
              2130.514,
              3825.506
            ],
            [
              -2441.629,
              2140.826,
              3845.043
            ],
            [
              -2464.869,
              2140.123,
              3868.293
            ],
            [
              -2491.57,
              2126.123,
              3898.442
            ],
            [
              -2514.888,
              2120.968,
              3922.323
            ],
            [
              -2528.453,
              2120.094,
              3935.916
            ],
            [
              -2551.595,
              2124.955,
              3959.563
            ],
            [
              -2561.836,
              2129.588,
              3970.804
            ],
            [
              -2579.681,
              2142.148,
              3992.625
            ],
            [
              -2585.368,
              2148.928,
              4001.475
            ],
            [
              -2589.062,
              2159.012,
              4012.214
            ],
            [
              -2606.026,
              2184.914,
              4043.177
            ],
            [
              -2610.326,
              2197.235,
              4056.227
            ],
            [
              -2613.804,
              2219.561,
              4078.822
            ],
            [
              -2614.214,
              2232.927,
              4092.194
            ],
            [
              -2611.32,
              2250.687,
              4110.189
            ],
            [
              -2605.925,
              2263.95,
              4124.507
            ],
            [
              -2595.955,
              2280.473,
              4143.805
            ],
            [
              -2588.136,
              2284.788,
              4152.735
            ],
            [
              -2577.443,
              2305.751,
              4176.268
            ],
            [
              -2591.532,
              2385.037,
              4256.796
            ],
            [
              -2598.371,
              2436.365,
              4308.578
            ],
            [
              -2602.959,
              2542.201,
              4414.513
            ],
            [
              -2607.706,
              2602.398,
              4474.897
            ],
            [
              -2619.569,
              2661.607,
              4535.283
            ],
            [
              -2672.012,
              2798.342,
              4681.729
            ],
            [
              -2693.846,
              2841.028,
              4729.676
            ],
            [
              -2698.439,
              2873.392,
              4762.364
            ],
            [
              -2831.804,
              3253.114,
              5164.825
            ],
            [
              -2853.662,
              3294.686,
              5211.794
            ],
            [
              -2870.652,
              3319.475,
              5241.846
            ],
            [
              -2888.502,
              3332.034,
              5263.671
            ],
            [
              -2904.222,
              3355.687,
              5292.071
            ],
            [
              -3126.24,
              3576.651,
              5605.308
            ],
            [
              -3256.351,
              3702.491,
              5786.319
            ],
            [
              -3334.924,
              3786.24,
              5901.155
            ],
            [
              -3406.008,
              3855.385,
              6000.321
            ],
            [
              -3427.01,
              3872.449,
              6027.382
            ],
            [
              -3454.8,
              3907.442,
              6072.068
            ],
            [
              -3626.746,
              4078.528,
              6314.628
            ],
            [
              -3781.512,
              4235.95,
              6535.387
            ],
            [
              -3884.317,
              4337.92,
              6680.186
            ],
            [
              -3915.514,
              4362.95,
              6720.183
            ],
            [
              -3928.112,
              4380.98,
              6742.178
            ],
            [
              -4226.292,
              4683.356,
              7166.845
            ],
            [
              -4305.622,
              4762.647,
              7279.007
            ],
            [
              -4338.114,
              4787.696,
              7320.035
            ],
            [
              -4349.425,
              4805.702,
              7341.298
            ],
            [
              -4420.502,
              4877.057,
              7442.013
            ],
            [
              -4439.501,
              4898.534,
              7470.687
            ],
            [
              -4461.157,
              4915.604,
              7498.263
            ],
            [
              -4476.532,
              4922.548,
              7515.133
            ],
            [
              -4488.111,
              4924.973,
              7526.963
            ],
            [
              -4508.363,
              4948.698,
              7558.156
            ],
            [
              -4600.366,
              5004.825,
              7665.928
            ],
            [
              -4658.205,
              5020.288,
              7725.799
            ],
            [
              -4736.87,
              5026.089,
              7804.677
            ],
            [
              -4780.873,
              5020.164,
              7849.077
            ],
            [
              -4794.293,
              5028.186,
              7864.712
            ],
            [
              -4887.841,
              5032.012,
              7958.338
            ],
            [
              -5084.124,
              5030.911,
              8154.625
            ],
            [
              -5215.445,
              4939.641,
              8314.548
            ],
            [
              -5291.942,
              4883.057,
              8409.698
            ],
            [
              -5256.598,
              4911.398,
              8455.002
            ],
            [
              -5543.457,
              4708.104,
              8806.593
            ],
            [
              -5565.132,
              4686.208,
              8837.403
            ],
            [
              -5573.178,
              4668.533,
              8856.823
            ],
            [
              -5896.258,
              4344.494,
              9314.406
            ],
            [
              -5929.163,
              4307.201,
              9364.14
            ],
            [
              -5947.232,
              4307.506,
              9382.212
            ],
            [
              -5952.3,
              4313.157,
              9389.803
            ],
            [
              -5952.758,
              4324.297,
              9400.952
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 833.588,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5167",
              "position": {
                "x": -582.7,
                "z": 1858.267
              },
              "distanceAlongShapeM": 1420.258,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6362",
              "position": {
                "x": -1048.212,
                "z": 2019.164
              },
              "distanceAlongShapeM": 1915.033,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6365",
              "position": {
                "x": -1411.426,
                "z": 1768.519
              },
              "distanceAlongShapeM": 2416.557,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 690,
              "departureOffsetSeconds": 690
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 3202.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 870,
              "departureOffsetSeconds": 870
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 3637.883,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 990,
              "departureOffsetSeconds": 990
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 4729.676,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1230,
              "departureOffsetSeconds": 1230
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 5263.671,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 6027.382,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 6720.183,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 7320.035,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 7526.963,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5557",
              "position": {
                "x": -4780.873,
                "z": 5020.164
              },
              "distanceAlongShapeM": 7849.077,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:7553",
              "position": {
                "x": -5291.942,
                "z": 4883.057
              },
              "distanceAlongShapeM": 8409.698,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5571",
              "position": {
                "x": -5573.178,
                "z": 4668.533
              },
              "distanceAlongShapeM": 8856.823,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:16788",
              "position": {
                "x": -5896.258,
                "z": 4344.494
              },
              "distanceAlongShapeM": 9314.406,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            }
          ],
          "departuresSeconds": [
            18540,
            19440,
            20820,
            22740,
            24000,
            25320,
            53640,
            54960,
            56700,
            58500,
            59880,
            61740
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_15:1",
          "sourceRouteId": "vilnius_trol_15",
          "sourceShapeId": "vilnius_trol_15_b-a",
          "directionId": 1,
          "headsign": "Stotis",
          "directionName": "Titnago g.–Žemieji Paneriai–Stotis",
          "mode": "trolleybus",
          "routeShortName": "15",
          "routeLongName": "Stotis–Žemieji Paneriai–Titnago g.",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5952.758,
              4324.297,
              0
            ],
            [
              -5932.772,
              4322.847,
              20.039
            ],
            [
              -5851.894,
              4410.536,
              139.331
            ],
            [
              -5542.812,
              4708.093,
              568.367
            ],
            [
              -5523.681,
              4732.259,
              599.189
            ],
            [
              -5495.647,
              4748.482,
              631.579
            ],
            [
              -5230.403,
              4933.216,
              954.814
            ],
            [
              -5256.503,
              4916.963,
              985.562
            ],
            [
              -5185.339,
              4963.618,
              1070.656
            ],
            [
              -5101.038,
              5023.407,
              1174.007
            ],
            [
              -5084.124,
              5030.911,
              1192.511
            ],
            [
              -4983.382,
              5032.532,
              1293.266
            ],
            [
              -4963.962,
              5035.54,
              1312.917
            ],
            [
              -4929.167,
              5031.606,
              1347.934
            ],
            [
              -4887.841,
              5032.012,
              1389.262
            ],
            [
              -4834.705,
              5081.197,
              1461.668
            ],
            [
              -4785.441,
              5130.448,
              1531.328
            ],
            [
              -4754.629,
              5157.75,
              1572.496
            ],
            [
              -4724.691,
              5171.709,
              1605.528
            ],
            [
              -4669.05,
              5178.548,
              1661.588
            ],
            [
              -4632.924,
              5176.815,
              1697.755
            ],
            [
              -4599.437,
              5171.788,
              1731.617
            ],
            [
              -4586.132,
              5157.088,
              1751.445
            ],
            [
              -4583.042,
              5111.394,
              1797.243
            ],
            [
              -4580.889,
              5011.17,
              1897.491
            ],
            [
              -4517.509,
              4980.025,
              1968.109
            ],
            [
              -4503.635,
              4960.862,
              1991.767
            ],
            [
              -4444.377,
              4915.316,
              2066.506
            ],
            [
              -4189.698,
              4671.592,
              2419.015
            ],
            [
              -4166.695,
              4657.837,
              2445.817
            ],
            [
              -4146.524,
              4629.659,
              2480.471
            ],
            [
              -4048.773,
              4533.349,
              2617.697
            ],
            [
              -3823.59,
              4303.471,
              2939.49
            ],
            [
              -3802.623,
              4284.184,
              2967.98
            ],
            [
              -3780.952,
              4268.223,
              2994.893
            ],
            [
              -3768.394,
              4247.967,
              3018.726
            ],
            [
              -3367.467,
              3844.694,
              3587.384
            ],
            [
              -3344.49,
              3829.822,
              3614.754
            ],
            [
              -3315.43,
              3793.692,
              3661.12
            ],
            [
              -3282.402,
              3763.059,
              3706.167
            ],
            [
              -3142.94,
              3618.132,
              3907.297
            ],
            [
              -2996.449,
              3469.738,
              4115.817
            ],
            [
              -2905.063,
              3381.305,
              4242.985
            ],
            [
              -2851.864,
              3323.598,
              4321.473
            ],
            [
              -2827.523,
              3276.416,
              4374.564
            ],
            [
              -2808.656,
              3248.254,
              4408.461
            ],
            [
              -2806.545,
              3221.5,
              4435.298
            ],
            [
              -2772.86,
              3118.493,
              4543.673
            ],
            [
              -2707,
              2936.995,
              4736.751
            ],
            [
              -2660.341,
              2801.476,
              4880.078
            ],
            [
              -2637.179,
              2724.257,
              4960.696
            ],
            [
              -2612.218,
              2675.949,
              5015.071
            ],
            [
              -2609.483,
              2648.071,
              5043.083
            ],
            [
              -2582.373,
              2575.235,
              5120.801
            ],
            [
              -2570.531,
              2514.913,
              5182.274
            ],
            [
              -2558.338,
              2437.886,
              5260.26
            ],
            [
              -2547.004,
              2385.365,
              5313.99
            ],
            [
              -2539.07,
              2359.622,
              5340.928
            ],
            [
              -2526.132,
              2324.884,
              5377.997
            ],
            [
              -2519.194,
              2315.856,
              5389.383
            ],
            [
              -2487.744,
              2306.396,
              5422.225
            ],
            [
              -2471.111,
              2298.31,
              5440.72
            ],
            [
              -2454.576,
              2284.659,
              5462.161
            ],
            [
              -2442.556,
              2271.088,
              5480.29
            ],
            [
              -2433.47,
              2237.532,
              5515.055
            ],
            [
              -2436.603,
              2169.681,
              5582.978
            ],
            [
              -2432.988,
              2155.146,
              5597.956
            ],
            [
              -2421.673,
              2138.248,
              5618.293
            ],
            [
              -2405.237,
              2119.033,
              5643.578
            ],
            [
              -2339.12,
              2063.317,
              5730.04
            ],
            [
              -2328.352,
              2051.995,
              5745.666
            ],
            [
              -2313.635,
              2045.055,
              5761.937
            ],
            [
              -2298.509,
              2024.75,
              5787.257
            ],
            [
              -1944.941,
              1697.877,
              6268.771
            ],
            [
              -1868.675,
              1633.068,
              6368.854
            ],
            [
              -1860.469,
              1622.903,
              6381.918
            ],
            [
              -1769.084,
              1537.785,
              6506.803
            ],
            [
              -1703.649,
              1480.959,
              6593.47
            ],
            [
              -1699.799,
              1479.777,
              6597.497
            ],
            [
              -1695.245,
              1481.922,
              6602.531
            ],
            [
              -1682.168,
              1491.708,
              6618.864
            ],
            [
              -1671.651,
              1502.653,
              6634.042
            ],
            [
              -1654.972,
              1533.526,
              6669.132
            ],
            [
              -1603.973,
              1571.579,
              6732.764
            ],
            [
              -1299.013,
              1921.245,
              7196.732
            ],
            [
              -1270.801,
              1947.457,
              7235.242
            ],
            [
              -1190.297,
              2047.317,
              7363.512
            ],
            [
              -1173.912,
              2061.495,
              7385.179
            ],
            [
              -1158.937,
              2069.019,
              7401.937
            ],
            [
              -1145.392,
              2068.776,
              7415.485
            ],
            [
              -1135.112,
              2066.366,
              7426.044
            ],
            [
              -987.662,
              2013.623,
              7582.643
            ],
            [
              -958.677,
              2010.875,
              7611.758
            ],
            [
              -943.398,
              1999.468,
              7630.826
            ],
            [
              -544.505,
              1865.369,
              8051.656
            ],
            [
              -470.051,
              1843.985,
              8129.12
            ],
            [
              -432.32,
              1825.49,
              8171.14
            ],
            [
              -327.19,
              1787.963,
              8282.767
            ],
            [
              -259.046,
              1774.482,
              8352.231
            ],
            [
              -147.106,
              1756.865,
              8465.55
            ],
            [
              9.981,
              1738.424,
              8623.715
            ],
            [
              41.02,
              1742.312,
              8654.996
            ],
            [
              63.816,
              1754.143,
              8680.68
            ],
            [
              97.435,
              1757.984,
              8714.517
            ],
            [
              156.41,
              1772.494,
              8775.252
            ],
            [
              318.606,
              1821.856,
              8944.792
            ],
            [
              328.524,
              1835.034,
              8961.286
            ],
            [
              373.827,
              1913.246,
              9051.67
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1008",
              "position": {
                "x": -5851.894,
                "z": 4410.536
              },
              "distanceAlongShapeM": 139.331,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5570",
              "position": {
                "x": -5523.681,
                "z": 4732.259
              },
              "distanceAlongShapeM": 599.189,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:7554",
              "position": {
                "x": -5256.503,
                "z": 4916.963
              },
              "distanceAlongShapeM": 985.562,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5564",
              "position": {
                "x": -4963.962,
                "z": 5035.54
              },
              "distanceAlongShapeM": 1312.917,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 1661.588,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 1968.109,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 2445.817,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 2994.893,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 3614.754,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 4408.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 5015.071,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 5761.937,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 6368.854,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6410",
              "position": {
                "x": -1654.972,
                "z": 1533.526
              },
              "distanceAlongShapeM": 6669.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6366",
              "position": {
                "x": -1299.013,
                "z": 1921.245
              },
              "distanceAlongShapeM": 7196.732,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6363",
              "position": {
                "x": -958.677,
                "z": 2010.875
              },
              "distanceAlongShapeM": 7611.758,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 8129.12,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 8680.68,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 9051.67,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            }
          ],
          "departuresSeconds": [
            20940,
            22200,
            23520,
            25560,
            27240,
            28920,
            51600,
            52860,
            54660,
            56520,
            57900,
            59760,
            61560,
            63000,
            64860
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_16",
      "sourceRouteId": "vilnius_trol_16",
      "mode": "trolleybus",
      "shortName": "16",
      "longName": "Pašilaičiai–Lazdynai–Stotis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_16:0",
          "sourceRouteId": "vilnius_trol_16",
          "sourceShapeId": "vilnius_trol_16_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Pašilaičiai–Lazdynai–Stotis",
          "mode": "trolleybus",
          "routeShortName": "16",
          "routeLongName": "Pašilaičiai–Lazdynai–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2897.378,
              -4403.536,
              0
            ],
            [
              -2904.267,
              -4392.283,
              13.195
            ],
            [
              -2902.49,
              -4364.484,
              41.051
            ],
            [
              -2923.723,
              -4326.261,
              84.775
            ],
            [
              -2938.397,
              -4244.738,
              167.609
            ],
            [
              -2943.47,
              -4203.459,
              209.198
            ],
            [
              -2943.332,
              -4158.933,
              253.724
            ],
            [
              -2947.565,
              -4106.537,
              306.291
            ],
            [
              -2936.886,
              -4048.837,
              364.97
            ],
            [
              -2933.232,
              -3950.938,
              462.938
            ],
            [
              -2933.288,
              -3880.804,
              533.071
            ],
            [
              -2935.53,
              -3825.104,
              588.817
            ],
            [
              -2942.439,
              -3778.227,
              636.2
            ],
            [
              -2941.11,
              -3739.288,
              675.162
            ],
            [
              -2942.553,
              -3711.432,
              703.055
            ],
            [
              -2962.772,
              -3578.604,
              837.414
            ],
            [
              -2994.393,
              -3434.443,
              985.002
            ],
            [
              -3009.522,
              -3378.516,
              1042.938
            ],
            [
              -3026.974,
              -3344.813,
              1080.892
            ],
            [
              -3029.648,
              -3313.596,
              1112.223
            ],
            [
              -3083.217,
              -3134.541,
              1299.12
            ],
            [
              -3102.428,
              -3054.053,
              1381.869
            ],
            [
              -3137.083,
              -2972.18,
              1470.774
            ],
            [
              -3158.619,
              -2877.179,
              1568.185
            ],
            [
              -3186.209,
              -2796.544,
              1653.41
            ],
            [
              -3248.067,
              -2685.253,
              1780.737
            ],
            [
              -3332.852,
              -2557.976,
              1933.668
            ],
            [
              -3349.352,
              -2543.216,
              1955.806
            ],
            [
              -3361.538,
              -2502.927,
              1997.898
            ],
            [
              -3386.79,
              -2435.693,
              2069.717
            ],
            [
              -3393.431,
              -2409.973,
              2096.281
            ],
            [
              -3395.464,
              -2378.768,
              2127.553
            ],
            [
              -3389.87,
              -2243.053,
              2263.382
            ],
            [
              -3384.424,
              -2226.45,
              2280.856
            ],
            [
              -3365.672,
              -2038.645,
              2469.595
            ],
            [
              -3375.166,
              -1991.724,
              2517.467
            ],
            [
              -3374.974,
              -1943.859,
              2565.332
            ],
            [
              -3391.774,
              -1872.32,
              2638.817
            ],
            [
              -3430.979,
              -1754.748,
              2762.753
            ],
            [
              -3480.186,
              -1619.191,
              2906.966
            ],
            [
              -3508.003,
              -1550.799,
              2980.798
            ],
            [
              -3525.544,
              -1521.55,
              3014.904
            ],
            [
              -3534.455,
              -1477.979,
              3059.376
            ],
            [
              -3620.717,
              -1211.532,
              3339.439
            ],
            [
              -3662.686,
              -1103.933,
              3454.933
            ],
            [
              -3680.758,
              -1067.996,
              3495.158
            ],
            [
              -3686.114,
              -1042.299,
              3521.408
            ],
            [
              -3720.918,
              -930.373,
              3638.62
            ],
            [
              -3751.541,
              -837.444,
              3736.465
            ],
            [
              -3761.526,
              -818.346,
              3758.015
            ],
            [
              -3766.218,
              -791.548,
              3785.222
            ],
            [
              -3793.988,
              -719.82,
              3862.137
            ],
            [
              -3843.779,
              -616.54,
              3976.793
            ],
            [
              -3881.258,
              -546.871,
              4055.904
            ],
            [
              -3968.98,
              -399.519,
              4227.39
            ],
            [
              -3986.683,
              -379.175,
              4254.358
            ],
            [
              -3999.719,
              -350.005,
              4286.308
            ],
            [
              -4048.201,
              -282.373,
              4369.522
            ],
            [
              -4133.499,
              -180.709,
              4502.23
            ],
            [
              -4196.245,
              -117.285,
              4591.447
            ],
            [
              -4221.08,
              -99.045,
              4622.261
            ],
            [
              -4243.751,
              -67.483,
              4661.121
            ],
            [
              -4402.336,
              85.535,
              4881.492
            ],
            [
              -4449.086,
              142,
              4954.8
            ],
            [
              -4479.797,
              193.736,
              5014.964
            ],
            [
              -4502.905,
              237.549,
              5064.497
            ],
            [
              -4519.036,
              274.562,
              5104.873
            ],
            [
              -4536.228,
              324.952,
              5158.115
            ],
            [
              -4547.048,
              370.78,
              5205.202
            ],
            [
              -4566.578,
              510.266,
              5346.049
            ],
            [
              -4574.501,
              537.119,
              5374.046
            ],
            [
              -4575.517,
              590.57,
              5427.507
            ],
            [
              -4579.623,
              651.866,
              5488.941
            ],
            [
              -4586.366,
              709.869,
              5547.334
            ],
            [
              -4584.541,
              741.007,
              5578.526
            ],
            [
              -4573.306,
              794.248,
              5632.939
            ],
            [
              -4555.909,
              830.684,
              5673.316
            ],
            [
              -4538.646,
              859.331,
              5706.762
            ],
            [
              -4503.175,
              896.569,
              5758.191
            ],
            [
              -4462.091,
              922.579,
              5806.816
            ],
            [
              -4445.644,
              941.22,
              5831.675
            ],
            [
              -4396.195,
              965.972,
              5886.973
            ],
            [
              -4188.107,
              1100.42,
              6134.716
            ],
            [
              -4154.055,
              1129.888,
              6179.748
            ],
            [
              -4048.114,
              1175.924,
              6295.259
            ],
            [
              -3997.487,
              1193.972,
              6349.008
            ],
            [
              -3829.673,
              1236.704,
              6522.177
            ],
            [
              -3789.4,
              1252.704,
              6565.511
            ],
            [
              -3749.695,
              1273.165,
              6610.178
            ],
            [
              -3705.908,
              1305.8,
              6664.79
            ],
            [
              -3669.839,
              1339.683,
              6714.277
            ],
            [
              -3634.26,
              1382.479,
              6769.931
            ],
            [
              -3619.001,
              1406.704,
              6798.561
            ],
            [
              -3601.633,
              1440.911,
              6836.925
            ],
            [
              -3596.615,
              1469.767,
              6866.214
            ],
            [
              -3579.402,
              1495.072,
              6896.818
            ],
            [
              -3566.606,
              1526.019,
              6930.306
            ],
            [
              -3560.672,
              1570.444,
              6975.126
            ],
            [
              -3561.909,
              1610.54,
              7015.242
            ],
            [
              -3553.124,
              1670.501,
              7075.842
            ],
            [
              -3546.511,
              1753.876,
              7159.479
            ],
            [
              -3528.72,
              1849.302,
              7256.55
            ],
            [
              -3507.519,
              1881.216,
              7294.864
            ],
            [
              -3466.677,
              1929.485,
              7358.093
            ],
            [
              -3411.117,
              1970.818,
              7427.342
            ],
            [
              -3377.989,
              1983.599,
              7462.849
            ],
            [
              -3293.772,
              2003.28,
              7549.336
            ],
            [
              -3253.06,
              2007.021,
              7590.22
            ],
            [
              -3234.374,
              2005.581,
              7608.961
            ],
            [
              -3211.057,
              2010.74,
              7632.841
            ],
            [
              -2960.432,
              2100.974,
              7899.216
            ],
            [
              -2902.519,
              2128.901,
              7963.511
            ],
            [
              -2763.528,
              2181.007,
              8111.947
            ],
            [
              -2705.632,
              2207.819,
              8175.75
            ],
            [
              -2695.312,
              2207.637,
              8186.072
            ],
            [
              -2620.644,
              2234.153,
              8265.308
            ],
            [
              -2602.113,
              2260.544,
              8297.555
            ],
            [
              -2588.136,
              2284.788,
              8325.54
            ],
            [
              -2571.13,
              2297.847,
              8346.981
            ],
            [
              -2532.153,
              2312.745,
              8388.708
            ],
            [
              -2506.977,
              2313.414,
              8413.893
            ],
            [
              -2483.854,
              2307.44,
              8437.776
            ],
            [
              -2455.846,
              2285.795,
              8473.173
            ],
            [
              -2438.355,
              2253.203,
              8510.162
            ],
            [
              -2433.47,
              2237.532,
              8526.577
            ],
            [
              -2436.603,
              2169.681,
              8594.5
            ],
            [
              -2432.988,
              2155.146,
              8609.478
            ],
            [
              -2421.673,
              2138.248,
              8629.815
            ],
            [
              -2405.237,
              2119.033,
              8655.1
            ],
            [
              -2339.12,
              2063.317,
              8741.562
            ],
            [
              -2328.352,
              2051.995,
              8757.188
            ],
            [
              -2313.635,
              2045.055,
              8773.459
            ],
            [
              -2298.509,
              2024.75,
              8798.778
            ],
            [
              -1944.941,
              1697.877,
              9280.293
            ],
            [
              -1868.675,
              1633.068,
              9380.376
            ],
            [
              -1860.469,
              1622.903,
              9393.44
            ],
            [
              -1769.084,
              1537.785,
              9518.325
            ],
            [
              -1703.649,
              1480.959,
              9604.992
            ],
            [
              -1699.799,
              1479.777,
              9609.018
            ],
            [
              -1682.168,
              1491.708,
              9630.307
            ],
            [
              -1671.651,
              1502.653,
              9645.486
            ],
            [
              -1654.972,
              1533.526,
              9680.576
            ],
            [
              -1603.973,
              1571.579,
              9744.207
            ],
            [
              -1299.013,
              1921.245,
              10208.176
            ],
            [
              -1270.801,
              1947.457,
              10246.686
            ],
            [
              -1190.297,
              2047.317,
              10374.955
            ],
            [
              -1173.912,
              2061.495,
              10396.622
            ],
            [
              -1158.937,
              2069.019,
              10413.381
            ],
            [
              -1145.392,
              2068.776,
              10426.928
            ],
            [
              -1135.112,
              2066.366,
              10437.487
            ],
            [
              -987.662,
              2013.623,
              10594.087
            ],
            [
              -958.677,
              2010.875,
              10623.201
            ],
            [
              -943.398,
              1999.468,
              10642.269
            ],
            [
              -544.505,
              1865.369,
              11063.099
            ],
            [
              -470.051,
              1843.985,
              11140.564
            ],
            [
              -432.32,
              1825.49,
              11182.584
            ],
            [
              -327.19,
              1787.963,
              11294.21
            ],
            [
              -259.046,
              1774.482,
              11363.675
            ],
            [
              -147.106,
              1756.865,
              11476.993
            ],
            [
              9.981,
              1738.424,
              11635.158
            ],
            [
              41.02,
              1742.312,
              11666.44
            ],
            [
              63.816,
              1754.143,
              11692.123
            ],
            [
              97.435,
              1757.984,
              11725.961
            ],
            [
              156.41,
              1772.494,
              11786.695
            ],
            [
              318.606,
              1821.856,
              11956.236
            ],
            [
              328.524,
              1835.034,
              11972.729
            ],
            [
              373.827,
              1913.246,
              12063.113
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8275",
              "position": {
                "x": -2897.378,
                "z": -4403.536
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -840,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6484",
              "position": {
                "x": -2923.723,
                "z": -4326.261
              },
              "distanceAlongShapeM": 84.775,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 306.291,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 636.2,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:6478",
              "position": {
                "x": -3026.974,
                "z": -3344.813
              },
              "distanceAlongShapeM": 1080.892,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6477",
              "position": {
                "x": -3137.083,
                "z": -2972.18
              },
              "distanceAlongShapeM": 1470.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6476",
              "position": {
                "x": -3349.352,
                "z": -2543.216
              },
              "distanceAlongShapeM": 1955.806,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:6475",
              "position": {
                "x": -3389.87,
                "z": -2243.053
              },
              "distanceAlongShapeM": 2263.382,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:5620",
              "position": {
                "x": -3375.166,
                "z": -1991.724
              },
              "distanceAlongShapeM": 2517.467,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 3014.904,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 3495.158,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 3758.015,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 4254.358,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 4622.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 5374.046,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6460",
              "position": {
                "x": -4445.644,
                "z": 941.22
              },
              "distanceAlongShapeM": 5831.675,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6461",
              "position": {
                "x": -4154.055,
                "z": 1129.888
              },
              "distanceAlongShapeM": 6179.748,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6333",
              "position": {
                "x": -3596.615,
                "z": 1469.767
              },
              "distanceAlongShapeM": 6866.214,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:721",
              "position": {
                "x": -3293.772,
                "z": 2003.28
              },
              "distanceAlongShapeM": 7549.336,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 8175.75,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5535",
              "position": {
                "x": -2313.635,
                "z": 2045.055
              },
              "distanceAlongShapeM": 8773.459,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:7853",
              "position": {
                "x": -1868.675,
                "z": 1633.068
              },
              "distanceAlongShapeM": 9380.376,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6410",
              "position": {
                "x": -1654.972,
                "z": 1533.526
              },
              "distanceAlongShapeM": 9680.576,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6366",
              "position": {
                "x": -1299.013,
                "z": 1921.245
              },
              "distanceAlongShapeM": 10208.176,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6363",
              "position": {
                "x": -958.677,
                "z": 2010.875
              },
              "distanceAlongShapeM": 10623.201,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5166",
              "position": {
                "x": -470.051,
                "z": 1843.985
              },
              "distanceAlongShapeM": 11140.564,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5160",
              "position": {
                "x": 63.816,
                "z": 1754.143
              },
              "distanceAlongShapeM": 11692.123,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 12063.113,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            }
          ],
          "departuresSeconds": [
            18240,
            19380,
            20520,
            21660,
            22680,
            23160,
            23640,
            24300,
            24900,
            25500,
            26100,
            26820,
            27540,
            28440,
            29400,
            30000,
            30600,
            31440,
            32400,
            33000,
            33660,
            34320,
            35340,
            36660,
            37800,
            39060,
            40320,
            41460,
            42660,
            43860,
            45060,
            46320,
            47460,
            48780,
            49860,
            51060,
            51660,
            52320,
            52980,
            53640,
            54420,
            55080,
            55920,
            56580,
            57300,
            57840,
            58380,
            58920,
            59640,
            60360,
            61320,
            62400,
            63360,
            63960,
            64860,
            65940,
            67380,
            68820,
            69960,
            71220,
            72300,
            73620,
            75120,
            76260,
            77460,
            78600,
            80100,
            81600,
            83160
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_16:1",
          "sourceRouteId": "vilnius_trol_16",
          "sourceShapeId": "vilnius_trol_16_b-a",
          "directionId": 1,
          "headsign": "Pašilaičiai",
          "directionName": "Stotis–Lazdynai–Pašilaičiai",
          "mode": "trolleybus",
          "routeShortName": "16",
          "routeLongName": "Pašilaičiai–Lazdynai–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              373.827,
              1913.246,
              0
            ],
            [
              381.688,
              1919.781,
              10.224
            ],
            [
              390.297,
              1931.87,
              25.064
            ],
            [
              381.613,
              1950.953,
              46.03
            ],
            [
              374.681,
              1959.986,
              57.417
            ],
            [
              359.73,
              1989.203,
              90.237
            ],
            [
              357.312,
              1998.153,
              99.508
            ],
            [
              360.055,
              2007.009,
              108.778
            ],
            [
              365.317,
              2012.479,
              116.368
            ],
            [
              381.462,
              2013.297,
              132.534
            ],
            [
              469.575,
              1962.704,
              234.14
            ],
            [
              481.002,
              1952.475,
              249.475
            ],
            [
              482.211,
              1948,
              254.111
            ],
            [
              476.141,
              1933.639,
              269.702
            ],
            [
              470.194,
              1925.956,
              279.418
            ],
            [
              463.683,
              1922.735,
              286.682
            ],
            [
              447.558,
              1923.03,
              302.809
            ],
            [
              415.411,
              1929.184,
              335.541
            ],
            [
              398.6,
              1927.265,
              352.46
            ],
            [
              334.106,
              1822.687,
              475.327
            ],
            [
              318.606,
              1821.856,
              490.849
            ],
            [
              29.934,
              1735.835,
              792.065
            ],
            [
              -11.424,
              1732.135,
              833.588
            ],
            [
              -46.755,
              1740.57,
              869.912
            ],
            [
              -320.217,
              1781.157,
              1146.369
            ],
            [
              -550.531,
              1853.232,
              1387.698
            ],
            [
              -582.7,
              1858.267,
              1420.258
            ],
            [
              -596.688,
              1869.651,
              1438.294
            ],
            [
              -1032.712,
              2019.998,
              1899.511
            ],
            [
              -1048.212,
              2019.164,
              1915.033
            ],
            [
              -1075.687,
              2034.129,
              1946.319
            ],
            [
              -1134.042,
              2054.101,
              2007.998
            ],
            [
              -1154.642,
              2056.697,
              2028.761
            ],
            [
              -1164.417,
              2051.306,
              2039.924
            ],
            [
              -1208.37,
              2010.905,
              2099.624
            ],
            [
              -1267.715,
              1939.609,
              2192.387
            ],
            [
              -1394.1,
              1799.379,
              2381.166
            ],
            [
              -1411.426,
              1768.519,
              2416.557
            ],
            [
              -1434.923,
              1753.354,
              2444.523
            ],
            [
              -1515.962,
              1659.065,
              2568.852
            ],
            [
              -1594.12,
              1581.422,
              2679.021
            ],
            [
              -1692.298,
              1466.285,
              2830.333
            ],
            [
              -1701.366,
              1464.22,
              2839.634
            ],
            [
              -1708.441,
              1465.459,
              2846.816
            ],
            [
              -1712.191,
              1472.205,
              2854.534
            ],
            [
              -1970.62,
              1705.012,
              3202.363
            ],
            [
              -1985.783,
              1723.093,
              3225.96
            ],
            [
              -2263.842,
              1978.495,
              3603.513
            ],
            [
              -2290.557,
              2000.118,
              3637.883
            ],
            [
              -2318.992,
              2034.018,
              3682.129
            ],
            [
              -2425.036,
              2130.514,
              3825.506
            ],
            [
              -2441.629,
              2140.826,
              3845.043
            ],
            [
              -2453.884,
              2141.043,
              3857.3
            ],
            [
              -2464.869,
              2140.123,
              3868.323
            ],
            [
              -2491.57,
              2126.123,
              3898.472
            ],
            [
              -2514.888,
              2120.968,
              3922.353
            ],
            [
              -2528.453,
              2120.094,
              3935.946
            ],
            [
              -2551.595,
              2124.955,
              3959.593
            ],
            [
              -2561.836,
              2129.588,
              3970.834
            ],
            [
              -2579.681,
              2142.148,
              3992.655
            ],
            [
              -2607.297,
              2186.05,
              4044.52
            ],
            [
              -2618.809,
              2191.819,
              4057.397
            ],
            [
              -2640.075,
              2193.306,
              4078.715
            ],
            [
              -2665.388,
              2184.846,
              4105.404
            ],
            [
              -2681.67,
              2176.227,
              4123.827
            ],
            [
              -2690.837,
              2168.596,
              4135.755
            ],
            [
              -2738.119,
              2158.296,
              4184.145
            ],
            [
              -2899.782,
              2101.023,
              4355.654
            ],
            [
              -2971.67,
              2085.586,
              4429.181
            ],
            [
              -3158.032,
              2017.605,
              4627.554
            ],
            [
              -3215.258,
              1991.889,
              4690.293
            ],
            [
              -3240.098,
              1973.399,
              4721.26
            ],
            [
              -3275.786,
              1961.777,
              4758.793
            ],
            [
              -3353.278,
              1920.828,
              4846.438
            ],
            [
              -3402.898,
              1887.184,
              4906.388
            ],
            [
              -3447.61,
              1838.983,
              4972.134
            ],
            [
              -3464.825,
              1813.679,
              5002.739
            ],
            [
              -3479.576,
              1781.653,
              5037.999
            ],
            [
              -3552.495,
              1521.32,
              5308.351
            ],
            [
              -3555.031,
              1486.855,
              5342.91
            ],
            [
              -3569.097,
              1457.043,
              5375.873
            ],
            [
              -3608.386,
              1386.482,
              5456.636
            ],
            [
              -3647.326,
              1335.952,
              5520.429
            ],
            [
              -3697.872,
              1285.623,
              5591.759
            ],
            [
              -3750.727,
              1250.919,
              5654.988
            ],
            [
              -3785.215,
              1233.706,
              5693.533
            ],
            [
              -3881.236,
              1201.976,
              5794.661
            ],
            [
              -3947.947,
              1186.435,
              5863.159
            ],
            [
              -4028.355,
              1162.223,
              5947.132
            ],
            [
              -4081.657,
              1138.655,
              6005.413
            ],
            [
              -4117.491,
              1118.124,
              6046.711
            ],
            [
              -4156.018,
              1090.96,
              6093.852
            ],
            [
              -4168.309,
              1088.946,
              6106.307
            ],
            [
              -4405.115,
              934.956,
              6388.778
            ],
            [
              -4421.523,
              918.541,
              6411.987
            ],
            [
              -4433.169,
              916.515,
              6423.808
            ],
            [
              -4463.138,
              899.22,
              6458.409
            ],
            [
              -4519.455,
              850.095,
              6533.141
            ],
            [
              -4559.388,
              778.424,
              6615.186
            ],
            [
              -4567.189,
              737.369,
              6656.975
            ],
            [
              -4562.176,
              653.793,
              6740.702
            ],
            [
              -4542.083,
              471.996,
              6923.606
            ],
            [
              -4530.426,
              437.286,
              6960.221
            ],
            [
              -4533.311,
              419.524,
              6978.216
            ],
            [
              -4527.744,
              368.221,
              7029.82
            ],
            [
              -4516.259,
              323.495,
              7075.996
            ],
            [
              -4491.638,
              255.166,
              7148.626
            ],
            [
              -4427.619,
              152.763,
              7269.394
            ],
            [
              -4367.011,
              77.134,
              7366.312
            ],
            [
              -4077.229,
              -208.399,
              7773.132
            ],
            [
              -3954.469,
              -380.846,
              7984.811
            ],
            [
              -3921.604,
              -419.265,
              8035.369
            ],
            [
              -3917.323,
              -432.698,
              8049.468
            ],
            [
              -3857.936,
              -540.596,
              8172.63
            ],
            [
              -3823.641,
              -607.984,
              8248.242
            ],
            [
              -3766.483,
              -732.543,
              8385.29
            ],
            [
              -3707.64,
              -908.34,
              8570.673
            ],
            [
              -3695.741,
              -928.584,
              8594.156
            ],
            [
              -3679.35,
              -950.021,
              8621.14
            ],
            [
              -3673.878,
              -969.04,
              8640.931
            ],
            [
              -3654.555,
              -1007.226,
              8683.728
            ],
            [
              -3618.236,
              -1069.084,
              8755.46
            ],
            [
              -3599.031,
              -1113.947,
              8804.261
            ],
            [
              -3569.469,
              -1193.5,
              8889.129
            ],
            [
              -3554.873,
              -1243.849,
              8941.551
            ],
            [
              -3543.073,
              -1269.659,
              8969.93
            ],
            [
              -3520.478,
              -1415.883,
              9117.89
            ],
            [
              -3500.646,
              -1498.607,
              9202.958
            ],
            [
              -3461.302,
              -1608.388,
              9319.576
            ],
            [
              -3438.975,
              -1658.872,
              9374.777
            ],
            [
              -3418.974,
              -1694.844,
              9415.936
            ],
            [
              -3409.362,
              -1735.088,
              9457.311
            ],
            [
              -3353.575,
              -1899.704,
              9631.124
            ],
            [
              -3340.35,
              -1954.483,
              9687.476
            ],
            [
              -3339.232,
              -2037.994,
              9770.994
            ],
            [
              -3345.53,
              -2177.035,
              9910.179
            ],
            [
              -3368.406,
              -2305.768,
              10040.928
            ],
            [
              -3372.034,
              -2365.819,
              10101.088
            ],
            [
              -3365.898,
              -2420.473,
              10156.086
            ],
            [
              -3338.206,
              -2495.543,
              10236.1
            ],
            [
              -3294.464,
              -2574.233,
              10326.131
            ],
            [
              -3256.485,
              -2613.86,
              10381.019
            ],
            [
              -3240.415,
              -2653.104,
              10423.426
            ],
            [
              -3181.544,
              -2750.984,
              10537.646
            ],
            [
              -3157.274,
              -2800.391,
              10592.692
            ],
            [
              -3108.891,
              -2944.844,
              10745.033
            ],
            [
              -3088.313,
              -3020.904,
              10823.827
            ],
            [
              -3080.894,
              -3038.845,
              10843.242
            ],
            [
              -3066.407,
              -3094.76,
              10901.003
            ],
            [
              -3053.229,
              -3115.03,
              10925.179
            ],
            [
              -3044.503,
              -3168.617,
              10979.473
            ],
            [
              -2983.753,
              -3378.969,
              11198.421
            ],
            [
              -2968.741,
              -3404.837,
              11228.329
            ],
            [
              -2964.33,
              -3447.216,
              11270.938
            ],
            [
              -2935.834,
              -3585.756,
              11412.379
            ],
            [
              -2926.739,
              -3654.936,
              11482.153
            ],
            [
              -2914.467,
              -3799.87,
              11627.606
            ],
            [
              -2906.719,
              -3835.629,
              11664.195
            ],
            [
              -2909.141,
              -3863.417,
              11692.089
            ],
            [
              -2921.12,
              -4178.248,
              12007.147
            ],
            [
              -2914.524,
              -4206.195,
              12035.861
            ],
            [
              -2917.063,
              -4240.66,
              12070.42
            ],
            [
              -2899.032,
              -4314.449,
              12146.381
            ],
            [
              -2865.992,
              -4377.371,
              12217.45
            ],
            [
              -2823.799,
              -4432.662,
              12287
            ],
            [
              -2835.666,
              -4448.038,
              12306.424
            ],
            [
              -2850.052,
              -4460.03,
              12325.152
            ],
            [
              -2854.56,
              -4459.951,
              12329.661
            ],
            [
              -2897.378,
              -4403.536,
              12400.485
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:3616",
              "position": {
                "x": 373.827,
                "z": 1913.246
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6650",
              "position": {
                "x": -11.424,
                "z": 1732.135
              },
              "distanceAlongShapeM": 833.588,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5167",
              "position": {
                "x": -582.7,
                "z": 1858.267
              },
              "distanceAlongShapeM": 1420.258,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6362",
              "position": {
                "x": -1048.212,
                "z": 2019.164
              },
              "distanceAlongShapeM": 1915.033,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6365",
              "position": {
                "x": -1411.426,
                "z": 1768.519
              },
              "distanceAlongShapeM": 2416.557,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7852",
              "position": {
                "x": -1970.62,
                "z": 1705.012
              },
              "distanceAlongShapeM": 3202.363,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5532",
              "position": {
                "x": -2290.557,
                "z": 2000.118
              },
              "distanceAlongShapeM": 3637.883,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 4135.755,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:720",
              "position": {
                "x": -3240.098,
                "z": 1973.399
              },
              "distanceAlongShapeM": 4721.26,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:790",
              "position": {
                "x": -3555.031,
                "z": 1486.855
              },
              "distanceAlongShapeM": 5342.91,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6648",
              "position": {
                "x": -4156.018,
                "z": 1090.96
              },
              "distanceAlongShapeM": 6093.852,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6462",
              "position": {
                "x": -4421.523,
                "z": 918.541
              },
              "distanceAlongShapeM": 6411.987,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 6960.221,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 7773.132,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 8035.369,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 8621.14,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 8969.93,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5722",
              "position": {
                "x": -3418.974,
                "z": -1694.844
              },
              "distanceAlongShapeM": 9415.936,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6472",
              "position": {
                "x": -3345.53,
                "z": -2177.035
              },
              "distanceAlongShapeM": 9910.179,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            },
            {
              "stopId": "judu:stop:6651",
              "position": {
                "x": -3256.485,
                "z": -2613.86
              },
              "distanceAlongShapeM": 10381.019,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 10925.179,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:6479",
              "position": {
                "x": -2968.741,
                "z": -3404.837
              },
              "distanceAlongShapeM": 11228.329,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 11664.195,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 12035.861,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:8275",
              "position": {
                "x": -2897.378,
                "z": -4403.536
              },
              "distanceAlongShapeM": 12400.485,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            }
          ],
          "departuresSeconds": [
            18840,
            20700,
            21840,
            22980,
            24180,
            25200,
            25800,
            26400,
            27060,
            27720,
            28320,
            28920,
            29640,
            30360,
            31200,
            32160,
            32760,
            33420,
            34260,
            35220,
            35820,
            36480,
            37080,
            38040,
            39300,
            40500,
            41760,
            43020,
            44100,
            45360,
            46560,
            47760,
            49020,
            50160,
            51540,
            52620,
            53820,
            54420,
            55080,
            55740,
            56460,
            57180,
            57840,
            58680,
            59340,
            60180,
            60720,
            61260,
            61740,
            62460,
            63180,
            64140,
            65220,
            66180,
            66780,
            67680,
            68760,
            70020,
            71400,
            72480,
            73740,
            74820,
            76140,
            77640,
            78780,
            79980,
            81060,
            82560,
            84000
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_17",
      "sourceRouteId": "vilnius_trol_17",
      "mode": "trolleybus",
      "shortName": "17",
      "longName": "Žirmūnai–Naujininkai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_17:0",
          "sourceRouteId": "vilnius_trol_17",
          "sourceShapeId": "vilnius_trol_17_a-b",
          "directionId": 0,
          "headsign": "Naujininkai",
          "directionName": "Žirmūnai–Naujininkai",
          "mode": "trolleybus",
          "routeShortName": "17",
          "routeLongName": "Žirmūnai–Naujininkai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1016.673,
              -4299.303,
              0
            ],
            [
              1017.645,
              -4281.509,
              17.821
            ],
            [
              1022.257,
              -4276.027,
              24.984
            ],
            [
              1106.613,
              -4278.698,
              109.382
            ],
            [
              1128.033,
              -4270.188,
              132.431
            ],
            [
              1147.356,
              -4270.545,
              151.757
            ],
            [
              1188.702,
              -4264.63,
              193.524
            ],
            [
              1202.517,
              -4249.3,
              214.16
            ],
            [
              1214.522,
              -4227.257,
              239.261
            ],
            [
              1220.978,
              -4191.753,
              275.347
            ],
            [
              1217.195,
              -3943.429,
              523.7
            ],
            [
              1219.986,
              -3862.213,
              604.964
            ],
            [
              1375.611,
              -3774.922,
              783.398
            ],
            [
              1393.375,
              -3755.212,
              809.932
            ],
            [
              1412.221,
              -3746.656,
              830.629
            ],
            [
              1509.056,
              -3563.653,
              1037.673
            ],
            [
              1556.885,
              -3486.613,
              1128.352
            ],
            [
              1607.644,
              -3390.704,
              1236.865
            ],
            [
              1620.009,
              -3384.254,
              1250.811
            ],
            [
              1689.847,
              -3267.548,
              1386.817
            ],
            [
              1697.306,
              -3247.648,
              1408.069
            ],
            [
              1696.944,
              -3128.524,
              1527.194
            ],
            [
              1687.839,
              -3098.296,
              1558.763
            ],
            [
              1693.427,
              -3075.022,
              1582.698
            ],
            [
              1690.731,
              -2873.474,
              1784.265
            ],
            [
              1684.353,
              -2661.838,
              1995.997
            ],
            [
              1677.945,
              -2590.471,
              2067.651
            ],
            [
              1676.674,
              -2554.823,
              2103.321
            ],
            [
              1670.083,
              -2527.983,
              2130.959
            ],
            [
              1679.06,
              -2495.866,
              2164.307
            ],
            [
              1670.601,
              -2049.296,
              2610.957
            ],
            [
              1665.105,
              -1963.474,
              2696.955
            ],
            [
              1665.702,
              -1896.69,
              2763.741
            ],
            [
              1663.09,
              -1759.712,
              2900.744
            ],
            [
              1653.419,
              -1725.022,
              2936.757
            ],
            [
              1660.464,
              -1692.869,
              2969.673
            ],
            [
              1642.718,
              -1572.308,
              3091.532
            ],
            [
              1626.598,
              -1502.988,
              3162.702
            ],
            [
              1590.763,
              -1384.318,
              3286.665
            ],
            [
              1541.473,
              -1260.946,
              3419.518
            ],
            [
              1439.941,
              -1068.699,
              3636.93
            ],
            [
              1418.417,
              -1047.149,
              3667.388
            ],
            [
              1413.029,
              -1024.784,
              3690.392
            ],
            [
              1381.79,
              -970.77,
              3752.79
            ],
            [
              1372.327,
              -959.462,
              3767.534
            ],
            [
              1333.941,
              -943.166,
              3809.236
            ],
            [
              1307.513,
              -942.677,
              3835.668
            ],
            [
              1293.291,
              -944.641,
              3850.025
            ],
            [
              1278.507,
              -942.141,
              3865.019
            ],
            [
              1268.297,
              -936.386,
              3876.74
            ],
            [
              1257.545,
              -925.054,
              3892.36
            ],
            [
              1249.597,
              -901.529,
              3917.192
            ],
            [
              1249.57,
              -868.132,
              3950.589
            ],
            [
              1251.689,
              -858.152,
              3960.792
            ],
            [
              1256.345,
              -850.445,
              3969.796
            ],
            [
              1271.438,
              -836.252,
              3990.514
            ],
            [
              1287.032,
              -829.861,
              4007.367
            ],
            [
              1306.39,
              -829.106,
              4026.74
            ],
            [
              1381.451,
              -814.909,
              4103.131
            ],
            [
              1598.931,
              -666.427,
              4366.465
            ],
            [
              1632.324,
              -639.216,
              4409.54
            ],
            [
              1644.195,
              -624.964,
              4428.089
            ],
            [
              1650.286,
              -609.492,
              4444.717
            ],
            [
              1647.435,
              -589.4,
              4465.01
            ],
            [
              1641.361,
              -569.249,
              4486.057
            ],
            [
              1626.241,
              -550.043,
              4510.5
            ],
            [
              1608.96,
              -543.043,
              4529.145
            ],
            [
              1227.773,
              -233.181,
              5020.386
            ],
            [
              1060.09,
              -128.781,
              5217.913
            ],
            [
              1042.305,
              -113.981,
              5241.051
            ],
            [
              992.552,
              -84.12,
              5299.077
            ],
            [
              920.398,
              -44.941,
              5381.182
            ],
            [
              797.689,
              -19.306,
              5506.54
            ],
            [
              670.384,
              1.958,
              5635.608
            ],
            [
              652.936,
              0.051,
              5653.16
            ],
            [
              630.873,
              -7.336,
              5676.427
            ],
            [
              604.636,
              -31.346,
              5711.993
            ],
            [
              564.962,
              -49.544,
              5755.641
            ],
            [
              476.44,
              -129.188,
              5874.718
            ],
            [
              402.286,
              -199.078,
              5976.617
            ],
            [
              346.776,
              -237.026,
              6043.858
            ],
            [
              281.176,
              -262.545,
              6114.247
            ],
            [
              119.684,
              -277.409,
              6276.422
            ],
            [
              35.151,
              -280.322,
              6361.005
            ],
            [
              -101.904,
              -298.979,
              6499.324
            ],
            [
              -140.08,
              -306.078,
              6538.155
            ],
            [
              -153.095,
              -312.52,
              6552.677
            ],
            [
              -191.836,
              -315.156,
              6591.507
            ],
            [
              -244.276,
              -326.45,
              6645.149
            ],
            [
              -305.298,
              -348.72,
              6710.108
            ],
            [
              -413.017,
              -421.354,
              6840.028
            ],
            [
              -450.326,
              -380.602,
              6895.279
            ],
            [
              -465.596,
              -369.193,
              6914.341
            ],
            [
              -470.512,
              -355.745,
              6928.659
            ],
            [
              -508.466,
              -314.982,
              6984.356
            ],
            [
              -611.52,
              -58.189,
              7261.055
            ],
            [
              -615.308,
              -53.668,
              7266.954
            ],
            [
              -625.745,
              -24.535,
              7297.899
            ],
            [
              -646.921,
              17.037,
              7344.554
            ],
            [
              -652.524,
              63.893,
              7391.745
            ],
            [
              -679.973,
              222.467,
              7552.677
            ],
            [
              -691.721,
              250.51,
              7583.081
            ],
            [
              -832.714,
              443.415,
              7822.019
            ],
            [
              -840.816,
              459.146,
              7839.714
            ],
            [
              -843.214,
              469.208,
              7850.058
            ],
            [
              -842.813,
              491.465,
              7872.319
            ],
            [
              -833.842,
              667.193,
              8048.275
            ],
            [
              -824.942,
              731.6,
              8113.294
            ],
            [
              -800.789,
              819.11,
              8204.076
            ],
            [
              -793.638,
              857.944,
              8243.563
            ],
            [
              -767.948,
              887.538,
              8282.752
            ],
            [
              -708.773,
              1021.171,
              8428.901
            ],
            [
              -697.048,
              1063.262,
              8472.594
            ],
            [
              -655.787,
              1240.633,
              8654.702
            ],
            [
              -656.233,
              1287.397,
              8701.467
            ],
            [
              -631.67,
              1361.539,
              8779.573
            ],
            [
              -535.917,
              1805.1,
              9233.351
            ],
            [
              -511.654,
              1933.795,
              9364.313
            ],
            [
              -496.901,
              1964.699,
              9398.558
            ],
            [
              -462.075,
              2106.562,
              9544.633
            ],
            [
              -436.719,
              2188.482,
              9630.387
            ],
            [
              -427.991,
              2207.248,
              9651.084
            ],
            [
              -344.32,
              2338.207,
              9806.491
            ],
            [
              -326.137,
              2380.181,
              9852.233
            ],
            [
              -285.296,
              2533.066,
              10010.479
            ],
            [
              -290.153,
              2585.475,
              10063.113
            ],
            [
              -278.461,
              2625.339,
              10104.657
            ],
            [
              -246.605,
              2887.483,
              10368.729
            ],
            [
              -243.843,
              2897.452,
              10379.074
            ],
            [
              -220.477,
              2904.821,
              10403.574
            ],
            [
              -210.175,
              2903.521,
              10413.957
            ],
            [
              -203.362,
              2887.812,
              10431.08
            ],
            [
              -196.145,
              2858.737,
              10461.037
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 132.431,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 809.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 1236.865,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 1558.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 2130.959,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 2936.757,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 3667.388,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 4529.145,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 5217.913,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 5711.993,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5249",
              "position": {
                "x": -153.095,
                "z": -312.52
              },
              "distanceAlongShapeM": 6552.677,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5257",
              "position": {
                "x": -465.596,
                "z": -369.193
              },
              "distanceAlongShapeM": 6914.341,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5264",
              "position": {
                "x": -646.921,
                "z": 17.037
              },
              "distanceAlongShapeM": 7344.554,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5266",
              "position": {
                "x": -793.638,
                "z": 857.944
              },
              "distanceAlongShapeM": 8243.563,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5272",
              "position": {
                "x": -656.233,
                "z": 1287.397
              },
              "distanceAlongShapeM": 8701.467,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7851",
              "position": {
                "x": -511.654,
                "z": 1933.795
              },
              "distanceAlongShapeM": 9364.313,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5173",
              "position": {
                "x": -290.153,
                "z": 2585.475
              },
              "distanceAlongShapeM": 10063.113,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 10461.037,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            18120,
            18960,
            19620,
            20400,
            21240,
            22080,
            22800,
            23400,
            24120,
            24600,
            25200,
            25860,
            26460,
            27240,
            28080,
            29220,
            30360,
            31560,
            32400,
            33240,
            34020,
            34920,
            35700,
            36480,
            37320,
            38220,
            39120,
            39900,
            40740,
            41520,
            42360,
            43200,
            44100,
            44940,
            45780,
            46560,
            47400,
            48240,
            49080,
            49980,
            50940,
            51840,
            52560,
            53460,
            54360,
            55320,
            56100,
            56640,
            57180,
            57720,
            58380,
            59040,
            59880,
            60900,
            61980,
            62820,
            63660,
            64680,
            65940,
            67260,
            68100,
            68940,
            69780,
            70680,
            71580,
            72420,
            73320,
            74100,
            74880,
            75600,
            76440,
            77280,
            78300,
            79500,
            80400,
            81420,
            82860
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_17:1",
          "sourceRouteId": "vilnius_trol_17",
          "sourceShapeId": "vilnius_trol_17_b-a",
          "directionId": 1,
          "headsign": "Žirmūnai",
          "directionName": "Naujininkai–Žirmūnai",
          "mode": "trolleybus",
          "routeShortName": "17",
          "routeLongName": "Žirmūnai–Naujininkai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -196.145,
              2858.737,
              0
            ],
            [
              -195.763,
              2844.258,
              14.484
            ],
            [
              -203.04,
              2834.371,
              26.761
            ],
            [
              -247.856,
              2818.486,
              74.308
            ],
            [
              -266.588,
              2603.973,
              289.638
            ],
            [
              -287.151,
              2501.929,
              393.733
            ],
            [
              -327.226,
              2355.709,
              545.345
            ],
            [
              -350.367,
              2324.958,
              583.83
            ],
            [
              -412.128,
              2228.113,
              698.693
            ],
            [
              -425.492,
              2202.75,
              727.361
            ],
            [
              -439.803,
              2160.707,
              771.773
            ],
            [
              -445.668,
              2121.85,
              811.07
            ],
            [
              -471.768,
              2034.377,
              902.354
            ],
            [
              -499.661,
              1919.106,
              1020.952
            ],
            [
              -508.548,
              1855.813,
              1084.866
            ],
            [
              -515.259,
              1841.463,
              1100.708
            ],
            [
              -529.526,
              1766.021,
              1177.487
            ],
            [
              -536.862,
              1752.795,
              1192.611
            ],
            [
              -542.324,
              1736.195,
              1210.086
            ],
            [
              -601.244,
              1474.539,
              1478.295
            ],
            [
              -678.532,
              1124.155,
              1837.101
            ],
            [
              -679.739,
              1093.006,
              1868.273
            ],
            [
              -691.829,
              1066.507,
              1897.4
            ],
            [
              -722.413,
              980.227,
              1988.94
            ],
            [
              -789.726,
              824.476,
              2158.615
            ],
            [
              -808.22,
              764.696,
              2221.191
            ],
            [
              -810.251,
              723.543,
              2262.393
            ],
            [
              -824.878,
              699.315,
              2290.694
            ],
            [
              -838.2,
              496.948,
              2493.499
            ],
            [
              -838.156,
              463.551,
              2526.897
            ],
            [
              -823.183,
              435.45,
              2558.737
            ],
            [
              -689.041,
              256.028,
              2782.761
            ],
            [
              -671.067,
              215.627,
              2826.979
            ],
            [
              -634.631,
              19.041,
              3026.913
            ],
            [
              -585.127,
              -96.516,
              3152.628
            ],
            [
              -570.097,
              -121.279,
              3181.595
            ],
            [
              -567.275,
              -143.594,
              3204.088
            ],
            [
              -513.161,
              -289.293,
              3359.512
            ],
            [
              -501.093,
              -299.53,
              3375.337
            ],
            [
              -461.426,
              -352.57,
              3441.569
            ],
            [
              -449.339,
              -361.695,
              3456.714
            ],
            [
              -413.017,
              -421.354,
              3526.56
            ],
            [
              -305.298,
              -348.72,
              3656.479
            ],
            [
              -203.339,
              -309.381,
              3765.765
            ],
            [
              -102.285,
              -284.5,
              3869.836
            ],
            [
              -50.388,
              -267.632,
              3924.406
            ],
            [
              -22.626,
              -265.911,
              3952.22
            ],
            [
              -0.545,
              -257.407,
              3975.882
            ],
            [
              58.367,
              -209.498,
              4051.816
            ],
            [
              82.464,
              -196.578,
              4079.158
            ],
            [
              94.753,
              -194.576,
              4091.61
            ],
            [
              103.738,
              -196.966,
              4100.907
            ],
            [
              115.784,
              -208.318,
              4117.459
            ],
            [
              119.866,
              -267.394,
              4176.676
            ],
            [
              241.125,
              -266.267,
              4297.94
            ],
            [
              291.552,
              -259.395,
              4348.833
            ],
            [
              357.234,
              -229.425,
              4421.029
            ],
            [
              436.36,
              -169.644,
              4520.199
            ],
            [
              541.549,
              -60.247,
              4671.963
            ],
            [
              554.165,
              -40.44,
              4695.447
            ],
            [
              588.702,
              -21.035,
              4735.062
            ],
            [
              628.519,
              4.952,
              4782.609
            ],
            [
              645.363,
              9.096,
              4799.956
            ],
            [
              675.04,
              9.665,
              4829.638
            ],
            [
              707.88,
              6.836,
              4862.599
            ],
            [
              925.597,
              -42.81,
              5085.905
            ],
            [
              1129.224,
              -156.774,
              5319.254
            ],
            [
              1143.99,
              -160.386,
              5334.456
            ],
            [
              1610.786,
              -514.132,
              5920.148
            ],
            [
              1615.737,
              -525.357,
              5932.415
            ],
            [
              1648.803,
              -550.462,
              5973.933
            ],
            [
              1662.944,
              -552.951,
              5988.291
            ],
            [
              1683.01,
              -548.871,
              6008.767
            ],
            [
              1706.196,
              -550.415,
              6032.005
            ],
            [
              1713.204,
              -554.998,
              6040.379
            ],
            [
              1719.444,
              -566.247,
              6053.242
            ],
            [
              1721.402,
              -599.681,
              6086.733
            ],
            [
              1716.683,
              -610.725,
              6098.744
            ],
            [
              1706.848,
              -619.449,
              6111.89
            ],
            [
              1700.984,
              -622.679,
              6118.584
            ],
            [
              1684.224,
              -622.368,
              6135.347
            ],
            [
              1662.848,
              -627.537,
              6157.339
            ],
            [
              1583.13,
              -683.945,
              6254.996
            ],
            [
              1381.451,
              -814.909,
              6495.466
            ],
            [
              1363.471,
              -845.747,
              6531.164
            ],
            [
              1362.208,
              -879.121,
              6564.561
            ],
            [
              1367.85,
              -922.642,
              6608.447
            ],
            [
              1384.491,
              -964.14,
              6653.157
            ],
            [
              1464.439,
              -1103.664,
              6813.962
            ],
            [
              1480.223,
              -1121.768,
              6837.981
            ],
            [
              1488.813,
              -1145.306,
              6863.037
            ],
            [
              1537.374,
              -1238.606,
              6968.218
            ],
            [
              1587.871,
              -1366.453,
              7105.677
            ],
            [
              1626.598,
              -1502.988,
              7247.598
            ],
            [
              1647.564,
              -1589.097,
              7336.223
            ],
            [
              1670.179,
              -1759.844,
              7508.461
            ],
            [
              1676.751,
              -1787.797,
              7537.176
            ],
            [
              1672.408,
              -1813.321,
              7563.067
            ],
            [
              1677.37,
              -1962.589,
              7712.417
            ],
            [
              1684.587,
              -2475.93,
              8225.809
            ],
            [
              1691.063,
              -2612.98,
              8363.012
            ],
            [
              1696.386,
              -2638.684,
              8389.261
            ],
            [
              1690.652,
              -2669.748,
              8420.85
            ],
            [
              1690.731,
              -2873.474,
              8624.576
            ],
            [
              1700.851,
              -3126.37,
              8877.674
            ],
            [
              1709.563,
              -3177.741,
              8929.779
            ],
            [
              1701.896,
              -3208.77,
              8961.741
            ],
            [
              1697.306,
              -3247.648,
              9000.889
            ],
            [
              1679.831,
              -3286.287,
              9043.296
            ],
            [
              1593.247,
              -3437.193,
              9217.276
            ],
            [
              1582.257,
              -3473.726,
              9255.427
            ],
            [
              1566.424,
              -3493.47,
              9280.735
            ],
            [
              1509.807,
              -3592.611,
              9394.904
            ],
            [
              1412.221,
              -3746.656,
              9577.257
            ],
            [
              1401.002,
              -3760.92,
              9595.405
            ],
            [
              1342.825,
              -3805.485,
              9668.689
            ],
            [
              1325.974,
              -3810.739,
              9686.341
            ],
            [
              1219.986,
              -3862.213,
              9804.167
            ],
            [
              1220.734,
              -4100.462,
              10042.417
            ],
            [
              1228.325,
              -4142.906,
              10085.534
            ],
            [
              1222.034,
              -4169.508,
              10112.87
            ],
            [
              1223.554,
              -4191.801,
              10135.214
            ],
            [
              1219.757,
              -4222.901,
              10166.546
            ],
            [
              1209.725,
              -4242.754,
              10188.79
            ],
            [
              1201.125,
              -4254.841,
              10203.624
            ],
            [
              1180.185,
              -4272.266,
              10230.866
            ],
            [
              1169.776,
              -4277.639,
              10242.58
            ],
            [
              1151.036,
              -4280.633,
              10261.558
            ],
            [
              1136.221,
              -4280.359,
              10276.375
            ],
            [
              1097.226,
              -4298.563,
              10319.41
            ],
            [
              1061.102,
              -4335.747,
              10371.252
            ],
            [
              1050.796,
              -4335.556,
              10381.559
            ],
            [
              1023.347,
              -4321.691,
              10412.312
            ],
            [
              1017.05,
              -4313.782,
              10422.421
            ],
            [
              1016.673,
              -4299.303,
              10436.905
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5200",
              "position": {
                "x": -196.145,
                "z": 2858.737
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -420,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6854",
              "position": {
                "x": -266.588,
                "z": 2603.973
              },
              "distanceAlongShapeM": 289.638,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5168",
              "position": {
                "x": -529.526,
                "z": 1766.021
              },
              "distanceAlongShapeM": 1177.487,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 270,
              "departureOffsetSeconds": 270
            },
            {
              "stopId": "judu:stop:6853",
              "position": {
                "x": -679.739,
                "z": 1093.006
              },
              "distanceAlongShapeM": 1868.273,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 390,
              "departureOffsetSeconds": 390
            },
            {
              "stopId": "judu:stop:5267",
              "position": {
                "x": -810.251,
                "z": 723.543
              },
              "distanceAlongShapeM": 2262.393,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 510,
              "departureOffsetSeconds": 510
            },
            {
              "stopId": "judu:stop:6736",
              "position": {
                "x": -570.097,
                "z": -121.279
              },
              "distanceAlongShapeM": 3181.595,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 690,
              "departureOffsetSeconds": 690
            },
            {
              "stopId": "judu:stop:5258",
              "position": {
                "x": -449.339,
                "z": -361.695
              },
              "distanceAlongShapeM": 3456.714,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 750,
              "departureOffsetSeconds": 750
            },
            {
              "stopId": "judu:stop:5248",
              "position": {
                "x": -50.388,
                "z": -267.632
              },
              "distanceAlongShapeM": 3924.406,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 4862.599,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 5334.456,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 5920.148,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 6837.981,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 7537.176,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 8389.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 8929.779,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 9255.427,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 9668.689,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 10085.534,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 10261.558,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            }
          ],
          "departuresSeconds": [
            20700,
            21660,
            22380,
            23340,
            24060,
            24960,
            25740,
            26340,
            27120,
            27780,
            28500,
            29100,
            29700,
            30480,
            31320,
            32460,
            33480,
            34500,
            35400,
            36240,
            37020,
            37800,
            38580,
            39360,
            40140,
            41100,
            42000,
            42780,
            43620,
            44400,
            45240,
            46140,
            47100,
            47880,
            48900,
            49500,
            50340,
            51240,
            52200,
            53100,
            53880,
            54780,
            55560,
            56400,
            57420,
            58500,
            59280,
            59880,
            60420,
            61140,
            61740,
            62520,
            63420,
            64320,
            65400,
            66300,
            67200,
            68220,
            69240,
            70260,
            71100,
            71880,
            72720,
            73560,
            74400,
            75240,
            76080,
            76860,
            77640,
            78480,
            79440,
            80400,
            81240,
            82200,
            83040,
            84000
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_18",
      "sourceRouteId": "vilnius_trol_18",
      "mode": "trolleybus",
      "shortName": "18",
      "longName": "Perkūnkiemis–Justiniškės–Žemieji Paneriai–Titnago g.",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_18:0",
          "sourceRouteId": "vilnius_trol_18",
          "sourceShapeId": "vilnius_trol_18_a-b",
          "directionId": 0,
          "headsign": "Titnago g.",
          "directionName": "Perkūnkiemis–Justiniškės–Žemieji Paneriai–Titnago g.",
          "mode": "trolleybus",
          "routeShortName": "18",
          "routeLongName": "Perkūnkiemis–Justiniškės–Žemieji Paneriai–Titnago g.",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -3921.595,
              -5098.093,
              0
            ],
            [
              -3918.942,
              -5093.687,
              5.144
            ],
            [
              -3911.137,
              -5089.369,
              14.063
            ],
            [
              -3894.999,
              -5087.423,
              30.318
            ],
            [
              -3881.494,
              -5088.771,
              43.89
            ],
            [
              -3870.508,
              -5086.736,
              55.063
            ],
            [
              -3858.762,
              -5078.034,
              69.681
            ],
            [
              -3854.099,
              -5069.209,
              79.662
            ],
            [
              -3845.592,
              -5061.565,
              91.099
            ],
            [
              -3838.726,
              -5037.193,
              116.419
            ],
            [
              -3828.914,
              -4880.4,
              273.519
            ],
            [
              -3839.647,
              -4756.647,
              397.737
            ],
            [
              -3856.989,
              -4679.534,
              476.776
            ],
            [
              -3893.073,
              -4568.698,
              593.338
            ],
            [
              -3919.183,
              -4476.961,
              688.718
            ],
            [
              -3925.083,
              -4445.689,
              720.542
            ],
            [
              -3938.125,
              -4417.632,
              751.482
            ],
            [
              -3934.344,
              -4385.414,
              783.921
            ],
            [
              -3933.945,
              -4325.308,
              844.029
            ],
            [
              -3923.556,
              -4246.45,
              923.568
            ],
            [
              -3863.253,
              -4076.062,
              1104.312
            ],
            [
              -3846.667,
              -4048.52,
              1136.463
            ],
            [
              -3724.705,
              -3815.753,
              1399.247
            ],
            [
              -3681.09,
              -3716.323,
              1507.822
            ],
            [
              -3652.775,
              -3644.457,
              1585.065
            ],
            [
              -3636.19,
              -3580.18,
              1651.447
            ],
            [
              -3633.854,
              -3520.107,
              1711.566
            ],
            [
              -3624.82,
              -3482.415,
              1750.325
            ],
            [
              -3626.214,
              -3414.484,
              1818.27
            ],
            [
              -3629.537,
              -3383.256,
              1849.674
            ],
            [
              -3641.883,
              -3315.135,
              1918.905
            ],
            [
              -3659.519,
              -3254.715,
              1981.847
            ],
            [
              -3681.569,
              -3188.651,
              2051.493
            ],
            [
              -3706.235,
              -3124.768,
              2119.972
            ],
            [
              -3740.623,
              -3064.057,
              2189.747
            ],
            [
              -3746.718,
              -3043.913,
              2210.792
            ],
            [
              -3749.61,
              -3024.938,
              2229.986
            ],
            [
              -3794.804,
              -2918.397,
              2345.717
            ],
            [
              -3982.054,
              -2455.389,
              2845.155
            ],
            [
              -4002.758,
              -2422.747,
              2883.809
            ],
            [
              -4007.392,
              -2392.61,
              2914.3
            ],
            [
              -4034.259,
              -2306.427,
              3004.574
            ],
            [
              -4048.116,
              -2250.527,
              3062.166
            ],
            [
              -4058.635,
              -2188.005,
              3125.567
            ],
            [
              -4065.192,
              -2119.986,
              3193.902
            ],
            [
              -4071.681,
              -2010.779,
              3303.301
            ],
            [
              -4063.29,
              -1898.49,
              3415.903
            ],
            [
              -4045.475,
              -1837.572,
              3479.373
            ],
            [
              -4006.94,
              -1771.447,
              3555.907
            ],
            [
              -3981.93,
              -1741.824,
              3594.676
            ],
            [
              -3941.981,
              -1705.781,
              3648.481
            ],
            [
              -3883.226,
              -1663.385,
              3720.935
            ],
            [
              -3846.769,
              -1642.867,
              3762.769
            ],
            [
              -3813.688,
              -1631.196,
              3797.848
            ],
            [
              -3809.119,
              -1627.936,
              3803.461
            ],
            [
              -3761.37,
              -1625.426,
              3851.276
            ],
            [
              -3487.628,
              -1602.363,
              4125.988
            ],
            [
              -3508.003,
              -1550.799,
              4181.43
            ],
            [
              -3525.544,
              -1521.55,
              4215.536
            ],
            [
              -3534.455,
              -1477.979,
              4260.009
            ],
            [
              -3620.717,
              -1211.532,
              4540.072
            ],
            [
              -3662.686,
              -1103.933,
              4655.566
            ],
            [
              -3680.758,
              -1067.996,
              4695.791
            ],
            [
              -3686.114,
              -1042.299,
              4722.04
            ],
            [
              -3720.918,
              -930.373,
              4839.253
            ],
            [
              -3751.541,
              -837.444,
              4937.098
            ],
            [
              -3761.526,
              -818.346,
              4958.648
            ],
            [
              -3766.218,
              -791.548,
              4985.855
            ],
            [
              -3793.988,
              -719.82,
              5062.77
            ],
            [
              -3843.779,
              -616.54,
              5177.426
            ],
            [
              -3881.258,
              -546.871,
              5256.537
            ],
            [
              -3968.98,
              -399.519,
              5428.023
            ],
            [
              -3986.683,
              -379.175,
              5454.991
            ],
            [
              -3999.719,
              -350.005,
              5486.941
            ],
            [
              -4048.201,
              -282.373,
              5570.155
            ],
            [
              -4133.499,
              -180.709,
              5702.863
            ],
            [
              -4196.245,
              -117.285,
              5792.08
            ],
            [
              -4221.08,
              -99.045,
              5822.894
            ],
            [
              -4243.751,
              -67.483,
              5861.754
            ],
            [
              -4402.336,
              85.535,
              6082.125
            ],
            [
              -4449.086,
              142,
              6155.433
            ],
            [
              -4479.797,
              193.736,
              6215.597
            ],
            [
              -4502.905,
              237.549,
              6265.13
            ],
            [
              -4519.036,
              274.562,
              6305.506
            ],
            [
              -4536.228,
              324.952,
              6358.748
            ],
            [
              -4547.048,
              370.78,
              6405.835
            ],
            [
              -4566.578,
              510.266,
              6546.682
            ],
            [
              -4574.501,
              537.119,
              6574.679
            ],
            [
              -4575.517,
              590.57,
              6628.14
            ],
            [
              -4579.623,
              651.866,
              6689.574
            ],
            [
              -4586.366,
              709.869,
              6747.967
            ],
            [
              -4584.541,
              741.007,
              6779.159
            ],
            [
              -4573.306,
              794.248,
              6833.572
            ],
            [
              -4555.909,
              830.684,
              6873.948
            ],
            [
              -4538.646,
              859.331,
              6907.394
            ],
            [
              -4503.175,
              896.569,
              6958.823
            ],
            [
              -4462.091,
              922.579,
              7007.449
            ],
            [
              -4445.644,
              941.22,
              7032.308
            ],
            [
              -4396.195,
              965.972,
              7087.606
            ],
            [
              -4188.107,
              1100.42,
              7335.349
            ],
            [
              -4154.055,
              1129.888,
              7380.381
            ],
            [
              -4048.114,
              1175.924,
              7495.892
            ],
            [
              -3997.487,
              1193.972,
              7549.641
            ],
            [
              -3829.673,
              1236.704,
              7722.81
            ],
            [
              -3789.4,
              1252.704,
              7766.144
            ],
            [
              -3749.695,
              1273.165,
              7810.811
            ],
            [
              -3705.908,
              1305.8,
              7865.423
            ],
            [
              -3669.839,
              1339.683,
              7914.91
            ],
            [
              -3634.26,
              1382.479,
              7970.564
            ],
            [
              -3619.001,
              1406.704,
              7999.194
            ],
            [
              -3601.633,
              1440.911,
              8037.558
            ],
            [
              -3596.615,
              1469.767,
              8066.847
            ],
            [
              -3579.402,
              1495.072,
              8097.451
            ],
            [
              -3566.606,
              1526.019,
              8130.939
            ],
            [
              -3560.672,
              1570.444,
              8175.759
            ],
            [
              -3561.909,
              1610.54,
              8215.875
            ],
            [
              -3553.124,
              1670.501,
              8276.475
            ],
            [
              -3546.511,
              1753.876,
              8360.112
            ],
            [
              -3528.72,
              1849.302,
              8457.182
            ],
            [
              -3507.519,
              1881.216,
              8495.496
            ],
            [
              -3466.677,
              1929.485,
              8558.726
            ],
            [
              -3411.117,
              1970.818,
              8627.975
            ],
            [
              -3377.989,
              1983.599,
              8663.482
            ],
            [
              -3293.772,
              2003.28,
              8749.969
            ],
            [
              -3253.06,
              2007.021,
              8790.853
            ],
            [
              -3234.374,
              2005.581,
              8809.593
            ],
            [
              -3211.057,
              2010.74,
              8833.474
            ],
            [
              -2960.432,
              2100.974,
              9099.849
            ],
            [
              -2902.519,
              2128.901,
              9164.144
            ],
            [
              -2763.528,
              2181.007,
              9312.58
            ],
            [
              -2705.632,
              2207.819,
              9376.383
            ],
            [
              -2695.312,
              2207.637,
              9386.705
            ],
            [
              -2620.644,
              2234.153,
              9465.941
            ],
            [
              -2602.113,
              2260.544,
              9498.188
            ],
            [
              -2577.443,
              2305.751,
              9549.688
            ],
            [
              -2591.532,
              2385.037,
              9630.217
            ],
            [
              -2598.371,
              2436.365,
              9681.998
            ],
            [
              -2602.959,
              2542.201,
              9787.934
            ],
            [
              -2607.706,
              2602.398,
              9848.317
            ],
            [
              -2619.569,
              2661.607,
              9908.703
            ],
            [
              -2672.012,
              2798.342,
              10055.15
            ],
            [
              -2693.846,
              2841.028,
              10103.096
            ],
            [
              -2698.439,
              2873.392,
              10135.785
            ],
            [
              -2831.804,
              3253.114,
              10538.246
            ],
            [
              -2853.662,
              3294.686,
              10585.214
            ],
            [
              -2870.652,
              3319.475,
              10615.267
            ],
            [
              -2888.502,
              3332.034,
              10637.092
            ],
            [
              -2904.222,
              3355.687,
              10665.492
            ],
            [
              -3126.24,
              3576.651,
              10978.729
            ],
            [
              -3256.351,
              3702.491,
              11159.739
            ],
            [
              -3334.924,
              3786.24,
              11274.576
            ],
            [
              -3406.008,
              3855.385,
              11373.742
            ],
            [
              -3427.01,
              3872.449,
              11400.803
            ],
            [
              -3454.8,
              3907.442,
              11445.489
            ],
            [
              -3626.746,
              4078.528,
              11688.049
            ],
            [
              -3781.512,
              4235.95,
              11908.807
            ],
            [
              -3884.317,
              4337.92,
              12053.606
            ],
            [
              -3915.514,
              4362.95,
              12093.604
            ],
            [
              -3928.112,
              4380.98,
              12115.598
            ],
            [
              -4226.292,
              4683.356,
              12540.266
            ],
            [
              -4305.622,
              4762.647,
              12652.428
            ],
            [
              -4338.114,
              4787.696,
              12693.455
            ],
            [
              -4349.425,
              4805.702,
              12714.719
            ],
            [
              -4420.502,
              4877.057,
              12815.434
            ],
            [
              -4439.501,
              4898.534,
              12844.108
            ],
            [
              -4461.157,
              4915.604,
              12871.683
            ],
            [
              -4476.532,
              4922.548,
              12888.554
            ],
            [
              -4488.111,
              4924.973,
              12900.384
            ],
            [
              -4508.363,
              4948.698,
              12931.577
            ],
            [
              -4600.366,
              5004.825,
              13039.348
            ],
            [
              -4658.205,
              5020.288,
              13099.219
            ],
            [
              -4736.87,
              5026.089,
              13178.098
            ],
            [
              -4780.873,
              5020.164,
              13222.497
            ],
            [
              -4794.293,
              5028.186,
              13238.133
            ],
            [
              -4887.841,
              5032.012,
              13331.759
            ],
            [
              -5084.124,
              5030.911,
              13528.045
            ],
            [
              -5215.445,
              4939.641,
              13687.968
            ],
            [
              -5291.942,
              4883.057,
              13783.118
            ],
            [
              -5256.598,
              4911.398,
              13828.422
            ],
            [
              -5543.457,
              4708.104,
              14180.014
            ],
            [
              -5565.132,
              4686.208,
              14210.824
            ],
            [
              -5573.178,
              4668.533,
              14230.244
            ],
            [
              -5896.258,
              4344.494,
              14687.827
            ],
            [
              -5929.163,
              4307.201,
              14737.561
            ],
            [
              -5947.232,
              4307.506,
              14755.632
            ],
            [
              -5952.3,
              4313.157,
              14763.224
            ],
            [
              -5952.758,
              4324.297,
              14774.373
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:7603",
              "position": {
                "x": -3854.099,
                "z": -5069.209
              },
              "distanceAlongShapeM": 79.662,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:687",
              "position": {
                "x": -3938.125,
                "z": -4417.632
              },
              "distanceAlongShapeM": 751.482,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:949",
              "position": {
                "x": -3863.253,
                "z": -4076.062
              },
              "distanceAlongShapeM": 1104.312,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:542",
              "position": {
                "x": -3683.061,
                "z": -3718.515
              },
              "distanceAlongShapeM": 1505.022,
              "shapeOffsetM": 0.925,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5060",
              "position": {
                "x": -3633.854,
                "z": -3520.107
              },
              "distanceAlongShapeM": 1711.566,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6580",
              "position": {
                "x": -3740.623,
                "z": -3064.057
              },
              "distanceAlongShapeM": 2189.747,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6581",
              "position": {
                "x": -4002.758,
                "z": -2422.747
              },
              "distanceAlongShapeM": 2883.809,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:6588",
              "position": {
                "x": -4045.475,
                "z": -1837.572
              },
              "distanceAlongShapeM": 3479.373,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:6591",
              "position": {
                "x": -3809.119,
                "z": -1627.936
              },
              "distanceAlongShapeM": 3803.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 4215.536,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:5643",
              "position": {
                "x": -3680.758,
                "z": -1067.996
              },
              "distanceAlongShapeM": 4695.791,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5646",
              "position": {
                "x": -3761.526,
                "z": -818.346
              },
              "distanceAlongShapeM": 4958.648,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5651",
              "position": {
                "x": -3986.683,
                "z": -379.175
              },
              "distanceAlongShapeM": 5454.991,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:5656",
              "position": {
                "x": -4221.08,
                "z": -99.045
              },
              "distanceAlongShapeM": 5822.894,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:5668",
              "position": {
                "x": -4574.501,
                "z": 537.119
              },
              "distanceAlongShapeM": 6574.679,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:6460",
              "position": {
                "x": -4445.644,
                "z": 941.22
              },
              "distanceAlongShapeM": 7032.308,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6461",
              "position": {
                "x": -4154.055,
                "z": 1129.888
              },
              "distanceAlongShapeM": 7380.381,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:6333",
              "position": {
                "x": -3596.615,
                "z": 1469.767
              },
              "distanceAlongShapeM": 8066.847,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:721",
              "position": {
                "x": -3293.772,
                "z": 2003.28
              },
              "distanceAlongShapeM": 8749.969,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6337",
              "position": {
                "x": -2705.632,
                "z": 2207.819
              },
              "distanceAlongShapeM": 9376.383,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5543",
              "position": {
                "x": -2693.846,
                "z": 2841.028
              },
              "distanceAlongShapeM": 10103.096,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5573",
              "position": {
                "x": -2888.502,
                "z": 3332.034
              },
              "distanceAlongShapeM": 10637.092,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:5587",
              "position": {
                "x": -3427.01,
                "z": 3872.449
              },
              "distanceAlongShapeM": 11400.803,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:5588",
              "position": {
                "x": -3915.514,
                "z": 4362.95
              },
              "distanceAlongShapeM": 12093.604,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5554",
              "position": {
                "x": -4338.114,
                "z": 4787.696
              },
              "distanceAlongShapeM": 12693.455,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5567",
              "position": {
                "x": -4488.111,
                "z": 4924.973
              },
              "distanceAlongShapeM": 12900.384,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5557",
              "position": {
                "x": -4780.873,
                "z": 5020.164
              },
              "distanceAlongShapeM": 13222.497,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:7553",
              "position": {
                "x": -5291.942,
                "z": 4883.057
              },
              "distanceAlongShapeM": 13783.118,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5571",
              "position": {
                "x": -5573.178,
                "z": 4668.533
              },
              "distanceAlongShapeM": 14230.244,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:16788",
              "position": {
                "x": -5896.258,
                "z": 4344.494
              },
              "distanceAlongShapeM": 14687.827,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:8374",
              "position": {
                "x": -5952.758,
                "z": 4324.297
              },
              "distanceAlongShapeM": 14774.373,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            }
          ],
          "departuresSeconds": [
            17760,
            18600,
            19440,
            20220,
            21120,
            21720,
            22500,
            23100,
            23760,
            24360,
            24960,
            25680,
            26580,
            27600,
            28560,
            29760,
            30960,
            32160,
            33420,
            34560,
            35640,
            36780,
            38220,
            39420,
            40560,
            41760,
            42960,
            44220,
            45420,
            46560,
            47700,
            48900,
            49620,
            50460,
            51180,
            51720,
            52320,
            52920,
            53640,
            54480,
            55260,
            55980,
            56520,
            57000,
            57540,
            58080,
            58800,
            59460,
            60300,
            61260,
            62280,
            63780,
            65340,
            66960,
            68400,
            69960,
            71100,
            72240,
            73440,
            74760,
            76080,
            77400,
            78780,
            80580
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_18:1",
          "sourceRouteId": "vilnius_trol_18",
          "sourceShapeId": "vilnius_trol_18_b-a",
          "directionId": 1,
          "headsign": "Perkūnkiemis",
          "directionName": "Titnago g.–Žemieji Paneriai–Justiniškės–Perkūnkiemis",
          "mode": "trolleybus",
          "routeShortName": "18",
          "routeLongName": "Perkūnkiemis–Justiniškės–Žemieji Paneriai–Titnago g.",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -5952.758,
              4324.297,
              0
            ],
            [
              -5932.772,
              4322.847,
              20.039
            ],
            [
              -5851.894,
              4410.536,
              139.331
            ],
            [
              -5542.812,
              4708.093,
              568.367
            ],
            [
              -5523.681,
              4732.259,
              599.189
            ],
            [
              -5495.647,
              4748.482,
              631.579
            ],
            [
              -5230.403,
              4933.216,
              954.814
            ],
            [
              -5256.503,
              4916.963,
              985.562
            ],
            [
              -5185.339,
              4963.618,
              1070.656
            ],
            [
              -5101.038,
              5023.407,
              1174.007
            ],
            [
              -5084.124,
              5030.911,
              1192.511
            ],
            [
              -4983.382,
              5032.532,
              1293.266
            ],
            [
              -4963.962,
              5035.54,
              1312.917
            ],
            [
              -4929.167,
              5031.606,
              1347.934
            ],
            [
              -4887.841,
              5032.012,
              1389.262
            ],
            [
              -4834.705,
              5081.197,
              1461.668
            ],
            [
              -4785.441,
              5130.448,
              1531.328
            ],
            [
              -4754.629,
              5157.75,
              1572.496
            ],
            [
              -4724.691,
              5171.709,
              1605.528
            ],
            [
              -4669.05,
              5178.548,
              1661.588
            ],
            [
              -4632.924,
              5176.815,
              1697.755
            ],
            [
              -4599.437,
              5171.788,
              1731.617
            ],
            [
              -4586.132,
              5157.088,
              1751.445
            ],
            [
              -4583.042,
              5111.394,
              1797.243
            ],
            [
              -4580.889,
              5011.17,
              1897.491
            ],
            [
              -4517.509,
              4980.025,
              1968.109
            ],
            [
              -4503.635,
              4960.862,
              1991.767
            ],
            [
              -4444.377,
              4915.316,
              2066.506
            ],
            [
              -4189.698,
              4671.592,
              2419.015
            ],
            [
              -4166.695,
              4657.837,
              2445.817
            ],
            [
              -4146.524,
              4629.659,
              2480.471
            ],
            [
              -4048.773,
              4533.349,
              2617.697
            ],
            [
              -3823.59,
              4303.471,
              2939.49
            ],
            [
              -3802.623,
              4284.184,
              2967.98
            ],
            [
              -3780.952,
              4268.223,
              2994.893
            ],
            [
              -3768.394,
              4247.967,
              3018.726
            ],
            [
              -3367.467,
              3844.694,
              3587.384
            ],
            [
              -3344.49,
              3829.822,
              3614.754
            ],
            [
              -3315.43,
              3793.692,
              3661.12
            ],
            [
              -3282.402,
              3763.059,
              3706.167
            ],
            [
              -3142.94,
              3618.132,
              3907.297
            ],
            [
              -2996.449,
              3469.738,
              4115.817
            ],
            [
              -2905.063,
              3381.305,
              4242.985
            ],
            [
              -2851.864,
              3323.598,
              4321.473
            ],
            [
              -2827.523,
              3276.416,
              4374.564
            ],
            [
              -2808.656,
              3248.254,
              4408.461
            ],
            [
              -2806.545,
              3221.5,
              4435.298
            ],
            [
              -2772.86,
              3118.493,
              4543.673
            ],
            [
              -2707,
              2936.995,
              4736.751
            ],
            [
              -2660.341,
              2801.476,
              4880.078
            ],
            [
              -2637.179,
              2724.257,
              4960.696
            ],
            [
              -2612.218,
              2675.949,
              5015.071
            ],
            [
              -2609.483,
              2648.071,
              5043.083
            ],
            [
              -2582.373,
              2575.235,
              5120.801
            ],
            [
              -2570.531,
              2514.913,
              5182.274
            ],
            [
              -2558.338,
              2437.886,
              5260.26
            ],
            [
              -2547.004,
              2385.365,
              5313.99
            ],
            [
              -2526.132,
              2324.884,
              5377.971
            ],
            [
              -2519.194,
              2315.856,
              5389.357
            ],
            [
              -2487.744,
              2306.396,
              5422.199
            ],
            [
              -2471.111,
              2298.31,
              5440.694
            ],
            [
              -2454.576,
              2284.659,
              5462.136
            ],
            [
              -2442.556,
              2271.088,
              5480.264
            ],
            [
              -2438.237,
              2259.88,
              5492.276
            ],
            [
              -2438.394,
              2250.977,
              5501.18
            ],
            [
              -2431.731,
              2226.369,
              5526.674
            ],
            [
              -2431.538,
              2200.762,
              5552.282
            ],
            [
              -2437.15,
              2175.257,
              5578.397
            ],
            [
              -2448.449,
              2156.532,
              5600.267
            ],
            [
              -2481.151,
              2131.505,
              5641.447
            ],
            [
              -2491.57,
              2126.123,
              5653.174
            ],
            [
              -2514.888,
              2120.968,
              5677.055
            ],
            [
              -2528.453,
              2120.094,
              5690.648
            ],
            [
              -2551.595,
              2124.955,
              5714.295
            ],
            [
              -2561.836,
              2129.588,
              5725.536
            ],
            [
              -2579.681,
              2142.148,
              5747.357
            ],
            [
              -2607.297,
              2186.05,
              5799.223
            ],
            [
              -2618.809,
              2191.819,
              5812.099
            ],
            [
              -2640.075,
              2193.306,
              5833.417
            ],
            [
              -2665.388,
              2184.846,
              5860.106
            ],
            [
              -2681.67,
              2176.227,
              5878.529
            ],
            [
              -2690.837,
              2168.596,
              5890.457
            ],
            [
              -2738.119,
              2158.296,
              5938.847
            ],
            [
              -2899.782,
              2101.023,
              6110.356
            ],
            [
              -2971.67,
              2085.586,
              6183.883
            ],
            [
              -3158.032,
              2017.605,
              6382.257
            ],
            [
              -3215.258,
              1991.889,
              6444.995
            ],
            [
              -3240.098,
              1973.399,
              6475.962
            ],
            [
              -3275.786,
              1961.777,
              6513.495
            ],
            [
              -3353.278,
              1920.828,
              6601.14
            ],
            [
              -3402.898,
              1887.184,
              6661.09
            ],
            [
              -3447.61,
              1838.983,
              6726.836
            ],
            [
              -3464.825,
              1813.679,
              6757.441
            ],
            [
              -3479.576,
              1781.653,
              6792.701
            ],
            [
              -3552.495,
              1521.32,
              7063.054
            ],
            [
              -3555.031,
              1486.855,
              7097.612
            ],
            [
              -3569.097,
              1457.043,
              7130.575
            ],
            [
              -3608.386,
              1386.482,
              7211.338
            ],
            [
              -3647.326,
              1335.952,
              7275.131
            ],
            [
              -3697.872,
              1285.623,
              7346.461
            ],
            [
              -3750.727,
              1250.919,
              7409.69
            ],
            [
              -3785.215,
              1233.706,
              7448.235
            ],
            [
              -3881.236,
              1201.976,
              7549.363
            ],
            [
              -3947.947,
              1186.435,
              7617.861
            ],
            [
              -4028.355,
              1162.223,
              7701.834
            ],
            [
              -4081.657,
              1138.655,
              7760.115
            ],
            [
              -4117.491,
              1118.124,
              7801.413
            ],
            [
              -4156.018,
              1090.96,
              7848.554
            ],
            [
              -4168.309,
              1088.946,
              7861.009
            ],
            [
              -4405.115,
              934.956,
              8143.48
            ],
            [
              -4421.523,
              918.541,
              8166.69
            ],
            [
              -4433.169,
              916.515,
              8178.51
            ],
            [
              -4463.138,
              899.22,
              8213.111
            ],
            [
              -4519.455,
              850.095,
              8287.843
            ],
            [
              -4559.388,
              778.424,
              8369.889
            ],
            [
              -4567.189,
              737.369,
              8411.677
            ],
            [
              -4562.176,
              653.793,
              8495.404
            ],
            [
              -4542.083,
              471.996,
              8678.308
            ],
            [
              -4530.426,
              437.286,
              8714.923
            ],
            [
              -4533.311,
              419.524,
              8732.918
            ],
            [
              -4527.744,
              368.221,
              8784.522
            ],
            [
              -4516.259,
              323.495,
              8830.699
            ],
            [
              -4491.638,
              255.166,
              8903.328
            ],
            [
              -4427.619,
              152.763,
              9024.097
            ],
            [
              -4367.011,
              77.134,
              9121.015
            ],
            [
              -4077.229,
              -208.399,
              9527.834
            ],
            [
              -3954.469,
              -380.846,
              9739.513
            ],
            [
              -3921.604,
              -419.265,
              9790.072
            ],
            [
              -3917.323,
              -432.698,
              9804.17
            ],
            [
              -3857.936,
              -540.596,
              9927.332
            ],
            [
              -3823.641,
              -607.984,
              10002.944
            ],
            [
              -3766.483,
              -732.543,
              10139.992
            ],
            [
              -3707.64,
              -908.34,
              10325.375
            ],
            [
              -3695.741,
              -928.584,
              10348.858
            ],
            [
              -3679.35,
              -950.021,
              10375.842
            ],
            [
              -3673.878,
              -969.04,
              10395.634
            ],
            [
              -3654.555,
              -1007.226,
              10438.43
            ],
            [
              -3618.236,
              -1069.084,
              10510.162
            ],
            [
              -3599.031,
              -1113.947,
              10558.963
            ],
            [
              -3569.469,
              -1193.5,
              10643.831
            ],
            [
              -3554.873,
              -1243.849,
              10696.253
            ],
            [
              -3543.073,
              -1269.659,
              10724.632
            ],
            [
              -3520.478,
              -1415.883,
              10872.592
            ],
            [
              -3500.646,
              -1498.607,
              10957.66
            ],
            [
              -3461.302,
              -1608.388,
              11074.278
            ],
            [
              -3462.063,
              -1615.054,
              11080.987
            ],
            [
              -3466.007,
              -1619.438,
              11086.885
            ],
            [
              -3480.186,
              -1619.191,
              11101.065
            ],
            [
              -3518.951,
              -1624.08,
              11140.138
            ],
            [
              -3542.913,
              -1630.342,
              11164.905
            ],
            [
              -3571.837,
              -1625.385,
              11194.25
            ],
            [
              -3644.74,
              -1628.568,
              11267.222
            ],
            [
              -3721.548,
              -1633.911,
              11344.216
            ],
            [
              -3788.083,
              -1641.66,
              11411.201
            ],
            [
              -3841.2,
              -1656.322,
              11466.305
            ],
            [
              -3882.188,
              -1677.875,
              11512.614
            ],
            [
              -3931.102,
              -1710.422,
              11571.367
            ],
            [
              -3978.977,
              -1757.46,
              11638.483
            ],
            [
              -4022.062,
              -1825.732,
              11719.214
            ],
            [
              -4044.37,
              -1885.459,
              11782.97
            ],
            [
              -4052.817,
              -1926.501,
              11824.873
            ],
            [
              -4053.048,
              -1939.856,
              11838.229
            ],
            [
              -4048.884,
              -1959.966,
              11858.766
            ],
            [
              -4055.493,
              -2006.606,
              11905.872
            ],
            [
              -4046.573,
              -2161.497,
              12061.019
            ],
            [
              -4020.612,
              -2299.985,
              12201.92
            ],
            [
              -3990.129,
              -2400.702,
              12307.149
            ],
            [
              -3964.263,
              -2470.17,
              12381.276
            ],
            [
              -3946.156,
              -2503.88,
              12419.542
            ],
            [
              -3932.856,
              -2517.469,
              12438.556
            ],
            [
              -3932.443,
              -2530.835,
              12451.928
            ],
            [
              -3926.386,
              -2553.204,
              12475.103
            ],
            [
              -3841.707,
              -2761.732,
              12700.168
            ],
            [
              -3765.67,
              -2947.847,
              12901.216
            ],
            [
              -3690.695,
              -3120.586,
              13089.525
            ],
            [
              -3680.304,
              -3153.05,
              13123.611
            ],
            [
              -3662.711,
              -3178.96,
              13154.93
            ],
            [
              -3658.589,
              -3201.296,
              13177.643
            ],
            [
              -3639.586,
              -3257.288,
              13236.772
            ],
            [
              -3617.301,
              -3346.734,
              13328.952
            ],
            [
              -3610.443,
              -3396.948,
              13379.632
            ],
            [
              -3607.737,
              -3500.524,
              13483.243
            ],
            [
              -3620.065,
              -3579.347,
              13563.025
            ],
            [
              -3625.467,
              -3630.461,
              13614.423
            ],
            [
              -3640.182,
              -3661.375,
              13648.661
            ],
            [
              -3673.181,
              -3743.178,
              13736.869
            ],
            [
              -3862.172,
              -4125.062,
              14162.96
            ],
            [
              -3875.164,
              -4168.252,
              14208.061
            ],
            [
              -3892.491,
              -4201.348,
              14245.418
            ],
            [
              -3906.204,
              -4248.978,
              14294.983
            ],
            [
              -3915.447,
              -4298.912,
              14345.765
            ],
            [
              -3918.758,
              -4341.156,
              14388.139
            ],
            [
              -3917.895,
              -4365.662,
              14412.66
            ],
            [
              -3914.159,
              -4410.256,
              14457.41
            ],
            [
              -3903.629,
              -4471.665,
              14519.716
            ],
            [
              -3893.942,
              -4507.456,
              14556.795
            ],
            [
              -3883.947,
              -4525.441,
              14577.371
            ],
            [
              -3876.856,
              -4562.301,
              14614.906
            ],
            [
              -3837.687,
              -4680.982,
              14739.884
            ],
            [
              -3830.05,
              -4723.417,
              14783
            ],
            [
              -3816.509,
              -4833.861,
              14894.271
            ],
            [
              -3815.714,
              -4936.291,
              14996.704
            ],
            [
              -3827.361,
              -5087.486,
              15148.347
            ],
            [
              -3832.624,
              -5130.81,
              15191.989
            ],
            [
              -3844.602,
              -5152.866,
              15217.088
            ],
            [
              -3879.396,
              -5153.374,
              15251.886
            ],
            [
              -3922.484,
              -5149.286,
              15295.167
            ],
            [
              -3928.106,
              -5139.169,
              15306.741
            ],
            [
              -3926.238,
              -5105.805,
              15340.157
            ],
            [
              -3921.595,
              -5098.093,
              15349.159
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:8374",
              "position": {
                "x": -5952.758,
                "z": 4324.297
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -540,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:1008",
              "position": {
                "x": -5851.894,
                "z": 4410.536
              },
              "distanceAlongShapeM": 139.331,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5570",
              "position": {
                "x": -5523.681,
                "z": 4732.259
              },
              "distanceAlongShapeM": 599.189,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:7554",
              "position": {
                "x": -5256.503,
                "z": 4916.963
              },
              "distanceAlongShapeM": 985.562,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5564",
              "position": {
                "x": -4963.962,
                "z": 5035.54
              },
              "distanceAlongShapeM": 1312.917,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5594",
              "position": {
                "x": -4669.05,
                "z": 5178.548
              },
              "distanceAlongShapeM": 1661.588,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:6850",
              "position": {
                "x": -4517.509,
                "z": 4980.025
              },
              "distanceAlongShapeM": 1968.109,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6851",
              "position": {
                "x": -4166.695,
                "z": 4657.837
              },
              "distanceAlongShapeM": 2445.817,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5546",
              "position": {
                "x": -3780.952,
                "z": 4268.223
              },
              "distanceAlongShapeM": 2994.893,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:9384",
              "position": {
                "x": -3344.49,
                "z": 3829.822
              },
              "distanceAlongShapeM": 3614.754,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:857",
              "position": {
                "x": -2808.656,
                "z": 3248.254
              },
              "distanceAlongShapeM": 4408.461,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5542",
              "position": {
                "x": -2612.218,
                "z": 2675.949
              },
              "distanceAlongShapeM": 5015.071,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6338",
              "position": {
                "x": -2690.837,
                "z": 2168.596
              },
              "distanceAlongShapeM": 5890.457,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:720",
              "position": {
                "x": -3240.098,
                "z": 1973.399
              },
              "distanceAlongShapeM": 6475.962,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:790",
              "position": {
                "x": -3555.031,
                "z": 1486.855
              },
              "distanceAlongShapeM": 7097.612,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6648",
              "position": {
                "x": -4156.018,
                "z": 1090.96
              },
              "distanceAlongShapeM": 7848.554,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6462",
              "position": {
                "x": -4421.523,
                "z": 918.541
              },
              "distanceAlongShapeM": 8166.69,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1380,
              "departureOffsetSeconds": 1380
            },
            {
              "stopId": "judu:stop:1071",
              "position": {
                "x": -4530.426,
                "z": 437.286
              },
              "distanceAlongShapeM": 8714.923,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:1004",
              "position": {
                "x": -4077.229,
                "z": -208.399
              },
              "distanceAlongShapeM": 9527.834,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:6649",
              "position": {
                "x": -3921.604,
                "z": -419.265
              },
              "distanceAlongShapeM": 9790.072,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:6643",
              "position": {
                "x": -3679.35,
                "z": -950.021
              },
              "distanceAlongShapeM": 10375.842,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 10724.632,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:6597",
              "position": {
                "x": -3542.913,
                "z": -1630.342
              },
              "distanceAlongShapeM": 11164.905,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:6587",
              "position": {
                "x": -4048.884,
                "z": -1959.966
              },
              "distanceAlongShapeM": 11858.766,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:6582",
              "position": {
                "x": -3932.856,
                "z": -2517.469
              },
              "distanceAlongShapeM": 12438.556,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:5063",
              "position": {
                "x": -3662.711,
                "z": -3178.96
              },
              "distanceAlongShapeM": 13154.93,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5140",
              "position": {
                "x": -3625.467,
                "z": -3630.461
              },
              "distanceAlongShapeM": 13614.423,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:5141",
              "position": {
                "x": -3875.164,
                "z": -4168.252
              },
              "distanceAlongShapeM": 14208.061,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:6925",
              "position": {
                "x": -3883.947,
                "z": -4525.441
              },
              "distanceAlongShapeM": 14577.371,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6931",
              "position": {
                "x": -3827.361,
                "z": -5087.486
              },
              "distanceAlongShapeM": 15148.347,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:8441",
              "position": {
                "x": -3921.595,
                "z": -5098.093
              },
              "distanceAlongShapeM": 15349.159,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            }
          ],
          "departuresSeconds": [
            19860,
            20700,
            21480,
            22380,
            23220,
            24120,
            24720,
            25320,
            25860,
            26400,
            27120,
            27840,
            28440,
            29160,
            30000,
            31020,
            32040,
            33060,
            34140,
            35160,
            36300,
            37440,
            38640,
            39840,
            41040,
            42240,
            43380,
            44580,
            45780,
            47040,
            48300,
            49440,
            50580,
            51720,
            52560,
            53280,
            54060,
            54660,
            55260,
            55920,
            56700,
            57540,
            58320,
            59100,
            59640,
            60120,
            60720,
            61260,
            61980,
            62700,
            63480,
            64380,
            65520,
            66960,
            68460,
            70020,
            71460,
            72840,
            74040,
            75180,
            76500,
            77580,
            79380,
            80580,
            81780,
            83280
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_19",
      "sourceRouteId": "vilnius_trol_19",
      "mode": "trolleybus",
      "shortName": "19",
      "longName": "Pašilaičiai–Konstitucijos pr.–Antakalnis–Saulėtekis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_19:0",
          "sourceRouteId": "vilnius_trol_19",
          "sourceShapeId": "vilnius_trol_19_a-b",
          "directionId": 0,
          "headsign": "Saulėtekis",
          "directionName": "Pašilaičiai–Konstitucijos pr.–Antakalnis–Saulėtekis",
          "mode": "trolleybus",
          "routeShortName": "19",
          "routeLongName": "Pašilaičiai–Konstitucijos pr.–Antakalnis–Saulėtekis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              -2897.378,
              -4403.536,
              0
            ],
            [
              -2904.267,
              -4392.283,
              13.195
            ],
            [
              -2902.49,
              -4364.484,
              41.051
            ],
            [
              -2923.723,
              -4326.261,
              84.775
            ],
            [
              -2938.397,
              -4244.738,
              167.609
            ],
            [
              -2943.47,
              -4203.459,
              209.198
            ],
            [
              -2943.332,
              -4158.933,
              253.724
            ],
            [
              -2947.565,
              -4106.537,
              306.291
            ],
            [
              -2936.886,
              -4048.837,
              364.97
            ],
            [
              -2933.232,
              -3950.938,
              462.938
            ],
            [
              -2933.288,
              -3880.804,
              533.071
            ],
            [
              -2935.53,
              -3825.104,
              588.817
            ],
            [
              -2942.439,
              -3778.227,
              636.2
            ],
            [
              -2941.11,
              -3739.288,
              675.162
            ],
            [
              -2942.553,
              -3711.432,
              703.055
            ],
            [
              -2962.772,
              -3578.604,
              837.414
            ],
            [
              -2994.393,
              -3434.443,
              985.002
            ],
            [
              -3009.522,
              -3378.516,
              1042.938
            ],
            [
              -3026.974,
              -3344.813,
              1080.892
            ],
            [
              -3029.648,
              -3313.596,
              1112.223
            ],
            [
              -3083.217,
              -3134.541,
              1299.12
            ],
            [
              -3102.428,
              -3054.053,
              1381.869
            ],
            [
              -3137.083,
              -2972.18,
              1470.774
            ],
            [
              -3158.619,
              -2877.179,
              1568.185
            ],
            [
              -3186.209,
              -2796.544,
              1653.41
            ],
            [
              -3248.067,
              -2685.253,
              1780.737
            ],
            [
              -3332.852,
              -2557.976,
              1933.668
            ],
            [
              -3349.352,
              -2543.216,
              1955.806
            ],
            [
              -3361.538,
              -2502.927,
              1997.898
            ],
            [
              -3386.79,
              -2435.693,
              2069.717
            ],
            [
              -3393.431,
              -2409.973,
              2096.281
            ],
            [
              -3395.464,
              -2378.768,
              2127.553
            ],
            [
              -3389.87,
              -2243.053,
              2263.382
            ],
            [
              -3384.424,
              -2226.45,
              2280.856
            ],
            [
              -3365.672,
              -2038.645,
              2469.595
            ],
            [
              -3375.166,
              -1991.724,
              2517.467
            ],
            [
              -3374.974,
              -1943.859,
              2565.332
            ],
            [
              -3391.774,
              -1872.32,
              2638.817
            ],
            [
              -3430.979,
              -1754.748,
              2762.753
            ],
            [
              -3480.186,
              -1619.191,
              2906.966
            ],
            [
              -3508.003,
              -1550.799,
              2980.798
            ],
            [
              -3525.544,
              -1521.55,
              3014.904
            ],
            [
              -3534.455,
              -1477.979,
              3059.376
            ],
            [
              -3626.266,
              -1196.964,
              3355.009
            ],
            [
              -3644.163,
              -1151.011,
              3404.324
            ],
            [
              -3645.883,
              -1138.735,
              3416.72
            ],
            [
              -3642.486,
              -1128.776,
              3427.243
            ],
            [
              -3630.73,
              -1120.075,
              3441.869
            ],
            [
              -3599.031,
              -1113.947,
              3474.155
            ],
            [
              -3412.497,
              -1176.2,
              3670.802
            ],
            [
              -3355.367,
              -1190.556,
              3729.709
            ],
            [
              -3108.49,
              -1230.499,
              3979.796
            ],
            [
              -3070.013,
              -1242.306,
              4020.044
            ],
            [
              -2879.155,
              -1277.94,
              4214.199
            ],
            [
              -2839.273,
              -1283.094,
              4254.413
            ],
            [
              -2787.087,
              -1285.125,
              4306.639
            ],
            [
              -2748.376,
              -1283.58,
              4345.38
            ],
            [
              -2714.118,
              -1278.617,
              4379.996
            ],
            [
              -2670.7,
              -1266.023,
              4425.204
            ],
            [
              -2624.585,
              -1246.798,
              4475.165
            ],
            [
              -2500.301,
              -1182.198,
              4615.235
            ],
            [
              -2469.831,
              -1172.717,
              4647.147
            ],
            [
              -2418.716,
              -1162.489,
              4699.275
            ],
            [
              -2392.231,
              -1159.617,
              4725.916
            ],
            [
              -2151.528,
              -1183.918,
              4967.842
            ],
            [
              -2126.509,
              -1191.041,
              4993.855
            ],
            [
              -2118.854,
              -1195.63,
              5002.78
            ],
            [
              -1988.935,
              -1213.522,
              5133.926
            ],
            [
              -1948.388,
              -1217.583,
              5174.675
            ],
            [
              -1866.572,
              -1221.265,
              5256.574
            ],
            [
              -1794.345,
              -1220.324,
              5328.807
            ],
            [
              -1681.879,
              -1204.518,
              5442.379
            ],
            [
              -1544.075,
              -1178.035,
              5582.704
            ],
            [
              -1436.465,
              -1145.449,
              5695.14
            ],
            [
              -1393.22,
              -1142.883,
              5738.46
            ],
            [
              -1155.149,
              -1098.17,
              5980.694
            ],
            [
              -1103.929,
              -1082.392,
              6034.289
            ],
            [
              -1083.324,
              -1083.875,
              6054.948
            ],
            [
              -1022.536,
              -1073.836,
              6116.56
            ],
            [
              -998.991,
              -1055.334,
              6146.503
            ],
            [
              -969.041,
              -1039.175,
              6180.535
            ],
            [
              -947.066,
              -1036.231,
              6202.706
            ],
            [
              -930.307,
              -1036.533,
              6219.468
            ],
            [
              -906.579,
              -1043.639,
              6244.237
            ],
            [
              -895.802,
              -1053.852,
              6259.085
            ],
            [
              -890.221,
              -1066.198,
              6272.634
            ],
            [
              -876.342,
              -1083.147,
              6294.54
            ],
            [
              -864.236,
              -1091.158,
              6309.057
            ],
            [
              -845.624,
              -1095.946,
              6328.275
            ],
            [
              -813.336,
              -1093.188,
              6360.68
            ],
            [
              -786.145,
              -1086.999,
              6388.567
            ],
            [
              -775.751,
              -1082.734,
              6399.801
            ],
            [
              -717.641,
              -1078.217,
              6458.087
            ],
            [
              -647.083,
              -1062.792,
              6530.311
            ],
            [
              -535.555,
              -1028.072,
              6647.119
            ],
            [
              -464.693,
              -995.958,
              6724.918
            ],
            [
              -361.843,
              -942.16,
              6840.989
            ],
            [
              -333.702,
              -919.293,
              6877.249
            ],
            [
              -286.889,
              -897.877,
              6928.729
            ],
            [
              -196.966,
              -846.075,
              7032.505
            ],
            [
              -115.583,
              -803.025,
              7124.573
            ],
            [
              -96.647,
              -790.01,
              7147.55
            ],
            [
              -42.035,
              -765.399,
              7207.451
            ],
            [
              224.8,
              -701.243,
              7481.891
            ],
            [
              237.149,
              -695.903,
              7495.345
            ],
            [
              292.85,
              -682.448,
              7552.648
            ],
            [
              331.506,
              -684.268,
              7591.347
            ],
            [
              436.802,
              -673.948,
              7697.148
            ],
            [
              647.48,
              -719,
              7912.588
            ],
            [
              692.52,
              -724.28,
              7957.937
            ],
            [
              729.304,
              -722.729,
              7994.753
            ],
            [
              752.305,
              -734.284,
              8020.494
            ],
            [
              1031.058,
              -793.963,
              8305.564
            ],
            [
              1157.03,
              -816.326,
              8433.505
            ],
            [
              1200.176,
              -819.349,
              8476.757
            ],
            [
              1220.015,
              -827.509,
              8498.208
            ],
            [
              1248.96,
              -831.383,
              8527.411
            ],
            [
              1306.39,
              -829.106,
              8584.887
            ],
            [
              1367.853,
              -817.997,
              8647.346
            ],
            [
              1381.451,
              -814.909,
              8661.29
            ],
            [
              1598.931,
              -666.427,
              8924.624
            ],
            [
              1632.324,
              -639.216,
              8967.699
            ],
            [
              1644.195,
              -624.964,
              8986.248
            ],
            [
              1650.286,
              -609.492,
              9002.876
            ],
            [
              1647.435,
              -589.4,
              9023.169
            ],
            [
              1649.076,
              -570.506,
              9042.134
            ],
            [
              1661.593,
              -556.266,
              9061.093
            ],
            [
              1683.01,
              -548.871,
              9083.751
            ],
            [
              1706.196,
              -550.415,
              9106.989
            ],
            [
              1713.204,
              -554.998,
              9115.363
            ],
            [
              1719.444,
              -566.247,
              9128.226
            ],
            [
              1719.696,
              -587.403,
              9149.384
            ],
            [
              1723.546,
              -623.099,
              9185.286
            ],
            [
              1729.599,
              -644.363,
              9207.395
            ],
            [
              1821.456,
              -767.415,
              9360.951
            ],
            [
              1905.301,
              -870.282,
              9493.66
            ],
            [
              1935.932,
              -922.062,
              9553.822
            ],
            [
              1949.532,
              -953.487,
              9588.063
            ],
            [
              1961.738,
              -990.451,
              9626.991
            ],
            [
              1968.757,
              -1305.631,
              9942.249
            ],
            [
              1988.222,
              -1471.868,
              10109.622
            ],
            [
              2032.094,
              -1677.525,
              10319.906
            ],
            [
              2032.074,
              -1713.148,
              10355.529
            ],
            [
              2048.644,
              -1792.498,
              10436.591
            ],
            [
              2069.62,
              -1877.497,
              10524.14
            ],
            [
              2087.852,
              -1936.84,
              10586.22
            ],
            [
              2087.374,
              -1962.435,
              10611.82
            ],
            [
              2110.719,
              -2024.1,
              10677.756
            ],
            [
              2234.812,
              -2316.979,
              10995.84
            ],
            [
              2284.924,
              -2429.242,
              11118.779
            ],
            [
              2299.015,
              -2468.47,
              11160.461
            ],
            [
              2319.691,
              -2569.05,
              11263.144
            ],
            [
              2327.089,
              -2587.001,
              11282.56
            ],
            [
              2323.492,
              -2606.972,
              11302.852
            ],
            [
              2328.687,
              -2639.354,
              11335.648
            ],
            [
              2411.872,
              -3118.499,
              11821.961
            ],
            [
              2419.872,
              -3138.687,
              11843.676
            ],
            [
              2418.768,
              -3163.158,
              11868.172
            ],
            [
              2474.472,
              -3526.012,
              12235.276
            ],
            [
              2513.109,
              -3664.781,
              12379.324
            ],
            [
              2522.438,
              -3682.768,
              12399.586
            ],
            [
              2522.312,
              -3689.445,
              12406.265
            ],
            [
              2535.711,
              -3730.887,
              12449.819
            ],
            [
              2556.818,
              -3773.588,
              12497.451
            ],
            [
              2598.204,
              -3834.482,
              12571.077
            ],
            [
              2619.624,
              -3860.489,
              12604.771
            ],
            [
              2636.723,
              -3876.397,
              12628.125
            ],
            [
              2642.893,
              -3890.985,
              12643.964
            ],
            [
              2709.56,
              -3977.961,
              12753.551
            ],
            [
              3021.059,
              -4338.966,
              13230.37
            ],
            [
              3086.352,
              -4293.444,
              13309.967
            ],
            [
              3111.27,
              -4270.537,
              13343.814
            ],
            [
              3142.482,
              -4255.542,
              13378.441
            ],
            [
              3336.938,
              -4126.748,
              13611.681
            ],
            [
              3389.682,
              -4097.691,
              13671.9
            ],
            [
              3402.776,
              -4086.807,
              13688.927
            ],
            [
              3446.229,
              -4072.046,
              13734.818
            ],
            [
              3528.69,
              -4039.102,
              13823.616
            ],
            [
              3592.048,
              -4028.061,
              13887.929
            ],
            [
              3640.634,
              -4014.513,
              13938.369
            ],
            [
              3666.294,
              -4020.567,
              13964.733
            ],
            [
              3848.026,
              -4019.578,
              14146.468
            ],
            [
              3878.881,
              -4023.507,
              14177.573
            ],
            [
              3901.964,
              -4029.514,
              14201.424
            ],
            [
              3958.181,
              -4055.079,
              14263.181
            ],
            [
              3967.843,
              -4055.264,
              14272.845
            ],
            [
              4018.762,
              -4121.92,
              14356.725
            ],
            [
              4037.773,
              -4172.381,
              14410.647
            ],
            [
              4032.364,
              -4185.636,
              14424.964
            ],
            [
              4021.265,
              -4193.217,
              14438.405
            ],
            [
              4012.248,
              -4193.045,
              14447.424
            ],
            [
              3999.472,
              -4187.234,
              14461.459
            ],
            [
              3957.337,
              -4132.992,
              14530.144
            ],
            [
              3954.003,
              -4105.097,
              14558.238
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6484",
              "position": {
                "x": -2923.723,
                "z": -4326.261
              },
              "distanceAlongShapeM": 84.775,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6523",
              "position": {
                "x": -2947.565,
                "z": -4106.537
              },
              "distanceAlongShapeM": 306.291,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6482",
              "position": {
                "x": -2942.439,
                "z": -3778.227
              },
              "distanceAlongShapeM": 636.2,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:6478",
              "position": {
                "x": -3026.974,
                "z": -3344.813
              },
              "distanceAlongShapeM": 1080.892,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:6477",
              "position": {
                "x": -3137.083,
                "z": -2972.18
              },
              "distanceAlongShapeM": 1470.774,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:6476",
              "position": {
                "x": -3349.352,
                "z": -2543.216
              },
              "distanceAlongShapeM": 1955.806,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:6475",
              "position": {
                "x": -3389.87,
                "z": -2243.053
              },
              "distanceAlongShapeM": 2263.382,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5620",
              "position": {
                "x": -3375.166,
                "z": -1991.724
              },
              "distanceAlongShapeM": 2517.467,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 600,
              "departureOffsetSeconds": 600
            },
            {
              "stopId": "judu:stop:928",
              "position": {
                "x": -3525.544,
                "z": -1521.55
              },
              "distanceAlongShapeM": 3014.904,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:7416",
              "position": {
                "x": -3108.49,
                "z": -1230.499
              },
              "distanceAlongShapeM": 3979.796,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6398",
              "position": {
                "x": -2151.528,
                "z": -1183.918
              },
              "distanceAlongShapeM": 4967.842,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6396",
              "position": {
                "x": -1436.465,
                "z": -1145.449
              },
              "distanceAlongShapeM": 5695.14,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:6397",
              "position": {
                "x": -1103.929,
                "z": -1082.392
              },
              "distanceAlongShapeM": 6034.289,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6635",
              "position": {
                "x": -775.751,
                "z": -1082.734
              },
              "distanceAlongShapeM": 6399.801,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:7381",
              "position": {
                "x": -333.702,
                "z": -919.293
              },
              "distanceAlongShapeM": 6877.249,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:17638",
              "position": {
                "x": -42.035,
                "z": -765.399
              },
              "distanceAlongShapeM": 7207.451,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1560,
              "departureOffsetSeconds": 1560
            },
            {
              "stopId": "judu:stop:5667",
              "position": {
                "x": 292.85,
                "z": -682.448
              },
              "distanceAlongShapeM": 7552.648,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:5665",
              "position": {
                "x": 729.304,
                "z": -722.729
              },
              "distanceAlongShapeM": 7994.753,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:6660",
              "position": {
                "x": 1200.176,
                "z": -819.349
              },
              "distanceAlongShapeM": 8476.757,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5826",
              "position": {
                "x": 1961.738,
                "z": -990.451
              },
              "distanceAlongShapeM": 9626.991,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:6702",
              "position": {
                "x": 2032.094,
                "z": -1677.525
              },
              "distanceAlongShapeM": 10319.906,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2280,
              "departureOffsetSeconds": 2280
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 10586.22,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2400,
              "departureOffsetSeconds": 2400
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 11282.56,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2520,
              "departureOffsetSeconds": 2520
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 11843.676,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2640,
              "departureOffsetSeconds": 2640
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 12399.586,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2760,
              "departureOffsetSeconds": 2760
            },
            {
              "stopId": "judu:stop:741",
              "position": {
                "x": 2636.723,
                "z": -3876.397
              },
              "distanceAlongShapeM": 12628.125,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:5104",
              "position": {
                "x": 3111.27,
                "z": -4270.537
              },
              "distanceAlongShapeM": 13343.814,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:5105",
              "position": {
                "x": 3402.776,
                "z": -4086.807
              },
              "distanceAlongShapeM": 13688.927,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:5107",
              "position": {
                "x": 3640.634,
                "z": -4014.513
              },
              "distanceAlongShapeM": 13938.369,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            },
            {
              "stopId": "judu:stop:900",
              "position": {
                "x": 3967.843,
                "z": -4055.264
              },
              "distanceAlongShapeM": 14272.845,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3120,
              "departureOffsetSeconds": 3120
            }
          ],
          "departuresSeconds": [
            18420,
            19620,
            20580,
            21780,
            22620,
            23340,
            24120,
            24900,
            25740,
            26640,
            27480,
            28200,
            29220,
            30420,
            31620,
            32820,
            33780,
            34800,
            35940,
            36720,
            37860,
            39060,
            40140,
            41220,
            42600,
            43980,
            45180,
            46500,
            47580,
            48660,
            50040,
            51480,
            52860,
            54180,
            55320,
            56040,
            56940,
            57660,
            58260,
            58920,
            59940,
            61140,
            62340,
            63540,
            64380,
            65700,
            66900,
            67500,
            68580,
            69960,
            71220,
            72540,
            74160,
            75120,
            76080,
            77160,
            78300,
            79740,
            81180,
            82440
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_19:1",
          "sourceRouteId": "vilnius_trol_19",
          "sourceShapeId": "vilnius_trol_19_b-a",
          "directionId": 1,
          "headsign": "Pašilaičiai",
          "directionName": "Saulėtekis–Antakalnis–Konstitucijos pr.–Pašilaičiai",
          "mode": "trolleybus",
          "routeShortName": "19",
          "routeLongName": "Pašilaičiai–Konstitucijos pr.–Antakalnis–Saulėtekis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              3954.003,
              -4105.097,
              0
            ],
            [
              3949.042,
              -4094.982,
              11.266
            ],
            [
              3942.445,
              -4069.251,
              37.829
            ],
            [
              3936.216,
              -4058,
              50.69
            ],
            [
              3917.749,
              -4046.514,
              72.437
            ],
            [
              3898.552,
              -4039.468,
              92.886
            ],
            [
              3898.616,
              -4036.13,
              96.225
            ],
            [
              3858.828,
              -4027.577,
              136.922
            ],
            [
              3592.048,
              -4028.061,
              403.703
            ],
            [
              3581.678,
              -4031.203,
              414.538
            ],
            [
              3565.986,
              -4043.151,
              434.261
            ],
            [
              3520.083,
              -4051.184,
              480.861
            ],
            [
              3445.458,
              -4078.711,
              560.402
            ],
            [
              3358.965,
              -4120.486,
              656.455
            ],
            [
              3360.169,
              -4124.962,
              661.09
            ],
            [
              3310.064,
              -4150.73,
              717.432
            ],
            [
              3021.059,
              -4338.966,
              1062.334
            ],
            [
              2959.695,
              -4278.804,
              1148.269
            ],
            [
              2937.404,
              -4265.024,
              1174.476
            ],
            [
              2920.517,
              -4237.987,
              1206.353
            ],
            [
              2810.169,
              -4110.107,
              1375.262
            ],
            [
              2739.116,
              -4050.879,
              1467.763
            ],
            [
              2661.391,
              -4003.772,
              1558.649
            ],
            [
              2636.416,
              -3995.509,
              1584.956
            ],
            [
              2619.338,
              -3978.489,
              1609.067
            ],
            [
              2604.004,
              -3971.521,
              1625.909
            ],
            [
              2521.143,
              -3923.207,
              1721.827
            ],
            [
              2505.227,
              -3912.889,
              1740.795
            ],
            [
              2488.876,
              -3891.43,
              1767.773
            ],
            [
              2479.071,
              -3864.528,
              1796.407
            ],
            [
              2475.189,
              -3831.057,
              1830.102
            ],
            [
              2503.004,
              -3722.48,
              1942.185
            ],
            [
              2508.663,
              -3661.358,
              2003.569
            ],
            [
              2463.001,
              -3519.117,
              2152.959
            ],
            [
              2462.068,
              -3500.174,
              2171.925
            ],
            [
              2434.072,
              -3309.282,
              2364.859
            ],
            [
              2425.512,
              -3284.63,
              2390.955
            ],
            [
              2426.678,
              -3256.82,
              2418.789
            ],
            [
              2328.687,
              -2639.354,
              3043.983
            ],
            [
              2308.053,
              -2536.548,
              3148.839
            ],
            [
              2296.913,
              -2511.848,
              3175.935
            ],
            [
              2295.002,
              -2476.188,
              3211.646
            ],
            [
              2274.24,
              -2414.57,
              3276.667
            ],
            [
              2234.812,
              -2316.979,
              3381.922
            ],
            [
              2177.257,
              -2188.992,
              3522.255
            ],
            [
              2082.177,
              -1964.565,
              3765.992
            ],
            [
              2062.178,
              -1896.283,
              3837.142
            ],
            [
              2050.931,
              -1842.637,
              3891.954
            ],
            [
              2043.488,
              -1826.913,
              3909.351
            ],
            [
              2041.617,
              -1789.027,
              3947.283
            ],
            [
              1994.191,
              -1532.095,
              4208.556
            ],
            [
              1983.608,
              -1511.859,
              4231.392
            ],
            [
              1983.607,
              -1477.349,
              4265.902
            ],
            [
              1966.491,
              -1323.401,
              4420.798
            ],
            [
              1951.301,
              -996.936,
              4747.616
            ],
            [
              1944.999,
              -954.515,
              4790.503
            ],
            [
              1921.875,
              -915.121,
              4836.182
            ],
            [
              1920.773,
              -905.081,
              4846.283
            ],
            [
              1905.301,
              -870.282,
              4884.366
            ],
            [
              1842.792,
              -798.983,
              4979.186
            ],
            [
              1722.529,
              -643.118,
              5176.055
            ],
            [
              1706.703,
              -627.239,
              5198.474
            ],
            [
              1684.224,
              -622.368,
              5221.475
            ],
            [
              1662.848,
              -627.537,
              5243.467
            ],
            [
              1583.13,
              -683.945,
              5341.123
            ],
            [
              1381.451,
              -814.909,
              5581.594
            ],
            [
              1363.471,
              -845.747,
              5617.291
            ],
            [
              1363.126,
              -899.177,
              5670.721
            ],
            [
              1355.02,
              -919.065,
              5692.198
            ],
            [
              1339.886,
              -935.484,
              5714.528
            ],
            [
              1325.561,
              -943.011,
              5730.71
            ],
            [
              1293.291,
              -944.641,
              5763.021
            ],
            [
              1278.507,
              -942.141,
              5778.015
            ],
            [
              1268.297,
              -936.386,
              5789.736
            ],
            [
              1257.545,
              -925.054,
              5805.356
            ],
            [
              1250.784,
              -907.118,
              5824.525
            ],
            [
              1250.468,
              -889.3,
              5842.345
            ],
            [
              1243.124,
              -868.013,
              5864.864
            ],
            [
              1234.408,
              -851.153,
              5883.843
            ],
            [
              1218.52,
              -838.613,
              5904.084
            ],
            [
              1192.86,
              -831.46,
              5930.723
            ],
            [
              1154.205,
              -829.633,
              5969.421
            ],
            [
              1120.288,
              -815.648,
              6006.108
            ],
            [
              1031.058,
              -793.963,
              6097.934
            ],
            [
              773.373,
              -745.803,
              6360.082
            ],
            [
              729.54,
              -744.998,
              6403.922
            ],
            [
              702.691,
              -732.259,
              6433.64
            ],
            [
              508.13,
              -687.5,
              6633.283
            ],
            [
              443.852,
              -676.304,
              6698.528
            ],
            [
              405.738,
              -680.059,
              6736.827
            ],
            [
              364.219,
              -693.772,
              6780.552
            ],
            [
              341.718,
              -690.021,
              6803.363
            ],
            [
              238.113,
              -713.732,
              6909.647
            ],
            [
              219.901,
              -722.305,
              6929.776
            ],
            [
              73.653,
              -750.808,
              7078.776
            ],
            [
              -18.428,
              -779.188,
              7175.131
            ],
            [
              -53.078,
              -805.275,
              7218.503
            ],
            [
              -306.711,
              -924.235,
              7498.648
            ],
            [
              -475.993,
              -1014.678,
              7690.577
            ],
            [
              -534.689,
              -1051.466,
              7759.848
            ],
            [
              -673.187,
              -1080.133,
              7901.282
            ],
            [
              -763.423,
              -1114.127,
              7997.708
            ],
            [
              -829.227,
              -1116.28,
              8063.548
            ],
            [
              -865.018,
              -1134.559,
              8103.737
            ],
            [
              -891.825,
              -1155.228,
              8137.586
            ],
            [
              -898.431,
              -1164.015,
              8148.579
            ],
            [
              -907.595,
              -1171.642,
              8160.502
            ],
            [
              -917.363,
              -1177.032,
              8171.659
            ],
            [
              -929.65,
              -1179.038,
              8184.108
            ],
            [
              -961.877,
              -1178.457,
              8216.34
            ],
            [
              -977.306,
              -1175.953,
              8231.971
            ],
            [
              -995.797,
              -1164.488,
              8253.728
            ],
            [
              -1006.474,
              -1148.711,
              8272.779
            ],
            [
              -1029.882,
              -1123.799,
              8306.963
            ],
            [
              -1062.634,
              -1116.531,
              8340.511
            ],
            [
              -1096.995,
              -1127.045,
              8376.445
            ],
            [
              -1143.947,
              -1120.636,
              8423.833
            ],
            [
              -1339.338,
              -1158.32,
              8622.825
            ],
            [
              -1374.402,
              -1172.164,
              8660.523
            ],
            [
              -1791.301,
              -1230.398,
              9081.469
            ],
            [
              -1855.793,
              -1231.475,
              9145.971
            ],
            [
              -1940.187,
              -1227.747,
              9230.447
            ],
            [
              -2027.705,
              -1218.399,
              9318.463
            ],
            [
              -2166.609,
              -1198.122,
              9458.838
            ],
            [
              -2255.397,
              -1187.643,
              9548.243
            ],
            [
              -2267.097,
              -1193.002,
              9561.112
            ],
            [
              -2295.924,
              -1182.472,
              9591.801
            ],
            [
              -2392.506,
              -1175.197,
              9688.657
            ],
            [
              -2431.277,
              -1180.078,
              9727.734
            ],
            [
              -2478.584,
              -1193.714,
              9776.967
            ],
            [
              -2533.196,
              -1219.467,
              9837.347
            ],
            [
              -2617.204,
              -1266.966,
              9933.853
            ],
            [
              -2663.944,
              -1285.067,
              9983.975
            ],
            [
              -2710.565,
              -1296.491,
              10031.976
            ],
            [
              -2762.303,
              -1305.599,
              10084.509
            ],
            [
              -2808.767,
              -1308.121,
              10131.042
            ],
            [
              -2858.317,
              -1302.797,
              10180.877
            ],
            [
              -3071.028,
              -1263.439,
              10397.199
            ],
            [
              -3140.52,
              -1255.542,
              10467.138
            ],
            [
              -3159.719,
              -1247.413,
              10487.987
            ],
            [
              -3359.526,
              -1207.182,
              10691.804
            ],
            [
              -3495.953,
              -1192.555,
              10829.013
            ],
            [
              -3539.254,
              -1198.48,
              10872.717
            ],
            [
              -3554.175,
              -1203.786,
              10888.553
            ],
            [
              -3558.842,
              -1212.61,
              10898.536
            ],
            [
              -3559.094,
              -1227.077,
              10913.005
            ],
            [
              -3554.873,
              -1243.849,
              10930.3
            ],
            [
              -3543.073,
              -1269.659,
              10958.679
            ],
            [
              -3520.478,
              -1415.883,
              11106.639
            ],
            [
              -3500.646,
              -1498.607,
              11191.706
            ],
            [
              -3461.302,
              -1608.388,
              11308.325
            ],
            [
              -3438.975,
              -1658.872,
              11363.526
            ],
            [
              -3418.974,
              -1694.844,
              11404.685
            ],
            [
              -3409.362,
              -1735.088,
              11446.06
            ],
            [
              -3353.575,
              -1899.704,
              11619.873
            ],
            [
              -3340.35,
              -1954.483,
              11676.225
            ],
            [
              -3339.232,
              -2037.994,
              11759.743
            ],
            [
              -3345.53,
              -2177.035,
              11898.927
            ],
            [
              -3368.406,
              -2305.768,
              12029.677
            ],
            [
              -3372.034,
              -2365.819,
              12089.837
            ],
            [
              -3365.898,
              -2420.473,
              12144.835
            ],
            [
              -3338.206,
              -2495.543,
              12224.849
            ],
            [
              -3294.464,
              -2574.233,
              12314.88
            ],
            [
              -3256.485,
              -2613.86,
              12369.767
            ],
            [
              -3240.415,
              -2653.104,
              12412.174
            ],
            [
              -3181.544,
              -2750.984,
              12526.395
            ],
            [
              -3157.274,
              -2800.391,
              12581.441
            ],
            [
              -3108.891,
              -2944.844,
              12733.782
            ],
            [
              -3088.313,
              -3020.904,
              12812.576
            ],
            [
              -3080.894,
              -3038.845,
              12831.991
            ],
            [
              -3066.407,
              -3094.76,
              12889.752
            ],
            [
              -3053.229,
              -3115.03,
              12913.928
            ],
            [
              -3044.503,
              -3168.617,
              12968.222
            ],
            [
              -2983.753,
              -3378.969,
              13187.17
            ],
            [
              -2968.741,
              -3404.837,
              13217.078
            ],
            [
              -2964.33,
              -3447.216,
              13259.687
            ],
            [
              -2935.834,
              -3585.756,
              13401.127
            ],
            [
              -2926.739,
              -3654.936,
              13470.902
            ],
            [
              -2914.467,
              -3799.87,
              13616.355
            ],
            [
              -2906.719,
              -3835.629,
              13652.944
            ],
            [
              -2909.141,
              -3863.417,
              13680.837
            ],
            [
              -2921.12,
              -4178.248,
              13995.896
            ],
            [
              -2914.524,
              -4206.195,
              14024.61
            ],
            [
              -2917.063,
              -4240.66,
              14059.169
            ],
            [
              -2899.032,
              -4314.449,
              14135.13
            ],
            [
              -2865.992,
              -4377.371,
              14206.198
            ],
            [
              -2823.799,
              -4432.662,
              14275.749
            ],
            [
              -2835.666,
              -4448.038,
              14295.173
            ],
            [
              -2850.052,
              -4460.03,
              14313.901
            ],
            [
              -2854.56,
              -4459.951,
              14318.41
            ],
            [
              -2897.378,
              -4403.536,
              14389.234
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:6239",
              "position": {
                "x": 3898.552,
                "z": -4039.468
              },
              "distanceAlongShapeM": 92.886,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5116",
              "position": {
                "x": 3565.986,
                "z": -4043.151
              },
              "distanceAlongShapeM": 434.261,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 60,
              "departureOffsetSeconds": 60
            },
            {
              "stopId": "judu:stop:6715",
              "position": {
                "x": 3360.169,
                "z": -4124.962
              },
              "distanceAlongShapeM": 661.09,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 120,
              "departureOffsetSeconds": 120
            },
            {
              "stopId": "judu:stop:5103",
              "position": {
                "x": 2937.404,
                "z": -4265.024
              },
              "distanceAlongShapeM": 1174.476,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5117",
              "position": {
                "x": 2636.416,
                "z": -3995.509
              },
              "distanceAlongShapeM": 1584.956,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 2152.959,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 2390.955,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 3175.935,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 720,
              "departureOffsetSeconds": 720
            },
            {
              "stopId": "judu:stop:5818",
              "position": {
                "x": 2043.488,
                "z": -1826.913
              },
              "distanceAlongShapeM": 3909.351,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:5819",
              "position": {
                "x": 1983.608,
                "z": -1511.859
              },
              "distanceAlongShapeM": 4231.392,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:5820",
              "position": {
                "x": 1921.875,
                "z": -915.121
              },
              "distanceAlongShapeM": 4836.182,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5662",
              "position": {
                "x": 1154.205,
                "z": -829.633
              },
              "distanceAlongShapeM": 5969.421,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5664",
              "position": {
                "x": 729.54,
                "z": -744.998
              },
              "distanceAlongShapeM": 6403.922,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:677",
              "position": {
                "x": 364.219,
                "z": -693.772
              },
              "distanceAlongShapeM": 6780.552,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:753",
              "position": {
                "x": -53.078,
                "z": -805.275
              },
              "distanceAlongShapeM": 7218.503,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1620,
              "departureOffsetSeconds": 1620
            },
            {
              "stopId": "judu:stop:7382",
              "position": {
                "x": -534.689,
                "z": -1051.466
              },
              "distanceAlongShapeM": 7759.848,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1740,
              "departureOffsetSeconds": 1740
            },
            {
              "stopId": "judu:stop:988",
              "position": {
                "x": -763.423,
                "z": -1114.127
              },
              "distanceAlongShapeM": 7997.708,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6404",
              "position": {
                "x": -1096.995,
                "z": -1127.045
              },
              "distanceAlongShapeM": 8376.445,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1920,
              "departureOffsetSeconds": 1920
            },
            {
              "stopId": "judu:stop:814",
              "position": {
                "x": -1374.402,
                "z": -1172.164
              },
              "distanceAlongShapeM": 8660.523,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5906",
              "position": {
                "x": -2267.097,
                "z": -1193.002
              },
              "distanceAlongShapeM": 9561.112,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:7415",
              "position": {
                "x": -3140.52,
                "z": -1255.542
              },
              "distanceAlongShapeM": 10467.138,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2220,
              "departureOffsetSeconds": 2220
            },
            {
              "stopId": "judu:stop:4990",
              "position": {
                "x": -3543.073,
                "z": -1269.659
              },
              "distanceAlongShapeM": 10958.679,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2340,
              "departureOffsetSeconds": 2340
            },
            {
              "stopId": "judu:stop:5722",
              "position": {
                "x": -3418.974,
                "z": -1694.844
              },
              "distanceAlongShapeM": 11404.685,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2460,
              "departureOffsetSeconds": 2460
            },
            {
              "stopId": "judu:stop:6472",
              "position": {
                "x": -3345.53,
                "z": -2177.035
              },
              "distanceAlongShapeM": 11898.927,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2580,
              "departureOffsetSeconds": 2580
            },
            {
              "stopId": "judu:stop:6651",
              "position": {
                "x": -3256.485,
                "z": -2613.86
              },
              "distanceAlongShapeM": 12369.767,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2700,
              "departureOffsetSeconds": 2700
            },
            {
              "stopId": "judu:stop:5067",
              "position": {
                "x": -3053.229,
                "z": -3115.03
              },
              "distanceAlongShapeM": 12913.928,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2820,
              "departureOffsetSeconds": 2820
            },
            {
              "stopId": "judu:stop:6479",
              "position": {
                "x": -2968.741,
                "z": -3404.837
              },
              "distanceAlongShapeM": 13217.078,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2880,
              "departureOffsetSeconds": 2880
            },
            {
              "stopId": "judu:stop:6481",
              "position": {
                "x": -2906.719,
                "z": -3835.629
              },
              "distanceAlongShapeM": 13652.944,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2940,
              "departureOffsetSeconds": 2940
            },
            {
              "stopId": "judu:stop:6653",
              "position": {
                "x": -2914.524,
                "z": -4206.195
              },
              "distanceAlongShapeM": 14024.61,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3000,
              "departureOffsetSeconds": 3000
            },
            {
              "stopId": "judu:stop:8275",
              "position": {
                "x": -2897.378,
                "z": -4403.536
              },
              "distanceAlongShapeM": 14389.234,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 3060,
              "departureOffsetSeconds": 3060
            }
          ],
          "departuresSeconds": [
            19920,
            20760,
            21420,
            22140,
            22860,
            23700,
            24360,
            25140,
            26040,
            26880,
            27780,
            28680,
            29640,
            30600,
            31440,
            32160,
            33060,
            34200,
            36420,
            38520,
            40320,
            41520,
            42660,
            43860,
            45060,
            46260,
            47580,
            48840,
            50160,
            51360,
            52140,
            52920,
            53880,
            54420,
            54960,
            56040,
            57120,
            58200,
            59280,
            60240,
            61080,
            61740,
            62340,
            63000,
            63960,
            65280,
            66660,
            68340,
            71040,
            72120,
            73440,
            74700,
            76080,
            77520,
            78480,
            79440,
            80640,
            81900,
            83160
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_20",
      "sourceRouteId": "vilnius_trol_20",
      "mode": "trolleybus",
      "shortName": "20",
      "longName": "Žirmūnai–Žygimantų–Pylimo g.–Stotis",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_20:0",
          "sourceRouteId": "vilnius_trol_20",
          "sourceShapeId": "vilnius_trol_20_a-b",
          "directionId": 0,
          "headsign": "Stotis",
          "directionName": "Žirmūnai–Žygimantų–Pylimo g.–Stotis",
          "mode": "trolleybus",
          "routeShortName": "20",
          "routeLongName": "Žirmūnai–Žygimantų–Pylimo g.–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1016.673,
              -4299.303,
              0
            ],
            [
              1017.645,
              -4281.509,
              17.821
            ],
            [
              1022.257,
              -4276.027,
              24.984
            ],
            [
              1106.613,
              -4278.698,
              109.382
            ],
            [
              1128.033,
              -4270.188,
              132.431
            ],
            [
              1147.356,
              -4270.545,
              151.757
            ],
            [
              1188.702,
              -4264.63,
              193.524
            ],
            [
              1202.517,
              -4249.3,
              214.16
            ],
            [
              1214.522,
              -4227.257,
              239.261
            ],
            [
              1220.978,
              -4191.753,
              275.347
            ],
            [
              1217.195,
              -3943.429,
              523.7
            ],
            [
              1219.986,
              -3862.213,
              604.964
            ],
            [
              1375.611,
              -3774.922,
              783.398
            ],
            [
              1393.375,
              -3755.212,
              809.932
            ],
            [
              1412.221,
              -3746.656,
              830.629
            ],
            [
              1509.056,
              -3563.653,
              1037.673
            ],
            [
              1556.885,
              -3486.613,
              1128.352
            ],
            [
              1607.644,
              -3390.704,
              1236.865
            ],
            [
              1620.009,
              -3384.254,
              1250.811
            ],
            [
              1689.847,
              -3267.548,
              1386.817
            ],
            [
              1697.306,
              -3247.648,
              1408.069
            ],
            [
              1696.944,
              -3128.524,
              1527.194
            ],
            [
              1687.839,
              -3098.296,
              1558.763
            ],
            [
              1693.427,
              -3075.022,
              1582.698
            ],
            [
              1690.731,
              -2873.474,
              1784.265
            ],
            [
              1684.353,
              -2661.838,
              1995.997
            ],
            [
              1677.945,
              -2590.471,
              2067.651
            ],
            [
              1676.674,
              -2554.823,
              2103.321
            ],
            [
              1670.083,
              -2527.983,
              2130.959
            ],
            [
              1679.06,
              -2495.866,
              2164.307
            ],
            [
              1670.601,
              -2049.296,
              2610.957
            ],
            [
              1665.105,
              -1963.474,
              2696.955
            ],
            [
              1665.702,
              -1896.69,
              2763.741
            ],
            [
              1663.09,
              -1759.712,
              2900.744
            ],
            [
              1653.419,
              -1725.022,
              2936.757
            ],
            [
              1660.464,
              -1692.869,
              2969.673
            ],
            [
              1642.718,
              -1572.308,
              3091.532
            ],
            [
              1626.598,
              -1502.988,
              3162.702
            ],
            [
              1590.763,
              -1384.318,
              3286.665
            ],
            [
              1541.473,
              -1260.946,
              3419.518
            ],
            [
              1439.941,
              -1068.699,
              3636.93
            ],
            [
              1418.417,
              -1047.149,
              3667.388
            ],
            [
              1413.029,
              -1024.784,
              3690.392
            ],
            [
              1381.79,
              -970.77,
              3752.79
            ],
            [
              1372.327,
              -959.462,
              3767.534
            ],
            [
              1333.941,
              -943.166,
              3809.236
            ],
            [
              1307.513,
              -942.677,
              3835.668
            ],
            [
              1293.291,
              -944.641,
              3850.025
            ],
            [
              1278.507,
              -942.141,
              3865.019
            ],
            [
              1268.297,
              -936.386,
              3876.74
            ],
            [
              1257.545,
              -925.054,
              3892.36
            ],
            [
              1249.597,
              -901.529,
              3917.192
            ],
            [
              1249.57,
              -868.132,
              3950.589
            ],
            [
              1251.689,
              -858.152,
              3960.792
            ],
            [
              1256.345,
              -850.445,
              3969.796
            ],
            [
              1271.438,
              -836.252,
              3990.514
            ],
            [
              1287.032,
              -829.861,
              4007.367
            ],
            [
              1306.39,
              -829.106,
              4026.74
            ],
            [
              1381.451,
              -814.909,
              4103.131
            ],
            [
              1598.931,
              -666.427,
              4366.465
            ],
            [
              1632.324,
              -639.216,
              4409.54
            ],
            [
              1644.195,
              -624.964,
              4428.089
            ],
            [
              1650.286,
              -609.492,
              4444.717
            ],
            [
              1647.435,
              -589.4,
              4465.01
            ],
            [
              1641.361,
              -569.249,
              4486.057
            ],
            [
              1626.241,
              -550.043,
              4510.5
            ],
            [
              1608.96,
              -543.043,
              4529.145
            ],
            [
              1227.773,
              -233.181,
              5020.386
            ],
            [
              1060.09,
              -128.781,
              5217.913
            ],
            [
              1042.305,
              -113.981,
              5241.051
            ],
            [
              992.552,
              -84.12,
              5299.077
            ],
            [
              920.398,
              -44.941,
              5381.182
            ],
            [
              895.357,
              -38.914,
              5406.938
            ],
            [
              797.689,
              -19.306,
              5506.555
            ],
            [
              670.384,
              1.958,
              5635.623
            ],
            [
              652.936,
              0.051,
              5653.175
            ],
            [
              630.873,
              -7.336,
              5676.442
            ],
            [
              604.636,
              -31.346,
              5712.007
            ],
            [
              564.962,
              -49.544,
              5755.656
            ],
            [
              476.44,
              -129.188,
              5874.733
            ],
            [
              402.286,
              -199.078,
              5976.631
            ],
            [
              346.776,
              -237.026,
              6043.873
            ],
            [
              281.176,
              -262.545,
              6114.262
            ],
            [
              119.684,
              -277.409,
              6276.437
            ],
            [
              35.151,
              -280.322,
              6361.02
            ],
            [
              26.146,
              -279.045,
              6370.115
            ],
            [
              15.43,
              -265.491,
              6387.394
            ],
            [
              14.363,
              -253.226,
              6399.705
            ],
            [
              16.439,
              -245.471,
              6407.733
            ],
            [
              25.627,
              -236.732,
              6420.413
            ],
            [
              45.916,
              -220.403,
              6446.456
            ],
            [
              103.215,
              -190.277,
              6511.193
            ],
            [
              127.382,
              -102.772,
              6601.974
            ],
            [
              121.848,
              -52.576,
              6652.474
            ],
            [
              115.041,
              -36.866,
              6669.595
            ],
            [
              117.583,
              -3.516,
              6703.043
            ],
            [
              102.671,
              133.684,
              6841.05
            ],
            [
              63.181,
              125.497,
              6881.38
            ],
            [
              59.312,
              125.568,
              6885.249
            ],
            [
              57.419,
              127.829,
              6888.199
            ],
            [
              31.786,
              278.582,
              7041.115
            ],
            [
              4.856,
              358.112,
              7125.081
            ],
            [
              -8.924,
              380.627,
              7151.479
            ],
            [
              -39.768,
              422.378,
              7203.387
            ],
            [
              -46.8,
              425.846,
              7211.227
            ],
            [
              -51.212,
              431.492,
              7218.393
            ],
            [
              -51.307,
              497.175,
              7284.076
            ],
            [
              -56,
              522.864,
              7310.19
            ],
            [
              -44.593,
              547.148,
              7337.02
            ],
            [
              -34.25,
              619.32,
              7409.929
            ],
            [
              -34.886,
              726.201,
              7516.812
            ],
            [
              -29.964,
              784,
              7574.82
            ],
            [
              -31.514,
              805.179,
              7596.056
            ],
            [
              -24.076,
              823.969,
              7616.264
            ],
            [
              -6.94,
              914.942,
              7708.837
            ],
            [
              5.94,
              949.218,
              7745.453
            ],
            [
              14.89,
              980.225,
              7777.727
            ],
            [
              17.976,
              1008,
              7805.672
            ],
            [
              98.858,
              1127.869,
              7950.277
            ],
            [
              206.575,
              1304.022,
              8156.754
            ],
            [
              265.611,
              1357.493,
              8236.406
            ],
            [
              347.967,
              1416.104,
              8337.488
            ],
            [
              403.761,
              1468.519,
              8414.041
            ],
            [
              405.778,
              1472.935,
              8418.896
            ],
            [
              396.871,
              1479.777,
              8430.127
            ],
            [
              393.103,
              1485.412,
              8436.906
            ],
            [
              391.311,
              1493.238,
              8444.934
            ],
            [
              394.908,
              1548.834,
              8500.646
            ],
            [
              392.049,
              1568.924,
              8520.939
            ],
            [
              397.453,
              1582.184,
              8535.258
            ],
            [
              391.321,
              1670.242,
              8623.528
            ],
            [
              330.657,
              1810.504,
              8776.347
            ],
            [
              327.072,
              1826.155,
              8792.404
            ],
            [
              328.524,
              1835.034,
              8801.401
            ],
            [
              390.297,
              1931.87,
              8916.262
            ],
            [
              384.797,
              1948.669,
              8933.938
            ],
            [
              364.123,
              1982.443,
              8973.538
            ],
            [
              361.04,
              1990.292,
              8981.971
            ],
            [
              363.158,
              2000.273,
              8992.173
            ],
            [
              374.225,
              2005.637,
              9004.471
            ],
            [
              387.77,
              2005.389,
              9018.018
            ],
            [
              447.829,
              1973.12,
              9086.198
            ],
            [
              479.21,
              1960.301,
              9120.096
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 132.431,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 809.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 1236.865,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 1558.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 2130.959,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5658",
              "position": {
                "x": 1653.419,
                "z": -1725.022
              },
              "distanceAlongShapeM": 2936.757,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:5661",
              "position": {
                "x": 1418.417,
                "z": -1047.149
              },
              "distanceAlongShapeM": 3667.388,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5768",
              "position": {
                "x": 1608.96,
                "z": -543.043
              },
              "distanceAlongShapeM": 4529.145,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5771",
              "position": {
                "x": 1060.09,
                "z": -128.781
              },
              "distanceAlongShapeM": 5217.913,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:848",
              "position": {
                "x": 604.636,
                "z": -31.346
              },
              "distanceAlongShapeM": 5712.007,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5409",
              "position": {
                "x": 115.041,
                "z": -36.866
              },
              "distanceAlongShapeM": 6669.595,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1500,
              "departureOffsetSeconds": 1500
            },
            {
              "stopId": "judu:stop:5338",
              "position": {
                "x": -56,
                "z": 522.864
              },
              "distanceAlongShapeM": 7310.19,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:5345",
              "position": {
                "x": 17.976,
                "z": 1008
              },
              "distanceAlongShapeM": 7805.672,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:5349",
              "position": {
                "x": 206.575,
                "z": 1304.022
              },
              "distanceAlongShapeM": 8156.754,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5430",
              "position": {
                "x": 392.049,
                "z": 1568.924
              },
              "distanceAlongShapeM": 8520.939,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1980,
              "departureOffsetSeconds": 1980
            },
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 9120.096,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            19920,
            21300,
            22680,
            24000,
            25320,
            26640,
            28260,
            29940,
            32700,
            34380,
            35940,
            37320,
            38520,
            39900,
            41220,
            42540,
            43800,
            45240,
            46560,
            47760,
            49140,
            50460,
            51840,
            53160,
            54360,
            55860,
            57300,
            58800,
            60000,
            61680,
            63360,
            65280,
            67680,
            69360,
            71040,
            72720,
            73860,
            75000,
            76380,
            77640,
            78840,
            80220,
            81660
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_20:1",
          "sourceRouteId": "vilnius_trol_20",
          "sourceShapeId": "vilnius_trol_20_b-a",
          "directionId": 1,
          "headsign": "Žirmūnai",
          "directionName": "Stotis–Pylimo–Žygimantų g.–Žirmūnai",
          "mode": "trolleybus",
          "routeShortName": "20",
          "routeLongName": "Žirmūnai–Žygimantų–Pylimo g.–Stotis",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              479.21,
              1960.301,
              0
            ],
            [
              486.04,
              1945.704,
              16.116
            ],
            [
              477.309,
              1926.939,
              36.813
            ],
            [
              467.471,
              1918.213,
              49.963
            ],
            [
              410.21,
              1927.053,
              107.902
            ],
            [
              405.736,
              1929.361,
              112.937
            ],
            [
              398.6,
              1927.265,
              120.374
            ],
            [
              329.489,
              1817.205,
              250.334
            ],
            [
              330.657,
              1810.504,
              257.135
            ],
            [
              391.321,
              1670.242,
              409.954
            ],
            [
              473.433,
              1574.115,
              536.377
            ],
            [
              482.238,
              1561.708,
              551.591
            ],
            [
              479.414,
              1548.401,
              565.194
            ],
            [
              472.7,
              1534.052,
              581.037
            ],
            [
              453.691,
              1517.701,
              606.11
            ],
            [
              360.424,
              1427.008,
              736.202
            ],
            [
              315.899,
              1391.085,
              793.412
            ],
            [
              256.42,
              1348.755,
              866.416
            ],
            [
              223.566,
              1315.958,
              912.838
            ],
            [
              196.476,
              1280.829,
              957.2
            ],
            [
              149.248,
              1202.651,
              1048.536
            ],
            [
              55.081,
              1061.873,
              1217.905
            ],
            [
              52.802,
              1042.989,
              1236.925
            ],
            [
              42.322,
              1034.274,
              1250.555
            ],
            [
              29.685,
              1013.353,
              1274.997
            ],
            [
              17.226,
              966.824,
              1323.165
            ],
            [
              -2.949,
              921.549,
              1372.732
            ],
            [
              -20.167,
              826.124,
              1469.698
            ],
            [
              -26.358,
              769.462,
              1526.697
            ],
            [
              -34.886,
              726.201,
              1570.79
            ],
            [
              -34.25,
              619.32,
              1677.674
            ],
            [
              -49.15,
              509.381,
              1788.618
            ],
            [
              -51.111,
              437.057,
              1860.969
            ],
            [
              -46.759,
              428.072,
              1870.952
            ],
            [
              -39.768,
              422.378,
              1879.968
            ],
            [
              18.234,
              348.963,
              1973.531
            ],
            [
              36.62,
              260.682,
              2063.706
            ],
            [
              56.855,
              132.292,
              2193.681
            ],
            [
              59.373,
              128.907,
              2197.9
            ],
            [
              70.978,
              128.695,
              2209.507
            ],
            [
              102.671,
              133.684,
              2241.59
            ],
            [
              116.145,
              94.475,
              2283.05
            ],
            [
              117.953,
              52.139,
              2325.424
            ],
            [
              129.077,
              -80.538,
              2458.567
            ],
            [
              129.194,
              -109.485,
              2487.514
            ],
            [
              121.85,
              -193.956,
              2572.304
            ],
            [
              119.866,
              -267.394,
              2645.768
            ],
            [
              179.196,
              -267.363,
              2705.098
            ],
            [
              270.197,
              -263.458,
              2796.182
            ],
            [
              305.837,
              -254.09,
              2833.033
            ],
            [
              342.264,
              -236.944,
              2873.294
            ],
            [
              410.165,
              -191.43,
              2955.038
            ],
            [
              461.971,
              -144.509,
              3024.934
            ],
            [
              541.549,
              -60.247,
              3140.833
            ],
            [
              554.165,
              -40.44,
              3164.317
            ],
            [
              588.702,
              -21.035,
              3203.932
            ],
            [
              628.519,
              4.952,
              3251.479
            ],
            [
              645.363,
              9.096,
              3268.825
            ],
            [
              675.04,
              9.665,
              3298.508
            ],
            [
              707.88,
              6.836,
              3331.469
            ],
            [
              925.597,
              -42.81,
              3554.775
            ],
            [
              1129.224,
              -156.774,
              3788.124
            ],
            [
              1143.99,
              -160.386,
              3803.326
            ],
            [
              1610.786,
              -514.132,
              4389.018
            ],
            [
              1615.737,
              -525.357,
              4401.285
            ],
            [
              1648.803,
              -550.462,
              4442.802
            ],
            [
              1662.944,
              -552.951,
              4457.16
            ],
            [
              1683.01,
              -548.871,
              4477.637
            ],
            [
              1706.196,
              -550.415,
              4500.875
            ],
            [
              1713.204,
              -554.998,
              4509.248
            ],
            [
              1719.444,
              -566.247,
              4522.111
            ],
            [
              1721.402,
              -599.681,
              4555.602
            ],
            [
              1716.683,
              -610.725,
              4567.613
            ],
            [
              1706.848,
              -619.449,
              4580.759
            ],
            [
              1700.984,
              -622.679,
              4587.454
            ],
            [
              1684.224,
              -622.368,
              4604.217
            ],
            [
              1662.848,
              -627.537,
              4626.209
            ],
            [
              1583.13,
              -683.945,
              4723.866
            ],
            [
              1381.451,
              -814.909,
              4964.336
            ],
            [
              1363.471,
              -845.747,
              5000.033
            ],
            [
              1362.208,
              -879.121,
              5033.431
            ],
            [
              1367.85,
              -922.642,
              5077.316
            ],
            [
              1384.491,
              -964.14,
              5122.027
            ],
            [
              1464.439,
              -1103.664,
              5282.832
            ],
            [
              1480.223,
              -1121.768,
              5306.851
            ],
            [
              1488.813,
              -1145.306,
              5331.907
            ],
            [
              1537.374,
              -1238.606,
              5437.088
            ],
            [
              1587.871,
              -1366.453,
              5574.546
            ],
            [
              1626.598,
              -1502.988,
              5716.467
            ],
            [
              1647.564,
              -1589.097,
              5805.092
            ],
            [
              1670.179,
              -1759.844,
              5977.331
            ],
            [
              1676.751,
              -1787.797,
              6006.046
            ],
            [
              1672.408,
              -1813.321,
              6031.937
            ],
            [
              1677.37,
              -1962.589,
              6181.286
            ],
            [
              1684.587,
              -2475.93,
              6694.679
            ],
            [
              1691.063,
              -2612.98,
              6831.881
            ],
            [
              1696.386,
              -2638.684,
              6858.13
            ],
            [
              1690.652,
              -2669.748,
              6889.72
            ],
            [
              1690.731,
              -2873.474,
              7093.446
            ],
            [
              1700.851,
              -3126.37,
              7346.544
            ],
            [
              1709.563,
              -3177.741,
              7398.649
            ],
            [
              1701.896,
              -3208.77,
              7430.61
            ],
            [
              1697.306,
              -3247.648,
              7469.759
            ],
            [
              1679.831,
              -3286.287,
              7512.165
            ],
            [
              1593.247,
              -3437.193,
              7686.146
            ],
            [
              1582.257,
              -3473.726,
              7724.296
            ],
            [
              1566.424,
              -3493.47,
              7749.605
            ],
            [
              1509.807,
              -3592.611,
              7863.774
            ],
            [
              1412.221,
              -3746.656,
              8046.127
            ],
            [
              1401.002,
              -3760.92,
              8064.275
            ],
            [
              1342.825,
              -3805.485,
              8137.559
            ],
            [
              1325.974,
              -3810.739,
              8155.211
            ],
            [
              1219.986,
              -3862.213,
              8273.036
            ],
            [
              1220.734,
              -4100.462,
              8511.286
            ],
            [
              1228.325,
              -4142.906,
              8554.404
            ],
            [
              1222.034,
              -4169.508,
              8581.739
            ],
            [
              1223.554,
              -4191.801,
              8604.084
            ],
            [
              1219.757,
              -4222.901,
              8635.416
            ],
            [
              1209.725,
              -4242.754,
              8657.659
            ],
            [
              1201.125,
              -4254.841,
              8672.493
            ],
            [
              1180.185,
              -4272.266,
              8699.735
            ],
            [
              1169.776,
              -4277.639,
              8711.449
            ],
            [
              1151.036,
              -4280.633,
              8730.427
            ],
            [
              1136.221,
              -4280.359,
              8745.244
            ],
            [
              1097.226,
              -4298.563,
              8788.28
            ],
            [
              1061.102,
              -4335.747,
              8840.121
            ],
            [
              1050.796,
              -4335.556,
              8850.428
            ],
            [
              1023.347,
              -4321.691,
              8881.181
            ],
            [
              1017.05,
              -4313.782,
              8891.291
            ],
            [
              1016.673,
              -4299.303,
              8905.775
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5300",
              "position": {
                "x": 479.21,
                "z": 1960.301
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:6834",
              "position": {
                "x": 472.7,
                "z": 1534.052
              },
              "distanceAlongShapeM": 581.037,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5346",
              "position": {
                "x": 52.802,
                "z": 1042.989
              },
              "distanceAlongShapeM": 1236.925,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5432",
              "position": {
                "x": -26.358,
                "z": 769.462
              },
              "distanceAlongShapeM": 1526.697,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 420,
              "departureOffsetSeconds": 420
            },
            {
              "stopId": "judu:stop:5459",
              "position": {
                "x": 18.234,
                "z": 348.963
              },
              "distanceAlongShapeM": 1973.531,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 540,
              "departureOffsetSeconds": 540
            },
            {
              "stopId": "judu:stop:5492",
              "position": {
                "x": 116.145,
                "z": 94.475
              },
              "distanceAlongShapeM": 2283.05,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 660,
              "departureOffsetSeconds": 660
            },
            {
              "stopId": "judu:stop:7278",
              "position": {
                "x": 707.88,
                "z": 6.836
              },
              "distanceAlongShapeM": 3331.469,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:6573",
              "position": {
                "x": 1143.99,
                "z": -160.386
              },
              "distanceAlongShapeM": 3803.326,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5770",
              "position": {
                "x": 1610.786,
                "z": -514.132
              },
              "distanceAlongShapeM": 4389.018,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1080,
              "departureOffsetSeconds": 1080
            },
            {
              "stopId": "judu:stop:6665",
              "position": {
                "x": 1480.223,
                "z": -1121.768
              },
              "distanceAlongShapeM": 5306.851,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            },
            {
              "stopId": "judu:stop:6666",
              "position": {
                "x": 1676.751,
                "z": -1787.797
              },
              "distanceAlongShapeM": 6006.046,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1440,
              "departureOffsetSeconds": 1440
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 6858.13,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1680,
              "departureOffsetSeconds": 1680
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 7398.649,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1800,
              "departureOffsetSeconds": 1800
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 7724.296,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1860,
              "departureOffsetSeconds": 1860
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 8137.559,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2040,
              "departureOffsetSeconds": 2040
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 8554.404,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2100,
              "departureOffsetSeconds": 2100
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 8730.427,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 2160,
              "departureOffsetSeconds": 2160
            }
          ],
          "departuresSeconds": [
            22080,
            23460,
            24840,
            26220,
            27720,
            29100,
            30720,
            32400,
            35040,
            36660,
            38220,
            39540,
            40740,
            42120,
            43440,
            44760,
            46020,
            47460,
            48780,
            49980,
            51360,
            52680,
            54060,
            55380,
            56580,
            58080,
            59640,
            61260,
            62460,
            64140,
            65820,
            67680,
            70020,
            71640,
            73260,
            74940,
            76020,
            77100,
            78480,
            79740,
            80940,
            82320,
            83700
          ]
        }
      ]
    },
    {
      "id": "judu:route:vilnius_trol_21",
      "sourceRouteId": "vilnius_trol_21",
      "mode": "trolleybus",
      "shortName": "21",
      "longName": "Antakalnis–Šilo tiltas–Žirmūnai",
      "color": "DC3131",
      "textColor": "FFFFFF",
      "patterns": [
        {
          "id": "judu:pattern:vilnius_trol_21:0",
          "sourceRouteId": "vilnius_trol_21",
          "sourceShapeId": "vilnius_trol_21_a-b",
          "directionId": 0,
          "headsign": "Žirmūnai",
          "directionName": "Antakalnis–Šilo tiltas–Žirmūnai",
          "mode": "trolleybus",
          "routeShortName": "21",
          "routeLongName": "Antakalnis–Šilo tiltas–Žirmūnai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              2551.422,
              -3889.265,
              0
            ],
            [
              2499.38,
              -3984.027,
              108.112
            ],
            [
              2494.143,
              -3988.382,
              114.923
            ],
            [
              2481.156,
              -3993.705,
              128.959
            ],
            [
              2470.227,
              -3992.386,
              139.967
            ],
            [
              2459.381,
              -3986.616,
              152.253
            ],
            [
              2448.681,
              -3973.056,
              169.526
            ],
            [
              2446.334,
              -3960.766,
              182.038
            ],
            [
              2458.099,
              -3917.57,
              226.807
            ],
            [
              2495.249,
              -3757.959,
              390.685
            ],
            [
              2503.087,
              -3718.029,
              431.377
            ],
            [
              2508.663,
              -3661.358,
              488.322
            ],
            [
              2463.001,
              -3519.117,
              637.712
            ],
            [
              2462.068,
              -3500.174,
              656.678
            ],
            [
              2434.072,
              -3309.282,
              849.612
            ],
            [
              2425.512,
              -3284.63,
              875.708
            ],
            [
              2426.678,
              -3256.82,
              903.542
            ],
            [
              2328.687,
              -2639.354,
              1528.736
            ],
            [
              2308.053,
              -2536.548,
              1633.592
            ],
            [
              2296.913,
              -2511.848,
              1660.688
            ],
            [
              2295.002,
              -2476.188,
              1696.399
            ],
            [
              2274.24,
              -2414.57,
              1761.42
            ],
            [
              2234.812,
              -2316.979,
              1866.675
            ],
            [
              2177.257,
              -2188.992,
              2007.008
            ],
            [
              2082.177,
              -1964.565,
              2250.745
            ],
            [
              2062.178,
              -1896.283,
              2321.895
            ],
            [
              2031.037,
              -1906.834,
              2354.775
            ],
            [
              1998.15,
              -1907.334,
              2387.666
            ],
            [
              1855.148,
              -1935.839,
              2533.481
            ],
            [
              1712.252,
              -1958.784,
              2678.208
            ],
            [
              1677.37,
              -1962.589,
              2713.297
            ],
            [
              1684.587,
              -2475.93,
              3226.689
            ],
            [
              1691.063,
              -2612.98,
              3363.892
            ],
            [
              1696.386,
              -2638.684,
              3390.141
            ],
            [
              1690.652,
              -2669.748,
              3421.73
            ],
            [
              1690.731,
              -2873.474,
              3625.456
            ],
            [
              1700.851,
              -3126.37,
              3878.554
            ],
            [
              1709.563,
              -3177.741,
              3930.659
            ],
            [
              1701.896,
              -3208.77,
              3962.62
            ],
            [
              1697.306,
              -3247.648,
              4001.769
            ],
            [
              1679.831,
              -3286.287,
              4044.175
            ],
            [
              1593.247,
              -3437.193,
              4218.156
            ],
            [
              1582.257,
              -3473.726,
              4256.307
            ],
            [
              1566.424,
              -3493.47,
              4281.615
            ],
            [
              1509.807,
              -3592.611,
              4395.784
            ],
            [
              1412.221,
              -3746.656,
              4578.137
            ],
            [
              1401.002,
              -3760.92,
              4596.285
            ],
            [
              1342.825,
              -3805.485,
              4669.569
            ],
            [
              1325.974,
              -3810.739,
              4687.221
            ],
            [
              1219.986,
              -3862.213,
              4805.047
            ],
            [
              1220.734,
              -4100.462,
              5043.297
            ],
            [
              1228.325,
              -4142.906,
              5086.414
            ],
            [
              1222.034,
              -4169.508,
              5113.749
            ],
            [
              1223.554,
              -4191.801,
              5136.094
            ],
            [
              1219.757,
              -4222.901,
              5167.426
            ],
            [
              1209.725,
              -4242.754,
              5189.67
            ],
            [
              1201.125,
              -4254.841,
              5204.503
            ],
            [
              1180.185,
              -4272.266,
              5231.745
            ],
            [
              1169.776,
              -4277.639,
              5243.459
            ],
            [
              1151.036,
              -4280.633,
              5262.438
            ],
            [
              1136.221,
              -4280.359,
              5277.254
            ],
            [
              1097.226,
              -4298.563,
              5320.29
            ],
            [
              1061.102,
              -4335.747,
              5372.131
            ],
            [
              1050.796,
              -4335.556,
              5382.439
            ],
            [
              1023.347,
              -4321.691,
              5413.191
            ],
            [
              1017.05,
              -4313.782,
              5423.301
            ],
            [
              1016.673,
              -4299.303,
              5437.785
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:1017",
              "position": {
                "x": 2551.422,
                "z": -3889.265
              },
              "distanceAlongShapeM": 0,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": -360,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5118",
              "position": {
                "x": 2463.001,
                "z": -3519.117
              },
              "distanceAlongShapeM": 637.712,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5119",
              "position": {
                "x": 2425.512,
                "z": -3284.63
              },
              "distanceAlongShapeM": 875.708,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 240,
              "departureOffsetSeconds": 240
            },
            {
              "stopId": "judu:stop:5096",
              "position": {
                "x": 2296.913,
                "z": -2511.848
              },
              "distanceAlongShapeM": 1660.688,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 390,
              "departureOffsetSeconds": 390
            },
            {
              "stopId": "judu:stop:5091",
              "position": {
                "x": 2031.037,
                "z": -1906.834
              },
              "distanceAlongShapeM": 2354.775,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 570,
              "departureOffsetSeconds": 570
            },
            {
              "stopId": "judu:stop:5606",
              "position": {
                "x": 1696.386,
                "z": -2638.684
              },
              "distanceAlongShapeM": 3390.141,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 840,
              "departureOffsetSeconds": 840
            },
            {
              "stopId": "judu:stop:6667",
              "position": {
                "x": 1709.563,
                "z": -3177.741
              },
              "distanceAlongShapeM": 3930.659,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 960,
              "departureOffsetSeconds": 960
            },
            {
              "stopId": "judu:stop:6668",
              "position": {
                "x": 1582.257,
                "z": -3473.726
              },
              "distanceAlongShapeM": 4256.307,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:5154",
              "position": {
                "x": 1342.825,
                "z": -3805.485
              },
              "distanceAlongShapeM": 4669.569,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            },
            {
              "stopId": "judu:stop:6671",
              "position": {
                "x": 1228.325,
                "z": -4142.906
              },
              "distanceAlongShapeM": 5086.414,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1260,
              "departureOffsetSeconds": 1260
            },
            {
              "stopId": "judu:stop:5505",
              "position": {
                "x": 1151.036,
                "z": -4280.633
              },
              "distanceAlongShapeM": 5262.438,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1320,
              "departureOffsetSeconds": 1320
            }
          ],
          "departuresSeconds": [
            22020,
            23940,
            25380,
            27720,
            29400,
            31920,
            33480,
            39120,
            42540,
            45840,
            49200,
            52800,
            56160,
            57840,
            60120,
            62100,
            64260,
            67200,
            70380,
            73500,
            76620,
            79620
          ]
        },
        {
          "id": "judu:pattern:vilnius_trol_21:1",
          "sourceRouteId": "vilnius_trol_21",
          "sourceShapeId": "vilnius_trol_21_b-a",
          "directionId": 1,
          "headsign": "Antakalnis",
          "directionName": "Žirmūnai–Šilo tiltas–Antakalnis",
          "mode": "trolleybus",
          "routeShortName": "21",
          "routeLongName": "Antakalnis–Šilo tiltas–Žirmūnai",
          "routeColor": "DC3131",
          "routeTextColor": "FFFFFF",
          "shape": [
            [
              1016.673,
              -4299.303,
              0
            ],
            [
              1017.645,
              -4281.509,
              17.821
            ],
            [
              1022.257,
              -4276.027,
              24.984
            ],
            [
              1106.613,
              -4278.698,
              109.382
            ],
            [
              1128.033,
              -4270.188,
              132.431
            ],
            [
              1147.356,
              -4270.545,
              151.757
            ],
            [
              1188.702,
              -4264.63,
              193.524
            ],
            [
              1202.517,
              -4249.3,
              214.16
            ],
            [
              1214.522,
              -4227.257,
              239.261
            ],
            [
              1220.978,
              -4191.753,
              275.347
            ],
            [
              1217.195,
              -3943.429,
              523.7
            ],
            [
              1219.986,
              -3862.213,
              604.964
            ],
            [
              1375.611,
              -3774.922,
              783.398
            ],
            [
              1393.375,
              -3755.212,
              809.932
            ],
            [
              1412.221,
              -3746.656,
              830.629
            ],
            [
              1509.056,
              -3563.653,
              1037.673
            ],
            [
              1556.885,
              -3486.613,
              1128.352
            ],
            [
              1607.644,
              -3390.704,
              1236.865
            ],
            [
              1620.009,
              -3384.254,
              1250.811
            ],
            [
              1689.847,
              -3267.548,
              1386.817
            ],
            [
              1697.306,
              -3247.648,
              1408.069
            ],
            [
              1696.944,
              -3128.524,
              1527.194
            ],
            [
              1687.839,
              -3098.296,
              1558.763
            ],
            [
              1693.427,
              -3075.022,
              1582.698
            ],
            [
              1690.731,
              -2873.474,
              1784.265
            ],
            [
              1684.353,
              -2661.838,
              1995.997
            ],
            [
              1677.945,
              -2590.471,
              2067.651
            ],
            [
              1676.674,
              -2554.823,
              2103.321
            ],
            [
              1670.083,
              -2527.983,
              2130.959
            ],
            [
              1679.06,
              -2495.866,
              2164.307
            ],
            [
              1670.601,
              -2049.296,
              2610.957
            ],
            [
              1665.105,
              -1963.474,
              2696.955
            ],
            [
              1667.869,
              -1953.506,
              2707.299
            ],
            [
              1676.994,
              -1948.109,
              2717.901
            ],
            [
              1724.765,
              -1944.545,
              2765.804
            ],
            [
              1955.555,
              -1909.879,
              2999.183
            ],
            [
              1982.08,
              -1904.808,
              3026.189
            ],
            [
              2058.602,
              -1880.631,
              3106.439
            ],
            [
              2066.336,
              -1880.775,
              3114.174
            ],
            [
              2070.784,
              -1884.198,
              3119.787
            ],
            [
              2087.852,
              -1936.84,
              3175.126
            ],
            [
              2087.374,
              -1962.435,
              3200.726
            ],
            [
              2110.719,
              -2024.1,
              3266.662
            ],
            [
              2234.812,
              -2316.979,
              3584.746
            ],
            [
              2284.924,
              -2429.242,
              3707.686
            ],
            [
              2299.015,
              -2468.47,
              3749.367
            ],
            [
              2319.691,
              -2569.05,
              3852.051
            ],
            [
              2327.089,
              -2587.001,
              3871.466
            ],
            [
              2323.492,
              -2606.972,
              3891.759
            ],
            [
              2328.687,
              -2639.354,
              3924.554
            ],
            [
              2411.872,
              -3118.499,
              4410.867
            ],
            [
              2419.872,
              -3138.687,
              4432.583
            ],
            [
              2418.768,
              -3163.158,
              4457.078
            ],
            [
              2474.472,
              -3526.012,
              4824.182
            ],
            [
              2513.109,
              -3664.781,
              4968.23
            ],
            [
              2522.438,
              -3682.768,
              4988.493
            ],
            [
              2542.483,
              -3747.714,
              5056.461
            ],
            [
              2553.555,
              -3775.753,
              5086.608
            ],
            [
              2562.319,
              -3823.788,
              5135.435
            ],
            [
              2551.422,
              -3889.265,
              5201.813
            ]
          ],
          "stops": [
            {
              "stopId": "judu:stop:5508",
              "position": {
                "x": 1128.033,
                "z": -4270.188
              },
              "distanceAlongShapeM": 132.431,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 0,
              "departureOffsetSeconds": 0
            },
            {
              "stopId": "judu:stop:5149",
              "position": {
                "x": 1393.375,
                "z": -3755.212
              },
              "distanceAlongShapeM": 809.932,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 180,
              "departureOffsetSeconds": 180
            },
            {
              "stopId": "judu:stop:5086",
              "position": {
                "x": 1607.644,
                "z": -3390.704
              },
              "distanceAlongShapeM": 1236.865,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 300,
              "departureOffsetSeconds": 300
            },
            {
              "stopId": "judu:stop:5087",
              "position": {
                "x": 1687.839,
                "z": -3098.296
              },
              "distanceAlongShapeM": 1558.763,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 360,
              "departureOffsetSeconds": 360
            },
            {
              "stopId": "judu:stop:5088",
              "position": {
                "x": 1670.083,
                "z": -2527.983
              },
              "distanceAlongShapeM": 2130.959,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 480,
              "departureOffsetSeconds": 480
            },
            {
              "stopId": "judu:stop:5092",
              "position": {
                "x": 2087.852,
                "z": -1936.84
              },
              "distanceAlongShapeM": 3175.126,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 780,
              "departureOffsetSeconds": 780
            },
            {
              "stopId": "judu:stop:5095",
              "position": {
                "x": 2327.089,
                "z": -2587.001
              },
              "distanceAlongShapeM": 3871.466,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 900,
              "departureOffsetSeconds": 900
            },
            {
              "stopId": "judu:stop:1035",
              "position": {
                "x": 2419.872,
                "z": -3138.687
              },
              "distanceAlongShapeM": 4432.583,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1020,
              "departureOffsetSeconds": 1020
            },
            {
              "stopId": "judu:stop:6711",
              "position": {
                "x": 2522.438,
                "z": -3682.768
              },
              "distanceAlongShapeM": 4988.493,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1140,
              "departureOffsetSeconds": 1140
            },
            {
              "stopId": "judu:stop:1017",
              "position": {
                "x": 2551.422,
                "z": -3889.265
              },
              "distanceAlongShapeM": 5201.813,
              "shapeOffsetM": 0,
              "arrivalOffsetSeconds": 1200,
              "departureOffsetSeconds": 1200
            }
          ],
          "departuresSeconds": [
            20340,
            22500,
            23640,
            25860,
            27540,
            29940,
            31740,
            34500,
            37560,
            40860,
            44280,
            47640,
            51300,
            54660,
            58200,
            60120,
            62220,
            64860,
            68520,
            70140,
            72060,
            75120,
            78180
          ]
        }
      ]
    }
  ]
}
